[
  {
    "id": "00027_1",
    "name": "BMW AG Niederlassung Düsseldorf",
    "country": "DE",
    "city": "Düsseldorf",
    "address": "Grafenberger Allee 277-287, 40237 Düsseldorf",
    "email": "nl.duesseldorf@bmw.de",
    "phone": "+49-211-909980",
    "website": "https://www.bmw-duesseldorf.de/de/home/",
    "coords": {
      "lat": 51.23435974121094,
      "lng": 6.8185601234436035
    }
  },
  {
    "id": "00081_1",
    "name": "BMW AG Niederlassung Berlin",
    "country": "DE",
    "city": "Berlin",
    "address": "Kaiserdamm 90/ Einfahrt Messedamm 1, 14057 Berlin",
    "email": "nl.berlin@bmw.de",
    "phone": "+49-30-200990",
    "website": "https://www.bmw-berlin.de/de/home/",
    "coords": {
      "lat": 52.509666442871094,
      "lng": 13.282041549682617
    }
  },
  {
    "id": "00085_5",
    "name": "BMW AG Niederlassung Mannheim",
    "country": "DE",
    "city": "Mannheim",
    "address": "Neckarauer Str. 164-166, 68163 Mannheim",
    "email": "bmw-mannheim@bmw.de",
    "phone": "+49-621-83570",
    "website": "http://www.bmw-mannheim.de/de/home/",
    "coords": {
      "lat": 49.465309143066406,
      "lng": 8.486920356750488
    }
  },
  {
    "id": "00089_1",
    "name": "BMW AG Niederlassung Nürnberg",
    "country": "DE",
    "city": "Nürnberg",
    "address": "Max-Ottenstein-Str. 1, 90441 Nürnberg",
    "email": "nl.nuernberg@bmw.de",
    "phone": "+49-911-14510",
    "website": "https://www.bmw-nuernberg.de",
    "coords": {
      "lat": 49.431026458740234,
      "lng": 11.041933059692383
    }
  },
  {
    "id": "00120_8",
    "name": "AH Rhein Würzburg Zw.-Nl. der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Würzburg",
    "address": "Louis-Pasteur-Str. 14, 97076 Würzburg",
    "email": "info@rhein-wuerzburg.de",
    "phone": "+49-931-278850",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 49.79352951049805,
      "lng": 9.998310089111328
    }
  },
  {
    "id": "00120_19",
    "name": "Autohaus Rhein Bayreuth Zweig-NL der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Bayreuth",
    "address": "Justus-Liebig-Straße 41, 95447 Bayreuth",
    "email": "info@rhein-bayreuth.de",
    "phone": "+49-921-75747-0",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 49.93324279785156,
      "lng": 11.563451766967773
    }
  },
  {
    "id": "00193_1",
    "name": "Vogelsang Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Recklinghausen",
    "address": "Rottstr. 118, 45659 Recklinghausen",
    "email": "info@vogelsang-automobile.de",
    "phone": "+49-2361-91930",
    "website": "https://vogelsang-automobile.de/bmw/",
    "coords": {
      "lat": 51.602134704589844,
      "lng": 7.181858062744141
    }
  },
  {
    "id": "00224_2",
    "name": "Autohaus Timmermanns GmbH Niederlassung Neuss",
    "country": "DE",
    "city": "Neuss",
    "address": "Hammer Landstr. 17, 41460 Neuss",
    "email": "info@timmermanns.de",
    "phone": "+49-2131-718720",
    "website": "https://www.timmermanns.de",
    "coords": {
      "lat": 51.1997184753418,
      "lng": 6.699729919433594
    }
  },
  {
    "id": "00250_8",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Eningen",
    "address": "Max-Planck-Str. 31, 72800 Eningen",
    "email": "bmw-eningen@ahg-mobile.de",
    "phone": "+49-7121-98400",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.477725982666016,
      "lng": 9.244811058044434
    }
  },
  {
    "id": "00250_20",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Tuttlingen",
    "address": "Stockacher Str. 181, 78532 Tuttlingen",
    "email": "bmw-tuttlingen@ahg-mobile.de",
    "phone": "+49-7461-93490",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 47.973114013671875,
      "lng": 8.834019660949707
    }
  },
  {
    "id": "00250_22",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Offenburg",
    "address": "Schutterwälder Str. 2, 77656 Offenburg",
    "email": "bmw-offenburg@ahg-mobile.de",
    "phone": "+49-781-6080",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.46527862548828,
      "lng": 7.931459903717041
    }
  },
  {
    "id": "00448_1",
    "name": "Autohaus Praller GmbH",
    "country": "DE",
    "city": "Deuerling",
    "address": "Regensburger Str. 35, 93180 Deuerling",
    "email": "info@praller.de",
    "phone": "+49-9498-94040",
    "website": "https://www.praller.de/",
    "coords": {
      "lat": 49.03758239746094,
      "lng": 11.90402603149414
    }
  },
  {
    "id": "01066_2",
    "name": "AHAG Automobil-Handelsges. Egon Gladen GmbH & Co. KG",
    "country": "DE",
    "city": "Marl",
    "address": "Herzlia Allee 107, 45770 Marl",
    "email": "kontakt.marl@ahag-bmw.de",
    "phone": "+49-2365-202190",
    "website": "https://www.ahag-group.de",
    "coords": {
      "lat": 51.64424133300781,
      "lng": 7.1015801429748535
    }
  },
  {
    "id": "01288_2",
    "name": "BMW AG Niederlassung Hannover Filiale Süd am EXPO Park",
    "country": "DE",
    "city": "Hannover",
    "address": "Lissabonner Allee 3, 30539 Hannover",
    "email": "nl-hannover@bmw.de",
    "phone": "+49-511-626202",
    "website": "https://www.bmw-hannover.de",
    "coords": {
      "lat": 52.31858444213867,
      "lng": 9.817460060119629
    }
  },
  {
    "id": "01575_1",
    "name": "Autohaus Backhaus Inh. Christoph Backhaus e.K.",
    "country": "DE",
    "city": "Bad Wildungen",
    "address": "Bahnhofstr. 27, 34537 Bad Wildungen",
    "email": "info@bmw-backhaus.de",
    "phone": "+49-5621-969480",
    "website": "https://www.bmw.de/de/partner/autohaus-backhaus-bad-wildungen-01575.ht",
    "coords": {
      "lat": 51.1202507019043,
      "lng": 9.134230613708496
    }
  },
  {
    "id": "01822_5",
    "name": "Autohaus Fulda Krah & Enders GmbH",
    "country": "DE",
    "city": "Eschwege",
    "address": "Westring 32, 37269 Eschwege",
    "email": "info@bmw-krah-enders-eschwege.de",
    "phone": "+49-5651-92090",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 51.190059661865234,
      "lng": 10.035082817077637
    }
  },
  {
    "id": "01859_6",
    "name": "Autohaus Erwin Schmidt GmbH & Co. KG",
    "country": "DE",
    "city": "Soest",
    "address": "Arnsberger Straße 30, 59494 Soest",
    "email": "info.soest@bmw-schmidt.de",
    "phone": "+49-2921-96250",
    "website": "https://www.bmw.de/de/partner/autohaus-erwin-schmidt-soest-37170.html",
    "coords": {
      "lat": 51.561676025390625,
      "lng": 8.105463027954102
    }
  },
  {
    "id": "00104_2",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Regensburg",
    "address": "Dr.-Gessler-Str. 33, 93051 Regensburg",
    "email": "regensburg@hofmann.auto",
    "phone": "+49-941-99270",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 49.005035400390625,
      "lng": 12.064470291137695
    }
  },
  {
    "id": "00104_7",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Regensburg",
    "address": "Junkersstr. 17, 93055 Regensburg",
    "email": "ostbayern@hofmann.auto",
    "phone": "+49-941-660990",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.98737716674805,
      "lng": 12.15291690826416
    }
  },
  {
    "id": "01889_2",
    "name": "Autohaus Uwe Ratzel GmbH & Co. KG",
    "country": "DE",
    "city": "Stutensee",
    "address": "Lorenzstraße 1, 76297 Stutensee",
    "email": "info@bmw-ratzel.de",
    "phone": "+49-7244-73650",
    "website": "https://www.bmw.de/de/partner/autohaus-uwe-ratzel-stutensee-50043.html",
    "coords": {
      "lat": 49.076377868652344,
      "lng": 8.459746360778809
    }
  },
  {
    "id": "00116_1",
    "name": "Auto-Leebmann GmbH",
    "country": "DE",
    "city": "Passau",
    "address": "Traminer Str. 1, 94036 Passau",
    "email": "info@leebmann.de",
    "phone": "+49-851-7001-0",
    "website": "https://www.leebmann.de/bmw",
    "coords": {
      "lat": 48.5546875,
      "lng": 13.416739463806152
    }
  },
  {
    "id": "00139_5",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Brilon",
    "address": "Möhnestr. 47, 59929 Brilon",
    "email": "brilon@wahl-group.de",
    "phone": "+49-2961-96260",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 51.40578079223633,
      "lng": 8.575258255004883
    }
  },
  {
    "id": "00139_11",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Gießen",
    "address": "Gottlieb-Daimler-Str. 1, 35398 Gießen",
    "email": "bmw.giessen@wahl-group.de",
    "phone": "+49-641-610660",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.585750579833984,
      "lng": 8.649741172790527
    }
  },
  {
    "id": "00141_2",
    "name": "HANKO Kraftfahrzeughandel GmbH",
    "country": "DE",
    "city": "Neuwied",
    "address": "Stettiner Str. 1, 56564 Neuwied",
    "email": "info@hanko.de",
    "phone": "+49-2631-39500",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.43528366088867,
      "lng": 7.484379768371582
    }
  },
  {
    "id": "00167_1",
    "name": "H. Freese GmbH",
    "country": "DE",
    "city": "Oldenburg",
    "address": "Wilhelmshavener Heerstr. 9-17, 26125 Oldenburg",
    "email": "info@freese-gruppe.de",
    "phone": "+49-441-350250-0",
    "website": "https://www.bmw-gruppe.de",
    "coords": {
      "lat": 53.17045211791992,
      "lng": 8.229866027832031
    }
  },
  {
    "id": "03419_1",
    "name": "Autohaus Schneider GmbH & Co. KG",
    "country": "DE",
    "city": "Schwelm",
    "address": "Wörther Str. 8-12, 58332 Schwelm",
    "email": "info@schneider-schwelm.de",
    "phone": "+49-2336-92820",
    "website": "https://www.bmw-schneider.de",
    "coords": {
      "lat": 51.29404067993164,
      "lng": 7.288670063018799
    }
  },
  {
    "id": "03788_1",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Duisburg",
    "address": "Gießereistr. 9, 47053 Duisburg",
    "email": "info@cloppenburg-duisburg.de",
    "phone": "+49-203-996460",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 51.411258697509766,
      "lng": 6.758195877075195
    }
  },
  {
    "id": "03829_1",
    "name": "Autohaus Wigger GmbH",
    "country": "DE",
    "city": "Rostock",
    "address": "Alte Dorfstr. 25, 18146 Rostock",
    "email": "info@bmw-wigger.de",
    "phone": "+49-381-659260",
    "website": "http://bmw-wigger.de/de/home/",
    "coords": {
      "lat": 54.09917449951172,
      "lng": 12.181039810180664
    }
  },
  {
    "id": "03892_2",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Castrop-Rauxel",
    "address": "Westring 212c, 44579 Castrop-Rauxel",
    "email": "castrop@bmw-procar.de",
    "phone": "+49-2305-923360",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.55233383178711,
      "lng": 7.295736789703369
    }
  },
  {
    "id": "03988_1",
    "name": "Autohaus Feil GmbH",
    "country": "DE",
    "city": "Gunzenhausen",
    "address": "Ansbacher Str. 23, 91710 Gunzenhausen",
    "email": "info@bmw-feil.de",
    "phone": "+49-9831-67980",
    "website": "https://www.bmw.de/de/partner/karl-feil-gunzenhausen-03988.html",
    "coords": {
      "lat": 49.12860107421875,
      "lng": 10.746789932250977
    }
  },
  {
    "id": "04071_1",
    "name": "Procar Automobile Düsseldorf GmbH",
    "country": "DE",
    "city": "Düsseldorf",
    "address": "Bertha-von-Suttner-Str. 11-15, 40595 Düsseldorf",
    "email": "hellerhof@bmw-procar.de",
    "phone": "+49-211-73900",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.13297653198242,
      "lng": 6.906489849090576
    }
  },
  {
    "id": "04071_4",
    "name": "Procar Automobile Düsseldorf GmbH",
    "country": "DE",
    "city": "Dormagen",
    "address": "Lübecker Str. 16, 41540 Dormagen",
    "email": "dormagen@bmw-procar.de",
    "phone": "+49-2133-53010",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.09101867675781,
      "lng": 6.812631607055664
    }
  },
  {
    "id": "04112_1",
    "name": "Autohaus Weigl GmbH",
    "country": "DE",
    "city": "Merseburg",
    "address": "Querfurter Str. 6, 06217 Merseburg",
    "email": "info@autohaus-weigl.de",
    "phone": "+49-3461-29040",
    "website": "https://www.bmw.de/de/partner/autohaus-weigl-merseburg-04112.html",
    "coords": {
      "lat": 51.371421813964844,
      "lng": 11.984210014343262
    }
  },
  {
    "id": "04110_2",
    "name": "Autohaus Ruffert GmbH",
    "country": "DE",
    "city": "Löbau",
    "address": "Weststr. 2, 02708 Löbau",
    "email": "ah.ruffert@bmw-ruffert.de",
    "phone": "+49-3585-468330",
    "website": "https://www.bmw-ruffert.de",
    "coords": {
      "lat": 51.10755920410156,
      "lng": 14.65573787689209
    }
  },
  {
    "id": "00507_1",
    "name": "Auto Weiss GmbH & Co. KG",
    "country": "DE",
    "city": "Aichach",
    "address": "Werner-von-Siemens-Str. 2, 86551 Aichach",
    "email": "info@bmw-weiss.de",
    "phone": "+49-8251-87450",
    "website": "https://www.bmw.de/de/partner/auto-weiss-aichach-00507.html",
    "coords": {
      "lat": 48.44496536254883,
      "lng": 11.138810157775879
    }
  },
  {
    "id": "04373_2",
    "name": "Wolter & Steiner GmbH",
    "country": "DE",
    "city": "Prenzlau",
    "address": "Stettiner Str. 107, 17291 Prenzlau",
    "email": "info.pz@wolter-steiner.de",
    "phone": "+49-3984-85550",
    "website": "http://bmw-wolter-steiner.de/de/home",
    "coords": {
      "lat": 53.3320198059082,
      "lng": 13.867980003356934
    }
  },
  {
    "id": "00557_1",
    "name": "Nefzger GmbH & Co. KG",
    "country": "DE",
    "city": "Berlin",
    "address": "Nonnendammallee 62-64, 13629 Berlin",
    "email": "info@nefzger-berlin.de",
    "phone": "+49-30-383801200",
    "website": "https://www.nefzger-berlin.de",
    "coords": {
      "lat": 52.537452697753906,
      "lng": 13.255149841308594
    }
  },
  {
    "id": "04543_4",
    "name": "BMW AG Niederlassung Dresden",
    "country": "DE",
    "city": "Dresden",
    "address": "Dohnaer Str. 99-101, 01219 Dresden",
    "email": "nl.dresden@bmw.de",
    "phone": "+49-351-4174170",
    "website": "https://www.bmw-dresden.de/de/home/",
    "coords": {
      "lat": 51.01517868041992,
      "lng": 13.771980285644531
    }
  },
  {
    "id": "00607_1",
    "name": "Autohaus Fink GmbH & Co. KG",
    "country": "DE",
    "city": "Erlangen",
    "address": "Günther-Scharowsky-Str. 8, 91058 Erlangen",
    "email": "fink@autohausfink.de",
    "phone": "+49-9131-30080",
    "website": "https://www.bmw.de/de/partner/autohaus-fink-erlangen-00607.html",
    "coords": {
      "lat": 49.5738410949707,
      "lng": 11.001663208007812
    }
  },
  {
    "id": "04670_2",
    "name": "Albert Bauer GmbH",
    "country": "DE",
    "city": "Schleswig",
    "address": "Heinrich-Hertz-Str. 1, 24837 Schleswig",
    "email": "office-sl@bauergruppe.de",
    "phone": "+49-4621-95550",
    "website": "https://www.bmw.de/de/partner/albert-bauer-schleswig-01062.html",
    "coords": {
      "lat": 54.530391693115234,
      "lng": 9.582810401916504
    }
  },
  {
    "id": "04670_3",
    "name": "Albert Bauer GmbH",
    "country": "DE",
    "city": "Husum",
    "address": "Robert-Koch-Str. 40, 25813 Husum",
    "email": "office-hu@bauergruppe.de",
    "phone": "+49-4841-77670",
    "website": "https://www.bmw.de/de/partner/albert-bauer-husum-34000.html",
    "coords": {
      "lat": 54.497230529785156,
      "lng": 9.086230278015137
    }
  },
  {
    "id": "04712_1",
    "name": "Hermann Arnold GmbH",
    "country": "DE",
    "city": "Hösbach",
    "address": "Industriestr. 1-3, 63768 Hösbach",
    "email": "info@bmw-arnold.com",
    "phone": "+49-6021-59900",
    "website": "https://www.bmw-arnold.com",
    "coords": {
      "lat": 50.00614929199219,
      "lng": 9.221500396728516
    }
  },
  {
    "id": "01548_6",
    "name": "Autohaus Euler GmbH",
    "country": "DE",
    "city": "Frankfurt am Main",
    "address": "Hanauer Landstaße 425, 60314 Frankfurt am Main",
    "email": "info@euler-group.de",
    "phone": "+49-69-408017-0",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 50.12167739868164,
      "lng": 8.737826347351074
    }
  },
  {
    "id": "01859_5",
    "name": "Autohaus Erwin Schmidt GmbH & Co. KG",
    "country": "DE",
    "city": "Hamm",
    "address": "Hohefeldweg 23, 59071 Hamm",
    "email": "info.hamm@bmw-schmidt.de",
    "phone": "+49-2381-97098300",
    "website": "https://www.bmw.de/de/partner/autohaus-erwin-schmidt-hamm-34933.html",
    "coords": {
      "lat": 51.677303314208984,
      "lng": 7.85142707824707
    }
  },
  {
    "id": "02258_1",
    "name": "Auto-Müller GmbH",
    "country": "DE",
    "city": "Hollfeld",
    "address": "Treppendorfer Str. 2, 96142 Hollfeld",
    "email": "autohaus@mueller-hollfeld.de",
    "phone": "+49-9274-97000",
    "website": "https://www.bmw.de/de/partner/auto-mueller-hollfeld-02258.html",
    "coords": {
      "lat": 49.92919158935547,
      "lng": 11.298845291137695
    }
  },
  {
    "id": "02356_1",
    "name": "Autohaus Wormser GmbH",
    "country": "DE",
    "city": "Erlangen",
    "address": "Reutleser Weg  15, 91058 Erlangen",
    "email": "info@bmw-wormser.de",
    "phone": "+49-9131-4800-0",
    "website": "https://www.autohaus-wormser.de",
    "coords": {
      "lat": 49.54273986816406,
      "lng": 11.028142929077148
    }
  },
  {
    "id": "02365_1",
    "name": "Auto Grimm GmbH & Co. KG",
    "country": "DE",
    "city": "Nördlingen",
    "address": "Würzburger Str. 17, 86720 Nördlingen",
    "email": "info@bmw-grimm.de",
    "phone": "+49-9081-290970",
    "website": "https://www.bmw.de/de/partner/auto-grimm-noerdlingen-02365.html",
    "coords": {
      "lat": 48.8560905456543,
      "lng": 10.479640007019043
    }
  },
  {
    "id": "02606_1",
    "name": "Autohaus Reith GmbH & Co. KG",
    "country": "DE",
    "city": "Wolnzach",
    "address": "Ingolstädter Str. 14, 85283 Wolnzach",
    "email": "autohaus@bmw-reith.de",
    "phone": "+49-8442-92440",
    "website": "https://www.bmw.de/de/partner/autohaus-reith-wolnzach-02606.html",
    "coords": {
      "lat": 48.61008834838867,
      "lng": 11.622090339660645
    }
  },
  {
    "id": "04107_13",
    "name": "BMW AG Niederlassung München Airportservice",
    "country": "DE",
    "city": "München-Flughafen",
    "address": "Nordallee 62, 85356 München-Flughafen",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-3535-70",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.35462951660156,
      "lng": 11.75094985961914
    }
  },
  {
    "id": "04109_1",
    "name": "Autohaus Fritze GmbH & Co. KG",
    "country": "DE",
    "city": "Sangerhausen",
    "address": "An der Stollenmühle 15, 06526 Sangerhausen",
    "email": "info@autohaus-fritze.de",
    "phone": "+49-3464-55930",
    "website": "https://www.bmw-fritze.de",
    "coords": {
      "lat": 51.46508026123047,
      "lng": 11.272430419921875
    }
  },
  {
    "id": "04210_2",
    "name": "Autohaus Becker-Tiemann Leinetal GmbH & Co. KG",
    "country": "DE",
    "city": "Einbeck",
    "address": "Altendorfer Tor 26, 37574 Einbeck",
    "email": "einbeck@becker-tiemannn.de",
    "phone": "+49-5561-93000",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 51.81364822387695,
      "lng": 9.878814697265625
    }
  },
  {
    "id": "04508_2",
    "name": "Autohaus Revo GmbH",
    "country": "DE",
    "city": "Sigmaringen",
    "address": "Laizer Str. 24, 72488 Sigmaringen",
    "email": "info@bmw-revo.de",
    "phone": "+49-7571-749100",
    "website": "https://www.bmw.de/de/partner/autohaus-revo-sigmaringen-28435.html",
    "coords": {
      "lat": 48.081790924072266,
      "lng": 9.201994895935059
    }
  },
  {
    "id": "04543_1",
    "name": "BMW AG Niederlassung Leipzig",
    "country": "DE",
    "city": "Leipzig",
    "address": "Zwickauer Str. 55, 04103 Leipzig",
    "email": "nl.leipzig@bmw.de",
    "phone": "+49-341-445500",
    "website": "https://www.bmw-leipzig.de/de/home/",
    "coords": {
      "lat": 51.31568908691406,
      "lng": 12.394515037536621
    }
  },
  {
    "id": "04553_1",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Langenwetzendorf",
    "address": "Am Daßlitzer Kreuz 21, 07957 Langenwetzendorf",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-36625-7933-0",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.683624267578125,
      "lng": 12.129426956176758
    }
  },
  {
    "id": "00085_2",
    "name": "BMW AG Niederlassung Stuttgart Filiale Rosensteinpark",
    "country": "DE",
    "city": "Stuttgart",
    "address": "Pragstr. 140, 70376 Stuttgart",
    "email": "bmw-stuttgart@bmw.de",
    "phone": "+49-711-13188000",
    "website": "https://www.bmw-stuttgart.de/de/home/",
    "coords": {
      "lat": 48.807106018066406,
      "lng": 9.193449974060059
    }
  },
  {
    "id": "00085_11",
    "name": "BMW AG Niederlassung Saar-Pfalz",
    "country": "DE",
    "city": "Kirkel",
    "address": "Konrad-Zuse-Straße 1, 66459 Kirkel",
    "email": "bmw-saar-pfalz@bmw.de",
    "phone": "+49-6841-972970",
    "website": "https://www.bmw-saarland.de/de/home/",
    "coords": {
      "lat": 49.3027229309082,
      "lng": 7.264605522155762
    }
  },
  {
    "id": "00120_17",
    "name": "Autohaus Rhein Ludwigsburg Zw. Nl. der Autohaus Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Asperg",
    "address": "Zeissstr. 2, 71679 Asperg",
    "email": "info@rhein-ludwigsburg.de",
    "phone": "+49-7141-40760",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 48.8980712890625,
      "lng": 9.154741287231445
    }
  },
  {
    "id": "00167_13",
    "name": "H. Freese GmbH",
    "country": "DE",
    "city": "Westerstede",
    "address": "Am Hamjebusch 49, 26655 Westerstede",
    "email": "info.wst@freese-gruppe.de",
    "phone": "+49-4488-520200-0",
    "website": "https://www.bmw-gruppe.de",
    "coords": {
      "lat": 53.25676345825195,
      "lng": 7.935588836669922
    }
  },
  {
    "id": "00224_1",
    "name": "Autohaus Timmermanns GmbH",
    "country": "DE",
    "city": "Düsseldorf",
    "address": "Heerdter Landstr. 110, 40549 Düsseldorf",
    "email": "info@timmermanns.de",
    "phone": "+49-211-50750",
    "website": "https://www.timmermanns.de",
    "coords": {
      "lat": 51.23168182373047,
      "lng": 6.711888313293457
    }
  },
  {
    "id": "00250_36",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Hausach",
    "address": "Hechtsberg 10, 77756 Hausach",
    "email": "bmw-hausach@ahg-mobile.de",
    "phone": "+49-7831-9376-0",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.28221893310547,
      "lng": 8.13833999633789
    }
  },
  {
    "id": "00282_1",
    "name": "Auto-Schmidt Rudolf Schmidt e.K. Inh. Elke Schmitt",
    "country": "DE",
    "city": "Saarburg",
    "address": "Industriestr. 3, 54439 Saarburg",
    "email": "info@autoschmidt-saarburg.de",
    "phone": "+49-6581-91750",
    "website": "https://www.bmw.de/de/partner/autohaus-schmidt-saarburg-00282.html",
    "coords": {
      "lat": 49.60633850097656,
      "lng": 6.575270175933838
    }
  },
  {
    "id": "00332_2",
    "name": "Bobrink GmbH",
    "country": "DE",
    "city": "Cuxhaven",
    "address": "Papenstr. 152, 27472 Cuxhaven",
    "email": "bobrink.cux@bmw-bobrink.de",
    "phone": "+49-4721-74500",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.85141372680664,
      "lng": 8.715319633483887
    }
  },
  {
    "id": "00391_12",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Schorndorf",
    "address": "Siechenfeldstr. 28, 73614 Schorndorf",
    "email": "verkauf.schorndorf@mulfinger.de",
    "phone": "+49-7181-70040",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 48.806880950927734,
      "lng": 9.515270233154297
    }
  },
  {
    "id": "00427_1",
    "name": "Autohaus Fetzer GmbH",
    "country": "DE",
    "city": "Kuchen",
    "address": "Hauptstr. 17, 73329 Kuchen",
    "email": "info@bmw-fetzer.de",
    "phone": "+49-7331-98860",
    "website": "https://www.bmw.de/de/partner/autohaus-fetzer-kuchen-00427.html",
    "coords": {
      "lat": 48.63156509399414,
      "lng": 9.806714057922363
    }
  },
  {
    "id": "00433_1",
    "name": "Autohaus Zeisler GmbH",
    "country": "DE",
    "city": "Waiblingen",
    "address": "Schüttelgrabenring 9, 71332 Waiblingen",
    "email": "info@bmw-zeisler.de",
    "phone": "+49-7151-959610",
    "website": "https://www.bmw-zeisler.de",
    "coords": {
      "lat": 48.8207893371582,
      "lng": 9.315279960632324
    }
  },
  {
    "id": "00612_1",
    "name": "Auto Grimm GmbH",
    "country": "DE",
    "city": "Schopfloch",
    "address": "Friedrich-Ebert-Str. 66, 91626 Schopfloch",
    "email": "info@bmw-grimm.de",
    "phone": "+49-9857-97000",
    "website": "https://www.bmw.de/de/partner/auto-grimm-schopfloch-00612.html",
    "coords": {
      "lat": 49.11647033691406,
      "lng": 10.306778907775879
    }
  },
  {
    "id": "00674_1",
    "name": "Autohaus Krah & Enders GmbH",
    "country": "DE",
    "city": "Bad Hersfeld",
    "address": "Kleine Industriestr. 5, 36251 Bad Hersfeld",
    "email": "info@bmw-krah-enders-hersfeld.de",
    "phone": "+49-6621-50000",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.86423873901367,
      "lng": 9.717144012451172
    }
  },
  {
    "id": "00795_5",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "Königswinter",
    "address": "Hauptstr. 21, 53639 Königswinter",
    "email": "kontakt@hakvoort.de",
    "phone": "+49-2223-92330",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.69843673706055,
      "lng": 7.175374984741211
    }
  },
  {
    "id": "01415_1",
    "name": "Autohaus Richard Hable GmbH",
    "country": "DE",
    "city": "Grafenau",
    "address": "Spitalstr. 33, 94481 Grafenau",
    "email": "richard.hable@bmw-hable.de",
    "phone": "+49-8552-96070",
    "website": "https://www.bmw-hable.de",
    "coords": {
      "lat": 48.85136795043945,
      "lng": 13.393705368041992
    }
  },
  {
    "id": "01859_1",
    "name": "Autohaus Erwin Schmidt GmbH & Co. KG",
    "country": "DE",
    "city": "Lünen",
    "address": "Cappenberger Str. 25 b, 44534 Lünen",
    "email": "info@bmw-schmidt.de",
    "phone": "+49-2306-705300",
    "website": "https://www.bmw.de/de/partner/autohaus-erwin-schmidt-luenen-01859.html",
    "coords": {
      "lat": 51.61975860595703,
      "lng": 7.5246100425720215
    }
  },
  {
    "id": "01574_1",
    "name": "Autohaus Gerd Hoyer GmbH",
    "country": "DE",
    "city": "Walsrode",
    "address": "Rudolf-Diesel-Str. 11, 29664 Walsrode",
    "email": "hoyer@hoyer.ps",
    "phone": "+49-5161-987798",
    "website": "https://www.bmw.de/de/partner/autohaus-hoyer-walsrode-01574.html",
    "coords": {
      "lat": 52.86211395263672,
      "lng": 9.619750022888184
    }
  },
  {
    "id": "01872_1",
    "name": "Riller & Schnauck GmbH",
    "country": "DE",
    "city": "Berlin",
    "address": "Hindenburgdamm 68, 12203 Berlin",
    "email": "anfrage@riller-schnauck.de",
    "phone": "+49-30-7900950",
    "website": "https://www.bmw.de/de/partner/riller-schnauck-berlin-01872.html",
    "coords": {
      "lat": 52.45180130004883,
      "lng": 13.315409660339355
    }
  },
  {
    "id": "01872_5",
    "name": "Riller & Schnauck GmbH",
    "country": "DE",
    "city": "Schönefeld",
    "address": "Querweg 3, 12529 Schönefeld",
    "email": "info@riller-schnauck.de",
    "phone": "+49-3379-44300",
    "website": "https://www.bmw.de/de/partner/riller-schnauck-schoenefeld-41245.html",
    "coords": {
      "lat": 52.40422439575195,
      "lng": 13.442136764526367
    }
  },
  {
    "id": "02341_1",
    "name": "Drexl + Ziegler GmbH & Co. KG",
    "country": "DE",
    "city": "Neusäß",
    "address": "Augsburger Str. 14-20, 86356 Neusäß",
    "email": "verkauf@drexl-ziegler.de",
    "phone": "+49-821-480680",
    "website": "https://www.bmw.de/de/partner/drexl-ziegler-neusaess-02341.html",
    "coords": {
      "lat": 48.38860321044922,
      "lng": 10.839070320129395
    }
  },
  {
    "id": "02813_1",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Ansbach",
    "address": "Rudolf-Diesel-Str. 2, 91522 Ansbach",
    "email": "info@cloppenburg-ansbach.de",
    "phone": "+49-981-970010",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 49.2593994140625,
      "lng": 10.612785339355469
    }
  },
  {
    "id": "03454_1",
    "name": "Autohaus Walter Ritzel GmbH & Co. KG",
    "country": "DE",
    "city": "Lippstadt",
    "address": "Rossfeld 78, 59557 Lippstadt",
    "email": "info@autohausritzel.de",
    "phone": "+49-2941-28580",
    "website": "https://www.bmw.de/de/partner/autohaus-walter-ritzel-lippstadt-03454.h",
    "coords": {
      "lat": 51.670352935791016,
      "lng": 8.365036964416504
    }
  },
  {
    "id": "04373_1",
    "name": "Wolter & Steiner GmbH",
    "country": "DE",
    "city": "Trollenhagen/ Hellfeld",
    "address": "Hellfelder Str. 4, 17039 Trollenhagen/ Hellfeld",
    "email": "info.nb@wolter-steiner.de",
    "phone": "+49-395-429420",
    "website": "http://bmw-wolter-steiner.de/de/home",
    "coords": {
      "lat": 53.59336471557617,
      "lng": 13.277443885803223
    }
  },
  {
    "id": "04553_6",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Hilmersdorf",
    "address": "Hoflindenstr. 1, 09429 Hilmersdorf",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-37369-1460",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.674041748046875,
      "lng": 13.12374496459961
    }
  },
  {
    "id": "04562_3",
    "name": "Langenhan GmbH",
    "country": "DE",
    "city": "Unstruttal",
    "address": "Am Brühl 3, 99996 Unstruttal",
    "email": "mhl@bmw-langenhan.de",
    "phone": "+49-3601-46460",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 51.24052810668945,
      "lng": 10.454899787902832
    }
  },
  {
    "id": "04649_1",
    "name": "Autohaus Josef Bauer GmbH",
    "country": "DE",
    "city": "Neumarkt-St. Veit",
    "address": "Bahnhofstr. 43, 84494 Neumarkt-St. Veit",
    "email": "info@bmw-bauer.de",
    "phone": "+49-8639-98380",
    "website": "https://www.bmw.de/de/partner/autohaus-josef-bauer-neumarkt-stveit-04649.html",
    "coords": {
      "lat": 48.35995101928711,
      "lng": 12.501893043518066
    }
  },
  {
    "id": "07214_3",
    "name": "Autohaus Kühne GmbH",
    "country": "DE",
    "city": "Grimma",
    "address": "Hengstbergstr. 9, 04668 Grimma",
    "email": "info-grimma@bmw-kuehne.de",
    "phone": "+49-3437-94880",
    "website": "https://bmw-service-kuehne.de",
    "coords": {
      "lat": 51.25613021850586,
      "lng": 12.726615905761719
    }
  },
  {
    "id": "07466_8",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Halberstadt",
    "address": "Im Sülzeteiche 1, 38820 Halberstadt",
    "email": "schubert.halberstadt@schubert-motors.de",
    "phone": "+49-3941-5990",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 51.87925338745117,
      "lng": 11.077882766723633
    }
  },
  {
    "id": "07808_1",
    "name": "Autohaus Skjellet GmbH",
    "country": "DE",
    "city": "Strausberg",
    "address": "Wendehammer 2, 15344 Strausberg",
    "email": "info@bmw-skjellet.de",
    "phone": "+49-3341-33170",
    "website": "https://www.bmw.de/de/partner/skjellet-strausberg-07808.html",
    "coords": {
      "lat": 52.58175277709961,
      "lng": 13.899852752685547
    }
  },
  {
    "id": "21887_1",
    "name": "Autohaus Schaal GmbH",
    "country": "DE",
    "city": "Bitburg",
    "address": "Graf-Zeppelin-Str. 4, 54634 Bitburg",
    "email": "info@bmw-schaal.de",
    "phone": "+49-6561-94700",
    "website": "https://www.autohaus-schaal.de/",
    "coords": {
      "lat": 49.9505500793457,
      "lng": 6.539646625518799
    }
  },
  {
    "id": "25742_3",
    "name": "Procar Automobile Münsterland GmbH",
    "country": "DE",
    "city": "Emsdetten",
    "address": "Grevener Damm 260, 48282 Emsdetten",
    "email": "emsdetten@bmw-procar.de",
    "phone": "+49-2572-93930",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 52.144710540771484,
      "lng": 7.563316345214844
    }
  },
  {
    "id": "07491_1",
    "name": "Autohaus H. Freese GmbH & Co. KG",
    "country": "DE",
    "city": "Wilhelmshaven",
    "address": "An der Junkerei 6, 26389 Wilhelmshaven",
    "email": "info.whv@freese-gruppe.de",
    "phone": "+49-4421-300300-0",
    "website": "https://www.bmw-gruppe.de",
    "coords": {
      "lat": 53.52407455444336,
      "lng": 8.076629638671875
    }
  },
  {
    "id": "26636_1",
    "name": "Procar Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Köln",
    "address": "Clevischer Ring 129, 51063 Köln",
    "email": "koelnost@bmw-procar.de",
    "phone": "+49-221-647070",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 50.97621154785156,
      "lng": 7.004389762878418
    }
  },
  {
    "id": "27944_1",
    "name": "Autohaus Karl Jungmayer GmbH",
    "country": "DE",
    "city": "Geiselhöring",
    "address": "Straubinger Str. 49, 94333 Geiselhöring",
    "email": "info@bmw-jungmayer.de",
    "phone": "+49-9423-20040",
    "website": "https://www.bmw-service-jungmayer.de/de/home/",
    "coords": {
      "lat": 48.829978942871094,
      "lng": 12.401140213012695
    }
  },
  {
    "id": "27959_1",
    "name": "Autohaus Gubin GmbH",
    "country": "DE",
    "city": "Bochum",
    "address": "Gollheide 28-30, 44866 Bochum",
    "email": "info@gubin.de",
    "phone": "+49-2327-60000",
    "website": "https://www.bmw.de/de/partner/autohaus-gubin-bochum-27959.html",
    "coords": {
      "lat": 51.480228424072266,
      "lng": 7.170139789581299
    }
  },
  {
    "id": "29220_1",
    "name": "Vögl GmbH & Co. Cham KG",
    "country": "DE",
    "city": "Cham",
    "address": "Gewerbepark Chammünster Nord A 6, 93413 Cham",
    "email": "cham@voegl.de",
    "phone": "+49-9971-76690",
    "website": "https://www.bmw.de/de/partner/voegl-cham-29220.html",
    "coords": {
      "lat": 49.20732116699219,
      "lng": 12.68151569366455
    }
  },
  {
    "id": "29964_2",
    "name": "Autohaus Kellner Erfurt GmbH",
    "country": "DE",
    "city": "Arnstadt",
    "address": "Ichtershäuser Str. 41, 99310 Arnstadt",
    "email": "info@bmw-service-kellner.de",
    "phone": "+49-3628-61690",
    "website": "https://www.bmw.de/de/partner/autohaus-kellner-arnstadt-45734.html",
    "coords": {
      "lat": 50.84693145751953,
      "lng": 10.953900337219238
    }
  },
  {
    "id": "20512_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Rosenheim",
    "address": "Sepp-Heindl-Str. 2, 83026 Rosenheim",
    "email": "info@bmw-unterberger.de",
    "phone": "+49-8031-21400",
    "website": "https://de.unterberger.cc/bmw/",
    "coords": {
      "lat": 47.84376907348633,
      "lng": 12.08397102355957
    }
  },
  {
    "id": "33291_1",
    "name": "Autohaus Moderegger GmbH",
    "country": "DE",
    "city": "Bischofswiesen",
    "address": "Im Stangenwald 46, 83483 Bischofswiesen",
    "email": "info@bmw-moderegger.de",
    "phone": "+49-8652-4566",
    "website": "https://www.bmw.de/de/partner/autohaus-moderegger-bischofswiesen-33291.html",
    "coords": {
      "lat": 47.617431640625,
      "lng": 12.969229698181152
    }
  },
  {
    "id": "33232_1",
    "name": "Autohaus Cyran GmbH",
    "country": "DE",
    "city": "Steinfurt",
    "address": "Altenberger Str. 212, 48565 Steinfurt",
    "email": "bmw.steinfurt@cyran.de",
    "phone": "+49-2552-93650",
    "website": "https://www.bmw.de/de/partner/autohaus-cyran-steinfurt-33232.html",
    "coords": {
      "lat": 52.104591369628906,
      "lng": 7.405570030212402
    }
  },
  {
    "id": "23470_4",
    "name": "Spaett GmbH & Co. KG",
    "country": "DE",
    "city": "Freising",
    "address": "Rudolf-Diesel-Str. 3, 85356 Freising",
    "email": "info@spaett.de",
    "phone": "+49-8161-5380-0",
    "website": "https://www.bmw.de/de/partner/spaett-freising-23470.html",
    "coords": {
      "lat": 48.4001350402832,
      "lng": 11.77132511138916
    }
  },
  {
    "id": "34007_1",
    "name": "Automag GmbH",
    "country": "DE",
    "city": "München",
    "address": "Landsberger Str. 170, 80687 München",
    "email": "info@automag.de",
    "phone": "+49-89-51020",
    "website": "https://www.automag.de",
    "coords": {
      "lat": 48.14080047607422,
      "lng": 11.524250030517578
    }
  },
  {
    "id": "34007_2",
    "name": "Automag GmbH",
    "country": "DE",
    "city": "München",
    "address": "Wasserburger Landstrasse 81, 81827 München",
    "email": "info@automag.de",
    "phone": "+49-89-5102-0",
    "website": "https://www.automag.de",
    "coords": {
      "lat": 48.11865234375,
      "lng": 11.682889938354492
    }
  },
  {
    "id": "24127_1",
    "name": "Weigl Automobile GmbH",
    "country": "DE",
    "city": "Weißenfels",
    "address": "Max-Planck-Str. 9, 06667 Weißenfels",
    "email": "info@autohaus-weigl.de",
    "phone": "+49-3443-46100",
    "website": "https://www.bmw.de/de/partner/autohaus-weigl-weissenfels-24127.html",
    "coords": {
      "lat": 51.186302185058594,
      "lng": 11.98461627960205
    }
  },
  {
    "id": "25784_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Prien am Chiemsee",
    "address": "Am Reitbach 2, 83209 Prien am Chiemsee",
    "email": "mail@bmw-unterberger.de",
    "phone": "+49-8051-98760",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.843387603759766,
      "lng": 12.346539497375488
    }
  },
  {
    "id": "07466_12",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Magdeburg",
    "address": "Halberstädter Str. 10, 39112 Magdeburg",
    "email": "schubert.magdeburg@schubert-motors.de",
    "phone": "+49-391-60980",
    "website": "https://www.schubert-motors.bmw",
    "coords": {
      "lat": 52.117130279541016,
      "lng": 11.616324424743652
    }
  },
  {
    "id": "28413_1",
    "name": "Autohaus Schmauser GmbH",
    "country": "DE",
    "city": "Tauberbischofsheim",
    "address": "Zum Schneekasten 10, 97941 Tauberbischofsheim",
    "email": "info@bmw-service-schmauser.de",
    "phone": "+49-9341-92500",
    "website": "https://bmw.de/de/partner/autohaus-schmauser-tauberbischofsheim-28413.html",
    "coords": {
      "lat": 49.63570022583008,
      "lng": 9.64861011505127
    }
  },
  {
    "id": "07850_1",
    "name": "BMW AG Service Zentrum Regensburg",
    "country": "DE",
    "city": "Regensburg",
    "address": "Herbert-Quandt-Allee, 93055 Regensburg",
    "email": "servicezentrum.regensburg@bmw.de",
    "phone": "+49-941-7703636",
    "website": "https://www.bmw.de/de/partner/bmw-service-regensburg-07850.html",
    "coords": {
      "lat": 48.9813117980957,
      "lng": 12.170088768005371
    }
  },
  {
    "id": "28750_1",
    "name": "Utzel & Littmann GmbH",
    "country": "DE",
    "city": "Paderborn",
    "address": "Detmolder Str. 60, 33100 Paderborn",
    "email": "info@utzel-littmann.de",
    "phone": "+49-5251-699890",
    "website": "https://www.bmw-service-utzel-littmann.de",
    "coords": {
      "lat": 51.73000717163086,
      "lng": 8.763662338256836
    }
  },
  {
    "id": "29925_1",
    "name": "Gottstein GmbH Automobile + Motorräder",
    "country": "DE",
    "city": "Waldshut-Tiengen",
    "address": "Karl-Ziegler-Straße 4, 79761 Waldshut-Tiengen",
    "email": "info@bmw-gottstein.de",
    "phone": "+49-7751-83920",
    "website": "https://www.gottstein-gruppe.de/de/marken/bmw/",
    "coords": {
      "lat": 47.61676788330078,
      "lng": 8.244810104370117
    }
  },
  {
    "id": "29925_3",
    "name": "Gottstein GmbH Automobile + Motorräder",
    "country": "DE",
    "city": "Bad Säckingen",
    "address": "Im Grütt 14, 79713 Bad Säckingen",
    "email": "info@bmw-gottstein.de",
    "phone": "+49-7761-92300",
    "website": "https://www.bmw.de/de/partner/gottstein-bad-saeckingen-00396.html",
    "coords": {
      "lat": 47.552711486816406,
      "lng": 7.927049160003662
    }
  },
  {
    "id": "30637_1",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Bad Kreuznach",
    "address": "Industriestr. 37, 55543 Bad Kreuznach",
    "email": "info@cloppenburg-badkreuznach.de",
    "phone": "+49-671-887000",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 49.85356140136719,
      "lng": 7.893943786621094
    }
  },
  {
    "id": "23463_3",
    "name": "Autohaus Becker-Tiemann GmbH & Co. KG",
    "country": "DE",
    "city": "Lemgo",
    "address": "Entruper Weg 23, 32657 Lemgo",
    "email": "lemgo@becker-tiemann.de",
    "phone": "+49-5261-25850",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.032371520996094,
      "lng": 8.893514633178711
    }
  },
  {
    "id": "23483_1",
    "name": "Wolter & Steiner Handels GmbH",
    "country": "DE",
    "city": "Waren/Müritz",
    "address": "Siegfried-Marcus-Str. 5, 17192 Waren/Müritz",
    "email": "info.wrn@wolter-steiner.de",
    "phone": "+49-3991-611500",
    "website": "http://bmw-wolter-steiner.de/de/home",
    "coords": {
      "lat": 53.52033233642578,
      "lng": 12.717618942260742
    }
  },
  {
    "id": "32292_2",
    "name": "Autohaus Becker-Tiemann Minden-Lübbecke GmbH & Co. KG",
    "country": "DE",
    "city": "Lübbecke",
    "address": "Siemensstr. 4, 32312 Lübbecke",
    "email": "luebbecke@becker-tiemann.de",
    "phone": "+49-5741-31800",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.324161529541016,
      "lng": 8.626870155334473
    }
  },
  {
    "id": "33952_2",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Wangen",
    "address": "Am Waltersbühl 3, 88239 Wangen",
    "email": "info.wangen@bmw-unterberger.de",
    "phone": "+49-7522-93030",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.69763946533203,
      "lng": 9.82510757446289
    }
  },
  {
    "id": "26636_5",
    "name": "Procar Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Köln",
    "address": "Bayerische Allee 1, 50858 Köln",
    "email": "koelnwest@bmw-procar.de",
    "phone": "+49-2234-9150",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 50.914669036865234,
      "lng": 6.85368013381958
    }
  },
  {
    "id": "33952_3",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Pfullendorf",
    "address": "Otterswanger Str. 7, 88630 Pfullendorf",
    "email": "info.pfullendorf@bmw-unterberger.de",
    "phone": "+49-7552-20010",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.93391418457031,
      "lng": 9.240349769592285
    }
  },
  {
    "id": "34244_1",
    "name": "L + K Hackelbörger GmbH",
    "country": "DE",
    "city": "Beckum",
    "address": "Zünftestr. 2, 59269 Beckum",
    "email": "service@bmw-hackelboerger.de",
    "phone": "+49-2521-96592-0",
    "website": "https://www.bmw.de/de/partner/hackelboerger-beckum-34244.html",
    "coords": {
      "lat": 51.77131271362305,
      "lng": 8.0341796875
    }
  },
  {
    "id": "35232_5",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Bad Segeberg",
    "address": "Lindhofstr. 16, 23795 Bad Segeberg",
    "email": "info.segeberg@hansanord.com",
    "phone": "+49-4551-88030",
    "website": "https://www.hansanord.com/hansa-nord-bad-segeberg/",
    "coords": {
      "lat": 53.95232391357422,
      "lng": 10.309089660644531
    }
  },
  {
    "id": "27847_1",
    "name": "BMW Service Moser GmbH & Co. KG",
    "country": "DE",
    "city": "Kirchdorf/Inn",
    "address": "Robert-Bosch-Ring 1, 84375 Kirchdorf/Inn",
    "email": "norbert.moser@bmwservice-moser.de",
    "phone": "+49-8571-91410",
    "website": "https://www.moser-service.bmw/de/home/",
    "coords": {
      "lat": 48.25800323486328,
      "lng": 13.00063419342041
    }
  },
  {
    "id": "27920_1",
    "name": "Autohaus Wallenwein GmbH",
    "country": "DE",
    "city": "Bingen",
    "address": "Scharlachbergstr. 1, 55411 Bingen",
    "email": "info@wallenwein.com",
    "phone": "+49-6721-97300",
    "website": "https://bmw.de/de/partner/autohaus-wallenwein-bingen-buedesheim-27920.html",
    "coords": {
      "lat": 49.951419830322266,
      "lng": 7.9075798988342285
    }
  },
  {
    "id": "28235_1",
    "name": "Team Pilz GmbH",
    "country": "DE",
    "city": "Dieburg",
    "address": "Aschaffenburger Straße 44, 64807 Dieburg",
    "email": "info@bmw-service-pilz.de",
    "phone": "+49-6071-20900",
    "website": "https://www.bmw.de/de/partner/team-pilz-dieburg-28235.html",
    "coords": {
      "lat": 49.903358459472656,
      "lng": 8.859268188476562
    }
  },
  {
    "id": "28497_1",
    "name": "Autohaus Hilgert GmbH",
    "country": "DE",
    "city": "Salzgitter",
    "address": "Leibnizstr. 14, 38228 Salzgitter",
    "email": "info@autohaus-hilgert.de",
    "phone": "+49-5341-85350",
    "website": "https://www.bmw.de/de/partner/autohaus-hilgert-salzgitter-28497.html",
    "coords": {
      "lat": 52.14585876464844,
      "lng": 10.314169883728027
    }
  },
  {
    "id": "28964_1",
    "name": "Autohaus Rump GmbH",
    "country": "DE",
    "city": "Nottuln",
    "address": "Appelhülsener Str. 16, 48301 Nottuln",
    "email": "info@autohaus-rump.de",
    "phone": "+49-2502-94020",
    "website": "https://www.bmw-service-rump.de",
    "coords": {
      "lat": 51.927310943603516,
      "lng": 7.363170146942139
    }
  },
  {
    "id": "29344_6",
    "name": "Autohaus Becker-Tiemann Schaumburg GmbH & Co. KG",
    "country": "DE",
    "city": "Springe",
    "address": "Philipp-Reis-Str. 50, 31832 Springe",
    "email": "springe@becker-tiemann.de",
    "phone": "+49-5041-9422-0",
    "website": "https://www.becker-tiemann.de",
    "coords": {
      "lat": 52.21834182739258,
      "lng": 9.572139739990234
    }
  },
  {
    "id": "30635_3",
    "name": "AH Euler Pirmasens GmbH Filiale Bad Bergzabern",
    "country": "DE",
    "city": "Pleisweiler-Oberhofen",
    "address": "Im Weidfeld 4, 76889 Pleisweiler-Oberhofen",
    "email": "info@euler-group.de",
    "phone": "+49-6343-93790",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 49.10694122314453,
      "lng": 8.011940956115723
    }
  },
  {
    "id": "31058_1",
    "name": "Autohaus Schwarz GmbH",
    "country": "DE",
    "city": "Kornwestheim",
    "address": "Enzstr. 24-26, 70806 Kornwestheim",
    "email": "info@schwarz-service.de",
    "phone": "+49-7154-178560",
    "website": "https://www.bmw.de/de/partner/autohaus-schwarz-kornwestheim-31058.html",
    "coords": {
      "lat": 48.86495590209961,
      "lng": 9.207664489746094
    }
  },
  {
    "id": "31117_1",
    "name": "Autohaus Mulfinger GmbH",
    "country": "DE",
    "city": "Schwäbisch Gmünd",
    "address": "Marie-Curie-Str. 11, 73529 Schwäbisch Gmünd",
    "email": "verkauf.schwaebisch-gmuend@mulfinger.de",
    "phone": "+49-7171-6009-0",
    "website": "https://www.mulfinger.bmw",
    "coords": {
      "lat": 48.789100646972656,
      "lng": 9.759320259094238
    }
  },
  {
    "id": "31585_4",
    "name": "Autohaus Michael Schmidt GmbH",
    "country": "DE",
    "city": "Germering",
    "address": "Industriestr. 8, 82110 Germering",
    "email": "info@bmw-schmidt.com",
    "phone": "+49-89-8941530",
    "website": "https://www.bmw-schmidt.com",
    "coords": {
      "lat": 48.131290435791016,
      "lng": 11.37460994720459
    }
  },
  {
    "id": "32517_1",
    "name": "Autohaus Tekken Aurich GmbH & Co. KG",
    "country": "DE",
    "city": "Aurich",
    "address": "Tjüchkampstr. 4 a, 26605 Aurich",
    "email": "autohaus.tekken@tekken.de",
    "phone": "+49-4941-93390",
    "website": "https://tekken.de/",
    "coords": {
      "lat": 53.441810607910156,
      "lng": 7.514745235443115
    }
  },
  {
    "id": "33229_1",
    "name": "Autohaus Schenk GmbH & Co. KG",
    "country": "DE",
    "city": "Ehingen",
    "address": "Röntgenstr. 13, 89584 Ehingen",
    "email": "autohaus.schenk@bmw-schenk.de",
    "phone": "+49-7391-77430",
    "website": "https://www.bmw.de/de/partner/autohaus-schenk-ehingen-33229.html",
    "coords": {
      "lat": 48.29153060913086,
      "lng": 9.721150398254395
    }
  },
  {
    "id": "33240_2",
    "name": "Autohaus Manfred Eggert GmbH",
    "country": "DE",
    "city": "Bergen auf Rügen",
    "address": "Stralsunder Chaussee 21, 18528 Bergen auf Rügen",
    "email": "bmw@auto-eggert.com",
    "phone": "+49-3838-820380",
    "website": "https://www.bmw.de/de_DE/partner/autohaus-manfred-eggert-ruegen-33099.html",
    "coords": {
      "lat": 54.40972900390625,
      "lng": 13.422680854797363
    }
  },
  {
    "id": "33248_1",
    "name": "Autohaus E. Funke Inhaber Ralf Funke e.K.",
    "country": "DE",
    "city": "Kirchhain",
    "address": "Fuldaer Str. 3, 35274 Kirchhain",
    "email": "info@bmw-service-funke.de",
    "phone": "+49-6422-4055",
    "website": "https://www.bmw.de/de/partner/autohaus-funke-kirchhain-33248.html",
    "coords": {
      "lat": 50.818634033203125,
      "lng": 8.941519737243652
    }
  },
  {
    "id": "34269_1",
    "name": "Autohaus M & M Parchim GmbH",
    "country": "DE",
    "city": "Parchim",
    "address": "Ziegendorfer Chaussee 87, 19370 Parchim",
    "email": "info@autohaus-mm.de",
    "phone": "+49-3871-62090",
    "website": "https://www.bmw.de/de/partner/autohaus-mm-parchim-34269.html",
    "coords": {
      "lat": 53.41680145263672,
      "lng": 11.81712532043457
    }
  },
  {
    "id": "35644_5",
    "name": "mobilforum GmbH",
    "country": "DE",
    "city": "Freiberg",
    "address": "Häuersteig 25, 09599 Freiberg",
    "email": "fg@mobilforum-gruppe.de",
    "phone": "+49-3731-6767-0",
    "website": "https://www.bmw-mobilforum.de/de/home/",
    "coords": {
      "lat": 50.89773178100586,
      "lng": 13.330068588256836
    }
  },
  {
    "id": "34794_1",
    "name": "Autohaus Norbert Stang e.K.",
    "country": "DE",
    "city": "Neustadt-Glewe",
    "address": "Seestraße 20, 19306 Neustadt-Glewe",
    "email": "info@bmw-service-stang.de",
    "phone": "+49-38757-22543",
    "website": "https://www.bmw.de/de/partner/autohaus-norbert-stang-neustadt-glewe-24794.html",
    "coords": {
      "lat": 53.386924743652344,
      "lng": 11.580795288085938
    }
  },
  {
    "id": "35136_1",
    "name": "Autohaus Leschitzki GmbH",
    "country": "DE",
    "city": "Greifswald",
    "address": "An den Bäckerwiesen 3, 17489 Greifswald",
    "email": "info@bmw-service-leschitzki.de",
    "phone": "+49-3834-57180",
    "website": "https://www.bmw.de/de/partner/autohaus-leschitzki-greifswald-35136.html",
    "coords": {
      "lat": 54.07169723510742,
      "lng": 13.387479782104492
    }
  },
  {
    "id": "35232_1",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Lübeck",
    "address": "Berliner Str. 10, 23560 Lübeck",
    "email": "info.luebeck@hansanord.com",
    "phone": "+49-451-583750",
    "website": "https://www.hansanord.com/hansa-nord-lubeck/",
    "coords": {
      "lat": 53.84791564941406,
      "lng": 10.683614730834961
    }
  },
  {
    "id": "38445_1",
    "name": "Felix Automobile GmbH",
    "country": "DE",
    "city": "Bottrop",
    "address": "Gladbecker Str. 120, 46236 Bottrop",
    "email": "info@bmw-felix.de",
    "phone": "+49-2041-18470",
    "website": "https://www.bmw-felix.de",
    "coords": {
      "lat": 51.53303527832031,
      "lng": 6.9305009841918945
    }
  },
  {
    "id": "39688_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Freilassing",
    "address": "Görlitzer Straße 3, 83395 Freilassing",
    "email": "autohaus@bmw-unterberger.de",
    "phone": "+49-8654-4950",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.854957580566406,
      "lng": 12.963658332824707
    }
  },
  {
    "id": "48159_1",
    "name": "Autohaus Bothe Inh. Mike Bothe",
    "country": "DE",
    "city": "Frankfurt (Oder)",
    "address": "Berliner Chaussee 91, 15234 Frankfurt (Oder)",
    "email": "mike.bothe@bmw-service-bothe.de",
    "phone": "+49-335-683790",
    "website": "https://www.bmw.de/de/partner/autohaus-bothe-frankfurt-oder-48159.html",
    "coords": {
      "lat": 52.36484909057617,
      "lng": 14.524226188659668
    }
  },
  {
    "id": "38476_2",
    "name": "AHAG Bochum GmbH",
    "country": "DE",
    "city": "Bochum",
    "address": "Porschestraße 4, 44809 Bochum",
    "email": "kontakt.bochum@ahag-bochum.de",
    "phone": "+49-234-6014060",
    "website": "https://www.ahag-group.bmw",
    "coords": {
      "lat": 51.486961364746094,
      "lng": 7.193297863006592
    }
  },
  {
    "id": "51178_4",
    "name": "Autohaus Krah + Enders GmbH & Co. KG",
    "country": "DE",
    "city": "Limburg a.d. Lahn",
    "address": "An der Meil 6, 65555 Limburg a.d. Lahn",
    "email": "info@bmw-krah-enders-limburg.de",
    "phone": "+49-6431-5295-0",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.408409118652344,
      "lng": 8.073884010314941
    }
  },
  {
    "id": "51107_1",
    "name": "Autohaus Rhein Franken GmbH",
    "country": "DE",
    "city": "Lauf a.d. Pegnitz",
    "address": "Industriestraße 19, 91207 Lauf a.d. Pegnitz",
    "email": "info@rhein-franken.de",
    "phone": "+49-09123-96950",
    "website": "https://www.rhein-franken.de",
    "coords": {
      "lat": 49.50266647338867,
      "lng": 11.291749954223633
    }
  },
  {
    "id": "52828_1",
    "name": "Ehrhardt AG",
    "country": "DE",
    "city": "Sonneberg",
    "address": "Dr. Hans-Popp-Straße 2, 96515 Sonneberg",
    "email": "bmw.service@ehrhardt.com",
    "phone": "+49-3675-40940",
    "website": "https://www.ah-ehrhardt.de",
    "coords": {
      "lat": 50.346553802490234,
      "lng": 11.218981742858887
    }
  },
  {
    "id": "48875_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Bad Wiessee",
    "address": "Münchner Straße 47-49, 83707 Bad Wiessee",
    "email": "info.bw@bmw-unterberger.de",
    "phone": "+49-8022-86040",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.718013763427734,
      "lng": 11.719051361083984
    }
  },
  {
    "id": "52090_1",
    "name": "Autohaus Becker-Tiemann Spenge GmbH & Co. KG",
    "country": "DE",
    "city": "Spenge",
    "address": "Düttingdorfer Str. 342, 32139 Spenge",
    "email": "spenge@becker-tiemann.de",
    "phone": "+49-5225-87850",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.1278076171875,
      "lng": 8.415115356445312
    }
  },
  {
    "id": "39322_1",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Heidenheim/ Brenz",
    "address": "In den Seewiesen 62, 89520 Heidenheim/ Brenz",
    "email": "verkauf.heidenheim@mulfinger.de",
    "phone": "+49-7321-35800",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 48.70029067993164,
      "lng": 10.165780067443848
    }
  },
  {
    "id": "40917_1",
    "name": "Martin Jacoby GmbH & Co. KG",
    "country": "DE",
    "city": "Hilden",
    "address": "Walder Straße 418, 40724 Hilden",
    "email": "info@martin-jacoby.com",
    "phone": "+49-212-2338790",
    "website": "https://www.bmw.de/de/partner/martin-jacoby-hilden-40917.html",
    "coords": {
      "lat": 51.16748809814453,
      "lng": 6.983668804168701
    }
  },
  {
    "id": "53059_1",
    "name": "Bühler & Ruff GmbH",
    "country": "DE",
    "city": "Hechingen",
    "address": "Am Schnellengarten 9, 72379 Hechingen",
    "email": "info@buehler-ruff.de",
    "phone": "+49-7471-98750",
    "website": "https://www.buehler-ruff.de",
    "coords": {
      "lat": 48.37049865722656,
      "lng": 8.961939811706543
    }
  },
  {
    "id": "04071_2",
    "name": "Procar Automobile Düsseldorf GmbH",
    "country": "DE",
    "city": "Hilden",
    "address": "Düsseldorfer Str. 2, 40721 Hilden",
    "email": "hilden@bmw-procar.de",
    "phone": "+49-2103-5020",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.16585159301758,
      "lng": 6.9224348068237305
    }
  },
  {
    "id": "26636_2",
    "name": "Procar Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Köln",
    "address": "Raderthalgürtel 1a, 50968 Köln",
    "email": "koelnsued@bmw-procar.de",
    "phone": "+49-221-376980",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 50.90375518798828,
      "lng": 6.955880165100098
    }
  },
  {
    "id": "00353_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Wiehl",
    "address": "Robert-Bosch-Str. 4, 51674 Wiehl",
    "email": "info.wiehl@kaltenbach-gruppe.de",
    "phone": "+49-2261-94720",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 50.96870040893555,
      "lng": 7.521599769592285
    }
  },
  {
    "id": "01263_4",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Salzwedel",
    "address": "Hauptstr. 6, 29410 Salzwedel",
    "email": "salzwedel@bundk.de",
    "phone": "+49-3901-83930",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.86704635620117,
      "lng": 11.095853805541992
    }
  },
  {
    "id": "01263_13",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Bad Homburg v.d.H.",
    "address": "Ober-Eschbacher Str. 153, 61352 Bad Homburg v.d.H.",
    "email": "badhomburg@bundk.de",
    "phone": "+49-6172-30900",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 50.210689544677734,
      "lng": 8.656840324401855
    }
  },
  {
    "id": "23309_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Remscheid",
    "address": "Borner Str. 35, 42897 Remscheid",
    "email": "info.remscheid@kaltenbach-gruppe.de",
    "phone": "+49-2191-463700",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.17755126953125,
      "lng": 7.254660129547119
    }
  },
  {
    "id": "01413_1",
    "name": "Autohaus Kaltenbach GmbH",
    "country": "DE",
    "city": "Waldbröl",
    "address": "Mühlenweg 1, 51545 Waldbröl",
    "email": "info.waldbroel@kaltenbach-gruppe.de",
    "phone": "+49-2291-92430",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 50.86900329589844,
      "lng": 7.599685192108154
    }
  },
  {
    "id": "00863_3",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Osnabrück",
    "address": "Sutthauser Str. 292, 49080 Osnabrück",
    "email": "osnabrueck@bundk.de",
    "phone": "+49-541-50000",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.247840881347656,
      "lng": 8.035309791564941
    }
  },
  {
    "id": "00863_7",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Cloppenburg",
    "address": "Nicolaus-Otto-Str. 1, 49661 Cloppenburg",
    "email": "clp@wellergruppe.de",
    "phone": "+49-4471-85020",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.835330963134766,
      "lng": 8.098170280456543
    }
  },
  {
    "id": "01263_5",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Uelzen",
    "address": "Nordallee 7, 29525 Uelzen",
    "email": "uelzen@bundk.de",
    "phone": "+49-581-970000",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.98670196533203,
      "lng": 10.54776668548584
    }
  },
  {
    "id": "01263_12",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Höxter",
    "address": "Holzmindener Str. 30, 37671 Höxter",
    "email": "hoexter@bundk.de",
    "phone": "+49-5531-93090",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.830867767333984,
      "lng": 9.4364652633667
    }
  },
  {
    "id": "01263_11",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Burgdorf",
    "address": "Lise-Meitner-Str. 4, 31303 Burgdorf",
    "email": "burgdorf@bundk.de",
    "phone": "+49-5136-88260",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.45980453491211,
      "lng": 9.993416786193848
    }
  },
  {
    "id": "01263_6",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Bad Oeynhausen",
    "address": "Mindener Str. 18, 32547 Bad Oeynhausen",
    "email": "oeynhausen@bundk.de",
    "phone": "+49-5731-25040",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.21181106567383,
      "lng": 8.81322956085205
    }
  },
  {
    "id": "01263_15",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Paderborn",
    "address": "Stedener Feld 2, 33104 Paderborn",
    "email": "paderborn@bundk.de",
    "phone": "+49-5251-13520",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.729862213134766,
      "lng": 8.722343444824219
    }
  },
  {
    "id": "01263_22",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Wolfenbüttel",
    "address": "Goslarsche Str. 32, 38304 Wolfenbüttel",
    "email": "info-wolfenbuettel@blockamring.de",
    "phone": "+49-5331-88260",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.16077423095703,
      "lng": 10.526744842529297
    }
  },
  {
    "id": "01263_14",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Kronberg",
    "address": "Frankfurter Str. 40-42, 61476 Kronberg",
    "email": "kronberg@bundk.de",
    "phone": "+49-6173-99610",
    "website": "https://www.bmw-bundk.de",
    "coords": {
      "lat": 50.17494583129883,
      "lng": 8.522322654724121
    }
  },
  {
    "id": "01263_17",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Detmold",
    "address": "Windmeierweg 12, 32758 Detmold",
    "email": "det@wellergruppe.de",
    "phone": "+49-5231-70050",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.960689544677734,
      "lng": 8.84124755859375
    }
  },
  {
    "id": "31099_1",
    "name": "Autohaus Kaltenbach GmbH",
    "country": "DE",
    "city": "Bergisch Gladbach",
    "address": "Mülheimer Str. 185-195, 51469 Bergisch Gladbach",
    "email": "info.gladbach@kaltenbach-gruppe.de",
    "phone": "+49-2202-95380",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 50.98429489135742,
      "lng": 7.111324787139893
    }
  },
  {
    "id": "01263_23",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Goslar",
    "address": "Hildesheimer Str. 38, 38644 Goslar",
    "email": "info-goslar@blockamring.de",
    "phone": "+49-5321-37420",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.92184829711914,
      "lng": 10.413829803466797
    }
  },
  {
    "id": "01914_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Lüdenscheid",
    "address": "Kölner Str. 137, 58509 Lüdenscheid",
    "email": "info.luedenscheid@kaltenbach-gruppe.de",
    "phone": "+49-2351-664020",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.21131134033203,
      "lng": 7.616040229797363
    }
  },
  {
    "id": "38573_1",
    "name": "Kaltenbach Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Olpe",
    "address": "Im Langen Feld 8, 57462 Olpe",
    "email": "info.olpe@kaltenbach-gruppe.de",
    "phone": "+49-2761-90280",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.00053787231445,
      "lng": 7.83847713470459
    }
  },
  {
    "id": "00795_3",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "Siegburg",
    "address": "Zeithstr. 89, 53721 Siegburg",
    "email": "kontakt-Siegburg@hakvoort.de",
    "phone": "+49-2241-969290",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.80220031738281,
      "lng": 7.217970848083496
    }
  },
  {
    "id": "01806_1",
    "name": "Autohaus Graser GmbH",
    "country": "DE",
    "city": "Pressath",
    "address": "Eschenbacher Str. 1, 92690 Pressath",
    "email": "info@ah-graser.de",
    "phone": "+49-9644-92290",
    "website": "https://www.bmw.de/de/partner/autohaus-graser-pressath-01806.html",
    "coords": {
      "lat": 49.76491928100586,
      "lng": 11.923669815063477
    }
  },
  {
    "id": "03821_1",
    "name": "Autohaus Müller Leipzig GmbH",
    "country": "DE",
    "city": "Leipzig",
    "address": "Schongauer Str. 29-31, 04328 Leipzig",
    "email": "info@automobile-mueller.info",
    "phone": "+49-341-2587300",
    "website": "https:///www.bmw.de/de/partner/autohaus-mueller-leipzig-03821.html",
    "coords": {
      "lat": 51.34818649291992,
      "lng": 12.47344970703125
    }
  },
  {
    "id": "04553_8",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Schneeberg",
    "address": "Hohe Str. 2, 08289 Schneeberg",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-3772-39170",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.575035095214844,
      "lng": 12.634342193603516
    }
  },
  {
    "id": "33234_1",
    "name": "Schmid Service GmbH",
    "country": "DE",
    "city": "Hauzenberg",
    "address": "Furtstr. 32, 94051 Hauzenberg",
    "email": "info@schmid-leebmann.de",
    "phone": "+49-8586-96390",
    "website": "https://www.leebmann.de",
    "coords": {
      "lat": 48.629722595214844,
      "lng": 13.640681266784668
    }
  },
  {
    "id": "54762_2",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Burghausen",
    "address": "Gewerbepark Lindach D 9A, 84489 Burghausen",
    "email": "info@bmw-unterberger.de",
    "phone": null,
    "website": "https://de.unterberger.cc/bmw/",
    "coords": {
      "lat": 48.161991119384766,
      "lng": 12.798640251159668
    }
  },
  {
    "id": "00139_6",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Frankenberg/ Eder",
    "address": "Röddenauer Str. 14, 35066 Frankenberg/ Eder",
    "email": "bmw.frankenberg@wahl-group.de",
    "phone": "+49-6451-50010",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 51.05740737915039,
      "lng": 8.78512954711914
    }
  },
  {
    "id": "00250_27",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Lahr",
    "address": "Dinglinger Hauptstr. 9, 77933 Lahr",
    "email": "bmw-lahr@ahg-mobile.de",
    "phone": "+49-7821-906990",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.34077072143555,
      "lng": 7.8577141761779785
    }
  },
  {
    "id": "00250_11",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Mühlacker",
    "address": "Vetterstr. 27, 75417 Mühlacker",
    "email": "bmw-muehlacker@ahg-mobile.de",
    "phone": "+49-7041-96320",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.957130432128906,
      "lng": 8.84904670715332
    }
  },
  {
    "id": "00186_1",
    "name": "Autohaus Timmermanns GmbH",
    "country": "DE",
    "city": "Kaarst",
    "address": "Hüngert 1, 41564 Kaarst",
    "email": "info@timmermanns.de",
    "phone": "+49-2131-96790",
    "website": "https://www.autohaus-timmermanns.bmw",
    "coords": {
      "lat": 51.21347427368164,
      "lng": 6.636645317077637
    }
  },
  {
    "id": "00391_9",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Ingelfingen",
    "address": "Eichendorffstr. 32, 74653 Ingelfingen",
    "email": "verkauf.ingelfingen@mulfinger.de",
    "phone": "+49-7940-92450",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 49.29598617553711,
      "lng": 9.663778305053711
    }
  },
  {
    "id": "00911_2",
    "name": "Klaus Scheller GmbH",
    "country": "DE",
    "city": "Grünstadt",
    "address": "Industriestr. 9, 67269 Grünstadt",
    "email": "info@bmw-scheller.de",
    "phone": "+49-6359-93240",
    "website": "https://www.bmw-scheller.de",
    "coords": {
      "lat": 49.56004333496094,
      "lng": 8.176220893859863
    }
  },
  {
    "id": "01822_2",
    "name": "Autohaus Fulda Krah & Enders GmbH",
    "country": "DE",
    "city": "Schlüchtern",
    "address": "Elmer Aue, 36381 Schlüchtern",
    "email": "info@bmw-krah-enders-schluechtern.de",
    "phone": "+49-6661-96010",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.3564453125,
      "lng": 9.5366849899292
    }
  },
  {
    "id": "00120_7",
    "name": "AH Stadel Zweig-NL der AH Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Eppingen",
    "address": "Bismarckstr. 55, 75031 Eppingen",
    "email": "info.epp@stadel.de",
    "phone": "+49-7262-20780",
    "website": "https://www.stadel.de/",
    "coords": {
      "lat": 49.13255310058594,
      "lng": 8.905977249145508
    }
  },
  {
    "id": "00916_1",
    "name": "Auto Wüst GmbH",
    "country": "DE",
    "city": "Kölbingen",
    "address": "Hauptstr. 28, 56459 Kölbingen",
    "email": "info@auto-wuest.de",
    "phone": "+49-2663-98799-30",
    "website": "http://bmw-wuest.de/de/home",
    "coords": {
      "lat": 50.551334381103516,
      "lng": 7.933839797973633
    }
  },
  {
    "id": "01263_8",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Winsen/Luhe",
    "address": "Lüneburger Str. 128-130, 21423 Winsen/Luhe",
    "email": "winsen@bundk.de",
    "phone": "+49-4171-78440",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 53.35251998901367,
      "lng": 10.227337837219238
    }
  },
  {
    "id": "00920_1",
    "name": "Autohaus Briem GmbH & Co. KG",
    "country": "DE",
    "city": "Filderstadt-Plattenhardt",
    "address": "Gutenbergstr. 9, 70794 Filderstadt-Plattenhardt",
    "email": "info@autohaus-briem.de",
    "phone": "+49-711-778810",
    "website": "https://bmw.de/de/partner/autohaus-briem-filderstadt-plattenhardt-00920.html",
    "coords": {
      "lat": 48.657440185546875,
      "lng": 9.202190399169922
    }
  },
  {
    "id": "01889_1",
    "name": "Autohaus Uwe Ratzel GmbH & Co. KG",
    "country": "DE",
    "city": "Linkenheim-Hochstetten",
    "address": "Waldstr. 44, 76351 Linkenheim-Hochstetten",
    "email": "info@bmw-ratzel.de",
    "phone": "+49-7247-93730",
    "website": "https://www.bmw.de/de/partner/autohaus-uwe-ratzel-linkenheim-01889.html",
    "coords": {
      "lat": 49.13190841674805,
      "lng": 8.42870044708252
    }
  },
  {
    "id": "30315_2",
    "name": "Ungeheuer Automobile GmbH",
    "country": "DE",
    "city": "Bruchsal",
    "address": "Murgstr. 4, 76646 Bruchsal",
    "email": "info@ungeheuer.de",
    "phone": "+49-7251-72160",
    "website": "https://www.ungeheuer-bmw.de",
    "coords": {
      "lat": 49.13774108886719,
      "lng": 8.592209815979004
    }
  },
  {
    "id": "30315_3",
    "name": "Ungeheuer Automobile GmbH",
    "country": "DE",
    "city": "Ettlingen",
    "address": "Hertzstr. 31, 76275 Ettlingen",
    "email": "info@ungeheuer.de",
    "phone": "+49-7243-54440",
    "website": "https://www.ungeheuer-bmw.de",
    "coords": {
      "lat": 48.939361572265625,
      "lng": 8.38113021850586
    }
  },
  {
    "id": "52912_1",
    "name": "Emil Frey Vogel Automobile GmbH",
    "country": "DE",
    "city": "Germersheim",
    "address": "Hafenstrasse 4, 76726 Germersheim",
    "email": "info@bmw-vogel.de",
    "phone": "+49-7274-9484-0",
    "website": "https://www.emilfrey.de/vogel-automobile",
    "coords": {
      "lat": 49.231998443603516,
      "lng": 8.370369911193848
    }
  },
  {
    "id": "37177_1",
    "name": "Autohaus Kaltenbach GmbH",
    "country": "DE",
    "city": "Arnsberg",
    "address": "Niedereimerfeld 16, 59823 Arnsberg",
    "email": "info.arnsberg@kaltenbach-gruppe.de",
    "phone": "+49-2932-6266",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.421539306640625,
      "lng": 8.036399841308594
    }
  },
  {
    "id": "52912_3",
    "name": "Emil Frey Vogel Automobile GmbH",
    "country": "DE",
    "city": "Zwingenberg",
    "address": "Gießer Weg 16, 64673 Zwingenberg",
    "email": "info@bmw-vogel.de",
    "phone": "+49-6251-7099-0",
    "website": "https://www.emilfrey.de/vogel-automobile",
    "coords": {
      "lat": 49.72309875488281,
      "lng": 8.602339744567871
    }
  },
  {
    "id": "07825_2",
    "name": "Autohaus Reier GmbH & Co. KG",
    "country": "DE",
    "city": "Berlin",
    "address": "Scharnweberstr. 132-133, 13405 Berlin",
    "email": "kontakt@autohaus-reier.de",
    "phone": "+49-30-4177910",
    "website": "http://bmw-reier.de/de/home/",
    "coords": {
      "lat": 52.56473159790039,
      "lng": 13.325209617614746
    }
  },
  {
    "id": "07315_1",
    "name": "Autohaus Matthes GmbH",
    "country": "DE",
    "city": "Meiningen",
    "address": "Herpfer Str. 38, 98617 Meiningen",
    "email": "info@bmw-matthes.de",
    "phone": "+49-3693-94000",
    "website": "https://www.bmw-matthes.de",
    "coords": {
      "lat": 50.561641693115234,
      "lng": 10.367070198059082
    }
  },
  {
    "id": "04109_5",
    "name": "Autohaus Fritze GmbH & Co. KG",
    "country": "DE",
    "city": "Nordhausen",
    "address": "Stresemannring 54, 99734 Nordhausen",
    "email": "info@autohaus-fritze.de",
    "phone": "+49-3631-68440",
    "website": "https://www.bmw-fritze.de",
    "coords": {
      "lat": 51.49778366088867,
      "lng": 10.814616203308105
    }
  },
  {
    "id": "24342_1",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Itzehoe",
    "address": "Papenkamp 1, 25524 Itzehoe",
    "email": "info@mayundolde.de",
    "phone": "+49-4821-439990",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.933685302734375,
      "lng": 9.485721588134766
    }
  },
  {
    "id": "24342_2",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Elmshorn",
    "address": "Hamburger Straße 134, 25337 Elmshorn",
    "email": "info@mayundolde.de",
    "phone": "+49-4121-90770",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.748775482177734,
      "lng": 9.688015937805176
    }
  },
  {
    "id": "24342_3",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Halstenbek",
    "address": "Stawedder 14-20, 25469 Halstenbek",
    "email": "info@mayundolde.de",
    "phone": "+49-4101-84220",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.6442985534668,
      "lng": 9.834067344665527
    }
  },
  {
    "id": "01443_8",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Schwabmünchen",
    "address": "Siemensstr. 25, 86830 Schwabmünchen",
    "email": "info@reisacher.de",
    "phone": "+49-8331-95500",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.166133880615234,
      "lng": 10.756046295166016
    }
  },
  {
    "id": "00250_23",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Achern",
    "address": "Fautenbacher Str. 15, 77855 Achern",
    "email": "bmw-achern@ahg-mobile.de",
    "phone": "+49-7841-62190",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.62745666503906,
      "lng": 8.057251930236816
    }
  },
  {
    "id": "35644_3",
    "name": "mobilforum GmbH",
    "country": "DE",
    "city": "Senftenberg",
    "address": "Laugkfeld 28, 01968 Senftenberg",
    "email": "sfb@mobilforum-gruppe.de",
    "phone": "+49-3573-70660",
    "website": "https://mobilforum.de/",
    "coords": {
      "lat": 51.52888870239258,
      "lng": 14.016079902648926
    }
  },
  {
    "id": "00406_6",
    "name": "Auer Gruppe GmbH",
    "country": "DE",
    "city": "Singen",
    "address": "Freibühlstr. 1, 78224 Singen",
    "email": "singen@auer-gruppe.de",
    "phone": "+49-7731-86850",
    "website": "https://www.bmw.de/de/partner/auer-gruppe-singen-22099.html",
    "coords": {
      "lat": 47.75813674926758,
      "lng": 8.865086555480957
    }
  },
  {
    "id": "00406_2",
    "name": "Auer Gruppe GmbH",
    "country": "DE",
    "city": "Ravensburg",
    "address": "Ganterhofstrasse 1, 88213 Ravensburg",
    "email": "weingarten@auer-gruppe.de",
    "phone": "+49-751-50930",
    "website": "https://www.bmw.de/de/partner/auer-gruppe-ravensburg-23363.html",
    "coords": {
      "lat": 47.76878356933594,
      "lng": 9.552998542785645
    }
  },
  {
    "id": "02428_4",
    "name": "Bobrink & Co. GmbH",
    "country": "DE",
    "city": "Osterholz-Scharmbeck",
    "address": "Ritterhuder Str. 56, 27711 Osterholz-Scharmbeck",
    "email": "bobrink.ohz@bmw-bobrink.de",
    "phone": "+49-4791-964060",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.217044830322266,
      "lng": 8.7802152633667
    }
  },
  {
    "id": "54761_1",
    "name": "Autohaus Melkus GmbH",
    "country": "DE",
    "city": "Dresden",
    "address": "Hamburger Str. 30, 01067 Dresden",
    "email": "info.dresden@bmw-melkus.de",
    "phone": "+49-351-269970",
    "website": "https://www.bmw-melkus.de",
    "coords": {
      "lat": 51.059688568115234,
      "lng": 13.699179649353027
    }
  },
  {
    "id": "35658_2",
    "name": "Autohaus Fink GmbH & Co. KG",
    "country": "DE",
    "city": "Leutkirch",
    "address": "Beim Hammerschmied 12, 88299 Leutkirch",
    "email": "leutkirch@bmw-fink.de",
    "phone": "+49-7561-817080",
    "website": "https://www.bmw-fink.de/",
    "coords": {
      "lat": 47.827598571777344,
      "lng": 10.011838912963867
    }
  },
  {
    "id": "00074_16",
    "name": "BMW AG Niederlassung Kassel",
    "country": "DE",
    "city": "Kassel",
    "address": "Scharnhorststr. 14, 34125 Kassel",
    "email": "nl.kassel@bmw.de",
    "phone": "+49-561-570000",
    "website": "https://www.bmw-kassel.de/de/home/",
    "coords": {
      "lat": 51.313934326171875,
      "lng": 9.51717472076416
    }
  },
  {
    "id": "00081_3",
    "name": "BMW AG Niederlassung Berlin Filiale Weißensee",
    "country": "DE",
    "city": "Berlin",
    "address": "Gehringstr. 20, 13088 Berlin",
    "email": "nl.berlin@bmw.de",
    "phone": "+49-30-200990",
    "website": "https://www.bmw-berlin.de/de/home/",
    "coords": {
      "lat": 52.56256866455078,
      "lng": 13.463589668273926
    }
  },
  {
    "id": "00114_4",
    "name": "Hermann Menton GmbH & Co KG",
    "country": "DE",
    "city": "Münsingen",
    "address": "Graf-Zeppelin-Straße 2, 72525 Münsingen",
    "email": "info@menton.de",
    "phone": "+49-7381-756990",
    "website": "https://www.menton.de",
    "coords": {
      "lat": 48.41609573364258,
      "lng": 9.476935386657715
    }
  },
  {
    "id": "00120_21",
    "name": "Autohaus Rhein Hochfranken Zw.Ndl. der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Hof",
    "address": "Schneebergstraße 5, 95032 Hof",
    "email": "info@rhein-hochfranken.de",
    "phone": "+49-9281-7573-0",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 50.29103088378906,
      "lng": 11.92529582977295
    }
  },
  {
    "id": "00139_8",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Dautphetal",
    "address": "Talstr. 19, 35232 Dautphetal",
    "email": "bmw.dautphetal@wahl-group.de",
    "phone": "+49-6468-9140-0",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.814720153808594,
      "lng": 8.532007217407227
    }
  },
  {
    "id": "00153_1",
    "name": "Auto Becker Hans Klausmann GmbH & Co. KG",
    "country": "DE",
    "city": "Krefeld",
    "address": "Glockenspitz 123, 47800 Krefeld",
    "email": "info@auto-becker-klausmann.de",
    "phone": "+49-2151-51040",
    "website": "https://www.auto-becker-klausmann.de",
    "coords": {
      "lat": 51.335121154785156,
      "lng": 6.596859931945801
    }
  },
  {
    "id": "00250_1",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Horb/Neckar",
    "address": "Weberstr. 13, 72160 Horb/Neckar",
    "email": "bmw-horb@ahg-mobile.de",
    "phone": "+49-7451-53990",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.45684814453125,
      "lng": 8.6958646774292
    }
  },
  {
    "id": "00250_13",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Villingen-Schwenningen",
    "address": "Auf Herdenen 2, 78052 Villingen-Schwenningen",
    "email": "bmw-villingen-schwenningen@ahg-mobile.de",
    "phone": "+49-7721-95940",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.076961517333984,
      "lng": 8.500574111938477
    }
  },
  {
    "id": "00332_3",
    "name": "Bobrink GmbH",
    "country": "DE",
    "city": "Bremerhaven",
    "address": "Am Lunedeich 182, 27572 Bremerhaven",
    "email": "bobrink.sued@bmw-bobrink.de",
    "phone": "+49-471-9008400",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.49095153808594,
      "lng": 8.594884872436523
    }
  },
  {
    "id": "00866_6",
    "name": "Autohaus Widmann + Winterholler GmbH",
    "country": "DE",
    "city": "Farchant",
    "address": "Partenkirchner Str. 34, 82490 Farchant",
    "email": "info@widmann-winterholler.de",
    "phone": "+49-8821-966760",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 47.521236419677734,
      "lng": 11.111715316772461
    }
  },
  {
    "id": "00866_10",
    "name": "Autohaus Widmann + Winterholler GmbH",
    "country": "DE",
    "city": "Weilheim i.OB.",
    "address": "Christoph-Selhamer-Str. 8, 82362 Weilheim i.OB.",
    "email": "info@bmw-ww.de",
    "phone": "+49-881-92478-0",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 47.847190856933594,
      "lng": 11.149589538574219
    }
  },
  {
    "id": "00887_1",
    "name": "Autohaus J. B. Lell e.K.",
    "country": "DE",
    "city": "Schwandorf",
    "address": "Industriestr. 18+20, 92421 Schwandorf",
    "email": "info@lell-bmw.de",
    "phone": "+49-9431-74440",
    "website": "https://www.lell-bmw.de",
    "coords": {
      "lat": 49.31193161010742,
      "lng": 12.100680351257324
    }
  },
  {
    "id": "00083_10",
    "name": "BMW AG Niederlassung Hamburg Filiale Elbvororte",
    "country": "DE",
    "city": "Hamburg",
    "address": "Osdorfer Landstr. 50, 22549 Hamburg",
    "email": "nl.hamburg@bmw.de",
    "phone": "+49-40-5530150",
    "website": "https://www.bmw-hamburg.de/de/home/",
    "coords": {
      "lat": 53.57160568237305,
      "lng": 9.865710258483887
    }
  },
  {
    "id": "00085_9",
    "name": "BMW AG Niederlassung Saarbrücken",
    "country": "DE",
    "city": "Saarbrücken",
    "address": "Am Halberg 6-7, 66121 Saarbrücken",
    "email": "bmw-saarbruecken@bmw.de",
    "phone": "+49-681-81060",
    "website": "https://www.bmw-saarland.de/de/home/",
    "coords": {
      "lat": 49.22415542602539,
      "lng": 7.0435261726379395
    }
  },
  {
    "id": "00085_10",
    "name": "BMW AG Niederlassung Saarlouis",
    "country": "DE",
    "city": "Saarlouis",
    "address": "Schanzenstr. 20, 66740 Saarlouis",
    "email": "bmw-saarlouis@bmw.de",
    "phone": "+49-6831-98950",
    "website": "https://www.bmw-saarland.de/de/home/",
    "coords": {
      "lat": 49.325199127197266,
      "lng": 6.749020099639893
    }
  },
  {
    "id": "01288_1",
    "name": "BMW AG Niederlassung Hannover",
    "country": "DE",
    "city": "Hannover",
    "address": "Lister Kirchweg 87, 30177 Hannover",
    "email": "onlinesales.hannover@bmw.de",
    "phone": "+49-511-626201",
    "website": "https://www.bmw-hannover.de",
    "coords": {
      "lat": 52.395973205566406,
      "lng": 9.75894546508789
    }
  },
  {
    "id": "01288_5",
    "name": "BMW AG Niederlassung Göttingen",
    "country": "DE",
    "city": "Göttingen",
    "address": "Herbert-Quandt-Str. 8, 37081 Göttingen",
    "email": "nl.goettingen@bmw.de",
    "phone": "+49-551-999090",
    "website": "https://www.bmw-goettingen.de",
    "coords": {
      "lat": 51.52545166015625,
      "lng": 9.885180473327637
    }
  },
  {
    "id": "01443_1",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Memmingen",
    "address": "Europastr. 1, 87700 Memmingen",
    "email": "info@reisacher.de",
    "phone": "+49-8331-95500",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 47.999000549316406,
      "lng": 10.152729988098145
    }
  },
  {
    "id": "01443_5",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Ulm",
    "address": "Blaubeurer Str. 110, 89077 Ulm",
    "email": "info@reisacher.de",
    "phone": "+49-731-189990",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.4008903503418,
      "lng": 9.960160255432129
    }
  },
  {
    "id": "01548_2",
    "name": "Autohaus Euler GmbH",
    "country": "DE",
    "city": "Frankfurt am Main",
    "address": "Königsteiner Str. 74, 65929 Frankfurt am Main",
    "email": "info@euler-group.de",
    "phone": "+49-69-3009080",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 50.10755157470703,
      "lng": 8.541999816894531
    }
  },
  {
    "id": "00114_1",
    "name": "Hermann Menton GmbH & Co KG",
    "country": "DE",
    "city": "Reutlingen",
    "address": "Am Heilbrunnen 145, 72766 Reutlingen",
    "email": "info@menton.de",
    "phone": "+49-7121-14800",
    "website": "https://www.menton.de",
    "coords": {
      "lat": 48.513389587402344,
      "lng": 9.232382774353027
    }
  },
  {
    "id": "00120_4",
    "name": "Autohaus Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Bad Rappenau",
    "address": "Riemenstr. 26, 74906 Bad Rappenau",
    "email": "info.br@heermann-rhein.de",
    "phone": "+49-7264-95960",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 49.23740005493164,
      "lng": 9.086795806884766
    }
  },
  {
    "id": "00120_12",
    "name": "Autohaus Rhein Schweinfurt Zw.Nl der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Schweinfurt",
    "address": "Amsterdamstr. 3, 97424 Schweinfurt",
    "email": "info@rhein-schweinfurt.de",
    "phone": "+49-9721-675270",
    "website": "http://www.rhein.bmw",
    "coords": {
      "lat": 50.02007293701172,
      "lng": 10.21909236907959
    }
  },
  {
    "id": "00120_20",
    "name": "Autohaus Rhein Kulmbach Zweig-NL der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Kulmbach",
    "address": "Am Milchhof 1, 95326 Kulmbach",
    "email": "info@rhein-kulmbach.de",
    "phone": "+49-9221-6900-0",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 50.11143493652344,
      "lng": 11.452345848083496
    }
  },
  {
    "id": "02428_3",
    "name": "Bobrink & Co. GmbH",
    "country": "DE",
    "city": "Bremen",
    "address": "Am Rabenfeld 7-9, 28757 Bremen",
    "email": "bobrink.hb-nord@bmw-bobrink.de",
    "phone": "+49-421-660560",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.18162155151367,
      "lng": 8.623000144958496
    }
  },
  {
    "id": "00131_2",
    "name": "Autohaus Karl + Co. GmbH & Co. KG",
    "country": "DE",
    "city": "Wiesbaden",
    "address": "Carl-Bosch-Str. 6, 65203 Wiesbaden",
    "email": "info@bmw-karl-co.de",
    "phone": "+49-611-278090",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.042728424072266,
      "lng": 8.22134017944336
    }
  },
  {
    "id": "00139_12",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Wetzlar",
    "address": "Dillfeld 25, 35576 Wetzlar",
    "email": "bmw.wetzlar@wahl-group.de",
    "phone": "+49-6441-91070",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.56904983520508,
      "lng": 8.48423957824707
    }
  },
  {
    "id": "00141_1",
    "name": "HANKO Kraftfahrzeughandel GmbH",
    "country": "DE",
    "city": "Koblenz",
    "address": "Moselring 27-29, 56073 Koblenz",
    "email": "info@hanko.de",
    "phone": "+49-261-40460",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.359378814697266,
      "lng": 7.588089942932129
    }
  },
  {
    "id": "00153_2",
    "name": "Auto Becker Hans Klausmann GmbH & Co. KG",
    "country": "DE",
    "city": "Kempen",
    "address": "Industriering Ost 50, 47906 Kempen",
    "email": "info@auto-becker-klausmann.de",
    "phone": "+49-2152-20510",
    "website": "https://www.auto-becker-klausmann.de",
    "coords": {
      "lat": 51.3696403503418,
      "lng": 6.435540199279785
    }
  },
  {
    "id": "00219_1",
    "name": "Baum-Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Bad Neuenahr-Ahrweiler",
    "address": "Heerstr. 87, 53474 Bad Neuenahr-Ahrweiler",
    "email": "info@baum-automobile.de",
    "phone": "+49-2641-75770",
    "website": "https://www.bmw-baum.de",
    "coords": {
      "lat": 50.548954010009766,
      "lng": 7.1340107917785645
    }
  },
  {
    "id": "00250_2",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Calw",
    "address": "Stuttgarter Str. 101, 75365 Calw",
    "email": "bmw-calw@ahg-mobile.de",
    "phone": "+49-7051-92450",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.70969009399414,
      "lng": 8.75905990600586
    }
  },
  {
    "id": "00250_15",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Sinzheim",
    "address": "In den Lissen 12, 76547 Sinzheim",
    "email": "bmw-baden-baden@ahg-mobile.de",
    "phone": "+49-7221-50880",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.77239990234375,
      "lng": 8.170940399169922
    }
  },
  {
    "id": "03829_2",
    "name": "Autohaus Wigger GmbH",
    "country": "DE",
    "city": "Güstrow",
    "address": "Lindbruch 1, 18273 Güstrow",
    "email": "info@bmw-wigger.de",
    "phone": "+49-3843-34480",
    "website": "http://bmw-wigger.de/de/home/",
    "coords": {
      "lat": 53.81290817260742,
      "lng": 12.190449714660645
    }
  },
  {
    "id": "00250_24",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Kehl",
    "address": "Königsberger Str. 10, 77694 Kehl",
    "email": "bmw-kehl@ahg-mobile.de",
    "phone": "+49-7851-93320",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.576847076416016,
      "lng": 7.819559097290039
    }
  },
  {
    "id": "00250_30",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Bretten",
    "address": "Melanchthonstraße 137, 75015 Bretten",
    "email": "bmw-bretten@ahg-mobile.de",
    "phone": "+49-7252-93970",
    "website": "https://www.ahg.bmw/",
    "coords": {
      "lat": 49.038536071777344,
      "lng": 8.690009117126465
    }
  },
  {
    "id": "00263_4",
    "name": "AHAG Münsterland GmbH",
    "country": "DE",
    "city": "Coesfeld",
    "address": "Rekener Str. 126, 48653 Coesfeld",
    "email": "kontakt.coesfeld@ahag-coesfeld.de",
    "phone": "+49-2541-94190",
    "website": "https://www.ahag-group.bmw/de/home/",
    "coords": {
      "lat": 51.932430267333984,
      "lng": 7.149787902832031
    }
  },
  {
    "id": "03897_1",
    "name": "Autohaus Lange GmbH & Co. KG",
    "country": "DE",
    "city": "Sundern",
    "address": "Hauptstr. 168 a, 59846 Sundern",
    "email": "info@bmw-lange.de",
    "phone": "+49-2933-2003",
    "website": "https://www.bmw.de/de/partner/autohaus-lange-sundern-03897.html",
    "coords": {
      "lat": 51.33306121826172,
      "lng": 8.001397132873535
    }
  },
  {
    "id": "00316_1",
    "name": "Autohaus Joas OHG",
    "country": "DE",
    "city": "Dillingen",
    "address": "Am Reitweg 10, 89407 Dillingen",
    "email": "info@bmw-joas.de",
    "phone": "+49-9071-58850",
    "website": "https://www.bmw-joas.de/",
    "coords": {
      "lat": 48.57767868041992,
      "lng": 10.499975204467773
    }
  },
  {
    "id": "00332_1",
    "name": "Bobrink GmbH",
    "country": "DE",
    "city": "Bremerhaven",
    "address": "Stresemannstr. 319, 27580 Bremerhaven",
    "email": "bobrink.nord@bmw-bobrink.de",
    "phone": "+49-471-982800",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.571678161621094,
      "lng": 8.597140312194824
    }
  },
  {
    "id": "00391_8",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Michelfeld",
    "address": "Im Buchhorn 3, 74545 Michelfeld",
    "email": "verkauf.schwaebisch-hall@mulfinger.de",
    "phone": "+49-791-950450",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 49.10335922241211,
      "lng": 9.695899963378906
    }
  },
  {
    "id": "04107_1",
    "name": "BMW AG Niederlassung München MINI München",
    "country": "DE",
    "city": "München",
    "address": "Petuelring 124/PKW:Riesenfeldstr.7, 80809 München",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-3535-40",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.17707824707031,
      "lng": 11.564780235290527
    }
  },
  {
    "id": "04119_1",
    "name": "Wernecke GmbH",
    "country": "DE",
    "city": "Wildau",
    "address": "Richard-Sorge-Str. 32, 15745 Wildau",
    "email": "info@bmw-wernecke.de",
    "phone": "+49-3375-50520",
    "website": "https://www.bmw-wernecke.de",
    "coords": {
      "lat": 52.31047058105469,
      "lng": 13.633270263671875
    }
  },
  {
    "id": "04210_1",
    "name": "Autohaus Becker-Tiemann Leinetal GmbH & Co. KG",
    "country": "DE",
    "city": "Northeim",
    "address": "Hirschberger Str. 2, 37154 Northeim",
    "email": "northeim@becker-tiemann.de",
    "phone": "+49-5551-98100",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 51.69281005859375,
      "lng": 9.98760986328125
    }
  },
  {
    "id": "04553_11",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Plauen",
    "address": "Pausaer Str. 190, 08525 Plauen",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-3741-5574-0",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.519981384277344,
      "lng": 12.114813804626465
    }
  },
  {
    "id": "04552_1",
    "name": "Autohaus Köhler GmbH",
    "country": "DE",
    "city": "Karlstadt",
    "address": "Bodelschwinghstr. 88, 97753 Karlstadt",
    "email": "andre.mehrlich@koehler-bmw.de",
    "phone": "+49-9353-97110",
    "website": "https://www.bmw-koehler.de",
    "coords": {
      "lat": 49.95595932006836,
      "lng": 9.778840065002441
    }
  },
  {
    "id": "00737_3",
    "name": "Autohaus Krauth GmbH & Co. KG",
    "country": "DE",
    "city": "Sinsheim",
    "address": "Neulandstr. 26, 74889 Sinsheim",
    "email": "info@bmw-krauth.de",
    "phone": "+49-7261-92510",
    "website": "https://www.bmw-krauth.de",
    "coords": {
      "lat": 49.24502182006836,
      "lng": 8.884360313415527
    }
  },
  {
    "id": "04712_3",
    "name": "Hermann Arnold GmbH",
    "country": "DE",
    "city": "Aschaffenburg",
    "address": "Großostheimer Str. 90, 63741 Aschaffenburg",
    "email": "info@bmw-arnold.com",
    "phone": "+49-6021-442420",
    "website": "https://www.bmw-arnold.com",
    "coords": {
      "lat": 49.95903396606445,
      "lng": 9.123934745788574
    }
  },
  {
    "id": "00893_4",
    "name": "Helming & Sohn GmbH",
    "country": "DE",
    "city": "Meppen",
    "address": "Schützenstr. 89, 49716 Meppen",
    "email": "meppen@helming-sohn.de",
    "phone": "+49-5931-93450",
    "website": "https://www.helming-sohn.de",
    "coords": {
      "lat": 52.703224182128906,
      "lng": 7.292107105255127
    }
  },
  {
    "id": "00893_5",
    "name": "Helming & Sohn GmbH",
    "country": "DE",
    "city": "Papenburg",
    "address": "Flachsmeerstr. 16, 26871 Papenburg",
    "email": "papenburg@bmw-helming.de",
    "phone": "+49-4961-97744",
    "website": "https://www.helming-sohn.de",
    "coords": {
      "lat": 53.083316802978516,
      "lng": 7.431758880615234
    }
  },
  {
    "id": "00893_7",
    "name": "Helming & Sohn GmbH",
    "country": "DE",
    "city": "Wietmarschen",
    "address": "Einsteinstr. 5, 49835 Wietmarschen",
    "email": "info-gaz@helming-sohn.de",
    "phone": "+49-5908-91999-500",
    "website": "https://www.helming-sohn.de",
    "coords": {
      "lat": 52.48176956176758,
      "lng": 7.20753812789917
    }
  },
  {
    "id": "01872_2",
    "name": "Riller & Schnauck GmbH",
    "country": "DE",
    "city": "Teltow",
    "address": "Warthestr. 3, 14513 Teltow",
    "email": "anfrage@riller-schnauck.de",
    "phone": "+49-3328-4420",
    "website": "https://www.bmw.de/de/partner/riller-schnauck-teltow-07487.html",
    "coords": {
      "lat": 52.39820861816406,
      "lng": 13.2424898147583
    }
  },
  {
    "id": "01911_1",
    "name": "Fett & Wirtz Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Moers",
    "address": "Dr.-Berns-Str. 34, 47441 Moers",
    "email": "info.moers@bmw-fett-wirtz.de",
    "phone": "+49-2841-20720",
    "website": "https://www.fett-wirtz.de/",
    "coords": {
      "lat": 51.461761474609375,
      "lng": 6.614009857177734
    }
  },
  {
    "id": "01945_1",
    "name": "Autohaus Kimbeck GmbH",
    "country": "DE",
    "city": "Eggenfelden",
    "address": "Niederndorf 26, 84307 Eggenfelden",
    "email": "info@bmw-kimbeck.de",
    "phone": "+49-8721-96300",
    "website": "https://www.autohaus-kimbeck.bmw/de/home",
    "coords": {
      "lat": 48.38821792602539,
      "lng": 12.761735916137695
    }
  },
  {
    "id": "02428_1",
    "name": "Bobrink & Co. GmbH",
    "country": "DE",
    "city": "Bremen",
    "address": "Henri-Dunant-Str. 1, 28329 Bremen",
    "email": "bobrink.bremen@bmw-bobrink.de",
    "phone": "+49-421-436460",
    "website": "https://www.bobrink.de/bmw/",
    "coords": {
      "lat": 53.08049774169922,
      "lng": 8.88122272491455
    }
  },
  {
    "id": "02446_1",
    "name": "Autohaus W. Maier GmbH",
    "country": "DE",
    "city": "Glonn",
    "address": "Zinneberger Str. 6, 85625 Glonn",
    "email": "info@bmw-service-maier.de",
    "phone": "+49-8093-90460",
    "website": "https://www.bmw.de/de/partner/autohaus-maier-glonn-02446.html",
    "coords": {
      "lat": 47.988162994384766,
      "lng": 11.873726844787598
    }
  },
  {
    "id": "02726_1",
    "name": "Autohaus Tekken Emden GmbH & Co. KG",
    "country": "DE",
    "city": "Emden",
    "address": "Nesserlander Str. 73-74, 26723 Emden",
    "email": "autohaus.emden@tekken.de",
    "phone": "+49-4921-90370",
    "website": "https://tekken.de/",
    "coords": {
      "lat": 53.355838775634766,
      "lng": 7.195219993591309
    }
  },
  {
    "id": "02807_1",
    "name": "AKG Automobile GmbH",
    "country": "DE",
    "city": "Meinerzhagen",
    "address": "Heerstr. 18, 58540 Meinerzhagen",
    "email": "info.meinerzhagen@kaltenbach-gruppe.de",
    "phone": "+49-2354-90930",
    "website": "https://www.bmw-autohaus-kaltenbach.de",
    "coords": {
      "lat": 51.09640121459961,
      "lng": 7.672709941864014
    }
  },
  {
    "id": "03892_3",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Hagen",
    "address": "Elseyer Straße 77, 58119 Hagen",
    "email": "hagen@bmw-procar.de",
    "phone": "+49-2334-8020-0",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.36758804321289,
      "lng": 7.54885196685791
    }
  },
  {
    "id": "03892_6",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Herne",
    "address": "Holsterhauser Straße 210, 44625 Herne",
    "email": "herne@bmw-procar.de",
    "phone": "+49-2325-641550",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.53121566772461,
      "lng": 7.203534126281738
    }
  },
  {
    "id": "03892_10",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Solingen",
    "address": "Frankfurter Damm 15, 42719 Solingen",
    "email": "solingen@bmw-procar.de",
    "phone": "+49-212-59630",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.1854133605957,
      "lng": 7.0549492835998535
    }
  },
  {
    "id": "03892_12",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Sprockhövel",
    "address": "Eichenhofer Weg 1-7, 45549 Sprockhövel",
    "email": "sprockhoevel@bmw-procar.de",
    "phone": "+49-2339-91830",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.318302154541016,
      "lng": 7.275492191314697
    }
  },
  {
    "id": "04107_19",
    "name": "BMW AG Niederlassung München Karosserie- und Lackzentrum",
    "country": "DE",
    "city": "Garching",
    "address": "Schleißheimer Str. 82, 85748 Garching",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-3535-60",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.24962615966797,
      "lng": 11.62869930267334
    }
  },
  {
    "id": "04109_8",
    "name": "Autohaus Fritze GmbH & Co. KG",
    "country": "DE",
    "city": "Schönburg (Saale)",
    "address": "Gewerbegebietsstr. 21, 06618 Schönburg (Saale)",
    "email": "info@autohaus-fritze.de",
    "phone": "+49-3445-71170",
    "website": "https://www.bmw-fritze.de",
    "coords": {
      "lat": 51.14269256591797,
      "lng": 11.840646743774414
    }
  },
  {
    "id": "04119_4",
    "name": "Wernecke GmbH",
    "country": "DE",
    "city": "Cottbus",
    "address": "Lamsfelder Str. 2, 03044 Cottbus",
    "email": "info@bmw-wernecke.de",
    "phone": "+49-355-494490",
    "website": "https://www.bmw-wernecke.de",
    "coords": {
      "lat": 51.77936935424805,
      "lng": 14.320710182189941
    }
  },
  {
    "id": "04553_7",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Saalfeld/Saale",
    "address": "Am Cröstener Weg 21, 07318 Saalfeld/Saale",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-3671-57590",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.65591049194336,
      "lng": 11.343339920043945
    }
  },
  {
    "id": "04553_10",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Zwickau",
    "address": "Werdauer Str. 164, 08060 Zwickau",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-375-440066-0",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.73120880126953,
      "lng": 12.447580337524414
    }
  },
  {
    "id": "04562_4",
    "name": "Langenhan GmbH",
    "country": "DE",
    "city": "Eisenach",
    "address": "Rennbahn 74, 99817 Eisenach",
    "email": "ea@bmw-langenhan.de",
    "phone": "+49-3691-23880",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 50.979000091552734,
      "lng": 10.30370044708252
    }
  },
  {
    "id": "04670_1",
    "name": "Albert Bauer GmbH",
    "country": "DE",
    "city": "Flensburg",
    "address": "Schleswiger Str. 65-75, 24941 Flensburg",
    "email": "office@bauergruppe.de",
    "phone": "+49-461-99900",
    "website": "https://www.bmw.de/de/partner/albert-bauer-flensburg-04670.html",
    "coords": {
      "lat": 54.77121353149414,
      "lng": 9.435219764709473
    }
  },
  {
    "id": "00027_4",
    "name": "BMW AG Niederlassung Dortmund",
    "country": "DE",
    "city": "Dortmund",
    "address": "Nortkirchenstr. 111, 44263 Dortmund",
    "email": "NL.Dortmund@bmw.de",
    "phone": "+49-231-95060",
    "website": "https://www.bmw-dortmund.de/de/home/",
    "coords": {
      "lat": 51.484676361083984,
      "lng": 7.471560955047607
    }
  },
  {
    "id": "00051_1",
    "name": "BMW AG Service Zentrum",
    "country": "DE",
    "city": "Dingolfing",
    "address": "Landshuter Str. 12, 84130 Dingolfing",
    "email": "Sz.info@bmw.de",
    "phone": "+49-8731-7622021",
    "website": "https://www.bmw-service-zentrum-dingolfing.de",
    "coords": {
      "lat": 48.64485168457031,
      "lng": 12.484199523925781
    }
  },
  {
    "id": "00074_8",
    "name": "BMW AG Niederlassung Darmstadt",
    "country": "DE",
    "city": "Darmstadt",
    "address": "Marburger Str. 22, 64289 Darmstadt",
    "email": "nl.darmstadt@bmw.de",
    "phone": "+49-6151-70070",
    "website": "https://www.bmw-darmstadt.de/de/home/",
    "coords": {
      "lat": 49.88842010498047,
      "lng": 8.659049034118652
    }
  },
  {
    "id": "00081_6",
    "name": "BMW AG Niederlassung Berlin Filiale Marzahn",
    "country": "DE",
    "city": "Berlin",
    "address": "Blumberger Damm 2, 12683 Berlin",
    "email": "marzahn.nlb@bmw.de",
    "phone": "+49-30-200990",
    "website": "https://www.bmw-berlin.de/de/home/",
    "coords": {
      "lat": 52.509788513183594,
      "lng": 13.563749313354492
    }
  },
  {
    "id": "00083_5",
    "name": "BMW AG Niederlassung Hamburg Filiale Wandsbek",
    "country": "DE",
    "city": "Hamburg",
    "address": "Friedrich-Ebert-Damm 120, 22047 Hamburg",
    "email": "nl.hamburg@bmw.de",
    "phone": "+49-40-5530130",
    "website": "https://www.bmw-hamburg.de/de/home/",
    "coords": {
      "lat": 53.587860107421875,
      "lng": 10.094090461730957
    }
  },
  {
    "id": "00120_5",
    "name": "AH Stadel Zweig-NL der AH Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Heilbronn",
    "address": "Stuttgarter Str. 53-61, 74074 Heilbronn",
    "email": "info@stadel.de",
    "phone": "+49-7131-50800",
    "website": "https://www.stadel.de/",
    "coords": {
      "lat": 49.12715148925781,
      "lng": 9.223730087280273
    }
  },
  {
    "id": "00120_6",
    "name": "AH Stadel Zweig-NL der AH Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Bietigheim-Bissingen",
    "address": "Alexander-Fleming-Str. 6, 74321 Bietigheim-Bissingen",
    "email": "info.bb@stadel.de",
    "phone": "+49-7142-90330",
    "website": "https://www.stadel.de/",
    "coords": {
      "lat": 48.954833984375,
      "lng": 9.117289543151855
    }
  },
  {
    "id": "00139_10",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Schwalmstadt",
    "address": "In der Aue 1, 34613 Schwalmstadt",
    "email": "bmw.schwalmstadt@wahl-group.de",
    "phone": "+49-6691-9632-0",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.91830062866211,
      "lng": 9.210556030273438
    }
  },
  {
    "id": "00131_1",
    "name": "Autohaus Karl + Co. GmbH & Co. KG",
    "country": "DE",
    "city": "Mainz",
    "address": "Alte Mainzer Str. 121, 55129 Mainz",
    "email": "info@bmw-karl-co.de",
    "phone": "+49-6131-83060",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 49.97182083129883,
      "lng": 8.281490325927734
    }
  },
  {
    "id": "00250_4",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Schramberg-Sulgen",
    "address": "Albert-Moser-Str. 20, 78713 Schramberg-Sulgen",
    "email": "bmw-schramberg@ahg-mobile.de",
    "phone": "+49-7422-99490",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.2384033203125,
      "lng": 8.418731689453125
    }
  },
  {
    "id": "00250_10",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Pforzheim",
    "address": "Karlsruher Str. 69, 75179 Pforzheim",
    "email": "bmw-pforzheim@ahg-mobile.de",
    "phone": "+49-7231-93080",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.9022331237793,
      "lng": 8.659838676452637
    }
  },
  {
    "id": "00250_33",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Kirchheim/Teck",
    "address": "Stuttgarter Str. 65, 73230 Kirchheim/Teck",
    "email": "bmw-kirchheim@ahg-mobile.de",
    "phone": "+49-7021-98035-0",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.651405334472656,
      "lng": 9.439842224121094
    }
  },
  {
    "id": "00391_1",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Backnang",
    "address": "Stuttgarter Str. 141, 71522 Backnang",
    "email": "verkauf.backnang@mulfinger.de",
    "phone": "+49-7191-1450",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 48.93584442138672,
      "lng": 9.437564849853516
    }
  },
  {
    "id": "00440_1",
    "name": "Autohaus Adolf Cuntz KG",
    "country": "DE",
    "city": "Speyer",
    "address": "Landwehrstr. 33, 67346 Speyer",
    "email": "info@autohaus-cuntz.de",
    "phone": "+49-6232-69700",
    "website": "https://www.autohaus-cuntz.de/",
    "coords": {
      "lat": 49.3398551940918,
      "lng": 8.428825378417969
    }
  },
  {
    "id": "00495_1",
    "name": "Autohaus Munding GmbH",
    "country": "DE",
    "city": "Biberach/Riß",
    "address": "Rißstr. 24, 88400 Biberach/Riß",
    "email": "information@bmw-munding.de",
    "phone": "+49-7351-1801430",
    "website": "https://www.bmw-munding.de",
    "coords": {
      "lat": 48.104000091552734,
      "lng": 9.795764923095703
    }
  },
  {
    "id": "00795_1",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "St. Augustin",
    "address": "Einsteinstr. 30, 53757 St. Augustin",
    "email": "kontakt@hakvoort.de",
    "phone": "+49-2241-91410",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.792179107666016,
      "lng": 7.178224563598633
    }
  },
  {
    "id": "00795_2",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "Eitorf",
    "address": "Im Laach 4, 53783 Eitorf",
    "email": "kontakt@hakvoort.de",
    "phone": "+49-2243-92220",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.77201843261719,
      "lng": 7.462520122528076
    }
  },
  {
    "id": "00866_4",
    "name": "Autohaus Widmann + Winterholler GmbH",
    "country": "DE",
    "city": "Weilheim i.OB.",
    "address": "Am Achalaich 1, 82362 Weilheim i.OB.",
    "email": "info@widmann-winterholler.de",
    "phone": "+49-881-924780",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 47.824241638183594,
      "lng": 11.134474754333496
    }
  },
  {
    "id": "00866_8",
    "name": "Autohaus Mendler ein Unt. der Widmann+Winterholler GmbH",
    "country": "DE",
    "city": "Füssen",
    "address": "Kemptener Str. 77, 87629 Füssen",
    "email": "info@bmw-mendler.de",
    "phone": "+49-8362-93620",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 47.56813049316406,
      "lng": 10.677639961242676
    }
  },
  {
    "id": "02319_2",
    "name": "Autohaus Langlinderer e. K.",
    "country": "DE",
    "city": "Waldkraiburg",
    "address": "Geretsrieder Str. 24, 84478 Waldkraiburg",
    "email": "bmw@langlinderer.de",
    "phone": "+49-8638-94400",
    "website": "https://www.bmw.de/de/partner/autohaus-langlinderer-waldkraiburg-40417.html",
    "coords": {
      "lat": 48.213462829589844,
      "lng": 12.411640167236328
    }
  },
  {
    "id": "02378_1",
    "name": "Autohaus Bachfrieder GmbH & Co. KG",
    "country": "DE",
    "city": "Piding b. Bad Reichenhall",
    "address": "Salzstr. 25, 83451 Piding b. Bad Reichenhall",
    "email": "anfrage@bachfrieder.de",
    "phone": "+49-8651-973030",
    "website": "https://www.bmw-bachfrieder.de",
    "coords": {
      "lat": 47.760284423828125,
      "lng": 12.900547981262207
    }
  },
  {
    "id": "03892_1",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Velbert",
    "address": "Kopernikusstr. 6, 42549 Velbert",
    "email": "velbert@bmw-procar.de",
    "phone": "+49-2051-31170",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.348365783691406,
      "lng": 7.025135040283203
    }
  },
  {
    "id": "04107_6",
    "name": "BMW AG Niederlassung München Filiale Solln",
    "country": "DE",
    "city": "München",
    "address": "Drygalski-Allee 35, 81477 München",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-353550",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.092071533203125,
      "lng": 11.502880096435547
    }
  },
  {
    "id": "04543_5",
    "name": "BMW AG Niederlassung Chemnitz",
    "country": "DE",
    "city": "Chemnitz",
    "address": "Röhrsdorfer Allee 3, 09247 Chemnitz",
    "email": "nl.chemnitz@bmw.de",
    "phone": "+49-3722-5060",
    "website": "https://www.bmw-chemnitz.de/de/home/",
    "coords": {
      "lat": 50.86634063720703,
      "lng": 12.859655380249023
    }
  },
  {
    "id": "04553_5",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Reichenbach",
    "address": "Zwickauer Str. 275, 08468 Reichenbach",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-3765-61020",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.637081146240234,
      "lng": 12.324981689453125
    }
  },
  {
    "id": "04562_1",
    "name": "Langenhan GmbH",
    "country": "DE",
    "city": "Gotha",
    "address": "Harjesstr. 11, 99867 Gotha",
    "email": "gth@bmw-langenhan.de",
    "phone": "+49-3621-72330",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 50.92547607421875,
      "lng": 10.714414596557617
    }
  },
  {
    "id": "04553_13",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Windischleuba",
    "address": "Fünfminutenweg Nord 9, 04603 Windischleuba",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-36625-7933-0",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 51.01564025878906,
      "lng": 12.457489967346191
    }
  },
  {
    "id": "04746_11",
    "name": "Kohl automobile GmbH",
    "country": "DE",
    "city": "Heinsberg",
    "address": "Industriestr. 53, 52525 Heinsberg",
    "email": "info@kohl.de",
    "phone": "+49-2452-91350",
    "website": "https://www.kohl.de/bmw",
    "coords": {
      "lat": 51.06087875366211,
      "lng": 6.1175432205200195
    }
  },
  {
    "id": "04755_2",
    "name": "Autohaus E. Brinkmann GmbH",
    "country": "DE",
    "city": "Zeven",
    "address": "Südring 1, 27404 Zeven",
    "email": "info-zeven@bmw-brinkmann.de",
    "phone": "+49-4281-95910",
    "website": "https://www.bmw.de/de/partner/autohaus-brinkmann-zeven-31953.html",
    "coords": {
      "lat": 53.2806396484375,
      "lng": 9.290499687194824
    }
  },
  {
    "id": "04776_1",
    "name": "Autohaus Fischer GmbH",
    "country": "DE",
    "city": "Münchberg",
    "address": "Kirchenlamitzer Str. 99, 95213 Münchberg",
    "email": "info@bmwfischer.de",
    "phone": "+49-9251-92000",
    "website": "https://www.bmw.de/de/partner/autohaus-fischer-muenchberg-04776.html",
    "coords": {
      "lat": 50.18901062011719,
      "lng": 11.803140640258789
    }
  },
  {
    "id": "07466_2",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Haldensleben",
    "address": "Friedrich-Schmelzer-Str. 1, 39340 Haldensleben",
    "email": "schubert.haldensleben@schubert-motors.de",
    "phone": "+49-3904-66060",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 52.283199310302734,
      "lng": 11.4298095703125
    }
  },
  {
    "id": "07466_11",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Gifhorn",
    "address": "Hugo-Junkers-Str. 2, 38518 Gifhorn",
    "email": "schubert.gifhorn@schubert-motors.de",
    "phone": "+49-5371-98990",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 52.45878601074219,
      "lng": 10.540268898010254
    }
  },
  {
    "id": "04818_1",
    "name": "Autohaus Müller GmbH & Co. KG",
    "country": "DE",
    "city": "Gerlingen",
    "address": "Weilimdorfer Str. 88, 70839 Gerlingen",
    "email": "info@bmw-mueller.net",
    "phone": "+49-7156-20200",
    "website": "https://bmw-mueller.net/",
    "coords": {
      "lat": 48.80506134033203,
      "lng": 9.07494068145752
    }
  },
  {
    "id": "07214_1",
    "name": "Autohaus Kühne GmbH",
    "country": "DE",
    "city": "Döbeln",
    "address": "Zschepplitzer Str. 25, 04720 Döbeln",
    "email": "info-doebeln@bmw-kuehne.de",
    "phone": "+49-3431-66340",
    "website": "https://bmw-service-kuehne.de",
    "coords": {
      "lat": 51.1361198425293,
      "lng": 13.096129417419434
    }
  },
  {
    "id": "07343_3",
    "name": "Michael Ludwig e. K.",
    "country": "DE",
    "city": "Pritzwalk",
    "address": "Havelberger Str. 34, 16928 Pritzwalk",
    "email": "info.pr@bmw-ludwig.de",
    "phone": "+49-3395-401890",
    "website": "https://www.bmw.de/de/partner/autohaus-ludwig-pritzwalk-33016.html",
    "coords": {
      "lat": 53.14607238769531,
      "lng": 12.174680709838867
    }
  },
  {
    "id": "07466_7",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Bernburg",
    "address": "Magdeburger Chaussee 11, 06406 Bernburg",
    "email": "schubert.bernburg@schubert-motors.de",
    "phone": "+49-3471-346630",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 51.80982208251953,
      "lng": 11.72446060180664
    }
  },
  {
    "id": "07466_13",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Burg",
    "address": "Magdeburger Chaussee 96, 39288 Burg",
    "email": "schubert.burg@schubert-motors.de",
    "phone": "+49-3921-914900",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 52.25830841064453,
      "lng": 11.841150283813477
    }
  },
  {
    "id": "07466_10",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Wolfsburg",
    "address": "Karl-Ferdinand-Braun-Ring 1, 38448 Wolfsburg",
    "email": "schubert.wolfsburg@schubert-motors.de",
    "phone": "+49-5363-70390",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 52.422698974609375,
      "lng": 10.862822532653809
    }
  },
  {
    "id": "25742_5",
    "name": "Procar Automobile Münsterland GmbH",
    "country": "DE",
    "city": "Lüdinghausen",
    "address": "Julius-Maggi-Str. 1, 59348 Lüdinghausen",
    "email": "luedinghausen@bmw-procar.de",
    "phone": "+49-2591-91890",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.7677001953125,
      "lng": 7.424149990081787
    }
  },
  {
    "id": "25742_4",
    "name": "Procar Automobile Münsterland GmbH",
    "country": "DE",
    "city": "Ahlen",
    "address": "Kruppstr. 2 b, 59227 Ahlen",
    "email": "ahlen@bmw-procar.de",
    "phone": "+49-2382-98350",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.76968002319336,
      "lng": 7.929834842681885
    }
  },
  {
    "id": "28147_1",
    "name": "Autohaus Graubaum GmbH",
    "country": "DE",
    "city": "Berlin",
    "address": "Köllnische Str. 10, 12439 Berlin",
    "email": "service@bmw-graubaum.de",
    "phone": "+49-30-6399030",
    "website": "https://www.bmw.de/de/partner/autohaus-graubaum-berlin-28147.html",
    "coords": {
      "lat": 52.4528923034668,
      "lng": 13.521265029907227
    }
  },
  {
    "id": "28531_1",
    "name": "Autohaus Sperber GmbH & Co. KG",
    "country": "DE",
    "city": "Bamberg",
    "address": "Ohmstr. 10a, 96050 Bamberg",
    "email": "info@autohaus-sperber.de",
    "phone": "+49-951-964333-0",
    "website": "https://www.autohaus-sperber.de",
    "coords": {
      "lat": 49.895652770996094,
      "lng": 10.91776180267334
    }
  },
  {
    "id": "28652_1",
    "name": "Stoltenberg Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Hamburg",
    "address": "Harksheider Str. 17, 22399 Hamburg",
    "email": "Info@stoltenberg.de",
    "phone": "+49-40-6068900",
    "website": "https://bmw-service-stoltenberg.de/de/home/",
    "coords": {
      "lat": 53.6612434387207,
      "lng": 10.081632614135742
    }
  },
  {
    "id": "29344_3",
    "name": "Autohaus Becker-Tiemann Schaumburg GmbH & Co. KG",
    "country": "DE",
    "city": "Wunstorf",
    "address": "Hagenburger Str. 46, 31515 Wunstorf",
    "email": "wunstorf@becker-tiemann.de",
    "phone": "+49-5031-94000",
    "website": "https://www.becker-tiemann.de",
    "coords": {
      "lat": 52.42854309082031,
      "lng": 9.411808967590332
    }
  },
  {
    "id": "30291_1",
    "name": "Auto Neumeier & Seidl GmbH",
    "country": "DE",
    "city": "Obertraubling",
    "address": "Am Langwiesfeld 6, 93083 Obertraubling",
    "email": "info@auto-neumeier-seidl.de",
    "phone": "+49-9401-528390",
    "website": "https://www.bmw.de/de/partner/auto-neumeier-seidl-obertraubling-30291.html",
    "coords": {
      "lat": 48.9698600769043,
      "lng": 12.171250343322754
    }
  },
  {
    "id": "30778_1",
    "name": "Reisacher Augsburg GmbH",
    "country": "DE",
    "city": "Augsburg",
    "address": "Ammannstraße 1, 86167 Augsburg",
    "email": "info@reisacher.de",
    "phone": "+49-821-9009-0",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.39858627319336,
      "lng": 10.922622680664062
    }
  },
  {
    "id": "31227_1",
    "name": "Autohaus Tekken Leer GmbH & Co. KG",
    "country": "DE",
    "city": "Leer",
    "address": "Ringstr. 24, 26789 Leer",
    "email": "autohaus.tekken@tekken.de",
    "phone": "+49-491-928310",
    "website": "https://tekken.de/",
    "coords": {
      "lat": 53.24142074584961,
      "lng": 7.459869861602783
    }
  },
  {
    "id": "31585_1",
    "name": "Autohaus Michael Schmidt GmbH",
    "country": "DE",
    "city": "Wolfratshausen",
    "address": "Hans-Urmiller-Ring 46 b, 82515 Wolfratshausen",
    "email": "info@bmw-schmidt.com",
    "phone": "+49-8171-418690",
    "website": "https://www.bmw-schmidt.com",
    "coords": {
      "lat": 47.901546478271484,
      "lng": 11.430510520935059
    }
  },
  {
    "id": "31585_2",
    "name": "Autohaus Michael Schmidt GmbH",
    "country": "DE",
    "city": "Bad Tölz",
    "address": "Demmeljochstr. 3, 83646 Bad Tölz",
    "email": "info@bmw-schmidt.com",
    "phone": "+49-8041-78990",
    "website": "https://www.bmw-schmidt.com",
    "coords": {
      "lat": 47.750205993652344,
      "lng": 11.567049980163574
    }
  },
  {
    "id": "23303_1",
    "name": "Vögl GmbH & Co. Am Ring KG",
    "country": "DE",
    "city": "Straubing",
    "address": "Hirschberger Ring 34, 94315 Straubing",
    "email": "straubing@voegl.de",
    "phone": "+49-9421-18330",
    "website": "https://www.bmw.de/de/partner/voegl-straubing-23303.html",
    "coords": {
      "lat": 48.881771087646484,
      "lng": 12.607159614562988
    }
  },
  {
    "id": "32112_1",
    "name": "Autohaus Euler Kaiserslautern GmbH",
    "country": "DE",
    "city": "Kaiserslautern",
    "address": "Opelkreisel 28a, 67663 Kaiserslautern",
    "email": "info@euler-group.de",
    "phone": "+49-631-351130",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 49.44688415527344,
      "lng": 7.707557201385498
    }
  },
  {
    "id": "33269_1",
    "name": "Autohaus Isert GmbH & Co. KG",
    "country": "DE",
    "city": "Kronach",
    "address": "Industriestr. 33, 96317 Kronach",
    "email": "info@autohaus-isert.de",
    "phone": "+49-9261-66640",
    "website": "https://www.bmw.de/de/partner/autohaus-isert-kronach-33269.html",
    "coords": {
      "lat": 50.23194885253906,
      "lng": 11.352009773254395
    }
  },
  {
    "id": "23470_6",
    "name": "Spaett GmbH & Co. KG",
    "country": "DE",
    "city": "Ismaning",
    "address": "Robert-Bürkle-Str. 15, 85737 Ismaning",
    "email": "info@spaett.de",
    "phone": "+49-89-189090",
    "website": "https://www.bmw.de/de/partner/spaett-ismaning-29307.html",
    "coords": {
      "lat": 48.23234939575195,
      "lng": 11.686653137207031
    }
  },
  {
    "id": "23470_3",
    "name": "Spaett GmbH & Co. KG",
    "country": "DE",
    "city": "Erding",
    "address": "Rennweg 46, 85435 Erding",
    "email": "info@spaett.de",
    "phone": "+49-8122-99460",
    "website": "https://www.bmw.de/de/partner/spaett-erding-22335.html",
    "coords": {
      "lat": 48.31184005737305,
      "lng": 11.889339447021484
    }
  },
  {
    "id": "33854_4",
    "name": "Müller-Dynamic GmbH",
    "country": "DE",
    "city": "Losheim am See",
    "address": "Wolfsborn 63-65, 66679 Losheim am See",
    "email": "kontakt@mueller-bmw.com",
    "phone": "+49-6872-922640",
    "website": "https://www.mueller-auto.com/markenwelten/bmw",
    "coords": {
      "lat": 49.507633209228516,
      "lng": 6.762317657470703
    }
  },
  {
    "id": "34052_2",
    "name": "Simon Gruber Autoservice GmbH & Co. KG",
    "country": "DE",
    "city": "Landsham",
    "address": "Erdinger Straße 24, 85652 Landsham",
    "email": "bmw.info@simon-gruber.de",
    "phone": "+49-89-99193960",
    "website": "https://www.bmw.de/de/partner/simon-gruber-autoservice-landsham-34053.html",
    "coords": {
      "lat": 48.18849563598633,
      "lng": 11.779191970825195
    }
  },
  {
    "id": "27988_1",
    "name": "Autohaus Pröschel GmbH",
    "country": "DE",
    "city": "Diespeck",
    "address": "Bamberger Str. 59/61, 91456 Diespeck",
    "email": "andre.rossel@bmw-service-proeschel.de",
    "phone": "+49-9161-88580",
    "website": "https://www.bmw-service-proeschel.de",
    "coords": {
      "lat": 49.60137176513672,
      "lng": 10.626009941101074
    }
  },
  {
    "id": "29219_1",
    "name": "Autohaus Möhring Inh. Susanne Möhring",
    "country": "DE",
    "city": "Herzberg am Harz",
    "address": "Northeimer Str. 98, 37412 Herzberg am Harz",
    "email": "info@bmw-moehring.de",
    "phone": "+49-5521-996990",
    "website": "https://www.bmw.de/de/partner/moehring-herzberg-harz-29219.html",
    "coords": {
      "lat": 51.64548873901367,
      "lng": 10.317915916442871
    }
  },
  {
    "id": "29344_2",
    "name": "Autohaus Becker-Tiemann Schaumburg GmbH & Co. KG",
    "country": "DE",
    "city": "Bückeburg",
    "address": "Bergdorfer Str. 42, 31675 Bückeburg",
    "email": "kontaktshg@becker-tiemann.de",
    "phone": "+49-5722-89300",
    "website": "https://www.becker-tiemann.de",
    "coords": {
      "lat": 52.25996017456055,
      "lng": 9.062789916992188
    }
  },
  {
    "id": "29484_1",
    "name": "Autohaus Thoma GmbH",
    "country": "DE",
    "city": "Sexau",
    "address": "Untere Ziel 3, 79350 Sexau",
    "email": "info@bmw-thoma.de",
    "phone": "+49-7641-933580",
    "website": "https://bmw-thoma.de/",
    "coords": {
      "lat": 48.091400146484375,
      "lng": 7.894239902496338
    }
  },
  {
    "id": "30310_1",
    "name": "ASG Automobilservice Grotewohlt GmbH",
    "country": "DE",
    "city": "Norderstedt",
    "address": "Niewisch 4, 22848 Norderstedt",
    "email": "asg@wtnet.de",
    "phone": "+49-40-5298800",
    "website": "https://www.bmw.de/de/partner/asg-automobilservice-grotewohlt-30310.html",
    "coords": {
      "lat": 53.6662483215332,
      "lng": 9.978249549865723
    }
  },
  {
    "id": "30635_1",
    "name": "Autohaus Euler Pirmasens GmbH",
    "country": "DE",
    "city": "Pirmasens",
    "address": "Zweibrücker Str. 173, 66954 Pirmasens",
    "email": "info@euler-group.de",
    "phone": "+49-6331-87040",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 49.21578598022461,
      "lng": 7.595891952514648
    }
  },
  {
    "id": "30637_3",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Alzey",
    "address": "Galgenwiesenweg 15-17, 55232 Alzey",
    "email": "info-az@auto-cloppenburg.de",
    "phone": "+49-6731-95360",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 49.752750396728516,
      "lng": 8.122091293334961
    }
  },
  {
    "id": "32141_1",
    "name": "Tief-Dörfler Automotive GmbH",
    "country": "DE",
    "city": "Marktsteft",
    "address": "Am Traugraben 2, 97342 Marktsteft",
    "email": "info@tief-doerfler.de",
    "phone": "+49-9332-593340",
    "website": "https://www.tief-doerfler.de/",
    "coords": {
      "lat": 49.68677520751953,
      "lng": 10.144725799560547
    }
  },
  {
    "id": "32913_1",
    "name": "Overdreef GmbH",
    "country": "DE",
    "city": "Duisburg",
    "address": "Am Nordhafen 10, 47119 Duisburg",
    "email": "info@bmw-overdreef.de",
    "phone": "+49-203-4557800",
    "website": "https://www.bmw-overdreef.de",
    "coords": {
      "lat": 51.459808349609375,
      "lng": 6.750649929046631
    }
  },
  {
    "id": "26505_1",
    "name": "Boomers GmbH & Co. KG",
    "country": "DE",
    "city": "Bocholt",
    "address": "Franzstr. 62, 46395 Bocholt",
    "email": "info.bocholt@boomers.de",
    "phone": "+49-2871-95060",
    "website": "https://www.boomers.de/bmw-hauptseite/",
    "coords": {
      "lat": 51.827239990234375,
      "lng": 6.628558158874512
    }
  },
  {
    "id": "34062_1",
    "name": "Autohaus Felske GmbH",
    "country": "DE",
    "city": "Braunschweig",
    "address": "Kirchweg 7a, 38104 Braunschweig",
    "email": "info@bmw-felske.de",
    "phone": "+49-531-236300",
    "website": "https://www.bmw.de/de/partner/autohaus-felske-braunschweig-34062.html",
    "coords": {
      "lat": 52.29399108886719,
      "lng": 10.597249984741211
    }
  },
  {
    "id": "27923_1",
    "name": "Auto Reichold GmbH & Co. KG",
    "country": "DE",
    "city": "Bad Vilbel",
    "address": "Homburger Str. 65, 61118 Bad Vilbel",
    "email": "info@reichold.net",
    "phone": "+49-6101-54440",
    "website": "http://www.bmw-service-reichold.de",
    "coords": {
      "lat": 50.18729019165039,
      "lng": 8.733449935913086
    }
  },
  {
    "id": "28040_1",
    "name": "Walter Gülke GmbH & Co. KG",
    "country": "DE",
    "city": "Uslar",
    "address": "Bollenser Str. 1, 37170 Uslar",
    "email": "fm@ah-guelke.de",
    "phone": "+49-5571-30070",
    "website": "https://www.bmw.de/de/partner/walter-guelke-uslar-28040.html",
    "coords": {
      "lat": 51.65546417236328,
      "lng": 9.651108741760254
    }
  },
  {
    "id": "28065_1",
    "name": "Autohaus Beutler GmbH & Co. KG",
    "country": "DE",
    "city": "Bad Essen",
    "address": "Gartenstr. 61, 49152 Bad Essen",
    "email": "info@autohaus-beutler.de",
    "phone": "+49-5472-94050",
    "website": "https://www.bmw.de/de/partner/autohaus-beutler-bad-essen-28065.html",
    "coords": {
      "lat": 52.323402404785156,
      "lng": 8.337724685668945
    }
  },
  {
    "id": "28454_1",
    "name": "Autohaus Euler Hofheim GmbH",
    "country": "DE",
    "city": "Hofheim",
    "address": "Nordring 15-21, 65719 Hofheim",
    "email": "info@euler-group.de",
    "phone": "+49-6192-99080",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 50.090938568115234,
      "lng": 8.459250450134277
    }
  },
  {
    "id": "29344_1",
    "name": "Autohaus Becker-Tiemann Schaumburg GmbH & Co. KG",
    "country": "DE",
    "city": "Stadthagen",
    "address": "Vornhäger Str. 59, 31655 Stadthagen",
    "email": "kontaktshg@becker-tiemann.de",
    "phone": "+49-5721-97400",
    "website": "https://www.becker-tiemann.de",
    "coords": {
      "lat": 52.328369140625,
      "lng": 9.2218599319458
    }
  },
  {
    "id": "29964_1",
    "name": "Autohaus Kellner Erfurt GmbH",
    "country": "DE",
    "city": "Erfurt",
    "address": "Mühlweg 1, 99091 Erfurt",
    "email": "info@kellner-automobile.de",
    "phone": "+49-361-730240",
    "website": "https://www.bmw.de/de/partner/autohaus-kellner-erfurt-29964.html",
    "coords": {
      "lat": 51.01776123046875,
      "lng": 11.011280059814453
    }
  },
  {
    "id": "32292_1",
    "name": "Autohaus Becker-Tiemann Minden-Lübbecke GmbH & Co. KG",
    "country": "DE",
    "city": "Minden",
    "address": "Uphauser Weg 70, 32429 Minden",
    "email": "minden@becker-tiemann.de",
    "phone": "+49-571-956270",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.26655960083008,
      "lng": 8.850720405578613
    }
  },
  {
    "id": "32292_3",
    "name": "Autohaus Becker-Tiemann Minden-Lübbecke GmbH & Co. KG",
    "country": "DE",
    "city": "Stolzenau",
    "address": "Windmühlenstr. 19, 31592 Stolzenau",
    "email": "stolzenau@becker-tiemann.de",
    "phone": "+49-5761-92200",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.51023864746094,
      "lng": 9.063250541687012
    }
  },
  {
    "id": "33240_3",
    "name": "Autohaus Manfred Eggert GmbH",
    "country": "DE",
    "city": "Greifswald",
    "address": "An den Bäckerwiesen 10, 17489 Greifswald",
    "email": "bmw@auto-eggert.com",
    "phone": "+49-3834-5149080",
    "website": "https://www.bmw.de/de_DE/partner/autohaus-manfred-eggert-greifswald-36532.html",
    "coords": {
      "lat": 54.0713996887207,
      "lng": 13.392354965209961
    }
  },
  {
    "id": "33854_1",
    "name": "Müller-Dynamic GmbH",
    "country": "DE",
    "city": "Lebach",
    "address": "In Bommersfeld 2, 66822 Lebach",
    "email": "kontakt@mueller-bmw.com",
    "phone": "+49-6881-92020",
    "website": "https://www.mueller-auto.com/markenwelten/bmw",
    "coords": {
      "lat": 49.413639068603516,
      "lng": 6.892620086669922
    }
  },
  {
    "id": "34233_1",
    "name": "Drexl & Ziegler GmbH & Co. KG",
    "country": "DE",
    "city": "Günzburg",
    "address": "Robert-Koch-Str. 8, 89312 Günzburg",
    "email": "info@drexl-ziegler.de",
    "phone": "+49-8221-90170",
    "website": "https://www.bmw.de/de/partner/drexl-ziegler-guenzburg-34233.html",
    "coords": {
      "lat": 48.451881408691406,
      "lng": 10.297459602355957
    }
  },
  {
    "id": "34894_1",
    "name": "Wiemer Automobile GmbH",
    "country": "DE",
    "city": "Köln",
    "address": "Humboldtstr. 137, 51145 Köln",
    "email": "mail@wiemer-automobile.de",
    "phone": "+49-2203-37020",
    "website": "https://www.bmw.de/de/partner/wiemer-automobile-koeln-34894.html",
    "coords": {
      "lat": 50.89784622192383,
      "lng": 7.066054821014404
    }
  },
  {
    "id": "35003_1",
    "name": "Autohaus Wormser GmbH Forchheim",
    "country": "DE",
    "city": "Forchheim",
    "address": "Hans-Böckler-Str. 1, 91301 Forchheim",
    "email": "info-fo@bmw-wormser.de",
    "phone": "+49-9191-72300",
    "website": "https://www.autohaus-wormser.de",
    "coords": {
      "lat": 49.70534896850586,
      "lng": 11.066463470458984
    }
  },
  {
    "id": "35232_9",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Stralsund",
    "address": "Gustower Weg 17, 18439 Stralsund",
    "email": "Info.stralsund@hansanord.com",
    "phone": "+49-3831-28830",
    "website": "https://www.hansanord.com/hansa-nord-stralsund/",
    "coords": {
      "lat": 54.27503967285156,
      "lng": 13.108790397644043
    }
  },
  {
    "id": "35232_7",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Dorf Mecklenburg",
    "address": "Rothentor 2a, 23972 Dorf Mecklenburg",
    "email": "info.wismar@hansanord.com",
    "phone": "+49-3841-72830",
    "website": "https://www.hansanord.com/hansa-nord-wismar/",
    "coords": {
      "lat": 53.870792388916016,
      "lng": 11.447653770446777
    }
  },
  {
    "id": "36166_1",
    "name": "Autohaus Lars Rosenkranz e.K.",
    "country": "DE",
    "city": "Elmenhorst/ Lichtenhagen",
    "address": "Hauptstr. 95, 18107 Elmenhorst/ Lichtenhagen",
    "email": "info@bmw-service-rosenkranz.de",
    "phone": "+49-381-7699223",
    "website": "http://bmw-service-rosenkranz.de/de/home",
    "coords": {
      "lat": 54.15547180175781,
      "lng": 12.014467239379883
    }
  },
  {
    "id": "35644_4",
    "name": "mobilforum GmbH",
    "country": "DE",
    "city": "Pirna",
    "address": "Longuyoner Straße 5, 01796 Pirna",
    "email": "pir@mobilforum-gruppe.de",
    "phone": "+49-3501-79750",
    "website": "https://mobilforum.de/",
    "coords": {
      "lat": 50.95009231567383,
      "lng": 13.953376770019531
    }
  },
  {
    "id": "47793_1",
    "name": "Autohaus Bock GmbH & Co. KG",
    "country": "DE",
    "city": "Nittenau",
    "address": "Brucker Str. 12, 93149 Nittenau",
    "email": "service@bock-bmw.de",
    "phone": "+49-09436-9400-0",
    "website": "https://www.bmw.de/de/partner/autohaus-bock-nittenau-47793.html",
    "coords": {
      "lat": 49.2017822265625,
      "lng": 12.279305458068848
    }
  },
  {
    "id": "38476_1",
    "name": "AHAG Bochum GmbH",
    "country": "DE",
    "city": "Bochum",
    "address": "Hattinger Straße 386 b, 44795 Bochum",
    "email": "kontakt.weitmar@ahag-bochum.de",
    "phone": "+49-234-6014000",
    "website": "https://www.ahag-group.bmw",
    "coords": {
      "lat": 51.44541549682617,
      "lng": 7.194585800170898
    }
  },
  {
    "id": "39322_3",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Bopfingen",
    "address": "Neue Nördlinger Straße 10, 73441 Bopfingen",
    "email": "info@mulfinger.de",
    "phone": "+49-7362-922360",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 48.85823059082031,
      "lng": 10.356861114501953
    }
  },
  {
    "id": "52441_1",
    "name": "Automobile Görnitz GmbH",
    "country": "DE",
    "city": "Halsbrücke",
    "address": "Erlichter Str. 5, 09633 Halsbrücke",
    "email": "automobile.goernitz@t-online.de",
    "phone": "+49-35209-20417",
    "website": "https://www.bmw-service-goernitz.de",
    "coords": {
      "lat": 50.97676086425781,
      "lng": 13.435930252075195
    }
  },
  {
    "id": "52764_1",
    "name": "Leebmann Deggendorf GmbH",
    "country": "DE",
    "city": "Deggendorf",
    "address": "Hauptstraße 18, 94469 Deggendorf",
    "email": "bmw.deggendorf@leebmann.de",
    "phone": "+49-991-370560",
    "website": "https://www.leebmann.de/bmw",
    "coords": {
      "lat": 48.82149124145508,
      "lng": 12.952019691467285
    }
  },
  {
    "id": "53827_3",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Traunstein",
    "address": "Crailsheimstr. 13, 83278 Traunstein",
    "email": "traunstein@motorheimat.de",
    "phone": "+49-861-986860",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 47.86808395385742,
      "lng": 12.639122009277344
    }
  },
  {
    "id": "40872_1",
    "name": "Autohaus Hannemann GmbH",
    "country": "DE",
    "city": "Künzelsau",
    "address": "Robert-Bosch-Straße 26, 74653 Künzelsau",
    "email": "mails@auto-hannemann.de",
    "phone": "+49-7940-4543",
    "website": "https://www.bmw-service-hannemann.de/de/home/",
    "coords": {
      "lat": 49.25536346435547,
      "lng": 9.679610252380371
    }
  },
  {
    "id": "49562_1",
    "name": "Auto- und Motorradhaus Siefert GmbH",
    "country": "DE",
    "city": "Gengenbach",
    "address": "Eugen-Klaussner-Str. 2, 77723 Gengenbach",
    "email": "info@automoto-siefert.de",
    "phone": "+49-07803-6160",
    "website": "https://www.bmw.de/de/partner/automoto-siefert-gengenbach-49562.html",
    "coords": {
      "lat": 48.396575927734375,
      "lng": 8.021665573120117
    }
  },
  {
    "id": "36342_1",
    "name": "Auto-Albert GmbH",
    "country": "DE",
    "city": "Baumholder",
    "address": "Kuseler Str. 20, 55774 Baumholder",
    "email": "auto-albert@bmw-auto-albert.de",
    "phone": "+49-6783-99450",
    "website": "https://bmw-service-auto-albert.de/de/home/",
    "coords": {
      "lat": 49.61349868774414,
      "lng": 7.34335994720459
    }
  },
  {
    "id": "51178_2",
    "name": "Autohaus Krah + Enders GmbH & Co. KG",
    "country": "DE",
    "city": "Friedberg (Hessen)",
    "address": "Pfingstweide 33, 61169 Friedberg (Hessen)",
    "email": "info@bmw-krah-enders-friedberg.de",
    "phone": "+49-6031-7188-0",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.31692123413086,
      "lng": 8.756957054138184
    }
  },
  {
    "id": "53680_1",
    "name": "Langenhan Erfurt GmbH",
    "country": "DE",
    "city": "Erfurt",
    "address": "Justus-Liebig-Str. 30, 99087 Erfurt",
    "email": "ef@bmw-langenhan.de",
    "phone": "+49-361-2621700",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 51.01726150512695,
      "lng": 11.035860061645508
    }
  },
  {
    "id": "40330_1",
    "name": "Autohaus Hoffmann e.K.",
    "country": "DE",
    "city": "Zweibrücken",
    "address": "Saarpfalzstr. 7, 66482 Zweibrücken",
    "email": "info@autohaus-hoffmann-zw.de",
    "phone": "+49-6332-910600",
    "website": "https://www.bmw.de/de/partner/autohaus-hoffmann-zweibruecken-40330.html",
    "coords": {
      "lat": 49.26024627685547,
      "lng": 7.338613510131836
    }
  },
  {
    "id": "40833_1",
    "name": "Autohaus Hasse GmbH",
    "country": "DE",
    "city": "Mindelheim",
    "address": "Nebelhornstr. 10, 87719 Mindelheim",
    "email": "info@autohaus-hasse.de",
    "phone": "+49-8261-76030",
    "website": "https://www.bmw-service-hasse.de/de/home/",
    "coords": {
      "lat": 48.03575134277344,
      "lng": 10.502039909362793
    }
  },
  {
    "id": "43942_1",
    "name": "Heiko Emde GmbH",
    "country": "DE",
    "city": "Wuppertal",
    "address": "Uellendahlerstr. 462, 42109 Wuppertal",
    "email": "info@bmw-emde-service.de",
    "phone": "+49-202-8702080",
    "website": "https://www.bmw.de/de/partner/autohaus-heiko-emde-wuppertal-43942.html",
    "coords": {
      "lat": 51.280479431152344,
      "lng": 7.169088840484619
    }
  },
  {
    "id": "51178_1",
    "name": "Autohaus Krah + Enders GmbH & Co. KG",
    "country": "DE",
    "city": "Nidda",
    "address": "Raun 97-99, 63667 Nidda",
    "email": "info@bmw-krah-enders-nidda.de",
    "phone": "+49-6043-404-0",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.407440185546875,
      "lng": 9.01171875
    }
  },
  {
    "id": "52278_1",
    "name": "Vögl GmbH & Co. Vilsbiburg KG",
    "country": "DE",
    "city": "Vilsbiburg",
    "address": "Baumgartenstraße 1, 84137 Vilsbiburg",
    "email": "vilsbiburg@voegl.de",
    "phone": "+49-08741-9259-0",
    "website": "https://www.bmw.de/de/partner/voegl-vilsbiburg-52278.html",
    "coords": {
      "lat": 48.452308654785156,
      "lng": 12.3302001953125
    }
  },
  {
    "id": "53551_1",
    "name": "Kattenstroth Automobile & Service GmbH",
    "country": "DE",
    "city": "Gütersloh",
    "address": "Kahlertstraße 145-147, 33330 Gütersloh",
    "email": "info@kattenstroth-automobile.de",
    "phone": "+49-5241-93680",
    "website": "https://www.bmw.de/de/partner/kattenstroth-automobile-guetersloh-53551.html",
    "coords": {
      "lat": 51.92310333251953,
      "lng": 8.385140419006348
    }
  },
  {
    "id": "53968_2",
    "name": "Müller Automotive GmbH",
    "country": "DE",
    "city": "Erbach",
    "address": "Robert-Bosch-Str. 15, 64711 Erbach",
    "email": "team@bmw-mueller.com",
    "phone": "+49-6062-9430-0",
    "website": "https://www.bmw-mueller.com",
    "coords": {
      "lat": 49.66756057739258,
      "lng": 8.99392032623291
    }
  },
  {
    "id": "03846_2",
    "name": "Andreas Ehrl Potsdam GmbH & Co. KG",
    "country": "DE",
    "city": "Brandenburg",
    "address": "Kaiserslauterner Str. 5, 14772 Brandenburg",
    "email": "info@bmw-ehrl.de",
    "phone": "+49-3381-72680",
    "website": "https://www.ehrl-gruppe.de",
    "coords": {
      "lat": 52.438968658447266,
      "lng": 12.528094291687012
    }
  },
  {
    "id": "33206_1",
    "name": "Autohaus C. Ehrl GmbH",
    "country": "DE",
    "city": "Berlin",
    "address": "Heerstr. 350, 13593 Berlin",
    "email": "info@bmw-ehrl.com",
    "phone": "+49-30-3559040",
    "website": "https://www.ehrl-gruppe.de",
    "coords": {
      "lat": 52.51748275756836,
      "lng": 13.174934387207031
    }
  },
  {
    "id": "32047_1",
    "name": "Autohaus Ehrl GmbH Dessau",
    "country": "DE",
    "city": "Dessau",
    "address": "Zunftstr. 12, 06847 Dessau",
    "email": "info@bmw-ehrl.com",
    "phone": "+49-340-541110",
    "website": "https://www.ehrl-gruppe.de",
    "coords": {
      "lat": 51.81819152832031,
      "lng": 12.217769622802734
    }
  },
  {
    "id": "04071_3",
    "name": "Procar Automobile Düsseldorf GmbH",
    "country": "DE",
    "city": "Mettmann",
    "address": "Willettstr. 7, 40822 Mettmann",
    "email": "mettmann@bmw-procar.de",
    "phone": "+49-2104-83340",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.254608154296875,
      "lng": 6.951600074768066
    }
  },
  {
    "id": "01263_1",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Hamburg",
    "address": "Buxtehuder Str. 112, 21073 Hamburg",
    "email": "hamburg@bundk.de",
    "phone": "+49-40-7660910",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 53.4694709777832,
      "lng": 9.962980270385742
    }
  },
  {
    "id": "04709_1",
    "name": "Kaltenbach Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Overath",
    "address": "Maarweg 1, 51491 Overath",
    "email": "info.overath@kaltenbach-gruppe.de",
    "phone": "+49-2206-90140",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 50.964996337890625,
      "lng": 7.323820114135742
    }
  },
  {
    "id": "01263_25",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Salzgitter",
    "address": "Gittertor 56, 38259 Salzgitter",
    "email": "sz@wellergruppe.de",
    "phone": "+49-5341-90090",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.04301834106445,
      "lng": 10.358240127563477
    }
  },
  {
    "id": "00863_4",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Gütersloh",
    "address": "Hülsbrockstr. 83-87, 33334 Gütersloh",
    "email": "guetersloh@bundk.de",
    "phone": "+49-5241-99800",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.918609619140625,
      "lng": 8.410840034484863
    }
  },
  {
    "id": "01263_2",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Lüneburg",
    "address": "Hamburger Str. 1, 21339 Lüneburg",
    "email": "lueneburg@bundk.de",
    "phone": "+49-4131-30040",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 53.26564025878906,
      "lng": 10.406265258789062
    }
  },
  {
    "id": "01263_7",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Stendal",
    "address": "Heerener Str. 56, 39576 Stendal",
    "email": "stendal@bundk.de",
    "phone": "+49-3931-70070",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.58803939819336,
      "lng": 11.87205982208252
    }
  },
  {
    "id": "01263_26",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Peine",
    "address": "Horstweg 12, 31226 Peine",
    "email": "pe@wellergruppe.de",
    "phone": "+49-5171-58590",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.31816864013672,
      "lng": 10.212987899780273
    }
  },
  {
    "id": "01263_20",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Hamburg",
    "address": "Bergedorfer Straße 68, 21033 Hamburg",
    "email": "be@wellergruppe.de",
    "phone": "+49-40-720040-0",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 53.49173355102539,
      "lng": 10.20085620880127
    }
  },
  {
    "id": "07322_1",
    "name": "Kaltenbach Automobile GmbH",
    "country": "DE",
    "city": "Werdohl",
    "address": "Gildestr. 26, 58791 Werdohl",
    "email": "info.werdohl@kaltenbach-gruppe.de",
    "phone": "+49-2392-93905",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.26150131225586,
      "lng": 7.785900115966797
    }
  },
  {
    "id": "23368_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Wermelskirchen",
    "address": "Neuenhaus 104-106, 42929 Wermelskirchen",
    "email": "info.wermelskirchen@kaltenbach-gruppe.de",
    "phone": "+49-2196-887670",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.106929779052734,
      "lng": 7.165369987487793
    }
  },
  {
    "id": "07466_1",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Oschersleben",
    "address": "Anderslebener Str. 49, 39387 Oschersleben",
    "email": "schubert.oschersleben@schubert-motors.de",
    "phone": "+49-3949-94940",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 52.422889709472656,
      "lng": 10.86362361907959
    }
  },
  {
    "id": "04562_6",
    "name": "Langenhan GmbH",
    "country": "DE",
    "city": "Jena",
    "address": "Göschwitzer Straße 2, 07745 Jena",
    "email": "j@bmw-langenhan.de",
    "phone": "+49-3641-22300",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 50.89762878417969,
      "lng": 11.594269752502441
    }
  },
  {
    "id": "07830_1",
    "name": "Autohaus Ehrl GmbH Halle",
    "country": "DE",
    "city": "Zscherben",
    "address": "Am Bruchfeld 1, 06179 Zscherben",
    "email": "info@bmw-ehrl.com",
    "phone": "+49-345-686970",
    "website": "https://www.ehrl-gruppe.de",
    "coords": {
      "lat": 51.47160720825195,
      "lng": 11.882819175720215
    }
  },
  {
    "id": "04562_5",
    "name": "Langenhan GmbH",
    "country": "DE",
    "city": "Weimar",
    "address": "Ettersburger Straße 23, 99427 Weimar",
    "email": "we@bmw-langenhan.de",
    "phone": "+49-3643-46440",
    "website": "https://www.langenhan-gruppe.de",
    "coords": {
      "lat": 50.995182037353516,
      "lng": 11.319343566894531
    }
  },
  {
    "id": "07205_1",
    "name": "Autohaus Zwingenberger",
    "country": "DE",
    "city": "Gersdorf",
    "address": "Hofer Str. 8, 09355 Gersdorf",
    "email": "ingo.henkel@bmw-zwingenberger.de",
    "phone": "+49-3723-401770",
    "website": "https://www.bmw.de/de/partner/zwingenberger-sachsenring-gersdorf-07205.html",
    "coords": {
      "lat": 50.78041076660156,
      "lng": 12.695819854736328
    }
  },
  {
    "id": "04536_1",
    "name": "Autohaus Pulz e.K.",
    "country": "DE",
    "city": "Riesa",
    "address": "Lommatzscher Str. 26, 01587 Riesa",
    "email": "info@bmw-pulz.de",
    "phone": "+49-3525-50080",
    "website": "https://www.bmw.de/de/partner/autohaus-pulz-riesa-04536.html",
    "coords": {
      "lat": 51.29521942138672,
      "lng": 13.285820007324219
    }
  },
  {
    "id": "33696_1",
    "name": "Autohaus J. B. Lell",
    "country": "DE",
    "city": "Weiden",
    "address": "Zur Centralwerkstätte 5, 92637 Weiden",
    "email": "info.wen@lell-bmw.de",
    "phone": "+49-961-30030",
    "website": "http://www.lell.bmw",
    "coords": {
      "lat": 49.68088150024414,
      "lng": 12.160163879394531
    }
  },
  {
    "id": "00911_1",
    "name": "Klaus Scheller GmbH",
    "country": "DE",
    "city": "Bad Dürkheim",
    "address": "Triftweg 10, 67098 Bad Dürkheim",
    "email": "info@bmw-scheller.de",
    "phone": "+49-6322-94250",
    "website": "https://www.bmw-scheller.de",
    "coords": {
      "lat": 49.463626861572266,
      "lng": 8.180667877197266
    }
  },
  {
    "id": "07491_3",
    "name": "Autohaus H. Freese GmbH & Co. KG",
    "country": "DE",
    "city": "Jever",
    "address": "Am Hillernsen Hamm 9, 26441 Jever",
    "email": "info.jev@freese-gruppe.de",
    "phone": "+49-4461-93120",
    "website": "https://www.bmw-gruppe.de",
    "coords": {
      "lat": 53.57978057861328,
      "lng": 7.903289794921875
    }
  },
  {
    "id": "28323_1",
    "name": "Autohaus Kainz GmbH & Co. KG Wittlich",
    "country": "DE",
    "city": "Wittlich",
    "address": "Max-Planck-Str. 21, 54516 Wittlich",
    "email": "info.wittlich@kainz-gruppe.de",
    "phone": "+49-6571-95330",
    "website": "https://www.bmw.de/de/partner/autohaus-kainz-wittlich-28323.html",
    "coords": {
      "lat": 49.9874267578125,
      "lng": 6.905773639678955
    }
  },
  {
    "id": "04703_1",
    "name": "Autohaus Kainz GmbH & Co. KG Daun",
    "country": "DE",
    "city": "Daun",
    "address": "Hamsterweg 3, 54550 Daun",
    "email": "info.daun@kainz-gruppe.de",
    "phone": "+49-6592-96900",
    "website": "https://www.bmw.de/de/partner/autohaus-kainz-daun-04703.html",
    "coords": {
      "lat": 50.19198989868164,
      "lng": 6.805339813232422
    }
  },
  {
    "id": "04543_3",
    "name": "BMW AG Niederlassung Leipzig Filiale Werk Leipzig",
    "country": "DE",
    "city": "Leipzig",
    "address": "BMW Allee 1, 04349 Leipzig",
    "email": "nl.leipzig@bmw.de",
    "phone": "+49-341-4455-2770",
    "website": "https://www.bmw-leipzig.de/de/home/",
    "coords": {
      "lat": 51.41196060180664,
      "lng": 12.43703842163086
    }
  },
  {
    "id": "54819_1",
    "name": "Mayer-Scheneman GmbH",
    "country": "DE",
    "city": "Heitersheim",
    "address": "Beiersdorfstr. 2-4, 79423 Heitersheim",
    "email": "info@bmw-service-mayer-scheneman.de",
    "phone": "+49-7634-2500",
    "website": "https://www.bmw-service-mayer-scheneman.de",
    "coords": {
      "lat": 47.87260818481445,
      "lng": 7.650559902191162
    }
  },
  {
    "id": "01911_4",
    "name": "Fett & Wirtz Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Kleve",
    "address": "Siemensstr. 19 + 26, 47533 Kleve",
    "email": "info.kleve@bmw-fett-wirtz.de",
    "phone": "+49-2821-711850",
    "website": "https://www.fett-wirtz.de/",
    "coords": {
      "lat": 51.813323974609375,
      "lng": 6.1410627365112305
    }
  },
  {
    "id": "01263_18",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Bad Salzuflen",
    "address": "Benzstr. 19, 32108 Bad Salzuflen",
    "email": "suf@wellergruppe.de",
    "phone": "+49-5222-92650",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.05299377441406,
      "lng": 8.75574779510498
    }
  },
  {
    "id": "00104_10",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Neuburg a.d. Donau",
    "address": "Münchener Straße 132, 86633 Neuburg a.d. Donau",
    "email": "neuburg@hofmann.auto",
    "phone": "+49-8431-67460",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.727935791015625,
      "lng": 11.19861125946045
    }
  },
  {
    "id": "33854_2",
    "name": "Müller-Dynamic GmbH",
    "country": "DE",
    "city": "Simmern",
    "address": "Rudolf-Diesel-Str. 1, 55469 Simmern",
    "email": "kontakt@mueller-bmw.com",
    "phone": "+49-6761-95960",
    "website": "https://www.mueller-auto.com/markenwelten/bmw",
    "coords": {
      "lat": 49.99412155151367,
      "lng": 7.5287652015686035
    }
  },
  {
    "id": "53827_4",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Altenmarkt",
    "address": "Traunsteiner Str. 80, 83352 Altenmarkt",
    "email": "altenmarkt@motorheimat.de",
    "phone": "+49-8621-98590",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 47.9891357421875,
      "lng": 12.542611122131348
    }
  },
  {
    "id": "35372_1",
    "name": "Jungeblut GmbH & Co. KG",
    "country": "DE",
    "city": "Borken",
    "address": "Nordring 35-39, 46325 Borken",
    "email": "service@bmw-jungeblut.de",
    "phone": "+49-2861-90660",
    "website": "https://www.boomers.bmw",
    "coords": {
      "lat": 51.848968505859375,
      "lng": 6.8573503494262695
    }
  },
  {
    "id": "00250_32",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Ostfildern",
    "address": "Senefelderstr. 2, 73760 Ostfildern",
    "email": "bmw-ostfildern@ahg-mobile.de",
    "phone": "+49-711-44983-0",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.73200225830078,
      "lng": 9.244146347045898
    }
  },
  {
    "id": "00557_3",
    "name": "Nefzger GmbH & Co. KG",
    "country": "DE",
    "city": "Oranienburg",
    "address": "Am Heidering 4, 16515 Oranienburg",
    "email": "info@nefzger-berlin.de",
    "phone": "+49-3301-83180",
    "website": "https://www.nefzger-berlin.de",
    "coords": {
      "lat": 52.773101806640625,
      "lng": 13.262789726257324
    }
  },
  {
    "id": "25997_1",
    "name": "Götze & Gellermann GmbH",
    "country": "DE",
    "city": "Mülheim an der Ruhr",
    "address": "Alexanderstr. 1, 45472 Mülheim an der Ruhr",
    "email": "info@gg-bmw.de",
    "phone": "+49-208-8826690",
    "website": "http://gg-bmw.de/",
    "coords": {
      "lat": 51.43656921386719,
      "lng": 6.9316301345825195
    }
  },
  {
    "id": "33251_1",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Achim",
    "address": "Bremer Str. 59-63, 28832 Achim",
    "email": "info-achim@cloppenburg-gruppe.de",
    "phone": "+49-4202-60140",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 53.01414489746094,
      "lng": 9.022096633911133
    }
  },
  {
    "id": "38574_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Lennestadt",
    "address": "Wigeystr. 16, 57368 Lennestadt",
    "email": "info.lennestadt@kaltenbach-gruppe.de",
    "phone": "+49-2723-71909-0",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.108436584472656,
      "lng": 8.073369026184082
    }
  },
  {
    "id": "33251_2",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Delmenhorst",
    "address": "Niedersachsendamm 14, 27751 Delmenhorst",
    "email": "info-delmenhorst@cloppenburg-gruppe.de",
    "phone": "+49-4221-298800",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 53.0338249206543,
      "lng": 8.656582832336426
    }
  },
  {
    "id": "54762_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Mühldorf am Inn",
    "address": "Leisederstr. 1, 84453 Mühldorf am Inn",
    "email": "info@bmw-unterberger.de",
    "phone": null,
    "website": "https://de.unterberger.cc/bmw/",
    "coords": {
      "lat": 48.25524139404297,
      "lng": 12.543149948120117
    }
  },
  {
    "id": "00250_38",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Bötzingen",
    "address": "Allmendweg 1, 79268 Bötzingen",
    "email": "bmw-boetzingen@ahg-mobile.de",
    "phone": "+49-7663-60080",
    "website": "https://bmw-boetzingen@ahg-mobile.de",
    "coords": {
      "lat": 48.06840133666992,
      "lng": 7.723810195922852
    }
  },
  {
    "id": "01263_27",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Wernigerode",
    "address": "Waldhofstr. 19, 38855 Wernigerode",
    "email": "wr@wellergruppe.de",
    "phone": "+49-3943-55316",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 51.83757781982422,
      "lng": 10.77968978881836
    }
  },
  {
    "id": "23258_1",
    "name": "Autohaus Müller Wittenberg GmbH",
    "country": "DE",
    "city": "Wittenberg",
    "address": "Dessauer Str. 9, 06886 Wittenberg",
    "email": "info@automobile-mueller.info",
    "phone": "+49-3491-433430",
    "website": "https://www.bmw.de/de/partner/autohaus-mueller-wittenberg-23258.html",
    "coords": {
      "lat": 51.8656005859375,
      "lng": 12.6218900680542
    }
  },
  {
    "id": "25742_2",
    "name": "Procar Automobile Münsterland GmbH",
    "country": "DE",
    "city": "Warendorf",
    "address": "Sassenberger Straße 77, 48231 Warendorf",
    "email": "warendorf@bmw-procar.de",
    "phone": "+49-2581-93490",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.957305908203125,
      "lng": 8.008464813232422
    }
  },
  {
    "id": "52912_2",
    "name": "Emil Frey Vogel Automobile GmbH",
    "country": "DE",
    "city": "Landau",
    "address": "Am Schänzel 6, 76829 Landau",
    "email": "info@bmw-vogel.de",
    "phone": "+49-6341-9484-0",
    "website": "https://www.emilfrey.de/vogel-automobile",
    "coords": {
      "lat": 49.20954132080078,
      "lng": 8.117959976196289
    }
  },
  {
    "id": "35232_2",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Kiel",
    "address": "Holzkoppelweg 1-3, 24118 Kiel",
    "email": "info.kiel@hansanord.com",
    "phone": "+49-431-540050",
    "website": "https://www.hansanord.com/hansa-nord-kiel/",
    "coords": {
      "lat": 54.33359909057617,
      "lng": 10.111650466918945
    }
  },
  {
    "id": "30315_4",
    "name": "Ungeheuer Automobile GmbH",
    "country": "DE",
    "city": "Rastatt",
    "address": "Woogseestr. 5, 76437 Rastatt",
    "email": "info@ungeheuer.de",
    "phone": "+49-7222-90840",
    "website": "https://www.ungeheuer-bmw.de",
    "coords": {
      "lat": 48.85964584350586,
      "lng": 8.231263160705566
    }
  },
  {
    "id": "35658_1",
    "name": "Autohaus Fink GmbH & Co. KG",
    "country": "DE",
    "city": "Kempten",
    "address": "Lindauer Str. 115-117, 87435 Kempten",
    "email": "kempten@bmw-fink.de",
    "phone": "+49-831-564010",
    "website": "https://www.bmw-fink.de/",
    "coords": {
      "lat": 47.716732025146484,
      "lng": 10.294967651367188
    }
  },
  {
    "id": "00131_7",
    "name": "Autohaus Karl + Co. GmbH & Co. KG",
    "country": "DE",
    "city": "Rüsselsheim",
    "address": "Stahlstr. 22, 65428 Rüsselsheim",
    "email": "info@bmw-karl-co.de",
    "phone": "+49-6142-8350-0",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 49.976200103759766,
      "lng": 8.429300308227539
    }
  },
  {
    "id": "00508_9",
    "name": "Autohaus Rolf Horn GmbH",
    "country": "DE",
    "city": "Wesseling",
    "address": "Industriestr. 37-39, 50389 Wesseling",
    "email": "info@rolfhorn.de",
    "phone": "+49-2232-18970",
    "website": "https://www.rolfhorn.de",
    "coords": {
      "lat": 50.83407974243164,
      "lng": 6.95028018951416
    }
  },
  {
    "id": "21519_1",
    "name": "Autohaus Briem Leinfelden GmbH",
    "country": "DE",
    "city": "Leinfelden-Echterdingen",
    "address": "Stuttgarter Str. 87, 70771 Leinfelden-Echterdingen",
    "email": "info@autohaus-briem.de",
    "phone": "+49-711-9036200",
    "website": "https://bmw.de/de/partner/autohaus-briem-leinfelden-echterdingen-21519.html",
    "coords": {
      "lat": 48.70220184326172,
      "lng": 9.140789985656738
    }
  },
  {
    "id": "32929_1",
    "name": "Autohaus Eichhorn Automotive GmbH",
    "country": "DE",
    "city": "Obernburg",
    "address": "Römerstr. 113, 63785 Obernburg",
    "email": "info@auto-eichhorn.de",
    "phone": "+49-6022-62170",
    "website": "https://www.auto-eichhorn.de/",
    "coords": {
      "lat": 49.850406646728516,
      "lng": 9.152970314025879
    }
  },
  {
    "id": "23267_1",
    "name": "Autohaus Briem Nürtingen GmbH",
    "country": "DE",
    "city": "Nürtingen",
    "address": "In der Au 1, 72622 Nürtingen",
    "email": "info-nt@autohaus-briem.de",
    "phone": "+49-7022-95700",
    "website": "https://www.bmw.de/de/partner/autohaus-briem-nuertingen-23267.html",
    "coords": {
      "lat": 48.63666915893555,
      "lng": 9.339879989624023
    }
  },
  {
    "id": "49003_2",
    "name": "Autohaus Euler Mühlheim GmbH",
    "country": "DE",
    "city": "Hainburg",
    "address": "Dieselstr. 14, 63512 Hainburg",
    "email": "info@euler-group.de",
    "phone": "+49-6182-95990",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 50.064544677734375,
      "lng": 8.970535278320312
    }
  },
  {
    "id": "00440_3",
    "name": "Adolf Cuntz KG",
    "country": "DE",
    "city": "Worms",
    "address": "Auf dem Sand 6, 67547 Worms",
    "email": "info@autohaus-cuntz.de",
    "phone": "+49-6232-69700",
    "website": "https://www.autohaus-cuntz.de/",
    "coords": {
      "lat": 49.65494155883789,
      "lng": 8.354838371276855
    }
  },
  {
    "id": "04712_2",
    "name": "Hermann Arnold GmbH",
    "country": "DE",
    "city": "Alzenau",
    "address": "Siemensstraße 41, 63755 Alzenau",
    "email": "info@bmw-arnold.com",
    "phone": "+49-6023-99296-0",
    "website": "https://www.bmw-arnold.com",
    "coords": {
      "lat": 50.095603942871094,
      "lng": 9.046473503112793
    }
  },
  {
    "id": "00263_1",
    "name": "AHAG Münsterland GmbH",
    "country": "DE",
    "city": "Dorsten",
    "address": "Zum Alten Kreuz 1, 46282 Dorsten",
    "email": "kontakt.dorsten@ahag-dorsten.de",
    "phone": "+49-2362-20070",
    "website": "https://www.ahag-group.bmw",
    "coords": {
      "lat": 51.65150451660156,
      "lng": 6.9785847663879395
    }
  },
  {
    "id": "24342_7",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Quickborn",
    "address": "Pascalstr. 6-8, 25451 Quickborn",
    "email": "info@mayundolde.de",
    "phone": "+49-4106-76090",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.74369812011719,
      "lng": 9.93962287902832
    }
  },
  {
    "id": "24342_10",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Buxtehude",
    "address": "Lüneburger Schanze 6, 21614 Buxtehude",
    "email": "info@mayundolde.de",
    "phone": "+49-4161-71600",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.46326446533203,
      "lng": 9.69493293762207
    }
  },
  {
    "id": "24342_11",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Norderstedt",
    "address": "Niendorfer Str. 151, 22848 Norderstedt",
    "email": "info@mayundolde.de",
    "phone": "+49-40-5488000",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.66748046875,
      "lng": 9.974430084228516
    }
  },
  {
    "id": "31585_5",
    "name": "Autohaus Michael Schmidt GmbH",
    "country": "DE",
    "city": "Baierbrunn",
    "address": "Oberdiller Str. 29, 82065 Baierbrunn",
    "email": "info@bmw-schmidt.com",
    "phone": "+49-89-7441810",
    "website": "https://www.bmw-schmidt.com",
    "coords": {
      "lat": 48.0189208984375,
      "lng": 11.476339340209961
    }
  },
  {
    "id": "00406_1",
    "name": "Auer Gruppe GmbH",
    "country": "DE",
    "city": "Stockach",
    "address": "Bodenseeallee 2, 78333 Stockach",
    "email": "stockach@auer-gruppe.de",
    "phone": "+49-7771-93050",
    "website": "https://www.bmw.de/de/partner/auer-gruppe-stockach-00406.html",
    "coords": {
      "lat": 47.84039306640625,
      "lng": 9.029214859008789
    }
  },
  {
    "id": "00406_4",
    "name": "Auer Gruppe GmbH",
    "country": "DE",
    "city": "Konstanz",
    "address": "Macairestr. 1, 78467 Konstanz",
    "email": "konstanz@auer-gruppe.de",
    "phone": "+49-7531-59300",
    "website": "https://www.bmw.de/de/partner/auer-gruppe-konstanz-02708.html",
    "coords": {
      "lat": 47.67807388305664,
      "lng": 9.14968490600586
    }
  },
  {
    "id": "01416_1",
    "name": "Autohaus Waldmüller GmbH & Co. KG",
    "country": "DE",
    "city": "Roth",
    "address": "Norisstr. 31, 91154 Roth",
    "email": "info.von@bmw-waldmueller.de",
    "phone": "+49-9171-84030",
    "website": "http://bmw-waldmueller.de",
    "coords": {
      "lat": 49.24673843383789,
      "lng": 11.117950439453125
    }
  },
  {
    "id": "00737_9",
    "name": "Autohaus Krauth GmbH & Co. KG",
    "country": "DE",
    "city": "Mosbach",
    "address": "Hohlweg 22, 74821 Mosbach",
    "email": "info@bmw-krauth.de",
    "phone": "+49-6261-97500",
    "website": "https://www.bmw-krauth.de",
    "coords": {
      "lat": 49.32948684692383,
      "lng": 9.108311653137207
    }
  },
  {
    "id": "00027_5",
    "name": "BMW AG Niederlassung Essen",
    "country": "DE",
    "city": "Essen",
    "address": "Berthold-Beitz-Boulevard 508, 45141 Essen",
    "email": "nl.essen@bmw.de",
    "phone": "+49-201-83180",
    "website": "https://www.bmw-essen.de/de/home/",
    "coords": {
      "lat": 51.474422454833984,
      "lng": 7.001535892486572
    }
  },
  {
    "id": "00027_7",
    "name": "BMW AG Niederlassung Essen Gebrauchte Automobile Zentrum",
    "country": "DE",
    "city": "Essen",
    "address": "Berthold-Beitz-Boulevard 522, 45141 Essen",
    "email": "nl.essen@bmw.de",
    "phone": "+49-201-8318-0",
    "website": "http://bmw-partner.bmw.de/niederlassung-essen-gaz",
    "coords": {
      "lat": 51.47551727294922,
      "lng": 7.006095886230469
    }
  },
  {
    "id": "00027_8",
    "name": "BMW AG Niederlassung Bonn",
    "country": "DE",
    "city": "Bonn",
    "address": "Vorgebirgsstr. 95, 53119 Bonn",
    "email": "nl.bonn@bmw.de",
    "phone": "+49-228-6070",
    "website": "https://www.bmw-bonn.de/de/home/",
    "coords": {
      "lat": 50.741310119628906,
      "lng": 7.079324245452881
    }
  },
  {
    "id": "00104_11",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Mertingen",
    "address": "Gewerbepark-Ost  4-6, 86690 Mertingen",
    "email": "mertingen@hofmann.auto",
    "phone": "+49-9078-9606-0",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.66150665283203,
      "lng": 10.828079223632812
    }
  },
  {
    "id": "00116_2",
    "name": "Auto-Leebmann GmbH",
    "country": "DE",
    "city": "Pocking",
    "address": "Gewerbering 4, 94060 Pocking",
    "email": "info@leebmann.de",
    "phone": "+49-8531-90490",
    "website": "https://www.leebmann.de/bmw",
    "coords": {
      "lat": 48.406551361083984,
      "lng": 13.303460121154785
    }
  },
  {
    "id": "00120_1",
    "name": "Autohaus Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Heilbronn",
    "address": "Neckarsulmer Str. 26, 74076 Heilbronn",
    "email": "info@heermann-rhein.de",
    "phone": "+49-7131-15870",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 49.15263748168945,
      "lng": 9.2225341796875
    }
  },
  {
    "id": "00120_10",
    "name": "Autohaus Rhein Bodensee Zw.-Nl. der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Friedrichshafen",
    "address": "Otto-Lilienthal-Str. 25, 88046 Friedrichshafen",
    "email": "info@rhein-bodensee.de",
    "phone": "+49-7541-38600",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 47.66257858276367,
      "lng": 9.498152732849121
    }
  },
  {
    "id": "00120_16",
    "name": "Rhein Rothenburg Zw.-Nl. der Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Neusitz",
    "address": "Schaffeldstr. 5, 91616 Neusitz",
    "email": "info@rhein-rothenburg.de",
    "phone": "+49-9861-95030",
    "website": "https://www.rhein.bmw",
    "coords": {
      "lat": 49.37515640258789,
      "lng": 10.234285354614258
    }
  },
  {
    "id": "00139_1",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Siegen",
    "address": "Weidenauer Str. 217-225, 57076 Siegen",
    "email": "bmw.siegen@wahl-group.de",
    "phone": "+49-271-4020",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.89308166503906,
      "lng": 8.029000282287598
    }
  },
  {
    "id": "00139_9",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Marburg",
    "address": "Zu den Sandbeeten 10, 35043 Marburg",
    "email": "bmw.marburg@wahl-group.de",
    "phone": "+49-6421-9468-0",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.779449462890625,
      "lng": 8.761153221130371
    }
  },
  {
    "id": "00250_3",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Balingen",
    "address": "Lange Str. 23, 72336 Balingen",
    "email": "onlinevertrieb@ahg-mobile.de",
    "phone": "+49-7433-99202000",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.26029968261719,
      "lng": 8.849760055541992
    }
  },
  {
    "id": "00250_19",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Rottenburg am Neckar",
    "address": "Schuhstr. 77, 72108 Rottenburg am Neckar",
    "email": "bmw-rottenburg@ahg-mobile.de",
    "phone": "+49-7472-96920",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.479713439941406,
      "lng": 8.949650764465332
    }
  },
  {
    "id": "00250_29",
    "name": "ahg Autohandelsgesellschaft mbh",
    "country": "DE",
    "city": "Albstadt",
    "address": "Sigmaringer Str.140, 72458 Albstadt",
    "email": "bmw-albstadt@ahg-mobile.de",
    "phone": "+49-7431-13220",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.203819274902344,
      "lng": 9.04649543762207
    }
  },
  {
    "id": "00250_39",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Emmendingen",
    "address": "Am Elzdamm 31, 79312 Emmendingen",
    "email": "bmw-emmendingen@ahg-mobile.de",
    "phone": "+49-7641-92400",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.123416900634766,
      "lng": 7.835114479064941
    }
  },
  {
    "id": "00263_5",
    "name": "AHAG Münsterland GmbH",
    "country": "DE",
    "city": "Dülmen",
    "address": "Dammweg 1 (B 51), 48249 Dülmen",
    "email": "kontakt.duelmen@ahag-duelmen.de",
    "phone": "+49-2594-789090",
    "website": "https://www.ahag-group.bmw/de/home/",
    "coords": {
      "lat": 51.82270431518555,
      "lng": 7.2687602043151855
    }
  },
  {
    "id": "00341_1",
    "name": "Rene Partl GmbH",
    "country": "DE",
    "city": "Neumarkt",
    "address": "Am Berliner Ring 4, 92318 Neumarkt",
    "email": "info@bmw-partl.de",
    "phone": "+49-9181-32033",
    "website": "https://www.bmw-partl.de",
    "coords": {
      "lat": 49.29867935180664,
      "lng": 11.474109649658203
    }
  },
  {
    "id": "00391_10",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Crailsheim",
    "address": "Haller Str. 61, 74564 Crailsheim",
    "email": "verkauf.crailsheim@mulfinger.de",
    "phone": "+49-7951-91110",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 49.14248275756836,
      "lng": 10.048789024353027
    }
  },
  {
    "id": "00440_2",
    "name": "Autohaus Adolf Cuntz KG",
    "country": "DE",
    "city": "Neustadt a.d. Weinstraße",
    "address": "Europastr. 28, 67433 Neustadt a.d. Weinstraße",
    "email": "info@autohaus-cuntz.de",
    "phone": "+49-6321-49940",
    "website": "https://www.autohaus-cuntz.de/",
    "coords": {
      "lat": 49.341835021972656,
      "lng": 8.152740478515625
    }
  },
  {
    "id": "00557_2",
    "name": "Nefzger GmbH & Co. KG",
    "country": "DE",
    "city": "Berlin",
    "address": "Spandauer Damm 106, 14059 Berlin",
    "email": "info@nefzger-berlin.de",
    "phone": "+49-30-383801100",
    "website": "https://www.nefzger-berlin.de",
    "coords": {
      "lat": 52.518524169921875,
      "lng": 13.281344413757324
    }
  },
  {
    "id": "00737_10",
    "name": "Autohaus Krauth GmbH & Co. KG",
    "country": "DE",
    "city": "Heidelberg",
    "address": "In der Gabel 12, 69123 Heidelberg",
    "email": "info@bmw-krauth.de",
    "phone": "+49-6221-73660",
    "website": "https://www.bmw-krauth.de",
    "coords": {
      "lat": 49.41354751586914,
      "lng": 8.640624046325684
    }
  },
  {
    "id": "00866_1",
    "name": "Autohaus Widmann + Winterholler GmbH",
    "country": "DE",
    "city": "Dachau",
    "address": "Rudolf-Diesel-Str. 18, 85221 Dachau",
    "email": "info@widmann-winterholler.de",
    "phone": "+49-8131-31210",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 48.26388168334961,
      "lng": 11.47467041015625
    }
  },
  {
    "id": "00893_1",
    "name": "Helming & Sohn GmbH",
    "country": "DE",
    "city": "Lingen",
    "address": "Rheiner Str. 105, 49809 Lingen",
    "email": "info@helming-sohn.de",
    "phone": "+49-591-804080",
    "website": "https://www.helming-sohn.de",
    "coords": {
      "lat": 52.50688171386719,
      "lng": 7.32056999206543
    }
  },
  {
    "id": "00893_3",
    "name": "Helming & Sohn GmbH",
    "country": "DE",
    "city": "Nordhorn",
    "address": "Lingener Str. 121, 48531 Nordhorn",
    "email": "nordhorn@helming-sohn.de",
    "phone": "+49-5921-82340",
    "website": "https://www.helming-sohn.de",
    "coords": {
      "lat": 52.44084930419922,
      "lng": 7.088469982147217
    }
  },
  {
    "id": "00027_2",
    "name": "BMW AG Niederlassung Düsseldorf Filiale Rath",
    "country": "DE",
    "city": "Düsseldorf",
    "address": "Theodorstr. 279, 40472 Düsseldorf",
    "email": "nl.duesseldorf@bmw.de",
    "phone": "+49-211-909980",
    "website": "https://www.bmw-duesseldorf.de/de/home/",
    "coords": {
      "lat": 51.27385711669922,
      "lng": 6.809084892272949
    }
  },
  {
    "id": "00074_1",
    "name": "BMW AG Niederlassung Frankfurt",
    "country": "DE",
    "city": "Frankfurt am Main",
    "address": "Hanauer Landstr. 255, 60314 Frankfurt am Main",
    "email": "nl.frankfurt@bmw.de",
    "phone": "+49-69-40360",
    "website": "https://www.bmw-frankfurt.de/de/home/",
    "coords": {
      "lat": 50.115169525146484,
      "lng": 8.722865104675293
    }
  },
  {
    "id": "00074_3",
    "name": "BMW AG Niederlassung Offenbach",
    "country": "DE",
    "city": "Offenbach",
    "address": "Spessartring 9, 63071 Offenbach",
    "email": "nl.frankfurt@bmw.de",
    "phone": "+49-69-8500010",
    "website": "https://www.bmw-offenbach.de/de/home/",
    "coords": {
      "lat": 50.09014892578125,
      "lng": 8.77140998840332
    }
  },
  {
    "id": "00083_1",
    "name": "BMW AG Niederlassung Hamburg",
    "country": "DE",
    "city": "Hamburg",
    "address": "Offakamp 10-20, 22529 Hamburg",
    "email": "nl.hamburg@bmw.de",
    "phone": "+49-40-5530110",
    "website": "https://www.bmw-hamburg.de/de/home/",
    "coords": {
      "lat": 53.600189208984375,
      "lng": 9.971610069274902
    }
  },
  {
    "id": "01024_1",
    "name": "Autohaus Bernhard Holme GmbH",
    "country": "DE",
    "city": "Pegnitz",
    "address": "Ganghoferstr. 1, 91257 Pegnitz",
    "email": "autohaus.holme@bmw-holme.de",
    "phone": "+49-9241-99030",
    "website": "https://www.bmw.de/de/partner/autohaus-bernhard-holme-pegnitz-01024.html",
    "coords": {
      "lat": 49.744869232177734,
      "lng": 11.534250259399414
    }
  },
  {
    "id": "00083_13",
    "name": "BMW AG Niederlassung Hamburg Gebrauchte Automobile Zentrum",
    "country": "DE",
    "city": "Barsbüttel",
    "address": "Rahlstedter Straße 4 - 10, 22885 Barsbüttel",
    "email": "nl.hamburg@bmw.de",
    "phone": "+49-40-5530160",
    "website": "https://www.bmw-hamburg.de/de/home/",
    "coords": {
      "lat": 53.57715606689453,
      "lng": 10.194551467895508
    }
  },
  {
    "id": "00085_1",
    "name": "BMW AG Niederlassung Stuttgart",
    "country": "DE",
    "city": "Stuttgart",
    "address": "U'Waldplätze 3/Einfahrt Pascalstr 1, 70569 Stuttgart",
    "email": "bmw-stuttgart@bmw.de",
    "phone": "+49-711-13180",
    "website": "https://www.bmw-stuttgart.de/de/home/",
    "coords": {
      "lat": 48.73204040527344,
      "lng": 9.088370323181152
    }
  },
  {
    "id": "01066_1",
    "name": "AHAG Automobil-Handelsges. Egon Gladen GmbH & Co. KG",
    "country": "DE",
    "city": "Gelsenkirchen",
    "address": "Kurt-Schumacher-Str. 382, 45897 Gelsenkirchen",
    "email": "kontakt@ahag-bmw.de",
    "phone": "+49-209-360000",
    "website": "https://www.ahag-group.de",
    "coords": {
      "lat": 51.57441711425781,
      "lng": 7.057796955108643
    }
  },
  {
    "id": "01288_6",
    "name": "BMW AG Niederlassung Bremen",
    "country": "DE",
    "city": "Bremen",
    "address": "Borgwardstr. 4-6, 28279 Bremen",
    "email": "nl.bremen@bmw.de",
    "phone": "+49-421-83030",
    "website": "https://www.bmw-bremen.de",
    "coords": {
      "lat": 53.0463981628418,
      "lng": 8.841388702392578
    }
  },
  {
    "id": "01459_1",
    "name": "Günter Reuter GmbH",
    "country": "DE",
    "city": "Erlenbach",
    "address": "Am Bäuerleinsberg 2, 97837 Erlenbach",
    "email": "guenter.reuter@bmw-reuter.de",
    "phone": "+49-9391-4013+14",
    "website": "https://www.bmw.de/de/partner/guenter-reuter-erlenbach-01459.html",
    "coords": {
      "lat": 49.82941436767578,
      "lng": 9.61856460571289
    }
  },
  {
    "id": "01443_6",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Landsberg am Lech",
    "address": "Am Penzinger Feld 1, 86899 Landsberg am Lech",
    "email": "info@reisacher.de",
    "phone": "+49-8191-428800",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.05339050292969,
      "lng": 10.896149635314941
    }
  },
  {
    "id": "01548_1",
    "name": "Autohaus Euler GmbH",
    "country": "DE",
    "city": "Frankfurt am Main",
    "address": "Karl-von-Drais-Str. 7-9, 60435 Frankfurt am Main",
    "email": "info@euler-group.de",
    "phone": "+49-69-548200",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 50.147586822509766,
      "lng": 8.680652618408203
    }
  },
  {
    "id": "00104_1",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Ingolstadt",
    "address": "Manchinger Str. 110, 85053 Ingolstadt",
    "email": "Ingolstadt@hofmann.auto",
    "phone": "+49-841-966050",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.7481803894043,
      "lng": 11.463589668273926
    }
  },
  {
    "id": "00104_8",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Pfaffenhofen",
    "address": "Otto-Hahn-Str. 2, 85276 Pfaffenhofen",
    "email": "pfaffenhofen@hofmann.auto",
    "phone": "+49-8441-89500",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.544673919677734,
      "lng": 11.513041496276855
    }
  },
  {
    "id": "00114_3",
    "name": "Hermann Menton GmbH & Co KG",
    "country": "DE",
    "city": "Tübingen",
    "address": "Eisenbahnstr. 140, 72072 Tübingen",
    "email": "info@menton.de",
    "phone": "+49-7071-36660",
    "website": "https://www.menton.de",
    "coords": {
      "lat": 48.51796340942383,
      "lng": 9.084319114685059
    }
  },
  {
    "id": "02319_1",
    "name": "Autohaus Langlinderer e. K.",
    "country": "DE",
    "city": "Altötting",
    "address": "Tüßlinger Str. 1, 84503 Altötting",
    "email": "bmw@langlinderer.de",
    "phone": "+49-8671-50000",
    "website": "https://bmw.de/de/partner/autohaus-langlinderer-altoetting-02319.html",
    "coords": {
      "lat": 48.22500991821289,
      "lng": 12.65824031829834
    }
  },
  {
    "id": "02341_2",
    "name": "Drexl + Ziegler GmbH & Co. KG",
    "country": "DE",
    "city": "Augsburg",
    "address": "Bergiusstrasse 9, 86199 Augsburg",
    "email": "info@drexl-ziegler.de",
    "phone": "+49-821-480680",
    "website": "https://www.bmw.de/de/partner/drexl-ziegler-augsburg-37349.html",
    "coords": {
      "lat": 48.34043502807617,
      "lng": 10.884055137634277
    }
  },
  {
    "id": "02519_1",
    "name": "Autohaus Stahmer GmbH",
    "country": "DE",
    "city": "Altdorf",
    "address": "Prackenfelser Str. 4-8, 90518 Altdorf",
    "email": "service@bmw-stahmer.de",
    "phone": "+49-9187-95250",
    "website": "https://www.bmw.de/de/partner/autohaus-stahmer-altdorf-02519.html",
    "coords": {
      "lat": 49.38230514526367,
      "lng": 11.345444679260254
    }
  },
  {
    "id": "00139_7",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Korbach",
    "address": "Briloner Landstr. 72, 34497 Korbach",
    "email": "korbach@wahl-group.de",
    "phone": "+49-5631-97950",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 51.283050537109375,
      "lng": 8.848259925842285
    }
  },
  {
    "id": "02813_2",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Bad Windsheim",
    "address": "Burgbernheimer Str. 2, 91438 Bad Windsheim",
    "email": "info@cloppenburg-badwindsheim.de",
    "phone": "+49-9841-66330",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 49.497413635253906,
      "lng": 10.408686637878418
    }
  },
  {
    "id": "00200_1",
    "name": "Autohaus Menke GmbH",
    "country": "DE",
    "city": "Lohne",
    "address": "Südring 30, 49393 Lohne",
    "email": "info@menke-gruppe.de",
    "phone": "+49-4442-80040",
    "website": "https://www.bmw-service-menke.de",
    "coords": {
      "lat": 52.659339904785156,
      "lng": 8.19328498840332
    }
  },
  {
    "id": "00250_12",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Donaueschingen",
    "address": "Rudolf-Diesel-Str. 5, 78166 Donaueschingen",
    "email": "bmw-donaueschingen@ahg-mobile.de",
    "phone": "+49-771-898550",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 47.96472930908203,
      "lng": 8.508426666259766
    }
  },
  {
    "id": "00250_17",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Jettingen",
    "address": "Nagolder Str. 57, 71131 Jettingen",
    "email": "bmw-jettingen@ahg-mobile.de",
    "phone": "+49-7452-89660",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.57318878173828,
      "lng": 8.765000343322754
    }
  },
  {
    "id": "00250_35",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Böblingen",
    "address": "Herrenberger Straße 60, 71034 Böblingen",
    "email": "bmw-boeblingen@ahg-mobile.de",
    "phone": "+49-7031-7277-0",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.68189239501953,
      "lng": 8.997777938842773
    }
  },
  {
    "id": "03892_11",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Unna",
    "address": "Hansastr. 101, 59425 Unna",
    "email": "unna@bmw-procar.de",
    "phone": "+49-2303-250200",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.54124450683594,
      "lng": 7.665981769561768
    }
  },
  {
    "id": "03892_8",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Wuppertal",
    "address": "Friedrich-Ebert-Str. 105, 42117 Wuppertal",
    "email": "wuppertal@bmw-procar.de",
    "phone": "+49-202-25270",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.252601623535156,
      "lng": 7.13163423538208
    }
  },
  {
    "id": "04107_9",
    "name": "BMW AG Niederlassung München Filiale Fröttmaning",
    "country": "DE",
    "city": "München",
    "address": "Werner-Heisenberg-Allee 10, 80939 München",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-353580",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.20909118652344,
      "lng": 11.619654655456543
    }
  },
  {
    "id": "04119_2",
    "name": "Wernecke GmbH",
    "country": "DE",
    "city": "Zossen",
    "address": "Stubenrauchstraße, 15806 Zossen",
    "email": "info@bmw-wernecke.de",
    "phone": "+49-3377-34220",
    "website": "https://www.bmw-wernecke.de",
    "coords": {
      "lat": 52.227012634277344,
      "lng": 13.443838119506836
    }
  },
  {
    "id": "04146_1",
    "name": "Wilhelm Boomers GmbH & Co. KG",
    "country": "DE",
    "city": "Ahaus",
    "address": "Wüllener Str. 81, 48683 Ahaus",
    "email": "info.ahaus@boomers.de",
    "phone": "+49-2561-95310",
    "website": "https://www.boomers.de/bmw-hauptseite/",
    "coords": {
      "lat": 52.07334518432617,
      "lng": 6.996273994445801
    }
  },
  {
    "id": "00525_1",
    "name": "Autohaus Fink Immenstadt GmbH & Co. KG",
    "country": "DE",
    "city": "Immenstadt",
    "address": "Im Engelfeld 6, 87509 Immenstadt",
    "email": "info@bmw-fink.de",
    "phone": "+49-8323-96650",
    "website": "https://www.bmw-fink.de/",
    "coords": {
      "lat": 47.558990478515625,
      "lng": 10.212820053100586
    }
  },
  {
    "id": "04502_1",
    "name": "Autohaus Walter Kühnl GmbH",
    "country": "DE",
    "city": "Haßfurt",
    "address": "Zeiler Str. 20, 97437 Haßfurt",
    "email": "info.autohaus@bmw-kuehnl.de",
    "phone": "+49-9521-94770",
    "website": "https://www.bmw.de/de/partner/autohaus-walter-kuehnl-hassfurt-04502.ht",
    "coords": {
      "lat": 50.03104782104492,
      "lng": 10.524100303649902
    }
  },
  {
    "id": "00618_1",
    "name": "Autohaus Wormser GmbH Coburg",
    "country": "DE",
    "city": "Coburg",
    "address": "Niorter Straße 8, 96450 Coburg",
    "email": "info-co@bmw-wormser.de",
    "phone": "+49-9561-87250",
    "website": "https://www.autohaus-wormser.de",
    "coords": {
      "lat": 50.28615951538086,
      "lng": 10.98098087310791
    }
  },
  {
    "id": "04621_1",
    "name": "Autohaus H. Emmerich GmbH",
    "country": "DE",
    "city": "Rottweil",
    "address": "Klaus-Gutsch-Str. 4, 78628 Rottweil",
    "email": "Info@autohaus-emmerich.com",
    "phone": "+49-741-175170",
    "website": "https://www.bmw.de/de/partner/autohaus-emmerich-rottweil-04621.html",
    "coords": {
      "lat": 48.14847183227539,
      "lng": 8.642970085144043
    }
  },
  {
    "id": "00738_1",
    "name": "Autohaus Knopf GmbH & Co. KG",
    "country": "DE",
    "city": "Schriesheim",
    "address": "Carl-Benz-Str. 12, 69198 Schriesheim",
    "email": "autohaus.knopf@bmw-service-knopf.de",
    "phone": "+49-6203-69780",
    "website": "https://www.bmw.de/de/partner/autohaus-knopf-schriesheim-00738.html",
    "coords": {
      "lat": 49.46631622314453,
      "lng": 8.663423538208008
    }
  },
  {
    "id": "04746_14",
    "name": "Kohl automobile GmbH",
    "country": "DE",
    "city": "Bergheim",
    "address": "Heisenbergstraße, 50126 Bergheim",
    "email": "info@kohl.de",
    "phone": "+49-2271-76030",
    "website": "https://www.kohl.de/bmw",
    "coords": {
      "lat": 50.946868896484375,
      "lng": 6.623993873596191
    }
  },
  {
    "id": "04746_12",
    "name": "Kohl automobile GmbH Filiale Laurensberg",
    "country": "DE",
    "city": "Aachen",
    "address": "Kackertstr. 2, 52072 Aachen",
    "email": "info@kohl.de",
    "phone": "+49-241-886890",
    "website": "https://www.kohl.de/bmw",
    "coords": {
      "lat": 50.791587829589844,
      "lng": 6.065669059753418
    }
  },
  {
    "id": "04723_1",
    "name": "Autohaus Kornexl & Lenz GmbH",
    "country": "DE",
    "city": "Waldkirchen",
    "address": "Bannholzstr. 3, 94065 Waldkirchen",
    "email": "info@bmw-service-kornexl-lenz.de",
    "phone": "+49-8581-96460",
    "website": "https://www.bmw.de/de/partner/autohaus-kornexl-lenz-waldkirchen-04723.html",
    "coords": {
      "lat": 48.723201751708984,
      "lng": 13.614873886108398
    }
  },
  {
    "id": "00795_4",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "Altenkirchen",
    "address": "Lise-Meitner-Str. 9, 57610 Altenkirchen",
    "email": "kontakt-AK@hakvoort.de",
    "phone": "+49-2681-87980",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.68986129760742,
      "lng": 7.621689796447754
    }
  },
  {
    "id": "00866_3",
    "name": "Autohaus Widmann + Winterholler GmbH",
    "country": "DE",
    "city": "Fürstenfeldbruck",
    "address": "Maisacher Str. 119, 82256 Fürstenfeldbruck",
    "email": "info@widmann-winterholler.de",
    "phone": "+49-8141-5346930",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 48.192405700683594,
      "lng": 11.256183624267578
    }
  },
  {
    "id": "01818_1",
    "name": "Autohaus Kruft GmbH",
    "country": "DE",
    "city": "Oberhausen",
    "address": "Werthfeldstr. 1, 46117 Oberhausen",
    "email": "kunden.anfrage@bmw-kruft.de",
    "phone": "+49-208-69070",
    "website": "https://www.bmw-kruft.de",
    "coords": {
      "lat": 51.50001907348633,
      "lng": 6.867195129394531
    }
  },
  {
    "id": "01861_1",
    "name": "Auto-Zentrum Bernhard Ernst GmbH & Co. KG",
    "country": "DE",
    "city": "Witten",
    "address": "Crengeldanzstr. 83, 58455 Witten",
    "email": "kontakt.witten@bmw-ernst.de",
    "phone": "+49-2302-20050",
    "website": "https://www.ahag-group.bmw",
    "coords": {
      "lat": 51.45073318481445,
      "lng": 7.3256449699401855
    }
  },
  {
    "id": "01868_1",
    "name": "Autohaus Weissenfels GmbH",
    "country": "DE",
    "city": "Montabaur",
    "address": "Alleestr. 15-17, 56410 Montabaur",
    "email": "info@bmw-weissenfels.de",
    "phone": "+49-2602-15650",
    "website": "https://www.bmw.de/de/partner/autohaus-weissenfels-montabaur-01868.html",
    "coords": {
      "lat": 50.43852996826172,
      "lng": 7.83234977722168
    }
  },
  {
    "id": "01911_3",
    "name": "Fett & Wirtz Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Geldern",
    "address": "Martinistr. 52b, 47608 Geldern",
    "email": "info.geldern@bmw-fett-wirtz.de",
    "phone": "+49-2831-9101200",
    "website": "https://www.fett-wirtz.de/",
    "coords": {
      "lat": 51.52139663696289,
      "lng": 6.292784214019775
    }
  },
  {
    "id": "01911_5",
    "name": "Fett & Wirtz Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Wesel",
    "address": "Emmericher Str. 5-7, 46485 Wesel",
    "email": "info.wesel@bmw-fett-wirtz.de",
    "phone": "+49-281-962600",
    "website": "https://www.fett-wirtz.de/",
    "coords": {
      "lat": 51.67243957519531,
      "lng": 6.634479999542236
    }
  },
  {
    "id": "01965_1",
    "name": "Hubauer GmbH",
    "country": "DE",
    "city": "Landshut",
    "address": "Ingolstädter Str. 19, 84030 Landshut",
    "email": "mail@bmw-hubauer.de",
    "phone": "+49-871-975660",
    "website": "https://www.bmw-hubauer.de",
    "coords": {
      "lat": 48.563785552978516,
      "lng": 12.137516975402832
    }
  },
  {
    "id": "01945_3",
    "name": "Autohaus Kimbeck GmbH",
    "country": "DE",
    "city": "Pfarrkirchen",
    "address": "Franz-Stelzenberger-Str. 5, 84347 Pfarrkirchen",
    "email": "info@bmw-kimbeck.de",
    "phone": "+49-8561-96300",
    "website": "https://www.bmw.de/de/partner/autohaus-kimbeck-pfarrkirchen-02741.html",
    "coords": {
      "lat": 48.418331146240234,
      "lng": 12.940290451049805
    }
  },
  {
    "id": "02277_1",
    "name": "Karl Raudzus & Söhne GmbH & Co. KG",
    "country": "DE",
    "city": "Husum",
    "address": "Bredstedter Str. 2-8, 25813 Husum",
    "email": "info@raudzus.de",
    "phone": "+49-4841-89890",
    "website": "https://bmw-service-raudzus.de/de/home/",
    "coords": {
      "lat": 54.48563003540039,
      "lng": 9.046150207519531
    }
  },
  {
    "id": "02377_1",
    "name": "Vögl GmbH & Co. Automobilvertriebs KG",
    "country": "DE",
    "city": "Dingolfing",
    "address": "Gewerbehof 13, 84130 Dingolfing",
    "email": "dingolfing@voegl.de",
    "phone": "+49-8731-37870",
    "website": "https://www.bmw.de/de/partner/voegl-dingolfing-02377.html",
    "coords": {
      "lat": 48.64590835571289,
      "lng": 12.485565185546875
    }
  },
  {
    "id": "03892_4",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Iserlohn",
    "address": "Hembergstr. 5, 58636 Iserlohn",
    "email": "iserlohn@bmw-procar.de",
    "phone": "+49-2371-78980",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.38679504394531,
      "lng": 7.705143928527832
    }
  },
  {
    "id": "03892_13",
    "name": "Procar Automobile Wuppertal GmbH & Co. KG",
    "country": "DE",
    "city": "Leverkusen",
    "address": "Overfeldweg 2, 51371 Leverkusen",
    "email": "leverkusen@bmw-procar.de",
    "phone": "+49-214-86670",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.045650482177734,
      "lng": 6.9857258796691895
    }
  },
  {
    "id": "04504_1",
    "name": "Autohaus Menke GmbH",
    "country": "DE",
    "city": "Cloppenburg",
    "address": "Daimlerstr. 10, 49661 Cloppenburg",
    "email": "info@menke-gruppe.de",
    "phone": "+49-4471-18438-0",
    "website": "https://www.bmw-service-menke.de",
    "coords": {
      "lat": 52.84077072143555,
      "lng": 8.07118034362793
    }
  },
  {
    "id": "04553_2",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Schleiz",
    "address": "Greizer Str. 41, 07907 Schleiz",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-3663-43440",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.58006286621094,
      "lng": 11.823026657104492
    }
  },
  {
    "id": "04568_1",
    "name": "Autohaus Berger GmbH",
    "country": "DE",
    "city": "Elsterwerda",
    "address": "An der B 101, 04910 Elsterwerda",
    "email": "info@bmw-berger.de",
    "phone": "+49-3533-48050",
    "website": "https://www.bmw.de/de/partner/autohaus-berger-elsterwerda-04568.html",
    "coords": {
      "lat": 51.4658088684082,
      "lng": 13.499290466308594
    }
  },
  {
    "id": "04755_1",
    "name": "Autohaus E. Brinkmann GmbH",
    "country": "DE",
    "city": "Grasberg",
    "address": "Wörpedorfer Str. 16, 28879 Grasberg",
    "email": "info@bmw-brinkmann.de",
    "phone": "+49-4208-91760",
    "website": "https://www.bmw.de/de/partner/autohaus-brinkmann-grasberg-04755.html",
    "coords": {
      "lat": 53.183380126953125,
      "lng": 8.982620239257812
    }
  },
  {
    "id": "00027_3",
    "name": "BMW AG Niederlassung Düsseldorf Gebr. Automobile Zentrum & Motorrad",
    "country": "DE",
    "city": "Düsseldorf",
    "address": "Grafenberger Allee 258, 40237 Düsseldorf",
    "email": "nl.duesseldorf@bmw.de",
    "phone": "+49-211-90998-1391",
    "website": "http://bmw-partner.bmw.de/niederlassung-duesseldorf-gaz",
    "coords": {
      "lat": 51.23469161987305,
      "lng": 6.8184099197387695
    }
  },
  {
    "id": "00074_5",
    "name": "BMW AG Niederlassung Dreieich",
    "country": "DE",
    "city": "Dreieich",
    "address": "Gustav-Otto-Str. 1, 63303 Dreieich",
    "email": "nl.dreieich@bmw.de",
    "phone": "+49-6103-9300-0",
    "website": "https://www.bmw-dreieich.de/de/home/",
    "coords": {
      "lat": 50.03334426879883,
      "lng": 8.701539993286133
    }
  },
  {
    "id": "00083_2",
    "name": "BMW AG Niederlassung Hamburg Filiale City Süd",
    "country": "DE",
    "city": "Hamburg",
    "address": "Süderstr. 141, 20537 Hamburg",
    "email": "nl.hamburg@bmw.de",
    "phone": "+49-40-5530120",
    "website": "https://www.bmw-hamburg.de/de/home/",
    "coords": {
      "lat": 53.54685974121094,
      "lng": 10.035999298095703
    }
  },
  {
    "id": "00085_6",
    "name": "BMW AG Niederlassung Mannheim Gebrauchte Automobile Zentrum",
    "country": "DE",
    "city": "Mannheim",
    "address": "Inselstr. 2, 68169 Mannheim",
    "email": "bmw-mannheim@bmw.de",
    "phone": "+49-621-8357-0",
    "website": "https://www.bmw-mannheim.de/de/home/",
    "coords": {
      "lat": 49.5021858215332,
      "lng": 8.454941749572754
    }
  },
  {
    "id": "00104_9",
    "name": "Autohaus Hofmann GmbH",
    "country": "DE",
    "city": "Abensberg",
    "address": "Werkstr. 13, 93326 Abensberg",
    "email": "abensberg@hofmann.auto",
    "phone": "+49-9443-91530",
    "website": "https://www.hofmann.auto",
    "coords": {
      "lat": 48.80802536010742,
      "lng": 11.878379821777344
    }
  },
  {
    "id": "00120_9",
    "name": "Autohaus Rhein Würzburg Zw.-Nl. der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Lauda-Königshofen",
    "address": "Am Wöllerspfad 7, 97922 Lauda-Königshofen",
    "email": "info@rhein-tauberfranken.de",
    "phone": "+49-9343-60030",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 49.53845977783203,
      "lng": 9.740525245666504
    }
  },
  {
    "id": "00120_14",
    "name": "AH Rhein Rhön-Saale Zw.-Nl. der AH Heermann und Rhein GmbH",
    "country": "DE",
    "city": "Salz b. Bad Neustadt/Saale",
    "address": "Ludwig-Elsbett-Straße 1, 97616 Salz b. Bad Neustadt/Saale",
    "email": "info@rhein-bmw.de",
    "phone": "+49-9771-63530",
    "website": "https://www.rhein-bmw.de/",
    "coords": {
      "lat": 50.29598617553711,
      "lng": 10.192727088928223
    }
  },
  {
    "id": "00120_23",
    "name": "Autohaus Grötzinger Zw.Nl der AH Heermann u. Rhein GmbH",
    "country": "DE",
    "city": "Öhringen",
    "address": "Im Brenntenstock 3, 74613 Öhringen",
    "email": "info@autohaus-groetzinger.de",
    "phone": "+49-7941-9434-0",
    "website": "https://www.autohaus-groetzinger.de",
    "coords": {
      "lat": 49.20293045043945,
      "lng": 9.488470077514648
    }
  },
  {
    "id": "00250_9",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Freudenstadt",
    "address": "Gutenbergstr. 2, 72250 Freudenstadt",
    "email": "bmw-freudenstadt@ahg-mobile.de",
    "phone": "+49-7441-91620",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.46657180786133,
      "lng": 8.440164566040039
    }
  },
  {
    "id": "00250_31",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Esslingen",
    "address": "Dornierstr. 8, 73730 Esslingen",
    "email": "bmw-esslingen@ahg-mobile.de",
    "phone": "+49-711-93131-0",
    "website": "https://ahg.bmw/",
    "coords": {
      "lat": 48.71704864501953,
      "lng": 9.342302322387695
    }
  },
  {
    "id": "00268_1",
    "name": "Autohaus Fuchs Inh. Jürgen Fuchs e. K.",
    "country": "DE",
    "city": "Lohr/Main",
    "address": "Im Aller 1, 97816 Lohr/Main",
    "email": "info@autohaus-fuchs.de",
    "phone": "+49-9352-87570",
    "website": "https://www.bmw.de/de/partner/autohaus-fuchs-lohr-main-00268.html",
    "coords": {
      "lat": 50.00271987915039,
      "lng": 9.584670066833496
    }
  },
  {
    "id": "00536_1",
    "name": "Karl Feil GmbH",
    "country": "DE",
    "city": "Weißenburg",
    "address": "Treuchtlinger Str. 19, 91781 Weißenburg",
    "email": "info@bmw-feil.de",
    "phone": "+49-9141-85000",
    "website": "https://www.bmw.de/de/partner/karl-feil-weissenburg-00536.html",
    "coords": {
      "lat": 49.01543045043945,
      "lng": 10.957467079162598
    }
  },
  {
    "id": "00737_1",
    "name": "Autohaus Krauth GmbH & Co. KG",
    "country": "DE",
    "city": "Walldorf",
    "address": "Josef-Reiert-Str. 20, 69190 Walldorf",
    "email": "info@bmw-krauth.de",
    "phone": "+49-6227-6090",
    "website": "https://www.bmw-krauth.de",
    "coords": {
      "lat": 49.3060417175293,
      "lng": 8.630499839782715
    }
  },
  {
    "id": "00795_6",
    "name": "Hakvoort GmbH",
    "country": "DE",
    "city": "Bad Marienberg",
    "address": "Bismarckstr. 59, 56470 Bad Marienberg",
    "email": "kontakt@hakvoort.de",
    "phone": "+49-2661-912310",
    "website": "https://www.hakvoort-gruppe.de/markenwelt-bmw",
    "coords": {
      "lat": 50.645565032958984,
      "lng": 7.94110631942749
    }
  },
  {
    "id": "00866_9",
    "name": "Autohaus Mendler ein Unt. der Widmann+Winterholler GmbH",
    "country": "DE",
    "city": "Kaufbeuren",
    "address": "Füssener Str. 21, 87600 Kaufbeuren",
    "email": "info@bmw-mendler.de",
    "phone": "+49-8341-966260",
    "website": "https://www.widmann-winterholler.de/bmw",
    "coords": {
      "lat": 47.87092590332031,
      "lng": 10.628524780273438
    }
  },
  {
    "id": "00914_1",
    "name": "Autohaus Steen GmbH",
    "country": "DE",
    "city": "Alt Mölln",
    "address": "Bundesstr. 5, 23881 Alt Mölln",
    "email": "info@bmw-steen.de",
    "phone": "+49-4542-85850",
    "website": "https://www.bmw.de/de/partner/autohaus-steen-alt-moelln-00914.html",
    "coords": {
      "lat": 53.621944427490234,
      "lng": 10.663684844970703
    }
  },
  {
    "id": "01047_1",
    "name": "Autohaus Tekken GmbH",
    "country": "DE",
    "city": "Norden",
    "address": "Bahnhofstr. 35, 26506 Norden",
    "email": "ah.norden@tekken.de",
    "phone": "+49-4931-95850",
    "website": "https://tekken.de/",
    "coords": {
      "lat": 53.58517837524414,
      "lng": 7.223169803619385
    }
  },
  {
    "id": "01068_2",
    "name": "Autohaus Becker-Tiemann Bielefeld GmbH & Co. KG",
    "country": "DE",
    "city": "Bielefeld",
    "address": "Am Niedermeyers Feld 6, 33719 Bielefeld",
    "email": "bielefeld@becker-tiemann.de",
    "phone": "+49-521-163990",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.01533126831055,
      "lng": 8.617109298706055
    }
  },
  {
    "id": "01822_1",
    "name": "Autohaus Fulda Krah & Enders GmbH",
    "country": "DE",
    "city": "Fulda",
    "address": "Frankfurter Str. 127, 36043 Fulda",
    "email": "info@bmw-krah-enders-fulda.de",
    "phone": "+49-661-94790",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.531715393066406,
      "lng": 9.676297187805176
    }
  },
  {
    "id": "02243_1",
    "name": "Autohaus Tschirley GmbH",
    "country": "DE",
    "city": "Lauffen",
    "address": "Bahnhofstr. 135, 74348 Lauffen",
    "email": "autohaus.tschirley@bmw-tschirley.de",
    "phone": "+49-7133-98870",
    "website": "https://www.tschirley.de/",
    "coords": {
      "lat": 49.07194137573242,
      "lng": 9.136919975280762
    }
  },
  {
    "id": "03415_1",
    "name": "Autohaus Horst Greiwing KG",
    "country": "DE",
    "city": "Münster",
    "address": "Sprakeler Str. 357, 48159 Münster",
    "email": "horst.greiwing@bmw-greiwing.de",
    "phone": "+49-251-210190",
    "website": "https://www.bmw.de/de/partner/autohaus-horst-greiwing-muenster-03415.html",
    "coords": {
      "lat": 52.009151458740234,
      "lng": 7.614950180053711
    }
  },
  {
    "id": "04107_4",
    "name": "BMW AG Niederlassung München",
    "country": "DE",
    "city": "München",
    "address": "Frankfurter Ring 35, 80807 München",
    "email": "bmw-muenchen@bmw.de",
    "phone": "+49-89-353510",
    "website": "https://bmw-muenchen.de",
    "coords": {
      "lat": 48.18864822387695,
      "lng": 11.57505989074707
    }
  },
  {
    "id": "04110_1",
    "name": "Autohaus Ruffert GmbH",
    "country": "DE",
    "city": "Bautzen",
    "address": "Muskauer Str. 31, 02625 Bautzen",
    "email": "ah.ruffert@bmw-ruffert.de",
    "phone": "+49-3591-31110",
    "website": "https://www.bmw-ruffert.de",
    "coords": {
      "lat": 51.18544387817383,
      "lng": 14.438868522644043
    }
  },
  {
    "id": "07343_2",
    "name": "Michael Ludwig e. K.",
    "country": "DE",
    "city": "Neuruppin",
    "address": "Martin-Ebell-Str. 5, 16816 Neuruppin",
    "email": "info.np@bmw-ludwig.de",
    "phone": "+49-3391-510790",
    "website": "https://www.bmw.de/de/partner/autohaus-ludwig-neuruppin-26501.html",
    "coords": {
      "lat": 52.88644027709961,
      "lng": 12.799249649047852
    }
  },
  {
    "id": "07808_2",
    "name": "Autohaus Skjellet GmbH",
    "country": "DE",
    "city": "Bernau",
    "address": "Krokusstr. 14, 16321 Bernau",
    "email": "info@bmw-skjellet.de",
    "phone": "+49-3338-39990",
    "website": "https://www.bmw.de/de/partner/skjellet-bernau-30792.html",
    "coords": {
      "lat": 52.672401428222656,
      "lng": 13.569860458374023
    }
  },
  {
    "id": "21567_1",
    "name": "Autohaus Cyran GmbH",
    "country": "DE",
    "city": "Gronau",
    "address": "Borgwardstr. 1, 48599 Gronau",
    "email": "kontakt.gronau@bmw-cyran.de",
    "phone": "+49-2562-9922630",
    "website": "https://www.ahag-group.bmw",
    "coords": {
      "lat": 52.201011657714844,
      "lng": 7.0701799392700195
    }
  },
  {
    "id": "07205_3",
    "name": "Autohaus Zwingenberger",
    "country": "DE",
    "city": "Meerane",
    "address": "Seiferitzer Allee 5, 08393 Meerane",
    "email": "mike.zwingenberger@bmw-zwingenberger.de",
    "phone": "+49-3764-401170",
    "website": "https://www.bmw.de/de/partner/zwingenberger-sachsenring-meerane-23907.html",
    "coords": {
      "lat": 50.834083557128906,
      "lng": 12.448929786682129
    }
  },
  {
    "id": "07214_2",
    "name": "Autohaus Kühne GmbH",
    "country": "DE",
    "city": "Oschatz",
    "address": "Striesaer Weg 6, 04758 Oschatz",
    "email": "info-oschatz@bmw-kuehne.de",
    "phone": "+49-3435-90330",
    "website": "https://bmw-service-kuehne.de",
    "coords": {
      "lat": 51.30242156982422,
      "lng": 13.094019889831543
    }
  },
  {
    "id": "26636_3",
    "name": "Procar Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Köln",
    "address": "Robert-Perthel-Str. 1, 50739 Köln",
    "email": "koelnnord@bmw-procar.de",
    "phone": "+49-221-179510",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 50.976829528808594,
      "lng": 6.921710014343262
    }
  },
  {
    "id": "28043_1",
    "name": "Autohaus Riegel GmbH",
    "country": "DE",
    "city": "Trittau",
    "address": "Vorburgstr. 15-19, 22946 Trittau",
    "email": "info@autohausriegel.de",
    "phone": "+49-4154-2257",
    "website": "https://www.bmw.de/de/partner/autohaus-riegel-trittau-28043.html",
    "coords": {
      "lat": 53.60586166381836,
      "lng": 10.413966178894043
    }
  },
  {
    "id": "28269_1",
    "name": "Autohaus Nord GmbH",
    "country": "DE",
    "city": "Neumünster",
    "address": "Bunsenstr. 2, 24536 Neumünster",
    "email": "info@autohaus-nord-gmbh.de",
    "phone": "+49-4321-53390",
    "website": "https://www.bmw-service-nord.de",
    "coords": {
      "lat": 54.102909088134766,
      "lng": 9.985260009765625
    }
  },
  {
    "id": "28531_2",
    "name": "Autohaus Sperber GmbH & Co. KG",
    "country": "DE",
    "city": "Lichtenfels",
    "address": "Grünewaldstr. 3a-9, 96215 Lichtenfels",
    "email": "info.lif@autohaus-sperber.de",
    "phone": "+49-9571-92300",
    "website": "https://www.autohaus-sperber.de",
    "coords": {
      "lat": 50.136741638183594,
      "lng": 11.06210994720459
    }
  },
  {
    "id": "28864_1",
    "name": "Krah + Enders GmbH & Co. KG",
    "country": "DE",
    "city": "Maintal",
    "address": "Kesselstädter Strasse 49, 63477 Maintal",
    "email": "autohaus@bmw-krah-enders-maintal.de",
    "phone": "+49-6181-409870",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.12934875488281,
      "lng": 8.870686531066895
    }
  },
  {
    "id": "29344_4",
    "name": "Autohaus Becker-Tiemann Schaumburg GmbH & Co. KG",
    "country": "DE",
    "city": "Hameln",
    "address": "Ohsener Str. 74-80, 31789 Hameln",
    "email": "hameln@becker-tiemann.de",
    "phone": "+49-5151-9304-0",
    "website": "https://www.becker-tiemann.de",
    "coords": {
      "lat": 52.095638275146484,
      "lng": 9.369250297546387
    }
  },
  {
    "id": "29925_2",
    "name": "Gottstein GmbH Automobile + Motorräder",
    "country": "DE",
    "city": "Binzen",
    "address": "Konrad-Zuse-Str. 4, 79589 Binzen",
    "email": "info@bmw-gottstein.de",
    "phone": "+49-7621-422310",
    "website": "https://www.gottstein-gruppe.de/de/marken/bmw/",
    "coords": {
      "lat": 47.62358093261719,
      "lng": 7.61214017868042
    }
  },
  {
    "id": "30400_1",
    "name": "Henning Orth Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Trier",
    "address": "Am Verteilerring, 54292 Trier",
    "email": "info@orth.de",
    "phone": "+49-651-209020",
    "website": "https://www.bmw.de/de/partner/autohaus-henning-orth-trier-30400.html",
    "coords": {
      "lat": 49.77186584472656,
      "lng": 6.665590763092041
    }
  },
  {
    "id": "30380_1",
    "name": "Autohaus Müller GmbH",
    "country": "DE",
    "city": "Leonberg",
    "address": "Berliner Str. 55, 71229 Leonberg",
    "email": "Info@bmw-mueller.net",
    "phone": "+49-7152-94070",
    "website": "https://bmw-mueller.net/",
    "coords": {
      "lat": 48.788909912109375,
      "lng": 9.017250061035156
    }
  },
  {
    "id": "30635_2",
    "name": "Autohaus Euler Pirmasens GmbH",
    "country": "DE",
    "city": "Landstuhl",
    "address": "Bruchwiesenstr. 38-40, 66849 Landstuhl",
    "email": "info@euler-group.de",
    "phone": "+49-6371-92500",
    "website": "https://www.bmw-euler.de",
    "coords": {
      "lat": 49.41746139526367,
      "lng": 7.573070049285889
    }
  },
  {
    "id": "30637_4",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Idar-Oberstein",
    "address": "Kaufacker 9, 55743 Idar-Oberstein",
    "email": "info@cloppenburg-idaroberstein.de",
    "phone": "+49-6784-99350",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 49.724388122558594,
      "lng": 7.38686990737915
    }
  },
  {
    "id": "23337_1",
    "name": "Philipp Automobile GmbH",
    "country": "DE",
    "city": "Mülheim an der Ruhr",
    "address": "Ruhrorter Str. 53, 45478 Mülheim an der Ruhr",
    "email": "info@bmw-philipp.de",
    "phone": "+49-208-37570",
    "website": "https://www.philipp-bmw.de/",
    "coords": {
      "lat": 51.433990478515625,
      "lng": 6.838405132293701
    }
  },
  {
    "id": "33251_3",
    "name": "Cloppenburg GmbH",
    "country": "DE",
    "city": "Syke",
    "address": "Siemensstr. 9, 28857 Syke",
    "email": "info@cloppenburg-gmbh.de",
    "phone": "+49-4242-95950",
    "website": "https://www.bmw-cloppenburg.de",
    "coords": {
      "lat": 52.917869567871094,
      "lng": 8.801012992858887
    }
  },
  {
    "id": "23463_1",
    "name": "Autohaus Becker-Tiemann GmbH & Co. KG",
    "country": "DE",
    "city": "Bünde",
    "address": "Wasserbreite 88-94, 32257 Bünde",
    "email": "kontakt@becker-tiemann.de",
    "phone": "+49-5223-92620",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.20378875732422,
      "lng": 8.587611198425293
    }
  },
  {
    "id": "33854_5",
    "name": "Müller-Dynamic GmbH",
    "country": "DE",
    "city": "Trier",
    "address": "Ruwerer Str. 1A, 54292 Trier",
    "email": "kontakt@mueller-bmw.com",
    "phone": "+49-651-84088-0",
    "website": "https://www.mueller-auto.com/markenwelten/bmw",
    "coords": {
      "lat": 49.77598190307617,
      "lng": 6.684750080108643
    }
  },
  {
    "id": "34052_1",
    "name": "Simon Gruber Autoservice GmbH & Co. KG",
    "country": "DE",
    "city": "Ottobrunn",
    "address": "Rosenheimer Landstr. 50, 85521 Ottobrunn",
    "email": "bmw.info@simon-gruber.de",
    "phone": "+49-89-608006600",
    "website": "https://www.bmw.de/de/partner/simon-gruber-autoservice-ottobrunn-34052.html",
    "coords": {
      "lat": 48.06415939331055,
      "lng": 11.661694526672363
    }
  },
  {
    "id": "27921_1",
    "name": "Auto-Hübner GmbH & Co. KG",
    "country": "DE",
    "city": "Viechtach",
    "address": "Flurstr. 28, 94234 Viechtach",
    "email": "info@bmw-huebner.de",
    "phone": "+49-9942-905060",
    "website": "https://www.bmw.de/de/partner/autohaus-huebner-viechtach-27921.html",
    "coords": {
      "lat": 49.0705451965332,
      "lng": 12.889945030212402
    }
  },
  {
    "id": "27945_1",
    "name": "Vögele GmbH",
    "country": "DE",
    "city": "Weinheim",
    "address": "Händelstr. 10-12, 69469 Weinheim",
    "email": "info@bmw-nick.de",
    "phone": "+49-6201-84569-0",
    "website": "https://www.bmw.de/de/partner/peter-nick-weinheim-27945.html",
    "coords": {
      "lat": 49.55546951293945,
      "lng": 8.656243324279785
    }
  },
  {
    "id": "07466_15",
    "name": "Schubert Motors GmbH",
    "country": "DE",
    "city": "Aschersleben",
    "address": "Ottostraße 5, 06449 Aschersleben",
    "email": "schubert.aschersleben@schubert-motors.de",
    "phone": "+49-3473-92880",
    "website": "https://www.schubert-motors.de/",
    "coords": {
      "lat": 51.77008819580078,
      "lng": 11.486029624938965
    }
  },
  {
    "id": "28023_1",
    "name": "Autohaus Manfred Maurer GmbH",
    "country": "DE",
    "city": "Braunfels",
    "address": "Attenbachstr. 2, 35619 Braunfels",
    "email": "martina.obergfell@maurer-bmw-service.de",
    "phone": "+49-6442-93450",
    "website": "https://www.maurer-bmw-service.de",
    "coords": {
      "lat": 50.512489318847656,
      "lng": 8.39480972290039
    }
  },
  {
    "id": "29202_1",
    "name": "Walter Hager & Sohn GmbH",
    "country": "DE",
    "city": "Tirschenreuth",
    "address": "Mitterteicher Str. 33, 95643 Tirschenreuth",
    "email": "kontakt@autohaus-hager.de",
    "phone": "+49-9631-1769",
    "website": "https://bmw-service-hager.de/de/home/",
    "coords": {
      "lat": 49.8856201171875,
      "lng": 12.323380470275879
    }
  },
  {
    "id": "30312_1",
    "name": "Autohaus Müller Wurzen GmbH",
    "country": "DE",
    "city": "Wurzen",
    "address": "Nischwitzer Breite 15, 04808 Wurzen",
    "email": "info@automobile-mueller.info",
    "phone": "+49-3425-819730",
    "website": "https://www.bmw.de/de/partner/autohaus-mueller-wurzen-30312.html",
    "coords": {
      "lat": 51.385555267333984,
      "lng": 12.730999946594238
    }
  },
  {
    "id": "21887_2",
    "name": "Autohaus Schaal GmbH",
    "country": "DE",
    "city": "Schönecken",
    "address": "Industriestr. 2, 54614 Schönecken",
    "email": "info@bmw-schaal.de",
    "phone": "+49-6553-92500",
    "website": "https://www.autohaus-schaal.de/",
    "coords": {
      "lat": 50.15284729003906,
      "lng": 6.4723711013793945
    }
  },
  {
    "id": "30776_1",
    "name": "Autohaus Lauterbach Kreis GmbH",
    "country": "DE",
    "city": "Lauterbach",
    "address": "Fritz-Ebel-Allee 19, 36341 Lauterbach",
    "email": "info@bmw-autohaus-lauterbach.de",
    "phone": "+49-6641-911640",
    "website": "https://www.bmw.de/de/partner/autohaus-lauterbach-kreis-30776.html",
    "coords": {
      "lat": 50.64738464355469,
      "lng": 9.412434577941895
    }
  },
  {
    "id": "23532_1",
    "name": "Autohaus Hoyer GmbH",
    "country": "DE",
    "city": "Nienburg",
    "address": "Kräher Weg 33, 31582 Nienburg",
    "email": "hoyer-ni@hoyer.ps",
    "phone": "+49-5021-888888",
    "website": "https://www.bmw.de/de/partner/autohaus-hoyer-nienburg-23532.html",
    "coords": {
      "lat": 52.641231536865234,
      "lng": 9.235440254211426
    }
  },
  {
    "id": "31585_3",
    "name": "Autohaus Michael Schmidt GmbH",
    "country": "DE",
    "city": "Starnberg",
    "address": "Leutstettener Str. 26, 82319 Starnberg",
    "email": "info@bmw-schmidt.com",
    "phone": "+49-8151-26980",
    "website": "https://www.bmw-schmidt.com",
    "coords": {
      "lat": 48.00532913208008,
      "lng": 11.348190307617188
    }
  },
  {
    "id": "24333_1",
    "name": "Raudzus & Bossen GmbH & Co. KG",
    "country": "DE",
    "city": "Niebüll",
    "address": "Ostring 1, 25899 Niebüll",
    "email": "niebuell@raudzus.de",
    "phone": "+49-4661-901500",
    "website": "https://www.bmw.de/de/partner/autohaus-raudzus-bossen-niebuell-24333.html",
    "coords": {
      "lat": 54.783103942871094,
      "lng": 8.85262393951416
    }
  },
  {
    "id": "24604_1",
    "name": "Gerd Hoyer GmbH",
    "country": "DE",
    "city": "Soltau",
    "address": "Vor dem Weiherbusch 1, 29614 Soltau",
    "email": "hoyer-so@hoyer.ps",
    "phone": "+49-5191-984498",
    "website": "https://www.bmw.de/de/partner/autohaus-hoyer-soltau-24604.html",
    "coords": {
      "lat": 52.969512939453125,
      "lng": 9.85357666015625
    }
  },
  {
    "id": "33501_1",
    "name": "Hugo Pfohe GmbH",
    "country": "DE",
    "city": "Schwerin",
    "address": "Kirschenhöfer Weg 78, 19057 Schwerin",
    "email": "bmw@hugopfohe.de",
    "phone": "+49-385-644380",
    "website": "https://www.bmw.de/de/partner/autohaus-hugo-pfohe-schwerin-33501.html",
    "coords": {
      "lat": 53.6624755859375,
      "lng": 11.358329772949219
    }
  },
  {
    "id": "33952_1",
    "name": "Autohaus Unterberger GmbH",
    "country": "DE",
    "city": "Lindau",
    "address": "Peter-Dornier-Str. 2, 88131 Lindau",
    "email": "information@bmw-unterberger.de",
    "phone": "+49-8382-96580",
    "website": "https://www.bmw-unterberger.de",
    "coords": {
      "lat": 47.54984664916992,
      "lng": 9.729066848754883
    }
  },
  {
    "id": "26636_6",
    "name": "Procar Automobile GmbH & Co. KG",
    "country": "DE",
    "city": "Erkelenz",
    "address": "Antwerpener Str. 6, 41812 Erkelenz",
    "email": "erkelenz@bmw-procar.de",
    "phone": "+49-2431-96770",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.07728958129883,
      "lng": 6.306059837341309
    }
  },
  {
    "id": "28236_1",
    "name": "Autohaus Günther GmbH",
    "country": "DE",
    "city": "Gelnhausen",
    "address": "Leipziger Allee 51, 63571 Gelnhausen",
    "email": "achim.guenther@bmw-guenther.de",
    "phone": "+49-6051-97600",
    "website": "https://www.bmw.de/de/partner/autohaus-guenther-gelnhausen-28236.html",
    "coords": {
      "lat": 50.20840072631836,
      "lng": 9.233180046081543
    }
  },
  {
    "id": "28238_1",
    "name": "Auto Katzenbogen GmbH",
    "country": "DE",
    "city": "Thierhaupten-Neukirchen",
    "address": "Heuweg 13, 86672 Thierhaupten-Neukirchen",
    "email": "info@auto-katzenbogen.de",
    "phone": "+49-8276-584990",
    "website": "https://www.katzenbogen-service.bmw/de/home/",
    "coords": {
      "lat": 48.559288024902344,
      "lng": 10.968941688537598
    }
  },
  {
    "id": "30568_1",
    "name": "Autohaus Hagl GmbH & Co. KG",
    "country": "DE",
    "city": "Ottobrunn",
    "address": "Alte Landstr. 3, 85521 Ottobrunn",
    "email": "kontakt@autohaus-hagl.de",
    "phone": "+49-89-608730",
    "website": "https://www.bmw.de/de/partner/autohaus-hagl-ottobrunn-30668.html",
    "coords": {
      "lat": 48.071590423583984,
      "lng": 11.655830383300781
    }
  },
  {
    "id": "33854_3",
    "name": "Müller-Dynamic GmbH",
    "country": "DE",
    "city": "St. Wendel",
    "address": "Werschweiler Str. 52-54, 66606 St. Wendel",
    "email": "kontakt@mueller-bmw.com",
    "phone": "+49-6851-93120",
    "website": "https://www.mueller-auto.com/markenwelten/bmw",
    "coords": {
      "lat": 49.45633316040039,
      "lng": 7.178069114685059
    }
  },
  {
    "id": "33985_1",
    "name": "Genzel & Co. GmbH",
    "country": "DE",
    "city": "Schwedt",
    "address": "Schwedter Allee 25, 16303 Schwedt",
    "email": "info@bmw-service-genzel.de",
    "phone": "+49-3332-20850",
    "website": "https://www.bmw.de/de/partner/autohaus-genzel-schwedt-33985.html",
    "coords": {
      "lat": 53.042171478271484,
      "lng": 14.248720169067383
    }
  },
  {
    "id": "35090_1",
    "name": "Team Pilz GmbH",
    "country": "DE",
    "city": "Bad König",
    "address": "Danziger Str. 5, 64732 Bad König",
    "email": "info@bmw-service-pilz.de",
    "phone": "+49-6063-93090",
    "website": "https://www.bmw-service-pilz.de/de/home/",
    "coords": {
      "lat": 49.751399993896484,
      "lng": 9.00139045715332
    }
  },
  {
    "id": "35232_3",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Oldenburg/Holstein",
    "address": "Am Vossberg 18, 23758 Oldenburg/Holstein",
    "email": "info.oldenburg@hansanord.com",
    "phone": "+49-4361-90990",
    "website": "https://www.hansanord.com/hansa-nord-oldenburg-i-h/",
    "coords": {
      "lat": 54.29188537597656,
      "lng": 10.916794776916504
    }
  },
  {
    "id": "35232_4",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Eutin",
    "address": "Lübecker Landstr. 61, 23701 Eutin",
    "email": "info.eutin@hansanord.com",
    "phone": "+49-4521-79480",
    "website": "https://www.hansanord.com/hansa-nord-eutin/",
    "coords": {
      "lat": 54.12470626831055,
      "lng": 10.630256652832031
    }
  },
  {
    "id": "34842_1",
    "name": "Auto Deters Rheine GmbH",
    "country": "DE",
    "city": "Rheine",
    "address": "Am Stadtwalde 59, 48432 Rheine",
    "email": "info@auto-deters.de",
    "phone": "+49-5971-8001330",
    "website": "https://www.bmw.de/de/partner/auto-deters-rheine-34842.html",
    "coords": {
      "lat": 52.30257034301758,
      "lng": 7.450601100921631
    }
  },
  {
    "id": "35404_1",
    "name": "Autohaus Timmermanns Nettetal GmbH",
    "country": "DE",
    "city": "Nettetal",
    "address": "Boisheimer Str. 65, 41334 Nettetal",
    "email": "info@timmermanns.de",
    "phone": "+49-2153-73730",
    "website": "https://www.autohaus-timmermanns.bmw",
    "coords": {
      "lat": 51.27716827392578,
      "lng": 6.253505229949951
    }
  },
  {
    "id": "36881_1",
    "name": "Faba Autowelt GmbH",
    "country": "DE",
    "city": "Mönchengladbach",
    "address": "Krefelder Str. 570, 41066 Mönchengladbach",
    "email": "info@bmw-faba.de",
    "phone": "+49-2161-96460",
    "website": "https://www.bmw-faba-autowelt.de",
    "coords": {
      "lat": 51.2229118347168,
      "lng": 6.481993198394775
    }
  },
  {
    "id": "37014_1",
    "name": "Riedel Automobile GmbH",
    "country": "DE",
    "city": "Dinslaken",
    "address": "Willy-Brandt-Str. 1, 46535 Dinslaken",
    "email": "info@bmw-riedel.de",
    "phone": "+49-2064-478920",
    "website": "https://www.bmw-riedel.de",
    "coords": {
      "lat": 51.56903839111328,
      "lng": 6.73032808303833
    }
  },
  {
    "id": "35232_8",
    "name": "Autohaus Hansa Nord GmbH",
    "country": "DE",
    "city": "Neumünster",
    "address": "Altonaer Straße 209, 24539 Neumünster",
    "email": "Info.neumuenster@hansanord.com",
    "phone": "+49-4321-78332-0",
    "website": "https://www.hansanord.com/hansa-nord-neumunster/",
    "coords": {
      "lat": 54.05337905883789,
      "lng": 9.976550102233887
    }
  },
  {
    "id": "43526_1",
    "name": "Autohaus Isernhagen GmbH & Co. KG",
    "country": "DE",
    "city": "Isernhagen",
    "address": "Fuhrbleek 48-50, 30916 Isernhagen",
    "email": "info@autohaus-isernhagen.com",
    "phone": "+49-511-123230",
    "website": "https://www.bmw.de/de/partner/autohaus-isernhagen-43526.html",
    "coords": {
      "lat": 52.450584411621094,
      "lng": 9.787862777709961
    }
  },
  {
    "id": "53827_1",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Kirchseeon",
    "address": "Münchner Str. 80, 85614 Kirchseeon",
    "email": "kirchseeon@motorheimat.de",
    "phone": "+49-8091-55000",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 48.07697677612305,
      "lng": 11.881281852722168
    }
  },
  {
    "id": "53968_1",
    "name": "Müller Automotive GmbH",
    "country": "DE",
    "city": "Buchen-Hettingen",
    "address": "Neue Buchener Str. 28, 74722 Buchen-Hettingen",
    "email": "team@bmw-mueller.com",
    "phone": "+49-6281-52850",
    "website": "https://www.bmw-mueller.com",
    "coords": {
      "lat": 49.518768310546875,
      "lng": 9.360329627990723
    }
  },
  {
    "id": "45053_1",
    "name": "Seifert Automobile GmbH",
    "country": "DE",
    "city": "Bad Kissingen",
    "address": "Würzburger Str. 22, 97688 Bad Kissingen",
    "email": "info@bmwservice-seifert.de",
    "phone": "+49-971-69899000",
    "website": "https://www.bmw.de/de/partner/seifert-automobile-bad-kissingen-45053.html",
    "coords": {
      "lat": 50.18429183959961,
      "lng": 10.077862739562988
    }
  },
  {
    "id": "49003_3",
    "name": "Autohaus Euler Mühlheim GmbH Filiale Rödermark",
    "country": "DE",
    "city": "Rödermark",
    "address": "Carl-Zeiss-Str. 8, 63322 Rödermark",
    "email": "info@euler-group.de",
    "phone": "+49-6074-886990",
    "website": "https://www.bmw-euler.de/",
    "coords": {
      "lat": 49.96549606323242,
      "lng": 8.824027061462402
    }
  },
  {
    "id": "38866_1",
    "name": "Proauto GmbH",
    "country": "DE",
    "city": "Langenfeld",
    "address": "Schneiderstr. 9, 40764 Langenfeld",
    "email": "info@proauto-bmw.de",
    "phone": "+49-2173-394950",
    "website": "https://www.bmw.de/de/partner/proauto-langenfeld-38866.html",
    "coords": {
      "lat": 51.119564056396484,
      "lng": 6.97006893157959
    }
  },
  {
    "id": "39322_4",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Giengen/Brenz",
    "address": "Wiesenstraße 9, 89537 Giengen/Brenz",
    "email": "bmw-service-giengen@mulfinger.de",
    "phone": "+49-7322-96390",
    "website": "https://www.mulfinger.bmw",
    "coords": {
      "lat": 48.62031936645508,
      "lng": 10.252881050109863
    }
  },
  {
    "id": "44164_1",
    "name": "Ernst & Lappe GmbH",
    "country": "DE",
    "city": "Essen",
    "address": "St. Annental 115, 45134 Essen",
    "email": "info@bmw-erla.de",
    "phone": "+49-201-7225990",
    "website": "https://bmw-erla.de/",
    "coords": {
      "lat": 51.429100036621094,
      "lng": 7.05413293838501
    }
  },
  {
    "id": "51178_3",
    "name": "Autohaus Krah + Enders GmbH & Co. KG",
    "country": "DE",
    "city": "Idstein",
    "address": "Black & Decker Str. 1-3, 65510 Idstein",
    "email": "info@bmw-krah-enders-idstein.de",
    "phone": "+49-6126-596-0",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.21489715576172,
      "lng": 8.254091262817383
    }
  },
  {
    "id": "52482_1",
    "name": "Raymond Götz GmbH",
    "country": "DE",
    "city": "Hohenbrunn",
    "address": "Georg-Knorr-Str. 6, 85662 Hohenbrunn",
    "email": "info@bmwservice-goetz.de",
    "phone": "+49-8102-999876-0",
    "website": null,
    "coords": {
      "lat": 48.03806686401367,
      "lng": 11.716836929321289
    }
  },
  {
    "id": "53827_2",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Wasserburg am Inn",
    "address": "Staudhamer Feld 5, 83512 Wasserburg am Inn",
    "email": "wasserburg@motorheimat.de",
    "phone": "+49-8071-51000",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 48.06011199951172,
      "lng": 12.174782752990723
    }
  },
  {
    "id": "53827_5",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Oberhaching",
    "address": "Raiffeisenallee 4, 82041 Oberhaching",
    "email": "oberhaching@motorheimat.de",
    "phone": "+49-89-379160970",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 48.03031539916992,
      "lng": 11.582066535949707
    }
  },
  {
    "id": "53827_6",
    "name": "MOTORHEIMAT Wagner-Schwarz GmbH & Co. KG",
    "country": "DE",
    "city": "Oberhaching",
    "address": "Kolpingring 2, 82041 Oberhaching",
    "email": "oberhaching@motorheimat.de",
    "phone": "+49-89-379160990",
    "website": "https://www.motorheimat.de",
    "coords": {
      "lat": 48.03152847290039,
      "lng": 11.584259986877441
    }
  },
  {
    "id": "31253_1",
    "name": "Autohaus Ehrl GmbH Halle Zentrum/SV",
    "country": "DE",
    "city": "Halle (Saale)",
    "address": "Delitzscher Straße 38, 06112 Halle (Saale)",
    "email": "info@bmw-ehrl.com",
    "phone": "+49-345-5164590",
    "website": "https://www.ehrl-gruppe.de",
    "coords": {
      "lat": 51.478790283203125,
      "lng": 11.997236251831055
    }
  },
  {
    "id": "03846_1",
    "name": "Andreas Ehrl Potsdam GmbH & Co. KG",
    "country": "DE",
    "city": "Potsdam",
    "address": "Fritz-Zubeil-Str. 95, 14482 Potsdam",
    "email": "info@bmw-ehrl.de",
    "phone": "+49-331-888888",
    "website": "http://www.bmw-ehrl.de/de/home",
    "coords": {
      "lat": 52.37629318237305,
      "lng": 13.111790657043457
    }
  },
  {
    "id": "00508_1",
    "name": "Autohaus Rolf Horn GmbH",
    "country": "DE",
    "city": "Euskirchen",
    "address": "Eifelring 44-46, 53879 Euskirchen",
    "email": "info@rolfhorn.de",
    "phone": "+49-2251-94510",
    "website": "https://www.rolfhorn.de",
    "coords": {
      "lat": 50.65327072143555,
      "lng": 6.792190074920654
    }
  },
  {
    "id": "00508_4",
    "name": "Autohaus Rolf Horn GmbH",
    "country": "DE",
    "city": "Düren",
    "address": "Bahnstr. 13-15, 52355 Düren",
    "email": "info@rolfhorn.de",
    "phone": "+49-2421-968000",
    "website": "https://www.rolfhorn.de",
    "coords": {
      "lat": 50.78948974609375,
      "lng": 6.467899799346924
    }
  },
  {
    "id": "00863_2",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Ibbenbüren",
    "address": "Rudolf-Diesel-Str. 1-3, 49479 Ibbenbüren",
    "email": "ibbenbueren@bundk.de",
    "phone": "+49-5451-9380",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.260650634765625,
      "lng": 7.7118401527404785
    }
  },
  {
    "id": "01263_3",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Celle",
    "address": "An der Koppel 1, 29227 Celle",
    "email": "celle@bundk.de",
    "phone": "+49-5141-88400",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.5900993347168,
      "lng": 10.066129684448242
    }
  },
  {
    "id": "00863_6",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Vechta",
    "address": "Osloer Str. 3, 49377 Vechta",
    "email": "vec@wellergruppe.de",
    "phone": "+49-4441-88960",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.73042297363281,
      "lng": 8.261343002319336
    }
  },
  {
    "id": "00863_1",
    "name": "WELLER Premium Deutschland GmbH",
    "country": "DE",
    "city": "Melle",
    "address": "Johann-Uttinger-Str. 6-12, 49324 Melle",
    "email": "melle@bundk.de",
    "phone": "+49-5422-9280",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.1953010559082,
      "lng": 8.3430757522583
    }
  },
  {
    "id": "01263_10",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Herford",
    "address": "Goebenstr. 92-100, 32051 Herford",
    "email": "herford@bundk.de",
    "phone": "+49-5221-59750",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.13019561767578,
      "lng": 8.66855239868164
    }
  },
  {
    "id": "01263_21",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Braunschweig",
    "address": "Gifhorner Str. 151, 38112 Braunschweig",
    "email": "info-braunschweig@blockamring.de",
    "phone": "+49-531-21420",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.30109786987305,
      "lng": 10.516812324523926
    }
  },
  {
    "id": "01263_24",
    "name": "WELLER Premium GmbH",
    "country": "DE",
    "city": "Hildesheim",
    "address": "Junkersstr. 2, 31137 Hildesheim",
    "email": "hi@wellergruppe.de",
    "phone": "+49-5121-76000",
    "website": "https://wellergruppe.de/marken/bmw",
    "coords": {
      "lat": 52.17402648925781,
      "lng": 9.945804595947266
    }
  },
  {
    "id": "02712_1",
    "name": "Autohaus Kaltenbach GmbH & Co. KG",
    "country": "DE",
    "city": "Wipperfürth",
    "address": "Obergraben Hämmern 2, 51688 Wipperfürth",
    "email": "info.wipperfuerth@kaltenbach-gruppe.de",
    "phone": "+49-2267-88660",
    "website": "https://kaltenbach-gruppe.de/marken/bmw-markenwelt/",
    "coords": {
      "lat": 51.125465393066406,
      "lng": 7.3605146408081055
    }
  },
  {
    "id": "04746_1",
    "name": "Kohl automobile GmbH",
    "country": "DE",
    "city": "Aachen",
    "address": "Neuenhofstr. 160, 52078 Aachen",
    "email": "info@kohl.de",
    "phone": "+49-241-568800",
    "website": "https://www.kohl.de/bmw",
    "coords": {
      "lat": 50.76639938354492,
      "lng": 6.147130012512207
    }
  },
  {
    "id": "35644_1",
    "name": "mobilforum GmbH",
    "country": "DE",
    "city": "Bischofswerda",
    "address": "Bautzener Str. 113, 01877 Bischofswerda",
    "email": "biw@mobilforum-gruppe.de",
    "phone": "+49-3594-77090",
    "website": "https://mobilforum.de/",
    "coords": {
      "lat": 51.135459899902344,
      "lng": 14.189929962158203
    }
  },
  {
    "id": "37132_1",
    "name": "Autohaus J.B. Lell GmbH",
    "country": "DE",
    "city": "Wunsiedel",
    "address": "Luisenburgstraße 45, 95632 Wunsiedel",
    "email": "info.wun@lell-bmw.de",
    "phone": "+49-9232-99650",
    "website": "http://www.lell.bmw",
    "coords": {
      "lat": 50.03007125854492,
      "lng": 12.000960350036621
    }
  },
  {
    "id": "28041_1",
    "name": "Autohaus Grieb GmbH",
    "country": "DE",
    "city": "Vohenstrauß",
    "address": "Waidhauser Str. 50, 92648 Vohenstrauß",
    "email": "info@autohaus-grieb.de",
    "phone": "+49-9651-92100",
    "website": "https://www.bmw.de/de/partner/autohaus-grieb-vohenstrauss-28041.html",
    "coords": {
      "lat": 49.61906814575195,
      "lng": 12.356369972229004
    }
  },
  {
    "id": "29337_1",
    "name": "Autohaus J. B. Lell",
    "country": "DE",
    "city": "Kümmersbruck",
    "address": "Vilstalstr. 25-29, 92245 Kümmersbruck",
    "email": "info.kb@lell-bmw.de",
    "phone": "+49-9621-77100",
    "website": "http://www.lell.bmw",
    "coords": {
      "lat": 49.425907135009766,
      "lng": 11.874573707580566
    }
  },
  {
    "id": "00911_3",
    "name": "Klaus Scheller GmbH",
    "country": "DE",
    "city": "Ludwigshafen",
    "address": "Ruchheimer Str. 1, 67071 Ludwigshafen",
    "email": "info@bmw-scheller.de",
    "phone": "+49-621-561040",
    "website": "https://www.bmw-scheller.de",
    "coords": {
      "lat": 49.48400115966797,
      "lng": 8.364265441894531
    }
  },
  {
    "id": "02732_1",
    "name": "Autohaus Kainz GmbH & Co. KG Mayen",
    "country": "DE",
    "city": "Kottenheim b. Mayen",
    "address": "August-Horch-Str. 1, 56736 Kottenheim b. Mayen",
    "email": "info.mayen@kainz-gruppe.de",
    "phone": "+49-2651-95890",
    "website": "https://www.autohaus-kainz.de/",
    "coords": {
      "lat": 50.33626937866211,
      "lng": 7.257053852081299
    }
  },
  {
    "id": "01068_1",
    "name": "Autohaus Becker-Tiemann Bielefeld GmbH & Co. KG",
    "country": "DE",
    "city": "Bielefeld",
    "address": "Sprungbachstr. 15-19, 33689 Bielefeld",
    "email": "kontakt@becker-tiemann.de",
    "phone": "+49-5205-96890",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 51.94218444824219,
      "lng": 8.585143089294434
    }
  },
  {
    "id": "01443_4",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Krumbach",
    "address": "Lichtensteinstr. 11, 86381 Krumbach",
    "email": "info@reisacher.de",
    "phone": "+49-8282-89020",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.24874496459961,
      "lng": 10.364431381225586
    }
  },
  {
    "id": "01592_1",
    "name": "Freese Handels-GmbH & Co. KG",
    "country": "DE",
    "city": "Oldenburg",
    "address": "Bremer Heerstr. 261, 26135 Oldenburg",
    "email": "info.kayser@freese-gruppe.de",
    "phone": "+49-441-92060-0",
    "website": "https://www.bmw-freese.de",
    "coords": {
      "lat": 53.120365142822266,
      "lng": 8.255455017089844
    }
  },
  {
    "id": "00139_4",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Betzdorf",
    "address": "Industriestr. 7, 57518 Betzdorf",
    "email": "bmw.betzdorf@wahl-group.de",
    "phone": "+49-2741-92060",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.79966735839844,
      "lng": 7.858088493347168
    }
  },
  {
    "id": "00391_3",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Winnenden",
    "address": "Waiblinger Str. 20, 71364 Winnenden",
    "email": "verkauf.winnenden@mulfinger.de",
    "phone": "+49-7195-1688",
    "website": "https://mulfinger.de/bmw",
    "coords": {
      "lat": 48.87514114379883,
      "lng": 9.393070220947266
    }
  },
  {
    "id": "00737_4",
    "name": "Autohaus Krauth GmbH & Co. KG",
    "country": "DE",
    "city": "Hockenheim",
    "address": "Mannheimer Str. 2, 68766 Hockenheim",
    "email": "info@bmw-krauth.de",
    "phone": "+49-6205-97880",
    "website": "https://www.bmw-krauth.de",
    "coords": {
      "lat": 49.33052062988281,
      "lng": 8.534814834594727
    }
  },
  {
    "id": "00495_2",
    "name": "Autohaus Munding GmbH",
    "country": "DE",
    "city": "Laupheim",
    "address": "Neue Welt 25, 88471 Laupheim",
    "email": "information@bmw-munding.de",
    "phone": "+49-7392-968166",
    "website": "https://www.bmw-munding.de",
    "coords": {
      "lat": 48.2415657043457,
      "lng": 9.866080284118652
    }
  },
  {
    "id": "01822_4",
    "name": "Autohaus Fulda Krah & Enders GmbH",
    "country": "DE",
    "city": "Burghaun",
    "address": "Am Grubener Weg 1, 36151 Burghaun",
    "email": "info@bmw-krah-enders-huenfeld.de",
    "phone": "+49-6652-96370",
    "website": "https://www.autohaus-krah-enders.de/",
    "coords": {
      "lat": 50.695613861083984,
      "lng": 9.750151634216309
    }
  },
  {
    "id": "07315_10",
    "name": "Autosalon Suhl Zw.NL d. AH Matthes GmbH",
    "country": "DE",
    "city": "Suhl",
    "address": "Hubertusstr. 6, 98527 Suhl",
    "email": "info@bmw-matthes.de",
    "phone": "+49-3681-800000",
    "website": "https://www.bmw-matthes.de",
    "coords": {
      "lat": 50.58768081665039,
      "lng": 10.71597957611084
    }
  },
  {
    "id": "23463_4",
    "name": "Autohaus Becker-Tiemann GmbH & Co. KG",
    "country": "DE",
    "city": "Versmold",
    "address": "Rothenfelder Str. 55, 33775 Versmold",
    "email": "versmold@becker-tiemann.de",
    "phone": "+49-5423-9515-0",
    "website": "https://www.bmw-becker-tiemann.de",
    "coords": {
      "lat": 52.051998138427734,
      "lng": 8.15291976928711
    }
  },
  {
    "id": "32929_2",
    "name": "Autohaus Eichhorn Automotive GmbH",
    "country": "DE",
    "city": "Miltenberg",
    "address": "Lassallestr. 9, 63897 Miltenberg",
    "email": "info@auto-eichhorn.de",
    "phone": "+49-9371-40390",
    "website": "https://www.auto-eichhorn.de/",
    "coords": {
      "lat": 49.705631256103516,
      "lng": 9.228594779968262
    }
  },
  {
    "id": "30315_1",
    "name": "Ungeheuer Automobile GmbH",
    "country": "DE",
    "city": "Karlsruhe",
    "address": "Ottostr. 22, 76227 Karlsruhe",
    "email": "info@ungeheuer.de",
    "phone": "+49-721-949304",
    "website": "https://www.ungeheuer-bmw.de",
    "coords": {
      "lat": 48.99674987792969,
      "lng": 8.437271118164062
    }
  },
  {
    "id": "04669_1",
    "name": "Heinrich Weiß GmbH & Co. KG",
    "country": "DE",
    "city": "Otzing",
    "address": "Hauptstr. 4, 94563 Otzing",
    "email": "info@bmw-service-weiss.de",
    "phone": "+49-9931-9828660",
    "website": "https://www.bmw.de/de/partner/heinrich-weiss-otzing-04669.html",
    "coords": {
      "lat": 48.763004302978516,
      "lng": 12.814453125
    }
  },
  {
    "id": "00232_1",
    "name": "Autohaus Muhra GmbH",
    "country": "DE",
    "city": "Oberhausen",
    "address": "Im Erlengrund 1, 46149 Oberhausen",
    "email": "info@bmw-muhra.de",
    "phone": "+49-208-659050",
    "website": "https://www.bmw.de/de/partner/autohaus-muhra-oberhausen-00232.html",
    "coords": {
      "lat": 51.51691818237305,
      "lng": 6.819759845733643
    }
  },
  {
    "id": "07315_6",
    "name": "Autohaus Matthes GmbH",
    "country": "DE",
    "city": "Tiefenort",
    "address": "Mühlheimer Str. 2, 36469 Tiefenort",
    "email": "info@bmw-matthes.de",
    "phone": "+49-3695-69790",
    "website": "https://www.bmw-matthes.de",
    "coords": {
      "lat": 50.825809478759766,
      "lng": 10.161664962768555
    }
  },
  {
    "id": "07814_1",
    "name": "Autohaus Müller Eilenburg GmbH",
    "country": "DE",
    "city": "Eilenburg",
    "address": "Bergstr. 45, 04838 Eilenburg",
    "email": "info@automobile-mueller.info",
    "phone": "+49-3423-651300",
    "website": "https://www.bmw.de/de/partner/autohaus-mueller-eilenburg-07814.html",
    "coords": {
      "lat": 51.457210540771484,
      "lng": 12.615010261535645
    }
  },
  {
    "id": "04553_12",
    "name": "Autohaus Kühnert GmbH & Co. KG",
    "country": "DE",
    "city": "Gera",
    "address": "Peter-Henlein-Str. 1, 07552 Gera",
    "email": "kontakt.kuehnert@bmw-kuehnert.de",
    "phone": "+49-36625-7933-0",
    "website": "https://www.autohaus-kuehnert.de",
    "coords": {
      "lat": 50.90232849121094,
      "lng": 12.103039741516113
    }
  },
  {
    "id": "39322_2",
    "name": "Autohaus Walter Mulfinger GmbH",
    "country": "DE",
    "city": "Essingen",
    "address": "Ferdinand-Porsche-Str. 2, 73457 Essingen",
    "email": "verkauf.essingen@mulfinger.de",
    "phone": "+49-7365-96060",
    "website": "https://www.mulfinger.bmw",
    "coords": {
      "lat": 48.821651458740234,
      "lng": 10.053959846496582
    }
  },
  {
    "id": "00139_3",
    "name": "Alfred Wahl GmbH & Co. KG",
    "country": "DE",
    "city": "Dillenburg",
    "address": "Auf der Langaar 1, 35684 Dillenburg",
    "email": "bmw.dillenburg@wahl-group.de",
    "phone": "+49-2771-81660",
    "website": "https://www.wahl-group.de/bmw",
    "coords": {
      "lat": 50.768070220947266,
      "lng": 8.29125690460205
    }
  },
  {
    "id": "01443_7",
    "name": "Autohaus Reisacher GmbH",
    "country": "DE",
    "city": "Günzburg",
    "address": "Lochfelbenstraße 27, 89312 Günzburg",
    "email": "guenzburg@reisacher.de",
    "phone": "+49-8221-96783-0",
    "website": "https://www.reisacher.de",
    "coords": {
      "lat": 48.46991729736328,
      "lng": 10.2763671875
    }
  },
  {
    "id": "01859_4",
    "name": "Autohaus Erwin Schmidt GmbH & Co. KG",
    "country": "DE",
    "city": "Werne",
    "address": "Fürstenhof 50, 59368 Werne",
    "email": "info.werne@bmw-schmidt.de",
    "phone": "+49-2389-402086",
    "website": "https://www.bmw.de/de/partner/autohaus-erwin-schmidt-werne-26779.html",
    "coords": {
      "lat": 51.66954040527344,
      "lng": 7.633400917053223
    }
  },
  {
    "id": "44822_1",
    "name": "Engelmeier GmbH & Co.KG",
    "country": "DE",
    "city": "Haltern am See",
    "address": "Recklinghäuser Str. 54a, 45721 Haltern am See",
    "email": "info@bmw-engelmeier.de",
    "phone": "+49-2364-92280",
    "website": "https://www.boomers.bmw",
    "coords": {
      "lat": 51.735660552978516,
      "lng": 7.187800884246826
    }
  },
  {
    "id": "00440_4",
    "name": "Adolf Cuntz KG",
    "country": "DE",
    "city": "Weinheim",
    "address": "Lorscher Str. 7, 69469 Weinheim",
    "email": "info@autohaus-cuntz.de",
    "phone": "+49-6201-34022",
    "website": "https://www.autohaus-cuntz.de/",
    "coords": {
      "lat": 49.56336212158203,
      "lng": 8.649014472961426
    }
  },
  {
    "id": "24342_4",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Heide",
    "address": "Süderdamm 2, 25746 Heide",
    "email": "info@mayundolde.de",
    "phone": "+49-481-85630",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 54.19868087768555,
      "lng": 9.124629974365234
    }
  },
  {
    "id": "24342_6",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Kaltenkirchen",
    "address": "Süderstr. 1, 24568 Kaltenkirchen",
    "email": "info@mayundolde.de",
    "phone": "+49-4191-70347-0",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.827518463134766,
      "lng": 9.972530364990234
    }
  },
  {
    "id": "24342_5",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Rendsburg",
    "address": "Büsumer Str. 150, 24768 Rendsburg",
    "email": "info@mayundolde.de",
    "phone": "+49-4331-78210",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 54.32732009887695,
      "lng": 9.619449615478516
    }
  },
  {
    "id": "24342_8",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Stade",
    "address": "Altländer Str. 91, 21680 Stade",
    "email": "info@mayundolde.de",
    "phone": "+49-4141-92000",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.60190963745117,
      "lng": 9.495050430297852
    }
  },
  {
    "id": "24342_9",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Buchholz",
    "address": "Hanomagstr. 25, 21244 Buchholz",
    "email": "info@mayundolde.de",
    "phone": "+49-4181-28900",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.3217887878418,
      "lng": 9.81151008605957
    }
  },
  {
    "id": "24342_12",
    "name": "May & Olde GmbH",
    "country": "DE",
    "city": "Ahrensburg",
    "address": "Beimoorkamp 2, 22926 Ahrensburg",
    "email": "info@mayundolde.de",
    "phone": "+49-4102-207770",
    "website": "https://www.mayundolde.de/bmw",
    "coords": {
      "lat": 53.67885971069336,
      "lng": 10.251239776611328
    }
  },
  {
    "id": "00924_1",
    "name": "Autohaus Pielmeier GmbH & Co. Vertriebs KG",
    "country": "DE",
    "city": "Schrobenhausen",
    "address": "Augsburger Str. 55, 86529 Schrobenhausen",
    "email": "info@pielmeier.com",
    "phone": "+49-8252-88870",
    "website": "https://www.pielmeier.com",
    "coords": {
      "lat": 48.54802703857422,
      "lng": 11.257189750671387
    }
  },
  {
    "id": "03813_2",
    "name": "Autohaus Melkus Chemnitz GmbH",
    "country": "DE",
    "city": "Chemnitz",
    "address": "F.-O.-Schimmel-Str. 31, 09120 Chemnitz",
    "email": "info@bmw-melkus.de",
    "phone": "+49-371-523990",
    "website": "https://autohaus-melkus.de/",
    "coords": {
      "lat": 50.80460739135742,
      "lng": 12.923741340637207
    }
  },
  {
    "id": "00250_37",
    "name": "ahg Autohandelsgesellschaft mbH",
    "country": "DE",
    "city": "Freiburg i. Br.",
    "address": "Hermann-Mitsch-Str. 17, 79108 Freiburg i. Br.",
    "email": "bmw-freiburg@ahg-mobile.de",
    "phone": "+49-761-885040",
    "website": "https://www.ahg-mobile.de/de/bmw",
    "coords": {
      "lat": 48.01424026489258,
      "lng": 7.842299938201904
    }
  },
  {
    "id": "25742_1",
    "name": "Procar Automobile Münsterland GmbH",
    "country": "DE",
    "city": "Münster",
    "address": "Weseler Str. 729-735, 48163 Münster",
    "email": "muenster@bmw-procar.de",
    "phone": "+49-251-971240",
    "website": "https://www.procar-automobile.de",
    "coords": {
      "lat": 51.92496871948242,
      "lng": 7.569368839263916
    }
  },
  {
    "id": "53348_1",
    "name": "ahg Autohandelsgesellschaft mbH GP",
    "country": "DE",
    "city": "Göppingen",
    "address": "Jahnstraße 103, 73037 Göppingen",
    "email": "bmw-goeppingen@ahg-mobile.de",
    "phone": "+49-7161-6292-0",
    "website": "https://ahg.bmw",
    "coords": {
      "lat": 48.69795227050781,
      "lng": 9.662555694580078
    }
  },
  {
    "id": "50070_01",
    "name": "BMW of Loveland",
    "country": "US",
    "city": "Loveland",
    "address": "4150 Byrd Dr, 80538 Loveland",
    "email": null,
    "phone": "9702925200",
    "website": null,
    "coords": {
      "lat": 40.435306549072266,
      "lng": -104.99446868896484
    }
  },
  {
    "id": "42277_01",
    "name": "BMW of Tri-Cities",
    "country": "US",
    "city": "Richland",
    "address": "955 Aaron Dr., 99352 Richland",
    "email": null,
    "phone": "5099439839",
    "website": "https://www.bmwtricities.com",
    "coords": {
      "lat": 46.25992965698242,
      "lng": -119.28070831298828
    }
  },
  {
    "id": "66771_50001",
    "name": "Auto Body Concepts, Independent Certified Collision Repair Center of Circle BMW",
    "country": "US",
    "city": "Asbury Park",
    "address": "1701 Asbury Avenue, 07712 Asbury Park",
    "email": null,
    "phone": "7328970909",
    "website": null,
    "coords": {
      "lat": 40.2239990234375,
      "lng": -74.02651977539062
    }
  },
  {
    "id": "43039_50001",
    "name": "Ray's Carstar Auto Body & Glass, Independent Certified Collision Repair Center of BMW of Waterbury",
    "country": "US",
    "city": "Bristol",
    "address": "137 Terryville Road, 06010 Bristol",
    "email": null,
    "phone": "8605839273",
    "website": null,
    "coords": {
      "lat": 41.6704216003418,
      "lng": -72.97142028808594
    }
  },
  {
    "id": "51008_50001",
    "name": "The Collision Center, Independent Certified Collision Repair Center of BMW of Rockland",
    "country": "US",
    "city": "Rockland",
    "address": "61 Accord Park Drive, 02370 Rockland",
    "email": null,
    "phone": "7812913071",
    "website": null,
    "coords": {
      "lat": 42.16484832763672,
      "lng": -70.88816833496094
    }
  },
  {
    "id": "52682_50001",
    "name": "Towne Body Shop, Independent Certified Collision Repair Center of BMW of Bridgeport",
    "country": "US",
    "city": "Stratford",
    "address": "1298 Stratford Ave, 06615 Stratford",
    "email": null,
    "phone": "2033755288",
    "website": null,
    "coords": {
      "lat": 41.18708038330078,
      "lng": -73.13555145263672
    }
  },
  {
    "id": "30462_50002",
    "name": "Freehold Auto Body, Independent Certified Collision Repair Center of BMW of Freehold",
    "country": "US",
    "city": "Freehold",
    "address": "3411 US Highway 9, 07728 Freehold",
    "email": null,
    "phone": "7324142530",
    "website": null,
    "coords": {
      "lat": 40.224700927734375,
      "lng": -74.26927185058594
    }
  },
  {
    "id": "40800_50002",
    "name": "Depalo and Sons Auto Body, Independent Certified Collision Repair Center of Habberstad BMW",
    "country": "US",
    "city": "Huntington",
    "address": "25 New York Avenue, 11743 Huntington",
    "email": null,
    "phone": "6314232950",
    "website": null,
    "coords": {
      "lat": 40.8820915222168,
      "lng": -73.4200668334961
    }
  },
  {
    "id": "56738_50002",
    "name": "Straightline Collision, Independent Certified Collision Repair Center of Open Road BMW",
    "country": "US",
    "city": "Staten Island",
    "address": "2912 Arthur Kill Road, 10309 Staten Island",
    "email": null,
    "phone": "7189668900",
    "website": null,
    "coords": {
      "lat": 40.54658889770508,
      "lng": -74.22888946533203
    }
  },
  {
    "id": "20989_50001",
    "name": "Woodcock Auto Body, Independent Certified Collision Repair Center of Orange County BMW",
    "country": "US",
    "city": "Washingtonville",
    "address": "71 Woodcock Mountain Road, 10992 Washingtonville",
    "email": null,
    "phone": "8454967598",
    "website": null,
    "coords": {
      "lat": 41.415863037109375,
      "lng": -74.15674591064453
    }
  },
  {
    "id": "20648_50001",
    "name": "Hendrick Collision at Mall of Georgia, Independent Certified Collision Repair Center of BMW of Gwinnett Place",
    "country": "US",
    "city": "Buford",
    "address": "4641 Harrison Run, 30518 Buford",
    "email": null,
    "phone": "9432022100",
    "website": null,
    "coords": {
      "lat": 34.10197067260742,
      "lng": -84.0186767578125
    }
  },
  {
    "id": "75784_4",
    "name": "BMW of Fort Lauderdale, Certified Collision Repair Center",
    "country": "US",
    "city": "Fort Lauderdale",
    "address": "900 N Andrews Ave, 33311 Fort Lauderdale",
    "email": null,
    "phone": "9549263590",
    "website": null,
    "coords": {
      "lat": 26.13572883605957,
      "lng": -80.14411926269531
    }
  },
  {
    "id": "66788_2",
    "name": "Hendrick BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Concord",
    "address": "7300 Weddington Road, 28027 Concord",
    "email": null,
    "phone": "7043793100",
    "website": null,
    "coords": {
      "lat": 35.37937927246094,
      "lng": -80.69927978515625
    }
  },
  {
    "id": "50948_2",
    "name": "BMW of Rockville, Certified Collision Repair Center",
    "country": "US",
    "city": "Rockville",
    "address": "5812 Wicomico Ave, 20852 Rockville",
    "email": null,
    "phone": "3019848480",
    "website": null,
    "coords": {
      "lat": 39.060245513916016,
      "lng": -77.11751556396484
    }
  },
  {
    "id": "26725_50002",
    "name": "Opeka Auto Repair - Upper St Clair, Independent Certified Collision Repair Center of Bobby Rahal BMW of South Hills",
    "country": "US",
    "city": "Pittsburgh",
    "address": "1403 Mclaughlin Road, 15241 Pittsburgh",
    "email": null,
    "phone": "4122570960",
    "website": null,
    "coords": {
      "lat": 40.35580062866211,
      "lng": -80.08979797363281
    }
  },
  {
    "id": "49134_1",
    "name": "Ferman BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Clearwater",
    "address": "24825 US Highway 19N, 33763 Clearwater",
    "email": null,
    "phone": "7277972277",
    "website": null,
    "coords": {
      "lat": 27.99859046936035,
      "lng": -82.72840118408203
    }
  },
  {
    "id": "56779_50001",
    "name": "Supreme Auto Collision, Independent Certified Collision Repair Center of Germain BMW of Naples",
    "country": "US",
    "city": "Naples",
    "address": "938 4th Avenue North, 34102 Naples",
    "email": null,
    "phone": "2392620405",
    "website": null,
    "coords": {
      "lat": 26.151506423950195,
      "lng": -81.79559326171875
    }
  },
  {
    "id": "46615_50001",
    "name": "Achbach Auto Industries, Independent Certified Collision Repair Center of Kelly BMW",
    "country": "US",
    "city": "Westerville",
    "address": "3476 E. Dublin Granville Rd, 43081 Westerville",
    "email": null,
    "phone": "6148905099",
    "website": null,
    "coords": {
      "lat": 40.080039978027344,
      "lng": -82.92858123779297
    }
  },
  {
    "id": "51049_50002",
    "name": "AutoMark Collision Center, Independent Certified Collision Repair Center of BMW of Farmington Hills",
    "country": "US",
    "city": "Farmington Hills",
    "address": "24750 North Industrial Dr, 48335 Farmington Hills",
    "email": null,
    "phone": "2484738100",
    "website": null,
    "coords": {
      "lat": 42.473663330078125,
      "lng": -83.42483520507812
    }
  },
  {
    "id": "46389_1",
    "name": "Basney BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "South Bend",
    "address": "52203 State Rd 933, 46637 South Bend",
    "email": null,
    "phone": "5742714945",
    "website": null,
    "coords": {
      "lat": 41.73457336425781,
      "lng": -86.25129699707031
    }
  },
  {
    "id": "86302_3",
    "name": "Enterprise BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Appleton",
    "address": "3023 N Victory Ln #102, 54913 Appleton",
    "email": null,
    "phone": "9207493232",
    "website": null,
    "coords": {
      "lat": 44.289520263671875,
      "lng": -88.4732894897461
    }
  },
  {
    "id": "36639_1",
    "name": "D-Patrick Motoplex, Certified Collision Repair Center",
    "country": "US",
    "city": "Evansville",
    "address": "200 N Green River Road, 47715 Evansville",
    "email": null,
    "phone": "8124736530",
    "website": null,
    "coords": {
      "lat": 37.978187561035156,
      "lng": -87.4931869506836
    }
  },
  {
    "id": "86716_50001",
    "name": "Body Builders Automotive, Independent Certified Collision Repair Center of Patrick BMW",
    "country": "US",
    "city": "Rolling Meadows",
    "address": "3737 Industrial Avenue, 60008 Rolling Meadows",
    "email": null,
    "phone": "8476708383",
    "website": null,
    "coords": {
      "lat": 42.0955696105957,
      "lng": -88.02925872802734
    }
  },
  {
    "id": "39797_50002",
    "name": "Kallemyn Collision, Independent Certified Collision Repair Center of BMW of Orland Park",
    "country": "US",
    "city": "Lemont",
    "address": "16039 New Ave, 60439 Lemont",
    "email": null,
    "phone": "6302572277",
    "website": null,
    "coords": {
      "lat": 41.6727294921875,
      "lng": -88.01087951660156
    }
  },
  {
    "id": "35121_50001",
    "name": "Abra Auto Body Repair of America North, Independent Certified Collision Repair Center of BMW of Sioux Falls",
    "country": "US",
    "city": "Sioux Falls",
    "address": "201 Carolyn Ave, 57107 Sioux Falls",
    "email": null,
    "phone": "6053619618",
    "website": null,
    "coords": {
      "lat": 43.54668045043945,
      "lng": -96.77699279785156
    }
  },
  {
    "id": "26731_50002",
    "name": "Solow Garage, Independent Certified Collision Repair Center of BMW of Dallas",
    "country": "US",
    "city": "Richardson",
    "address": "409 N Interurban St, 75081 Richardson",
    "email": null,
    "phone": "4053885001",
    "website": null,
    "coords": {
      "lat": 32.95478820800781,
      "lng": -96.72940826416016
    }
  },
  {
    "id": "52309_50001",
    "name": "Carlsbad Collision Center, Independent Certified Collision Repair Center of BMW of Carlsbad",
    "country": "US",
    "city": "Carlsbad",
    "address": "6030 Avenida Encinas Ste C, 92011 Carlsbad",
    "email": null,
    "phone": "7604761027",
    "website": null,
    "coords": {
      "lat": 33.119041442871094,
      "lng": -117.32372283935547
    }
  },
  {
    "id": "86846_50002",
    "name": "Premier Coach Auto Collision - Thousand Oaks, Independent Certified Collision Repair Center of Rusnak BMW",
    "country": "US",
    "city": "Thousand Oaks",
    "address": "3053 Los Feliz Dr., 91362 Thousand Oaks",
    "email": null,
    "phone": "8053737366",
    "website": null,
    "coords": {
      "lat": 34.17144012451172,
      "lng": -118.8344497680664
    }
  },
  {
    "id": "51458_2",
    "name": "BMW of Escondido, Certified Collision Repair Center",
    "country": "US",
    "city": "Escondido",
    "address": "240 S Andreasen Dr, 92029 Escondido",
    "email": null,
    "phone": "4422485167",
    "website": null,
    "coords": {
      "lat": 33.11763000488281,
      "lng": -117.10945129394531
    }
  },
  {
    "id": "36721_50003",
    "name": "SSR Auto Body, Independent Certified Collision Repair Center of Crevier BMW",
    "country": "US",
    "city": "Orange",
    "address": "590 West Freedom Avenue, 92865 Orange",
    "email": null,
    "phone": "9495777904",
    "website": null,
    "coords": {
      "lat": 33.827110290527344,
      "lng": -117.85836029052734
    }
  },
  {
    "id": "52781_50001",
    "name": "Premier Coach Auto Collision - Camarillo, Independent Certified Collision Repair Center of BMW of Camarillo",
    "country": "US",
    "city": "Camarillo",
    "address": "852 Via Alondro, 93012 Camarillo",
    "email": null,
    "phone": "8053899574",
    "website": null,
    "coords": {
      "lat": 34.22609329223633,
      "lng": -119.02212524414062
    }
  },
  {
    "id": "22083_50002",
    "name": "Caliber Collision Santa Clara, Independent Certified Collision Repair Center of Stevens Creek BMW",
    "country": "US",
    "city": "Santa Clara",
    "address": "3165 De La Cruz Blvd, 95054 Santa Clara",
    "email": null,
    "phone": "4083434035",
    "website": null,
    "coords": {
      "lat": 37.36650848388672,
      "lng": -121.94503021240234
    }
  },
  {
    "id": "49544_50001",
    "name": "JP Auto Body Shop, Independent Certified Collision Repair Center of BMW of San Francisco",
    "country": "US",
    "city": "South San Francisco",
    "address": "112 S Linden Ave, 94080 South San Francisco",
    "email": null,
    "phone": "6508779777",
    "website": null,
    "coords": {
      "lat": 37.645999908447266,
      "lng": -122.41374206542969
    }
  },
  {
    "id": "36021_2",
    "name": "BMW of Tigard, Certified Collision Repair Center",
    "country": "US",
    "city": "Beaverton",
    "address": "3725 SW Cedar Hills Blvd, 97005 Beaverton",
    "email": null,
    "phone": "5033727563",
    "website": null,
    "coords": {
      "lat": 45.492950439453125,
      "lng": -122.812255859375
    }
  },
  {
    "id": "10732_2",
    "name": "BMW of Bellevue, Certified Collision Repair Center",
    "country": "US",
    "city": "Bellevue",
    "address": "1424 130th Ave NE, 98005 Bellevue",
    "email": null,
    "phone": "8558679498",
    "website": null,
    "coords": {
      "lat": 47.62360382080078,
      "lng": -122.16635131835938
    }
  },
  {
    "id": "36688_03",
    "name": "Newbold BMW",
    "country": "US",
    "city": "O Fallon",
    "address": "1283 Central Park Dr., 62269 O Fallon",
    "email": null,
    "phone": "6186287300",
    "website": null,
    "coords": {
      "lat": 38.584590911865234,
      "lng": -89.94071197509766
    }
  },
  {
    "id": "76731_04",
    "name": "BMW Service Kapolei",
    "country": "US",
    "city": "Kapolei",
    "address": "367 Farrington Highway, Unit 5A, 96707 Kapolei",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 21.334165573120117,
      "lng": -158.08665466308594
    }
  },
  {
    "id": "31026_2",
    "name": "Herb Chambers Collision Center of Holliston",
    "country": "US",
    "city": "Holliston",
    "address": "60 October Hill Road, 01746 Holliston",
    "email": null,
    "phone": "5088818080",
    "website": null,
    "coords": {
      "lat": 42.23013687133789,
      "lng": -71.42656707763672
    }
  },
  {
    "id": "69000_50001",
    "name": "Keri Coachworks, Independent Certified Collision Repair Center of Rallye BMW",
    "country": "US",
    "city": "Westbury",
    "address": "15 Urban Ave, 11590 Westbury",
    "email": null,
    "phone": "5169978400",
    "website": null,
    "coords": {
      "lat": 40.75447463989258,
      "lng": -73.56304168701172
    }
  },
  {
    "id": "40808_50002",
    "name": "Frank & Son Autobody, Independent Certified Collision Repair Center of BMW of Greenwich",
    "country": "US",
    "city": "Bronx",
    "address": "1530 Stillwell Ave #B, 10461 Bronx",
    "email": null,
    "phone": "7188226726",
    "website": null,
    "coords": {
      "lat": 40.853668212890625,
      "lng": -73.8425521850586
    }
  },
  {
    "id": "34753_1",
    "name": "BMW of Reading, Certified Collision Repair Center",
    "country": "US",
    "city": "Reading",
    "address": "420 Gregg Ave, 19611 Reading",
    "email": null,
    "phone": "6103759991",
    "website": null,
    "coords": {
      "lat": 40.32098388671875,
      "lng": -75.93612670898438
    }
  },
  {
    "id": "52264_50001",
    "name": "BrandyWine Coachworks, Independent Certified Collision Repair Center of BMW of West Chester",
    "country": "US",
    "city": "Chadds Ford",
    "address": "1209 Baltimore Pike, 19317 Chadds Ford",
    "email": null,
    "phone": "6104598860",
    "website": null,
    "coords": {
      "lat": 39.88111114501953,
      "lng": -75.54966735839844
    }
  },
  {
    "id": "40713_50001",
    "name": "Cavallo Auto Body, Independent Certified Collision Repair Center of BMW of Devon",
    "country": "US",
    "city": "Newtown Square",
    "address": "18 S Newtown Street Rd, 19073 Newtown Square",
    "email": null,
    "phone": "6103533300",
    "website": null,
    "coords": {
      "lat": 39.98556137084961,
      "lng": -75.39994049072266
    }
  },
  {
    "id": "15673_3",
    "name": "Moses BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "St Albans",
    "address": "2001 Macorkle Ave, 25177 St Albans",
    "email": null,
    "phone": "3047224900",
    "website": null,
    "coords": {
      "lat": 38.38623809814453,
      "lng": -81.81375885009766
    }
  },
  {
    "id": "46826_2",
    "name": "Rick Hendrick BMW Charleston, Certified Collision Repair Center",
    "country": "US",
    "city": "Charleston",
    "address": "1535B  Savannah Hwy, 29407 Charleston",
    "email": null,
    "phone": "8434026644",
    "website": null,
    "coords": {
      "lat": 32.78464889526367,
      "lng": -80.00800323486328
    }
  },
  {
    "id": "26338_3",
    "name": "BMW of Southpoint, Certified Collision Repair Center",
    "country": "US",
    "city": "Cary",
    "address": "121 Team Hendrick Way, 27511 Cary",
    "email": null,
    "phone": "9194621277",
    "website": null,
    "coords": {
      "lat": 35.73793029785156,
      "lng": -78.8173828125
    }
  },
  {
    "id": "26338_2",
    "name": "BMW of Southpoint, Certified Collision Repair Center",
    "country": "US",
    "city": "Durham",
    "address": "1606 Page Road Extension, 27703 Durham",
    "email": null,
    "phone": "9199423191",
    "website": null,
    "coords": {
      "lat": 35.931278228759766,
      "lng": -78.81157684326172
    }
  },
  {
    "id": "36322_50001",
    "name": "Kendrick Body & Paint, Independent Certified Collision Repair Center of Taylor BMW",
    "country": "US",
    "city": "Augusta",
    "address": "1333 Broad St, 30901 Augusta",
    "email": null,
    "phone": "7067244071",
    "website": null,
    "coords": {
      "lat": 33.47951889038086,
      "lng": -81.9767074584961
    }
  },
  {
    "id": "20648_3",
    "name": "BMW of Gwinnett Place, Certified Collision Repair Center",
    "country": "US",
    "city": "Duluth",
    "address": "3150 Steve Reynolds Blvd, 30096 Duluth",
    "email": null,
    "phone": "7706227986",
    "website": null,
    "coords": {
      "lat": 33.95969772338867,
      "lng": -84.14070129394531
    }
  },
  {
    "id": "26715_2",
    "name": "Nalley BMW of Decatur, Certified Collision Repair Center",
    "country": "US",
    "city": "Atlanta",
    "address": "2500 The Nalley Way, 30341 Atlanta",
    "email": null,
    "phone": "7704545999",
    "website": null,
    "coords": {
      "lat": 33.925785064697266,
      "lng": -84.28053283691406
    }
  },
  {
    "id": "32147_50001",
    "name": "Sarasota Bodyworx, Independent Certified Collision Repair Center of BMW of Sarasota",
    "country": "US",
    "city": "Sarasota",
    "address": "4883 Clark Rd, 34233 Sarasota",
    "email": null,
    "phone": "9419243040",
    "website": null,
    "coords": {
      "lat": 27.272140502929688,
      "lng": -82.47142791748047
    }
  },
  {
    "id": "39797_50001",
    "name": "Crash Champions, Independent Certified Collision Repair Center of BMW of Orland Park",
    "country": "US",
    "city": "Mokena",
    "address": "8910 W 191st Street, 60448 Mokena",
    "email": null,
    "phone": "7084794321",
    "website": null,
    "coords": {
      "lat": 41.543861389160156,
      "lng": -87.83492279052734
    }
  },
  {
    "id": "20412_50001",
    "name": "Roslund's Paint & Body, Independent Certified Collision Repair Center of BMW of Tallahassee",
    "country": "US",
    "city": "Tallahassee",
    "address": "3138 West Tharpe St, 32303 Tallahassee",
    "email": null,
    "phone": "8505803499",
    "website": null,
    "coords": {
      "lat": 30.46470069885254,
      "lng": -84.35265350341797
    }
  },
  {
    "id": "46222_50001",
    "name": "Quality Body Shop, Independent Certified Collision Repair Center of BMW of Akron",
    "country": "US",
    "city": "Akron",
    "address": "878 W Bowery St, 44307 Akron",
    "email": null,
    "phone": "3303765121",
    "website": null,
    "coords": {
      "lat": 41.06517028808594,
      "lng": -81.53970336914062
    }
  },
  {
    "id": "34748_50002",
    "name": "Automotive Super Sports, Independent Certified Collision Repair Center of BMW of Gainesville",
    "country": "US",
    "city": "Gainesville",
    "address": "3001 NE 21st Way, 32609 Gainesville",
    "email": null,
    "phone": "3523799111",
    "website": null,
    "coords": {
      "lat": 29.680110931396484,
      "lng": -82.29486083984375
    }
  },
  {
    "id": "56843_1",
    "name": "BMW of Lafayette, Certified Collision Repair Center",
    "country": "US",
    "city": "Lafayette",
    "address": "320 Sagamore Pkwy S, 47905 Lafayette",
    "email": null,
    "phone": "7653479788",
    "website": null,
    "coords": {
      "lat": 40.41256332397461,
      "lng": -86.85863494873047
    }
  },
  {
    "id": "56892_50001",
    "name": "Wallace Collision Center, Independent Certified Collision Repair Center of Rick Hill BMW",
    "country": "US",
    "city": "Bristol",
    "address": "1625 Bluff City Highway, 37620 Bristol",
    "email": null,
    "phone": "4237641145",
    "website": null,
    "coords": {
      "lat": 36.5536994934082,
      "lng": -82.21733093261719
    }
  },
  {
    "id": "96628_1",
    "name": "Fields BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Glenview",
    "address": "2015 Chestnut Ave, 60025 Glenview",
    "email": null,
    "phone": "8479980680",
    "website": null,
    "coords": {
      "lat": 42.08666229248047,
      "lng": -87.80933380126953
    }
  },
  {
    "id": "95801_50001",
    "name": "Highway Auto Center, Independent Certified Collision Repair Center of BMW Cleveland",
    "country": "US",
    "city": "Chagrin Falls",
    "address": "8410 East Washington St, 44023 Chagrin Falls",
    "email": null,
    "phone": "4407080600",
    "website": null,
    "coords": {
      "lat": 41.41434860229492,
      "lng": -81.34156036376953
    }
  },
  {
    "id": "22819_1",
    "name": "BMW of Macon, Certified Collision Repair Center",
    "country": "US",
    "city": "Macon",
    "address": "1500 Hall road, 31210 Macon",
    "email": null,
    "phone": "4787840601",
    "website": null,
    "coords": {
      "lat": 32.912269592285156,
      "lng": -83.70793914794922
    }
  },
  {
    "id": "46786_2",
    "name": "Perillo BMW, Inc., Certified Collision Repair Center",
    "country": "US",
    "city": "Chicago",
    "address": "681 N. Green Street, 60642 Chicago",
    "email": null,
    "phone": "3122917342",
    "website": null,
    "coords": {
      "lat": 41.89482879638672,
      "lng": -87.6480712890625
    }
  },
  {
    "id": "34883_50001",
    "name": "Tom and Eds Auto Body, Independent Certified Collision Repair Center of BMW of Schererville",
    "country": "US",
    "city": "Schererville",
    "address": "1225 Birch Drive, 46375 Schererville",
    "email": null,
    "phone": "2193225220",
    "website": null,
    "coords": {
      "lat": 41.50101852416992,
      "lng": -87.47068786621094
    }
  },
  {
    "id": "36688_50001",
    "name": "Schaefer Autobody O'Fallon, Independent Certified Collision Repair Center of Newbold BMW",
    "country": "US",
    "city": "O'Fallon",
    "address": "1290 Central Park Dr, 62269 O'Fallon",
    "email": null,
    "phone": "6185897213",
    "website": null,
    "coords": {
      "lat": 38.58689880371094,
      "lng": -89.94122314453125
    }
  },
  {
    "id": "26701_50001",
    "name": "Frank's Collision Center, Independent Certified Collision Repair Center of BMW of Columbus",
    "country": "US",
    "city": "Columbus",
    "address": "4754 Wam Springs Rd, 31909 Columbus",
    "email": null,
    "phone": "7065657171",
    "website": null,
    "coords": {
      "lat": 32.52628707885742,
      "lng": -84.9134292602539
    }
  },
  {
    "id": "52800_3",
    "name": "Karl Knauz Motors, Certified Collision Repair Center",
    "country": "US",
    "city": "Lake Bluff",
    "address": "407 Stokie Highway, 60044 Lake Bluff",
    "email": null,
    "phone": "8476045000",
    "website": null,
    "coords": {
      "lat": 42.27968215942383,
      "lng": -87.8542709350586
    }
  },
  {
    "id": "43775_1",
    "name": "BMW of West Houston, Certified Collision Repair Center",
    "country": "US",
    "city": "Houston",
    "address": "11811 Katy Fwy, 77079 Houston",
    "email": null,
    "phone": "8777550432",
    "website": null,
    "coords": {
      "lat": 29.783519744873047,
      "lng": -95.59512329101562
    }
  },
  {
    "id": "43775_50002",
    "name": "Expro Collision, Independent Certified Collision Repair Center of BMW of West Houston",
    "country": "US",
    "city": "Houston",
    "address": "910 Hwy 6 S, 77079 Houston",
    "email": null,
    "phone": "2815989776",
    "website": null,
    "coords": {
      "lat": 29.771869659423828,
      "lng": -95.64311981201172
    }
  },
  {
    "id": "51029_1",
    "name": "BMW of Clear Lake, Certified Collision Repair Center",
    "country": "US",
    "city": "Friendswood",
    "address": "18160B Gulf Freeway, 77546 Friendswood",
    "email": null,
    "phone": "8774936232",
    "website": null,
    "coords": {
      "lat": 29.556167602539062,
      "lng": -95.15823364257812
    }
  },
  {
    "id": "26747_1",
    "name": "Momentum BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Houston",
    "address": "9911 Centre Pkwy, 77036 Houston",
    "email": null,
    "phone": "8883078193",
    "website": null,
    "coords": {
      "lat": 29.672409057617188,
      "lng": -95.55017852783203
    }
  },
  {
    "id": "52685_3",
    "name": "BMW of Downtown Los Angeles, Certified Collision Repair Center",
    "country": "US",
    "city": "Huntington Park",
    "address": "6000 S Alameda St., 90255 Huntington Park",
    "email": null,
    "phone": "3235831901",
    "website": null,
    "coords": {
      "lat": 33.98694610595703,
      "lng": -118.2369384765625
    }
  },
  {
    "id": "47724_50004",
    "name": "All City Coachcraft, Independent Certified Collision Repair Center of BMW of Sherman Oaks",
    "country": "US",
    "city": "Van Nuys",
    "address": "7745 Sepulveda Blvd, 91405 Van Nuys",
    "email": null,
    "phone": "8189946400",
    "website": null,
    "coords": {
      "lat": 34.211631774902344,
      "lng": -118.46637725830078
    }
  },
  {
    "id": "31642_50001",
    "name": "AW Collision of Monrovia, Independent Certified Collision Repair Center of BMW of Monrovia",
    "country": "US",
    "city": "Monrovia",
    "address": "1875 Mountain Ave, 91016 Monrovia",
    "email": null,
    "phone": "6264080300",
    "website": null,
    "coords": {
      "lat": 34.13002395629883,
      "lng": -117.98760223388672
    }
  },
  {
    "id": "21188_50002",
    "name": "Spectrum Collision Center, Independent Certified Collision Repair Center of Irvine BMW",
    "country": "US",
    "city": "Irvine",
    "address": "20 McLaren, 92618 Irvine",
    "email": null,
    "phone": "9495813702",
    "website": null,
    "coords": {
      "lat": 33.63578796386719,
      "lng": -117.71762084960938
    }
  },
  {
    "id": "40335_50001",
    "name": "Ben Clymer's The Bodyshop, Independent Certified Collision Repair Center of BMW of Riverside",
    "country": "US",
    "city": "Moreno Valley",
    "address": "22335 Alessandro Blvd, 92553 Moreno Valley",
    "email": null,
    "phone": "9516569100",
    "website": null,
    "coords": {
      "lat": 33.91688919067383,
      "lng": -117.27271270751953
    }
  },
  {
    "id": "30822_50002",
    "name": "Monterey Auto Body, Independent Certified Collision Repair Center of BMW of Monterey",
    "country": "US",
    "city": "Monterey",
    "address": "1231 Del Monte Ave, 93940 Monterey",
    "email": null,
    "phone": "8883229505",
    "website": null,
    "coords": {
      "lat": 36.60029983520508,
      "lng": -121.87944793701172
    }
  },
  {
    "id": "04618_1",
    "name": "Niello BMW Sacramento, Certified Collision Repair Center",
    "country": "US",
    "city": "Sacramento",
    "address": "2625 Arden Way, 95825 Sacramento",
    "email": null,
    "phone": "9164819735",
    "website": null,
    "coords": {
      "lat": 38.5963020324707,
      "lng": -121.40040588378906
    }
  },
  {
    "id": "04618_50001",
    "name": "Kniesels Collision - Power Inn, Independent Certified Collision Repair Center of Niello BMW Sacramento",
    "country": "US",
    "city": "Sacramento",
    "address": "6211 Power Inn Road, 95824 Sacramento",
    "email": null,
    "phone": "9163817964",
    "website": null,
    "coords": {
      "lat": 38.51380157470703,
      "lng": -121.40859985351562
    }
  },
  {
    "id": "42367_1",
    "name": "BMW of Chico, Certified Collision Repair Center",
    "country": "US",
    "city": "CHICO",
    "address": "13330 Garner Ln, 95973 CHICO",
    "email": null,
    "phone": "5303459444",
    "website": null,
    "coords": {
      "lat": 39.762474060058594,
      "lng": -121.84300231933594
    }
  },
  {
    "id": "54280_01",
    "name": "BMW of Sewickley",
    "country": "US",
    "city": "Sewickley",
    "address": "119 Kramer Street, 15143 Sewickley",
    "email": null,
    "phone": "4127416400",
    "website": null,
    "coords": {
      "lat": 40.535499572753906,
      "lng": -80.18473815917969
    }
  },
  {
    "id": "53086_01",
    "name": "BMW of Coconut Creek",
    "country": "US",
    "city": "Coconut Creek",
    "address": "4401 W Sample Rd, 33073 Coconut Creek",
    "email": null,
    "phone": "9549352700",
    "website": null,
    "coords": {
      "lat": 26.274024963378906,
      "lng": -80.18431854248047
    }
  },
  {
    "id": "45332_01",
    "name": "BMW of Eugene",
    "country": "US",
    "city": "Eugene",
    "address": "2100 Martin Luther King Jr. Blvd., 97401 Eugene",
    "email": null,
    "phone": "5413421763",
    "website": "https://bmwofeugene.com",
    "coords": {
      "lat": 44.059566497802734,
      "lng": -123.07914733886719
    }
  },
  {
    "id": "10699_50001",
    "name": "Todays Collision, Independent Certified Collision Repair Center of BMW of Peabody",
    "country": "US",
    "city": "Danvers",
    "address": "151 Andover Street, 01923 Danvers",
    "email": null,
    "phone": "9786247911",
    "website": null,
    "coords": {
      "lat": 42.558929443359375,
      "lng": -70.97026824951172
    }
  },
  {
    "id": "51085_2",
    "name": "BMW of Ridgefield, Certified Collision Repair Center",
    "country": "US",
    "city": "Ridgefield",
    "address": "721 Danbury Road, 06877 Ridgefield",
    "email": null,
    "phone": "2032442881",
    "website": null,
    "coords": {
      "lat": 41.32952880859375,
      "lng": -73.47396850585938
    }
  },
  {
    "id": "41518_50001",
    "name": "Mid Island Collision, Independent Certified Collision Repair Center of BMW of Freeport",
    "country": "US",
    "city": "Rockville Centre",
    "address": "20 Lakeview Ave, 11570 Rockville Centre",
    "email": null,
    "phone": "5167660101",
    "website": null,
    "coords": {
      "lat": 40.6684684753418,
      "lng": -73.65556335449219
    }
  },
  {
    "id": "30374_50001",
    "name": "Moppert Bros Collision Center, Independent Certified Collision Repair Center of BMW of Atlantic City",
    "country": "US",
    "city": "Northfield",
    "address": "231 Tilton Rd, 08225 Northfield",
    "email": null,
    "phone": "6093802988",
    "website": null,
    "coords": {
      "lat": 39.38869857788086,
      "lng": -74.55760192871094
    }
  },
  {
    "id": "30462_50004",
    "name": "County Line Auto Body, Independent Certified Collision Repair Center of BMW of Freehold",
    "country": "US",
    "city": "Howell",
    "address": "278 Alexander Avenue, 07731 Howell",
    "email": null,
    "phone": "7323635904",
    "website": null,
    "coords": {
      "lat": 40.11492919921875,
      "lng": -74.21199798583984
    }
  },
  {
    "id": "21295_2",
    "name": "BMW of Turnersville, Certified Collision Repair Center",
    "country": "US",
    "city": "Turnersville",
    "address": "3400-H Route 42, 08012 Turnersville",
    "email": null,
    "phone": "8563470900",
    "website": null,
    "coords": {
      "lat": 39.729705810546875,
      "lng": -75.02999877929688
    }
  },
  {
    "id": "26700_2",
    "name": "Sun Motor Cars BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Mechanicsburg",
    "address": "6681 Carlisle Pike, 17050 Mechanicsburg",
    "email": null,
    "phone": "7176972300",
    "website": null,
    "coords": {
      "lat": 40.240562438964844,
      "lng": -77.04923248291016
    }
  },
  {
    "id": "36640_50001",
    "name": "Cavallo Auto Body, Independent Certified Collision Repair Center of BMW of the Main Line",
    "country": "US",
    "city": "Drexel Hill",
    "address": "187 Burmont Rd, 19026 Drexel Hill",
    "email": null,
    "phone": "6106221111",
    "website": null,
    "coords": {
      "lat": 39.93838119506836,
      "lng": -75.29122924804688
    }
  },
  {
    "id": "22800_50001",
    "name": "South Shore Auto Collision, Independent Certified Collision Repair Center of Competition BMW of Smithtown",
    "country": "US",
    "city": "Manorville",
    "address": "624 North St, 11949 Manorville",
    "email": null,
    "phone": "6319241560",
    "website": null,
    "coords": {
      "lat": 40.83536911010742,
      "lng": -72.86456298828125
    }
  },
  {
    "id": "22800_50002",
    "name": "Sal's Auto Body, Independent Certified Collision Repair Center of Competition BMW of Smithtown",
    "country": "US",
    "city": "St James",
    "address": "644 Middle Country Rd, 11780 St James",
    "email": null,
    "phone": "6312659029",
    "website": null,
    "coords": {
      "lat": 40.859336853027344,
      "lng": -73.15573120117188
    }
  },
  {
    "id": "34520_1",
    "name": "BMW of Rochester, Certified Collision Repair Center",
    "country": "US",
    "city": "Rochester",
    "address": "4545 Ridge Rd West, 14626 Rochester",
    "email": null,
    "phone": "5853521200",
    "website": null,
    "coords": {
      "lat": 43.216976165771484,
      "lng": -77.74980163574219
    }
  },
  {
    "id": "22006_2",
    "name": "BMW of Fairfax, Certified Collision Repair Center",
    "country": "US",
    "city": "Fairfax",
    "address": "8439 Lee Highway, 22031 Fairfax",
    "email": null,
    "phone": "7036988161",
    "website": null,
    "coords": {
      "lat": 38.872615814208984,
      "lng": -77.23883056640625
    }
  },
  {
    "id": "96255_2",
    "name": "Fields BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Orlando",
    "address": "4429 N John Young Pkwy, 32804 Orlando",
    "email": null,
    "phone": "4075215882",
    "website": null,
    "coords": {
      "lat": 28.593252182006836,
      "lng": -81.41829681396484
    }
  },
  {
    "id": "75784_2",
    "name": "BMW of Fort Lauderdale, Certified Collision Repair Center",
    "country": "US",
    "city": "Pembroke Pines",
    "address": "14800 Sheridan St, 33331 Pembroke Pines",
    "email": null,
    "phone": "9545058674",
    "website": null,
    "coords": {
      "lat": 26.028650283813477,
      "lng": -80.34587860107422
    }
  },
  {
    "id": "96499_50001",
    "name": "DCR Systems, Independent Certified Collision Repair Center of Classic BMW",
    "country": "US",
    "city": "Mentor",
    "address": "8697 Tyler Blvd, 44060 Mentor",
    "email": null,
    "phone": "4402059900",
    "website": null,
    "coords": {
      "lat": 41.689918518066406,
      "lng": -81.32755279541016
    }
  },
  {
    "id": "43872_2",
    "name": "BMW of Milwaukee North, Certified Collision Repair Center",
    "country": "US",
    "city": "Milwaukee",
    "address": "1711 W Florist Ave, 53209 Milwaukee",
    "email": null,
    "phone": "4142904360",
    "website": null,
    "coords": {
      "lat": 43.12578201293945,
      "lng": -87.9323959350586
    }
  },
  {
    "id": "41903_1",
    "name": "South Bay BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Torrance",
    "address": "4306 W 190th St, 90504 Torrance",
    "email": null,
    "phone": "3106264657",
    "website": null,
    "coords": {
      "lat": 33.858341217041016,
      "lng": -118.3485107421875
    }
  },
  {
    "id": "43786_1",
    "name": "BMW of Grapevine, Certified Collision Repair Center",
    "country": "US",
    "city": "Grapevine",
    "address": "1005 E. State Hwy 114, 76051 Grapevine",
    "email": null,
    "phone": "8179124500",
    "website": null,
    "coords": {
      "lat": 32.923500061035156,
      "lng": -97.0628433227539
    }
  },
  {
    "id": "40304_2",
    "name": "BMW of Arlington, Certified Collision Repair Center",
    "country": "US",
    "city": "Arlington",
    "address": "401 N Collins St, 76011 Arlington",
    "email": null,
    "phone": "8174365840",
    "website": null,
    "coords": {
      "lat": 32.7411994934082,
      "lng": -97.0973129272461
    }
  },
  {
    "id": "55806_50003",
    "name": "Cascade Collision Ogden, Independent Certified Collision Repair Center of BMW of Murray",
    "country": "US",
    "city": "Ogden",
    "address": "3520 Wall St, 84401 Ogden",
    "email": null,
    "phone": "8013951946",
    "website": null,
    "coords": {
      "lat": 41.199310302734375,
      "lng": -111.97936248779297
    }
  },
  {
    "id": "45289_50001",
    "name": "AutoNation Collision Center Spring, Independent Certified Collision Repair Center of BMW of The Woodlands",
    "country": "US",
    "city": "Spring",
    "address": "21055 North Freeway I-45, 77388 Spring",
    "email": null,
    "phone": "3468316731",
    "website": null,
    "coords": {
      "lat": 30.068038940429688,
      "lng": -95.43529510498047
    }
  },
  {
    "id": "24024_50001",
    "name": "Schaefer Autobody, Independent Certified Collision Repair Center of Autohaus BMW of Maplewood",
    "country": "US",
    "city": "Maplewood",
    "address": "7920 Jaguar Trail, 63143 Maplewood",
    "email": null,
    "phone": "3142881597",
    "website": null,
    "coords": {
      "lat": 38.60765075683594,
      "lng": -90.33415985107422
    }
  },
  {
    "id": "56357_50001",
    "name": "Ken Ganley Auto Collision, Independent Certified Collision Repair Center of BMW of Westlake",
    "country": "US",
    "city": "Cleveland",
    "address": "4081 West 150th Street, 44111 Cleveland",
    "email": null,
    "phone": "2164761241",
    "website": null,
    "coords": {
      "lat": 41.443328857421875,
      "lng": -81.80130004882812
    }
  },
  {
    "id": "21613_50001",
    "name": "Capital Collision, Independent Certified Collision Repair Center of BMW of Spokane",
    "country": "US",
    "city": "Helena",
    "address": "1006 Euclid Ave, 59601 Helena",
    "email": null,
    "phone": "4064428611",
    "website": null,
    "coords": {
      "lat": 46.60097122192383,
      "lng": -112.04913330078125
    }
  },
  {
    "id": "05080_50001",
    "name": "Colorado Coach Auto Body, Independent Certified Collision Repair Center of Gebhardt BMW",
    "country": "US",
    "city": "Boulder",
    "address": "4850 Valmont Rd, 80301 Boulder",
    "email": null,
    "phone": "3034494153",
    "website": null,
    "coords": {
      "lat": 40.028961181640625,
      "lng": -105.24137878417969
    }
  },
  {
    "id": "44427_50002",
    "name": "World Class Collision Jack's Bodyworks, Independent Certified Collision Repair Center of BMW of Palm Springs",
    "country": "US",
    "city": "Palm Desert",
    "address": "74824 Lennon Place, 92260 Palm Desert",
    "email": null,
    "phone": "7603214752",
    "website": null,
    "coords": {
      "lat": 33.745479583740234,
      "lng": -116.3609619140625
    }
  },
  {
    "id": "51458_50001",
    "name": "European Coachworks of San Marcos, Independent Certified Collision Repair Center of BMW of Escondido",
    "country": "US",
    "city": "San Marcos",
    "address": "1139 Grand Avenue, 92069 San Marcos",
    "email": null,
    "phone": "6198841895",
    "website": null,
    "coords": {
      "lat": 33.14189910888672,
      "lng": -117.18876647949219
    }
  },
  {
    "id": "47046_50002",
    "name": "Supreme Collision, Independent Certified Collision Repair Center of BMW of Buena Park",
    "country": "US",
    "city": "Fullerton",
    "address": "144 North Gilbert Street, 92833 Fullerton",
    "email": null,
    "phone": "7144089500",
    "website": null,
    "coords": {
      "lat": 33.871559143066406,
      "lng": -117.96784210205078
    }
  },
  {
    "id": "10731_50001",
    "name": "B&S Hacienda Auto Body, Independent Certified Collision Repair Center of East Bay BMW",
    "country": "US",
    "city": "Pleasanton",
    "address": "3687 Old Santa Rita Rd #27, 94588 Pleasanton",
    "email": null,
    "phone": "9258478789",
    "website": null,
    "coords": {
      "lat": 37.69784164428711,
      "lng": -121.87940216064453
    }
  },
  {
    "id": "24856_50001",
    "name": "Caliber Collision Fremont, Independent Certified Collision Repair Center of BMW of Fremont",
    "country": "US",
    "city": "Fremont",
    "address": "41703 Albrae St, 94538 Fremont",
    "email": null,
    "phone": "5106234910",
    "website": null,
    "coords": {
      "lat": 37.51436996459961,
      "lng": -121.97718811035156
    }
  },
  {
    "id": "32652_50004",
    "name": "AW Collision Serramonte, Independent Certified Collision Repair Center of Peter Pan BMW",
    "country": "US",
    "city": "South San Francisco",
    "address": "339 Harbor Way, 94080 South San Francisco",
    "email": null,
    "phone": "6509921400",
    "website": null,
    "coords": {
      "lat": 37.64488983154297,
      "lng": -122.39900207519531
    }
  },
  {
    "id": "26718_50001",
    "name": "Classic Collision Goleta, Independent Certified Collision Repair Center of BMW Santa Barbara",
    "country": "US",
    "city": "Goleta",
    "address": "5901 Hollister Avenue, 93117 Goleta",
    "email": null,
    "phone": "8059648900",
    "website": null,
    "coords": {
      "lat": 34.43571090698242,
      "lng": -119.82933044433594
    }
  },
  {
    "id": "04923_50001",
    "name": "Caliber Collision, Independent Certified Collision Repair Center of BMW of Roseville",
    "country": "US",
    "city": "Roseville",
    "address": "8880 Industrial Ave Suites 140 & 160, 95678 Roseville",
    "email": null,
    "phone": "9167803198",
    "website": null,
    "coords": {
      "lat": 38.79121017456055,
      "lng": -121.3071517944336
    }
  },
  {
    "id": "49962_1",
    "name": "Medford BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Medford",
    "address": "2665 Bullock Rd, 97504 Medford",
    "email": null,
    "phone": "5417766470",
    "website": null,
    "coords": {
      "lat": 42.355777740478516,
      "lng": -122.87125396728516
    }
  },
  {
    "id": "28786_50001",
    "name": "Lithia Auto Body Express, Independent Certified Collision Repair Center of BMW of Anchorage",
    "country": "US",
    "city": "Anchorage",
    "address": "4904 Old Seward Hwy, 99518 Anchorage",
    "email": null,
    "phone": "9075616222",
    "website": null,
    "coords": {
      "lat": 61.17496109008789,
      "lng": -149.8684844970703
    }
  },
  {
    "id": "76731_50001",
    "name": "Basic Auto Collision, Independent Certified Collision Repair Center of BMW of Honolulu",
    "country": "US",
    "city": "Honolulu",
    "address": "711 Umi St, 96819 Honolulu",
    "email": null,
    "phone": "8088423966",
    "website": null,
    "coords": {
      "lat": 21.33329963684082,
      "lng": -157.87890625
    }
  },
  {
    "id": "45332_50001",
    "name": "Old Dominion Auto Body, Independent Certified Collision Repair Center of BMW of Eugene",
    "country": "US",
    "city": "Eugene",
    "address": "1060 West 1st Ave, 97402 Eugene",
    "email": null,
    "phone": "5414853368",
    "website": null,
    "coords": {
      "lat": 44.05839157104492,
      "lng": -123.10877990722656
    }
  },
  {
    "id": "46886_50003",
    "name": "Sunn West City's Auto Body, Independent Certified Collision Repair Center of Arrowhead BMW",
    "country": "US",
    "city": "Surprise",
    "address": "17126 N 134th Drive Suite 1, 85378 Surprise",
    "email": null,
    "phone": "6235464122",
    "website": null,
    "coords": {
      "lat": 33.64070129394531,
      "lng": -112.34793853759766
    }
  },
  {
    "id": "40335_2",
    "name": "BMW of Riverside, Certified Collision Repair Center",
    "country": "US",
    "city": "Riverside",
    "address": "3040 Adams St, 92504 Riverside",
    "email": null,
    "phone": "9513735000",
    "website": null,
    "coords": {
      "lat": 33.923091888427734,
      "lng": -117.41679382324219
    }
  },
  {
    "id": "42868_50001",
    "name": "Ficarro's Collision Inc., Independent Certified Collision Repair Center of Princeton BMW",
    "country": "US",
    "city": "Ewing",
    "address": "21 Industry Court, 08638 Ewing",
    "email": null,
    "phone": "2158269200",
    "website": null,
    "coords": {
      "lat": 40.25294876098633,
      "lng": -74.75406646728516
    }
  },
  {
    "id": "40713_50003",
    "name": "Classic Coachwork of the Main Line, Independent Certified Collision Repair Center of BMW of Devon",
    "country": "US",
    "city": "Wayne",
    "address": "228 E Lancaster Ave, 19087 Wayne",
    "email": null,
    "phone": "6106870799",
    "website": null,
    "coords": {
      "lat": 40.043758392333984,
      "lng": -75.38282775878906
    }
  },
  {
    "id": "46539_1",
    "name": "BMW of Shrewsbury, Certified Collision Repair Center",
    "country": "US",
    "city": "Shrewsbury",
    "address": "420 Boston Turnpike, 01545 Shrewsbury",
    "email": null,
    "phone": "7742752657",
    "website": null,
    "coords": {
      "lat": 42.27621078491211,
      "lng": -71.7272720336914
    }
  },
  {
    "id": "31638_01",
    "name": "BMW of Mt. Laurel",
    "country": "US",
    "city": "Mount Laurel",
    "address": "1220 Route 73, 08054 Mount Laurel",
    "email": "info@bmwofmtlaurel.com",
    "phone": "8568401400",
    "website": "https://www.bmwofmtlaurel.com",
    "coords": {
      "lat": 39.9221076965332,
      "lng": -74.9485855102539
    }
  },
  {
    "id": "52264_01",
    "name": "BMW of West Chester",
    "country": "US",
    "city": "West Chester",
    "address": "1275 Wilmington Pike, 19382 West Chester",
    "email": "service@bmwofwestchester.com",
    "phone": "6103996800",
    "website": "https://www.bmwofwestchester.com/",
    "coords": {
      "lat": 39.90869903564453,
      "lng": -75.56909942626953
    }
  },
  {
    "id": "26703_01",
    "name": "BMW of Warwick",
    "country": "US",
    "city": "Warwick",
    "address": "1515 Bald Hill Rd, 02888 Warwick",
    "email": "webleads@inskipbmw.dsmessage.com",
    "phone": "4012989896",
    "website": "https://bmwofwarwick.com",
    "coords": {
      "lat": 41.69896697998047,
      "lng": -71.49747467041016
    }
  },
  {
    "id": "54387_01",
    "name": "BMW of Sudbury",
    "country": "US",
    "city": "Sudbury",
    "address": "68 Old County Rd, 01776 Sudbury",
    "email": null,
    "phone": "5089035300",
    "website": null,
    "coords": {
      "lat": 42.363739013671875,
      "lng": -71.3941421508789
    }
  },
  {
    "id": "36493_01",
    "name": "I. G. Burton BMW",
    "country": "US",
    "city": "Milford",
    "address": "509 Bay Rd, 19963 Milford",
    "email": "mgmt@igburtonbmw.com",
    "phone": "3024243042",
    "website": "https://www.igburtonbmw.com",
    "coords": {
      "lat": 38.94610595703125,
      "lng": -75.42669677734375
    }
  },
  {
    "id": "34559_01",
    "name": "BMW of Newton",
    "country": "US",
    "city": "Newton",
    "address": "119 Hampton House Rd, 07860 Newton",
    "email": null,
    "phone": "9735792600",
    "website": "https://www.bmwnewton.com",
    "coords": {
      "lat": 41.08045959472656,
      "lng": -74.73626708984375
    }
  },
  {
    "id": "50887_01",
    "name": "BMW of Charlottesville",
    "country": "US",
    "city": "Charlottesville",
    "address": "1295 Richmond Rd, 22911 Charlottesville",
    "email": null,
    "phone": "4343275378",
    "website": "https://www.bmwcharlottesville.com",
    "coords": {
      "lat": 38.03342056274414,
      "lng": -78.45166015625
    }
  },
  {
    "id": "43872_01",
    "name": "BMW of Milwaukee North",
    "country": "US",
    "city": "Milwaukee",
    "address": "5990 N Green Bay Ave, 53209 Milwaukee",
    "email": null,
    "phone": "4142904200",
    "website": "https://www.bmwofmilwaukeenorth.com",
    "coords": {
      "lat": 43.12611770629883,
      "lng": -87.9343032836914
    }
  },
  {
    "id": "51637_01",
    "name": "BMW of Roanoke",
    "country": "US",
    "city": "Roanoke",
    "address": "2012 Peters Creek Rd NW, 24017 Roanoke",
    "email": "jlazarski@parksautogroup.com",
    "phone": "5405620099",
    "website": "https://www.bmwroanoke.com/",
    "coords": {
      "lat": 37.3098030090332,
      "lng": -80.00747680664062
    }
  },
  {
    "id": "86773_01",
    "name": "BMW of Huntsville",
    "country": "US",
    "city": "Huntsville",
    "address": "3810 University Dr NW, 35816 Huntsville",
    "email": "century@centuryauto.com",
    "phone": "2565363800",
    "website": "https://www.centurybmwhuntsville.com",
    "coords": {
      "lat": 34.73554992675781,
      "lng": -86.62313079833984
    }
  },
  {
    "id": "66641_01",
    "name": "Voss Village BMW",
    "country": "US",
    "city": "Dayton",
    "address": "620 Miamisburg Centerville Rd, 45459 Dayton",
    "email": "aaronkerstanski@vossbmw.net",
    "phone": "9374335111",
    "website": "https://www.vossbmw.com",
    "coords": {
      "lat": 39.62716293334961,
      "lng": -84.17464447021484
    }
  },
  {
    "id": "24987_01",
    "name": "Laurel BMW of Westmont",
    "country": "US",
    "city": "Westmont",
    "address": "430 E Ogden Ave, 60559 Westmont",
    "email": "CREEDONC@AUTONATION.COM",
    "phone": "6306545400",
    "website": "https://www.laurelbmw.com",
    "coords": {
      "lat": 41.81142044067383,
      "lng": -87.96324157714844
    }
  },
  {
    "id": "51106_01",
    "name": "BMW of Bloomfield Hills",
    "country": "US",
    "city": "Bloomfield Hills",
    "address": "1845 S. Telegraph Road, 48302 Bloomfield Hills",
    "email": "jnazzal@penskeautomotive.com",
    "phone": "2486426565",
    "website": "https://www.bmwbloomfieldhills.com/",
    "coords": {
      "lat": 42.613441467285156,
      "lng": -83.30653381347656
    }
  },
  {
    "id": "23968_01",
    "name": "BMW of Peoria",
    "country": "US",
    "city": "Peoria",
    "address": "1720 W Pioneer Pkwy, 61615 Peoria",
    "email": "nleman@lemanauto.com",
    "phone": "3096924840",
    "website": "https://www.bmwofpeoria.com",
    "coords": {
      "lat": 40.78287887573242,
      "lng": -89.61952209472656
    }
  },
  {
    "id": "55200_01",
    "name": "BMW of Raleigh",
    "country": "US",
    "city": "Raleigh",
    "address": "5603 Capital Blvd, 27616 Raleigh",
    "email": "sean.beach@leithcars.com",
    "phone": "9198822420",
    "website": "https://www.bmwofraleigh.com/",
    "coords": {
      "lat": 35.863250732421875,
      "lng": -78.58416748046875
    }
  },
  {
    "id": "66788_06",
    "name": "Hendrick BMW Certified Pre-Owned",
    "country": "US",
    "city": "Charlotte",
    "address": "9029 South Blvd, 28273 Charlotte",
    "email": "HLGTLservice@hendrickauto.com",
    "phone": "7045350885",
    "website": "https://www.hendrickbmwcposouth.com/",
    "coords": {
      "lat": 35.1147346496582,
      "lng": -80.88208770751953
    }
  },
  {
    "id": "23071_01",
    "name": "BMW of Lincoln",
    "country": "US",
    "city": "Lincoln",
    "address": "6741 Telluride Dr, 68521 Lincoln",
    "email": "bniebrugge@huskerautogroup.com",
    "phone": "4024797500",
    "website": "https://www.bmwoflincoln.com",
    "coords": {
      "lat": 40.879276275634766,
      "lng": -96.68428039550781
    }
  },
  {
    "id": "49543_01",
    "name": "BMW of Jackson",
    "country": "US",
    "city": "Jackson",
    "address": "1685 High St, 39202 Jackson",
    "email": "bmw.sales@herrin-gear.com",
    "phone": "6013542269",
    "website": null,
    "coords": {
      "lat": 32.30062484741211,
      "lng": -90.16536712646484
    }
  },
  {
    "id": "96255_02",
    "name": "Fields BMW South Orlando",
    "country": "US",
    "city": "Orlando",
    "address": "9750 S Orange Blossom Trl, 32837 Orlando",
    "email": null,
    "phone": "4079566300",
    "website": "https://www.fieldsbmworlando.com",
    "coords": {
      "lat": 28.414928436279297,
      "lng": -81.40533447265625
    }
  },
  {
    "id": "45289_01",
    "name": "BMW of The Woodlands",
    "country": "US",
    "city": "The Woodlands",
    "address": "17830 Interstate 45 South, 77384 The Woodlands",
    "email": null,
    "phone": "9362713000",
    "website": "https://www.bmwofthewoodlands.com",
    "coords": {
      "lat": 30.19861602783203,
      "lng": -95.45642852783203
    }
  },
  {
    "id": "32082_01",
    "name": "BMW Tucson",
    "country": "US",
    "city": "Tucson",
    "address": "855 W. Wetmore Rd., 85705 Tucson",
    "email": "pezzir@autonation.com",
    "phone": "5207481333",
    "website": "https://www.tucsonbmw.com",
    "coords": {
      "lat": 32.286251068115234,
      "lng": -110.98554992675781
    }
  },
  {
    "id": "05080_01",
    "name": "Gebhardt BMW",
    "country": "US",
    "city": "Boulder",
    "address": "4740 Valmont Rd, 80301 Boulder",
    "email": "bobr@gebauto.com",
    "phone": "7209741000",
    "website": "https://www.gebhardtbmw.com",
    "coords": {
      "lat": 40.02848434448242,
      "lng": -105.24237060546875
    }
  },
  {
    "id": "46886_01",
    "name": "Arrowhead BMW",
    "country": "US",
    "city": "Glendale",
    "address": "19250 N 101 Loop, 85308 Glendale",
    "email": "email@arrowheadbmw.com",
    "phone": "8337001269",
    "website": "https://www.arrowheadbmw.com/",
    "coords": {
      "lat": 33.658241271972656,
      "lng": -112.23402404785156
    }
  },
  {
    "id": "10732_01",
    "name": "BMW of Bellevue",
    "country": "US",
    "city": "Bellevue",
    "address": "11959 Northup Way, 98005 Bellevue",
    "email": "zabihis@autonation.com",
    "phone": "4256434544",
    "website": "https://www.bmwbellevue.com",
    "coords": {
      "lat": 47.63124084472656,
      "lng": -122.18121337890625
    }
  },
  {
    "id": "86513_01",
    "name": "Sterling BMW",
    "country": "US",
    "city": "Newport Beach",
    "address": "3000 W Coast Hwy, 92663 Newport Beach",
    "email": "joe@sterlingbmw.com",
    "phone": "9496455900",
    "website": "https://www.sterlingbmw.com",
    "coords": {
      "lat": 33.621559143066406,
      "lng": -117.92549133300781
    }
  },
  {
    "id": "32467_01",
    "name": "BMW of El Cajon",
    "country": "US",
    "city": "El Cajon",
    "address": "720 El Cajon Boulevard, 92020 El Cajon",
    "email": "sales@bmwsouthcounty.com",
    "phone": "6194428888",
    "website": "http://www.bmwofelcajon.com/",
    "coords": {
      "lat": 32.786922454833984,
      "lng": -116.97571563720703
    }
  },
  {
    "id": "52685_01",
    "name": "BMW of Downtown Los Angeles",
    "country": "US",
    "city": "Los Angeles",
    "address": "6333 S Alameda Street, 90001 Los Angeles",
    "email": null,
    "phone": "3235831901",
    "website": null,
    "coords": {
      "lat": 33.982398986816406,
      "lng": -118.23690032958984
    }
  },
  {
    "id": "49544_01",
    "name": "BMW of San Francisco",
    "country": "US",
    "city": "San Francisco",
    "address": "1675 Howard St, 94103 San Francisco",
    "email": null,
    "phone": "6282351200",
    "website": null,
    "coords": {
      "lat": 37.77096176147461,
      "lng": -122.4170913696289
    }
  },
  {
    "id": "76731_02",
    "name": "BMW of Maui",
    "country": "US",
    "city": "Puunene",
    "address": "151 Alaihi Street, 96784 Puunene",
    "email": "shawn.karn@bmwhawaii.com",
    "phone": "8088774269",
    "website": "https://www.bmwofmaui.com",
    "coords": {
      "lat": 20.887258529663086,
      "lng": -156.45431518554688
    }
  },
  {
    "id": "23779_01",
    "name": "Hansel BMW of Santa Rosa",
    "country": "US",
    "city": "Santa Rosa",
    "address": "2925 Corby Ave, 95407 Santa Rosa",
    "email": "dlong@gohansel.com",
    "phone": "7075937644",
    "website": "https://www.hanselbmwofsantarosa.com",
    "coords": {
      "lat": 38.405731201171875,
      "lng": -122.7164306640625
    }
  },
  {
    "id": "16856_01",
    "name": "BMW of Morristown",
    "country": "US",
    "city": "Morristown",
    "address": "111 Ridgedale Ave, 07960 Morristown",
    "email": "kaman.li@openroad.com",
    "phone": "9734550700",
    "website": "https://www.morristownbmw.com",
    "coords": {
      "lat": 40.8032112121582,
      "lng": -74.46403503417969
    }
  },
  {
    "id": "23200_01",
    "name": "Continental BMW of Darien",
    "country": "US",
    "city": "Darien",
    "address": "140 Ledge Rd, 06820 Darien",
    "email": "sales@bmwdarien.com",
    "phone": "2036561804",
    "website": "https://www.bmwdarien.com",
    "coords": {
      "lat": 41.07292175292969,
      "lng": -73.47763061523438
    }
  },
  {
    "id": "51085_01",
    "name": "BMW of Ridgefield",
    "country": "US",
    "city": "Ridgefield",
    "address": "746 Danbury Rd, 06877 Ridgefield",
    "email": null,
    "phone": "2034380471",
    "website": null,
    "coords": {
      "lat": 41.330501556396484,
      "lng": -73.47309875488281
    }
  },
  {
    "id": "21102_01",
    "name": "BMW of Bridgewater",
    "country": "US",
    "city": "Bridgewater",
    "address": "655 Route 202/206, 08807 Bridgewater",
    "email": "lori.trimarco@bridgewaterbmw.com",
    "phone": "9082871800",
    "website": "https://www.bmwofbridgewater.com",
    "coords": {
      "lat": 40.600746154785156,
      "lng": -74.62394714355469
    }
  },
  {
    "id": "69000_01",
    "name": "Rallye BMW",
    "country": "US",
    "city": "Westbury",
    "address": "1 Brush Hollow Rd, 11590 Westbury",
    "email": "ddewling@rallyebmw.com",
    "phone": "5163930000",
    "website": "https://www.rallyebmw.com",
    "coords": {
      "lat": 40.77919006347656,
      "lng": -73.55850219726562
    }
  },
  {
    "id": "34753_01",
    "name": "BMW of Reading",
    "country": "US",
    "city": "Reading",
    "address": "1015 Lancaster Ave, 19607 Reading",
    "email": "bmwofreadingloyalty@masano.com",
    "phone": "8778666272",
    "website": "https://www.bmwofreading.com",
    "coords": {
      "lat": 40.314876556396484,
      "lng": -75.94377899169922
    }
  },
  {
    "id": "42868_01",
    "name": "Princeton BMW",
    "country": "US",
    "city": "Hamilton",
    "address": "3630 Quakerbridge Rd, 08619 Hamilton",
    "email": null,
    "phone": "6095701520",
    "website": "https://www.princetonbmw.com/",
    "coords": {
      "lat": 40.26023483276367,
      "lng": -74.67720031738281
    }
  },
  {
    "id": "32146_01",
    "name": "BMW of Annapolis",
    "country": "US",
    "city": "Annapolis",
    "address": "31 Old Mill Bottom Rd N, 21409 Annapolis",
    "email": "sdaly@group1auto.com",
    "phone": "4103499312",
    "website": "https://www.bmwofannapolis.com/",
    "coords": {
      "lat": 39.02214050292969,
      "lng": -76.47740936279297
    }
  },
  {
    "id": "53152_01",
    "name": "BMW of York",
    "country": "US",
    "city": "York",
    "address": "1370 Roosevelt Ave, 17404 York",
    "email": null,
    "phone": "7178456689",
    "website": null,
    "coords": {
      "lat": 39.978065490722656,
      "lng": -76.75774383544922
    }
  },
  {
    "id": "21295_01",
    "name": "BMW of Turnersville",
    "country": "US",
    "city": "Turnersville",
    "address": "3400 Route 42, 08012 Turnersville",
    "email": "pnaegele@penskeautomotive.com",
    "phone": "8565166500",
    "website": "https://www.bmwofturnersville.com",
    "coords": {
      "lat": 39.72911834716797,
      "lng": -75.02980041503906
    }
  },
  {
    "id": "30374_01",
    "name": "BMW of Atlantic City",
    "country": "US",
    "city": "Egg Harbor Township",
    "address": "6037 Black Horse Pike, 08234 Egg Harbor Township",
    "email": "mdemarco@group1auto.com",
    "phone": "6095689200",
    "website": "https://www.BMWAtlanticCity.com",
    "coords": {
      "lat": 39.43563461303711,
      "lng": -74.6140365600586
    }
  },
  {
    "id": "43383_01",
    "name": "BMW of South Albany",
    "country": "US",
    "city": "Glenmont",
    "address": "617 Route 9W, 12077 Glenmont",
    "email": null,
    "phone": "5184633141",
    "website": "https://www.bmwofsouthalbany.com",
    "coords": {
      "lat": 42.58937072753906,
      "lng": -73.79756164550781
    }
  },
  {
    "id": "21183_01",
    "name": "Gault Auto Sport BMW",
    "country": "US",
    "city": "Endicott",
    "address": "2507 North St, 13760 Endicott",
    "email": "jeremy.krebbeks@gaultautosportbmw.com",
    "phone": "6077488244",
    "website": "https://www.gaultautosportbmw.com",
    "coords": {
      "lat": 42.10712814331055,
      "lng": -76.03509521484375
    }
  },
  {
    "id": "86854_01",
    "name": "Burdick BMW",
    "country": "US",
    "city": "Cicero",
    "address": "5947 E Circle Dr, 13039 Cicero",
    "email": "internet@dvburdick.com",
    "phone": "3154596000",
    "website": "https://www.burdickbmw.com",
    "coords": {
      "lat": 43.15286636352539,
      "lng": -76.11296081542969
    }
  },
  {
    "id": "49851_01",
    "name": "BMW of Sterling",
    "country": "US",
    "city": "Sterling",
    "address": "21710 Auto World Circle, 20166 Sterling",
    "email": null,
    "phone": "5714341944",
    "website": "https://www.bmwofsterling.com",
    "coords": {
      "lat": 39.012733459472656,
      "lng": -77.439453125
    }
  },
  {
    "id": "20635_01",
    "name": "Preston BMW",
    "country": "US",
    "city": "Boardman",
    "address": "7830 Market St., 44512 Boardman",
    "email": "kwhelan@prestonauto.com",
    "phone": "3307087332",
    "website": "https://www.prestonbmw.com",
    "coords": {
      "lat": 41.01150131225586,
      "lng": -80.6632308959961
    }
  },
  {
    "id": "26338_01",
    "name": "BMW of Southpoint",
    "country": "US",
    "city": "Durham",
    "address": "225 Kentington Drive, 27713 Durham",
    "email": "4performance@hendrickauto.com",
    "phone": "9842875400",
    "website": "https://www.bmwsouthpoint.com",
    "coords": {
      "lat": 35.899085998535156,
      "lng": -78.9456558227539
    }
  },
  {
    "id": "25244_01",
    "name": "Checkered Flag BMW",
    "country": "US",
    "city": "Virginia Beach",
    "address": "5225 Virginia Beach Blvd, 23462 Virginia Beach",
    "email": "aharrison@checkeredflag.com",
    "phone": "7574901111",
    "website": "https://bmw.checkeredflag.com",
    "coords": {
      "lat": 36.84721755981445,
      "lng": -76.16232299804688
    }
  },
  {
    "id": "50498_01",
    "name": "BMW of Rochester Hills",
    "country": "US",
    "city": "Shelby Township",
    "address": "45550 Dequindre Rd, 48317 Shelby Township",
    "email": "info@bmwofrochesterhills.com",
    "phone": "2489977700",
    "website": "https://www.bmwofrochesterhills.com",
    "coords": {
      "lat": 42.627784729003906,
      "lng": -83.09042358398438
    }
  },
  {
    "id": "27600_01",
    "name": "Dreyer & Reinbold, Inc.",
    "country": "US",
    "city": "Indianapolis",
    "address": "9375 Whitley Dr, 46240 Indianapolis",
    "email": "bmwinfo@dreyerreinbold.com",
    "phone": "3175730200",
    "website": "https://www.dreyerreinboldbmwnorth.com",
    "coords": {
      "lat": 39.92306137084961,
      "lng": -86.11408233642578
    }
  },
  {
    "id": "33540_01",
    "name": "BMW of Traverse City",
    "country": "US",
    "city": "Traverse City",
    "address": "2801 N US Highway 31 S, 49684 Traverse City",
    "email": "dzamaites@foxmotors.com",
    "phone": "2319222002",
    "website": "https://www.foxbmwtc.com",
    "coords": {
      "lat": 44.72884750366211,
      "lng": -85.64724731445312
    }
  },
  {
    "id": "34883_01",
    "name": "BMW of Schererville",
    "country": "US",
    "city": "Schererville",
    "address": "1400 Indianapolis Blvd, 46375 Schererville",
    "email": "bob@bmwsch.com",
    "phone": "2198647333",
    "website": "https://www.bmwofschererville.com",
    "coords": {
      "lat": 41.496009826660156,
      "lng": -87.47321319580078
    }
  },
  {
    "id": "96717_01",
    "name": "The BMW Store",
    "country": "US",
    "city": "Cincinnati",
    "address": "6131 Stewart Ave, 45227 Cincinnati",
    "email": "bmwsales@bmwstore.com",
    "phone": "5132718700",
    "website": "https://www.bmwstore.com",
    "coords": {
      "lat": 39.179100036621094,
      "lng": -84.39620208740234
    }
  },
  {
    "id": "16345_01",
    "name": "BMW of Toledo",
    "country": "US",
    "city": "Toledo",
    "address": "7600 West Central Ave, 43617 Toledo",
    "email": "dyark@yarkauto.com",
    "phone": "4198427956",
    "website": "https://www.BMWofToledo.com",
    "coords": {
      "lat": 41.67561721801758,
      "lng": -83.68718719482422
    }
  },
  {
    "id": "29189_01",
    "name": "BMW of Okemos",
    "country": "US",
    "city": "Okemos",
    "address": "2777 Jolly Rd, 48864 Okemos",
    "email": "chris.shade@serraautocampus.com",
    "phone": "5178532600",
    "website": "https://www.bmwofokemos.com/",
    "coords": {
      "lat": 42.68275833129883,
      "lng": -84.45169067382812
    }
  },
  {
    "id": "46631_01",
    "name": "BMW of Cincinnati North",
    "country": "US",
    "city": "Cincinnati",
    "address": "105 W. Kemper Road, 45246 Cincinnati",
    "email": "rsabbagh@jakesweeney.com",
    "phone": "5137821122",
    "website": "https://www.BMWofCincinnatiNorth.com",
    "coords": {
      "lat": 39.28480529785156,
      "lng": -84.47026824951172
    }
  },
  {
    "id": "43381_01",
    "name": "BMW of Louisville",
    "country": "US",
    "city": "Louisville",
    "address": "2200 Blankenbaker Parkway, 40299 Louisville",
    "email": "mail@louisvillebmw.com",
    "phone": "5024995080",
    "website": "https://www.louisvillebmw.com/",
    "coords": {
      "lat": 38.21242904663086,
      "lng": -85.53929901123047
    }
  },
  {
    "id": "86716_01",
    "name": "Patrick BMW",
    "country": "US",
    "city": "Schaumburg",
    "address": "700 E Golf Rd, 60173 Schaumburg",
    "email": "ecosta@patrickcars.com",
    "phone": "8478434000",
    "website": "https://www.patrickbmw.com",
    "coords": {
      "lat": 42.05082702636719,
      "lng": -88.06221008300781
    }
  },
  {
    "id": "20133_01",
    "name": "International Autos",
    "country": "US",
    "city": "West Allis",
    "address": "2400 S 108th St, 53227 West Allis",
    "email": "office@international-autos.com",
    "phone": "4145433000",
    "website": "https://www.internationalbmw.com",
    "coords": {
      "lat": 43.00004577636719,
      "lng": -88.04623413085938
    }
  },
  {
    "id": "39450_01",
    "name": "BMW of Champaign",
    "country": "US",
    "city": "Savoy",
    "address": "100 Burwash Ave, 61874 Savoy",
    "email": "ben@serrachampaign.com",
    "phone": "2173560303",
    "website": "https://www.serrabmwchampaign.com/",
    "coords": {
      "lat": 40.07471466064453,
      "lng": -88.24919128417969
    }
  },
  {
    "id": "34909_01",
    "name": "BMW of Bloomington",
    "country": "US",
    "city": "Bloomington",
    "address": "1604 Commerce Parkway, 61704 Bloomington",
    "email": null,
    "phone": "3096612691",
    "website": "https://www.bmwofbloomington.com",
    "coords": {
      "lat": 40.45758056640625,
      "lng": -88.9748764038086
    }
  },
  {
    "id": "21233_01",
    "name": "BMW of Chattanooga",
    "country": "US",
    "city": "Chattanooga",
    "address": "6806 E Brainerd Rd, 37421 Chattanooga",
    "email": "david.goforth@bmwofchattanooga.com",
    "phone": "4238945660",
    "website": "https://www.bmwofchattanooga.com",
    "coords": {
      "lat": 35.01528549194336,
      "lng": -85.18258666992188
    }
  },
  {
    "id": "20648_01",
    "name": "BMW of Gwinnett Place",
    "country": "US",
    "city": "Duluth",
    "address": "3264 Commerce Ave, 30096 Duluth",
    "email": "bmwgwinnettsales@penskeautomotive.com",
    "phone": "4702002809",
    "website": "https://bmwofgwinnettplace.com",
    "coords": {
      "lat": 33.95948791503906,
      "lng": -84.11957550048828
    }
  },
  {
    "id": "26701_01",
    "name": "BMW of Columbus",
    "country": "US",
    "city": "Columbus",
    "address": "6549 Whittlesey Blvd, 31909 Columbus",
    "email": "chris.grasman@bmwofcolumbus.com",
    "phone": "7065962888",
    "website": "https://www.bmwofcolumbus.com",
    "coords": {
      "lat": 32.550296783447266,
      "lng": -84.93585205078125
    }
  },
  {
    "id": "21181_01",
    "name": "Plaza Motor Company",
    "country": "US",
    "city": "Creve Coeur",
    "address": "11830 Olive Blvd, 63141 Creve Coeur",
    "email": "KSPECTOR@plazamotors.com",
    "phone": "3143011705",
    "website": "https://www.plazabmw.com",
    "coords": {
      "lat": 38.67041778564453,
      "lng": -90.4451904296875
    }
  },
  {
    "id": "21553_01",
    "name": "Coggin BMW Treasure Coast",
    "country": "US",
    "city": "Fort Pierce",
    "address": "4429 S US Highway 1, 34982 Fort Pierce",
    "email": "mmcneal@cogginauto.com",
    "phone": "7724298300",
    "website": "https://www.cogginbmw.com",
    "coords": {
      "lat": 27.382339477539062,
      "lng": -80.32683563232422
    }
  },
  {
    "id": "20412_01",
    "name": "BMW of Tallahassee",
    "country": "US",
    "city": "Tallahassee",
    "address": "1485 Capital Circle NW, 32303 Tallahassee",
    "email": "catkins@crowncars.com",
    "phone": "8505743777",
    "website": "https://www.capital-bmw.com",
    "coords": {
      "lat": 30.46869468688965,
      "lng": -84.36028289794922
    }
  },
  {
    "id": "29187_01",
    "name": "BMW of Montgomery",
    "country": "US",
    "city": "Montgomery",
    "address": "731 Eastern Blvd, 36117 Montgomery",
    "email": "bmwofmontgomery@eleadtrack.net",
    "phone": "8009969705",
    "website": "https://www.bmwofmontgomery.com",
    "coords": {
      "lat": 32.36970138549805,
      "lng": -86.20953369140625
    }
  },
  {
    "id": "21359_01",
    "name": "Park Place BMW",
    "country": "US",
    "city": "Rochester",
    "address": "2828 Highway 52 N., 55901 Rochester",
    "email": "brad.johnson@lutherauto.com",
    "phone": "5072829468",
    "website": "https://www.parkplace-bmw.com",
    "coords": {
      "lat": 44.05363464355469,
      "lng": -92.49285125732422
    }
  },
  {
    "id": "23805_01",
    "name": "BMW of Fort Walton Beach",
    "country": "US",
    "city": "Fort Walton Beach",
    "address": "1000 N. Beal Pkwy, 32547 Fort Walton Beach",
    "email": "cdkbmw@ztmotorsfwb.com",
    "phone": "8508638352",
    "website": "https://www.bmwfwb.com",
    "coords": {
      "lat": 30.453140258789062,
      "lng": -86.63922119140625
    }
  },
  {
    "id": "41053_01",
    "name": "BMW of Meridian",
    "country": "US",
    "city": "Meridian",
    "address": "2000 Highway 39 N, 39301 Meridian",
    "email": "wwilkinson@BMWofMeridian.com",
    "phone": "6014838131",
    "website": "https://www.bmwofmeridian.com",
    "coords": {
      "lat": 32.3800163269043,
      "lng": -88.68082427978516
    }
  },
  {
    "id": "46891_02",
    "name": "Braman Motorcars of Jupiter",
    "country": "US",
    "city": "Jupiter",
    "address": "1555 W Indiantown Rd, 33458 Jupiter",
    "email": "michael.trapasso@bramanmc.com",
    "phone": "5616887000",
    "website": "https://www.bramanbmwjupiter.com",
    "coords": {
      "lat": 26.934843063354492,
      "lng": -80.12251281738281
    }
  },
  {
    "id": "34537_01",
    "name": "BMW of Mobile",
    "country": "US",
    "city": "Mobile",
    "address": "3025 Highway 90 W, 36606 Mobile",
    "email": "scottdavis@group1auto.com",
    "phone": "2514762550",
    "website": "https://www.bmwofmobile.com",
    "coords": {
      "lat": 30.655542373657227,
      "lng": -88.11553192138672
    }
  },
  {
    "id": "44821_01",
    "name": "BMW of Little Rock",
    "country": "US",
    "city": "Little Rock",
    "address": "4621 Colonel Glenn Plaza Dr., 72210 Little Rock",
    "email": null,
    "phone": "5012243200",
    "website": "https://www.bmwoflittlerock.com",
    "coords": {
      "lat": 34.714744567871094,
      "lng": -92.40523529052734
    }
  },
  {
    "id": "20721_01",
    "name": "Peake BMW",
    "country": "US",
    "city": "Kenner",
    "address": "2630 Veterans Memorial Blvd, 70062 Kenner",
    "email": "mpeake@peakebmw.com",
    "phone": "5044696165",
    "website": "https://www.peakebmw.com",
    "coords": {
      "lat": 30.006591796875,
      "lng": -90.2311019897461
    }
  },
  {
    "id": "40304_01",
    "name": "BMW of Arlington",
    "country": "US",
    "city": "Arlington",
    "address": "1105 E Lamar Blvd, 76011 Arlington",
    "email": null,
    "phone": "8174365700",
    "website": "https://www.bmwofarlington.com",
    "coords": {
      "lat": 32.765499114990234,
      "lng": -97.0945816040039
    }
  },
  {
    "id": "44503_01",
    "name": "BMW of Wichita",
    "country": "US",
    "city": "Wichita",
    "address": "11000 E. 13th Street N., 67206 Wichita",
    "email": null,
    "phone": "3167792613",
    "website": "https://www.bmwofwichita.com",
    "coords": {
      "lat": 37.7092399597168,
      "lng": -97.2095947265625
    }
  },
  {
    "id": "52938_01",
    "name": "BMW of McKinney",
    "country": "US",
    "city": "McKinney",
    "address": "2601 N Central Expressway, 75071 McKinney",
    "email": null,
    "phone": "9452346400",
    "website": null,
    "coords": {
      "lat": 33.226829528808594,
      "lng": -96.6365966796875
    }
  },
  {
    "id": "51029_01",
    "name": "BMW of Clear Lake",
    "country": "US",
    "city": "Webster",
    "address": "15943 Gulf Freeway, 77598 Webster",
    "email": null,
    "phone": "2815577000",
    "website": null,
    "coords": {
      "lat": 29.583694458007812,
      "lng": -95.18045043945312
    }
  },
  {
    "id": "26747_01",
    "name": "Momentum BMW",
    "country": "US",
    "city": "Houston",
    "address": "9570 Southwest Freeway, 77074 Houston",
    "email": "thomas.kuranoff@momentumbmw.net",
    "phone": "7135963100",
    "website": "https://www.momentumbmw.net",
    "coords": {
      "lat": 29.676881790161133,
      "lng": -95.54220581054688
    }
  },
  {
    "id": "44235_01",
    "name": "BMW of South Austin",
    "country": "US",
    "city": "Austin",
    "address": "5501 S IH35 Frontage Road, 78744 Austin",
    "email": null,
    "phone": "5124387500",
    "website": null,
    "coords": {
      "lat": 30.19989013671875,
      "lng": -97.7619400024414
    }
  },
  {
    "id": "21538_01",
    "name": "BMW of Idaho Falls",
    "country": "US",
    "city": "Idaho Falls",
    "address": "2200 West Sunnyside Rd, 83402 Idaho Falls",
    "email": "nsayer@ronsayerauto.com",
    "phone": "2085294269",
    "website": "https://www.bmwofidahofalls.com",
    "coords": {
      "lat": 43.50288772583008,
      "lng": -112.02684783935547
    }
  },
  {
    "id": "40335_01",
    "name": "BMW of Riverside",
    "country": "US",
    "city": "Riverside",
    "address": "3060 Adams St, 92504 Riverside",
    "email": "rlee@bmwriverside.com",
    "phone": "9513735000",
    "website": "https://www.bmwofriverside.com",
    "coords": {
      "lat": 33.92302322387695,
      "lng": -117.41725158691406
    }
  },
  {
    "id": "55806_02",
    "name": "BMW of Pleasant Grove",
    "country": "US",
    "city": "Pleasant Grove",
    "address": "2111 W Grove Pkwy, 84062 Pleasant Grove",
    "email": "sales@bmwofpleasantgrove.com",
    "phone": "8014432000",
    "website": "https://www.bmwofpleasantgrove.com",
    "coords": {
      "lat": 40.35214614868164,
      "lng": -111.77021026611328
    }
  },
  {
    "id": "52070_01",
    "name": "BMW of Lynnwood",
    "country": "US",
    "city": "Lynnwood",
    "address": "18700 Highway 99, 98037 Lynnwood",
    "email": "hana.kim@swickard.com",
    "phone": "4252980590",
    "website": null,
    "coords": {
      "lat": 47.82952117919922,
      "lng": -122.30882263183594
    }
  },
  {
    "id": "34821_01",
    "name": "BMW of Ontario",
    "country": "US",
    "city": "Ontario",
    "address": "1350 Auto Center Dr, 91761 Ontario",
    "email": null,
    "phone": "9093907888",
    "website": "https://www.bmwofontario.com",
    "coords": {
      "lat": 34.04964065551758,
      "lng": -117.54472351074219
    }
  },
  {
    "id": "17966_01",
    "name": "New Century BMW",
    "country": "US",
    "city": "Alhambra",
    "address": "1139 W Main St, 91801 Alhambra",
    "email": "info@ncbmw.com",
    "phone": "6265708444",
    "website": "https://www.newcenturybmw.com",
    "coords": {
      "lat": 34.091575622558594,
      "lng": -118.13514709472656
    }
  },
  {
    "id": "47046_01",
    "name": "BMW of Buena Park",
    "country": "US",
    "city": "Buena Park",
    "address": "6750 Auto Center Dr, 90621 Buena Park",
    "email": null,
    "phone": "7145983738",
    "website": "https://www.bmwbuenapark.com/",
    "coords": {
      "lat": 33.8618278503418,
      "lng": -117.98887634277344
    }
  },
  {
    "id": "31643_01",
    "name": "Long Beach BMW",
    "country": "US",
    "city": "Signal Hill",
    "address": "1660 E. Spring Street, 90755 Signal Hill",
    "email": "Leslie.Morales@longbeachbmw.co",
    "phone": "5624275494",
    "website": "https://www.longbeachbmw.com",
    "coords": {
      "lat": 33.81108474731445,
      "lng": -118.17110443115234
    }
  },
  {
    "id": "36721_01",
    "name": "Crevier BMW",
    "country": "US",
    "city": "Santa Ana",
    "address": "1500 Auto Mall Dr, 92705 Santa Ana",
    "email": null,
    "phone": "6572315000",
    "website": "https://www.crevierbmw.com",
    "coords": {
      "lat": 33.727508544921875,
      "lng": -117.83866119384766
    }
  },
  {
    "id": "76731_03",
    "name": "BMW of Hawaii",
    "country": "US",
    "city": "Kailua Kona",
    "address": "74-5533 Loloku St, 96740 Kailua Kona",
    "email": "ademesa@bmwhawaii.com",
    "phone": "8089303400",
    "website": "https://www.bmwbigisland.com",
    "coords": {
      "lat": 19.644208908081055,
      "lng": -156.0028839111328
    }
  },
  {
    "id": "42869_01",
    "name": "BMW of San Rafael",
    "country": "US",
    "city": "San Rafael",
    "address": "1599 Francisco Blvd E, 94901 San Rafael",
    "email": null,
    "phone": "4154822000",
    "website": "https://www.bmwofsanrafael.com/",
    "coords": {
      "lat": 37.95146942138672,
      "lng": -122.49492645263672
    }
  },
  {
    "id": "21616_01",
    "name": "Valley BMW",
    "country": "US",
    "city": "Modesto",
    "address": "4725 McHenry Ave, 95356 Modesto",
    "email": "cgodden@valley-bmw.com",
    "phone": "2095750269",
    "website": "https://www.valley-bmw.com",
    "coords": {
      "lat": 37.70315170288086,
      "lng": -120.99568939208984
    }
  },
  {
    "id": "65734_01",
    "name": "BMW of Santa Maria",
    "country": "US",
    "city": "Santa Maria",
    "address": "2150 S College Dr, 93455 Santa Maria",
    "email": "Rudycorrea@bmwsm.com",
    "phone": "8056140306",
    "website": "https://www.bmwsm.com",
    "coords": {
      "lat": 34.92226028442383,
      "lng": -120.42529296875
    }
  },
  {
    "id": "65775_01",
    "name": "BMW of Manhattan",
    "country": "US",
    "city": "New York",
    "address": "555 W 57th St, 10019 New York",
    "email": "appointments.nyc@bmwnyc.com",
    "phone": "2125862269",
    "website": "https://www.bmwnyc.com",
    "coords": {
      "lat": 40.77030944824219,
      "lng": -73.99061584472656
    }
  },
  {
    "id": "53290_01",
    "name": "BMW of Latham",
    "country": "US",
    "city": "Latham",
    "address": "1111 Troy Schenectady Rd, 12110 Latham",
    "email": null,
    "phone": "5187854197",
    "website": null,
    "coords": {
      "lat": 42.766807556152344,
      "lng": -73.81411743164062
    }
  },
  {
    "id": "54386_01",
    "name": "BMW of Boston",
    "country": "US",
    "city": "Boston",
    "address": "1168 Commonwealth Ave, 02134 Boston",
    "email": null,
    "phone": "6177311700",
    "website": null,
    "coords": {
      "lat": 42.35017013549805,
      "lng": -71.12816619873047
    }
  },
  {
    "id": "54675_01",
    "name": "BMW of Alexandria",
    "country": "US",
    "city": "Alexandria",
    "address": "499 S Pickett St, 22304 Alexandria",
    "email": "sales@bmwofalexandria.com",
    "phone": "7036848500",
    "website": null,
    "coords": {
      "lat": 38.80806350708008,
      "lng": -77.12773895263672
    }
  },
  {
    "id": "40808_01",
    "name": "BMW of Greenwich",
    "country": "US",
    "city": "Port Chester",
    "address": "110 Midland Ave, 10573 Port Chester",
    "email": null,
    "phone": "2034131900",
    "website": "https://www.bmwofgreenwich.com/",
    "coords": {
      "lat": 40.993045806884766,
      "lng": -73.66828918457031
    }
  },
  {
    "id": "56000_01",
    "name": "BMW of Brooklyn",
    "country": "US",
    "city": "Brooklyn",
    "address": "6223 2nd Ave, 11220 Brooklyn",
    "email": null,
    "phone": "7187595940",
    "website": "https://www.bmwofbrooklyn.com/",
    "coords": {
      "lat": 40.64215087890625,
      "lng": -74.02410125732422
    }
  },
  {
    "id": "49134_01",
    "name": "Ferman BMW",
    "country": "US",
    "city": "Palm Harbor",
    "address": "31480 US Highway 19 N, 34684 Palm Harbor",
    "email": "bob.murray@ferman.com",
    "phone": "7277853900",
    "website": "https://www.fermanbmw.com",
    "coords": {
      "lat": 28.05779457092285,
      "lng": -82.73969268798828
    }
  },
  {
    "id": "32652_01",
    "name": "Peter Pan BMW",
    "country": "US",
    "city": "Burlingame",
    "address": "1625 Adrian Rd, 94010 Burlingame",
    "email": null,
    "phone": "6503499077",
    "website": "https://www.peterpanbmw.com",
    "coords": {
      "lat": 37.59661865234375,
      "lng": -122.37214660644531
    }
  },
  {
    "id": "51458_01",
    "name": "BMW of Escondido",
    "country": "US",
    "city": "Escondido",
    "address": "330 S Hale Ave, 92029 Escondido",
    "email": null,
    "phone": "7607453000",
    "website": "https://www.bmwofescondido.com/",
    "coords": {
      "lat": 33.11487579345703,
      "lng": -117.1043472290039
    }
  },
  {
    "id": "28628_50003",
    "name": "River Oaks Paint and Body Midtown, Independent Certified Collision Repair Center of BMW of Houston Midtown",
    "country": "US",
    "city": "Houston",
    "address": "4603 Southwest Fwy, 77027 Houston",
    "email": null,
    "phone": "7135234774",
    "website": null,
    "coords": {
      "lat": 29.729440689086914,
      "lng": -95.45176696777344
    }
  },
  {
    "id": "56592_01",
    "name": "Casey BMW",
    "country": "US",
    "city": "Newport News",
    "address": "12861 Jefferson Ave, 23608 Newport News",
    "email": "dennis_grant@caseyauto.com",
    "phone": "7579891300",
    "website": "https://www.caseybmw.com",
    "coords": {
      "lat": 37.14529800415039,
      "lng": -76.52645111083984
    }
  },
  {
    "id": "79100_50001",
    "name": "Sterling Auto Service And Body Shop, Independent Certified Collision Repair Center of BMW of Silver Spring",
    "country": "US",
    "city": "Silver Spring",
    "address": "2311 Perkins Place, 20910 Silver Spring",
    "email": null,
    "phone": "3016081433",
    "website": null,
    "coords": {
      "lat": 39.004180908203125,
      "lng": -77.04981231689453
    }
  },
  {
    "id": "10695_50004",
    "name": "Flower Hill Auto Body Roslyn, Independent Certified Collision Repair Center of BMW of Manhasset",
    "country": "US",
    "city": "Roslyn",
    "address": "12 Middleneck Road, 11576 Roslyn",
    "email": null,
    "phone": "5166273913",
    "website": null,
    "coords": {
      "lat": 40.79928970336914,
      "lng": -73.66374206542969
    }
  },
  {
    "id": "86846_50001",
    "name": "Caliber Collision Westlake Village, Independent Certified Collision Repair Center of Rusnak BMW",
    "country": "US",
    "city": "Westlake Village",
    "address": "31245 La Baya, 91362 Westlake Village",
    "email": null,
    "phone": "8189916904",
    "website": null,
    "coords": {
      "lat": 34.156700134277344,
      "lng": -118.80462646484375
    }
  },
  {
    "id": "21613_01",
    "name": "BMW of Spokane",
    "country": "US",
    "city": "Spokane",
    "address": "215 E Montgomery Ave, 99207 Spokane",
    "email": "chrismarino@lithia.com",
    "phone": "5094583288",
    "website": "https://www.bmwofspokane.com/",
    "coords": {
      "lat": 47.678955078125,
      "lng": -117.40739440917969
    }
  },
  {
    "id": "22227_01",
    "name": "Paul Miller BMW",
    "country": "US",
    "city": "Wayne",
    "address": "1515 Route 23 South, 07470 Wayne",
    "email": "bmwservice@paulmiller.com",
    "phone": "9736966060",
    "website": "https://www.paulmillerbmw.com",
    "coords": {
      "lat": 40.93583679199219,
      "lng": -74.2704849243164
    }
  },
  {
    "id": "04660_50001",
    "name": "Beverly Coachcraft",
    "country": "US",
    "city": "Los Angeles",
    "address": "2320 Sawtelle Blvd, 90064 Los Angeles",
    "email": null,
    "phone": "3104776561",
    "website": null,
    "coords": {
      "lat": 34.036380767822266,
      "lng": -118.43952941894531
    }
  },
  {
    "id": "54793_01",
    "name": "BMW of Dublin",
    "country": "US",
    "city": "Dublin",
    "address": "5825 Venture Drive, 43017 Dublin",
    "email": null,
    "phone": "6148892571",
    "website": null,
    "coords": {
      "lat": 40.10072326660156,
      "lng": -83.14920043945312
    }
  },
  {
    "id": "50644_01",
    "name": "BMW of Fort Washington",
    "country": "US",
    "city": "Dresher",
    "address": "1401 Dreshertown Rd, 19025 Dresher",
    "email": "jim.kostack@mileone.com",
    "phone": "2156433322",
    "website": "https://www.bmwoffortwashington.com/",
    "coords": {
      "lat": 40.143470764160156,
      "lng": -75.16635131835938
    }
  },
  {
    "id": "43005_01",
    "name": "BMW of Springfield",
    "country": "US",
    "city": "Springfield",
    "address": "391 US 22, 07081 Springfield",
    "email": "egemma@bmwofspringfieldnj.com",
    "phone": "9733797744",
    "website": "https://www.bmwofspringfieldnj.com",
    "coords": {
      "lat": 40.684608459472656,
      "lng": -74.33491516113281
    }
  },
  {
    "id": "40713_01",
    "name": "BMW of Devon",
    "country": "US",
    "city": "Devon",
    "address": "20 Lancaster Ave, 19333 Devon",
    "email": "david.sloane@sloaneautos.com",
    "phone": "6106879350",
    "website": "https://www.bmwofdevon.com",
    "coords": {
      "lat": 40.04791259765625,
      "lng": -75.4163589477539
    }
  },
  {
    "id": "54878_01",
    "name": "BMW of Santa Monica",
    "country": "US",
    "city": "Santa Monica",
    "address": "1127 Santa Monica Blvd, 90401 Santa Monica",
    "email": null,
    "phone": "4243223300",
    "website": null,
    "coords": {
      "lat": 34.02265548706055,
      "lng": -118.48799133300781
    }
  },
  {
    "id": "54799_01",
    "name": "BMW of Bel Air",
    "country": "US",
    "city": "Bel Air",
    "address": "716 Belair Road, 21014 Bel Air",
    "email": null,
    "phone": "4436401000",
    "website": null,
    "coords": {
      "lat": 39.52238845825195,
      "lng": -76.35948181152344
    }
  },
  {
    "id": "53372_01",
    "name": "BMW of Humboldt Bay",
    "country": "US",
    "city": "McKinleyville",
    "address": "1795 Central Ave, 95519 McKinleyville",
    "email": null,
    "phone": "7078394269",
    "website": null,
    "coords": {
      "lat": 40.93751907348633,
      "lng": -124.1007080078125
    }
  },
  {
    "id": "36635_50001",
    "name": "King Collision, Independent Certified Collision Repair Center of BMW of Cape Cod",
    "country": "US",
    "city": "Plymouth",
    "address": "48 Holman Rd, 02360 Plymouth",
    "email": null,
    "phone": "5087472005",
    "website": null,
    "coords": {
      "lat": 41.92903518676758,
      "lng": -70.66204833984375
    }
  },
  {
    "id": "46539_50001",
    "name": "Wagner Collision Center, Independent Certified Collision Repair Center of BMW of Shrewsbury",
    "country": "US",
    "city": "Worcester",
    "address": "700 Plantation St, 01605 Worcester",
    "email": null,
    "phone": "5085815900",
    "website": null,
    "coords": {
      "lat": 42.299346923828125,
      "lng": -71.76182556152344
    }
  },
  {
    "id": "59127_50001",
    "name": "Town & County Auto Body, Independent Certified Collision Repair Center of BMW of North Haven",
    "country": "US",
    "city": "North Haven",
    "address": "18 Corporate Drive, 06473 North Haven",
    "email": null,
    "phone": "2032349443",
    "website": null,
    "coords": {
      "lat": 41.372459411621094,
      "lng": -72.86759185791016
    }
  },
  {
    "id": "31638_2",
    "name": "BMW of Mt. Laurel, Certified Collision Repair Center",
    "country": "US",
    "city": "Maple Shade",
    "address": "571 Route 38 W, 08052 Maple Shade",
    "email": null,
    "phone": "8007108558",
    "website": null,
    "coords": {
      "lat": 39.94363021850586,
      "lng": -74.97274780273438
    }
  },
  {
    "id": "22800_50003",
    "name": "Autofix Collision Center, Independent Certified Collision Repair Center of Competition BMW of Smithtown",
    "country": "US",
    "city": "Bohemia",
    "address": "1585 Lakeland Ave, 11716 Bohemia",
    "email": null,
    "phone": "6315673535",
    "website": null,
    "coords": {
      "lat": 40.78268051147461,
      "lng": -73.11192321777344
    }
  },
  {
    "id": "35797_2",
    "name": "Passport BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Suitland",
    "address": "4721 Auth Place, 20746 Suitland",
    "email": null,
    "phone": "3014232200",
    "website": null,
    "coords": {
      "lat": 38.82508087158203,
      "lng": -76.9218978881836
    }
  },
  {
    "id": "26726_50001",
    "name": "Master Body Works, Independent Certified Collision Repair Center of BMW of Albany",
    "country": "US",
    "city": "Leesburg",
    "address": "1518 US Hwy 19 S, 31763 Leesburg",
    "email": null,
    "phone": "2294398833",
    "website": null,
    "coords": {
      "lat": 31.634544372558594,
      "lng": -84.17733764648438
    }
  },
  {
    "id": "32146_3",
    "name": "BMW of Annapolis, Certified Collision Repair Center",
    "country": "US",
    "city": "Annapolis",
    "address": "31 Old Mill Bottom Road, 21401 Annapolis",
    "email": null,
    "phone": "4103492509",
    "website": null,
    "coords": {
      "lat": 39.02309799194336,
      "lng": -76.4708251953125
    }
  },
  {
    "id": "55200_50004",
    "name": "Relentless Collision, Independent Certified Collision Repair Center of BMW of Raleigh",
    "country": "US",
    "city": "Cary",
    "address": "1640 Piney Plains Road, 27518 Cary",
    "email": null,
    "phone": "9844651026",
    "website": null,
    "coords": {
      "lat": 35.75920867919922,
      "lng": -78.74669647216797
    }
  },
  {
    "id": "48289_2",
    "name": "BMW of Owings Mills, Certified Collision Repair Center",
    "country": "US",
    "city": "Owings Mills",
    "address": "9618 Reisterstown Rd, 21117 Owings Mills",
    "email": null,
    "phone": "4109028700",
    "website": null,
    "coords": {
      "lat": 39.40545654296875,
      "lng": -76.7601547241211
    }
  },
  {
    "id": "43381_2",
    "name": "BMW of Louisville, Certified Collision Repair Center",
    "country": "US",
    "city": "Louisville",
    "address": "4 Autocenter Dr, 40299 Louisville",
    "email": null,
    "phone": "5024933370",
    "website": null,
    "coords": {
      "lat": 38.2169189453125,
      "lng": -85.5794906616211
    }
  },
  {
    "id": "34537_2",
    "name": "BMW of Mobile, Certified Collision Repair Center",
    "country": "US",
    "city": "Mobile",
    "address": "3025 Government Blvd, 36606 Mobile",
    "email": null,
    "phone": "8665204797",
    "website": null,
    "coords": {
      "lat": 30.65577507019043,
      "lng": -88.11573791503906
    }
  },
  {
    "id": "93777_2",
    "name": "Bert Smith International, Certified Collision Repair Center",
    "country": "US",
    "city": "Saint Petersburg",
    "address": "3800 34th St. North, 33714 Saint Petersburg",
    "email": null,
    "phone": "7275271111",
    "website": null,
    "coords": {
      "lat": 27.807077407836914,
      "lng": -82.68038940429688
    }
  },
  {
    "id": "27600_50001",
    "name": "Performance Collision Center, Independent Certified Collision Repair Center of Dreyer & Reinbold, Inc.",
    "country": "US",
    "city": "Zionsville",
    "address": "10710 Nottingham Way, 46077 Zionsville",
    "email": null,
    "phone": "3177332758",
    "website": null,
    "coords": {
      "lat": 39.942138671875,
      "lng": -86.24040222167969
    }
  },
  {
    "id": "50498_50001",
    "name": "AutoMark Collision Center Rochester Hills, Independent Certified Collision Repair Center of BMW of Rochester Hills",
    "country": "US",
    "city": "Rochester Hills",
    "address": "1300 West Hamlin Road, 48309 Rochester Hills",
    "email": null,
    "phone": "2485943323",
    "website": null,
    "coords": {
      "lat": 42.652191162109375,
      "lng": -83.16024780273438
    }
  },
  {
    "id": "29672_2",
    "name": "BMW of Des Moines, Certified Collision Repair Center",
    "country": "US",
    "city": "Urbandale",
    "address": "9943 Hickman Road #107, 50322 Urbandale",
    "email": null,
    "phone": "8773312413",
    "website": null,
    "coords": {
      "lat": 41.61727523803711,
      "lng": -93.75284576416016
    }
  },
  {
    "id": "25786_50001",
    "name": "Hourglass Collision Repair South, Independent Certified Collision Repair Center of BMW of Tulsa",
    "country": "US",
    "city": "Tulsa",
    "address": "10226 E 61st Street, 74133 Tulsa",
    "email": null,
    "phone": "9186156000",
    "website": null,
    "coords": {
      "lat": 36.07500076293945,
      "lng": -95.86163330078125
    }
  },
  {
    "id": "35071_50001",
    "name": "Gerber Collision Edmond, Independent Certified Collision Repair Center of Jackie Cooper Imports",
    "country": "US",
    "city": "Edmond",
    "address": "3730 NW 166th St, 73012 Edmond",
    "email": null,
    "phone": "4054936240",
    "website": null,
    "coords": {
      "lat": 35.640628814697266,
      "lng": -97.58649444580078
    }
  },
  {
    "id": "53171_50001",
    "name": "Lamettry's Collision, Independent Certified Collision Repair Center of BMW of Minnetonka",
    "country": "US",
    "city": "Chanhassen",
    "address": "1650 Motorplex Ct, 55317 Chanhassen",
    "email": null,
    "phone": "9524057300",
    "website": null,
    "coords": {
      "lat": 44.856563568115234,
      "lng": -93.5624771118164
    }
  },
  {
    "id": "44235_50001",
    "name": "Caliber Collision Onion Creek, Independent Certified Collision Repair Center of BMW of South Austin",
    "country": "US",
    "city": "Austin",
    "address": "11210 S. IH 35, 78748 Austin",
    "email": null,
    "phone": "5124652557",
    "website": null,
    "coords": {
      "lat": 30.206453323364258,
      "lng": -97.75826263427734
    }
  },
  {
    "id": "36270_2",
    "name": "BMW of El Paso, Certified Collision Repair Center",
    "country": "US",
    "city": "El Paso",
    "address": "11351 Gateway West, 79936 El Paso",
    "email": null,
    "phone": "9156294530",
    "website": null,
    "coords": {
      "lat": 31.7311954498291,
      "lng": -106.31526184082031
    }
  },
  {
    "id": "42164_1",
    "name": "BMW of San Antonio, Certified Collision Repair Center",
    "country": "US",
    "city": "San Antonio",
    "address": "15507 West Interstate 10, 78249 San Antonio",
    "email": null,
    "phone": "2104773132",
    "website": null,
    "coords": {
      "lat": 29.583709716796875,
      "lng": -98.59559631347656
    }
  },
  {
    "id": "53089_1",
    "name": "BMW of Beaumont, Certified Collision Repair Center",
    "country": "US",
    "city": "Beaumont",
    "address": "3760 Corley Ave, 77701 Beaumont",
    "email": null,
    "phone": "4092122070",
    "website": null,
    "coords": {
      "lat": 30.061609268188477,
      "lng": -94.13279724121094
    }
  },
  {
    "id": "45289_50002",
    "name": "Caliber Magnolia, Independent Certified Collision Repair Center of BMW of The Woodlands",
    "country": "US",
    "city": "Magnolia",
    "address": "9605 FM 1488, 77354 Magnolia",
    "email": null,
    "phone": "3467034511",
    "website": null,
    "coords": {
      "lat": 30.221609115600586,
      "lng": -95.61195373535156
    }
  },
  {
    "id": "05080_50002",
    "name": "SVE Auto Body, Independent Certified Collision Repair Center of Gebhardt BMW",
    "country": "US",
    "city": "Broomfield",
    "address": "465 Alter St, 80020 Broomfield",
    "email": null,
    "phone": "3034666717",
    "website": null,
    "coords": {
      "lat": 39.92388153076172,
      "lng": -105.09246063232422
    }
  },
  {
    "id": "10729_3",
    "name": "Chapman BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Tempe",
    "address": "5301 S Kyrene Rd, 85283 Tempe",
    "email": null,
    "phone": "4809498959",
    "website": null,
    "coords": {
      "lat": 33.37541198730469,
      "lng": -111.94478607177734
    }
  },
  {
    "id": "38859_50001",
    "name": "Auto Collision Group Ontario",
    "country": "US",
    "city": "Ontario",
    "address": "955 Brooks St, 91762 Ontario",
    "email": null,
    "phone": "9097801400",
    "website": null,
    "coords": {
      "lat": 34.06135177612305,
      "lng": -117.66767883300781
    }
  },
  {
    "id": "21390_50001",
    "name": "AW Collision Beverly Hills, Independent Certified Collision Repair Center of Beverly Hills BMW",
    "country": "US",
    "city": "Los Angeles",
    "address": "1716 S La Cienega Blvd, 90035 Los Angeles",
    "email": null,
    "phone": "4242538300",
    "website": null,
    "coords": {
      "lat": 34.046669006347656,
      "lng": -118.37574005126953
    }
  },
  {
    "id": "76837_1",
    "name": "Pacific BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Glendale",
    "address": "901 S. Brand Blvd, 91204 Glendale",
    "email": null,
    "phone": "8186912590",
    "website": null,
    "coords": {
      "lat": 34.13551712036133,
      "lng": -118.25537872314453
    }
  },
  {
    "id": "47046_50001",
    "name": "City Collision Center, Independent Certified Collision Repair Center of BMW of Buena Park",
    "country": "US",
    "city": "Stanton",
    "address": "8250 Cerritos Ave, 90680 Stanton",
    "email": null,
    "phone": "7148289119",
    "website": null,
    "coords": {
      "lat": 33.810001373291016,
      "lng": -117.98857116699219
    }
  },
  {
    "id": "31643_50001",
    "name": "AW Collision of Long Beach, Independent Certified Collision Repair Center of Long Beach BMW",
    "country": "US",
    "city": "Lakewood",
    "address": "2400 E Carson St, 90712 Lakewood",
    "email": null,
    "phone": "5622944990",
    "website": null,
    "coords": {
      "lat": 33.83259963989258,
      "lng": -118.16265106201172
    }
  },
  {
    "id": "50070_50001",
    "name": "Ozzie's Body Shop, Independent Certified Collision Repair Center of BMW of Loveland",
    "country": "US",
    "city": "Loveland",
    "address": "5280 North Garfield Ave, 80538 Loveland",
    "email": null,
    "phone": "9706677849",
    "website": null,
    "coords": {
      "lat": 40.44738006591797,
      "lng": -105.07672119140625
    }
  },
  {
    "id": "46886_1",
    "name": "Arrowhead BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Glendale",
    "address": "19400 North 101 Loop, 85308 Glendale",
    "email": null,
    "phone": "6026135118",
    "website": null,
    "coords": {
      "lat": 33.66307067871094,
      "lng": -112.23542022705078
    }
  },
  {
    "id": "04637_50001",
    "name": "Precision Auto Body, Independent Certified Collision Repair Center of Bob Smith BMW",
    "country": "US",
    "city": "Reseda",
    "address": "7654 Tampa Ave, 91335 Reseda",
    "email": null,
    "phone": "8188887654",
    "website": null,
    "coords": {
      "lat": 34.21158981323242,
      "lng": -118.55647277832031
    }
  },
  {
    "id": "52781_50004",
    "name": "Prestige Bodyworks, Independent Certified Collision Repair Center of BMW of Camarillo",
    "country": "US",
    "city": "Oxnard",
    "address": "4121 Southbank Road, 93036 Oxnard",
    "email": null,
    "phone": "8054857222",
    "website": null,
    "coords": {
      "lat": 34.25531005859375,
      "lng": -119.16236114501953
    }
  },
  {
    "id": "44427_50003",
    "name": "Ben Clymer's The Body Shop Palm Desert, Independent Certified Collision Repair Center of BMW of Palm Springs",
    "country": "US",
    "city": "Palm Desert",
    "address": "73725 Dinah Shore Drive, 92211 Palm Desert",
    "email": null,
    "phone": "7606567600",
    "website": null,
    "coords": {
      "lat": 33.79658889770508,
      "lng": -116.3775863647461
    }
  },
  {
    "id": "32652_50001",
    "name": "Autobahn Collision Center, Independent Certified Collision Repair Center of Peter Pan BMW",
    "country": "US",
    "city": "Belmont",
    "address": "500 Harbor Blvd., 94002 Belmont",
    "email": null,
    "phone": "6505916800",
    "website": null,
    "coords": {
      "lat": 37.519737243652344,
      "lng": -122.2693862915039
    }
  },
  {
    "id": "22820_50003",
    "name": "Caliber Collision, Independent Certified Collision Repair Center of BMW of San Luis Obispo",
    "country": "US",
    "city": "San Luis Obispo",
    "address": "139 Granada Ave, 93401 San Luis Obispo",
    "email": null,
    "phone": "8055418781",
    "website": null,
    "coords": {
      "lat": 35.251129150390625,
      "lng": -120.6700210571289
    }
  },
  {
    "id": "26718_50002",
    "name": "Gerber Collision & Glass Goleta, Independent Certified Collision Repair Center of BMW Santa Barbara",
    "country": "US",
    "city": "Goleta",
    "address": "57 S. Fairview Ave, 93117 Goleta",
    "email": null,
    "phone": "8056834711",
    "website": null,
    "coords": {
      "lat": 34.43815994262695,
      "lng": -119.83084869384766
    }
  },
  {
    "id": "10731_50003",
    "name": "B&S Hacienda Auto Body, Independent Certified Collision Repair Center of East Bay BMW",
    "country": "US",
    "city": "San Ramon",
    "address": "2250 San Ramon Valley Blvd, 94583 San Ramon",
    "email": null,
    "phone": "9253092540",
    "website": null,
    "coords": {
      "lat": 37.78079605102539,
      "lng": -121.97791290283203
    }
  },
  {
    "id": "04497_3",
    "name": "BMW Concord, Certified Collision Repair Center",
    "country": "US",
    "city": "Concord",
    "address": "1321 Galaxy Way Ste B, 94520 Concord",
    "email": null,
    "phone": "9256823577",
    "website": null,
    "coords": {
      "lat": 37.97697067260742,
      "lng": -122.04902648925781
    }
  },
  {
    "id": "21616_50001",
    "name": "All Foreign and Domestic Body Shop, Independent Certified Collision Repair Center of Valley BMW",
    "country": "US",
    "city": "Stockton",
    "address": "1917 Navy Drive, 95206 Stockton",
    "email": null,
    "phone": "2094624444",
    "website": null,
    "coords": {
      "lat": 37.93872833251953,
      "lng": -121.31568145751953
    }
  },
  {
    "id": "30822_50001",
    "name": "Watsonville Auto Body, Independent Certified Collision Repair Center of BMW of Monterey",
    "country": "US",
    "city": "Freedom",
    "address": "107 Airport Blvd, 95019 Freedom",
    "email": null,
    "phone": "8319200743",
    "website": null,
    "coords": {
      "lat": 36.93711853027344,
      "lng": -121.77832794189453
    }
  },
  {
    "id": "24336_50001",
    "name": "Haury's Collision, Independent Certified Collision Repair Center of BMW Seattle",
    "country": "US",
    "city": "Seattle",
    "address": "11514 Lake City Way NE, 98125 Seattle",
    "email": null,
    "phone": "2063651565",
    "website": null,
    "coords": {
      "lat": 47.712501525878906,
      "lng": -122.29882049560547
    }
  },
  {
    "id": "23805_02",
    "name": "BMW of Fort Walton Beach",
    "country": "US",
    "city": "Fort Walton Beach",
    "address": "1006 N. Beal Pkwy, 32547 Fort Walton Beach",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 30.453596115112305,
      "lng": -86.63912200927734
    }
  },
  {
    "id": "54314_01",
    "name": "BMW of Wichita Falls",
    "country": "US",
    "city": "Wichita Falls",
    "address": "315 Central Fwy E, 76301 Wichita Falls",
    "email": null,
    "phone": "9407660293",
    "website": null,
    "coords": {
      "lat": 33.889522552490234,
      "lng": -98.4869155883789
    }
  },
  {
    "id": "43005_3",
    "name": "BMW of Springfield, Certified Collision Repair Center",
    "country": "US",
    "city": "Springfield",
    "address": "5 Cornell Pkwy #C, 07081 Springfield",
    "email": null,
    "phone": "9735649300",
    "website": null,
    "coords": {
      "lat": 40.68354797363281,
      "lng": -74.33234405517578
    }
  },
  {
    "id": "20173_50001",
    "name": "Airport Road Auto Body, Independent Certified Collision Repair Center of New Country BMW",
    "country": "US",
    "city": "Hartford",
    "address": "75 Locust St, 06114 Hartford",
    "email": null,
    "phone": "8602962639",
    "website": null,
    "coords": {
      "lat": 41.747982025146484,
      "lng": -72.66443634033203
    }
  },
  {
    "id": "20989_50002",
    "name": "Superior Auto Body, Independent Certified Collision Repair Center of Orange County BMW",
    "country": "US",
    "city": "Montgomery",
    "address": "2106 NY-208, 12549 Montgomery",
    "email": null,
    "phone": "8454575500",
    "website": null,
    "coords": {
      "lat": 41.516109466552734,
      "lng": -74.20735168457031
    }
  },
  {
    "id": "40305_2",
    "name": "BMW of Catonsville, Certified Collision Repair Center",
    "country": "US",
    "city": "Baltimore",
    "address": "1501 S Caton Ave, 21227 Baltimore",
    "email": null,
    "phone": "4105251000",
    "website": null,
    "coords": {
      "lat": 39.262184143066406,
      "lng": -76.66529083251953
    }
  },
  {
    "id": "25244_1",
    "name": "Checkered Flag BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Virginia Beach",
    "address": "5225 Virginia Beach Blvd, 23462 Virginia Beach",
    "email": null,
    "phone": "7576873540",
    "website": null,
    "coords": {
      "lat": 36.84733200073242,
      "lng": -76.16217041015625
    }
  },
  {
    "id": "26776_1",
    "name": "BMW of Doylestown, Certified Collision Repair Center",
    "country": "US",
    "city": "Plumsteadville",
    "address": "6175 Easton Rod, 18949 Plumsteadville",
    "email": null,
    "phone": "2157661900",
    "website": null,
    "coords": {
      "lat": 40.394920349121094,
      "lng": -75.1478271484375
    }
  },
  {
    "id": "50644_50001",
    "name": "Classic Coachwork, Independent Certified Collision Repair Center of BMW of Fort Washington",
    "country": "US",
    "city": "Ambler",
    "address": "125 West Butler Pike, 19002 Ambler",
    "email": null,
    "phone": "2156467887",
    "website": null,
    "coords": {
      "lat": 40.15290069580078,
      "lng": -75.22650909423828
    }
  },
  {
    "id": "21470_50001",
    "name": "Eagle Body Works, Independent Certified Collision Repair Center of Century BMW",
    "country": "US",
    "city": "Greenville",
    "address": "810 Mauldin Road, 29607 Greenville",
    "email": null,
    "phone": "8642776051",
    "website": null,
    "coords": {
      "lat": 34.78213882446289,
      "lng": -82.35124969482422
    }
  },
  {
    "id": "26540_50002",
    "name": "Athens Collision Center, Independent Certified Collision Repair Center of Athens BMW",
    "country": "US",
    "city": "Athens",
    "address": "135 Old Monroe Road, 30606 Athens",
    "email": null,
    "phone": "8889749495",
    "website": null,
    "coords": {
      "lat": 33.93960952758789,
      "lng": -83.49855041503906
    }
  },
  {
    "id": "24987_3",
    "name": "Laurel BMW of Westmont, Certified Collision Repair Center",
    "country": "US",
    "city": "Westmont",
    "address": "433 Plaza Dr, 60559 Westmont",
    "email": null,
    "phone": "6303320444",
    "website": null,
    "coords": {
      "lat": 41.81079864501953,
      "lng": -87.96331024169922
    }
  },
  {
    "id": "76504_50001",
    "name": "Custom Automotive Colors, Independent Certified Collision Repair Center of Brian Harris BMW",
    "country": "US",
    "city": "Baton Rouge",
    "address": "11550 Cloverland Ave, 70809 Baton Rouge",
    "email": null,
    "phone": "2257525947",
    "website": null,
    "coords": {
      "lat": 30.391010284423828,
      "lng": -91.0519790649414
    }
  },
  {
    "id": "86773_2",
    "name": "BMW of Huntsville, Certified Collision Repair Center",
    "country": "US",
    "city": "Huntsville",
    "address": "1008 Jordan Ln, 35816 Huntsville",
    "email": null,
    "phone": "2567130183",
    "website": null,
    "coords": {
      "lat": 34.73567199707031,
      "lng": -86.62301635742188
    }
  },
  {
    "id": "47727_50001",
    "name": "Crash Champions LUXE | EV, Independent Certified Collision Repair Center of BMW of Ocala",
    "country": "US",
    "city": "Belleview",
    "address": "4828 SE 102nd Place, 34420 Belleview",
    "email": null,
    "phone": "3522455551",
    "website": null,
    "coords": {
      "lat": 29.072608947753906,
      "lng": -82.06817626953125
    }
  },
  {
    "id": "52126_50001",
    "name": "International Body Shop, Independent Certified Collision Repair Center of BMW of Elmhurst",
    "country": "US",
    "city": "Elmhurst",
    "address": "652 W. Lake St, 60126 Elmhurst",
    "email": null,
    "phone": "6308344018",
    "website": null,
    "coords": {
      "lat": 41.9213981628418,
      "lng": -87.96206665039062
    }
  },
  {
    "id": "43384_50001",
    "name": "Unique Collision Center, Independent Certified Collision Repair Center of Galleria BMW",
    "country": "US",
    "city": "Gulfport",
    "address": "3550 13th Ave, 39501 Gulfport",
    "email": null,
    "phone": "2288635944",
    "website": null,
    "coords": {
      "lat": 30.39400291442871,
      "lng": -89.07767486572266
    }
  },
  {
    "id": "31833_2",
    "name": "BMW of Northwest Arkansas, Certified Collision Repair Center",
    "country": "US",
    "city": "Rogers",
    "address": "2104 S 8th St, 72758 Rogers",
    "email": null,
    "phone": "8665132525",
    "website": null,
    "coords": {
      "lat": 36.30500793457031,
      "lng": -94.12760925292969
    }
  },
  {
    "id": "26731_50001",
    "name": "JP Auto Collision, Independent Certified Collision Repair Center of BMW of Dallas",
    "country": "US",
    "city": "Garland",
    "address": "414 South Yale Dr, 75042 Garland",
    "email": null,
    "phone": "9452164988",
    "website": null,
    "coords": {
      "lat": 32.909889221191406,
      "lng": -96.69185638427734
    }
  },
  {
    "id": "48401_50001",
    "name": "Loid's Collision Center, Independent Certified Collision Repair Center of Sandia BMW",
    "country": "US",
    "city": "Albuquerque",
    "address": "5401 San Diego Rd NE, 87113 Albuquerque",
    "email": null,
    "phone": "8556742856",
    "website": null,
    "coords": {
      "lat": 35.19325637817383,
      "lng": -106.58319091796875
    }
  },
  {
    "id": "46886_50004",
    "name": "Unlimited Collision, Independent Certified Collision Repair Center of Arrowhead BMW",
    "country": "US",
    "city": "Litchfield Park",
    "address": "6030 N Litchfield Road #2, 85340 Litchfield Park",
    "email": null,
    "phone": "6239797565",
    "website": null,
    "coords": {
      "lat": 33.5230598449707,
      "lng": -112.35816192626953
    }
  },
  {
    "id": "20741_50002",
    "name": "Carstar Automotive Collision Services, Independent Certified Collision Repair Center of BMW North Scottsdale",
    "country": "US",
    "city": "Phoenix",
    "address": "1700 E Robin Lane, 85024 Phoenix",
    "email": null,
    "phone": "4806999400",
    "website": null,
    "coords": {
      "lat": 33.69081115722656,
      "lng": -112.04620361328125
    }
  },
  {
    "id": "21294_50002",
    "name": "Updated Auto - Henderson, Independent Certified Collision Repair Center of BMW of Las Vegas",
    "country": "US",
    "city": "Henderson",
    "address": "710 Susanna Way, 89011 Henderson",
    "email": null,
    "phone": "7025659339",
    "website": null,
    "coords": {
      "lat": 36.066619873046875,
      "lng": -115.02307891845703
    }
  },
  {
    "id": "55806_50002",
    "name": "Cascade Collision Orem, Independent Certified Collision Repair Center of BMW of Murray",
    "country": "US",
    "city": "Orem",
    "address": "1005 N State, 84057 Orem",
    "email": null,
    "phone": "8012248020",
    "website": null,
    "coords": {
      "lat": 40.31589126586914,
      "lng": -111.70332336425781
    }
  },
  {
    "id": "47993_50004",
    "name": "Park Place Bodywerks, Independent Certified Collision Repair Center of Autobahn Motorcars",
    "country": "US",
    "city": "Fort Worth",
    "address": "5760 Bryant Irvin Road, 76132 Fort Worth",
    "email": null,
    "phone": "8172633965",
    "website": null,
    "coords": {
      "lat": 32.664878845214844,
      "lng": -97.4223403930664
    }
  },
  {
    "id": "39314_50001",
    "name": "Rickenbaugh Collision, Independent Certified Collision Repair Center of BMW of Denver Downtown",
    "country": "US",
    "city": "Denver",
    "address": "444 Kalamath St, 80203 Denver",
    "email": null,
    "phone": "3035714443",
    "website": null,
    "coords": {
      "lat": 39.72328567504883,
      "lng": -105.00010681152344
    }
  },
  {
    "id": "45533_50001",
    "name": "Caliber Collision, Independent Certified Collision Repair Center of BMW of the Permian Basin",
    "country": "US",
    "city": "Odessa",
    "address": "2381 Field St, 79761 Odessa",
    "email": null,
    "phone": "4324980152",
    "website": null,
    "coords": {
      "lat": 31.861169815063477,
      "lng": -102.33711242675781
    }
  },
  {
    "id": "11010_1",
    "name": "Peterson BMW of Boise, Certified Collision Repair Center",
    "country": "US",
    "city": "Boise",
    "address": "1450 N Kimball St, 83704 Boise",
    "email": null,
    "phone": "2083789030",
    "website": null,
    "coords": {
      "lat": 43.617919921875,
      "lng": -116.29915618896484
    }
  },
  {
    "id": "21390_50002",
    "name": "Carstar Lucky Body Shop, Independent Certified Collision Repair Center of Beverly Hills BMW",
    "country": "US",
    "city": "Los Angeles",
    "address": "2501 James M Wood Blvd, 90006 Los Angeles",
    "email": null,
    "phone": "2133656000",
    "website": null,
    "coords": {
      "lat": 34.055450439453125,
      "lng": -118.28324890136719
    }
  },
  {
    "id": "35744_50002",
    "name": "Faith Quality Auto Body, Independent Certified Collision Repair Center of BMW of Murrieta",
    "country": "US",
    "city": "Murrieta",
    "address": "41108 Nick Lane, 92562 Murrieta",
    "email": null,
    "phone": "9516988215",
    "website": null,
    "coords": {
      "lat": 33.53562927246094,
      "lng": -117.17350769042969
    }
  },
  {
    "id": "24856_50002",
    "name": "Ariana Auto Body, Independent Certified Collision Repair Center of BMW of Fremont",
    "country": "US",
    "city": "Newark",
    "address": "8145 Enterprise Drive, Suite F, 94560 Newark",
    "email": null,
    "phone": "9259978457",
    "website": null,
    "coords": {
      "lat": 37.52207946777344,
      "lng": -122.04563903808594
    }
  },
  {
    "id": "21188_50001",
    "name": "Caliber Collision Irvine, Independent Certified Collision Repair Center of Irvine BMW",
    "country": "US",
    "city": "Irvine",
    "address": "7 Oldfield, 92618 Irvine",
    "email": null,
    "phone": "9493305200",
    "website": null,
    "coords": {
      "lat": 33.634918212890625,
      "lng": -117.7188720703125
    }
  },
  {
    "id": "36269_2",
    "name": "Autonation Collision Center Stevens Creek",
    "country": "US",
    "city": "Santa Clara",
    "address": "4201 Stevens Creek Blvd Suite C, 95051 Santa Clara",
    "email": null,
    "phone": "4085122836",
    "website": null,
    "coords": {
      "lat": 37.324119567871094,
      "lng": -121.97564697265625
    }
  },
  {
    "id": "22083_50001",
    "name": "AW Collision of San Jose, Independent Certified Collision Repair Center of Stevens Creek BMW",
    "country": "US",
    "city": "San Jose",
    "address": "1729 Junction Avenue, 95112 San Jose",
    "email": null,
    "phone": "4083921200",
    "website": null,
    "coords": {
      "lat": 37.37508010864258,
      "lng": -121.9059829711914
    }
  },
  {
    "id": "86513_50003",
    "name": "Beach Collision, Independent Certified Collision Repair Center of Sterling BMW",
    "country": "US",
    "city": "Huntington Beach",
    "address": "18042 Gothard Street, 92648 Huntington Beach",
    "email": null,
    "phone": "7148473499",
    "website": null,
    "coords": {
      "lat": 33.70106887817383,
      "lng": -117.99964141845703
    }
  },
  {
    "id": "35687_1",
    "name": "Marin Collision Center",
    "country": "US",
    "city": "Corte Madera",
    "address": "5880 Paradise Drive, 94925 Corte Madera",
    "email": null,
    "phone": "4158434292",
    "website": null,
    "coords": {
      "lat": 37.926029205322266,
      "lng": -122.51207733154297
    }
  },
  {
    "id": "24336_50003",
    "name": "Pacific Auto Body, Independent Certified Collision Repair Center of BMW Seattle",
    "country": "US",
    "city": "Seattle",
    "address": "2400 Airport Way South, 98134 Seattle",
    "email": null,
    "phone": "2062079545",
    "website": null,
    "coords": {
      "lat": 47.58177185058594,
      "lng": -122.32083892822266
    }
  },
  {
    "id": "51049_01",
    "name": "BMW of Farmington Hills",
    "country": "US",
    "city": "Farmington Hills",
    "address": "38700 Grand River Ave, 48335 Farmington Hills",
    "email": null,
    "phone": "2483066800",
    "website": "https://www.bmwfarmingtonhills.com",
    "coords": {
      "lat": 42.470340728759766,
      "lng": -83.42668914794922
    }
  },
  {
    "id": "21234_04",
    "name": "BMW Certified Pre-Owned Nashville",
    "country": "US",
    "city": "Nashville",
    "address": "4040 Armory Oaks Drive, 37204 Nashville",
    "email": null,
    "phone": "6158504040",
    "website": null,
    "coords": {
      "lat": 36.10421371459961,
      "lng": -86.76078796386719
    }
  },
  {
    "id": "10742_2",
    "name": "Autogermana BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Rio Piedras",
    "address": "1090 Ave Munoz Rivera, 00927 Rio Piedras",
    "email": null,
    "phone": "7872002818",
    "website": null,
    "coords": {
      "lat": 18.399789810180664,
      "lng": -66.05628967285156
    }
  },
  {
    "id": "41518_50002",
    "name": "Finish Line Collision, Independent Certified Collision Repair Center of BMW of Freeport",
    "country": "US",
    "city": "Valley Stream",
    "address": "21 Railroad Avenue, 11580 Valley Stream",
    "email": null,
    "phone": "5162562666",
    "website": null,
    "coords": {
      "lat": 40.66305923461914,
      "lng": -73.68952178955078
    }
  },
  {
    "id": "51008_50002",
    "name": "Highway Auto Body, Independent Certified Collision Repair Center of BMW of Rockland",
    "country": "US",
    "city": "Rockland",
    "address": "195 VFW Drive, 02370 Rockland",
    "email": null,
    "phone": "7818712345",
    "website": null,
    "coords": {
      "lat": 42.14823913574219,
      "lng": -70.9160385131836
    }
  },
  {
    "id": "21102_50001",
    "name": "Bridgewater Collision Repair, Independent Certified Collision Repair Center of BMW of Bridgewater",
    "country": "US",
    "city": "Bridgewater",
    "address": "208 Route 28, 08807 Bridgewater",
    "email": null,
    "phone": "9085260176",
    "website": null,
    "coords": {
      "lat": 40.59846115112305,
      "lng": -74.67131805419922
    }
  },
  {
    "id": "23418_50001",
    "name": "Flemington Auto Body, Independent Certified Collision Repair Center of Flemington BMW",
    "country": "US",
    "city": "Flemington",
    "address": "212 Route 202, 08822 Flemington",
    "email": null,
    "phone": "9087824217",
    "website": null,
    "coords": {
      "lat": 40.48719787597656,
      "lng": -74.861572265625
    }
  },
  {
    "id": "53850_1",
    "name": "BMW of Allentown, Certified Collision Repair Center",
    "country": "US",
    "city": "Allentown",
    "address": "1327 W Tilghman St, 18102 Allentown",
    "email": null,
    "phone": "6108202950",
    "website": null,
    "coords": {
      "lat": 40.60810089111328,
      "lng": -75.48999786376953
    }
  },
  {
    "id": "21614_2",
    "name": "BMW of the Hudson Valley, Certified Collision Repair Center",
    "country": "US",
    "city": "Poughkeepsie",
    "address": "2068 South Rd, 12601 Poughkeepsie",
    "email": null,
    "phone": "8778451571",
    "website": null,
    "coords": {
      "lat": 41.6312141418457,
      "lng": -73.91537475585938
    }
  },
  {
    "id": "49851_50001",
    "name": "Carstar Centreville Collision Center, Independent Certified Collision Repair Center of BMW of Sterling",
    "country": "US",
    "city": "Chantilly",
    "address": "14805 Willard Road, 20151 Chantilly",
    "email": null,
    "phone": "7036570070",
    "website": null,
    "coords": {
      "lat": 38.88869094848633,
      "lng": -77.45957946777344
    }
  },
  {
    "id": "46778_4",
    "name": "Tom Bush BMW Jacksonville, Certified Collision Repair Center",
    "country": "US",
    "city": "Jacksonville",
    "address": "9750 Regency Square Boulevard, 32225 Jacksonville",
    "email": null,
    "phone": "9047431144",
    "website": null,
    "coords": {
      "lat": 30.325849533081055,
      "lng": -81.545166015625
    }
  },
  {
    "id": "51009_4",
    "name": "BMW of Towson, Certified Collision Repair Center",
    "country": "US",
    "city": "Towson",
    "address": "803 Gleneagles Court, 21286 Towson",
    "email": null,
    "phone": "4108233400",
    "website": null,
    "coords": {
      "lat": 39.40203857421875,
      "lng": -76.57227325439453
    }
  },
  {
    "id": "46586_1",
    "name": "BMW of Delray Beach, Certified Collision Repair Center",
    "country": "US",
    "city": "Delray Beach",
    "address": "1475 SW 4th Ave, 33444 Delray Beach",
    "email": null,
    "phone": "5614541510",
    "website": null,
    "coords": {
      "lat": 26.441930770874023,
      "lng": -80.07598114013672
    }
  },
  {
    "id": "21851_2",
    "name": "BMW of Birmingham, Certified Collision Repair Center",
    "country": "US",
    "city": "Irondale",
    "address": "2001 Tom Williams Way, 35210 Irondale",
    "email": null,
    "phone": "8005450142",
    "website": null,
    "coords": {
      "lat": 33.520530700683594,
      "lng": -86.66375732421875
    }
  },
  {
    "id": "53086_1",
    "name": "BMW of Coconut Creek, Certified Collision Repair Center",
    "country": "US",
    "city": "Coconut Creek",
    "address": "4401 W Sample Rd, 33073 Coconut Creek",
    "email": null,
    "phone": "9549352690",
    "website": null,
    "coords": {
      "lat": 26.274688720703125,
      "lng": -80.18452453613281
    }
  },
  {
    "id": "20626_3",
    "name": "Braman BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Miami",
    "address": "151 NE 20th Terrace, 33137 Miami",
    "email": null,
    "phone": "3055711240",
    "website": null,
    "coords": {
      "lat": 25.79618263244629,
      "lng": -80.1920166015625
    }
  },
  {
    "id": "51106_2",
    "name": "BMW of Bloomfield Hills, Certified Collision Repair Center",
    "country": "US",
    "city": "Bloomfield Hills",
    "address": "1845 S. Telegraph, 48302 Bloomfield Hills",
    "email": null,
    "phone": "2487800775",
    "website": null,
    "coords": {
      "lat": 42.61259841918945,
      "lng": -83.30660247802734
    }
  },
  {
    "id": "20741_50004",
    "name": "Penske Collision Arizona, Independent Certified Collision Repair Center of BMW North Scottsdale",
    "country": "US",
    "city": "Scottsdale",
    "address": "350 Hayden Road, 85257 Scottsdale",
    "email": null,
    "phone": "4809418800",
    "website": null,
    "coords": {
      "lat": 33.45240020751953,
      "lng": -111.90936279296875
    }
  },
  {
    "id": "31015_3",
    "name": "Baron BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Merriam",
    "address": "6231 Mastin St., 66203 Merriam",
    "email": null,
    "phone": "9136711350",
    "website": null,
    "coords": {
      "lat": 39.01628494262695,
      "lng": -94.70216369628906
    }
  },
  {
    "id": "24336_50002",
    "name": "Metro Auto Rebuild, Independent Certified Collision Repair Center of BMW Seattle",
    "country": "US",
    "city": "Seattle",
    "address": "2218 Airport Way S #2, 90134 Seattle",
    "email": null,
    "phone": "2066236336",
    "website": null,
    "coords": {
      "lat": 47.58335876464844,
      "lng": -122.32087707519531
    }
  },
  {
    "id": "47724_50003",
    "name": "Premier Collision Collision, Independent Certified Collision Repair Center of BMW of Sherman Oaks",
    "country": "US",
    "city": "Northridge",
    "address": "8612 Darby Ave, 91325 Northridge",
    "email": null,
    "phone": "8183491800",
    "website": null,
    "coords": {
      "lat": 34.226890563964844,
      "lng": -118.53382110595703
    }
  },
  {
    "id": "86716_3",
    "name": "Patrick BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Schaumburg",
    "address": "534 Mall Dr, 60173 Schaumburg",
    "email": null,
    "phone": "8472308298",
    "website": null,
    "coords": {
      "lat": 42.04011917114258,
      "lng": -88.03977966308594
    }
  },
  {
    "id": "53171_50002",
    "name": "LaMettry's Collision Minnetonka, Independent Certified Collision Repair Center of BMW of Minnetonka",
    "country": "US",
    "city": "Minnetonka",
    "address": "13600 County Road 62, 55345 Minnetonka",
    "email": null,
    "phone": "9524000131",
    "website": null,
    "coords": {
      "lat": 44.89282989501953,
      "lng": -93.4532470703125
    }
  },
  {
    "id": "23968_50001",
    "name": "Benishek & Will, Independent Certified Collision Repair Center of BMW of Peoria",
    "country": "US",
    "city": "Peoria",
    "address": "8711 N. Industrial Road, 61615 Peoria",
    "email": null,
    "phone": "3096933444",
    "website": null,
    "coords": {
      "lat": 40.79374313354492,
      "lng": -89.62802124023438
    }
  },
  {
    "id": "66641_1",
    "name": "Voss Village BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Dayton",
    "address": "650 Miamisburg Centerville Rd, 45459 Dayton",
    "email": null,
    "phone": "9374334811",
    "website": null,
    "coords": {
      "lat": 39.62701416015625,
      "lng": -84.17549896240234
    }
  },
  {
    "id": "21181_2",
    "name": "Plaza Motor Company, Certified Collision Repair Center",
    "country": "US",
    "city": "Saint Louis",
    "address": "11820 Lackland Rd, 63146 Saint Louis",
    "email": null,
    "phone": "3143011704",
    "website": null,
    "coords": {
      "lat": 38.696834564208984,
      "lng": -90.43488311767578
    }
  },
  {
    "id": "63766_2",
    "name": "BMW of Madison, Certified Collision Repair Center",
    "country": "US",
    "city": "Madison",
    "address": "1707 N. Stoughton Rd, 53704 Madison",
    "email": null,
    "phone": "6084435770",
    "website": null,
    "coords": {
      "lat": 43.121463775634766,
      "lng": -89.32367706298828
    }
  },
  {
    "id": "24335_50001",
    "name": "Fix Auto Poway, Independent Certified Collision Repair Center of BMW of San Diego",
    "country": "US",
    "city": "Poway",
    "address": "13175 Gregg St, 92064 Poway",
    "email": null,
    "phone": "8588423075",
    "website": null,
    "coords": {
      "lat": 32.93709182739258,
      "lng": -117.04345703125
    }
  },
  {
    "id": "55806_50001",
    "name": "Alpine Auto Restoration, Independent Certified Collision Repair Center of BMW of Murray",
    "country": "US",
    "city": "Salt Lake City",
    "address": "3270 S. 1100 W, 84119 Salt Lake City",
    "email": null,
    "phone": "8013648276",
    "website": null,
    "coords": {
      "lat": 40.70057678222656,
      "lng": -111.93901824951172
    }
  },
  {
    "id": "52309_50002",
    "name": "Chris Amato's Body Werks, Independent Certified Collision Repair Center of BMW of Carlsbad",
    "country": "US",
    "city": "Oceanside",
    "address": "3018 San Luis Rey Rd, 92058 Oceanside",
    "email": null,
    "phone": "7604335050",
    "website": null,
    "coords": {
      "lat": 33.21189880371094,
      "lng": -117.35077667236328
    }
  },
  {
    "id": "96733_3",
    "name": "McKenna BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Downey",
    "address": "9778 Firestone Blvd., 90241 Downey",
    "email": null,
    "phone": "5623457000",
    "website": null,
    "coords": {
      "lat": 33.92790985107422,
      "lng": -118.11021423339844
    }
  },
  {
    "id": "43764_50001",
    "name": "Yokum Collision Center, Independent Certified Collision Repair Center of Orr BMW of Shreveport",
    "country": "US",
    "city": "Shreveport",
    "address": "1199 E Bert Kouns Industrial Loop, 71105 Shreveport",
    "email": null,
    "phone": "3187953165",
    "website": null,
    "coords": {
      "lat": 32.4193115234375,
      "lng": -93.7205581665039
    }
  },
  {
    "id": "21294_1",
    "name": "BMW of Las Vegas, Certified Collision Repair Center",
    "country": "US",
    "city": "Las Vegas",
    "address": "5720 W Sahara Ave, 89146 Las Vegas",
    "email": null,
    "phone": "7022572000",
    "website": null,
    "coords": {
      "lat": 36.14531707763672,
      "lng": -115.21992492675781
    }
  },
  {
    "id": "26167_2",
    "name": "BMW of Austin, Certified Collision Repair Center",
    "country": "US",
    "city": "Round Rock",
    "address": "2450 N Mays St, 78665 Round Rock",
    "email": null,
    "phone": "5122449333",
    "website": null,
    "coords": {
      "lat": 30.53631591796875,
      "lng": -97.68917083740234
    }
  },
  {
    "id": "35744_50001",
    "name": "Auto Body of Murrieta, Independent Certified Collision Repair Center of BMW of Murrieta",
    "country": "US",
    "city": "Murrieta",
    "address": "41188 Sandalwood Circle, 92562 Murrieta",
    "email": null,
    "phone": "9518948680",
    "website": null,
    "coords": {
      "lat": 33.53390884399414,
      "lng": -117.1736831665039
    }
  },
  {
    "id": "86335_50001",
    "name": "Caliber Collision Visalia, Independent Certified Collision Repair Center of BMW of Visalia",
    "country": "US",
    "city": "Visalia",
    "address": "1232 E Mineral King Ave, 95050 Visalia",
    "email": null,
    "phone": "5597397600",
    "website": null,
    "coords": {
      "lat": 36.32741165161133,
      "lng": -119.2791519165039
    }
  },
  {
    "id": "42277_50001",
    "name": "Frank and Sons Autobody, Independent Certified Collision Repair Center of BMW of Tri-Cities",
    "country": "US",
    "city": "Richland",
    "address": "2265 Robertson Drive, 99354 Richland",
    "email": null,
    "phone": "5093929550",
    "website": null,
    "coords": {
      "lat": 46.32501983642578,
      "lng": -119.31266784667969
    }
  },
  {
    "id": "46038_1",
    "name": "BMW Northwest, Certified Collision Repair Center",
    "country": "US",
    "city": "Fife",
    "address": "3801 20th ST E, 98424 Fife",
    "email": null,
    "phone": "2536501200",
    "website": null,
    "coords": {
      "lat": 47.239688873291016,
      "lng": -122.3775863647461
    }
  },
  {
    "id": "20989_01",
    "name": "Orange County BMW",
    "country": "US",
    "city": "Harriman",
    "address": "101 Maher Ln, 10926 Harriman",
    "email": "stephen@ocbmw.com",
    "phone": "8457824269",
    "website": "https://www.orangecountybmw.com",
    "coords": {
      "lat": 41.314918518066406,
      "lng": -74.13946533203125
    }
  },
  {
    "id": "36582_01",
    "name": "BMW of New London",
    "country": "US",
    "city": "New London",
    "address": "543 Colman St, 06320 New London",
    "email": "marc.antonino@bmwofnewlondon.com",
    "phone": "8604473141",
    "website": "https://www.bmwofnewlondon.com",
    "coords": {
      "lat": 41.364444732666016,
      "lng": -72.11558532714844
    }
  },
  {
    "id": "43039_01",
    "name": "BMW of Waterbury",
    "country": "US",
    "city": "Waterbury",
    "address": "133 Schraffts Drive, 06705 Waterbury",
    "email": "jason.herndon@hoffmanauto.com",
    "phone": "8602747515",
    "website": "https://www.bmwofwatertown.com",
    "coords": {
      "lat": 41.54158401489258,
      "lng": -72.989990234375
    }
  },
  {
    "id": "79100_01",
    "name": "BMW of Silver Spring",
    "country": "US",
    "city": "Silver Spring",
    "address": "3211 Automobile Blvd, 20904 Silver Spring",
    "email": "steve.sarecky@mileone.com",
    "phone": "3018903000",
    "website": "https://www.bmwofsilverspring.com",
    "coords": {
      "lat": 39.078758239746094,
      "lng": -76.94658660888672
    }
  },
  {
    "id": "16734_01",
    "name": "Tom Hesser BMW",
    "country": "US",
    "city": "Scranton",
    "address": "1001 N Washington Ave, 18509 Scranton",
    "email": "pdauchert@tomhesser.com",
    "phone": "5703431221",
    "website": "https://www.tomhesserbmw.com",
    "coords": {
      "lat": 41.41819381713867,
      "lng": -75.6531982421875
    }
  },
  {
    "id": "32111_01",
    "name": "BMW of West Springfield",
    "country": "US",
    "city": "West Springfield",
    "address": "1712 Riverdale St, 01089 West Springfield",
    "email": "ezawacki@bmwwestspringfield.net",
    "phone": "4133019053",
    "website": "https://www.bmwwestspringfield.net",
    "coords": {
      "lat": 42.15037155151367,
      "lng": -72.63211822509766
    }
  },
  {
    "id": "26700_01",
    "name": "Sun Motor Cars BMW",
    "country": "US",
    "city": "Mechanicsburg",
    "address": "6691 Carlisle Pike, 17050 Mechanicsburg",
    "email": "mguimond@sunmotorcars.com",
    "phone": "7176972300",
    "website": "https://www.bmw.sunmotorcars.com",
    "coords": {
      "lat": 40.23964309692383,
      "lng": -77.04954528808594
    }
  },
  {
    "id": "40808_02",
    "name": "BMW of Greenwich-Mamaroneck",
    "country": "US",
    "city": "Mamaroneck",
    "address": "236 W Boston Post Rd, 10543 Mamaroneck",
    "email": null,
    "phone": "9146700011",
    "website": "https://www.bmwofmamaroneck.com/",
    "coords": {
      "lat": 40.94686508178711,
      "lng": -73.73472595214844
    }
  },
  {
    "id": "40800_01",
    "name": "Habberstad BMW",
    "country": "US",
    "city": "Huntington Station",
    "address": "945 E. Jericho Tpke, 11746 Huntington Station",
    "email": "info@habberstadbmw.com",
    "phone": "6312717177",
    "website": "https://www.habberstadbmwofhuntington.com/",
    "coords": {
      "lat": 40.83605194091797,
      "lng": -73.3748779296875
    }
  },
  {
    "id": "95801_01",
    "name": "BMW Cleveland",
    "country": "US",
    "city": "Solon",
    "address": "6135 Kruse Dr, 44139 Solon",
    "email": "marty.sharp@bmwcleveland.com",
    "phone": "4405420600",
    "website": "https://www.bmwcleveland.com",
    "coords": {
      "lat": 41.392601013183594,
      "lng": -81.44202423095703
    }
  },
  {
    "id": "52342_01",
    "name": "BMW of North Canton",
    "country": "US",
    "city": "North Canton",
    "address": "6461 Whipple Ave NW, 44720 North Canton",
    "email": null,
    "phone": "3304945588",
    "website": null,
    "coords": {
      "lat": 40.87471389770508,
      "lng": -81.42321014404297
    }
  },
  {
    "id": "63766_01",
    "name": "BMW of Madison",
    "country": "US",
    "city": "Madison",
    "address": "320 West Beltline Highway, 53713 Madison",
    "email": "zimbrickbmwsaleslead@gmail.com",
    "phone": "6084433900",
    "website": "https://www.bmwofmadison.com",
    "coords": {
      "lat": 43.039451599121094,
      "lng": -89.38308715820312
    }
  },
  {
    "id": "22819_01",
    "name": "BMW of Macon",
    "country": "US",
    "city": "Macon",
    "address": "4785 Riverside Drive, 31210 Macon",
    "email": "tanzir.rafi@bmwofmacon.com",
    "phone": "4787577000",
    "website": "https://www.bmwofmacon.com",
    "coords": {
      "lat": 32.92359161376953,
      "lng": -83.70965576171875
    }
  },
  {
    "id": "15268_01",
    "name": "Flow BMW",
    "country": "US",
    "city": "Winston Salem",
    "address": "2565 Peters Creek Pkwy, 27127 Winston Salem",
    "email": "jkeranen@flowauto.com",
    "phone": "3367883333",
    "website": "https://www.flowbmw.com",
    "coords": {
      "lat": 36.06086730957031,
      "lng": -80.25785827636719
    }
  },
  {
    "id": "46826_01",
    "name": "Rick Hendrick BMW Charleston",
    "country": "US",
    "city": "Charleston",
    "address": "1518 Savannah Hwy, 29407 Charleston",
    "email": "sheila.thomasson@hendrickauto.com",
    "phone": "8437638403",
    "website": "https://www.rickhendrickbmw.com",
    "coords": {
      "lat": 32.78706741333008,
      "lng": -80.0079116821289
    }
  },
  {
    "id": "29867_01",
    "name": "Fields BMW of Daytona",
    "country": "US",
    "city": "Daytona Beach",
    "address": "1050 N Tomoka Farms Rd, 32124 Daytona Beach",
    "email": "robert.dunn@fieldsauto.com",
    "phone": "3862741200",
    "website": "https://www.fieldsbmwofdaytona.com",
    "coords": {
      "lat": 29.209861755371094,
      "lng": -81.1003646850586
    }
  },
  {
    "id": "31833_01",
    "name": "BMW of Northwest Arkansas",
    "country": "US",
    "city": "Bentonville",
    "address": "2500 SE Moberly Ln, 72712 Bentonville",
    "email": null,
    "phone": "4796364155",
    "website": "https://www.bmwofnwa.com",
    "coords": {
      "lat": 36.34550857543945,
      "lng": -94.18376159667969
    }
  },
  {
    "id": "10736_01",
    "name": "Fields BMW - Lakeland",
    "country": "US",
    "city": "Lakeland",
    "address": "4285 Lakeland Park Dr, 33809 Lakeland",
    "email": "mromero@fieldsauto.com",
    "phone": "8638161234",
    "website": "https://www.fieldsbmwlakeland.com",
    "coords": {
      "lat": 28.096771240234375,
      "lng": -81.95462799072266
    }
  },
  {
    "id": "31015_01",
    "name": "Baron BMW",
    "country": "US",
    "city": "Merriam",
    "address": "9010 Shawnee Mission Pkwy, 66202 Merriam",
    "email": "jhartigan@baronauto.com",
    "phone": "9137225100",
    "website": "https://www.baronbmw.com",
    "coords": {
      "lat": 39.01577377319336,
      "lng": -94.69123840332031
    }
  },
  {
    "id": "53171_01",
    "name": "BMW of Minnetonka",
    "country": "US",
    "city": "Minnetonka",
    "address": "15802 Wayzata Boulevard, 55391 Minnetonka",
    "email": null,
    "phone": "9523037500",
    "website": null,
    "coords": {
      "lat": 44.97133255004883,
      "lng": -93.47927856445312
    }
  },
  {
    "id": "43380_01",
    "name": "BMW of College Station",
    "country": "US",
    "city": "College Station",
    "address": "3417 State Highway 6 South, 77845 College Station",
    "email": null,
    "phone": "9793142000",
    "website": "https://www.bmwofbrazosvalley.com",
    "coords": {
      "lat": 30.593120574951172,
      "lng": -96.28890228271484
    }
  },
  {
    "id": "39314_01",
    "name": "BMW of Denver Downtown",
    "country": "US",
    "city": "Denver",
    "address": "1040 S. Colorado Boulevard, 80246 Denver",
    "email": null,
    "phone": "3039544856",
    "website": "https://www.bmwofdenverdowntown.com",
    "coords": {
      "lat": 39.69924545288086,
      "lng": -104.93762969970703
    }
  },
  {
    "id": "46038_01",
    "name": "BMW Northwest",
    "country": "US",
    "city": "Tacoma",
    "address": "4011 20th St E, 98424 Tacoma",
    "email": "charles@bmwnorthwest.com",
    "phone": "2539228700",
    "website": "https://www.bmwnorthwest.com/",
    "coords": {
      "lat": 47.23910903930664,
      "lng": -122.37346649169922
    }
  },
  {
    "id": "31642_01",
    "name": "BMW of Monrovia",
    "country": "US",
    "city": "Monrovia",
    "address": "1425 S Mountain Ave, 91016 Monrovia",
    "email": "ian.lawyer@bmwofmonrovia.com",
    "phone": "6263584269",
    "website": "https://www.bmwofmonrovia.net/",
    "coords": {
      "lat": 34.137516021728516,
      "lng": -117.9869155883789
    }
  },
  {
    "id": "21188_01",
    "name": "Irvine BMW",
    "country": "US",
    "city": "Irvine",
    "address": "9881 Research Dr, 92618 Irvine",
    "email": "CIC@irvinebmw.com",
    "phone": "9495233960",
    "website": "https://www.irvinebmw.com",
    "coords": {
      "lat": 33.63167953491211,
      "lng": -117.72614288330078
    }
  },
  {
    "id": "96733_01",
    "name": "McKenna BMW",
    "country": "US",
    "city": "Norwalk",
    "address": "10900 Firestone Blvd, 90650 Norwalk",
    "email": "ali.h@mckennacars.com",
    "phone": "5628683233",
    "website": "https://www.mckennabmw.com",
    "coords": {
      "lat": 33.923301696777344,
      "lng": -118.1022720336914
    }
  },
  {
    "id": "36021_01",
    "name": "BMW of Tigard",
    "country": "US",
    "city": "Tigard",
    "address": "10035 SW Cascade Ave, 97223 Tigard",
    "email": "sven.wood@holman.com",
    "phone": "5037485400",
    "website": "https://www.bmwtigard.com/",
    "coords": {
      "lat": 45.44878005981445,
      "lng": -122.78535461425781
    }
  },
  {
    "id": "47724_01",
    "name": "BMW of Sherman Oaks",
    "country": "US",
    "city": "Sherman Oaks",
    "address": "5201 Van Nuys Blvd, 91401 Sherman Oaks",
    "email": "cashebmw_leads@lithia.com",
    "phone": "8189079995",
    "website": null,
    "coords": {
      "lat": 34.1655387878418,
      "lng": -118.4493179321289
    }
  },
  {
    "id": "04618_01",
    "name": "Niello BMW Sacramento",
    "country": "US",
    "city": "Sacramento",
    "address": "2020 Fulton Ave, 95825 Sacramento",
    "email": "cdesantis@niello.com",
    "phone": "9164861011",
    "website": "https://bmw.niello.com",
    "coords": {
      "lat": 38.60240936279297,
      "lng": -121.40119934082031
    }
  },
  {
    "id": "04514_01",
    "name": "Weatherford BMW",
    "country": "US",
    "city": "Berkeley",
    "address": "750 Potter St, 94710 Berkeley",
    "email": "blair.robinson@weatherfordbmw.com",
    "phone": "5106548280",
    "website": "https://www.weatherfordbmw.com",
    "coords": {
      "lat": 37.85052490234375,
      "lng": -122.29461669921875
    }
  },
  {
    "id": "41903_01",
    "name": "South Bay BMW",
    "country": "US",
    "city": "Torrance",
    "address": "18800 Hawthorne Blvd, 90504 Torrance",
    "email": "kschulz@mckennacars.com",
    "phone": "3109397300",
    "website": "https://www.southbaybmw.com",
    "coords": {
      "lat": 33.86071014404297,
      "lng": -118.35231018066406
    }
  },
  {
    "id": "76731_01",
    "name": "BMW of Honolulu",
    "country": "US",
    "city": "Honolulu",
    "address": "777 Kapiolani Blvd, 96813 Honolulu",
    "email": "tpalms@bmwhawaii.com",
    "phone": "8085971225",
    "website": "https://www.bmwhawaii.com",
    "coords": {
      "lat": 21.300512313842773,
      "lng": -157.85406494140625
    }
  },
  {
    "id": "46579_01",
    "name": "BMW of Ramsey",
    "country": "US",
    "city": "Ramsey",
    "address": "985 State Route 17, 07446 Ramsey",
    "email": null,
    "phone": "2012586000",
    "website": "https://www.bmwramsey.com",
    "coords": {
      "lat": 41.066200256347656,
      "lng": -74.13390350341797
    }
  },
  {
    "id": "66771_01",
    "name": "Circle BMW",
    "country": "US",
    "city": "Eatontown",
    "address": "500 State Route 36, 07724 Eatontown",
    "email": "circlebmw@circlebmw.com",
    "phone": "7324401200",
    "website": "https://www.circlebmw.com",
    "coords": {
      "lat": 40.29045486450195,
      "lng": -74.04144287109375
    }
  },
  {
    "id": "26711_01",
    "name": "BMW of Roxbury",
    "country": "US",
    "city": "Kenvil (Roxbury)",
    "address": "840 US Highway 46, 07847 Kenvil (Roxbury)",
    "email": "Ken.castellaneta@openroad.com",
    "phone": "9736270700",
    "website": "https://www.bmwrox.com",
    "coords": {
      "lat": 40.87858581542969,
      "lng": -74.63597106933594
    }
  },
  {
    "id": "22800_01",
    "name": "Competition BMW of Smithtown",
    "country": "US",
    "city": "Saint James",
    "address": "599 Middle Country Road, 11780 Saint James",
    "email": "mmacchio@competitionbmw.com",
    "phone": "6312652208",
    "website": "https://www.competitionbmw.com",
    "coords": {
      "lat": 40.860599517822266,
      "lng": -73.15835571289062
    }
  },
  {
    "id": "59127_01",
    "name": "BMW of North Haven",
    "country": "US",
    "city": "North Haven",
    "address": "610 Washington Ave, 06473 North Haven",
    "email": "mfertiguena@bmwofnorthhaven.com",
    "phone": "2032397272",
    "website": "https://www.bmwofnorthhaven.com",
    "coords": {
      "lat": 41.42129898071289,
      "lng": -72.839599609375
    }
  },
  {
    "id": "48081_01",
    "name": "BMW of Williamsport",
    "country": "US",
    "city": "Muncy",
    "address": "205 Lycoming Mall Drive, 17756 Muncy",
    "email": null,
    "phone": "5705672021",
    "website": null,
    "coords": {
      "lat": 41.23672866821289,
      "lng": -76.81316375732422
    }
  },
  {
    "id": "43006_01",
    "name": "BMW of Newport",
    "country": "US",
    "city": "Middletown",
    "address": "1235 W Main Rd, 02842 Middletown",
    "email": null,
    "phone": "4018479600",
    "website": "https://www.bmwofnewport.com",
    "coords": {
      "lat": 41.53271484375,
      "lng": -71.2924575805664
    }
  },
  {
    "id": "10699_03",
    "name": "BMW of Peabody",
    "country": "US",
    "city": "Peabody",
    "address": "7 Centennial Dr, 01960 Peabody",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 42.520328521728516,
      "lng": -70.97237396240234
    }
  },
  {
    "id": "16815_02",
    "name": "Tulley BMW Manchester",
    "country": "US",
    "city": "Manchester",
    "address": "170 Auto Center Rd, 03103 Manchester",
    "email": "bmwofmanchester@tulley.com",
    "phone": "6036442691",
    "website": "https://www.tulleybmwmanchester.com/",
    "coords": {
      "lat": 42.95079040527344,
      "lng": -71.43766784667969
    }
  },
  {
    "id": "51009_01",
    "name": "BMW of Towson",
    "country": "US",
    "city": "Towson",
    "address": "700 Kenilworth Dr, 21204 Towson",
    "email": null,
    "phone": "6679302458",
    "website": "https://www.bmwtowson.com/",
    "coords": {
      "lat": 39.41080093383789,
      "lng": -76.616943359375
    }
  },
  {
    "id": "51008_01",
    "name": "BMW of Rockland",
    "country": "US",
    "city": "Rockland",
    "address": "1040 Hingham Street, 02370 Rockland",
    "email": null,
    "phone": "8888604882",
    "website": "https://www.southshorebmw.com/",
    "coords": {
      "lat": 42.16740798950195,
      "lng": -70.89949798583984
    }
  },
  {
    "id": "34520_01",
    "name": "BMW of Rochester",
    "country": "US",
    "city": "Rochester",
    "address": "4250 W Henrietta Rd, 14623 Rochester",
    "email": "BCARLIN@WESTHERR.COM",
    "phone": "5853597373",
    "website": "https://www.bmwrochester.com",
    "coords": {
      "lat": 43.06776809692383,
      "lng": -77.64553833007812
    }
  },
  {
    "id": "10699_01",
    "name": "BMW of Peabody",
    "country": "US",
    "city": "Peabody",
    "address": "221 Andover St, 01960 Peabody",
    "email": "jpirotte@bmwpeabody.com",
    "phone": "9785389900",
    "website": "https://www.bmwpeabody.com",
    "coords": {
      "lat": 42.54542541503906,
      "lng": -70.94391632080078
    }
  },
  {
    "id": "16815_01",
    "name": "Tulley BMW",
    "country": "US",
    "city": "Nashua",
    "address": "147 Daniel Webster Hwy, 03060 Nashua",
    "email": "www.tulleybmw.com",
    "phone": "6038885050",
    "website": "https://www.tulleybmw.com",
    "coords": {
      "lat": 42.72438049316406,
      "lng": -71.44629669189453
    }
  },
  {
    "id": "35797_01",
    "name": "Passport BMW",
    "country": "US",
    "city": "Suitland",
    "address": "4730 Auth Place, 20746 Suitland",
    "email": "cameron.hellmuth@passportauto.com",
    "phone": "3014232700",
    "website": "https://www.passportbmw.com",
    "coords": {
      "lat": 38.82491683959961,
      "lng": -76.9202651977539
    }
  },
  {
    "id": "34910_01",
    "name": "BMW of Pittsburgh",
    "country": "US",
    "city": "Pittsburgh",
    "address": "4801 Baum Blvd., 15213 Pittsburgh",
    "email": null,
    "phone": "4126820788",
    "website": "https://www.pandwbmw.com",
    "coords": {
      "lat": 40.45466995239258,
      "lng": -79.94727325439453
    }
  },
  {
    "id": "21608_01",
    "name": "Richmond BMW",
    "country": "US",
    "city": "Richmond",
    "address": "8710 W Broad St, 23294 Richmond",
    "email": "pyurcaba@crownauto.com",
    "phone": "8042074692",
    "website": "https://www.richmond-bmw.com",
    "coords": {
      "lat": 37.63399887084961,
      "lng": -77.54149627685547
    }
  },
  {
    "id": "76472_01",
    "name": "BMW of Westbrook",
    "country": "US",
    "city": "Westbrook",
    "address": "7 Saunders Way, 04092 Westbrook",
    "email": "pthomas@billdodgeautogroup.com",
    "phone": "2078543200",
    "website": "https://www.bmwofwestbrook.com/",
    "coords": {
      "lat": 43.674503326416016,
      "lng": -70.3392562866211
    }
  },
  {
    "id": "96499_01",
    "name": "Classic BMW",
    "country": "US",
    "city": "Willoughby Hills",
    "address": "2571 SOM Center Road, 44094 Willoughby Hills",
    "email": "msouthworth@driveclassic.com",
    "phone": "4405859990",
    "website": "https://www.driveclassicbmw.com",
    "coords": {
      "lat": 41.59787368774414,
      "lng": -81.43933868408203
    }
  },
  {
    "id": "39741_01",
    "name": "BMW of Lynchburg",
    "country": "US",
    "city": "Lynchburg",
    "address": "2643 Lakeside Dr, 24501 Lynchburg",
    "email": null,
    "phone": "4343856226",
    "website": "https://www.bmwoflynchburg.com",
    "coords": {
      "lat": 37.394832611083984,
      "lng": -79.23178100585938
    }
  },
  {
    "id": "53042_01",
    "name": "BMW of Kinston",
    "country": "US",
    "city": "Kinston",
    "address": "1063 US Highway 258 N, 28504 Kinston",
    "email": null,
    "phone": "2525223611",
    "website": "https://www.deaconjonesbmw.com/",
    "coords": {
      "lat": 35.264610290527344,
      "lng": -77.64242553710938
    }
  },
  {
    "id": "46222_01",
    "name": "BMW of Akron",
    "country": "US",
    "city": "Akron",
    "address": "500 W Exchange St, 44302 Akron",
    "email": "bmwakron@jayauto.com",
    "phone": "3307620791",
    "website": "https://www.bmwakron.com",
    "coords": {
      "lat": 41.085391998291016,
      "lng": -81.53707122802734
    }
  },
  {
    "id": "86813_01",
    "name": "A & L BMW",
    "country": "US",
    "city": "Monroeville",
    "address": "3780 William Penn Hwy, 15146 Monroeville",
    "email": "nate@almotors.com",
    "phone": "4123736071",
    "website": "https://www.albmw.com",
    "coords": {
      "lat": 40.43600082397461,
      "lng": -79.78450012207031
    }
  },
  {
    "id": "52082_01",
    "name": "BMW of Buffalo",
    "country": "US",
    "city": "Williamsville",
    "address": "8215 Main St, 14221 Williamsville",
    "email": "bbmgrs@westherr.com",
    "phone": "7165052100",
    "website": "http://www.bmwbuffalo.com/",
    "coords": {
      "lat": 42.96466064453125,
      "lng": -78.6873779296875
    }
  },
  {
    "id": "66390_01",
    "name": "Laurel BMW",
    "country": "US",
    "city": "Johnstown",
    "address": "1800 Bedford St, 15902 Johnstown",
    "email": "jaime.shustrick@laurelautogroup.com",
    "phone": "8142627028",
    "website": "https://www.laurelbmwpa.com",
    "coords": {
      "lat": 40.30133819580078,
      "lng": -78.8869400024414
    }
  },
  {
    "id": "36722_01",
    "name": "BMW of Florence",
    "country": "US",
    "city": "Florence",
    "address": "2199 David H McLeod Blvd, 29501 Florence",
    "email": "tmoore@fivestaronline.net",
    "phone": "8436628711",
    "website": "https://www.bmwofflorence.com",
    "coords": {
      "lat": 34.188316345214844,
      "lng": -79.81600952148438
    }
  },
  {
    "id": "16694_01",
    "name": "Grayson BMW",
    "country": "US",
    "city": "Knoxville",
    "address": "10671 Parkside Dr, 37922 Knoxville",
    "email": "fscialdone@graysonauto.com",
    "phone": "8656934555",
    "website": "https://bmw.graysonauto.com",
    "coords": {
      "lat": 35.90177536010742,
      "lng": -84.1390151977539
    }
  },
  {
    "id": "36634_01",
    "name": "Hilton Head BMW",
    "country": "US",
    "city": "Bluffton",
    "address": "1230 Fording Island Road, 29910 Bluffton",
    "email": "smolthop@hiltonheadbmw.com",
    "phone": "8438151501",
    "website": "https://www.hiltonheadbmw.com",
    "coords": {
      "lat": 32.248756408691406,
      "lng": -80.83554077148438
    }
  },
  {
    "id": "47212_01",
    "name": "BMW of Myrtle Beach",
    "country": "US",
    "city": "Myrtle Beach",
    "address": "936 Jason Blvd., 29577 Myrtle Beach",
    "email": null,
    "phone": "8438486800",
    "website": null,
    "coords": {
      "lat": 33.7135009765625,
      "lng": -78.90350341796875
    }
  },
  {
    "id": "56843_01",
    "name": "BMW of Lafayette",
    "country": "US",
    "city": "Lafayette",
    "address": "178 Sagamore Pkwy S, 47905 Lafayette",
    "email": "sales@defouw.com",
    "phone": "7654492800",
    "website": "https://www.defouwbmw.com",
    "coords": {
      "lat": 40.41531753540039,
      "lng": -86.85787963867188
    }
  },
  {
    "id": "52681_01",
    "name": "BMW of Wilmington",
    "country": "US",
    "city": "Wilmington",
    "address": "4900 New Centre Dr, 28403 Wilmington",
    "email": null,
    "phone": "9103922700",
    "website": "https://www.bmwofwilmington.com/",
    "coords": {
      "lat": 34.242515563964844,
      "lng": -77.88009643554688
    }
  },
  {
    "id": "66788_03",
    "name": "Hendrick BMW Northlake",
    "country": "US",
    "city": "Charlotte",
    "address": "10720 Northlake Auto Plaza Blvd, 28269 Charlotte",
    "email": "HLGTLservice@hendrickauto.com",
    "phone": "7043793100",
    "website": "https://www.hendrickbmwnorthlake.com/",
    "coords": {
      "lat": 35.36721420288086,
      "lng": -80.8308334350586
    }
  },
  {
    "id": "96628_01",
    "name": "Fields BMW",
    "country": "US",
    "city": "Northfield",
    "address": "700 W Frontage Rd, 60093 Northfield",
    "email": "steve.mcdonald@fieldsauto.com",
    "phone": "8474415300",
    "website": "https://www.fieldsbmwnorthfield.com",
    "coords": {
      "lat": 42.111106872558594,
      "lng": -87.77511596679688
    }
  },
  {
    "id": "26792_01",
    "name": "Bill Jacobs BMW",
    "country": "US",
    "city": "Naperville",
    "address": "2495 Aurora Ave, 60540 Naperville",
    "email": "brian.kosanovich@billjacobs.com",
    "phone": "6303571200",
    "website": "https://www.billjacobsbmw.com",
    "coords": {
      "lat": 41.76329803466797,
      "lng": -88.19588470458984
    }
  },
  {
    "id": "21234_01",
    "name": "BMW of Nashville",
    "country": "US",
    "city": "Brentwood",
    "address": "1568 Mallory Lane, 37027 Brentwood",
    "email": "loyalty@bmwofnashville.com",
    "phone": "6159282541",
    "website": "https://www.bmwofnashville.com",
    "coords": {
      "lat": 35.978759765625,
      "lng": -86.8045654296875
    }
  },
  {
    "id": "20415_01",
    "name": "Bachrodt BMW",
    "country": "US",
    "city": "Rockford",
    "address": "7070 Cherryvale North Blvd, 61112 Rockford",
    "email": "n.sabir@bachrodt.com",
    "phone": "8153323000",
    "website": "https://www.loubachrodtbmw.com",
    "coords": {
      "lat": 42.25040054321289,
      "lng": -88.97799682617188
    }
  },
  {
    "id": "46778_03",
    "name": "Tom Bush BMW Orange Park",
    "country": "US",
    "city": "Jacksonville",
    "address": "6914 Blanding Blvd, 32244 Jacksonville",
    "email": "robert.sharp@tombush.com",
    "phone": "9047772500",
    "website": "https://www.tombushbmworangepark.com",
    "coords": {
      "lat": 30.22478675842285,
      "lng": -81.73900604248047
    }
  },
  {
    "id": "50229_01",
    "name": "BMW of Bowling Green",
    "country": "US",
    "city": "Bowling Green",
    "address": "325 Three Springs Rd, 42104 Bowling Green",
    "email": "jcoffey@millsautogroup.com",
    "phone": "2707450001",
    "website": null,
    "coords": {
      "lat": 36.93686294555664,
      "lng": -86.4213638305664
    }
  },
  {
    "id": "52126_01",
    "name": "BMW of Elmhurst",
    "country": "US",
    "city": "Elmhurst",
    "address": "500 W Lake St, 60126 Elmhurst",
    "email": null,
    "phone": "6308337945",
    "website": null,
    "coords": {
      "lat": 41.9185905456543,
      "lng": -87.95426940917969
    }
  },
  {
    "id": "24024_01",
    "name": "Autohaus BMW of Maplewood",
    "country": "US",
    "city": "Saint Louis",
    "address": "3015 S Hanley Rd, 63143 Saint Louis",
    "email": "Peggy.Wessel@bmwautohaus.com.com",
    "phone": "3147278870",
    "website": "https://www.bmwautohaus.com",
    "coords": {
      "lat": 38.60957717895508,
      "lng": -90.33451843261719
    }
  },
  {
    "id": "56802_01",
    "name": "Roadshow BMW",
    "country": "US",
    "city": "Cordova",
    "address": "405 N Germantown Pkwy, 38018 Cordova",
    "email": "bmw405leads@roadshowbmw.com",
    "phone": "9013652584",
    "website": "https://www.roadshowbmw.com/",
    "coords": {
      "lat": 35.136783599853516,
      "lng": -89.79747772216797
    }
  },
  {
    "id": "48600_01",
    "name": "Melbourne BMW",
    "country": "US",
    "city": "Melbourne",
    "address": "1432 S Harbor City Blvd, 32901 Melbourne",
    "email": "Mikep@bmwinmelbourne.com",
    "phone": "3217273788",
    "website": "https://www.bmwinmelbourne.com",
    "coords": {
      "lat": 28.086103439331055,
      "lng": -80.60731506347656
    }
  },
  {
    "id": "34748_01",
    "name": "BMW of Gainesville",
    "country": "US",
    "city": "Gainesville",
    "address": "2853 N Main Street, 32609 Gainesville",
    "email": "thill@gettel.com",
    "phone": "3523764551",
    "website": "https://www.bmwofgainesville.com",
    "coords": {
      "lat": 29.678504943847656,
      "lng": -82.31951141357422
    }
  },
  {
    "id": "26865_01",
    "name": "Kimberly BMW of Davenport",
    "country": "US",
    "city": "Davenport",
    "address": "625 W Kimberly Rd, 52806 Davenport",
    "email": "rzillmer@kimberlycarcity.com",
    "phone": "5633918300",
    "website": "https://www.bmwofdavenport.com",
    "coords": {
      "lat": 41.559898376464844,
      "lng": -90.58110046386719
    }
  },
  {
    "id": "36637_02",
    "name": "BMW of Wesley Chapel",
    "country": "US",
    "city": "Wesley Chapel",
    "address": "26645 State Road 56, 33544 Wesley Chapel",
    "email": null,
    "phone": "8139073600",
    "website": "https://www.wesleychapelbmw.com",
    "coords": {
      "lat": 28.185670852661133,
      "lng": -82.35572052001953
    }
  },
  {
    "id": "50929_01",
    "name": "BMW of Tampa",
    "country": "US",
    "city": "Tampa",
    "address": "109 E Fowler Ave, 33612 Tampa",
    "email": null,
    "phone": "8139365500",
    "website": null,
    "coords": {
      "lat": 28.05451774597168,
      "lng": -82.45699310302734
    }
  },
  {
    "id": "93777_01",
    "name": "Bert Smith International",
    "country": "US",
    "city": "Saint Petersburg",
    "address": "3800 34th St N, 33714 Saint Petersburg",
    "email": "lgraner@bertsmith.com",
    "phone": "7275271111",
    "website": "https://www.bertsmithbmw.com",
    "coords": {
      "lat": 27.807104110717773,
      "lng": -82.68040466308594
    }
  },
  {
    "id": "20416_01",
    "name": "BMW of Springfield",
    "country": "US",
    "city": "Springfield",
    "address": "3500 East Sunshine Street, 65809 Springfield",
    "email": "nmeyer@vtaig.com",
    "phone": "4178899200",
    "website": "https://www.reliablebmw.com",
    "coords": {
      "lat": 37.179786682128906,
      "lng": -93.22285461425781
    }
  },
  {
    "id": "22081_01",
    "name": "BMW of Fort Myers",
    "country": "US",
    "city": "Fort Myers",
    "address": "15421 S Tamiami Trl, 33908 Fort Myers",
    "email": "troy.arch@bmwoffortmyers.com",
    "phone": "2394338378",
    "website": "https://www.bmwoffortmyers.com",
    "coords": {
      "lat": 26.519725799560547,
      "lng": -81.8674087524414
    }
  },
  {
    "id": "35121_01",
    "name": "BMW of Sioux Falls",
    "country": "US",
    "city": "Sioux Falls",
    "address": "101 S. Carolyn Ave., 57107 Sioux Falls",
    "email": "MCHAPLIN@BMWOFSIOUXFALLS.COM",
    "phone": "8669803526",
    "website": "https://www.bmwofsiouxfalls.com",
    "coords": {
      "lat": 43.545570373535156,
      "lng": -96.7784423828125
    }
  },
  {
    "id": "56779_01",
    "name": "Germain BMW of Naples",
    "country": "US",
    "city": "Naples",
    "address": "11286 Tamiami Trl N, 34110 Naples",
    "email": "bmwnaples@germain.com",
    "phone": "2396432220",
    "website": "https://www.germainbmw.com",
    "coords": {
      "lat": 26.2767333984375,
      "lng": -81.8011474609375
    }
  },
  {
    "id": "46550_01",
    "name": "Walker BMW",
    "country": "US",
    "city": "Alexandria",
    "address": "6655 Coliseum Blvd., 71303 Alexandria",
    "email": "walker@walkerautomotive.com",
    "phone": "3184456678",
    "website": "https://www.walkerbmw.com",
    "coords": {
      "lat": 31.29543685913086,
      "lng": -92.51966094970703
    }
  },
  {
    "id": "43764_01",
    "name": "Orr BMW of Shreveport",
    "country": "US",
    "city": "Shreveport",
    "address": "7561 East Kings Hwy, 71105 Shreveport",
    "email": "tcarlson@orrbmw.com",
    "phone": "3186291269",
    "website": "https://www.orrbmw.com",
    "coords": {
      "lat": 32.439697265625,
      "lng": -93.70706939697266
    }
  },
  {
    "id": "25786_01",
    "name": "BMW of Tulsa",
    "country": "US",
    "city": "Tulsa",
    "address": "9702 S Memorial Dr, 74133 Tulsa",
    "email": "jwmoore@tulsabmw.com",
    "phone": "9186634444",
    "website": "https://www.bmwoftulsa.com",
    "coords": {
      "lat": 36.02294158935547,
      "lng": -95.88710021972656
    }
  },
  {
    "id": "10022_01",
    "name": "Cardenas BMW",
    "country": "US",
    "city": "Harlingen",
    "address": "210 N Loop 499, 78550 Harlingen",
    "email": "lorenzo@cardenasautogroup.com",
    "phone": "9564252400",
    "website": "https://www.cardenasbmw.com",
    "coords": {
      "lat": 26.191659927368164,
      "lng": -97.66255187988281
    }
  },
  {
    "id": "26840_01",
    "name": "Autoplex BMW",
    "country": "US",
    "city": "Amarillo",
    "address": "4600 Canyon Dr, 79109 Amarillo",
    "email": "ronnie.kyle@autoplex-tx.com",
    "phone": "8066265012",
    "website": "https://www.autoplexbmw.com",
    "coords": {
      "lat": 35.158748626708984,
      "lng": -101.8775863647461
    }
  },
  {
    "id": "43775_01",
    "name": "BMW of West Houston",
    "country": "US",
    "city": "Katy",
    "address": "20822 Katy Fwy, 77449 Katy",
    "email": "charles.cannon@bmwwest.com",
    "phone": "8327729000",
    "website": "https://www.bmwwest.com",
    "coords": {
      "lat": 29.78629493713379,
      "lng": -95.73246002197266
    }
  },
  {
    "id": "44812_01",
    "name": "BMW of Corpus Christi",
    "country": "US",
    "city": "Corpus Christi",
    "address": "7601 South Padre Island Dr, 78412 Corpus Christi",
    "email": "bmwofcorpuschristi@eleadtrack.net",
    "phone": "3619915555",
    "website": "https://www.bmwofcc.com",
    "coords": {
      "lat": 27.689462661743164,
      "lng": -97.33386993408203
    }
  },
  {
    "id": "16418_01",
    "name": "Winslow BMW of Colorado Springs",
    "country": "US",
    "city": "Colorado Springs",
    "address": "5845 N. Nevada Avenue, 80918 Colorado Springs",
    "email": "phil@winslowmotors.com",
    "phone": "7194731373",
    "website": "https://www.winslowbmw.com",
    "coords": {
      "lat": 38.91312026977539,
      "lng": -104.8155288696289
    }
  },
  {
    "id": "26419_01",
    "name": "Bill Pearce BMW",
    "country": "US",
    "city": "Reno",
    "address": "11555 S Virginia St, 89511 Reno",
    "email": "bmw@billpearcemotors.com",
    "phone": "7758262100",
    "website": "https://www.billpearcebmw.com",
    "coords": {
      "lat": 39.4263801574707,
      "lng": -119.76100158691406
    }
  },
  {
    "id": "11010_01",
    "name": "Peterson BMW of Boise",
    "country": "US",
    "city": "Boise",
    "address": "1225 N. Maple Grove Road, 83704 Boise",
    "email": "jrummel@petersoncars.com",
    "phone": "2083785980",
    "website": "https://www.petersonbmw.com",
    "coords": {
      "lat": 43.61637496948242,
      "lng": -116.29499816894531
    }
  },
  {
    "id": "10729_02",
    "name": "Chapman BMW on Camelback",
    "country": "US",
    "city": "Phoenix",
    "address": "830 E Camelback Rd, 85014 Phoenix",
    "email": "bobcola@chapmanchoice.com",
    "phone": "6023084269",
    "website": "https://www.chapmanbmwoncamelback.com",
    "coords": {
      "lat": 33.509342193603516,
      "lng": -112.06244659423828
    }
  },
  {
    "id": "04637_01",
    "name": "Bob Smith BMW",
    "country": "US",
    "city": "Calabasas",
    "address": "24500 Calabasas Rd, 91302 Calabasas",
    "email": "service@bobsmithbmw.com",
    "phone": "8183463144",
    "website": "https://www.bobsmithbmw.com",
    "coords": {
      "lat": 34.14944076538086,
      "lng": -118.66133880615234
    }
  },
  {
    "id": "04497_01",
    "name": "BMW Concord",
    "country": "US",
    "city": "Concord",
    "address": "1967 Market St, 94520 Concord",
    "email": null,
    "phone": "9256823577",
    "website": "https://www.bmwconcord.com",
    "coords": {
      "lat": 37.974998474121094,
      "lng": -122.04447937011719
    }
  },
  {
    "id": "22820_01",
    "name": "BMW of San Luis Obispo",
    "country": "US",
    "city": "San Luis Obispo",
    "address": "1251 Calle Joaquin Road, 93405 San Luis Obispo",
    "email": "lsmith@coast-bmw.com",
    "phone": "8055434423",
    "website": "https://www.coastbmw.com",
    "coords": {
      "lat": 35.25132369995117,
      "lng": -120.67999267578125
    }
  },
  {
    "id": "10729_01",
    "name": "Chapman BMW",
    "country": "US",
    "city": "Chandler",
    "address": "7455 W Orchid Lane, 85226 Chandler",
    "email": "shane@chapmanbmw.com",
    "phone": "4803444269",
    "website": "https://www.chapmanbmwchandler.com/",
    "coords": {
      "lat": 33.3234977722168,
      "lng": -111.97055053710938
    }
  },
  {
    "id": "20741_01",
    "name": "BMW North Scottsdale",
    "country": "US",
    "city": "Phoenix",
    "address": "18018 North Scottsdale Rd., 85054 Phoenix",
    "email": "skhouri@penskeautomotive.com",
    "phone": "8777053224",
    "website": "https://www.bmwnorthscottsdale.com",
    "coords": {
      "lat": 33.64891052246094,
      "lng": -111.92604064941406
    }
  },
  {
    "id": "24781_01",
    "name": "BMW of Bakersfield",
    "country": "US",
    "city": "Bakersfield",
    "address": "5400 Gasoline Alley Dr, 93313 Bakersfield",
    "email": "bmwofbakersfield.com",
    "phone": "6613964040",
    "website": "https://www.bmwofbakersfield.com",
    "coords": {
      "lat": 35.3048095703125,
      "lng": -119.0343017578125
    }
  },
  {
    "id": "39668_01",
    "name": "BMW of Salem",
    "country": "US",
    "city": "Salem",
    "address": "1151 Van Ness Avenue NE, 97301 Salem",
    "email": null,
    "phone": "5033999541",
    "website": "https://www.bmwofsalem.com",
    "coords": {
      "lat": 44.9719352722168,
      "lng": -123.01863861083984
    }
  },
  {
    "id": "20268_01",
    "name": "Century West BMW",
    "country": "US",
    "city": "North Hollywood",
    "address": "4245 Lankershim Blvd, 91602 North Hollywood",
    "email": "bghosn@centurywestbmw.com",
    "phone": "8184325800",
    "website": "https://www.centurywestbmw.com",
    "coords": {
      "lat": 34.14691162109375,
      "lng": -118.36305236816406
    }
  },
  {
    "id": "39315_01",
    "name": "BMW Fresno",
    "country": "US",
    "city": "Fresno",
    "address": "7171 N Palm Ave, 93650 Fresno",
    "email": "ruben.valdez@bmwfresno.com",
    "phone": "5594476700",
    "website": "https://www.bmwfresno.com",
    "coords": {
      "lat": 36.84018325805664,
      "lng": -119.80921173095703
    }
  },
  {
    "id": "22180_01",
    "name": "Valencia BMW",
    "country": "US",
    "city": "Valencia",
    "address": "23435 Valencia Blvd, 91355 Valencia",
    "email": "karvunidisn@autonation.com",
    "phone": "6612548000",
    "website": "https://www.valenciabmw.com",
    "coords": {
      "lat": 34.420936584472656,
      "lng": -118.54927825927734
    }
  },
  {
    "id": "21618_01",
    "name": "BMW of Mountain View",
    "country": "US",
    "city": "Mountain View",
    "address": "150 E El Camino Real, 94040 Mountain View",
    "email": "roshanp@autonation.com",
    "phone": "6509431000",
    "website": "https://www.bmwofmountainview.com",
    "coords": {
      "lat": 37.38037872314453,
      "lng": -122.07171630859375
    }
  },
  {
    "id": "10731_01",
    "name": "East Bay BMW",
    "country": "US",
    "city": "Pleasanton",
    "address": "4350 Rosewood Dr, 94588 Pleasanton",
    "email": "joe.pagano@hendrickauto.com",
    "phone": "8885937018",
    "website": "https://www.eastbaybmw.com",
    "coords": {
      "lat": 37.699745178222656,
      "lng": -121.87654876708984
    }
  },
  {
    "id": "36459_50003",
    "name": "Caliber Collision Vancouver - Orchards",
    "country": "US",
    "city": "Vancouver",
    "address": "12302 NE Fourth Plain Blvd, 98682 Vancouver",
    "email": null,
    "phone": "3608911159",
    "website": null,
    "coords": {
      "lat": 45.66893005371094,
      "lng": -122.54624938964844
    }
  },
  {
    "id": "21234_50002",
    "name": "AW Collision Nashville North, Independent Certified Collision Repair Center of BMW of Nashville",
    "country": "US",
    "city": "Nashville",
    "address": "115 Duluth Ave, 37209 Nashville",
    "email": null,
    "phone": "6293122800",
    "website": null,
    "coords": {
      "lat": 36.15827178955078,
      "lng": -86.86613464355469
    }
  },
  {
    "id": "10695_50001",
    "name": "North Shore Auto & Towing Inc, Independent Certified Collision Repair Center of BMW of Manhasset",
    "country": "US",
    "city": "Manhasset",
    "address": "265 East Shore Road, 11030 Manhasset",
    "email": null,
    "phone": "5164822500",
    "website": null,
    "coords": {
      "lat": 40.791168212890625,
      "lng": -73.70953369140625
    }
  },
  {
    "id": "43383_50001",
    "name": "VIVE Collision of Albany, Independent Certified Collision Repair Center of BMW of South Albany",
    "country": "US",
    "city": "Albany",
    "address": "808 Central Avenue, 12206 Albany",
    "email": null,
    "phone": "5182844241",
    "website": null,
    "coords": {
      "lat": 42.67869186401367,
      "lng": -73.78858184814453
    }
  },
  {
    "id": "31384_50001",
    "name": "Kolors by Keisler, Independent Certified Collision Repair Center of BMW of Columbia",
    "country": "US",
    "city": "Lexington",
    "address": "5935 Edmond Highway, 29073 Lexington",
    "email": null,
    "phone": "8037714184",
    "website": null,
    "coords": {
      "lat": 33.85702133178711,
      "lng": -81.20416259765625
    }
  },
  {
    "id": "51826_01",
    "name": "BMW of Mt. Kisco",
    "country": "US",
    "city": "Mount Kisco",
    "address": "250 Kisco Ave, 10549 Mount Kisco",
    "email": "jerome.ballesteros@darcars.com",
    "phone": "9142414444",
    "website": "https://www.bmwmtkisco.com/",
    "coords": {
      "lat": 41.217586517333984,
      "lng": -73.72570037841797
    }
  },
  {
    "id": "40305_01",
    "name": "BMW of Catonsville",
    "country": "US",
    "city": "Baltimore",
    "address": "6700 Baltimore National Pike, 21228 Baltimore",
    "email": "mwinter@mileone.com",
    "phone": "4107442000",
    "website": "https://www.bmwofcatonsville.com",
    "coords": {
      "lat": 39.29018020629883,
      "lng": -76.77045440673828
    }
  },
  {
    "id": "47859_50001",
    "name": "Alioto's Garage",
    "country": "US",
    "city": "Suisun City",
    "address": "1510 Humphrey Drive, 94585 Suisun City",
    "email": null,
    "phone": "7074221072",
    "website": null,
    "coords": {
      "lat": 38.261539459228516,
      "lng": -122.00721740722656
    }
  },
  {
    "id": "50857_01",
    "name": "BMW of Lubbock",
    "country": "US",
    "city": "Lubbock",
    "address": "1120 19th St, 79401 Lubbock",
    "email": null,
    "phone": "8067638041",
    "website": null,
    "coords": {
      "lat": 33.57862854003906,
      "lng": -101.84756469726562
    }
  },
  {
    "id": "45533_01",
    "name": "BMW of the Permian Basin",
    "country": "US",
    "city": "Midland",
    "address": "1601 Avalon Drive, 79707 Midland",
    "email": null,
    "phone": "4325225900",
    "website": "https://www.bmwpb.com",
    "coords": {
      "lat": 31.99213409423828,
      "lng": -102.1712417602539
    }
  },
  {
    "id": "81000_01",
    "name": "Union Park BMW",
    "country": "US",
    "city": "Wilmington",
    "address": "901 N Union St, 19805 Wilmington",
    "email": "jeremypatterson@unionpark.com",
    "phone": "3026587245",
    "website": "https://www.unionparkbmw.com",
    "coords": {
      "lat": 39.75360107421875,
      "lng": -75.57003784179688
    }
  },
  {
    "id": "22006_01",
    "name": "BMW of Fairfax",
    "country": "US",
    "city": "Fairfax",
    "address": "8504 Lee Hwy, 22031 Fairfax",
    "email": "Charles.Barber@bmwoffairfax.com",
    "phone": "7035602300",
    "website": "https://www.bmwoffairfax.com",
    "coords": {
      "lat": 38.87356185913086,
      "lng": -77.23849487304688
    }
  },
  {
    "id": "20626_01",
    "name": "Braman BMW",
    "country": "US",
    "city": "Miami",
    "address": "2060 NE 2nd Ave, 33137 Miami",
    "email": "WPeraza@BramanMiami.com",
    "phone": "7863104249",
    "website": "https://www.bramanmotorsbmw.com",
    "coords": {
      "lat": 25.79660415649414,
      "lng": -80.19091033935547
    }
  },
  {
    "id": "41518_01",
    "name": "BMW of Freeport",
    "country": "US",
    "city": "Freeport",
    "address": "100 Cleveland Ave, 11520 Freeport",
    "email": ".",
    "phone": "5162236160",
    "website": "https://www.bmwoffreeport.com",
    "coords": {
      "lat": 40.6544075012207,
      "lng": -73.56897735595703
    }
  },
  {
    "id": "21390_01",
    "name": "Beverly Hills BMW",
    "country": "US",
    "city": "Los Angeles",
    "address": "5151 Wilshire Blvd, 90036 Los Angeles",
    "email": "Sean.Ramezani@bmwofbeverlyhills.com",
    "phone": "3103587880",
    "website": "https://www.bmwofbeverlyhills.com",
    "coords": {
      "lat": 34.062538146972656,
      "lng": -118.34190368652344
    }
  },
  {
    "id": "10742_01",
    "name": "Autogermana BMW",
    "country": "US",
    "city": "Guaynabo",
    "address": "Avenida Marginal Acuarela 106, 00969 Guaynabo",
    "email": "donald.guerrero@autogermana.com",
    "phone": "7874747000",
    "website": "https://www.autogermanabmw.com",
    "coords": {
      "lat": 18.36602783203125,
      "lng": -66.10884094238281
    }
  },
  {
    "id": "68500_01",
    "name": "Park Avenue BMW",
    "country": "US",
    "city": "South Hackensack",
    "address": "530 Huyler St, 07606 South Hackensack",
    "email": "wayne@parkavemotors.com",
    "phone": "2018437900",
    "website": "https://www.parkavebmw.com",
    "coords": {
      "lat": 40.86201095581055,
      "lng": -74.04815673828125
    }
  },
  {
    "id": "75784_01",
    "name": "BMW of Fort Lauderdale",
    "country": "US",
    "city": "Fort Lauderdale",
    "address": "2601 S. Andrews Ave, 33316 Fort Lauderdale",
    "email": "kloiseau@holmanauto.com",
    "phone": "9545273800",
    "website": "https://www.bmwoffortlauderdale.com/",
    "coords": {
      "lat": 26.09012794494629,
      "lng": -80.14031219482422
    }
  },
  {
    "id": "28628_01",
    "name": "BMW of Houston Midtown",
    "country": "US",
    "city": "Houston",
    "address": "2101 San Jacinto St, 77002 Houston",
    "email": "solszewski@advantagecars.com",
    "phone": "7132891200",
    "website": "https://www.advantagebmwhouston.com",
    "coords": {
      "lat": 29.7473087310791,
      "lng": -95.36821746826172
    }
  },
  {
    "id": "46615_01",
    "name": "Kelly BMW",
    "country": "US",
    "city": "Columbus",
    "address": "4050 Morse Rd, 43230 Columbus",
    "email": "bcarter@kellybmw.com",
    "phone": "6144712277",
    "website": "https://www.kellybmw.com",
    "coords": {
      "lat": 40.059932708740234,
      "lng": -82.90641784667969
    }
  },
  {
    "id": "55806_50004",
    "name": "Cascade Collision St. George, Independent Certified Collision Repair Center of BMW of Murray",
    "country": "US",
    "city": "St. George",
    "address": "1552 Gateway Drive, 84770 St. George",
    "email": null,
    "phone": "4358179100",
    "website": null,
    "coords": {
      "lat": 37.118751525878906,
      "lng": -113.55022430419922
    }
  },
  {
    "id": "47993_01",
    "name": "Autobahn Motorcars",
    "country": "US",
    "city": "Fort Worth",
    "address": "2828 White Settlement Rd, 76107 Fort Worth",
    "email": "JKopp@AutobahnFW.com",
    "phone": "8173360885",
    "website": "https://www.shopautobahnbmw.com",
    "coords": {
      "lat": 32.759193420410156,
      "lng": -97.35804748535156
    }
  },
  {
    "id": "04660_50002",
    "name": "All City Auto Body",
    "country": "US",
    "city": "Los Angeles",
    "address": "2022 S Sepulveda Blvd, 90025 Los Angeles",
    "email": null,
    "phone": "3104772597",
    "website": null,
    "coords": {
      "lat": 34.04253005981445,
      "lng": -118.43978881835938
    }
  },
  {
    "id": "56738_01",
    "name": "Open Road BMW",
    "country": "US",
    "city": "Edison",
    "address": "720 US Highway 1, 08817 Edison",
    "email": "alison.wirth@openroad.com",
    "phone": "7328394500",
    "website": "https://www.bmwedison.com",
    "coords": {
      "lat": 40.50932312011719,
      "lng": -74.38695526123047
    }
  },
  {
    "id": "50336_01",
    "name": "BMW of Ann Arbor",
    "country": "US",
    "city": "Ann Arbor",
    "address": "4550 Jackson Road, 48103 Ann Arbor",
    "email": null,
    "phone": "7346633309",
    "website": "https://www.bmwofannarbor.com/",
    "coords": {
      "lat": 42.28659439086914,
      "lng": -83.82019805908203
    }
  },
  {
    "id": "66788_01",
    "name": "Hendrick BMW",
    "country": "US",
    "city": "Charlotte",
    "address": "6950 E Independence Blvd, 28227 Charlotte",
    "email": "HLGTLservice@hendrickauto.com",
    "phone": "8667557302",
    "website": "https://www.hendrickbmwcharlotte.com",
    "coords": {
      "lat": 35.166099548339844,
      "lng": -80.74340057373047
    }
  },
  {
    "id": "96774_01",
    "name": "Zeigler BMW",
    "country": "US",
    "city": "Kalamazoo",
    "address": "4201 Stadium Dr, 49008 Kalamazoo",
    "email": "hzkalamazoo@haroldzeigler.com",
    "phone": "2693754500",
    "website": "https://www.haroldzeiglerbmw.com",
    "coords": {
      "lat": 42.270084381103516,
      "lng": -85.63982391357422
    }
  },
  {
    "id": "36640_01",
    "name": "BMW of the Main Line",
    "country": "US",
    "city": "Bala Cynwyd",
    "address": "225 Bala Ave, 19004 Bala Cynwyd",
    "email": "sales@bmwmainline.com",
    "phone": "6106682200",
    "website": "https://www.bmwmainline.com",
    "coords": {
      "lat": 40.00629806518555,
      "lng": -75.23207092285156
    }
  },
  {
    "id": "51007_50001",
    "name": "Akiki Auto Body, Independent Certified Collision Repair Center of BMW of Norwood",
    "country": "US",
    "city": "Hyde Park",
    "address": "1550 River Street, 02136 Hyde Park",
    "email": null,
    "phone": "6173613773",
    "website": null,
    "coords": {
      "lat": 42.24911880493164,
      "lng": -71.13101959228516
    }
  },
  {
    "id": "26715_01",
    "name": "Nalley BMW of Decatur",
    "country": "US",
    "city": "Decatur",
    "address": "1606 Church St, 30033 Decatur",
    "email": "wetheridge@nalleycars.com",
    "phone": "4042921400",
    "website": "https://www.nalleybmw.com",
    "coords": {
      "lat": 33.79399871826172,
      "lng": -84.28410339355469
    }
  },
  {
    "id": "40800_50001",
    "name": "Long Island Auto Body, Independent Certified Collision Repair Center of Habberstad BMW",
    "country": "US",
    "city": "Deer Park",
    "address": "874 Long Island Ave, 11729 Deer Park",
    "email": null,
    "phone": "6317599496",
    "website": null,
    "coords": {
      "lat": 40.763938903808594,
      "lng": -73.32012939453125
    }
  },
  {
    "id": "53850_01",
    "name": "BMW of Allentown",
    "country": "US",
    "city": "Allentown",
    "address": "4600 Crackersport Rd, 18104 Allentown",
    "email": "david.sloane@sloaneautos.com",
    "phone": "6108202950",
    "website": null,
    "coords": {
      "lat": 40.60123825073242,
      "lng": -75.56300354003906
    }
  },
  {
    "id": "21850_50004",
    "name": "One Twenty Two Collision Midtown, Independent Certified Collision Repair Center of Global Imports",
    "country": "US",
    "city": "Atlanta",
    "address": "1835 Macarthur Boulevard NW, 30318 Atlanta",
    "email": null,
    "phone": "4709454897",
    "website": null,
    "coords": {
      "lat": 33.813690185546875,
      "lng": -84.44844055175781
    }
  },
  {
    "id": "54844_01",
    "name": "BMW of Henderson",
    "country": "US",
    "city": "Henderson",
    "address": "261 Auto Mall Drive, 89014 Henderson",
    "email": null,
    "phone": "7025700279",
    "website": null,
    "coords": {
      "lat": 36.04682540893555,
      "lng": -115.0246810913086
    }
  },
  {
    "id": "54386_04",
    "name": "BMW Certified Pre-Owned Medford",
    "country": "US",
    "city": "Medford",
    "address": "60 Mystic Ave, 02155 Medford",
    "email": null,
    "phone": "6177318700",
    "website": null,
    "coords": {
      "lat": 42.413448333740234,
      "lng": -71.1078109741211
    }
  },
  {
    "id": "53082_01",
    "name": "BMW of South Miami",
    "country": "US",
    "city": "Miami",
    "address": "16165 S Dixie Hwy, 33157 Miami",
    "email": null,
    "phone": "8558800590",
    "website": null,
    "coords": {
      "lat": 25.620492935180664,
      "lng": -80.34451293945312
    }
  },
  {
    "id": "16815_3",
    "name": "Tulley BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Nashua",
    "address": "147 Daniel Webster Highway, 03060 Nashua",
    "email": null,
    "phone": "6038880550",
    "website": null,
    "coords": {
      "lat": 42.724082946777344,
      "lng": -71.44672393798828
    }
  },
  {
    "id": "23200_50001",
    "name": "My Way Autobody, Independent Certified Collision Repair Center of Continental BMW of Darien",
    "country": "US",
    "city": "Stamford",
    "address": "36 Gleason Avenue, 06902 Stamford",
    "email": null,
    "phone": "2033480423",
    "website": null,
    "coords": {
      "lat": 41.04848861694336,
      "lng": -73.52747344970703
    }
  },
  {
    "id": "41518_3",
    "name": "BMW of Freeport, Certified Collision Repair Center",
    "country": "US",
    "city": "Freeport",
    "address": "153 E Merrick Rd, 11520 Freeport",
    "email": null,
    "phone": "5163780010",
    "website": null,
    "coords": {
      "lat": 40.654754638671875,
      "lng": -73.57320404052734
    }
  },
  {
    "id": "30462_50003",
    "name": "Jacks Body Shop, Independent Certified Collision Repair Center of BMW of Freehold",
    "country": "US",
    "city": "Toms River",
    "address": "2202 US Route 9, 08755 Toms River",
    "email": null,
    "phone": "7329294500",
    "website": null,
    "coords": {
      "lat": 40.035221099853516,
      "lng": -74.22390747070312
    }
  },
  {
    "id": "53290_3",
    "name": "BMW of Latham, Certified Collision Repair Center",
    "country": "US",
    "city": "Latham",
    "address": "1111 Troy Schenectady Rd, 12110 Latham",
    "email": null,
    "phone": "8884867103",
    "website": null,
    "coords": {
      "lat": 42.76685333251953,
      "lng": -73.81399536132812
    }
  },
  {
    "id": "40713_50002",
    "name": "Conestoga Collision, Independent Certified Collision Repair Center of BMW of Devon",
    "country": "US",
    "city": "Berwyn",
    "address": "961 Lancaster Ave, 19312 Berwyn",
    "email": null,
    "phone": "6106441000",
    "website": null,
    "coords": {
      "lat": 40.045379638671875,
      "lng": -75.44683837890625
    }
  },
  {
    "id": "36634_50001",
    "name": "Advanced Autobody, Independent Certified Collision Repair Center of Hilton Head BMW",
    "country": "US",
    "city": "Hilton Head",
    "address": "10 Cardinal Rd, 29926 Hilton Head",
    "email": null,
    "phone": "8433429741",
    "website": null,
    "coords": {
      "lat": 32.22288513183594,
      "lng": -80.70210266113281
    }
  },
  {
    "id": "21850_50001",
    "name": "Classic Collision, Independent Certified Collision Repair Center of Global Imports",
    "country": "US",
    "city": "Marrietta",
    "address": "701 Cobb Pkwy S, 30060 Marrietta",
    "email": null,
    "phone": "7709533366",
    "website": null,
    "coords": {
      "lat": 33.935768127441406,
      "lng": -84.51170349121094
    }
  },
  {
    "id": "42766_50001",
    "name": "Port City Collision",
    "country": "US",
    "city": "Wilmington",
    "address": "6101 A Market St, 28403 Wilmington",
    "email": null,
    "phone": "9107986151",
    "website": null,
    "coords": {
      "lat": 34.25309371948242,
      "lng": -77.85221099853516
    }
  },
  {
    "id": "66788_1",
    "name": "Hendrick BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Charlotte",
    "address": "5101 E Independence Blvd, 28212 Charlotte",
    "email": null,
    "phone": "7045667497",
    "website": null,
    "coords": {
      "lat": 35.1902961730957,
      "lng": -80.76057434082031
    }
  },
  {
    "id": "43336_3",
    "name": "BMW of Lancaster, Certified Collision Repair Center",
    "country": "US",
    "city": "Lancaster",
    "address": "1350 Loop Road, 17601 Lancaster",
    "email": null,
    "phone": "7175694269",
    "website": null,
    "coords": {
      "lat": 40.077667236328125,
      "lng": -76.33599090576172
    }
  },
  {
    "id": "26338_50002",
    "name": "Relentless Collision Morrisville, Independent Certified Collision Repair Center of BMW of Southpoint",
    "country": "US",
    "city": "Morrisville",
    "address": "104 Waldron Ct, 27560 Morrisville",
    "email": null,
    "phone": "9194607693",
    "website": null,
    "coords": {
      "lat": 35.841148376464844,
      "lng": -78.82875061035156
    }
  },
  {
    "id": "26715_1",
    "name": "Nalley BMW of Decatur, Certified Collision Repair Center",
    "country": "US",
    "city": "Stonecrest",
    "address": "7947 Mall Pkwy, 30038 Stonecrest",
    "email": null,
    "phone": "6787816368",
    "website": null,
    "coords": {
      "lat": 33.695159912109375,
      "lng": -84.10320281982422
    }
  },
  {
    "id": "20635_50001",
    "name": "Preston Collision Center, Independent Certified Collision Repair Center of Preston BMW",
    "country": "US",
    "city": "New Castle",
    "address": "1502 Wilmington Rd, 16105 New Castle",
    "email": null,
    "phone": "7246586500",
    "website": null,
    "coords": {
      "lat": 41.01737976074219,
      "lng": -80.35331726074219
    }
  },
  {
    "id": "21233_50001",
    "name": "Action Enterprises, Independent Certified Collision Repair Center of BMW of Chattanooga",
    "country": "US",
    "city": "Ooltewah",
    "address": "5617 Main St, 37363 Ooltewah",
    "email": null,
    "phone": "4232405661",
    "website": null,
    "coords": {
      "lat": 35.0743293762207,
      "lng": -85.06253814697266
    }
  },
  {
    "id": "22081_1",
    "name": "BMW of Fort Myers, Certified Collision Repair Center",
    "country": "US",
    "city": "Fort Myers",
    "address": "6211 Idlewild St, 33966 Fort Myers",
    "email": null,
    "phone": "2397915390",
    "website": null,
    "coords": {
      "lat": 26.58378028869629,
      "lng": -81.84864044189453
    }
  },
  {
    "id": "56802_50001",
    "name": "Joe Stewart Body Shop, Independent Certified Collision Repair Center of Roadshow BMW",
    "country": "US",
    "city": "Memphis",
    "address": "2916 Summer Ave, 38112 Memphis",
    "email": null,
    "phone": "9013232296",
    "website": null,
    "coords": {
      "lat": 35.14992904663086,
      "lng": -89.96395874023438
    }
  },
  {
    "id": "46615_50002",
    "name": "K-ceps Auto Body - Granville, Independent Certified Collision Repair Center of Kelly BMW",
    "country": "US",
    "city": "Granville",
    "address": "460 South Main Street, 43023 Granville",
    "email": null,
    "phone": "7405873389",
    "website": null,
    "coords": {
      "lat": 40.06373977661133,
      "lng": -82.51911163330078
    }
  },
  {
    "id": "46288_1",
    "name": "BMW of Fort Wayne, Certified Collision Repair Center",
    "country": "US",
    "city": "Fort Wayne",
    "address": "175 Grand National Drive, 46804 Fort Wayne",
    "email": null,
    "phone": "2604344957",
    "website": null,
    "coords": {
      "lat": 41.081459045410156,
      "lng": -85.22225952148438
    }
  },
  {
    "id": "86862_50001",
    "name": "Koenes Auto Body, Independent Certified Collision Repair Center of Sharpe BMW",
    "country": "US",
    "city": "Grand Rapids",
    "address": "5100 Patterson Avenue, 49512 Grand Rapids",
    "email": null,
    "phone": "6169492640",
    "website": null,
    "coords": {
      "lat": 42.87076950073242,
      "lng": -85.54643249511719
    }
  },
  {
    "id": "46631_1",
    "name": "BMW of Cincinnati North, Certified Collision Repair Center",
    "country": "US",
    "city": "Cincinnati",
    "address": "169 Northland Blvd, 45246 Cincinnati",
    "email": null,
    "phone": "5137821100",
    "website": null,
    "coords": {
      "lat": 39.283935546875,
      "lng": -84.47483825683594
    }
  },
  {
    "id": "41681_50002",
    "name": "Hendrick Collision Center of Kansas City, Independent Certified Collision Repair Center of BMW of Kansas City South",
    "country": "US",
    "city": "Kansas City",
    "address": "9400 Troost Ave, 64131 Kansas City",
    "email": null,
    "phone": "8163335600",
    "website": null,
    "coords": {
      "lat": 38.956233978271484,
      "lng": -94.57891082763672
    }
  },
  {
    "id": "26792_50001",
    "name": "Birkholz Body Werks, Independent Certified Collision Repair Center of Bill Jacobs BMW",
    "country": "US",
    "city": "Naperville",
    "address": "1560 W Ogden Ave, 60540 Naperville",
    "email": null,
    "phone": "6306379999",
    "website": null,
    "coords": {
      "lat": 41.772071838378906,
      "lng": -88.18852996826172
    }
  },
  {
    "id": "39797_50003",
    "name": "CDE Collision Center -Vissers, Independent Certified Collision Repair Center of BMW of Orland Park",
    "country": "US",
    "city": "Tinley Park",
    "address": "17500 S Harlem Ave, 60477 Tinley Park",
    "email": null,
    "phone": "7085327400",
    "website": null,
    "coords": {
      "lat": 41.57257843017578,
      "lng": -87.79337310791016
    }
  },
  {
    "id": "05042_50001",
    "name": "EuroCollision, Independent Certified Collision Repair Center of Schomp BMW of Highlands Ranch",
    "country": "US",
    "city": "Littleton",
    "address": "8536 S. Colorado Blvd., 80126 Littleton",
    "email": null,
    "phone": "3037930404",
    "website": null,
    "coords": {
      "lat": 39.56196975708008,
      "lng": -104.94084930419922
    }
  },
  {
    "id": "39314_2",
    "name": "BMW of Denver Downtown, Certified Collision Repair Center",
    "country": "US",
    "city": "Denver",
    "address": "2201 S Wabash St, 80231 Denver",
    "email": null,
    "phone": "3032433001",
    "website": null,
    "coords": {
      "lat": 39.67627716064453,
      "lng": -104.88997650146484
    }
  },
  {
    "id": "46886_50001",
    "name": "Larry H Miller Collision Center Peoria, Independent Certified Collision Repair Center of Arrowhead BMW",
    "country": "US",
    "city": "Peoria",
    "address": "17295 N 84th Ave, 85382 Peoria",
    "email": null,
    "phone": "6238152280",
    "website": null,
    "coords": {
      "lat": 33.64013671875,
      "lng": -112.24121856689453
    }
  },
  {
    "id": "47046_50003",
    "name": "Diamond Hills Collision Center, Independent Certified Collision Repair Center of BMW of Buena Park",
    "country": "US",
    "city": "Diamond Bar",
    "address": "20540 East Walnut Drive North, 91789 Diamond Bar",
    "email": null,
    "phone": "9094685626",
    "website": null,
    "coords": {
      "lat": 34.001068115234375,
      "lng": -117.85550689697266
    }
  },
  {
    "id": "20268_50004",
    "name": "First Class Collision Center, Independent Certified Collision Repair Center of Century West BMW",
    "country": "US",
    "city": "North Hollywood",
    "address": "6826 Lankershim Blvd, 91605 North Hollywood",
    "email": null,
    "phone": "8187541107",
    "website": null,
    "coords": {
      "lat": 34.1946907043457,
      "lng": -118.38768005371094
    }
  },
  {
    "id": "17966_2",
    "name": "New Century BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Alhambra",
    "address": "3001 West Main Street, 91801 Alhambra",
    "email": null,
    "phone": "6262822233",
    "website": null,
    "coords": {
      "lat": 34.09540557861328,
      "lng": -118.1572494506836
    }
  },
  {
    "id": "86513_50001",
    "name": "Crash Champions 854 Airway, Independent Certified Collision Repair Center of Sterling BMW",
    "country": "US",
    "city": "Costa Mesa",
    "address": "2975 Airway Avenue, 92626 Costa Mesa",
    "email": null,
    "phone": "7143891112",
    "website": null,
    "coords": {
      "lat": 33.67073059082031,
      "lng": -117.87696838378906
    }
  },
  {
    "id": "76731_50002",
    "name": "Central Body & Paint, Independent Certified Collision Repair Center of BMW of Honolulu",
    "country": "US",
    "city": "Aiea",
    "address": "98-021 Kamehameha Hwy, 96701 Aiea",
    "email": null,
    "phone": "8084880045",
    "website": null,
    "coords": {
      "lat": 21.38429069519043,
      "lng": -157.9525146484375
    }
  },
  {
    "id": "21616_50002",
    "name": "Kruse Lucas Body & Paint, Independent Certified Collision Repair Center of Valley BMW",
    "country": "US",
    "city": "Modesto",
    "address": "320 Motor City Court, 95356 Modesto",
    "email": null,
    "phone": "2095771747",
    "website": null,
    "coords": {
      "lat": 37.70024108886719,
      "lng": -120.99635314941406
    }
  },
  {
    "id": "49544_50004",
    "name": "European Collision Center, Independent Certified Collision Repair Center of BMW of San Francisco",
    "country": "US",
    "city": "San Francisco",
    "address": "180 12th St, 94103 San Francisco",
    "email": null,
    "phone": "4155519700",
    "website": null,
    "coords": {
      "lat": 37.771759033203125,
      "lng": -122.41754150390625
    }
  },
  {
    "id": "56779_02",
    "name": "Germain BMW Certified Pre-Owned",
    "country": "US",
    "city": "Naples",
    "address": "3707 Davis Blvd, 34104 Naples",
    "email": null,
    "phone": "2396432220",
    "website": null,
    "coords": {
      "lat": 26.139385223388672,
      "lng": -81.7629165649414
    }
  },
  {
    "id": "42367_01",
    "name": "BMW of Chico",
    "country": "US",
    "city": "Chico",
    "address": "13330 Garner Lane, 95973 Chico",
    "email": null,
    "phone": "5308931300",
    "website": "https://www.bmwofchico.com",
    "coords": {
      "lat": 39.78687286376953,
      "lng": -121.89027404785156
    }
  },
  {
    "id": "30462_50001",
    "name": "Compact Auto Body, Independent Certified Collision Repair Center of BMW of Freehold",
    "country": "US",
    "city": "Matawan",
    "address": "279 Main St., 07747 Matawan",
    "email": null,
    "phone": "7325836566",
    "website": null,
    "coords": {
      "lat": 40.40739822387695,
      "lng": -74.23602294921875
    }
  },
  {
    "id": "56738_50001",
    "name": "Heavenly Autobody, Independent Certified Collision Repair Center of Open Road BMW",
    "country": "US",
    "city": "Woodbridge",
    "address": "158 Amboy Rd, 07095 Woodbridge",
    "email": null,
    "phone": "7327261114",
    "website": null,
    "coords": {
      "lat": 40.54637908935547,
      "lng": -74.27776336669922
    }
  },
  {
    "id": "32111_50001",
    "name": "Ricks Auto Body, Independent Certified Collision Repair Center of BMW of West Springfield",
    "country": "US",
    "city": "Springfield",
    "address": "375 Pasco Road, 01119 Springfield",
    "email": null,
    "phone": "4137963368",
    "website": null,
    "coords": {
      "lat": 42.14474868774414,
      "lng": -72.50244140625
    }
  },
  {
    "id": "69000_50002",
    "name": "Mid Island Collision, Independent Certified Collision Repair Center of Rallye BMW",
    "country": "US",
    "city": "Carle Place",
    "address": "245 Glen Cove Rd, 11514 Carle Place",
    "email": null,
    "phone": "5167411800",
    "website": null,
    "coords": {
      "lat": 40.75138854980469,
      "lng": -73.61811065673828
    }
  },
  {
    "id": "34521_50001",
    "name": "Village Auto Body, Independent Certified Collision Repair Center of BMW of Southampton",
    "country": "US",
    "city": "Hampton Bays",
    "address": "82 Old Powerhead Rd, 11946 Hampton Bays",
    "email": null,
    "phone": "6317281500",
    "website": null,
    "coords": {
      "lat": 40.88481140136719,
      "lng": -72.532470703125
    }
  },
  {
    "id": "65775_50001",
    "name": "Empire State Auto Group, Independent Certified Collision Repair Center of BMW of Manhattan",
    "country": "US",
    "city": "Bronx",
    "address": "1403 Story Ave, 10473 Bronx",
    "email": null,
    "phone": "6464504191",
    "website": null,
    "coords": {
      "lat": 40.821678161621094,
      "lng": -73.88184356689453
    }
  },
  {
    "id": "86813_2",
    "name": "A & L BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Monroeville",
    "address": "3780 William Penn Hwy, 15146 Monroeville",
    "email": null,
    "phone": "4123736071",
    "website": null,
    "coords": {
      "lat": 40.4359016418457,
      "lng": -79.7842788696289
    }
  },
  {
    "id": "40808_50001",
    "name": "Crystal Clear Collision, Independent Certified Collision Repair Center of BMW of Greenwich",
    "country": "US",
    "city": "Port Chester",
    "address": "5 Rollhaus Pl, 10573 Port Chester",
    "email": null,
    "phone": "9149370214",
    "website": null,
    "coords": {
      "lat": 41.008338928222656,
      "lng": -73.65701293945312
    }
  },
  {
    "id": "26725_50001",
    "name": "Kilkeary's Auto Body, Independent Certified Collision Repair Center of Bobby Rahal BMW of South Hills",
    "country": "US",
    "city": "Eighty Four",
    "address": "647 Thomas Rd, 15330 Eighty Four",
    "email": null,
    "phone": "7249414940",
    "website": null,
    "coords": {
      "lat": 40.23862838745117,
      "lng": -80.09380340576172
    }
  },
  {
    "id": "21608_50001",
    "name": "Dorn's Body and Paint, Independent Certified Collision Repair Center of Richmond BMW",
    "country": "US",
    "city": "Mechanicsville",
    "address": "8190 Mechanicsville Tpke, 23111 Mechanicsville",
    "email": null,
    "phone": "8047463928",
    "website": null,
    "coords": {
      "lat": 37.59761428833008,
      "lng": -77.3807373046875
    }
  },
  {
    "id": "34910_1",
    "name": "BMW of Pittsburgh, Certified Collision Repair Center",
    "country": "US",
    "city": "Pittsburgh",
    "address": "4801 Baum Blvd, 15213 Pittsburgh",
    "email": null,
    "phone": "4126820788",
    "website": null,
    "coords": {
      "lat": 40.454654693603516,
      "lng": -79.94729614257812
    }
  },
  {
    "id": "45051_50001",
    "name": "Performance Auto Collision, Independent Certified Collision Repair Center of United BMW",
    "country": "US",
    "city": "Alpharetta",
    "address": "1775 Hembree Road, 30009 Alpharetta",
    "email": null,
    "phone": "7707520099",
    "website": null,
    "coords": {
      "lat": 34.060420989990234,
      "lng": -84.30625915527344
    }
  },
  {
    "id": "15268_50001",
    "name": "K&M Collision, Independent Certified Collision Repair Center of Flow BMW",
    "country": "US",
    "city": "Hickory",
    "address": "916 Lenoir Rhyne Blvd SE, 28602 Hickory",
    "email": null,
    "phone": "8285691275",
    "website": null,
    "coords": {
      "lat": 35.72237014770508,
      "lng": -81.31829071044922
    }
  },
  {
    "id": "26338_50004",
    "name": "Relentless Collision Durham, Independent Certified Collision Repair Center of BMW of Southpoint",
    "country": "US",
    "city": "Durham",
    "address": "442 Martin Luther King Jr Pkwy, 27713 Durham",
    "email": null,
    "phone": "9842786623",
    "website": null,
    "coords": {
      "lat": 35.938411712646484,
      "lng": -78.9010009765625
    }
  },
  {
    "id": "15268_2",
    "name": "Flow BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Winston Salem",
    "address": "425 Silas Creek Pkwy, 27127 Winston Salem",
    "email": null,
    "phone": "3367233524",
    "website": null,
    "coords": {
      "lat": 36.06705093383789,
      "lng": -80.2464828491211
    }
  },
  {
    "id": "51991_2",
    "name": "BMW of Greensboro, Certified Collision Repair Center",
    "country": "US",
    "city": "Greensboro",
    "address": "719 Camann St, 27407 Greensboro",
    "email": null,
    "phone": "3365470120",
    "website": null,
    "coords": {
      "lat": 36.063194274902344,
      "lng": -79.86970520019531
    }
  },
  {
    "id": "20648_50002",
    "name": "Mundys Collision, Independent Certified Collision Repair Center of BMW of Gwinnett Place",
    "country": "US",
    "city": "Lawrenceville",
    "address": "289 Hurricane Shoals Road NE, 30046 Lawrenceville",
    "email": null,
    "phone": "7709620169",
    "website": null,
    "coords": {
      "lat": 33.97542190551758,
      "lng": -83.98201751708984
    }
  },
  {
    "id": "21850_50002",
    "name": "Driven Collision, Independent Certified Collision Repair Center of Global Imports",
    "country": "US",
    "city": "Kennesaw",
    "address": "2184 Cobb Pkwy NW, 30152 Kennesaw",
    "email": null,
    "phone": "6784241308",
    "website": null,
    "coords": {
      "lat": 34.006221771240234,
      "lng": -84.60397338867188
    }
  },
  {
    "id": "26731_2",
    "name": "BMW of Dallas, Certified Collision Repair Center",
    "country": "US",
    "city": "Addison",
    "address": "4300 Lindberg Dr, 75001 Addison",
    "email": null,
    "phone": "9723921441",
    "website": null,
    "coords": {
      "lat": 32.95757293701172,
      "lng": -96.8338623046875
    }
  },
  {
    "id": "21234_50001",
    "name": "AW Collision Nashville, Independent Certified Collision Repair Center of BMW of Nashville",
    "country": "US",
    "city": "Franklin",
    "address": "150 Alpha Drive, 37064 Franklin",
    "email": null,
    "phone": "6292366800",
    "website": null,
    "coords": {
      "lat": 35.89690017700195,
      "lng": -86.87114715576172
    }
  },
  {
    "id": "46891_50001",
    "name": "European Paint & Body II, Independent Certified Collision Repair Center of Braman Motorcars",
    "country": "US",
    "city": "West Palm Beach",
    "address": "1575 Donna Road, 33409 West Palm Beach",
    "email": null,
    "phone": "5616878088",
    "website": null,
    "coords": {
      "lat": 26.70001983642578,
      "lng": -80.08104705810547
    }
  },
  {
    "id": "52342_50001",
    "name": "Ellsworth Auto Body, Independent Certified Collision Repair Center of BMW of North Canton",
    "country": "US",
    "city": "North Canton",
    "address": "1607 East Maple St, 44720 North Canton",
    "email": null,
    "phone": "3304996033",
    "website": null,
    "coords": {
      "lat": 40.87559127807617,
      "lng": -81.37467956542969
    }
  },
  {
    "id": "61100_50002",
    "name": "B Street Collision - West Omaha, Independent Certified Collision Repair Center of BMW of Omaha",
    "country": "US",
    "city": "Omaha",
    "address": "13222 F Street, 68137 Omaha",
    "email": null,
    "phone": "4023339872",
    "website": null,
    "coords": {
      "lat": 41.21961975097656,
      "lng": -96.12090301513672
    }
  },
  {
    "id": "16694_2",
    "name": "Grayson BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Knoxville",
    "address": "8729 Kingston Pike, 37923 Knoxville",
    "email": null,
    "phone": "8656934553",
    "website": null,
    "coords": {
      "lat": 35.918582916259766,
      "lng": -84.07380676269531
    }
  },
  {
    "id": "47993_50001",
    "name": "Caliber Collision Fort Worth - Downtown, Independent Certified Collision Repair Center of Autobahn Motorcars",
    "country": "US",
    "city": "Fort Worth",
    "address": "2510 White Settlement Road, 76107 Fort Worth",
    "email": null,
    "phone": "8173362201",
    "website": null,
    "coords": {
      "lat": 32.759090423583984,
      "lng": -97.35144805908203
    }
  },
  {
    "id": "26747_50003",
    "name": "CMS Collision, Independent Certified Collision Repair Center of Momentum BMW",
    "country": "US",
    "city": "Houston",
    "address": "4721 Boone Rd, 77072 Houston",
    "email": null,
    "phone": "7135963250",
    "website": null,
    "coords": {
      "lat": 29.704919815063477,
      "lng": -95.57537841796875
    }
  },
  {
    "id": "21294_50003",
    "name": "Updated Auto - Las Vegas, Independent Certified Collision Repair Center of BMW of Las Vegas",
    "country": "US",
    "city": "Las Vegas",
    "address": "3095 S. Highland Dr., 89109 Las Vegas",
    "email": null,
    "phone": "8312399222",
    "website": null,
    "coords": {
      "lat": 36.13383102416992,
      "lng": -115.17533111572266
    }
  },
  {
    "id": "20741_50005",
    "name": "BMW North Scottsdale, Certified Collision Repair Center",
    "country": "US",
    "city": "Phoenix",
    "address": "7111 E Princess Dr, 85054 Phoenix",
    "email": null,
    "phone": "4809418800",
    "website": null,
    "coords": {
      "lat": 33.646209716796875,
      "lng": -111.92700958251953
    }
  },
  {
    "id": "16418_50001",
    "name": "Euro Cars Collision, Independent Certified Collision Repair Center of Winslow BMW of Colorado Springs",
    "country": "US",
    "city": "Colorado Springs",
    "address": "730 N Circle Drive, 80908 Colorado Springs",
    "email": null,
    "phone": "7194731374",
    "website": null,
    "coords": {
      "lat": 38.84322738647461,
      "lng": -104.77655029296875
    }
  },
  {
    "id": "21471_3",
    "name": "BMW of Houston North, Certified Collision Repair Center",
    "country": "US",
    "city": "Houston",
    "address": "325 FM 1960 East, 77073 Houston",
    "email": null,
    "phone": "2812094040",
    "website": null,
    "coords": {
      "lat": 30.023611068725586,
      "lng": -95.42452239990234
    }
  },
  {
    "id": "31643_50002",
    "name": "Class Auto Center, Independent Certified Collision Repair Center of Long Beach BMW",
    "country": "US",
    "city": "Long Beach",
    "address": "3031 Cherry Ave, 90807 Long Beach",
    "email": null,
    "phone": "5625956400",
    "website": null,
    "coords": {
      "lat": 33.81235122680664,
      "lng": -118.1683578491211
    }
  },
  {
    "id": "47724_50001",
    "name": "AGC Collision Center Valley, Independent Certified Collision Repair Center of BMW of Sherman Oaks",
    "country": "US",
    "city": "North Hollywood",
    "address": "6831 Vineland Ave, 91605 North Hollywood",
    "email": null,
    "phone": "3236638076",
    "website": null,
    "coords": {
      "lat": 34.194820404052734,
      "lng": -118.3706283569336
    }
  },
  {
    "id": "31642_50002",
    "name": "Caliber Collision Covina, Independent Certified Collision Repair Center of BMW of Monrovia",
    "country": "US",
    "city": "Covina",
    "address": "433 E. San Bernardino Rd, 91723 Covina",
    "email": null,
    "phone": "6269154953",
    "website": null,
    "coords": {
      "lat": 34.09043884277344,
      "lng": -117.88160705566406
    }
  },
  {
    "id": "44427_50001",
    "name": "i10 Collision, Independent Certified Collision Repair Center of BMW of Palm Springs",
    "country": "US",
    "city": "Thousand Palms",
    "address": "72234 Corporate Way, 92276 Thousand Palms",
    "email": null,
    "phone": "7603431115",
    "website": null,
    "coords": {
      "lat": 33.821388244628906,
      "lng": -116.40209197998047
    }
  },
  {
    "id": "47046_50004",
    "name": "Anaheim Hills Auto Body, Independent Certified Collision Repair Center of BMW of Buena Park",
    "country": "US",
    "city": "Anaheim",
    "address": "3500 E La Palma, 92806 Anaheim",
    "email": null,
    "phone": "7146328266",
    "website": null,
    "coords": {
      "lat": 33.854888916015625,
      "lng": -117.84211730957031
    }
  },
  {
    "id": "24781_2",
    "name": "BMW of Bakersfield, Certified Collision Repair Center",
    "country": "US",
    "city": "Bakersfield",
    "address": "3000 Bashirtash Dr, 93313 Bakersfield",
    "email": null,
    "phone": "6616172311",
    "website": null,
    "coords": {
      "lat": 35.31148147583008,
      "lng": -119.03697967529297
    }
  },
  {
    "id": "86513_50004",
    "name": "No.1 Collision Newport Beach, Independent Certified Collision Repair Center of Sterling BMW",
    "country": "US",
    "city": "Costa Mesa",
    "address": "2750 Bristol St, 92626 Costa Mesa",
    "email": null,
    "phone": "9493354228",
    "website": null,
    "coords": {
      "lat": 33.67435073852539,
      "lng": -117.88897705078125
    }
  },
  {
    "id": "65734_50004",
    "name": "CARSTAR City Motors Collision, Independent Certified Collision Repair Center of BMW of Santa Maria",
    "country": "US",
    "city": "Santa Maria",
    "address": "516 South Oakley Avenue, 93458 Santa Maria",
    "email": null,
    "phone": "8059228279",
    "website": null,
    "coords": {
      "lat": 34.9480094909668,
      "lng": -120.44696807861328
    }
  },
  {
    "id": "32467_50001",
    "name": "Phill Thearles Autowerks, Independent Certified Collision Repair Center of BMW of El Cajon",
    "country": "US",
    "city": "Santee",
    "address": "8809 Mission Gorge Rd, 92071 Santee",
    "email": null,
    "phone": "6194490111",
    "website": null,
    "coords": {
      "lat": 32.83539962768555,
      "lng": -117.00607299804688
    }
  },
  {
    "id": "04923_50003",
    "name": "Caliber Collision Roseville, Independent Certified Collision Repair Center of BMW of Roseville",
    "country": "US",
    "city": "Roseville",
    "address": "2018 Taylor Rd, 95678 Roseville",
    "email": null,
    "phone": "9167813242",
    "website": null,
    "coords": {
      "lat": 38.76985168457031,
      "lng": -121.25370788574219
    }
  },
  {
    "id": "40808_50003",
    "name": "J&B Body Works, Independent Certified Collision Repair Center of BMW of Greenwich",
    "country": "US",
    "city": "Mount Vernon",
    "address": "38 Beach St, 10550 Mount Vernon",
    "email": null,
    "phone": "9146648080",
    "website": null,
    "coords": {
      "lat": 40.90681076049805,
      "lng": -73.85140991210938
    }
  },
  {
    "id": "33326_50001",
    "name": "Gabriel Sports Car, Independent Certified Collision Repair Center of BMW of Westchester",
    "country": "US",
    "city": "Yonkers",
    "address": "393 Walnut St, 10701 Yonkers",
    "email": null,
    "phone": "9149651888",
    "website": null,
    "coords": {
      "lat": 40.93584060668945,
      "lng": -73.88623809814453
    }
  },
  {
    "id": "59127_50002",
    "name": "Hamden Auto Body, Independent Certified Collision Repair Center of BMW of North Haven",
    "country": "US",
    "city": "Hamden",
    "address": "2111 Dixwell Ave, 06514 Hamden",
    "email": null,
    "phone": "2032486116",
    "website": null,
    "coords": {
      "lat": 41.3685417175293,
      "lng": -72.91963958740234
    }
  },
  {
    "id": "21102_50002",
    "name": "Britland Auto Body, Independent Certified Collision Repair Center of BMW of Bridgewater",
    "country": "US",
    "city": "Bridgewater",
    "address": "26 Kearney St, 08807 Bridgewater",
    "email": null,
    "phone": "7324693285",
    "website": null,
    "coords": {
      "lat": 40.56324005126953,
      "lng": -74.56218719482422
    }
  },
  {
    "id": "46579_50001",
    "name": "Collision Pros Bodywork, Independent Certified Collision Repair Center of BMW of Ramsey",
    "country": "US",
    "city": "Waldwick",
    "address": "45 Hewson St, 07463 Waldwick",
    "email": null,
    "phone": "2018570419",
    "website": null,
    "coords": {
      "lat": 41.01520919799805,
      "lng": -74.12293243408203
    }
  },
  {
    "id": "26703_3",
    "name": "BMW of Warwick, Certified Collision Repair Center",
    "country": "US",
    "city": "Warwick",
    "address": "1517D Bald Hill Rd, 02886 Warwick",
    "email": null,
    "phone": "4018242333",
    "website": null,
    "coords": {
      "lat": 41.69908905029297,
      "lng": -71.49664306640625
    }
  },
  {
    "id": "68500_1",
    "name": "Park Avenue BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "South Hackensack",
    "address": "490 Huyler St, 07606 South Hackensack",
    "email": null,
    "phone": "8776666518",
    "website": null,
    "coords": {
      "lat": 40.861934661865234,
      "lng": -74.04840087890625
    }
  },
  {
    "id": "25770_2",
    "name": "Wide World BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Spring Valley",
    "address": "125 E Route 59, 10977 Spring Valley",
    "email": null,
    "phone": "8454252600",
    "website": null,
    "coords": {
      "lat": 41.10702896118164,
      "lng": -74.03712463378906
    }
  },
  {
    "id": "22227_2",
    "name": "Paul Miller BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Wayne",
    "address": "2075 Hamburg Tpke, 07470 Wayne",
    "email": null,
    "phone": "8623770700",
    "website": null,
    "coords": {
      "lat": 40.9797477722168,
      "lng": -74.2734146118164
    }
  },
  {
    "id": "86327_50001",
    "name": "Caliber Collision Coraopolis",
    "country": "US",
    "city": "Coraopolis",
    "address": "124 Flaugherty Run Rd, 15108 Coraopolis",
    "email": null,
    "phone": "4122643300",
    "website": null,
    "coords": {
      "lat": 40.54146957397461,
      "lng": -80.21829223632812
    }
  },
  {
    "id": "34521_50003",
    "name": "Fireplace Auto Collision, Independent Certified Collision Repair Center of BMW of Southampton",
    "country": "US",
    "city": "East Hampton",
    "address": "195 Springs Fireplace Rd, 11937 East Hampton",
    "email": null,
    "phone": "6319079839",
    "website": null,
    "coords": {
      "lat": 40.98413848876953,
      "lng": -72.17353820800781
    }
  },
  {
    "id": "66788_3",
    "name": "Hendrick BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Hickory",
    "address": "1171 A Lenoir Rhyne Blvd, 28603 Hickory",
    "email": null,
    "phone": "8284492552",
    "website": null,
    "coords": {
      "lat": 35.71580505371094,
      "lng": -81.31349182128906
    }
  },
  {
    "id": "30955_50004",
    "name": "Crash Champions LUXE | EV, Independent Certified Collision Repair Center of BMW of South Atlanta",
    "country": "US",
    "city": "Jonesboro",
    "address": "1934 Highway 85 North, 30238 Jonesboro",
    "email": null,
    "phone": "6788174722",
    "website": null,
    "coords": {
      "lat": 33.514530181884766,
      "lng": -84.42913055419922
    }
  },
  {
    "id": "55200_50002",
    "name": "Xtreme Collision, Independent Certified Collision Repair Center of BMW of Raleigh",
    "country": "US",
    "city": "Raleigh",
    "address": "4805 Hargrave Road Suite 102, 27616 Raleigh",
    "email": null,
    "phone": "9198746334",
    "website": null,
    "coords": {
      "lat": 35.852970123291016,
      "lng": -78.5928726196289
    }
  },
  {
    "id": "55200_50001",
    "name": "Relentless Collision, Independent Certified Collision Repair Center of BMW of Raleigh",
    "country": "US",
    "city": "Raleigh",
    "address": "2620 Westinghouse Blvd, 27604 Raleigh",
    "email": null,
    "phone": "9197479165",
    "website": null,
    "coords": {
      "lat": 35.816650390625,
      "lng": -78.59757232666016
    }
  },
  {
    "id": "21470_50003",
    "name": "Joe Hudson's Collision Center, Independent Certified Collision Repair Center of Century BMW",
    "country": "US",
    "city": "Spartanburg",
    "address": "2051 Chesnee Hwy, 29303 Spartanburg",
    "email": null,
    "phone": "8645912541",
    "website": null,
    "coords": {
      "lat": 34.993160247802734,
      "lng": -81.915771484375
    }
  },
  {
    "id": "41053_50001",
    "name": "Perfection Collision Center, Independent Certified Collision Repair Center of BMW of Meridian",
    "country": "US",
    "city": "Meridian",
    "address": "4712 24th Pl, 39305 Meridian",
    "email": null,
    "phone": "6015815676",
    "website": null,
    "coords": {
      "lat": 32.40702819824219,
      "lng": -88.70323944091797
    }
  },
  {
    "id": "48600_50001",
    "name": "Platinumwerks Collision Center, Independent Certified Collision Repair Center of Melbourne BMW",
    "country": "US",
    "city": "Melbourne",
    "address": "24 North Harbor City Blvd, 32935 Melbourne",
    "email": null,
    "phone": "8669826122",
    "website": null,
    "coords": {
      "lat": 28.10774040222168,
      "lng": -80.6176986694336
    }
  },
  {
    "id": "53082_1",
    "name": "BMW of South Miami, Certified Collision Repair Center",
    "country": "US",
    "city": "Miami",
    "address": "9720 SW 170th Street, 33157 Miami",
    "email": null,
    "phone": "8444491410",
    "website": null,
    "coords": {
      "lat": 25.611669540405273,
      "lng": -80.34996795654297
    }
  },
  {
    "id": "30414_50004",
    "name": "Raymond Auto Body, Independent Certified Collision Repair Center of Motorwerks BMW",
    "country": "US",
    "city": "St. Paul",
    "address": "1075 Pierce Butler Rte, 55104 St. Paul",
    "email": null,
    "phone": "6514880588",
    "website": null,
    "coords": {
      "lat": 44.96649932861328,
      "lng": -93.14530944824219
    }
  },
  {
    "id": "30414_50001",
    "name": "Master Collision, Independent Certified Collision Repair Center of Motorwerks BMW",
    "country": "US",
    "city": "Bloomington",
    "address": "1101 American Blvd West, 55420 Bloomington",
    "email": null,
    "phone": "9528814252",
    "website": null,
    "coords": {
      "lat": 44.85905075073242,
      "lng": -93.29427337646484
    }
  },
  {
    "id": "44821_1",
    "name": "BMW of Little Rock, Certified Collision Repair Center",
    "country": "US",
    "city": "Little Rock",
    "address": "1500 N Shackleford Rd Suite A, 72211 Little Rock",
    "email": null,
    "phone": "5019070217",
    "website": null,
    "coords": {
      "lat": 34.76831817626953,
      "lng": -92.39673614501953
    }
  },
  {
    "id": "47724_50002",
    "name": "Classic Collision, Independent Certified Collision Repair Center of BMW of Sherman Oaks",
    "country": "US",
    "city": "Van Nuys",
    "address": "7950 Haskell Ave, 91406 Van Nuys",
    "email": null,
    "phone": "8189090660",
    "website": null,
    "coords": {
      "lat": 34.21538162231445,
      "lng": -118.47470092773438
    }
  },
  {
    "id": "44013_50001",
    "name": "Spirit West Motor Carriage, Independent Certified Collision Repair Center of BMW of West St. Louis",
    "country": "US",
    "city": "Manchester",
    "address": "610 Park Lane, 63021 Manchester",
    "email": null,
    "phone": "6363941712",
    "website": null,
    "coords": {
      "lat": 38.59259033203125,
      "lng": -90.51764678955078
    }
  },
  {
    "id": "05042_50002",
    "name": "John's Collision Repair, Independent Certified Collision Repair Center of Schomp BMW of Highlands Ranch",
    "country": "US",
    "city": "Sheridan",
    "address": "4010 S Federal Blvd, 80110 Sheridan",
    "email": null,
    "phone": "3037894715",
    "website": null,
    "coords": {
      "lat": 39.645408630371094,
      "lng": -105.0284423828125
    }
  },
  {
    "id": "05042_50003",
    "name": "Stuttgart Auto Body, Independent Certified Collision Repair Center of Schomp BMW of Highlands Ranch",
    "country": "US",
    "city": "Littleton",
    "address": "8301 Southpark Lane, 80120 Littleton",
    "email": null,
    "phone": "3039932978",
    "website": null,
    "coords": {
      "lat": 39.56666946411133,
      "lng": -105.00176239013672
    }
  },
  {
    "id": "20268_50003",
    "name": "LA Collision Centers, Independent Certified Collision Repair Center of Century West BMW",
    "country": "US",
    "city": "North Hollywood",
    "address": "8026 Lankershim Blvd, 91605 North Hollywood",
    "email": null,
    "phone": "8183088169",
    "website": null,
    "coords": {
      "lat": 34.216548919677734,
      "lng": -118.3876724243164
    }
  },
  {
    "id": "26731_3",
    "name": "BMW of Dallas, Certified Collision Repair Center",
    "country": "US",
    "city": "Dallas",
    "address": "6700 Maple Avenue, 75235 Dallas",
    "email": null,
    "phone": "9728953044",
    "website": null,
    "coords": {
      "lat": 32.83028030395508,
      "lng": -96.84574890136719
    }
  },
  {
    "id": "24335_3",
    "name": "BMW of San Diego, Certified Collision Repair Center",
    "country": "US",
    "city": "San Diego",
    "address": "7860 Balboa Ave, 92111 San Diego",
    "email": null,
    "phone": "8585605050",
    "website": null,
    "coords": {
      "lat": 32.82280731201172,
      "lng": -117.15363311767578
    }
  },
  {
    "id": "36721_50004",
    "name": "Auto Collision Group Santa Ana, Independent Certified Collision Repair Center of Crevier BMW",
    "country": "US",
    "city": "Santa Ana",
    "address": "1221 E Warner Ave, 92705 Santa Ana",
    "email": null,
    "phone": "9492201400",
    "website": null,
    "coords": {
      "lat": 33.71603012084961,
      "lng": -117.85545349121094
    }
  },
  {
    "id": "52781_50003",
    "name": "Caliber Collision - Oxnard, Independent Certified Collision Repair Center of BMW of Camarillo",
    "country": "US",
    "city": "Oxnard",
    "address": "3101 Sturgis Road, 93030 Oxnard",
    "email": null,
    "phone": "8052786688",
    "website": null,
    "coords": {
      "lat": 34.20191955566406,
      "lng": -119.13256072998047
    }
  },
  {
    "id": "23779_2",
    "name": "Hansel BMW of Santa Rosa, Certified Collision Repair Center",
    "country": "US",
    "city": "Santa Rosa",
    "address": "2966 Coors Ct, 95407 Santa Rosa",
    "email": null,
    "phone": "7075668730",
    "website": null,
    "coords": {
      "lat": 38.40565872192383,
      "lng": -122.71954345703125
    }
  },
  {
    "id": "04514_2",
    "name": "Weatherford BMW, Certified Collision Repair Center",
    "country": "US",
    "city": "Berkeley",
    "address": "1255 Eastshore Highway, 94710 Berkeley",
    "email": null,
    "phone": "5105703440",
    "website": null,
    "coords": {
      "lat": 37.87958526611328,
      "lng": -122.3068618774414
    }
  },
  {
    "id": "39315_50001",
    "name": "Diamond Auto Body, Independent Certified Collision Repair Center of BMW Fresno",
    "country": "US",
    "city": "Fresno",
    "address": "427 W Bedford Ave #107, 93711 Fresno",
    "email": null,
    "phone": "5594393868",
    "website": null,
    "coords": {
      "lat": 36.84587097167969,
      "lng": -119.80001831054688
    }
  },
  {
    "id": "04923_50002",
    "name": "Caliber Collision El Dorado Hills, Independent Certified Collision Repair Center of BMW of Roseville",
    "country": "US",
    "city": "El Dorado Hills",
    "address": "4624 Post Rd, 95762 El Dorado Hills",
    "email": null,
    "phone": "9169340559",
    "website": null,
    "coords": {
      "lat": 38.64854049682617,
      "lng": -121.06773376464844
    }
  },
  {
    "id": "36459_50001",
    "name": "Active Autobody",
    "country": "US",
    "city": "Portland",
    "address": "1835 NW Couch St, 97209 Portland",
    "email": null,
    "phone": "5032287609",
    "website": null,
    "coords": {
      "lat": 45.523658752441406,
      "lng": -122.69013214111328
    }
  },
  {
    "id": "26419_50001",
    "name": "High Tech Collision, Independent Certified Collision Repair Center of Bill Pearce BMW",
    "country": "US",
    "city": "Sparks",
    "address": "1236 Glendale Avenue, 89431 Sparks",
    "email": null,
    "phone": "7758561820",
    "website": null,
    "coords": {
      "lat": 39.52798080444336,
      "lng": -119.7583236694336
    }
  },
  {
    "id": "36637_50001",
    "name": "Crash Champions - Lutz",
    "country": "US",
    "city": "Land O Lakes",
    "address": "5602 Land O Lakes Blvd, 34638 Land O Lakes",
    "email": null,
    "phone": "8133039685",
    "website": null,
    "coords": {
      "lat": 28.259889602661133,
      "lng": -82.47501373291016
    }
  },
  {
    "id": "20173_01",
    "name": "New Country BMW",
    "country": "US",
    "city": "Hartford",
    "address": "1 Weston Park Rd, 06120 Hartford",
    "email": "bsmall@newcountry.com",
    "phone": "8605226273",
    "website": "https://www.newcountrybmw.com",
    "coords": {
      "lat": 41.781944274902344,
      "lng": -72.66758728027344
    }
  },
  {
    "id": "23418_01",
    "name": "Flemington BMW",
    "country": "US",
    "city": "Flemington",
    "address": "216 US Highway 202/31, 08822 Flemington",
    "email": "bbrisbyjr@flemingtonbmw.com",
    "phone": "9087882691",
    "website": "https://www.flemingtonbmw.com",
    "coords": {
      "lat": 40.48752212524414,
      "lng": -74.86270904541016
    }
  },
  {
    "id": "26717_01",
    "name": "BMW of Bloomfield",
    "country": "US",
    "city": "Bloomfield",
    "address": "425 Bloomfield Ave, 07003 Bloomfield",
    "email": "chrischang@dchusa.com",
    "phone": "9737488200",
    "website": "https://www.bmwofbloomfield.com",
    "coords": {
      "lat": 40.78884506225586,
      "lng": -74.19490051269531
    }
  },
  {
    "id": "33326_01",
    "name": "BMW of Westchester",
    "country": "US",
    "city": "White Plains",
    "address": "543 Tarrytown Road, 10607 White Plains",
    "email": "jdinnocenzo@westchesterbmw.com",
    "phone": "9147616666",
    "website": "https://www.westchesterbmw.com",
    "coords": {
      "lat": 41.04432678222656,
      "lng": -73.80299377441406
    }
  },
  {
    "id": "51007_01",
    "name": "BMW of Norwood",
    "country": "US",
    "city": "Norwood",
    "address": "918 - 920 Boston-Providence Turnpike, 02062 Norwood",
    "email": null,
    "phone": "7817622691",
    "website": "https://www.bmwnorwood.com/",
    "coords": {
      "lat": 42.181114196777344,
      "lng": -71.18788146972656
    }
  },
  {
    "id": "21614_01",
    "name": "BMW of the Hudson Valley",
    "country": "US",
    "city": "Poughkeepsie",
    "address": "2068 South Rd, 12601 Poughkeepsie",
    "email": "jwalton@bmwhudsonvalley.com",
    "phone": "8454621030",
    "website": "https://www.bmwhudsonvalley.com",
    "coords": {
      "lat": 41.63072204589844,
      "lng": -73.91542053222656
    }
  },
  {
    "id": "36635_01",
    "name": "BMW of Cape Cod",
    "country": "US",
    "city": "Hyannis",
    "address": "500 Yarmouth Rd, 02601 Hyannis",
    "email": null,
    "phone": "8883060995",
    "website": "https://www.bmwofcapecod.com",
    "coords": {
      "lat": 41.666282653808594,
      "lng": -70.27146911621094
    }
  },
  {
    "id": "48289_01",
    "name": "BMW of Owings Mills",
    "country": "US",
    "city": "Owings Mills",
    "address": "9702 Reisterstown Rd, 21117 Owings Mills",
    "email": "ijaved@saffordauto.com",
    "phone": "4109028700",
    "website": "https://www.bmwofowingsmills.com",
    "coords": {
      "lat": 39.40568542480469,
      "lng": -76.76106262207031
    }
  },
  {
    "id": "29461_01",
    "name": "BMW of Stratham",
    "country": "US",
    "city": "Stratham",
    "address": "71 Portsmouth Ave, 03885 Stratham",
    "email": "mwilkins@group1auto.com",
    "phone": "6037720000",
    "website": "https://www.bmwofstratham.com",
    "coords": {
      "lat": 43.010311126708984,
      "lng": -70.91860961914062
    }
  },
  {
    "id": "21470_01",
    "name": "Century BMW",
    "country": "US",
    "city": "Greenville",
    "address": "2934 Laurens Road, 29607 Greenville",
    "email": "bmw@century-bmw.com",
    "phone": "8642346437",
    "website": "https://www.century-bmw.com",
    "coords": {
      "lat": 34.809288024902344,
      "lng": -82.33202362060547
    }
  },
  {
    "id": "36688_01",
    "name": "Newbold BMW",
    "country": "US",
    "city": "O Fallon",
    "address": "1283 Central Park Dr, 62269 O Fallon",
    "email": "knewbold@newboldbmw.com",
    "phone": "6186287300",
    "website": "https://www.newboldbmw.com",
    "coords": {
      "lat": 38.58469772338867,
      "lng": -89.94012451171875
    }
  },
  {
    "id": "31384_01",
    "name": "BMW of Columbia",
    "country": "US",
    "city": "Columbia",
    "address": "250 Killian Commons Parkway, 29203 Columbia",
    "email": "samreynolds@group1auto.com",
    "phone": "8034045400",
    "website": "https://www.bmwofcolumbia.com",
    "coords": {
      "lat": 34.12662887573242,
      "lng": -80.95915222167969
    }
  },
  {
    "id": "46518_01",
    "name": "BMW of Crystal Lake",
    "country": "US",
    "city": "Crystal Lake",
    "address": "360 N Route 31, 60012 Crystal Lake",
    "email": "lruscitti@andersoncars.com",
    "phone": "8154554330",
    "website": "https://www.bmwofcrystallake.com",
    "coords": {
      "lat": 42.251346588134766,
      "lng": -88.28752899169922
    }
  },
  {
    "id": "27600_02",
    "name": "Dreyer & Reinbold, Inc.",
    "country": "US",
    "city": "Greenwood",
    "address": "1301 US Highway 31 S, 46143 Greenwood",
    "email": "greenwoodsales@dreyerreinbold.com",
    "phone": "3178854800",
    "website": "https://www.dreyerreinboldbmwsouth.com",
    "coords": {
      "lat": 39.5975341796875,
      "lng": -86.10396575927734
    }
  },
  {
    "id": "46387_01",
    "name": "Dubuque BMW",
    "country": "US",
    "city": "Dubuque",
    "address": "600 Century Dr, 52002 Dubuque",
    "email": null,
    "phone": "5635837345",
    "website": "https://www.bmwofdubuque.com",
    "coords": {
      "lat": 42.49264907836914,
      "lng": -90.72621154785156
    }
  },
  {
    "id": "46288_01",
    "name": "BMW of Fort Wayne",
    "country": "US",
    "city": "Fort Wayne",
    "address": "715 Grand National Drive, 46804 Fort Wayne",
    "email": "sales@kelleyauto.com",
    "phone": "8669380974",
    "website": "https://www.bmwfortwayne.com",
    "coords": {
      "lat": 41.077430725097656,
      "lng": -85.2262191772461
    }
  },
  {
    "id": "86302_01",
    "name": "Enterprise BMW",
    "country": "US",
    "city": "Appleton",
    "address": "3002 Victory Ln, 54913 Appleton",
    "email": "enterprisemotorcars@bergstromauto.com",
    "phone": "9207492020",
    "website": "https://www.enterprisebmw.com",
    "coords": {
      "lat": 44.29092025756836,
      "lng": -88.46959686279297
    }
  },
  {
    "id": "51991_01",
    "name": "BMW of Greensboro",
    "country": "US",
    "city": "Greensboro",
    "address": "3902 W Wendover Ave, 27407 Greensboro",
    "email": null,
    "phone": "3363233900",
    "website": null,
    "coords": {
      "lat": 36.06050109863281,
      "lng": -79.87740325927734
    }
  },
  {
    "id": "36322_01",
    "name": "Taylor BMW",
    "country": "US",
    "city": "Evans",
    "address": "4180 Washington Rd, 30809 Evans",
    "email": "taylorbmw@eleadtrack.net",
    "phone": "7068686400",
    "website": "https://www.taylorbmw.com",
    "coords": {
      "lat": 33.51897048950195,
      "lng": -82.11769104003906
    }
  },
  {
    "id": "46786_01",
    "name": "Perillo BMW, Inc.",
    "country": "US",
    "city": "Chicago",
    "address": "1035 N Clark St, 60610 Chicago",
    "email": "mark@joeperillo.com",
    "phone": "3129810000",
    "website": "https://www.perillobmw.com",
    "coords": {
      "lat": 41.90172576904297,
      "lng": -87.6312026977539
    }
  },
  {
    "id": "47727_01",
    "name": "BMW of Ocala",
    "country": "US",
    "city": "Ocala",
    "address": "5145 SW College Road, 34474 Ocala",
    "email": "rcole@gettel.com",
    "phone": "3528610234",
    "website": null,
    "coords": {
      "lat": 29.130319595336914,
      "lng": -82.2054443359375
    }
  },
  {
    "id": "46586_01",
    "name": "BMW of Delray Beach",
    "country": "US",
    "city": "Delray Beach",
    "address": "1311 Linton Boulevard, 33444 Delray Beach",
    "email": null,
    "phone": "5614912329",
    "website": "https://www.bmwdelraybeach.com",
    "coords": {
      "lat": 26.440135955810547,
      "lng": -80.08637237548828
    }
  },
  {
    "id": "10698_01",
    "name": "Sandy Sansing BMW",
    "country": "US",
    "city": "Pensacola",
    "address": "186 W Airport Blvd, 32505 Pensacola",
    "email": "jrowell@sandysansing.com",
    "phone": "8504771855",
    "website": "https://www.sandysansingbmw.com",
    "coords": {
      "lat": 30.473411560058594,
      "lng": -87.25170135498047
    }
  },
  {
    "id": "29672_01",
    "name": "BMW of Des Moines",
    "country": "US",
    "city": "Urbandale",
    "address": "9631 Hickman Road, 50322 Urbandale",
    "email": "sales@bmwdesmoines.com",
    "phone": "5159895681",
    "website": "https://www.bmwdesmoines.com",
    "coords": {
      "lat": 41.616111755371094,
      "lng": -93.7547378540039
    }
  },
  {
    "id": "46872_01",
    "name": "BMW of North Liberty",
    "country": "US",
    "city": "North Liberty",
    "address": "525 N Madison Ave, 52317 North Liberty",
    "email": "jjunge@junge.com",
    "phone": "3196269500",
    "website": "http://www.bmwofnorthliberty.com",
    "coords": {
      "lat": 41.75155258178711,
      "lng": -91.63642883300781
    }
  },
  {
    "id": "21471_01",
    "name": "BMW of Houston North",
    "country": "US",
    "city": "Houston",
    "address": "17730 North Fwy, 77090 Houston",
    "email": "nguyent20@autonation.com",
    "phone": "2817754400",
    "website": "https://www.bmwofhoustonnorth.com",
    "coords": {
      "lat": 30.024381637573242,
      "lng": -95.42741394042969
    }
  },
  {
    "id": "53089_01",
    "name": "BMW of Beaumont",
    "country": "US",
    "city": "Beaumont",
    "address": "1855 Interstate 10 S, 77701 Beaumont",
    "email": null,
    "phone": "4098403585",
    "website": null,
    "coords": {
      "lat": 30.058799743652344,
      "lng": -94.13529968261719
    }
  },
  {
    "id": "48291_01",
    "name": "Santa Fe BMW",
    "country": "US",
    "city": "Santa Fe",
    "address": "2578 Camino Entrada, 87507 Santa Fe",
    "email": "pday@santafebmw.com",
    "phone": "5054740066",
    "website": null,
    "coords": {
      "lat": 35.63224411010742,
      "lng": -106.02317810058594
    }
  },
  {
    "id": "40807_01",
    "name": "BMW of Bend",
    "country": "US",
    "city": "Bend",
    "address": "1045 SE 3rd St, 97702 Bend",
    "email": "chrisroot@kendallauto.com",
    "phone": "5413821711",
    "website": "https://www.kendallbmwofbend.com",
    "coords": {
      "lat": 44.0401496887207,
      "lng": -121.30551147460938
    }
  },
  {
    "id": "44427_01",
    "name": "BMW of Palm Springs",
    "country": "US",
    "city": "Palm Springs",
    "address": "3737 E Palm Canyon Dr, 92264 Palm Springs",
    "email": "FPierce@indigoautogroup.com",
    "phone": "7603247071",
    "website": "https://www.BMWpalmsprings.com",
    "coords": {
      "lat": 33.795047760009766,
      "lng": -116.50445556640625
    }
  },
  {
    "id": "24335_01",
    "name": "BMW of San Diego",
    "country": "US",
    "city": "San Diego",
    "address": "5090 Kearny Mesa Rd, 92111 San Diego",
    "email": "tmoorman@penskeautomotive.com",
    "phone": "8585605050",
    "website": "https://www.bmwofsandiego.com",
    "coords": {
      "lat": 32.82780075073242,
      "lng": -117.14469909667969
    }
  },
  {
    "id": "76837_01",
    "name": "Pacific BMW",
    "country": "US",
    "city": "Glendale",
    "address": "800 S Brand Blvd, 91204 Glendale",
    "email": "servicebdlc@pacificbmw.com",
    "phone": "8182465600",
    "website": "https://www.pacificbmw.com",
    "coords": {
      "lat": 34.13700485229492,
      "lng": -118.25481414794922
    }
  },
  {
    "id": "30822_01",
    "name": "BMW of Monterey",
    "country": "US",
    "city": "Seaside",
    "address": "1 Geary Plz, 93955 Seaside",
    "email": "sales@bmwmonterey.com",
    "phone": "8775835029",
    "website": "https://www.bmwmonterey.com",
    "coords": {
      "lat": 36.614410400390625,
      "lng": -121.84353637695312
    }
  },
  {
    "id": "28786_01",
    "name": "BMW of Anchorage",
    "country": "US",
    "city": "Anchorage",
    "address": "730 E 5th Avenue, 99501 Anchorage",
    "email": "sales@bmwofanchorage.com",
    "phone": "9076467500",
    "website": "https://www.bmwofanchorage.com",
    "coords": {
      "lat": 61.21715545654297,
      "lng": -149.87034606933594
    }
  },
  {
    "id": "76350_01",
    "name": "BMW of Tenafly",
    "country": "US",
    "city": "Tenafly",
    "address": "301 County Rd, 07670 Tenafly",
    "email": "Service@bmwoftenafly.com",
    "phone": "2015689000",
    "website": "https://www.bmwoftenafly.com",
    "coords": {
      "lat": 40.93455505371094,
      "lng": -73.95751190185547
    }
  },
  {
    "id": "40800_03",
    "name": "Habberstad BMW of Bay Shore",
    "country": "US",
    "city": "Bay Shore",
    "address": "600 Sunrise Highway, 11706 Bay Shore",
    "email": "info@habberstadbmw.com",
    "phone": "6316476700",
    "website": "https://www.habberstadbmwofbayshore.com/",
    "coords": {
      "lat": 40.7269172668457,
      "lng": -73.28337097167969
    }
  },
  {
    "id": "30462_01",
    "name": "BMW of Freehold",
    "country": "US",
    "city": "Freehold",
    "address": "4225 US Highway 9, 07728 Freehold",
    "email": "ddado@dchusa.com",
    "phone": "7324620042",
    "website": "https://www.bmwoffreehold.com",
    "coords": {
      "lat": 40.2751579284668,
      "lng": -74.2939682006836
    }
  },
  {
    "id": "34521_01",
    "name": "BMW of Southampton",
    "country": "US",
    "city": "Southampton",
    "address": "759 County Rd 39A, 11968 Southampton",
    "email": null,
    "phone": "6312830888",
    "website": "https://www.bmwofsouthampton.com",
    "coords": {
      "lat": 40.898887634277344,
      "lng": -72.37290954589844
    }
  },
  {
    "id": "44721_01",
    "name": "Wyoming Valley BMW",
    "country": "US",
    "city": "Wilkes-Barre",
    "address": "1470 Pennsylvania 315, 18702 Wilkes-Barre",
    "email": null,
    "phone": "5702871133",
    "website": "https://www.bmwofwyomingvalley.com",
    "coords": {
      "lat": 41.273353576660156,
      "lng": -75.80581665039062
    }
  },
  {
    "id": "46539_01",
    "name": "BMW of Shrewsbury",
    "country": "US",
    "city": "Shrewsbury",
    "address": "770 Boston Turnpike, 01545 Shrewsbury",
    "email": null,
    "phone": "5085815500",
    "website": "https://www.bmwofshrewsbury.com/",
    "coords": {
      "lat": 42.277244567871094,
      "lng": -71.6936264038086
    }
  },
  {
    "id": "54571_01",
    "name": "BMW of State College",
    "country": "US",
    "city": "State College",
    "address": "120 E Clinton Ave, 16803 State College",
    "email": null,
    "phone": "8147531200",
    "website": null,
    "coords": {
      "lat": 40.8036994934082,
      "lng": -77.88400268554688
    }
  },
  {
    "id": "50948_01",
    "name": "BMW of Rockville",
    "country": "US",
    "city": "Rockville",
    "address": "1450 Rockville Pike, 20852 Rockville",
    "email": null,
    "phone": "3019848989",
    "website": "https://www.bmwrockville.com/",
    "coords": {
      "lat": 39.06649398803711,
      "lng": -77.12751770019531
    }
  },
  {
    "id": "16718_01",
    "name": "The Automaster",
    "country": "US",
    "city": "Shelburne",
    "address": "3328 Shelburne Rd, 05482 Shelburne",
    "email": "hani@theautomaster.com",
    "phone": "8029858411",
    "website": "https://www.theautomasterbmw.com",
    "coords": {
      "lat": 44.40839385986328,
      "lng": -73.21846771240234
    }
  },
  {
    "id": "26725_01",
    "name": "Bobby Rahal BMW of South Hills",
    "country": "US",
    "city": "Canonsburg",
    "address": "2610 Washington Rd, 15317 Canonsburg",
    "email": "kkaminsky@bobbyrahalbmw.com",
    "phone": "7247462600",
    "website": "https://www.bobbyrahalbmw.com",
    "coords": {
      "lat": 40.25483703613281,
      "lng": -80.15635681152344
    }
  },
  {
    "id": "56357_03",
    "name": "BMW of Westlake",
    "country": "US",
    "city": "Middleburg Heights",
    "address": "6976 Pearl Road, 44130 Middleburg Heights",
    "email": null,
    "phone": "4408459333",
    "website": "https://www.bmwofwestlake.com",
    "coords": {
      "lat": 41.37688446044922,
      "lng": -81.79523468017578
    }
  },
  {
    "id": "31663_01",
    "name": "BMW of Dayton",
    "country": "US",
    "city": "Dayton",
    "address": "7124 Poe Ave, 45414 Dayton",
    "email": "jtillman@evanscars.com",
    "phone": "9378906200",
    "website": "https://www.bmwofdayton.com",
    "coords": {
      "lat": 39.85052490234375,
      "lng": -84.18791198730469
    }
  },
  {
    "id": "56357_01",
    "name": "BMW of Westlake",
    "country": "US",
    "city": "Westlake",
    "address": "24690 Sperry Drive, 44145 Westlake",
    "email": "leads@bmwofwestlake.com",
    "phone": "4408870000",
    "website": "https://www.bmwofwestlake.com",
    "coords": {
      "lat": 41.47538375854492,
      "lng": -81.89452362060547
    }
  },
  {
    "id": "15673_01",
    "name": "Moses BMW",
    "country": "US",
    "city": "Saint Albans",
    "address": "2001 MacCorkle Ave, 25177 Saint Albans",
    "email": "mosesbmwwv@gmail..com",
    "phone": "3047224900",
    "website": "https://www.mosesbmw.com",
    "coords": {
      "lat": 38.38641357421875,
      "lng": -81.81378173828125
    }
  },
  {
    "id": "36752_01",
    "name": "Valley Auto World, Inc.",
    "country": "US",
    "city": "Fayetteville",
    "address": "3822 Sycamore Dairy Rd, 28303 Fayetteville",
    "email": "ethompson@valleyautoworld.com",
    "phone": "9108677000",
    "website": "https://www.valleyautoworldbmw.com",
    "coords": {
      "lat": 35.0796012878418,
      "lng": -78.9468002319336
    }
  },
  {
    "id": "50888_01",
    "name": "BMW of Grand Blanc",
    "country": "US",
    "city": "Grand Blanc",
    "address": "9099 Holly Rd, 48439 Grand Blanc",
    "email": null,
    "phone": "8106954400",
    "website": "https://www.bmwgrandblanc.com/",
    "coords": {
      "lat": 42.90031433105469,
      "lng": -83.62992095947266
    }
  },
  {
    "id": "56892_01",
    "name": "Rick Hill BMW",
    "country": "US",
    "city": "Kingsport",
    "address": "865 E Stone Dr, 37660 Kingsport",
    "email": "rickhillbmw@rickhillimports.net",
    "phone": "4232242100",
    "website": "https://www.rickhillimports.com",
    "coords": {
      "lat": 36.556644439697266,
      "lng": -82.53900909423828
    }
  },
  {
    "id": "46389_01",
    "name": "Basney BMW",
    "country": "US",
    "city": "South Bend",
    "address": "52203 State Rd 933, 46637 South Bend",
    "email": "chad@basneyimports.com",
    "phone": "5742728504",
    "website": "https://www.basneybmw.com",
    "coords": {
      "lat": 41.734615325927734,
      "lng": -86.25110626220703
    }
  },
  {
    "id": "86627_01",
    "name": "Don Jacobs BMW",
    "country": "US",
    "city": "Lexington",
    "address": "2689 Nicholasville Rd, 40503 Lexington",
    "email": "sbrittain@donjacobs.com",
    "phone": "8592763546",
    "website": "https://www.donjacobsbmw.com",
    "coords": {
      "lat": 37.998268127441406,
      "lng": -84.52265167236328
    }
  },
  {
    "id": "33147_01",
    "name": "BMW of Asheville",
    "country": "US",
    "city": "Arden",
    "address": "31 Skyland Inn Drive, 28704 Arden",
    "email": "larryt@fieldsauto.com",
    "phone": "8286819900",
    "website": "https://www.bmwofasheville.com",
    "coords": {
      "lat": 35.48066711425781,
      "lng": -82.55372619628906
    }
  },
  {
    "id": "86862_01",
    "name": "Sharpe BMW",
    "country": "US",
    "city": "Grand Rapids",
    "address": "1010 28th St SE, 49508 Grand Rapids",
    "email": "leads@sharpecrm.net",
    "phone": "6164525101",
    "website": "https://www.sharpebmw.com",
    "coords": {
      "lat": 42.91239929199219,
      "lng": -85.6404037475586
    }
  },
  {
    "id": "39797_01",
    "name": "BMW of Orland Park",
    "country": "US",
    "city": "Orland Park",
    "address": "11030 W 159th St, 60467 Orland Park",
    "email": null,
    "phone": "7084604545",
    "website": "https://www.bmwoforlandpark.com",
    "coords": {
      "lat": 41.600791931152344,
      "lng": -87.88729095458984
    }
  },
  {
    "id": "25000_01",
    "name": "Critz BMW",
    "country": "US",
    "city": "Savannah",
    "address": "7009 Abercorn St, 31406 Savannah",
    "email": "info@critz.com",
    "phone": "9123547000",
    "website": "https://www.critzbmw.com",
    "coords": {
      "lat": 32.0140380859375,
      "lng": -81.11492156982422
    }
  },
  {
    "id": "52244_01",
    "name": "BMW of Barrington",
    "country": "US",
    "city": "Barrington",
    "address": "1475 S Barrington Rd, 60010 Barrington",
    "email": "tkioutas@motorwerksautomotive.com",
    "phone": "8473818900",
    "website": null,
    "coords": {
      "lat": 42.129398345947266,
      "lng": -88.13500213623047
    }
  },
  {
    "id": "26726_01",
    "name": "BMW of Albany",
    "country": "US",
    "city": "Albany",
    "address": "801 E Oglethorpe Blvd, 31705 Albany",
    "email": "albanymotorcars@newsales.leads.cmdlr.com",
    "phone": "2298832040",
    "website": "https://www.bmwofalbany.com",
    "coords": {
      "lat": 31.574298858642578,
      "lng": -84.1320571899414
    }
  },
  {
    "id": "53781_01",
    "name": "Isringhausen Imports",
    "country": "US",
    "city": "Springfield",
    "address": "200 E Madison St, 62702 Springfield",
    "email": "sales@isringhausen.com",
    "phone": "2175282042",
    "website": "https://www.isringhausenbmw.com",
    "coords": {
      "lat": 39.80375289916992,
      "lng": -89.65260314941406
    }
  },
  {
    "id": "21851_01",
    "name": "BMW of Birmingham",
    "country": "US",
    "city": "Irondale",
    "address": "1000 Tom Williams Way, 35210 Irondale",
    "email": "kaleb.redmond@birminghambmw.com",
    "phone": "2052529512",
    "website": "http://www.birminghambmw.com/",
    "coords": {
      "lat": 33.52226638793945,
      "lng": -86.66365051269531
    }
  },
  {
    "id": "26540_01",
    "name": "Athens BMW",
    "country": "US",
    "city": "Athens",
    "address": "3040 Atlanta Hwy, 30606 Athens",
    "email": "jeff.socha@athensbmw.com",
    "phone": "7065495340",
    "website": "https://www.athensbmw.com",
    "coords": {
      "lat": 33.94367599487305,
      "lng": -83.44194793701172
    }
  },
  {
    "id": "52800_01",
    "name": "Karl Knauz Motors",
    "country": "US",
    "city": "Lake Bluff",
    "address": "407 Skokie Hwy, 60044 Lake Bluff",
    "email": "Sales@karlknauzbmw.edealerhub.com",
    "phone": "8476045000",
    "website": "https://www.knauzbmw.com/index.htm",
    "coords": {
      "lat": 42.276817321777344,
      "lng": -87.86903381347656
    }
  },
  {
    "id": "30955_01",
    "name": "BMW of South Atlanta",
    "country": "US",
    "city": "Union City",
    "address": "4171 Jonesboro Rd, 30291 Union City",
    "email": "cnalley@sonsautogroup.com",
    "phone": "7709690755",
    "website": "https://www.bmwofsouthatlanta.com",
    "coords": {
      "lat": 33.5677604675293,
      "lng": -84.52281188964844
    }
  },
  {
    "id": "46778_01",
    "name": "Tom Bush BMW Jacksonville",
    "country": "US",
    "city": "Jacksonville",
    "address": "9875 Atlantic Blvd, 32225 Jacksonville",
    "email": "robert.sharp@tombush.com",
    "phone": "9043714790",
    "website": "https://www.tombushbmw.com",
    "coords": {
      "lat": 30.322429656982422,
      "lng": -81.54298400878906
    }
  },
  {
    "id": "32923_01",
    "name": "Bluegrass BMW",
    "country": "US",
    "city": "Paducah",
    "address": "3235 Park Ave, 42001 Paducah",
    "email": "joe.langston@bluegrassbmw.com",
    "phone": "2704440660",
    "website": "https://www.bluegrassbmw.com",
    "coords": {
      "lat": 37.08433532714844,
      "lng": -88.650634765625
    }
  },
  {
    "id": "44013_01",
    "name": "BMW of West St. Louis",
    "country": "US",
    "city": "Manchester",
    "address": "14417 Manchester Rd, 63011 Manchester",
    "email": null,
    "phone": "6362275454",
    "website": "https://bmwofweststlouis.com",
    "coords": {
      "lat": 38.593299865722656,
      "lng": -90.51699829101562
    }
  },
  {
    "id": "96255_01",
    "name": "Fields BMW",
    "country": "US",
    "city": "Winter Park",
    "address": "963 Wymore Rd, 32789 Winter Park",
    "email": null,
    "phone": "4076282100",
    "website": "https://www.fieldsbmworlando.com",
    "coords": {
      "lat": 28.60810089111328,
      "lng": -81.38529968261719
    }
  },
  {
    "id": "26273_01",
    "name": "BMW of Columbia",
    "country": "US",
    "city": "Columbia",
    "address": "1900 Interstate 70 Drive SW, 65203 Columbia",
    "email": "sveros@drewingauto.com",
    "phone": "5734462691",
    "website": "https://www.columbiabmw.com",
    "coords": {
      "lat": 38.964168548583984,
      "lng": -92.36165618896484
    }
  },
  {
    "id": "30414_01",
    "name": "Motorwerks BMW",
    "country": "US",
    "city": "Bloomington",
    "address": "1300 American Blvd W, 55420 Bloomington",
    "email": "atarar@penskeautomotive.com",
    "phone": "9528882700",
    "website": "https://www.motorwerksbmw.com",
    "coords": {
      "lat": 44.86043167114258,
      "lng": -93.2963638305664
    }
  },
  {
    "id": "75784_03",
    "name": "Lauderdale BMW of Pembroke Pines",
    "country": "US",
    "city": "Fort Lauderdale",
    "address": "14800 Sheridan St, 33331 Fort Lauderdale",
    "email": null,
    "phone": "9546205050",
    "website": "https://www.bmwofpembrokepines.com/",
    "coords": {
      "lat": 26.0286808013916,
      "lng": -80.34660339355469
    }
  },
  {
    "id": "41681_01",
    "name": "BMW of Kansas City South",
    "country": "US",
    "city": "Kansas City",
    "address": "1200 West 104th Street, 64114 Kansas City",
    "email": null,
    "phone": "8165012700",
    "website": "https://www.bmwofkansascitysouth.com",
    "coords": {
      "lat": 38.93885040283203,
      "lng": -94.60655975341797
    }
  },
  {
    "id": "61100_01",
    "name": "BMW of Omaha",
    "country": "US",
    "city": "Omaha",
    "address": "14800 Branch Street, 68154 Omaha",
    "email": "jchu@hhautomotive.com",
    "phone": "4023939700",
    "website": "https://www.bmwofomaha.com",
    "coords": {
      "lat": 41.26118469238281,
      "lng": -96.14468383789062
    }
  },
  {
    "id": "43384_01",
    "name": "Galleria BMW",
    "country": "US",
    "city": "D'Iberville",
    "address": "11282 Mandal Parkway, 39540 D'Iberville",
    "email": "sales@galleriabmw.com",
    "phone": "2282320333",
    "website": "https://www.galleriabmw.com/",
    "coords": {
      "lat": 30.45046043395996,
      "lng": -88.90154266357422
    }
  },
  {
    "id": "46891_01",
    "name": "Braman Motorcars",
    "country": "US",
    "city": "West Palm Beach",
    "address": "2901 Okeechobee Blvd, 33409 West Palm Beach",
    "email": "dbayard@bramanmotorcars.dealerspace.com",
    "phone": "5616846666",
    "website": "https://www.bramanbmwwpb.com",
    "coords": {
      "lat": 26.70743179321289,
      "lng": -80.09822845458984
    }
  },
  {
    "id": "32147_01",
    "name": "BMW of Sarasota",
    "country": "US",
    "city": "Sarasota",
    "address": "5151 Clark Rd, 34233 Sarasota",
    "email": "vyoung@bmwofsarasota.com",
    "phone": "9419232700",
    "website": "https://www.bmwofsarasota.com",
    "coords": {
      "lat": 27.270370483398438,
      "lng": -82.46697235107422
    }
  },
  {
    "id": "41274_01",
    "name": "BMW of Topeka",
    "country": "US",
    "city": "Topeka",
    "address": "3030 S Kansas Ave, 66611 Topeka",
    "email": "isaac.nichols@bmwvwtopeka.com",
    "phone": "7852668480",
    "website": "https://www.Bmwtopeka.com",
    "coords": {
      "lat": 39.013099670410156,
      "lng": -95.68190002441406
    }
  },
  {
    "id": "42319_01",
    "name": "BMW of Temple",
    "country": "US",
    "city": "Temple",
    "address": "6006 South General Bruce Drive, 76502 Temple",
    "email": "bdc@garlynshelton.com",
    "phone": "2547710128",
    "website": "https://www.garlynsheltonbmwoftemple.com",
    "coords": {
      "lat": 31.076566696166992,
      "lng": -97.41632843017578
    }
  },
  {
    "id": "26731_01",
    "name": "BMW of Dallas",
    "country": "US",
    "city": "Dallas",
    "address": "6200 Lemmon Ave, 75209 Dallas",
    "email": "delatorrej2@autonation.com",
    "phone": "2143535000",
    "website": "https://www.bmwofdallas.com",
    "coords": {
      "lat": 32.83405685424805,
      "lng": -96.82966613769531
    }
  },
  {
    "id": "46753_01",
    "name": "BMW of Lafayette",
    "country": "US",
    "city": "Lafayette",
    "address": "6652 Johnston Street, 70503 Lafayette",
    "email": "moss@moreatmoss.com",
    "phone": "3372020972",
    "website": "https://www.mossmotorsbmw.com",
    "coords": {
      "lat": 30.15531349182129,
      "lng": -92.0915298461914
    }
  },
  {
    "id": "43552_01",
    "name": "BMW of Tyler",
    "country": "US",
    "city": "Tyler",
    "address": "2401 W Southwest Loop 323, 75701 Tyler",
    "email": "jteeter@bmwoftyler.com",
    "phone": "9035617049",
    "website": "https://www.bmwoftyler.com/",
    "coords": {
      "lat": 32.304298400878906,
      "lng": -95.3307113647461
    }
  },
  {
    "id": "05042_01",
    "name": "Schomp BMW of Highlands Ranch",
    "country": "US",
    "city": "Highlands Ranch",
    "address": "1190 Plum Valley Ln, 80129 Highlands Ranch",
    "email": "jeffe@schomp.com",
    "phone": "7208940122",
    "website": "https://www.schompbmw.com",
    "coords": {
      "lat": 39.56034469604492,
      "lng": -105.00212097167969
    }
  },
  {
    "id": "35071_01",
    "name": "Jackie Cooper Imports",
    "country": "US",
    "city": "Edmond",
    "address": "14145 Broadway Ext, 73013 Edmond",
    "email": "rvairo@cooperautogroup.com",
    "phone": "8665975676",
    "website": "https://www.cooperbmw.com",
    "coords": {
      "lat": 35.614070892333984,
      "lng": -97.49381256103516
    }
  },
  {
    "id": "26167_01",
    "name": "BMW of Austin",
    "country": "US",
    "city": "Austin",
    "address": "7011 McNeil Dr, 78729 Austin",
    "email": "ahathaway@penskeautomotive.com",
    "phone": "5123433500",
    "website": "https://www.bmwofaustin.com",
    "coords": {
      "lat": 30.435998916625977,
      "lng": -97.76190185546875
    }
  },
  {
    "id": "13761_01",
    "name": "BMW of Pharr",
    "country": "US",
    "city": "Pharr",
    "address": "6001 North Cage Boulevard, 78577 Pharr",
    "email": "patrickf@bertogden.com",
    "phone": "9566866666",
    "website": "https://www.bertogdenbmw.com",
    "coords": {
      "lat": 26.246536254882812,
      "lng": -98.17742156982422
    }
  },
  {
    "id": "48401_01",
    "name": "Sandia BMW",
    "country": "US",
    "city": "Albuquerque",
    "address": "6001 Pan American West Fwy NE, 87109 Albuquerque",
    "email": "bbolio@sandiabmw.com",
    "phone": "8664289748",
    "website": null,
    "coords": {
      "lat": 35.1486701965332,
      "lng": -106.59040832519531
    }
  },
  {
    "id": "42164_01",
    "name": "BMW of San Antonio",
    "country": "US",
    "city": "San Antonio",
    "address": "15507 IH 10 West, 78249 San Antonio",
    "email": "blaird@principleauto.com",
    "phone": "2107327121",
    "website": "https://www.bmwofsanantonio.com/",
    "coords": {
      "lat": 29.583791732788086,
      "lng": -98.59464263916016
    }
  },
  {
    "id": "35744_01",
    "name": "BMW of Murrieta",
    "country": "US",
    "city": "Murrieta",
    "address": "41430 Auto Mall Pkwy, 92562 Murrieta",
    "email": "TVBBDC@HendrickAuto.com",
    "phone": "9512498000",
    "website": "https://www.bmwofmurrieta.com",
    "coords": {
      "lat": 33.532958984375,
      "lng": -117.17091369628906
    }
  },
  {
    "id": "52309_01",
    "name": "BMW of Carlsbad",
    "country": "US",
    "city": "Carlsbad",
    "address": "1060 Auto Center Court, 92008 Carlsbad",
    "email": null,
    "phone": "7603356124",
    "website": "https://www.bmwcarlsbad.com/",
    "coords": {
      "lat": 33.13491439819336,
      "lng": -117.32414245605469
    }
  },
  {
    "id": "22083_01",
    "name": "Stevens Creek BMW",
    "country": "US",
    "city": "Santa Clara",
    "address": "4343 Stevens Creek Blvd, 95051 Santa Clara",
    "email": "raul.hagen@stevenscreekbmw.com",
    "phone": "4082499070",
    "website": "https://www.scbmw.com",
    "coords": {
      "lat": 37.3238639831543,
      "lng": -121.97798156738281
    }
  },
  {
    "id": "86846_01",
    "name": "Rusnak BMW",
    "country": "US",
    "city": "Thousand Oaks",
    "address": "3645 Auto Mall Drive, 91362 Thousand Oaks",
    "email": "babdou@rusnakautogroup.com",
    "phone": "8054966500",
    "website": "https://www.rusnakbmw.com",
    "coords": {
      "lat": 34.16242980957031,
      "lng": -118.83128356933594
    }
  },
  {
    "id": "36270_01",
    "name": "BMW of El Paso",
    "country": "US",
    "city": "El Paso",
    "address": "6318 Montana Ave, 79925 El Paso",
    "email": null,
    "phone": "9157789381",
    "website": "https://www.bmwofelpaso.com",
    "coords": {
      "lat": 31.78730010986328,
      "lng": -106.40730285644531
    }
  },
  {
    "id": "55806_01",
    "name": "BMW of Murray",
    "country": "US",
    "city": "Murray",
    "address": "4735 S State St, 84107 Murray",
    "email": "kimberly.howe@bmwofmurray.com",
    "phone": "8012622479",
    "website": "https://www.bmwofmurray.com",
    "coords": {
      "lat": 40.669586181640625,
      "lng": -111.88806915283203
    }
  },
  {
    "id": "24336_01",
    "name": "BMW Seattle",
    "country": "US",
    "city": "Seattle",
    "address": "1002 Airport Way South, 98134 Seattle",
    "email": "sales@bmwseattle.com",
    "phone": "2063288787",
    "website": "https://www.bmwseattle.com",
    "coords": {
      "lat": 47.593719482421875,
      "lng": -122.32455444335938
    }
  },
  {
    "id": "21294_01",
    "name": "BMW of Las Vegas",
    "country": "US",
    "city": "Las Vegas",
    "address": "6900 W Sahara Ave, 89117 Las Vegas",
    "email": "ZiegenbeinE@autonation.com",
    "phone": "7025700279",
    "website": "https://www.bmwvegas.com/",
    "coords": {
      "lat": 36.14500427246094,
      "lng": -115.24382781982422
    }
  },
  {
    "id": "54068_01",
    "name": "BMW of Chula Vista",
    "country": "US",
    "city": "Chula Vista",
    "address": "670 Main Street, 91911 Chula Vista",
    "email": null,
    "phone": "8583628500",
    "website": "https://www.bmwofchulavista.com/",
    "coords": {
      "lat": 32.59263229370117,
      "lng": -117.02117919921875
    }
  },
  {
    "id": "86335_01",
    "name": "BMW of Visalia",
    "country": "US",
    "city": "Visalia",
    "address": "111 N Neeley St, 93291 Visalia",
    "email": "m.puentes@@bmwofvisalia.com",
    "phone": "5597324700",
    "website": "https://www.bmwofvisalia.com",
    "coords": {
      "lat": 36.329559326171875,
      "lng": -119.3958740234375
    }
  },
  {
    "id": "49962_01",
    "name": "Medford BMW",
    "country": "US",
    "city": "Medford",
    "address": "4600 Grumman Drive, 97504 Medford",
    "email": "rshultz@medfordbmw.com",
    "phone": "5417748450",
    "website": null,
    "coords": {
      "lat": 42.38113021850586,
      "lng": -122.85719299316406
    }
  },
  {
    "id": "26718_01",
    "name": "BMW Santa Barbara",
    "country": "US",
    "city": "Santa Barbara",
    "address": "402 S Hope Ave, 93105 Santa Barbara",
    "email": "BDC_CRM@sbautogroup.com",
    "phone": "8056822000",
    "website": "https://www.bmwsantabarbara.com",
    "coords": {
      "lat": 34.43467712402344,
      "lng": -119.74717712402344
    }
  },
  {
    "id": "52781_01",
    "name": "BMW of Camarillo",
    "country": "US",
    "city": "Camarillo",
    "address": "411 E Daily Dr, 93010 Camarillo",
    "email": "travisr@bmwofcamarillo.com",
    "phone": "8054828878",
    "website": null,
    "coords": {
      "lat": 34.21978759765625,
      "lng": -119.06398010253906
    }
  },
  {
    "id": "43786_01",
    "name": "BMW of Grapevine",
    "country": "US",
    "city": "Grapevine",
    "address": "1111 East State Highway 114, 76051 Grapevine",
    "email": null,
    "phone": "8179124500",
    "website": "https://www.bmwofgrapevine.com",
    "coords": {
      "lat": 32.923980712890625,
      "lng": -97.06230163574219
    }
  },
  {
    "id": "65775_04",
    "name": "BMW of Manhattan Executive Sales",
    "country": "US",
    "city": "New York",
    "address": "555 W 57th St, 10019 New York",
    "email": null,
    "phone": "2125862269",
    "website": "http://www.bmwnyc.com/",
    "coords": {
      "lat": 40.77030944824219,
      "lng": -73.99061584472656
    }
  },
  {
    "id": "47859_50002",
    "name": "Fairfield Body Shop",
    "country": "US",
    "city": "Fairfield",
    "address": "2501 Martin Road, 94534 Fairfield",
    "email": null,
    "phone": "7076399041",
    "website": null,
    "coords": {
      "lat": 38.27524185180664,
      "lng": -122.048828125
    }
  },
  {
    "id": "25770_01",
    "name": "Wide World BMW",
    "country": "US",
    "city": "Spring Valley",
    "address": "125 E Route 59, 10977 Spring Valley",
    "email": "bsorce@newcountry.com",
    "phone": "8454252600",
    "website": "http://www.wideworldofcarsbmw.com/",
    "coords": {
      "lat": 41.10701370239258,
      "lng": -74.03675079345703
    }
  },
  {
    "id": "50923_01",
    "name": "BMW of Plano",
    "country": "US",
    "city": "Plano",
    "address": "6800 Dallas Parkway, 75024 Plano",
    "email": null,
    "phone": "2147782600",
    "website": null,
    "coords": {
      "lat": 33.06644821166992,
      "lng": -96.82115936279297
    }
  },
  {
    "id": "54680_01",
    "name": "BMW of Napa Valley",
    "country": "US",
    "city": "Fairfield",
    "address": "2399 Auto Mall Parkway, 94533 Fairfield",
    "email": null,
    "phone": "7073449806",
    "website": null,
    "coords": {
      "lat": 38.24618148803711,
      "lng": -122.07627868652344
    }
  },
  {
    "id": "54576_01",
    "name": "BMW of Portland",
    "country": "US",
    "city": "Portland",
    "address": "2001 SW Jefferson St, 97201 Portland",
    "email": null,
    "phone": "5032260380",
    "website": null,
    "coords": {
      "lat": 45.519100189208984,
      "lng": -122.69512939453125
    }
  },
  {
    "id": "76504_01",
    "name": "Brian Harris BMW",
    "country": "US",
    "city": "Baton Rouge",
    "address": "12326 Airline Hwy, 70817 Baton Rouge",
    "email": "paul.macaluso@brianharrisbmw.com",
    "phone": "2257541200",
    "website": "https://www.brianharrisbmw.com",
    "coords": {
      "lat": 30.387248992919922,
      "lng": -91.04470825195312
    }
  },
  {
    "id": "45051_01",
    "name": "United BMW",
    "country": "US",
    "city": "Roswell",
    "address": "11458 Alpharetta Hwy, 30076 Roswell",
    "email": null,
    "phone": "6784303775",
    "website": "https://www.unitedbmw.com",
    "coords": {
      "lat": 34.05839538574219,
      "lng": -84.32823944091797
    }
  },
  {
    "id": "24856_01",
    "name": "BMW of Fremont",
    "country": "US",
    "city": "Fremont",
    "address": "43810 Auto Mall Cir, 94538 Fremont",
    "email": "sprengerg@autonation.com",
    "phone": "5103605900",
    "website": "https://www.bmwoffremont.com",
    "coords": {
      "lat": 37.49853515625,
      "lng": -121.97422790527344
    }
  },
  {
    "id": "21850_01",
    "name": "Global Imports",
    "country": "US",
    "city": "Atlanta",
    "address": "500 Interstate North Pkwy SE, 30339 Atlanta",
    "email": "peter.bearsch@atlantabmw.com",
    "phone": "7709512697",
    "website": "https://www.atlantabmw.com",
    "coords": {
      "lat": 33.89794158935547,
      "lng": -84.45059204101562
    }
  },
  {
    "id": "28628_50001",
    "name": "River Oaks Paint & Body Midtown, Independent Certified Collision Repair Center of BMW of Houston Midtown",
    "country": "US",
    "city": "Houston",
    "address": "2815 San Jacinto St, 77004 Houston",
    "email": null,
    "phone": "7136593393",
    "website": null,
    "coords": {
      "lat": 29.7426700592041,
      "lng": -95.37348937988281
    }
  },
  {
    "id": "10695_01",
    "name": "BMW of Manhasset",
    "country": "US",
    "city": "Great Neck",
    "address": "266 E Shore Rd, 11023 Great Neck",
    "email": "pturano@burnsmotorcompany.com",
    "phone": "7182294400",
    "website": "https://www.bmwbayside.com",
    "coords": {
      "lat": 40.7972412109375,
      "lng": -73.71314239501953
    }
  },
  {
    "id": "26776_01",
    "name": "BMW of Doylestown",
    "country": "US",
    "city": "Doylestown",
    "address": "40 W Swamp Rd, 18901 Doylestown",
    "email": "BMWSALES@1800THOMPSON.COM",
    "phone": "2153403900",
    "website": "https://www.thompsonbmw.com",
    "coords": {
      "lat": 40.32881546020508,
      "lng": -75.13053131103516
    }
  },
  {
    "id": "43336_01",
    "name": "BMW of Lancaster",
    "country": "US",
    "city": "Lancaster",
    "address": "1510 Commerce Dr, 17601 Lancaster",
    "email": "jmarquardt@faulknerbmw.com",
    "phone": "7175694269",
    "website": "https://www.faulknerbmw.com/",
    "coords": {
      "lat": 40.0777702331543,
      "lng": -76.33878326416016
    }
  },
  {
    "id": "28628_50002",
    "name": "Metropolitan Collision, Independent Certified Collision Repair Center of BMW of Houston Midtown",
    "country": "US",
    "city": "Houston",
    "address": "818 W 16th St, 77008 Houston",
    "email": null,
    "phone": "8326181700",
    "website": null,
    "coords": {
      "lat": 29.799238204956055,
      "lng": -95.4128646850586
    }
  },
  {
    "id": "54745_01",
    "name": "BMW of Erie",
    "country": "US",
    "city": "Erie",
    "address": "8670 Peach St, 16509 Erie",
    "email": null,
    "phone": "8148684805",
    "website": null,
    "coords": {
      "lat": 42.0357780456543,
      "lng": -80.06669616699219
    }
  },
  {
    "id": "52682_01",
    "name": "BMW of Bridgeport",
    "country": "US",
    "city": "Bridgeport",
    "address": "43 North Ave, 06606 Bridgeport",
    "email": "managers@bmwofbridgeport.com",
    "phone": "2033341672",
    "website": null,
    "coords": {
      "lat": 41.20201110839844,
      "lng": -73.18941497802734
    }
  },
  {
    "id": "50201_01",
    "name": "BMW of Lenox",
    "country": "US",
    "city": "Lenox",
    "address": "374 Pittsfield Road, 01240 Lenox",
    "email": "leads@mcgeeberkshires.com",
    "phone": "4134434702",
    "website": "https://www.bmwlenox.com",
    "coords": {
      "lat": 42.39710235595703,
      "lng": -73.26907348632812
    }
  },
  {
    "id": "54675_50002",
    "name": "Rosslyn Auto Body, Independent Certified Collision Repair Center of BMW of Alexandria",
    "country": "US",
    "city": "Alexandria",
    "address": "6015 Farrington Ave, 22304 Alexandria",
    "email": null,
    "phone": "7038201800",
    "website": null,
    "coords": {
      "lat": 38.79859924316406,
      "lng": -77.14082336425781
    }
  },
  {
    "id": "36639_01",
    "name": "D-Patrick Motoplex",
    "country": "US",
    "city": "Evansville",
    "address": "200 N Green River Rd, 47715 Evansville",
    "email": "info@dpatrickbmw.com",
    "phone": "8124736590",
    "website": "https://www.dpatrickbmw.com",
    "coords": {
      "lat": 37.97809982299805,
      "lng": -87.49357604980469
    }
  },
  {
    "id": "46891_50002",
    "name": "Fantastic Finishes of West Palm Beach, Independent Certified Collision Repair Center of Braman Motorcars",
    "country": "US",
    "city": "West Palm Beach",
    "address": "900 Stinson Way, 33411 West Palm Beach",
    "email": null,
    "phone": "5617904090",
    "website": null,
    "coords": {
      "lat": 26.690309524536133,
      "lng": -80.17859649658203
    }
  },
  {
    "id": "54681_01",
    "name": "Niello BMW of Elk Grove",
    "country": "US",
    "city": "Elk Grove",
    "address": "8580 Laguna Grove Drive, 95757 Elk Grove",
    "email": null,
    "phone": "9166879000",
    "website": null,
    "coords": {
      "lat": 38.402740478515625,
      "lng": -121.38951110839844
    }
  },
  {
    "id": "54776_01",
    "name": "BMW of Tuscaloosa",
    "country": "US",
    "city": "Tuscaloosa",
    "address": "3537 Skyland Boulevard East, 35405 Tuscaloosa",
    "email": null,
    "phone": "2053459811",
    "website": null,
    "coords": {
      "lat": 33.16920852661133,
      "lng": -87.49085235595703
    }
  },
  {
    "id": "25803_50001",
    "name": "True Performance",
    "country": "US",
    "city": "Plain City",
    "address": "7854 Industrial Parkway, 43064 Plain City",
    "email": null,
    "phone": "6147330708",
    "website": null,
    "coords": {
      "lat": 40.126609802246094,
      "lng": -83.1965103149414
    }
  },
  {
    "id": "04923_01",
    "name": "BMW of Roseville",
    "country": "US",
    "city": "Roseville",
    "address": "500 Automall Drive, 95661 Roseville",
    "email": "branerl@autonation.com",
    "phone": "9167829434",
    "website": "https://www.bmwroseville.com",
    "coords": {
      "lat": 38.750999450683594,
      "lng": -121.25540161132812
    }
  },
  {
    "id": "22180_50002",
    "name": "Caliber Collision Palmdale, Independent Certified Collision Repair Center of Valencia BMW",
    "country": "US",
    "city": "Palmdale",
    "address": "40360 LaQuinta Ln, 93551 Palmdale",
    "email": null,
    "phone": "6612955910",
    "website": null,
    "coords": {
      "lat": 34.61595916748047,
      "lng": -118.140380859375
    }
  },
  {
    "id": "54824_01",
    "name": "BMW of Midlothian",
    "country": "US",
    "city": "Midlothian",
    "address": "12100 Midlothian Turnpike, 23113 Midlothian",
    "email": "rperry@crownauto.com",
    "phone": "8043618758",
    "website": null,
    "coords": {
      "lat": 37.50522232055664,
      "lng": -77.62248992919922
    }
  },
  {
    "id": "54853_01",
    "name": "BMW of Pompano Beach",
    "country": "US",
    "city": "Pompano Beach",
    "address": "744 North Federal Highway, 33062 Pompano Beach",
    "email": null,
    "phone": "9544801188",
    "website": null,
    "coords": {
      "lat": 26.238554000854492,
      "lng": -80.10198211669922
    }
  },
  {
    "id": "08389_1",
    "name": "Group 1 Colchester",
    "country": "GB",
    "city": "Colchester",
    "address": "Ipswich Road, CO4 9TD Colchester",
    "email": "ColchesterBMW@group1auto.co.uk",
    "phone": "+44-1206-932159",
    "website": "https://www.group1colchesterbmw.co.uk/",
    "coords": {
      "lat": 51.9202880859375,
      "lng": 0.9335160255432129
    }
  },
  {
    "id": "08389_6",
    "name": "Group 1 Norwich",
    "country": "GB",
    "city": "Norwich",
    "address": "Forest Way, Dereham Road, NR5 0JH Norwich",
    "email": "NorwichBMW@group1auto.co.uk",
    "phone": "+44-1603-726222",
    "website": "https://www.group1norwichbmw.co.uk/",
    "coords": {
      "lat": 52.6518440246582,
      "lng": 1.1798663139343262
    }
  },
  {
    "id": "08696_2",
    "name": "Group 1 Borehamwood Aftersales Centre",
    "country": "GB",
    "city": "Borehamwood",
    "address": "Chester Road, WD6 1LT Borehamwood",
    "email": "borehamwoodbmw@group1auto.co.uk",
    "phone": "+44-208-7314200",
    "website": "https://www.group1borehamwoodbmw.co.uk",
    "coords": {
      "lat": 51.65764617919922,
      "lng": -0.25789040327072144
    }
  },
  {
    "id": "08389_4",
    "name": "Group 1 Chelmsford",
    "country": "GB",
    "city": "Chelmsford",
    "address": "Colchester Road, CM2 5PG Chelmsford",
    "email": "ChelmsfordBMW@group1auto.co.uk",
    "phone": "+44-1245-895029",
    "website": "https://www.group1chelmsfordbmw.co.uk/",
    "coords": {
      "lat": 51.75083923339844,
      "lng": 0.5141800045967102
    }
  },
  {
    "id": "05316_10",
    "name": "Hedin Automotive Blackheath",
    "country": "GB",
    "city": "Blackheath",
    "address": "321-341 Lee High Road, SE12 8RU Blackheath",
    "email": "woolwichbmw@stephenjames.co.uk",
    "phone": "+44-20-83186868",
    "website": "https://www.hedinautomotiveblackheathbmw.co.uk",
    "coords": {
      "lat": 51.45677947998047,
      "lng": 0.010723699815571308
    }
  },
  {
    "id": "05348_3",
    "name": "Douglas Park Edinburgh",
    "country": "GB",
    "city": "Edinburgh",
    "address": "20C Seafield Road East, EH15 1ED Edinburgh",
    "email": "Alan.McMillan2@parks.uk.com",
    "phone": "+44-131-6690900",
    "website": "https://www.douglasparkedinburghbmw.co.uk",
    "coords": {
      "lat": 55.959495544433594,
      "lng": -3.124527931213379
    }
  },
  {
    "id": "08654_1",
    "name": "Marshall Scunthorpe Authorised Repairer",
    "country": "GB",
    "city": "Scunthorpe",
    "address": "Old Crosby, DN15 8PT Scunthorpe",
    "email": "mail@astlescunthorpe.bmw-net.co.uk",
    "phone": "+44-1724-249631",
    "website": "https://www.marshallscunthorpemini.co.uk",
    "coords": {
      "lat": 53.598426818847656,
      "lng": -0.6519420146942139
    }
  },
  {
    "id": "08661_1",
    "name": "Halliwell Jones North Wales",
    "country": "GB",
    "city": "Llandudno Junction",
    "address": "Ffordd Maelgwyn, LL31 9PL Llandudno Junction",
    "email": "enquiries@halliwelljones.co.uk",
    "phone": "+44-1492-562400",
    "website": "https://www.halliwelljonesnorthwalesbmw.co.uk",
    "coords": {
      "lat": 53.281219482421875,
      "lng": -3.79407000541687
    }
  },
  {
    "id": "08727_1",
    "name": "Stratstone Derby",
    "country": "GB",
    "city": "Derby",
    "address": "Sir Frank Whittle Road, DE21 4RZ Derby",
    "email": "derbybmw@stratstone.com",
    "phone": "+44-1332-984900",
    "website": "https://www.stratstonederbybmw.co.uk",
    "coords": {
      "lat": 52.94041061401367,
      "lng": -1.4621000289916992
    }
  },
  {
    "id": "08730_1",
    "name": "Bowker Blackburn",
    "country": "GB",
    "city": "Blackburn",
    "address": "Trident Way, Trident Park, BB1 3NU Blackburn",
    "email": "admin@bowkerbmw.com",
    "phone": "+44-1254-274444",
    "website": "https://www.bowkerblackburnbmw.co.uk",
    "coords": {
      "lat": 53.761539459228516,
      "lng": -2.4496400356292725
    }
  },
  {
    "id": "10063_1",
    "name": "Group 1 Ruislip Authorised Repairer",
    "country": "GB",
    "city": "South Ruislip",
    "address": "Bradfield Road, HA4 0NU South Ruislip",
    "email": "ruislipbmw@group1auto.co.uk",
    "phone": "+44-1895-612500",
    "website": "https://www.group1ruislipbmw.co.uk",
    "coords": {
      "lat": 51.55588912963867,
      "lng": -0.3800300061702728
    }
  },
  {
    "id": "10531_1",
    "name": "Marshall Salisbury",
    "country": "GB",
    "city": "Salisbury",
    "address": "London Road, SP1 3YU Salisbury",
    "email": "info@marshallsalisburybmw.co.uk",
    "phone": "+44-1722-626872",
    "website": "https://www.marshallsalisburybmw.co.uk",
    "coords": {
      "lat": 51.08769607543945,
      "lng": -1.7719202041625977
    }
  },
  {
    "id": "20504_1",
    "name": "Marshall Hampshire",
    "country": "GB",
    "city": "Hook",
    "address": "Griffin Way South, RG27 9RW Hook",
    "email": "allhampshire@marshall.co.uk",
    "phone": "+44-1256-442395",
    "website": "https://www.marshallhampshirebmw.co.uk",
    "coords": {
      "lat": 51.27766418457031,
      "lng": -0.9584580063819885
    }
  },
  {
    "id": "22118_1",
    "name": "Marshall Grimsby",
    "country": "GB",
    "city": "Grimsby",
    "address": "30 Grimsby Road, DN37 7DP Grimsby",
    "email": "bmw@marshall.co.uk",
    "phone": "+44-1472-728520",
    "website": "https://www.marshallgrimsbybmw.co.uk",
    "coords": {
      "lat": 53.54104232788086,
      "lng": -0.16012200713157654
    }
  },
  {
    "id": "05316_1",
    "name": "Hedin Automotive Enfield",
    "country": "GB",
    "city": "Enfield",
    "address": "Lincoln Road, EN1 1SW Enfield",
    "email": "enfieldbmw@stephenjames.co.uk",
    "phone": "+44-20-84438443",
    "website": "https://www.hedinautomotiveenfieldbmw.co.uk",
    "coords": {
      "lat": 51.64574432373047,
      "lng": -0.06027600169181824
    }
  },
  {
    "id": "05316_2",
    "name": "Hedin Automotive Enfield Aftersales",
    "country": "GB",
    "city": "Enfield",
    "address": "Unit 1 Martinbridge Estate, EN1 1SP Enfield",
    "email": "enfieldbmw@stephenjames.co.uk",
    "phone": "+44-20-84438443",
    "website": "https://www.hedinautomotiveenfieldbmw.co.uk",
    "coords": {
      "lat": 51.64472961425781,
      "lng": -0.05860000103712082
    }
  },
  {
    "id": "05343_3",
    "name": "Lloyd Cockermouth",
    "country": "GB",
    "city": "Cockermouth",
    "address": "Laithwaite Park, CA13 0HH Cockermouth",
    "email": "mail@lloydcockermouth.bmw-net.co.uk",
    "phone": "+44-1900-823666",
    "website": "https://www.lloydcockermouthbmw.co.uk",
    "coords": {
      "lat": 54.663780212402344,
      "lng": -3.375623941421509
    }
  },
  {
    "id": "05343_5",
    "name": "Lloyd Newcastle",
    "country": "GB",
    "city": "Newcastle Upon Tyne",
    "address": "Fenham Barracks, NE2 4LE Newcastle Upon Tyne",
    "email": "bmwnewcastle.reception@lloydgroup.co.uk",
    "phone": "+44-191-2617366",
    "website": "https://www.lloydnewcastlebmw.co.uk",
    "coords": {
      "lat": 54.98020553588867,
      "lng": -1.633424997329712
    }
  },
  {
    "id": "05383_1",
    "name": "Berry Heathrow",
    "country": "GB",
    "city": "West Drayton",
    "address": "Stone Close, UB7 8JU West Drayton",
    "email": "mail@berrybmw.co.uk",
    "phone": "+44-1895-433999",
    "website": "https://www.berryheathrowbmw.co.uk",
    "coords": {
      "lat": 51.5114860534668,
      "lng": -0.4608080983161926
    }
  },
  {
    "id": "08623_1",
    "name": "Bowker Preston",
    "country": "GB",
    "city": "Preston",
    "address": "Channel Way, PR2 2YA Preston",
    "email": "sales@bowkermail.com",
    "phone": "+44-1772-769976",
    "website": "https://www.bowkerprestonbmw.co.uk",
    "coords": {
      "lat": 53.761539459228516,
      "lng": -2.7267699241638184
    }
  },
  {
    "id": "08610_3",
    "name": "John Clark Tayside",
    "country": "GB",
    "city": "Dundee",
    "address": "Kings Cross Road, DD2 3PT Dundee",
    "email": "taysidebmw.service@john-clark.co.uk",
    "phone": "+44-1382-815993",
    "website": "https://www.johnclarktaysidebmw.co.uk",
    "coords": {
      "lat": 56.478851318359375,
      "lng": -3.0010600090026855
    }
  },
  {
    "id": "08657_1",
    "name": "Dick Lovett Swindon",
    "country": "GB",
    "city": "Swindon",
    "address": "Rushey Park, SN5 8WG Swindon",
    "email": "bmw.swindon@dicklovett.co.uk",
    "phone": "+44-1793-615999",
    "website": "https://www.dicklovettswindonbmw.co.uk",
    "coords": {
      "lat": 51.55414962768555,
      "lng": -1.807960033416748
    }
  },
  {
    "id": "08675_1",
    "name": "Marshall Bournemouth",
    "country": "GB",
    "city": "Bournemouth",
    "address": "361 - 371  Wallisdown Road, BH12 5WB Bournemouth",
    "email": "bmwbournemouthservice@marshall.co.uk",
    "phone": "+44-1202-065492",
    "website": "https://www.marshallbournemouthbmw.co.uk",
    "coords": {
      "lat": 50.74687957763672,
      "lng": -1.9127449989318848
    }
  },
  {
    "id": "08682_5",
    "name": "Arnold Clark Kirkcaldy",
    "country": "GB",
    "city": "Kirkcaldy",
    "address": "Carberry Place, KY1 3NQ Kirkcaldy",
    "email": "kirkcaldy.mail@arnoldclark.co.uk",
    "phone": "+44-1592-657800",
    "website": "https://www.arnoldclarkkirkcaldybmw.co.uk",
    "coords": {
      "lat": 56.13523864746094,
      "lng": -3.148550033569336
    }
  },
  {
    "id": "08681_1",
    "name": "Berry Cobham",
    "country": "GB",
    "city": "Cobham",
    "address": "18-22 Portsmouth Road, KT11 1JA Cobham",
    "email": "mail@berrybmw.co.uk",
    "phone": "+44-1932-589400",
    "website": "https://www.berrycobhambmw.co.uk",
    "coords": {
      "lat": 51.33280563354492,
      "lng": -0.41984644532203674
    }
  },
  {
    "id": "44637_1",
    "name": "Prentice Portadown",
    "country": "GB",
    "city": "Craigavon",
    "address": "Seagoe Road, BT63 5QD Craigavon",
    "email": "mail@prenticebmw.co.uk",
    "phone": "+44-2838-338833",
    "website": "https://www.prenticebmw.co.uk",
    "coords": {
      "lat": 54.447837829589844,
      "lng": -6.42641019821167
    }
  },
  {
    "id": "54589_1",
    "name": "Howards Barnstaple Authorised Repairer",
    "country": "GB",
    "city": "Barnstaple",
    "address": "Howard Avenue, EX32 8QA Barnstaple",
    "email": "bmwminiservice.barnstaple@howardsgroup.co.uk",
    "phone": "+44-1271-445100",
    "website": "https://www.howardsbarnstaplebmw.co.uk/",
    "coords": {
      "lat": 51.07426071166992,
      "lng": -4.043597221374512
    }
  },
  {
    "id": "05343_8",
    "name": "Lloyd North Tyneside",
    "country": "GB",
    "city": "Wallsend",
    "address": "Silverlink Park, NE28 9ND Wallsend",
    "email": "bmwnorthtyneside@lloydgroup.co.uk",
    "phone": "+44-191-2951295",
    "website": "https://www.lloydnorthtynesidebmw.co.uk",
    "coords": {
      "lat": 55.012760162353516,
      "lng": -1.497380018234253
    }
  },
  {
    "id": "05362_1",
    "name": "Group 1 Watford Authorised Repairer",
    "country": "GB",
    "city": "Watford",
    "address": "4 Odhams Trading Estate, WD24 7RY Watford",
    "email": "watfordbmw@group1auto.co.uk",
    "phone": "+44-1923-298500",
    "website": "https://www.group1watfordbmw.co.uk",
    "coords": {
      "lat": 51.67794418334961,
      "lng": -0.3902849853038788
    }
  },
  {
    "id": "08604_4",
    "name": "Grassicks Garage Ltd",
    "country": "GB",
    "city": "Perth",
    "address": "The Triangle, PH1 3GA Perth",
    "email": "mail@grassicks.bmw-net.co.uk",
    "phone": "+44-1738-630001",
    "website": "https://www.grassicksbmw.co.uk",
    "coords": {
      "lat": 56.417396545410156,
      "lng": -3.4620370864868164
    }
  },
  {
    "id": "08620_1",
    "name": "Sandal Huddersfield",
    "country": "GB",
    "city": "Huddersfield",
    "address": "98 Leeds Road, HD1 6NN Huddersfield",
    "email": "mail@sandalhuddersfieldbmw.net",
    "phone": "+44-1484-515515",
    "website": "https://www.sandalhuddersfieldbmw.co.uk",
    "coords": {
      "lat": 53.654727935791016,
      "lng": -1.7758448123931885
    }
  },
  {
    "id": "52475_1",
    "name": "Berry Banstead Authorised Repairer",
    "country": "GB",
    "city": "Tadworth",
    "address": "Brighton Road, KT20 6BU Tadworth",
    "email": "mail@berrybmw.co.uk",
    "phone": "+44-1737-302750",
    "website": "https://www.berrybansteadbmw.co.uk",
    "coords": {
      "lat": 51.30509948730469,
      "lng": -0.2190999984741211
    }
  },
  {
    "id": "08710_1",
    "name": "Group 1 Southend",
    "country": "GB",
    "city": "Leigh-on-Sea",
    "address": "Southend Arterial Road, SS9 4XX Leigh-on-Sea",
    "email": "southendbmw@group1auto.co.uk",
    "phone": "+44-1702-420111",
    "website": "https://www.group1southendbmw.co.uk",
    "coords": {
      "lat": 51.56290817260742,
      "lng": 0.6596620082855225
    }
  },
  {
    "id": "05473_3",
    "name": "Vines of Redhill",
    "country": "GB",
    "city": "Redhill",
    "address": "10-12 Bonehurst Road, RH1 5EP Redhill",
    "email": "sales.support@vinesgroup.net",
    "phone": "+44-1293-772000",
    "website": "https://www.vinesofredhillbmw.co.uk",
    "coords": {
      "lat": 51.19528579711914,
      "lng": -0.1637060046195984
    }
  },
  {
    "id": "05473_1",
    "name": "Vines of Gatwick",
    "country": "GB",
    "city": "Crawley",
    "address": "Stephenson Way, RH10 1TN Crawley",
    "email": "sales.support@vinesgroup.net",
    "phone": "+44-1293-611117",
    "website": "https://www.vinesofgatwickbmw.co.uk",
    "coords": {
      "lat": 51.115440368652344,
      "lng": -0.1642809957265854
    }
  },
  {
    "id": "08717_1",
    "name": "Stratstone Tunbridge Wells",
    "country": "GB",
    "city": "Tunbridge Wells",
    "address": "Longfield Road, TN2 3UE Tunbridge Wells",
    "email": "info.tunbridgebmw@stratstone.com",
    "phone": "+44-1892-483862",
    "website": "https://www.ardentunbridgewellsbmw.co.uk",
    "coords": {
      "lat": 51.156436920166016,
      "lng": 0.29169389605522156
    }
  },
  {
    "id": "28986_1",
    "name": "Vertu Durham",
    "country": "GB",
    "city": "Durham",
    "address": "Broomside Park, DH1 1HP Durham",
    "email": "salesenquiries@vertumotors.com",
    "phone": "+44-191-3837560",
    "website": "https://www.vertudurhambmw.co.uk",
    "coords": {
      "lat": 54.787254333496094,
      "lng": -1.5449568033218384
    }
  },
  {
    "id": "05350_1",
    "name": "Sytner Coventry",
    "country": "GB",
    "city": "Coventry",
    "address": "128 Holyhead Road, CV5 8NA Coventry",
    "email": "bmw.coventry@sytner.co.uk",
    "phone": "+44-2476-600600",
    "website": "https://www.sytnercoventrybmw.co.uk",
    "coords": {
      "lat": 52.41255569458008,
      "lng": -1.5276870727539062
    }
  },
  {
    "id": "08644_1",
    "name": "Sytner Oldbury",
    "country": "GB",
    "city": "Oldbury",
    "address": "819 Wolverhampton Road, B68 8DA Oldbury",
    "email": "bmw.oldbury@sytner.co.uk",
    "phone": "+44-121-5522825",
    "website": "https://www.sytneroldburybmw.co.uk",
    "coords": {
      "lat": 52.482608795166016,
      "lng": -2.0156099796295166
    }
  },
  {
    "id": "08747_1",
    "name": "Sytner Tring",
    "country": "GB",
    "city": "Tring",
    "address": "London Road, Cow Roast, HP23 5RE Tring",
    "email": "bmw.tring@sytner.co.uk",
    "phone": "+44-1442-890666",
    "website": "https://www.sytnertringbmw.co.uk",
    "coords": {
      "lat": 51.78276824951172,
      "lng": -0.611739993095398
    }
  },
  {
    "id": "08741_1",
    "name": "Vertu Exeter",
    "country": "GB",
    "city": "Exeter",
    "address": "Matford Park, EX2 8FD Exeter",
    "email": "bmwexeter@vertumotors.com",
    "phone": "+44-1392-822555",
    "website": "https://www.vertuexeterbmw.co.uk",
    "coords": {
      "lat": 50.69612121582031,
      "lng": -3.5206069946289062
    }
  },
  {
    "id": "08745_1",
    "name": "Stratstone Hull",
    "country": "GB",
    "city": "Hull",
    "address": "Paragon House, HU9 1TQ Hull",
    "email": "mail@stratstonehull.bmw-net.co.uk",
    "phone": "+44-1482-601130",
    "website": "https://www.stratstonehullbmw.co.uk",
    "coords": {
      "lat": 53.74348449707031,
      "lng": -0.3257089853286743
    }
  },
  {
    "id": "05353_1",
    "name": "Williams Stockport",
    "country": "GB",
    "city": "Stockport",
    "address": "Kingsreach Business Park, SK4 2JZ Stockport",
    "email": "mail@williamsstockportbmw.co.uk",
    "phone": "+44-161-4776000",
    "website": "https://www.williamsstockportbmw.co.uk",
    "coords": {
      "lat": 53.407989501953125,
      "lng": -2.181339979171753
    }
  },
  {
    "id": "05361_1",
    "name": "Listers Boston",
    "country": "GB",
    "city": "Boston",
    "address": "Sleaford Road, PE21 7PQ Boston",
    "email": "bmw.boston@listersgroup.co.uk",
    "phone": "+44-1205-350000",
    "website": "https://www.listersbostonbmw.co.uk",
    "coords": {
      "lat": 52.97247314453125,
      "lng": -0.05990900099277496
    }
  },
  {
    "id": "05348_6",
    "name": "Douglas Park Hillington Authorised Repairer",
    "country": "GB",
    "city": "Glasgow",
    "address": "420 Hillington Road, G52 4BL Glasgow",
    "email": "douglaspark.hillington@parks.uk.com",
    "phone": "+44-141-8915900",
    "website": "https://www.douglasparkhillingtonbmw.co.uk",
    "coords": {
      "lat": 55.85857009887695,
      "lng": -4.3612799644470215
    }
  },
  {
    "id": "08393_1",
    "name": "Halliwell Jones Chester",
    "country": "GB",
    "city": "Chester",
    "address": "Sealand Road, CH1 4LS Chester",
    "email": "mail@halliwelljoneschester.bmw-net.co.uk",
    "phone": "+44-1244-393600",
    "website": "https://www.halliwelljoneschesterbmw.co.uk",
    "coords": {
      "lat": 53.19512176513672,
      "lng": -2.9160900115966797
    }
  },
  {
    "id": "08682_8",
    "name": "Arnold Clark Irvine",
    "country": "GB",
    "city": "Irvine",
    "address": "Ayr Road, KA12 8BZ Irvine",
    "email": "irvine.mail@arnoldclark.co.uk",
    "phone": "+44-1294-849438",
    "website": "https://www.arnoldclarkirvinebmw.co.uk",
    "coords": {
      "lat": 55.60395812988281,
      "lng": -4.665200233459473
    }
  },
  {
    "id": "08658_1",
    "name": "Vertu Bridgwater",
    "country": "GB",
    "city": "Bridgwater",
    "address": "Taunton Road, TA6 6DD Bridgwater",
    "email": "bmwbridgwater@vertumotors.com",
    "phone": "+44-1278-429122",
    "website": "https://www.vertubridgwaterbmw.co.uk",
    "coords": {
      "lat": 51.11240005493164,
      "lng": -2.9937100410461426
    }
  },
  {
    "id": "21377_1",
    "name": "Halliwell Jones Warrington",
    "country": "GB",
    "city": "Warrington",
    "address": "Winwick Road, WA2 8HY Warrington",
    "email": "mail@halliwelljoneswarrington.bmw-net.co.uk",
    "phone": "+44-1925-248000",
    "website": "https://www.halliwelljoneswarringtonbmw.co.uk",
    "coords": {
      "lat": 53.40167236328125,
      "lng": -2.594238042831421
    }
  },
  {
    "id": "05314_2",
    "name": "Group 1 Farnborough Aftersales",
    "country": "GB",
    "city": "Ash Vale",
    "address": "Lysons Avenue, GU12 5QF Ash Vale",
    "email": "farnboroughbmw@group1auto.co.uk",
    "phone": "+44-1252-520500",
    "website": "https://www.group1farnboroughbmw.co.uk",
    "coords": {
      "lat": 51.27327346801758,
      "lng": -0.7247869968414307
    }
  },
  {
    "id": "08677_1",
    "name": "Van Mossel Jacksons Guernsey",
    "country": "GB",
    "city": "Guernsey",
    "address": "Airport Forecourt, GY8 0DD Guernsey",
    "email": "mail@jacksonsguernsey.bmw-net.co.uk",
    "phone": "+44-1481-235441",
    "website": "http://www.jacksonsci.com/",
    "coords": {
      "lat": 49.432029724121094,
      "lng": -2.5948801040649414
    }
  },
  {
    "id": "08676_1",
    "name": "Van Mossel Jacksons Jersey",
    "country": "GB",
    "city": "Jersey",
    "address": "La Rue Fondon, JE3 7BF Jersey",
    "email": "bdcsales@jacksons.je",
    "phone": "+44-1534-497777",
    "website": "http://www.jacksonsci.com/",
    "coords": {
      "lat": 49.20570755004883,
      "lng": -2.179959297180176
    }
  },
  {
    "id": "08739_2",
    "name": "Sytner Sunningdale Aftersales",
    "country": "GB",
    "city": "South Ascot",
    "address": "Lyndhurst Road, SL5 9EE South Ascot",
    "email": "bmw.sunningdale@sytner.co.uk",
    "phone": "+44-1344-630400",
    "website": "https://www.sunningdalebmw.co.uk",
    "coords": {
      "lat": 51.405479431152344,
      "lng": -0.6757400035858154
    }
  },
  {
    "id": "21972_29",
    "name": "BMW Park Lane (Park Royal) Aftersales",
    "country": "GB",
    "city": "Park Royal",
    "address": "36 Cumberland Avenue, NW10 7RQ Park Royal",
    "email": "mail@bmwparklane.co.uk",
    "phone": "+44-370-7005321",
    "website": "https://www.bmwparklane.co.uk",
    "coords": {
      "lat": 51.53001403808594,
      "lng": -0.2736389935016632
    }
  },
  {
    "id": "08717_2",
    "name": "Stratstone Bury St Edmunds",
    "country": "GB",
    "city": "Bury St Edmunds",
    "address": "Thetford Road, IP31 1SX Bury St Edmunds",
    "email": "info.burystedmundsbmw@stratstone.com",
    "phone": "+44-1284-752525",
    "website": "https://www.stratstoneburystedmundsbmw.co.uk/",
    "coords": {
      "lat": 52.26222229003906,
      "lng": 0.7130380272865295
    }
  },
  {
    "id": "29377_1",
    "name": "Van Mossel Jacksons Isle of Man",
    "country": "GB",
    "city": "Braddan",
    "address": "Cooil Road, IM4 2AZ Braddan",
    "email": "info@jacksons.im",
    "phone": "+44-1624-616161",
    "website": "https://www.jacksons.im",
    "coords": {
      "lat": 54.150489807128906,
      "lng": -4.532360076904297
    }
  },
  {
    "id": "05361_2",
    "name": "Listers Kings Lynn",
    "country": "GB",
    "city": "Kings Lynn",
    "address": "Hardwick Road, PE30 4NA Kings Lynn",
    "email": "mail@listers.bmw-net.co.uk",
    "phone": "+44-1553-692000",
    "website": "https://www.listerskingslynnbmw.co.uk",
    "coords": {
      "lat": 52.73970031738281,
      "lng": 0.41321998834609985
    }
  },
  {
    "id": "08612_1",
    "name": "JKC",
    "country": "GB",
    "city": "Coleraine",
    "address": "1-9 Millburn Road, BT52 1QS Coleraine",
    "email": "mail@jkc.bmw-net.co.uk",
    "phone": "+44-28-70355222",
    "website": "https://www.jkcbmw.co.uk",
    "coords": {
      "lat": 55.13358688354492,
      "lng": -6.671104431152344
    }
  },
  {
    "id": "08689_1",
    "name": "Dick Lovett Hungerford",
    "country": "GB",
    "city": "Hungerford",
    "address": "Bath Road, RG17 0EL Hungerford",
    "email": "bmw.hungerford@dicklovett.co.uk",
    "phone": "+44-1488-682772",
    "website": "https://www.dicklovetthungerfordbmw.co.uk",
    "coords": {
      "lat": 51.41838836669922,
      "lng": -1.5141199827194214
    }
  },
  {
    "id": "10056_1",
    "name": "Group 1 Hailsham",
    "country": "GB",
    "city": "Hailsham",
    "address": "Gleneagles Drive, BN27 3UA Hailsham",
    "email": "hailshambmw@group1auto.co.uk",
    "phone": "+44-1323-844032",
    "website": "https://www.group1hailshambmw.co.uk",
    "coords": {
      "lat": 50.862770080566406,
      "lng": 0.24367299675941467
    }
  },
  {
    "id": "22312_2",
    "name": "Barretts Ashford",
    "country": "GB",
    "city": "Ashford",
    "address": "The Boulevard, TN24 0GA Ashford",
    "email": "abmw@barretsbmw.co.uk",
    "phone": "+44-1233-500555",
    "website": "https://www.barrettsashfordbmw.co.uk",
    "coords": {
      "lat": 51.12892532348633,
      "lng": 0.8961089849472046
    }
  },
  {
    "id": "05343_4",
    "name": "Lloyd Colne",
    "country": "GB",
    "city": "Colne",
    "address": "Crown Way, BB8 9NP Colne",
    "email": "info@lloydcolne.co.uk",
    "phone": "+44-1282-720720",
    "website": "https://www.lloydcolnebmw.co.uk",
    "coords": {
      "lat": 53.85641098022461,
      "lng": -2.180150032043457
    }
  },
  {
    "id": "05348_9",
    "name": "Douglas Park Stirling",
    "country": "GB",
    "city": "Stirling",
    "address": "New Kerse Road, FK7 7RZ Stirling",
    "email": "douglaspark.stirling.service@parks.uk.com",
    "phone": "+44-1786-474477",
    "website": "https://www.douglasparkstirlingbmw.co.uk",
    "coords": {
      "lat": 56.111820220947266,
      "lng": -3.9163498878479004
    }
  },
  {
    "id": "05368_1",
    "name": "Berry Croydon",
    "country": "GB",
    "city": "Croydon",
    "address": "57 Croydon Road, CR0 4QE Croydon",
    "email": "mail@berrybmw.co.uk",
    "phone": "+44-20-82887777",
    "website": "https://www.berrycroydonbmw.co.uk",
    "coords": {
      "lat": 51.3675537109375,
      "lng": -0.12310869991779327
    }
  },
  {
    "id": "05385_6",
    "name": "Ocean Plymouth",
    "country": "GB",
    "city": "Plymouth",
    "address": "St Modwen House, Longbridge Road, PL6 8LD Plymouth",
    "email": "mail@oceanplymouth.bmw-net.co.uk",
    "phone": "+44-1752-202828",
    "website": "https://www.oceanplymouthbmw.co.uk",
    "coords": {
      "lat": 50.394561767578125,
      "lng": -4.090235233306885
    }
  },
  {
    "id": "05385_1",
    "name": "Ocean Torbay Authorised Repairer",
    "country": "GB",
    "city": "Paignton",
    "address": "349 Totnes Road, TQ4 7DF Paignton",
    "email": "mail@oceantorbay.bmw-net.co.uk",
    "phone": "+44-1803-666666",
    "website": "https://www.oceantorbaybmw.co.uk",
    "coords": {
      "lat": 50.428871154785156,
      "lng": -3.5977699756622314
    }
  },
  {
    "id": "08674_1",
    "name": "Snows Portsmouth",
    "country": "GB",
    "city": "Portsmouth",
    "address": "BMW House, PO3 5FF Portsmouth",
    "email": "mail@snows.bmw-net.co.uk",
    "phone": "+44-2392-007718",
    "website": "https://www.snowsportsmouthbmw.co.uk",
    "coords": {
      "lat": 50.819950103759766,
      "lng": -1.0435240268707275
    }
  },
  {
    "id": "08682_3",
    "name": "Arnold Clark Dumfries Authorised Repairer",
    "country": "GB",
    "city": "Dumfries",
    "address": "York House, DG1 3AW Dumfries",
    "email": "dumfries.mail@arnoldclark.co.uk",
    "phone": "+44-1387-253473",
    "website": "https://www.arnoldclarkdumfriesbmw.co.uk",
    "coords": {
      "lat": 55.070499420166016,
      "lng": -3.6009199619293213
    }
  },
  {
    "id": "08715_1",
    "name": "Group 1 Worthing",
    "country": "GB",
    "city": "Rustington",
    "address": "Manor Retail Park, BN16 3FH Rustington",
    "email": "worthingbmw@group1auto.co.uk",
    "phone": "+44-1903-784147",
    "website": "https://www.group1worthingbmw.co.uk",
    "coords": {
      "lat": 50.8194694519043,
      "lng": -0.5037130117416382
    }
  },
  {
    "id": "08724_1",
    "name": "Group 1 Brighton",
    "country": "GB",
    "city": "Brighton",
    "address": "Victoria Road, BN41 1YH Brighton",
    "email": "brightonbmw@group1auto.co.uk",
    "phone": "+44-1273-080635",
    "website": "https://www.group1brightonbmw.co.uk",
    "coords": {
      "lat": 50.83645248413086,
      "lng": -0.20990799367427826
    }
  },
  {
    "id": "05335_1",
    "name": "Cotswold Cheltenham",
    "country": "GB",
    "city": "Cheltenham",
    "address": "Corinthian Way, GL51 6UP Cheltenham",
    "email": "mail@cotswoldgroup.co.uk",
    "phone": "+44-1242-335335",
    "website": "https://www.cotswoldcheltenhambmw.co.uk",
    "coords": {
      "lat": 51.89197540283203,
      "lng": -2.1348230838775635
    }
  },
  {
    "id": "05316_7",
    "name": "Hedin Automotive Woolwich",
    "country": "GB",
    "city": "Woolwich",
    "address": "Duke of Wellington Avenue, SE18 6SR Woolwich",
    "email": "woolwichbmw@stephenjames.co.uk",
    "phone": "+44-20-83186868",
    "website": "https://www.hedinautomotivewoolwichbmw.co.uk",
    "coords": {
      "lat": 51.492427825927734,
      "lng": 0.07592099905014038
    }
  },
  {
    "id": "06004_4",
    "name": "Lookers Stafford",
    "country": "GB",
    "city": "Stafford",
    "address": "Lichfield Road, ST17 4PQ Stafford",
    "email": "bmwsales@lookers.co.uk",
    "phone": "+44-1785-246999",
    "website": "https://www.lookersstaffordbmw.co.uk",
    "coords": {
      "lat": 52.792198181152344,
      "lng": -2.0912699699401855
    }
  },
  {
    "id": "08615_1",
    "name": "Sandal Wakefield",
    "country": "GB",
    "city": "Wakefield",
    "address": "Dewsbury Road, WF2 9BE Wakefield",
    "email": "mail@sandalwakefieldbmw.net",
    "phone": "+44-1924-433500",
    "website": "https://www.sandalwakefieldbmw.co.uk",
    "coords": {
      "lat": 53.67917251586914,
      "lng": -1.5170559883117676
    }
  },
  {
    "id": "08656_1",
    "name": "Dick Lovett Bristol",
    "country": "GB",
    "city": "Bristol",
    "address": "Laurel Court, BS10 7TU Bristol",
    "email": "bmw.bristol@dicklovett.co.uk",
    "phone": "+44-117-9050000",
    "website": "https://www.dicklovettbristolbmw.co.uk",
    "coords": {
      "lat": 51.52129364013672,
      "lng": -2.6192150115966797
    }
  },
  {
    "id": "08696_1",
    "name": "Group 1 Borehamwood",
    "country": "GB",
    "city": "Borehamwood",
    "address": "Stirling Way, WD6 2BT Borehamwood",
    "email": "borehamwoodbmw@group1auto.co.uk",
    "phone": "+44-20-89512600",
    "website": "https://www.group1borehamwoodbmw.co.uk",
    "coords": {
      "lat": 51.64461135864258,
      "lng": -0.25434398651123047
    }
  },
  {
    "id": "08613_1",
    "name": "The Country Garage",
    "country": "GB",
    "city": "Ballymena",
    "address": "59 Ballycowan Road, BT42 3DW Ballymena",
    "email": "mail@countrygarage.bmw-net.co.uk",
    "phone": "+44-28-25891324",
    "website": "https://www.countrygaragebmw.co.uk",
    "coords": {
      "lat": 54.82795333862305,
      "lng": -6.2441864013671875
    }
  },
  {
    "id": "08691_1",
    "name": "Sytner Stevenage",
    "country": "GB",
    "city": "Stevenage",
    "address": "Gunnels Wood Road, SG1 2BE Stevenage",
    "email": "bmw.stevenage@sytner.co.uk",
    "phone": "+44-1438-760200",
    "website": "https://www.sytnerstevenagebmw.co.uk",
    "coords": {
      "lat": 51.89059829711914,
      "lng": -0.20409999787807465
    }
  },
  {
    "id": "10048_1",
    "name": "Sytner Leicester",
    "country": "GB",
    "city": "Leicester",
    "address": "Meridian East,, LE19 1UY Leicester",
    "email": "bmw.leicester@sytner.co.uk",
    "phone": "+44-116-2827700",
    "website": "https://www.sytnerleicesterbmw.co.uk",
    "coords": {
      "lat": 52.603416442871094,
      "lng": -1.1892470121383667
    }
  },
  {
    "id": "33181_1",
    "name": "Sytner Stratford",
    "country": "GB",
    "city": "Stratford Upon Avon",
    "address": "Birmingham Road, CV37 0RN Stratford Upon Avon",
    "email": "mini.stratford@sytner.co.uk",
    "phone": "+44-1789-201999",
    "website": "https://www.sytnerstratforduponavonmini.co.uk/",
    "coords": {
      "lat": 52.215389251708984,
      "lng": -1.7276699542999268
    }
  },
  {
    "id": "05332_1",
    "name": "Vertu York",
    "country": "GB",
    "city": "York",
    "address": "Clifton Moorgate, YO30 4WR York",
    "email": "salesenquiries@vertumotors.com",
    "phone": "+44-1904-693313",
    "website": "https://www.vertuyorkbmw.co.uk",
    "coords": {
      "lat": 53.98551559448242,
      "lng": -1.0988523960113525
    }
  },
  {
    "id": "08617_1",
    "name": "Vertu Sunderland",
    "country": "GB",
    "city": "West Boldon",
    "address": "Boldon Business Park, NE36 0BQ West Boldon",
    "email": "salesenquiries@vertumotors.com",
    "phone": "+44-191-5194455",
    "website": "https://www.vertusunderlandbmw.co.uk",
    "coords": {
      "lat": 54.9423713684082,
      "lng": -1.4651199579238892
    }
  },
  {
    "id": "08728_1",
    "name": "Stratstone Leeds",
    "country": "GB",
    "city": "Leeds",
    "address": "Gelderd Road, LS12 6EG Leeds",
    "email": "mail@stratstoneleeds.bmw-net.co.uk",
    "phone": "+44-113-4574180",
    "website": "https://www.stratstoneleedsbmw.co.uk",
    "coords": {
      "lat": 53.778221130371094,
      "lng": -1.5836199522018433
    }
  },
  {
    "id": "08622_1",
    "name": "Williams Manchester",
    "country": "GB",
    "city": "Manchester",
    "address": "20 Barton Dock Road, M41 7GF Manchester",
    "email": "mail@williamsm.bmw-net.co.uk",
    "phone": "+44-161-9075100",
    "website": "https://www.williamsmanchesterbmw.co.uk",
    "coords": {
      "lat": 53.46434020996094,
      "lng": -2.3413500785827637
    }
  },
  {
    "id": "08634_1",
    "name": "Sytner Sheffield",
    "country": "GB",
    "city": "Sheffield",
    "address": "Brightside Way, S9 2RQ Sheffield",
    "email": "mail@sytnersheffield.bmw-net.co.uk",
    "phone": "+44-114-2565900",
    "website": "https://www.sytnersheffieldbmw.co.uk",
    "coords": {
      "lat": 53.402671813964844,
      "lng": -1.43313729763031
    }
  },
  {
    "id": "08651_1",
    "name": "Sytner Nottingham",
    "country": "GB",
    "city": "Nottingham",
    "address": "Lenton Lane, NG7 2AX Nottingham",
    "email": "bmw.nottingham@sytner.co.uk",
    "phone": "+44-115-9341414",
    "website": "https://www.sytnernottinghambmw.co.uk",
    "coords": {
      "lat": 52.93082809448242,
      "lng": -1.1689200401306152
    }
  },
  {
    "id": "08660_1",
    "name": "Sytner Swansea",
    "country": "GB",
    "city": "Swansea",
    "address": "375 Carmarthen Road,, SA5 8LW Swansea",
    "email": "bmw.swansea@sytner.co.uk",
    "phone": "+44-1792-651474",
    "website": "https://www.sytnerswanseabmw.co.uk",
    "coords": {
      "lat": 51.635337829589844,
      "lng": -3.954965114593506
    }
  },
  {
    "id": "25037_1",
    "name": "Sytner Newport",
    "country": "GB",
    "city": "Newport",
    "address": "Usk Way, NP20 2DS Newport",
    "email": "bmw.newport@sytner.co.uk",
    "phone": "+44-1633-241500",
    "website": "https://www.sytnernewportbmw.co.uk",
    "coords": {
      "lat": 51.580482482910156,
      "lng": -2.9837679862976074
    }
  },
  {
    "id": "29631_1",
    "name": "Sytner Shrewsbury",
    "country": "GB",
    "city": "Shrewsbury",
    "address": "70 Battlefield Road, SY1 4AQ Shrewsbury",
    "email": "bmw.shrewsbury@sytner.co.uk",
    "phone": "+44-1743-467467",
    "website": "https://www.Sytnershrewsburybmw.co.uk",
    "coords": {
      "lat": 52.739891052246094,
      "lng": -2.720639944076538
    }
  },
  {
    "id": "33180_1",
    "name": "Sytner Warwick",
    "country": "GB",
    "city": "Warwick",
    "address": "Fusiliers Way, CV34 8DD Warwick",
    "email": "bmw.warwick@sytner.co.uk",
    "phone": "+44-1926-333888",
    "website": "https://www.Sytnerwarwickbmw.co.uk",
    "coords": {
      "lat": 52.272281646728516,
      "lng": -1.56325101852417
    }
  },
  {
    "id": "05350_6",
    "name": "Sytner Chigwell",
    "country": "GB",
    "city": "Loughton",
    "address": "Langston Road, IG10 3UE Loughton",
    "email": "bmw.chigwell@sytner.co.uk",
    "phone": "+44-208-4187600",
    "website": "https://www.sytnerchigwellbmw.co.uk",
    "coords": {
      "lat": 51.64335632324219,
      "lng": 0.08481200039386749
    }
  },
  {
    "id": "05316_4",
    "name": "Hedin Automotive Bromley",
    "country": "GB",
    "city": "Bromley",
    "address": "Bickley Road, BR1 2NE Bromley",
    "email": "reservations@hedinautomotive.co.uk",
    "phone": "+44-20-82958500",
    "website": "https://www.hedinautomotivebromleybmw.co.uk",
    "coords": {
      "lat": 51.40414047241211,
      "lng": 0.03857799991965294
    }
  },
  {
    "id": "05350_2",
    "name": "Sytner Cardiff",
    "country": "GB",
    "city": "Cardiff",
    "address": "285 - 287 Penarth Road, CF11 8TT Cardiff",
    "email": "bmw.cardiff@sytner.co.uk",
    "phone": "+44-29-20550300",
    "website": "https://www.sytnercardiffbmw.co.uk",
    "coords": {
      "lat": 51.465450286865234,
      "lng": -3.191540002822876
    }
  },
  {
    "id": "08653_1",
    "name": "Wollaston Motors",
    "country": "GB",
    "city": "Northampton",
    "address": "Riverside Way, NN1 5NX Northampton",
    "email": "mail@wollaston.bmw-net.co.uk",
    "phone": "+44-1604-232000",
    "website": "https://www.wollastonbmw.co.uk",
    "coords": {
      "lat": 52.233821868896484,
      "lng": -0.8808199763298035
    }
  },
  {
    "id": "05350_8",
    "name": "Sytner High Wycombe",
    "country": "GB",
    "city": "High Wycombe",
    "address": "575-647 London Road, HP11 1EZ High Wycombe",
    "email": "bmw.highwycombe@sytner.co.uk",
    "phone": "+44-1494-455100",
    "website": "https://www.sytnerhighwycombebmw.co.uk",
    "coords": {
      "lat": 51.6179313659668,
      "lng": -0.7158269882202148
    }
  },
  {
    "id": "08393_2",
    "name": "Halliwell Jones Chester A/S Centre After Sales Centre",
    "country": "GB",
    "city": "Chester",
    "address": "Knutsford Way, CH1 4NS Chester",
    "email": "mail@halliwelljoneschester.bmw-net.co.uk",
    "phone": "+44-1244-393600",
    "website": "https://www.halliwelljoneschesterbmw.co.uk/",
    "coords": {
      "lat": 53.193328857421875,
      "lng": -2.918156623840332
    }
  },
  {
    "id": "08737_1",
    "name": "Vertu Yeovil",
    "country": "GB",
    "city": "Yeovil",
    "address": "Mead Avenue, BA22 8RT Yeovil",
    "email": "bmwyeovil@vertumotors.com",
    "phone": "+44-01935-423423",
    "website": "https://www.vertuyeovilbmw.co.uk",
    "coords": {
      "lat": 50.945762634277344,
      "lng": -2.672571897506714
    }
  },
  {
    "id": "08682_1",
    "name": "Arnold Clark Glasgow",
    "country": "GB",
    "city": "Glasgow",
    "address": "10 Mossland Drive, G52 4FA Glasgow",
    "email": "giffnock.mail@arnoldclark.co.uk",
    "phone": "+44-141-6386522",
    "website": "https://www.arnoldclarkglasgowbmw.co.uk",
    "coords": {
      "lat": 55.86544418334961,
      "lng": -4.371933937072754
    }
  },
  {
    "id": "22041_1",
    "name": "Group 1 Lincoln",
    "country": "GB",
    "city": "Lincoln",
    "address": "Roman Way, LN6 9UH Lincoln",
    "email": "support@soperbmw.co.uk",
    "phone": "+44-1522-690000",
    "website": "https://www.group1lincolnbmw.co.uk",
    "coords": {
      "lat": 53.17702102661133,
      "lng": -0.6203299760818481
    }
  },
  {
    "id": "08389_5",
    "name": "Group 1 Ipswich",
    "country": "GB",
    "city": "Ipswich",
    "address": "667 Norwich Road, IP1 6JZ Ipswich",
    "email": "IpswichBMW@group1auto.co.uk",
    "phone": "+44-1473-849918",
    "website": "https://www.group1ipswichbmw.co.uk/",
    "coords": {
      "lat": 52.08115005493164,
      "lng": 1.1246399879455566
    }
  },
  {
    "id": "08682_6",
    "name": "Arnold Clark Inverness",
    "country": "GB",
    "city": "Inverness",
    "address": "32 Longman Road, IV1 1RY Inverness",
    "email": "inverness.mail@arnoldclark.co.uk",
    "phone": "+44-1463-236566",
    "website": "https://arnoldclarkinvernessbmw.co.uk",
    "coords": {
      "lat": 57.48414993286133,
      "lng": -4.22155237197876
    }
  },
  {
    "id": "05343_1",
    "name": "Lloyd Carlisle",
    "country": "GB",
    "city": "Carlisle",
    "address": "Grearshill Road, CA3 0EE Carlisle",
    "email": "mail@lloydcarlisle.bmw-net.co.uk",
    "phone": "+44-1228-542222",
    "website": "https://www.lloydcarlislebmw.co.uk",
    "coords": {
      "lat": 54.925601959228516,
      "lng": -2.946704864501953
    }
  },
  {
    "id": "05343_2",
    "name": "Lloyd Blackpool",
    "country": "GB",
    "city": "Blackpool",
    "address": "Lytham St Annes Way, FY4 5PQ Blackpool",
    "email": "mail@lloydblackpool.bmw-net.co.uk",
    "phone": "+44-1253-607680",
    "website": "https://www.lloydblackpoolbmw.co.uk",
    "coords": {
      "lat": 53.78908157348633,
      "lng": -2.982379913330078
    }
  },
  {
    "id": "05343_7",
    "name": "Lloyd South Lakes",
    "country": "GB",
    "city": "Grange-over-Sands",
    "address": "Kendal Road, LA11 6QR Grange-over-Sands",
    "email": "mail@lloydsouthlakes.bmw-net.co.uk",
    "phone": "+44-1539-533751",
    "website": "https://www.lloydsouthlakesbmw.co.uk",
    "coords": {
      "lat": 54.22132873535156,
      "lng": -2.883091926574707
    }
  },
  {
    "id": "06074_1",
    "name": "Group 1 Bedford",
    "country": "GB",
    "city": "Bedford",
    "address": "Clifton Parc, MK41 0GL Bedford",
    "email": "bedfordbmw@group1auto.co.uk",
    "phone": "+44-844-3267246",
    "website": "https://www.group1bedfordbmw.co.uk",
    "coords": {
      "lat": 52.146514892578125,
      "lng": -0.4175941050052643
    }
  },
  {
    "id": "09063_1",
    "name": "Group 1 Cambridge",
    "country": "GB",
    "city": "Cambridge",
    "address": "4 Sheepfold Lane, CB23 6EF Cambridge",
    "email": "cambridgebmw@group1auto.co.uk",
    "phone": "+44-844-3267249",
    "website": "https://www.group1cambridgebmw.co.uk",
    "coords": {
      "lat": 52.22344207763672,
      "lng": -0.07454629987478256
    }
  },
  {
    "id": "22313_1",
    "name": "Dick Lovett Melksham",
    "country": "GB",
    "city": "Melksham",
    "address": "Portal Road, SN12 6GN Melksham",
    "email": "bmw.melksham@dicklovett.co.uk",
    "phone": "+44-1225-448145",
    "website": "https://www.dicklovettmelkshambmw.co.uk",
    "coords": {
      "lat": 51.35505294799805,
      "lng": -2.135249376296997
    }
  },
  {
    "id": "05314_1",
    "name": "Group 1 Farnborough",
    "country": "GB",
    "city": "Farnborough",
    "address": "105 Farnborough Road, GU14 6TL Farnborough",
    "email": "farnboroughbmw@group1auto.co.uk",
    "phone": "+44-1252-490096",
    "website": "https://www.group1farnboroughbmw.co.uk",
    "coords": {
      "lat": 51.2847900390625,
      "lng": -0.7532899975776672
    }
  },
  {
    "id": "05359_1",
    "name": "Halliwell Jones Southport",
    "country": "GB",
    "city": "Southport",
    "address": "59-61 Southport Road, PR8 5JF Southport",
    "email": "mail@halliwelljonessouthport.bmw-net.co.uk",
    "phone": "+44-1704-503800",
    "website": "https://www.halliwelljonessouthportbmw.co.uk",
    "coords": {
      "lat": 53.6280403137207,
      "lng": -2.9647281169891357
    }
  },
  {
    "id": "05385_4",
    "name": "Ocean Falmouth",
    "country": "GB",
    "city": "Penryn",
    "address": "Falmouth Road, TR10 8AD Penryn",
    "email": "mail@oceanfalmouth.bmw-net.co.uk",
    "phone": "+44-1326-375100",
    "website": "https://www.oceanfalmouthbmw.co.uk",
    "coords": {
      "lat": 50.166229248046875,
      "lng": -5.093800067901611
    }
  },
  {
    "id": "08604_1",
    "name": "Eastern Motor Co. Ltd.",
    "country": "GB",
    "city": "Newbridge",
    "address": "Edinburgh Luxury Car Village, EH28 8TG Newbridge",
    "email": "mail@eastern.bmw-net.co.uk",
    "phone": "+44-131-4677938",
    "website": "https://www.easternbmw.co.uk",
    "coords": {
      "lat": 55.941078186035156,
      "lng": -3.4082300662994385
    }
  },
  {
    "id": "08611_1",
    "name": "Bavarian",
    "country": "GB",
    "city": "Belfast",
    "address": "2 Boucher Crescent, BT12 6HU Belfast",
    "email": "bavarianbmw@agnews.co.uk",
    "phone": "+44-2890-381311",
    "website": "https://www.bavarianbmw.co.uk",
    "coords": {
      "lat": 54.58318328857422,
      "lng": -5.962711334228516
    }
  },
  {
    "id": "21972_1",
    "name": "BMW Park Lane",
    "country": "GB",
    "city": "London",
    "address": "70 Park Lane, W1K 7TT London",
    "email": "mail@bmwparklane.co.uk",
    "phone": "+44-370-7005200",
    "website": "https://www.bmwparklane.com",
    "coords": {
      "lat": 51.508235931396484,
      "lng": -0.15381599962711334
    }
  },
  {
    "id": "21985_1",
    "name": "Berry Chiswick",
    "country": "GB",
    "city": "Brentford",
    "address": "10-11 Syon Gate, TW8 9DD Brentford",
    "email": "info@berrybmw.co.uk",
    "phone": "+44-208-2325700",
    "website": "https://www.berrychiswickbmw.co.uk",
    "coords": {
      "lat": 51.48384094238281,
      "lng": -0.32299429178237915
    }
  },
  {
    "id": "33486_1",
    "name": "Harwoods Authorised Repairer",
    "country": "GB",
    "city": "Basingstoke",
    "address": "Edison Road, RG21 6YH Basingstoke",
    "email": "mail@harwoodsbmw.co.uk",
    "phone": "+44-1256-312800",
    "website": "https://www.harwoodsbasingstokebmw.co.uk",
    "coords": {
      "lat": 51.27585220336914,
      "lng": -1.105695128440857
    }
  },
  {
    "id": "05316_6",
    "name": "Hedin Automotive Ruxley",
    "country": "GB",
    "city": "Sidcup",
    "address": "Maidstone Road, DA14 5BG Sidcup",
    "email": "marketing.department@stephenjames.co.uk",
    "phone": "+44-20-83026431",
    "website": "https://www.hedinautomotiveruxleybmw.co.uk",
    "coords": {
      "lat": 51.414886474609375,
      "lng": 0.12986800074577332
    }
  },
  {
    "id": "05334_1",
    "name": "Partridge of Hampshire Ltd",
    "country": "GB",
    "city": "Eastleigh",
    "address": "1 Stoneycroft Rise, SO53 3YU Eastleigh",
    "email": "mail@partridgebmw.co.uk",
    "phone": "+44-23-80689800",
    "website": "https://www.partridgebmw.co.uk",
    "coords": {
      "lat": 50.96531295776367,
      "lng": -1.3867517709732056
    }
  },
  {
    "id": "05335_5",
    "name": "Cotswold Hereford",
    "country": "GB",
    "city": "Hereford",
    "address": "Roman Road, HR1 1LN Hereford",
    "email": "mail@cotswoldgroup.com",
    "phone": "+44-1432-375555",
    "website": "https://www.cotswoldherefordbmw.co.uk",
    "coords": {
      "lat": 52.07398986816406,
      "lng": -2.709019899368286
    }
  },
  {
    "id": "08610_1",
    "name": "John Clark Aberdeen",
    "country": "GB",
    "city": "Aberdeen",
    "address": "Wellington Road, AB12 3EW Aberdeen",
    "email": "aberdeenbmw.service@john-clark.co.uk",
    "phone": "+44-1224-335577",
    "website": "https://www.johnclarkaberdeenbmw.co.uk",
    "coords": {
      "lat": 57.124000549316406,
      "lng": -2.089600086212158
    }
  },
  {
    "id": "08693_1",
    "name": "North Oxford Garage",
    "country": "GB",
    "city": "Oxford",
    "address": "Wolvercote Roundabout, OX2 8JP Oxford",
    "email": "service@oxfordbmw.co.uk",
    "phone": "+44-1865-319000",
    "website": "https://www.oxfordbmw.co.uk",
    "coords": {
      "lat": 51.78826904296875,
      "lng": -1.280900001525879
    }
  },
  {
    "id": "08866_1",
    "name": "Stratstone Chesterfield",
    "country": "GB",
    "city": "Chesterfield",
    "address": "Eastside Road, S41 9BH Chesterfield",
    "email": "mail@stratstonechesterfield.bmw-net.co.uk",
    "phone": "+44-1246-208681",
    "website": "https://www.stratstonechesterfieldbmw.co.uk",
    "coords": {
      "lat": 53.2546501159668,
      "lng": -1.4223099946975708
    }
  },
  {
    "id": "22312_1",
    "name": "Barretts Canterbury",
    "country": "GB",
    "city": "Canterbury",
    "address": "Broad Oak Road, CT2 7PX Canterbury",
    "email": "cbmw@barrettsbmw.co.uk",
    "phone": "+44-1227-828888",
    "website": "https://www.barrettscanterburybmw.co.uk",
    "coords": {
      "lat": 51.29140853881836,
      "lng": 1.0898350477218628
    }
  },
  {
    "id": "08680_1",
    "name": "Berry Thames Ditton",
    "country": "GB",
    "city": "Surbiton",
    "address": "42 Portsmouth Road, KT6 5PZ Surbiton",
    "email": "mail@berrybmw.co.uk",
    "phone": "+44-208-3981111",
    "website": "https://www.berrythamesdittonbmw.co.uk",
    "coords": {
      "lat": 51.391563415527344,
      "lng": -0.3199540078639984
    }
  },
  {
    "id": "05369_1",
    "name": "Stratstone Harrogate",
    "country": "GB",
    "city": "Harrogate",
    "address": "Princess Royal Way, HG3 1LG Harrogate",
    "email": "mail@stratstoneharrogate.bmw-net.co.uk",
    "phone": "+44-1423-855500",
    "website": "https://www.stratstoneharrogatebmw.co.uk",
    "coords": {
      "lat": 53.95574951171875,
      "lng": -1.5322699546813965
    }
  },
  {
    "id": "08705_1",
    "name": "Sycamore Peterborough",
    "country": "GB",
    "city": "Peterborough",
    "address": "Papyrus Road, PE4 5HW Peterborough",
    "email": "mail@sycamore.bmw-net.co.uk",
    "phone": "+44-1733-707070",
    "website": "https://www.sycamorebmw.co.uk",
    "coords": {
      "lat": 52.61833953857422,
      "lng": -0.28960999846458435
    }
  },
  {
    "id": "08717_3",
    "name": "Stratstone Maidstone",
    "country": "GB",
    "city": "Aylesford",
    "address": "12 Wood Close, ME20 7UB Aylesford",
    "email": "info.maidstonebmw@stratstone.com",
    "phone": "+44-1622-717222",
    "website": "https://www.ardenmaidstonebmw.co.uk",
    "coords": {
      "lat": 51.29148483276367,
      "lng": 0.47032400965690613
    }
  },
  {
    "id": "08739_1",
    "name": "Sytner Sunningdale",
    "country": "GB",
    "city": "Ascot",
    "address": "London Road, SL5 0EX Ascot",
    "email": "bmw.sunningdale@sytner.co.uk",
    "phone": "+44-1344-630400",
    "website": "https://www.sunningdalebmw.co.uk",
    "coords": {
      "lat": 51.39168930053711,
      "lng": -0.6347500085830688
    }
  },
  {
    "id": "08744_1",
    "name": "Stratstone Doncaster",
    "country": "GB",
    "city": "Doncaster",
    "address": "Wheatley Hall Road, DN2 4SR Doncaster",
    "email": "doncasterbmw@stratstone.com",
    "phone": "+44-1302-380500",
    "website": "https://www.stratstonedoncasterbmw.co.uk",
    "coords": {
      "lat": 53.54492950439453,
      "lng": -1.0993200540542603
    }
  },
  {
    "id": "09062_1",
    "name": "Sytner Wolverhampton",
    "country": "GB",
    "city": "Wolverhampton",
    "address": "Lever Street, WV2 1AD Wolverhampton",
    "email": "bmw.wolverhampton@sytner.co.uk",
    "phone": "+44-1902-457000",
    "website": "https://www.Sytnerwolverhamptonbmw.co.uk",
    "coords": {
      "lat": 52.5803108215332,
      "lng": -2.1243999004364014
    }
  },
  {
    "id": "21384_1",
    "name": "Sytner Maidenhead",
    "country": "GB",
    "city": "Maidenhead",
    "address": "Bath Road, SL6 0BW Maidenhead",
    "email": "bmw.maidenhead@sytner.co.uk",
    "phone": "+44-1628-680300",
    "website": "https://www.sytnermaidenheadbmw.co.uk",
    "coords": {
      "lat": 51.52333068847656,
      "lng": -0.6919699907302856
    }
  },
  {
    "id": "08630_1",
    "name": "Williams Liverpool",
    "country": "GB",
    "city": "Liverpool",
    "address": "4 Great Howard Street, L3 7HT Liverpool",
    "email": "mail@williamsl.bmw-net.co.uk",
    "phone": "+44-151-4742000",
    "website": "https://www.williamsliverpoolbmw.co.uk",
    "coords": {
      "lat": 53.4127311706543,
      "lng": -2.995759963989258
    }
  },
  {
    "id": "08633_1",
    "name": "Williams Bolton",
    "country": "GB",
    "city": "Bolton",
    "address": "1 Vincent Way, BL3 2NB Bolton",
    "email": "mail@williamsb.bmw-net.co.uk",
    "phone": "+44-1204-900900",
    "website": "https://www.williamsboltonbmw.co.uk",
    "coords": {
      "lat": 53.56644821166992,
      "lng": -2.4130749702453613
    }
  },
  {
    "id": "05473_2",
    "name": "Vines of Guildford",
    "country": "GB",
    "city": "Guildford",
    "address": "21 Moorfield Road, GU1 1RD Guildford",
    "email": "sales.support@vinesgroup.net",
    "phone": "+44-1483-207000",
    "website": "https://www.vinesofguildfordbmw.co.uk",
    "coords": {
      "lat": 51.26116180419922,
      "lng": -0.5663735270500183
    }
  },
  {
    "id": "05386_1",
    "name": "Williams Rochdale",
    "country": "GB",
    "city": "Rochdale",
    "address": "Gorrels Way, OL11 2PX Rochdale",
    "email": "mail@williamsr.bmw-net.co.uk",
    "phone": "+44-1706-717700",
    "website": "https://www.williamsbmwrochdale.co.uk",
    "coords": {
      "lat": 53.598228454589844,
      "lng": -2.164720058441162
    }
  },
  {
    "id": "08717_5",
    "name": "Stratstone Milton Keynes",
    "country": "GB",
    "city": "Milton Keynes",
    "address": "Northfield Drive, MK15 0DQ Milton Keynes",
    "email": "info.miltonkeynesbmw@stratstone.com",
    "phone": "+44-1908-906251",
    "website": "https://www.stratstonemiltonkeynesbmw.co.uk",
    "coords": {
      "lat": 52.05155944824219,
      "lng": -0.7050489783287048
    }
  },
  {
    "id": "08705_2",
    "name": "Sycamore Stamford Fast Lane",
    "country": "GB",
    "city": "Stamford",
    "address": "West Street, PE9 2PR Stamford",
    "email": "mail@sycamore.bmw-net.co.uk",
    "phone": "+44-1733-707070",
    "website": "https://www.sycamorestamfordbmw.co.uk",
    "coords": {
      "lat": 52.65155029296875,
      "lng": -0.48546430468559265
    }
  },
  {
    "id": "08743_1",
    "name": "Sytner Solihull",
    "country": "GB",
    "city": "Solihull",
    "address": "120 Highlands Road, B90 4BW Solihull",
    "email": "bmw.solihull@sytner.co.uk",
    "phone": "+44-121-7333444",
    "website": "https://www.sytnersolihullbmw.co.uk",
    "coords": {
      "lat": 52.39582061767578,
      "lng": -1.7989000082015991
    }
  },
  {
    "id": "08864_1",
    "name": "Sytner Tamworth",
    "country": "GB",
    "city": "Tamworth",
    "address": "Winchester Road, B78 3JH Tamworth",
    "email": "bmw.tamworth@sytner.co.uk",
    "phone": "+44-1827-309000",
    "website": "https://www.sytnertamworthbmw.co.uk",
    "coords": {
      "lat": 52.62620162963867,
      "lng": -1.7083640098571777
    }
  },
  {
    "id": "08685_1",
    "name": "Sytner Luton",
    "country": "GB",
    "city": "Luton",
    "address": "501 Dunstable Road, LU4 8QN Luton",
    "email": "bmw.luton@sytner.co.uk",
    "phone": "+44-1582-590700",
    "website": "https://www.sytnerlutonbmw.co.uk",
    "coords": {
      "lat": 51.891841888427734,
      "lng": -0.4536139965057373
    }
  },
  {
    "id": "08733_1",
    "name": "Vertu Teesside",
    "country": "GB",
    "city": "Stockton-on-Tees",
    "address": "Concorde Way, TS18 3RB Stockton-on-Tees",
    "email": "salesenquiries@vertumotors.com",
    "phone": "+44-1642-618618",
    "website": "https://www.vertuteessidebmw.co.uk",
    "coords": {
      "lat": 54.54241180419922,
      "lng": -1.3353500366210938
    }
  },
  {
    "id": "33512_1",
    "name": "Sytner Worcester",
    "country": "GB",
    "city": "Worcester",
    "address": "Knightsbridge Park, WR4 9FA Worcester",
    "email": "bmw.worcester@sytner.co.uk",
    "phone": "+44-1905-459600",
    "website": "https://www.Sytnerworcesterbmw.co.uk",
    "coords": {
      "lat": 52.21297073364258,
      "lng": -2.1748600006103516
    }
  },
  {
    "id": "05350_7",
    "name": "Sytner Harold Wood",
    "country": "GB",
    "city": "Romford",
    "address": "A12 Colchester Road, RM3 0GX Romford",
    "email": "bmw.haroldwood@sytner.co.uk",
    "phone": "+44-1708-371234",
    "website": "https://www.sytnerharoldwoodbmw.co.uk",
    "coords": {
      "lat": 51.595436096191406,
      "lng": 0.2220669984817505
    }
  },
  {
    "id": "06004_3",
    "name": "Lookers Stoke-on-Trent",
    "country": "GB",
    "city": "Stoke-on-Trent",
    "address": "Bede Road, ST4 4GU Stoke-on-Trent",
    "email": "bmwsales@lookers.co.uk",
    "phone": "+44-1782-572100",
    "website": "https://www.lookersstokeontrentbmw.co.uk",
    "coords": {
      "lat": 52.986488342285156,
      "lng": -2.1864778995513916
    }
  },
  {
    "id": "05348_5",
    "name": "Douglas Park Glasgow",
    "country": "GB",
    "city": "Glasgow",
    "address": "3-33 Kyle Street, G4 0HP Glasgow",
    "email": "douglaspark.glasgow@parks.uk.com",
    "phone": "+44-141-6117700",
    "website": "https://www.douglasparkglasgowbmw.co.uk",
    "coords": {
      "lat": 55.86785125732422,
      "lng": -4.246429920196533
    }
  },
  {
    "id": "05348_1",
    "name": "Douglas Park Hamilton",
    "country": "GB",
    "city": "Hamilton",
    "address": "14 Bothwell Road, ML3 0AY Hamilton",
    "email": "mail@douglaspark.bmw-net.co.uk",
    "phone": "+44-1698-303700",
    "website": "https://www.douglasparkhamiltonbmw.co.uk",
    "coords": {
      "lat": 55.7809944152832,
      "lng": -4.045314788818359
    }
  },
  {
    "id": "06004_1",
    "name": "Lookers Crewe",
    "country": "GB",
    "city": "Crewe",
    "address": "Fourth Avenue, CW1 6XH Crewe",
    "email": "bmwsales@lookers.co.uk",
    "phone": "+44-1270-212525",
    "website": "https://www.lookerscrewebmw.co.uk",
    "coords": {
      "lat": 53.0843391418457,
      "lng": -2.423150062561035
    }
  },
  {
    "id": "05348_7",
    "name": "Douglas Park  Aftersales",
    "country": "GB",
    "city": "Glasgow",
    "address": "30 Pinkston Road, G4 0DD Glasgow",
    "email": "douglaspark.glasgow@parks.uk.com",
    "phone": "+44-141-6117700",
    "website": "https://www.douglasparkglasgowbmw.co.uk",
    "coords": {
      "lat": 55.87154769897461,
      "lng": -4.240658283233643
    }
  },
  {
    "id": "08389_2",
    "name": "Group 1 Reading",
    "country": "GB",
    "city": "Reading",
    "address": "Drake Way, RG2 0GH Reading",
    "email": "ReadingBMW@group1auto.co.uk",
    "phone": "+44-118-9145380",
    "website": "https://www.group1readingbmw.co.uk/",
    "coords": {
      "lat": 51.42878723144531,
      "lng": -0.9771170020103455
    }
  },
  {
    "id": "08632_1",
    "name": "Halliwell Jones Wilmslow",
    "country": "GB",
    "city": "Wilmslow",
    "address": "Coppice Way, SK9 3PB Wilmslow",
    "email": "enquiries@halliwelljoneswilmslow.co.uk",
    "phone": "+44-1625-529955",
    "website": "https://halliwelljoneswilmslowbmw.co.uk",
    "coords": {
      "lat": 53.348358154296875,
      "lng": -2.2072501182556152
    }
  },
  {
    "id": "08682_2",
    "name": "Arnold Clark Giffnock Authorised Repairer",
    "country": "GB",
    "city": "Glasgow",
    "address": "139 Burnfield Road, G46 7TS Glasgow",
    "email": "giffnock.mail@arnoldclark.co.uk",
    "phone": "+44-141-3338937",
    "website": "https://www.arnoldclarkgiffnockbmw.co.uk",
    "coords": {
      "lat": 55.80903625488281,
      "lng": -4.298896789550781
    }
  },
  {
    "id": "08614_1",
    "name": "JCT600 Authorised Repairer",
    "country": "GB",
    "city": "Bradford",
    "address": "99 Sticker Lane, BD4 8RU Bradford",
    "email": "JCT600.WebBookings@jct600.co.uk",
    "phone": "+44-1274-263600",
    "website": "https://www.jct600bmw.co.uk",
    "coords": {
      "lat": 53.78511047363281,
      "lng": -1.719480037689209
    }
  },
  {
    "id": "04877_3",
    "name": "HESS AUTOMOBILE PONTARLIER",
    "country": "FR",
    "city": "PONTARLIER",
    "address": "2 RUE EUGENE THEVENIN, 25300 PONTARLIER",
    "email": "serviceclient@hessautomobile.com",
    "phone": "+33-3-81497000",
    "website": "https://www.bmw-pontarlier.fr/",
    "coords": {
      "lat": 46.90043258666992,
      "lng": 6.33577823638916
    }
  },
  {
    "id": "04890_3",
    "name": "BAYERN BY AUTOSPHERE ARLES",
    "country": "FR",
    "city": "ARLES",
    "address": "QUARTIER FOURCHON, 13200 ARLES",
    "email": "service.commercial@meridional.net.bmw.fr",
    "phone": "+33-4-90188600",
    "website": "https://www.bmw-bayern-arles.fr/",
    "coords": {
      "lat": 43.6641731262207,
      "lng": 4.640251159667969
    }
  },
  {
    "id": "05420_2",
    "name": "ESPACE H OBERNAI",
    "country": "FR",
    "city": "OBERNAI",
    "address": "1 RUE DES ATELIERS, 67210 OBERNAI",
    "email": "contact@lespaceh.fr",
    "phone": "+33-3-88338338",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/42442",
    "coords": {
      "lat": 48.456321716308594,
      "lng": 7.49238920211792
    }
  },
  {
    "id": "27727_1",
    "name": "HESS AUTOMOBILE MULHOUSE",
    "country": "FR",
    "city": "SAUSHEIM",
    "address": "25 ROUTE DEPARTEMENTALE 201, 68390 SAUSHEIM",
    "email": "bmw-mini-mulhouse@groupehess.com",
    "phone": "+33-3-89617656",
    "website": "https://www.bmw-hess-mulhouse.fr/",
    "coords": {
      "lat": 47.78767395019531,
      "lng": 7.3878631591796875
    }
  },
  {
    "id": "28150_1",
    "name": "BMW MINI PARIS",
    "country": "FR",
    "city": "PARIS",
    "address": "58 RUE DE LOURMEL SAV 44 RUE GINOUX, 75015 PARIS",
    "email": "bmwparis@bmw.fr",
    "phone": "+33-1-56770000",
    "website": "http://partenaire.bmw.fr/bmw-paris",
    "coords": {
      "lat": 48.84682846069336,
      "lng": 2.288749933242798
    }
  },
  {
    "id": "28505_1",
    "name": "SARL AUTO BOURGOGNE VACHER MONTCEAU LES MINES",
    "country": "FR",
    "city": "MONTCEAU LES MINES",
    "address": "RUE DE SEMUR, 71300 MONTCEAU LES MINES",
    "email": "autobourgogne.vacher@abv.net.bmw.fr",
    "phone": "+33-3-85573920",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28505",
    "coords": {
      "lat": 46.68703079223633,
      "lng": 4.355125904083252
    }
  },
  {
    "id": "31359_5",
    "name": "PANEL SENS",
    "country": "FR",
    "city": "SENS",
    "address": "21 BIS RUE DES CARRIERES, 89100 SENS",
    "email": "fontainebleau@panel.net.bmw.fr",
    "phone": "+33-3-86657090",
    "website": "https://partenaire.bmw.fr/panel-fontainebleau",
    "coords": {
      "lat": 48.178443908691406,
      "lng": 3.289763927459717
    }
  },
  {
    "id": "33156_1",
    "name": "GRIM PASSION MONTPELLIER",
    "country": "FR",
    "city": "LATTES",
    "address": "564 ROUTE DU PONT DE GUERRE, 34970 LATTES",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-4-67068804",
    "website": "https://www.groupe-grim.com/bmw/",
    "coords": {
      "lat": 43.5753059387207,
      "lng": 3.873405933380127
    }
  },
  {
    "id": "33778_1",
    "name": "BAYARD AUTO MOTO GAP",
    "country": "FR",
    "city": "GAP",
    "address": "77 ROUTE DES EYSSAGNIERES, 05000 GAP",
    "email": "bayard@figest.net",
    "phone": "+33-4-92520257",
    "website": "http://partenaire.bmw.fr/bayard-auto-moto",
    "coords": {
      "lat": 44.53982162475586,
      "lng": 6.052264213562012
    }
  },
  {
    "id": "37934_2",
    "name": "OUEST MOTORS MORLAIX",
    "country": "FR",
    "city": "MORLAIX CEDEX",
    "address": "Z.A. DE LA BOISSIERE, 29202 MORLAIX CEDEX",
    "email": "contact@ouest-auto.net.bmw.fr",
    "phone": "+33-2-98633030",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/37968",
    "coords": {
      "lat": 48.5926399230957,
      "lng": -3.8171000480651855
    }
  },
  {
    "id": "39329_1",
    "name": "ESPACE H HAGUENAU",
    "country": "FR",
    "city": "HAGUENAU CEDEX",
    "address": "110 ROUTE DE STRASBOURG, 67502 HAGUENAU CEDEX",
    "email": "info.haguenau@lespaceh.fr",
    "phone": "+33-3-88061717",
    "website": "http://partenaire.bmw.fr/lespaceh-haguenau",
    "coords": {
      "lat": 48.80025100708008,
      "lng": 7.765539646148682
    }
  },
  {
    "id": "04890_1",
    "name": "BAYERN BY AUTOSPHERE NIMES",
    "country": "FR",
    "city": "NIMES CEDEX 9",
    "address": "1550 ROUTE DE SAINT-GILLES, 30900 NIMES CEDEX 9",
    "email": "service.commercial@meridional.net.bmw.fr",
    "phone": "+33-4-66388989",
    "website": "https://www.bmw-bayern-nimes.fr/",
    "coords": {
      "lat": 43.808990478515625,
      "lng": 4.371471881866455
    }
  },
  {
    "id": "04890_2",
    "name": "BAYERN BY AUTOSPHERE ALES",
    "country": "FR",
    "city": "ALES",
    "address": "555 CHEMIN DE LA TOURTUGUE, 30100 ALES",
    "email": "service.commercial@meridional.net.bmw.fr",
    "phone": "+33-4-66301414",
    "website": "http://www.bmw-meridional-ales.fr/",
    "coords": {
      "lat": 44.12031173706055,
      "lng": 4.109260082244873
    }
  },
  {
    "id": "04990_1",
    "name": "AMPLITUDE AUTOMOBILES LE MANS",
    "country": "FR",
    "city": "LE MANS",
    "address": "2 BOULEVARD RENE CASSIN, 72000 LE MANS",
    "email": "contactlemans@amplitude.net.bmw.fr",
    "phone": "+33-2-43850011",
    "website": "https://partenaire.bmw.fr/amplitude-automobiles-le-mans/",
    "coords": {
      "lat": 47.98101806640625,
      "lng": 0.1912740021944046
    }
  },
  {
    "id": "05515_1",
    "name": "HESS AUTOMOBILE COLMAR",
    "country": "FR",
    "city": "COLMAR Cedex",
    "address": "156 AVENUE D ALSACE, 68007 COLMAR Cedex",
    "email": "bmw-mini-colmar@groupehess.com",
    "phone": "+33-3-89216000",
    "website": "https://www.bmw-hess-colmar.fr/",
    "coords": {
      "lat": 48.06602096557617,
      "lng": 7.363951206207275
    }
  },
  {
    "id": "21205_1",
    "name": "BAYERN BY AUTOSPHERE LILLE SECLIN",
    "country": "FR",
    "city": "SECLIN",
    "address": "RUE DES PAVES, 59113 SECLIN",
    "email": "contact@bavaria-concept.fr",
    "phone": "+33-3-20160059",
    "website": "https://www.bmw-bayern-seclin.fr/",
    "coords": {
      "lat": 50.551124572753906,
      "lng": 3.0529980659484863
    }
  },
  {
    "id": "04877_2",
    "name": "HESS AUTOMOBILE BELFORT",
    "country": "FR",
    "city": "BELFORT",
    "address": "1 RUE ALBERT CAMUS, 90000 BELFORT",
    "email": "serviceclient@hessautomobile.com",
    "phone": "+33-3-84573890",
    "website": "https://www.bmw-belfort.fr",
    "coords": {
      "lat": 47.642234802246094,
      "lng": 6.878042221069336
    }
  },
  {
    "id": "04988_2",
    "name": "AMPLITUDE AUTOMOBILES (TOURS MINI)",
    "country": "FR",
    "city": "CHAMBRAY LES TOURS",
    "address": "3 RUE BENJAMIN FRANKLIN, 37170 CHAMBRAY LES TOURS",
    "email": "contacttours@amplitude.net.mini.fr",
    "phone": "+33-2-47376464",
    "website": "https://partenaire.mini.fr/amplitudetours/",
    "coords": {
      "lat": 47.33137130737305,
      "lng": 0.7047079801559448
    }
  },
  {
    "id": "06648_1",
    "name": "BAYERN BY AUTOSPHERE AIX EN PROVENCE",
    "country": "FR",
    "city": "AIX-EN-PROVENCE CEDEX 4",
    "address": "RUE GUILLAUME DU VAIR, 13546 AIX-EN-PROVENCE CEDEX 4",
    "email": "info@bayern-aix.net.bmw.fr",
    "phone": "+33-4-42162070",
    "website": "http://www.bmw-bayern-aixenprovence.fr/",
    "coords": {
      "lat": 43.507755279541016,
      "lng": 5.403419017791748
    }
  },
  {
    "id": "21901_2",
    "name": "NEUBAUER LE CHESNAY",
    "country": "FR",
    "city": "LE CHESNAY",
    "address": "46-48 RUE MOXOURIS, 78150 LE CHESNAY",
    "email": "contacts@neubauer.fr",
    "phone": "+33-1-39230000",
    "website": "https://www.neubauer-bmw.fr/concessionnaire/neubauer-le-chesnay.html",
    "coords": {
      "lat": 48.83145523071289,
      "lng": 2.1165719032287598
    }
  },
  {
    "id": "25078_1",
    "name": "ARAVIS AUTOMOBILES ANNECY",
    "country": "FR",
    "city": "EPAGNY METZ-TESSY",
    "address": "292 RUE DES SAVOIE, 74330 EPAGNY METZ-TESSY",
    "email": "aravis@rossi-automobile.com",
    "phone": "+33-4-50335483",
    "website": "https://partenaire.bmw.fr/aravis-automobiles",
    "coords": {
      "lat": 45.92438888549805,
      "lng": 6.084390163421631
    }
  },
  {
    "id": "04940_1",
    "name": "OLIVA MOTOR PERPIGNAN",
    "country": "FR",
    "city": "PERPIGNAN",
    "address": "2500 AVENUE DE PRADES, 66000 PERPIGNAN",
    "email": "perpignan@olivamotor.com",
    "phone": "+33-4-68340783",
    "website": "https://www.bmw.fr/olivamotor",
    "coords": {
      "lat": 42.69340896606445,
      "lng": 2.848140001296997
    }
  },
  {
    "id": "40354_1",
    "name": "LOUYET NICE",
    "country": "FR",
    "city": "NICE",
    "address": "116 AVENUE SIMONE VEIL, 06200 NICE",
    "email": "leads@npm.net.bmw.fr",
    "phone": "+33-4-93182200",
    "website": "http://partenaire.bmw.fr/nice-premium-motors/",
    "coords": {
      "lat": 43.689388275146484,
      "lng": 7.201399803161621
    }
  },
  {
    "id": "04911_2",
    "name": "CAR AVENUE BEAUNE",
    "country": "FR",
    "city": "BEAUNE",
    "address": "93 BIS ROUTE DE POMMARD, 21200 BEAUNE",
    "email": "bmwbeaune@caravenue.com",
    "phone": "+33-3-80228869",
    "website": "https://beaune.bmwcaravenue.fr/",
    "coords": {
      "lat": 47.013362884521484,
      "lng": 4.815709114074707
    }
  },
  {
    "id": "04955_2",
    "name": "EDENAUTO PREMIUM TARBES",
    "country": "FR",
    "city": "TARBES",
    "address": "RUE PATRICK BAUDRY, 65000 TARBES",
    "email": "edenautopremium.tarbes.contact@edenauto.com",
    "phone": "+33-5-62900600",
    "website": "https://bmw-tarbes.edenauto.com",
    "coords": {
      "lat": 43.21942138671875,
      "lng": 0.08941400051116943
    }
  },
  {
    "id": "04977_3",
    "name": "ENVERGURE CAEN HEROUVILLE",
    "country": "FR",
    "city": "HEROUVILLE-SAINT-CLAIR",
    "address": "1226 RUE LEON FOUCAULT, 14200 HEROUVILLE-SAINT-CLAIR",
    "email": "marketing@normandy.net.bmw.fr",
    "phone": "+33-2-31450908",
    "website": "https://www.groupegca.com/concession/bmw-caen",
    "coords": {
      "lat": 49.21088409423828,
      "lng": -0.35272398591041565
    }
  },
  {
    "id": "05414_1",
    "name": "BMS LE HAVRE",
    "country": "FR",
    "city": "LE HAVRE",
    "address": "171 BOULEVARD DE GRAVILLE, 76600 LE HAVRE",
    "email": "contact.lehavre@groupebms.fr",
    "phone": "+33-2-32927676",
    "website": "https://www.groupebms.fr/concession/bms-le-havre/",
    "coords": {
      "lat": 49.491092681884766,
      "lng": 0.14901100099086761
    }
  },
  {
    "id": "05534_1",
    "name": "L'ESPACE BIENVENUE ROYAN",
    "country": "FR",
    "city": "SAINT GEORGES DE DIDONNE",
    "address": "4, RUE ROBERT SCHUMANN, 17110 SAINT GEORGES DE DIDONNE",
    "email": "contact.royan@bienvenue.net.bmw.fr",
    "phone": "+33-5-46050162",
    "website": "http://partenaire.bmw.fr/espace-bienvenue-royan",
    "coords": {
      "lat": 45.61693572998047,
      "lng": -0.9896280169487
    }
  },
  {
    "id": "05534_4",
    "name": "L'ESPACE BIENVENUE ANGOULEME",
    "country": "FR",
    "city": "CHAMPNIERS",
    "address": "ZAC LES MONTAGNES OUEST, 16430 CHAMPNIERS",
    "email": "contact.angouleme@bienvenue.net.bmw.fr",
    "phone": "+33-5-45904290",
    "website": "http://partenaire.bmw.fr/espace-bienvenue-angouleme",
    "coords": {
      "lat": 45.69046401977539,
      "lng": 0.17677700519561768
    }
  },
  {
    "id": "05547_1",
    "name": "SELLENS FREJUS",
    "country": "FR",
    "city": "FREJUS",
    "address": "RUE HUBERT MASQUEFA, 83600 FREJUS",
    "email": "lead@jpv.fr",
    "phone": "+33-4-94196200",
    "website": "http://partenaire.bmw.fr/jpv",
    "coords": {
      "lat": 43.472625732421875,
      "lng": 6.733966827392578
    }
  },
  {
    "id": "11380_5",
    "name": "ENVERGURE SAINT-QUENTIN (02)",
    "country": "FR",
    "city": "SAINT QUENTIN",
    "address": "RUE ANTOINE PARMENTIER, 02100 SAINT QUENTIN",
    "email": "envergurereims@groupegca.com",
    "phone": "+33-3-23603560",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/35953",
    "coords": {
      "lat": 49.85591125488281,
      "lng": 3.2584800720214844
    }
  },
  {
    "id": "21903_3",
    "name": "PAUTRIC LAVAL",
    "country": "FR",
    "city": "LAVAL",
    "address": "ROUTE DE FOUGERES, 53000 LAVAL",
    "email": "suivi-contact@huchet.net.bmw.fr",
    "phone": "+33-2-43533159",
    "website": "https://bmw-huchet-laval.fr/",
    "coords": {
      "lat": 48.084754943847656,
      "lng": -0.7924060225486755
    }
  },
  {
    "id": "04853_1",
    "name": "GUEUDET 1880 SAINT MERRI CHANTILLY (BMW)",
    "country": "FR",
    "city": "SAINT MAXIMIN",
    "address": "89 R.DES DROITS DE L'HOMME ET CIT., 60740 SAINT MAXIMIN",
    "email": "contact-saintmerri@gueudet.fr",
    "phone": "+33-3-44671900",
    "website": "https://www.saintmerri.fr/",
    "coords": {
      "lat": 49.23170471191406,
      "lng": 2.4670701026916504
    }
  },
  {
    "id": "04907_5",
    "name": "AXXIA SAS NEVERS",
    "country": "FR",
    "city": "NEVERS",
    "address": "BOULEVARD DU PRE PLANTIN, 58000 NEVERS",
    "email": "contact.bmw58@axxia.net.bmw.fr",
    "phone": "+33-3-86618282",
    "website": "http://partenaire.bmw.fr/axxia-nevers",
    "coords": {
      "lat": 46.98535919189453,
      "lng": 3.123013973236084
    }
  },
  {
    "id": "04909_2",
    "name": "INDIGO BALLAINVILLIERS",
    "country": "FR",
    "city": "BALLAINVILLIERS",
    "address": "54, ROUTE NATIONALE 20, 91160 BALLAINVILLIERS",
    "email": "contact@indigo.net.bmw.fr",
    "phone": "+33-1-69809401",
    "website": "https://bmw-indigo.fr/",
    "coords": {
      "lat": 48.66378402709961,
      "lng": 2.2776029109954834
    }
  },
  {
    "id": "04843_1",
    "name": "PAUTRIC GRENOBLE MEYLAN",
    "country": "FR",
    "city": "MEYLAN",
    "address": "1 BIS, BOULEVARD DES ALPES, 38240 MEYLAN",
    "email": "Experience.BMW@royal.net.bmw.fr",
    "phone": "+33-4-76419010",
    "website": "https://www.bmw-royalsa.fr",
    "coords": {
      "lat": 45.20268630981445,
      "lng": 5.766053199768066
    }
  },
  {
    "id": "04955_1",
    "name": "EDENAUTO PREMIUM PAU",
    "country": "FR",
    "city": "LESCAR",
    "address": "1 AVENUE SANTOS DUMONT, 64230 LESCAR",
    "email": "edenautopremium.pau-lescar.contact@edenauto.com",
    "phone": "+33-5-59811800",
    "website": "https://bmw-pau-lescar.edenauto.com",
    "coords": {
      "lat": 43.31974792480469,
      "lng": -0.42243099212646484
    }
  },
  {
    "id": "04886_1",
    "name": "BMS MANTES LA JOLIE",
    "country": "FR",
    "city": "BUCHELAY",
    "address": "1, AVENUE DE LA GARONNE, 78200 BUCHELAY",
    "email": "contact.mantes@groupebms.fr",
    "phone": "+33-1-34799741",
    "website": "https://www.groupebms.fr/concession/bms-mantes/",
    "coords": {
      "lat": 48.99006652832031,
      "lng": 1.6769750118255615
    }
  },
  {
    "id": "04907_1",
    "name": "AXXIA SAS BOURGES",
    "country": "FR",
    "city": "SAINT DOULCHARD",
    "address": "1549 ROUTE D'ORLEANS, 18230 SAINT DOULCHARD",
    "email": "contact.bmw18@axxia.net.bmw.fr",
    "phone": "+33-2-48481313",
    "website": "https://partenaire.bmw.fr/axxia-bourges",
    "coords": {
      "lat": 47.11811447143555,
      "lng": 2.3733179569244385
    }
  },
  {
    "id": "04908_1",
    "name": "CAR AVENUE CHALON SUR SAONE",
    "country": "FR",
    "city": "CHALON SUR SAONE",
    "address": "2 AVENUE DE L AUTOMOBILE, 71000 CHALON SUR SAONE",
    "email": "bmwchalon@caravenue.com",
    "phone": "+33-3-85481214",
    "website": "https://chalon.bmwcaravenue.fr/",
    "coords": {
      "lat": 46.76851272583008,
      "lng": 4.859673976898193
    }
  },
  {
    "id": "05417_1",
    "name": "HORIZON NORMANDIE ROUEN",
    "country": "FR",
    "city": "ROUEN CEDEX",
    "address": "122 RUE DE CONSTANTINE, 76021 ROUEN CEDEX",
    "email": "rouen@horizon.fr",
    "phone": "+33-2-35983377",
    "website": "https://www.horizon.fr",
    "coords": {
      "lat": 49.448001861572266,
      "lng": 1.0718979835510254
    }
  },
  {
    "id": "05445_1",
    "name": "ENVERGURE LA ROCHELLE",
    "country": "FR",
    "city": "PUILBOREAU",
    "address": "RUE DU 8 MAI 1945, 17138 PUILBOREAU",
    "email": "contact.larochelle@groupegca.com",
    "phone": "+33-5-46273434",
    "website": "https://partenaire.bmw.fr/envergure-larochelle/",
    "coords": {
      "lat": 46.17933654785156,
      "lng": -1.1045809984207153
    }
  },
  {
    "id": "04986_2",
    "name": "ENVERGURE GRANVILLE",
    "country": "FR",
    "city": "GRANVILLE",
    "address": "139, RUE DES ENTREPRENEURS, 50400 GRANVILLE",
    "email": "contact@envergureauto.net.bmw.fr",
    "phone": "+33-2-33503427",
    "website": "http://concessionnaire.bmw.fr/envergure-auto-saintlo/fr_FR/index.html",
    "coords": {
      "lat": 48.83734893798828,
      "lng": -1.5486769676208496
    }
  },
  {
    "id": "04986_1",
    "name": "ENVERGURE SAINT LO",
    "country": "FR",
    "city": "SAINT LO",
    "address": "ROND POINT DE L'EUROPE, 50000 SAINT LO",
    "email": "contact@envergureauto.net.bmw.fr",
    "phone": "+33-2-33051555",
    "website": "https://partenaire.bmw.fr/envergure-auto-saintlo",
    "coords": {
      "lat": 49.09928894042969,
      "lng": -1.0806790590286255
    }
  },
  {
    "id": "05402_2",
    "name": "PAUTRIC LA BAULE",
    "country": "FR",
    "city": "GUERANDE",
    "address": "20 RUE DE LA BRIQUERIE-VILLENEUVE, 44350 GUERANDE",
    "email": "informations@pays-loire.net.bmw.fr",
    "phone": "+33-2-40111001",
    "website": "http://www.capouest-auto.com",
    "coords": {
      "lat": 47.321502685546875,
      "lng": -2.4136457443237305
    }
  },
  {
    "id": "08540_1",
    "name": "BYMYCAR 77 MARNE LA VALLEE",
    "country": "FR",
    "city": "SAINT THIBAULT DES VIGNES",
    "address": "31 BIS AVENUE ST GERMAIN DES NOYERS, 77400 SAINT THIBAULT DES VIGNES",
    "email": "lead.idf@bymycar.fr",
    "phone": "+33-1-60354040",
    "website": "http://partenaire.bmw.fr/bymycar77",
    "coords": {
      "lat": 48.86037063598633,
      "lng": 2.6719160079956055
    }
  },
  {
    "id": "11380_6",
    "name": "ENVERGURE SOISSONS",
    "country": "FR",
    "city": "SOISSONS",
    "address": "2 ROUTE DE PRESLES, 02200 SOISSONS",
    "email": "envergurereims@groupegca.com",
    "phone": "+33-3-23735050",
    "website": "https://partenaire.bmw.fr/envergure-soissons",
    "coords": {
      "lat": 49.36703872680664,
      "lng": 3.307373046875
    }
  },
  {
    "id": "21125_1",
    "name": "PAUTRIC VANNES",
    "country": "FR",
    "city": "VANNES",
    "address": "ZA PARC LANN, 56000 VANNES",
    "email": "contact@littoral.net.bmw.fr",
    "phone": "+33-2-49882274",
    "website": "http://partenaire.bmw.fr/littoral-automobiles",
    "coords": {
      "lat": 47.665531158447266,
      "lng": -2.7868099212646484
    }
  },
  {
    "id": "21125_3",
    "name": "PAUTRIC QUIMPER",
    "country": "FR",
    "city": "QUIMPER",
    "address": "5, RUE JOSEPH CUGNOT, 29000 QUIMPER",
    "email": "contact-latitude@latitude.net.bmw.fr",
    "phone": "+33-2-49880500",
    "website": "http://partenaire.bmw.fr/latitude-automobiles-quimper",
    "coords": {
      "lat": 47.98115921020508,
      "lng": -4.039553642272949
    }
  },
  {
    "id": "26366_7",
    "name": "HORIZON SAINT GRATIEN",
    "country": "FR",
    "city": "SAINT-GRATIEN",
    "address": "51 BOULEVARD DU MARECHAL FOCH, 95210 SAINT-GRATIEN",
    "email": "saintgratien@horizon.fr",
    "phone": "+33-1-34174747",
    "website": "https://www.horizon.fr/",
    "coords": {
      "lat": 48.964256286621094,
      "lng": 2.288808584213257
    }
  },
  {
    "id": "08118_4",
    "name": "PAUTRIC LYON SUD",
    "country": "FR",
    "city": "VENISSIEUX",
    "address": "2-4 RUE LOUIS BLANC, 69200 VENISSIEUX",
    "email": "experience.clientbmwlyonsud@emeraudes.net.bmw.fr",
    "phone": "+33-4-78783939",
    "website": "http://www.6avenue.fr",
    "coords": {
      "lat": 45.720733642578125,
      "lng": 4.879133224487305
    }
  },
  {
    "id": "32337_1",
    "name": "BAYERN AUTO SPORT CALAIS",
    "country": "FR",
    "city": "COQUELLES",
    "address": "PLACE DE CANTORBÉRY, 62231 COQUELLES",
    "email": "bmwcalais@groupe-lempereur.com",
    "phone": "+33-3-21855500",
    "website": "https://www.groupe-lempereur.com/content/689-bmw-vehicule-neuf",
    "coords": {
      "lat": 50.937904357910156,
      "lng": 1.8086349964141846
    }
  },
  {
    "id": "32870_1",
    "name": "SELLENS MARSEILLE",
    "country": "FR",
    "city": "MARSEILLE",
    "address": "83 BOULEVARD DE PARIS, 13002 MARSEILLE",
    "email": "serviceclients@bmwstation7.fr",
    "phone": "+33-4-91919107",
    "website": "http://partenaire.bmw.fr/station7",
    "coords": {
      "lat": 43.309688568115234,
      "lng": 5.370243072509766
    }
  },
  {
    "id": "32484_3",
    "name": "ENVERGURE SAUMUR",
    "country": "FR",
    "city": "DISTRE",
    "address": "9 RUE DU VAL DE LOIRE, 49400 DISTRE",
    "email": "service.commercial@dynamism.net.bmw.fr",
    "phone": "+33-2-41501010",
    "website": "http://www.dynamism-automobiles.bmw.fr",
    "coords": {
      "lat": 47.23011016845703,
      "lng": -0.12912189960479736
    }
  },
  {
    "id": "20427_5",
    "name": "EDENAUTO PREMIUM CARCASSONNE",
    "country": "FR",
    "city": "CARCASSONNE",
    "address": "AVENUE DU GENERAL LECLERC, 11000 CARCASSONNE",
    "email": "contact.bnc@eden-auto.com",
    "phone": "+33-4-68471414",
    "website": "https://bmw-carcassonne.edenauto.com",
    "coords": {
      "lat": 43.20713806152344,
      "lng": 2.384484052658081
    }
  },
  {
    "id": "21903_1",
    "name": "PAUTRIC RENNES",
    "country": "FR",
    "city": "SAINT GREGOIRE CEDEX",
    "address": "ZA ROUTE DU MEUBLE, 35768 SAINT GREGOIRE CEDEX",
    "email": "suivi-contact@huchet.net.bmw.fr",
    "phone": "+33-2-99250606",
    "website": "http://www.huchet-sa.fr",
    "coords": {
      "lat": 48.17962646484375,
      "lng": -1.7213759422302246
    }
  },
  {
    "id": "43543_1",
    "name": "CAR PREMIUM 62 BETHUNE",
    "country": "FR",
    "city": "BETHUNE",
    "address": "TECHNOPARC FUTURA, 62400 BETHUNE",
    "email": "bethune@car-premium.net.bmw.fr",
    "phone": "+33-3-21688240",
    "website": "http://partenaire.bmw.fr/car-premium-bethune",
    "coords": {
      "lat": 50.512447357177734,
      "lng": 2.6599230766296387
    }
  },
  {
    "id": "44690_1",
    "name": "CAR PREMIUM 59 DOUAI",
    "country": "FR",
    "city": "DECHY",
    "address": "RUE BARACK OBAMA, 59187 DECHY",
    "email": "douai@car-premium.net.bmw.fr",
    "phone": "+33-3-59640300",
    "website": "http://partenaire.bmw.fr/car-premium-dechy/",
    "coords": {
      "lat": 50.34535598754883,
      "lng": 3.1170899868011475
    }
  },
  {
    "id": "23869_1",
    "name": "CAR AVENUE CHAUMONT",
    "country": "FR",
    "city": "CHAUMONT",
    "address": "9 ROUTE DE NEUILLY, 52000 CHAUMONT",
    "email": "bmwchaumont@caravenue.com",
    "phone": "+33-3-25034904",
    "website": "https://chaumont.bmwcaravenue.fr/",
    "coords": {
      "lat": 48.08771896362305,
      "lng": 5.146124839782715
    }
  },
  {
    "id": "26366_1",
    "name": "HORIZON NANTERRE",
    "country": "FR",
    "city": "NANTERRE",
    "address": "100 AVENUE FRANCOIS ARAGO, 92000 NANTERRE",
    "email": "ladefense@horizon.fr",
    "phone": "+33-1-55704747",
    "website": "https://www.horizon.fr/",
    "coords": {
      "lat": 48.90074920654297,
      "lng": 2.224720001220703
    }
  },
  {
    "id": "32337_5",
    "name": "BAYERN AUTO SPORT SAINT OMER",
    "country": "FR",
    "city": "ARQUES",
    "address": "RUE YVES MONTAND, 62510 ARQUES",
    "email": "bmwstomer@groupe-lempereur.com",
    "phone": "+33-3-21985000",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/32338",
    "coords": {
      "lat": 50.73045349121094,
      "lng": 2.2779040336608887
    }
  },
  {
    "id": "04951_4",
    "name": "GROUPE AUTOSPHERE MONT DE MARSAN",
    "country": "FR",
    "city": "SAINT AVIT",
    "address": "150 ALLEE DE L'ERMITE, 40090 SAINT AVIT",
    "email": "contact@bayern-lpb.net.bmw.fr",
    "phone": "+33-5-58059076",
    "website": "https://www.bmw-bayern-montdemarsan.fr/",
    "coords": {
      "lat": 43.918670654296875,
      "lng": -0.45083001255989075
    }
  },
  {
    "id": "05495_2",
    "name": "GROUPE AUTOSPHERE LA TESTE DE BUCH",
    "country": "FR",
    "city": "LA TESTE DE BUCH",
    "address": "1016, BD DE L'INDUSTRIE, 33260 LA TESTE DE BUCH",
    "email": "contact@bordeaux-bayern.net.bmw.fr",
    "phone": "+33-5-56543373",
    "website": "https://www.bmw-bayern-arcachon.fr/",
    "coords": {
      "lat": 44.609588623046875,
      "lng": -1.1305259466171265
    }
  },
  {
    "id": "04951_1",
    "name": "GROUPE AUTOSPHERE BAYONNE",
    "country": "FR",
    "city": "BAYONNE",
    "address": "Avenue du Grand Basque, 64100 BAYONNE",
    "email": "contact@bayern-lpb.net.bmw.fr",
    "phone": "+33-5-59508877",
    "website": "http://www.bmw-bayern-bayonne.fr/",
    "coords": {
      "lat": 43.49011993408203,
      "lng": -1.4559669494628906
    }
  },
  {
    "id": "05495_1",
    "name": "GROUPE AUTOSPHERE MERIGNAC",
    "country": "FR",
    "city": "MERIGNAC",
    "address": "59 RUE JACQUES PREVERT SORTIE N°10, 33700 MERIGNAC",
    "email": "accueil@bordeaux-bayern.net.bmw.fr",
    "phone": "+33-5-56342524",
    "website": "https://www.bmw-bayern-merignac.fr/",
    "coords": {
      "lat": 44.848880767822266,
      "lng": -0.667460024356842
    }
  },
  {
    "id": "35958_1",
    "name": "LE SPECIALISTE ANGERS",
    "country": "FR",
    "city": "BEAUCOUZE",
    "address": "29 RUE DU LANDREAU, 49070 BEAUCOUZE",
    "email": "pascal.retif@lespecialiste.fr",
    "phone": "+33-2-41770770",
    "website": "https://www.lespecialiste.fr",
    "coords": {
      "lat": 47.47309875488281,
      "lng": -0.6205160021781921
    }
  },
  {
    "id": "04942_1",
    "name": "ESCAT RODEZ",
    "country": "FR",
    "city": "ONET-LE-CHATEAU",
    "address": "556 RUE DES ENLUMINEURS, 12850 ONET-LE-CHATEAU",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-5-65428421",
    "website": "http://partenaire.bmw.fr/escat-rodez",
    "coords": {
      "lat": 44.378028869628906,
      "lng": 2.5386340618133545
    }
  },
  {
    "id": "04947_2",
    "name": "FOUREL MONTELIMAR",
    "country": "FR",
    "city": "MONTELIMAR",
    "address": "AVENUE DE GOURNIER, 26200 MONTELIMAR",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-4-75008787",
    "website": "https://www.groupe-grim.com",
    "coords": {
      "lat": 44.53410720825195,
      "lng": 4.7338972091674805
    }
  },
  {
    "id": "05528_1",
    "name": "AUVERGNE AUTO AURILLAC",
    "country": "FR",
    "city": "AURILLAC",
    "address": "40 AVENUE GEORGES POMPIDOU, 15000 AURILLAC",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-4-71645844",
    "website": "http://partenaire.bmw.fr/auvergne-auto",
    "coords": {
      "lat": 44.91868209838867,
      "lng": 2.465301990509033
    }
  },
  {
    "id": "25068_2",
    "name": "HESS AUTOMOBILE DOLE",
    "country": "FR",
    "city": "FOUCHERANS",
    "address": "CHEMIN DE ROUGEMONT, 39100 FOUCHERANS",
    "email": "serviceclient@hessautomobile.com",
    "phone": "+33-3-84728488",
    "website": "https://www.bmw-dole.fr",
    "coords": {
      "lat": 47.07722854614258,
      "lng": 5.46115779876709
    }
  },
  {
    "id": "28637_1",
    "name": "CHAMARAUD SARL PARAY LE MONIAL",
    "country": "FR",
    "city": "PARAY LE MONIAL",
    "address": "52, QUAI DU COMMERCE, 71600 PARAY LE MONIAL",
    "email": "accueil.chamaraud@chamaraud.net.bmw.fr",
    "phone": "+33-3-85811031",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28637",
    "coords": {
      "lat": 46.44465637207031,
      "lng": 4.121809005737305
    }
  },
  {
    "id": "30383_1",
    "name": "NEUBAUER MIRABEAU PARIS MIRABEAU",
    "country": "FR",
    "city": "PARIS",
    "address": "71 AVENUE DE VERSAILLES, 75016 PARIS",
    "email": "bmwmini@neubauer.fr",
    "phone": "+33-1-46470000",
    "website": "https://www.neubauer-bmw.fr/concessionnaire/neubauer-mirabeau.html",
    "coords": {
      "lat": 48.84669494628906,
      "lng": 2.2729549407958984
    }
  },
  {
    "id": "31359_3",
    "name": "PANEL MELUN",
    "country": "FR",
    "city": "VERT SAINT DENIS",
    "address": "130 ROUTE DEPARTEMENTALE 306, 77240 VERT SAINT DENIS",
    "email": "melun@panel.net.bmw.fr",
    "phone": "+33-1-64142244",
    "website": "https://partenaire.bmw.fr/panel-melun",
    "coords": {
      "lat": 48.56768035888672,
      "lng": 2.627734899520874
    }
  },
  {
    "id": "32329_1",
    "name": "SALEVE AUTOMOBILES ANNEMASSE (BMW)",
    "country": "FR",
    "city": "VILLE LA GRAND",
    "address": "8 RUE DES BUCHILLONS, 74100 VILLE LA GRAND",
    "email": "saleve@rossi-automobile.com",
    "phone": "+33-4-50846868",
    "website": "https://partenaire.bmw.fr/saleve-automobiles",
    "coords": {
      "lat": 46.19953536987305,
      "lng": 6.266478061676025
    }
  },
  {
    "id": "32329_3",
    "name": "HERMONE AUTOMOBILES THONON LES BAINS",
    "country": "FR",
    "city": "ANTHY SUR LEMAN",
    "address": "3 RUE DE L'EUROPE, 74200 ANTHY SUR LEMAN",
    "email": "hermone@rossi-automobile.com",
    "phone": "+33-4-58550143",
    "website": "https://partenaire.bmw.fr/hermone-automobiles",
    "coords": {
      "lat": 46.35093307495117,
      "lng": 6.443146228790283
    }
  },
  {
    "id": "40418_1",
    "name": "STORE MONACO",
    "country": "FR",
    "city": "MONACO",
    "address": "9 RUE DU GABIAN, 98000 MONACO",
    "email": "contact@bmw.mc",
    "phone": "+377-97978960",
    "website": "https://partenaire.bmw.fr/storemonaco",
    "coords": {
      "lat": 43.73019027709961,
      "lng": 7.415472030639648
    }
  },
  {
    "id": "04877_1",
    "name": "HESS AUTOMOBILE BESANCON",
    "country": "FR",
    "city": "MISEREY SALINES",
    "address": "Z.A.C. DE VALENTIN, 25480 MISEREY SALINES",
    "email": "serviceclient@hessautomobile.com",
    "phone": "+33-3-81479797",
    "website": "https://www.bmw-motorrad-besancon.fr/",
    "coords": {
      "lat": 47.27976989746094,
      "lng": 5.987020969390869
    }
  },
  {
    "id": "04947_1",
    "name": "FOUREL VALENCE",
    "country": "FR",
    "city": "VALENCE",
    "address": "ROUTE DE BEAUVALLON, 26000 VALENCE",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-4-75442097",
    "website": "https://www.groupe-grim.com",
    "coords": {
      "lat": 44.90178680419922,
      "lng": 4.886023044586182
    }
  },
  {
    "id": "05420_1",
    "name": "ESPACE H STRASBOURG",
    "country": "FR",
    "city": "HOENHEIM",
    "address": "2 RUE EMILE MATHIS, 67800 HOENHEIM",
    "email": "contact@lespaceh.fr",
    "phone": "+33-3-88753753",
    "website": "http://partenaire.bmw.fr/lespaceh-strasbourg",
    "coords": {
      "lat": 48.621585845947266,
      "lng": 7.728174209594727
    }
  },
  {
    "id": "30383_6",
    "name": "NEUBAUER BOULOGNE BOULOGNE BILLANCOURT",
    "country": "FR",
    "city": "BOULOGNE-BILLANCOURT",
    "address": "24, RUE DU CHEMIN VERT, 92100 BOULOGNE-BILLANCOURT",
    "email": "contact@neubauer.net.bmw.fr",
    "phone": "+33-1-55206666",
    "website": "http://www.neubauer.bmw.fr",
    "coords": {
      "lat": 48.83742141723633,
      "lng": 2.2524900436401367
    }
  },
  {
    "id": "31359_1",
    "name": "PANEL FONTAINEBLEAU",
    "country": "FR",
    "city": "SAMOREAU",
    "address": "4 RUE DU BOIS GASSEAU, 77210 SAMOREAU",
    "email": "fontainebleau@panel.net.bmw.fr",
    "phone": "+33-1-60396000",
    "website": "https://partenaire.bmw.fr/panel-fontainebleau",
    "coords": {
      "lat": 48.42494583129883,
      "lng": 2.763390064239502
    }
  },
  {
    "id": "37934_1",
    "name": "OUEST MOTORS BREST",
    "country": "FR",
    "city": "BREST",
    "address": "168 ROUTE DE GOUESNOU, 29200 BREST",
    "email": "contact@ouest-auto.net.bmw.fr",
    "phone": "+33-2-98021115",
    "website": "https://partenaire.bmw.fr/ouest-motors-brest",
    "coords": {
      "lat": 48.42066955566406,
      "lng": -4.4688520431518555
    }
  },
  {
    "id": "05424_4",
    "name": "BAVARIA MOTORS TOULON",
    "country": "FR",
    "city": "OLLIOULES",
    "address": "AVENUE JEAN MERMOZ, 83190 OLLIOULES",
    "email": "contact@bavaria.net.bmw.fr",
    "phone": "+33-4-94108640",
    "website": "https://partenaire.bmw.fr/bavaria-motors-ollioules",
    "coords": {
      "lat": 43.12162780761719,
      "lng": 5.846692085266113
    }
  },
  {
    "id": "05439_1",
    "name": "BAYERN BY AUTOSPHERE LILLE",
    "country": "FR",
    "city": "LILLE/VILLENEUVE D'ASCQ CEDEX",
    "address": "16 RUE DU HAUT DE LA CRUPPE, 59664 LILLE/VILLENEUVE D'ASCQ CEDEX",
    "email": "contact@autolille.fr",
    "phone": "+33-3-20662727",
    "website": "http://www.autolille.fr/",
    "coords": {
      "lat": 50.64094161987305,
      "lng": 3.1221559047698975
    }
  },
  {
    "id": "05546_7",
    "name": "DUPONT MONTARGIS",
    "country": "FR",
    "city": "AMILLY",
    "address": "61 RUE DE LA ROSE BLANCHE, 45200 AMILLY",
    "email": "contactmontargis@dupont.net.bmw.fr",
    "phone": "+33-2-38980026",
    "website": "https://partenaire.bmw.fr/dupontmontargis",
    "coords": {
      "lat": 47.96227264404297,
      "lng": 2.7360970973968506
    }
  },
  {
    "id": "06648_3",
    "name": "BAYERN BY AUTOSPHERE SALON DE PROVENCE",
    "country": "FR",
    "city": "SALON-DE-PROVENCE",
    "address": "659 CHEMIN DES CARDELINES, 13300 SALON-DE-PROVENCE",
    "email": "info@bayern-aix.net.bmw.fr",
    "phone": "+33-4-90562119",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/29663",
    "coords": {
      "lat": 43.619625091552734,
      "lng": 5.092360973358154
    }
  },
  {
    "id": "23800_2",
    "name": "OUEST MOTORS LANNION",
    "country": "FR",
    "city": "LANNION",
    "address": "RUE PAUL FLEURIOT DE LANGLE, 22300 LANNION",
    "email": "contact@rose.net.bmw.fr",
    "phone": "+33-2-96141414",
    "website": "https://partenaire.bmw.fr/ouest-motors",
    "coords": {
      "lat": 48.73282241821289,
      "lng": -3.4338219165802
    }
  },
  {
    "id": "28150_3",
    "name": "BMW MINI PARIS VELIZY",
    "country": "FR",
    "city": "VELIZY VILLACOUBLAY",
    "address": "39 AVENUE LOUIS BREGUET, 78140 VELIZY VILLACOUBLAY",
    "email": "bmwparis@bmw.fr",
    "phone": "+33-1-39450400",
    "website": "http://partenaire.bmw.fr/paris-velizy",
    "coords": {
      "lat": 48.782230377197266,
      "lng": 2.1765599250793457
    }
  },
  {
    "id": "29302_2",
    "name": "HELI-MOTORS MONTLUCON",
    "country": "FR",
    "city": "MONTLUCON",
    "address": "62, RUE DE PASQUIS, 03100 MONTLUCON",
    "email": "contact@heli-motors.net.bmw.fr",
    "phone": "+33-4-70030030",
    "website": "http://partenaire.bmw.fr/heli-motors-montlucon",
    "coords": {
      "lat": 46.365509033203125,
      "lng": 2.5927979946136475
    }
  },
  {
    "id": "27951_3",
    "name": "EQUATION CASTRES",
    "country": "FR",
    "city": "CASTRES",
    "address": "11 RUE DU MELOU, 81100 CASTRES",
    "email": "contact@equation.net.bmw.fr",
    "phone": "+33-5-63590252",
    "website": "http://partenaire.bmw.fr/equation-automobiles-castres/",
    "coords": {
      "lat": 43.59195327758789,
      "lng": 2.217582941055298
    }
  },
  {
    "id": "05513_1",
    "name": "PELRAS SA TOULOUSE",
    "country": "FR",
    "city": "TOULOUSE",
    "address": "145, RUE NICOLAS VAUQUELIN, 31100 TOULOUSE",
    "email": "hello@pelras.fr",
    "phone": "+33-5-34608608",
    "website": "https://partenaire.bmw.fr/pelras-sa/concession-bmw-pelras-toulouse",
    "coords": {
      "lat": 43.58323669433594,
      "lng": 1.4035029411315918
    }
  },
  {
    "id": "04907_2",
    "name": "AXXIA CHATEAUROUX",
    "country": "FR",
    "city": "CHATEAUROUX",
    "address": "LA POTERIE, 36000 CHATEAUROUX",
    "email": "contact.bmw36@axxia.net.bmw.fr",
    "phone": "+33-2-54081717",
    "website": "http://partenaire.bmw.fr/axxia-chateauroux",
    "coords": {
      "lat": 46.792537689208984,
      "lng": 1.7140599489212036
    }
  },
  {
    "id": "04955_3",
    "name": "EDENAUTO PREMIUM AUCH",
    "country": "FR",
    "city": "AUCH",
    "address": "20 AVENUE MARGUERITE DURAS, 32000 AUCH",
    "email": "edenautopremium.auch.contact@edenauto.com",
    "phone": "+33-5-562635004",
    "website": "https://bmw-auch.edenauto.com/",
    "coords": {
      "lat": 43.66343688964844,
      "lng": 0.6192060112953186
    }
  },
  {
    "id": "05402_3",
    "name": "PAUTRIC REZE",
    "country": "FR",
    "city": "REZE",
    "address": "3 BOULEVARD LEONARD DE VINCI, 44400 REZE",
    "email": "informations@pays-loire.net.bmw.fr",
    "phone": "+33-2-51783990",
    "website": "http://www.pays-de-loire-automobiles.com",
    "coords": {
      "lat": 47.15574645996094,
      "lng": -1.5459738969802856
    }
  },
  {
    "id": "05478_2",
    "name": "ENVERGURE LES SABLES DOLONNE",
    "country": "FR",
    "city": "LES SABLES D OLONNE",
    "address": "156, AVENUE DU PAS DU BOIS, 85180 LES SABLES D OLONNE",
    "email": "commercial.ls@napoleon.net.bmw.fr",
    "phone": "+33-2-51213656",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/5595",
    "coords": {
      "lat": 46.49082946777344,
      "lng": -1.7489960193634033
    }
  },
  {
    "id": "05538_1",
    "name": "EDENAUTO PREMIUM BORDEAUX",
    "country": "FR",
    "city": "LORMONT",
    "address": "28 AVENUE PRESIDENT JF KENNEDY, 33310 LORMONT",
    "email": "bmw.bordeaux.contact@edenauto.com",
    "phone": "+33-5-57350303",
    "website": "https://bmw-bordeaux.edenauto.com",
    "coords": {
      "lat": 44.868350982666016,
      "lng": -0.5084699988365173
    }
  },
  {
    "id": "11380_3",
    "name": "ENVERGURE CHARLEVILLE MEZIERES",
    "country": "FR",
    "city": "CHARLEVILLE MEZIERES",
    "address": "ANDRE JOSEPH, 08000 CHARLEVILLE MEZIERES",
    "email": "envergurereims@groupegca.com",
    "phone": "+33-3-24355656",
    "website": "https://partenaire.bmw.fr/envergure-charleville",
    "coords": {
      "lat": 49.73799133300781,
      "lng": 4.709466934204102
    }
  },
  {
    "id": "11470_1",
    "name": "CAR AVENUE NANCY",
    "country": "FR",
    "city": "MAXEVILLE",
    "address": "34 RUE HAROUN TAZIEFF, 54320 MAXEVILLE",
    "email": "bmwnancy@caravenue.com",
    "phone": "+33-3-83974000",
    "website": "https://partenaire.bmw.fr/caravenuenancy",
    "coords": {
      "lat": 48.707603454589844,
      "lng": 6.134881019592285
    }
  },
  {
    "id": "21125_2",
    "name": "PAUTRIC LORIENT",
    "country": "FR",
    "city": "LORIENT",
    "address": "1 RUE FRANCOIS TOULLEC, 56100 LORIENT",
    "email": "contact@latitude.net.bmw.fr",
    "phone": "+33-2-49883193",
    "website": "http://partenaire.bmw.fr/latitude-automobiles-lorient",
    "coords": {
      "lat": 47.73520278930664,
      "lng": -3.375056028366089
    }
  },
  {
    "id": "28419_1",
    "name": "GARAGE RAYMOND MARMANDE",
    "country": "FR",
    "city": "MARMANDE",
    "address": "52 avenue Jean Jaures, 47200 MARMANDE",
    "email": "fabien.raymond@raymond.net.bmw.fr",
    "phone": "+33-5-53640759",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28419",
    "coords": {
      "lat": 44.50419616699219,
      "lng": 0.1535249948501587
    }
  },
  {
    "id": "27950_1",
    "name": "VALMOTORS VALENCIENNES",
    "country": "FR",
    "city": "VALENCIENNES / PETITE FORET",
    "address": "310 RUE ETIENNE LENOIR, 59494 VALENCIENNES / PETITE FORET",
    "email": "contact@valmotors.net.bmw.fr",
    "phone": "+33-3-27410100",
    "website": "http://partenaire.bmw.fr/valmotors",
    "coords": {
      "lat": 50.38045883178711,
      "lng": 3.4789481163024902
    }
  },
  {
    "id": "40353_1",
    "name": "BYMYCAR CHENNEVIERES",
    "country": "FR",
    "city": "CHENNEVIERES SUR MARNE",
    "address": "2 RUE LAVOISIER, 94430 CHENNEVIERES SUR MARNE",
    "email": "lead.idf@bymycar.fr",
    "phone": "+33-1-49620330",
    "website": "http://partenaire.bmw.fr/bymycarbac",
    "coords": {
      "lat": 48.79649353027344,
      "lng": 2.547314405441284
    }
  },
  {
    "id": "40611_1",
    "name": "CAR PREMIUM ARRAS BEAURAINS",
    "country": "FR",
    "city": "BEAURAINS",
    "address": "RD 60, 62217 BEAURAINS",
    "email": "arras@car-premium.net.bmw.fr",
    "phone": "+33-3-21163080",
    "website": "http://partenaire.bmw.fr/car-premium-beaurains",
    "coords": {
      "lat": 50.26801681518555,
      "lng": 2.7988100051879883
    }
  },
  {
    "id": "39653_1",
    "name": "EDENAUTO BRIVE",
    "country": "FR",
    "city": "BRIVE LA GAILLARDE",
    "address": "7 - 9 AVENUE CYPRIEN FAURIE, 19100 BRIVE LA GAILLARDE",
    "email": "edenautopremium.brive.contact@edenauto.com",
    "phone": "+33-5-55222222",
    "website": "https://bmw-brive-la-gaillarde.edenauto.com",
    "coords": {
      "lat": 45.14988708496094,
      "lng": 1.4818660020828247
    }
  },
  {
    "id": "39653_2",
    "name": "EDENAUTO PREMIUM LIMOGES",
    "country": "FR",
    "city": "LIMOGES",
    "address": "27 AVENUE DES CAMBUSES, 87280 LIMOGES",
    "email": "edenautopremium.limoges.contact@edenauto.com",
    "phone": "+33-5-55304270",
    "website": "https://bmw-limoges.edenauto.com",
    "coords": {
      "lat": 45.88935470581055,
      "lng": 1.2714639902114868
    }
  },
  {
    "id": "46692_1",
    "name": "EVOLUTION AUTOMOBILE CARBONNE",
    "country": "FR",
    "city": "CARBONNE",
    "address": "1056 AVENUE DU VOLVESTRE, 31390 CARBONNE",
    "email": "alain.cave@evolution.net.bmw.fr",
    "phone": "+33-5-61871010",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/46692",
    "coords": {
      "lat": 43.315860748291016,
      "lng": 1.2095760107040405
    }
  },
  {
    "id": "41829_1",
    "name": "BYmyCAR PARIS 12",
    "country": "FR",
    "city": "PARIS",
    "address": "101 AVENUE DU GENERAL MICHEL BIZOT, 75012 PARIS",
    "email": "lead.idf@bymycar.fr",
    "phone": "+33-1-40359292",
    "website": "http://partenaire.bmw.fr/bymycar-rivoli",
    "coords": {
      "lat": 48.839141845703125,
      "lng": 2.403870105743408
    }
  },
  {
    "id": "32870_3",
    "name": "SELLENS MARSEILLE (SERVICE)",
    "country": "FR",
    "city": "MARSEILLE",
    "address": "516-522 CHEMIN DU LITTORAL, 13016 MARSEILLE",
    "email": "Marion.francois@station7.net.bmw.fr",
    "phone": "+33-4-84919170",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/40540",
    "coords": {
      "lat": 43.35242462158203,
      "lng": 5.3389058113098145
    }
  },
  {
    "id": "30288_1",
    "name": "CAR AVENUE TROYES",
    "country": "FR",
    "city": "ROSIERES-PRES-TROYES",
    "address": "14 CHEMIN DU CURE, 10430 ROSIERES-PRES-TROYES",
    "email": "bmwtroyes@caravenue.com",
    "phone": "+33-3-25820376",
    "website": "https://troyes.bmwcaravenue.fr/",
    "coords": {
      "lat": 48.267799377441406,
      "lng": 4.05258321762085
    }
  },
  {
    "id": "04847_2",
    "name": "INDIGO JUVISY SUR ORGE",
    "country": "FR",
    "city": "JUVISY SUR ORGE",
    "address": "1 AVENUE DE LA COUR DE FRANCE, 91260 JUVISY SUR ORGE",
    "email": "contact@indigo.net.bmw.fr",
    "phone": "+33-1-69244747",
    "website": "https://bmw-indigo.fr/",
    "coords": {
      "lat": 48.68783187866211,
      "lng": 2.371567964553833
    }
  },
  {
    "id": "04909_1",
    "name": "INDIGO LES ULIS",
    "country": "FR",
    "city": "VILLEBON SUR YVETTE",
    "address": "8 AVENUE DU QUEBEC, 91140 VILLEBON SUR YVETTE",
    "email": "contact@indigo.net.bmw.fr",
    "phone": "+33-1-69078484",
    "website": "https://bmw-indigo.fr/",
    "coords": {
      "lat": 48.68791198730469,
      "lng": 2.2080209255218506
    }
  },
  {
    "id": "04977_1",
    "name": "ENVERGURE CAEN",
    "country": "FR",
    "city": "MONDEVILLE",
    "address": "ROUTE DE PARIS, 14120 MONDEVILLE",
    "email": "marketing@normandy.net.bmw.fr",
    "phone": "+33-2-31351535",
    "website": "https://www.groupegca.com/concession/bmw-caen",
    "coords": {
      "lat": 49.168399810791016,
      "lng": -0.3170259892940521
    }
  },
  {
    "id": "04911_1",
    "name": "CAR AVENUE DIJON",
    "country": "FR",
    "city": "CHENOVE CEDEX",
    "address": "18 RUE ANTOINE BECQUEREL, 21301 CHENOVE CEDEX",
    "email": "bmwdijon@caravenue.com",
    "phone": "+33-3-80540707",
    "website": "https://dijon.bmwcaravenue.fr/",
    "coords": {
      "lat": 47.290836334228516,
      "lng": 5.023836135864258
    }
  },
  {
    "id": "04923_1",
    "name": "SAS BERNARDINI AJACCIO",
    "country": "FR",
    "city": "AJACCIO CEDEX 5",
    "address": "ROUTE DE MEZZAVIA, 20503 AJACCIO CEDEX 5",
    "email": "contact@bernardini.net.bmw.fr",
    "phone": "+33-4-95700707",
    "website": "http://partenaire.bmw.fr/bernardini-ajaccio",
    "coords": {
      "lat": 41.94961929321289,
      "lng": 8.768068313598633
    }
  },
  {
    "id": "05404_1",
    "name": "BYMYCAR NOISY NOISY LE SEC",
    "country": "FR",
    "city": "NOISY LE SEC",
    "address": "30, RUE DE PARIS, 93130 NOISY LE SEC",
    "email": "lead.idf@bymycar.fr",
    "phone": "+33-1-85532476",
    "website": "http://partenaire.bmw.fr/bymycarnoisy",
    "coords": {
      "lat": 48.89853286743164,
      "lng": 2.4445910453796387
    }
  },
  {
    "id": "05438_1",
    "name": "GUEUDET 1880 SAINT MERRI COMPIEGNE",
    "country": "FR",
    "city": "COMPIEGNE",
    "address": "1 RUE HENRI ADNOT, 60200 COMPIEGNE",
    "email": "contact-saintmerri@gueudet.fr",
    "phone": "+33-3-44364000",
    "website": "http://partenaire.bmw.fr/saint-merri-compiegne",
    "coords": {
      "lat": 49.388427734375,
      "lng": 2.787353992462158
    }
  },
  {
    "id": "05417_3",
    "name": "HORIZON NORMANDIE DIEPPE",
    "country": "FR",
    "city": "DIEPPE",
    "address": "200 AVENUE NORMANDIE SUSSEX, 76200 DIEPPE",
    "email": "dieppe@horizon.fr",
    "phone": "+33-2-35402873",
    "website": "https://www.horizon.fr",
    "coords": {
      "lat": 49.91823196411133,
      "lng": 1.0878349542617798
    }
  },
  {
    "id": "04923_2",
    "name": "SAS BERNARDINI ET FILS BASTIA",
    "country": "FR",
    "city": "FURIANI",
    "address": "1653 AVENUE SAMPIERO, 20600 FURIANI",
    "email": "contact@bernardini.net.bmw.fr",
    "phone": "+33-4-95700707",
    "website": "http://partenaire.bmw.fr/bernardini-bastia",
    "coords": {
      "lat": 42.65043640136719,
      "lng": 9.440290451049805
    }
  },
  {
    "id": "05529_1",
    "name": "ENVERGURE MEAUX",
    "country": "FR",
    "city": "MAREUIL LES MEAUX",
    "address": "840 COTE DE LA JUSTICE, 77100 MAREUIL LES MEAUX",
    "email": "contact.bmwmeaux@groupegca.com",
    "phone": "+33-1-60093535",
    "website": "https://partenaire.bmw.fr/envergure-meaux/accueil",
    "coords": {
      "lat": 48.93418884277344,
      "lng": 2.8797619342803955
    }
  },
  {
    "id": "05537_1",
    "name": "PAUTRIC BOURGOIN JALLIEU",
    "country": "FR",
    "city": "BOURGOIN JALLIEU",
    "address": "53 RUE ISAAC ASIMOV, 38300 BOURGOIN JALLIEU",
    "email": "marketingbourgoin@6avenue.net.bmw.fr",
    "phone": "+33-4-74432873",
    "website": "http://www.6avenue-bourgoin.fr",
    "coords": {
      "lat": 45.5920295715332,
      "lng": 5.249380111694336
    }
  },
  {
    "id": "05478_3",
    "name": "ENVERGURE NIORT",
    "country": "FR",
    "city": "NIORT",
    "address": "600 AVENUE DE PARIS, 79000 NIORT",
    "email": "web.bmw@juillet-automobiles.fr",
    "phone": "+33-5-49330146",
    "website": "http://partenaire.bmw.fr/garage-juillet",
    "coords": {
      "lat": 46.339542388916016,
      "lng": -0.40400099754333496
    }
  },
  {
    "id": "05438_2",
    "name": "GUEUDET 1880 SAINT MERRI BEAUVAIS",
    "country": "FR",
    "city": "BEAUVAIS",
    "address": "6 RUE PIERRE ET MARIE CURIE, 60000 BEAUVAIS",
    "email": "contact-saintmerri@gueudet.fr",
    "phone": "+33-3-44051525",
    "website": "http://partenaire.bmw.fr/saint-merri-beauvais",
    "coords": {
      "lat": 49.414512634277344,
      "lng": 2.113257884979248
    }
  },
  {
    "id": "11380_1",
    "name": "ENVERGURE REIMS",
    "country": "FR",
    "city": "REIMS",
    "address": "3, 5 ET 7 RUE LENA BERNSTEIN, 51100 REIMS",
    "email": "envergurereims@groupegca.com",
    "phone": "+33-3-26086368",
    "website": "https://partenaire.bmw.fr/envergure-reims",
    "coords": {
      "lat": 49.237308502197266,
      "lng": 4.082376956939697
    }
  },
  {
    "id": "21903_2",
    "name": "PAUTRIC ST MALO",
    "country": "FR",
    "city": "SAINT MALO",
    "address": "ZAC DE LA MAISON-NEUVE, 35400 SAINT MALO",
    "email": "suivi-contact@huchet.net.bmw.fr",
    "phone": "+33-2-99823545",
    "website": "https://huchet-saintmalo.com/",
    "coords": {
      "lat": 48.62591552734375,
      "lng": -1.9873449802398682
    }
  },
  {
    "id": "23306_1",
    "name": "BMS EVREUX",
    "country": "FR",
    "city": "EVREUX",
    "address": "251 RUE RENE PANHARD, 27000 EVREUX",
    "email": "contact.evreux@groupebms.fr",
    "phone": "+33-2-32622550",
    "website": "https://www.groupebms.fr/concession/bms-evreux/",
    "coords": {
      "lat": 49.02297592163086,
      "lng": 1.1893529891967773
    }
  },
  {
    "id": "05541_1",
    "name": "CAR AVENUE METZ",
    "country": "FR",
    "city": "METZ CEDEX 3",
    "address": "92 BIS BOULEVARD SOLIDARITE, 57075 METZ CEDEX 3",
    "email": "bmwmetz@caravenue.com",
    "phone": "+33-3-87604240",
    "website": "https://partenaire.bmw.fr/caravenue-metz",
    "coords": {
      "lat": 49.10523986816406,
      "lng": 6.234516143798828
    }
  },
  {
    "id": "11380_2",
    "name": "ENVERGURE CHALONS EN CHAMPAGNE",
    "country": "FR",
    "city": "SAINT-MEMMIE",
    "address": "1, AVENUE MARC HAMET, 51470 SAINT-MEMMIE",
    "email": "envergurereims@groupegca.com",
    "phone": "+33-3-26694646",
    "website": "https://www.groupegca.com/concession/bmw-chalons-en-champagne",
    "coords": {
      "lat": 48.949039459228516,
      "lng": 4.392970085144043
    }
  },
  {
    "id": "08118_1",
    "name": "PAUTRIC LYON CENTRE",
    "country": "FR",
    "city": "LYON",
    "address": "82, BD  VIVIER  MERLE, 69003 LYON",
    "email": "experience.clientbmwlyonsud@emeraudes.net.bmw.fr",
    "phone": "+33-4-78635566",
    "website": "http://www.6avenue.fr",
    "coords": {
      "lat": 45.754756927490234,
      "lng": 4.858987808227539
    }
  },
  {
    "id": "20427_4",
    "name": "EDENAUTO PREMIUM NARBONNE",
    "country": "FR",
    "city": "NARBONNE",
    "address": "CHEMIN DE SAINT CRESCENT, 11100 NARBONNE",
    "email": "contact.bnc@eden-auto.com",
    "phone": "+33-4-68581414",
    "website": "https://bmw-narbonne.edenauto.com",
    "coords": {
      "lat": 43.1729621887207,
      "lng": 2.9924240112304688
    }
  },
  {
    "id": "48713_1",
    "name": "CAR AVENUE THIONVILLE",
    "country": "FR",
    "city": "TERVILLE",
    "address": "RUE JEAN-PIERRE BELTOISE, 57180 TERVILLE",
    "email": "bmwterville@caravenue.com",
    "phone": "+33-3-82885883",
    "website": "https://partenaire.bmw.fr/caravenue-terville",
    "coords": {
      "lat": 49.35014343261719,
      "lng": 6.145945072174072
    }
  },
  {
    "id": "26366_6",
    "name": "HORIZON ST OUEN L'AUMONE",
    "country": "FR",
    "city": "SAINT OUEN L'AUMONE",
    "address": "15 RUE LOUIS DELAGE, 95310 SAINT OUEN L'AUMONE",
    "email": "saintouenlaumone@minihorizon.com",
    "phone": "+33-1-34354747",
    "website": "https://www.horizon.fr",
    "coords": {
      "lat": 49.033416748046875,
      "lng": 2.117173910140991
    }
  },
  {
    "id": "28777_3",
    "name": "ALTITUDE 42 ROANNE",
    "country": "FR",
    "city": "LE COTEAU CEDEX",
    "address": "36, BD CHARLES DE GAULLE, 42124 LE COTEAU CEDEX",
    "email": "altitude42-bmw@groupe-altitude.com",
    "phone": "+33-4-77704222",
    "website": "http://partenaire.bmw.fr/altitude42",
    "coords": {
      "lat": 46.01428985595703,
      "lng": 4.096360206604004
    }
  },
  {
    "id": "35846_1",
    "name": "GUEUDET 1880 SAINT MERRI AMIENS",
    "country": "FR",
    "city": "RIVERY",
    "address": "1 BIS AVENUE DE LA DEFENSE PASSIVE, 80136 RIVERY",
    "email": "contact-saintmerri@gueudet.fr",
    "phone": "+33-3-22337744",
    "website": "http://partenaire.bmw.fr/saint-merri-amiens",
    "coords": {
      "lat": 49.91130447387695,
      "lng": 2.3344709873199463
    }
  },
  {
    "id": "39327_1",
    "name": "ALTITUDE 69 VILLEFRANCHE VILLEFRANCHE SUR SAONE",
    "country": "FR",
    "city": "VILLEFRANCHE SUR SAONE CEDEX",
    "address": "680 AVENUE DE L 'EUROPE, 69400 VILLEFRANCHE SUR SAONE CEDEX",
    "email": "altitudeVF69-bmw@groupe-altitude.com",
    "phone": "+33-4-74603060",
    "website": "https://www.groupe-altitude.com",
    "coords": {
      "lat": 45.990150451660156,
      "lng": 4.742981433868408
    }
  },
  {
    "id": "48714_1",
    "name": "CAR AVENUE FORBACH",
    "country": "FR",
    "city": "FORBACH",
    "address": "327 ROUTE NATIONALE, 57600 FORBACH",
    "email": "bmwforbach@caravenue.com",
    "phone": "+33-3-87888600",
    "website": "https://partenaire.bmw.fr/caravenue-forbach",
    "coords": {
      "lat": 49.175758361816406,
      "lng": 6.879691123962402
    }
  },
  {
    "id": "05418_1",
    "name": "GROUPE AUTOSPHERE POITIERS",
    "country": "FR",
    "city": "POITIERS CEDEX 9",
    "address": "155 AV DU 8 MAI 1945, 86062 POITIERS CEDEX 9",
    "email": "contact@futurauto.net.bmw.fr",
    "phone": "+33-5-49540404",
    "website": "https://www.bmw-futurauto-poitiers.fr/",
    "coords": {
      "lat": 46.552127838134766,
      "lng": 0.3057819902896881
    }
  },
  {
    "id": "04951_2",
    "name": "GROUPE AUTOSPHERE DAX",
    "country": "FR",
    "city": "MEES",
    "address": "Z.A. DU STANQUET, 40990 MEES",
    "email": "contact@bayern-lpb.net.bmw.fr",
    "phone": "+33-5-58911717",
    "website": "https://www.bmw-bayern-dax.fr/",
    "coords": {
      "lat": 43.71683120727539,
      "lng": -1.132091999053955
    }
  },
  {
    "id": "04878_1",
    "name": "CHARRIER CHOLET",
    "country": "FR",
    "city": "CHOLET CEDEX",
    "address": "53, RUE DE LA JOMINIERE, 49302 CHOLET CEDEX",
    "email": "leads.bmw@charrier.net.bmw.fr",
    "phone": "+33-2-41710584",
    "website": "http://partenaire.bmw.fr/charrier",
    "coords": {
      "lat": 47.073246002197266,
      "lng": -0.8684682250022888
    }
  },
  {
    "id": "04910_1",
    "name": "HELI-DRIVE CLERMONT FERRAND",
    "country": "FR",
    "city": "AUBIERE",
    "address": "RUE JACQUELINE AURIOL, 63170 AUBIERE",
    "email": "contact@heli-drive.net.bmw.fr",
    "phone": "+33-4-73152929",
    "website": "https://partenaire.bmw.fr/heli-drive",
    "coords": {
      "lat": 45.751468658447266,
      "lng": 3.138045072555542
    }
  },
  {
    "id": "04988_3",
    "name": "AMPLITUDE AUTOMOBILES BLOIS",
    "country": "FR",
    "city": "BLOIS CEDEX",
    "address": "5 RUE DE L'AZIN, 41018 BLOIS CEDEX",
    "email": "contactblois@amplitude.net.bmw.fr",
    "phone": "+33-2-54504040",
    "website": "http://partenaire.bmw.fr/amplitude-automobiles-blois",
    "coords": {
      "lat": 47.61292266845703,
      "lng": 1.3308039903640747
    }
  },
  {
    "id": "04988_1",
    "name": "AMPLITUDE AUTOMOBILES TOURS",
    "country": "FR",
    "city": "CHAMBRAY LES TOURS",
    "address": "7 RUE BENJAMIN FRANKLIN, 37170 CHAMBRAY LES TOURS",
    "email": "contacttours@amplitude.net.bmw.fr",
    "phone": "+33-2-47272121",
    "website": "http://partenaire.bmw.fr/amplitude-automobiles-tours",
    "coords": {
      "lat": 47.33086013793945,
      "lng": 0.7017253041267395
    }
  },
  {
    "id": "05424_1",
    "name": "BAVARIA MOTORS TOULON EST",
    "country": "FR",
    "city": "LA GARDE",
    "address": "ZAC DES QUATRE CHEMINS, 83130 LA GARDE",
    "email": "contact@bavaria.net.bmw.fr",
    "phone": "+33-4-94080960",
    "website": "http://partenaire.bmw.fr/bavaria-motors-lagarde",
    "coords": {
      "lat": 43.136749267578125,
      "lng": 6.026120185852051
    }
  },
  {
    "id": "05546_1",
    "name": "DUPONT ORLEANS",
    "country": "FR",
    "city": "ORLEANS CEDEX 2",
    "address": "RN 20 - EXPO SUD - 2 BIS RUE TABART, 45081 ORLEANS CEDEX 2",
    "email": "contact2@dupont.net.bmw.fr",
    "phone": "+33-2-38227171",
    "website": "https://partenaire.bmw.fr/dupontsa",
    "coords": {
      "lat": 47.8766975402832,
      "lng": 1.9128750562667847
    }
  },
  {
    "id": "40418_2",
    "name": "STORE MONACO",
    "country": "FR",
    "city": "MONACO",
    "address": "2 AVENUE DE ROQUEVILLE, 98000 MONACO",
    "email": "sav@bmw.mc",
    "phone": "+377-97978980",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/40419",
    "coords": {
      "lat": 43.739105224609375,
      "lng": 7.422962188720703
    }
  },
  {
    "id": "50230_1",
    "name": "MONT D'AREU SALLANCHES",
    "country": "FR",
    "city": "DOMANCY",
    "address": "2701 ROUTE DE FAYET, 74700 DOMANCY",
    "email": "aravis@rossi-automobile.com",
    "phone": "+33-4-50585349",
    "website": "https://partenaire.bmw.fr/aravis-automobiles-sallanches/",
    "coords": {
      "lat": 45.904239654541016,
      "lng": 6.691160202026367
    }
  },
  {
    "id": "04867_1",
    "name": "GARAGE THIREAU GARAGE THIREAU CHARTRES",
    "country": "FR",
    "city": "NOGENT-LE-PHAYE",
    "address": "14 RUE GILLES DE ROBERVAL, 28630 NOGENT-LE-PHAYE",
    "email": "service.commercial.thireau@groupe-berteaux.fr",
    "phone": "+33-2-37880880",
    "website": "https://partenaire.bmw.fr/chartres",
    "coords": {
      "lat": 48.454689025878906,
      "lng": 1.5459959506988525
    }
  },
  {
    "id": "05481_1",
    "name": "ESPACE BERTEAUX DREUX",
    "country": "FR",
    "city": "VERNOUILLET",
    "address": "7 BOULEVARD DE L'EUROPE, 28500 VERNOUILLET",
    "email": "espace.berteaux@groupe-berteaux.fr",
    "phone": "+33-2-37389420",
    "website": "http://partenaire.bmw.fr/espace-berteaux",
    "coords": {
      "lat": 48.71989440917969,
      "lng": 1.3710490465164185
    }
  },
  {
    "id": "05500_1",
    "name": "NEUBAUER PLAISIR",
    "country": "FR",
    "city": "PLAISIR",
    "address": "141 RUE DES PECHERS, 78370 PLAISIR",
    "email": "contacts@neubauer.fr",
    "phone": "+33-1-30057090",
    "website": "https://www.neubauer-bmw.fr/concessionnaire/pajean-plaisir.html",
    "coords": {
      "lat": 48.80064392089844,
      "lng": 1.9507240056991577
    }
  },
  {
    "id": "06648_2",
    "name": "BAYERN BY AUTOSPHERE MARIGNANE",
    "country": "FR",
    "city": "MARIGNANE",
    "address": "CHEMIN DE CARTHAGE, 13700 MARIGNANE",
    "email": "info@bayern-aix.net.bmw.fr",
    "phone": "+33-4-42467000",
    "website": "http://www.bmw-bayern-marignane.fr/",
    "coords": {
      "lat": 43.42258071899414,
      "lng": 5.231151103973389
    }
  },
  {
    "id": "11450_1",
    "name": "GRAND SUD AUTO MARSEILLE (BMW)",
    "country": "FR",
    "city": "MARSEILLE",
    "address": "3 A 5 BOULEVARD RABATAU, 13008 MARSEILLE",
    "email": "contact@grand-sud.net.bmw.fr",
    "phone": "+33-4-91181515",
    "website": "http://partenaire.bmw.fr/grand-sud-auto",
    "coords": {
      "lat": 43.273521423339844,
      "lng": 5.392209053039551
    }
  },
  {
    "id": "25068_1",
    "name": "HESS AUTOMOBILE LONS LE SAUNIER",
    "country": "FR",
    "city": "LONS LE SAUNIER",
    "address": "40 RUE BLAISE PASCAL, 39000 LONS LE SAUNIER",
    "email": "serviceclient@hessautomobile.com",
    "phone": "+33-3-84470545",
    "website": "https://www.bmw-lons-le-saunier.fr",
    "coords": {
      "lat": 46.67212677001953,
      "lng": 5.576166152954102
    }
  },
  {
    "id": "04887_1",
    "name": "ISERAN AUTOMOBILES CHAMBERY",
    "country": "FR",
    "city": "CHAMBERY CEDEX",
    "address": "RUE ALEXANDER FLEMING, 73006 CHAMBERY CEDEX",
    "email": "iseran@rossi-automobile.com",
    "phone": "+33-4-79713535",
    "website": "https://partenaire.bmw.fr/iseran-automobiles",
    "coords": {
      "lat": 45.59859085083008,
      "lng": 5.893686771392822
    }
  },
  {
    "id": "04942_2",
    "name": "ESCAT ALBI",
    "country": "FR",
    "city": "ALBI",
    "address": "1 ROUTE DE CASTRES, 81000 ALBI",
    "email": "contactezmoi@groupe-grim.com",
    "phone": "+33-5-63456323",
    "website": "http://partenaire.bmw.fr/escat-albi",
    "coords": {
      "lat": 43.912261962890625,
      "lng": 2.142190933227539
    }
  },
  {
    "id": "27951_1",
    "name": "EQUATION TOULOUSE",
    "country": "FR",
    "city": "LABEGE",
    "address": "3006 LA LAURAGAISE, 31670 LABEGE",
    "email": "contact@equation.net.bmw.fr",
    "phone": "+33-5-62711111",
    "website": "http://partenaire.bmw.fr/equation-automobiles",
    "coords": {
      "lat": 43.547607421875,
      "lng": 1.5151159763336182
    }
  },
  {
    "id": "27951_5",
    "name": "EQUATION MONTAUBAN",
    "country": "FR",
    "city": "MONTAUBAN",
    "address": "1000 AVENUE DE L'EUROPE, 82000 MONTAUBAN",
    "email": "contact@equation.net.bmw.fr",
    "phone": "+33-5-63636363",
    "website": "http://partenaire.bmw.fr/equation-automobiles",
    "coords": {
      "lat": 43.99161148071289,
      "lng": 1.332021951675415
    }
  },
  {
    "id": "29302_1",
    "name": "HELI-MOTORS VICHY",
    "country": "FR",
    "city": "BELLERIVE SUR ALLIER",
    "address": "20 ROUTE DE CHARMEIL, 03700 BELLERIVE SUR ALLIER",
    "email": "contact@heli-motors.net.bmw.fr",
    "phone": "+33-4-70986580",
    "website": "http://partenaire.bmw.fr/heli-motors-vichy",
    "coords": {
      "lat": 46.145469665527344,
      "lng": 3.395780086517334
    }
  },
  {
    "id": "31359_4",
    "name": "PANEL AUXERRE",
    "country": "FR",
    "city": "AUXERRE",
    "address": "3 RUE LOUISE WEISS, 89000 AUXERRE",
    "email": "auxerre@panel.net.bmw.fr",
    "phone": "+33-3-86722272",
    "website": "https://partenaire.bmw.fr/panel-auxerre",
    "coords": {
      "lat": 47.81201934814453,
      "lng": 3.563023090362549
    }
  },
  {
    "id": "21901_1",
    "name": "NEUBAUER CHAMBOURCY",
    "country": "FR",
    "city": "CHAMBOURCY",
    "address": "31 ROUTE DE MANTES, 78240 CHAMBOURCY",
    "email": "contacts@neubauer.fr",
    "phone": "+33-1-85470287",
    "website": "https://www.neubauer-bmw.fr/concessionnaire/neubauer-chambourcy.html",
    "coords": {
      "lat": 48.905426025390625,
      "lng": 2.0498290061950684
    }
  },
  {
    "id": "23800_1",
    "name": "OUEST MOTORS SAINT BRIEUC",
    "country": "FR",
    "city": "TREGUEUX",
    "address": "30 AVENUE PIERRE MENDES FRANCE, 22950 TREGUEUX",
    "email": "contact@ouest-motors.fr",
    "phone": "+33-2-96525454",
    "website": "https://partenaire.bmw.fr/ouest-motors",
    "coords": {
      "lat": 48.4911994934082,
      "lng": -2.767859935760498
    }
  },
  {
    "id": "04986_4",
    "name": "ENVERGURE CHERBOURG",
    "country": "FR",
    "city": "TOURLAVILLE",
    "address": "70 rue Pierre Brossolette, 50110 TOURLAVILLE",
    "email": "contact@envergureauto.net.bmw.fr",
    "phone": "+33-2-33204478",
    "website": "http://partenaire.bmw.fr/envergure-auto-tourlaville",
    "coords": {
      "lat": 49.63456726074219,
      "lng": -1.592903971672058
    }
  },
  {
    "id": "05409_1",
    "name": "CAR AVENUE EPINAL",
    "country": "FR",
    "city": "CHAVELOT",
    "address": "RUE NICOLAS BARRY, 88150 CHAVELOT",
    "email": "bmwepinal@caravenue.com",
    "phone": "+33-3-29313534",
    "website": "https://partenaire.bmw.fr/caravenueepinal",
    "coords": {
      "lat": 48.2160758972168,
      "lng": 6.437694072723389
    }
  },
  {
    "id": "05478_1",
    "name": "ENVERGURE LA ROCHE SUR YON",
    "country": "FR",
    "city": "MOUILLERON LE CAPTIF",
    "address": "80 RUE DE LA CROISEE, 85000 MOUILLERON LE CAPTIF",
    "email": "web@napoleon.net.bmw.fr",
    "phone": "+33-2-51373627",
    "website": "http://partenaire.bmw.fr/nasa",
    "coords": {
      "lat": 46.72246170043945,
      "lng": -1.4282710552215576
    }
  },
  {
    "id": "05534_2",
    "name": "L'ESPACE BIENVENUE ROCHEFORT",
    "country": "FR",
    "city": "ROCHEFORT",
    "address": "VERGEROUX NORD, 17300 ROCHEFORT",
    "email": "contact.rochefort@bienvenue.net.bmw.fr",
    "phone": "+33-5-46991613",
    "website": "http://partenaire.bmw.fr/espace-bienvenue-rochefort",
    "coords": {
      "lat": 45.96648406982422,
      "lng": -0.9822890162467957
    }
  },
  {
    "id": "20427_1",
    "name": "EDENAUTO PREMIUM BEZIERS",
    "country": "FR",
    "city": "BEZIERS CEDEX",
    "address": "ZAC DE MONTIMARAN, 34504 BEZIERS CEDEX",
    "email": "contact.bnc@eden-auto.com",
    "phone": "+33-4-67351033",
    "website": "https://bmw-beziers.edenauto.com",
    "coords": {
      "lat": 43.345062255859375,
      "lng": 3.2563090324401855
    }
  },
  {
    "id": "28777_1",
    "name": "ALTITUDE 42 SAINT ETIENNE",
    "country": "FR",
    "city": "SAINT ETIENNE",
    "address": "42 RUE DOCTEURS H. ET B. MULLER, 42000 SAINT ETIENNE",
    "email": "altitude42-bmw@groupe-altitude.com",
    "phone": "+33-4-77250047",
    "website": "https://partenaire.bmw.fr/altitude42/accueil",
    "coords": {
      "lat": 45.44898223876953,
      "lng": 4.39890718460083
    }
  },
  {
    "id": "48714_3",
    "name": "CAR AVENUE SARREBOURG",
    "country": "FR",
    "city": "SARREBOURG",
    "address": "2 CHEMIN D'IMLING, 57400 SARREBOURG",
    "email": "bmwsarrebourg@caravenue.com",
    "phone": "+33-3-87032371",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/37403",
    "coords": {
      "lat": 48.72248840332031,
      "lng": 7.041309833526611
    }
  },
  {
    "id": "04847_1",
    "name": "INDIGO LISSES",
    "country": "FR",
    "city": "LISSES",
    "address": "2 ROUTE DE VILLABE - D260, 91090 LISSES",
    "email": "contact@indigo.net.bmw.fr",
    "phone": "+33-1-69877070",
    "website": "https://bmw-indigo.fr/",
    "coords": {
      "lat": 48.60087203979492,
      "lng": 2.4409289360046387
    }
  },
  {
    "id": "05402_1",
    "name": "PAUTRIC NANTES",
    "country": "FR",
    "city": "SAINT HERBLAIN",
    "address": "PORTE DE SAUTRON, 44800 SAINT HERBLAIN",
    "email": "informations@pays-loire.net.bmw.fr",
    "phone": "+33-2-40169430",
    "website": "http://www.pays-de-loire-automobiles.com",
    "coords": {
      "lat": 47.24959182739258,
      "lng": -1.6193020343780518
    }
  },
  {
    "id": "04956_1",
    "name": "EDENAUTO PREMIUM PERIGUEUX",
    "country": "FR",
    "city": "TRELISSAC",
    "address": "21 AVENUE DE L'AUTOMOBILE, 24750 TRELISSAC",
    "email": "bmw.perigueux.vn@edenauto.com",
    "phone": "+33-5-53454400",
    "website": "https://bmw-perigueux.edenauto.com/",
    "coords": {
      "lat": 45.19865417480469,
      "lng": 0.7922379970550537
    }
  },
  {
    "id": "05403_1",
    "name": "ALTITUDE 71 MACON",
    "country": "FR",
    "city": "SANCE",
    "address": "16 RUE DE LA MADONE, 71000 SANCE",
    "email": "altitude71-bmw@groupe-altitude.com",
    "phone": "+33-3-85384605",
    "website": "http://partenaire.bmw.fr/altitude71",
    "coords": {
      "lat": 46.3350715637207,
      "lng": 4.844203948974609
    }
  },
  {
    "id": "04977_2",
    "name": "ENVERGURE DEAUVILLE",
    "country": "FR",
    "city": "SAINT ARNOULT",
    "address": "PLACE ANDRE CHOTARD, 14820 SAINT ARNOULT",
    "email": "garance.mace@normandy.net.bmw.fr",
    "phone": "+33-2-31145100",
    "website": "https://www.groupegca.com/concession/bmw-caen",
    "coords": {
      "lat": 49.3374137878418,
      "lng": 0.09152799844741821
    }
  },
  {
    "id": "05478_4",
    "name": "ENVERGURE CHALLANS",
    "country": "FR",
    "city": "CHALLANS",
    "address": "8 SQUARE VASCO DE GAMA, 85300 CHALLANS",
    "email": "web@napoleon.net.bmw.fr",
    "phone": "+33-2-51370364",
    "website": "http://partenaire.bmw.fr/nasa",
    "coords": {
      "lat": 46.85227584838867,
      "lng": -1.844614028930664
    }
  },
  {
    "id": "05488_1",
    "name": "ENVERGURE ALENCON",
    "country": "FR",
    "city": "VALFRAMBERT",
    "address": "1 IMPASSE JOAN MIRO, 61250 VALFRAMBERT",
    "email": "envergure.alencon@groupegca.com",
    "phone": "+33-2-33288000",
    "website": "https://www.groupegca.com/concession/bmw-alencon",
    "coords": {
      "lat": 48.45443344116211,
      "lng": 0.11909899860620499
    }
  },
  {
    "id": "05526_1",
    "name": "PAUTRIC BOURG EN BRESSE",
    "country": "FR",
    "city": "VIRIAT",
    "address": "40, RUE GAY LUSSAC, 01440 VIRIAT",
    "email": "service.commercial@bresse.net.bmw.fr",
    "phone": "+33-4-74226255",
    "website": "https://www.bresse-motosport.fr/",
    "coords": {
      "lat": 46.219947814941406,
      "lng": 5.210657119750977
    }
  },
  {
    "id": "05544_1",
    "name": "ALTITUDE 38 VIENNE",
    "country": "FR",
    "city": "VIENNE",
    "address": "ZONE INDUSTRIELLE DE SEYSSUEL, 38200 VIENNE",
    "email": "altitude38-bmw@groupe-altitude.com",
    "phone": "+33-4-74858483",
    "website": "http://partenaire.bmw.fr/altitude38",
    "coords": {
      "lat": 45.5511474609375,
      "lng": 4.832693099975586
    }
  },
  {
    "id": "05549_3",
    "name": "FOCH AUTOMOBILES AVIGNON",
    "country": "FR",
    "city": "AVIGNON",
    "address": "125, AVENUE CHARLES VALENTE, 84000 AVIGNON",
    "email": "bmw@foch.net.bmw.fr",
    "phone": "+33-4-90036060",
    "website": "http://partenaire.bmw.fr/foch-automobiles",
    "coords": {
      "lat": 43.91896438598633,
      "lng": 4.87641716003418
    }
  },
  {
    "id": "05549_4",
    "name": "FOCH AUTOMOBILES ORANGE",
    "country": "FR",
    "city": "ORANGE",
    "address": "RUE GRENACHE, 84100 ORANGE",
    "email": "contact@foch.net.bmw.fr",
    "phone": "+33-4-90118490",
    "website": "https://www.foch-automobiles.fr",
    "coords": {
      "lat": 44.1129264831543,
      "lng": 4.8445329666137695
    }
  },
  {
    "id": "28695_1",
    "name": "SARL GARAGE FAVOLINI BALARUC LES BAINS",
    "country": "FR",
    "city": "BALARUC-LES-BAINS",
    "address": "Z.A.M. DU BASSIN DE THAU, 34450 BALARUC-LES-BAINS",
    "email": "garagefavolini@gmail.com",
    "phone": "+33-4-67482828",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28695",
    "coords": {
      "lat": 43.44156265258789,
      "lng": 3.6983370780944824
    }
  },
  {
    "id": "28075_1",
    "name": "ALAIN VERNE MEYZIEU",
    "country": "FR",
    "city": "MEYZIEU",
    "address": "20 BOULEVARD AMBROISE PARE, 69330 MEYZIEU",
    "email": "luc.martin@verne.net.bmw.fr",
    "phone": "+33-4-78490742",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28075",
    "coords": {
      "lat": 45.77055358886719,
      "lng": 4.988012790679932
    }
  },
  {
    "id": "32337_6",
    "name": "BAYERN AUTO SPORT BOULOGNE SUR MER",
    "country": "FR",
    "city": "SAINT LEONARD",
    "address": "BOULEVARD DE LA LIANE, 62360 SAINT LEONARD",
    "email": "bmwboulogne@groupe-lempereur.com",
    "phone": "+33-3-21809515",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/40619",
    "coords": {
      "lat": 50.687381744384766,
      "lng": 1.6241689920425415
    }
  },
  {
    "id": "36273_4",
    "name": "ALTITUDE 69 LYON LIMONEST",
    "country": "FR",
    "city": "LIMONEST",
    "address": "170 RUE DE L'ETANG - RN6, 69760 LIMONEST",
    "email": "altitudeLY69-bmw@groupe-altitude.com",
    "phone": "+33-4-72538888",
    "website": "https://www.groupe-altitude.com",
    "coords": {
      "lat": 45.80878448486328,
      "lng": 4.778801918029785
    }
  },
  {
    "id": "22321_1",
    "name": "CH. POZZI",
    "country": "FR",
    "city": "PARIS",
    "address": "12, PLACE DU GENERAL KOENIG, 75017 PARIS",
    "email": "paris@charlespozzi.fr",
    "phone": "+33-1-47454747",
    "website": "https://www.horizon.fr",
    "coords": {
      "lat": 48.881649017333984,
      "lng": 2.284036159515381
    }
  },
  {
    "id": "22321_2",
    "name": "CH. POZZI",
    "country": "FR",
    "city": "LEVALLOIS-PERRET",
    "address": "40 RUE ARISTIDE BRIAND, 92300 LEVALLOIS-PERRET",
    "email": "paris@charlespozzi.fr",
    "phone": "+33-1-55373210",
    "website": "https://www.horizon.fr",
    "coords": {
      "lat": 48.89076232910156,
      "lng": 2.2847321033477783
    }
  },
  {
    "id": "28420_1",
    "name": "RABAUTE AUTOMOBILES LAVELANET",
    "country": "FR",
    "city": "VILLENEUVE D'OLMES",
    "address": "LES CHAUBETS, 09300 VILLENEUVE D'OLMES",
    "email": "bmw-mini.lavelanet09@rabaute.net.bmw.fr",
    "phone": "+33-5-61010724",
    "website": "http://fr.bmw.com/SIFE/BMW/dealer/28420",
    "coords": {
      "lat": 42.920413970947266,
      "lng": 1.832497000694275
    }
  },
  {
    "id": "30289_1",
    "name": "EDENAUTO PREMIUM AGEN",
    "country": "FR",
    "city": "BOE",
    "address": "Z.A.C. LAMOTHE MAGNAC, 47550 BOE",
    "email": "bmw.agen.vn@edenauto.com",
    "phone": "+33-5-53962955",
    "website": "https://bmw-agen.edenauto.com/",
    "coords": {
      "lat": 44.176849365234375,
      "lng": 0.6304259896278381
    }
  },
  {
    "id": "32337_2",
    "name": "BAYERN AUTO SPORT DUNKERQUE",
    "country": "FR",
    "city": "COUDEKERQUE BRANCHE",
    "address": "48 BIS, ROUTE DE BERGUES, 59412 COUDEKERQUE BRANCHE",
    "email": "bmwdunkerque@groupe-lempereur.com",
    "phone": "+33-3-28587000",
    "website": "https://www.groupe-lempereur.com/content/689-bmw-vehicule-neuf",
    "coords": {
      "lat": 51.00741958618164,
      "lng": 2.380866050720215
    }
  },
  {
    "id": "32484_1",
    "name": "ENVERGURE ANGERS",
    "country": "FR",
    "city": "BEAUCOUZE",
    "address": "8 RUE AMEDEE GORDINI, 49070 BEAUCOUZE",
    "email": "envergure.angers@groupegca.com",
    "phone": "+33-2-41318520",
    "website": "https://www.groupegca.com/concession/bmw-angers",
    "coords": {
      "lat": 47.472015380859375,
      "lng": -0.6176049709320068
    }
  },
  {
    "id": "36273_1",
    "name": "ALTITUDE 69 LYON",
    "country": "FR",
    "city": "LYON",
    "address": "6 RUE JOANNES CARRET, 69009 LYON",
    "email": "altitudely69-bmw@groupe-altitude.com",
    "phone": "+33-4-72538888",
    "website": "https://www.groupe-altitude.com/",
    "coords": {
      "lat": 45.78496170043945,
      "lng": 4.808730125427246
    }
  },
  {
    "id": "40184_1",
    "name": "LOUYET CANNES",
    "country": "FR",
    "city": "MOUGINS",
    "address": "470 BIS AVENUE DE SAINT MARTIN, 06250 MOUGINS",
    "email": "contact@bayern-cannes.net.bmw.fr",
    "phone": "+33-4-93948620",
    "website": "http://www.bayern-avenue.fr/",
    "coords": {
      "lat": 43.60830307006836,
      "lng": 6.9843549728393555
    }
  },
  {
    "id": "05579_3",
    "name": "M.CAR SPA",
    "country": "IT",
    "city": "POZZUOLI",
    "address": "Via Antiniana, 3, 80078 POZZUOLI",
    "email": "info@mcar.it",
    "phone": "+39-081-19936300",
    "website": "https://www.mcar.bmw.it",
    "coords": {
      "lat": 40.82831954956055,
      "lng": 14.15652847290039
    }
  },
  {
    "id": "02248_3",
    "name": "FIMAUTO SPA AUTOGEMELLI",
    "country": "IT",
    "city": "VICENZA",
    "address": "VIA DELL'ECONOMIA, 6, 36100 VICENZA",
    "email": "info@fimautogemelli.it",
    "phone": "+39-0444-960505",
    "website": "https://www.gruppofimauto.bmw.it",
    "coords": {
      "lat": 45.5255012512207,
      "lng": 11.514484405517578
    }
  },
  {
    "id": "05864_1",
    "name": "AutoVanti S.r.l.",
    "country": "IT",
    "city": "GRANAROLO DELL'EMILIA",
    "address": "Via del Lavoro, 10, 40057 GRANAROLO DELL'EMILIA",
    "email": "info@autovanti-bologna.it",
    "phone": "+39-051-6058411",
    "website": "http://www.vantigroup.bmw.it",
    "coords": {
      "lat": 44.528411865234375,
      "lng": 11.411659240722656
    }
  },
  {
    "id": "05579_2",
    "name": "M.CAR SPA",
    "country": "IT",
    "city": "Teverola",
    "address": "Strada Statale 7 Bis, km 10,600, 81030 Teverola",
    "email": "antonio.debernardo@mcar.conc-bmw.com",
    "phone": "+39-081-8911402",
    "website": "http://www.mcar.bmw.it",
    "coords": {
      "lat": 41.01577377319336,
      "lng": 14.220947265625
    }
  },
  {
    "id": "05864_6",
    "name": "AutoVanti S.r.l. AutoVanti Milano",
    "country": "IT",
    "city": "MILANO",
    "address": "VIALE DEL GHISALLO, 20, 20151 MILANO",
    "email": "info.milano@autovanti.it",
    "phone": "+39-02-82823300",
    "website": "http://www.autovantimilano.bmw.it",
    "coords": {
      "lat": 45.49661636352539,
      "lng": 9.12975025177002
    }
  },
  {
    "id": "06060_1",
    "name": "ROLANDI AUTO SPA",
    "country": "IT",
    "city": "ALESSANDRIA",
    "address": "Via Del Lavoro, 35, 15121 ALESSANDRIA",
    "email": "davide.rolandi@rolandiauto.conc-bmw.com",
    "phone": "+39-0131-347131",
    "website": "https://www.rolandiauto.bmw.it",
    "coords": {
      "lat": 44.88706970214844,
      "lng": 8.61410140991211
    }
  },
  {
    "id": "06204_4",
    "name": "ERREEFFE GROUP SPA MONSELICE MOTORI",
    "country": "IT",
    "city": "MONSELICE",
    "address": "VIALE LOMBARDIA, 15 (Z.I.), 35043 MONSELICE",
    "email": "info@erreeffegroup.it",
    "phone": "+39-0429-783388",
    "website": "https://www.erreeffegroup.bmw.it",
    "coords": {
      "lat": 45.215999603271484,
      "lng": 11.754765510559082
    }
  },
  {
    "id": "06224_4",
    "name": "AUTOABRUZZO SRL",
    "country": "IT",
    "city": "L'Aquila",
    "address": "LOC. BAZZANO - S.S. 17 KM 43,085, 67100 L'Aquila",
    "email": "andrea.dilena@autoabruzzo.conc-bmw.com",
    "phone": "+39-085-432511",
    "website": "https://www.bmw-motorrad.it/autoabruzzo-laquila/it/home.html",
    "coords": {
      "lat": 42.33232116699219,
      "lng": 13.475151062011719
    }
  },
  {
    "id": "21582_9",
    "name": "BMW ITALIA RETAIL SRL BMW ROMA",
    "country": "IT",
    "city": "ROMA",
    "address": "Via Salaria, 1268, 00138 ROMA",
    "email": "info@bmwroma.bmw.it",
    "phone": "+39-06-882821",
    "website": "https://www.bmwroma.bmw.it",
    "coords": {
      "lat": 41.9918212890625,
      "lng": 12.5146484375
    }
  },
  {
    "id": "22532_2",
    "name": "A.D. MOTOR SPA",
    "country": "IT",
    "city": "PERUGIA",
    "address": "Via P. Soriano, 1, 06132 PERUGIA",
    "email": "info@admotor.conc-bmw.com",
    "phone": "+39-075-5279942",
    "website": "https://www.admotor.bmw.it",
    "coords": {
      "lat": 43.07822036743164,
      "lng": 12.336917877197266
    }
  },
  {
    "id": "26559_2",
    "name": "ACTIVA SPA BRIXINA",
    "country": "IT",
    "city": "BRESSANONE",
    "address": "Via Julius Durst, 26, 39042 BRESSANONE",
    "email": "info@activabmw.it",
    "phone": "+39-0472-836427",
    "website": "https://www.activa.bmw.it",
    "coords": {
      "lat": 46.69945526123047,
      "lng": 11.648283958435059
    }
  },
  {
    "id": "27998_4",
    "name": "STILE SPA CAR POINT RIMINI",
    "country": "IT",
    "city": "RIMINI",
    "address": "Via Flaminia, 235, 47923 RIMINI",
    "email": "servizio.clienti@stile.conc-bmw.com",
    "phone": "+39-0541-319711",
    "website": "https://www.carpoint.bmw.it",
    "coords": {
      "lat": 44.041481018066406,
      "lng": 12.58371639251709
    }
  },
  {
    "id": "28227_3",
    "name": "CECCATO MOTORS SRL",
    "country": "IT",
    "city": "MESTRE",
    "address": "Via Orlanda, 8/1-2-3-4, 30173 MESTRE",
    "email": "info@ceccato.conc-bmw.com",
    "phone": "+39-041-2676200",
    "website": "https://www.ceccato.bmw.it",
    "coords": {
      "lat": 45.4808235168457,
      "lng": 12.274078369140625
    }
  },
  {
    "id": "28227_4",
    "name": "CECCATO MOTORS SRL",
    "country": "IT",
    "city": "LEGNARO",
    "address": "VIA FERMI,1, 35020 LEGNARO",
    "email": "info@ceccato.conc-bmw.com",
    "phone": "+39-049-2701600",
    "website": "https://www.ceccato.bmw.it",
    "coords": {
      "lat": 45.35005569458008,
      "lng": 11.95858383178711
    }
  },
  {
    "id": "31229_1",
    "name": "CALZONI GROUP SRL",
    "country": "IT",
    "city": "Pian Camuno",
    "address": "Via Provinciale 31, 25050 Pian Camuno",
    "email": "info.bmw@calzonigroup.it",
    "phone": "+39-0364-591616",
    "website": "http://www.calzonigroup.bmw.it",
    "coords": {
      "lat": 45.84370422363281,
      "lng": 10.146724700927734
    }
  },
  {
    "id": "32245_1",
    "name": "PATRIARCA SRL",
    "country": "IT",
    "city": "ROMA",
    "address": "VIA ASSISI 57, 00181 ROMA",
    "email": "info@patriarcabmw.it",
    "phone": "+39-06-7826575",
    "website": "https://www.patriarca.bmw.it",
    "coords": {
      "lat": 41.87959671020508,
      "lng": 12.525803565979004
    }
  },
  {
    "id": "32596_1",
    "name": "GF CAR SRL",
    "country": "IT",
    "city": "RENDE",
    "address": "VIA R. AMUNDSEN, SNC, 87036 RENDE",
    "email": "alessandro.donato@gfcar.conc-bmw.com",
    "phone": "+39-0984-404407",
    "website": "https://www.gfcar.bmw.it",
    "coords": {
      "lat": 39.372032165527344,
      "lng": 16.25037384033203
    }
  },
  {
    "id": "36393_1",
    "name": "PRESTIGIACOMO SRL",
    "country": "IT",
    "city": "PALERMO",
    "address": "VIA REG. SICILIANA NORD/OVEST 4769, 90145 PALERMO",
    "email": "andrea.prestigiacomo@prestigiacomo.service-bmw.com",
    "phone": "+39-091-6702788",
    "website": "https://www.prestigiacomo.bmw.it/",
    "coords": {
      "lat": 38.14604187011719,
      "lng": 13.329063415527344
    }
  },
  {
    "id": "36443_1",
    "name": "BIAUTO SRL",
    "country": "IT",
    "city": "TORINO",
    "address": "VIA BOLOGNA, 102, 10154 TORINO",
    "email": "info@biautogroup.com",
    "phone": "+39-011-2483711",
    "website": "https://www.biauto.bmw.it",
    "coords": {
      "lat": 45.084190368652344,
      "lng": 7.699280738830566
    }
  },
  {
    "id": "36443_4",
    "name": "BIAUTO SRL",
    "country": "IT",
    "city": "MONCALIERI",
    "address": "Via Corrado Corradino 8, 10024 MONCALIERI",
    "email": "info@biautogroup.com",
    "phone": "+39-011-5803126",
    "website": "https://www.biauto.bmw.it",
    "coords": {
      "lat": 45.016170501708984,
      "lng": 7.6703691482543945
    }
  },
  {
    "id": "39135_18",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "PORDENONE",
    "address": "Viale Venezia, 59, 33170 PORDENONE",
    "email": "info.pordenone@autotorino.it",
    "phone": "+39-0434-511211",
    "website": "http://www.autotorino-pordenone.mini.it/",
    "coords": {
      "lat": 45.97191619873047,
      "lng": 12.639273643493652
    }
  },
  {
    "id": "40886_4",
    "name": "AUTOMERCATO STABIA SRL CENTER",
    "country": "IT",
    "city": "Montercorvino Pugliano",
    "address": "Via Renato Carosone Snc, 84090 Montercorvino Pugliano",
    "email": "salerno@automercatostabia.conc-bmw.com",
    "phone": "+39-089-3061560",
    "website": "https://www.automercatostabia.bmw.it",
    "coords": {
      "lat": 40.635677337646484,
      "lng": 14.916403770446777
    }
  },
  {
    "id": "52125_1",
    "name": "GRUPPO EMME SRL",
    "country": "IT",
    "city": "BATTIPAGLIA",
    "address": "VIA BOSCO I, 7 Z.I., 84091 BATTIPAGLIA",
    "email": null,
    "phone": "+39-0828-1955300",
    "website": null,
    "coords": {
      "lat": 40.596160888671875,
      "lng": 14.9915189743042
    }
  },
  {
    "id": "06194_1",
    "name": "LIRIO BONSIGNORI SRL",
    "country": "IT",
    "city": "CASTELFRANCO DI SOTTO",
    "address": "Via Dell'Artigianato, 3-5, 56022 CASTELFRANCO DI SOTTO",
    "email": "lirio.bonsignori@bonsignori.service-bmw.com",
    "phone": "+39-0571-478135",
    "website": "https://www.bonsignori.bmw.it",
    "coords": {
      "lat": 43.70212936401367,
      "lng": 10.761114120483398
    }
  },
  {
    "id": "06204_5",
    "name": "ERREEFFE GROUP SPA ROMAGNA MOTORI",
    "country": "IT",
    "city": "FORLIMPOPOLI",
    "address": "VIA GRAMSCI, 4/6, 47034 FORLIMPOPOLI",
    "email": "info@erreeffegroup.it",
    "phone": "+39-0543-550330",
    "website": "https://www.erreeffegroup.bmw.it",
    "coords": {
      "lat": 44.18143081665039,
      "lng": 12.140939712524414
    }
  },
  {
    "id": "20019_3",
    "name": "LARIO BERGAUTO SPA",
    "country": "IT",
    "city": "BERGAMO",
    "address": "Via Campagnola, 48-50, 24126 BERGAMO",
    "email": "bdc@lariobergauto.bmw.it",
    "phone": "+39-035-4212222",
    "website": "https://www.lariobergauto.bmw.it",
    "coords": {
      "lat": 45.677120208740234,
      "lng": 9.673060417175293
    }
  },
  {
    "id": "20019_7",
    "name": "LARIO BERGAUTO SPA",
    "country": "IT",
    "city": "S.PIETRO BERBENNO",
    "address": "Via Industriale, 97/1, 23010 S.PIETRO BERBENNO",
    "email": "bdc@lariobergauto.bmw.it",
    "phone": "+39-034-2492151",
    "website": "https://www.lariobergauto.bmw.it",
    "coords": {
      "lat": 46.16093444824219,
      "lng": 9.750404357910156
    }
  },
  {
    "id": "20295_1",
    "name": "EMMEAUTO SRL",
    "country": "IT",
    "city": "BRINDISI",
    "address": "Via Enrico Fermi, 25, 72100 BRINDISI",
    "email": "info.brindisi@emmeautogroup.com",
    "phone": "+39-0831-546686",
    "website": "https://www.emmeauto.bmw.it",
    "coords": {
      "lat": 40.63499069213867,
      "lng": 17.970415115356445
    }
  },
  {
    "id": "22291_2",
    "name": "TARGET SRL",
    "country": "IT",
    "city": "ASTI",
    "address": "Frazione Quarto Inferiore 310, 14100 ASTI",
    "email": "info@biautogroup.com",
    "phone": "+39-0141-477575",
    "website": "https://www.target.bmw.it",
    "coords": {
      "lat": 44.91763687133789,
      "lng": 8.272833824157715
    }
  },
  {
    "id": "27184_1",
    "name": "ZAGARINI SRL",
    "country": "IT",
    "city": "GELA",
    "address": "S.S. 117 Bis Km 88.200, 93012 GELA",
    "email": "ilary.cavaleri@zagarini.service-bmw.com",
    "phone": "+39-0933-907916",
    "website": "https://www.zagarini.bmw.it",
    "coords": {
      "lat": 37.09622573852539,
      "lng": 14.274752616882324
    }
  },
  {
    "id": "29624_1",
    "name": "FRANCESCO UTIZI SRL",
    "country": "IT",
    "city": "SALA CONSILINA",
    "address": "Via Barca,1, 84036 SALA CONSILINA",
    "email": "francesco.utizi@utizi.service-bmw.com",
    "phone": "+39-0975-520532",
    "website": "https://www.francescoutizi.bmw.it",
    "coords": {
      "lat": 40.413272857666016,
      "lng": 15.561298370361328
    }
  },
  {
    "id": "31063_1",
    "name": "AUTOSPORT DI LANNI ELIO",
    "country": "IT",
    "city": "CASSINO",
    "address": "VIA PESCAROLA SNC, 03043 CASSINO",
    "email": "info@autosportlanni.service-bmw.com",
    "phone": "+39-0776-22922",
    "website": "http://www.autosport.bmw.it",
    "coords": {
      "lat": 41.49121856689453,
      "lng": 13.841874122619629
    }
  },
  {
    "id": "40646_2",
    "name": "AD PUGLIESE SPA",
    "country": "IT",
    "city": "MELILLI",
    "address": "S.P. EX SS 114, 96010 MELILLI",
    "email": "pugliese@usersdesk.it",
    "phone": "+39-0931-765022",
    "website": "https://www.adpugliese.bmw.it",
    "coords": {
      "lat": 37.11618423461914,
      "lng": 15.233851432800293
    }
  },
  {
    "id": "40646_4",
    "name": "AD PUGLIESE SPA",
    "country": "IT",
    "city": "AGRIGENTO",
    "address": "Via Unità d'italia 70, 92100 AGRIGENTO",
    "email": "pugliese@usersdesk.it",
    "phone": "+39-0922-525702",
    "website": "https://www.adpugliese.bmw.it",
    "coords": {
      "lat": 37.332176208496094,
      "lng": 13.596639633178711
    }
  },
  {
    "id": "41741_1",
    "name": "SPAZIO AUTO SRL",
    "country": "IT",
    "city": "ARZIGNANO",
    "address": "VIA DEL LAVORO, 1, 36071 ARZIGNANO",
    "email": "roberto.turato@spazioauto.service-bmw.com",
    "phone": "+39-0444-676362",
    "website": "https://www.spazioauto.bmw.it",
    "coords": {
      "lat": 45.510562896728516,
      "lng": 11.34953498840332
    }
  },
  {
    "id": "51394_1",
    "name": "IONA' MOTORI SRL CALABRIA MOTORI",
    "country": "IT",
    "city": "Campo Calabro",
    "address": "VIA GINESTRE SNC, 89052 Campo Calabro",
    "email": "emanuele.iona@calabriamotori.org",
    "phone": "+39-0965-1659051",
    "website": "https://calabriamotori.bmw.it/",
    "coords": {
      "lat": 38.20640563964844,
      "lng": 15.648588180541992
    }
  },
  {
    "id": "52040_1",
    "name": "CLERICI AUTO SPA",
    "country": "IT",
    "city": "TAVERNERIO",
    "address": "SS BRIANTEA ,11, 22038 TAVERNERIO",
    "email": "massimiliano.mandrini@clericiauto.it",
    "phone": "+39-031-428111",
    "website": "https://clericiauto.bmw.it/",
    "coords": {
      "lat": 45.7943000793457,
      "lng": 9.147072792053223
    }
  },
  {
    "id": "06029_1",
    "name": "CAPPELLO ANTONIO",
    "country": "IT",
    "city": "SENIGALLIA",
    "address": "Via Arceviese, 10 A, 60019 SENIGALLIA",
    "email": "info@cappello.service-bmw.com",
    "phone": "+39-071-7926033",
    "website": "https://www.cappelloantonio.bmw.it",
    "coords": {
      "lat": 43.699100494384766,
      "lng": 13.201970100402832
    }
  },
  {
    "id": "06098_1",
    "name": "NANNI NEMBER SRL",
    "country": "IT",
    "city": "BRESCIA",
    "address": "Via Valcamonica, 15 C, 25126 BRESCIA",
    "email": "info@nanninember.it",
    "phone": "+39-030-3156411",
    "website": "https://www.nanninember.bmw.it",
    "coords": {
      "lat": 45.54627990722656,
      "lng": 10.174057960510254
    }
  },
  {
    "id": "06098_3",
    "name": "NANNI NEMBER SRL",
    "country": "IT",
    "city": "Desenzano del Garda",
    "address": "Via Mapella, 25017 Desenzano del Garda",
    "email": "info@nanninember.it",
    "phone": "+39-030-3156499",
    "website": "https://www.nanninember.bmw.it",
    "coords": {
      "lat": 45.460670471191406,
      "lng": 10.51294994354248
    }
  },
  {
    "id": "06204_1",
    "name": "ERREEFFE GROUP SPA ROVIGO MOTORI",
    "country": "IT",
    "city": "ROVIGO",
    "address": "Viale della Tecnica, 6, 45100 ROVIGO",
    "email": "info@erreeffegroup.it",
    "phone": "+39-0425-474767",
    "website": "https://www.erreeffegroup.bmw.it",
    "coords": {
      "lat": 45.053497314453125,
      "lng": 11.779446601867676
    }
  },
  {
    "id": "06224_3",
    "name": "AUTOABRUZZO SRL",
    "country": "IT",
    "city": "MOZZAGROGNA",
    "address": "Strada Provinciale, 23, 66030 MOZZAGROGNA",
    "email": "vanessa.agostinelli@autoabruzzo.conc-bmw.com",
    "phone": "+39-0872-57194",
    "website": "http://www.autoabruzzo.bmw.it",
    "coords": {
      "lat": 42.21412658691406,
      "lng": 14.422872543334961
    }
  },
  {
    "id": "06932_4",
    "name": "CARTENI S.P.A.",
    "country": "IT",
    "city": "PAVIA",
    "address": "S.S. 35 DEI GIOVI - KM 87,800, 27100 PAVIA",
    "email": "info.pavia@carteni.conc-bmw.com",
    "phone": "+39-0382-498289",
    "website": "https://carteni.bmw.it/",
    "coords": {
      "lat": 45.166229248046875,
      "lng": 9.14001178741455
    }
  },
  {
    "id": "28227_6",
    "name": "CECCATO MOTORS SRL",
    "country": "IT",
    "city": "MUSILE DI PIAVE",
    "address": "VIA INDUSTRIE 71, 30021 MUSILE DI PIAVE",
    "email": "info@ceccato.conc-bmw.com",
    "phone": "+39-049-8062600",
    "website": "https://www.ceccato.bmw.it",
    "coords": {
      "lat": 45.6214599609375,
      "lng": 12.538591384887695
    }
  },
  {
    "id": "28699_1",
    "name": "COMMERCIALE AUTOMOBILI SRL",
    "country": "IT",
    "city": "PRATO",
    "address": "Via F.lli Da Maiano, 14, 59100 PRATO",
    "email": "commercialeautomobili@gmail.com",
    "phone": "+39-0574-593941",
    "website": "http://www.commercialeautomobili.bmw.it",
    "coords": {
      "lat": 43.870609283447266,
      "lng": 11.110390663146973
    }
  },
  {
    "id": "29861_3",
    "name": "L'AUTOMOBILE SRL",
    "country": "IT",
    "city": "CISTERNA DI LATINA",
    "address": "SS 148 Pontina, km 63.500, 04012 CISTERNA DI LATINA",
    "email": "info@automobilebmw.it",
    "phone": "+39-800-709990",
    "website": "https://automobile.bmw.it/",
    "coords": {
      "lat": 41.495445251464844,
      "lng": 12.824285507202148
    }
  },
  {
    "id": "30184_1",
    "name": "SERVICE TOSKANA SRL",
    "country": "IT",
    "city": "FIRENZE",
    "address": "Via Ambrosoli, 30, 50136 FIRENZE",
    "email": "fulvio.selmi@autoeursud.service-bmw.com",
    "phone": "+39-055-671462",
    "website": "https://www.servicetoskana.bmw.it",
    "coords": {
      "lat": 43.76491165161133,
      "lng": 11.305408477783203
    }
  },
  {
    "id": "30184_3",
    "name": "SERVICE TOSKANA SRL",
    "country": "IT",
    "city": "PISTOIA",
    "address": "VIA GALVANI,11, 51100 PISTOIA",
    "email": "fulvio.selmi@autoeursud.service-bmw.com",
    "phone": "+39-0573-535300",
    "website": "https://www.servicetoskana.bmw.it",
    "coords": {
      "lat": 43.933467864990234,
      "lng": 10.932625770568848
    }
  },
  {
    "id": "33056_1",
    "name": "BARLETTA MOTOR SERVICE SRL",
    "country": "IT",
    "city": "SETTINGIANO",
    "address": "Via Campo dei Fiori Snc, 88040 SETTINGIANO",
    "email": "francesco.barletta@barlettamotor.service-bmw.com",
    "phone": "+39-0961-904072",
    "website": "https://www.bmw-motorrad.it/barlettamotorservice/it/home.html",
    "coords": {
      "lat": 38.88330078125,
      "lng": 16.540990829467773
    }
  },
  {
    "id": "36443_2",
    "name": "BIAUTO SRL",
    "country": "IT",
    "city": "TORINO",
    "address": "CORSO ORBASSANO,  INT /D, 10137 TORINO",
    "email": "info@biautogroup.com",
    "phone": "+39-011-3116419",
    "website": "https://www.biauto.bmw.it",
    "coords": {
      "lat": 45.03427505493164,
      "lng": 7.616525173187256
    }
  },
  {
    "id": "36443_3",
    "name": "BIAUTO SRL",
    "country": "IT",
    "city": "MONCALIERI",
    "address": "Via Moncenisio 8, 10024 MONCALIERI",
    "email": "info@biautogroup.com",
    "phone": "+39-011-6311100",
    "website": "https://www.biauto.bmw.it",
    "coords": {
      "lat": 45.01564407348633,
      "lng": 7.668882846832275
    }
  },
  {
    "id": "39135_1",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "CREMONA",
    "address": "Via Eridano, 11, 26100 CREMONA",
    "email": "info.cremona@autotorino.it",
    "phone": "+39-0372-470611",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.13337326049805,
      "lng": 9.999549865722656
    }
  },
  {
    "id": "39135_7",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "NOVARA",
    "address": "CORSO VERCELLI, 85 F, 28100 NOVARA",
    "email": "info.novara@autotorino.it",
    "phone": "+39-0321-521711",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.429988861083984,
      "lng": 8.58796215057373
    }
  },
  {
    "id": "47752_1",
    "name": "SUPERAUTO SERVICE SRL",
    "country": "IT",
    "city": "Velletri",
    "address": "Via dei Volsci, 55, 00049 Velletri",
    "email": null,
    "phone": "+39-06-96151006",
    "website": "https://superautoservice.bmw.it/",
    "coords": {
      "lat": 41.69001007080078,
      "lng": 12.783886909484863
    }
  },
  {
    "id": "54456_1",
    "name": "Mastroleo S.r.l.",
    "country": "IT",
    "city": "LECCE",
    "address": "S.S. 275, km 21, 400, 73030 LECCE",
    "email": null,
    "phone": "+39-0833-784127",
    "website": null,
    "coords": {
      "lat": 39.94035339355469,
      "lng": 18.31919288635254
    }
  },
  {
    "id": "51021_4",
    "name": "BM BymyCar Milano S.r.l. BYmyCAR Milano",
    "country": "IT",
    "city": "San Donato Milanese",
    "address": "Via Cesare Zavattini, 4, 20097 San Donato Milanese",
    "email": "sales.bmw.zavattini@bymycar.it",
    "phone": "+39-02-51883111",
    "website": "https://bymycar-milano.bmw.it/",
    "coords": {
      "lat": 45.41266632080078,
      "lng": 9.263340950012207
    }
  },
  {
    "id": "51021_1",
    "name": "BM BymyCar Milano S.r.l. BYmyCAR Milano",
    "country": "IT",
    "city": "MILANO",
    "address": "Via dei Missaglia, 89, 20142 MILANO",
    "email": "sales.bmw.missaglia@bymycar.it",
    "phone": "+39-02-81273029",
    "website": "https://bymycar-milano.bmw.it/",
    "coords": {
      "lat": 45.41439437866211,
      "lng": 9.17628288269043
    }
  },
  {
    "id": "43584_1",
    "name": "PARADISO SRL",
    "country": "IT",
    "city": "LAMEZIA TERME",
    "address": "LOC. FRASSO BRAGO', 88046 LAMEZIA TERME",
    "email": "stefania.crudo@paradisosrl.conc-bmw.com",
    "phone": "+39-0968-53096",
    "website": "https://www.paradiso.bmw.it",
    "coords": {
      "lat": 38.90929412841797,
      "lng": 16.31635093688965
    }
  },
  {
    "id": "05896_5",
    "name": "NUOVA SPORT CAR SPA",
    "country": "IT",
    "city": "CATANIA",
    "address": "SS 192 C. da Jungetto, 95121 CATANIA",
    "email": "info@nuovasportcar.com",
    "phone": "+39-095-7491211",
    "website": "https://www.nuovasportcar.bmw.it",
    "coords": {
      "lat": 37.463130950927734,
      "lng": 15.018192291259766
    }
  },
  {
    "id": "51394_3",
    "name": "IONA' MOTORI SRL CALABRIA MOTORI",
    "country": "IT",
    "city": "LAMEZIA TERME",
    "address": "Via Del Progresso, 342, 88046 LAMEZIA TERME",
    "email": "info@calabriamotori.org",
    "phone": "+39-3404102548",
    "website": "https://calabriamotori.bmw.it/",
    "coords": {
      "lat": 38.95064163208008,
      "lng": 16.329776763916016
    }
  },
  {
    "id": "09298_4",
    "name": "SPECIAL CAR SPA",
    "country": "IT",
    "city": "ORISTANO",
    "address": "VIA PARIGI SNC, 09170 ORISTANO",
    "email": "info@specialcargroup.com",
    "phone": "+39-07-83210098",
    "website": "https://www.specialcar.bmw.it",
    "coords": {
      "lat": 39.91151428222656,
      "lng": 8.589866638183594
    }
  },
  {
    "id": "20019_1",
    "name": "LARIO BERGAUTO SPA",
    "country": "IT",
    "city": "LECCO",
    "address": "Corso Carlo Alberto, 114, 23900 LECCO",
    "email": "bdc@lariobergauto.bmw.it",
    "phone": "+39-034-1278822",
    "website": "https://www.lariobergauto.bmw.it",
    "coords": {
      "lat": 45.841163635253906,
      "lng": 9.408563613891602
    }
  },
  {
    "id": "49332_1",
    "name": "X SERVICE SRL",
    "country": "IT",
    "city": "ANGRI",
    "address": "VIA NAZIONALE 299 B, 84012 ANGRI",
    "email": "info@x.service-bmw.com",
    "phone": "+39-081-946813",
    "website": "https://xservice.bmw.it/",
    "coords": {
      "lat": 40.748592376708984,
      "lng": 14.581307411193848
    }
  },
  {
    "id": "02248_1",
    "name": "FIMAUTO SPA",
    "country": "IT",
    "city": "BUSSOLENGO",
    "address": "Via Del Lavoro, 19, 37012 BUSSOLENGO",
    "email": "info@fimautogemelli.it",
    "phone": "+39-045-6767787",
    "website": "https://www.bmw-motorrad.it/gruppofimauto-bussolengo",
    "coords": {
      "lat": 45.44773864746094,
      "lng": 10.875194549560547
    }
  },
  {
    "id": "02248_4",
    "name": "FIMAUTO SPA AUTOGEMELLI",
    "country": "IT",
    "city": "BASSANO DEL GRAPPA",
    "address": "VIALE VICENZA, 71, 36061 BASSANO DEL GRAPPA",
    "email": "info@fimautogemelli.it",
    "phone": "+39-0424-505250",
    "website": "https://www.gruppofimauto.bmw.it",
    "coords": {
      "lat": 45.76175308227539,
      "lng": 11.711371421813965
    }
  },
  {
    "id": "05864_3",
    "name": "AutoVanti S.r.l.",
    "country": "IT",
    "city": "GRANAROLO DELL'EMILIA",
    "address": "Via Del Lavoro, 1, 40057 GRANAROLO DELL'EMILIA",
    "email": "info@autovanti-bologna.it",
    "phone": "+39-051-6039201",
    "website": "https://www.vantigroup.bmw.it",
    "coords": {
      "lat": 44.52663040161133,
      "lng": 11.416170120239258
    }
  },
  {
    "id": "05579_1",
    "name": "M.CAR SPA",
    "country": "IT",
    "city": "SAN NICOLA LA STRADA",
    "address": "Viale Carlo III, 191, 81020 SAN NICOLA LA STRADA",
    "email": "info@mcar.it",
    "phone": "+39-0823-218511",
    "website": "https://www.mcar.bmw.it",
    "coords": {
      "lat": 41.04294204711914,
      "lng": 14.324797630310059
    }
  },
  {
    "id": "05864_7",
    "name": "AutoVanti S.r.l. AutoVanti Brianza",
    "country": "IT",
    "city": "DESIO",
    "address": "VIA MILANO, 33, 20832 DESIO",
    "email": "info.brianza@autovanti.it",
    "phone": "+39-0362-3981",
    "website": "https://www.autovantibrianza.bmw.it",
    "coords": {
      "lat": 45.60316848754883,
      "lng": 9.201416969299316
    }
  },
  {
    "id": "05864_8",
    "name": "AutoVanti S.r.l. AutoVanti Monza",
    "country": "IT",
    "city": "MONZA",
    "address": "VIALE SICILIA 130, 20900 MONZA",
    "email": "info@autovanti.it",
    "phone": "+39-039-39391",
    "website": "https://www.autovanti.bmw.it",
    "coords": {
      "lat": 45.58064651489258,
      "lng": 9.315496444702148
    }
  },
  {
    "id": "02248_5",
    "name": "FIMAUTO SPA AUTOGEMELLI",
    "country": "IT",
    "city": "ZANE'",
    "address": "VIA PRA' BORDONI, 62, 36010 ZANE'",
    "email": "info@fimautogemelli.it",
    "phone": "+39-0445-315282",
    "website": "https://www.gruppofimauto.bmw.it",
    "coords": {
      "lat": 45.72060012817383,
      "lng": 11.443416595458984
    }
  },
  {
    "id": "05912_1",
    "name": "SIRIO AUTO 77 SRL",
    "country": "IT",
    "city": "ROMA",
    "address": "Via M. Pantaleoni, 19, 00191 ROMA",
    "email": "emanuele.ottaviani@sirioauto.service.bmw.com",
    "phone": "+39-06-3293911",
    "website": "http://www.sirioauto.bmw.it",
    "coords": {
      "lat": 41.95054244995117,
      "lng": 12.470514297485352
    }
  },
  {
    "id": "06204_7",
    "name": "ERREEFFE GROUP SPA Ravenna Motori",
    "country": "IT",
    "city": "RAVENNA",
    "address": "VIA DELLA FORNACE 13, 48124 RAVENNA",
    "email": "info@erreeffegroup.it",
    "phone": "+39-0544-1673621",
    "website": "https://www.erreeffegroup.bmw.it",
    "coords": {
      "lat": 44.41732406616211,
      "lng": 12.149275779724121
    }
  },
  {
    "id": "24380_5",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "GUAMO - CAPANNORI",
    "address": "VIA DI VORNO SNC, 55060 GUAMO - CAPANNORI",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0571-902482",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.81549835205078,
      "lng": 10.49786376953125
    }
  },
  {
    "id": "24380_3",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "PRATO",
    "address": "Via Udine, 60, 59100 PRATO",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0574-606880",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.87748718261719,
      "lng": 11.07385540008545
    }
  },
  {
    "id": "24380_1",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "VINCI",
    "address": "Viale Palmiro Togliatti, 79, 50059 VINCI",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0571-902482",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.72562026977539,
      "lng": 10.943665504455566
    }
  },
  {
    "id": "25327_1",
    "name": "ESCLUSIVA SRL",
    "country": "IT",
    "city": "SALERNO",
    "address": "Via Terre Risaie, 10 (ex IMMSI)-ZI, 84131 SALERNO",
    "email": "esclusiva@gruppolaus.it",
    "phone": "+39-089-3065411",
    "website": "https://www.esclusiva.bmw.it",
    "coords": {
      "lat": 40.638580322265625,
      "lng": 14.847494125366211
    }
  },
  {
    "id": "26559_8",
    "name": "ACTIVA SPA AUTO IKARO",
    "country": "IT",
    "city": "MERANO",
    "address": "VIA BROGLIATI, 7, 39012 MERANO",
    "email": "info@activabmw.it",
    "phone": "+39-0473-239855",
    "website": "https://www.activa.bmw.it",
    "coords": {
      "lat": 46.66194152832031,
      "lng": 11.147582054138184
    }
  },
  {
    "id": "31377_1",
    "name": "EURMOTOR SRL",
    "country": "IT",
    "city": "ROMA",
    "address": "Via Meucci, 6, 00146 ROMA",
    "email": "paolo.giannini@eurmotor.service-bmw.com",
    "phone": "+39-06-5562763",
    "website": "https://www.eurmotor.bmw.it",
    "coords": {
      "lat": 41.866058349609375,
      "lng": 12.46708869934082
    }
  },
  {
    "id": "34971_1",
    "name": "BONERA SPA DINAMICA - BRESCIA",
    "country": "IT",
    "city": "BRESCIA",
    "address": "Via Breve, 4, 25135 BRESCIA",
    "email": "info@bonera.it",
    "phone": "+39-030-3696011",
    "website": "https://www.dinamica.bmw.it",
    "coords": {
      "lat": 45.51448440551758,
      "lng": 10.295737266540527
    }
  },
  {
    "id": "35427_4",
    "name": "AUTOBI SRL",
    "country": "IT",
    "city": "Genova",
    "address": "Via Di Francia, 34r, 16149 Genova",
    "email": "info@biautogroup.com",
    "phone": "+39-010-6567073",
    "website": "https://www.autobi.bmw.it",
    "coords": {
      "lat": 44.41051483154297,
      "lng": 8.90648078918457
    }
  },
  {
    "id": "35427_5",
    "name": "AUTOBI SRL",
    "country": "IT",
    "city": "Genova",
    "address": "Via Romairone, 42 D, 16163 Genova",
    "email": "info@biautogroup.com",
    "phone": "+39-011-19214666",
    "website": "https://www.autobi.bmw.it",
    "coords": {
      "lat": 44.477027893066406,
      "lng": 8.896163940429688
    }
  },
  {
    "id": "36398_5",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "PISA",
    "address": "VIA ANTONIO MEUCCI,1, 56121 PISA",
    "email": "ginoweb@ginospa.com",
    "phone": "+39-050-96751",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 43.676090240478516,
      "lng": 10.431710243225098
    }
  },
  {
    "id": "39135_9",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "VERCELLI",
    "address": "VIA ETTORE ARA, 2 ANG.VIA TRINO, 13100 VERCELLI",
    "email": "info.vercelli@autotorino.it",
    "phone": "+39-0161-300711",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.30546188354492,
      "lng": 8.398767471313477
    }
  },
  {
    "id": "39135_4",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "OLGIATE OLONA",
    "address": "Corso Sempione, 80, 21057 OLGIATE OLONA",
    "email": "info.olgiate@autorino.it",
    "phone": "+39-0331-372711",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.61686706542969,
      "lng": 8.87882137298584
    }
  },
  {
    "id": "39135_11",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "VIGEVANO",
    "address": "CORSO GIUSEPPE DI VITTORIO, 47, 27029 VIGEVANO",
    "email": "info.vigevano@autotorino.it",
    "phone": "+39-0381-908611",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.31179428100586,
      "lng": 8.865448951721191
    }
  },
  {
    "id": "42090_1",
    "name": "GIANNI SRL",
    "country": "IT",
    "city": "ROBBIATE",
    "address": "VIA NOVARINO, 1, 23899 ROBBIATE",
    "email": "service@gianni.service-bmw.com",
    "phone": "+39-039-9515800",
    "website": "http://www.gianni.bmw.it",
    "coords": {
      "lat": 45.68146514892578,
      "lng": 9.42974853515625
    }
  },
  {
    "id": "05944_1",
    "name": "ULTRAMOTOR SRL",
    "country": "IT",
    "city": "MATERA",
    "address": "Via delle Industrie snc, 75100 MATERA",
    "email": "nuovo@ultramotor.bmw.it",
    "phone": "+39-0835-386333",
    "website": "https://www.ultramotor.bmw.it",
    "coords": {
      "lat": 40.67926788330078,
      "lng": 16.573558807373047
    }
  },
  {
    "id": "06962_1",
    "name": "AUTOCLUB SPA",
    "country": "IT",
    "city": "MODENA",
    "address": "Via Emilia Est, 720, 41100 MODENA",
    "email": "vendite@autoclub.conc-bmw.com",
    "phone": "+39-059-376500",
    "website": "https://www.autoclub.bmw.it",
    "coords": {
      "lat": 44.636314392089844,
      "lng": 10.949785232543945
    }
  },
  {
    "id": "06978_2",
    "name": "MOTORAUTO F.LLI NARDONI SRL",
    "country": "IT",
    "city": "CECINA",
    "address": "VIA SAN PIETRO IN PALAZZI, 24, 57023 CECINA",
    "email": "massimo.chesi@motorautonardoni.it",
    "phone": "+39-0586-681810",
    "website": "https://www.motorauto.bmw.it",
    "coords": {
      "lat": 43.32468795776367,
      "lng": 10.508979797363281
    }
  },
  {
    "id": "20595_2",
    "name": "FORMULA 3 SPA",
    "country": "IT",
    "city": "Campo Calabro",
    "address": "Via Ginestre SNC, 89018 Campo Calabro",
    "email": "info@formula3.conc-bmw.com",
    "phone": "+39-0965-655851",
    "website": "https://www.formula3.bmw.it",
    "coords": {
      "lat": 38.20366668701172,
      "lng": 15.645731925964355
    }
  },
  {
    "id": "20751_1",
    "name": "AUTOPRESTIGE SRL",
    "country": "IT",
    "city": "SASSARI",
    "address": "viale Porto Torres, 26, 07100 SASSARI",
    "email": "massimo.mele@pimaxgroup.it",
    "phone": "+39-079-2637600",
    "website": "https://www.bmw-motorrad.it/autoprestige-sassari/it/home.html",
    "coords": {
      "lat": 40.73310089111328,
      "lng": 8.547906875610352
    }
  },
  {
    "id": "22532_3",
    "name": "A.D. MOTOR SPA",
    "country": "IT",
    "city": "FOLIGNO",
    "address": "Via Fiamenga, 53 A, 06034 FOLIGNO",
    "email": "info@admotor.conc-bmw.com",
    "phone": "+39-0742-22600",
    "website": "https://www.admotor.bmw.it",
    "coords": {
      "lat": 42.964778900146484,
      "lng": 12.689635276794434
    }
  },
  {
    "id": "24380_6",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "GUAMO - LUCCA",
    "address": "VIA PROVINCIALE Z.I., 55060 GUAMO - LUCCA",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0571-902482",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.816673278808594,
      "lng": 10.49738597869873
    }
  },
  {
    "id": "24363_1",
    "name": "BLU CAR SRL",
    "country": "IT",
    "city": "SIENA",
    "address": "Via Del Casone, 1-3, 53100 SIENA",
    "email": "lorenzo.bigi@blucar.service-bmw.com",
    "phone": "+39-0577-222396",
    "website": "http://www.blucar.bmw.it",
    "coords": {
      "lat": 43.3138313293457,
      "lng": 11.35846996307373
    }
  },
  {
    "id": "26559_1",
    "name": "ACTIVA SPA",
    "country": "IT",
    "city": "TRENTO",
    "address": "Via Di Spini 29, 38121 TRENTO",
    "email": "info@activabmw.it",
    "phone": "+39-0461-383200",
    "website": "https://www.activa.bmw.it",
    "coords": {
      "lat": 46.118831634521484,
      "lng": 11.102991104125977
    }
  },
  {
    "id": "24947_1",
    "name": "PIZZALA SRL",
    "country": "IT",
    "city": "MAGENTA",
    "address": "Via Murri, 36-38, 20013 MAGENTA",
    "email": "service@pizzala.service-bmw.com",
    "phone": "+39-02-97297096",
    "website": "http://www.pizzala.bmw.it",
    "coords": {
      "lat": 45.452354431152344,
      "lng": 8.89231014251709
    }
  },
  {
    "id": "29185_1",
    "name": "EMMEAUTO TARANTO SRL",
    "country": "IT",
    "city": "TARANTO",
    "address": "Viale Unità D'Italia, 255, 74122 TARANTO",
    "email": "info.taranto@emmeautogroup.com",
    "phone": "+39-099-7729058",
    "website": "https://www.emmeautotaranto.bmw.it",
    "coords": {
      "lat": 40.42683029174805,
      "lng": 17.259519577026367
    }
  },
  {
    "id": "29861_1",
    "name": "L'AUTOMOBILE SRL",
    "country": "IT",
    "city": "FROSINONE",
    "address": "via Enrico Fermi, 27, 03100 FROSINONE",
    "email": "info@automobilebmw.it",
    "phone": "+39-800-709990",
    "website": "https://www.automobile.bmw.it",
    "coords": {
      "lat": 41.62152862548828,
      "lng": 13.310331344604492
    }
  },
  {
    "id": "35935_1",
    "name": "MILIZIA DOMENICO",
    "country": "IT",
    "city": "CORIGLIANO CALABRO",
    "address": "ZONA INDUSTRIALE SETTORE 4, 87065 CORIGLIANO CALABRO",
    "email": "domenico.milizia@milizia.service-bmw.com",
    "phone": "+39-0983-885741",
    "website": "https://www.miliziadomenico.bmw.it",
    "coords": {
      "lat": 39.670875549316406,
      "lng": 16.505823135375977
    }
  },
  {
    "id": "39135_3",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "PARMA",
    "address": "VIA FRANCESCO BARBACINI, 2/1A, 43122 PARMA",
    "email": "info.parma@autotorino.it",
    "phone": "+39-0521-795511",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 44.82227325439453,
      "lng": 10.322755813598633
    }
  },
  {
    "id": "39135_5",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "MILANO",
    "address": "VIA LUDOVICO BREME,2, 20156 MILANO",
    "email": "info.milano@autotorino.it",
    "phone": "+39-02-30081111",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.49614334106445,
      "lng": 9.139422416687012
    }
  },
  {
    "id": "39135_12",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "CORSICO",
    "address": "VIA MEUCCI,5, 20094 CORSICO",
    "email": "info.corsico@autotorino.it",
    "phone": "+39-02-44075811",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.428924560546875,
      "lng": 9.083846092224121
    }
  },
  {
    "id": "40673_1",
    "name": "AUTOLUX SERVICE SRL",
    "country": "IT",
    "city": "PIEDIRIPA DI MACERATA",
    "address": "STR. CLUENTINA, 41, 62100 PIEDIRIPA DI MACERATA",
    "email": "info.bmw@autolux.service-bmw.com",
    "phone": "+39-0733-292090",
    "website": "https://www.autoluxservice.bmw.it",
    "coords": {
      "lat": 43.27490234375,
      "lng": 13.493719100952148
    }
  },
  {
    "id": "43214_1",
    "name": "AMBROSI AUTO SPA",
    "country": "IT",
    "city": "TERNI",
    "address": "via Bartocci 15, 05100 TERNI",
    "email": "relazioniclienti@ambrosispa.it",
    "phone": "+39-0744-037401",
    "website": "https://www.ambrosiauto.bmw.it",
    "coords": {
      "lat": 42.55827713012695,
      "lng": 12.602560997009277
    }
  },
  {
    "id": "48318_2",
    "name": "MALDARIZZI AUTOMOTIVE SPA",
    "country": "IT",
    "city": "Trani",
    "address": "Via Barletta, 134, 76125 Trani",
    "email": "info@maldarizzi.com",
    "phone": "+39-0883-1985050",
    "website": "https://www.maldarizzi.bmw.it",
    "coords": {
      "lat": 41.28618621826172,
      "lng": 16.38791275024414
    }
  },
  {
    "id": "51539_1",
    "name": "BRANDINI S.P.A.",
    "country": "IT",
    "city": "OSMANNORO",
    "address": "VIA NOBEL, 8, 50019 OSMANNORO",
    "email": "info@brandini.it",
    "phone": "+39-840-055055",
    "website": "https://www.brandini.bmw.it",
    "coords": {
      "lat": 43.80495834350586,
      "lng": 11.185236930847168
    }
  },
  {
    "id": "06060_2",
    "name": "ROLANDI AUTO SPA",
    "country": "IT",
    "city": "TORTONA",
    "address": "SS per Voghera Località Villoria, 15057 TORTONA",
    "email": "info@rolandiauto.it",
    "phone": "+39-0131-870136",
    "website": "https://www.rolandiauto.bmw.it",
    "coords": {
      "lat": 44.904876708984375,
      "lng": 8.836190223693848
    }
  },
  {
    "id": "06932_1",
    "name": "CARTENI S.P.A. DUE C",
    "country": "IT",
    "city": "PIACENZA",
    "address": "Via Emilia Pavese, 144, 29121 PIACENZA",
    "email": "info.piacenza@carteni.conc-bmw.com",
    "phone": "+39-0523-497021",
    "website": "https://carteni.bmw.it/",
    "coords": {
      "lat": 45.05485916137695,
      "lng": 9.654450416564941
    }
  },
  {
    "id": "06932_3",
    "name": "CARTENI S.P.A.",
    "country": "IT",
    "city": "VOGHERA",
    "address": "VIA TORTONA, 32, 27058 VOGHERA",
    "email": "info.voghera@carteni.conc-bmw.com",
    "phone": "+39-0383-362642",
    "website": "https://carteni.bmw.it/",
    "coords": {
      "lat": 44.9852294921875,
      "lng": 8.987770080566406
    }
  },
  {
    "id": "06932_2",
    "name": "CARTENI S.P.A. F.LLI CARTENI",
    "country": "IT",
    "city": "LODI",
    "address": "SS 9 KM 298, 26900 LODI",
    "email": "info.lodi@carteni.conc-bmw.com",
    "phone": "+39-0371-610384",
    "website": "https://www.carteni.bmw.it",
    "coords": {
      "lat": 45.304264068603516,
      "lng": 9.482059478759766
    }
  },
  {
    "id": "06962_6",
    "name": "AUTOCLUB SPA AUTOCLUB SPA - Reggio Emilia",
    "country": "IT",
    "city": "REGGIO EMILIA",
    "address": "VIA F.LLI CERVI 91, 42124 REGGIO EMILIA",
    "email": "info.reggio@autoclub.it",
    "phone": "+39-0522-385611",
    "website": "https://www.autoclub.bmw.it",
    "coords": {
      "lat": 44.71345520019531,
      "lng": 10.587924003601074
    }
  },
  {
    "id": "24380_4",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "AREZZO",
    "address": "VIA F.LLI LUMIERE, 9, 52100 AREZZO",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0575-383350",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.47099304199219,
      "lng": 11.849523544311523
    }
  },
  {
    "id": "27998_1",
    "name": "STILE SPA CAR POINT - ANCONA",
    "country": "IT",
    "city": "ANCONA",
    "address": "Via I Maggio, 124, 60131 ANCONA",
    "email": "servizio.clienti@stile.conc-bmw.com",
    "phone": "+39-071-2912511",
    "website": "https://www.carpoint.bmw.it",
    "coords": {
      "lat": 43.545188903808594,
      "lng": 13.509610176086426
    }
  },
  {
    "id": "24184_1",
    "name": "MAGNIFICA SRL",
    "country": "IT",
    "city": "TRIGGIANO",
    "address": "Via San Giorgio 62/64/66, 70019 TRIGGIANO",
    "email": "info@magnifica.service-bmw.com",
    "phone": "+39-080-5494560",
    "website": "http://www.magnifica.bmw.it",
    "coords": {
      "lat": 41.09025955200195,
      "lng": 16.95048713684082
    }
  },
  {
    "id": "30184_2",
    "name": "SERVICE TOSKANA SRL",
    "country": "IT",
    "city": "SCANDICCI",
    "address": "VIA CHARTA 77, 9, 50018 SCANDICCI",
    "email": "fulvio.selmi@autoeursud.service-bmw.com",
    "phone": "+39-055-720013",
    "website": "http://www.servicetoskana.bmw.it",
    "coords": {
      "lat": 43.76426315307617,
      "lng": 11.16081714630127
    }
  },
  {
    "id": "30349_1",
    "name": "PERITO GROUP SRL",
    "country": "IT",
    "city": "SALA CONSILINA",
    "address": "VIA FONTI SNC, 84036 SALA CONSILINA",
    "email": "info@peritogroup.it",
    "phone": "+39-0975-520350",
    "website": "https://www.peritogroup.bmw.it",
    "coords": {
      "lat": 40.356712341308594,
      "lng": 15.624579429626465
    }
  },
  {
    "id": "33294_4",
    "name": "CASCIOLI SPA",
    "country": "IT",
    "city": "TERAMO",
    "address": "S.S. 80 PIANO D'ACCIO, KM 6, 64100 TERAMO",
    "email": "servizioclienti@cascioli.conc-bmw.com",
    "phone": "+39-085-807591",
    "website": "https://www.cascioli.bmw.it",
    "coords": {
      "lat": 42.685699462890625,
      "lng": 13.767424583435059
    }
  },
  {
    "id": "33294_3",
    "name": "CASCIOLI SPA",
    "country": "IT",
    "city": "CIVITANOVA MARCHE",
    "address": "Via Giorgio Sidney Sonnino, 59, 62012 CIVITANOVA MARCHE",
    "email": "servizioclienti@cascioli.conc-bmw.com",
    "phone": "+39-085-807591",
    "website": "https://www.cascioli.bmw.it",
    "coords": {
      "lat": 43.289642333984375,
      "lng": 13.707603454589844
    }
  },
  {
    "id": "36398_9",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "SANREMO",
    "address": "Via Armea 94, 18038 SANREMO",
    "email": "stefania.canale@ginospa.com",
    "phone": "+39-0171-410777",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 43.82655334472656,
      "lng": 7.828324317932129
    }
  },
  {
    "id": "37339_1",
    "name": "P. AUTO SERVICE SRL",
    "country": "IT",
    "city": "ROMA",
    "address": "VIA DELLA PISANA 383, 00163 ROMA",
    "email": "antonella.miconi@pauto.service-bmw.com",
    "phone": "+39-06-66135201",
    "website": "https://www.pautoservice.bmw.it",
    "coords": {
      "lat": 41.866294860839844,
      "lng": 12.41032886505127
    }
  },
  {
    "id": "36844_1",
    "name": "MONACO SERVICE SRL",
    "country": "IT",
    "city": "GAMBELLARA",
    "address": "VIA FRANCIA, 10 ZONA IND., 36053 GAMBELLARA",
    "email": "sharon.tirapelle@monaco.service-bmw.com",
    "phone": "+39-0444-831168",
    "website": "http://www.monacoservice.bmw.it",
    "coords": {
      "lat": 45.43072509765625,
      "lng": 11.344335556030273
    }
  },
  {
    "id": "39135_6",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "CREMA",
    "address": "VIA MILANO, 77, 26013 CREMA",
    "email": "info.crema@autotorino.it",
    "phone": "+39-0373-298211",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.359832763671875,
      "lng": 9.642729759216309
    }
  },
  {
    "id": "39135_10",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "VERBANIA - TROBASO",
    "address": "VIA RENCO, 73 BIS, 28900 VERBANIA - TROBASO",
    "email": "info.verbania@autotorino.it",
    "phone": "+39-0323-574611",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.95083999633789,
      "lng": 8.548450469970703
    }
  },
  {
    "id": "39135_19",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "SUSEGANA",
    "address": "VIA CONEGLIANO, 77, 31058 SUSEGANA",
    "email": "info.susegana@autotorino.it",
    "phone": "+39-0438-184711",
    "website": "http://www.autotorino-susegana.mini.it/",
    "coords": {
      "lat": 45.86460494995117,
      "lng": 12.268228530883789
    }
  },
  {
    "id": "39135_16",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "TAVAGNACCO",
    "address": "Via Nazionale, 17, 33010 TAVAGNACCO",
    "email": "info.tavagnacco@autotorino.it",
    "phone": "+39-0432-465211",
    "website": "http://www.autotorino-tavagnacco.mini.it/",
    "coords": {
      "lat": 46.10176467895508,
      "lng": 13.228398323059082
    }
  },
  {
    "id": "41052_1",
    "name": "SASSUOLAUTO SERVICE SRL",
    "country": "IT",
    "city": "VEGGIA CASALGRANDE",
    "address": "VIA RADICI 67, 42013 VEGGIA CASALGRANDE",
    "email": "info@sassuolauto.it",
    "phone": "+39-0536-990211",
    "website": "https://www.sassuolautoservice.bmw.it",
    "coords": {
      "lat": 44.54399108886719,
      "lng": 10.762395858764648
    }
  },
  {
    "id": "42829_1",
    "name": "AICARDI SRL",
    "country": "IT",
    "city": "MILANO",
    "address": "Via Losanna, 40, 20154 MILANO",
    "email": "info@aicardi.it",
    "phone": "+39-02-314157",
    "website": "https://www.aicardi.bmw.it",
    "coords": {
      "lat": 45.48676681518555,
      "lng": 9.165271759033203
    }
  },
  {
    "id": "47040_1",
    "name": "BIEMME MOTORI SRL",
    "country": "IT",
    "city": "MARIANO COMENSE",
    "address": "VIA COMO, 68, 22066 MARIANO COMENSE",
    "email": "contatti@biemme-motori.com",
    "phone": "+39-031-3551808",
    "website": "https://www.sarmaservice.bmw.it/",
    "coords": {
      "lat": 45.712791442871094,
      "lng": 9.163800239562988
    }
  },
  {
    "id": "50927_1",
    "name": "PINAUTO GROUP S.r.l.",
    "country": "IT",
    "city": "CEPPALONI",
    "address": "S.S. 7APPIA Km 251, 82010 CEPPALONI",
    "email": "info@pinauto.com",
    "phone": "+39-0824-840801",
    "website": "https://www.pinauto.bmw.it",
    "coords": {
      "lat": 41.06769561767578,
      "lng": 14.711365699768066
    }
  },
  {
    "id": "48318_3",
    "name": "MALDARIZZI AUTOMOTIVE SPA",
    "country": "IT",
    "city": "Bari",
    "address": "Via F.lli Philips, 5, 70123 Bari",
    "email": "info@maldarizzi.com",
    "phone": "+39-080-5384111",
    "website": "https://www.maldarizzi.bmw.it",
    "coords": {
      "lat": 41.111366271972656,
      "lng": 16.806835174560547
    }
  },
  {
    "id": "47751_1",
    "name": "AUTO SOLE SERVICE SRL",
    "country": "IT",
    "city": "LEGNAGO",
    "address": "VIA ENRICO MATTEI, 7, 37045 LEGNAGO",
    "email": null,
    "phone": "+39-0442-629096",
    "website": null,
    "coords": {
      "lat": 45.1861686706543,
      "lng": 11.257096290588379
    }
  },
  {
    "id": "50789_1",
    "name": "F.LLI GORI LUCA E ANDREA SNC",
    "country": "IT",
    "city": "GROSSETO",
    "address": "VIA AURELIA NORD, R/1, 58100 GROSSETO",
    "email": "andrea.gori@fratelligori.service-bmw.com",
    "phone": "+39-0564-458871",
    "website": "https://gori.bmw.it/",
    "coords": {
      "lat": 42.787139892578125,
      "lng": 11.09412956237793
    }
  },
  {
    "id": "36398_3",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "ALBENGA",
    "address": "Regione Torre Pernice, 2/A, 17031 ALBENGA",
    "email": "infogino@ginospa.com",
    "phone": "+39-0182-571057",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 44.0691032409668,
      "lng": 8.170058250427246
    }
  },
  {
    "id": "34971_2",
    "name": "BONERA SPA DINAMICA - MANTOVA",
    "country": "IT",
    "city": "San Giorgio Bigarello",
    "address": "VIA EINSTEIN, 19, 46051 San Giorgio Bigarello",
    "email": "info@bonera.it",
    "phone": "+39-030-3696011",
    "website": "https://www.dinamica.bmw.it",
    "coords": {
      "lat": 45.15985870361328,
      "lng": 10.845474243164062
    }
  },
  {
    "id": "06962_8",
    "name": "AUTOCLUB SPA",
    "country": "IT",
    "city": "IMOLA",
    "address": "Via Provinciale Selice, 23 b, 40026 IMOLA",
    "email": "vendite@autoclub.conc-bmw.com",
    "phone": "+39-059-376500",
    "website": "https://www.autoclub.bmw.it",
    "coords": {
      "lat": 44.37129211425781,
      "lng": 11.731210708618164
    }
  },
  {
    "id": "05896_7",
    "name": "NUOVA SPORT CAR SPA",
    "country": "IT",
    "city": "ISOLA DELLE FEMMINE",
    "address": "Via delle Industrie, 77, 90040 ISOLA DELLE FEMMINE",
    "email": "info@nuovasportcar.com",
    "phone": "+39-091-6372245",
    "website": "https://www.nuovasportcar.bmw.it",
    "coords": {
      "lat": 38.1897087097168,
      "lng": 13.250874519348145
    }
  },
  {
    "id": "06060_3",
    "name": "ROLANDI AUTO SPA ROMANO BRUNO",
    "country": "IT",
    "city": "CASALE MONFERRATO",
    "address": "VIA G. BRODOLINI, 7, 15033 CASALE MONFERRATO",
    "email": "riccarda.rolandi@rolandiauto.conc-bmw.com",
    "phone": "+39-0142-456555",
    "website": "https://www.rolandiauto.bmw.it",
    "coords": {
      "lat": 45.124855041503906,
      "lng": 8.477605819702148
    }
  },
  {
    "id": "06224_1",
    "name": "AUTOABRUZZO SRL",
    "country": "IT",
    "city": "SAN GIOVANNI TEATINO - SAMBUCETO",
    "address": "Via Amendola, 300, 66020 SAN GIOVANNI TEATINO - SAMBUCETO",
    "email": "andrea.dilena@autoabruzzo.conc-bmw.com",
    "phone": "+39-085-432511",
    "website": "https://www.autoabruzzo.bmw.it",
    "coords": {
      "lat": 42.4359016418457,
      "lng": 14.19342041015625
    }
  },
  {
    "id": "21875_1",
    "name": "GECAR SPA",
    "country": "IT",
    "city": "GENOVA",
    "address": "Lungobisagno Dalmazia, 31, 16141 GENOVA",
    "email": "gianni.garbarino@gecar.conc-bmw.com",
    "phone": "+39-010-8377220",
    "website": "http://www.gecarservice.bmw.it",
    "coords": {
      "lat": 44.433650970458984,
      "lng": 8.961770057678223
    }
  },
  {
    "id": "40886_1",
    "name": "AUTOMERCATO STABIA SRL",
    "country": "IT",
    "city": "NAPOLI",
    "address": "VIA DELLE REPUBBLICHE MARINARE, 61, 80147 NAPOLI",
    "email": "info@automercatostabia.conc-bmw.com",
    "phone": "+39-081-2286911",
    "website": "https://www.automercatostabia.bmw.it",
    "coords": {
      "lat": 40.84467697143555,
      "lng": 14.305490493774414
    }
  },
  {
    "id": "02248_6",
    "name": "FIMAUTO SPA",
    "country": "IT",
    "city": "VERONA",
    "address": "VIA TORRICELLI, 44 ZAI, 37136 VERONA",
    "email": "info@fimautogemelli.it",
    "phone": "+39-045-8622044",
    "website": "https://www.gruppofimauto.bmw.it",
    "coords": {
      "lat": 45.41032028198242,
      "lng": 10.957265853881836
    }
  },
  {
    "id": "05864_4",
    "name": "AutoVanti S.r.l.",
    "country": "IT",
    "city": "CASALECCHIO DI RENO",
    "address": "Via Guido Rossa, 8, 40033 CASALECCHIO DI RENO",
    "email": "info@autovanti-bologna.it",
    "phone": "+39-051-6137811",
    "website": "https://www.vantigroup.bmw.it",
    "coords": {
      "lat": 44.48850631713867,
      "lng": 11.264049530029297
    }
  },
  {
    "id": "05864_5",
    "name": "AutoVanti S.r.l. AutoVanti Milano",
    "country": "IT",
    "city": "MILANO",
    "address": "VIA GUGLIELMO SILVA, 8, 20149 MILANO",
    "email": "info.milano@autovanti.it",
    "phone": "+39-02-4816095",
    "website": "https://www.autovantimilano.bmw.it",
    "coords": {
      "lat": 45.48052978515625,
      "lng": 9.150369644165039
    }
  },
  {
    "id": "05968_4",
    "name": "EMMEAUTO LECCE SRL",
    "country": "IT",
    "city": "MAGLIE",
    "address": "Via Luigi De Maggio, 5, 73024 MAGLIE",
    "email": "info.maglie@emmeautogroup.com",
    "phone": "+39-0836-426338",
    "website": "https://www.emmeautolecce.bmw.it",
    "coords": {
      "lat": 40.13446807861328,
      "lng": 18.288650512695312
    }
  },
  {
    "id": "05968_1",
    "name": "EMMEAUTO LECCE SRL",
    "country": "IT",
    "city": "LECCE",
    "address": "Superstrada Lecce - Brindisi, 11, 73100 LECCE",
    "email": "info.lecce@emmeautogroup.com",
    "phone": "+39-0832-398144",
    "website": "https://www.emmeautolecce.bmw.it",
    "coords": {
      "lat": 40.36623764038086,
      "lng": 18.161043167114258
    }
  },
  {
    "id": "06055_1",
    "name": "MORETTI BRUNO SRL",
    "country": "IT",
    "city": "PEGOGNAGA",
    "address": "Via San Francesco d'Assisi, 21, 46020 PEGOGNAGA",
    "email": "info@morettibruno.com",
    "phone": "+39-0376-558107",
    "website": "http://www.morettibruno.bmw.it",
    "coords": {
      "lat": 44.98834228515625,
      "lng": 10.842219352722168
    }
  },
  {
    "id": "06204_2",
    "name": "ERREEFFE GROUP SPA FERRARA MOTORI",
    "country": "IT",
    "city": "FERRARA",
    "address": "Via Guglielmo Marconi, 248, 44122 FERRARA",
    "email": "info@erreeffegroup.it",
    "phone": "+39-0532-771308",
    "website": "https://www.erreeffegroup.bmw.it",
    "coords": {
      "lat": 44.86113357543945,
      "lng": 11.602065086364746
    }
  },
  {
    "id": "06962_5",
    "name": "AUTOCLUB SPA AUTOCLUB SPA - Carpi",
    "country": "IT",
    "city": "CARPI",
    "address": "Viale Dell'Industria, 4, 41012 CARPI",
    "email": "vendite@autoclub.conc-bmw.com",
    "phone": "+39-059-643585",
    "website": "https://www.autoclub.bmw.it",
    "coords": {
      "lat": 44.78575134277344,
      "lng": 10.858769416809082
    }
  },
  {
    "id": "06976_1",
    "name": "M C MOTORS di R.Mari e C.Clementi snc",
    "country": "IT",
    "city": "ASCOLI PICENO",
    "address": "Via Del Commercio, 3, 63100 ASCOLI PICENO",
    "email": "info@mcmotors.service-bmw.com",
    "phone": "+39-0736-341070",
    "website": "http://www.mcmotors.bmw.it",
    "coords": {
      "lat": 42.84675598144531,
      "lng": 13.61289119720459
    }
  },
  {
    "id": "22291_3",
    "name": "TARGET SRL",
    "country": "IT",
    "city": "ALBA",
    "address": "CORSO ASTI, 18, 12051 ALBA",
    "email": "info@biautogroup.com",
    "phone": "+39-0173-387005",
    "website": "https://www.target.bmw.it",
    "coords": {
      "lat": 44.711700439453125,
      "lng": 8.028860092163086
    }
  },
  {
    "id": "24380_7",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "LIVORNO",
    "address": "VIA DELLE CATERATTE 96, 57122 LIVORNO",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0586-188147",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.56707000732422,
      "lng": 10.313961029052734
    }
  },
  {
    "id": "26559_7",
    "name": "ACTIVA SPA AUTO IKARO",
    "country": "IT",
    "city": "BOLZANO",
    "address": "Via Siemens, 4, 39100 BOLZANO",
    "email": "info@activabmw.it",
    "phone": "+39-0471-546000",
    "website": "https://autoikaro.bmw.it/",
    "coords": {
      "lat": 46.48263931274414,
      "lng": 11.331399917602539
    }
  },
  {
    "id": "26559_6",
    "name": "ACTIVA SPA",
    "country": "IT",
    "city": "VILLA LAGARINA",
    "address": "VIA ZANDONAI, 119, 38060 VILLA LAGARINA",
    "email": "info@activabmw.it",
    "phone": "+39-0464-490091",
    "website": "https://www.activa.bmw.it",
    "coords": {
      "lat": 45.91191482543945,
      "lng": 11.03197956085205
    }
  },
  {
    "id": "27998_3",
    "name": "STILE SPA CAR POINT PESARO",
    "country": "IT",
    "city": "PESARO",
    "address": "STRADA DELLA ROMAGNA, 161/3, 61121 PESARO",
    "email": "servizio.clienti@stile.conc-bmw.com",
    "phone": "+39-0721-288511",
    "website": "https://www.carpoint.bmw.it",
    "coords": {
      "lat": 43.93352508544922,
      "lng": 12.844141006469727
    }
  },
  {
    "id": "32332_1",
    "name": "MJ CAR SRL",
    "country": "IT",
    "city": "NOLA",
    "address": "Via Circumvallazione, 132, 80035 NOLA",
    "email": "assistenza@mjcar.it",
    "phone": "+39-081-5126341",
    "website": "https://www.mjcar.bmw.it",
    "coords": {
      "lat": 40.91825485229492,
      "lng": 14.533327102661133
    }
  },
  {
    "id": "35910_1",
    "name": "GRUPPO MAROTTA SRL",
    "country": "IT",
    "city": "POLLA",
    "address": "VIA SS 19 KM58+400, 84035 POLLA",
    "email": "niclo.marotta@marotta.service-bmw.com",
    "phone": "+39-0975-391060",
    "website": "https://www.gruppomarotta.bmw.it",
    "coords": {
      "lat": 40.50315475463867,
      "lng": 15.520313262939453
    }
  },
  {
    "id": "36398_8",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "MASSA",
    "address": "VIA DEGLI OLIVETI, 113, 54100 MASSA",
    "email": "ginoweb@ginospa.com",
    "phone": "+39-0171-410777",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 44.024234771728516,
      "lng": 10.108448028564453
    }
  },
  {
    "id": "36398_10",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "BIELLA",
    "address": "Via Candelo 6, 13900 BIELLA",
    "email": "ginoweb@ginospa.com",
    "phone": "+39-015-8408148",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 45.554744720458984,
      "lng": 8.06485366821289
    }
  },
  {
    "id": "39135_13",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "COMO",
    "address": "VIA ASIAGO, 71 - TAVERNOLA, 22100 COMO",
    "email": "info.tavernola@autotorino.it",
    "phone": "+39-031-3443711",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.84040451049805,
      "lng": 9.046345710754395
    }
  },
  {
    "id": "39135_14",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "VARESE",
    "address": "VIALE AGUGGIARI, 138, 21100 VARESE",
    "email": "info.varese2@autotorino.it",
    "phone": "+39-0332-244111",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.83639144897461,
      "lng": 8.817944526672363
    }
  },
  {
    "id": "39135_20",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "CARITA' DI VILLORBA",
    "address": "Via Roma, 141/A, 31020 CARITA' DI VILLORBA",
    "email": "info.villorba.bmw@autotorino.it",
    "phone": "+39-0422-1838411",
    "website": "http://www.autotorino-villorba.mini.it/",
    "coords": {
      "lat": 45.72228240966797,
      "lng": 12.253853797912598
    }
  },
  {
    "id": "39135_17",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "TRIESTE",
    "address": "Via Flavia,134, 34147 TRIESTE",
    "email": "info.trieste@autotorino.it",
    "phone": "+39-040-827032",
    "website": "http://www.autotorino-trieste.mini.it/",
    "coords": {
      "lat": 45.60835647583008,
      "lng": 13.814390182495117
    }
  },
  {
    "id": "40646_3",
    "name": "AD PUGLIESE SPA",
    "country": "IT",
    "city": "Ragusa",
    "address": "S.P.25 Ragusa-Marina di RG KM 2.5, 97100 Ragusa",
    "email": "pugliese@usersdesk.it",
    "phone": "+39-0932-080670",
    "website": "https://www.adpugliese.bmw.it",
    "coords": {
      "lat": 36.88567352294922,
      "lng": 14.685948371887207
    }
  },
  {
    "id": "45727_1",
    "name": "AUTONOVA MILANO SRL",
    "country": "IT",
    "city": "MILANO",
    "address": "VIA PELLEGRINO ROSSI, 9/11, 20161 MILANO",
    "email": "francesco.casuscelli@autonova.service-bmw.com",
    "phone": "+39-02-66201336",
    "website": "http://www.autonova-milano.bmw.it/",
    "coords": {
      "lat": 45.50761032104492,
      "lng": 9.17783260345459
    }
  },
  {
    "id": "05967_1",
    "name": "BORGOGNONI SRL",
    "country": "IT",
    "city": "ROMA",
    "address": "Via A. Fusco, 23, 00136 ROMA",
    "email": "info@borgognonibmw.it",
    "phone": "+39-06-35450904",
    "website": "http://www.borgognoni.bmw.it",
    "coords": {
      "lat": 41.923011779785156,
      "lng": 12.437167167663574
    }
  },
  {
    "id": "51394_2",
    "name": "IONA' MOTORI SRL CALABRIA MOTORI",
    "country": "IT",
    "city": "RENDE",
    "address": "Via Ermanno Stradelli, 9, 87036 RENDE",
    "email": "info@calabriamotori.org",
    "phone": "+39-0965-1659051",
    "website": "https://calabriamotori.bmw.it/",
    "coords": {
      "lat": 39.36520767211914,
      "lng": 16.252681732177734
    }
  },
  {
    "id": "52771_1",
    "name": "AUTOVANTI SARONNO S.R.L.",
    "country": "IT",
    "city": "SARONNO",
    "address": "Via Luigi Sampietro, 146, 21047 SARONNO",
    "email": "nuovo.saronno@autovanti.it",
    "phone": "+39-02-9628881",
    "website": "https://autovantisaronno.bmw.it/",
    "coords": {
      "lat": 45.613258361816406,
      "lng": 9.024229049682617
    }
  },
  {
    "id": "09298_5",
    "name": "SPECIAL CAR SPA",
    "country": "IT",
    "city": "SASSARI",
    "address": "Z.I. PREDDA NIEDDA STR. 14, CIV. 12, 07100 SASSARI",
    "email": "nicola.vacca@specialcar.conc-bmw.com",
    "phone": "+39-079-9149501",
    "website": "https://www.specialcar.bmw.it",
    "coords": {
      "lat": 40.72840881347656,
      "lng": 8.532590866088867
    }
  },
  {
    "id": "20019_5",
    "name": "LARIO BERGAUTO SPA",
    "country": "IT",
    "city": "Grumello del Monte",
    "address": "Via Brescia, 78, 24064 Grumello del Monte",
    "email": "commerciale.gdm@mobility.it",
    "phone": "+39-035-830914",
    "website": "https://www.lariobergauto.bmw.it",
    "coords": {
      "lat": 45.630367279052734,
      "lng": 9.8800630569458
    }
  },
  {
    "id": "20751_2",
    "name": "AUTOPRESTIGE SRL",
    "country": "IT",
    "city": "OLBIA",
    "address": "Localita' Colgo' - Zona Aeroporto, 07026 OLBIA",
    "email": "giusy.chessa@autoprestige.conc-bmw.com",
    "phone": "+39-0789-66839",
    "website": "http://www.autoprestige.bmw.it",
    "coords": {
      "lat": 40.90720748901367,
      "lng": 9.506537437438965
    }
  },
  {
    "id": "20751_3",
    "name": "AUTOPRESTIGE SRL",
    "country": "IT",
    "city": "CAGLIARI",
    "address": "VIALE MONASTIR, 219, 09122 CAGLIARI",
    "email": "massimo.mele@pimaxgroup.it",
    "phone": "+39-070-7628100",
    "website": "https://www.bmw-motorrad.it/autoprestige-sassari/it/home.html",
    "coords": {
      "lat": 39.24102783203125,
      "lng": 9.096997261047363
    }
  },
  {
    "id": "21582_10",
    "name": "BMW ITALIA RETAIL SRL BMW ROMA",
    "country": "IT",
    "city": "ROMA",
    "address": "Via Appia Nuova, 1257/A, 00178 ROMA",
    "email": "info@bmwroma.bmw.it",
    "phone": "+39-06-7129041",
    "website": "https://www.bmwroma.bmw.it",
    "coords": {
      "lat": 41.815513610839844,
      "lng": 12.571303367614746
    }
  },
  {
    "id": "21582_13",
    "name": "BMW ITALIA RETAIL SRL BMW ROMA",
    "country": "IT",
    "city": "ROMA",
    "address": "VIA BARBERINI, 92/100, 00187 ROMA",
    "email": "info@bmwroma.bmw.it",
    "phone": "+39-06-88282600",
    "website": "https://www.bmwroma.bmw.it",
    "coords": {
      "lat": 41.90472412109375,
      "lng": 12.493171691894531
    }
  },
  {
    "id": "21875_2",
    "name": "GECAR SPA",
    "country": "IT",
    "city": "CHIAVARI",
    "address": "Via Fiume, 1, 16043 CHIAVARI",
    "email": "gianni.garbarino@gecar.conc-bmw.com",
    "phone": "+39-0185-370010",
    "website": "https://www.bmw-motorrad.it/gecar-chiavari/it/home.html",
    "coords": {
      "lat": 44.32014083862305,
      "lng": 9.319890022277832
    }
  },
  {
    "id": "24380_2",
    "name": "BIRINDELLI AUTO SRL",
    "country": "IT",
    "city": "MONSUMMANO TERME",
    "address": "Via Lorenzo Billi, 2-4, 51015 MONSUMMANO TERME",
    "email": "birindelli@birindelli.com",
    "phone": "+39-0572-520224",
    "website": "https://www.birindelli.bmw.it",
    "coords": {
      "lat": 43.8681755065918,
      "lng": 10.806955337524414
    }
  },
  {
    "id": "28227_1",
    "name": "CECCATO MOTORS SRL",
    "country": "IT",
    "city": "PADOVA",
    "address": "Via Venezia, 17, 35131 PADOVA",
    "email": "info@ceccato.conc-bmw.com",
    "phone": "+39-049-8062600",
    "website": "https://www.ceccato.bmw.it",
    "coords": {
      "lat": 45.410911560058594,
      "lng": 11.8960599899292
    }
  },
  {
    "id": "28227_5",
    "name": "CECCATO MOTORS SRL",
    "country": "IT",
    "city": "CASTELFRANCO VENETO",
    "address": "VIA CIRCONVALLAZIONE EST, 6/A, 31033 CASTELFRANCO VENETO",
    "email": "info@ceccatomotors.com",
    "phone": "+39-0423-422500",
    "website": "https://www.ceccato.bmw.it",
    "coords": {
      "lat": 45.68393325805664,
      "lng": 11.929290771484375
    }
  },
  {
    "id": "29626_1",
    "name": "MARIO MARANGONI E FIGLI SAS",
    "country": "IT",
    "city": "LATINA",
    "address": "Via Monte Gemma, 2, 04100 LATINA",
    "email": "paolo.marangoni@marangoni.service-bmw.com",
    "phone": "+39-0773-691891",
    "website": "http://www.marangoni.bmw.it",
    "coords": {
      "lat": 41.47886657714844,
      "lng": 12.909429550170898
    }
  },
  {
    "id": "33576_1",
    "name": "CAMI SRL",
    "country": "IT",
    "city": "POMEZIA",
    "address": "VIA BOLIVIA, 5, 00071 POMEZIA",
    "email": "camiweb@camiweb.it",
    "phone": "+39-06-9108666",
    "website": "http://www.cami.bmw.it",
    "coords": {
      "lat": 41.66500473022461,
      "lng": 12.519914627075195
    }
  },
  {
    "id": "33848_1",
    "name": "RIVOLTELLA SPA",
    "country": "IT",
    "city": "ARCENE",
    "address": "Via del Gaggiolo, 1, 24040 ARCENE",
    "email": "info@rivoltellagroup.it",
    "phone": "+39-035-4199311",
    "website": "https://www.rivoltella.bmw.it",
    "coords": {
      "lat": 45.567970275878906,
      "lng": 9.612143516540527
    }
  },
  {
    "id": "39135_21",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "BELLUNO",
    "address": "VIA MASI SIMONETTI, 1, 32100 BELLUNO",
    "email": "info.belluno.bmw@autotorino.it",
    "phone": "+39-0437-355113",
    "website": "http://www.autotorino-belluno.mini.it/",
    "coords": {
      "lat": 46.15790939331055,
      "lng": 12.235143661499023
    }
  },
  {
    "id": "40646_1",
    "name": "AD PUGLIESE SPA",
    "country": "IT",
    "city": "CALTANISSETTA",
    "address": "VIA SANTO SPIRITO 102, 93100 CALTANISSETTA",
    "email": "pugliese@usersdesk.it",
    "phone": "+39-0934-566166",
    "website": "https://adpugliese.bmw.it/",
    "coords": {
      "lat": 37.50539016723633,
      "lng": 14.081768989562988
    }
  },
  {
    "id": "43214_2",
    "name": "AMBROSI AUTO SPA",
    "country": "IT",
    "city": "VITERBO",
    "address": "S.S. CASSIA NORD KM 85.900, 01100 VITERBO",
    "email": "relazioniclienti@ambrosispa.it",
    "phone": "+39-0761-159131",
    "website": "https://www.ambrosiauto.bmw.it",
    "coords": {
      "lat": 42.44765090942383,
      "lng": 12.086251258850098
    }
  },
  {
    "id": "06119_3",
    "name": "TULLO PEZZO SRL",
    "country": "IT",
    "city": "CASTIGLIONE DELLE STIVIERE",
    "address": "Via Mazzini, 28/Z, 46043 CASTIGLIONE DELLE STIVIERE",
    "email": "vendite@tullopezzo.conc-bmw.com",
    "phone": "+39-0376-636884",
    "website": "http://www.tullopezzo.bmw.it",
    "coords": {
      "lat": 45.38271713256836,
      "lng": 10.493016242980957
    }
  },
  {
    "id": "09298_2",
    "name": "SPECIAL CAR SPA",
    "country": "IT",
    "city": "ELMAS",
    "address": "Via  Sernagiotto 24/28, 09030 ELMAS",
    "email": "nicola.vacca@specialcar.conc-bmw.com",
    "phone": "+39-070-241181",
    "website": "https://www.specialcar.bmw.it",
    "coords": {
      "lat": 39.25419998168945,
      "lng": 9.076201438903809
    }
  },
  {
    "id": "29861_2",
    "name": "L'AUTOMOBILE SRL",
    "country": "IT",
    "city": "FORMIA",
    "address": "SR 630 AUSONIA FORMIA CASSINO, 04023 FORMIA",
    "email": "info@automobilebmw.it",
    "phone": "+39-800-709990",
    "website": "https://www.automobile.bmw.it",
    "coords": {
      "lat": 41.27558135986328,
      "lng": 13.699918746948242
    }
  },
  {
    "id": "30807_1",
    "name": "PROCAR SRL",
    "country": "IT",
    "city": "MISTERBIANCO",
    "address": "Via George Marshall, 7, 95045 MISTERBIANCO",
    "email": "giovanni.viola@procarct.service-bmw.com",
    "phone": "+39-095-473963",
    "website": "https://www.bmw-motorrad.it/procar-misterbianco/it/home.html",
    "coords": {
      "lat": 37.51259994506836,
      "lng": 15.034350395202637
    }
  },
  {
    "id": "33294_1",
    "name": "CASCIOLI SPA",
    "country": "IT",
    "city": "S.BENEDETTO DEL TRONTO",
    "address": "Via Liberazione, 194, 63074 S.BENEDETTO DEL TRONTO",
    "email": "servizioclienti@cascioli.conc-bmw.com",
    "phone": "+39-085-807591",
    "website": "http://www.cascioli.bmw-motorrad.it",
    "coords": {
      "lat": 42.9266471862793,
      "lng": 13.884844779968262
    }
  },
  {
    "id": "35258_1",
    "name": "FN AUTO SRL",
    "country": "IT",
    "city": "TORINO",
    "address": "CORSO CINCINNATO, 250, 10151 TORINO",
    "email": "info@fnautosrl.it",
    "phone": "+39-011-7399435",
    "website": "https://www.fnauto.bmw.it",
    "coords": {
      "lat": 45.10457229614258,
      "lng": 7.653611183166504
    }
  },
  {
    "id": "33537_1",
    "name": "BORRAUTO SRL",
    "country": "IT",
    "city": "MONTEBELLUNA",
    "address": "VIA SCHIAVONESCA PRIULA, 83, 31044 MONTEBELLUNA",
    "email": "ivan.rigato@borrauto.it",
    "phone": "+39-0423-302621",
    "website": "https://www.borrauto.bmw.it",
    "coords": {
      "lat": 45.780845642089844,
      "lng": 12.073116302490234
    }
  },
  {
    "id": "35419_1",
    "name": "ELETTRODIESEL CAMPATELLI",
    "country": "IT",
    "city": "BARBERINO VAL D'ELSA",
    "address": "VIA F. PETRARCA, 2, 50021 BARBERINO VAL D'ELSA",
    "email": "info@elettrodieselcampatelli.it",
    "phone": "+39-055-8078571",
    "website": "https://www.elettrodieselcampatelli.bmw.it",
    "coords": {
      "lat": 43.483577728271484,
      "lng": 11.132455825805664
    }
  },
  {
    "id": "36398_1",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "MADONNA DELL'OLMO",
    "address": "VIA F.LLI CEIRANO, 15/17, 12020 MADONNA DELL'OLMO",
    "email": "ginoweb@ginospa.com",
    "phone": "+39-0171-410700",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 44.42265319824219,
      "lng": 7.563443183898926
    }
  },
  {
    "id": "36398_7",
    "name": "GINO AUTO SRL",
    "country": "IT",
    "city": "LA SPEZIA",
    "address": "VIALE SAN BARTOLOMEO 623, 19126 LA SPEZIA",
    "email": "ginoweb@ginospa.com",
    "phone": "+39-0171-503437",
    "website": "https://www.gino.bmw.it",
    "coords": {
      "lat": 44.10866165161133,
      "lng": 9.856599807739258
    }
  },
  {
    "id": "39135_8",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "GATTICO",
    "address": "S.S.142 BORGOMANERO - ARONA SNC, 28013 GATTICO",
    "email": "info.gattico@autotorino.it",
    "phone": "+39-0322-867411",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.71609878540039,
      "lng": 8.485159873962402
    }
  },
  {
    "id": "39135_15",
    "name": "AUTOTORINO SPA",
    "country": "IT",
    "city": "VARESE",
    "address": "VIA GIAMBOLOGNA, 52, 21100 VARESE",
    "email": "info.varese2@autotorino.it",
    "phone": "+39-0332-244111",
    "website": "https://www.autotorino.bmw.it",
    "coords": {
      "lat": 45.831825256347656,
      "lng": 8.836309432983398
    }
  },
  {
    "id": "40886_3",
    "name": "AUTOMERCATO STABIA SRL",
    "country": "IT",
    "city": "Castellammare di Stabia",
    "address": "Via Annunziatella,36, 80053 Castellammare di Stabia",
    "email": "info@automercatostabia.conc-bmw.com",
    "phone": "+39-081-8705428",
    "website": "https://www.automercatostabia.bmw.it",
    "coords": {
      "lat": 40.712799072265625,
      "lng": 14.489339828491211
    }
  },
  {
    "id": "43828_1",
    "name": "MARCHETTI POTITO SRL",
    "country": "IT",
    "city": "FOGGIA",
    "address": "VIA DI SAN GIULIANO 17/19, 71100 FOGGIA",
    "email": "gerardo@marchetti.service-bmw.com",
    "phone": "+39-0881-568667",
    "website": "https://www.marchettipotito.bmw.it",
    "coords": {
      "lat": 41.47182083129883,
      "lng": 15.552860260009766
    }
  },
  {
    "id": "51539_3",
    "name": "BRANDINI S.P.A.",
    "country": "IT",
    "city": "PISTOIA",
    "address": "VIA FERMI-ZONA S.AGOSTINO, 5, 51100 PISTOIA",
    "email": "info@brandini.it",
    "phone": "+39-840-055055",
    "website": "https://www.brandini.bmw.it",
    "coords": {
      "lat": 43.932228088378906,
      "lng": 10.929150581359863
    }
  },
  {
    "id": "05944_3",
    "name": "ULTRAMOTOR SRL",
    "country": "IT",
    "city": "TRIGGIANO",
    "address": "Strada Statale 16 KM 810, 200, 70019 TRIGGIANO",
    "email": "customer.care@ultramotor.conc-bmw.com",
    "phone": "+39-080-8406357",
    "website": "https://www.ultramotor.bmw.it",
    "coords": {
      "lat": 41.09196090698242,
      "lng": 16.957120895385742
    }
  },
  {
    "id": "51539_4",
    "name": "BRANDINI S.P.A.",
    "country": "IT",
    "city": "FIRENZE SUD",
    "address": "Lungo L'Ema 19/23, 50012 FIRENZE SUD",
    "email": "info@brandini.it",
    "phone": "+39-840-055055",
    "website": "https://www.brandini.bmw.it",
    "coords": {
      "lat": 43.741939544677734,
      "lng": 11.285039901733398
    }
  },
  {
    "id": "51021_2",
    "name": "BM BymyCar Milano S.r.l. BYmyCAR Milano",
    "country": "IT",
    "city": "MILANO",
    "address": "Via De Amicis, 20-22, 20123 MILANO",
    "email": "sales.bmw.deamicis@bymycar.it",
    "phone": "+39-02-81273077",
    "website": "https://bymycar-milano.bmw.it/",
    "coords": {
      "lat": 45.45855712890625,
      "lng": 9.178841590881348
    }
  },
  {
    "id": "20595_1",
    "name": "FORMULA 3 SPA",
    "country": "IT",
    "city": "MESSINA",
    "address": "Via Orso Mario Corbino ZIR, 98124 MESSINA",
    "email": "info@formula3.conc-bmw.com",
    "phone": "+39-090-2982711",
    "website": "https://www.formula3.bmw.it",
    "coords": {
      "lat": 38.16456604003906,
      "lng": 15.542885780334473
    }
  },
  {
    "id": "53760_1",
    "name": "Medecar S.r.l.",
    "country": "IT",
    "city": "Tito",
    "address": "Contrada Santa Loja, 85050 Tito",
    "email": "servicebmwmini@medecar.it",
    "phone": "+39-0971-1790045",
    "website": null,
    "coords": {
      "lat": 40.610130310058594,
      "lng": 15.715962409973145
    }
  },
  {
    "id": "01349_1",
    "name": "Talleres Sebas, S.A.",
    "country": "ES",
    "city": "Soria",
    "address": "Avda. de Valladolid, s/n, 42005 Soria",
    "email": "rclientes@sebas.net.bmw.es",
    "phone": "+34-975233675",
    "website": "https://talleresebas.tallerautorizadobmw.es",
    "coords": {
      "lat": 41.76942443847656,
      "lng": -2.488874912261963
    }
  },
  {
    "id": "09911_3",
    "name": "Automoviles Fersan, S.A.",
    "country": "ES",
    "city": "El Verger",
    "address": "Avda. Valencia, 27, 03770 El Verger",
    "email": "rclientes@fersan.net.bmw.es",
    "phone": "+34-966439804",
    "website": "https://benigar-vergel.concesionariobmw.es",
    "coords": {
      "lat": 38.84907913208008,
      "lng": 0.0055069997906684875
    }
  },
  {
    "id": "06662_2",
    "name": "Engasa, S.A.",
    "country": "ES",
    "city": "Valencia",
    "address": "Avda. Ausias March 190, 46026 Valencia",
    "email": "engasa@engasa.net.bmw.es",
    "phone": "+34-963755008",
    "website": "https://engasa-pistadesilla.concesionariobmw.es/es",
    "coords": {
      "lat": 39.42692184448242,
      "lng": -0.3722529113292694
    }
  },
  {
    "id": "31982_1",
    "name": "AC 99 Motor, S.L.",
    "country": "ES",
    "city": "Marbella",
    "address": "P.I. Las Albarizas-C/. Pirita, esq., 29603 Marbella",
    "email": "servicio@ac99.net.bmw.es",
    "phone": "+34-952900012",
    "website": "https://acmotor99.tallerautorizadobmw.es",
    "coords": {
      "lat": 36.510684967041016,
      "lng": -4.870802879333496
    }
  },
  {
    "id": "29642_1",
    "name": "La Flecha Motor. S.L.U.",
    "country": "ES",
    "city": "Valladolid",
    "address": "Avenida de  Salamanca, 108, 47197 Valladolid",
    "email": "rclientes@laflecha.net.bmw.es",
    "phone": "+34-983408282",
    "website": "https://laflechamotor.tallerautorizadobmw.es",
    "coords": {
      "lat": 41.625877380371094,
      "lng": -4.764150142669678
    }
  },
  {
    "id": "32690_1",
    "name": "Asturcar Automoción, S.A.",
    "country": "ES",
    "city": "Gijón",
    "address": "Avda. del Transporte, 12, 33211 Gijón",
    "email": "asturcar@asturcar.net.bmw.es",
    "phone": "+34-985146227",
    "website": "http://asturcar.tallerautorizadobmw.es",
    "coords": {
      "lat": 43.52983856201172,
      "lng": -5.705286979675293
    }
  },
  {
    "id": "20839_3",
    "name": "Murcia Premium, S.L.",
    "country": "ES",
    "city": "Murcia",
    "address": "Avda. del Rocío, 4, 30007 Murcia",
    "email": "rclientes@murciapremium.net.bmw.es",
    "phone": "+34-968201021",
    "website": "https://murciapremium.concesionariobmw.es",
    "coords": {
      "lat": 37.99264144897461,
      "lng": -1.1161220073699951
    }
  },
  {
    "id": "33207_1",
    "name": "Tormes Motor, S.A.",
    "country": "ES",
    "city": "Carbajosa de la Sagrada",
    "address": "C/. Salamanca, 51, 37188 Carbajosa de la Sagrada",
    "email": "tormesmotor@tormesmotor.com",
    "phone": "+34-923197777",
    "website": "https://tormesmotor.concesionariobmw.es",
    "coords": {
      "lat": 40.94118881225586,
      "lng": -5.655127048492432
    }
  },
  {
    "id": "39233_1",
    "name": "Autoberón, S.L.",
    "country": "ES",
    "city": "Logroño",
    "address": "c/ Circunde, 40-42, 26006 Logroño",
    "email": "rclientes@bmwautoberon.es",
    "phone": "+34-941240783",
    "website": "https://autoberon.concesionariobmw.es",
    "coords": {
      "lat": 42.45869064331055,
      "lng": -2.3915090560913086
    }
  },
  {
    "id": "51827_2",
    "name": "BYMYCAR Madrid, S.L.U. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Algete",
    "address": "Calle Tejera, 2- Ctra. Algete km. 3, 28111 Algete",
    "email": "bmw.madrid@bymycar.es",
    "phone": "+34-913351900",
    "website": "https://bmwbymycar.concesionariobmw.es",
    "coords": {
      "lat": 40.58879470825195,
      "lng": -3.5421218872070312
    }
  },
  {
    "id": "09911_6",
    "name": "Automoviles Fersan, S.A.",
    "country": "ES",
    "city": "Alzira",
    "address": "Avda. del Drets Humans, s/n, 46600 Alzira",
    "email": "rclientes@fersan.net.bmw.es",
    "phone": "+34-962459062",
    "website": "https://benigar-alzira.concesionariobmw.es",
    "coords": {
      "lat": 39.164588928222656,
      "lng": -0.4212679862976074
    }
  },
  {
    "id": "39349_1",
    "name": "Oliva Motor Gavarres, S.L.U.",
    "country": "ES",
    "city": "Tarragona",
    "address": "Carrer Josep Mª Folch i Torres, 2, 43006 Tarragona",
    "email": "rclients.tarragona@olivamotor.com",
    "phone": "+34-618219657",
    "website": "https://olivamotor.concesionariobmw.es",
    "coords": {
      "lat": 41.129676818847656,
      "lng": 1.1996920108795166
    }
  },
  {
    "id": "41672_2",
    "name": "Albamocion, S.L.",
    "country": "ES",
    "city": "Ciudad Real",
    "address": "Avenida de la Ciencia, 10, 13005 Ciudad Real",
    "email": "rclientescr@albamocion.net.bmw.es",
    "phone": "+34-926971151",
    "website": "https://albamocion-ciudadreal.concesionariobmw.es/es",
    "coords": {
      "lat": 38.98556900024414,
      "lng": -3.909635066986084
    }
  },
  {
    "id": "46347_4",
    "name": "Oliva Motor Girona, S.L.U. Figueres",
    "country": "ES",
    "city": "Figueres",
    "address": "Vilatenim, 35, 17600 Figueres",
    "email": "rclients.girona@olivamotor.com",
    "phone": "+34-972513758",
    "website": "https://olivamotorgirona-figueras.concesionariobmw.es",
    "coords": {
      "lat": 42.26969909667969,
      "lng": 2.9769999980926514
    }
  },
  {
    "id": "09144_4",
    "name": "San Pablo Motor, S.L.",
    "country": "ES",
    "city": "Tomares",
    "address": "Avda. del Aljarafe s/n, 41940 Tomares",
    "email": "ventasdigitalsanpablomotor@sanpablomotor.es",
    "phone": "+34-955519050",
    "website": "https://sanpablomotor.concesionariobmw.es/",
    "coords": {
      "lat": 37.36836624145508,
      "lng": -6.037889003753662
    }
  },
  {
    "id": "09901_2",
    "name": "Hispamovil, S.A.",
    "country": "ES",
    "city": "Torrevieja",
    "address": "Urbanización El Limonar II, 03180 Torrevieja",
    "email": "rclientes@hispamovil.net.bmw.es",
    "phone": "+34-966789609",
    "website": "https://benigar-torrevieja.concesionariobmw.es",
    "coords": {
      "lat": 38.002811431884766,
      "lng": -0.6932790279388428
    }
  },
  {
    "id": "33284_7",
    "name": "Ibericar Barcelona Premium S.L. Sant Boi",
    "country": "ES",
    "city": "Sant Boi de Llobregat",
    "address": "Ctra. del Prat, 15, 08830 Sant Boi de Llobregat",
    "email": "marketing@barcelonapremium.net.bmw.es",
    "phone": "+34-933319800",
    "website": "https://barcelonapremium-santboi.concesionariobmw.es",
    "coords": {
      "lat": 41.33494567871094,
      "lng": 2.051661968231201
    }
  },
  {
    "id": "33948_1",
    "name": "Pruna Motor, S.L. Granollers",
    "country": "ES",
    "city": "Granollers",
    "address": "Ctra. C-17, Km. 19,060, 08403 Granollers",
    "email": "rclientes@prunamotor.net.bmw.es",
    "phone": "+34-938618923",
    "website": "https://prunamotor.concesionariobmw.es",
    "coords": {
      "lat": 41.592830657958984,
      "lng": 2.2619330883026123
    }
  },
  {
    "id": "20822_4",
    "name": "Canarioalemana del Automóvil, S.L Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "San Miguel de Abona",
    "address": "Avda. Claudio Delgado Díaz, 55, 38639 San Miguel de Abona",
    "email": "rclientes@canaauto.net.bmw.es",
    "phone": "+34-922629292",
    "website": "https://canaauto.concesionariobmw.es",
    "coords": {
      "lat": 28.04996109008789,
      "lng": -16.62122344970703
    }
  },
  {
    "id": "33284_2",
    "name": "Ibericar Barcelona Premium S.L. Ronda de Dalt",
    "country": "ES",
    "city": "Barcelona",
    "address": "C/. Esteve Terrades, 77-79, 08023 Barcelona",
    "email": "marketing@barcelonapremium.net.bmw.es",
    "phone": "+34-933319800",
    "website": "https://barcelonapremium-esteveterrades.tallerautorizadobmw.es",
    "coords": {
      "lat": 41.41499328613281,
      "lng": 2.139396905899048
    }
  },
  {
    "id": "39349_2",
    "name": "Oliva Motor Gavarres, S.L.U.",
    "country": "ES",
    "city": "Tortosa",
    "address": "Ctra. de Tortosa a la Aldea, Km, 2, 43500 Tortosa",
    "email": "rclients.tarragona@olivamotor.com",
    "phone": "+34-676324084",
    "website": "https://olivamotor.concesionariobmw.es/",
    "coords": {
      "lat": 40.784934997558594,
      "lng": 0.5246704816818237
    }
  },
  {
    "id": "46347_1",
    "name": "Oliva Motor Girona, S.L.U.",
    "country": "ES",
    "city": "Salt",
    "address": "C/ De Lingen, 9-11, 17190 Salt",
    "email": "rclients.girona@olivamotor.com",
    "phone": "+34-972246263",
    "website": "https://olivamotorgirona.concesionariobmw.es",
    "coords": {
      "lat": 41.968994140625,
      "lng": 2.7799301147460938
    }
  },
  {
    "id": "20285_4",
    "name": "Ceres Motor, S.L.",
    "country": "ES",
    "city": "Badajoz",
    "address": "Autovía Madrid- Lisboa, Km. 398,9, 06009 Badajoz",
    "email": "mandelmotor@mandelmotor.net.bmw.es",
    "phone": "+34-924240502",
    "website": "https://ceresmotor-mandelmotorbadajoz.concesionariobmw.es",
    "coords": {
      "lat": 38.87554168701172,
      "lng": -6.952499866485596
    }
  },
  {
    "id": "09926_1",
    "name": "Burgocar Comercial del Automóvil SA",
    "country": "ES",
    "city": "Burgos",
    "address": "Ctra. Logroño, Km.109, 09007 Burgos",
    "email": "burgocar@burgocar.es",
    "phone": "+34-947484350",
    "website": "https://burgocar.concesionariobmw.es",
    "coords": {
      "lat": 42.344932556152344,
      "lng": -3.6481759548187256
    }
  },
  {
    "id": "20285_1",
    "name": "Ceres Motor, S.L.",
    "country": "ES",
    "city": "Cáceres",
    "address": "C./Molineros, 10, 10005 Cáceres",
    "email": "rclientes@ceresmotor.net.bmw.es",
    "phone": "+34-927235256",
    "website": "https://ceresmotor.concesionariobmw.es",
    "coords": {
      "lat": 39.489532470703125,
      "lng": -6.418066024780273
    }
  },
  {
    "id": "39428_2",
    "name": "Adler Motor, S.L.",
    "country": "ES",
    "city": "Cazalegas",
    "address": "Polígono Industrial Cazalegas, 45683 Cazalegas",
    "email": "rclientes@adlermotor.net.bmw.es",
    "phone": "+34-925869988",
    "website": "https://adlermotor-cazalegas.concesionariobmw.es",
    "coords": {
      "lat": 39.9778938293457,
      "lng": -4.740095138549805
    }
  },
  {
    "id": "07450_1",
    "name": "Vehinter, S.A.",
    "country": "ES",
    "city": "Getafe",
    "address": "Ctra. Madrid-Toledo,, 28905 Getafe",
    "email": "rclientes@vehinter.net.bmw.es",
    "phone": "+34-916835700",
    "website": "https://vehinter.concesionariobmw.es",
    "coords": {
      "lat": 40.291168212890625,
      "lng": -3.7402920722961426
    }
  },
  {
    "id": "08552_5",
    "name": "Auto Premier Baviera, S.A.",
    "country": "ES",
    "city": "Madrid",
    "address": "Carretera de Valencia, Km 7,3, 28031 Madrid",
    "email": "rclientes@autopremier.net.bmw.es",
    "phone": "+34-913322540",
    "website": "https://autopremier-madrid.concesionariobmw.es",
    "coords": {
      "lat": 40.38999938964844,
      "lng": -3.6222729682922363
    }
  },
  {
    "id": "34945_2",
    "name": "Automotor Premium, S.L.U.",
    "country": "ES",
    "city": "Marbella",
    "address": "Ctra. Nal. 340, Km. 175,3, 29660 Marbella",
    "email": "automotor@automotorpremium.net.bmw.es",
    "phone": "+34-952818800",
    "website": "https://automotor-marbella.concesionariobmw.es",
    "coords": {
      "lat": 36.49591064453125,
      "lng": -4.9496002197265625
    }
  },
  {
    "id": "34945_1",
    "name": "Automotor Premium, S.L.U.",
    "country": "ES",
    "city": "Málaga",
    "address": "Avda. Ortega y Gasset, 339, 29006 Málaga",
    "email": "hola.malaga@automotorpremium.com",
    "phone": "+34-952333600",
    "website": "https://automotor-malaga.concesionariobmw.es",
    "coords": {
      "lat": 36.7076416015625,
      "lng": -4.478089809417725
    }
  },
  {
    "id": "23332_2",
    "name": "San Rafael Motor, S.L. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Lucena",
    "address": "Ctra. Córdoba-Málaga, Km. 69, 14900 Lucena",
    "email": "ventasdigitalsanrafaelmotor@sanrafaelmotor.es",
    "phone": "+34-957509380",
    "website": "https://sanrafaelmotor.concesionariobmw.es/",
    "coords": {
      "lat": 37.422454833984375,
      "lng": -4.523353099822998
    }
  },
  {
    "id": "34945_4",
    "name": "Automotor Premium, S.L.U. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Fuengirola",
    "address": "C/. Don Quijote de la Mancha, 29640 Fuengirola",
    "email": "automotor@automotorpremium.net.bmw.es",
    "phone": "+34-951606000",
    "website": "http://automotor-fuengirola.concesionariobmw.es",
    "coords": {
      "lat": 36.55733108520508,
      "lng": -4.620642185211182
    }
  },
  {
    "id": "46156_1",
    "name": "Automotor Costa, S.L.U.",
    "country": "ES",
    "city": "Huercal de Almería",
    "address": "Ctra. N-340 km. 446,5, 04230 Huercal de Almería",
    "email": "somos@automotorcosta.net.bmw.es",
    "phone": "+34-950142111",
    "website": "https://automotorcosta.concesionariobmw.es",
    "coords": {
      "lat": 36.87363052368164,
      "lng": -2.444938898086548
    }
  },
  {
    "id": "39812_9",
    "name": "Proa Premium, S.L.",
    "country": "ES",
    "city": "Palma de Mallorca",
    "address": "Gran Vía Asima, nº 19, 07009 Palma de Mallorca",
    "email": "info@proapremium.net.bmw.es",
    "phone": "+34-971108282",
    "website": "https://proapremium.concesionariobmw.es",
    "coords": {
      "lat": 39.606483459472656,
      "lng": 2.668360710144043
    }
  },
  {
    "id": "20285_2",
    "name": "Ceres Motor, S.L.",
    "country": "ES",
    "city": "Plasencia",
    "address": "Avda. Martín Palomino, 45, 10600 Plasencia",
    "email": "rclientes@ceresmotor.net.bmw.es",
    "phone": "+34-927426454",
    "website": "https://ceresmotor-plasencia.concesionariobmw.es",
    "coords": {
      "lat": 40.01036071777344,
      "lng": -6.108972072601318
    }
  },
  {
    "id": "54888_2",
    "name": "Momentum Norte, S.R.L.",
    "country": "ES",
    "city": "Lejona",
    "address": "Autonomía, 3, 48940 Lejona",
    "email": "rclientes@momentumnorte.es",
    "phone": "+34-944804222",
    "website": "https://momentummotor.es/",
    "coords": {
      "lat": 43.318260192871094,
      "lng": -3.003580093383789
    }
  },
  {
    "id": "01212_1",
    "name": "Automóviles Oviedo, S.A.",
    "country": "ES",
    "city": "Oviedo",
    "address": "Cerdeño, 31, 33010 Oviedo",
    "email": "autosa@autosa.com",
    "phone": "+34-985118800",
    "website": "https://autosa.concesionariobmw.es",
    "coords": {
      "lat": 43.37078857421875,
      "lng": -5.817000865936279
    }
  },
  {
    "id": "08596_1",
    "name": "Augusta Aragón, S.A.",
    "country": "ES",
    "city": "Zaragoza",
    "address": "Avda. Alcalde Caballero, 112, 50015 Zaragoza",
    "email": "rclientes@bmwaugusta.es",
    "phone": "+34-976732909",
    "website": "https://augustaaragon.concesionariobmw.es",
    "coords": {
      "lat": 41.677223205566406,
      "lng": -0.868960976600647
    }
  },
  {
    "id": "28310_1",
    "name": "Tallcar, S.L.",
    "country": "ES",
    "city": "Castellar del Vallés",
    "address": "C/. Suiza, 6, 08211 Castellar del Vallés",
    "email": "servicio@tallcar.net.bmw.es",
    "phone": "+34-937142775",
    "website": "https://tallcar.tallerautorizadobmw.es",
    "coords": {
      "lat": 41.607662200927734,
      "lng": 2.08561110496521
    }
  },
  {
    "id": "01211_1",
    "name": "Autogal, S.A.",
    "country": "ES",
    "city": "Orense",
    "address": "Carretera de Vigo, Km. 575, 32001 Orense",
    "email": "rclientes@autogalbmw.es",
    "phone": "+34-988214472",
    "website": "https://autogal.concesionariobmw.es",
    "coords": {
      "lat": 42.350582122802734,
      "lng": -7.9181809425354
    }
  },
  {
    "id": "09144_5",
    "name": "San Pablo Motor, S.L.",
    "country": "ES",
    "city": "Sevilla",
    "address": "Carlos Serra y Pickman 460, 41007 Sevilla",
    "email": "ventasdigitalsanpablomotor@sanpablomotor.es",
    "phone": "+34-954933490",
    "website": null,
    "coords": {
      "lat": 37.39286422729492,
      "lng": -5.943546772003174
    }
  },
  {
    "id": "40230_1",
    "name": "Marmotor Carnarias, S.L.",
    "country": "ES",
    "city": "Las Palmas de Gran Canaria",
    "address": "Avda. Escaleritas, 178, 35019 Las Palmas de Gran Canaria",
    "email": "rclientes@marmotor.net.bmw.es",
    "phone": "+34-928215315",
    "website": "https://marmotor.concesionariobmw.es",
    "coords": {
      "lat": 28.10015869140625,
      "lng": -15.447978973388672
    }
  },
  {
    "id": "51827_1",
    "name": "BYMYCAR Madrid, S.L.U. (Las Tablas)",
    "country": "ES",
    "city": "Madrid",
    "address": "Avenida de Burgos, 133, 28050 Madrid",
    "email": "bmw.madrid@bymycar.es",
    "phone": "+34-913351900",
    "website": "https://bmwbymycar.concesionariobmw.es",
    "coords": {
      "lat": 40.49836349487305,
      "lng": -3.6641499996185303
    }
  },
  {
    "id": "41991_1",
    "name": "Lizaga Motor, S.L.",
    "country": "ES",
    "city": "Teruel",
    "address": "Ctra. Sagunto- Burgos, km.121,7, 44003 Teruel",
    "email": "rclientes@martinlizaga.es",
    "phone": "+34-978607394",
    "website": "https://talleresmartinlizaga.tallerautorizadobmw.es",
    "coords": {
      "lat": 40.34611129760742,
      "lng": -1.1216155290603638
    }
  },
  {
    "id": "09144_1",
    "name": "San Pablo Motor, S.L.",
    "country": "ES",
    "city": "Sevilla",
    "address": "Ctra. de su Eminencia, 26, 41006 Sevilla",
    "email": "ventasdigitalsanpablomotor@sanpablomotor.es",
    "phone": "+34-954933490",
    "website": "https://sanpablomotor.concesionariobmw.es",
    "coords": {
      "lat": 37.3626708984375,
      "lng": -5.957915782928467
    }
  },
  {
    "id": "09901_1",
    "name": "Hispamovil, S.A.",
    "country": "ES",
    "city": "Elche",
    "address": "C/. Monovar, Rda. Vall de Uxo, 03206 Elche",
    "email": "rclientes@hispamovil.net.bmw.es",
    "phone": "+34-966610101",
    "website": "https://benigar-elche.concesionariobmw.es",
    "coords": {
      "lat": 38.281494140625,
      "lng": -0.7244880199432373
    }
  },
  {
    "id": "01357_7",
    "name": "Automoviles Bertolin, S.L. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Valencia",
    "address": "Avda. del Maestro Rodrigo, 42, 46015 Valencia",
    "email": "bertolin@bertolin.es",
    "phone": "+34-963898974",
    "website": "https://bertolin-naturalista.concesionariobmw.es",
    "coords": {
      "lat": 39.48471450805664,
      "lng": -0.4026238024234772
    }
  },
  {
    "id": "39200_1",
    "name": "Unicars Ponent, S.L.",
    "country": "ES",
    "city": "Lleida",
    "address": "Passeig de Ronda, 47-Esc. Bis, 25006 Lleida",
    "email": "bmw@grupmibec.net",
    "phone": "+34-973279887",
    "website": "https://unicarsponent.concesionariobmw.es",
    "coords": {
      "lat": 41.61501693725586,
      "lng": 0.6131640076637268
    }
  },
  {
    "id": "52622_1",
    "name": "Movitransa Cars, S.L.",
    "country": "ES",
    "city": "Jerez de la Frontera",
    "address": "Avenida Tío Pepe, 55, 11407 Jerez de la Frontera",
    "email": "rclientes@movitran.com",
    "phone": "+34-956185559",
    "website": "https://movitran.com",
    "coords": {
      "lat": 36.716182708740234,
      "lng": -6.106328010559082
    }
  },
  {
    "id": "09911_8",
    "name": "Automoviles Fersan, S.A.",
    "country": "ES",
    "city": "Gandia",
    "address": "Avda. Castell de Bairen, 3, 46702 Gandia",
    "email": "rclientes@fersan.net.bmw.es",
    "phone": "+34-962874250",
    "website": "https://benigar-gandia.concesionariobmw.es",
    "coords": {
      "lat": 38.977508544921875,
      "lng": -0.18345099687576294
    }
  },
  {
    "id": "20273_1",
    "name": "Triocar Comercial  Automóvil, S.L",
    "country": "ES",
    "city": "Gijón",
    "address": "Ctra. AS II nº 1529, 33392 Gijón",
    "email": "qma@triocar.es",
    "phone": "+34-985168558",
    "website": "https://triocar.concesionariobmw.es/",
    "coords": {
      "lat": 43.50843811035156,
      "lng": -5.694183826446533
    }
  },
  {
    "id": "22761_2",
    "name": "Celtamotor, S.L.",
    "country": "ES",
    "city": "Caldas de Reis",
    "address": "Ctra.N-640, Km. 233,9, 36615 Caldas de Reis",
    "email": "qma@celtamotor.es",
    "phone": "+34-986565587",
    "website": "https://celtamotor-caldasdelrey.concesionariobmw.es",
    "coords": {
      "lat": 42.57623291015625,
      "lng": -8.720267295837402
    }
  },
  {
    "id": "28878_3",
    "name": "Movil Begar Levante, S.A.",
    "country": "ES",
    "city": "Cocentaina",
    "address": "Avda. Alacant, 51, 03820 Cocentaina",
    "email": "rclientes@movilbegar.net.bmw.es",
    "phone": "+34-966500232",
    "website": "https://benigar-cocentaina.concesionariobmw.es",
    "coords": {
      "lat": 38.7188835144043,
      "lng": -0.4573250114917755
    }
  },
  {
    "id": "39812_3",
    "name": "Proa Premium, S.L.",
    "country": "ES",
    "city": "Manacor",
    "address": "C/ Es Ferrers, 1, 07500 Manacor",
    "email": "info@proapremium.net.bmw.es",
    "phone": "+34-971596777",
    "website": "https://proapremium-manacor.concesionariobmw.es",
    "coords": {
      "lat": 39.572139739990234,
      "lng": 3.185131311416626
    }
  },
  {
    "id": "39200_3",
    "name": "Unicars Ponent, S.L.",
    "country": "ES",
    "city": "Tárrega",
    "address": "Carrer de la Conca de Barberà,Nave6, 25300 Tárrega",
    "email": "bmw@grupmibec.net",
    "phone": "+34-973279887",
    "website": "http://red.bmw.es/unicars/es_ES/home.html",
    "coords": {
      "lat": 41.65445327758789,
      "lng": 1.1568677425384521
    }
  },
  {
    "id": "39812_6",
    "name": "Proa Premium, S.L.",
    "country": "ES",
    "city": "Llucmajor",
    "address": "Avda. Son Noguera, 5, 07620 Llucmajor",
    "email": "info@proapremium.net.bmw.es",
    "phone": "+34-971108282",
    "website": "https://proapremium.concesionariobmw.es",
    "coords": {
      "lat": 39.483760833740234,
      "lng": 2.851464033126831
    }
  },
  {
    "id": "46779_2",
    "name": "Motri Motor, S.A.",
    "country": "ES",
    "city": "Úbeda",
    "address": "Ctra. de Vilches, 55, 23400 Úbeda",
    "email": "motrimotor@motrimotor.net.bmw.es",
    "phone": "+34-953796200",
    "website": "https://motrimotor.concesionariobmw.es",
    "coords": {
      "lat": 38.0211181640625,
      "lng": -3.3708720207214355
    }
  },
  {
    "id": "52622_4",
    "name": "Movitransa Cars, S.L. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Cádiz",
    "address": "c/ Alcalá de los Gazules - Nave 9, 11011 Cádiz",
    "email": "gerencia@movitran.com",
    "phone": "+34-956185559",
    "website": "https://movitran.com",
    "coords": {
      "lat": 36.493961334228516,
      "lng": -6.262517929077148
    }
  },
  {
    "id": "20273_2",
    "name": "Triocar Comercial  Automóvil, S.L",
    "country": "ES",
    "city": "Avilés",
    "address": "C/. Conserveras, 6-8, 33417 Avilés",
    "email": "qma@triocar.es",
    "phone": "+34-985540700",
    "website": "https://triocar-aviles.concesionariobmw.es",
    "coords": {
      "lat": 43.55902862548828,
      "lng": -5.910106182098389
    }
  },
  {
    "id": "20822_1",
    "name": "Canarioalemana del Automóvil, S.L",
    "country": "ES",
    "city": "Taco-La Laguna",
    "address": "C/. Las Industrias, 12, 38108 Taco-La Laguna",
    "email": "rclientes@canaauto.net.bmw.es",
    "phone": "+34-922629292",
    "website": "https://canaauto.concesionariobmw.es",
    "coords": {
      "lat": 28.448808670043945,
      "lng": -16.293529510498047
    }
  },
  {
    "id": "41672_3",
    "name": "Albamocion, S.L.",
    "country": "ES",
    "city": "Cuenca",
    "address": "Avenida de la Cruz Roja, 14, 16002 Cuenca",
    "email": "rclientescu@albamocion.net.bmw.es",
    "phone": "+34-967113040",
    "website": null,
    "coords": {
      "lat": 40.07380676269531,
      "lng": -2.1621670722961426
    }
  },
  {
    "id": "35695_3",
    "name": "Ilbira Motor, S.L.",
    "country": "ES",
    "city": "Motril",
    "address": "Pol. Industrial El Vadillo, 18600 Motril",
    "email": "ventasdigitalilbiramotor@ilbiramotor.es",
    "phone": "+34-958294161",
    "website": "https://ilbiramotor.concesionariobmw.es",
    "coords": {
      "lat": 36.73081588745117,
      "lng": -3.508362054824829
    }
  },
  {
    "id": "34945_3",
    "name": "Automotor Premium, S.L.U. Velazquez",
    "country": "ES",
    "city": "Málaga",
    "address": "Avda. de Velázquez, 184, 29004 Málaga",
    "email": "hola.malaga@automotorpremium.com",
    "phone": "+34-951773001",
    "website": "https://automotor-malaga.concesionariobmw.es",
    "coords": {
      "lat": 36.68488693237305,
      "lng": -4.465000152587891
    }
  },
  {
    "id": "01354_2",
    "name": "Alonso Pineda, S.L.",
    "country": "ES",
    "city": "Cazalegas",
    "address": "Soto de Cazalegas-Parc. 49, 45683 Cazalegas",
    "email": "rclientes@alonsopineda.es",
    "phone": "+34-925814998",
    "website": "http://alonsopineda-cazalegas.tallerautorizadobmw.es",
    "coords": {
      "lat": 39.978363037109375,
      "lng": -4.7379608154296875
    }
  },
  {
    "id": "01354_1",
    "name": "Alonso Pineda, S.L.",
    "country": "ES",
    "city": "Olías del Rey",
    "address": "Autovía A-42, Km. 63,3, 45280 Olías del Rey",
    "email": "rclientes@alonsopineda.es",
    "phone": "+34-925353603",
    "website": "http://alonsopineda.tallerautorizadobmw.es",
    "coords": {
      "lat": 39.91239547729492,
      "lng": -4.008851051330566
    }
  },
  {
    "id": "07450_4",
    "name": "Vehinter, S.A.",
    "country": "ES",
    "city": "Leganés",
    "address": "C/. Palier esq. C/ Bastidor - P.I., 28914 Leganés",
    "email": "rclientes@vehinter.net.bmw.es",
    "phone": "+34-914988100",
    "website": "https://vehinter-momentumleganes.concesionariobmw.es",
    "coords": {
      "lat": 40.314937591552734,
      "lng": -3.7652900218963623
    }
  },
  {
    "id": "06670_5",
    "name": "Movilnorte, S.A.",
    "country": "ES",
    "city": "Majadahonda",
    "address": "C/. Fresa, 13, 28220 Majadahonda",
    "email": "rclientes@movilnorte.net.bmw.es",
    "phone": "+34-916395504",
    "website": "https://movilnorte.concesionariobmw.es",
    "coords": {
      "lat": 40.45370864868164,
      "lng": -3.8720149993896484
    }
  },
  {
    "id": "39428_1",
    "name": "Adler Motor, S.L.",
    "country": "ES",
    "city": "Olias del Rey",
    "address": "Ctra. Madrid-Toledo, Km. 63,800, 45280 Olias del Rey",
    "email": "rclientes@adlermotor.net.bmw.es",
    "phone": "+34-925354893",
    "website": "https://adlermotor.concesionariobmw.es",
    "coords": {
      "lat": 39.90913009643555,
      "lng": -4.010939121246338
    }
  },
  {
    "id": "08552_6",
    "name": "Auto Premier Baviera, S.A. Vehículo de Ocasión Certificado",
    "country": "ES",
    "city": "Alcalá de Henares",
    "address": "Calle Argentina, 7, 28806 Alcalá de Henares",
    "email": "rclientes@autopremier.net.bmw.es",
    "phone": "+34-949210960",
    "website": "https://autopremier.concesionariobmw.es/",
    "coords": {
      "lat": 40.497249603271484,
      "lng": -3.396899461746216
    }
  },
  {
    "id": "22761_1",
    "name": "Celtamotor, S.L.",
    "country": "ES",
    "city": "Vigo",
    "address": "Ctra.de Camposancos, 115, 36213 Vigo",
    "email": "qma@celtamotor.es",
    "phone": "+34-986213645",
    "website": "http://red.bmw.es/celtamotor-vigo/es_ES/home.html",
    "coords": {
      "lat": 42.19810104370117,
      "lng": -8.763213157653809
    }
  },
  {
    "id": "05570_4",
    "name": "Avilcar, S.L.",
    "country": "ES",
    "city": "Palencia",
    "address": "C/ Los Yeseros, 10, 34004 Palencia",
    "email": "arlanzamotor@arlanzamotor.net.bmw.es",
    "phone": "+34-979721254",
    "website": "https://avilcar-arlanzamotor.concesionariobmw.es",
    "coords": {
      "lat": 42.002830505371094,
      "lng": -4.5042338371276855
    }
  },
  {
    "id": "08337_11",
    "name": "Caetano Cuzco, S.L.U.",
    "country": "ES",
    "city": "Madrid",
    "address": "C/. Vivero, 2, 28040 Madrid",
    "email": "rclientes@caetanocuzco.net.bmw.es",
    "phone": "+34-913341016",
    "website": "https://caetanocuzco-vivero.tallerautorizadobmw.es/",
    "coords": {
      "lat": 40.448280334472656,
      "lng": -3.7102138996124268
    }
  },
  {
    "id": "01327_1",
    "name": "Grünblau Motor, S.A.",
    "country": "ES",
    "city": "Santander-Camargo",
    "address": "Barrio de la Venta, s/n, 39608 Santander-Camargo",
    "email": "rclientes@grunblau.es",
    "phone": "+34-942580937",
    "website": "https://grunblaumotor.concesionariobmw.es",
    "coords": {
      "lat": 43.44044876098633,
      "lng": -3.8866400718688965
    }
  },
  {
    "id": "20285_5",
    "name": "Ceres Motor, S.L.",
    "country": "ES",
    "city": "Don  Benito",
    "address": "C/. Guttemberg, s/n, 06400 Don  Benito",
    "email": "mandelmotor@mandelmotor.net.bmw.es",
    "phone": "+34-924812959",
    "website": "https://ceresmotor-motordonbenito.concesionariobmw.es",
    "coords": {
      "lat": 38.960697174072266,
      "lng": -5.8779401779174805
    }
  },
  {
    "id": "09926_2",
    "name": "Burgocar Comercial del Automóvil SA",
    "country": "ES",
    "city": "Aranda de Duero",
    "address": "Avenida Luis Mateos, 104, 09400 Aranda de Duero",
    "email": "burgocar@burgocar.es",
    "phone": "+34-947484350",
    "website": "http://red.bmw.es/burgocar/es_ES/home.html",
    "coords": {
      "lat": 41.66545104980469,
      "lng": -3.7099928855895996
    }
  },
  {
    "id": "22761_3",
    "name": "Celtamotor, S.L.",
    "country": "ES",
    "city": "Lalín",
    "address": "Parque Empresarial Lalín 2000, 36512 Lalín",
    "email": "qma@celtamotor.es",
    "phone": "+34-986787599",
    "website": "https://celtamotor-lalin.concesionariobmw.es",
    "coords": {
      "lat": 42.674625396728516,
      "lng": -8.152499198913574
    }
  },
  {
    "id": "54468_1",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Sabadell",
    "address": "Costa i Deu, 133, 08205 Sabadell",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": "https://www.quadismunich.es/",
    "coords": {
      "lat": 41.52580642700195,
      "lng": 2.0995800495147705
    }
  },
  {
    "id": "54468_6",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Vic",
    "address": "Perot Rocaguinarda, 1, 08500 Vic",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": null,
    "coords": {
      "lat": 41.9277458190918,
      "lng": 2.247175931930542
    }
  },
  {
    "id": "54468_4",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Vilanova i la Geltrú",
    "address": "Calle Eduard Toldrá, 69, 08800 Vilanova i la Geltrú",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": null,
    "coords": {
      "lat": 41.22845458984375,
      "lng": 1.7364306449890137
    }
  },
  {
    "id": "54468_5",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Sant Fruitós de Bages",
    "address": "Ctra. Manresa- Berga, Km. 34,5, 08272 Sant Fruitós de Bages",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": null,
    "coords": {
      "lat": 41.76559829711914,
      "lng": 1.8758859634399414
    }
  },
  {
    "id": "54888_3",
    "name": "Momentum Norte, S.R.L.",
    "country": "ES",
    "city": "Noain",
    "address": "Pol. Industrial Taluntxe II-Calle 8, 31110 Noain",
    "email": "rclientes@momentumnorte.es",
    "phone": "+34-948368009",
    "website": "https://momentummotor.es/",
    "coords": {
      "lat": 42.76988220214844,
      "lng": -1.6310620307922363
    }
  },
  {
    "id": "06662_1",
    "name": "Engasa, S.A.",
    "country": "ES",
    "city": "Quart de Poblet",
    "address": "Avda. Real Mº Santa Mª Poblet, 74, 46930 Quart de Poblet",
    "email": "engasa@engasa.net.bmw.es",
    "phone": "+34-963181030",
    "website": "https://engasa.concesionariobmw.es",
    "coords": {
      "lat": 39.479862213134766,
      "lng": -0.4512549936771393
    }
  },
  {
    "id": "09964_1",
    "name": "Lugauto, S.A.",
    "country": "ES",
    "city": "Lugo",
    "address": "Ctra. de Santiago, Km. 2, 27297 Lugo",
    "email": "rclientes@lugauto.net.bmw.es",
    "phone": "+34-982244061",
    "website": "http://red.bmw.es/lugauto/es_ES/home.html",
    "coords": {
      "lat": 42.994937896728516,
      "lng": -7.587275981903076
    }
  },
  {
    "id": "20839_7",
    "name": "Murcia Premium, S.L.",
    "country": "ES",
    "city": "Cartagena",
    "address": "Avenida Tito Didio s/n, 30353 Cartagena",
    "email": "rclientes@murciapremium.net.bmw.es",
    "phone": "+34-968532511",
    "website": "https://cartagenapremium.concesionariobmw.es",
    "coords": {
      "lat": 37.625213623046875,
      "lng": -0.9649410247802734
    }
  },
  {
    "id": "21110_1",
    "name": "Maberauto, S.A.",
    "country": "ES",
    "city": "Castellón",
    "address": "Avda. Valencia, 99, 12005 Castellón",
    "email": "rclientes@maberauto.net.bmw.es",
    "phone": "+34-964238411",
    "website": "https://maberauto.concesionariobmw.es/",
    "coords": {
      "lat": 39.97222137451172,
      "lng": -0.0535149984061718
    }
  },
  {
    "id": "28067_1",
    "name": "Autoram, S.L.",
    "country": "ES",
    "city": "Zamora",
    "address": "Ctra. de la Hiniesta, 69, 49025 Zamora",
    "email": "autoram@autoram.net.bmw.es",
    "phone": "+34-980557935",
    "website": "https://autoramgar.concesionariobmw.es",
    "coords": {
      "lat": 41.51752471923828,
      "lng": -5.758019924163818
    }
  },
  {
    "id": "31934_1",
    "name": "Carteya Motor, S.L.",
    "country": "ES",
    "city": "Los Barrios",
    "address": "Área del Fresno- Z.A.L., 11370 Los Barrios",
    "email": "ventasdigitalcarteyamotor@carteyamotor.es",
    "phone": "+34-956651700",
    "website": "https://carteyamotor.concesionariobmw.es",
    "coords": {
      "lat": 36.16995620727539,
      "lng": -5.457833766937256
    }
  },
  {
    "id": "34177_1",
    "name": "Cabrero Motorsport, S.L.",
    "country": "ES",
    "city": "Huesca",
    "address": "C/. Comercio, 6, 22006 Huesca",
    "email": "cabrero@cabrero.net.bmw.es",
    "phone": "+34-974241245",
    "website": "https://cabreromotorsport.concesionariobmw.es",
    "coords": {
      "lat": 42.14608383178711,
      "lng": -0.4096269905567169
    }
  },
  {
    "id": "05572_1",
    "name": "Automoviles Dohisa, S.A.",
    "country": "ES",
    "city": "Trobajo del Camino",
    "address": "Ctra. León-Astorga, Km.3,800, 24010 Trobajo del Camino",
    "email": "rclientes@dohisa.net.bmw.es",
    "phone": "+34-987802460",
    "website": "https://dohisa.tallerautorizadobmw.es",
    "coords": {
      "lat": 42.591346740722656,
      "lng": -5.614195823669434
    }
  },
  {
    "id": "09785_1",
    "name": "Amiocar, S.A.",
    "country": "ES",
    "city": "Santiago de Compostela",
    "address": "C/. Rua de Malta 3,, 15707 Santiago de Compostela",
    "email": "ventas@amiocar.es",
    "phone": "+34-981569680",
    "website": "https://amiocar.concesionariobmw.es",
    "coords": {
      "lat": 42.89984893798828,
      "lng": -8.51004409790039
    }
  },
  {
    "id": "20720_1",
    "name": "Pyrénées Motors, S.A.",
    "country": "ES",
    "city": "Sant Julià de Lòria",
    "address": "Prat de la Tresa,s/n, 00600 Sant Julià de Lòria",
    "email": "rclientes@pyrenees.net.bmw.es",
    "phone": "+376-880750",
    "website": "https://pyreneesmotors.concesionariobmw.es",
    "coords": {
      "lat": 42.482791900634766,
      "lng": 1.4897199869155884
    }
  },
  {
    "id": "20975_1",
    "name": "Fuenteolid, S.L.",
    "country": "ES",
    "city": "Valladolid",
    "address": "C/. Ciudad de la Habana, 69, 47014 Valladolid",
    "email": "rclientes@fuenteolid.es",
    "phone": "+34-983408841",
    "website": "https://fuenteolid.concesionariobmw.es",
    "coords": {
      "lat": 41.63188171386719,
      "lng": -4.765931129455566
    }
  },
  {
    "id": "32314_1",
    "name": "SPA - Móvil, S.L.",
    "country": "ES",
    "city": "Paterna",
    "address": "Ciudad de Sagunto, 8-c, 46988 Paterna",
    "email": "spamovil@spamovil.net.bmw.es",
    "phone": "+34-961341415",
    "website": "https://spamovil.tallerautorizadobmw.es",
    "coords": {
      "lat": 39.514339447021484,
      "lng": -0.45820701122283936
    }
  },
  {
    "id": "39198_1",
    "name": "Enekuri Motor, S.L.",
    "country": "ES",
    "city": "Erandio",
    "address": "Ctra.Bilbao-Asúa, 0-1 Pol.Ind., 48950 Erandio",
    "email": "rclientes@enekurimotor.net.bmw.es",
    "phone": "+34-944745969",
    "website": "https://enekurimotor.concesionariobmw.es",
    "coords": {
      "lat": 43.291664123535156,
      "lng": -2.960452079772949
    }
  },
  {
    "id": "40644_1",
    "name": "Bernesga Motor, S.L.",
    "country": "ES",
    "city": "San Andrés del Rabanedo",
    "address": "Ctra. León- Astorga, Km. 4,5, 24010 San Andrés del Rabanedo",
    "email": "rclientes@bernesgamotor.es",
    "phone": "+34-987045165",
    "website": "https://bernesgamotor.concesionariobmw.es",
    "coords": {
      "lat": 42.5880126953125,
      "lng": -5.622199058532715
    }
  },
  {
    "id": "20839_8",
    "name": "Murcia Premium, S.L.",
    "country": "ES",
    "city": "Murcia",
    "address": "Avenida Juan Carlos I, 43, 30007 Murcia",
    "email": "rclientes@murciapremium.net.bmw.es",
    "phone": "+34-968927394",
    "website": "https://murciapremium-jc1.concesionariobmw.es",
    "coords": {
      "lat": 38.005401611328125,
      "lng": -1.1441539525985718
    }
  },
  {
    "id": "31757_1",
    "name": "Sitjas Motor, S.L.",
    "country": "ES",
    "city": "Sabadell",
    "address": "C/. Quintana, 64, 08205 Sabadell",
    "email": "sitjas@sitjas.es",
    "phone": "+34-937104089",
    "website": "https://sitjasmotor.tallerautorizadobmw.es",
    "coords": {
      "lat": 41.53704071044922,
      "lng": 2.0991077423095703
    }
  },
  {
    "id": "08337_1",
    "name": "Caetano Cuzco, S.L.U.",
    "country": "ES",
    "city": "Madrid",
    "address": "C/.Salvatierra, 11-13, 28034 Madrid",
    "email": "rclientes@caetanocuzco.net.bmw.es",
    "phone": "+34-913341016",
    "website": "https://caetanocuzco.concesionariobmw.es/",
    "coords": {
      "lat": 40.490238189697266,
      "lng": -3.692254066467285
    }
  },
  {
    "id": "05570_2",
    "name": "Avilcar, S.L.",
    "country": "ES",
    "city": "Segovia",
    "address": "C/. Navacerrada, 21, 40006 Segovia",
    "email": "eresmamotor@eresmamotor.es",
    "phone": "+34-921433971",
    "website": "https://eresmamotor.concesionariobmw.es/",
    "coords": {
      "lat": 40.92703628540039,
      "lng": -4.110723972320557
    }
  },
  {
    "id": "05570_1",
    "name": "Avilcar, S.L.",
    "country": "ES",
    "city": "Ávila",
    "address": "Jorge de Santayana,74, 05004 Ávila",
    "email": "avilcar@avilcar.net.bmw.es",
    "phone": "+34-920352401",
    "website": "https://avilcar.concesionariobmw.es",
    "coords": {
      "lat": 40.67130661010742,
      "lng": -4.689334869384766
    }
  },
  {
    "id": "06670_2",
    "name": "Movilnorte, S.A.",
    "country": "ES",
    "city": "Las Rozas",
    "address": "A6-Km. 23,100, 28230 Las Rozas",
    "email": "rclientes@movilnorte.net.bmw.es",
    "phone": "+34-916395550",
    "website": "https://movilnorte-lasrozas.concesionariobmw.es",
    "coords": {
      "lat": 40.53151321411133,
      "lng": -3.8881070613861084
    }
  },
  {
    "id": "09926_3",
    "name": "Burgocar Comercial del Automóvil SA",
    "country": "ES",
    "city": "Vitoria",
    "address": "Alto de Armentía, 14, 01007 Vitoria",
    "email": "rclientes@motorgorbea.com",
    "phone": "+34-947484350",
    "website": "https://motorgorbea.concesionariobmw.es/",
    "coords": {
      "lat": 42.83644485473633,
      "lng": -2.7020630836486816
    }
  },
  {
    "id": "08337_10",
    "name": "Caetano Cuzco, S.L.U.",
    "country": "ES",
    "city": "Madrid",
    "address": "C/. Alcalá, 474, 28027 Madrid",
    "email": "rclientes@caetanocuzco.net.bmw.es",
    "phone": "+34-913341016",
    "website": "https://caetanocuzco-alcala.concesionariobmw.es",
    "coords": {
      "lat": 40.43925857543945,
      "lng": -3.6327760219573975
    }
  },
  {
    "id": "08337_9",
    "name": "Caetano Cuzco, S.L.U.",
    "country": "ES",
    "city": "Madrid",
    "address": "c/ Edgar Neville, 1, 28020 Madrid",
    "email": "rclientes@caetanocuzco.net.bmw.es",
    "phone": "+34-913341016",
    "website": "https://caetanocuzco-raimundofdezvillaverde.concesionariobmw.es",
    "coords": {
      "lat": 40.446678161621094,
      "lng": -3.6970698833465576
    }
  },
  {
    "id": "07450_2",
    "name": "Vehinter, S.A.",
    "country": "ES",
    "city": "Alcorcón",
    "address": "Av. S.Martín de Valdeiglesias 14-16, 28922 Alcorcón",
    "email": "rclientes@vehinter.net.bmw.es",
    "phone": "+34-914880008",
    "website": "https://vehinter-alcorcon.concesionariobmw.es",
    "coords": {
      "lat": 40.35710906982422,
      "lng": -3.8248250484466553
    }
  },
  {
    "id": "05568_1",
    "name": "Novomóvil, S.A.",
    "country": "ES",
    "city": "Oleiros",
    "address": "Rua O Morrazo, 9, 15171 Oleiros",
    "email": "rclientes@novomovil.net.bmw.es",
    "phone": "+34-981635750",
    "website": "https://novomovil.concesionariobmw.es",
    "coords": {
      "lat": 43.3260612487793,
      "lng": -8.363691329956055
    }
  },
  {
    "id": "07450_5",
    "name": "Vehinter, S.A. Vehiculo de Ocasión Certificado",
    "country": "ES",
    "city": "Madrid",
    "address": "Calle del Aguacate, 37-39, 28054 Madrid",
    "email": "rclientes@vehinter.net.bmw.es",
    "phone": "+34-916835700",
    "website": "https://vehinter.concesionariobmw.es",
    "coords": {
      "lat": 40.36916732788086,
      "lng": -3.743135452270508
    }
  },
  {
    "id": "06670_1",
    "name": "Movilnorte, S.A.",
    "country": "ES",
    "city": "Majadahonda",
    "address": "Ctra. El Plantío, 62, 28220 Majadahonda",
    "email": "rclientes@movilnorte.net.bmw.es",
    "phone": "+34-916395661",
    "website": "https://movilnorte.concesionariobmw.es/",
    "coords": {
      "lat": 40.47447967529297,
      "lng": -3.8500239849090576
    }
  },
  {
    "id": "08552_1",
    "name": "Auto Premier Baviera, S.A. AutoPremier (Vehículo de Ocasión Ce",
    "country": "ES",
    "city": "Guadalajara",
    "address": "Paseo de la Estación, 23, 19004 Guadalajara",
    "email": "rclientes@autopremier.net.bmw.es",
    "phone": "+34-949210960",
    "website": "https://autopremier.concesionariobmw.es/",
    "coords": {
      "lat": 40.641319274902344,
      "lng": -3.1734800338745117
    }
  },
  {
    "id": "08552_4",
    "name": "Auto Premier Baviera, S.A.",
    "country": "ES",
    "city": "Alcalá de Henares",
    "address": "Via Complutense, 131, 28805 Alcalá de Henares",
    "email": "rclientes@autopremier.net.bmw.es",
    "phone": "+34-918821735",
    "website": "https://autopremier.concesionariobmw.es",
    "coords": {
      "lat": 40.495365142822266,
      "lng": -3.3457019329071045
    }
  },
  {
    "id": "01357_4",
    "name": "Automoviles Bertolin, S.L.",
    "country": "ES",
    "city": "Valencia",
    "address": "Avda. General Avilés, 68, 46015 Valencia",
    "email": "bertolin@bertolin.es",
    "phone": "+34-963898974",
    "website": "https://bertolin.concesionariobmw.es",
    "coords": {
      "lat": 39.48372268676758,
      "lng": -0.40107598900794983
    }
  },
  {
    "id": "01357_1",
    "name": "Automoviles Bertolin, S.L.",
    "country": "ES",
    "city": "Valencia",
    "address": "C/ Naturalista Rafael Cisternes, 2, 46010 Valencia",
    "email": "bertolin@bertolin.es",
    "phone": "+34-963898973",
    "website": "http://bertolin-naturalista.concesionariobmw.es",
    "coords": {
      "lat": 39.473602294921875,
      "lng": -0.360617995262146
    }
  },
  {
    "id": "09911_2",
    "name": "Automoviles Fersan, S.A.",
    "country": "ES",
    "city": "Finestrat",
    "address": "C/. Alicante, 31, 03509 Finestrat",
    "email": "rclientes@fersan.net.bmw.es",
    "phone": "+34-966889600",
    "website": "https://benigar-finestrat.concesionariobmw.es",
    "coords": {
      "lat": 38.53824996948242,
      "lng": -0.18205200135707855
    }
  },
  {
    "id": "09901_3",
    "name": "Hispamovil, S.A.",
    "country": "ES",
    "city": "San Carlos-Redován",
    "address": "Ctra. N. 340, km. 29,200, 03317 San Carlos-Redován",
    "email": "rclientes@hispamovil.net.bmw.es",
    "phone": "+34-966448666",
    "website": "https://benigar-redovan.concesionariobmw.es",
    "coords": {
      "lat": 38.131553649902344,
      "lng": -0.9324349761009216
    }
  },
  {
    "id": "33948_2",
    "name": "Pruna Motor, S.L. Mataró",
    "country": "ES",
    "city": "Mataró",
    "address": "Via Sergia, 2, 08302 Mataró",
    "email": "rclientes@prunamotor.net.bmw.es",
    "phone": "+34-937414848",
    "website": "https://prunamotor-mataro.concesionariobmw.es",
    "coords": {
      "lat": 41.5250358581543,
      "lng": 2.428307056427002
    }
  },
  {
    "id": "46347_3",
    "name": "Oliva Motor Girona, S.L.U.",
    "country": "ES",
    "city": "Olot",
    "address": "Ronda Les Mates, 32, 17800 Olot",
    "email": "rclients.girona@olivamotor.com",
    "phone": "+34-972270474",
    "website": null,
    "coords": {
      "lat": 42.19280242919922,
      "lng": 2.509207010269165
    }
  },
  {
    "id": "40644_2",
    "name": "Bernesga Motor, S.L.",
    "country": "ES",
    "city": "Camponaraya",
    "address": "Av. Camino de Santiago, 316, 24410 Camponaraya",
    "email": "rclientes@bernesgamotor.es",
    "phone": "+34-987045165",
    "website": "http://red.bmw.es/bernesgamotor/es_ES/home.html",
    "coords": {
      "lat": 42.57295227050781,
      "lng": -6.6539411544799805
    }
  },
  {
    "id": "22761_4",
    "name": "Celtamotor, S.L.",
    "country": "ES",
    "city": "Salcedo",
    "address": "Ctra. Nacional 550, Km.125, 36143 Salcedo",
    "email": "qma@celtamotor.es",
    "phone": "+34-986160460",
    "website": "https://celtamotor-salcedo.concesionariobmw.es",
    "coords": {
      "lat": 42.409908294677734,
      "lng": -8.640027046203613
    }
  },
  {
    "id": "41672_1",
    "name": "Albamocion, S.L.",
    "country": "ES",
    "city": "Albacete",
    "address": "Avenida Gregorio Arcos, 41, 02007 Albacete",
    "email": "rclientes@albamocion.net.bmw.es",
    "phone": "+34-967113040",
    "website": "https://albamocion.concesionariobmw.es",
    "coords": {
      "lat": 39.016475677490234,
      "lng": -1.8814589977264404
    }
  },
  {
    "id": "52622_3",
    "name": "Movitransa Cars, S.L.",
    "country": "ES",
    "city": "Huelva",
    "address": "Ctra. Huelva- Sevilla, Km.637,5, 21007 Huelva",
    "email": "gerencia@movitran.com",
    "phone": "+34-956180879",
    "website": "https://movitran.com",
    "coords": {
      "lat": 37.271610260009766,
      "lng": -6.912804126739502
    }
  },
  {
    "id": "52622_2",
    "name": "Movitransa Cars, S.L.",
    "country": "ES",
    "city": "Cádiz",
    "address": "Villa de Rota s/n, 11011 Cádiz",
    "email": "gerencia@movitran.com",
    "phone": "+34-956251510",
    "website": "https://movitran.com",
    "coords": {
      "lat": 36.49370574951172,
      "lng": -6.263064861297607
    }
  },
  {
    "id": "09911_1",
    "name": "Automoviles Fersan, S.A.",
    "country": "ES",
    "city": "San Juan",
    "address": "Ctra.Alicante-Valencia, 03550 San Juan",
    "email": "rclientes@fersan.net.bmw.es",
    "phone": "+34-965657392",
    "website": "https://benigar-sanjuan.concesionariobmw.es",
    "coords": {
      "lat": 38.391807556152344,
      "lng": -0.43451300263404846
    }
  },
  {
    "id": "28878_1",
    "name": "Movil Begar Levante, S.A.",
    "country": "ES",
    "city": "Alicante",
    "address": "Ctra. Madrid, Km. 4, 03006 Alicante",
    "email": "rclientes@movilbegar.net.bmw.es",
    "phone": "+34-965101620",
    "website": "https://benigar.concesionariobmw.es",
    "coords": {
      "lat": 38.34389877319336,
      "lng": -0.5398160219192505
    }
  },
  {
    "id": "33284_10",
    "name": "Ibericar Barcelona Premium S.L. Ronda Litoral",
    "country": "ES",
    "city": "Sant Adrià de Besòs",
    "address": "Juan de Austria, 1, 08930 Sant Adrià de Besòs",
    "email": "marketing@barcelonapremium.net.bmw.es",
    "phone": "+34-933319800",
    "website": "https://barcelonapremium.concesionariobmw.es",
    "coords": {
      "lat": 41.43207550048828,
      "lng": 2.2109129428863525
    }
  },
  {
    "id": "33284_12",
    "name": "Ibericar Barcelona Premium S.L.",
    "country": "ES",
    "city": "L Hospitalet de Llobregat",
    "address": "Montserrat Roig, 31, 08908 L Hospitalet de Llobregat",
    "email": "marketing@barcelonapremium.net.bmw.es",
    "phone": "+34-932121150",
    "website": "https://barcelonapremium-hospitalet.concesionariobmw.es",
    "coords": {
      "lat": 41.3503303527832,
      "lng": 2.125221014022827
    }
  },
  {
    "id": "33284_11",
    "name": "Ibericar Barcelona Premium S.L.",
    "country": "ES",
    "city": "Barcelona",
    "address": "c/ Entença, 324-326, 08029 Barcelona",
    "email": "marketing@barcelonapremium.net.bmw.es",
    "phone": "+34-933319800",
    "website": "https://barcelonapremium-entenca.concesionariobmw.es",
    "coords": {
      "lat": 41.390316009521484,
      "lng": 2.1382908821105957
    }
  },
  {
    "id": "46347_2",
    "name": "Oliva Motor Girona, S.L.U.",
    "country": "ES",
    "city": "Olot",
    "address": "Avda. de les Tries, 92, 17800 Olot",
    "email": "rclients.girona@olivamotor.com",
    "phone": "+34-972273892",
    "website": "https://olivamotorgirona-olot.concesionariobmw.es",
    "coords": {
      "lat": 42.19004821777344,
      "lng": 2.505505084991455
    }
  },
  {
    "id": "46779_1",
    "name": "Motri Motor, S.A.",
    "country": "ES",
    "city": "Jaén",
    "address": "C/. Juan Eslava Galán, 4, 23009 Jaén",
    "email": "ventasdigitalmotrimotor@motrimotor.es",
    "phone": "+34-953280111",
    "website": "https://motrimotor.concesionariobmw.es",
    "coords": {
      "lat": 37.78794479370117,
      "lng": -3.785465955734253
    }
  },
  {
    "id": "23332_1",
    "name": "San Rafael Motor, S.L.",
    "country": "ES",
    "city": "Córdoba",
    "address": "C/. Esteban Cabrera, s/n, 14014 Córdoba",
    "email": "ventasdigitalsanrafaelmotor@sanrafaelmotor.es",
    "phone": "+34-957322381",
    "website": "https://sanrafaelmotor.concesionariobmw.es",
    "coords": {
      "lat": 37.90483093261719,
      "lng": -4.726657867431641
    }
  },
  {
    "id": "35695_1",
    "name": "Ilbira Motor, S.L.",
    "country": "ES",
    "city": "Granada",
    "address": "Avda. Andalucía, 114, 18015 Granada",
    "email": "ventasdigitalilbiramotor@ilbiramotor.es",
    "phone": "+34-958294161",
    "website": "https://ilbiramotor.concesionariobmw.es",
    "coords": {
      "lat": 37.19797134399414,
      "lng": -3.635895013809204
    }
  },
  {
    "id": "46156_2",
    "name": "Automotor Costa, S.L.U.",
    "country": "ES",
    "city": "El Ejido",
    "address": "Avda. El Treinta, 147, 04700 El Ejido",
    "email": "somos@automotorcosta.net.bmw.es",
    "phone": "+34-950142111",
    "website": "https://automotorcosta-elejido.concesionariobmw.es",
    "coords": {
      "lat": 36.77734375,
      "lng": -2.7905290126800537
    }
  },
  {
    "id": "39812_4",
    "name": "Proa Premium, S.L.",
    "country": "ES",
    "city": "Ibiza",
    "address": "Ctra. Aeropuerto Km 4,500, 07817 Ibiza",
    "email": "info@proapremium.net.bmw.es",
    "phone": "+34-971396494",
    "website": "https://www.bmw-motorrad.es/proapremium-palmademallorca/es/home.html",
    "coords": {
      "lat": 38.885860443115234,
      "lng": 1.3922189474105835
    }
  },
  {
    "id": "54468_2",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Tarrasa",
    "address": "Anoia, 9, 08223 Tarrasa",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": null,
    "coords": {
      "lat": 41.546287536621094,
      "lng": 2.0303890705108643
    }
  },
  {
    "id": "54468_3",
    "name": "Altrac Europa, S.A.",
    "country": "ES",
    "city": "Sant Cugat del Vallès",
    "address": "Carrer Vallespir , 19, 08173 Sant Cugat del Vallès",
    "email": "contacto@quadismunich.es",
    "phone": "+34-937207580",
    "website": null,
    "coords": {
      "lat": 41.479949951171875,
      "lng": 2.068000078201294
    }
  },
  {
    "id": "28878_2",
    "name": "Movil Begar Levante, S.A.",
    "country": "ES",
    "city": "Petrer",
    "address": "C/. Primero de Mayo, 25, 03610 Petrer",
    "email": "rclientes@movilbegar.net.bmw.es",
    "phone": "+34-965371341",
    "website": "https://benigar-petrer.concesionariobmw.es",
    "coords": {
      "lat": 38.508445739746094,
      "lng": -0.7934049963951111
    }
  },
  {
    "id": "20839_4",
    "name": "Murcia Premium, S.L.",
    "country": "ES",
    "city": "Lorca",
    "address": "Ctra. Granada, Km. 2,5, 30800 Lorca",
    "email": "rclientes@murciapremium.net.bmw.es",
    "phone": "+34-968478081",
    "website": "https://murciapremium-lorca.concesionariobmw.es",
    "coords": {
      "lat": 37.65531921386719,
      "lng": -1.7121829986572266
    }
  },
  {
    "id": "39812_1",
    "name": "Proa Premium, S.L.",
    "country": "ES",
    "city": "Palma de Mallorca",
    "address": "Gremi de Sucrers i Candelers 6A, 07009 Palma de Mallorca",
    "email": "info@proapremium.net.bmw.es",
    "phone": "+34-971108282",
    "website": "https://proapremium.concesionariobmw.es",
    "coords": {
      "lat": 39.608001708984375,
      "lng": 2.657749891281128
    }
  },
  {
    "id": "54888_1",
    "name": "Momentum Norte, S.R.L.",
    "country": "ES",
    "city": "Oyarzun",
    "address": "Pol. Industrial Makarraztegi. 3, 20180 Oyarzun",
    "email": "rclientes@momentumnorte.es",
    "phone": "+34-943260500",
    "website": "https://momentummotor.es/",
    "coords": {
      "lat": 43.317665100097656,
      "lng": -1.8728450536727905
    }
  },
  {
    "id": "07010_1",
    "name": "Auto Walser AG Wangs",
    "country": "CH",
    "city": "Wangs",
    "address": "Bahnhofstrasse 56, 7323 Wangs",
    "email": "info@autowalser.ch",
    "phone": "+41-81-7204550",
    "website": "https://www.bmw.ch/de_CH/partner/auto-walser-wangs-07010.html",
    "coords": {
      "lat": 47.039825439453125,
      "lng": 9.43674087524414
    }
  },
  {
    "id": "07016_3",
    "name": "Binelli Automobile AG",
    "country": "CH",
    "city": "Adliswil",
    "address": "Zürichstrasse 102, 8134 Adliswil",
    "email": "info.adliswil@binelli-group.ch",
    "phone": "+41-58-2707171",
    "website": "https://www.bmw.ch/de_CH/partner/binelli-automobile-adliswil-07085.html",
    "coords": {
      "lat": 47.32646179199219,
      "lng": 8.531160354614258
    }
  },
  {
    "id": "07073_2",
    "name": "Hutter Dynamics AG Schaffhausen",
    "country": "CH",
    "city": "Schaffhausen",
    "address": "Solenbergstrasse 1, 8207 Schaffhausen",
    "email": "info.sh@hutter-dynamics.ch",
    "phone": "+41-52-2447788",
    "website": "https://www.bmw.ch/de_CH/partner/hutter-dynamics-schaffhausen-07006.html",
    "coords": {
      "lat": 47.71250534057617,
      "lng": 8.65903377532959
    }
  },
  {
    "id": "07130_3",
    "name": "Emil Frey SA Balerna",
    "country": "CH",
    "city": "Balerna",
    "address": "Via San Gottardo 6, 6828 Balerna",
    "email": "info-balerna@emilfrey.ch",
    "phone": "+41-91-6833353",
    "website": "https://www.bmw.ch/it_CH/partner/emil-frey-balerna-07000.html",
    "coords": {
      "lat": 45.83960723876953,
      "lng": 9.019454002380371
    }
  },
  {
    "id": "07130_7",
    "name": "Emil Frey AG St. Moritz",
    "country": "CH",
    "city": "St. Moritz",
    "address": "Via Maistra 46, 7500 St. Moritz",
    "email": "stmoritz@emilfrey.ch",
    "phone": "+41-81-8333333",
    "website": "https://www.bmw.ch/de_CH/partner/emil-frey-stmoritz-48467.html",
    "coords": {
      "lat": 46.500877380371094,
      "lng": 9.844758033752441
    }
  },
  {
    "id": "20088_1",
    "name": "Facchinetti Automobiles (Delémont) SA",
    "country": "CH",
    "city": "Delémont",
    "address": "Route de Moutier 113, 2800 Delémont",
    "email": "info-de@facchinetti.ch",
    "phone": "+41-32-4710101",
    "website": "https://www.bmw.ch/fr_CH/partner/facchinetti-automobiles-delemont-20088.html",
    "coords": {
      "lat": 47.362674713134766,
      "lng": 7.361396789550781
    }
  },
  {
    "id": "07008_2",
    "name": "Auto Marti AG MINI Center Bern",
    "country": "CH",
    "city": "Muri",
    "address": "Worbstrasse 75, 3074 Muri",
    "email": "empfang.mini@automarti.ch",
    "phone": "+41-31-7481010",
    "website": "https://www.bmw.ch/de_CH/partner/auto-marti-muri-bern-34830.html",
    "coords": {
      "lat": 46.93648910522461,
      "lng": 7.487932205200195
    }
  },
  {
    "id": "07012_1",
    "name": "Hans Bader AG",
    "country": "CH",
    "city": "Oberweningen",
    "address": "Wehntalerstrasse 5, 8165 Oberweningen",
    "email": "info@baderag.ch",
    "phone": "+41-44-8560668",
    "website": "https://www.bmw.ch/de_CH/partner/hans-bader-oberweningen-07012.html",
    "coords": {
      "lat": 47.49967956542969,
      "lng": 8.410621643066406
    }
  },
  {
    "id": "07073_1",
    "name": "Hutter Dynamics AG Winterthur",
    "country": "CH",
    "city": "Winterthur",
    "address": "Hegmattenstrasse 3, 8404 Winterthur",
    "email": "info.win@hutter-dynamics.ch",
    "phone": "+41-52-2447777",
    "website": "https://www.bmw.ch/de_CH/partner/hutter-dynamics-winterthur-07073.html",
    "coords": {
      "lat": 47.509700775146484,
      "lng": 8.76047134399414
    }
  },
  {
    "id": "07130_4",
    "name": "Emil Frey SA Lamone",
    "country": "CH",
    "city": "Lamone",
    "address": "Via Vedeggio, 6814 Lamone",
    "email": "lamone@emilfrey.ch",
    "phone": "+41-91-9616363",
    "website": "https://www.bmw.ch/it_CH/partner/emil-frey-lamone-35686.html",
    "coords": {
      "lat": 46.03862380981445,
      "lng": 8.930039405822754
    }
  },
  {
    "id": "07130_8",
    "name": "Emil Frey SA Succursale de Lausanne",
    "country": "CH",
    "city": "Chavannes-près-Renens",
    "address": "Route de la Maladière 44, 1022 Chavannes-près-Renens",
    "email": "info-chavannes@emilfrey.ch",
    "phone": "+41-21-6227161",
    "website": "https://www.bmw.ch/fr_CH/partner/emil-frey-chavannes-renens-48574.html",
    "coords": {
      "lat": 46.52730178833008,
      "lng": 6.581200122833252
    }
  },
  {
    "id": "25393_1",
    "name": "Auto-Graf AG",
    "country": "CH",
    "city": "Meilen",
    "address": "Seestrasse 941, 8706 Meilen",
    "email": "info@autograf.ch",
    "phone": "+41-44-9242424",
    "website": "https://www.bmw.ch/de_CH/partner/auto-graf-meilen-25393.html",
    "coords": {
      "lat": 47.26431655883789,
      "lng": 8.661479949951172
    }
  },
  {
    "id": "05497_4",
    "name": "Abt Automobile AG",
    "country": "CH",
    "city": "Muttenz",
    "address": "St. Jakob-Strasse 70, 4132 Muttenz",
    "email": "info.muttenz@abtautomobile.ch",
    "phone": "+41-61-4654444",
    "website": "https://www.abtautomobile.ch/",
    "coords": {
      "lat": 47.530921936035156,
      "lng": 7.639689922332764
    }
  },
  {
    "id": "07008_3",
    "name": "Auto Marti AG Gwatt",
    "country": "CH",
    "city": "Gwatt",
    "address": "C.F.L.-Lohnerstrasse 29, 3645 Gwatt",
    "email": "info.thun@automarti.ch",
    "phone": "+41-33-3342060",
    "website": "https://www.bmw.ch/de_CH/partner/auto-marti-gwatt-46326.html",
    "coords": {
      "lat": 46.73072814941406,
      "lng": 7.617891788482666
    }
  },
  {
    "id": "07027_1",
    "name": "Felix Emmenegger AG Hettenschwil",
    "country": "CH",
    "city": "Hettenschwil",
    "address": "Gibriststrasse 5, 5317 Hettenschwil",
    "email": "cs-fp@emmeneggerag.ch",
    "phone": "+41-56-5208460",
    "website": "https://www.bmw.ch/de_CH/partner/felix-emmenegger-hettenschwil-07027.html",
    "coords": {
      "lat": 47.57442855834961,
      "lng": 8.202560424804688
    }
  },
  {
    "id": "07089_1",
    "name": "Mythen-Garage AG",
    "country": "CH",
    "city": "Ibach",
    "address": "Gotthardstrasse 166, 6438 Ibach",
    "email": "info@mythengarage.ch",
    "phone": "+41-41-8118121",
    "website": "https://www.bmw.ch/de_CH/partner/mythen-garage-ibach-07089.html",
    "coords": {
      "lat": 47.01959228515625,
      "lng": 8.640130043029785
    }
  },
  {
    "id": "07130_2",
    "name": "Emil Frey SA Succursale Morges",
    "country": "CH",
    "city": "Morges",
    "address": "Avenue de Plan 8, 1110 Morges",
    "email": "info-morges@emilfrey.ch",
    "phone": "+41-21-8115100",
    "website": "https://www.bmw.ch/fr_CH/partner/emil-frey-morges-47342.html",
    "coords": {
      "lat": 46.51769256591797,
      "lng": 6.504000186920166
    }
  },
  {
    "id": "07130_10",
    "name": "Emil Frey AG Züri-Oberland Wetzikon",
    "country": "CH",
    "city": "Wetzikon",
    "address": "Giessereistrasse 1, 8620 Wetzikon",
    "email": "info-zo-wetzikon@emilfrey.ch",
    "phone": "+41-44-9332020",
    "website": "https://www.bmw.ch/de_CH/partner/emil-frey-wetzikon-07114.html",
    "coords": {
      "lat": 47.3255729675293,
      "lng": 8.786020278930664
    }
  },
  {
    "id": "47186_1",
    "name": "Facchinetti Automobiles (Gland-Vich) SA",
    "country": "CH",
    "city": "Vich/Gland",
    "address": "Route de l'Etraz 2, 1267 Vich/Gland",
    "email": "info-gv@facchinetti.ch",
    "phone": "+41-22-3540303",
    "website": "https://www.bmw.ch/fr_CH/partner/facchinetti-automobiles-gland-vich-37313.html",
    "coords": {
      "lat": 46.42573165893555,
      "lng": 6.254417896270752
    }
  },
  {
    "id": "46758_1",
    "name": "Dimab Chablais SA Vionnaz",
    "country": "CH",
    "city": "Vionnaz",
    "address": "Route du Simplon 16, 1895 Vionnaz",
    "email": "chablais@dimab.ch",
    "phone": "+41-58-2550990",
    "website": "https://www.bmw.ch/fr_CH/partner/dimab-chablais-37288.html",
    "coords": {
      "lat": 46.30826950073242,
      "lng": 6.905335903167725
    }
  },
  {
    "id": "21524_1",
    "name": "Nino Unold AG",
    "country": "CH",
    "city": "Davos Dorf",
    "address": "Flüelastrasse 2, 7260 Davos Dorf",
    "email": "info@bmw-unold.ch",
    "phone": "+41-81-4201660",
    "website": "https://www.bmw.ch/de_CH/partner/nino-unold-davos-dorf-21524.html",
    "coords": {
      "lat": 46.81132125854492,
      "lng": 9.844442367553711
    }
  },
  {
    "id": "30631_2",
    "name": "Bickel Auto AG Weinfelden",
    "country": "CH",
    "city": "Weinfelden",
    "address": "Dunantstrasse 2, 8570 Weinfelden",
    "email": "info@bickelautoag.ch",
    "phone": "+41-71-6226444",
    "website": "https://www.bmw.ch/de_CH/partner/bickel-auto-weinfelden-29359.html",
    "coords": {
      "lat": 47.568843841552734,
      "lng": 9.094099044799805
    }
  },
  {
    "id": "52452_1",
    "name": "Dimab Rossens SA",
    "country": "CH",
    "city": "Farvagny-le-Grand",
    "address": "Chemin de la Longivue 1, 1726 Farvagny-le-Grand",
    "email": "rossens@dimab.ch",
    "phone": "+41-26-5522525",
    "website": "https://www.bmw.ch/fr_CH/partner/dimab-rossens-52452.html",
    "coords": {
      "lat": 46.72319793701172,
      "lng": 7.084498882293701
    }
  },
  {
    "id": "07057_5",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Bachenbülach",
    "country": "CH",
    "city": "Bachenbülach",
    "address": "Weieracherstrasse 11, 8184 Bachenbülach",
    "email": "info-bachenbuelach@hedinautomotive.ch",
    "phone": "+41-44-8648403",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-bachenbuelach-52270.html",
    "coords": {
      "lat": 47.506500244140625,
      "lng": 8.540180206298828
    }
  },
  {
    "id": "07057_7",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung St. Gallen",
    "country": "CH",
    "city": "St. Gallen",
    "address": "Schuppisstrasse 9, 9016 St. Gallen",
    "email": "info-stgallen@hedinautomotive.ch",
    "phone": "+41-71-2824969",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-stgallen-09214.html",
    "coords": {
      "lat": 47.441165924072266,
      "lng": 9.417860984802246
    }
  },
  {
    "id": "07057_9",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Chur",
    "country": "CH",
    "city": "Chur",
    "address": "Kasernenstrasse 165, 7007 Chur",
    "email": "info-chur@hedinautomotive.ch",
    "phone": "+41-81-2871010",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-chur-07058.html",
    "coords": {
      "lat": 46.8459358215332,
      "lng": 9.510181427001953
    }
  },
  {
    "id": "07049_1",
    "name": "Hess Automobile Group AG",
    "country": "CH",
    "city": "Aesch",
    "address": "Therwilerstrasse 2, 4147 Aesch",
    "email": "info@hess-group.ch",
    "phone": "+41-61-7179010",
    "website": "https://www.bmw.ch/de_CH/partner/hess-automobile-aesch-07049.html",
    "coords": {
      "lat": 47.48003005981445,
      "lng": 7.592238903045654
    }
  },
  {
    "id": "07008_1",
    "name": "Auto Marti AG Autobahnausfahrt A12",
    "country": "CH",
    "city": "Bern Niederwangen",
    "address": "Hallmattstrasse 33, 3172 Bern Niederwangen",
    "email": "info@automarti.ch",
    "phone": "+41-31-9851010",
    "website": "https://www.bmw.ch/de_CH/partner/auto-marti-niederwangen-07008.html",
    "coords": {
      "lat": 46.93073654174805,
      "lng": 7.380046367645264
    }
  },
  {
    "id": "07130_12",
    "name": "Emil Frey AG Emil Frey Gfenn Dübendorf",
    "country": "CH",
    "city": "Dübendorf",
    "address": "Gfennstrasse 5, 8600 Dübendorf",
    "email": "info-zo-bruettisellen@emilfrey.ch",
    "phone": "+41-44-5464126",
    "website": "http://dealer.bmw.ch/efag-bruettisellen",
    "coords": {
      "lat": 47.39448547363281,
      "lng": 8.646464347839355
    }
  },
  {
    "id": "07027_2",
    "name": "Felix Emmenegger AG Gebenstorf",
    "country": "CH",
    "city": "Gebenstorf",
    "address": "Grubenstrasse 1, 5412 Gebenstorf",
    "email": "cs-g-fp@emmeneggerag.ch",
    "phone": "+41-56-5208400",
    "website": "https://www.bmw.ch/de_CH/partner/felix-emmenegger-gebenstorf-28010.html",
    "coords": {
      "lat": 47.489898681640625,
      "lng": 8.24153995513916
    }
  },
  {
    "id": "05497_2",
    "name": "Abt Automobile AG Muttenz",
    "country": "CH",
    "city": "Muttenz",
    "address": "St. Jakob-Strasse 72/80, 4132 Muttenz",
    "email": "info.muttenz@abtautomobile.ch",
    "phone": "+41-61-4655151",
    "website": "https://www.bmw.ch/de_CH/partner/abt-automobile-muttenz-34994.html",
    "coords": {
      "lat": 47.53091812133789,
      "lng": 7.638202667236328
    }
  },
  {
    "id": "07033_1",
    "name": "Garage Torretta SA Bellinzona",
    "country": "CH",
    "city": "Bellinzona",
    "address": "Via S. Gottardo 109, 6500 Bellinzona",
    "email": "info@bmw-torretta.ch",
    "phone": "+41-91-8293549",
    "website": "https://www.bmw-torretta.ch",
    "coords": {
      "lat": 46.21025085449219,
      "lng": 9.038780212402344
    }
  },
  {
    "id": "07047_1",
    "name": "Max Heidegger AG",
    "country": "CH",
    "city": "Triesen",
    "address": "Messinastrasse 1, 9495 Triesen",
    "email": "info@heidegger.li",
    "phone": "+423-3994080",
    "website": "https://www.bmw.ch/de_CH/partner/max-heidegger-triesen-07047.html",
    "coords": {
      "lat": 47.11971664428711,
      "lng": 9.520059585571289
    }
  },
  {
    "id": "07093_2",
    "name": "Auto-Steiner AG Rapperswil-Jona",
    "country": "CH",
    "city": "Rapperswil-Jona",
    "address": "Rütistrasse 163, 8645 Rapperswil-Jona",
    "email": "info@auto-steiner-ag.ch",
    "phone": "+41-55-2201030",
    "website": "https://www.bmw.ch/de_CH/partner/auto-steiner-rapperswil-jona-30192.html",
    "coords": {
      "lat": 47.24463653564453,
      "lng": 8.830207824707031
    }
  },
  {
    "id": "07094_1",
    "name": "Steiner Group AG Luzern",
    "country": "CH",
    "city": "Luzern",
    "address": "Fluhmühle 9, 6015 Luzern",
    "email": "info@steiner-group.ch",
    "phone": "+41-41-2487048",
    "website": "https://www.bmw.ch/de_CH/partner/steiner-group-luzern-07094.html",
    "coords": {
      "lat": 47.05768585205078,
      "lng": 8.285176277160645
    }
  },
  {
    "id": "07094_2",
    "name": "Steiner Group AG Kriens",
    "country": "CH",
    "city": "Kriens",
    "address": "Horwerstrasse 70, 6010 Kriens",
    "email": "info@bmw-steiner.ch",
    "phone": "+41-41-2487095",
    "website": "https://www.bmw.ch/de_CH/partner/steiner-group-kriens-45077.html",
    "coords": {
      "lat": 47.02822494506836,
      "lng": 8.293961524963379
    }
  },
  {
    "id": "20321_2",
    "name": "Claude Urfer SA Sion",
    "country": "CH",
    "city": "Sion",
    "address": "Chemin Saint-Hubert 12, 1950 Sion",
    "email": "info@urfersa.ch",
    "phone": "+41-58-1225200",
    "website": "https://www.bmw.ch/fr_CH/partner/claude-urfer-sion-22097.html",
    "coords": {
      "lat": 46.2232551574707,
      "lng": 7.349034786224365
    }
  },
  {
    "id": "21242_1",
    "name": "zbinden ag hägendorf",
    "country": "CH",
    "city": "Hägendorf",
    "address": "Oltnerstrasse 18, 4614 Hägendorf",
    "email": "info@bmw-zbinden.ch",
    "phone": "+41-62-2097000",
    "website": "https://www.bmw.ch/de_CH/partner/zbinden-haegendorf-21242.html",
    "coords": {
      "lat": 47.335243225097656,
      "lng": 7.849414825439453
    }
  },
  {
    "id": "07015_1",
    "name": "Beutler Auto AG",
    "country": "CH",
    "city": "Bärau",
    "address": "Bäraugrundstrasse 3a, 3552 Bärau",
    "email": "info@beutler-auto.ch",
    "phone": "+41-34-4083666",
    "website": "https://www.bmw.ch/de_CH/partner/beutler-auto-baerau-07015.html",
    "coords": {
      "lat": 46.93838119506836,
      "lng": 7.800139904022217
    }
  },
  {
    "id": "07029_1",
    "name": "Sepp Fässler AG Appenzell",
    "country": "CH",
    "city": "Appenzell",
    "address": "Feldstrasse 11, 9050 Appenzell",
    "email": "info@faessler-garage.ch",
    "phone": "+41-71-7883060",
    "website": "https://www.bmw.ch/de_CH/partner/sepp-faessler-appenzell-07029.html",
    "coords": {
      "lat": 47.33412551879883,
      "lng": 9.404199600219727
    }
  },
  {
    "id": "07064_1",
    "name": "Stehli & Fischer AG, Garage Maxim",
    "country": "CH",
    "city": "Zürich",
    "address": "Ottenweg 11, 8032 Zürich",
    "email": "info@bmw-stehlifischer.ch",
    "phone": "+41-44-2519244",
    "website": "https://www.bmw.ch/de_CH/partner/stehli-fischer-zuerich-07064.html",
    "coords": {
      "lat": 47.363128662109375,
      "lng": 8.553350448608398
    }
  },
  {
    "id": "07094_3",
    "name": "Steiner Group AG Buochs",
    "country": "CH",
    "city": "Buochs",
    "address": "Erlenwäldlistrasse 9, 6374 Buochs",
    "email": "info@bmw-steiner.ch",
    "phone": "+41-41-2486050",
    "website": "https://www.bmw.ch/de_CH/partner/steiner-group-buochs-47863.html",
    "coords": {
      "lat": 46.967674255371094,
      "lng": 8.398160934448242
    }
  },
  {
    "id": "20321_3",
    "name": "Claude Urfer SA Sierre",
    "country": "CH",
    "city": "Sierre",
    "address": "Route du Simplon 58, 3960 Sierre",
    "email": "info@urfersa.ch",
    "phone": "+41-58-1225220",
    "website": "https://www.bmw.ch/fr_CH/partner/claude-urfer-sierre-28204.html",
    "coords": {
      "lat": 46.29719924926758,
      "lng": 7.544384002685547
    }
  },
  {
    "id": "46577_1",
    "name": "Sepp Fässler (Wil) AG",
    "country": "CH",
    "city": "Wil",
    "address": "Flawilerstrasse 23, 9500 Wil",
    "email": "info.wil@faessler-garage.ch",
    "phone": "+41-71-9139933",
    "website": "https://www.bmw.ch/de_CH/partner/sepp-faessler-wil-31366.html",
    "coords": {
      "lat": 47.451961517333984,
      "lng": 9.053208351135254
    }
  },
  {
    "id": "46757_1",
    "name": "Dimab Riviera SA St-Légier",
    "country": "CH",
    "city": "St-Légier",
    "address": "Chemin de la Veyre d'en Haut A3, 1806 St-Légier",
    "email": "riviera@dimab.ch",
    "phone": "+41-21-9430070",
    "website": "https://www.bmw.ch/fr_CH/partner/dimab-riviera-33809.html",
    "coords": {
      "lat": 46.47682571411133,
      "lng": 6.860334873199463
    }
  },
  {
    "id": "47185_1",
    "name": "Facchinetti Automobiles (Genève-Meyrin) SA",
    "country": "CH",
    "city": "Meyrin",
    "address": "Route de Meyrin 214, 1217 Meyrin",
    "email": "info-ge@facchinetti.ch",
    "phone": "+41-22-9898100",
    "website": "https://www.bmw.ch/fr_CH/partner/facchinetti-automobiles-geneve-meyrin-34763.h",
    "coords": {
      "lat": 46.22560119628906,
      "lng": 6.080846786499023
    }
  },
  {
    "id": "07016_4",
    "name": "Binelli Automobile AG Filiale Zürich",
    "country": "CH",
    "city": "Zürich",
    "address": "Badenerstrasse 527, 8048 Zürich",
    "email": "info.zuerich@binelli-group.ch",
    "phone": "+41-58-2707777",
    "website": "https://www.bmw.ch/de_CH/partner/binelli-automobile-zuerich-07098.html",
    "coords": {
      "lat": 47.38212966918945,
      "lng": 8.50160026550293
    }
  },
  {
    "id": "07016_8",
    "name": "Binelli Automobile AG Filiale Sihlbrugg",
    "country": "CH",
    "city": "Sihlbrugg",
    "address": "Sihlbruggstrasse 138, 6340 Sihlbrugg",
    "email": "info.sihlbrugg@binelli-group.ch",
    "phone": "+41-58-2707676",
    "website": "https://www.bmw.ch/de_CH/partner/binelli-automobile-sihlbrugg-51151.html",
    "coords": {
      "lat": 47.215267181396484,
      "lng": 8.570982933044434
    }
  },
  {
    "id": "07037_1",
    "name": "Gerber Auto AG",
    "country": "CH",
    "city": "Burgdorf",
    "address": "Kirchbergstrasse 140, 3400 Burgdorf",
    "email": "info@bmw-gerber.ch",
    "phone": "+41-34-4200202",
    "website": "https://www.bmw.ch/de_CH/partner/gerber-auto-burgdorf-07037.html",
    "coords": {
      "lat": 47.06521987915039,
      "lng": 7.6113600730896
    }
  },
  {
    "id": "07296_2",
    "name": "Dimab SA Yverdon",
    "country": "CH",
    "city": "Yverdon",
    "address": "Avenue Haldimand 34, 1401 Yverdon",
    "email": "yverdon@bmw-dimab.ch",
    "phone": "+41-26-6624120",
    "website": "https://www.bmw.ch/fr_CH/partner/dimab-yverdon-43315.html",
    "coords": {
      "lat": 46.77878189086914,
      "lng": 6.646141052246094
    }
  },
  {
    "id": "29658_1",
    "name": "Brand Automobile AG",
    "country": "CH",
    "city": "Schattdorf",
    "address": "Gotthardstrasse 66, 6467 Schattdorf",
    "email": "info@brand-automobile.ch",
    "phone": "+41-41-8742030",
    "website": "https://www.bmw.ch/de_CH/partner/brand-automobile-schattdorf-29658.html",
    "coords": {
      "lat": 46.86358642578125,
      "lng": 8.647769927978516
    }
  },
  {
    "id": "30290_2",
    "name": "Facchinetti Automobiles SA",
    "country": "CH",
    "city": "La Chaux-de-Fonds",
    "address": "Boulevard de la Liberté 2, 2300 La Chaux-de-Fonds",
    "email": "info@facchinetti.ch",
    "phone": "+41-32-7202222",
    "website": "https://www.bmw.ch/fr_CH/partner/facchinetti-automobiles-chaux-de-fonds-37152.",
    "coords": {
      "lat": 47.09334945678711,
      "lng": 6.822152614593506
    }
  },
  {
    "id": "07057_2",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Dielsdorf",
    "country": "CH",
    "city": "Dielsdorf",
    "address": "Industriestrasse 6, 8157 Dielsdorf",
    "email": "info-dielsdorf@hedinautomotive.ch",
    "phone": "+41-58-2697100",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-dielsdorf-49791.html",
    "coords": {
      "lat": 47.48368453979492,
      "lng": 8.464578628540039
    }
  },
  {
    "id": "07057_1",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Wohlen",
    "country": "CH",
    "city": "Wohlen",
    "address": "Schützenmattweg 20, 5610 Wohlen",
    "email": "Info-wohlen@hedinautomotive.ch",
    "phone": "+41-56-6188525",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-wohlen-07057.html",
    "coords": {
      "lat": 47.35771942138672,
      "lng": 8.272135734558105
    }
  },
  {
    "id": "07057_4",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Samstagern",
    "country": "CH",
    "city": "Samstagern",
    "address": "Hügsamstrasse 2, 8833 Samstagern",
    "email": "Info-samstagern@hedinautomotive.ch",
    "phone": "+41-44-7875555",
    "website": "https://www.bmw.ch/de_CH/partner/hedin-automotive-samstagern-07104.html",
    "coords": {
      "lat": 47.196407318115234,
      "lng": 8.680130958557129
    }
  },
  {
    "id": "07057_6",
    "name": "Hedin Automotive Schweiz AG Zweigniederlassung Widnau",
    "country": "CH",
    "city": "Widnau",
    "address": "Unterdorfstrasse 85, 9443 Widnau",
    "email": "info-widnau@hedinautomotive.ch",
    "phone": "+41-71-7272040",
    "website": "https://dealer.bmw.ch/alpinagroup-widnau",
    "coords": {
      "lat": 47.41598129272461,
      "lng": 9.63467025756836
    }
  },
  {
    "id": "07296_1",
    "name": "Dimab SA Payerne",
    "country": "CH",
    "city": "Payerne",
    "address": "ZI la Palaz c 36, 1530 Payerne",
    "email": "payerne@dimab.ch",
    "phone": "+41-26-6624030",
    "website": "https://www.bmw.ch/fr_CH/partner/dimab-payerne-07296.html",
    "coords": {
      "lat": 46.825462341308594,
      "lng": 6.9284796714782715
    }
  },
  {
    "id": "07021_1",
    "name": "Garage Burkhardt AG",
    "country": "CH",
    "city": "Oberkirch",
    "address": "Neuweidstrasse 6, 6208 Oberkirch",
    "email": "info@garage-burkhardt.ch",
    "phone": "+41-41-9252727",
    "website": "https://www.bmw.ch/de_CH/partner/garage-burkhardt-oberkirch-07021.html",
    "coords": {
      "lat": 47.15135192871094,
      "lng": 8.118308067321777
    }
  },
  {
    "id": "07033_2",
    "name": "Garage Torretta SA Biasca",
    "country": "CH",
    "city": "Biasca",
    "address": "Via Chiasso 16, 6710 Biasca",
    "email": "info@bmw-torretta.ch",
    "phone": "+41-91-8625252",
    "website": "https://www.bmw.ch/it_CH/partner/garage-torretta-biasca-44842.html",
    "coords": {
      "lat": 46.343353271484375,
      "lng": 8.975754737854004
    }
  },
  {
    "id": "07033_3",
    "name": "Garage Torretta SA Minusio",
    "country": "CH",
    "city": "Minusio",
    "address": "Via Rinaldo Simen 56, 6648 Minusio",
    "email": "info-minusio@bmw-torretta.ch",
    "phone": "+41-91-7358931",
    "website": "https://dealer.bmw.ch/torretta-minusio/it",
    "coords": {
      "lat": 46.17583084106445,
      "lng": 8.820019721984863
    }
  },
  {
    "id": "07094_4",
    "name": "Steiner Group AG Nebikon",
    "country": "CH",
    "city": "Nebikon",
    "address": "Vorstatt 28, 6244 Nebikon",
    "email": "info@steiner-group.ch",
    "phone": "+41-41-2487055",
    "website": "https://www.steiner-group.ch/de",
    "coords": {
      "lat": 47.18922805786133,
      "lng": 7.973923206329346
    }
  },
  {
    "id": "07130_5",
    "name": "Emil Frey SA Succursale Centre Automobile Romand",
    "country": "CH",
    "city": "Crissier",
    "address": "Chemin de la Closalet 19, 1023 Crissier",
    "email": "info-bmw.crissier@emilfrey.ch",
    "phone": "+41-21-6312411",
    "website": "https://www.bmw.ch/fr_CH/partner/emil-frey-crissier-07083.html",
    "coords": {
      "lat": 46.556007385253906,
      "lng": 6.570609092712402
    }
  },
  {
    "id": "07143_1",
    "name": "Auto Derungs AG",
    "country": "CH",
    "city": "Ilanz",
    "address": "Via Crappa Grossa 20, 7130 Ilanz",
    "email": "info@auto-derungs.ch",
    "phone": "+41-81-9201010",
    "website": "https://www.bmw.ch/de_CH/partner/auto-derungs-ilanz-07143.html",
    "coords": {
      "lat": 46.774715423583984,
      "lng": 9.193821907043457
    }
  },
  {
    "id": "07182_1",
    "name": "Peter Winter GmbH",
    "country": "CH",
    "city": "Zwillikon",
    "address": "Ottenbacherstrasse 26, 8909 Zwillikon",
    "email": "info@bmw-service-winter.ch",
    "phone": "+41-44-7611212",
    "website": "https://www.bmw.ch/de_CH/partner/peter-winter-zwillikon-07182.html",
    "coords": {
      "lat": 47.288909912109375,
      "lng": 8.441190719604492
    }
  },
  {
    "id": "05497_1",
    "name": "Abt Automobile AG",
    "country": "CH",
    "city": "Liestal",
    "address": "Altmarktstr./Lausenerstr. 11, 4410 Liestal",
    "email": "info.liestal@abtautomobile.ch",
    "phone": "+41-61-9268555",
    "website": "https://www.bmw.ch/de_CH/partner/abt-automobile-liestal-05497.html",
    "coords": {
      "lat": 47.4772834777832,
      "lng": 7.747377872467041
    }
  },
  {
    "id": "07100_1",
    "name": "Vogelsang AG Garage + Carrosserie",
    "country": "CH",
    "city": "Grenchen",
    "address": "Bielstrasse 85, 2540 Grenchen",
    "email": "info@auto-vogelsang.ch",
    "phone": "+41-32-6542222",
    "website": "https://www.bmw.ch/de_CH/partner/vogelsang-grenchen-07100.html",
    "coords": {
      "lat": 47.1892204284668,
      "lng": 7.388204097747803
    }
  },
  {
    "id": "07130_11",
    "name": "Emil Frey AG Züri-Oberland Volketswil",
    "country": "CH",
    "city": "Volketswil",
    "address": "Industriestrasse 2 b, 8604 Volketswil",
    "email": "info-zo-volketswil@emilfrey.ch",
    "phone": "+41-44-9081818",
    "website": "https://www.bmw.ch/de_CH/partner/emil-frey-volketswil-10661.html",
    "coords": {
      "lat": 47.382789611816406,
      "lng": 8.664917945861816
    }
  },
  {
    "id": "07248_1",
    "name": "Bellevue Auto AG",
    "country": "CH",
    "city": "Hochdorf",
    "address": "Baldeggstrasse 18, 6280 Hochdorf",
    "email": "info@bmw-bellevue.ch",
    "phone": "+41-41-9106161",
    "website": "https://www.bmw.ch/de_CH/partner/bellevue-auto-hochdorf-07248.html",
    "coords": {
      "lat": 47.17087936401367,
      "lng": 8.286629676818848
    }
  },
  {
    "id": "20571_1",
    "name": "ACW Auto-Center Visp AG",
    "country": "CH",
    "city": "Eyholz",
    "address": "Kantonsstrasse 6, 3930 Eyholz",
    "email": "info@acwauto.ch",
    "phone": "+41-27-9481680",
    "website": "https://www.bmw.ch/de_CH/partner/acw-auto-center-eyholz-visp-20571.html",
    "coords": {
      "lat": 46.294029235839844,
      "lng": 7.905126094818115
    }
  },
  {
    "id": "05497_3",
    "name": "Abt Automobile AG Reinach",
    "country": "CH",
    "city": "Reinach",
    "address": "Aumattstrasse 144, 4153 Reinach",
    "email": "info.reinach@abtautomobile.ch",
    "phone": "+41-61-7155000",
    "website": "https://www.bmw.ch/de_CH/partner/abt-automobile-reinach-46658.html",
    "coords": {
      "lat": 47.49027633666992,
      "lng": 7.59711217880249
    }
  },
  {
    "id": "07016_5",
    "name": "Binelli Automobile AG Filiale Baar",
    "country": "CH",
    "city": "Baar",
    "address": "Neuhofstrasse 1, 6341 Baar",
    "email": "info.zug@binelli-group.ch",
    "phone": "+41-58-2707575",
    "website": "https://www.bmw.ch/de_CH/partner/binelli-automobile-baar-21285.html",
    "coords": {
      "lat": 47.19110870361328,
      "lng": 8.513114929199219
    }
  },
  {
    "id": "07102_1",
    "name": "Autoverkehr Region Bern AG",
    "country": "CH",
    "city": "Bern-Worblaufen",
    "address": "Hubelgutstrasse 2, 3048 Bern-Worblaufen",
    "email": "bern@autoverkehr.ch",
    "phone": "+41-31-9211658",
    "website": "https://www.bmw.ch/de_CH/partner/autoverkehr-region-bern-worblaufen-07102.html",
    "coords": {
      "lat": 46.98090744018555,
      "lng": 7.4558000564575195
    }
  },
  {
    "id": "46236_1",
    "name": "Autoverkehr AG Biel/Bienne",
    "country": "CH",
    "city": "Biel/Bienne",
    "address": "Längfeldweg 90, 2504 Biel/Bienne",
    "email": "biel-bienne@autoverkehr.ch",
    "phone": "+41-32-3667900",
    "website": "https://www.bmw.ch/de_CH/partner/autoverkehr-biel-bienne-09485.html",
    "coords": {
      "lat": 47.150821685791016,
      "lng": 7.2801899909973145
    }
  },
  {
    "id": "47937_1",
    "name": "Autoverkehr AG Langenthal",
    "country": "CH",
    "city": "Langenthal",
    "address": "Gaswerkstrasse 41, 4900 Langenthal",
    "email": "langenthal@autoverkehr.ch",
    "phone": "+41-62-2071111",
    "website": "https://www.bmw.ch/de_CH/partner/autoverkehr-langenthal-47937.html",
    "coords": {
      "lat": 47.22837829589844,
      "lng": 7.787553787231445
    }
  },
  {
    "id": "20321_1",
    "name": "Claude Urfer SA Martigny",
    "country": "CH",
    "city": "Martigny",
    "address": "Rue du Levant 171, 1920 Martigny",
    "email": "info@urfersa.ch",
    "phone": "+41-58-1225210",
    "website": "https://www.bmw.ch/fr_CH/partner/claude-urfer-martigny-20321.html",
    "coords": {
      "lat": 46.1068000793457,
      "lng": 7.099785804748535
    }
  },
  {
    "id": "20571_2",
    "name": "ACW Auto-Center Brig",
    "country": "CH",
    "city": "Gamsen",
    "address": "Kantonsstrasse 338, 3900 Gamsen",
    "email": "info@acwauto.ch",
    "phone": "+41-27-9221680",
    "website": "https://www.bmw-acw.ch",
    "coords": {
      "lat": 46.30628967285156,
      "lng": 7.959349632263184
    }
  },
  {
    "id": "28034_1",
    "name": "Autoverkehr AG Zuchwil",
    "country": "CH",
    "city": "Zuchwil",
    "address": "Gewerbestrasse 1, 4528 Zuchwil",
    "email": "zuchwil@autoverkehr.ch",
    "phone": "+41-32-6865311",
    "website": "https://www.bmw.ch/de_CH/partner/autoverkehr-zuchwil-28034.html",
    "coords": {
      "lat": 47.20145034790039,
      "lng": 7.572444915771484
    }
  },
  {
    "id": "30631_1",
    "name": "Bickel Auto AG Frauenfeld",
    "country": "CH",
    "city": "Frauenfeld",
    "address": "Messenriet 2, 8500 Frauenfeld",
    "email": "info@bickelautoag.ch",
    "phone": "+41-52-7289191",
    "website": "https://www.bmw.ch/de_CH/partner/bickel-auto-frauenfeld-30631.html",
    "coords": {
      "lat": 47.5526237487793,
      "lng": 8.869629859924316
    }
  },
  {
    "id": "07130_1",
    "name": "Emil Frey SA Succursale de Genève Acacias",
    "country": "CH",
    "city": "Genève 26",
    "address": "Route des Acacias 23, 1211 Genève 26",
    "email": "info-bmw.geneve@emilfrey.ch",
    "phone": "+41-22-3085308",
    "website": "https://www.bmw.ch/fr_CH/partner/emil-frey-geneve-07130.html",
    "coords": {
      "lat": 46.19143295288086,
      "lng": 6.135584831237793
    }
  },
  {
    "id": "07155_1",
    "name": "Häusermann AG",
    "country": "CH",
    "city": "Aarau",
    "address": "Rohrerstrasse 30, 5001 Aarau",
    "email": "info@garage-haeusermann.ch",
    "phone": "+41-62-8382080",
    "website": "https://www.bmw.ch/de_CH/partner/haeusermann-garage-aarau-07155.html",
    "coords": {
      "lat": 47.394920349121094,
      "lng": 8.05840015411377
    }
  },
  {
    "id": "07039_1",
    "name": "Horben Garage AG",
    "country": "CH",
    "city": "Ebnat-Kappel",
    "address": "Horben 1858, 9642 Ebnat-Kappel",
    "email": "info@horben-garage.ch",
    "phone": "+41-71-9933733",
    "website": "https://www.bmw.ch/de_CH/partner/horben-garage-ebnat-kappel-07039.html",
    "coords": {
      "lat": 47.255348205566406,
      "lng": 9.1533203125
    }
  },
  {
    "id": "07086_1",
    "name": "Garage Suter AG",
    "country": "CH",
    "city": "Ringgenberg",
    "address": "Hauptstrasse 276, 3852 Ringgenberg",
    "email": "info@garage-suter.ch",
    "phone": "+41-33-8260060",
    "website": "https://www.bmw.ch/de_CH/partner/garage-suter-ringgenberg-07086.html",
    "coords": {
      "lat": 46.70697021484375,
      "lng": 7.9012298583984375
    }
  },
  {
    "id": "07107_1",
    "name": "Graf Automobile AG",
    "country": "CH",
    "city": "Rupperswil",
    "address": "Bruggerstrasse 25, 5102 Rupperswil",
    "email": "info@graf-automobile.ch",
    "phone": "+41-62-8891070",
    "website": "https://www.bmw.ch/de_CH/partner/graf-automobile-rupperswil-07107.html",
    "coords": {
      "lat": 47.406742095947266,
      "lng": 8.133959770202637
    }
  },
  {
    "id": "07020_1",
    "name": "R. Bühler AG",
    "country": "CH",
    "city": "Neuenegg",
    "address": "Austrasse 8, 3176 Neuenegg",
    "email": "info@auto-buehler.ch",
    "phone": "+41-31-7446868",
    "website": "https://www.bmw.ch/de_CH/partner/buehler-neuenegg-07020.html",
    "coords": {
      "lat": 46.89448547363281,
      "lng": 7.304943561553955
    }
  },
  {
    "id": "30290_1",
    "name": "Facchinetti Automobiles SA Neuchâtel",
    "country": "CH",
    "city": "Neuchâtel",
    "address": "Avenue des Portes-Rouges 12, 2000 Neuchâtel",
    "email": "info@facchinetti.ch",
    "phone": "+41-32-7202222",
    "website": "https://www.bmw.ch/fr_CH/partner/facchinetti-automobiles-neuchatel-30290.html",
    "coords": {
      "lat": 47.002655029296875,
      "lng": 6.951255798339844
    }
  },
  {
    "id": "05627_1",
    "name": "AutoFrey GmbH Standort Villach",
    "country": "AT",
    "city": "Villach",
    "address": "Auenweg 39, 9500 Villach",
    "email": "info.villach@autofrey.at",
    "phone": "+43-4242-35422",
    "website": "https://www.autofrey.at",
    "coords": {
      "lat": 46.59170913696289,
      "lng": 13.835670471191406
    }
  },
  {
    "id": "05768_2",
    "name": "Höglinger Denzel GesmbH",
    "country": "AT",
    "city": "Linz",
    "address": "Estermannstraße 2-4, 4020 Linz",
    "email": "info@hoeglinger.bmw.at",
    "phone": "+43-732-798030",
    "website": "https://bmw-hoeglinger-denzel-linz.at",
    "coords": {
      "lat": 48.30466842651367,
      "lng": 14.320639610290527
    }
  },
  {
    "id": "07718_1",
    "name": "Autohaus Huber GmbH",
    "country": "AT",
    "city": "Bruck/Oberaich",
    "address": "Brucker Straße 128, 8600 Bruck/Oberaich",
    "email": "anfragen@huber.bmw.at",
    "phone": "+43-3862-58200",
    "website": "https://bmw-huber-bruck-oberaich.at",
    "coords": {
      "lat": 47.400413513183594,
      "lng": 15.23859691619873
    }
  },
  {
    "id": "24468_1",
    "name": "Fritz Köchl GmbH",
    "country": "AT",
    "city": "Ramingstein",
    "address": "Trieblingstraße 328, 5591 Ramingstein",
    "email": "fritz@koechl.bmw.at",
    "phone": "+43-6475-345",
    "website": "https://bmw-service-koechl-ramingstein.at",
    "coords": {
      "lat": 47.07424545288086,
      "lng": 13.830389976501465
    }
  },
  {
    "id": "07510_2",
    "name": "Bierbaum GesmbH Standort Eisenstadt",
    "country": "AT",
    "city": "Eisenstadt",
    "address": "Mattersburger Str. 42, 7000 Eisenstadt",
    "email": "info@bierbaumei.bmw.at",
    "phone": "+43-2682-61501",
    "website": "https://www.bmw-bierbaum.at",
    "coords": {
      "lat": 47.82952117919922,
      "lng": 16.522350311279297
    }
  },
  {
    "id": "07552_1",
    "name": "Autohaus Dallamassl GmbH",
    "country": "AT",
    "city": "Horn-Frauenhofen",
    "address": "Scheibenstraße 30, 3580 Horn-Frauenhofen",
    "email": "info@dallamassl.bmw.at",
    "phone": "+43-2982-20301",
    "website": "https://bmw-dallamassl-horn-frauenhofen.at",
    "coords": {
      "lat": 48.667205810546875,
      "lng": 15.629485130310059
    }
  },
  {
    "id": "07561_1",
    "name": "Autohaus Grasmann GmbH",
    "country": "AT",
    "city": "Steinbach am Attersee",
    "address": "Seefeld 9, 4853 Steinbach am Attersee",
    "email": "steinbach@bmw-grasmann.at",
    "phone": "+43-7663-315",
    "website": "https://www.bmw-grasmann.at",
    "coords": {
      "lat": 47.840980529785156,
      "lng": 13.547430038452148
    }
  },
  {
    "id": "07587_1",
    "name": "BMW Wien Heiligenstadt",
    "country": "AT",
    "city": "Wien",
    "address": "Heiligenstädter Lände 27, 1190 Wien",
    "email": "office@bmw-wien.at",
    "phone": "+43-1-360610",
    "website": "https://bmw-wien-heiligenstadt.at",
    "coords": {
      "lat": 48.24230194091797,
      "lng": 16.36477279663086
    }
  },
  {
    "id": "07588_1",
    "name": "Autohaus Gönitzer GmbH",
    "country": "AT",
    "city": "Wolfsberg",
    "address": "Grazer Straße 4, 9400 Wolfsberg",
    "email": "info@goenitzer.bmw.at",
    "phone": "+43-4352-2540",
    "website": "https://bmw-goenitzer-wolfsberg.at",
    "coords": {
      "lat": 46.84273147583008,
      "lng": 14.841710090637207
    }
  },
  {
    "id": "32473_1",
    "name": "Automobile Baschinger GmbH",
    "country": "AT",
    "city": "Leonding",
    "address": "Welserstraße 120, 4060 Leonding",
    "email": "info@baschinger.bmw.at",
    "phone": "+43-732-6772770",
    "website": "https://bmw-service-baschinger-leonding.at",
    "coords": {
      "lat": 48.24932861328125,
      "lng": 14.242779731750488
    }
  },
  {
    "id": "07510_1",
    "name": "Bierbaum GesmbH Standort Baden",
    "country": "AT",
    "city": "Baden",
    "address": "Vöslauer Straße 73, 2500 Baden",
    "email": "info@bierbaumbd.bmw.at",
    "phone": "+43-2252-84100-0",
    "website": "https://www.bmw-bierbaum.at",
    "coords": {
      "lat": 47.998348236083984,
      "lng": 16.228919982910156
    }
  },
  {
    "id": "07629_7",
    "name": "Wolfgang Denzel Auto AG Standort Wien Gumpendorf",
    "country": "AT",
    "city": "Wien",
    "address": "Gumpendorferstraße 19, 1060 Wien",
    "email": "office12@denzel.at",
    "phone": "+43-1-58878",
    "website": "https://bmw-denzel-wien-gumpendorf.at",
    "coords": {
      "lat": 48.19947052001953,
      "lng": 16.359909057617188
    }
  },
  {
    "id": "07635_1",
    "name": "Papst GmbH",
    "country": "AT",
    "city": "Voitsberg",
    "address": "Grazer Vorstadt 120, 8570 Voitsberg",
    "email": "info@papst.bmw.at",
    "phone": "+43-3142-23745",
    "website": "https://bmw-papst-voitsberg.at",
    "coords": {
      "lat": 47.038848876953125,
      "lng": 15.166170120239258
    }
  },
  {
    "id": "07550_1",
    "name": "Josef Mann GmbH",
    "country": "AT",
    "city": "Pressbaum",
    "address": "Hauptstrasse 29 und 31a, 3021 Pressbaum",
    "email": "info@mann.bmw.at",
    "phone": "+43-2233-523650",
    "website": "https://bmw-mann-pressbaum.at",
    "coords": {
      "lat": 48.18216323852539,
      "lng": 16.086259841918945
    }
  },
  {
    "id": "07540_2",
    "name": "Gady Automobile GmbH Standort Deutsch-Goritz",
    "country": "AT",
    "city": "Deutsch-Goritz",
    "address": "Deutsch Goritz 26, 8483 Deutsch-Goritz",
    "email": "info@gady.at",
    "phone": "+43-3474-8256",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 46.75138473510742,
      "lng": 15.828510284423828
    }
  },
  {
    "id": "07629_1",
    "name": "Wolfgang Denzel Auto AG Standort Graz",
    "country": "AT",
    "city": "Graz",
    "address": "Wetzelsdorfer Straße 35, 8020 Graz",
    "email": "office31@gmail.com",
    "phone": "+43-316-5070",
    "website": "https://bmw-service-denzel-graz.at",
    "coords": {
      "lat": 47.05893325805664,
      "lng": 15.412432670593262
    }
  },
  {
    "id": "10621_1",
    "name": "Zorn-Wolf GmbH",
    "country": "AT",
    "city": "Imst",
    "address": "Langgasse 89, 6460 Imst",
    "email": "info@zorn-wolf.at",
    "phone": "+43-5412-63518",
    "website": "https://bmw-zorn-wolf-imst.at",
    "coords": {
      "lat": 47.228111267089844,
      "lng": 10.74594497680664
    }
  },
  {
    "id": "07527_1",
    "name": "Autohaus Harmtodt GmbH",
    "country": "AT",
    "city": "Grafendorf",
    "address": "Hauptstraße 240, 8232 Grafendorf",
    "email": "info@harmtodt.bmw.at",
    "phone": "+43-3338-2275",
    "website": "https://harmtodt.com/",
    "coords": {
      "lat": 47.33533477783203,
      "lng": 15.990947723388672
    }
  },
  {
    "id": "21525_1",
    "name": "Autohaus Hütter GmbH",
    "country": "AT",
    "city": "Braunau/Inn",
    "address": "Industriezeile 51, 5280 Braunau/Inn",
    "email": "info@autohaus-huetter.at",
    "phone": "+43-7722-85558",
    "website": "https://bmw-huetter-braunau.at",
    "coords": {
      "lat": 48.24626159667969,
      "lng": 13.05366039276123
    }
  },
  {
    "id": "07549_2",
    "name": "Denzel Zitta GmbH Standort Wr. Neustadt",
    "country": "AT",
    "city": "Wiener Neustadt",
    "address": "Prof.-Dr.-Stephan-Koren-Str. 12, 2700 Wiener Neustadt",
    "email": "office23@zitta.at",
    "phone": "+43-2622-219900",
    "website": "https://bmw-zitta-wiener-neustadt.at",
    "coords": {
      "lat": 47.83927917480469,
      "lng": 16.246021270751953
    }
  },
  {
    "id": "07549_3",
    "name": "Denzel Zitta GmbH Standort Bruckneudorf",
    "country": "AT",
    "city": "Bruckneudorf",
    "address": "Parndorfer Straße 22, 2460 Bruckneudorf",
    "email": "office22@denzel.at",
    "phone": "+43-2162-64136",
    "website": "https://bmw-zitta-bruckneudorf.at",
    "coords": {
      "lat": 48.01972198486328,
      "lng": 16.788536071777344
    }
  },
  {
    "id": "05612_2",
    "name": "AutoFrey GmbH Standort Hallwang",
    "country": "AT",
    "city": "Hallwang",
    "address": "Wiener Bundesstraße 81, 5300 Hallwang",
    "email": "info.hallwang@autofrey.at",
    "phone": "+43-6225-20090",
    "website": "https://home/partner/autofreygmbh.html",
    "coords": {
      "lat": 47.854698181152344,
      "lng": 13.107799530029297
    }
  },
  {
    "id": "07584_1",
    "name": "H. Slawitscheck GmbH",
    "country": "AT",
    "city": "St.Georgen am Ybbsfelde",
    "address": "Hart-Landstrasse 22, 3304 St.Georgen am Ybbsfelde",
    "email": "info@slawitscheck.at",
    "phone": "+43-7472-66799",
    "website": "https://www.slawitscheck.at/autohandel/marken/bmw",
    "coords": {
      "lat": 48.11406326293945,
      "lng": 14.925809860229492
    }
  },
  {
    "id": "07564_1",
    "name": "Unterberger Automobile GmbH & Co KG Standort St. Johann",
    "country": "AT",
    "city": "St. Johann/Tirol",
    "address": "Anichweg 1, 6380 St. Johann/Tirol",
    "email": "office.stj@unterberger.bmw.at",
    "phone": "+43-5352-62389",
    "website": "https://at.unterberger.cc/standorte/st-johann/",
    "coords": {
      "lat": 47.530609130859375,
      "lng": 12.434049606323242
    }
  },
  {
    "id": "07538_2",
    "name": "Fritz Unterberger- Wolfgang Denzel GmbH & CO KG",
    "country": "AT",
    "city": "Telfs",
    "address": "Wildauweg 1, 6410 Telfs",
    "email": "info@unterberger-denzel.bmw.at",
    "phone": "+43-512-33435",
    "website": "https://at.unterberger.cc/standorte/telfs/",
    "coords": {
      "lat": 47.30717849731445,
      "lng": 11.080463409423828
    }
  },
  {
    "id": "05612_1",
    "name": "AutoFrey GmbH Standort Salzburg",
    "country": "AT",
    "city": "Salzburg",
    "address": "Alpenstraße 85, 5020 Salzburg",
    "email": "info.salzburg@autofrey.at",
    "phone": "+43-662-623581",
    "website": "https://www.autofrey.at",
    "coords": {
      "lat": 47.77881622314453,
      "lng": 13.069016456604004
    }
  },
  {
    "id": "07576_1",
    "name": "Hans Geyrhofer & Sohn GmbH",
    "country": "AT",
    "city": "Wels",
    "address": "Hans Sachs Straße 133, 4600 Wels",
    "email": "info@geyrhofer.bmw.at",
    "phone": "+43-7242-462370",
    "website": "https://bmw-geyrhofer-wels.at",
    "coords": {
      "lat": 48.17155075073242,
      "lng": 14.049880027770996
    }
  },
  {
    "id": "07580_1",
    "name": "Kfz-Service Winter KG",
    "country": "AT",
    "city": "Wien",
    "address": "Felsgasse 3, 1110 Wien",
    "email": "info@winter.bmw.at",
    "phone": "+43-1-7491341",
    "website": "https://bmw-service-winter-wien.at",
    "coords": {
      "lat": 48.17620086669922,
      "lng": 16.411348342895508
    }
  },
  {
    "id": "07587_4",
    "name": "BMW Wien - Zentrum GA Zentrum Gebrauchte Automobile",
    "country": "AT",
    "city": "Wien",
    "address": "Heiligenstädter Straße 66, 1190 Wien",
    "email": "office@bmw-wien.at",
    "phone": "+43-1-3684747",
    "website": "http://www.bmw-wien.at",
    "coords": {
      "lat": 48.242774963378906,
      "lng": 16.36142921447754
    }
  },
  {
    "id": "23472_1",
    "name": "Bauer GmbH",
    "country": "AT",
    "city": "Zwettl",
    "address": "Franz-Eigl-Straße 6, 3910 Zwettl",
    "email": "info@bauer.bmw.at",
    "phone": "+43-2822-340500",
    "website": "https://bmw-service-bauer-zwettl.at",
    "coords": {
      "lat": 48.60279083251953,
      "lng": 15.185859680175781
    }
  },
  {
    "id": "26360_1",
    "name": "Autohaus M. Grasmann GmbH",
    "country": "AT",
    "city": "Bad Goisern",
    "address": "Untere Marktstraße 75, 4822 Bad Goisern",
    "email": "goisern@bmw-grasmann.at",
    "phone": "+43-6135-20532",
    "website": "https://www.bmw-grasmann.at",
    "coords": {
      "lat": 47.64773178100586,
      "lng": 13.613493919372559
    }
  },
  {
    "id": "49880_2",
    "name": "Schmidt Premium Cars GmbH",
    "country": "AT",
    "city": "Wien",
    "address": "Wagramer Strasse 256, 1220 Wien",
    "email": "info@bmw-schmidt.at",
    "phone": "+43-1-3433330",
    "website": "https://schmidtpremiumcars.at/service/",
    "coords": {
      "lat": 48.267120361328125,
      "lng": 16.461050033569336
    }
  },
  {
    "id": "07572_4",
    "name": "drive ME GmbH Innviertel",
    "country": "AT",
    "city": "Hohenzell",
    "address": "Gewerbestrasse West 2, 4921 Hohenzell",
    "email": "info.ried@driveme.bmw.at",
    "phone": "+43-7752-85111",
    "website": "https://bmw-drive-me-innviertel.at",
    "coords": {
      "lat": 48.208805084228516,
      "lng": 13.527090072631836
    }
  },
  {
    "id": "07585_1",
    "name": "Peter Göndle Ges.m.b.H.",
    "country": "AT",
    "city": "St. Pölten",
    "address": "Wiener Straße 215, 3100 St. Pölten",
    "email": "info@goendle.bmw.at",
    "phone": "+43-2742-2575010",
    "website": "https://bmw-goendle-st-poelten.at",
    "coords": {
      "lat": 48.216007232666016,
      "lng": 15.653792381286621
    }
  },
  {
    "id": "07547_1",
    "name": "Automobile Knauss GmbH",
    "country": "AT",
    "city": "Weißenbach/Liezen",
    "address": "Knaufstraße 11, 8940 Weißenbach/Liezen",
    "email": "info@knauss.bmw.at",
    "phone": "+43-3612-22622",
    "website": "https://bmw-knauss-weissenbach.at",
    "coords": {
      "lat": 47.56962966918945,
      "lng": 14.214859962463379
    }
  },
  {
    "id": "07590_1",
    "name": "Autohaus Innerbichler GmbH",
    "country": "AT",
    "city": "Ramsau im Zillertal",
    "address": "Talstrasse 14, 6284 Ramsau im Zillertal",
    "email": "info@innerbichler.bmw.at",
    "phone": "+43-5282-2971",
    "website": "https://bmw-innerbichler-ramsau.at",
    "coords": {
      "lat": 47.211769104003906,
      "lng": 11.873417854309082
    }
  },
  {
    "id": "07617_1",
    "name": "AutoFrey GmbH",
    "country": "AT",
    "city": "Steyr",
    "address": "Prof.-Anton-Neumann-Str.4, 4400 Steyr",
    "email": "info.steyr@autofrey.at",
    "phone": "+43-7252-80988",
    "website": "https://www.autofrey.at/standort/steyr/",
    "coords": {
      "lat": 48.05425262451172,
      "lng": 14.418233871459961
    }
  },
  {
    "id": "07540_1",
    "name": "Gady Automobile GmbH Standort Lebring",
    "country": "AT",
    "city": "Lebring",
    "address": "Leibnitzer Strasse 76, 8403 Lebring",
    "email": "info@gady.at",
    "phone": "+43-3182-24570",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 46.846038818359375,
      "lng": 15.538370132446289
    }
  },
  {
    "id": "07540_3",
    "name": "Gady Automobile GmbH Standort Fehring",
    "country": "AT",
    "city": "Fehring",
    "address": "Bahnhofstraße 21, 8350 Fehring",
    "email": "info@gady.at",
    "phone": "+43-3155-2310",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 46.939353942871094,
      "lng": 16.012235641479492
    }
  },
  {
    "id": "07540_5",
    "name": "Gady Automobile GmbH Standort Graz-Nord",
    "country": "AT",
    "city": "Graz",
    "address": "Wiener Straße 314, 8051 Graz",
    "email": "info@gady.at",
    "phone": "+43-316-232316",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 47.0994873046875,
      "lng": 15.40368366241455
    }
  },
  {
    "id": "07549_4",
    "name": "Denzel Zitta GmbH Standort Wien Oberlaa",
    "country": "AT",
    "city": "Wien",
    "address": "Murbangasse 3, 1100 Wien",
    "email": "office21@denzel.at",
    "phone": "+43-1-6894690",
    "website": "https://bmw-zitta-wien.at",
    "coords": {
      "lat": 48.14599609375,
      "lng": 16.379011154174805
    }
  },
  {
    "id": "07625_1",
    "name": "Autohaus Reichhart GmbH",
    "country": "AT",
    "city": "Mauthausen",
    "address": "Perger Strasse 6, 4310 Mauthausen",
    "email": "info@reichhart.bmw.at",
    "phone": "+43-7238-25880",
    "website": "https://home/partner/autohausreichhart.html",
    "coords": {
      "lat": 48.246273040771484,
      "lng": 14.555971145629883
    }
  },
  {
    "id": "07629_5",
    "name": "Wolfgang Denzel Auto AG Standort Salzburg",
    "country": "AT",
    "city": "Salzburg",
    "address": "Innsbrucker Bundesstraße 79, 5020 Salzburg",
    "email": "office62@denzel.at",
    "phone": "+43-662-839400",
    "website": "https://bmw-service-denzel-salzburg.at",
    "coords": {
      "lat": 47.799320220947266,
      "lng": 13.010120391845703
    }
  },
  {
    "id": "40758_1",
    "name": "Denzel Plattner GmbH Standort Langenrohr",
    "country": "AT",
    "city": "Langenrohr",
    "address": "Europastraße 1, 3442 Langenrohr",
    "email": "office25@denzel.at",
    "phone": "+43-2272-66800",
    "website": "https://bmw-plattner-langenrohr.at",
    "coords": {
      "lat": 48.32078552246094,
      "lng": 16.022924423217773
    }
  },
  {
    "id": "07518_1",
    "name": "Autohaus Pestuka GmbH",
    "country": "AT",
    "city": "Zistersdorf",
    "address": "Umfahrungsstraße 30, 2225 Zistersdorf",
    "email": "info@pestuka.bmw.at",
    "phone": "+43-2532-2414",
    "website": "https://www.pestuka.at/",
    "coords": {
      "lat": 48.54283905029297,
      "lng": 16.765750885009766
    }
  },
  {
    "id": "20098_1",
    "name": "Reiterer GmbH",
    "country": "AT",
    "city": "Deutschlandsberg",
    "address": "Frauentaler Straße 104, 8530 Deutschlandsberg",
    "email": "info@reiterer.bmw.at",
    "phone": "+43-3462-7920",
    "website": "https://www.reiterer-autohaus.at/",
    "coords": {
      "lat": 46.82065963745117,
      "lng": 15.232516288757324
    }
  },
  {
    "id": "07629_3",
    "name": "Wolfgang Denzel Auto AG Standort Klagenfurt",
    "country": "AT",
    "city": "Klagenfurt",
    "address": "Feldkirchner Straße 90, 9020 Klagenfurt",
    "email": "office46@denzel.at",
    "phone": "+43-463-45400",
    "website": "https://bmw-denzel-klagenfurt.at",
    "coords": {
      "lat": 46.63683319091797,
      "lng": 14.29526424407959
    }
  },
  {
    "id": "07538_1",
    "name": "Unterberger Automobile GmbH & Co KG Standort Kufstein",
    "country": "AT",
    "city": "Kufstein",
    "address": "Endach 32, 6330 Kufstein",
    "email": "info@unterberger.cc",
    "phone": "+43-5372-6945",
    "website": "https://at.unterberger.cc/standorte/kufstein/",
    "coords": {
      "lat": 47.56562042236328,
      "lng": 12.151920318603516
    }
  },
  {
    "id": "10682_1",
    "name": "Fritz Unterberger- Wolfgang Denzel GesmbH & Co KG",
    "country": "AT",
    "city": "Innsbruck",
    "address": "Griesauweg 32, 6020 Innsbruck",
    "email": "info@unterberger-denzel.bmw.at",
    "phone": "+43-512-33435",
    "website": "https://at.unterberger.cc/standorte/innsbruck/",
    "coords": {
      "lat": 47.2675895690918,
      "lng": 11.439029693603516
    }
  },
  {
    "id": "53803_1",
    "name": "Unterberger Automobile GmbH & Co KG Standort Landeck",
    "country": "AT",
    "city": "Landeck",
    "address": "Innstraße 32, 6500 Landeck",
    "email": "info.landeck@unterberger.cc",
    "phone": "+43-5442-63076",
    "website": "https://at.unterberger.cc/standorte/landeck/",
    "coords": {
      "lat": 47.14072799682617,
      "lng": 10.564496994018555
    }
  },
  {
    "id": "45404_1",
    "name": "Unterberger Automobile GmbH & Co KG Standort Nenzing",
    "country": "AT",
    "city": "Nenzing",
    "address": "Bundesstrasse 96, 6710 Nenzing",
    "email": "info.nenzing@unterberger.bmw.at",
    "phone": "+43-5525-6971",
    "website": "https://at.unterberger.cc/standorte/nenzing/",
    "coords": {
      "lat": 47.188255310058594,
      "lng": 9.70666790008545
    }
  },
  {
    "id": "07510_3",
    "name": "BPS Platz Bierbaum Sooß",
    "country": "AT",
    "city": "Sooß",
    "address": "Bezirksstraße 21, 2500 Sooß",
    "email": "gw@bierbaumbd.bmw.at",
    "phone": "+43-2252-841000",
    "website": "http://bierbaum.bmw.at/206/index",
    "coords": {
      "lat": 47.982078552246094,
      "lng": 16.22102928161621
    }
  },
  {
    "id": "07587_2",
    "name": "BMW Wien Donaustadt",
    "country": "AT",
    "city": "Wien",
    "address": "Rautenweg 4-6, 1220 Wien",
    "email": "office@bmw-wien.at",
    "phone": "+43-1-25935460",
    "website": "https://bmw-wien-donaustadt.at",
    "coords": {
      "lat": 48.26430130004883,
      "lng": 16.456565856933594
    }
  },
  {
    "id": "24467_1",
    "name": "Unger GmbH",
    "country": "AT",
    "city": "St. Ruprecht/Raab",
    "address": "Dietmannsdorferstraße 330, 8181 St. Ruprecht/Raab",
    "email": "info@unger.bmw.at",
    "phone": "+43-3178-50080",
    "website": "https://bmw-unger-st-ruprecht-raab.at",
    "coords": {
      "lat": 47.149784088134766,
      "lng": 15.67326545715332
    }
  },
  {
    "id": "07556_1",
    "name": "Neuper GmbH",
    "country": "AT",
    "city": "Judenburg",
    "address": "Burggasse 110, 8750 Judenburg",
    "email": "info@neuper.bmw.at",
    "phone": "+43-3572-85333",
    "website": "https://bmw-neuper-judenburg.at",
    "coords": {
      "lat": 47.170631408691406,
      "lng": 14.64076042175293
    }
  },
  {
    "id": "07629_4",
    "name": "Wolfgang Denzel Auto AG Standort Wien Erdberg",
    "country": "AT",
    "city": "Wien",
    "address": "Erdbergstraße 189-193, 1030 Wien",
    "email": "office@denzel.at",
    "phone": "+43-1-740080",
    "website": "https://bmw-denzel-wien-erdberg.at",
    "coords": {
      "lat": 48.185791015625,
      "lng": 16.425010681152344
    }
  },
  {
    "id": "07572_1",
    "name": "drive ME GmbH",
    "country": "AT",
    "city": "Regau",
    "address": "Handelsstraße 1, 4844 Regau",
    "email": "info@driveme.bmw.at",
    "phone": "+43-7672-21224",
    "website": "https://bmw-drive-me-regau.at",
    "coords": {
      "lat": 47.99702072143555,
      "lng": 13.684528350830078
    }
  },
  {
    "id": "07624_1",
    "name": "J. Kneidinger GmbH",
    "country": "AT",
    "city": "Haslach",
    "address": "Sternwaldstraße 48, 4170 Haslach",
    "email": "info@kneidinger.bmw.at",
    "phone": "+43-7289-71797",
    "website": "https://bmw-kneidinger-haslach.at",
    "coords": {
      "lat": 48.574668884277344,
      "lng": 14.05232048034668
    }
  },
  {
    "id": "10161_2",
    "name": "Gady Auto Ost GmbH Standort St. Michael",
    "country": "AT",
    "city": "St. Michael",
    "address": "Oberwarter Straße 274, 7535 St. Michael",
    "email": "info@gady.at",
    "phone": "+43-3327-8161",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 47.127750396728516,
      "lng": 16.257259368896484
    }
  },
  {
    "id": "07540_6",
    "name": "Gady Automobile GmbH Standort Graz-Liebenau",
    "country": "AT",
    "city": "Graz-Liebenau",
    "address": "Liebenauer Hauptstraße 60, 8041 Graz-Liebenau",
    "email": "info@gady.at",
    "phone": "+43-316-4722200",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 47.04330062866211,
      "lng": 15.457610130310059
    }
  },
  {
    "id": "10161_1",
    "name": "Gady Auto Ost GmbH Standort Oberpullendorf",
    "country": "AT",
    "city": "Oberpullendorf",
    "address": "Stoob-Süd 24, 7350 Oberpullendorf",
    "email": "info@gady.at",
    "phone": "+43-2612-430000",
    "website": "https://bmw.gady.at/",
    "coords": {
      "lat": 47.51008987426758,
      "lng": 16.498090744018555
    }
  },
  {
    "id": "07593_1",
    "name": "Autohaus Rachbauer GmbH",
    "country": "AT",
    "city": "Ried /Innkreis",
    "address": "Grillparzerstraße 3, 4910 Ried /Innkreis",
    "email": "info@autohaus-rachbauer.at",
    "phone": "+43-7752-87979",
    "website": "https://bmw-service-rachbauer-ried.at",
    "coords": {
      "lat": 48.215309143066406,
      "lng": 13.483793258666992
    }
  },
  {
    "id": "52129_1",
    "name": "Denzel Krems GmbH Standort Krems",
    "country": "AT",
    "city": "Krems",
    "address": "Gewerbeparkstraße 37, 3500 Krems",
    "email": "verkauf36@denzel.at",
    "phone": "+43-2732-78200",
    "website": "https://bmw-denzel.at/",
    "coords": {
      "lat": 48.40825271606445,
      "lng": 15.668760299682617
    }
  },
  {
    "id": "07549_1",
    "name": "Denzel Zitta GmbH Standort Perchtoldsdorf",
    "country": "AT",
    "city": "Perchtoldsdorf",
    "address": "Muehlgasse 82, 2380 Perchtoldsdorf",
    "email": "office20@denzel.at",
    "phone": "+43-1-8690275",
    "website": "https://bmw-zitta-perchtoldsdorf.at",
    "coords": {
      "lat": 48.12373733520508,
      "lng": 16.288976669311523
    }
  },
  {
    "id": "07331_1",
    "name": "AutoFrey GmbH Standort St. Veit",
    "country": "AT",
    "city": "St. Veit",
    "address": "Gewerbestraße 1, 5621 St. Veit",
    "email": "info.stveit@autofrey.at",
    "phone": "+43-6415-7301",
    "website": "https://www.autofrey.at/",
    "coords": {
      "lat": 47.3232307434082,
      "lng": 13.17311954498291
    }
  },
  {
    "id": "07540_7",
    "name": "Gady Automobile GmbH",
    "country": "AT",
    "city": "Lieboch",
    "address": "Gadystrasse 1, 8501 Lieboch",
    "email": "info@gady.at",
    "phone": "+43-3136-90310",
    "website": "https://www.gady.at/standorte/uebersicht/l/lieboch",
    "coords": {
      "lat": 46.95808029174805,
      "lng": 15.345524787902832
    }
  },
  {
    "id": "47675_1",
    "name": "Unterberger Automobile GmbH & Co KG",
    "country": "AT",
    "city": "Kaprun",
    "address": "Landesstraße 30, 5710 Kaprun",
    "email": "info.kaprun@unterberger.cc",
    "phone": "+43-6547-8534",
    "website": "https://at.unterberger.cc/standorte/kaprun/",
    "coords": {
      "lat": 47.27690505981445,
      "lng": 12.757164001464844
    }
  },
  {
    "id": "07551_1",
    "name": "Thum & Unterberger GmbH",
    "country": "AT",
    "city": "Lienz",
    "address": "Peggetzstraße 10, 9900 Lienz",
    "email": "anfrage@thum-unterberger.cc",
    "phone": "+43-4852-63333",
    "website": "https://at.unterberger.cc/standorte/thum-unterberger-lienz/",
    "coords": {
      "lat": 46.82427978515625,
      "lng": 12.791299819946289
    }
  },
  {
    "id": "27907_1",
    "name": "Unterberger Automobile GmbH & Co KG Standort Dornbirn",
    "country": "AT",
    "city": "Dornbirn",
    "address": "Stiglingen 75, 6850 Dornbirn",
    "email": "info.dornbirn@unterberger.bmw.at",
    "phone": "+43-5572-232860",
    "website": "https://at.unterberger.cc/standorte/dornbirn/",
    "coords": {
      "lat": 47.43489074707031,
      "lng": 9.737990379333496
    }
  },
  {
    "id": "03624_1",
    "name": "Dusseldorp Schiedam B.V.",
    "country": "NL",
    "city": "Schiedam",
    "address": "Karel Doormanweg 21, 3115 JD Schiedam",
    "email": "Schiedam@dusseldorpbmw.nl",
    "phone": "+31-10-2462828",
    "website": "https://www.dusseldorpbmw.nl/",
    "coords": {
      "lat": 51.907203674316406,
      "lng": 4.372812747955322
    }
  },
  {
    "id": "03626_1",
    "name": "Ekris Heerlen",
    "country": "NL",
    "city": "HEERLEN",
    "address": "Terhoevenderweg 98, 6412 ZJ HEERLEN",
    "email": "Heerlen@ekris.nl",
    "phone": "+31-45-5452121",
    "website": "https://www.ekris.nl/bmw/over-ekris/vestigingen/heerlen",
    "coords": {
      "lat": 50.90399169921875,
      "lng": 5.948322772979736
    }
  },
  {
    "id": "03630_1",
    "name": "Van Poelgeest Hilversum B.V.",
    "country": "NL",
    "city": "Hilversum",
    "address": "Franciscusweg 4, 1216 SK Hilversum",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-35-6241156",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.21384811401367,
      "lng": 5.144951820373535
    }
  },
  {
    "id": "03631_1",
    "name": "Van Laarhoven BMW",
    "country": "NL",
    "city": "Eindhoven",
    "address": "Huizingalaan 64, 5628 CM Eindhoven",
    "email": "info@vanlaarhovenbmw.nl",
    "phone": "+31-40-2901100",
    "website": "http://www.vanlaarhovenbmw.nl",
    "coords": {
      "lat": 51.481143951416016,
      "lng": 5.455623626708984
    }
  },
  {
    "id": "03640_1",
    "name": "NobraCars Helmond",
    "country": "NL",
    "city": "Helmond",
    "address": "Varenschut 15, 5705 DK Helmond",
    "email": "info@nobracars.nl",
    "phone": "+31-492-530730",
    "website": "http://www.nobracars-helmond.nl",
    "coords": {
      "lat": 51.45934295654297,
      "lng": 5.693466663360596
    }
  },
  {
    "id": "08586_1",
    "name": "Van Poelgeest Alphen aan den Rijn",
    "country": "NL",
    "city": "Alphen A/d Rijn",
    "address": "Gouwelandenlaan 13, 2408 ZG Alphen A/d Rijn",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-172-422214",
    "website": "https://hanssevers.nl/",
    "coords": {
      "lat": 52.11168670654297,
      "lng": 4.6612749099731445
    }
  },
  {
    "id": "21136_1",
    "name": "Van Poelgeest Amersfoort B.V.",
    "country": "NL",
    "city": "Amersfoort",
    "address": "Ruimtevaart 2, 3824 MX Amersfoort",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-33-4621500",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.19539260864258,
      "lng": 5.397348880767822
    }
  },
  {
    "id": "03600_1",
    "name": "Dusseldorp Apeldoorn B.V.",
    "country": "NL",
    "city": "Apeldoorn",
    "address": "Kayersdijk 150, 7332 AW Apeldoorn",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-55-5380380",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-apeldoorn",
    "coords": {
      "lat": 52.18191146850586,
      "lng": 5.981594085693359
    }
  },
  {
    "id": "31107_1",
    "name": "Van Poelgeest Gouda",
    "country": "NL",
    "city": "Gouda",
    "address": "Antwerpseweg 11, 2803 PB Gouda",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-182-513000",
    "website": "https://www.seversbreeman.nl",
    "coords": {
      "lat": 52.020851135253906,
      "lng": 4.6841654777526855
    }
  },
  {
    "id": "30984_1",
    "name": "Van Poelgeest Noordwijk",
    "country": "NL",
    "city": "Noordwijk",
    "address": "Keyserswey 91, 2201 CX Noordwijk",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-71-4090910",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.213340759277344,
      "lng": 4.43678092956543
    }
  },
  {
    "id": "03571_1",
    "name": "Dusseldorp Hoorn B.V.",
    "country": "NL",
    "city": "Zwaag (Hoorn)",
    "address": "De Compagnie 27, 1689 AG Zwaag (Hoorn)",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-229-282100",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-hoorn",
    "coords": {
      "lat": 52.670982360839844,
      "lng": 5.054978847503662
    }
  },
  {
    "id": "03587_1",
    "name": "Dusseldorp Wateringen B.V.",
    "country": "NL",
    "city": "Wateringen",
    "address": "De Lierseweg 3, 2291 PD Wateringen",
    "email": "wateringen@dusseldorpbmw.nl",
    "phone": "+31-174-291891",
    "website": "https://www.dusseldorpbmw.nl/",
    "coords": {
      "lat": 52.0108528137207,
      "lng": 4.287093162536621
    }
  },
  {
    "id": "03639_1",
    "name": "Story Nijmegen",
    "country": "NL",
    "city": "NIJMEGEN",
    "address": "Neerbosscheweg 2, 6534 AA NIJMEGEN",
    "email": "info@story-nijmegen.nl",
    "phone": "+31-24-3719719",
    "website": "http://www.story-nijmegen.nl",
    "coords": {
      "lat": 51.826168060302734,
      "lng": 5.827444076538086
    }
  },
  {
    "id": "03645_1",
    "name": "Van Poelgeest Amstelveen B.V.",
    "country": "NL",
    "city": "Amstelveen",
    "address": "Burg A. Colijnweg 6-8, 1182 AL Amstelveen",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-20-5032300",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.303680419921875,
      "lng": 4.84473180770874
    }
  },
  {
    "id": "20758_1",
    "name": "Dusseldorp Oostzaan B.V.",
    "country": "NL",
    "city": "Oostzaan",
    "address": "Skoon 30, 1511 HV Oostzaan",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-75-6351901",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-zaandam",
    "coords": {
      "lat": 52.43153381347656,
      "lng": 4.873686790466309
    }
  },
  {
    "id": "22093_1",
    "name": "Ekris Groningen",
    "country": "NL",
    "city": "Groningen",
    "address": "Kieler Bocht 13, 9723 JA Groningen",
    "email": "groningen@ekris.nl",
    "phone": "+31-50-5717273",
    "website": "https://www.ekris.nl",
    "coords": {
      "lat": 53.21591567993164,
      "lng": 6.609002590179443
    }
  },
  {
    "id": "03686_1",
    "name": "Ekris Veenendaal",
    "country": "NL",
    "city": "Veenendaal",
    "address": "Plesmanstraat 45, 3905 KZ Veenendaal",
    "email": "veenendaal@ekris.nl",
    "phone": "+31-318-546546",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 52.04124450683594,
      "lng": 5.556831359863281
    }
  },
  {
    "id": "03596_1",
    "name": "De Maassche Echt",
    "country": "NL",
    "city": "Echt",
    "address": "Bellweg 3, 6101 XA Echt",
    "email": "infoecht@demaasschebmw.nl",
    "phone": "+31-475-386286",
    "website": "http://www.demaassche-echt.nl",
    "coords": {
      "lat": 51.11941909790039,
      "lng": 5.880305767059326
    }
  },
  {
    "id": "03633_1",
    "name": "Dusseldorp Alkmaar B.V.",
    "country": "NL",
    "city": "Alkmaar",
    "address": "Koraalstraat 5, 1812 RK Alkmaar",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-72-5617844",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-alkmaar",
    "coords": {
      "lat": 52.61188888549805,
      "lng": 4.750508785247803
    }
  },
  {
    "id": "03665_1",
    "name": "Story 's-Hertogenbosch",
    "country": "NL",
    "city": "'s-Hertogenbosch",
    "address": "Hervensebaan 29, 5232 JL 's-Hertogenbosch",
    "email": "info@story-denbosch.nl",
    "phone": "+31-73-6200400",
    "website": "http://www.story-denbosch.nl",
    "coords": {
      "lat": 51.706050872802734,
      "lng": 5.329582691192627
    }
  },
  {
    "id": "03664_1",
    "name": "Ekris Nijkerk",
    "country": "NL",
    "city": "Nijkerk",
    "address": "Patroonstraat 5, 3861 RN Nijkerk",
    "email": "nijkerk@ekris.nl",
    "phone": "+31-33-2456114",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 52.237548828125,
      "lng": 5.483622074127197
    }
  },
  {
    "id": "22003_1",
    "name": "Ekris Zeist",
    "country": "NL",
    "city": "Huis ter Heide",
    "address": "Blanckenhagenweg 22-24, 3712 DE Huis ter Heide",
    "email": "zeist@ekris.nl",
    "phone": "+31-30-6925872",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 52.10712432861328,
      "lng": 5.258513450622559
    }
  },
  {
    "id": "03580_2",
    "name": "Oostland Doetinchem B.V.",
    "country": "NL",
    "city": "Doetinchem",
    "address": "Innovatieweg 12, 7007 CD Doetinchem",
    "email": "info@oostland-doetinchem.nl",
    "phone": "+31-314-326351",
    "website": "https://www.oostlandbmw.nl",
    "coords": {
      "lat": 51.944580078125,
      "lng": 6.276039123535156
    }
  },
  {
    "id": "03589_1",
    "name": "Dusseldorp Rotterdam Noord",
    "country": "NL",
    "city": "Rotterdam",
    "address": "Autolettestraat 20, 3063 NP Rotterdam",
    "email": "rotterdamnoord@dusseldorpbmw.nl",
    "phone": "+31-10-2424000",
    "website": "https://www.dusseldorpbmw.nl/",
    "coords": {
      "lat": 51.91061782836914,
      "lng": 4.536092758178711
    }
  },
  {
    "id": "03588_1",
    "name": "De Maassche Venlo B.V.",
    "country": "NL",
    "city": "Venlo",
    "address": "Hudsonweg 1, 5928 LW Venlo",
    "email": "infovenlo@demaasschebmw.nl",
    "phone": "+31-77-3552333",
    "website": "http://www.demaassche-venlo.nl",
    "coords": {
      "lat": 51.39625549316406,
      "lng": 6.078422546386719
    }
  },
  {
    "id": "03604_1",
    "name": "Hedin Automotive Numansdorp",
    "country": "NL",
    "city": "Numansdorp",
    "address": "Burg. de Zeeuwstraat 130, 3281 AL Numansdorp",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-186-658111",
    "website": "https://www.dubbelsteyn.nl/bmw/",
    "coords": {
      "lat": 51.737674713134766,
      "lng": 4.44047212600708
    }
  },
  {
    "id": "03615_1",
    "name": "Dusseldorp Brielle",
    "country": "NL",
    "city": "Vierpolders (Brielle)",
    "address": "Seggelant - Oost 4, 3237 MH Vierpolders (Brielle)",
    "email": "brielle@dusseldorpbmw.nl",
    "phone": "+31-181-409050",
    "website": "https://www.dusseldorpbmw.nl/",
    "coords": {
      "lat": 51.892616271972656,
      "lng": 4.1946258544921875
    }
  },
  {
    "id": "03650_1",
    "name": "Hedin Automotive Tilburg",
    "country": "NL",
    "city": "Tilburg",
    "address": "Driehuizendijk 1, 5022 KD Tilburg",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-13-5422133",
    "website": "https://www.hedinautomotive.nl/bmw",
    "coords": {
      "lat": 51.545684814453125,
      "lng": 5.109342098236084
    }
  },
  {
    "id": "03699_1",
    "name": "Van Hooff B.V.",
    "country": "NL",
    "city": "Veldhoven",
    "address": "De Run 6803, 5504 DW Veldhoven",
    "email": "info@vanhooffbmw.nl",
    "phone": "+31-40-2532283",
    "website": "http://www.vanhooffbmw.nl/",
    "coords": {
      "lat": 51.40419006347656,
      "lng": 5.409878730773926
    }
  },
  {
    "id": "05755_1",
    "name": "Ekris Maastricht",
    "country": "NL",
    "city": "MAASTRICHT-AIRPORT",
    "address": "Australiëlaan 30, 6199 AA MAASTRICHT-AIRPORT",
    "email": "maastricht@ekris.nl",
    "phone": "+31-43-3618555",
    "website": "https://www.ekris.nl/bmw/over-ekris/vestigingen/maastricht-airport",
    "coords": {
      "lat": 50.923553466796875,
      "lng": 5.777032852172852
    }
  },
  {
    "id": "10087_1",
    "name": "Van Poelgeest Amsterdam B.V.",
    "country": "NL",
    "city": "Amsterdam - Duivendrecht",
    "address": "Pieter Braaijweg 12, 1114 AJ Amsterdam - Duivendrecht",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-20-4604690",
    "website": "https://www.van-poelgeest.nl/",
    "coords": {
      "lat": 52.328941345214844,
      "lng": 4.921274185180664
    }
  },
  {
    "id": "21845_1",
    "name": "Oostland Groenlo B.V.",
    "country": "NL",
    "city": "Groenlo",
    "address": "Winterswijkseweg 6, 7141 DN Groenlo",
    "email": "info@oostland-groenlo.nl",
    "phone": "+31-544-461360",
    "website": "https://www.oostlandbmw.nl/",
    "coords": {
      "lat": 52.03944778442383,
      "lng": 6.6202168464660645
    }
  },
  {
    "id": "03625_1",
    "name": "Dusseldorp Zwolle B.V.",
    "country": "NL",
    "city": "Zwolle",
    "address": "Molenland 4, 8024 AL Zwolle",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-38-4277357",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-zwolle",
    "coords": {
      "lat": 52.52524185180664,
      "lng": 6.122589588165283
    }
  },
  {
    "id": "03663_1",
    "name": "Van Poelgeest Naarden B.V.",
    "country": "NL",
    "city": "Naarden",
    "address": "Energiestraat 51, 1411 AS Naarden",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-35-6997676",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.30440139770508,
      "lng": 5.145448207855225
    }
  },
  {
    "id": "20298_1",
    "name": "Oostland Enschede B.V.",
    "country": "NL",
    "city": "Enschede",
    "address": "Spaansland 10, 7543 BG Enschede",
    "email": "info@oostland-enschede.nl",
    "phone": "+31-53-4310961",
    "website": "https://www.oostlandbmw.nl",
    "coords": {
      "lat": 52.204036712646484,
      "lng": 6.89122200012207
    }
  },
  {
    "id": "30983_1",
    "name": "Van Poelgeest Heemstede",
    "country": "NL",
    "city": "Heemstede",
    "address": "Cruquiusweg 25, 2102 LS Heemstede",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-23-5285284",
    "website": "https://www.van-poelgeest.nl/bmw",
    "coords": {
      "lat": 52.34477233886719,
      "lng": 4.627668857574463
    }
  },
  {
    "id": "03579_1",
    "name": "Kallenhard B.V.",
    "country": "NL",
    "city": "Gorinchem",
    "address": "Bannepoort 2, 4205 MZ Gorinchem",
    "email": "info@bergwerffbmw.nl",
    "phone": "+31-183-624011",
    "website": "http://www.bergwerffbmw.nl/",
    "coords": {
      "lat": 51.84354782104492,
      "lng": 4.951744079589844
    }
  },
  {
    "id": "03599_1",
    "name": "Hedin Automotive Dordrecht",
    "country": "NL",
    "city": "Dordrecht",
    "address": "Mijlweg 65, 3316 BE Dordrecht",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-78-6527600",
    "website": "https://www.dubbelsteyn.nl/bmw/",
    "coords": {
      "lat": 51.7902946472168,
      "lng": 4.648759841918945
    }
  },
  {
    "id": "03635_1",
    "name": "Hedin Automotive Waalwijk",
    "country": "NL",
    "city": "Waalwijk",
    "address": "Van Andelstraat 9, 5141 PB Waalwijk",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-416-332443",
    "website": "https://www.hedinautomotive.nl/bmw",
    "coords": {
      "lat": 51.68911361694336,
      "lng": 5.045195579528809
    }
  },
  {
    "id": "03693_1",
    "name": "Ekris Assen",
    "country": "NL",
    "city": "Assen",
    "address": "Transportweg 6, 9405 PR Assen",
    "email": "assen@ekris.nl",
    "phone": "+31-592-245245",
    "website": "https://www.ekris.nl",
    "coords": {
      "lat": 52.993377685546875,
      "lng": 6.520975589752197
    }
  },
  {
    "id": "05563_1",
    "name": "Oostland Almelo B.V.",
    "country": "NL",
    "city": "Almelo",
    "address": "Twentepoort West 4, 7609 RD Almelo",
    "email": "info@oostland-almelo.nl",
    "phone": "+31-546-545000",
    "website": "https://www.oostlandbmw.nl/",
    "coords": {
      "lat": 52.32933044433594,
      "lng": 6.649464130401611
    }
  },
  {
    "id": "08915_1",
    "name": "Ekris Flevoland",
    "country": "NL",
    "city": "Lelystad",
    "address": "Poseidonweg 5, 8239 DK Lelystad",
    "email": "lelystad@ekris.nl",
    "phone": "+31-320-211911",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 52.474098205566406,
      "lng": 5.485897541046143
    }
  },
  {
    "id": "20260_1",
    "name": "Hedin Automotive Roosendaal",
    "country": "NL",
    "city": "Roosendaal",
    "address": "Vlierwerf 2, 4704 SB Roosendaal",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-165-576376",
    "website": "https://www.hedinautomotive.nl/bmw",
    "coords": {
      "lat": 51.559478759765625,
      "lng": 4.463863372802734
    }
  },
  {
    "id": "20299_1",
    "name": "NobraCars Uden",
    "country": "NL",
    "city": "Uden",
    "address": "Hoevenseweg 22, 5403 PA Uden",
    "email": "info@nobracarsuden.nl",
    "phone": "+31-413-334977",
    "website": "http://www.nobracars-uden.nl",
    "coords": {
      "lat": 51.6754035949707,
      "lng": 5.640830039978027
    }
  },
  {
    "id": "03606_1",
    "name": "Dusseldorp Deventer B.V.",
    "country": "NL",
    "city": "Epse",
    "address": "Lochemseweg 2C, 7214 RH Epse",
    "email": "info@dusseldorpbmw.nl",
    "phone": "+31-575-498500",
    "website": "https://www.dusseldorpbmw.nl/dusseldorp-deventer",
    "coords": {
      "lat": 52.2265510559082,
      "lng": 6.1934099197387695
    }
  },
  {
    "id": "03681_1",
    "name": "Van Poelgeest Woerden",
    "country": "NL",
    "city": "Woerden",
    "address": "Middellandse Zee 13, 3446 CG Woerden",
    "email": "info@van-poelgeest.nl",
    "phone": "+31-348-413778",
    "website": "https://www.seversbreeman.nl",
    "coords": {
      "lat": 52.0754508972168,
      "lng": 4.909461975097656
    }
  },
  {
    "id": "07346_1",
    "name": "Dusseldorp Den Haag B.V.",
    "country": "NL",
    "city": "Den Haag",
    "address": "Donau 38-40 (Forepark), 2491 BA Den Haag",
    "email": "denhaag@dusseldorpbmw.nl",
    "phone": "+31-70-3017170",
    "website": "https://dusseldorpbmw.nl/dusseldorp-den-haag",
    "coords": {
      "lat": 52.069175720214844,
      "lng": 4.3884358406066895
    }
  },
  {
    "id": "20300_1",
    "name": "Ekris Arnhem",
    "country": "NL",
    "city": "Velp",
    "address": "Markweg 4, 6883 JM Velp",
    "email": "arnhem@ekris.nl",
    "phone": "+31-26-3642164",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 51.980892181396484,
      "lng": 5.985188961029053
    }
  },
  {
    "id": "03578_1",
    "name": "Ekris Heerenveen",
    "country": "NL",
    "city": "Heerenveen",
    "address": "Skrynmakker 32, 8447 GH Heerenveen",
    "email": "heerenveen@ekris.nl",
    "phone": "+31-513-618888",
    "website": "https://www.ekris.nl/bmw",
    "coords": {
      "lat": 52.96739196777344,
      "lng": 5.899986743927002
    }
  },
  {
    "id": "03672_1",
    "name": "Ekris Utrecht",
    "country": "NL",
    "city": "Utrecht",
    "address": "Proostwetering 51, 3543 AC Utrecht",
    "email": "utrecht@ekris.nl",
    "phone": "+31-30-2713625",
    "website": "https://www.ekris.nl/bmw/",
    "coords": {
      "lat": 52.11112976074219,
      "lng": 5.0457000732421875
    }
  },
  {
    "id": "06987_1",
    "name": "Hedin Automotive Breda",
    "country": "NL",
    "city": "Breda",
    "address": "Huifakkerstraat 1, 4815 PN Breda",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-76-5223549",
    "website": "https://www.hedinautomotive.nl/bmw",
    "coords": {
      "lat": 51.599266052246094,
      "lng": 4.740764141082764
    }
  },
  {
    "id": "03666_1",
    "name": "Story Waardenburg",
    "country": "NL",
    "city": "WAARDENBURG",
    "address": "Filipsweistraat 8, 4181 CH WAARDENBURG",
    "email": "info@story-waardenburg.nl",
    "phone": "+31-418-657100",
    "website": "https://www.story-waardenburg.nl",
    "coords": {
      "lat": 51.83352279663086,
      "lng": 5.249049186706543
    }
  },
  {
    "id": "03619_1",
    "name": "Hedin Automotive Goes",
    "country": "NL",
    "city": "Goes",
    "address": "Amundsenweg 33, 4462 GP Goes",
    "email": "RCC.bmw@hedinautomotive.nl",
    "phone": "+31-113-245245",
    "website": "https://www.hedinautomotive.nl/bmw",
    "coords": {
      "lat": 51.48714828491211,
      "lng": 3.8740246295928955
    }
  },
  {
    "id": "05600_8",
    "name": "Pautric Aalbeke",
    "country": "BE",
    "city": "Kortrijk-Aalbeke",
    "address": "Moeskroensesteenweg 383, 8511 Kortrijk-Aalbeke",
    "email": "info.aalbeke@pautric.be",
    "phone": "+32-56-439191",
    "website": "http://www.monserez.bmw.be",
    "coords": {
      "lat": 50.765506744384766,
      "lng": 3.2219159603118896
    }
  },
  {
    "id": "05604_17",
    "name": "Meeusen Malle",
    "country": "BE",
    "city": "Oostmalle",
    "address": "Antwerpsesteenweg 105, 2390 Oostmalle",
    "email": "info.malle@meeusen.net.bmw.be",
    "phone": "+32-3-3128580",
    "website": "http://dealer.bmw.be/centrauto-oostmalle/nl_BE/index.html",
    "coords": {
      "lat": 51.29850387573242,
      "lng": 4.709449768066406
    }
  },
  {
    "id": "05606_1",
    "name": "Bilia Arlon",
    "country": "BE",
    "city": "Arlon",
    "address": "Route de Bastogne 394, 6700 Arlon",
    "email": "vente.bmw@bilia.be",
    "phone": "+32-63-230560",
    "website": "https://www.bilia.bmw.be",
    "coords": {
      "lat": 49.704071044921875,
      "lng": 5.805651664733887
    }
  },
  {
    "id": "05719_1",
    "name": "De Schepper",
    "country": "BE",
    "city": "St. Niklaas",
    "address": "Prins Boudewijnlaan 53, 9100 St. Niklaas",
    "email": "Info@deschepper.net.bmw.be",
    "phone": "+32-3-7660006",
    "website": "http://www.deschepper.bmw.be",
    "coords": {
      "lat": 51.161434173583984,
      "lng": 4.165404796600342
    }
  },
  {
    "id": "05735_1",
    "name": "Bilia Verstraeten",
    "country": "BE",
    "city": "Lochristi",
    "address": "Antwerpsesteenweg 81, 9080 Lochristi",
    "email": "info@biliaverstraeten.be",
    "phone": "+32-9-3450688",
    "website": "http://www.verstraeten.bmw.be",
    "coords": {
      "lat": 51.08888244628906,
      "lng": 3.809368848800659
    }
  },
  {
    "id": "10126_1",
    "name": "Bortolin Hannut",
    "country": "BE",
    "city": "Hannut",
    "address": "Route de Landen, 166, 4280 Hannut",
    "email": "info.hannut@bortolin.net.bmw.be",
    "phone": "+32-19-512440",
    "website": "http://www.bortolin.bmw.be",
    "coords": {
      "lat": 50.70025634765625,
      "lng": 5.081601142883301
    }
  },
  {
    "id": "49997_1",
    "name": "Louyet Charleroi",
    "country": "BE",
    "city": "Charleroi",
    "address": "Rue de Mons 80, 6000 Charleroi",
    "email": "Info@louyet.net.bmw.be",
    "phone": "+32-71-202260",
    "website": "http://www.louyet.bmw.be",
    "coords": {
      "lat": 50.41225051879883,
      "lng": 4.43391227722168
    }
  },
  {
    "id": "05645_1",
    "name": "Louyet Namur",
    "country": "BE",
    "city": "Namur (Wierde)",
    "address": "Chaussée de Marche 620, 5100 Namur (Wierde)",
    "email": "info@louyet.net.bmw.be",
    "phone": "+32-81-303894",
    "website": "http://www.louyet.bmw.be",
    "coords": {
      "lat": 50.43906021118164,
      "lng": 4.908877849578857
    }
  },
  {
    "id": "05683_2",
    "name": "De Mey Knokke",
    "country": "BE",
    "city": "Knokke",
    "address": "Natiënlaan 52, 8300 Knokke",
    "email": "infoknokke@demey.net.bmw.be",
    "phone": "+32-50-895555",
    "website": "http://www.demey.bmw.be",
    "coords": {
      "lat": 51.336952209472656,
      "lng": 3.287764072418213
    }
  },
  {
    "id": "05719_2",
    "name": "De Schepper Tweedehandscentrum",
    "country": "BE",
    "city": "Sint-Niklaas",
    "address": "Europark-Zuid 9, 9100 Sint-Niklaas",
    "email": "premium@deschepper.net.bmw.be",
    "phone": "+32-3-7660006",
    "website": "https://www.bmwpremiumselection.be/nl/dealer/deschepper-sint-niklaas/",
    "coords": {
      "lat": 51.1596794128418,
      "lng": 4.169983386993408
    }
  },
  {
    "id": "05711_1",
    "name": "Dejonckheere Roeselare",
    "country": "BE",
    "city": "Roeselare",
    "address": "Oostnieuwkerksesteenweg 136, 8800 Roeselare",
    "email": "Info@dejonckheere.net.bmw.be",
    "phone": "+32-51-227022",
    "website": "http://www.dejonckheere.bmw.be",
    "coords": {
      "lat": 50.94620132446289,
      "lng": 3.097421884536743
    }
  },
  {
    "id": "32327_1",
    "name": "Sneyers Tweedehandscentrum",
    "country": "BE",
    "city": "Herentals",
    "address": "Toekomstlaan 7, 2200 Herentals",
    "email": "Premium@sneyers.net.bmw.be",
    "phone": "+32-14-490049",
    "website": "https://www.sneyers.bmw.be",
    "coords": {
      "lat": 51.16014099121094,
      "lng": 4.812910079956055
    }
  },
  {
    "id": "05600_7",
    "name": "Pautric Ieper tweedehandscentrum",
    "country": "BE",
    "city": "Ieper",
    "address": "Jaagpad 6, 8900 Ieper",
    "email": "info.ieper@pautric.be",
    "phone": "+32-57-219293",
    "website": "https://www.pautric.bmw.be/nl",
    "coords": {
      "lat": 50.87046432495117,
      "lng": 2.8825831413269043
    }
  },
  {
    "id": "05610_1",
    "name": "Patrick Smets",
    "country": "BE",
    "city": "Lier",
    "address": "Aarschotsesteenweg 328, 2500 Lier",
    "email": "Info@psmets.net.bmw.be",
    "phone": "+32-3-4822151",
    "website": "http://www.smets.bmw.be",
    "coords": {
      "lat": 51.086971282958984,
      "lng": 4.640480041503906
    }
  },
  {
    "id": "05628_1",
    "name": "Pautric Woluwe",
    "country": "BE",
    "city": "Bruxelles / Brussel",
    "address": "Rue Francois Desmedt 96, 1150 Bruxelles / Brussel",
    "email": "info.woluwe@pautric.be",
    "phone": "+32-2-7720820",
    "website": "http://www.jmmartin.bmw.be",
    "coords": {
      "lat": 50.84334182739258,
      "lng": 4.464200973510742
    }
  },
  {
    "id": "05659_1",
    "name": "Juma Leuven",
    "country": "BE",
    "city": "Herent",
    "address": "Brusselsesteenweg 72, 3020 Herent",
    "email": "info@juma.net.bmw.be",
    "phone": "+32-16-499870",
    "website": "http://www.juma.bmw.be/",
    "coords": {
      "lat": 50.88848114013672,
      "lng": 4.661227226257324
    }
  },
  {
    "id": "05683_1",
    "name": "De Mey Maldegem",
    "country": "BE",
    "city": "Maldegem",
    "address": "Aalterbaan, 216C, 9990 Maldegem",
    "email": "Info@demey.net.bmw.be",
    "phone": "+32-50-714044",
    "website": "http://www.demey.bmw.be",
    "coords": {
      "lat": 51.19411087036133,
      "lng": 3.4535396099090576
    }
  },
  {
    "id": "05724_1",
    "name": "Le Couter",
    "country": "BE",
    "city": "Tielt",
    "address": "Deinsesteenweg 16, 8700 Tielt",
    "email": "info@lecouter.net.bmw.be",
    "phone": "+32-51-400188",
    "website": "http://www.lecouter.bmw.be",
    "coords": {
      "lat": 50.99714660644531,
      "lng": 3.353384017944336
    }
  },
  {
    "id": "41709_1",
    "name": "Davo Sint-Truiden by A&M",
    "country": "BE",
    "city": "Sint-Truiden",
    "address": "Spookvliegerlaan 1131, 3800 Sint-Truiden",
    "email": "Sint-Truiden.davo@anmgroup.be",
    "phone": "+32-11-713000",
    "website": "http://www.davo.bmw.be",
    "coords": {
      "lat": 50.80063247680664,
      "lng": 5.206453800201416
    }
  },
  {
    "id": "49997_5",
    "name": "Louyet Mons",
    "country": "BE",
    "city": "Mons-Cuesmes",
    "address": "Rue des Sandrinettes 48, 7033 Mons-Cuesmes",
    "email": "info@louyet.net.bmw.be",
    "phone": "+32-65-400200",
    "website": "https://www.louyet.bmw.be",
    "coords": {
      "lat": 50.44913864135742,
      "lng": 3.918126106262207
    }
  },
  {
    "id": "05742_1",
    "name": "Louyet Waterloo",
    "country": "BE",
    "city": "Waterloo",
    "address": "Chaussée de Bruxelles 54, 1410 Waterloo",
    "email": "waterloo@louyet.be",
    "phone": "+32-2-3520330",
    "website": "https://www.louyet.bmw.be",
    "coords": {
      "lat": 50.73011016845703,
      "lng": 4.397776126861572
    }
  },
  {
    "id": "23686_6",
    "name": "A&M Zonhoven",
    "country": "BE",
    "city": "Zonhoven",
    "address": "Heuveneindeweg 119, 3520 Zonhoven",
    "email": "zonhoven.premiumselection@anmgroup.be",
    "phone": "+32-11-265020",
    "website": "http://www.vanosch.bmw.be",
    "coords": {
      "lat": 50.97324752807617,
      "lng": 5.362539768218994
    }
  },
  {
    "id": "05716_1",
    "name": "Dejonckheere Tournai",
    "country": "BE",
    "city": "Tournai",
    "address": "Chaussée de Bruxelles, 190, 7500 Tournai",
    "email": "tournai@dejonckheere.net.bmw.be",
    "phone": "+32-69-891212",
    "website": "http://www.dejonckheere-tournai.bmw.be/",
    "coords": {
      "lat": 50.60447311401367,
      "lng": 3.4135963916778564
    }
  },
  {
    "id": "50057_3",
    "name": "Louyet Brussels Used Car",
    "country": "BE",
    "city": "Bruxelles",
    "address": "Av. Léonard Mommaerts 1, 1140 Bruxelles",
    "email": "brussels@louyet.be",
    "phone": "+32-2-7304911",
    "website": "https://www.louyet.be",
    "coords": {
      "lat": 50.857139587402344,
      "lng": 4.412774562835693
    }
  },
  {
    "id": "05657_3",
    "name": "A&M Halen (Tweedehandscentrum)",
    "country": "BE",
    "city": "Zelk-Halen",
    "address": "Staatsbaan 63, 3545 Zelk-Halen",
    "email": "halen.premiumselection@anmgroup.be",
    "phone": "+32-13-461051",
    "website": "https://www.vanosch.bmw.be",
    "coords": {
      "lat": 50.956974029541016,
      "lng": 5.093210220336914
    }
  },
  {
    "id": "05655_2",
    "name": "Louyet Overijse",
    "country": "BE",
    "city": "Overijse",
    "address": "Brusselsesteenweg 403, 3090 Overijse",
    "email": "overijse@louyet.be",
    "phone": "+32-2-6879140",
    "website": "https://www.louyet.bmw.be/nl/overijse",
    "coords": {
      "lat": 50.785099029541016,
      "lng": 4.500663757324219
    }
  },
  {
    "id": "05699_6",
    "name": "Meerschman Aalst",
    "country": "BE",
    "city": "Aalst",
    "address": "Churchillsteenweg 24, 9320 Aalst",
    "email": "aalst@meerschman.net.bmw.be",
    "phone": "+32-53-646500",
    "website": "http://www.meerschman.bmw.be",
    "coords": {
      "lat": 50.91448974609375,
      "lng": 4.034527778625488
    }
  },
  {
    "id": "05726_1",
    "name": "Davo Tongeren by A&M",
    "country": "BE",
    "city": "Tongeren",
    "address": "Maastrichtersteenweg, 529, 3700 Tongeren",
    "email": "Tongeren.davo@anmgroup.be",
    "phone": "+32-12-237155",
    "website": "http://www.davo.bmw.be",
    "coords": {
      "lat": 50.78889846801758,
      "lng": 5.506082057952881
    }
  },
  {
    "id": "49997_3",
    "name": "Louyet La Louvière",
    "country": "BE",
    "city": "La Louvière",
    "address": "Rue de la Déportation 61, 7100 La Louvière",
    "email": "info@louyet.net.bmw.be",
    "phone": "+32-64-773030",
    "website": "http://dealer.bmw.be/louyet-la-louviere/fr_BE",
    "coords": {
      "lat": 50.464359283447266,
      "lng": 4.19956111907959
    }
  },
  {
    "id": "05670_1",
    "name": "Meeusen Kalmthout",
    "country": "BE",
    "city": "Kalmthout",
    "address": "Brasschaatsteenweg 318, 2920 Kalmthout",
    "email": "Info@meeusen.net.bmw.be",
    "phone": "+32-3-6202110",
    "website": "http://www.meeusen.bmw.be",
    "coords": {
      "lat": 51.35839080810547,
      "lng": 4.507193088531494
    }
  },
  {
    "id": "05681_1",
    "name": "Beliën Lommel",
    "country": "BE",
    "city": "Lommel",
    "address": "E.Anseelestraat 21, 3920 Lommel",
    "email": "info@belienlommel.net.bmw.be",
    "phone": "+32-11-552070",
    "website": "http://www.belien.bmw.be",
    "coords": {
      "lat": 51.216339111328125,
      "lng": 5.2672343254089355
    }
  },
  {
    "id": "05704_1",
    "name": "Vande Kerckhove",
    "country": "BE",
    "city": "Kruisem",
    "address": "Gentsesteenweg 61A, 9750 Kruisem",
    "email": "info@vandekerckhove.net.bmw.be",
    "phone": "+32-9-3896200",
    "website": "http://www.vandekerckhove.bmw.be",
    "coords": {
      "lat": 50.91144943237305,
      "lng": 3.617051601409912
    }
  },
  {
    "id": "05722_1",
    "name": "Gregoir Puurs",
    "country": "BE",
    "city": "Puurs-Sint-Amands",
    "address": "Rijksweg 31, 2870 Puurs-Sint-Amands",
    "email": "info@gregoir.net.bmw.be",
    "phone": "+32-3-8862412",
    "website": "https://www.gregoir.bmw.be",
    "coords": {
      "lat": 51.063232421875,
      "lng": 4.325051307678223
    }
  },
  {
    "id": "05655_1",
    "name": "Louyet Sint-Pieters-Leeuw",
    "country": "BE",
    "city": "St. Pieters Leeuw",
    "address": "Bergensesteenweg 720, 1600 St. Pieters Leeuw",
    "email": "louyet_spl_info@louyet.net.bmw.be",
    "phone": "+32-2-3600880",
    "website": "https://www.louyet.bmw.be/nl/sint-pieters-leeuw",
    "coords": {
      "lat": 50.76451110839844,
      "lng": 4.250979423522949
    }
  },
  {
    "id": "05662_1",
    "name": "Ottevaere",
    "country": "BE",
    "city": "Hever (Boortmeerbeek)",
    "address": "Leuvensesteenweg 135, 3191 Hever (Boortmeerbeek)",
    "email": "Info@ottevaere.net.bmw.be",
    "phone": "+32-15-511379",
    "website": "http://www.ottevaere.bmw.be",
    "coords": {
      "lat": 50.98460388183594,
      "lng": 4.547976016998291
    }
  },
  {
    "id": "05670_2",
    "name": "Meeusen nv (Tweedehandscentrum)",
    "country": "BE",
    "city": "Kalmthout",
    "address": "Brasschaatsteenweg 318, 2920 Kalmthout",
    "email": "Premium@meeusen.net.bmw.be",
    "phone": "+32-3-6452290",
    "website": "https://www.meeusen.bmw.be",
    "coords": {
      "lat": 51.35839080810547,
      "lng": 4.507193088531494
    }
  },
  {
    "id": "05691_1",
    "name": "Juma Mechelen",
    "country": "BE",
    "city": "Mechelen",
    "address": "Kruisbaan 125, 2800 Mechelen",
    "email": "info@juma.net.bmw.be",
    "phone": "+32-15-423000",
    "website": "http://www.juma.bmw.be",
    "coords": {
      "lat": 51.01023864746094,
      "lng": 4.464365005493164
    }
  },
  {
    "id": "05699_5",
    "name": "Meerschman Zottegem",
    "country": "BE",
    "city": "Zottegem",
    "address": "Ter Kameren 2, 9620 Zottegem",
    "email": "info@meerschmanzottegem.net.bmw.be",
    "phone": "+32-9-3613701",
    "website": "http://www.meerschman.bmw.be",
    "coords": {
      "lat": 50.88344192504883,
      "lng": 3.827653169631958
    }
  },
  {
    "id": "05728_1",
    "name": "Bortolin Huy",
    "country": "BE",
    "city": "Huy-Tihange",
    "address": "Avenue de l'Industrie,32, 4500 Huy-Tihange",
    "email": "Info@bortolin.net.bmw.be",
    "phone": "+32-85-278070",
    "website": "http://www.bortolin.bmw.be",
    "coords": {
      "lat": 50.53207778930664,
      "lng": 5.263766765594482
    }
  },
  {
    "id": "10028_1",
    "name": "G & A Motors",
    "country": "BE",
    "city": "Turnhout",
    "address": "Raadsherenstraat 1, 2300 Turnhout",
    "email": "info@gamotors.net.bmw.be",
    "phone": "+32-14-411724",
    "website": "http://www.gamotors.bmw.be",
    "coords": {
      "lat": 51.304161071777344,
      "lng": 4.917809963226318
    }
  },
  {
    "id": "21738_1",
    "name": "Louyet Eupen",
    "country": "BE",
    "city": "Eupen",
    "address": "Route de Herbesthal 265B, 4700 Eupen",
    "email": "eupen@discar.net.bmw.be",
    "phone": "+32-87-590050",
    "website": "http://www.discar.bmw.be",
    "coords": {
      "lat": 50.63511657714844,
      "lng": 6.02276611328125
    }
  },
  {
    "id": "50057_1",
    "name": "Louyet Brussels",
    "country": "BE",
    "city": "Evere",
    "address": "Chaussée de Louvain 864, 1140 Evere",
    "email": "brussels@louyet.be",
    "phone": "+32-2-7304911",
    "website": "https://www.louyet.be",
    "coords": {
      "lat": 50.856624603271484,
      "lng": 4.412238121032715
    }
  },
  {
    "id": "05683_3",
    "name": "De Mey Oostende",
    "country": "BE",
    "city": "Oostende",
    "address": "Joseph Plateaustraat 1, 8400 Oostende",
    "email": "info@verhelst.net.bmw.be",
    "phone": "+32-59-242700",
    "website": "http://www.demey.bmw.be",
    "coords": {
      "lat": 51.209346771240234,
      "lng": 2.93896484375
    }
  },
  {
    "id": "05623_1",
    "name": "Pautric Drogenbos",
    "country": "BE",
    "city": "Drogenbos",
    "address": "Grote Baan 336, 1620 Drogenbos",
    "email": "info.drogenbos@pautric.be",
    "phone": "+32-2-5211717",
    "website": "https://www.pautric.bmw.be/nl",
    "coords": {
      "lat": 50.7907600402832,
      "lng": 4.309187889099121
    }
  },
  {
    "id": "05711_2",
    "name": "Dejonckheere Roeselare Tweedehands",
    "country": "BE",
    "city": "Roeselare",
    "address": "Oostnieuwkerksesteenweg 132, 8800 Roeselare",
    "email": "Premium@dejonckheere.net.bmw.be",
    "phone": "+32-51-227022",
    "website": "https://www.dejonckheere.bmw.be",
    "coords": {
      "lat": 50.94668197631836,
      "lng": 3.099005937576294
    }
  },
  {
    "id": "05600_9",
    "name": "Pautric Tweedehandscentrum Aalbeke",
    "country": "BE",
    "city": "Aalbeke (Kortrijk)",
    "address": "Moeskroensesteenweg 383, 8511 Aalbeke (Kortrijk)",
    "email": "info.aalbeke@pautric.be",
    "phone": "+32-56-439191",
    "website": "https://www.pautric.bmw.be/nl",
    "coords": {
      "lat": 50.76552963256836,
      "lng": 3.2219107151031494
    }
  },
  {
    "id": "05657_1",
    "name": "A&M Halen",
    "country": "BE",
    "city": "Halen",
    "address": "Industriepark 1122, 3545 Halen",
    "email": "halen.bmw@anmgroup.be",
    "phone": "+32-13-460130",
    "website": "http://www.vanosch.bmw.be",
    "coords": {
      "lat": 50.95566177368164,
      "lng": 5.116489887237549
    }
  },
  {
    "id": "05666_1",
    "name": "Pautric Ieper",
    "country": "BE",
    "city": "Ieper",
    "address": "Jaagpad 6, Noorderring, 8900 Ieper",
    "email": "info.aalbeke@pautric.be",
    "phone": "+32-57-219293",
    "website": "http://www.monserez.bmw.be",
    "coords": {
      "lat": 50.86997604370117,
      "lng": 2.8828279972076416
    }
  },
  {
    "id": "05735_8",
    "name": "Bilia Verstraeten Tweedehandscentru",
    "country": "BE",
    "city": "Lochristi",
    "address": "Antwerpsesteenweg 85, 9080 Lochristi",
    "email": "premium@biliaverstraeten.be",
    "phone": "+32-9-3450688",
    "website": "http://bmwpremiumselection.be/nl/dealer/verstraeten-lochristi/",
    "coords": {
      "lat": 51.08877944946289,
      "lng": 3.80936861038208
    }
  },
  {
    "id": "20736_1",
    "name": "Gregoir Sint-Martens-Latem",
    "country": "BE",
    "city": "St. Martens Latem",
    "address": "Xavier de Cocklaan, 48-50, 9831 St. Martens Latem",
    "email": "Sales.Latem@gregoir.net.bmw.be",
    "phone": "+32-9-2807080",
    "website": "https://gregoir.bmw.be/",
    "coords": {
      "lat": 51.00074768066406,
      "lng": 3.6139719486236572
    }
  },
  {
    "id": "23686_1",
    "name": "A&M Hasselt",
    "country": "BE",
    "city": "Hasselt",
    "address": "Scheepvaartkaai 14, 3500 Hasselt",
    "email": "hasselt.bmw@anmgroup.be",
    "phone": "+32-11-211510",
    "website": "https://www.anmgroup.bmw.be/nl",
    "coords": {
      "lat": 50.940643310546875,
      "lng": 5.345939636230469
    }
  },
  {
    "id": "05604_1",
    "name": "Meeusen Wijnegem",
    "country": "BE",
    "city": "Wijnegem",
    "address": "Willem van Halmalelaan 1, 2110 Wijnegem",
    "email": "info.wijnegem@meeusen.net.bmw.be",
    "phone": "+32-3-3208320",
    "website": "http://www.meeusen.bmw.be",
    "coords": {
      "lat": 51.23223114013672,
      "lng": 4.502999782562256
    }
  },
  {
    "id": "05600_1",
    "name": "Pautric Kortrijk",
    "country": "BE",
    "city": "Kortrijk",
    "address": "Meensesteenweg 86, 8500 Kortrijk",
    "email": "info.kortrijk@pautric.be",
    "phone": "+32-56-374386",
    "website": "http://www.monserez.bmw.be",
    "coords": {
      "lat": 50.829429626464844,
      "lng": 3.2490949630737305
    }
  },
  {
    "id": "05610_3",
    "name": "Patrick Smets Tweedehandscentrum",
    "country": "BE",
    "city": "Berlaar",
    "address": "Aarschotsebaan 296, 2590 Berlaar",
    "email": "Info@psmets.net.bmw.be",
    "phone": "+32-3-4822151",
    "website": "http://www.smets.bmw.be",
    "coords": {
      "lat": 51.087928771972656,
      "lng": 4.640288352966309
    }
  },
  {
    "id": "05649_1",
    "name": "A&M Dilsen-Stokkem",
    "country": "BE",
    "city": "Dilsen-Stokkem",
    "address": "Meerkensstraat 43-45, 3650 Dilsen-Stokkem",
    "email": "bmw.dilsen@anmgroup.be",
    "phone": "+32-89-322210",
    "website": "https://www.anmgroup.bmw.be/nl",
    "coords": {
      "lat": 51.01652908325195,
      "lng": 5.695655345916748
    }
  },
  {
    "id": "05645_3",
    "name": "Louyet Marche",
    "country": "BE",
    "city": "Marche-en-Famenne",
    "address": "Rue de l'Expansion 2, 6900 Marche-en-Famenne",
    "email": "info@louyet.net.bmw.be",
    "phone": "+32-84-220545",
    "website": "http://www.quoilin.bmw.be",
    "coords": {
      "lat": 50.242244720458984,
      "lng": 5.2889251708984375
    }
  },
  {
    "id": "05679_1",
    "name": "Sneyers",
    "country": "BE",
    "city": "Herentals",
    "address": "Toekomstlaan 12, 2200 Herentals",
    "email": "info@sneyers.net.bmw.be",
    "phone": "+32-14-490049",
    "website": "http://www.sneyers.bmw.be",
    "coords": {
      "lat": 51.1607666015625,
      "lng": 4.810486793518066
    }
  },
  {
    "id": "05687_1",
    "name": "Tanghe",
    "country": "BE",
    "city": "Melsbroek",
    "address": "Haachtsesteenweg 228, 1820 Melsbroek",
    "email": "Info@tanghe.net.bmw.be",
    "phone": "+32-2-7518497",
    "website": "http://www.tanghe.bmw.be",
    "coords": {
      "lat": 50.91006088256836,
      "lng": 4.477560043334961
    }
  },
  {
    "id": "05690_1",
    "name": "Louyet Mariembourg",
    "country": "BE",
    "city": "Mariembourg",
    "address": "Chaussée de Philippeville, 67, 5660 Mariembourg",
    "email": "Mariembourg@louyet.be",
    "phone": "+32-60-312600",
    "website": "https://www.louyet.bmw.be",
    "coords": {
      "lat": 50.09554672241211,
      "lng": 4.514552593231201
    }
  },
  {
    "id": "05730_1",
    "name": "Louyet Verviers",
    "country": "BE",
    "city": "Petit-Rechain (Verviers)",
    "address": "Avenue du Parc 31, 4800 Petit-Rechain (Verviers)",
    "email": "verviers@discar.net.bmw.be",
    "phone": "+32-87-321150",
    "website": "http://www.discar.bmw.be",
    "coords": {
      "lat": 50.626190185546875,
      "lng": 5.8411712646484375
    }
  },
  {
    "id": "05738_1",
    "name": "Jorssen Zuid",
    "country": "BE",
    "city": "Aartselaar",
    "address": "Antwerpsesteenweg 126, 2630 Aartselaar",
    "email": "Info@jorssen.net.bmw.be",
    "phone": "+32-3-8207400",
    "website": "http://www.jorssen.bmw.be",
    "coords": {
      "lat": 51.146400451660156,
      "lng": 4.38123083114624
    }
  },
  {
    "id": "20736_3",
    "name": "Gregoir Oudenaarde",
    "country": "BE",
    "city": "Oudenaarde",
    "address": "Westerring 27B, 9700 Oudenaarde",
    "email": "Sales.Oudenaarde@gregoir.net.bmw.be",
    "phone": "+32-55-337080",
    "website": "https://gregoir.bmw.be/",
    "coords": {
      "lat": 50.86689758300781,
      "lng": 3.6057627201080322
    }
  },
  {
    "id": "22540_1",
    "name": "A&M Tienen",
    "country": "BE",
    "city": "Tienen",
    "address": "Ambachtenlaan, 2a, 3300 Tienen",
    "email": "bmw.tienen@anmgroup.be",
    "phone": "+32-16-812539",
    "website": "http://www.vanosch.bmw.be",
    "coords": {
      "lat": 50.80034637451172,
      "lng": 4.972085952758789
    }
  },
  {
    "id": "40866_1",
    "name": "Lemmens - Le Couter",
    "country": "BE",
    "city": "Desselgem (Waregem)",
    "address": "Gentseweg 209, 8792 Desselgem (Waregem)",
    "email": "info@lemmenslecouter.net.bmw.be",
    "phone": "+32-56-738888",
    "website": "https://www.lecouter.bmw.be",
    "coords": {
      "lat": 50.88697052001953,
      "lng": 3.3739237785339355
    }
  },
  {
    "id": "05606_8",
    "name": "Bilia Libramont",
    "country": "BE",
    "city": "Libramont",
    "address": "rue de Neufchâteau 26, 6800 Libramont",
    "email": "info@bilia.be",
    "phone": "+32-61-224724",
    "website": "https://www.bilia-emond.bmw.be",
    "coords": {
      "lat": 49.9099235534668,
      "lng": 5.359012126922607
    }
  },
  {
    "id": "05617_1",
    "name": "Cocquyt",
    "country": "BE",
    "city": "Brugge",
    "address": "Waggelwaterstraat 27, 8200 Brugge",
    "email": "Info@cocquyt.net.bmw.be",
    "phone": "+32-50-455937",
    "website": "http://www.cocquyt.bmw.be",
    "coords": {
      "lat": 51.21226119995117,
      "lng": 3.201319932937622
    }
  },
  {
    "id": "05638_1",
    "name": "Gregoir Dendermonde",
    "country": "BE",
    "city": "Dendermonde-Appels",
    "address": "Bevrijdingslaan 199, 9200 Dendermonde-Appels",
    "email": "service.dendermonde@gregoir.net.bmw.be",
    "phone": "+32-52-261340",
    "website": "https://www.gregoir.bmw.be",
    "coords": {
      "lat": 51.02169418334961,
      "lng": 4.047060012817383
    }
  },
  {
    "id": "05641_1",
    "name": "Pautric Dilbeek",
    "country": "BE",
    "city": "Dilbeek",
    "address": "H. Moeremanslaan, 146, 1700 Dilbeek",
    "email": "info.dilbeek@pautric.be",
    "phone": "+32-2-4662088",
    "website": "http://www.vandenbroeck.bmw.be",
    "coords": {
      "lat": 50.84598159790039,
      "lng": 4.277272701263428
    }
  },
  {
    "id": "05659_2",
    "name": "Juma Leuven Tweedehandscentrum",
    "country": "BE",
    "city": "Herent",
    "address": "Brusselsesteenweg 66, 3020 Herent",
    "email": "premium.leuven@juma.net.bmw.be",
    "phone": "+32-16-499870",
    "website": "http://www.juma.bmw.be/",
    "coords": {
      "lat": 50.887840270996094,
      "lng": 4.662234783172607
    }
  },
  {
    "id": "05675_1",
    "name": "Louyet Liège",
    "country": "BE",
    "city": "Liege",
    "address": "Boulevard Frankignoul 8, 4020 Liege",
    "email": "liege@discar.net.bmw.be",
    "phone": "+32-4-3419911",
    "website": "http://www.discar.bmw.be",
    "coords": {
      "lat": 50.6273193359375,
      "lng": 5.588054180145264
    }
  },
  {
    "id": "05718_1",
    "name": "Beliën Neerpelt",
    "country": "BE",
    "city": "Pelt",
    "address": "Hamonterweg 100, 3910 Pelt",
    "email": "Info@belien.net.bmw.be",
    "phone": "+32-11-668580",
    "website": "http://www.belien.bmw.be",
    "coords": {
      "lat": 51.23867416381836,
      "lng": 5.46871280670166
    }
  },
  {
    "id": "05721_1",
    "name": "Jorssen Noord",
    "country": "BE",
    "city": "Merksem",
    "address": "Kapelsesteenweg 1-3, 2170 Merksem",
    "email": "info@jorssennoord.net.bmw.be",
    "phone": "+32-3-6419000",
    "website": "http://www.jorssen.bmw.be",
    "coords": {
      "lat": 51.26716232299805,
      "lng": 4.4623188972473145
    }
  },
  {
    "id": "05741_1",
    "name": "Louyet Wavre",
    "country": "BE",
    "city": "Wavre",
    "address": "Rue Cerisier d'Haine 50, 1301 Wavre",
    "email": "wavre@louyet.be",
    "phone": "+32-10-452745",
    "website": "https://www.louyet.bmw.be",
    "coords": {
      "lat": 50.730674743652344,
      "lng": 4.5803728103637695
    }
  },
  {
    "id": "49997_2",
    "name": "Louyet Sambreville",
    "country": "BE",
    "city": "Sambreville",
    "address": "Rue Bois Sainte-Marie 180, 5060 Sambreville",
    "email": "info@louyet.net.bmw.be",
    "phone": "+32-71-750630",
    "website": "https://www.louyet.bmw.be",
    "coords": {
      "lat": 50.44645690917969,
      "lng": 4.647171974182129
    }
  },
  {
    "id": "05616_1",
    "name": "Delbecq",
    "country": "BE",
    "city": "Seraing",
    "address": "Boulevard Pasteur 15, 4100 Seraing",
    "email": "Info@delbecq.net.bmw.be",
    "phone": "+32-4-3376500",
    "website": "http://www.delbecq.bmw.be",
    "coords": {
      "lat": 50.59150695800781,
      "lng": 5.497364044189453
    }
  },
  {
    "id": "05740_1",
    "name": "Gregoir Jette",
    "country": "BE",
    "city": "Brussel",
    "address": "Tentoonstellingslaan 317, 1090 Brussel",
    "email": "info@gregoir.net.bmw.be",
    "phone": "+32-2-4740474",
    "website": "http://www.gregoir.bmw.be",
    "coords": {
      "lat": 50.88637161254883,
      "lng": 4.317069053649902
    }
  },
  {
    "id": "21738_3",
    "name": "Louyet Malmedy",
    "country": "BE",
    "city": "Malmedy",
    "address": "Route de Waimes 117, 4960 Malmedy",
    "email": "malmedy@discar.net.bmw.be",
    "phone": "+32-80-670250",
    "website": "http://www.discar.bmw.be",
    "coords": {
      "lat": 50.405540466308594,
      "lng": 6.060669898986816
    }
  },
  {
    "id": "05617_5",
    "name": "O. Cocquyt nv (Tweedehandscentrum)",
    "country": "BE",
    "city": "Brugge",
    "address": "Dirk Martensstraat 7, 8200 Brugge",
    "email": "premium@cocquyt.net.bmw.be",
    "phone": "+32-50-455938",
    "website": "http://www.cocquyt.bmw.be",
    "coords": {
      "lat": 51.20981979370117,
      "lng": 3.198319911956787
    }
  },
  {
    "id": "05699_1",
    "name": "Meerschman Aalst Tweedehandscentrum",
    "country": "BE",
    "city": "Aalst",
    "address": "Moorselbaan 370, 9300 Aalst",
    "email": "sales@meerschman.net.bmw.be",
    "phone": "+32-53-646500",
    "website": "http://www.meerschman.bmw.be",
    "coords": {
      "lat": 50.94483947753906,
      "lng": 4.0688557624816895
    }
  },
  {
    "id": "31688_1",
    "name": "All-Cars",
    "country": "BE",
    "city": "Leuze (Eghezée)",
    "address": "Chaussée de Namur 258, 5310 Leuze (Eghezée)",
    "email": "reception@allcars.net.bmw.be",
    "phone": "+32-81-513311",
    "website": "http://www.allcars.be/",
    "coords": {
      "lat": 50.55009078979492,
      "lng": 4.906510829925537
    }
  },
  {
    "id": "05623_2",
    "name": "Pautric Groot-Bijgaarden",
    "country": "BE",
    "city": "Dilbeek",
    "address": "Roekhout 11, 1072 Dilbeek",
    "email": "usedcars.groot-bijgaarden@pautric.be",
    "phone": "+32-2-5562932",
    "website": "https://www.jmmartin.bmw.be",
    "coords": {
      "lat": 50.87897872924805,
      "lng": 4.265375137329102
    }
  },
  {
    "id": "05654_1",
    "name": "Genet",
    "country": "BE",
    "city": "Haccourt (Oupeye)",
    "address": "Avenue des Courtils 2, 4684 Haccourt (Oupeye)",
    "email": "Info@genet.net.bmw.be",
    "phone": "+32-4-3791293",
    "website": "http://www.genet.bmw.be",
    "coords": {
      "lat": 50.7296028137207,
      "lng": 5.668699741363525
    }
  },
  {
    "id": "05633_2",
    "name": "Louyet Ath",
    "country": "BE",
    "city": "Meslin-l'Eveque",
    "address": "Chaussée de Bruxelles 375, 7822 Meslin-l'Eveque",
    "email": "Info@depotter.net.bmw.be",
    "phone": "+32-68-657148",
    "website": "http://www.depotter.bmw.be",
    "coords": {
      "lat": 50.6485481262207,
      "lng": 3.8541839122772217
    }
  },
  {
    "id": "09267_1",
    "name": "Elite BMW",
    "country": "CA",
    "city": "Ottawa",
    "address": "1040 Ogilvie Road, K1J 8G9 Ottawa",
    "email": "info@elitebmw.com",
    "phone": "+1-613-7497700",
    "website": "http://www.elitebmw.com",
    "coords": {
      "lat": 45.424720764160156,
      "lng": -75.63526916503906
    }
  },
  {
    "id": "09284_1",
    "name": "Bavaria BMW",
    "country": "CA",
    "city": "Edmonton",
    "address": "18925 Stony Plain Road West, T5S 2Y4 Edmonton",
    "email": "info@bavariabmw.ca",
    "phone": "+1-780-4840000",
    "website": "https://www.bavariabmw.ca/",
    "coords": {
      "lat": 53.53953170776367,
      "lng": -113.65109252929688
    }
  },
  {
    "id": "20008_1",
    "name": "O'Regan's BMW",
    "country": "CA",
    "city": "Halifax",
    "address": "3240 Kempt Road, B3K 4X1 Halifax",
    "email": "oregansbmw@oregans.com",
    "phone": "+1-902-4545000",
    "website": "https://www.oregansbmw.com",
    "coords": {
      "lat": 44.660667419433594,
      "lng": -63.60761642456055
    }
  },
  {
    "id": "35891_1",
    "name": "Georgian BMW",
    "country": "CA",
    "city": "Barrie",
    "address": "220 Essa Rd, L4N 6N2 Barrie",
    "email": "info@georgianbmw.ca",
    "phone": "+1-705-7974200",
    "website": "http://www.georgianbmw.ca/",
    "coords": {
      "lat": 44.360355377197266,
      "lng": -79.69738006591797
    }
  },
  {
    "id": "52019_1",
    "name": "BMW Etobicoke",
    "country": "CA",
    "city": "Etobicoke",
    "address": "440 Evans Avenue, M8W 2T5 Etobicoke",
    "email": "BMWEtobicoke@policaro.ca",
    "phone": "+1-416-6405740",
    "website": "https://www.bmwetobicoke.com",
    "coords": {
      "lat": 43.615238189697266,
      "lng": -79.53047180175781
    }
  },
  {
    "id": "08336_1",
    "name": "Maranello BMW",
    "country": "CA",
    "city": "Vaughan",
    "address": "55 Autopark Circle., L4L 8R1 Vaughan",
    "email": "bdc@maranellobmw.com",
    "phone": "+1-416-2135699",
    "website": "http://www.maranellobmw.com/",
    "coords": {
      "lat": 43.78318405151367,
      "lng": -79.5488510131836
    }
  },
  {
    "id": "09271_1",
    "name": "BMW London",
    "country": "CA",
    "city": "London",
    "address": "766 Wharncliffe Rd. South, N6J 2N4 London",
    "email": "info@bmwlondon.ca",
    "phone": "+1-519-6852277",
    "website": "http://www.bmwlondon.ca/",
    "coords": {
      "lat": 42.94457244873047,
      "lng": -81.25736999511719
    }
  },
  {
    "id": "25147_1",
    "name": "BMW Victoria",
    "country": "CA",
    "city": "Victoria",
    "address": "95 Esquimalt Road, V9A 3K8 Victoria",
    "email": "info@bmwvictoria.ca",
    "phone": "+1-250-9959250",
    "website": "http://www.bmwvictoria.ca/",
    "coords": {
      "lat": 48.428279876708984,
      "lng": -123.37684631347656
    }
  },
  {
    "id": "27020_1",
    "name": "BMW Aurora",
    "country": "CA",
    "city": "Aurora",
    "address": "56 Sunday Drive, L4G 4A2 Aurora",
    "email": "sales@bmwaurora.ca",
    "phone": "+1-905-8958700",
    "website": "http://www.bmwaurora.ca",
    "coords": {
      "lat": 44.00986862182617,
      "lng": -79.41339111328125
    }
  },
  {
    "id": "35170_1",
    "name": "BMW West Island",
    "country": "CA",
    "city": "Dorval",
    "address": "2000 Transcanadienne Sud, H9P 2N4 Dorval",
    "email": "info@bmwwestisland.ca",
    "phone": "+1-514-9147777",
    "website": "https://www.bmwwestisland.ca",
    "coords": {
      "lat": 45.483551025390625,
      "lng": -73.7848892211914
    }
  },
  {
    "id": "42097_1",
    "name": "BMW Kingston",
    "country": "CA",
    "city": "Kingston",
    "address": "1412 Bath Road, K7M 4X6 Kingston",
    "email": "info@bmwkingston.ca",
    "phone": "+1-613-8171808",
    "website": "http://www.bmwkingston.ca/",
    "coords": {
      "lat": 44.23799133300781,
      "lng": -76.55226135253906
    }
  },
  {
    "id": "45948_1",
    "name": "BMW Levis",
    "country": "CA",
    "city": "Levis",
    "address": "5303 Boul. Louis-H La Fontaine, G6V 8X4 Levis",
    "email": null,
    "phone": "+1-418-8305000",
    "website": "https://www.bmwlevis.com",
    "coords": {
      "lat": 46.78211212158203,
      "lng": -71.16529083251953
    }
  },
  {
    "id": "09305_1",
    "name": "Park Shore BMW",
    "country": "CA",
    "city": "North Vancouver",
    "address": "835 Automall Drive, V7P 3R8 North Vancouver",
    "email": "info@parkshorebmw.com",
    "phone": "+1-604-9859344",
    "website": "http://www.parkshorebmw.com/",
    "coords": {
      "lat": 49.3157958984375,
      "lng": -123.0992431640625
    }
  },
  {
    "id": "10589_1",
    "name": "Trois-Rivieres BMW",
    "country": "CA",
    "city": "Trois Rivieres",
    "address": "445 Rue Vachon, G8T 8P6 Trois Rivieres",
    "email": "info@trbmw.com",
    "phone": "+1-819-3766668",
    "website": "http://www.trbmw.com/",
    "coords": {
      "lat": 46.370689392089844,
      "lng": -72.55550384521484
    }
  },
  {
    "id": "21217_1",
    "name": "Pfaff BMW",
    "country": "CA",
    "city": "Mississauga",
    "address": "4505 Dixie Road, L4W 5K3 Mississauga",
    "email": "info@pfaffbmw.com",
    "phone": "+1-905-6257533",
    "website": "http://www.pfaffbmw.com/",
    "coords": {
      "lat": 43.63280487060547,
      "lng": -79.6160659790039
    }
  },
  {
    "id": "28256_1",
    "name": "The BMW Store",
    "country": "CA",
    "city": "Vancouver",
    "address": "1855 Fir St., V6J 3A9 Vancouver",
    "email": "sales@thebmwstore.ca",
    "phone": "+1-604-6593200",
    "website": "http://thebmwstore.ca/",
    "coords": {
      "lat": 49.160369873046875,
      "lng": -123.08439636230469
    }
  },
  {
    "id": "09201_1",
    "name": "BMW Montreal Centre",
    "country": "CA",
    "city": "Montreal",
    "address": "4090 Rue Jean Talon West, H4P 1V5 Montreal",
    "email": "ventes@bmwmontrealcentre.ca",
    "phone": "+1-514-7317871",
    "website": "http://bmwmontrealcentre.ca",
    "coords": {
      "lat": 45.49876403808594,
      "lng": -73.64806365966797
    }
  },
  {
    "id": "28664_1",
    "name": "Edmonton BMW",
    "country": "CA",
    "city": "Edmonton",
    "address": "7450 Roper Road, T6B 3L9 Edmonton",
    "email": "info@edmontonbmw.com",
    "phone": "+1-780-4905269",
    "website": "http://www.edmontonbmw.com/",
    "coords": {
      "lat": 53.49305725097656,
      "lng": -113.44176483154297
    }
  },
  {
    "id": "26341_1",
    "name": "Budds' BMW Hamilton",
    "country": "CA",
    "city": "Hamilton",
    "address": "1471 Upper James Street, L9B 1K2 Hamilton",
    "email": "hamilton@buddsbmw.com",
    "phone": "+1-905-3877507",
    "website": "http://www.buddsbmwhamilton.com/",
    "coords": {
      "lat": 43.20669937133789,
      "lng": -79.89115142822266
    }
  },
  {
    "id": "35892_1",
    "name": "BMW Langley",
    "country": "CA",
    "city": "Langley",
    "address": "6025 Collection Drive, V3A 0C2 Langley",
    "email": "info@bmwlangley.com",
    "phone": "+1-604-5330269",
    "website": "http://bmwlangley.com/",
    "coords": {
      "lat": 49.1123046875,
      "lng": -122.64759826660156
    }
  },
  {
    "id": "07598_1",
    "name": "Calgary BMW",
    "country": "CA",
    "city": "Calgary",
    "address": "34 Heritage Meadows Rd SE, T2H 3C1 Calgary",
    "email": "sales@calgarybmw.ca",
    "phone": "+1-403-2530338",
    "website": "http://calgarybmw.ca/",
    "coords": {
      "lat": 50.98419952392578,
      "lng": -114.03351593017578
    }
  },
  {
    "id": "08135_1",
    "name": "BMW Regina",
    "country": "CA",
    "city": "Regina",
    "address": "1001 Broad Street, S4R 8S3 Regina",
    "email": "service@dilawribmw.ca",
    "phone": "+1-306-5254269",
    "website": "https://www.bmwregina.ca",
    "coords": {
      "lat": 50.46337127685547,
      "lng": -104.60633087158203
    }
  },
  {
    "id": "09200_1",
    "name": "BMW Laval",
    "country": "CA",
    "city": "Laval",
    "address": "2450 Boulevard Chomedey, H7T 2X3 Laval",
    "email": "bmw@bmwlaval.com",
    "phone": "+1-450-6867272",
    "website": "https://www.bmwlaval.com/",
    "coords": {
      "lat": 45.5639762878418,
      "lng": -73.76145935058594
    }
  },
  {
    "id": "09206_1",
    "name": "BMW Brossard",
    "country": "CA",
    "city": "Brossard",
    "address": "8400 Taschereau Blvd., J4X 1C2 Brossard",
    "email": "info@parkavenuebmw.com",
    "phone": "+1-450-4454555",
    "website": "http://parkavenuebmw.com/",
    "coords": {
      "lat": 45.43375015258789,
      "lng": -73.47599029541016
    }
  },
  {
    "id": "09232_1",
    "name": "BMW Sarnia",
    "country": "CA",
    "city": "Sarnia",
    "address": "1374 Exmouth Street, N7S 3X9 Sarnia",
    "email": null,
    "phone": "+1-519-3322886",
    "website": "https://www.bmwsarnia.com/",
    "coords": {
      "lat": 42.9853401184082,
      "lng": -82.35352325439453
    }
  },
  {
    "id": "09238_1",
    "name": "Budds' BMW Oakville",
    "country": "CA",
    "city": "Oakville",
    "address": "2454 South Service Rd West, L6L 5M9 Oakville",
    "email": "buddsbmw@buddsbmw.com",
    "phone": "+1-905-8453577",
    "website": "http://www.buddsbmw.com/",
    "coords": {
      "lat": 43.40986633300781,
      "lng": -79.73542022705078
    }
  },
  {
    "id": "09285_1",
    "name": "Brian Jessel BMW",
    "country": "CA",
    "city": "Vancouver",
    "address": "2311 Boundary Road, V5M 4W5 Vancouver",
    "email": "info@brianjesselbmw.com",
    "phone": "+1-604-2227788",
    "website": "https://www.brianjesselbmw.com",
    "coords": {
      "lat": 49.26448059082031,
      "lng": -123.0239028930664
    }
  },
  {
    "id": "26343_1",
    "name": "Parkview BMW",
    "country": "CA",
    "city": "North York",
    "address": "1155 Leslie Street, M3C 2J6 North York",
    "email": "info@parkviewbmw.com",
    "phone": "+1-416-4444269",
    "website": "http://www.parkviewbmw.com/",
    "coords": {
      "lat": 43.72713088989258,
      "lng": -79.35030364990234
    }
  },
  {
    "id": "26342_1",
    "name": "BMW Royal Oak",
    "country": "CA",
    "city": "Calgary",
    "address": "7699 - 110 Ave NW, T3R 1R8 Calgary",
    "email": "info@bmwroyaloak.ca",
    "phone": "+1-403-2756492",
    "website": "http://bmwroyaloak.ca/",
    "coords": {
      "lat": 51.152828216552734,
      "lng": -114.19597625732422
    }
  },
  {
    "id": "32129_1",
    "name": "BMW Moncton",
    "country": "CA",
    "city": "Dieppe",
    "address": "733 Ferdinand Boulevard, E1A 7G1 Dieppe",
    "email": "info@bmwmoncton.ca",
    "phone": "+1-506-8725400",
    "website": "http://www.bmwmoncton.com/",
    "coords": {
      "lat": 46.11311340332031,
      "lng": -64.69811248779297
    }
  },
  {
    "id": "09227_1",
    "name": "Birchwood BMW",
    "country": "CA",
    "city": "Winnipeg",
    "address": "45-3965 Portage Ave, R3K 2H6 Winnipeg",
    "email": "bmw.lease@birchwood.ca",
    "phone": "+1-204-4527799",
    "website": "https://www.birchwoodbmw.ca/",
    "coords": {
      "lat": 49.882686614990234,
      "lng": -97.32880401611328
    }
  },
  {
    "id": "09263_1",
    "name": "Otto's BMW",
    "country": "CA",
    "city": "Ottawa",
    "address": "660 Hunt Club Road, K1V 1C1 Ottawa",
    "email": "info@bmwottawa.com",
    "phone": "+1-613-7253048",
    "website": "https://www.bmwottos.ca",
    "coords": {
      "lat": 45.34239196777344,
      "lng": -75.67227172851562
    }
  },
  {
    "id": "09289_1",
    "name": "Bema Autosport BMW",
    "country": "CA",
    "city": "Saskatoon",
    "address": "607 Brand Court, S7J 5L3 Saskatoon",
    "email": "info@bemaautosport.com",
    "phone": "+1-306-9550900",
    "website": "http://www.bemaautosport.com/",
    "coords": {
      "lat": 52.08790969848633,
      "lng": -106.65386962890625
    }
  },
  {
    "id": "22109_1",
    "name": "BMW Durham",
    "country": "CA",
    "city": "Ajax",
    "address": "100 Achilles Road, L1Z 0C5 Ajax",
    "email": "bdc@bmwdurham.ca",
    "phone": "+1-905-6195522",
    "website": "http://www.bmwdurham.ca",
    "coords": {
      "lat": 43.8542366027832,
      "lng": -79.00663757324219
    }
  },
  {
    "id": "43999_1",
    "name": "Grenier BMW",
    "country": "CA",
    "city": "Terrebonne",
    "address": "201 rue des Migrateurs, J6V 0A8 Terrebonne",
    "email": null,
    "phone": "+1-450-6574444",
    "website": "http://www.grenierbmw.com",
    "coords": {
      "lat": 45.7169075012207,
      "lng": -73.50350952148438
    }
  },
  {
    "id": "20459_1",
    "name": "BMW Autohaus",
    "country": "CA",
    "city": "Thornhill",
    "address": "480 Steeles Avenue West, L4J 6X6 Thornhill",
    "email": "info@bmwautohaus.ca",
    "phone": "+1-905-8863380",
    "website": "http://www.bmwautohaus.ca/",
    "coords": {
      "lat": 43.794437408447266,
      "lng": -79.43657684326172
    }
  },
  {
    "id": "35890_1",
    "name": "BMW St. John's",
    "country": "CA",
    "city": "St. John's",
    "address": "120 Kenmount Rd, A1B 3R2 St. John's",
    "email": "info@bmwstjohns.ca",
    "phone": "+1-709-7543269",
    "website": "https://www.bmwstjohns.ca/",
    "coords": {
      "lat": 47.5550422668457,
      "lng": -52.76744079589844
    }
  },
  {
    "id": "09206_3",
    "name": "BMW Sainte-Julie",
    "country": "CA",
    "city": "Sainte-Julie",
    "address": "1633 Boulevard Armand-Frappier, J3E 3R6 Sainte-Julie",
    "email": "info@bmwsaintejulie.com",
    "phone": "+1-450-9221633",
    "website": "https://www.bmwsaintejulie.com",
    "coords": {
      "lat": 45.57884979248047,
      "lng": -73.3404312133789
    }
  },
  {
    "id": "09265_1",
    "name": "BMW Markham",
    "country": "CA",
    "city": "Markham",
    "address": "8111 Kennedy Road, L3R 5M2 Markham",
    "email": "bdc@bmwmarkham.com",
    "phone": "+1-905-4772212",
    "website": "http://www.bmwmarkham.com/",
    "coords": {
      "lat": 43.85392379760742,
      "lng": -79.30709075927734
    }
  },
  {
    "id": "28665_1",
    "name": "Kelowna BMW",
    "country": "CA",
    "city": "Kelowna",
    "address": "2530 Enterprise Way, V1X 7X5 Kelowna",
    "email": "info@kelownabmw.ca",
    "phone": "+1-250-8601269",
    "website": "http://www.kelownabmw.ca/",
    "coords": {
      "lat": 49.88852310180664,
      "lng": -119.4288101196289
    }
  },
  {
    "id": "33021_1",
    "name": "BMW Toronto",
    "country": "CA",
    "city": "Toronto",
    "address": "11 Sunlight Park Road, M4M 1B5 Toronto",
    "email": "info@bmwtoronto.ca",
    "phone": "+1-416-6234269",
    "website": "http://www.bmwtoronto.ca/",
    "coords": {
      "lat": 43.656192779541016,
      "lng": -79.3488540649414
    }
  },
  {
    "id": "42954_1",
    "name": "Policaro BMW",
    "country": "CA",
    "city": "Brampton",
    "address": "5 Coachworks Crescent, L6R 3Y2 Brampton",
    "email": "info@policarobmw.ca",
    "phone": "+1-855-8076420",
    "website": "http://www.policarobmw.ca/",
    "coords": {
      "lat": 43.758216857910156,
      "lng": -79.7948989868164
    }
  },
  {
    "id": "47900_1",
    "name": "BMW Ste-Agathe",
    "country": "CA",
    "city": "Sainte-Agathe-des-Monts",
    "address": "500 Chemin de La Riviere, J8C 1W3 Sainte-Agathe-des-Monts",
    "email": null,
    "phone": "+1-819-3266464",
    "website": "https://www.bmwsteagathe.com",
    "coords": {
      "lat": 46.044349670410156,
      "lng": -74.26323699951172
    }
  },
  {
    "id": "06625_1",
    "name": "Performance BMW",
    "country": "CA",
    "city": "St. Catharines",
    "address": "266 Lake Street, L2N 4H1 St. Catharines",
    "email": "info@performancebmw.ca",
    "phone": "+1-905-9343356",
    "website": "https://www.performance-bmw.com/",
    "coords": {
      "lat": 43.1801872253418,
      "lng": -79.24978637695312
    }
  },
  {
    "id": "08804_1",
    "name": "Overseas Motors",
    "country": "CA",
    "city": "Windsor",
    "address": "9425  Tecumseh Road East, N8R 1A1 Windsor",
    "email": "bmwsales@overseasmotors.com",
    "phone": "+1-519-2544303",
    "website": "https://www.overseasbmw.com/",
    "coords": {
      "lat": 42.31431579589844,
      "lng": -82.92415618896484
    }
  },
  {
    "id": "09226_1",
    "name": "BMW Grand River",
    "country": "CA",
    "city": "Kitchener",
    "address": "1800 Victoria St. North, N2B 3E5 Kitchener",
    "email": "info@bmwgrandriver.com",
    "phone": "+1-519-7470269",
    "website": "http://www.bmwgrandriver.com/",
    "coords": {
      "lat": 43.47886276245117,
      "lng": -80.42823028564453
    }
  },
  {
    "id": "09304_2",
    "name": "MINI Richmond",
    "country": "CA",
    "city": "Richmond",
    "address": "4331 Vanguard Rd, V6X 2P6 Richmond",
    "email": "info@minirichmond.ca",
    "phone": "+1-604-2330700",
    "website": "http://www.minirichmond.com/",
    "coords": {
      "lat": 49.182315826416016,
      "lng": -123.10138702392578
    }
  },
  {
    "id": "09285_2",
    "name": "Brian Jessel BMW Pre-Owned",
    "country": "CA",
    "city": "Vancouver",
    "address": "1515 Boundary Road, V5K 5C4 Vancouver",
    "email": "info@brianjesselbmw.com",
    "phone": "+1-604-2228820",
    "website": "https://www.brianjesselbmwpreowned.com/",
    "coords": {
      "lat": 49.271060943603516,
      "lng": -123.02374267578125
    }
  },
  {
    "id": "09304_1",
    "name": "Auto West BMW",
    "country": "CA",
    "city": "Richmond",
    "address": "10780 Cambie Road, V6X 1K8 Richmond",
    "email": "sales@autowestbmw.com",
    "phone": "+1-604-2732217",
    "website": "https://www.autowestbmw.com/",
    "coords": {
      "lat": 49.18446350097656,
      "lng": -123.10437774658203
    }
  },
  {
    "id": "25147_2",
    "name": "BMW Nanaimo",
    "country": "CA",
    "city": "Nanaimo",
    "address": "2470 Kenworth Road, V9T 3Y3 Nanaimo",
    "email": "info@bmwnanaimo.ca",
    "phone": "+1-250-5856959",
    "website": "http://www.bmwnanaimo.ca/",
    "coords": {
      "lat": 49.2027702331543,
      "lng": -124.00365447998047
    }
  },
  {
    "id": "31908_1",
    "name": "Hamel BMW",
    "country": "CA",
    "city": "Blainville",
    "address": "620 boul. de la Seigneurie Ouest, J7C 5T7 Blainville",
    "email": "receptionbmw@hamelbmw.com",
    "phone": "+1-888-4516138",
    "website": "http://www.hamelbmw.com",
    "coords": {
      "lat": 45.66114807128906,
      "lng": -73.88250732421875
    }
  },
  {
    "id": "20459_2",
    "name": "BMW Richmond Hill Service",
    "country": "CA",
    "city": "Richmond Hill",
    "address": "371 Ohio Road, L4C 3A1 Richmond Hill",
    "email": null,
    "phone": "+1-905-8868018",
    "website": "https://richmondhillservice.bmw.ca",
    "coords": {
      "lat": 43.89031219482422,
      "lng": -79.43463134765625
    }
  },
  {
    "id": "31563_1",
    "name": "BMW ville de Quebec",
    "country": "CA",
    "city": "Quebec City",
    "address": "215 Rue Etienne Dubreuil, G1M 4A6 Quebec City",
    "email": "info@bmwvilledequebec.ca",
    "phone": "+1-418-6815000",
    "website": "https://www.bmwvilledequebec.com",
    "coords": {
      "lat": 46.830162048339844,
      "lng": -71.27059936523438
    }
  },
  {
    "id": "54796_1",
    "name": "BMW Sherbrooke",
    "country": "CA",
    "city": "Sherbrooke",
    "address": "4620 Boulevard Bourque, J1N 2A8 Sherbrooke",
    "email": "dep.ventes@bmwsherbrooke.com",
    "phone": "+1-819-8219272",
    "website": "https://www.bmwsherbrooke.com",
    "coords": {
      "lat": 45.37553787231445,
      "lng": -71.98043060302734
    }
  },
  {
    "id": "08979_1",
    "name": "Townsville BMW",
    "country": "AU",
    "city": "Townsville",
    "address": "719 Sturt Street, 4810 Townsville",
    "email": "bmw.sales@townsvillebmw.com.au",
    "phone": "+61-7-47265555",
    "website": "https://www.townsvillebmw.com.au",
    "coords": {
      "lat": -19.267763137817383,
      "lng": 146.80555725097656
    }
  },
  {
    "id": "38435_3",
    "name": "Berwick BMW",
    "country": "AU",
    "city": "Narre Warren",
    "address": "6 Coventry Road, 3805 Narre Warren",
    "email": "enquiries@berwickbmw.com.au",
    "phone": "+61-3-87634500",
    "website": "https://www.berwickbmw.com.au",
    "coords": {
      "lat": -38.025936126708984,
      "lng": 145.3115234375
    }
  },
  {
    "id": "45144_3",
    "name": "Ringwood BMW",
    "country": "AU",
    "city": "Ringwood",
    "address": "405 Maroondah Highway, 3134 Ringwood",
    "email": "ringwoodbmw@ringwoodbmw.com.au",
    "phone": "+61-3-88480088",
    "website": "https://www.ringwoodbmw.com.au",
    "coords": {
      "lat": -37.8018913269043,
      "lng": 145.2466583251953
    }
  },
  {
    "id": "49782_2",
    "name": "Hobart BMW",
    "country": "AU",
    "city": "Hobart",
    "address": "23 Barrack Street, 7000 Hobart",
    "email": "sales@hobartbmw.com.au",
    "phone": "+61-3-62135400",
    "website": "https://www.hobartbmw.com.au",
    "coords": {
      "lat": -42.88612365722656,
      "lng": 147.3237762451172
    }
  },
  {
    "id": "08987_8",
    "name": "Brighton BMW",
    "country": "AU",
    "city": "Bentleigh",
    "address": "795 Nepean Highway, 3204 Bentleigh",
    "email": "information@brightonbmw.com.au",
    "phone": "+61-3-95244000",
    "website": "http://www.brightonbmw.com.au",
    "coords": {
      "lat": -37.9222526550293,
      "lng": 145.02423095703125
    }
  },
  {
    "id": "38435_1",
    "name": "Waverley BMW",
    "country": "AU",
    "city": "Glen Waverley",
    "address": "579 Springvale Road, 3150 Glen Waverley",
    "email": "enquiries@waverleybmw.com.au",
    "phone": "+61-3-85819600",
    "website": "https://www.waverleybmw.com.au",
    "coords": {
      "lat": -37.90700149536133,
      "lng": 145.15988159179688
    }
  },
  {
    "id": "52832_1",
    "name": "Darwin BMW",
    "country": "AU",
    "city": "Berrimah",
    "address": "674-676 Stuart Highway, 0828 Berrimah",
    "email": "servicebooking@darwinbmw.com.au",
    "phone": "+61-8-89477727",
    "website": "https://www.darwinbmw.com.au",
    "coords": {
      "lat": -12.434414863586426,
      "lng": 130.92214965820312
    }
  },
  {
    "id": "52066_2",
    "name": "Macarthur BMW",
    "country": "AU",
    "city": "Narellan",
    "address": "10 Yarmouth Place, 2567 Narellan",
    "email": "service@macarthurbmw.com.au",
    "phone": "+61-2-46600200",
    "website": "https://www.macarthurbmw.com.au/",
    "coords": {
      "lat": -34.04166030883789,
      "lng": 150.75108337402344
    }
  },
  {
    "id": "39908_1",
    "name": "Shepparton BMW",
    "country": "AU",
    "city": "Kialla",
    "address": "7969 Goulburn Valley Highway, 3631 Kialla",
    "email": "info@sheppartonbmw.com.au",
    "phone": "+61-3-58232940",
    "website": "https://www.sheppartonbmw.com.au",
    "coords": {
      "lat": -36.412742614746094,
      "lng": 145.39195251464844
    }
  },
  {
    "id": "45144_5",
    "name": "Gold Coast BMW",
    "country": "AU",
    "city": "Southport",
    "address": "285 Southport-Nerang Road, 4215 Southport",
    "email": "service@goldcoastbmw.com.au",
    "phone": "+61-7-55577999",
    "website": "https://www.goldcoastbmw.com.au/",
    "coords": {
      "lat": -27.976343154907227,
      "lng": 153.38755798339844
    }
  },
  {
    "id": "46622_1",
    "name": "Canterbury BMW",
    "country": "AU",
    "city": "Canterbury",
    "address": "376-384 Canterbury Road, 2193 Canterbury",
    "email": "info@canterburybmw.com.au",
    "phone": "+61-2-80387888",
    "website": "http://www.canterburybmw.com.au",
    "coords": {
      "lat": -33.91618728637695,
      "lng": 151.11038208007812
    }
  },
  {
    "id": "08939_1",
    "name": "J T Fossey",
    "country": "AU",
    "city": "Tamworth",
    "address": "501 Peel Street, 2340 Tamworth",
    "email": "info@jtfossey.com.au",
    "phone": "+61-2-67661466",
    "website": "https://www.jtfosseybmw.com.au",
    "coords": {
      "lat": -31.094837188720703,
      "lng": 150.9336700439453
    }
  },
  {
    "id": "08916_5",
    "name": "Sylvania BMW Service Centre",
    "country": "AU",
    "city": "Miranda",
    "address": "128 Parraweena Road, 2228 Miranda",
    "email": "service@sylvaniabmw.com.au",
    "phone": "+61-2-85435440",
    "website": "http://www.sylvania.bmw.com.au",
    "coords": {
      "lat": -34.02693557739258,
      "lng": 151.1170654296875
    }
  },
  {
    "id": "08933_1",
    "name": "Newcastle BMW",
    "country": "AU",
    "city": "Newcastle West",
    "address": "934 Hunter Street, 2302 Newcastle West",
    "email": "bmw.service@newcastle.com.au",
    "phone": "+61-2-49170100",
    "website": "https://www.newcastlebmw.com.au",
    "coords": {
      "lat": -32.92332077026367,
      "lng": 151.7557830810547
    }
  },
  {
    "id": "08970_1",
    "name": "Westco Motors",
    "country": "AU",
    "city": "Cairns",
    "address": "207-209 Newell Street, 4870 Cairns",
    "email": null,
    "phone": "+61-7-40444122",
    "website": "https://www.westcobmw.com.au",
    "coords": {
      "lat": -16.937847137451172,
      "lng": 145.7503204345703
    }
  },
  {
    "id": "22262_1",
    "name": "Central West Prestige",
    "country": "AU",
    "city": "Orange",
    "address": "Cnr Summer & Peisley Street, 2800 Orange",
    "email": "service@tonyleahey.com.au",
    "phone": "+61-2-63601200",
    "website": "http://www.centralwestprestige.com.au",
    "coords": {
      "lat": -33.284637451171875,
      "lng": 149.10366821289062
    }
  },
  {
    "id": "28594_1",
    "name": "Mornington BMW",
    "country": "AU",
    "city": "Mornington",
    "address": "181 Mornington-Tyabb Road, 3931 Mornington",
    "email": "information@morningtonbmw.com.au",
    "phone": "+61-3-59705970",
    "website": "https://www.morningtonbmw.com.au",
    "coords": {
      "lat": -38.23711395263672,
      "lng": 145.06326293945312
    }
  },
  {
    "id": "45917_1",
    "name": "Gippsland BMW",
    "country": "AU",
    "city": "Traralgon",
    "address": "Cnr Princes Hwy & Coonoc Rd, 3844 Traralgon",
    "email": "bmw@valleymotorgroup.com.au",
    "phone": "+61-3-51735888",
    "website": "https://www.gippslandbmw.com.au",
    "coords": {
      "lat": -38.20650100708008,
      "lng": 146.50210571289062
    }
  },
  {
    "id": "48144_1",
    "name": "Adelaide BMW",
    "country": "AU",
    "city": "Adelaide",
    "address": "36-40 West Terrace, 5000 Adelaide",
    "email": "sales@adelaidebmw.com.au",
    "phone": "+61-8-84143111",
    "website": "http://www.adelaidebmw.com.au",
    "coords": {
      "lat": -34.92451858520508,
      "lng": 138.5880889892578
    }
  },
  {
    "id": "52715_1",
    "name": "Riverina BMW",
    "country": "AU",
    "city": "East Wagga Wagga",
    "address": "15 Mason Street, 2650 East Wagga Wagga",
    "email": null,
    "phone": "+61-2-69231144",
    "website": null,
    "coords": {
      "lat": -35.1200065612793,
      "lng": 147.3823699951172
    }
  },
  {
    "id": "54015_1",
    "name": "Launceston BMW",
    "country": "AU",
    "city": "Invermay",
    "address": "143 Invermay Road, 7248 Invermay",
    "email": "service@launcestonbmw.com.au",
    "phone": "+61-3-63255400",
    "website": "https://www.launcestonbmw.com.au",
    "coords": {
      "lat": -41.423423767089844,
      "lng": 147.13601684570312
    }
  },
  {
    "id": "08904_5",
    "name": "Auto Classic BMW (Melville)",
    "country": "AU",
    "city": "Melville",
    "address": "2 Thurso Road, 6156 Melville",
    "email": "service@autoclassic.com.au",
    "phone": "+61-8-93117533",
    "website": "http://www.autoclassic.bmw.com.au",
    "coords": {
      "lat": -32.04591369628906,
      "lng": 115.80919647216797
    }
  },
  {
    "id": "08926_1",
    "name": "McGuigan BMW",
    "country": "AU",
    "city": "Port Macquarie",
    "address": "140 Hastings River Drive, 2444 Port Macquarie",
    "email": "service@mcguiganbmw.com.au",
    "phone": "+61-2-65888500",
    "website": "http://www.mcguiganbmw.com.au",
    "coords": {
      "lat": -31.426908493041992,
      "lng": 152.8787841796875
    }
  },
  {
    "id": "08942_1",
    "name": "Canberra BMW",
    "country": "AU",
    "city": "Phillip",
    "address": "2 Botany Street, 2606 Phillip",
    "email": "bmw@canberrabmw.com.au",
    "phone": "+61-2-62084111",
    "website": "https://www.canberrabmw.com.au",
    "coords": {
      "lat": -35.35124588012695,
      "lng": 149.08567810058594
    }
  },
  {
    "id": "08987_10",
    "name": "Brighton BMW Fast Lane",
    "country": "AU",
    "city": "Mentone",
    "address": "2 Hargrave Place, 3194 Mentone",
    "email": "information@brightonbmw.com.au",
    "phone": "+61-3-95244040",
    "website": "https://www.brightonbmw.com.au/",
    "coords": {
      "lat": -37.985538482666016,
      "lng": 145.10411071777344
    }
  },
  {
    "id": "32877_1",
    "name": "Blacklocks Prestige",
    "country": "AU",
    "city": "Lavington",
    "address": "587 Wagga Road, 2641 Lavington",
    "email": "bikesales@blacklocks.com.au",
    "phone": "+61-2-60495500",
    "website": "https://www.blacklocksprestigebmw.com.au",
    "coords": {
      "lat": -36.03709030151367,
      "lng": 146.964111328125
    }
  },
  {
    "id": "46046_1",
    "name": "Melbourne BMW",
    "country": "AU",
    "city": "South Melbourne",
    "address": "209 Kings Way, 3205 South Melbourne",
    "email": "melbournebmw@melbournebmw.com.au",
    "phone": "+61-3-92682222",
    "website": "https://www.melbournebmw.com.au",
    "coords": {
      "lat": -37.831634521484375,
      "lng": 144.96726989746094
    }
  },
  {
    "id": "48144_3",
    "name": "Medindie BMW",
    "country": "AU",
    "city": "Medindie",
    "address": "1-15 Main North Road, 5081 Medindie",
    "email": "info@adelaidebmw.com.au",
    "phone": "+61-8-82698055",
    "website": "http://www.adelaidebmw.com.au",
    "coords": {
      "lat": -34.897560119628906,
      "lng": 138.5987091064453
    }
  },
  {
    "id": "48757_5",
    "name": "Castle Hill BMW",
    "country": "AU",
    "city": "Castle Hill",
    "address": "13 Carrington Road, 2154 Castle Hill",
    "email": "info@castlehillbmw.com.au",
    "phone": "+61-02-78034400",
    "website": "https://www.castlehillbmw.com.au/",
    "coords": {
      "lat": -33.72892761230469,
      "lng": 150.9818878173828
    }
  },
  {
    "id": "52066_1",
    "name": "South Coast BMW",
    "country": "AU",
    "city": "Wollongong",
    "address": "208 Corrimal Street, 2500 Wollongong",
    "email": "sales@southcoastbmw.com.au",
    "phone": "+61-2-42434700",
    "website": "https://www.southcoastbmw.com.au",
    "coords": {
      "lat": -34.43380355834961,
      "lng": 150.897705078125
    }
  },
  {
    "id": "08980_1",
    "name": "Brisbane BMW",
    "country": "AU",
    "city": "Fortitude Valley",
    "address": "Corner Wickham & Bridge Streets, 4006 Fortitude Valley",
    "email": "info@brisbanebmw.com.au",
    "phone": "+61-7-35204057",
    "website": "http://www.brisbanebmw.com.au/",
    "coords": {
      "lat": -27.455747604370117,
      "lng": 153.03724670410156
    }
  },
  {
    "id": "33984_3",
    "name": "Mosman BMW",
    "country": "AU",
    "city": "Cremorne",
    "address": "261-263 Military Road, 2090 Cremorne",
    "email": "info@nsbmw.com.au",
    "phone": "+61-2-90568000",
    "website": "https://www.northshorebmw.com.au/",
    "coords": {
      "lat": -33.829368591308594,
      "lng": 151.22817993164062
    }
  },
  {
    "id": "45144_1",
    "name": "Doncaster BMW",
    "country": "AU",
    "city": "Doncaster",
    "address": "812-814 Doncaster Road, 3108 Doncaster",
    "email": "info@doncasterbmw.com.au",
    "phone": "+61-3-88480000",
    "website": "https://www.doncasterbmw.com.au",
    "coords": {
      "lat": -37.78684616088867,
      "lng": 145.14060974121094
    }
  },
  {
    "id": "46181_1",
    "name": "Hornsby BMW",
    "country": "AU",
    "city": "Waitara",
    "address": "56-62 Pacific Highway, 2077 Waitara",
    "email": "info@hornsbybmw.com.au",
    "phone": "+61-2-94801888",
    "website": "https://www.hornsbybmw.com.au",
    "coords": {
      "lat": -33.71159744262695,
      "lng": 151.10659790039062
    }
  },
  {
    "id": "51160_1",
    "name": "Mildura BMW",
    "country": "AU",
    "city": "Mildura",
    "address": "19-29 Orange Avenue, 3500 Mildura",
    "email": "info@mildurabmw.com.au",
    "phone": "+61-3-50219910",
    "website": "https://www.mildurabmw.com.au",
    "coords": {
      "lat": -34.18590545654297,
      "lng": 142.1655731201172
    }
  },
  {
    "id": "08904_1",
    "name": "Auto Classic",
    "country": "AU",
    "city": "Osborne Park",
    "address": "384 Scarborough Beach Road, 6017 Osborne Park",
    "email": "sales@autoclassic.com.au",
    "phone": "+61-8-93117533",
    "website": "https://www.autoclassic.com.au",
    "coords": {
      "lat": -31.91194725036621,
      "lng": 115.81692504882812
    }
  },
  {
    "id": "08916_3",
    "name": "Sylvania BMW",
    "country": "AU",
    "city": "Sylvania",
    "address": "101-107 Princes Highway, 2224 Sylvania",
    "email": "info@sylvaniabmw.com.au",
    "phone": "+61-2-85435470",
    "website": "http://www.sylvaniabmw.com.au",
    "coords": {
      "lat": -34.00758361816406,
      "lng": 151.1068878173828
    }
  },
  {
    "id": "08904_3",
    "name": "Westcoast BMW",
    "country": "AU",
    "city": "Wangara",
    "address": "17 Luisini Rd, 6065 Wangara",
    "email": "info@westcoastbmw.com.au",
    "phone": "+61-8-93035888",
    "website": "https://www.westcoastbmw.com.au",
    "coords": {
      "lat": -31.79543113708496,
      "lng": 115.82893371582031
    }
  },
  {
    "id": "29692_1",
    "name": "Geelong BMW",
    "country": "AU",
    "city": "Geelong",
    "address": "212-224 Latrobe Terrace, 3220 Geelong",
    "email": "service@geelongbmw.com.au",
    "phone": "+61-3-52212111",
    "website": "http://www.geelongbmw.com.au",
    "coords": {
      "lat": -38.14464569091797,
      "lng": 144.3523406982422
    }
  },
  {
    "id": "33984_1",
    "name": "North Shore BMW",
    "country": "AU",
    "city": "Chatswood",
    "address": "676 Pacific Highway, 2067 Chatswood",
    "email": "bookings@nsbmw.com.au",
    "phone": "+61-2-94060888",
    "website": "https://www.northshorebmw.com",
    "coords": {
      "lat": -33.79933166503906,
      "lng": 151.17857360839844
    }
  },
  {
    "id": "38435_4",
    "name": "South Yarra BMW",
    "country": "AU",
    "city": "Prahran",
    "address": "145-147 Williams Road, 3181 Prahran",
    "email": "info@southyarrabmw.com.au",
    "phone": "+61-3-95212121",
    "website": "https://www.southyarrabmw.com.au/",
    "coords": {
      "lat": -37.849002838134766,
      "lng": 145.0026397705078
    }
  },
  {
    "id": "45144_2",
    "name": "Bundoora BMW",
    "country": "AU",
    "city": "Bundoora",
    "address": "62 Enterprise Drive, 3083 Bundoora",
    "email": "contact@bundoorabmw.com.au",
    "phone": "+61-3-94688000",
    "website": "https://www.bundoorabmw.com.au",
    "coords": {
      "lat": -37.686580657958984,
      "lng": 145.07566833496094
    }
  },
  {
    "id": "48757_1",
    "name": "Parramatta BMW",
    "country": "AU",
    "city": "Parramatta",
    "address": "40-52 Church Street, 2150 Parramatta",
    "email": "info@parramattabmw.com.au",
    "phone": "+61-02-90543064",
    "website": "https://www.parramattabmw.com.au",
    "coords": {
      "lat": -33.821876525878906,
      "lng": 151.00466918945312
    }
  },
  {
    "id": "52887_1",
    "name": "Sydney BMW",
    "country": "AU",
    "city": "Rushcutters Bay",
    "address": "65 Craigend Street, 2011 Rushcutters Bay",
    "email": null,
    "phone": "+61-2-93344555",
    "website": null,
    "coords": {
      "lat": -33.87715148925781,
      "lng": 151.2274627685547
    }
  },
  {
    "id": "53032_1",
    "name": "Essendon BMW",
    "country": "AU",
    "city": "Essendon Fields",
    "address": "1 Centro Circuit, 3041 Essendon Fields",
    "email": null,
    "phone": "+61-3-90867200",
    "website": null,
    "coords": {
      "lat": -37.71402359008789,
      "lng": 144.89332580566406
    }
  },
  {
    "id": "08913_1",
    "name": "Col Crawford Motors",
    "country": "AU",
    "city": "Brookvale",
    "address": "489 Pittwater Road, 2100 Brookvale",
    "email": "bmwservice@colcrawford.com.au",
    "phone": "+61-2-99411290",
    "website": "https://www.colcrawfordbmw.com.au/",
    "coords": {
      "lat": -33.76456832885742,
      "lng": 151.2707977294922
    }
  },
  {
    "id": "08980_3",
    "name": "Westside BMW",
    "country": "AU",
    "city": "Darra",
    "address": "275 Monier Rd, 4076 Darra",
    "email": "info@westsidebmw.com.au",
    "phone": "+61-7-31860531",
    "website": "https://www.westsidebmw.com.au",
    "coords": {
      "lat": -27.558626174926758,
      "lng": 152.94236755371094
    }
  },
  {
    "id": "38435_5",
    "name": "Glenelg BMW",
    "country": "AU",
    "city": "Glenelg South",
    "address": "141 Brighton Road, 5045 Glenelg South",
    "email": "crbmw@jmgpl.com.au",
    "phone": "+61-8-82943444",
    "website": "https://www.glenelgbmw.com.au",
    "coords": {
      "lat": -34.989532470703125,
      "lng": 138.5205078125
    }
  },
  {
    "id": "45144_4",
    "name": "Motorline BMW",
    "country": "AU",
    "city": "Daisy Hill",
    "address": "1-11 Old Chatswood Road, 4127 Daisy Hill",
    "email": "service@motorline.com.au",
    "phone": "+61-7-32907000",
    "website": "http://www.motorlinebmw.com.au",
    "coords": {
      "lat": -27.63530158996582,
      "lng": 153.13690185546875
    }
  },
  {
    "id": "45512_1",
    "name": "Coastline BMW",
    "country": "AU",
    "city": "Currimundi",
    "address": "770 Nicklin Way, 4551 Currimundi",
    "email": "info@coastlinebmw.com.au",
    "phone": "+61-7-54919100",
    "website": "http://www.coastlinebmw.com.au",
    "coords": {
      "lat": -26.774492263793945,
      "lng": 153.1243438720703
    }
  },
  {
    "id": "06931_1",
    "name": "Symes Motors",
    "country": "AU",
    "city": "Bendigo",
    "address": "239-245 High Street, 3550 Bendigo",
    "email": null,
    "phone": "+61-3-54443338",
    "website": "http://www.symesbmw.com.au",
    "coords": {
      "lat": -36.76778030395508,
      "lng": 144.2660369873047
    }
  },
  {
    "id": "33984_4",
    "name": "North Shore BMW Service Centre",
    "country": "AU",
    "city": "Artarmon",
    "address": "53 Hotham Parade, 2064 Artarmon",
    "email": "service@nsbmw.com.au",
    "phone": "+61-2-84255555",
    "website": "https://www.northshore.bmw.com",
    "coords": {
      "lat": -33.815521240234375,
      "lng": 151.1796875
    }
  },
  {
    "id": "46046_3",
    "name": "Melbourne BMW Bodyshop",
    "country": "AU",
    "city": "Port Melbourne",
    "address": "770 Lorimer Street, 3207 Port Melbourne",
    "email": "info@melbournebmw.com.au",
    "phone": "+61-3-96767666",
    "website": "http://www.melbournebmw.com.au",
    "coords": {
      "lat": -37.82147216796875,
      "lng": 144.92926025390625
    }
  },
  {
    "id": "49024_2",
    "name": "Ballarat BMW",
    "country": "AU",
    "city": "Wendouree",
    "address": "291-299 Learmonth Road, 3355 Wendouree",
    "email": null,
    "phone": "+61-3-53372600",
    "website": "http://www.ballaratbmw.com.au/",
    "coords": {
      "lat": -37.525299072265625,
      "lng": 143.80943298339844
    }
  },
  {
    "id": "23533_1",
    "name": "Worthington BMW",
    "country": "AU",
    "city": "Kariong",
    "address": "Cnr Central Coast Hwy & Kangoo Road, 2250 Kariong",
    "email": "service@worthingtonprestige.com.au",
    "phone": "+61-2-43409988",
    "website": "https://www.worthingtonbmw.com.au",
    "coords": {
      "lat": -33.42858123779297,
      "lng": 151.29100036621094
    }
  },
  {
    "id": "02682_2",
    "name": "K.K. Motoren Mikawa, Okazaki",
    "country": "JP",
    "city": "Okazaki-city,",
    "address": "3-52-6, Ueji,, 444-0823 Okazaki-city,",
    "email": null,
    "phone": "0564-545041",
    "website": "https://mikawa.bmw.jp/okazaki",
    "coords": {
      "lat": 34.910499572753906,
      "lng": 137.17031860351562
    }
  },
  {
    "id": "04385_7",
    "name": "K.K. Autoplatz, Ogikubo",
    "country": "JP",
    "city": "Suginami-ku,",
    "address": "1-15-15, Zenpukuji,, 167-0041 Suginami-ku,",
    "email": null,
    "phone": "03-53104161",
    "website": "https://autoplatz.bmw.jp/ogikubo",
    "coords": {
      "lat": 35.713191986083984,
      "lng": 139.5995330810547
    }
  },
  {
    "id": "04387_4",
    "name": "Meitetsu Auto Co.,Ltd., Komaki",
    "country": "JP",
    "city": "Komaki-city,",
    "address": "1-1-1, Kawanishi, 485-0045 Komaki-city,",
    "email": null,
    "phone": "0568-753200",
    "website": "https://meitetsu.bmw.jp/komaki",
    "coords": {
      "lat": 35.2852668762207,
      "lng": 136.90684509277344
    }
  },
  {
    "id": "09429_2",
    "name": "K.K. Motoren Lepio, Moriya",
    "country": "JP",
    "city": "Moriya-city",
    "address": "2-16-4, Misono, 302-0124 Moriya-city",
    "email": null,
    "phone": "0297-200888",
    "website": "https://ibaraki.bmw.jp/moriya",
    "coords": {
      "lat": 35.92434310913086,
      "lng": 140.00132751464844
    }
  },
  {
    "id": "09435_1",
    "name": "K.K. Eins Motors, HQ",
    "country": "JP",
    "city": "Kofu-city,",
    "address": "1-1-10, Tomitake,, 400-0049 Kofu-city,",
    "email": null,
    "phone": "055-2281339",
    "website": "https://yamanashi.bmw.jp/yamanashi",
    "coords": {
      "lat": 35.65888977050781,
      "lng": 138.5482177734375
    }
  },
  {
    "id": "20176_1",
    "name": "Sojitz Auto Group Tokyo Co., Ltd. A dachi",
    "country": "JP",
    "city": "Adachi-ku",
    "address": "4-1-25, Oyata, 120-0001 Adachi-ku",
    "email": null,
    "phone": "03-56976211",
    "website": "https://sojitz-tokyo.bmw.jp/ja/adachi",
    "coords": {
      "lat": 35.77724075317383,
      "lng": 139.8368377685547
    }
  },
  {
    "id": "21127_2",
    "name": "K.K. Motoren Sendai, Izumi",
    "country": "JP",
    "city": "Sendai-city,",
    "address": "31-1, Nanakita-shindou, Izumi-ku,, 981-3131 Sendai-city,",
    "email": null,
    "phone": "022-3710318",
    "website": "https://sendai.bmw.jp/izumi",
    "coords": {
      "lat": 38.33512878417969,
      "lng": 140.88885498046875
    }
  },
  {
    "id": "24782_7",
    "name": "K.K. Motoren Glanz, Matsudo/MINI Ma",
    "country": "JP",
    "city": "Matsudo-city",
    "address": "362-13, Korokudai, 271-0075 Matsudo-city",
    "email": null,
    "phone": "047-3641500",
    "website": "https://motoren-glanz.bmw.jp/matsudo",
    "coords": {
      "lat": 35.781837463378906,
      "lng": 139.9091796875
    }
  },
  {
    "id": "25828_9",
    "name": "K.K. ABE MOTORS, Meguro Showroom / MINI Meguro",
    "country": "JP",
    "city": "Meguro-ku",
    "address": "1-16-11, Kakinokizaka, 152-0022 Meguro-ku",
    "email": null,
    "phone": "03-57315550",
    "website": "https://meguro.bmw.jp/meguro",
    "coords": {
      "lat": 35.619258880615234,
      "lng": 139.6771240234375
    }
  },
  {
    "id": "25828_3",
    "name": "K.K. ABE MOTORS, Shinagawa Sogo Ser vice Center",
    "country": "JP",
    "city": "Minato-ku",
    "address": "5-1-50, Konan, 108-0075 Minato-ku",
    "email": null,
    "phone": "03-54796160",
    "website": "https://abe.bmw.jp/shinagawa_sc",
    "coords": {
      "lat": 35.62446975708008,
      "lng": 139.75376892089844
    }
  },
  {
    "id": "30295_6",
    "name": "K.K. Motoren BEING, Takasaki HQ",
    "country": "JP",
    "city": "Takasaki-city,",
    "address": "585, Hamajiri-machi,, 370-0005 Takasaki-city,",
    "email": null,
    "phone": "027-3622020",
    "website": "https://gunma.bmw.jp/takasaki",
    "coords": {
      "lat": 36.356201171875,
      "lng": 139.01390075683594
    }
  },
  {
    "id": "41512_1",
    "name": "BMW Japan Corp, FREUDE by BMW",
    "country": "JP",
    "city": "Minato-ku",
    "address": "Tower Plaza 1F-2F, 1-3-1 Azabudai, 106-0041 Minato-ku",
    "email": "driving@freude-by-bmw.jp",
    "phone": "03-32717460",
    "website": "https://www.bmw.com/ja/freude-by-bmw.html",
    "coords": {
      "lat": 35.66077423095703,
      "lng": 139.74002075195312
    }
  },
  {
    "id": "02682_1",
    "name": "K.K. Motoren Mikawa, Toyohashi",
    "country": "JP",
    "city": "Toyohashi-city",
    "address": "44-3, Hashiguchi, Shimoji-cho,, 440-0086 Toyohashi-city",
    "email": null,
    "phone": "0532-522141",
    "website": "https://mikawa.bmw.jp/toyohashi",
    "coords": {
      "lat": 34.784759521484375,
      "lng": 137.3785858154297
    }
  },
  {
    "id": "02692_1",
    "name": "Alster Auto K.K., HQ",
    "country": "JP",
    "city": "Matsuyama-city,",
    "address": "381, Ido-machi,, 791-1114 Matsuyama-city,",
    "email": null,
    "phone": "089-9050200",
    "website": "https://ehime.bmw.jp/ehime",
    "coords": {
      "lat": 33.799285888671875,
      "lng": 132.7852325439453
    }
  },
  {
    "id": "03987_2",
    "name": "K.K. Motoren Sapporo, Obihiro/MINI",
    "country": "JP",
    "city": "Obihiro-city,",
    "address": "3-21-8, Nishi 22jo Minami,, 080-2472 Obihiro-city,",
    "email": null,
    "phone": "0155-365432",
    "website": "https://motoren-sapporo.bmw.jp/obihiro",
    "coords": {
      "lat": 42.9167594909668,
      "lng": 143.1339111328125
    }
  },
  {
    "id": "04393_3",
    "name": "K.K.Motoren Shonan, Fujisawa",
    "country": "JP",
    "city": "Fujisawa-city,",
    "address": "2-10-6, Tsujido Taiheidai,, 251-0044 Fujisawa-city,",
    "email": null,
    "phone": "0466-305007",
    "website": "https://shonan.bmw.jp/fujisawa",
    "coords": {
      "lat": 35.334163665771484,
      "lng": 139.4648895263672
    }
  },
  {
    "id": "09392_5",
    "name": "K.K. Motoren Shizuoka, Numazu/Numaz u Service Workshop",
    "country": "JP",
    "city": "Numazu-city,",
    "address": "372, Okaisshiki,, 410-0012 Numazu-city,",
    "email": null,
    "phone": "055-9223110",
    "website": "https://shizuoka.bmw.jp/numazu",
    "coords": {
      "lat": 35.127647399902344,
      "lng": 138.87693786621094
    }
  },
  {
    "id": "09423_1",
    "name": "K.K. Motoren Nagano, HQ",
    "country": "JP",
    "city": "Nagano-city,",
    "address": "331-1, Minaminagaike,, 381-0024 Nagano-city,",
    "email": null,
    "phone": "026-2670022",
    "website": "https://nagano.bmw.jp/nagano",
    "coords": {
      "lat": 36.64204788208008,
      "lng": 138.2381591796875
    }
  },
  {
    "id": "09430_2",
    "name": "K.K.Motoren Iwate, Mizusawa Servi ce Center",
    "country": "JP",
    "city": "Mizusawa-ku, Ousyu-city,",
    "address": "48-1, Sakurakawa Aza hettuido,, 023-0003 Mizusawa-ku, Ousyu-city,",
    "email": null,
    "phone": "0197-222311",
    "website": "https://iwate.bmw.jp/mizusawa_sc",
    "coords": {
      "lat": 39.169368743896484,
      "lng": 141.1412353515625
    }
  },
  {
    "id": "09439_2",
    "name": "K.K. Motoren Freude, Kumamoto Inter",
    "country": "JP",
    "city": "Kumamoto-city,",
    "address": "3-5-15, Nishibaru, Higashi-ku,, 861-8029 Kumamoto-city,",
    "email": null,
    "phone": "096-3862000",
    "website": "https://kumamoto.bmw.jp/ja/kumamotointer",
    "coords": {
      "lat": 32.82249450683594,
      "lng": 130.7613067626953
    }
  },
  {
    "id": "21547_4",
    "name": "Fuji Motoren K.K., Kodachi",
    "country": "JP",
    "city": "Hamamatsu-city,",
    "address": "124-14, Kodachi-cho, Chuo-ku,, 430-0801 Hamamatsu-city,",
    "email": null,
    "phone": "053-4644360",
    "website": "https://fuji-motoren.bmw.jp/koudachi",
    "coords": {
      "lat": 34.71813201904297,
      "lng": 137.7527618408203
    }
  },
  {
    "id": "31874_3",
    "name": "K.K. Motoren Kobe, Akashi Service C enter",
    "country": "JP",
    "city": "Kobe-city,",
    "address": "2-98, Mochiko, Nishi-ku,, 651-2131 Kobe-city,",
    "email": null,
    "phone": "078-9281341",
    "website": "https://kobe.bmw.jp/akashi_sc",
    "coords": {
      "lat": 34.669189453125,
      "lng": 134.9808349609375
    }
  },
  {
    "id": "30295_4",
    "name": "K.K. Motoren BEING, Tochigi Sogo Se rvice Center",
    "country": "JP",
    "city": "Kanuma-city,",
    "address": "775-10, Fukazu,, 322-0013 Kanuma-city,",
    "email": null,
    "phone": "0289-765505",
    "website": "https://tochigi.bmw.jp/kanuma_sc",
    "coords": {
      "lat": 36.5355339050293,
      "lng": 139.81573486328125
    }
  },
  {
    "id": "01316_1",
    "name": "Nicole Cars LLC, HQ",
    "country": "JP",
    "city": "Kawasaki-city,",
    "address": "2-5-7, Tode, Saiwai-ku,, 212-0005 Kawasaki-city,",
    "email": null,
    "phone": "044-5112000",
    "website": "https://nicole.bmw.jp/tamagawa",
    "coords": {
      "lat": 35.54602813720703,
      "lng": 139.69227600097656
    }
  },
  {
    "id": "02682_4",
    "name": "K.K. Motoren Mikawa, Kariya",
    "country": "JP",
    "city": "Kariya-city,",
    "address": "3-207-2, Toshin-cho,, 448-0031 Kariya-city,",
    "email": null,
    "phone": "0566-280003",
    "website": "https://mikawa.bmw.jp/kariya",
    "coords": {
      "lat": 35.00627136230469,
      "lng": 137.01223754882812
    }
  },
  {
    "id": "03996_1",
    "name": "K.K. ALC Motoren, Hiratsuka",
    "country": "JP",
    "city": "Hiratsuka-city,",
    "address": "3-9-11, Higashiyawata,, 254-0016 Hiratsuka-city,",
    "email": null,
    "phone": "0463-221911",
    "website": "https://alc.bmw.jp/hiratsuka",
    "coords": {
      "lat": 35.34431838989258,
      "lng": 139.35655212402344
    }
  },
  {
    "id": "03987_4",
    "name": "K.K. Motoren Sapporo, Sapporo-Nishi",
    "country": "JP",
    "city": "Sapporo-city,",
    "address": "4-1-3, Miyano-sawa 1jo, Nishi-ku,, 063-0051 Sapporo-city,",
    "email": null,
    "phone": "011-6761184",
    "website": "https://motoren-sapporo.bmw.jp/sapporonishi",
    "coords": {
      "lat": 43.091312408447266,
      "lng": 141.26869201660156
    }
  },
  {
    "id": "04383_2",
    "name": "K.K. Sun Motoren, HQ",
    "country": "JP",
    "city": "Ichinomiya-city,",
    "address": "1-8-1, Akami,, 491-0023 Ichinomiya-city,",
    "email": null,
    "phone": "0586-764311",
    "website": "https://sun-motoren.bmw.jp/ichinomiya",
    "coords": {
      "lat": 35.30094528198242,
      "lng": 136.82284545898438
    }
  },
  {
    "id": "09415_4",
    "name": "K.K. Motoren Saitama, Omiya",
    "country": "JP",
    "city": "Saitama-city,",
    "address": "6-686, Mihashi, Nishi-ku,, 331-0052 Saitama-city,",
    "email": null,
    "phone": "048-6226666",
    "website": "https://m-saitama.bmw.jp/oomiya",
    "coords": {
      "lat": 35.915096282958984,
      "lng": 139.59300231933594
    }
  },
  {
    "id": "09415_11",
    "name": "K.K. Motoren Saitama, Kumagay",
    "country": "JP",
    "city": "Kumagaya-city,",
    "address": "48, Enoki-cho,, 360-0823 Kumagaya-city,",
    "email": null,
    "phone": "048-5231813",
    "website": "https://m-saitama.bmw.jp/kuma",
    "coords": {
      "lat": 36.14059829711914,
      "lng": 139.3795623779297
    }
  },
  {
    "id": "09432_2",
    "name": "K.K. Murauchi Gaisha Center, Sagami ono",
    "country": "JP",
    "city": "Sagamihara-city,",
    "address": "3-50-1, Unomori, Minami-ku,, 252-0301 Sagamihara-city,",
    "email": null,
    "phone": "042-7441411",
    "website": "https://murauchi.bmw.jp/sagamiono",
    "coords": {
      "lat": 35.53836441040039,
      "lng": 139.43435668945312
    }
  },
  {
    "id": "21547_3",
    "name": "Fuji Motoren K.K., Nagatsuru Service Center",
    "country": "JP",
    "city": "Hamamatsu-city,",
    "address": "227-1, Nagatsuru-cho, Chuo-ku,, 435-0031 Hamamatsu-city,",
    "email": null,
    "phone": "053-4643281",
    "website": "https://fuji-motoren.bmw.jp/nagatsuru_bps",
    "coords": {
      "lat": 34.71228790283203,
      "lng": 137.78001403808594
    }
  },
  {
    "id": "30295_8",
    "name": "K.K. Motoren BEING, Gunma Sogo Serv ice Center",
    "country": "JP",
    "city": "Takasaki-city,",
    "address": "20-190, Sugaya-machi,, 370-3522 Takasaki-city,",
    "email": null,
    "phone": "027-3722828",
    "website": "https://gunma.bmw.jp/takasaki_sc",
    "coords": {
      "lat": 36.37874221801758,
      "lng": 139.01950073242188
    }
  },
  {
    "id": "33424_14",
    "name": "K.K. Motoren Hanshin, Takarazuka",
    "country": "JP",
    "city": "Takarazuka-city,",
    "address": "1-8-45, Sakaemachi,, 665-0845 Takarazuka-city,",
    "email": null,
    "phone": "0797-843252",
    "website": "https://hanshin.bmw.jp/",
    "coords": {
      "lat": 34.80795669555664,
      "lng": 135.34698486328125
    }
  },
  {
    "id": "52940_1",
    "name": "K.K. Motoren Tokushima,HQ",
    "country": "JP",
    "city": "Tokushima-city",
    "address": "1 Toiyacho,, 770-8056 Tokushima-city",
    "email": null,
    "phone": "088-6560355",
    "website": "https://m-tokushima.bmw.jp/tokushima",
    "coords": {
      "lat": 34.04853057861328,
      "lng": 134.55169677734375
    }
  },
  {
    "id": "01318_1",
    "name": "Motoren Okinawa K.K., HQ/BPS Okin awa/MINI Okinawa/MINI NEXT Okinawa",
    "country": "JP",
    "city": "Urasoe-city",
    "address": "2693, Gusukuma, 901-2133 Urasoe-city",
    "email": null,
    "phone": "098-8777733",
    "website": "https://okinawa.bmw.jp/urazoe",
    "coords": {
      "lat": 26.26222038269043,
      "lng": 127.71241760253906
    }
  },
  {
    "id": "01316_3",
    "name": "Nicole Cars LLC, BPS/MINI NEXT Yoko hama-Kohoku",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "279, Higashikata-cho, Tsuzuki-ku,, 224-0045 Yokohama-city,",
    "email": null,
    "phone": "045-4722600",
    "website": "https://nicole.bmw.jp/bps_yokohamakohoku",
    "coords": {
      "lat": 35.5191535949707,
      "lng": 139.58236694335938
    }
  },
  {
    "id": "02693_3",
    "name": "K.K. Motoren Aomori, Hachinohe/BP S Hachinohe/MINI Aomori (Service)",
    "country": "JP",
    "city": "Hachinohe-city",
    "address": "24-1, Naganawashiro Aza Bakeishi, 039-1103 Hachinohe-city",
    "email": null,
    "phone": "0178-705036",
    "website": "https://aomori.bmw.jp/ja/hachinohe",
    "coords": {
      "lat": 40.510231018066406,
      "lng": 141.45286560058594
    }
  },
  {
    "id": "02682_3",
    "name": "K.K. Motoren Mikawa, BPS Okazaki",
    "country": "JP",
    "city": "Okazaki-city",
    "address": "3-19-3, Ueji, 444-0823 Okazaki-city",
    "email": null,
    "phone": "0564-737750",
    "website": "https://mikawa.bmw.jp/ja/bps_okazaki",
    "coords": {
      "lat": 34.914398193359375,
      "lng": 137.17633056640625
    }
  },
  {
    "id": "02691_2",
    "name": "K.K. Motoren Toto, BPS Higashi-Yama",
    "country": "JP",
    "city": "Higashiyamato-city",
    "address": "4-1125, Shimizu, 207-0004 Higashiyamato-city",
    "email": null,
    "phone": "042-5622641",
    "website": "https://toto.bmw.jp/higashiyamato",
    "coords": {
      "lat": 35.74880599975586,
      "lng": 139.44808959960938
    }
  },
  {
    "id": "03978_1",
    "name": "K.K. MATSUFUJI, Nagasaki HQ/MINI Na gasaki/BPS/MINI NEXT Nagasaki",
    "country": "JP",
    "city": "Isahaya-city",
    "address": "515-5, Kakoi, Tarami-cho, 859-0402 Isahaya-city",
    "email": null,
    "phone": "0957-433688",
    "website": "https://matsufuji.bmw.jp/nagasaki",
    "coords": {
      "lat": 32.8260383605957,
      "lng": 129.97738647460938
    }
  },
  {
    "id": "03987_1",
    "name": "K.K. Motoren Sapporo, BPS Kushiro/ MINI NEXT Kushiro",
    "country": "JP",
    "city": "Kushiro-city,",
    "address": "4-15-6, Tottori Odori,, 084-0906 Kushiro-city,",
    "email": null,
    "phone": "0154-525432",
    "website": "https://motoren-sapporo.bmw.jp/kushiro_bps",
    "coords": {
      "lat": 43.0146484375,
      "lng": 144.3491973876953
    }
  },
  {
    "id": "09407_2",
    "name": "K.K. Motoren Akita, BPS Akita",
    "country": "JP",
    "city": "Akita-City",
    "address": "1-11-44, Niida futatsuya, 010-1431 Akita-City",
    "email": null,
    "phone": "018-8351234",
    "website": "https://akita.bmw.jp/akita_bps",
    "coords": {
      "lat": 39.68902587890625,
      "lng": 140.1240234375
    }
  },
  {
    "id": "09422_1",
    "name": "K.K. Gaisha Center, HQ/BPS Kochi/MI NI Kochi(Service)",
    "country": "JP",
    "city": "Kochi-city",
    "address": "4-1-3, Takasushinmachi, 781-8122 Kochi-city",
    "email": null,
    "phone": "088-8843141",
    "website": "https://kochi.bmw.jp/kochi",
    "coords": {
      "lat": 33.556541442871094,
      "lng": 133.57810974121094
    }
  },
  {
    "id": "09402_8",
    "name": "Balcom Motors Co.,Ltd, BPS Gionshin do/MINI NEXT Gionshindo",
    "country": "JP",
    "city": "Hiroshima-city",
    "address": "6-26-2, Nishihara, Asa-Minami-ku, 731-0113 Hiroshima-city",
    "email": null,
    "phone": "082-8325505",
    "website": "https://balcom.bmw.jp/bps_gionshindo",
    "coords": {
      "lat": 34.44014358520508,
      "lng": 132.4736785888672
    }
  },
  {
    "id": "09402_20",
    "name": "Balcom Motors Co.,Ltd, Shimonoseki/ BPS Shimonoseki",
    "country": "JP",
    "city": "Shimonoseki-city",
    "address": "3-1, Hatabumiyanoshita-cho, 751-0829 Shimonoseki-city",
    "email": null,
    "phone": "083-2425855",
    "website": "https://balcom.bmw.jp/shimonoseki",
    "coords": {
      "lat": 33.98044204711914,
      "lng": 130.9319305419922
    }
  },
  {
    "id": "09402_16",
    "name": "Balcom Motors Co.,Ltd,BPS Kurashiki",
    "country": "JP",
    "city": "Kurashiki-city",
    "address": "813-1, Higashi-Tomii, 710-0847 Kurashiki-city",
    "email": null,
    "phone": "086-4266100",
    "website": "https://balcom.bmw.jp/kurashiki",
    "coords": {
      "lat": 34.57713317871094,
      "lng": 133.7564239501953
    }
  },
  {
    "id": "09402_3",
    "name": "Balcom Motors Co.,Ltd, Fukuyama/MIN I Fukuyama/BPS/MINI NEXT Fukuyama",
    "country": "JP",
    "city": "Fukuyama-city",
    "address": "120-1, Kohashi, Saba-cho, 720-0835 Fukuyama-city",
    "email": null,
    "phone": "084-9515200",
    "website": "https://balcom.bmw.jp/fukuyama",
    "coords": {
      "lat": 34.48526382446289,
      "lng": 133.33407592773438
    }
  },
  {
    "id": "09406_6",
    "name": "K.K. EPM Corp., BPS Kanazawa/MINI N EXT Kanazawa",
    "country": "JP",
    "city": "Nonoichi-city,",
    "address": "2-35, Mikkaichi-machi,, 921-8806 Nonoichi-city,",
    "email": null,
    "phone": "076-2462100",
    "website": "https://epm.bmw.jp/kanazawa_bps",
    "coords": {
      "lat": 36.535072326660156,
      "lng": 136.59678649902344
    }
  },
  {
    "id": "09429_3",
    "name": "K.K. Motoren Lepio, Tsukuba / MINI",
    "country": "JP",
    "city": "Tsukuba-city,",
    "address": "3-8-2, Gakuen no mori,, 305-0816 Tsukuba-city,",
    "email": null,
    "phone": "029-8500298",
    "website": "https://ibaraki.bmw.jp/tsukuba",
    "coords": {
      "lat": 36.095787048339844,
      "lng": 140.08181762695312
    }
  },
  {
    "id": "04387_8",
    "name": "Meitetsu Auto Co.,Ltd.,BPS Nagakute",
    "country": "JP",
    "city": "Nagakute-city",
    "address": "1-1301, Katahira, 480-1146 Nagakute-city",
    "email": null,
    "phone": "0561-650700",
    "website": "https://meitetsu.bmw.jp/nagakute_bps",
    "coords": {
      "lat": 35.160404205322266,
      "lng": 137.03536987304688
    }
  },
  {
    "id": "04387_16",
    "name": "Meitetsu Auto Co.,Ltd., Ogaki",
    "country": "JP",
    "city": "Ogaki-city",
    "address": "5-73, Tsukizute-cho, 503-0854 Ogaki-city",
    "email": null,
    "phone": "0584-872030",
    "website": "https://meitetsu.bmw.jp/oogaki",
    "coords": {
      "lat": 35.334434509277344,
      "lng": 136.62066650390625
    }
  },
  {
    "id": "22237_11",
    "name": "Weins Import Cars K.K.,Minato-Mirai Workshop",
    "country": "JP",
    "city": "Yokohama-city",
    "address": "3-11, Shinyamashita, Naka-ku, 231-0801 Yokohama-city",
    "email": null,
    "phone": "045-6232311",
    "website": null,
    "coords": {
      "lat": 35.43838119506836,
      "lng": 139.66397094726562
    }
  },
  {
    "id": "30295_9",
    "name": "K.K. Motoren BEING, Maebashi/ BMW Premium Selection Maebashi",
    "country": "JP",
    "city": "Maebashi-city",
    "address": "1363-3, Komagata-machi, 379-2122 Maebashi-city",
    "email": null,
    "phone": "027-2667000",
    "website": "https://gunma.bmw.jp/maebashi",
    "coords": {
      "lat": 36.34659194946289,
      "lng": 139.14437866210938
    }
  },
  {
    "id": "27024_23",
    "name": "YANASE Bayern Motors Co.,Ltd. Yokka ichi/BPS Yokkaichi",
    "country": "JP",
    "city": "Yokkaichi-city",
    "address": "9-22, Tomarikoyanagi-cho, 510-0883 Yokkaichi-city",
    "email": null,
    "phone": "059-3493330",
    "website": "https://yanase.bmw.jp/yokkaichi",
    "coords": {
      "lat": 34.94020462036133,
      "lng": 136.60142517089844
    }
  },
  {
    "id": "30295_2",
    "name": "K.K. Motoren BEING, Oyama/BPS Oyama",
    "country": "JP",
    "city": "Oyama-city",
    "address": "303-3, Hitotonoya, 323-0827 Oyama-city",
    "email": null,
    "phone": "0285-233111",
    "website": "https://tochigi.bmw.jp/oyama",
    "coords": {
      "lat": 36.300724029541016,
      "lng": 139.78912353515625
    }
  },
  {
    "id": "53920_3",
    "name": "K.K. ONE Motoren, Owariasahi",
    "country": "JP",
    "city": "Owariasahi-city",
    "address": "2-16-15, Shibukawa-cho, 488-0839 Owariasahi-city",
    "email": null,
    "phone": "0561-555540",
    "website": "https://one.bmw.jp/ja/owariasahi",
    "coords": {
      "lat": 35.205875396728516,
      "lng": 137.0159912109375
    }
  },
  {
    "id": "27024_10",
    "name": "YANASE Bayern Motors Co.,Ltd. BPS N akagawa",
    "country": "JP",
    "city": "Nagoya-city,",
    "address": "1-248, Hokke, Nakagawa-ku,, 454-0933 Nagoya-city,",
    "email": null,
    "phone": "052-3632100",
    "website": "https://yanase.bmw.jp/nakagawa",
    "coords": {
      "lat": 35.12803268432617,
      "lng": 136.84510803222656
    }
  },
  {
    "id": "27024_11",
    "name": "YANASE Bayern Motors Co.,Ltd. Tenpa ku/ BPS Tenpaku",
    "country": "JP",
    "city": "Nagoya-city",
    "address": "3-903, Ueda Minami, Tenpaku-ku, 468-0053 Nagoya-city",
    "email": null,
    "phone": "052-8041711",
    "website": "https://yanase.bmw.jp/tenpaku",
    "coords": {
      "lat": 35.125816345214844,
      "lng": 136.9917449951172
    }
  },
  {
    "id": "29103_7",
    "name": "K.K. Motoren Tomei-Yokohama, Machid a-Tsurukawa/MINI/BPS/MINI NEXT",
    "country": "JP",
    "city": "Machida-city,",
    "address": "2413-6, Nozutamachi,, 195-0063 Machida-city,",
    "email": null,
    "phone": "042-736-0297",
    "website": "https://tomeiyokohama.bmw.jp/machidatsurukawa",
    "coords": {
      "lat": 35.585750579833984,
      "lng": 139.4493408203125
    }
  },
  {
    "id": "29103_12",
    "name": "K.K. Motoren Tomei-Yokohama, BPS/MI NI NEXT Tomei-Yokohama",
    "country": "JP",
    "city": "Machida-city,",
    "address": "5-18-1, Tsuruma,, 194-0004 Machida-city,",
    "email": null,
    "phone": "042-7888022",
    "website": "https://tomeiyokohama.bmw.jp/tomeiyokohama_bps",
    "coords": {
      "lat": 35.50309371948242,
      "lng": 139.470947265625
    }
  },
  {
    "id": "30295_3",
    "name": "K.K. Motoren BEING, BPS Nishinasuno",
    "country": "JP",
    "city": "Nasu-Shiobaha-city",
    "address": "4-1, Nishi-Toyama, 329-2762 Nasu-Shiobaha-city",
    "email": null,
    "phone": "0287-369595",
    "website": "https://tochigi.bmw.jp/nishinasuno",
    "coords": {
      "lat": 36.90016174316406,
      "lng": 139.98573303222656
    }
  },
  {
    "id": "30295_5",
    "name": "K.K. Motoren BEING, BPS Utsunomiya",
    "country": "JP",
    "city": "Utsunomiya-city",
    "address": "1596-1, Tokami-cho, 320-0856 Utsunomiya-city",
    "email": null,
    "phone": "028-6899030",
    "website": "https://tochigi.bmw.jp/utsunomiya_bps",
    "coords": {
      "lat": 36.541770935058594,
      "lng": 139.84967041015625
    }
  },
  {
    "id": "31874_2",
    "name": "K.K. Motoren Kobe, Himeji/BPS Himej",
    "country": "JP",
    "city": "Himeji-city",
    "address": "65, Chuji, Minamino-cho, 670-0975 Himeji-city",
    "email": null,
    "phone": "079-2350635",
    "website": "https://kobe.bmw.jp/himeji",
    "coords": {
      "lat": 34.81568908691406,
      "lng": 134.6661834716797
    }
  },
  {
    "id": "39253_1",
    "name": "K.K. Motoren Global, Asahikawa/MIN I Asahikawa/BPS/MINI NEXT Asahikawa",
    "country": "JP",
    "city": "Asahikawa-city,",
    "address": "4-490-111, Taisetsu-dori,, 070-0010 Asahikawa-city,",
    "email": null,
    "phone": "0166-231357",
    "website": "https://asahikawa.bmw.jp/asahikawa",
    "coords": {
      "lat": 43.778724670410156,
      "lng": 142.38534545898438
    }
  },
  {
    "id": "09402_2",
    "name": "Balcom Motors Co.,Ltd, Ujina",
    "country": "JP",
    "city": "Hiroshima-city,",
    "address": "3-4-23, Ujina-Nishi, Minami-ku,, 734-0014 Hiroshima-city,",
    "email": null,
    "phone": "082-5052800",
    "website": "https://balcom.bmw.jp/ujina",
    "coords": {
      "lat": 34.361480712890625,
      "lng": 132.4591827392578
    }
  },
  {
    "id": "09415_8",
    "name": "K.K. Motoren Saitama, BPS Tsu rugashima/MINI NEXT Tsurugashima",
    "country": "JP",
    "city": "Tsurugashima-city",
    "address": "1230-2, Takakura, 350-2223 Tsurugashima-city",
    "email": null,
    "phone": "049-2861002",
    "website": "https://m-saitama.bmw.jp/tsurugasima_bps",
    "coords": {
      "lat": 35.93381881713867,
      "lng": 139.38861083984375
    }
  },
  {
    "id": "23343_3",
    "name": "K.K.Motoren TI, Wakayama/BPS Wakaya ma/MINI Wakayama/MINI NEXT Wakayama",
    "country": "JP",
    "city": "Wakayama-city",
    "address": "302-1, Akizuki, 640-8322 Wakayama-city",
    "email": null,
    "phone": "073-4882950",
    "website": "https://motoren-ti.bmw.jp/wakayama",
    "coords": {
      "lat": 34.229774475097656,
      "lng": 135.206298828125
    }
  },
  {
    "id": "23343_2",
    "name": "K.K. Motoren TI, BPS Nara/MINI Nara /MINI NEXT Nara",
    "country": "JP",
    "city": "Nara-city",
    "address": "373, Hachijo-cho, 630-8146 Nara-city",
    "email": null,
    "phone": "0742-348612",
    "website": "https://motoren-ti.bmw.jp/nara_bps",
    "coords": {
      "lat": 34.671627044677734,
      "lng": 135.8008270263672
    }
  },
  {
    "id": "22309_2",
    "name": "K.K.Motoren Saga, BPS Tosu/MINI NEX T Tosu",
    "country": "JP",
    "city": "Tosu-city",
    "address": "1988-1, Aza-Akaide, Maki-machi, 841-0046 Tosu-city",
    "email": null,
    "phone": "0942-481144",
    "website": "https://saga.bmw.jp/tosu_bps",
    "coords": {
      "lat": 33.36057662963867,
      "lng": 130.50653076171875
    }
  },
  {
    "id": "09429_11",
    "name": "K.K. Motoren Lepio, BPS Chiba-Kita/ MINI NEXT Chiba-Kita",
    "country": "JP",
    "city": "Chiba-city",
    "address": "344-1, Naganumahara-cho, Inage-ku, 263-0001 Chiba-city",
    "email": null,
    "phone": "043-2167155",
    "website": "https://keiyo.bmw.jp/chibakita_bps",
    "coords": {
      "lat": 35.67561721801758,
      "lng": 140.12451171875
    }
  },
  {
    "id": "09429_16",
    "name": "K.K. Motoren Lepio, BPS Tsuchiura/ MINI NEXT Tsuchiura",
    "country": "JP",
    "city": "Tsuchiura-city",
    "address": "1-18-19, Nakatakatsu, 300-0815 Tsuchiura-city",
    "email": null,
    "phone": "029-8222050",
    "website": "https://ibaraki.bmw.jp/tsuchiura",
    "coords": {
      "lat": 36.065608978271484,
      "lng": 140.1840057373047
    }
  },
  {
    "id": "09429_13",
    "name": "K.K. Motoren Lepio, Mito /BPS Mito/ MINI Mito/MINI NEXT Mito",
    "country": "JP",
    "city": "Mito-city",
    "address": "1016-1, Yoshizawa-cho, 310-0845 Mito-city",
    "email": null,
    "phone": "029-3041331",
    "website": "https://ibaraki.bmw.jp",
    "coords": {
      "lat": 36.32740783691406,
      "lng": 140.46173095703125
    }
  },
  {
    "id": "09432_6",
    "name": "K.K. Murauchi Gaisha Center, BPS Sa gamiono",
    "country": "JP",
    "city": "Sagamihara-city",
    "address": "7-34-8,KamitsurumaHoncho,Minami-ku, 252-0318 Sagamihara-city",
    "email": null,
    "phone": "042-7453722",
    "website": "https://murauchi.bmw.jp/sagamiono_bps",
    "coords": {
      "lat": 35.5270881652832,
      "lng": 139.44728088378906
    }
  },
  {
    "id": "09440_4",
    "name": "K.K. Hattori Motors, HQ",
    "country": "JP",
    "city": "Otsu-city",
    "address": "1-10, Fujimidai, 520-0846 Otsu-city",
    "email": null,
    "phone": "077-5371950",
    "website": "https://shiga.bmw.jp/shiga",
    "coords": {
      "lat": 34.98685836791992,
      "lng": 135.8878173828125
    }
  },
  {
    "id": "09448_2",
    "name": "K.K. Alcon, Matsue/MINI Matsue/BP S Matsue/MINI NEXT Matsue",
    "country": "JP",
    "city": "Matsue-city",
    "address": "1295-3, Higashi-tsuda-cho, 690-0011 Matsue-city",
    "email": null,
    "phone": "0852-274011",
    "website": "https://alcon.bmw.jp/matsue",
    "coords": {
      "lat": 35.45530319213867,
      "lng": 133.0923614501953
    }
  },
  {
    "id": "04385_2",
    "name": "K.K. Autoplatz, BPS Ikebukuro",
    "country": "JP",
    "city": "Toshima-ku",
    "address": "1-23-1, Kaname-cho, 171-0043 Toshima-ku",
    "email": null,
    "phone": "03-59860281",
    "website": "https://autoplatz.bmw.jp/ja/ikebukuro_bps",
    "coords": {
      "lat": 35.73432159423828,
      "lng": 139.69525146484375
    }
  },
  {
    "id": "09399_5",
    "name": "K.K. Hattori Motor Shokai, HQ/BPS K yoto-Gojo/MINI NEXT Kyoto-Gojo",
    "country": "JP",
    "city": "Kyoto-city",
    "address": "10 Saiinminamitakada-cho, Ukyo-ku, 615-0041 Kyoto-city",
    "email": null,
    "phone": "075-3145500",
    "website": "https://kyoto.bmw.jp/kyoto",
    "coords": {
      "lat": 34.99641418457031,
      "lng": 135.73104858398438
    }
  },
  {
    "id": "09429_7",
    "name": "K.K. Motoren Lepio, Makuhari/MINI M",
    "country": "JP",
    "city": "Chiba-city",
    "address": "2-22-25,Makuharihongo,Hanamigawa-ku, 262-0033 Chiba-city",
    "email": null,
    "phone": "043-2727000",
    "website": "https://keiyo.bmw.jp/makuhari",
    "coords": {
      "lat": 35.666648864746094,
      "lng": 140.0393829345703
    }
  },
  {
    "id": "09399_6",
    "name": "K.K. Hattori Motor Shokai, Takaraga ike/MINI Kyoto",
    "country": "JP",
    "city": "Kyoto-city,",
    "address": "6,Iwakurahigashigoda-cho,Sakyo-ku,, 606-0007 Kyoto-city,",
    "email": null,
    "phone": "075-7215400",
    "website": "https://kyoto.bmw.jp/takaragaike",
    "coords": {
      "lat": 35.064876556396484,
      "lng": 135.78204345703125
    }
  },
  {
    "id": "03996_4",
    "name": "K.K. ALC Motoren, BMW Premium Selec tion Atsugi/MINI NEXT Atsugi",
    "country": "JP",
    "city": "Atsugi-city",
    "address": "3032-1, Okada, 243-0021 Atsugi-city",
    "email": null,
    "phone": "046-2901188",
    "website": "https://alc.bmw.jp/bps_atsugi",
    "coords": {
      "lat": 35.42190933227539,
      "lng": 139.3599395751953
    }
  },
  {
    "id": "09416_2",
    "name": "Sanyo Jidosha K.K., Suzuka",
    "country": "JP",
    "city": "Suzuka-city,",
    "address": "6-20-1, Jike,, 510-0254 Suzuka-city,",
    "email": null,
    "phone": "059-3873311",
    "website": "https://miechuo.bmw.jp/suzuka",
    "coords": {
      "lat": 34.822811126708984,
      "lng": 136.57565307617188
    }
  },
  {
    "id": "09416_5",
    "name": "Sanyo Jidosha K.K., BPS Tsu",
    "country": "JP",
    "city": "Tsu-city",
    "address": "298, Takajyaya, Komori-cho, 514-0817 Tsu-city",
    "email": null,
    "phone": "059-2382288",
    "website": "https://miechuo.bmw.jp/tsu_bps",
    "coords": {
      "lat": 34.6717414855957,
      "lng": 136.51597595214844
    }
  },
  {
    "id": "54674_4",
    "name": "WILLPLUS Motoren Tokyo Corporation, BMW Premium Selection Koshigaya",
    "country": "JP",
    "city": "Koshigaya-city",
    "address": "2-7-26, Kawarasone, 343-0821 Koshigaya-city",
    "email": null,
    "phone": "048-9629500",
    "website": null,
    "coords": {
      "lat": 35.88248062133789,
      "lng": 139.79359436035156
    }
  },
  {
    "id": "54674_2",
    "name": "WILLPLUS Motoren Tokyo Corporation, BMW Premium Selection Kasukabe",
    "country": "JP",
    "city": "Kasukabe-city",
    "address": "1-27-4, Yutaka-cho, 344-0066 Kasukabe-city",
    "email": null,
    "phone": "048-7550055",
    "website": null,
    "coords": {
      "lat": 35.97087860107422,
      "lng": 139.73684692382812
    }
  },
  {
    "id": "54674_1",
    "name": "WILLPLUS Motoren Tokyo Corporation, Koshigaya",
    "country": "JP",
    "city": "Koshigaya-city",
    "address": "2-8-20, Kawarasone, 343-0821 Koshigaya-city",
    "email": null,
    "phone": "048-9629590",
    "website": null,
    "coords": {
      "lat": 35.88146209716797,
      "lng": 139.7935333251953
    }
  },
  {
    "id": "54674_3",
    "name": "WILLPLUS Motoren Tokyo Corporation, Ageo",
    "country": "JP",
    "city": "Ageo-city",
    "address": "295-1, Kami, 362-0001 Ageo-city",
    "email": null,
    "phone": "048-7782222",
    "website": null,
    "coords": {
      "lat": 35.99460983276367,
      "lng": 139.5758819580078
    }
  },
  {
    "id": "02685_1",
    "name": "Elbe Auto K.K., HQ/BPS Sakai",
    "country": "JP",
    "city": "Sakai-city",
    "address": "3401, Fukai Kita-Machi, Naka-Ku, 599-8271 Sakai-city",
    "email": null,
    "phone": "072-2772300",
    "website": "https://elbe.bmw.jp/ja/sakai",
    "coords": {
      "lat": 34.540077209472656,
      "lng": 135.4912872314453
    }
  },
  {
    "id": "33424_11",
    "name": "K.K. Motoren Hanshin,Osaka-Minami/M INI Osaka-Minami",
    "country": "JP",
    "city": "Osaka-city,",
    "address": "4-19-4,Imagawa,Higashisumiyoshi-ku, 546-0003 Osaka-city,",
    "email": null,
    "phone": "06-67003108",
    "website": "https://hanshin.bmw.jp/osakaminami",
    "coords": {
      "lat": 34.628074645996094,
      "lng": 135.53814697265625
    }
  },
  {
    "id": "31886_3",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , BPS Suita",
    "country": "JP",
    "city": "Suita-city",
    "address": "5-55, Yoshino-cho, 564-0054 Suita-city",
    "email": null,
    "phone": "06-48615515",
    "website": "https://osaka.bmw.jp/bpm_suita",
    "coords": {
      "lat": 34.75738525390625,
      "lng": 135.48902893066406
    }
  },
  {
    "id": "27024_28",
    "name": "YANASE Bayern Motors Co.,Ltd. Fukuo ka--Itazuke / BMW Premium Selection",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "2-24-15, Mugino, Hakata-ku, 812-0882 Fukuoka-city",
    "email": null,
    "phone": "092-5879900",
    "website": "https://yanase.bmw.jp/itazuke",
    "coords": {
      "lat": 33.55796432495117,
      "lng": 130.46009826660156
    }
  },
  {
    "id": "31886_7",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , Kadoma Service Center",
    "country": "JP",
    "city": "Kadoma-city,",
    "address": "9-4, Tonoshima-cho,, 571-0045 Kadoma-city,",
    "email": null,
    "phone": "06-69036611",
    "website": "https://osaka.bmw.jp",
    "coords": {
      "lat": 34.7308235168457,
      "lng": 135.5798797607422
    }
  },
  {
    "id": "33424_3",
    "name": "K.K. Motoren Hanshin, Minoo/MINI Mi noo Workshop",
    "country": "JP",
    "city": "Minoo-city,",
    "address": "2-4-13, Kayano,, 562-0014 Minoo-city,",
    "email": null,
    "phone": "072-7244711",
    "website": "https://hanshin.bmw.jp/minoh",
    "coords": {
      "lat": 34.829742431640625,
      "lng": 135.48690795898438
    }
  },
  {
    "id": "34188_9",
    "name": "Willplus Motoren Corporation, Yahat a/BPS Yahata/MINI NEXT Yahata",
    "country": "JP",
    "city": "Kitakyusyu-city",
    "address": "2-1-1, Momozono, Yahata-Higashi-ku, 805-0068 Kitakyusyu-city",
    "email": null,
    "phone": "093-6636555",
    "website": "https://willplus.bmw.jp/yahata",
    "coords": {
      "lat": 33.86805725097656,
      "lng": 130.78439331054688
    }
  },
  {
    "id": "33424_15",
    "name": "K.K. Motoren Hanshin, BMW Premium S election/MINI NEXT Osaka Bay",
    "country": "JP",
    "city": "Osaka-city",
    "address": "1-5-38, Kaigandori, Minato-ku, 552-0022 Osaka-city",
    "email": null,
    "phone": "06-65742371",
    "website": "https://hanshin.bmw.jp",
    "coords": {
      "lat": 34.65163803100586,
      "lng": 135.42669677734375
    }
  },
  {
    "id": "02693_1",
    "name": "K.K. Motoren Aomori, Aomori/ MINI NEXT Aomori",
    "country": "JP",
    "city": "Aomori-city",
    "address": "24-1, Ohono Aza maeda, 030-0852 Aomori-city",
    "email": null,
    "phone": "017-7290155",
    "website": "https://aomori.bmw.jp/ja/aomori",
    "coords": {
      "lat": 40.7977294921875,
      "lng": 140.7360076904297
    }
  },
  {
    "id": "02688_1",
    "name": "K.K. MK Motors, HQ/BMW Service",
    "country": "JP",
    "city": "Oita-city,",
    "address": "3260-31, Oaza Shimogori,, 870-0951 Oita-city,",
    "email": null,
    "phone": "097-5691400",
    "website": "https://oita.bmw.jp/oita",
    "coords": {
      "lat": 33.222068786621094,
      "lng": 131.62576293945312
    }
  },
  {
    "id": "04387_15",
    "name": "Meitetsu Auto Co.,Ltd., Gifu",
    "country": "JP",
    "city": "Gifu-city,",
    "address": "6, Toko-cho,, 500-8137 Gifu-city,",
    "email": null,
    "phone": "058-2481168",
    "website": "https://meitetsu.bmw.jp/gifu",
    "coords": {
      "lat": 35.416690826416016,
      "lng": 136.78207397460938
    }
  },
  {
    "id": "04393_5",
    "name": "K.K.Motoren Shonan, Konan",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "9-32-2 Konandai, Konan-ku,, 234-0054 Yokohama-city,",
    "email": null,
    "phone": "045-8350330",
    "website": "https://shonan.bmw.jp/konan",
    "coords": {
      "lat": 35.36753845214844,
      "lng": 139.58074951171875
    }
  },
  {
    "id": "09392_2",
    "name": "K.K. Motoren Shizuoka, Fuji",
    "country": "JP",
    "city": "Fuji-city,",
    "address": "300 Aoba-cho,, 416-0952 Fuji-city,",
    "email": null,
    "phone": "0545-655300",
    "website": "https://shizuoka.bmw.jp/fuji",
    "coords": {
      "lat": 35.16643524169922,
      "lng": 138.6708221435547
    }
  },
  {
    "id": "09392_3",
    "name": "K.K. Motoren Shizuoka, Shizuoka",
    "country": "JP",
    "city": "Shizuoka-city,",
    "address": "175-1, Nakanoshinden, Suruga-ku,, 422-8051 Shizuoka-city,",
    "email": null,
    "phone": "054-2841351",
    "website": "https://shizuoka.bmw.jp/shizuoka",
    "coords": {
      "lat": 34.95233154296875,
      "lng": 138.38584899902344
    }
  },
  {
    "id": "09415_3",
    "name": "K.K. Motoren Saitama, Urawa/M INI Urawa",
    "country": "JP",
    "city": "Warabi-city,",
    "address": "2-1-37, Nishiki-cho,, 335-0005 Warabi-city,",
    "email": null,
    "phone": "048-4438861",
    "website": "https://m-saitama.bmw.jp/urawa",
    "coords": {
      "lat": 35.82546615600586,
      "lng": 139.67724609375
    }
  },
  {
    "id": "09415_14",
    "name": "K.K. Motoren Saitama, Toda Se rvice Center",
    "country": "JP",
    "city": "Toda-city,",
    "address": "2-14-5, Hikawa-cho, 335-0027 Toda-city,",
    "email": null,
    "phone": "048-4206006",
    "website": "https://m-saitama.bmw.jp/toda",
    "coords": {
      "lat": 35.812137603759766,
      "lng": 139.65618896484375
    }
  },
  {
    "id": "09424_1",
    "name": "K.K. A-1 Auto Iwase, HQ Showroom/MI NI Matsumoto",
    "country": "JP",
    "city": "Matsumoto-city,",
    "address": "2-7-1, Muraimachi-Minami,, 399-0036 Matsumoto-city,",
    "email": null,
    "phone": "0263-853636",
    "website": "https://matsumoto.bmw.jp/ja/matsumoto-bmw",
    "coords": {
      "lat": 36.181217193603516,
      "lng": 137.96554565429688
    }
  },
  {
    "id": "09432_7",
    "name": "K.K. Murauchi Gaisha Center, Kunita chi Workshop",
    "country": "JP",
    "city": "Kunitachi-city,",
    "address": "4-16-4, Izumi,, 186-0012 Kunitachi-city,",
    "email": null,
    "phone": "042-5010740",
    "website": "https://murauchi.bmw.jp/kunitachi_ws",
    "coords": {
      "lat": 35.676231384277344,
      "lng": 139.4313201904297
    }
  },
  {
    "id": "09440_3",
    "name": "K.K. Hattori Motors, Ritto",
    "country": "JP",
    "city": "Ritto-city,",
    "address": "4-1-3, Ohashi,, 520-3046 Ritto-city,",
    "email": null,
    "phone": "077-5522311",
    "website": "https://shiga.bmw.jp/ritto",
    "coords": {
      "lat": 35.03273391723633,
      "lng": 136.00323486328125
    }
  },
  {
    "id": "30295_1",
    "name": "K.K. Motoren BEING, Utsunomiya HQ",
    "country": "JP",
    "city": "Utsunomiya-city,",
    "address": "3-17-1, Naka-Imaizumi,, 321-0968 Utsunomiya-city,",
    "email": null,
    "phone": "028-6343221",
    "website": "https://tochigi.bmw.jp/utsunomiya",
    "coords": {
      "lat": 36.56970977783203,
      "lng": 139.9059600830078
    }
  },
  {
    "id": "31874_5",
    "name": "K.K. Motoren Kobe, Harbor Kobe",
    "country": "JP",
    "city": "Kobe-city,",
    "address": "11-1, Shinko-cho, Chuo-ku,, 650-0041 Kobe-city,",
    "email": null,
    "phone": "078-3913578",
    "website": "https://kobe.bmw.jp/ja/harbor",
    "coords": {
      "lat": 34.68415069580078,
      "lng": 135.19497680664062
    }
  },
  {
    "id": "01316_2",
    "name": "Nicole Cars LLC, Yokohama-Koh oku",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "3-21-28, Hayabuchi, Tsuzuki-ku,, 224-0025 Yokohama-city,",
    "email": null,
    "phone": "045-5921200",
    "website": "https://nicole.bmw.jp/yokohamakohoku",
    "coords": {
      "lat": 35.548309326171875,
      "lng": 139.60264587402344
    }
  },
  {
    "id": "03996_3",
    "name": "K.K. ALC Motoren, Atsugi",
    "country": "JP",
    "city": "Atsugi-city,",
    "address": "3060, Sakai,, 243-0022 Atsugi-city,",
    "email": null,
    "phone": "046-2271911",
    "website": "https://alc.bmw.jp/atsugi",
    "coords": {
      "lat": 35.42148208618164,
      "lng": 139.35948181152344
    }
  },
  {
    "id": "09406_1",
    "name": "K.K. EPM Corp., HQ",
    "country": "JP",
    "city": "Nonoichi-city,",
    "address": "4-43, Futsukaichi,, 921-8809 Nonoichi-city,",
    "email": null,
    "phone": "076-2186110",
    "website": "https://epm.bmw.jp/ishikawa",
    "coords": {
      "lat": 36.537078857421875,
      "lng": 136.5985107421875
    }
  },
  {
    "id": "09430_1",
    "name": "K.K.Motoren Iwate, Morioka/MINI Mor",
    "country": "JP",
    "city": "Morioka-city,",
    "address": "3-13-22, Tsushidaminami,, 020-0839 Morioka-city,",
    "email": null,
    "phone": "019-6376530",
    "website": "https://iwate.bmw.jp/iwate",
    "coords": {
      "lat": 39.657257080078125,
      "lng": 141.1522674560547
    }
  },
  {
    "id": "09432_4",
    "name": "K.K. Murauchi Gaisha Center, Sagami hara",
    "country": "JP",
    "city": "Sagamihara-city,",
    "address": "4-8-1, Seishin, Chuo-ku,, 252-0216 Sagamihara-city,",
    "email": null,
    "phone": "042-7797811",
    "website": "https://murauchi.bmw.jp/sagamihara",
    "coords": {
      "lat": 35.58052444458008,
      "lng": 139.35935974121094
    }
  },
  {
    "id": "09439_1",
    "name": "K.K. Motoren Freude, Shimotori",
    "country": "JP",
    "city": "Kumamoto-city,",
    "address": "1-5-15 Shimotori, Chuo-ku, 860-0807 Kumamoto-city,",
    "email": null,
    "phone": "096-2456371",
    "website": "https://kumamoto.bmw.jp/ja/kumamoto_shimotori",
    "coords": {
      "lat": 32.8015251159668,
      "lng": 130.7083740234375
    }
  },
  {
    "id": "09440_2",
    "name": "K.K. Hattori Motors, Koto",
    "country": "JP",
    "city": "Higashi-Omi-city,",
    "address": "46-3, Gokashotatsuta-cho,, 529-1421 Higashi-Omi-city,",
    "email": null,
    "phone": "0748-485681",
    "website": "https://shiga.bmw.jp/koto",
    "coords": {
      "lat": 35.15400314331055,
      "lng": 136.1912841796875
    }
  },
  {
    "id": "21127_4",
    "name": "K.K. Motoren Sendai, Wakabayashi/MI NI Sendai/MINI NEXT Sendai",
    "country": "JP",
    "city": "Sendai-city",
    "address": "1-18-37, Toumizuka, Wakabayashi-ku, 984-0823 Sendai-city",
    "email": null,
    "phone": "022-7669917",
    "website": "https://sendai.bmw.jp/wakabayashi",
    "coords": {
      "lat": 38.23645782470703,
      "lng": 140.91290283203125
    }
  },
  {
    "id": "31874_1",
    "name": "K.K. Motoren Kobe, Akashi/MINI",
    "country": "JP",
    "city": "Kobe-city,",
    "address": "1302-1,Arise,Ikawadani-cho,, 651-2113 Kobe-city,",
    "email": null,
    "phone": "078-9783288",
    "website": "https://kobe.bmw.jp/akashi",
    "coords": {
      "lat": 34.6633186340332,
      "lng": 135.01499938964844
    }
  },
  {
    "id": "50262_3",
    "name": "K.K. ALC Motoren Tokyo, Sasazuka Wo rkshop",
    "country": "JP",
    "city": "Shibuya-ku",
    "address": "2-1-8, Sasazuka, 151-0073 Shibuya-ku",
    "email": null,
    "phone": "03-53717300",
    "website": "https://alc.bmw.jp/ja/sasazuka_service",
    "coords": {
      "lat": 35.67613983154297,
      "lng": 139.67039489746094
    }
  },
  {
    "id": "02691_1",
    "name": "K.K. Motoren Toto, Nishi-Tokyo HQ",
    "country": "JP",
    "city": "Higashikurume-city,",
    "address": "3-11-2, Takiyama,, 203-0033 Higashikurume-city,",
    "email": null,
    "phone": "042-4751231",
    "website": "https://toto.bmw.jp/higashikurume",
    "coords": {
      "lat": 35.74026107788086,
      "lng": 139.50550842285156
    }
  },
  {
    "id": "03979_1",
    "name": "Motoren Niigata K.K., Niigata Show room",
    "country": "JP",
    "city": "Niigata-city,",
    "address": "2-14-19, Dekijima, Chuo-ku,, 950-0962 Niigata-city,",
    "email": null,
    "phone": "025-2857232",
    "website": "https://niigata.bmw.jp/niigata",
    "coords": {
      "lat": 37.89797592163086,
      "lng": 139.02345275878906
    }
  },
  {
    "id": "04387_6",
    "name": "Meitetsu Auto Co.,Ltd., Nakamura",
    "country": "JP",
    "city": "Nagoya-city,",
    "address": "17-24, Ibuka-cho, Nakamura-ku,, 453-0012 Nagoya-city,",
    "email": null,
    "phone": "052-4541700",
    "website": "https://meitetsu.bmw.jp/nakamura",
    "coords": {
      "lat": 35.177734375,
      "lng": 136.87496948242188
    }
  },
  {
    "id": "04385_4",
    "name": "K.K. Autoplatz, Nerima/MINI Nerima (Service)",
    "country": "JP",
    "city": "Nerima-ku,",
    "address": "4-20-5, Takanodai,, 177-0033 Nerima-ku,",
    "email": null,
    "phone": "03-39952211",
    "website": "https://autoplatz.bmw.jp/ja/nerima",
    "coords": {
      "lat": 35.74909210205078,
      "lng": 139.61676025390625
    }
  },
  {
    "id": "09407_1",
    "name": "K.K. Motoren Akita, HQ",
    "country": "JP",
    "city": "Akita-city,",
    "address": "1-10-40, Niida futatsuya,, 010-1431 Akita-city,",
    "email": null,
    "phone": "018-8339449",
    "website": "https://akita.bmw.jp/akita",
    "coords": {
      "lat": 39.689632415771484,
      "lng": 140.12391662597656
    }
  },
  {
    "id": "09415_1",
    "name": "K.K. Motoren Saitama, Kawaguc hi/Kawaguchi Service Center",
    "country": "JP",
    "city": "Kawaguchi-city,",
    "address": "1-5-20, Asahi,, 332-0001 Kawaguchi-city,",
    "email": null,
    "phone": "048-2234415",
    "website": "https://m-saitama.bmw.jp/kawaguchi_nc",
    "coords": {
      "lat": 35.8066291809082,
      "lng": 139.73338317871094
    }
  },
  {
    "id": "09415_9",
    "name": "K.K. Motoren Saitama, Saitama -Higashi",
    "country": "JP",
    "city": "Kawaguchi-city",
    "address": "3-3-27,Totsuka, 333-0811 Kawaguchi-city",
    "email": null,
    "phone": "048-2873139",
    "website": "https://m-saitama.bmw.jp/saitamahigasi",
    "coords": {
      "lat": 35.86804962158203,
      "lng": 139.74522399902344
    }
  },
  {
    "id": "09415_5",
    "name": "K.K. Motoren Saitama, Kawagoe",
    "country": "JP",
    "city": "Kawagoe-city,",
    "address": "390-1, Oosenba,, 350-0032 Kawagoe-city,",
    "email": null,
    "phone": "049-2240050",
    "website": "https://m-saitama.bmw.jp/kawagoe",
    "coords": {
      "lat": 35.912715911865234,
      "lng": 139.4989776611328
    }
  },
  {
    "id": "20176_2",
    "name": "Sojitz Auto Group Tokyo Co., Ltd. K oto",
    "country": "JP",
    "city": "Koto-ku",
    "address": "7-41-7, Kameido, 136-0071 Koto-ku",
    "email": null,
    "phone": "03-36381811",
    "website": "https://sojitz-tokyo.bmw.jp/ja/koto",
    "coords": {
      "lat": 35.696876525878906,
      "lng": 139.83653259277344
    }
  },
  {
    "id": "25827_24",
    "name": "BMW Tokyo Corp., Kiba Service Cente",
    "country": "JP",
    "city": "Koto-ku",
    "address": "2-4-7, Shiohama, 135-0043 Koto-ku",
    "email": null,
    "phone": "03-56352530",
    "website": "https://bmw-tokyo.bmw.jp/kiba_sf",
    "coords": {
      "lat": 35.66358947753906,
      "lng": 139.8035888671875
    }
  },
  {
    "id": "47974_3",
    "name": "K.K. Idex Bayern Motors, Kagoshima- Chuo",
    "country": "JP",
    "city": "Kagoshima-city",
    "address": "8-7, Shinei-cho,, 890-0072 Kagoshima-city",
    "email": null,
    "phone": "099-2030480",
    "website": "https://idex.bmw.jp/kagoshimachuoh",
    "coords": {
      "lat": 31.54685401916504,
      "lng": 130.54493713378906
    }
  },
  {
    "id": "27024_5",
    "name": "YANASE Bayern Motors Co.,Ltd. Denen chofu",
    "country": "JP",
    "city": "Setagaya-ku,",
    "address": "6-3-5, Okusawa,, 158-0083 Setagaya-ku,",
    "email": null,
    "phone": "03-37034611",
    "website": "https://yanase.bmw.jp/denenchofu",
    "coords": {
      "lat": 35.601715087890625,
      "lng": 139.6606903076172
    }
  },
  {
    "id": "27024_9",
    "name": "YANASE Bayern Motors Co.,Ltd. Nagoy",
    "country": "JP",
    "city": "Nagoya-city,",
    "address": "4-21-10, Sakae, Naka-ku,, 460-0008 Nagoya-city,",
    "email": null,
    "phone": "052-8577610",
    "website": "https://yanase.bmw.jp/nagoya",
    "coords": {
      "lat": 35.166229248046875,
      "lng": 136.91452026367188
    }
  },
  {
    "id": "02688_2",
    "name": "K.K. MK Motors, MINI Oita/BPS Oita/ MINI NEXT Oita",
    "country": "JP",
    "city": "Oita-city",
    "address": "1916-1, Ropponmatsu, Tsuru, 870-0100 Oita-city",
    "email": null,
    "phone": "097-5691333",
    "website": "https://oita.bmw.jp/oita_bps",
    "coords": {
      "lat": 33.23319625854492,
      "lng": 131.62985229492188
    }
  },
  {
    "id": "03979_2",
    "name": "Motoren Niigata K.K., Nagaoka/ BPS Nagaoka",
    "country": "JP",
    "city": "Nagaoka-city,",
    "address": "9, Sakaihigashi-machi,, 940-2026 Nagaoka-city,",
    "email": null,
    "phone": "0258-274011",
    "website": "https://niigata.bmw.jp/nagaoka",
    "coords": {
      "lat": 37.458702087402344,
      "lng": 138.81378173828125
    }
  },
  {
    "id": "03987_3",
    "name": "K.K. Motoren Sapporo, BPS Kitami/ MINI NEXT Kitami",
    "country": "JP",
    "city": "Kitami-city,",
    "address": "51-36, Taisyo,, 090-0008 Kitami-city,",
    "email": null,
    "phone": "0157-365350",
    "website": "https://motoren-sapporo.bmw.jp/ja/kitami_bps",
    "coords": {
      "lat": 43.807334899902344,
      "lng": 143.8397979736328
    }
  },
  {
    "id": "04393_2",
    "name": "K.K.Motoren Shonan, Yamato/ BPS Yamato",
    "country": "JP",
    "city": "Yamato-city",
    "address": "1-6-1, Shibuya, 242-0023 Yamato-city",
    "email": null,
    "phone": "046-2697278",
    "website": "https://shonan.bmw.jp/yamato_bps",
    "coords": {
      "lat": 35.43717575073242,
      "lng": 139.4667205810547
    }
  },
  {
    "id": "09392_7",
    "name": "K.K. Motoren Shizuoka, BPS Yaizu",
    "country": "JP",
    "city": "Yaizu-city",
    "address": "1-1-1, Daikakuji, 425-0088 Yaizu-city",
    "email": null,
    "phone": "054-6207531",
    "website": "https://shizuoka.bmw.jp/yaizu_bps",
    "coords": {
      "lat": 34.87738800048828,
      "lng": 138.30377197265625
    }
  },
  {
    "id": "09402_1",
    "name": "Balcom Motors Co.,Ltd, Hiroshima/BP S Hiroshima",
    "country": "JP",
    "city": "Hiroshima-city",
    "address": "3-8-10, Nakasuji, Asaminami-ku, 731-0122 Hiroshima-city",
    "email": null,
    "phone": "082-8702100",
    "website": "https://balcom.bmw.jp/hiroshima",
    "coords": {
      "lat": 34.45393371582031,
      "lng": 132.47801208496094
    }
  },
  {
    "id": "09402_29",
    "name": "Balcom Motors Co.,Ltd, BMW Premium Selection Okayama-kita",
    "country": "JP",
    "city": "Okayama-shi",
    "address": "346-116, Shimonakano, Kita-ku, 700-0973 Okayama-shi",
    "email": null,
    "phone": "086-2447500",
    "website": "https://balcom.bmw.jp/ja/bps_okayamakita",
    "coords": {
      "lat": 34.63801956176758,
      "lng": 133.90380859375
    }
  },
  {
    "id": "09402_27",
    "name": "Balcom Motors Co.,Ltd, BPS Ujina",
    "country": "JP",
    "city": "Hiroshima-city",
    "address": "5-2-1, Ujina-nishi, Minami-ku, 734-0014 Hiroshima-city",
    "email": null,
    "phone": "082-5675566",
    "website": "https://balcom.bmw.jp/bps_ujina",
    "coords": {
      "lat": 34.36360168457031,
      "lng": 132.4576873779297
    }
  },
  {
    "id": "09402_10",
    "name": "Balcom Motors Co.,Ltd, Yamaguchi/BP S Yamaguch",
    "country": "JP",
    "city": "Yamaguchi-city",
    "address": "1618-1, Asada, 753-0871 Yamaguchi-city",
    "email": null,
    "phone": "083-9010700",
    "website": "https://balcom.bmw.jp/yamaguchi",
    "coords": {
      "lat": 34.14204025268555,
      "lng": 131.42611694335938
    }
  },
  {
    "id": "09402_14",
    "name": "Balcom Motors Co.,Ltd, MINI Hiroshi ma/MINI NEXT Hiroshima/BPS Kanon",
    "country": "JP",
    "city": "Hiroshima-city",
    "address": "2-7-42, Kanonshinmachi, Nishi-ku, 733-0036 Hiroshima-city",
    "email": null,
    "phone": "082-5328500",
    "website": "https://balcom.bmw.jp/bps_kanon",
    "coords": {
      "lat": 34.37963104248047,
      "lng": 132.42355346679688
    }
  },
  {
    "id": "09402_9",
    "name": "Balcom Motors Co.,Ltd, Okayama / BP S Okayama",
    "country": "JP",
    "city": "Okayama-City",
    "address": "3349-1, Senoo, Minami-ku, 701-0205 Okayama-City",
    "email": null,
    "phone": "086-2502111",
    "website": "https://balcom.bmw.jp/okayama",
    "coords": {
      "lat": 34.62192916870117,
      "lng": 133.8690185546875
    }
  },
  {
    "id": "09402_11",
    "name": "Balcom Motors Co.,Ltd, Shunan/BPS S",
    "country": "JP",
    "city": "Kudamatsu-city",
    "address": "6-9-14, Minami-Hanaoka, 744-0027 Kudamatsu-city",
    "email": null,
    "phone": "0833-450080",
    "website": "https://balcom.bmw.jp/shunan",
    "coords": {
      "lat": 34.0297737121582,
      "lng": 131.86383056640625
    }
  },
  {
    "id": "09423_3",
    "name": "K.K. Motoren Nagano, BPS Nagano",
    "country": "JP",
    "city": "Nagano-city",
    "address": "299-11, Minami-Nanagaike, 381-0024 Nagano-city",
    "email": null,
    "phone": "026-4805001",
    "website": "https://nagano.bmw.jp/ja/nagano_bps",
    "coords": {
      "lat": 36.64176559448242,
      "lng": 138.23765563964844
    }
  },
  {
    "id": "09439_4",
    "name": "K.K. Motoren Freude, BPS Kumamoto I nter/MINI NEXT Kumamoto",
    "country": "JP",
    "city": "Kumamoto-city",
    "address": "2-24-6, Nishibaru, Higashi-ku, 861-8029 Kumamoto-city",
    "email": null,
    "phone": "096-3862800",
    "website": "https://kumamoto.bmw.jp/ja/kumamotointer_bps",
    "coords": {
      "lat": 32.81816864013672,
      "lng": 130.75465393066406
    }
  },
  {
    "id": "09430_4",
    "name": "K.K.Motoren Iwate, BPS Morioka/MI NI NEXT Morioka",
    "country": "JP",
    "city": "Morioka-city,",
    "address": "3-13-22, Tsushidaminami,, 020-0839 Morioka-city,",
    "email": null,
    "phone": "019-6376530",
    "website": "https://iwate.bmw.jp/morioka_bps",
    "coords": {
      "lat": 39.657257080078125,
      "lng": 141.1522674560547
    }
  },
  {
    "id": "09429_12",
    "name": "K.K. Motoren Lepio, Narita/BPS Nari",
    "country": "JP",
    "city": "Narita-city",
    "address": "221-1 Namiki-cho, 286-0045 Narita-city",
    "email": null,
    "phone": "0476-202080",
    "website": "https://keiyo.bmw.jp/narita_bps",
    "coords": {
      "lat": 35.75269317626953,
      "lng": 140.30084228515625
    }
  },
  {
    "id": "09448_1",
    "name": "K.K. Alcon, HQ/BPS Yonago/MINI NEXT",
    "country": "JP",
    "city": "Yonago-city",
    "address": "215, Ryomitsuyanagi, 683-0853 Yonago-city",
    "email": null,
    "phone": "0859-303992",
    "website": "https://alcon.bmw.jp/yonago",
    "coords": {
      "lat": 35.44736099243164,
      "lng": 133.32630920410156
    }
  },
  {
    "id": "27024_3",
    "name": "YANASE Bayern Motors Co.,Ltd. BPS S etagaya",
    "country": "JP",
    "city": "Setagaya-ku",
    "address": "6-32-30, Kamiyoga, 158-0098 Setagaya-ku",
    "email": null,
    "phone": "03-54505547",
    "website": "https://yanase.bmw.jp/bps_setagaya",
    "coords": {
      "lat": 35.63728332519531,
      "lng": 139.62306213378906
    }
  },
  {
    "id": "25827_8",
    "name": "BMW Tokyo Corp., Kachidoki Service/ BPS Kachidoki/MINI NEXT Kachidoki",
    "country": "JP",
    "city": "Chuo-ku",
    "address": "5-11-8, Kachidoki, 104-0054 Chuo-ku",
    "email": null,
    "phone": "03-55603711",
    "website": "https://bmw-tokyo.bmw.jp/kachidoki_sf",
    "coords": {
      "lat": 35.655723571777344,
      "lng": 139.7712860107422
    }
  },
  {
    "id": "47974_1",
    "name": "K.K. Idex Bayern Motors, Miyazaki-C huo",
    "country": "JP",
    "city": "Miyazaki-city",
    "address": "510 Yanaginomaru, Hanagashima-cho, 880-0036 Miyazaki-city",
    "email": null,
    "phone": "0985-349366",
    "website": "https://idex.bmw.jp/ja/miyazakichuoh",
    "coords": {
      "lat": 31.958049774169922,
      "lng": 131.43531799316406
    }
  },
  {
    "id": "25828_5",
    "name": "K.K. ABE MOTORS, BMW Premium Select ion Shinagawa/MINI NEXT Shinagawa",
    "country": "JP",
    "city": "Shinagawa-ku",
    "address": "2-2-20, Higashi-shinagawa, 140-0002 Shinagawa-ku",
    "email": null,
    "phone": "03-54609666",
    "website": "https://abe.bmw.jp/bps_shinagawa",
    "coords": {
      "lat": 35.62221145629883,
      "lng": 139.7501220703125
    }
  },
  {
    "id": "24782_15",
    "name": "K.K. Motoren Glanz, BPS Urayasu/MIN I NEXT Urayasu",
    "country": "JP",
    "city": "Ichikawa-city",
    "address": "2-3-1, Arai, 272-0144 Ichikawa-city",
    "email": null,
    "phone": "047-3077800",
    "website": "https://motoren-glanz.bmw.jp/urayasu_bps",
    "coords": {
      "lat": 35.67549133300781,
      "lng": 139.89608764648438
    }
  },
  {
    "id": "27024_14",
    "name": "YANASE Bayern Motors Co.,Ltd. BPS D enenchofu",
    "country": "JP",
    "city": "Setagaya-ku",
    "address": "1-14-10, Tamagawa Denenchofu, 158-0085 Setagaya-ku",
    "email": null,
    "phone": "03-54830311",
    "website": "https://yanase.bmw.jp/bps_denenchofu",
    "coords": {
      "lat": 35.600250244140625,
      "lng": 139.6645965576172
    }
  },
  {
    "id": "33424_9",
    "name": "K.K. Motoren Hanshin, BPS Rokko-Isl and",
    "country": "JP",
    "city": "Higashinada-ku, Kobe-city",
    "address": "6-12-6, Koyochonaka, 658-0032 Higashinada-ku, Kobe-city",
    "email": null,
    "phone": "078-8575900",
    "website": "https://hanshin.bmw.jp/ja/bps_rokkoisland",
    "coords": {
      "lat": 34.68804931640625,
      "lng": 135.26829528808594
    }
  },
  {
    "id": "29103_13",
    "name": "K.K. Motoren Tomei-Yokohama, Chofu / BMW Premium Selection Chofu",
    "country": "JP",
    "city": "Chofu-city",
    "address": "2-14-1, Yagumodai, 182-0015 Chofu-city",
    "email": null,
    "phone": "042-4261212",
    "website": "https://tomeiyokohama.bmw.jp",
    "coords": {
      "lat": 35.653541564941406,
      "lng": 139.5619354248047
    }
  },
  {
    "id": "29103_14",
    "name": "K.K. Motoren Tomei-Yokohama BMW Pre mium Selection Mitsuzawa",
    "country": "JP",
    "city": "Yokohama-city",
    "address": "322-3, Okazawa-cho, Hodogaya-ku, 240-0062 Yokohama-city",
    "email": null,
    "phone": "045-6128488",
    "website": "https://tomeiyokohama.bmw.jp/ja",
    "coords": {
      "lat": 35.4735221862793,
      "lng": 139.59808349609375
    }
  },
  {
    "id": "52038_1",
    "name": "K.K. Motoren Donan,Hakodate/MINI Ha",
    "country": "JP",
    "city": "Hokuto-city",
    "address": "6-15-17, Nanaehama,, 049-0111 Hokuto-city",
    "email": null,
    "phone": "0138-496001",
    "website": "https://motoren-hakodate.bmw.jp/hakodate",
    "coords": {
      "lat": 41.823543548583984,
      "lng": 140.70538330078125
    }
  },
  {
    "id": "52940_2",
    "name": "K.K. Motoren Tokushima, BMW Premium Selection Tokushima",
    "country": "JP",
    "city": "Tokushima-city",
    "address": "2-1-1, Higashiokinosu, 770-0873 Tokushima-city",
    "email": null,
    "phone": "088-6779908",
    "website": "https://m-tokushima.bmw.jp/ja",
    "coords": {
      "lat": 34.06260299682617,
      "lng": 134.59548950195312
    }
  },
  {
    "id": "33424_4",
    "name": "K.K. Motoren Hanshin, BPS Amagasaki",
    "country": "JP",
    "city": "Amagasaki-city,",
    "address": "3-3-23, Onishi-cho,, 661-0023 Amagasaki-city,",
    "email": null,
    "phone": "06-64211777",
    "website": "https://hanshin.bmw.jp/amagasaki",
    "coords": {
      "lat": 34.7410774230957,
      "lng": 135.41168212890625
    }
  },
  {
    "id": "09415_19",
    "name": "K.K. Motoren Saitama, BPS Kawaguchi /MINI NEXT Kawaguchi",
    "country": "JP",
    "city": "Kawaguchi-city",
    "address": "1-5-16, Asahi, 332-0001 Kawaguchi-city",
    "email": null,
    "phone": "048-2228420",
    "website": "https://m-saitama.bmw.jp/kawaguchi_bps",
    "coords": {
      "lat": 35.80726623535156,
      "lng": 139.7335205078125
    }
  },
  {
    "id": "25827_10",
    "name": "BMW Tokyo Corp., BMW Aoyama Square",
    "country": "JP",
    "city": "Minato-ku",
    "address": "Yoshikawa bldg., 2-12-16,Kitaaoyama, 107-0061 Minato-ku",
    "email": null,
    "phone": "03-54118100",
    "website": "https://bmw-tokyo.bmw.jp/aoyama",
    "coords": {
      "lat": 35.670204162597656,
      "lng": 139.71649169921875
    }
  },
  {
    "id": "21127_7",
    "name": "K.K. Motoren Sendai, BPS Sendai-Min ami",
    "country": "JP",
    "city": "Sendai-city",
    "address": "2-1, Kagonose, Koriyama,Taihaku-ku, 982-0003 Sendai-city",
    "email": null,
    "phone": "022-2818980",
    "website": "https://sendai.bmw.jp/sendaiminami_bps",
    "coords": {
      "lat": 38.21310043334961,
      "lng": 140.8928680419922
    }
  },
  {
    "id": "25828_2",
    "name": "K.K. ABE MOTORS, Shinagawa Showroom",
    "country": "JP",
    "city": "Shinagwa-ku",
    "address": "3-13-6, Higashi-Shinagawa, 140-0002 Shinagwa-ku",
    "email": null,
    "phone": "03-68905611",
    "website": "https://abe.bmw.jp/shinagawa",
    "coords": {
      "lat": 35.61473083496094,
      "lng": 139.74746704101562
    }
  },
  {
    "id": "25828_1",
    "name": "K.K. ABE MOTORS, Azabu Showroom",
    "country": "JP",
    "city": "Minato-ku",
    "address": "Abe bldg. 1F, 1-10-11, Higashiazabu, 106-0044 Minato-ku",
    "email": null,
    "phone": "03-35823281",
    "website": "https://abe.bmw.jp/azabu",
    "coords": {
      "lat": 35.65678787231445,
      "lng": 139.74464416503906
    }
  },
  {
    "id": "03987_7",
    "name": "K.K. Motoren Sapporo, BPS Sapporo-H igashi/MINI NEXT Sapporo-Higashi",
    "country": "JP",
    "city": "Sapporo-city,",
    "address": "3-2-15,Higashinaebo 3jo,Higashi-ku,, 007-0803 Sapporo-city,",
    "email": null,
    "phone": "011-7801184",
    "website": "https://motoren-sapporo.bmw.jp/sapporohigashi_bps",
    "coords": {
      "lat": 43.08545684814453,
      "lng": 141.40658569335938
    }
  },
  {
    "id": "33424_12",
    "name": "K.K. Motoren Hanshin, Kobe Higashin ada Technical Center",
    "country": "JP",
    "city": "Kobe-city,",
    "address": "61-1,Fukaehamamachi,Higashinada-ku, 658-0023 Kobe-city,",
    "email": null,
    "phone": "078-4356355",
    "website": "https://hanshin.bmw.jp/kobehigashinada_tc",
    "coords": {
      "lat": 34.71253967285156,
      "lng": 135.3016815185547
    }
  },
  {
    "id": "50158_1",
    "name": "K.K. Motoren Fukushima, BMW Koriyam a/MINI Koriyama",
    "country": "JP",
    "city": "Fukuyamamachi Kubota,Koriyama-city,",
    "address": "174-1,Taroudenmae, Kubota,, 963-8071 Fukuyamamachi Kubota,Koriyama-city,",
    "email": null,
    "phone": "024-9534701",
    "website": "https://fukushima.bmw.jp/ja/koriya",
    "coords": {
      "lat": 37.40589904785156,
      "lng": 140.3968048095703
    }
  },
  {
    "id": "02692_3",
    "name": "Alster Auto K.K., BPS Ehime",
    "country": "JP",
    "city": "Matsuyama-city",
    "address": "385-2, Ido-machi, 791-1114 Matsuyama-city",
    "email": null,
    "phone": "089-9050050",
    "website": "https://ehime.bmw.jp/ehime_bps",
    "coords": {
      "lat": 33.799560546875,
      "lng": 132.78506469726562
    }
  },
  {
    "id": "24782_6",
    "name": "K.K. Motoren Glanz, Funabashi/MINI",
    "country": "JP",
    "city": "Funabashi-city",
    "address": "3-124-1, Kaijincho, 273-0022 Funabashi-city",
    "email": null,
    "phone": "047-4200700",
    "website": "https://motoren-glanz.bmw.jp/funabashi",
    "coords": {
      "lat": 35.698482513427734,
      "lng": 139.9754180908203
    }
  },
  {
    "id": "09416_1",
    "name": "Sanyo Jidosha K.K., Ise",
    "country": "JP",
    "city": "Ise-city,",
    "address": "1040, Ueji-cho,, 516-0051 Ise-city,",
    "email": null,
    "phone": "0596-220125",
    "website": "https://miechuo.bmw.jp/ise",
    "coords": {
      "lat": 34.49419021606445,
      "lng": 136.6704864501953
    }
  },
  {
    "id": "01316_8",
    "name": "Nicole Cars LLC, Shin-Yurigao ka/MINI Shin-Yurigaoka",
    "country": "JP",
    "city": "Kawasaki-city,",
    "address": "1-5-11, Katahira, Aso-ku,, 215-0023 Kawasaki-city,",
    "email": null,
    "phone": "044-9591400",
    "website": "https://nicole.bmw.jp/shinyurigaoka",
    "coords": {
      "lat": 35.59696960449219,
      "lng": 139.49942016601562
    }
  },
  {
    "id": "30295_10",
    "name": "K.K. Motoren BEING,  BMW Premium Se lection Tatebayashi",
    "country": "JP",
    "city": "Tatebayashi-city,",
    "address": "3-14-9, Matsubara,, 374-0016 Tatebayashi-city,",
    "email": null,
    "phone": "0276-501555",
    "website": null,
    "coords": {
      "lat": 36.23468017578125,
      "lng": 139.54241943359375
    }
  },
  {
    "id": "23343_7",
    "name": "K.K. Motoren TI, BPS Higashi-Osaka",
    "country": "JP",
    "city": "Higashiosaka-city",
    "address": "2-21, Shinke-Higashimachi, 577-0026 Higashiosaka-city",
    "email": null,
    "phone": "06-67849090",
    "website": "https://motoren-ti.bmw.jp/higashiosaka_bps",
    "coords": {
      "lat": 34.67473602294922,
      "lng": 135.59706115722656
    }
  },
  {
    "id": "23343_6",
    "name": "K.K. Motoren TI, Higashi-Osaka",
    "country": "JP",
    "city": "Higashi-Osaka-city,",
    "address": "1-2-7, Wakae-Nishi-Shinmachi,, 578-0944 Higashi-Osaka-city,",
    "email": null,
    "phone": "06-67287500",
    "website": "https://motoren-ti.bmw.jp/higashiosaka",
    "coords": {
      "lat": 34.66168212890625,
      "lng": 135.5977020263672
    }
  },
  {
    "id": "31886_2",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , Senri",
    "country": "JP",
    "city": "Suita-city,",
    "address": "7-1-D109-101, Tsukumodai,, 565-0862 Suita-city,",
    "email": null,
    "phone": "06-68325761",
    "website": "https://osaka.bmw.jp/senri",
    "coords": {
      "lat": 34.804927825927734,
      "lng": 135.5039520263672
    }
  },
  {
    "id": "33424_10",
    "name": "K.K. Motoren Hanshin,Takatsuki/BPS Takatsuki/MINI NEXT Takatsuki",
    "country": "JP",
    "city": "Takatsuki-city",
    "address": "1-20-10, Kawanishi-cho, 569-1133 Takatsuki-city",
    "email": null,
    "phone": "072-6828710",
    "website": "https://hanshin.bmw.jp/takatsuki",
    "coords": {
      "lat": 34.8477783203125,
      "lng": 135.6051025390625
    }
  },
  {
    "id": "02685_3",
    "name": "Elbe Auto K.K., Sakai Service",
    "country": "JP",
    "city": "Sakai-city,",
    "address": "3401, Fukai Kita-Machi, Naka-Ku,, 599-8271 Sakai-city,",
    "email": null,
    "phone": "072-2772300",
    "website": "https://elbe.bmw.jp/sakai",
    "coords": {
      "lat": 34.540077209472656,
      "lng": 135.49124145507812
    }
  },
  {
    "id": "09402_22",
    "name": "Balcom Motors Co.,Ltd, Fukuoka/BPS Balcom Fukuoka",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "1-8-10, Jigyo, Chuo-ku, 810-0064 Fukuoka-city",
    "email": null,
    "phone": "092-7370505",
    "website": "https://balcom.bmw.jp/fukuoka",
    "coords": {
      "lat": 33.588645935058594,
      "lng": 130.36630249023438
    }
  },
  {
    "id": "27024_26",
    "name": "YANASE Bayern Motors Co.,Ltd. Kurum",
    "country": "JP",
    "city": "Kurume-city,",
    "address": "1-10-58, Yamakawakumashiro,, 839-0811 Kurume-city,",
    "email": null,
    "phone": "0942-436357",
    "website": "https://yanase.bmw.jp/kurume",
    "coords": {
      "lat": 33.32032012939453,
      "lng": 130.5611572265625
    }
  },
  {
    "id": "27024_31",
    "name": "YANASE Bayern Motors Co.,Ltd. BMW P remium Selection Kurume",
    "country": "JP",
    "city": "Kurume-city",
    "address": "1-6-29 Fujimitsu, 830-0057 Kurume-city",
    "email": null,
    "phone": "0942-518200",
    "website": "https://yanase.bmw.jp/kurume_bps",
    "coords": {
      "lat": 33.285560607910156,
      "lng": 130.5152587890625
    }
  },
  {
    "id": "31886_5",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , Joto-Tsurumi",
    "country": "JP",
    "city": "Osaka-city,",
    "address": "1-8-5, Midori, Tsurumi-ku,, 538-0054 Osaka-city,",
    "email": null,
    "phone": "06-69335757",
    "website": "https://osaka.bmw.jp/jototsurumi",
    "coords": {
      "lat": 34.71125793457031,
      "lng": 135.5606231689453
    }
  },
  {
    "id": "31886_14",
    "name": "Sojitz Auto Group Osaka  Co., Ltd. , BPS/MINI NEXT Joto-Tsurumi",
    "country": "JP",
    "city": "Osaka-city",
    "address": "1-8-5, Midori, Tsurumi-ku, 538-0054 Osaka-city",
    "email": null,
    "phone": "06-69336600",
    "website": "https://osaka.bmw.jp/bpm_jototsurumi",
    "coords": {
      "lat": 34.71096420288086,
      "lng": 135.56063842773438
    }
  },
  {
    "id": "31886_17",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , BPS Himesato",
    "country": "JP",
    "city": "Osaka-city",
    "address": "3-1-29, Himesato, Nishiyodogawa-ku, 555-0025 Osaka-city",
    "email": null,
    "phone": "06-64711300",
    "website": "https://osaka.bmw.jp/bpm_shinumeda",
    "coords": {
      "lat": 34.70866012573242,
      "lng": 135.4582977294922
    }
  },
  {
    "id": "01316_12",
    "name": "Nicole Cars LLC, Ota",
    "country": "JP",
    "city": "Ota-ku",
    "address": "1-16-11, Kitamagome, 143-0021 Ota-ku",
    "email": null,
    "phone": "03-64171430",
    "website": "https://nicole.bmw.jp/ota",
    "coords": {
      "lat": 35.5994758605957,
      "lng": 139.7039794921875
    }
  },
  {
    "id": "04387_5",
    "name": "Meitetsu Auto Co.,Ltd, Kachigawa Se rvice Center",
    "country": "JP",
    "city": "Kasugai-city,",
    "address": "4-12, Kachigawa-cho,, 486-0945 Kasugai-city,",
    "email": null,
    "phone": "0568-362110",
    "website": "https://meitetsu.bmw.jp/kachigawa_sc",
    "coords": {
      "lat": 35.22686004638672,
      "lng": 136.9467010498047
    }
  },
  {
    "id": "04385_1",
    "name": "K.K. Autoplatz, Ikebukuro",
    "country": "JP",
    "city": "Toshima-Ku",
    "address": "1-23-1, Kaname-cho, 171-0043 Toshima-Ku",
    "email": null,
    "phone": "03-39564411",
    "website": "https://autoplatz.bmw.jp/ikebukuro",
    "coords": {
      "lat": 35.73432159423828,
      "lng": 139.69525146484375
    }
  },
  {
    "id": "09432_5",
    "name": "K.K. Murauchi Gaisha Center, Fuchu/ MINI Fuchu Service",
    "country": "JP",
    "city": "Fuchu-city,",
    "address": "3-11-7, Midori-cho,, 183-0006 Fuchu-city,",
    "email": null,
    "phone": "042-3353001",
    "website": "https://murauchi.bmw.jp/fuchu",
    "coords": {
      "lat": 35.670719146728516,
      "lng": 139.49188232421875
    }
  },
  {
    "id": "22309_1",
    "name": "K.K.Motoren Saga, HQ/MINI Saga",
    "country": "JP",
    "city": "Saga-city,",
    "address": "4-2-28, Hyogo-Minami,, 849-0918 Saga-city,",
    "email": null,
    "phone": "0952-222268",
    "website": "https://saga.bmw.jp/saga",
    "coords": {
      "lat": 33.261871337890625,
      "lng": 130.3184814453125
    }
  },
  {
    "id": "24782_14",
    "name": "K.K. Motoren Glanz, Urayasu",
    "country": "JP",
    "city": "Urayasu-city",
    "address": "4-2-28, Fujimi, 279-0043 Urayasu-city",
    "email": null,
    "phone": "047-3066200",
    "website": "https://motoren-glanz.bmw.jp/urayasu",
    "coords": {
      "lat": 35.64957809448242,
      "lng": 139.8904266357422
    }
  },
  {
    "id": "29103_1",
    "name": "K.K. Motoren Tomei-Yokohama, Tomei- Yokohama/MINI Tomei-Yokohama",
    "country": "JP",
    "city": "Machida-city,",
    "address": "8-19-15, Tsuruma,, 194-0004 Machida-city,",
    "email": null,
    "phone": "042-7991211",
    "website": "https://tomeiyokohama.bmw.jp/tomeiyokohama",
    "coords": {
      "lat": 35.507904052734375,
      "lng": 139.478271484375
    }
  },
  {
    "id": "33424_2",
    "name": "K.K. Motoren Hanshin, Ashiya",
    "country": "JP",
    "city": "Ashiya-city,",
    "address": "1-5, Kasuga-cho,, 659-0021 Ashiya-city,",
    "email": null,
    "phone": "0797-312622",
    "website": "https://hanshin.bmw.jp/ashiya",
    "coords": {
      "lat": 34.73399353027344,
      "lng": 135.31570434570312
    }
  },
  {
    "id": "03978_2",
    "name": "K.K. MATSUFUJI, Sasebo/MINI Sasebo",
    "country": "JP",
    "city": "Sasebo-city,",
    "address": "2787-6, Hiu-cho,, 857-1151 Sasebo-city,",
    "email": null,
    "phone": "0956-336465",
    "website": "https://matsufuji.bmw.jp/sasebo",
    "coords": {
      "lat": 33.157283782958984,
      "lng": 129.76608276367188
    }
  },
  {
    "id": "04387_3",
    "name": "Meitetsu Auto Co.,Ltd.,Nagoya Inter",
    "country": "JP",
    "city": "Nagoya-city,",
    "address": "1-1306, Kamiyashiro, Meito-Ku,, 465-0025 Nagoya-city,",
    "email": null,
    "phone": "052-7269800",
    "website": "https://meitetsu.bmw.jp/meito",
    "coords": {
      "lat": 35.17279052734375,
      "lng": 137.0065155029297
    }
  },
  {
    "id": "09417_2",
    "name": "Kokusai Kogyo K.K., Miyanomori",
    "country": "JP",
    "city": "Sapporo-city,",
    "address": "10-3-18 Miyanomori 2 Jo, Chuo-ku,, 064-0952 Sapporo-city,",
    "email": null,
    "phone": "011-6165931",
    "website": "https://kokusai-kogyo.bmw.jp/miyanomori",
    "coords": {
      "lat": 43.057559967041016,
      "lng": 141.30294799804688
    }
  },
  {
    "id": "09429_1",
    "name": "K.K. Motoren Lepio, HQ",
    "country": "JP",
    "city": "Tsuchiura-city,",
    "address": "10-2, Nagakunihigashimachi,, 300-0816 Tsuchiura-city,",
    "email": null,
    "phone": "029-8223340",
    "website": "https://ibaraki.bmw.jp/tsuchiura",
    "coords": {
      "lat": 36.0644645690918,
      "lng": 140.18505859375
    }
  },
  {
    "id": "09429_6",
    "name": "K.K. Motoren Lepio, Chiba-Kita",
    "country": "JP",
    "city": "Chiba-city",
    "address": "377-1, Sono-cho, Inage-ku, 263-0051 Chiba-city",
    "email": null,
    "phone": "043-2071500",
    "website": "https://keiyo.bmw.jp/chibakita",
    "coords": {
      "lat": 35.65236282348633,
      "lng": 140.11825561523438
    }
  },
  {
    "id": "09440_1",
    "name": "K.K. Hattori Motors, HQ Workshop",
    "country": "JP",
    "city": "Otsu-city,",
    "address": "1-10, Fujimidai,, 520-0846 Otsu-city,",
    "email": null,
    "phone": "077-5371952",
    "website": "https://shiga.bmw.jp/shiga",
    "coords": {
      "lat": 34.986881256103516,
      "lng": 135.8878631591797
    }
  },
  {
    "id": "24782_9",
    "name": "K.K. Motoren Glanz, Ichikawa/MINI I",
    "country": "JP",
    "city": "Ichikawa-city",
    "address": "1-2-3, Baraki, 272-0004 Ichikawa-city",
    "email": null,
    "phone": "047-3275050",
    "website": "https://motoren-glanz.bmw.jp/ichikawa",
    "coords": {
      "lat": 35.7071418762207,
      "lng": 139.94546508789062
    }
  },
  {
    "id": "29103_9",
    "name": "K.K. Motoren Tomei-Yokohama, Yokoha ma-Mitsuzawa",
    "country": "JP",
    "city": "Kanagawa-ku, Yokohama-City,",
    "address": "1-11, Mitsuzawa Kamimachi,, 221-0856 Kanagawa-ku, Yokohama-City,",
    "email": null,
    "phone": "045-3133311",
    "website": "https://tomeiyokohama.bmw.jp/yokohamamitsusawa",
    "coords": {
      "lat": 35.476280212402344,
      "lng": 139.60618591308594
    }
  },
  {
    "id": "30295_7",
    "name": "K.K. Motoren BEING, Ota",
    "country": "JP",
    "city": "Ota-city,",
    "address": "2791-1, Ryumai-cho,, 373-0806 Ota-city,",
    "email": null,
    "phone": "0276-466611",
    "website": "https://gunma.bmw.jp/ota",
    "coords": {
      "lat": 36.282161712646484,
      "lng": 139.41983032226562
    }
  },
  {
    "id": "31874_9",
    "name": "K.K. Motoren Kobe, Himeji Technical Center",
    "country": "JP",
    "city": "Himeji-city,",
    "address": "1-26-1, Kameyama,, 670-0973 Himeji-city,",
    "email": null,
    "phone": "079-2350039",
    "website": "https://kobe.bmw.jp/himeji_sc",
    "coords": {
      "lat": 34.807159423828125,
      "lng": 134.6724395751953
    }
  },
  {
    "id": "31874_10",
    "name": "K.K. Motoren Kobe, Port Island Tech nical Center",
    "country": "JP",
    "city": "Kobe-city,",
    "address": "8-11-2, Minatojima, Chuo-ku,, 650-0045 Kobe-city,",
    "email": null,
    "phone": "078-3045200",
    "website": "https://kobe.bmw.jp",
    "coords": {
      "lat": 34.6632194519043,
      "lng": 135.22154235839844
    }
  },
  {
    "id": "33424_5",
    "name": "K.K. Motoren Hanshin, Nishinomiya",
    "country": "JP",
    "city": "Nishinomiya-city,",
    "address": "4-3, Tsutoogo-cho,, 663-8243 Nishinomiya-city,",
    "email": null,
    "phone": "0798-373525",
    "website": "https://hanshin.bmw.jp/nishinomiya",
    "coords": {
      "lat": 34.73641586303711,
      "lng": 135.35556030273438
    }
  },
  {
    "id": "01316_4",
    "name": "Nicole Cars LLC, Nicole BMW S ervice Center",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "15-46, Kuzugaya, Tsuzuki-ku,, 224-0062 Yokohama-city,",
    "email": null,
    "phone": "045-9482500",
    "website": "https://nicole.bmw.jp/nicole_sc",
    "coords": {
      "lat": 35.5356330871582,
      "lng": 139.5633087158203
    }
  },
  {
    "id": "04387_1",
    "name": "Meitetsu Auto Co.,Ltd., Ozone",
    "country": "JP",
    "city": "Nagoya-city,",
    "address": "1-5-20, Yamada, Kita-ku,, 462-0810 Nagoya-city,",
    "email": null,
    "phone": "052-9910199",
    "website": "https://meitetsu.bmw.jp/ozone",
    "coords": {
      "lat": 35.192935943603516,
      "lng": 136.9365234375
    }
  },
  {
    "id": "04393_6",
    "name": "K.K.Motoren Shonan, Higashi-T otsuka",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "152-5, Kawakami-cho, Totsuka-ku,, 244-0805 Yokohama-city,",
    "email": null,
    "phone": "045-8290211",
    "website": "https://shonan.bmw.jp/higashitotsuka",
    "coords": {
      "lat": 35.42750930786133,
      "lng": 139.55368041992188
    }
  },
  {
    "id": "09429_10",
    "name": "K.K. Motoren Lepio, MINI Narita/MIN I NEXT Narita",
    "country": "JP",
    "city": "Narita-city",
    "address": "15-17, Iinaka, 286-0046 Narita-city",
    "email": null,
    "phone": "0476-201911",
    "website": "http://www.narita.mini.jp",
    "coords": {
      "lat": 35.75526428222656,
      "lng": 140.30181884765625
    }
  },
  {
    "id": "21547_1",
    "name": "Fuji Motoren K.K., Sanarudai",
    "country": "JP",
    "city": "Hamamatsu-city,",
    "address": "5-1-5, Sanarudai, Chuo-ku,, 432-8021 Hamamatsu-city,",
    "email": null,
    "phone": "053-4563201",
    "website": "https://fuji-motoren.bmw.jp/hamamatsu",
    "coords": {
      "lat": 34.714599609375,
      "lng": 137.70359802246094
    }
  },
  {
    "id": "50262_1",
    "name": "K.K. ALC Motoren Tokyo, Suginami sh iten",
    "country": "JP",
    "city": "Siginami-ku,",
    "address": "3-27-19, Hamadayama,, 168-0065 Siginami-ku,",
    "email": null,
    "phone": "03-33138131",
    "website": "https://alc.bmw.jp/ja/suginami",
    "coords": {
      "lat": 35.683895111083984,
      "lng": 139.628173828125
    }
  },
  {
    "id": "27024_4",
    "name": "YANASE Bayern Motors Co.,Ltd. Setag aya",
    "country": "JP",
    "city": "Setagaya-ku,",
    "address": "6-20-7, Kamiyoga,, 158-0098 Setagaya-ku,",
    "email": null,
    "phone": "03-54517011",
    "website": "https://yanase.bmw.jp/setagaya",
    "coords": {
      "lat": 35.63544464111328,
      "lng": 139.6226806640625
    }
  },
  {
    "id": "27024_7",
    "name": "YANASE Bayern Motors Co.,Ltd. Denen chofu Ikegami Service Center",
    "country": "JP",
    "city": "Ota-ku",
    "address": "2-15-16, Nakaikegami, 146-0081 Ota-ku",
    "email": null,
    "phone": "03-57475011",
    "website": "https://yanase.bmw.jp/ikegami_sc",
    "coords": {
      "lat": 35.58245086669922,
      "lng": 139.70065307617188
    }
  },
  {
    "id": "09415_2",
    "name": "K.K. Motoren Saitama, Tokoroz awa/MINI Tokorozawa",
    "country": "JP",
    "city": "Tokorozawa-city,",
    "address": "37-1, Kotesashidai,, 359-1101 Tokorozawa-city,",
    "email": null,
    "phone": "04-29281471",
    "website": "https://m-saitama.bmw.jp/tokorozawa",
    "coords": {
      "lat": 35.7931022644043,
      "lng": 139.4402618408203
    }
  },
  {
    "id": "09429_8",
    "name": "K.K. Motoren Lepio, MINI Chiba-Kita",
    "country": "JP",
    "city": "Chiba-city",
    "address": "387-8, Sono-cho, Inage-ku, 263-0051 Chiba-city",
    "email": null,
    "phone": "043-3823201",
    "website": "https://keiyo.bmw.jp",
    "coords": {
      "lat": 35.65525817871094,
      "lng": 140.1190643310547
    }
  },
  {
    "id": "03996_6",
    "name": "K.K. ALC Motoren, BMW Premium Selec tion Odawara / MINI NEXT Odawara",
    "country": "JP",
    "city": "Odawara-city",
    "address": "968-8, Sakawa,, 256-0816 Odawara-city",
    "email": null,
    "phone": "0465-461032",
    "website": "https://alc.bmw.jp/ja/bps_odawara",
    "coords": {
      "lat": 35.27975082397461,
      "lng": 139.1894989013672
    }
  },
  {
    "id": "04387_17",
    "name": "Meitetsu Auto Co.,Ltd., Tajimi",
    "country": "JP",
    "city": "Tajimi-city",
    "address": "3-1-1, Hikarigaoka, 507-0052 Tajimi-city",
    "email": null,
    "phone": "0572-200750",
    "website": "https://meitetsu.bmw.jp",
    "coords": {
      "lat": 35.348365783691406,
      "lng": 137.10499572753906
    }
  },
  {
    "id": "09399_4",
    "name": "K.K. Hattori Motor Shokai, BPS Joyo /MINI NEXT Joyo",
    "country": "JP",
    "city": "Joyo-city",
    "address": "315, Kusearauchi, 610-0102 Joyo-city",
    "email": null,
    "phone": "0774-571500",
    "website": "https://kyoto.bmw.jp/joyo_bps",
    "coords": {
      "lat": 34.861087799072266,
      "lng": 135.762451171875
    }
  },
  {
    "id": "04387_19",
    "name": "Meitetsu Auto Co.,Ltd., BPS Komaki/ MINI NEXT Komaki",
    "country": "JP",
    "city": "Komaki-city,",
    "address": "890, Oaza Mamahara shinden,, 485-0016 Komaki-city,",
    "email": null,
    "phone": "0568-757523",
    "website": "https://meitetsu.bmw.jp/komaki_bps",
    "coords": {
      "lat": 35.302555084228516,
      "lng": 136.91966247558594
    }
  },
  {
    "id": "04387_18",
    "name": "Meitetsu Auto Co.,Ltd., BPS Gifu",
    "country": "JP",
    "city": "Hashima-gun",
    "address": "7-156, Kami-injiki, Ginan-cho, 501-6001 Hashima-gun",
    "email": null,
    "phone": "058-2593303",
    "website": "https://meitetsu.bmw.jp/gifu_bps",
    "coords": {
      "lat": 35.39190673828125,
      "lng": 136.78564453125
    }
  },
  {
    "id": "03979_4",
    "name": "Motoren Niigata K.K., BPS Niigata/ MINI NEXT Niigata",
    "country": "JP",
    "city": "Niigata-city,",
    "address": "1-14-14, Dekijima, Chuo-ku,, 950-0962 Niigata-city,",
    "email": null,
    "phone": "025-2801555",
    "website": "https://niigata.bmw.jp/niigata_bps",
    "coords": {
      "lat": 37.898555755615234,
      "lng": 139.0232696533203
    }
  },
  {
    "id": "03979_3",
    "name": "Motoren Niigata K.K., Joetsu/ BPS Joetsu",
    "country": "JP",
    "city": "Jyoetsu-city",
    "address": "41-1, Oaza Teramachi, 943-0859 Jyoetsu-city",
    "email": null,
    "phone": "025-5212828",
    "website": "https://niigata.bmw.jp/joetsu",
    "coords": {
      "lat": 37.06234359741211,
      "lng": 138.25936889648438
    }
  },
  {
    "id": "02693_6",
    "name": "K.K. Motoren Aomori, BPS Hirosaki/M INI NEXT Hirosaki",
    "country": "JP",
    "city": "Hirosaki-city,",
    "address": "4-1-4, Oaza Kanda,, 036-8061 Hirosaki-city,",
    "email": null,
    "phone": "0172-267955",
    "website": "https://aomori.bmw.jp/hirosaki",
    "coords": {
      "lat": 40.6224365234375,
      "lng": 140.48854064941406
    }
  },
  {
    "id": "09406_5",
    "name": "K.K. EPM Corp., Toyama-Chuo/BPS Toy",
    "country": "JP",
    "city": "Toyama-city",
    "address": "234-1, Shimokutsuwada, Fuchumachi, 939-2716 Toyama-city",
    "email": null,
    "phone": "076-4664700",
    "website": "https://epm.bmw.jp/toyamachuo",
    "coords": {
      "lat": 36.66066360473633,
      "lng": 137.17178344726562
    }
  },
  {
    "id": "09421_1",
    "name": "K.K. Motoren Yamagata, Yamagata/MIN I Yamagata/BPS/MINI NEXT Yamagata",
    "country": "JP",
    "city": "Yamagata-city,",
    "address": "1-1-60, Shimakita,, 990-0885 Yamagata-city,",
    "email": null,
    "phone": "023-6655582",
    "website": "https://yamagata.bmw.jp/yamagata",
    "coords": {
      "lat": 38.28546142578125,
      "lng": 140.3242950439453
    }
  },
  {
    "id": "09423_2",
    "name": "K.K. Motoren Nagano, Ueda/BPS Ueda",
    "country": "JP",
    "city": "Ueda-city",
    "address": "6-18-18, Chuo, 386-0012 Ueda-city",
    "email": null,
    "phone": "0268-277750",
    "website": "https://nagano.bmw.jp/ueda",
    "coords": {
      "lat": 36.401702880859375,
      "lng": 138.26246643066406
    }
  },
  {
    "id": "09424_2",
    "name": "K.K. A-1 Auto Iwase, BPS Matsumoto/ MINI NEXT Matsumoto",
    "country": "JP",
    "city": "Matsumoto-city,",
    "address": "1-21-19, Muraimachi-Minami,, 399-0036 Matsumoto-city,",
    "email": null,
    "phone": "0263-854400",
    "website": "https://matsumoto.bmw.jp/azumino_bps",
    "coords": {
      "lat": 36.17784118652344,
      "lng": 137.9613494873047
    }
  },
  {
    "id": "09415_16",
    "name": "K.K. Motoren Saitama, BPS Ura wamisono/MINI NEXT Urawamisono",
    "country": "JP",
    "city": "Saitama-city",
    "address": "6-11-1, Misono, Midori-ku, 336-0967 Saitama-city",
    "email": null,
    "phone": "048-8122525",
    "website": "https://m-saitama.bmw.jp/urawamisono_bps",
    "coords": {
      "lat": 35.88529586791992,
      "lng": 139.73858642578125
    }
  },
  {
    "id": "24782_8",
    "name": "K.K. Motoren Glanz, Kashiwa/BPS Kas hiwa/MINI Kashiwa/MINI NEXT Kashiwa",
    "country": "JP",
    "city": "Kashiwa-city",
    "address": "8-47, Yayoi-cho, 277-0015 Kashiwa-city",
    "email": null,
    "phone": "04-71661500",
    "website": "https://motoren-glanz.bmw.jp/kashiwa",
    "coords": {
      "lat": 35.85465621948242,
      "lng": 139.9885711669922
    }
  },
  {
    "id": "23778_1",
    "name": "K.K. Motoren Tokai, HQ/BPS Nagoya-M inami",
    "country": "JP",
    "city": "Nagoya-city",
    "address": "3-8, Tatewaki-cho, Minami-ku, 457-0077 Nagoya-city",
    "email": null,
    "phone": "052-8212002",
    "website": "https://nagoya-minami.bmw.jp/nagoyaminami",
    "coords": {
      "lat": 35.094390869140625,
      "lng": 136.92864990234375
    }
  },
  {
    "id": "25827_36",
    "name": "BMW Tokyo Corp., BMW Tokyo Bay/MIN I TOKYO BAY/BPS/MINI NEXT TOKYO BAY",
    "country": "JP",
    "city": "Koto-ku",
    "address": "2-2-15, Aomi, 135-0064 Koto-ku",
    "email": null,
    "phone": "03-35993840",
    "website": "https://bmw-tokyo.bmw.jp/tokyobay",
    "coords": {
      "lat": 35.62196731567383,
      "lng": 139.77719116210938
    }
  },
  {
    "id": "31874_4",
    "name": "K.K. Motoren Kobe, BPS Kakogawa / MINI NEXT Kakogawa",
    "country": "JP",
    "city": "Kakogawa-city",
    "address": "1025, Sakamoto, Noguchi-cho, 675-0018 Kakogawa-city",
    "email": null,
    "phone": "079-4260760",
    "website": "https://kobe.bmw.jp/kakogawa_bps",
    "coords": {
      "lat": 34.75880813598633,
      "lng": 134.85035705566406
    }
  },
  {
    "id": "29103_11",
    "name": "K.K. Motoren Tomei-Yokohama, BMW Pr emium Selection Yokosuka",
    "country": "JP",
    "city": "Yokosuka-city",
    "address": "3-1, Hinode-cho, 238-0006 Yokosuka-city",
    "email": null,
    "phone": "046-8250031",
    "website": "https://tomeiyokohama.bmw.jp/yokosuka",
    "coords": {
      "lat": 35.276756286621094,
      "lng": 139.67730712890625
    }
  },
  {
    "id": "50158_2",
    "name": "K.K. Motoren Fukushima, Iwaki / BPS Iwaki / MINI Iwaki / MINI NEXT Iwak",
    "country": "JP",
    "city": "Iwaki-city,",
    "address": "1,Onahamashima Nishiya, 971-8125 Iwaki-city,",
    "email": null,
    "phone": "0246-849251",
    "website": "https://fukushima.bmw.jp/ja/iwaki",
    "coords": {
      "lat": 36.97597122192383,
      "lng": 140.87014770507812
    }
  },
  {
    "id": "47974_4",
    "name": "K.K. Idex Bayern Motors, BMW Premiu m Selection Kagoshima-Chuo",
    "country": "JP",
    "city": "Kagoshima-city",
    "address": "12-46, Higashikourimotocho, 890-0068 Kagoshima-city",
    "email": null,
    "phone": "099-2539380",
    "website": "https://idex.bmw.jp/kagoshimachuogh",
    "coords": {
      "lat": 31.553245544433594,
      "lng": 130.54852294921875
    }
  },
  {
    "id": "50262_2",
    "name": "K.K. ALC Motoren Tokyo, BMW Premium Selection Suginami",
    "country": "JP",
    "city": "Suginami-ku",
    "address": "4-14-1, Hamadayama, 168-0065 Suginami-ku",
    "email": null,
    "phone": "03-53075781",
    "website": "https://alc.bmw.jp/ja/bps_suginami",
    "coords": {
      "lat": 35.684600830078125,
      "lng": 139.62794494628906
    }
  },
  {
    "id": "22237_8",
    "name": "Weins Import Cars Co., Ltd. Minato- Mirai/MINI Minato-Mirai",
    "country": "JP",
    "city": "Yokohama-city,",
    "address": "4-5-1, Minato-Mirai, Nishi-ku,, 220-0012 Yokohama-city,",
    "email": null,
    "phone": "045-2276811",
    "website": "https://minato-mirai.bmw.jp/minatomirai",
    "coords": {
      "lat": 35.45771026611328,
      "lng": 139.62831115722656
    }
  },
  {
    "id": "23343_1",
    "name": "K.K. Motoren TI, HQ/BPS Nara-Sanjo",
    "country": "JP",
    "city": "Nara-city",
    "address": "7-26, Sanjosoegawa-cho, 630-8127 Nara-city",
    "email": null,
    "phone": "0742-358632",
    "website": "https://motoren-ti.bmw.jp/nara",
    "coords": {
      "lat": 34.67989730834961,
      "lng": 135.81202697753906
    }
  },
  {
    "id": "20176_7",
    "name": "Sojitz Auto Group Tokyo Co., Ltd. B MW Premium Selection Edogawa",
    "country": "JP",
    "city": "Edogawa-ku",
    "address": "11-22, Osugi 1-chome, 132-0022 Edogawa-ku",
    "email": null,
    "phone": "03-56070316",
    "website": "https://sojitz-tokyo.bmw.jp/ja/edogawa_bps",
    "coords": {
      "lat": 35.70301055908203,
      "lng": 139.87872314453125
    }
  },
  {
    "id": "09429_5",
    "name": "K.K. Motoren Lepio, Chiba-Chuo/MIN I Chiba/BPS/MINI NEXT Chiba-Chuo",
    "country": "JP",
    "city": "Chiba-city",
    "address": "5-10-7, Suehiro, Chuo-ku, 260-0843 Chiba-city",
    "email": null,
    "phone": "043-3052111",
    "website": "https://keiyo.bmw.jp/chibachuuou",
    "coords": {
      "lat": 35.58658218383789,
      "lng": 140.1304473876953
    }
  },
  {
    "id": "09429_15",
    "name": "K.K. Motoren Lepio, BMW Premium Sel ection Kisarazu/MINI NEXT Kisarazu",
    "country": "JP",
    "city": "Kisarazu-city",
    "address": "1-10-3, Kaneda-Higashi, 292-0009 Kisarazu-city",
    "email": null,
    "phone": "0438-412020",
    "website": "https://keiyo.bmw.jp/ja/kisarazu_bps",
    "coords": {
      "lat": 35.43840408325195,
      "lng": 139.92794799804688
    }
  },
  {
    "id": "09437_1",
    "name": "Motoren Fukui K.K., HQ/BPS Fukui/MI NI Fukui/MINI NEXT Fukui",
    "country": "JP",
    "city": "Fukui-city",
    "address": "Aoi HQ Bldg. 1F, 4-44-1, Ninomiya, 910-0015 Fukui-city",
    "email": null,
    "phone": "0776-278320",
    "website": "https://fukui.bmw.jp/fukui",
    "coords": {
      "lat": 36.08702850341797,
      "lng": 136.20907592773438
    }
  },
  {
    "id": "09432_3",
    "name": "K.K. Murauchi Gaisha Center, Kunita chi/BPS Kunitachi",
    "country": "JP",
    "city": "Kunitachi-city",
    "address": "403-1, Yaho, 186-0011 Kunitachi-city",
    "email": null,
    "phone": "042-5800540",
    "website": "https://murauchi.bmw.jp/kunitachi",
    "coords": {
      "lat": 35.67607116699219,
      "lng": 139.4456024169922
    }
  },
  {
    "id": "09448_3",
    "name": "K.K. Alcon, Tottori/BPS Tottori/MIN I Tottori/MINI NEXT Tottori",
    "country": "JP",
    "city": "Tottori-city",
    "address": "3-6, Chiyomi, 680-0911 Tottori-city",
    "email": null,
    "phone": "0857-312814",
    "website": "https://alcon.bmw.jp/tottori",
    "coords": {
      "lat": 35.5172233581543,
      "lng": 134.20175170898438
    }
  },
  {
    "id": "09435_2",
    "name": "K.K. Eins Motors, BPS Yamana shi",
    "country": "JP",
    "city": "Nakakoma-gun",
    "address": "2710-1, Saijyo, Showa-machi, 409-3866 Nakakoma-gun",
    "email": null,
    "phone": "055-2685515",
    "website": "https://yamanashi.bmw.jp/ja/yamanashi_bps",
    "coords": {
      "lat": 35.64375686645508,
      "lng": 138.53585815429688
    }
  },
  {
    "id": "09429_4",
    "name": "K.K. Motoren Lepio, BPS Moriya",
    "country": "JP",
    "city": "Moriya-city",
    "address": "3-1-2, Misono, 302-0124 Moriya-city",
    "email": null,
    "phone": "0297-447788",
    "website": "https://ibaraki.bmw.jp/moriya_bps",
    "coords": {
      "lat": 35.92447280883789,
      "lng": 139.9994659423828
    }
  },
  {
    "id": "09432_1",
    "name": "K.K. Murauchi Gaisha Center, MINI Hachioji",
    "country": "JP",
    "city": "Hachioji-city,",
    "address": "787, Sanyumachi,, 192-0012 Hachioji-city,",
    "email": null,
    "phone": "042-6912302",
    "website": "https://murauchi.bmw.jp/hachioji_sr",
    "coords": {
      "lat": 35.6784782409668,
      "lng": 139.33538818359375
    }
  },
  {
    "id": "09442_1",
    "name": "M-Line Auto K.K., HQ/BPS Kagawa",
    "country": "JP",
    "city": "Takamatsu-city",
    "address": "1136-17, Matsunawa-cho, 760-0079 Takamatsu-city",
    "email": null,
    "phone": "087-8698601",
    "website": "https://kagawa.bmw.jp/kagawa",
    "coords": {
      "lat": 34.312347412109375,
      "lng": 134.06118774414062
    }
  },
  {
    "id": "04385_5",
    "name": "K.K. Autoplatz, BPS Nerima",
    "country": "JP",
    "city": "Nerima-ku,",
    "address": "4-20-5, Takanodai,, 177-0033 Nerima-ku,",
    "email": null,
    "phone": "03-39952877",
    "website": "https://autoplatz.bmw.jp/ja/nerima_bps",
    "coords": {
      "lat": 35.74909210205078,
      "lng": 139.61676025390625
    }
  },
  {
    "id": "03987_5",
    "name": "K.K. Motoren Sapporo, Sapporo-Higas hi",
    "country": "JP",
    "city": "Sapporo-city,",
    "address": "3-2-1,Higashinaebo 5jo,Higashi-ku,, 007-0805 Sapporo-city,",
    "email": null,
    "phone": "011-7841184",
    "website": "https://motoren-sapporo.bmw.jp/sapporohigashi",
    "coords": {
      "lat": 43.088375091552734,
      "lng": 141.40830993652344
    }
  },
  {
    "id": "09417_1",
    "name": "Kokusai Kogyo K.K., Tsukisamu",
    "country": "JP",
    "city": "Toyohira-ku,Sapporo-city,",
    "address": "11-4-1,Tsukisamuchuo-dori,, 062-0020 Toyohira-ku,Sapporo-city,",
    "email": null,
    "phone": "011-8536891",
    "website": "https://kokusai-kogyo.bmw.jp/ja/tsukisamu",
    "coords": {
      "lat": 43.02362823486328,
      "lng": 141.40150451660156
    }
  },
  {
    "id": "09399_3",
    "name": "K.K. Hattori Motor Shokai, Kyoto Mi nami",
    "country": "JP",
    "city": "Kyoto-city,",
    "address": "3,Takedafukenokawa-cho,Fushimi-ku,, 612-8454 Kyoto-city,",
    "email": null,
    "phone": "075-6044600",
    "website": "https://kyoto.bmw.jp/kyotominami",
    "coords": {
      "lat": 34.945953369140625,
      "lng": 135.74911499023438
    }
  },
  {
    "id": "21127_1",
    "name": "K.K. Motoren Sendai, HQ/BPS Sendai",
    "country": "JP",
    "city": "Sendai-city",
    "address": "98-1,Shinmei, Nakano,Miyagino-ku, 983-0013 Sendai-city",
    "email": null,
    "phone": "022-3878770",
    "website": "https://sendai.bmw.jp/sendai",
    "coords": {
      "lat": 38.27848815917969,
      "lng": 140.9807586669922
    }
  },
  {
    "id": "53920_2",
    "name": "K.K. ONE Motoren, Narumi",
    "country": "JP",
    "city": "Nagoya-city",
    "address": "19, Horogo, Narumi-cho, Midori-ku, 458-0801 Nagoya-city",
    "email": null,
    "phone": "052-6233700",
    "website": "https://one.bmw.jp/ja/narumi",
    "coords": {
      "lat": 35.07459259033203,
      "lng": 136.9508819580078
    }
  },
  {
    "id": "53920_4",
    "name": "K.K. ONE Motoren, Yagoto",
    "country": "JP",
    "city": "Nagoya-city",
    "address": "10, Ishizaka, Hirojicho, Showa-ku, 466-0834 Nagoya-city",
    "email": null,
    "phone": "052-8393100",
    "website": "https://one.bmw.jp/ja/yagoto",
    "coords": {
      "lat": 35.13652038574219,
      "lng": 136.96153259277344
    }
  },
  {
    "id": "04383_3",
    "name": "K.K. Sun Motoren,BPS Ichinomiya/MIN I NEXT Ichinomiya/Kariyasuga Servic",
    "country": "JP",
    "city": "Yamato-cho,Ichinomiya-city,",
    "address": "45, Higuchikami Kariyasuka,, 491-0934 Yamato-cho,Ichinomiya-city,",
    "email": null,
    "phone": "0586-450532",
    "website": "http://www.ichinomiya.mini.jp",
    "coords": {
      "lat": 35.28915023803711,
      "lng": 136.78001403808594
    }
  },
  {
    "id": "01316_7",
    "name": "Nicole Cars LLC, Aoba-Miyamae",
    "country": "JP",
    "city": "Kawasaki-city,",
    "address": "3-2-1, Arima, Miyamae-ku,, 216-0003 Kawasaki-city,",
    "email": null,
    "phone": "044-8708500",
    "website": "https://nicole.bmw.jp/aobamiyamae",
    "coords": {
      "lat": 35.57756423950195,
      "lng": 139.58445739746094
    }
  },
  {
    "id": "21547_2",
    "name": "Fuji Motoren K.K., BMW Premium Sele ction Hamamatsu",
    "country": "JP",
    "city": "Hamamatsu-city",
    "address": "480, Nakada-cho, Chuo-ku, 435-0057 Hamamatsu-city",
    "email": null,
    "phone": "053-4017800",
    "website": "https://fuji-motoren.bmw.jp/ja/bps_hamamatsu",
    "coords": {
      "lat": 34.73506164550781,
      "lng": 137.75929260253906
    }
  },
  {
    "id": "09417_3",
    "name": "Kokusai Kogyo K.K., BPS Sapporo",
    "country": "JP",
    "city": "Sapporo-city",
    "address": "14-1-4, Kita1jo-Nishi, Chuo-ku, 060-0001 Sapporo-city",
    "email": null,
    "phone": "011-7115931",
    "website": "https://kokusai-kogyo.bmw.jp/sapporo_bps",
    "coords": {
      "lat": 43.060020446777344,
      "lng": 141.3351287841797
    }
  },
  {
    "id": "31886_4",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , Shin-Umeda",
    "country": "JP",
    "city": "Osaka-city,",
    "address": "7-20-1, Fukushima, Fukushima-ku,, 553-0003 Osaka-city,",
    "email": null,
    "phone": "06-64580671",
    "website": "https://osaka.bmw.jp/shinumeda",
    "coords": {
      "lat": 34.7002067565918,
      "lng": 135.4861602783203
    }
  },
  {
    "id": "33424_6",
    "name": "K.K. Motoren Hanshin, BPS Minoo/MIN I NEXT Minoo",
    "country": "JP",
    "city": "Minoo-city",
    "address": "Isao Kataoka, 562-0044 Minoo-city",
    "email": null,
    "phone": "072-7218505",
    "website": "https://hanshin.bmw.jp/bps_minoh",
    "coords": {
      "lat": 34.81333923339844,
      "lng": 135.45875549316406
    }
  },
  {
    "id": "02685_2",
    "name": "Elbe Auto K.K., Kaizuka/BPS Kaizu",
    "country": "JP",
    "city": "Kaizuka-city",
    "address": "285-1, Issai, 597-0082 Kaizuka-city",
    "email": null,
    "phone": "072-4382300",
    "website": "https://elbe.bmw.jp/kaizuka",
    "coords": {
      "lat": 34.432701110839844,
      "lng": 135.35914611816406
    }
  },
  {
    "id": "09399_8",
    "name": "K.K. Hattori Motor Shokai, Hirakata /BPS Hirakata",
    "country": "JP",
    "city": "Hirakata-city",
    "address": "1-20, Doyamahigashimachi, 573-0006 Hirakata-city",
    "email": null,
    "phone": "072-8907611",
    "website": "https://kyoto.bmw.jp/hirakata",
    "coords": {
      "lat": 34.814640045166016,
      "lng": 135.671875
    }
  },
  {
    "id": "09402_28",
    "name": "Balcom Motors Co.,Ltd, Fukuoka-Higa shi / BPS Fukuoka-Higashi",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "2-8-22, Kashiiekimae, Higashi-ku, 813-0013 Fukuoka-city",
    "email": null,
    "phone": "092-4050877",
    "website": "https://balcom.bmw.jp/fukuoka-higashi",
    "coords": {
      "lat": 33.65964126586914,
      "lng": 130.4386444091797
    }
  },
  {
    "id": "09402_23",
    "name": "Balcom Motors Co.,Ltd, Hakata/BPS B alcom Hakata",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "1-3-17, Higashi-Hie, Hakata-ku, 812-0007 Fukuoka-city",
    "email": null,
    "phone": "092-4776565",
    "website": "https://balcom.bmw.jp/hakata",
    "coords": {
      "lat": 33.59032440185547,
      "lng": 130.4286651611328
    }
  },
  {
    "id": "27024_30",
    "name": "YANASE Bayern Motors Co.,Ltd. BMW P remium SelectionFukuoka-Nishi",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "4-39-11, Kamo, Sawara-ku, 814-0164 Fukuoka-city",
    "email": null,
    "phone": "092-8652421",
    "website": "https://yanase.bmw.jp/fukuokanishi_bps",
    "coords": {
      "lat": 33.55076217651367,
      "lng": 130.3379669189453
    }
  },
  {
    "id": "27024_27",
    "name": "YANASE Bayern Motors Co.,Ltd. Fukuo ka-Nishi",
    "country": "JP",
    "city": "Fukuoka-city",
    "address": "6-2-30, Hara, Sawara-ku, 814-0022 Fukuoka-city",
    "email": null,
    "phone": "092-5108277",
    "website": "https://yanase.bmw.jp/fukuokanishi",
    "coords": {
      "lat": 33.56699752807617,
      "lng": 130.345458984375
    }
  },
  {
    "id": "31886_16",
    "name": "Sojitz Auto Group Osaka Co., Ltd. , Technical Center",
    "country": "JP",
    "city": "Osaka-city,",
    "address": "5-14-13 Mitejima, Nishiyodogawa-ku,, 555-0012 Osaka-city,",
    "email": null,
    "phone": "06-49671155",
    "website": "https://osaka.bmw.jp/shinumeda_sf",
    "coords": {
      "lat": 34.722049713134766,
      "lng": 135.45639038085938
    }
  },
  {
    "id": "34188_2",
    "name": "Willplus Motoren Corporation, Kokur a/BPS Kokura",
    "country": "JP",
    "city": "Kokurakita-ku, Kitakyushu-city",
    "address": "1-1-25, Tatemachi, 803-0818 Kokurakita-ku, Kitakyushu-city",
    "email": null,
    "phone": "093-5911166",
    "website": "https://willplus.bmw.jp/kokura",
    "coords": {
      "lat": 33.88740158081055,
      "lng": 130.87069702148438
    }
  },
  {
    "id": "01631_10",
    "name": "Kolon Motors Gwangju GC FF Showroom and Workshop",
    "country": "KR",
    "city": "Gwangju",
    "address": "72, Jukbong-daero, Seo-gu, 61932 Gwangju",
    "email": "bmwsales@kolon.com",
    "phone": "+82-62-5217301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.15965270996094,
      "lng": 126.88420104980469
    }
  },
  {
    "id": "01631_35",
    "name": "Kolon Motors Opo WS Workshop",
    "country": "KR",
    "city": "Gwangju-si",
    "address": "86-5, Sinhyeon-ro, Opo-eup,, 12771 Gwangju-si",
    "email": "jaehyun@kolon.com",
    "phone": "82-31-7267301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.35948181152344,
      "lng": 127.15676879882812
    }
  },
  {
    "id": "01631_45",
    "name": "Kolon Motors Daejeon YS. WS Workshop",
    "country": "KR",
    "city": "Daejeon",
    "address": "38-6, Wonsinheungnam-ro 12beon-gil,, 34195 Daejeon",
    "email": "jaehyun@kolon.com",
    "phone": "82-42-8267201",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.333290100097656,
      "lng": 127.34014892578125
    }
  },
  {
    "id": "25230_22",
    "name": "Bavarian Motors Goyang SR Showroom",
    "country": "KR",
    "city": "Goyang-si",
    "address": "1972-5, Goyangdae-ro, Deogyang-gu, 10596 Goyang-si",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-69587501",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.64635467529297,
      "lng": 126.89801025390625
    }
  },
  {
    "id": "25230_20",
    "name": "Bavarian Motors Siheung Homeplus FL Fastlane Service Center",
    "country": "KR",
    "city": "Seoul",
    "address": "201, Siheung-daero, Geumcheon-gu, 08632 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-8087401",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.45178985595703,
      "lng": 126.90074920654297
    }
  },
  {
    "id": "25233_5",
    "name": "BMW Dongsung Motors Jinju WS Workshop",
    "country": "KR",
    "city": "Jinju-si",
    "address": "123, Naedong-ro, Naedong-myeon, 52849 Jinju-si",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-55-7487301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.15562438964844,
      "lng": 128.0808868408203
    }
  },
  {
    "id": "25233_13",
    "name": "BMW Dongsung Motors BusanJungang SR Showroom",
    "country": "KR",
    "city": "Busan",
    "address": "73 Jungang-daero, Jung-gu, 48929 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-7157301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.10417938232422,
      "lng": 129.03604125976562
    }
  },
  {
    "id": "25235_5",
    "name": "BMW National Jeonju UC Used Car Showroom",
    "country": "KR",
    "city": "Jeonju-si",
    "address": "234, Ongoeul-ro, Deokjin-gu, 54884 Jeonju-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-63-2128301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 35.840023040771484,
      "lng": 127.10004425048828
    }
  },
  {
    "id": "25235_10",
    "name": "National Motors Anseong StarfieldSR Showroom",
    "country": "KR",
    "city": "Anseong-si",
    "address": "39, 3980, Seodong-daero, Gongdo-eup, 17563 Anseong-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-63-6567301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 36.99475860595703,
      "lng": 127.14722442626953
    }
  },
  {
    "id": "26986_1",
    "name": "BMW Deutsch Motors Wonju FF Showroom and Workshop",
    "country": "KR",
    "city": "Wonju-si",
    "address": "2539, Bugwon-ro, 26341 Wonju-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-33-7347301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.371036529541016,
      "lng": 127.9410171508789
    }
  },
  {
    "id": "26986_19",
    "name": "BMW Deutsch Motors Songpa SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "251, Baekjegobun-ro, Songpa-gu, 05604 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-4167301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.502864837646484,
      "lng": 127.0944595336914
    }
  },
  {
    "id": "28261_11",
    "name": "BMW Handok Motors Gwangju Sangmu FF Showroom and Workshop(FLS)",
    "country": "KR",
    "city": "Gwangju",
    "address": "855, Sangmu-daero, Seo-gu, 61964 Gwangju",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-62-3827301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 35.150123596191406,
      "lng": 126.85552215576172
    }
  },
  {
    "id": "28261_7",
    "name": "BMW Handok Motors Suwon FF UC Showroom and Workshop",
    "country": "KR",
    "city": "Yongin-si",
    "address": "266 Joongbudaero, Kiheung-gu, 17095 Yongin-si",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-31-2237301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.269718170166016,
      "lng": 127.09713745117188
    }
  },
  {
    "id": "01631_1",
    "name": "Kolon Motors Gangnam SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "301, Dosan-daero, Gangnam-gu, 06021 Seoul",
    "email": "bmwsales@kolon.com",
    "phone": "82-2-5467301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.52198028564453,
      "lng": 127.03410339355469
    }
  },
  {
    "id": "01631_13",
    "name": "Kolon Motors Gyodae WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "1596-8, Seocho-dong, Seocho-gu, 06652 Seoul",
    "email": "jaehyun@kolon.com",
    "phone": "+82-2-5863331",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.487274169921875,
      "lng": 127.01260375976562
    }
  },
  {
    "id": "01631_17",
    "name": "Kolon Motors Daegu WS Workshop",
    "country": "KR",
    "city": "Daegu",
    "address": "104-2, Dongho-dong, Dong-gu, 41078 Daegu",
    "email": "kodol@kolon.com",
    "phone": "82-53-5597301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.86984634399414,
      "lng": 128.71551513671875
    }
  },
  {
    "id": "01631_16",
    "name": "Kolon Motors Gwangju WS Workshop",
    "country": "KR",
    "city": "Gwangju",
    "address": "261-9, Songha-dong, Nam-gu, 61738 Gwangju",
    "email": "jaehyun@kolon.com",
    "phone": "82-62-6757301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.11149978637695,
      "lng": 126.88079833984375
    }
  },
  {
    "id": "01631_24",
    "name": "Kolon Motors Daechi WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "340, Yeongdong-daero, Gangnam-gu,, 06177 Seoul",
    "email": "jaehyun@kolon.com",
    "phone": "82-2-5497401",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.50505447387695,
      "lng": 127.06587219238281
    }
  },
  {
    "id": "01631_43",
    "name": "Kolon Motors Bucheon SR Showroom",
    "country": "KR",
    "city": "Bucheon-si",
    "address": "96, Gyeongin-ro, 14727 Bucheon-si",
    "email": "endugu@kolon.com",
    "phone": "82-32-6547301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.4833984375,
      "lng": 126.7657241821289
    }
  },
  {
    "id": "25230_3",
    "name": "Bavarian Motors Mokdong SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "210, Mokdongdong-ro, Yangcheon-gu, 08005 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-26497301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.52418899536133,
      "lng": 126.8715591430664
    }
  },
  {
    "id": "25233_17",
    "name": "Dongsung Motors UlsanJJ Lotte FLS Fastlane Service Center",
    "country": "KR",
    "city": "Ulsan",
    "address": "64, Jinjangyutong-ro, Buk-gu, 44248 Ulsan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-52-7028361",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.57609939575195,
      "lng": 129.3593292236328
    }
  },
  {
    "id": "25233_20",
    "name": "Dongsung Motors Sasang FF SR, WS",
    "country": "KR",
    "city": "Busan",
    "address": "163 Gayadae-ro Sasang-gu, 46985 Busan",
    "email": "dsmain@bmwdongsung.co.kr",
    "phone": "82-51-7127307",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.149845123291016,
      "lng": 128.990478515625
    }
  },
  {
    "id": "25237_12",
    "name": "BMW Samchully Motors Ansan WS Workshop",
    "country": "KR",
    "city": "Ansan",
    "address": "24, Seonjin 6-gil, Sangrok-gu, 15633 Ansan",
    "email": "aftersalesas@sclmotors.co.kr",
    "phone": "82-31-80688401",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.28135299682617,
      "lng": 126.84558868408203
    }
  },
  {
    "id": "26986_35",
    "name": "Deutsch Motors Namyangju FF Showroom, Workshop",
    "country": "KR",
    "city": "Namyangju-si",
    "address": "25-29 DasanJungang-ro 19beon-gil, 12248 Namyangju-si",
    "email": "deutsch.invoices@deutschmotors.com",
    "phone": null,
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.61376953125,
      "lng": 127.1544418334961
    }
  },
  {
    "id": "28261_5",
    "name": "BMW Handok Motors Seocho FF Showroom and Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "72, Banpo-daero, Seocho-gu, 06652 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-5950123",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.48693084716797,
      "lng": 127.01056671142578
    }
  },
  {
    "id": "01631_38",
    "name": "Kolon Motors DaeguSuseong FL Fastlane Workshop",
    "country": "KR",
    "city": "Daegu",
    "address": "4-4 Sang-dong, Suseong-gu, 42160 Daegu",
    "email": "jaehyun@kolon.com",
    "phone": "82-53-768-7301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.84032440185547,
      "lng": 128.61355590820312
    }
  },
  {
    "id": "01631_46",
    "name": "Kolon Motors Bucheon WS Workshop",
    "country": "KR",
    "city": "Bucheon-si",
    "address": "26, Sinheung-ro 441beon-gil, 14451 Bucheon-si",
    "email": "jaehyun@kolon.com",
    "phone": "82-32-6767301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.523704528808594,
      "lng": 126.7745590209961
    }
  },
  {
    "id": "25230_23",
    "name": "Bavarian Motors Goyang IKEA FL Fastlane Service Center",
    "country": "KR",
    "city": "Goyang-si Deokyang-gu",
    "address": "Kwonyuldae-ro 420, 10551 Goyang-si Deokyang-gu",
    "email": "gy.ikea.ws@bavarian.co.kr",
    "phone": null,
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.62995910644531,
      "lng": 126.86297607421875
    }
  },
  {
    "id": "25233_6",
    "name": "Dongsung Motors Ulsan SR WS Showroom and Workshop",
    "country": "KR",
    "city": "Ulsan",
    "address": "147, Dotjil-ro, Nam-gu, 44694 Ulsan",
    "email": "dkkim@bmwdongsung.co.kr",
    "phone": "82-52-2609700",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.540611267089844,
      "lng": 129.32162475585938
    }
  },
  {
    "id": "25233_7",
    "name": "BMW Dongsung Motors Pohang FF Showroom and Workshop",
    "country": "KR",
    "city": "Pohang-si",
    "address": "569, Saecheonnyeon-daero, Buk-gu, 37700 Pohang-si",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-54-2827301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 36.02505111694336,
      "lng": 129.35255432128906
    }
  },
  {
    "id": "25233_16",
    "name": "Dongsung Motors Myeongji StarFld SR Showroom",
    "country": "KR",
    "city": "Busan",
    "address": "168, Myeongjigukje 6-ro, Gangseo-gu, 46726 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-9000090",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.092864990234375,
      "lng": 128.91819763183594
    }
  },
  {
    "id": "25237_1",
    "name": "BMW Samchully Motors Cheongju SR Showroom",
    "country": "KR",
    "city": "Cheongju-si",
    "address": "1643, 2sunhwan-ro, Nami-myeon, 28632 Cheongju-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-43-2693002",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 36.600826263427734,
      "lng": 127.46179962158203
    }
  },
  {
    "id": "25235_4",
    "name": "BMW National Mortors Gunsan FF Connected Center",
    "country": "KR",
    "city": "Gunsan-si",
    "address": "344 Beonyeong-ro, 54070 Gunsan-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-63-4517301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 35.963043212890625,
      "lng": 126.75495147705078
    }
  },
  {
    "id": "25235_8",
    "name": "BMWNational Motors Pyeongtaek WS UC",
    "country": "KR",
    "city": "Anseong-si",
    "address": "1797, Cheongwon-ro, Wongok-myeon, 17556 Anseong-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-31-6587301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 37.04112243652344,
      "lng": 127.11956787109375
    }
  },
  {
    "id": "25237_5",
    "name": "BMW Samchully Motors Cheonan UC Used Car Showroom",
    "country": "KR",
    "city": "Cheonan-si",
    "address": "1271, Cheonan-daero, Seobuk-gu, 31080 Cheonan-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-41-18338401",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 36.854713439941406,
      "lng": 127.15372467041016
    }
  },
  {
    "id": "25237_2",
    "name": "BMW Samchully Motors Cheongju WS Workshop",
    "country": "KR",
    "city": "Cheongju-si",
    "address": "15, Garosu-ro 754beon-gil, 28370 Cheongju-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-43-2367501",
    "website": "https://www.samchullymotors.co.kr/",
    "coords": {
      "lat": 36.61985397338867,
      "lng": 127.38325500488281
    }
  },
  {
    "id": "25237_10",
    "name": "BMW Samchully Motors Sejong FF SR, WS",
    "country": "KR",
    "city": "Sejong-si",
    "address": "650, Janggi-ro, Janggun-myeon, 30054 Sejong-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-44-4103200",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 36.489402770996094,
      "lng": 127.21002197265625
    }
  },
  {
    "id": "26986_17",
    "name": "Deutsch Motors Jeju SR Showroom",
    "country": "KR",
    "city": "Jeju-si",
    "address": "120, Yeonsam-ro, 63145 Jeju-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-64-7577601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 33.49289321899414,
      "lng": 126.50518035888672
    }
  },
  {
    "id": "26986_29",
    "name": "Deutsch Motors Jeju WS Workshop",
    "country": "KR",
    "city": "Jeju-si",
    "address": "66-2, Donghwa-ro, 63300 Jeju-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-64-7577601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 33.51453399658203,
      "lng": 126.57254028320312
    }
  },
  {
    "id": "26986_30",
    "name": "Deutsch Motors B/M SuwonAutoworldFF Showroom, UC, and Workshop",
    "country": "KR",
    "city": "Suwon-si",
    "address": "308-5, Gwonseon-ro, Gwonseon-gu, 16602 Suwon-si",
    "email": "deutsch.invoices@deutschmotors.com",
    "phone": "82-31-51737000",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.258155822753906,
      "lng": 126.98725891113281
    }
  },
  {
    "id": "01631_34",
    "name": "Kolon Motors Janganpyung UC Used Car Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "96, Jadongchasijang 1-gil, 04808 Seoul",
    "email": "jaehyun@kolon.com",
    "phone": "82-2-22147301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.55989074707031,
      "lng": 127.06831359863281
    }
  },
  {
    "id": "25230_13",
    "name": "Bavarian Motors Gimpo UC used car showroom",
    "country": "KR",
    "city": "Gimpo-si",
    "address": "45, Arayuk-ro 152beon-gil, 10135 Gimpo-si",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-16887601",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.603946685791016,
      "lng": 126.79776763916016
    }
  },
  {
    "id": "01631_42",
    "name": "Kolon Motors Bucheon UC Used Car Showroom",
    "country": "KR",
    "city": "Bucheon-si",
    "address": "450, Songnae-daero,, 14449 Bucheon-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-32-6547301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.52296447753906,
      "lng": 126.76133728027344
    }
  },
  {
    "id": "01631_4",
    "name": "Kolon Motors Samseong SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "301, Yeongdong-daero, Gangnam-gu, 06189 Seoul",
    "email": "bmwsales@kolon.com",
    "phone": "82-2-5687301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.50143051147461,
      "lng": 127.06671905517578
    }
  },
  {
    "id": "01631_14",
    "name": "Kolon Motors Seongsan WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "589, Seongsan-dong, Mapo-gu, 03939 Seoul",
    "email": "sseockk@kolon.com",
    "phone": "82-2-3757301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.56658935546875,
      "lng": 126.90388488769531
    }
  },
  {
    "id": "25230_1",
    "name": "Bavarian Motors Incheon SR Showroom",
    "country": "KR",
    "city": "Incheon",
    "address": "675, Inju-daero, Namdong-gu, 21564 Incheon",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-32-4297301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.449703216552734,
      "lng": 126.7120590209961
    }
  },
  {
    "id": "25230_11",
    "name": "Bavarian Motors Driving Center WS Workshop",
    "country": "KR",
    "city": "Incheon",
    "address": "136, Gonghangdong-ro, Jung-gu,, 22379 Incheon",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-32-4227301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.463829040527344,
      "lng": 126.48448944091797
    }
  },
  {
    "id": "25230_19",
    "name": "Bavarian Motors Incheon Gyeyang FF SR, WS",
    "country": "KR",
    "city": "Incheon",
    "address": "6, Seounsandan-ro 2-gil, Gyeyang-gu, 21072 Incheon",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-32-7217401",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.5321159362793,
      "lng": 126.75637817382812
    }
  },
  {
    "id": "25233_2",
    "name": "Dongsung Motors Seomyun WS Workshop",
    "country": "KR",
    "city": "Busan",
    "address": "135, Dongseong-ro, Busanjin-gu, 47243 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-8197301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.160545349121094,
      "lng": 129.06422424316406
    }
  },
  {
    "id": "25230_15",
    "name": "BMW Bavarian Motors Jayuro FF Showroom and Workshop",
    "country": "KR",
    "city": "Goyang-si",
    "address": "56-18, Beopgot-gil 115beon-gil, 10203 Goyang-si",
    "email": "bavarian@bavarian.co.kr",
    "phone": "+82-31-9947301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.660987854003906,
      "lng": 126.72321319580078
    }
  },
  {
    "id": "26986_2",
    "name": "Deutsch Motors Dongdaemun WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "91, Gomisul-ro, Dongdaemun-gu, 02622 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-22447601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.56493377685547,
      "lng": 127.05662536621094
    }
  },
  {
    "id": "26986_18",
    "name": "BMW Deutsch Motors Jamsil SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "340, Olympic-ro, Songpa-gu, 05542 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-4197301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.51556396484375,
      "lng": 127.1080093383789
    }
  },
  {
    "id": "28261_1",
    "name": "BMW Handok Motors Bangbae FF Showroom and Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "218, Bangbae-ro, Seocho-gu, 06585 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-34770123",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.49273681640625,
      "lng": 126.9908676147461
    }
  },
  {
    "id": "01631_23",
    "name": "Kolon Motors Bundang FF Showroom and Workshop",
    "country": "KR",
    "city": "Seongnam-si",
    "address": "2, Seohyeon-ro 429beon-gil, 13579 Seongnam-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-31-7167401",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.37435531616211,
      "lng": 127.14453887939453
    }
  },
  {
    "id": "01631_40",
    "name": "Kolon Motors Gumi CC Connected Center",
    "country": "KR",
    "city": "Gumi-si",
    "address": "198, Gumi-daero, 39347 Gumi-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-54-4647301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.104393005371094,
      "lng": 128.36351013183594
    }
  },
  {
    "id": "25233_1",
    "name": "Dongsung Motors Haeundae SR Showroom",
    "country": "KR",
    "city": "Busan",
    "address": "5, Haeundaehaebyeon-ro 265beon-gil, 48094 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-7317301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.1600456237793,
      "lng": 129.16036987304688
    }
  },
  {
    "id": "25233_19",
    "name": "Dongsung Motors Geumjeong FF SR, WS",
    "country": "KR",
    "city": "Busan",
    "address": "1603 Jungangdae-ro Geumjeong-gu, 46279 Busan",
    "email": "dsmain@bmwdongsung.co.kr",
    "phone": "82-51-7127301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.22788619995117,
      "lng": 129.08969116210938
    }
  },
  {
    "id": "25235_9",
    "name": "BMW National Motors Pyeongtaek SR Showroom",
    "country": "KR",
    "city": "Pyeongtaek-si",
    "address": "895, Gyeonggi-daero, 17747 Pyeongtaek-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-31-6587301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 37.029136657714844,
      "lng": 127.06986999511719
    }
  },
  {
    "id": "26986_10",
    "name": "BMW Deutsch Motors Daechi SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "411, Dogok-ro, Gangnam-gu, 06207 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-5547601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.497474670410156,
      "lng": 127.05534362792969
    }
  },
  {
    "id": "26986_26",
    "name": "Deutsch Motors Misa WS Workshop",
    "country": "KR",
    "city": "Hanam-si",
    "address": "192, Deokpungbuk-ro, 12927 Hanam-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-31-7947607",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.5524787902832,
      "lng": 127.20941925048828
    }
  },
  {
    "id": "28261_9",
    "name": "BMW Handok Motors Seodaegu FF Showroom and Workshop",
    "country": "KR",
    "city": "Daegu",
    "address": "1841, Dalgubeol-daero, Seo-gu, 41872 Daegu",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-53-6237301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 35.86096954345703,
      "lng": 128.56581115722656
    }
  },
  {
    "id": "28261_14",
    "name": "Handok Motors BMW Yongsan IPARKMALL Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "Iparkmall,55, Hangang-daero 23-gil,, 04377 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-20123302",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.5294075012207,
      "lng": 126.96432495117188
    }
  },
  {
    "id": "01631_36",
    "name": "Kolon Motors Suncheon SR_CC Showroom (Connected Center)",
    "country": "KR",
    "city": "Suncheon-si",
    "address": "609, Baekgang-ro, Seo-myeon, 57991 Suncheon-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-61-7417301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 34.984718322753906,
      "lng": 127.51387786865234
    }
  },
  {
    "id": "25230_4",
    "name": "Bavarian Motors Incheon WS Workshop",
    "country": "KR",
    "city": "Incheon",
    "address": "7-324, Sinheungdong 3-ga, Jung-gu, 22332 Incheon",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-32-8817401",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.4619140625,
      "lng": 126.6329345703125
    }
  },
  {
    "id": "25235_2",
    "name": "BMW National Motors Jeonju WS Workshop",
    "country": "KR",
    "city": "Jeonju-si",
    "address": "180, Sinbok-ro, Deokjin-gu, 54841 Jeonju-si",
    "email": "national@bmwnational.co.kr",
    "phone": "82-63-2110505",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 35.864444732666016,
      "lng": 127.09930419921875
    }
  },
  {
    "id": "25237_4",
    "name": "BMW Samchully Motors Cheonan FF Showroom and Workshop",
    "country": "KR",
    "city": "Cheonan-si",
    "address": "1265, Cheonandaero Seobuk-gu, 31080 Cheonan-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-41-5727401",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 36.85407257080078,
      "lng": 127.15396881103516
    }
  },
  {
    "id": "26986_22",
    "name": "BMW Deutsch Motors Hannam SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "152, Hannam-daero, Yongsan-gu, 04417 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-7497301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.541927337646484,
      "lng": 127.00321197509766
    }
  },
  {
    "id": "28261_6",
    "name": "BMW Handok Motors Bundang FF UC Showroom and Workshop",
    "country": "KR",
    "city": "Seongnam-si",
    "address": "331, Daewangpangyo-ro, Bundang-gu, 13550 Seongnam-si",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-31-7810123",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.37308883666992,
      "lng": 127.1011734008789
    }
  },
  {
    "id": "25230_17",
    "name": "Bavarian Motors BMW Mapo SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "227, Mapo-daero, Mapo-gu, 04117 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-31447501",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.55439376831055,
      "lng": 126.95685577392578
    }
  },
  {
    "id": "25230_8",
    "name": "Bavarian Motors Songdo FF UC Fully Fledged",
    "country": "KR",
    "city": "Incheon",
    "address": "74, Cheomdan-daero 124beon-gil, 21991 Incheon",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-32-4277301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.36002731323242,
      "lng": 126.6522216796875
    }
  },
  {
    "id": "01631_30",
    "name": "Kolon Motors Daegu UC Used Car Showroom",
    "country": "KR",
    "city": "Daegu",
    "address": "42-30, Ihyeon-dong, Seo-gu, 41752 Daegu",
    "email": "jaehyun@kolon.com",
    "phone": "82-53-5237301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.875099182128906,
      "lng": 128.53704833984375
    }
  },
  {
    "id": "25233_4",
    "name": "Dongsung Motors Changwon FF UC Showroom, Workshop, Used Car",
    "country": "KR",
    "city": "Changwon-si",
    "address": "163, Bongyang-ro, Masanhoewon-gu, 51348 Changwon-si",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-55-2477301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.217708587646484,
      "lng": 128.603271484375
    }
  },
  {
    "id": "01631_39",
    "name": "Kolon Motors Busan UC Used Car Showroom",
    "country": "KR",
    "city": "Busan",
    "address": "420, Sinseon-ro, Nam-gu, 48520 Busan",
    "email": "jaehyun@kolon.com",
    "phone": "82-51-8167301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.15395736694336,
      "lng": 129.05401611328125
    }
  },
  {
    "id": "01631_37",
    "name": "Kolon Motors Gwangju UC UC Showroom",
    "country": "KR",
    "city": "Gwangju",
    "address": "78, Hoejaeutong-gil, Seo-gu, 62071 Gwangju",
    "email": "jaehyun@kolon.com",
    "phone": "82-62-4467301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.114601135253906,
      "lng": 126.85484313964844
    }
  },
  {
    "id": "25230_7",
    "name": "Bavarian Motors Ilsan FF UC Fully Fledged",
    "country": "KR",
    "city": "Goyang-si",
    "address": "383, Mugunghwa-ro, Ilsandong-gu, 10320 Goyang-si",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-31-9227301",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.678733825683594,
      "lng": 126.8012924194336
    }
  },
  {
    "id": "25233_9",
    "name": "Dongsung Motors Busan Sajik UC Used Car Showroom",
    "country": "KR",
    "city": "Busan-si",
    "address": "15, Gyeonggijang-ro, Yeonje-gu, 47500 Busan-si",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-15887305",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.18783950805664,
      "lng": 129.0538330078125
    }
  },
  {
    "id": "01631_9",
    "name": "Kolon Motors Gwanganli WS Workshop",
    "country": "KR",
    "city": "Busan",
    "address": "173-14, Gwangan-dong, suyoung-gu, 48299 Busan",
    "email": "jaehyun@kolon.com",
    "phone": "82-51-3277301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.15373611450195,
      "lng": 129.1168212890625
    }
  },
  {
    "id": "01631_11",
    "name": "Kolon Motors Daejeon SR Showroom",
    "country": "KR",
    "city": "Daejeon",
    "address": "8, Hanbat-daero 492beon-gil, 34184 Daejeon",
    "email": "bmwsales@kolon.com",
    "phone": "82-42-5237301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.35933303833008,
      "lng": 127.35311889648438
    }
  },
  {
    "id": "01631_15",
    "name": "Kolon Motors Daejeon WS Workshop",
    "country": "KR",
    "city": "Daejeon",
    "address": "304-1 Wa-dong, Daedeok-gu, 34357 Daejeon",
    "email": "jaehyun@kolon.com",
    "phone": "82-42-6337301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.4076042175293,
      "lng": 127.42342376708984
    }
  },
  {
    "id": "01631_27",
    "name": "Kolon Motors Suncheon CC Workshop (Connected Center)",
    "country": "KR",
    "city": "Suncheon-si",
    "address": "609, Baekgang-ro, Seo-myeon, 57928 Suncheon-si",
    "email": "jaehyun@kolon.com",
    "phone": "82-61-7457301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 34.984718322753906,
      "lng": 127.51387786865234
    }
  },
  {
    "id": "01631_41",
    "name": "Kolon Motors Uijeongbu FF Showroom and Workshop",
    "country": "KR",
    "city": "Uijeongbu-si",
    "address": "11, Dongil-ro 192beon-gil, 11724 Uijeongbu-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-31-5407301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.70648193359375,
      "lng": 127.05791473388672
    }
  },
  {
    "id": "01631_49",
    "name": "Kolon Motors Daejeon SSG SR Showroom",
    "country": "KR",
    "city": "Daejeon",
    "address": "17, Expo-ro, Yuseong-gu, 34126 Daejeon",
    "email": "bmwsales@kolon.com",
    "phone": "82-42-6078600",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.3751106262207,
      "lng": 127.38117980957031
    }
  },
  {
    "id": "01631_50",
    "name": "Kolon Motors Gwanpyeong WS Workshop",
    "country": "KR",
    "city": "Daejeon",
    "address": "77-6, TechnoJungang-ro, Yuseong-gu, 34028 Daejeon",
    "email": "bmwsales@kolon.com",
    "phone": "82-42-7217301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.42371368408203,
      "lng": 127.40074157714844
    }
  },
  {
    "id": "25230_5",
    "name": "Bavarian Motors Gangseo WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "59, Gonghang-daero, Gangseo-gu, 07618 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-26617401",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.56135177612305,
      "lng": 126.81397247314453
    }
  },
  {
    "id": "25233_10",
    "name": "BMW Dongsung Motors Jinju SR Showroom",
    "country": "KR",
    "city": "Jinju-si",
    "address": "123, Naedong-ro, Naedong-myeon, 52849 Jinju-si",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-55-7487301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.15562438964844,
      "lng": 128.0808868408203
    }
  },
  {
    "id": "25237_8",
    "name": "BMW Samchully Motors Ansan SR",
    "country": "KR",
    "city": "Ansan-si",
    "address": "126-1, Chungjang-ro, Sangnok-gu, 15552 Ansan-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-31-5083002",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.29282760620117,
      "lng": 126.8586654663086
    }
  },
  {
    "id": "25237_6",
    "name": "BMW Samchully Motors Dongtan SR Showroom",
    "country": "KR",
    "city": "Hwaseong-si",
    "address": "436, 10yongsa-ro, 18438 Hwaseong-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-31-8071-3002",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.19846725463867,
      "lng": 127.06498718261719
    }
  },
  {
    "id": "25237_9",
    "name": "BMW Samchully Motors Anyang FF UC SR, WS, UC",
    "country": "KR",
    "city": "Anyang-si",
    "address": "116, Simin-daero, Dongan-gu, 14077 Anyang-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-31-3833002",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.38679504394531,
      "lng": 126.9458236694336
    }
  },
  {
    "id": "26986_6",
    "name": "BMW Deutsch Motors Yangjae SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "36, Yangjae-daero 11-gil, Seocho-gu, 06772 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-5457301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.461822509765625,
      "lng": 127.03535461425781
    }
  },
  {
    "id": "26986_25",
    "name": "Deutsch Motors Hanam Starfield SR Showroom",
    "country": "KR",
    "city": "Hanam-si",
    "address": "750 Misa-daero, 12942 Hanam-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-31-7947301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.54561233520508,
      "lng": 127.22405242919922
    }
  },
  {
    "id": "26986_21",
    "name": "Deutsch Motors BMW MINI Guri WS Workshop",
    "country": "KR",
    "city": "Guri-si",
    "address": "166 Beolmal-ro, Guri-si, 11945 Guri-si",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-31-5677601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.59114074707031,
      "lng": 127.14997863769531
    }
  },
  {
    "id": "26986_33",
    "name": "Deutsch Motors Seongnam WS Workshop",
    "country": "KR",
    "city": "Seongnam-si",
    "address": "356 Doonchondae-ro Jungwon-gu, 13404 Seongnam-si",
    "email": "deutsch.invoices@deutschmotors.com",
    "phone": null,
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.43146514892578,
      "lng": 127.15755462646484
    }
  },
  {
    "id": "28261_12",
    "name": "Handok Motors Gwangju Pyeongdong WS",
    "country": "KR",
    "city": "Gwangju",
    "address": "170-19, Pyeongdongsandan-ro, 62418 Gwangju",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-62-3837301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 35.1224250793457,
      "lng": 126.771240234375
    }
  },
  {
    "id": "01631_51",
    "name": "Kolon Motors Gangneung FF SR, WS",
    "country": "KR",
    "city": "Gangneung",
    "address": "613-1 Gyo-dong, 25473 Gangneung",
    "email": "chlghdud@kolon.com",
    "phone": "82-33-8087301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.77552032470703,
      "lng": 128.8885040283203
    }
  },
  {
    "id": "25233_14",
    "name": "Dongsung Motors Busan FF UC Showroom,Workshop and Used Car Show",
    "country": "KR",
    "city": "Busan",
    "address": "299, Haeundaehaebyeon-ro, 48095 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "82-51-7478100",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.16117858886719,
      "lng": 129.16351318359375
    }
  },
  {
    "id": "25235_1",
    "name": "BMW National Motors Jeonju SR Showroom",
    "country": "KR",
    "city": "Jeonju-si",
    "address": "234 Ongoeul-ro, Deokjin-gu,, 54884 Jeonju-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-63-2237301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 35.840023040771484,
      "lng": 127.10004425048828
    }
  },
  {
    "id": "25235_7",
    "name": "BMW National Motors Seosan FF Fully Fledged",
    "country": "KR",
    "city": "Seosan-si",
    "address": "323, Jungang-ro, 32010 Seosan-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-41-6647501",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 36.76497268676758,
      "lng": 126.48030853271484
    }
  },
  {
    "id": "25237_7",
    "name": "Samchully Motors BMW Dongtan WS Workshop",
    "country": "KR",
    "city": "Osan-si",
    "address": "28, Jandarian-gil, 18105 Osan-si",
    "email": "samchully@samchullymotors.co.kr",
    "phone": "82-31-6543002",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.187591552734375,
      "lng": 127.0390396118164
    }
  },
  {
    "id": "26986_8",
    "name": "BMW Deutsch Motors Songpa WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "444, Dogok-ro, Songpa-gu, 05573 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-4157601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.50498580932617,
      "lng": 127.07767486572266
    }
  },
  {
    "id": "28261_2",
    "name": "BMW Handok Motors Gangbuk FF Showroom and Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "101, Dobong-ro, Gangbuk-gu, 01179 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-9870123",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.6180305480957,
      "lng": 127.0290298461914
    }
  },
  {
    "id": "28261_10",
    "name": "Handok Motors Seodaegu Central WS Workshop",
    "country": "KR",
    "city": "Daegu",
    "address": "425, Waryong-ro, Seo-gu, 41754 Daegu",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-53-6537301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 35.870853424072266,
      "lng": 128.53736877441406
    }
  },
  {
    "id": "01631_8",
    "name": "Kolon Motors Daegu SR Showroom",
    "country": "KR",
    "city": "Daegu",
    "address": "132, Dongdaegu-ro, Suseong-gu, 42110 Daegu",
    "email": "bmwsales@kolon.com",
    "phone": "+82-53-7457301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.84217071533203,
      "lng": 128.6249542236328
    }
  },
  {
    "id": "01631_7",
    "name": "Kolon Motors Busan SR Showroom",
    "country": "KR",
    "city": "Busan",
    "address": "342, Suyeong-ro, Nam-gu, 48509 Busan",
    "email": "bmwsales@kolon.com",
    "phone": "+82-51-6277301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.138614654541016,
      "lng": 129.1031494140625
    }
  },
  {
    "id": "01631_44",
    "name": "Kolon Motors Gimhae FF Connected Center",
    "country": "KR",
    "city": "Gimhae-si",
    "address": "40-31, Gimhae-daero 2324beon-gil, 50940 Gimhae-si",
    "email": "bmwsales@kolon.com",
    "phone": "82-55-3117301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 35.2258415222168,
      "lng": 128.87855529785156
    }
  },
  {
    "id": "01631_48",
    "name": "Kolon Motors WiryeStarfield Showroom",
    "country": "KR",
    "city": "Hanam-si",
    "address": "200, Wirye-daero, 13012 Hanam-si",
    "email": "jaehyun@kolon.com",
    "phone": "82-2-64167301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.47625732421875,
      "lng": 127.1500244140625
    }
  },
  {
    "id": "01631_53",
    "name": "Kolon Motors Chuncheon FF SR, WS",
    "country": "KR",
    "city": "Chuncheon",
    "address": "500-2 Janghak-ri Dong-myeon, 24210 Chuncheon",
    "email": "bmwsales@kolon.com",
    "phone": "82-33-8307301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 37.914894104003906,
      "lng": 127.75226593017578
    }
  },
  {
    "id": "25230_18",
    "name": "Bavarian Motors YDP Lotte VIC FLS Fastlane Service Center",
    "country": "KR",
    "city": "Seoul",
    "address": "125, Yeongjung-ro, Yeongdeungpo-gu,, 07228 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-69567401",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.52774429321289,
      "lng": 126.90507507324219
    }
  },
  {
    "id": "25230_16",
    "name": "Bavarian Motors Geumcheon SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "489 Siheungdae-ro Geumcheon-gu, 08530 Seoul",
    "email": "bavarian@bavarian.co.kr",
    "phone": "82-2-26457501",
    "website": "https://www.bavarian.co.kr",
    "coords": {
      "lat": 37.477264404296875,
      "lng": 126.89830780029297
    }
  },
  {
    "id": "25235_6",
    "name": "BMW National Motors Mokpo FF Fully Fledged",
    "country": "KR",
    "city": "Mokpo-si",
    "address": "101, Daeyang-ro, 58601 Mokpo-si",
    "email": "national@nationalmotors.co.kr",
    "phone": "82-61-2837301",
    "website": "https://www.nationalmotors.co.kr",
    "coords": {
      "lat": 34.82160186767578,
      "lng": 126.39065551757812
    }
  },
  {
    "id": "26986_3",
    "name": "BMW Deutsch Motors Dongdaemun SR Showrooom",
    "country": "KR",
    "city": "Seoul",
    "address": "329, Cheonho-daero, Dongdaemun-gu, 02622 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-22357301",
    "website": "https://www.deutschmtoros.com",
    "coords": {
      "lat": 37.564369201660156,
      "lng": 127.05659484863281
    }
  },
  {
    "id": "25237_11",
    "name": "BMW Samchully Motors Gunpo WS Workshop",
    "country": "KR",
    "city": "Gunpo",
    "address": "11, Dangjeong-ro 27-gil, 15850 Gunpo",
    "email": "aftersalesgq@sclmotors.co.kr",
    "phone": "82-31-80688501",
    "website": "https://www.samchullymotors.co.kr",
    "coords": {
      "lat": 37.350685119628906,
      "lng": 126.95489501953125
    }
  },
  {
    "id": "26986_16",
    "name": "Deutsch Motors Dogok WS Fastlane Service Center",
    "country": "KR",
    "city": "Seoul",
    "address": "17, Nonhyeon-ro 28-gil, Gangnam-gu, 06301 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-5757601",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.48316955566406,
      "lng": 127.043701171875
    }
  },
  {
    "id": "26986_27",
    "name": "Deutsch Motors Seongsu FF Fully Fledged",
    "country": "KR",
    "city": "Seoul",
    "address": "111, Dongil-ro, Seongdong-gu, 04798 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-21707100",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.542442321777344,
      "lng": 127.06389617919922
    }
  },
  {
    "id": "26986_28",
    "name": "Deutsch Motors Yangjae WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "7, Nonhyeon-ro 7-gil, Seocho-gu, 06783 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-5757602",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.472904205322266,
      "lng": 127.0486831665039
    }
  },
  {
    "id": "26986_34",
    "name": "Deutsch Motors Wonju WS Workshop",
    "country": "KR",
    "city": "Wonju-si",
    "address": "2305-7 Taejang-dong, 26311 Wonju-si",
    "email": "deutsch.invoices@deutschmotors.com",
    "phone": "82-33-7347301",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.39374542236328,
      "lng": 127.94987487792969
    }
  },
  {
    "id": "28261_8",
    "name": "BMW Handok Motors Seocho Central WS Workshop",
    "country": "KR",
    "city": "Seoul",
    "address": "45-13, Hyoryeong-ro 55-gil, 06651 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-4667301",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.48661422729492,
      "lng": 127.0135269165039
    }
  },
  {
    "id": "01631_29",
    "name": "Kolon Motors Daejeon UC Used Car Showroom",
    "country": "KR",
    "city": "Daejeon",
    "address": "189-3 Bongnyong-dong, Yuseong-gu, 34202 Daejeon",
    "email": "jaehyun@kolon.com",
    "phone": "82-41-6047301",
    "website": "https://www.kolonmotors.com",
    "coords": {
      "lat": 36.34128189086914,
      "lng": 127.32145690917969
    }
  },
  {
    "id": "26986_11",
    "name": "Deutsch Motors Yangjae UC Used Car Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "36, Yangjae-daero 11-gil, Seocho-gu, 06772 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-16448844",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.461822509765625,
      "lng": 127.03535461425781
    }
  },
  {
    "id": "26986_20",
    "name": "Deutsch Motors Gayang UC Used Car Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "30, Yangcheon-ro 52 gil, Gangseo-gu, 07528 Seoul",
    "email": "deutsch@deutschmotors.com",
    "phone": "82-2-16443883",
    "website": "https://www.deutschmotors.com",
    "coords": {
      "lat": 37.56654739379883,
      "lng": 126.8470687866211
    }
  },
  {
    "id": "28261_3",
    "name": "BMW Handok Motors Yongsan SR Showroom",
    "country": "KR",
    "city": "Seoul",
    "address": "241, Cheongpa-ro, Yongsan-gu, 04315 Seoul",
    "email": "handok@bmwhandok.co.kr",
    "phone": "82-2-32750123",
    "website": "https://www.bmwhandok.co.kr",
    "coords": {
      "lat": 37.5410270690918,
      "lng": 126.9706039428711
    }
  },
  {
    "id": "25233_15",
    "name": "Dongsung Motors Busan Lotte FLS Fastlane Service Center",
    "country": "KR",
    "city": "Busan",
    "address": "241, Sincheon-daero, Busanjin-gu, 47187 Busan",
    "email": "dongsung@bmwdongsung.co.kr",
    "phone": "+82-51-7317301",
    "website": "https://www.bmwdongsung.co.kr",
    "coords": {
      "lat": 35.16331100463867,
      "lng": 129.049560546875
    }
  },
  {
    "id": "09467_4",
    "name": "Tatung Motors Ltd. Pingzhen",
    "country": "TW",
    "city": "Taoyuan County",
    "address": "No.188, Sec.3, Yanping Rd., 324 Taoyuan County",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-3-4020988",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.939146041870117,
      "lng": 121.2027587890625
    }
  },
  {
    "id": "04825_8",
    "name": "PGUM Ltd. Taipei Minsheng Showroom",
    "country": "TW",
    "city": "Taipei City",
    "address": "No.10, Sec. 3, Minsheng E. Rd., 104 Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-25012166",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.057649612426758,
      "lng": 121.53885650634766
    }
  },
  {
    "id": "02133_2",
    "name": "Pan-Europe Motors Ltd. Chiayi",
    "country": "TW",
    "city": "Chiayi City",
    "address": "No. 800-2, Beigang Rd. West Distr., 600 Chiayi City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-5-2372255",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 23.48727798461914,
      "lng": 120.41548919677734
    }
  },
  {
    "id": "04623_1",
    "name": "Sun-Der Motors Taipei Xinzhuang",
    "country": "TW",
    "city": "New Taipei City",
    "address": "No.518, Zhongzheng Rd., 242 New Taipei City",
    "email": "sun-der@sun-der.bmw.com.tw",
    "phone": "+886-2-29030606",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.03208351135254,
      "lng": 121.43170928955078
    }
  },
  {
    "id": "04825_6",
    "name": "PGUM Ltd. Taipei Zhuwei Service",
    "country": "TW",
    "city": "New Taipei City",
    "address": "No. 179, Sec. 2, Zhongzheng E. Rd, 251 New Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-28096060",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.143924713134766,
      "lng": 121.46011352539062
    }
  },
  {
    "id": "09476_3",
    "name": "PGUM Ltd. Taichung Fuxing",
    "country": "TW",
    "city": "Taichung City",
    "address": "No. 45, Sec. 1, Zhongshan Rd., 414 Taichung City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-4-23360678",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.110612869262695,
      "lng": 120.64871978759766
    }
  },
  {
    "id": "38930_3",
    "name": "Long-Der Motors Ltd. Service Center",
    "country": "TW",
    "city": "Taipei City",
    "address": "No.9, Ln. 48, Xingshan Rd., 114 Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-87913989",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.057130813598633,
      "lng": 121.57543182373047
    }
  },
  {
    "id": "04825_9",
    "name": "PGUM Ltd. Taipei Dunnan Showroom",
    "country": "TW",
    "city": "Taipei City",
    "address": "No.198, Sec. 2, Dunhua S. Rd., 106 Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-27380123",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.023113250732422,
      "lng": 121.54843139648438
    }
  },
  {
    "id": "09452_1",
    "name": "PGUM Ltd. Tainan Yonghua",
    "country": "TW",
    "city": "Tainan City",
    "address": "No.456, Sec. 2, Yonghua Rd., 708 Tainan City",
    "email": "bmwtainan@pgumtn.bmw.com.tw",
    "phone": "+886-6-2994850",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 22.990615844726562,
      "lng": 120.17680358886719
    }
  },
  {
    "id": "38930_2",
    "name": "Long-Der Motors Ltd. Used Car",
    "country": "TW",
    "city": "Taipei City",
    "address": "No. 15, Ln. 48, Xingshan Rd., 114 Taipei City",
    "email": "tim@long-der.bmw.com.tw",
    "phone": "+886-2-27912558",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.057714462280273,
      "lng": 121.57522583007812
    }
  },
  {
    "id": "38930_5",
    "name": "Long-Der Motors Ltd. Lanyang Worksh Lanyang Workshop",
    "country": "TW",
    "city": "Yilan",
    "address": "No. 368, Sec. 3, Wujie Rd., 268 Yilan",
    "email": "long-der@long-der.bmw.com.tw",
    "phone": "+886-3-9605053",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.683000564575195,
      "lng": 121.78504180908203
    }
  },
  {
    "id": "27244_5",
    "name": "PGUM Ltd. Kaohsiung Xinsheng",
    "country": "TW",
    "city": "Qianzhen",
    "address": "No. 206, Xinsheng Rd.,, 806 Qianzhen",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-7-8220999",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 22.58168601989746,
      "lng": 120.31229400634766
    }
  },
  {
    "id": "09471_1",
    "name": "Lai-Der Motors Ltd. Hualien",
    "country": "TW",
    "city": "Hualien County",
    "address": "No. 312, Sec. 3, Zhongyang Rd., 973 Hualien County",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-3-8541155",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 23.982860565185547,
      "lng": 121.58562469482422
    }
  },
  {
    "id": "04825_10",
    "name": "PGUM Ltd. Taipei Tianmu Showroom",
    "country": "TW",
    "city": "Taipei City",
    "address": "No.76, Sec. 6, Zhongshan N. Rd., 111 Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-28381516",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.104305267333984,
      "lng": 121.52510070800781
    }
  },
  {
    "id": "09468_1",
    "name": "Chung-Mei Motors Ltd. Hsinchu",
    "country": "TW",
    "city": "Hsinchu City",
    "address": "No. 239, Sec. 1, Zhonghua Rd., 300 Hsinchu City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-3-5328888",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.812856674194336,
      "lng": 120.99015808105469
    }
  },
  {
    "id": "09451_1",
    "name": "Yi-Der Motors Ltd. Zhonghe",
    "country": "TW",
    "city": "New Taipei City",
    "address": "No. 68, Jianyi Road, 235 New Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-22235053",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.003021240234375,
      "lng": 121.48782348632812
    }
  },
  {
    "id": "09467_7",
    "name": "Tatung Motors Ltd. Taoyuan Used Car",
    "country": "TW",
    "city": "Taoyuan City",
    "address": "No. 658, Wenzhong Rd., 330 Taoyuan City",
    "email": "customer.service@ta-tung.bmw.com.tw",
    "phone": "+886-3-3706588",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.993627548217773,
      "lng": 121.27713012695312
    }
  },
  {
    "id": "09467_5",
    "name": "Tatung Motors Ltd. Pingzheng Used Used Car",
    "country": "TW",
    "city": "Taoyuan County",
    "address": "No. 586, Sec. 3, Yanping Rd., 324 Taoyuan County",
    "email": "jean@ta-tung.bmw.com.tw",
    "phone": "+886-3-4961888",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.932010650634766,
      "lng": 121.1971664428711
    }
  },
  {
    "id": "27244_3",
    "name": "PGUM Ltd. Kaohsiung Pingtung",
    "country": "TW",
    "city": "Pingtung County",
    "address": "No. 498, Sec.2, Hesheng Rd., 900 Pingtung County",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-8-7553205",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 22.654842376708984,
      "lng": 120.4715805053711
    }
  },
  {
    "id": "38930_1",
    "name": "Long-Der Motors Ltd. Neihu Showroom",
    "country": "TW",
    "city": "Taipei City",
    "address": "No. 36, Sec. 1, Jiuzong Rd., 114 Taipei City",
    "email": "tim@long-der.bmw.com.tw",
    "phone": "+886-2-87918181",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.058122634887695,
      "lng": 121.58071899414062
    }
  },
  {
    "id": "38930_4",
    "name": "Long-Der Motors Ltd. Yilan Showroom",
    "country": "TW",
    "city": "Yilan",
    "address": "No. 336, Sec. 3, Chunjing Rd., 265 Yilan",
    "email": "tim@long-der.bmw.com.tw",
    "phone": "+886-3-9532889",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.68645477294922,
      "lng": 121.7684097290039
    }
  },
  {
    "id": "09452_3",
    "name": "PGUM Ltd. Tainan Yongkang",
    "country": "TW",
    "city": "Tainan City",
    "address": "No.15, Xiaobei Rd., 710 Tainan City",
    "email": "bmwtainan@pgumtn.bmw.com.tw",
    "phone": "+886-6-2525666",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 23.020790100097656,
      "lng": 120.214599609375
    }
  },
  {
    "id": "09454_2",
    "name": "Chang-Ching Motors Ltd. Nantou",
    "country": "TW",
    "city": "Nantou County",
    "address": "No. 288, Nangang 3rd Rd., 540 Nantou County",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-49-2259888",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 23.939546585083008,
      "lng": 120.66488647460938
    }
  },
  {
    "id": "09473_1",
    "name": "Chang-E Motors Ltd. Changhua",
    "country": "TW",
    "city": "Changhua County",
    "address": "No. 498-1, Sec.2, Zhongshan Rd., 503 Changhua County",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-4-7870360",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.039825439453125,
      "lng": 120.53531646728516
    }
  },
  {
    "id": "09476_1",
    "name": "PGUM Ltd. Taichung Wenxin",
    "country": "TW",
    "city": "Taichung City",
    "address": "No.463, Sec.1, Wenxin Rd., 408 Taichung City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-4-22520303",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.15168571472168,
      "lng": 120.6465072631836
    }
  },
  {
    "id": "27244_1",
    "name": "PGUM Ltd. Kaohsiung Boai",
    "country": "TW",
    "city": "Kaohsiung City",
    "address": "No. 582, Boai 3rd Road, 813 Kaohsiung City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-7-3411300",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 22.68061065673828,
      "lng": 120.31011962890625
    }
  },
  {
    "id": "09476_6",
    "name": "PGUM Ltd.Taichung Chongder BMW Showroom",
    "country": "TW",
    "city": "Taichung City",
    "address": "No.489, Sec.3, Chongde Rd., 406 Taichung City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-4-24211188",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.192012786865234,
      "lng": 120.68624114990234
    }
  },
  {
    "id": "04825_2",
    "name": "PGUM Ltd. Taipei Binjiang",
    "country": "TW",
    "city": "Taipei City",
    "address": "No.337, Binjiang St., 104 Taipei City",
    "email": "pgmccm@email.bmw.com.tw",
    "phone": "+886-2-25027800",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.072612762451172,
      "lng": 121.54806518554688
    }
  },
  {
    "id": "09467_1",
    "name": "Tatung Motors Ltd. Taoyuan Wenzhong",
    "country": "TW",
    "city": "Taoyuan County",
    "address": "No. 746, Wenzhong Rd., 330 Taoyuan County",
    "email": "andy.ch@bmw.com.tw",
    "phone": "+886-3-3602222",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 24.993253707885742,
      "lng": 121.27458953857422
    }
  },
  {
    "id": "04825_12",
    "name": "PGUM.Ltd Taipei Dunbei BPS",
    "country": "TW",
    "city": "Taipei",
    "address": "No. 349, Dunhua N. Rd.,, 105 Taipei",
    "email": "sales999@pgumtp.bmw.com.tw",
    "phone": "+886-2-7189520",
    "website": "https://www.bmw.com.tw",
    "coords": {
      "lat": 25.06020164489746,
      "lng": 121.55073547363281
    }
  },
  {
    "id": "25046_1",
    "name": "Tlokinski Spolka Jawna",
    "country": "PL",
    "city": "Lodz",
    "address": "Aleksandrowska 131c, 91-224 Lodz",
    "email": "informacja@bmw-tlokinski.pl",
    "phone": "+48-42-6559847",
    "website": "https://www.bmw-tlokinski.pl",
    "coords": {
      "lat": 51.80345916748047,
      "lng": 19.365371704101562
    }
  },
  {
    "id": "28597_3",
    "name": "M-Cars Sp. z o.o. Sp.K.",
    "country": "PL",
    "city": "Nowy Sacz",
    "address": "Tarnowska 179, 33-300 Nowy Sacz",
    "email": "recepcja.nowysacz@bmw-mcars.pl",
    "phone": "+48-18-4489900",
    "website": "https://nowysacz.bmw-mcars.pl/",
    "coords": {
      "lat": 49.659793853759766,
      "lng": 20.68858528137207
    }
  },
  {
    "id": "28965_4",
    "name": "Inchcape Motor Polska Sp.zo.o.",
    "country": "PL",
    "city": "Swadzim k. Poznania",
    "address": "Wschodnia 9, 62-080 Swadzim k. Poznania",
    "email": "salon.poznan@bmw-imp.pl",
    "phone": "+48-61-6414646",
    "website": "https://poznan.bmw-inchcape.pl",
    "coords": {
      "lat": 52.43817138671875,
      "lng": 16.759532928466797
    }
  },
  {
    "id": "28966_1",
    "name": "Bawaria Motors Sp.zo.o.",
    "country": "PL",
    "city": "Warszawa",
    "address": "Czerniakowska 47, 00-715 Warszawa",
    "email": "info@bmw-bawariamotors.pl",
    "phone": "+48-22-5500300",
    "website": "http://warszawa.bmw-bawariamotors.pl/",
    "coords": {
      "lat": 52.19828414916992,
      "lng": 21.049365997314453
    }
  },
  {
    "id": "31536_5",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Pila",
    "address": "Wojciecha Kossaka 102, 64-920 Pila",
    "email": "recepcja@bmw-bonkowscy.pl",
    "phone": "+48-88-2095830",
    "website": "https://szczecin.bmw-bonkowscy.pl/",
    "coords": {
      "lat": 53.16232681274414,
      "lng": 16.770923614501953
    }
  },
  {
    "id": "33160_1",
    "name": "Best Auto Sp.zo.o.",
    "country": "PL",
    "city": "Lublin",
    "address": "Metalurgiczna 60, 20-234 Lublin",
    "email": "info@bmw-bestauto.pl",
    "phone": "+48-81-7495858",
    "website": "https://www.bmw-bestauto.pl",
    "coords": {
      "lat": 51.24205017089844,
      "lng": 22.645612716674805
    }
  },
  {
    "id": "32059_2",
    "name": "Sikora AC Sp.zo.o.",
    "country": "PL",
    "city": "Mikolow",
    "address": "Pszczynska 103, 43-190 Mikolow",
    "email": "salon.mikolow@bmw-sikora.pl",
    "phone": "+48-32-3260013",
    "website": "https://www.mikolow.bmw-sikora.pl",
    "coords": {
      "lat": 50.15376663208008,
      "lng": 18.901914596557617
    }
  },
  {
    "id": "32940_1",
    "name": "Auto Fus Group Sp. J.",
    "country": "PL",
    "city": "Warszawa",
    "address": "Ostrobramska 73, 04-175 Warszawa",
    "email": "info@bmw-autofus.pl",
    "phone": "+48-22-6139003",
    "website": "https://www.bmw-autofus.pl",
    "coords": {
      "lat": 52.232421875,
      "lng": 21.113880157470703
    }
  },
  {
    "id": "34977_1",
    "name": "Dynamic Motors sp. z o.o.",
    "country": "PL",
    "city": "Bydgoszcz",
    "address": "Torunska 272A, 85-831 Bydgoszcz",
    "email": "recepcja@bmw-dynamicmotors.pl",
    "phone": "+48-52-3395110",
    "website": "https://www.bmw-dynamicmotors.pl",
    "coords": {
      "lat": 53.115291595458984,
      "lng": 18.060148239135742
    }
  },
  {
    "id": "35491_4",
    "name": "ZK Motors Rzeszow",
    "country": "PL",
    "city": "Krasne",
    "address": "Krasne 9A, 36-007 Krasne",
    "email": "salon.rzeszow@bmw-zkmotors.pl",
    "phone": "+48-73-4132120",
    "website": "https://www.bmw-zkmotors.pl",
    "coords": {
      "lat": 50.0399055480957,
      "lng": 22.069002151489258
    }
  },
  {
    "id": "36893_3",
    "name": "Gazda Group Sp. z o.o.",
    "country": "PL",
    "city": "Katowice",
    "address": "Bochenskiego 66, 40-847 Katowice",
    "email": "infolinia@bmw-gazda.pl",
    "phone": "+48-32-7001000",
    "website": "https://www.bmw-gazda.pl",
    "coords": {
      "lat": 50.259185791015625,
      "lng": 18.985544204711914
    }
  },
  {
    "id": "32767_2",
    "name": "Auto Premium Rzeszow Sp. z o.o.",
    "country": "PL",
    "city": "Swilcza",
    "address": "Rzeszow - Swilcza 147H, 36-072 Swilcza",
    "email": "autopremium@bmw-autopremium.pl",
    "phone": "+48-17-8750050",
    "website": "https://www.bmw-autopremium.pl",
    "coords": {
      "lat": 50.06528091430664,
      "lng": 21.931007385253906
    }
  },
  {
    "id": "36891_4",
    "name": "Premium Arena JTB Sp. z o.o.",
    "country": "PL",
    "city": "Dobron",
    "address": "Wroclawska 18a, 95-082 Dobron",
    "email": "bmw.dobron@bmw-premiumarena.pl",
    "phone": "+48-42-6136600",
    "website": "https://dobron.bmw-premiumarena.pl",
    "coords": {
      "lat": 51.62350082397461,
      "lng": 19.234575271606445
    }
  },
  {
    "id": "36892_1",
    "name": "Sikora AC Lubin Sp. z o.o.",
    "country": "PL",
    "city": "Lubin",
    "address": "Zielonogorska 6, 59-300 Lubin",
    "email": "salon.lubin@bmw-sikora.pl",
    "phone": "+48-76-7237780",
    "website": "https://lubin.bmw-sikora.pl/",
    "coords": {
      "lat": 51.40740966796875,
      "lng": 16.208396911621094
    }
  },
  {
    "id": "36893_1",
    "name": "Gazda Group",
    "country": "PL",
    "city": "Gliwice",
    "address": "ul. Pszczynska 322, 44-100 Gliwice",
    "email": "infolinia@bmw-gazda.pl",
    "phone": "+48-32-7001000",
    "website": "https://www.bmw-gazda.pl",
    "coords": {
      "lat": 50.265621185302734,
      "lng": 18.71401023864746
    }
  },
  {
    "id": "44852_1",
    "name": "Auto-Centrum Sikora Sp. z o.o.",
    "country": "PL",
    "city": "Opole",
    "address": "Wroclawska 143, 43-837 Opole",
    "email": "salon.opole@bmw-sikora.pl",
    "phone": "+48-77-4138105",
    "website": "https://opole.bmw-sikora.pl",
    "coords": {
      "lat": 50.68107986450195,
      "lng": 17.872909545898438
    }
  },
  {
    "id": "31536_6",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Wroclaw",
    "address": "Cwiczebna 2, 51-180 Wroclaw",
    "email": "recepcja.wroclaw@bmw-bonkowscy.pl",
    "phone": "+48-91-717277800",
    "website": "https://www.bmw-bonkowscy.pl",
    "coords": {
      "lat": 51.15797805786133,
      "lng": 17.009092330932617
    }
  },
  {
    "id": "28966_5",
    "name": "Bawaria Motors Sp.zo.o.",
    "country": "PL",
    "city": "Piaseczno",
    "address": "Okulickiego 6, 05-500 Piaseczno",
    "email": "info.piaseczno@bmw-bawariamotors.pl",
    "phone": "+48-22-5500360",
    "website": "https://piaseczno.bmw-bawariamotors.pl/",
    "coords": {
      "lat": 52.081199645996094,
      "lng": 21.026411056518555
    }
  },
  {
    "id": "28966_4",
    "name": "Bawaria Motors Gdansk",
    "country": "PL",
    "city": "Gdansk",
    "address": "Grunwaldzka 195, 80-266 Gdansk",
    "email": "infogdansk@bmw-bawariamotors.pl",
    "phone": "+48-58-7666500",
    "website": "https://gdansk.bmw-bawariamotors.pl/",
    "coords": {
      "lat": 54.38652801513672,
      "lng": 18.592552185058594
    }
  },
  {
    "id": "34238_1",
    "name": "Zdunek Premium Sp. z o.o.",
    "country": "PL",
    "city": "Gdansk",
    "address": "ul. Mialki Szlak 43/45, 80-717 Gdansk",
    "email": "gdansk@bmw-zdunek.pl",
    "phone": "+48-58-6001102",
    "website": "https://www.bmw-zdunek.pl",
    "coords": {
      "lat": 54.34819793701172,
      "lng": 18.689109802246094
    }
  },
  {
    "id": "34238_2",
    "name": "Zdunek Premium Sp. z o.o.",
    "country": "PL",
    "city": "Gdynia",
    "address": "ul. Druskiennicka 1A, 81-533 Gdynia",
    "email": "gdynia@bmw-zdunek.pl",
    "phone": "+48-58-6001202",
    "website": "https://www.bmw-zdunek.pl",
    "coords": {
      "lat": 54.47936248779297,
      "lng": 18.527585983276367
    }
  },
  {
    "id": "28966_3",
    "name": "Bawaria Motors Sp.zo.o.",
    "country": "PL",
    "city": "Falenty",
    "address": "Aleja Krakowska 5, 05-090 Falenty",
    "email": "czesci.janki@bmw-bawariamotors.pl",
    "phone": "+48-22-2506000",
    "website": "https://www.bmw-bawariamotors.pl",
    "coords": {
      "lat": 52.1431884765625,
      "lng": 20.908390045166016
    }
  },
  {
    "id": "34977_4",
    "name": "Dynamic Motors sp. z o.o.",
    "country": "PL",
    "city": "Bydgoszcz",
    "address": "Fordonska 325, 85-790 Bydgoszcz",
    "email": "recepcja.fordonska@bmw-dynamicmotors.pl",
    "phone": "+48-52-3395110",
    "website": "https://www.bmw-dynamicmotors.pl",
    "coords": {
      "lat": 53.13583755493164,
      "lng": 18.123262405395508
    }
  },
  {
    "id": "35140_1",
    "name": "Dobrzanski Sp. z o.o. Sp. k.",
    "country": "PL",
    "city": "Kraków",
    "address": "Aleja Jana Pawla II 45, 31-864 Kraków",
    "email": "salon@bmw-dobrzanski.pl",
    "phone": "+48-12-3493333",
    "website": "http://www.bmw-dobrzanski.pl",
    "coords": {
      "lat": 50.0750846862793,
      "lng": 20.001901626586914
    }
  },
  {
    "id": "35491_2",
    "name": "ZK Motors",
    "country": "PL",
    "city": "Kielce",
    "address": "Wystawowa 2, 25-672 Kielce",
    "email": "salon@bmw-zkmotors.pl",
    "phone": "+48-734188400",
    "website": "https://www.bmw-zkmotors.pl",
    "coords": {
      "lat": 50.90272903442383,
      "lng": 20.58441162109375
    }
  },
  {
    "id": "36893_2",
    "name": "Gazda Group Sp. z o.o.",
    "country": "PL",
    "city": "Dabrowa Gornicza",
    "address": "Aleja Jozefa Pilsudskiego 17, 41-303 Dabrowa Gornicza",
    "email": "informacja@bmw-gazda.pl",
    "phone": "+48-32-7001800",
    "website": "https://www.bmw-gazda.pl",
    "coords": {
      "lat": 50.33146667480469,
      "lng": 19.215816497802734
    }
  },
  {
    "id": "52673_1",
    "name": "SMORAWINSKI GZ sp. z o.o.",
    "country": "PL",
    "city": "Poznan",
    "address": "Ostrowska 330, 61-312 Poznan",
    "email": "poznan@bmw-smorawinskigz.pl",
    "phone": "+48-61-6575100",
    "website": "https://bmw-smorawinskigz.pl/",
    "coords": {
      "lat": 52.368717193603516,
      "lng": 16.992151260375977
    }
  },
  {
    "id": "28136_1",
    "name": "PHU Fialkowski Sp.J.",
    "country": "PL",
    "city": "Zielona Góra",
    "address": "Trasa Polnocna 12B, 65-119 Zielona Góra",
    "email": "biuro@bmw-service-fialkowski.pl",
    "phone": "+48-68-3242805",
    "website": "https://www.bmw-service-fialkowski.pl",
    "coords": {
      "lat": 51.96147537231445,
      "lng": 15.503602027893066
    }
  },
  {
    "id": "28597_4",
    "name": "M-Cars Sp. z o.o. Sp.K.",
    "country": "PL",
    "city": "Lukanowice",
    "address": "Lukanowice 239, 32-830 Lukanowice",
    "email": "recepcja.tarnow@bmw-mcars.pl",
    "phone": "+48-14-6968900",
    "website": "https://www.bmw-mcars.pl",
    "coords": {
      "lat": 49.96826171875,
      "lng": 20.86692237854004
    }
  },
  {
    "id": "28965_5",
    "name": "Inchcape Motor Polska Sp.zo.o.",
    "country": "PL",
    "city": "Warszawa",
    "address": "Lopuszanska 38B, 02-232 Warszawa",
    "email": "salon.warszawa@bmw-imp.pl",
    "phone": "+48-22-5333500",
    "website": "http://warszawa.bmw-inchcape.pl/",
    "coords": {
      "lat": 52.195499420166016,
      "lng": 20.94147300720215
    }
  },
  {
    "id": "28966_2",
    "name": "Bawaria Motors Sp.zo.o.",
    "country": "PL",
    "city": "Katowice",
    "address": "Aleja Walentego Rozdzienskiego 204, 40-315 Katowice",
    "email": "info.katowice@bmw-bawariamotors.pl",
    "phone": "+48-32-2591800",
    "website": "http://katowice.bmw-bawariamotors.pl/",
    "coords": {
      "lat": 50.27008056640625,
      "lng": 19.063295364379883
    }
  },
  {
    "id": "28597_1",
    "name": "M-Cars Sp. z o.o. Sp.K.",
    "country": "PL",
    "city": "Krakow-Libertow",
    "address": "Gora Libertowska 14, 30-444 Krakow-Libertow",
    "email": "info@bmw-mcars.pl",
    "phone": "+48-12-2564555",
    "website": "https://www.bmw-mcars.pl",
    "coords": {
      "lat": 49.97922897338867,
      "lng": 19.909700393676758
    }
  },
  {
    "id": "28965_2",
    "name": "Inchcape Motor Polska Sp.zo.o.",
    "country": "PL",
    "city": "Wroclaw",
    "address": "Karkonoska 61, 53-015 Wroclaw",
    "email": "salon.wroclaw@bmw-imp.pl",
    "phone": "+48-71-3331000",
    "website": "https://www.wroclaw.bmw-inchcape.pl",
    "coords": {
      "lat": 51.06126403808594,
      "lng": 16.994834899902344
    }
  },
  {
    "id": "31536_1",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Szczecin",
    "address": "Ustowo 55, 70-001 Szczecin",
    "email": "recepcja@bmw-bonkowscy.pl",
    "phone": "+48-91-4648300",
    "website": "https://www.bmw-bonkowscy.pl",
    "coords": {
      "lat": 53.38902282714844,
      "lng": 14.498262405395508
    }
  },
  {
    "id": "34238_3",
    "name": "Zdunek Premium Sp. z o.o.",
    "country": "PL",
    "city": "Olsztyn",
    "address": "ul. Warszawska 117C, 10-701 Olsztyn",
    "email": "olsztyn@bmw-zdunek.pl",
    "phone": "+48-58-6001302",
    "website": "https://www.bmw-zdunek.pl",
    "coords": {
      "lat": 53.74843978881836,
      "lng": 20.460954666137695
    }
  },
  {
    "id": "34238_4",
    "name": "Zdunek Premium Sp. z o.o.",
    "country": "PL",
    "city": "Gdansk",
    "address": "Franciszka Mamuszki 2, 80-178 Gdansk",
    "email": "serwis.gdansk.mamuszki@bmw-zdunek.pl",
    "phone": "+48-58-7632410",
    "website": "https://www.bmw-zdunek.pl",
    "coords": {
      "lat": 54.33903884887695,
      "lng": 18.526081085205078
    }
  },
  {
    "id": "06030_1",
    "name": "P.H. Smorawinski Sp. z o.o.",
    "country": "PL",
    "city": "Poznan",
    "address": "Obornicka 235, 60-650 Poznan",
    "email": "info@bmw-smorawinski.pl",
    "phone": "+48-61-8455100",
    "website": "https://www.bmw-smorawinski.pl",
    "coords": {
      "lat": 52.447139739990234,
      "lng": 16.907495498657227
    }
  },
  {
    "id": "27023_1",
    "name": "Auto Fus Group Sp. z o.o.",
    "country": "PL",
    "city": "Choroszcz",
    "address": "Porosly Kolonia 1K, 16-070 Choroszcz",
    "email": "bialystok.info@bmw-autofus.pl",
    "phone": "+48-85-7418888",
    "website": "https://bialystok.bmw-autofus.pl",
    "coords": {
      "lat": 53.14854049682617,
      "lng": 23.062349319458008
    }
  },
  {
    "id": "31536_2",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Gorzow Wielkopolski",
    "address": "Kasprzaka 6G, 66-400 Gorzow Wielkopolski",
    "email": "recepcja.gorzow@bmw-bonkowscy.pl",
    "phone": "+48-95-7814545",
    "website": "https://www.bmw-bonkowscy.pl",
    "coords": {
      "lat": 52.70935821533203,
      "lng": 15.244548797607422
    }
  },
  {
    "id": "31536_4",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Koszalin",
    "address": "Lniana 3, 75-213 Koszalin",
    "email": "recepcja.koszalin@bmw-bonkowscy.pl",
    "phone": "+48-94-3415120",
    "website": "https://koszalin.bmw-service-bonkowscy.pl/",
    "coords": {
      "lat": 54.198787689208984,
      "lng": 16.162450790405273
    }
  },
  {
    "id": "32059_1",
    "name": "Sikora AC Sp.zo.o.",
    "country": "PL",
    "city": "Bielsko-Biala",
    "address": "Warszawska 56, 43-300 Bielsko-Biala",
    "email": "poczta@bmw-sikora.pl",
    "phone": "+48-33-8168695",
    "website": "https://www.bmw-sikora.pl",
    "coords": {
      "lat": 49.835487365722656,
      "lng": 19.04119873046875
    }
  },
  {
    "id": "34110_1",
    "name": "Auto Rawski sp. z o.o.",
    "country": "PL",
    "city": "Marki",
    "address": "Majora Billa 2, 05-270 Marki",
    "email": "kontakt@bmw-service-autorawski.pl",
    "phone": "+48-22-7713993",
    "website": "https://www.bmw-service-autorawski.pl",
    "coords": {
      "lat": 52.36494445800781,
      "lng": 21.14190673828125
    }
  },
  {
    "id": "34977_2",
    "name": "Dynamic Motors sp. z o.o.",
    "country": "PL",
    "city": "Lubicz Dolny",
    "address": "Torunska 64, 87-162 Lubicz Dolny",
    "email": "recepcja.torun@bmw-dynamicmotors.pl",
    "phone": "+48-56-6452170",
    "website": "https://www.bmw-dynamicmotors.pl",
    "coords": {
      "lat": 53.03587341308594,
      "lng": 18.72474479675293
    }
  },
  {
    "id": "34977_3",
    "name": "Dynamic Motors Sp.z o.o.",
    "country": "PL",
    "city": "Plock",
    "address": "Wyszogrodzka 134, 09-410 Plock",
    "email": "recepcja.plock@bmw-dynamicmotors.pl",
    "phone": "+48-24-2682408",
    "website": "https://www.bmw-dynamicmotors.pl",
    "coords": {
      "lat": 52.53748321533203,
      "lng": 19.746746063232422
    }
  },
  {
    "id": "36891_2",
    "name": "Premium Arena JTB Sp. z o.o.",
    "country": "PL",
    "city": "Kalisz",
    "address": "Wroclawska 50a, 62-800 Kalisz",
    "email": "bmw.kalisz@bmw-premiumarena.pl",
    "phone": "+48-62-7610800",
    "website": "https://www.kalisz.bmw-premiumarena.pl",
    "coords": {
      "lat": 51.736812591552734,
      "lng": 18.049816131591797
    }
  },
  {
    "id": "36891_3",
    "name": "Premium Arena JTB Sp. z o.o.",
    "country": "PL",
    "city": "Lodz",
    "address": "Al. Wlokniarzy 48, 91-348 Lodz",
    "email": "bmw.wlokniarzy@bmw-premiumarena.pl",
    "phone": "+48-42-6647200",
    "website": "http://bmw-premiumarena.pl",
    "coords": {
      "lat": 51.80171585083008,
      "lng": 19.425321578979492
    }
  },
  {
    "id": "28597_2",
    "name": "M-Cars Sp. z o.o. Sp.K.",
    "country": "PL",
    "city": "Kraków",
    "address": "Josepha Conrada 20, 31-357 Kraków",
    "email": "salon@bmw-mcars.pl",
    "phone": "+48-12-2114500",
    "website": "https://www.bmw-mcars.pl",
    "coords": {
      "lat": 50.08985137939453,
      "lng": 19.903789520263672
    }
  },
  {
    "id": "28965_1",
    "name": "Inchcape Motor Polska Sp.zo.o.",
    "country": "PL",
    "city": "Warszawa",
    "address": "Aleja Prymasa Tysiaclecia 64, 01-424 Warszawa",
    "email": "salon.warszawa@bmw-imp.pl",
    "phone": "+48-22-5333500",
    "website": "http://warszawa.bmw-inchcape.pl/",
    "coords": {
      "lat": 52.236385345458984,
      "lng": 20.956581115722656
    }
  },
  {
    "id": "33160_2",
    "name": "Best Auto Sp.zo.o.",
    "country": "PL",
    "city": "Lomza",
    "address": "Wojska Polskiego 163A, 18-400 Lomza",
    "email": "info@bmw-bestauto.pl",
    "phone": "+48-81-7495858",
    "website": "https://www.bmw-bestauto.pl",
    "coords": {
      "lat": 53.174190521240234,
      "lng": 22.037843704223633
    }
  },
  {
    "id": "35491_3",
    "name": "ZK Motors Radom",
    "country": "PL",
    "city": "Radom",
    "address": "Warszawska 234, 26-617 Radom",
    "email": "salon.radom@bmw-zkmotors.pl",
    "phone": "+48-734188500",
    "website": "https://radom.bmw-service-zkmotors.pl/",
    "coords": {
      "lat": 51.45423889160156,
      "lng": 21.142309188842773
    }
  },
  {
    "id": "31536_3",
    "name": "Bonkowscy Spólka Akcyjna",
    "country": "PL",
    "city": "Szczecin",
    "address": "Hangarowa 17, 70-767 Szczecin",
    "email": "Recepcja.hangarowa@bmw-bonkowscy.pl",
    "phone": "+48-91-4648300",
    "website": "https://www.bmw-bonkowscy.pl",
    "coords": {
      "lat": 53.38663864135742,
      "lng": 14.64222240447998
    }
  },
  {
    "id": "31893_1",
    "name": "Pawelec Moto Expert Sp.zo.o.",
    "country": "PL",
    "city": "Nowy Tomysl",
    "address": "Sekowo 4, 64-300 Nowy Tomysl",
    "email": "recepcja@bmw-pawelec.pl",
    "phone": "+48-61-4426182",
    "website": "https://www.bmw-service-pawelec.pl/",
    "coords": {
      "lat": 52.30967712402344,
      "lng": 16.10085678100586
    }
  },
  {
    "id": "35140_3",
    "name": "Dobrzanski Sp. z o.o. Sp. k.",
    "country": "PL",
    "city": "Krakow",
    "address": "Wielicka 119, 30-552 Krakow",
    "email": "salon@bmw-dobrzanski.pl",
    "phone": "+48-12-3493333",
    "website": "http://www.bmw-dobrzanski.pl",
    "coords": {
      "lat": 50.026084899902344,
      "lng": 19.97690773010254
    }
  },
  {
    "id": "36891_1",
    "name": "Premium Arena JTB Sp. z o.o.",
    "country": "PL",
    "city": "Lodz",
    "address": "Rokicinska 190, 92-412 Lodz",
    "email": "bmw@bmw-premiumarena.pl",
    "phone": "+48-42-6136600",
    "website": "https://www.lodz.bmw-premiumarena.pl",
    "coords": {
      "lat": 51.75338363647461,
      "lng": 19.58182144165039
    }
  },
  {
    "id": "37764_1",
    "name": "Frank Cars Sp. z o.o. Sp. k.",
    "country": "PL",
    "city": "Czestochowa",
    "address": "Jagiellonska 147/151, 42-200 Czestochowa",
    "email": "poczta@bmw-frankcars.pl",
    "phone": "+48-34-3991600",
    "website": "https://www.bmw-frankcars.pl",
    "coords": {
      "lat": 50.78839874267578,
      "lng": 19.105859756469727
    }
  },
  {
    "id": "51448_1",
    "name": "Sikora Moto Expert Sp. z o.o.",
    "country": "PL",
    "city": "Zielona Góra",
    "address": "Ul. Trasa Pólnocna 35, 65-119 Zielona Góra",
    "email": "poczta@bmw-sikora.pl",
    "phone": "+48-33-8168695",
    "website": "https://www.bmw-sikora.pl",
    "coords": {
      "lat": 51.95766067504883,
      "lng": 15.529282569885254
    }
  },
  {
    "id": "43945_1",
    "name": "TEAM Sp. z o.o.",
    "country": "PL",
    "city": "Dlugoleka",
    "address": "Wroclawska 56, 55-095 Dlugoleka",
    "email": "bmw@bmw-team.pl",
    "phone": "+48-71-7576600",
    "website": "http://www.bmw-team.pl",
    "coords": {
      "lat": 51.17353439331055,
      "lng": 17.175067901611328
    }
  },
  {
    "id": "28518_1",
    "name": "BASE NEXT, s.r.o.",
    "country": "CZ",
    "city": "Karlovy Vary",
    "address": "Jenisov 187, 360 01 Karlovy Vary",
    "email": "info@basenext.cz",
    "phone": "+420-731508800",
    "website": "https://www.basenext.cz/",
    "coords": {
      "lat": 50.22279357910156,
      "lng": 12.804770469665527
    }
  },
  {
    "id": "37151_1",
    "name": "CarTec Olomouc, s.r.o.",
    "country": "CZ",
    "city": "Olomouc",
    "address": "Tovarni 1297/1b, 779 00 Olomouc",
    "email": "bmw@cartecolomouc.cz",
    "phone": "+420-584101200",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 49.5886116027832,
      "lng": 17.28611183166504
    }
  },
  {
    "id": "48556_1",
    "name": "Lex Auto TB  s.r.o.",
    "country": "CZ",
    "city": "Ostrava-Poruba",
    "address": "Nad Porubkou 2391, 708 00 Ostrava-Poruba",
    "email": "info@lexauto.cz",
    "phone": "+420-553777888",
    "website": "https://www.lexauto.cz",
    "coords": {
      "lat": 49.821533203125,
      "lng": 18.175762176513672
    }
  },
  {
    "id": "49740_2",
    "name": "Kopecky s.r.o.",
    "country": "CZ",
    "city": "Pardubice",
    "address": "K Vapence 2925, 530 02 Pardubice",
    "email": "bmw.pardubice@kopecky.cz",
    "phone": "+420-467-070905",
    "website": "https://www.kopecky.cz/bmw",
    "coords": {
      "lat": 50.029178619384766,
      "lng": 15.751195907592773
    }
  },
  {
    "id": "40313_1",
    "name": "Bychl Auto, a.s.",
    "country": "CZ",
    "city": "Vestec",
    "address": "Videnska 169, 252 42 Vestec",
    "email": "servis@bmwbychl.cz",
    "phone": "+420-241007222",
    "website": "http://www.bmw-bychlauto.cz",
    "coords": {
      "lat": 49.97853469848633,
      "lng": 14.498567581176758
    }
  },
  {
    "id": "54265_1",
    "name": "Invelt s.r.o., Plzen",
    "country": "CZ",
    "city": "Plzen",
    "address": "Rokycanska 1422/111, 312 00 Plzen",
    "email": "plzen@invelt.com",
    "phone": "+420-377684111",
    "website": "https://www.bmw-invelt.com",
    "coords": {
      "lat": 49.74755096435547,
      "lng": 13.426478385925293
    }
  },
  {
    "id": "20117_4",
    "name": "Renocar a.s., Fast Lane Service",
    "country": "CZ",
    "city": "Praha 4",
    "address": "5. kvetna 1640/65, 140 00 Praha 4",
    "email": "bmwpraha@renocar.cz",
    "phone": "+420-261393690",
    "website": "https://www.renocar.cz",
    "coords": {
      "lat": 50.06215286254883,
      "lng": 14.428606986999512
    }
  },
  {
    "id": "20117_5",
    "name": "Renocar a.s. Urban Store",
    "country": "CZ",
    "city": "Praha",
    "address": "5 kvetna 1640/65, 140 21 Praha",
    "email": "bmwpraha@renocar.cz",
    "phone": "+420-261393696",
    "website": "https://www.renocar-bmw.cz",
    "coords": {
      "lat": 50.062191009521484,
      "lng": 14.42848014831543
    }
  },
  {
    "id": "26245_1",
    "name": "CarTec Praha s.r.o.",
    "country": "CZ",
    "city": "Praha 10",
    "address": "Prubezna 76, 100 00 Praha 10",
    "email": "bmw@cartecpraha.cz",
    "phone": "+420-226-889011",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 50.06441879272461,
      "lng": 14.501302719116211
    }
  },
  {
    "id": "50437_1",
    "name": "Auto Base s.r.o.",
    "country": "CZ",
    "city": "Praha",
    "address": "K Hrusovu 292/4, 102 00 Praha",
    "email": "info@autobase.cz",
    "phone": "+420-242-451200",
    "website": "https://autobase.cz/",
    "coords": {
      "lat": 50.06827926635742,
      "lng": 14.541463851928711
    }
  },
  {
    "id": "26247_1",
    "name": "ACR auto, a.s.",
    "country": "CZ",
    "city": "Ceske Budejovice",
    "address": "Okruzni 49, 370 01 Ceske Budejovice",
    "email": "bmw@acrauto.cz",
    "phone": "+420-387221111",
    "website": "https://www.acrauto.cz",
    "coords": {
      "lat": 49.001136779785156,
      "lng": 14.488868713378906
    }
  },
  {
    "id": "52864_4",
    "name": "AutoWallis Pardubice",
    "country": "CZ",
    "city": "Pardubice",
    "address": "Drazkovice 239, 533 33 Pardubice",
    "email": "pardubice@autowallis.cz",
    "phone": "+420-467027091",
    "website": "https://www.bmwautowallis.cz",
    "coords": {
      "lat": 50.00743865966797,
      "lng": 15.772238731384277
    }
  },
  {
    "id": "20117_1",
    "name": "Renocar a.s., Brno",
    "country": "CZ",
    "city": "Brno-Slatina",
    "address": "Ripska 5c, 627 00 Brno-Slatina",
    "email": "info@renocar.cz",
    "phone": "+420-548-141548",
    "website": "https://www.renocar-bmw.cz",
    "coords": {
      "lat": 49.17048645019531,
      "lng": 16.686269760131836
    }
  },
  {
    "id": "32526_1",
    "name": "CarTec Liberec, s.r.o.",
    "country": "CZ",
    "city": "Liberec 11",
    "address": "Obchodni 622, 460 01 Liberec 11",
    "email": "bmw@bmwliberec.cz",
    "phone": "+420-734418584",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 50.77522659301758,
      "lng": 15.021513938903809
    }
  },
  {
    "id": "32526_3",
    "name": "CarTec Liberec, s.r.o.",
    "country": "CZ",
    "city": "Liberec 11",
    "address": "Ostasovská 307/94, 460 01 Liberec 11",
    "email": "bmw@bmwliberec.cz",
    "phone": "+420-734418584",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 50.77391052246094,
      "lng": 15.023073196411133
    }
  },
  {
    "id": "20117_2",
    "name": "Renocar a.s., Praha",
    "country": "CZ",
    "city": "Cestlice",
    "address": "Lipova 280, 251 01 Cestlice",
    "email": "info@renocar.cz",
    "phone": "+420-261393600",
    "website": "https://www.renocar-bmw.cz",
    "coords": {
      "lat": 49.99774169921875,
      "lng": 14.585820198059082
    }
  },
  {
    "id": "26250_2",
    "name": "Kopecky Auto s.r.o.",
    "country": "CZ",
    "city": "Usti nad Labem",
    "address": "Pristavni 837/85, 400 07 Usti nad Labem",
    "email": "bmw@kopecky.cz",
    "phone": "+420-475201527",
    "website": "https://www.kopecky.cz/bmw/",
    "coords": {
      "lat": 50.663387298583984,
      "lng": 14.077558517456055
    }
  },
  {
    "id": "28074_1",
    "name": "CarTec Ostrava, s.r.o.",
    "country": "CZ",
    "city": "Ostrava",
    "address": "Vitkovicka 3246/1A, 702 00 Ostrava",
    "email": "bmw@bmwcartec.cz",
    "phone": "+420-597-499200",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 49.83061981201172,
      "lng": 18.27957534790039
    }
  },
  {
    "id": "53868_1",
    "name": "Renocar Synot, a.s.",
    "country": "CZ",
    "city": "Zlin",
    "address": "Tr. T. Bati 400, 763 02 Zlin",
    "email": "obchod@renocar-synot.cz",
    "phone": "+420-577112211",
    "website": "https://www.renocar-synot.cz",
    "coords": {
      "lat": 49.212615966796875,
      "lng": 17.616851806640625
    }
  },
  {
    "id": "54265_2",
    "name": "Invelt s.r.o., Praha",
    "country": "CZ",
    "city": "Praha 5 - Stodulky",
    "address": "Jeremiasova 5, 155 00 Praha 5 - Stodulky",
    "email": "praha@invelt.com",
    "phone": "+420-257117222",
    "website": "https://www.invelt.com",
    "coords": {
      "lat": 50.0393180847168,
      "lng": 14.326483726501465
    }
  },
  {
    "id": "20117_9",
    "name": "Renocar Bubenec",
    "country": "CZ",
    "city": "Bubenec",
    "address": "Papirenska 411, 160 00 Bubenec",
    "email": "bubenec@renocar.cz",
    "phone": "+420-261393616",
    "website": "https://www.renocar.cz/renocar-bubenec",
    "coords": {
      "lat": 50.109100341796875,
      "lng": 14.403188705444336
    }
  },
  {
    "id": "52864_5",
    "name": "AutoWallis Hradec Králové",
    "country": "CZ",
    "city": "Hradec Kralove-Brezhrad",
    "address": "Brezhradska 195, 503 32 Hradec Kralove-Brezhrad",
    "email": "hradeckralove@autowallis.cz",
    "phone": "+420-495733733",
    "website": "https://www.bmwautowallis.cz",
    "coords": {
      "lat": 50.17378616333008,
      "lng": 15.80134391784668
    }
  },
  {
    "id": "52864_2",
    "name": "AutoWallis Praha",
    "country": "CZ",
    "city": "Praha 9",
    "address": "Za Klicovem 1, 190 00 Praha 9",
    "email": "praha@autowallis.cz",
    "phone": "+420-241090111",
    "website": "https://www.bmwautowallis.cz",
    "coords": {
      "lat": 50.122840881347656,
      "lng": 14.508886337280273
    }
  },
  {
    "id": "28074_2",
    "name": "CarTec Ostrava s.r.o.",
    "country": "CZ",
    "city": "Ostrava - Vitkovice",
    "address": "Ruska 3018, 703 00 Ostrava - Vitkovice",
    "email": "bmw@bmwcartec.cz",
    "phone": "+420-597499200",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 49.81871032714844,
      "lng": 18.279184341430664
    }
  },
  {
    "id": "20117_6",
    "name": "Renocar a.s., Brno Ceska",
    "country": "CZ",
    "city": "Brno",
    "address": "Ceska 385, 664 31 Brno",
    "email": "info@renocar.cz",
    "phone": "+420-548-141548",
    "website": "https://www.renocar-bmw.cz",
    "coords": {
      "lat": 49.28762435913086,
      "lng": 16.561891555786133
    }
  },
  {
    "id": "37151_2",
    "name": "CarTec Brno s.r.o.",
    "country": "CZ",
    "city": "Brno",
    "address": "Skrobárenská 497/10, 617 00 Brno",
    "email": "bmw@cartecbrno.cz",
    "phone": "+420-511-181900",
    "website": "https://www.bmw-cartecgroup.cz/",
    "coords": {
      "lat": 49.183345794677734,
      "lng": 16.62387466430664
    }
  },
  {
    "id": "53881_1",
    "name": "Wallis Motor Pest Kft.",
    "country": "HU",
    "city": "Budapest",
    "address": "Hungária krt. 95, 1143 Budapest",
    "email": "wmp@wallismotor.hu",
    "phone": "+36-20-3334303",
    "website": "https://www.bmw-wallis.hu/",
    "coords": {
      "lat": 47.50901794433594,
      "lng": 19.102115631103516
    }
  },
  {
    "id": "25305_1",
    "name": "Rack Autó Autóforg. Kft.",
    "country": "HU",
    "city": "Székesfehérvár",
    "address": "Szent Flórián krt. 6, 8000 Székesfehérvár",
    "email": "info@rackauto.hu",
    "phone": "+36-22-801100",
    "website": "http://www.bmw-rackauto.hu",
    "coords": {
      "lat": 47.20966339111328,
      "lng": 18.42112922668457
    }
  },
  {
    "id": "28527_1",
    "name": "Wallis Motor Duna Kft.",
    "country": "HU",
    "city": "Budapest",
    "address": "Könyves Kálmán krt. 5, 1097 Budapest",
    "email": "info@wallisduna.hu",
    "phone": "+36-20-3336303",
    "website": "http://www.bmw-wallis.hu/",
    "coords": {
      "lat": 47.47032928466797,
      "lng": 19.089736938476562
    }
  },
  {
    "id": "44691_1",
    "name": "Bavarian Classics Zrt.",
    "country": "HU",
    "city": "Erd",
    "address": "Ercsi ut 21, 2030 Erd",
    "email": "info@bavarianclassics.com",
    "phone": "+36-23-360127",
    "website": "http://bavarianclassics.com",
    "coords": {
      "lat": 47.371498107910156,
      "lng": 18.915422439575195
    }
  },
  {
    "id": "25303_1",
    "name": "Leier Autó Kft.",
    "country": "HU",
    "city": "Györ",
    "address": "Szauter Ferenc út 9, 9024 Györ",
    "email": "bmw@leier.hu",
    "phone": "+36-96-513213",
    "website": "http://www.leierauto.hu/",
    "coords": {
      "lat": 47.6659049987793,
      "lng": 17.64579200744629
    }
  },
  {
    "id": "36632_1",
    "name": "Autófókusz Kft.",
    "country": "HU",
    "city": "Szombathely",
    "address": "Köszegi ut 1639/3.hrsz., 9700 Szombathely",
    "email": "bmw@autofokusz.hu",
    "phone": "+36-94-514885",
    "website": "http://www.bmw-autofokusz.hu",
    "coords": {
      "lat": 47.23068618774414,
      "lng": 16.621843338012695
    }
  },
  {
    "id": "25304_1",
    "name": "Glass Kft.",
    "country": "HU",
    "city": "Békéscsaba",
    "address": "Felsonyomas 256/2, 5600 Békéscsaba",
    "email": "bmwglass@bmwglass.hu",
    "phone": "+36-66-440505",
    "website": "http://www.bmw-glass.hu",
    "coords": {
      "lat": 46.687808990478516,
      "lng": 21.04212188720703
    }
  },
  {
    "id": "45278_2",
    "name": "AVALON MOTORS Kft.",
    "country": "HU",
    "city": "Szikszo",
    "address": "Avalon utca 4, 3800 Szikszo",
    "email": "avalonmotors@avalonmotors.hu",
    "phone": "+36-46-887877",
    "website": "http://www.bmw-avalonmotors.hu",
    "coords": {
      "lat": 48.17667007446289,
      "lng": 20.91301918029785
    }
  },
  {
    "id": "26545_2",
    "name": "Linartech Autóház Kft.",
    "country": "HU",
    "city": "Szolnok",
    "address": "Thokoly ut 100, 5000 Szolnok",
    "email": "info@linartechautohaz.hu",
    "phone": "+36-56999200",
    "website": "https://www.bmw-linartechautohaz.hu",
    "coords": {
      "lat": 47.200462341308594,
      "lng": 20.159469604492188
    }
  },
  {
    "id": "32346_1",
    "name": "Mag3 Magisz Ker. es Szolg. Kft",
    "country": "HU",
    "city": "Nyíregyháza",
    "address": "Debreceni út 233, 4405 Nyíregyháza",
    "email": "info@bmw-mag3.hu",
    "phone": "+36-42-596236",
    "website": "http://www.bmw-magisz.hu",
    "coords": {
      "lat": 47.91923522949219,
      "lng": 21.718608856201172
    }
  },
  {
    "id": "07424_1",
    "name": "Schneider Autóház Kft.",
    "country": "HU",
    "city": "Pécs",
    "address": "Pécsváradi út 23, 7630 Pécs",
    "email": "info.pecs@schneiderautohaz.hu",
    "phone": "+36-72-539000",
    "website": "http://www.bmw-schneider.hu",
    "coords": {
      "lat": 46.08706283569336,
      "lng": 18.273767471313477
    }
  },
  {
    "id": "25301_1",
    "name": "Linartech Group Kft.",
    "country": "HU",
    "city": "Szeged",
    "address": "Kálvária sgt. 83-85, 6725 Szeged",
    "email": "cmobil.titkarsag@cmobil.com",
    "phone": "+36-62-553213",
    "website": "http://www.bmw-cmobil.hu",
    "coords": {
      "lat": 46.25300979614258,
      "lng": 20.14142608642578
    }
  },
  {
    "id": "26545_1",
    "name": "Linartech Autóház Kft.",
    "country": "HU",
    "city": "Kecskemét",
    "address": "Szent László krt. 80, 6000 Kecskemét",
    "email": "info@linartechautohaz.hu",
    "phone": "+36-76-503600",
    "website": "https://www.bmw-linartechautohaz.hu",
    "coords": {
      "lat": 46.88203048706055,
      "lng": 19.696731567382812
    }
  },
  {
    "id": "30686_2",
    "name": "Budapest Motors Kft.",
    "country": "HU",
    "city": "Budapest",
    "address": "Bécsi út 254, 1037 Budapest",
    "email": "bmw@budapestmotors.hu",
    "phone": "+36-202507373",
    "website": "https://www.bmw-budapestmotors.hu",
    "coords": {
      "lat": 47.561981201171875,
      "lng": 19.0225887298584
    }
  },
  {
    "id": "31337_1",
    "name": "Schneider Autóház Kft.",
    "country": "HU",
    "city": "Kaposvár",
    "address": "Elod Vezer u. 1., 7400 Kaposvár",
    "email": "info.kaposvar@schneiderautohaz.hu",
    "phone": "+36-82-528290",
    "website": "http://www.bmw-schneider.hu",
    "coords": {
      "lat": 46.366783142089844,
      "lng": 17.808006286621094
    }
  },
  {
    "id": "07425_1",
    "name": "Schneider ZALA  Autohaz Kft.",
    "country": "HU",
    "city": "Nagykanizsa",
    "address": "Teleki utca 21, 8800 Nagykanizsa",
    "email": "info@angyalosiautohaz.hu",
    "phone": "+36-93-314745",
    "website": "http://www.bmw-angyalosiautohaz.hu",
    "coords": {
      "lat": 46.45149612426758,
      "lng": 17.01641082763672
    }
  },
  {
    "id": "30686_1",
    "name": "Budapest Motors Kft",
    "country": "HU",
    "city": "Budapest",
    "address": "Szentendrei út 63., 1033 Budapest",
    "email": "bmw@budapestmotors.hu",
    "phone": "+36-1-2266363",
    "website": "https://www.bmw-budapestmotors.hu",
    "coords": {
      "lat": 47.55250549316406,
      "lng": 19.04503631591797
    }
  },
  {
    "id": "25306_1",
    "name": "Magisz Kft.",
    "country": "HU",
    "city": "Debrecen",
    "address": "Böszörményi út 218, 4032 Debrecen",
    "email": "info@magisz.hu",
    "phone": "+36-52-350994",
    "website": "http://www.bmw-magisz.hu",
    "coords": {
      "lat": 47.564632415771484,
      "lng": 21.599010467529297
    }
  },
  {
    "id": "28819_1",
    "name": "Rack Autó Autóforg. Kft.",
    "country": "HU",
    "city": "Budaörs",
    "address": "Csata utca 23, 2040 Budaörs",
    "email": "bmw@rackauto.hu",
    "phone": "+36-23-886100",
    "website": "http://www.bmw-rackauto.hu",
    "coords": {
      "lat": 47.45322036743164,
      "lng": 18.960519790649414
    }
  },
  {
    "id": "53881_2",
    "name": "Wallis Motor Pest Kft.",
    "country": "HU",
    "city": "Budapest",
    "address": "Vaci ut 175, 1138 Budapest",
    "email": "wmp@wallismotor.hu",
    "phone": "+36-20-3334303",
    "website": "http://www.wallispest.hu/",
    "coords": {
      "lat": 47.553001403808594,
      "lng": 19.075380325317383
    }
  },
  {
    "id": "31520_1",
    "name": "Automobile Bavaria S.R.L Bucuresti, Baneasa",
    "country": "RO",
    "city": "Bucuresti",
    "address": "Sos. Bucuresti-Ploiesti 53 A, 013685 Bucuresti",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-21-2006263",
    "website": "https://www.bmw-bavaria.ro",
    "coords": {
      "lat": 44.501441955566406,
      "lng": 26.079959869384766
    }
  },
  {
    "id": "29144_1",
    "name": "Automobile Bavaria S.R.L. Timisoara",
    "country": "RO",
    "city": "Ghiroda",
    "address": "Str. Calea Lugojului 74, 307200 Ghiroda",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-256-228881",
    "website": "https://www.bmw-timisoara.ro",
    "coords": {
      "lat": 45.773319244384766,
      "lng": 21.29265785217285
    }
  },
  {
    "id": "32117_2",
    "name": "Automobile Bavaria S.R.L. Craiova",
    "country": "RO",
    "city": "Pielesti",
    "address": "Str. Calea Bucuresti, 131/1, 200620 Pielesti",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-251-470665",
    "website": "https://bmw-bavaria.ro/craiova",
    "coords": {
      "lat": 44.31194305419922,
      "lng": 23.864444732666016
    }
  },
  {
    "id": "34231_1",
    "name": "Grup West Premium S.R.L. Oradea",
    "country": "RO",
    "city": "Oradea",
    "address": "Calea Clujului 300, 410553 Oradea",
    "email": "office@bmw-grupwest.ro",
    "phone": "+40-259-477796",
    "website": "http://www.bmw-grupwest.ro",
    "coords": {
      "lat": 47.03812026977539,
      "lng": 22.003459930419922
    }
  },
  {
    "id": "31520_4",
    "name": "Automobile Bavaria S.R.L Bacau",
    "country": "RO",
    "city": "Nicolae Balcescu",
    "address": "DN2 - E85, km 278, 607355 Nicolae Balcescu",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-374-829756",
    "website": "https://www.bmw-bacau.ro",
    "coords": {
      "lat": 46.49510192871094,
      "lng": 26.924556732177734
    }
  },
  {
    "id": "31520_6",
    "name": "Automobile Bavaria S.R.L. Targu Mures-Cristesti",
    "country": "RO",
    "city": "Cristesti",
    "address": "Principala nr. 800H, 547185 Cristesti",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-21-2006263",
    "website": "https://www.bmw-bavaria.ro",
    "coords": {
      "lat": 46.507083892822266,
      "lng": 24.50172233581543
    }
  },
  {
    "id": "41186_1",
    "name": "Automobile Bavaria S.R.L. Arad",
    "country": "RO",
    "city": "Arad",
    "address": "Calea Aurel Vlaicu 275 B, 310227 Arad",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-257-260001",
    "website": "https://bmw-bavaria.ro/arad",
    "coords": {
      "lat": 46.20119094848633,
      "lng": 21.26388931274414
    }
  },
  {
    "id": "42813_1",
    "name": "Auto Cobalcescu S.R.L. Bucuresti",
    "country": "RO",
    "city": "Bucuresti",
    "address": "Splaiul Unirii 309, 030138 Bucuresti",
    "email": "office@bmw-autocobalcescu.ro",
    "phone": "+40-374-491913",
    "website": "http://bmw-autocobalcescu.ro",
    "coords": {
      "lat": 44.4067268371582,
      "lng": 26.13315200805664
    }
  },
  {
    "id": "31520_8",
    "name": "Automobile Bavaria S.R.L",
    "country": "RO",
    "city": "Jilava",
    "address": "Sos. Giurgiului 48u, 077120 Jilava",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-21-311303713",
    "website": "https://www.bmw-bavaria.ro",
    "coords": {
      "lat": 44.3516731262207,
      "lng": 26.082862854003906
    }
  },
  {
    "id": "33348_1",
    "name": "Transporturi Auto Filaret S.A. Transporturi Auto Filaret, Bucurest",
    "country": "RO",
    "city": "Bucuresti",
    "address": "Str. Spatarul Preda 7A, 050185 Bucuresti",
    "email": "office@bmw-filaret.ro",
    "phone": "+40-316-207600",
    "website": "https://www.bmw-filaret.ro",
    "coords": {
      "lat": 44.41147232055664,
      "lng": 26.083332061767578
    }
  },
  {
    "id": "42813_2",
    "name": "Auto Cobalcescu S.R.L. Pitesti",
    "country": "RO",
    "city": "Pitesti",
    "address": "Cartier Prundu Autostrada DN 65B, 117140 Pitesti",
    "email": "office.pitesti@bmw-autocobalcescu.ro",
    "phone": "+40-747-056418",
    "website": "https://bmw-autocobalcescu.ro/",
    "coords": {
      "lat": 44.82293701171875,
      "lng": 24.923198699951172
    }
  },
  {
    "id": "53604_1",
    "name": "APAN Motors Suceava",
    "country": "RO",
    "city": "Suceava",
    "address": "Sofia Vicoveanca 19A, 727371 Suceava",
    "email": "service.suceava@apan.ro",
    "phone": "+40-374-994422",
    "website": "https://www.bmw-apan.ro",
    "coords": {
      "lat": 47.626434326171875,
      "lng": 26.234508514404297
    }
  },
  {
    "id": "38434_1",
    "name": "Proleasing Motors S.R.L. Ploiesti",
    "country": "RO",
    "city": "Comuna Blejoi",
    "address": "Str. Strandului, nr 13, Sat Tantare, 107072 Comuna Blejoi",
    "email": "bmw.vanzari@proleasing.ro",
    "phone": "+40-244-407352",
    "website": "https://www.bmw-proleasing.ro",
    "coords": {
      "lat": 44.95968246459961,
      "lng": 26.055213928222656
    }
  },
  {
    "id": "41148_1",
    "name": "EXPRESS MOTORS S.R.L. Artizan, Bistrita",
    "country": "RO",
    "city": "Bistrita",
    "address": "Drumul Cetatii Nr. 23, 420006 Bistrita",
    "email": "contact@bmw-bistrita.ro",
    "phone": "+40-729-333311",
    "website": "https://www.bmw-bistrita.ro",
    "coords": {
      "lat": 47.10968780517578,
      "lng": 24.45401954650879
    }
  },
  {
    "id": "25508_1",
    "name": "Automobile Bavaria S.R.L. Brasov",
    "country": "RO",
    "city": "Sacele",
    "address": "Str. Calea Bucuresti Nr.33, 505600 Sacele",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-268-338000",
    "website": "http://www.bmw-bv.ro",
    "coords": {
      "lat": 45.60666275024414,
      "lng": 25.655380249023438
    }
  },
  {
    "id": "43392_1",
    "name": "Group West Motors S.R.L. Satu Mare",
    "country": "RO",
    "city": "Satu Mare",
    "address": "Str. Aurel Vlaicu 119, 440122 Satu Mare",
    "email": "office@bmw-groupwestmotors.ro",
    "phone": "+40-261-715580",
    "website": "https://bmw-groupwestmotors.ro/",
    "coords": {
      "lat": 47.81144714355469,
      "lng": 22.853199005126953
    }
  },
  {
    "id": "31520_2",
    "name": "Automobile Bavaria S.R.L. Otopeni",
    "country": "RO",
    "city": "Otopeni",
    "address": "Strada Garii 1A, 075100 Otopeni",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-21-3520414",
    "website": "https://www.bmw-bavaria.ro",
    "coords": {
      "lat": 44.53959274291992,
      "lng": 26.082889556884766
    }
  },
  {
    "id": "25510_1",
    "name": "Automobile Bavaria S.R.L. Constanta",
    "country": "RO",
    "city": "Ovidiu",
    "address": "Sos. DN 2A km 201-880, 905900 Ovidiu",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-241-559970",
    "website": "https://www.bmw-constanta.ro",
    "coords": {
      "lat": 44.23127746582031,
      "lng": 28.584064483642578
    }
  },
  {
    "id": "33851_1",
    "name": "Automobile Bavaria S.R.L. Sibiu",
    "country": "RO",
    "city": "Sibiu",
    "address": "Str. Europa  Unita 2, 550052 Sibiu",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-269-259950",
    "website": "https://www.bmw-sb.ro",
    "coords": {
      "lat": 45.78995132446289,
      "lng": 24.091516494750977
    }
  },
  {
    "id": "36684_1",
    "name": "APAN Motors S.R.L. Braila",
    "country": "RO",
    "city": "Braila",
    "address": "DN 22B Km4, 810550 Braila",
    "email": "bmw@apan.ro",
    "phone": "+40-339-401888",
    "website": "https://www.bmw-apan.ro",
    "coords": {
      "lat": 45.30277633666992,
      "lng": 27.981111526489258
    }
  },
  {
    "id": "25509_1",
    "name": "Automobile Bavaria S.R.L. Cluj-Napoca",
    "country": "RO",
    "city": "Floresti",
    "address": "Str. Avram Jancu No. 396-398, 407280 Floresti",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-264-275010",
    "website": "https://www.bmw-cluj.ro",
    "coords": {
      "lat": 46.74950408935547,
      "lng": 23.518552780151367
    }
  },
  {
    "id": "32117_1",
    "name": "Automobile Bavaria S.R.L. Bucuresti, Militari",
    "country": "RO",
    "city": "Bucuresti",
    "address": "Bd. Iuliu Maniu 592, 061129 Bucuresti",
    "email": "contact@automobilebavaria.ro",
    "phone": "+40-372-112500",
    "website": "http://www.bmw-mhs.ro/",
    "coords": {
      "lat": 44.43574523925781,
      "lng": 25.97751235961914
    }
  },
  {
    "id": "42813_3",
    "name": "Auto Cobalcescu S.R.L. Digital Service Only",
    "country": "RO",
    "city": "Bucuresti",
    "address": "Strada Valea Oltului 15, 061971 Bucuresti",
    "email": "office@bmw-autocobalcescu.ro",
    "phone": "+40-374-102410",
    "website": "http://bmw-autocobalcescu.ro",
    "coords": {
      "lat": 44.41276931762695,
      "lng": 26.014341354370117
    }
  },
  {
    "id": "43392_2",
    "name": "Group West Motors S.R.L.",
    "country": "RO",
    "city": "Baia Mare",
    "address": "Bulevardul Independentei 59, 430060 Baia Mare",
    "email": "office.baiamare@bmw-groupwestmotors.ro",
    "phone": "+40-262-223298",
    "website": "https://bmw-groupwestmotors.ro/",
    "coords": {
      "lat": 47.66057205200195,
      "lng": 23.505722045898438
    }
  },
  {
    "id": "53604_2",
    "name": "APAN Motors Iasi",
    "country": "RO",
    "city": "Iasi",
    "address": "Soseaua Pacurari, 189, 700545 Iasi",
    "email": "bmw.iasi@apan.ro",
    "phone": "+40-374-269269",
    "website": "https://www.bmw-apan.ro",
    "coords": {
      "lat": 47.17558288574219,
      "lng": 27.494726181030273
    }
  },
  {
    "id": "39461_1",
    "name": "Auto Palace Bratislava s.r.o.",
    "country": "SK",
    "city": "Bratislava",
    "address": "Vajnorská 136/C, 831 04 Bratislava",
    "email": "bmw-vajnorska@autopalace.sk",
    "phone": "+421-2-32158444",
    "website": "https://www.autopalacebratislava.sk",
    "coords": {
      "lat": 48.183231353759766,
      "lng": 17.16785430908203
    }
  },
  {
    "id": "45537_1",
    "name": "Bavaria TT, s.r.o.",
    "country": "SK",
    "city": "Trnava",
    "address": "Nitrianska 6/A, 917 01 Trnava",
    "email": "info@bavariatt.sk",
    "phone": "+421-33-2020000",
    "website": "http://www.bavariatt.sk",
    "coords": {
      "lat": 48.36418533325195,
      "lng": 17.60138511657715
    }
  },
  {
    "id": "28137_1",
    "name": "Regnum Bavaria s.r.o.",
    "country": "SK",
    "city": "Presov",
    "address": "Petrovanska ul. 54, 080 05 Presov",
    "email": "info@regnum-bavaria.sk",
    "phone": "+421-51-7581236",
    "website": "http://www.regnum-bavaria.sk",
    "coords": {
      "lat": 48.958194732666016,
      "lng": 21.25589942932129
    }
  },
  {
    "id": "39460_1",
    "name": "Regnum Kosice s.r.o.",
    "country": "SK",
    "city": "Kosice",
    "address": "Ostrovského 3667/3, 040 11 Kosice",
    "email": "info@regnum.sk",
    "phone": "+421-55-3046420",
    "website": "http://www.regnum-kosice.sk",
    "coords": {
      "lat": 48.70249938964844,
      "lng": 21.248332977294922
    }
  },
  {
    "id": "32527_1",
    "name": "Dunauto DS s.r.o.",
    "country": "SK",
    "city": "Dunajska Streda",
    "address": "Hlavna 81/35, 929 01 Dunajska Streda",
    "email": "bmw@dunauto.com",
    "phone": "+421-31-5900151",
    "website": "https://bmw.dunauto.com",
    "coords": {
      "lat": 47.98895263671875,
      "lng": 17.630399703979492
    }
  },
  {
    "id": "25528_1",
    "name": "T.O.B. s.r.o.",
    "country": "SK",
    "city": "Trencianska Turna",
    "address": "Banovska 1033, 913 21 Trencianska Turna",
    "email": "bmw@tob-bmw.sk",
    "phone": "+421-32-6496933",
    "website": "https://www.tob-bmw.sk",
    "coords": {
      "lat": 48.848262786865234,
      "lng": 18.029510498046875
    }
  },
  {
    "id": "30624_1",
    "name": "BAVARIA Bratislava s.r.o.",
    "country": "SK",
    "city": "Bratislava",
    "address": "Panonska cesta 61, 851 04 Bratislava",
    "email": "info@bavariabratislava.sk",
    "phone": "+421-2-43637728",
    "website": "https://www.bavariabratislava.sk",
    "coords": {
      "lat": 48.094642639160156,
      "lng": 17.11329460144043
    }
  },
  {
    "id": "28159_1",
    "name": "MD-Bavaria Zilina s.r.o.",
    "country": "SK",
    "city": "Zilina",
    "address": "Bytcicka 82, 010 01 Zilina",
    "email": "info@md-bavaria.sk",
    "phone": "+421-41-5072821",
    "website": "http://www.bmw-zilina.sk",
    "coords": {
      "lat": 49.199684143066406,
      "lng": 18.73215675354004
    }
  },
  {
    "id": "31718_1",
    "name": "RIJA - Bavaria s.r.o",
    "country": "SK",
    "city": "Nitra",
    "address": "Drazovska 3282/17, 949 01 Nitra",
    "email": "info@rijabavaria.sk",
    "phone": "+421-37-7730720",
    "website": "https://www.rijabavaria.sk",
    "coords": {
      "lat": 48.33089828491211,
      "lng": 18.083293914794922
    }
  },
  {
    "id": "42732_1",
    "name": "LION CAR, s.r.o.",
    "country": "SK",
    "city": "Banská Bystrica",
    "address": "Partizanska cesta 83, 974 01 Banská Bystrica",
    "email": "predaj@bmw-lioncar.sk",
    "phone": "+421-48-4718899",
    "website": "https://www.bmw-lioncar.sk",
    "coords": {
      "lat": 48.741661071777344,
      "lng": 19.178499221801758
    }
  },
  {
    "id": "54581_1",
    "name": "Group M Slovensko a. s.",
    "country": "SK",
    "city": "Bratislava",
    "address": "Harmincova 2/B, 841 01 Bratislava",
    "email": "servis@bmw-groupm.sk",
    "phone": "+421-2-21001001",
    "website": "http://bmw-groupm.sk",
    "coords": {
      "lat": 48.17820358276367,
      "lng": 17.049715042114258
    }
  },
  {
    "id": "24986_1",
    "name": "Avtoval d.o.o.",
    "country": "SI",
    "city": "Grosuplje",
    "address": "Pod Jelsami 2, 1290 Grosuplje",
    "email": "info@avtoval.si",
    "phone": "+386-1-7811300",
    "website": "https://www.avtoval.si",
    "coords": {
      "lat": 45.96684646606445,
      "lng": 14.66203784942627
    }
  },
  {
    "id": "24997_1",
    "name": "Selmar d.o.o.",
    "country": "SI",
    "city": "Celje",
    "address": "Mariborska cesta 119, 3000 Celje",
    "email": "info-ce@selmar.si",
    "phone": "+386-3-4244000",
    "website": "https://www.bmw-selmar.si/",
    "coords": {
      "lat": 46.24663543701172,
      "lng": 15.27885913848877
    }
  },
  {
    "id": "51089_1",
    "name": "Avto Aktiv SLO d.o.o.",
    "country": "SI",
    "city": "Kranj",
    "address": "Mirka Vadnova 2a, 4000 Kranj",
    "email": "bmw@avto-aktiv.si",
    "phone": "+386-4-2811400",
    "website": "https://www.bmw-avto-aktiv.si/",
    "coords": {
      "lat": 46.24300765991211,
      "lng": 14.371341705322266
    }
  },
  {
    "id": "49574_1",
    "name": "Wallis Motor Ljubljana prodaja in servis vozil, d.o.o.",
    "country": "SI",
    "city": "Ljubljana",
    "address": "Celovska cesta 182, 1000 Ljubljana",
    "email": "info@wallismotor.si",
    "phone": "+386-15833500",
    "website": "https://www.bmw-wallis.si/",
    "coords": {
      "lat": 46.07875442504883,
      "lng": 14.483704566955566
    }
  },
  {
    "id": "51089_2",
    "name": "Avto Aktiv SLO d.o.o.",
    "country": "SI",
    "city": "Trzin",
    "address": "Ljubljanska 24, 1236 Trzin",
    "email": "info@avto-aktiv.si",
    "phone": "+386-1-5605800",
    "website": "https://www.bmw-avto-aktiv.si",
    "coords": {
      "lat": 46.12998962402344,
      "lng": 14.558924674987793
    }
  },
  {
    "id": "24997_2",
    "name": "Selmar d.o.o. PE Maribor",
    "country": "SI",
    "city": "Maribor",
    "address": "Ptujska cesta 83, 2000 Maribor",
    "email": "info-mb@selmar.si",
    "phone": "+386-2-8280100",
    "website": "https://www.bmw-selmar.si",
    "coords": {
      "lat": 46.53506088256836,
      "lng": 15.662050247192383
    }
  },
  {
    "id": "51089_4",
    "name": "Avto Aktiv SLO d.o.o.",
    "country": "SI",
    "city": "Koper",
    "address": "Ankaranska cesta 12, 6000 Koper",
    "email": "koper@avto-aktiv.si",
    "phone": "+386-5-6203235",
    "website": "https://www.bmw-avto-aktiv.si",
    "coords": {
      "lat": 45.54734802246094,
      "lng": 13.741368293762207
    }
  },
  {
    "id": "09198_1",
    "name": "PSC Molk d.o.o.",
    "country": "SI",
    "city": "Vrhnika",
    "address": "Turnovse 29, 1360 Vrhnika",
    "email": "matej.molk@psc-molk.si",
    "phone": "+386-1-7557170",
    "website": "https://www.psc-molk.si",
    "coords": {
      "lat": 45.95945739746094,
      "lng": 14.28654670715332
    }
  },
  {
    "id": "24984_2",
    "name": "Makoma d.o.o.",
    "country": "SI",
    "city": "Novo mesto",
    "address": "Brsljin 2, 8000 Novo mesto",
    "email": "info@makoma.si",
    "phone": "+386-7-3934200",
    "website": "https://bmw.makoma.si/",
    "coords": {
      "lat": 45.81440734863281,
      "lng": 15.152010917663574
    }
  },
  {
    "id": "51089_5",
    "name": "Avto Aktiv SLO d.o.o.",
    "country": "SI",
    "city": "Nova Gorica",
    "address": "Industrijska Cesta 9, 5102 Nova Gorica",
    "email": "info.ng@avto-aktiv.si",
    "phone": "+386-5-8502508",
    "website": "https://www.avto-aktiv.si/",
    "coords": {
      "lat": 45.95414352416992,
      "lng": 13.673977851867676
    }
  },
  {
    "id": "07877_5",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Split",
    "address": "Dubrovacka 1, 21000 Split",
    "email": "split@tomic.hr",
    "phone": "+385-21-544729",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 43.50524139404297,
      "lng": 16.456340789794922
    }
  },
  {
    "id": "07877_8",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Zadar",
    "address": "84. gardijske bojne HV Termiti 49, 23000 Zadar",
    "email": "zadar@tomic.hr",
    "phone": "+385-23-630520",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 44.094970703125,
      "lng": 15.274249076843262
    }
  },
  {
    "id": "07877_9",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Pula",
    "address": "Ulica Ante Dukica 1A, 52100 Pula",
    "email": "pula@tomic.hr",
    "phone": "+385-052215288",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 44.876399993896484,
      "lng": 13.867741584777832
    }
  },
  {
    "id": "26258_1",
    "name": "Vuko d.o.o.",
    "country": "HR",
    "city": "Slavonski Brod",
    "address": "Sjeverna vezna cesta 21, 35000 Slavonski Brod",
    "email": "info@vuko.hr",
    "phone": "+385-35-400700",
    "website": "https://www.vuko.hr",
    "coords": {
      "lat": 45.178810119628906,
      "lng": 17.98819923400879
    }
  },
  {
    "id": "07877_6",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Zagreb",
    "address": "Rooseveltov trg 4, 10000 Zagreb",
    "email": "info@tomic.hr",
    "phone": "+385-1-6470895",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 45.80755615234375,
      "lng": 15.96765422821045
    }
  },
  {
    "id": "07877_3",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Rijeka",
    "address": "Osjecka 50, 51000 Rijeka",
    "email": "rijeka@tomic.hr",
    "phone": "+385-51-506982",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 45.34079360961914,
      "lng": 14.425870895385742
    }
  },
  {
    "id": "07877_7",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Osijek",
    "address": "Hrastova ul. 2, 31000 Osijek",
    "email": "info@tomic.hr",
    "phone": "+385-31-445090",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 45.53940200805664,
      "lng": 18.652080535888672
    }
  },
  {
    "id": "07877_1",
    "name": "Tomic & Co. d.o.o.",
    "country": "HR",
    "city": "Zagreb",
    "address": "Folnegoviceva 12, 10000 Zagreb",
    "email": "gdpr@tomic.hr",
    "phone": "+385-1-6301999",
    "website": "https://www.tomic.hr",
    "coords": {
      "lat": 45.79671096801758,
      "lng": 16.00758934020996
    }
  },
  {
    "id": "26261_1",
    "name": "Auto Centar Baumgartner d.o.o.",
    "country": "HR",
    "city": "Cakovec",
    "address": "Brace Graner 2, 40000 Cakovec",
    "email": "info@ac-baumgartner.hr",
    "phone": "+385-40-328007",
    "website": "https://www.baumgartner.hr",
    "coords": {
      "lat": 46.39008331298828,
      "lng": 16.414640426635742
    }
  },
  {
    "id": "27173_1",
    "name": "Mitic company d.o.o.",
    "country": "RS",
    "city": "Nis",
    "address": "Dimitrija Tucovica 173, 18000 Nis",
    "email": "office@bmw-mitic.rs",
    "phone": "+381-18-4519519",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/Mitic.html",
    "coords": {
      "lat": 43.31591033935547,
      "lng": 21.849163055419922
    }
  },
  {
    "id": "33466_1",
    "name": "Auto-Garant d.o.o.",
    "country": "RS",
    "city": "Cacak",
    "address": "Ibarski put bb, 32212 Cacak",
    "email": "office@autogarant.rs",
    "phone": "+381-32-380900",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/Autogarant.html",
    "coords": {
      "lat": 43.903072357177734,
      "lng": 20.41263771057129
    }
  },
  {
    "id": "31165_2",
    "name": "Radulovic Novi Sad",
    "country": "RS",
    "city": "Novi Sad",
    "address": "Novosadski Put 71, 21203 Novi Sad",
    "email": "office@radulovic-group.com",
    "phone": "+381-21-820888",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/NoviSad-Radulovic.html",
    "coords": {
      "lat": 45.247379302978516,
      "lng": 19.765939712524414
    }
  },
  {
    "id": "53834_1",
    "name": "Elite Motors doo",
    "country": "RS",
    "city": "Novi Pazar",
    "address": "Mihaila Pupina 5, 36300 Novi Pazar",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 43.15907669067383,
      "lng": 20.53221321105957
    }
  },
  {
    "id": "31165_1",
    "name": "Radulovic Beograd",
    "country": "RS",
    "city": "Belgrade",
    "address": "Dragoslava Srejovica, BB, 11000 Belgrade",
    "email": "office@radulovic-group.com",
    "phone": "+381-11-2080180",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/radulovic.html",
    "coords": {
      "lat": 44.8148078918457,
      "lng": 20.486494064331055
    }
  },
  {
    "id": "30850_1",
    "name": "DELTA MOTORS D.O.O. Cukarica",
    "country": "RS",
    "city": "Belgrade",
    "address": "Radnicka 8, 11030 Belgrade",
    "email": "office@bmw.rs",
    "phone": "+381-11-3539928",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/delta-motors.html",
    "coords": {
      "lat": 44.7839469909668,
      "lng": 20.412601470947266
    }
  },
  {
    "id": "30850_3",
    "name": "Delta Motors Novi Beograd",
    "country": "RS",
    "city": "Belgrade",
    "address": "Omladinskih Brigada 33a, 11070 Belgrade",
    "email": "servis.prijem@bmwservis.rs",
    "phone": "+381-11-2010911",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/bmw-delta-auto-servis.html",
    "coords": {
      "lat": 44.8036003112793,
      "lng": 20.403230667114258
    }
  },
  {
    "id": "34268_1",
    "name": "Stefanovic Auto d.o.o",
    "country": "RS",
    "city": "Mladenovac",
    "address": "Beogradski Put BB, 11400 Mladenovac",
    "email": "office@bmw-stefanovic.com",
    "phone": "+381-8201900",
    "website": "https://www.bmw.rs/sr/fastlane/bmw-dileri/Stefanovic.html",
    "coords": {
      "lat": 44.487892150878906,
      "lng": 20.65727424621582
    }
  },
  {
    "id": "25913_1",
    "name": "М Кар Плевен ООД",
    "country": "BG",
    "city": "Плевен",
    "address": "кв. \"Дружба\" 1, 5800 Плевен",
    "email": "contact@bmw-mcarpleven.bg",
    "phone": "+359-64-970915",
    "website": "https://www.bmw-mcarpleven.bg",
    "coords": {
      "lat": 43.40386962890625,
      "lng": 24.635950088500977
    }
  },
  {
    "id": "31990_1",
    "name": "Дару Кар ЕАД Кв. Дружба",
    "country": "BG",
    "city": "София",
    "address": "ул. Илия Бешков 2, ж.к. Дружба I, 1592 София",
    "email": "contact@bmw-darucar.bg",
    "phone": "+359-2-9601603",
    "website": "http://www.bmw-darucar.bg",
    "coords": {
      "lat": 42.66188430786133,
      "lng": 23.40460777282715
    }
  },
  {
    "id": "47183_1",
    "name": "М Кар Уест ЕООД",
    "country": "BG",
    "city": "София",
    "address": " бул. Сливница 618, 1331 София",
    "email": "contact@bmw-mcarwest.bg",
    "phone": "+359-988-135824",
    "website": "https://www.bmw-mcarsofia.bg",
    "coords": {
      "lat": 42.74640655517578,
      "lng": 23.228239059448242
    }
  },
  {
    "id": "25914_2",
    "name": "М Кар Велико Търново ЕООД",
    "country": "BG",
    "city": "Велико Търново",
    "address": "Западна Индустриална зона, Ул. \"36-, 5000 Велико Търново",
    "email": "contact@bmw-mcartarnovo.bg",
    "phone": "+359-886575655",
    "website": "http://www.bmw-mcar.bg",
    "coords": {
      "lat": 43.08113098144531,
      "lng": 25.593000411987305
    }
  },
  {
    "id": "25914_1",
    "name": "М Кар ООД",
    "country": "BG",
    "city": "с. Труд",
    "address": "ул. Карловско шосе, № 16, 4199 с. Труд",
    "email": "contact@bmw-mcar.bg",
    "phone": "+359-32-906996",
    "website": "http://www.bmw-mcar.bg",
    "coords": {
      "lat": 42.20087814331055,
      "lng": 24.735300064086914
    }
  },
  {
    "id": "29657_1",
    "name": "М Кар Варна ООД",
    "country": "BG",
    "city": "Варна",
    "address": "бул. Владислав Варненчик 320, 9023 Варна",
    "email": "contact@bmw-mcarvarna.bg",
    "phone": "+359-52-705250",
    "website": "https://bmw-mcarvarna.bg/",
    "coords": {
      "lat": 43.227943420410156,
      "lng": 27.861671447753906
    }
  },
  {
    "id": "25916_1",
    "name": "Бова Кар ООД",
    "country": "BG",
    "city": "Бургас",
    "address": "Ул. Проф. Я. Якимов 11, 8000 Бургас",
    "email": "sales@bmw-bovacar.bg",
    "phone": "+359-56-860065",
    "website": "http://www.bmw-bovacar.bg",
    "coords": {
      "lat": 42.52460861206055,
      "lng": 27.44582176208496
    }
  },
  {
    "id": "45072_1",
    "name": "М Кар София",
    "country": "BG",
    "city": "София",
    "address": "бул. Черни връх 53, 1000 София",
    "email": "contact@bmw-mcarsofia.bg",
    "phone": "+359-24517800",
    "website": "https://www.bmw-mcarsofia.bg",
    "coords": {
      "lat": 42.657630920410156,
      "lng": 23.316434860229492
    }
  },
  {
    "id": "31519_4",
    "name": "Auto Bavaria OOD",
    "country": "BG",
    "city": "Sofia",
    "address": "5 Rezbraska str, 1510 Sofia",
    "email": "contact@bmw-autobavaria.bg",
    "phone": null,
    "website": "http://www.bmw-autobavaria.bg/",
    "coords": {
      "lat": 42.711238861083984,
      "lng": 23.3499813079834
    }
  },
  {
    "id": "31519_1",
    "name": "Ауто Бавария ООД",
    "country": "BG",
    "city": "София",
    "address": "Младост 4, Бизнес парк София №5, 1766 София",
    "email": "contact@bmw-autobavaria.bg",
    "phone": "+359-2-9766502",
    "website": "http://www.bmw-autobavaria.bg/",
    "coords": {
      "lat": 42.62405776977539,
      "lng": 23.377389907836914
    }
  },
  {
    "id": "33301_1",
    "name": "Русе Кар ЕАД",
    "country": "BG",
    "city": "Русе",
    "address": "ул. Капитан Райчо Николов, 7000 Русе",
    "email": "service@bmw-rusecar.bg",
    "phone": "+359-82-821111",
    "website": "https://www.bmw-service-rusecar.bg",
    "coords": {
      "lat": 43.81857681274414,
      "lng": 25.928552627563477
    }
  },
  {
    "id": "31519_2",
    "name": "Ауто Бавария ООД",
    "country": "BG",
    "city": "София",
    "address": "Бул. „Д-р Петър Дертлиев“ 42, 1335 София",
    "email": "contact@bmw-autobavaria.bg",
    "phone": "+359-2-9766565",
    "website": "http://www.bmw-autobavaria.bg/",
    "coords": {
      "lat": 42.711971282958984,
      "lng": 23.27375030517578
    }
  },
  {
    "id": "02899_3",
    "name": "Inchcape Auto UAB - Kaunas",
    "country": "LT",
    "city": "Kaunas",
    "address": "Veiveriu g. 150, 46391 Kaunas",
    "email": "kaunas@bmw.lt",
    "phone": "+370-66979520",
    "website": "https://www.krasta-auto.lt",
    "coords": {
      "lat": 54.863040924072266,
      "lng": 23.886859893798828
    }
  },
  {
    "id": "02899_2",
    "name": "Inchcape Auto UAB - Klaipeda",
    "country": "LT",
    "city": "Klaipeda",
    "address": "Svajones g. 40, 94101 Klaipeda",
    "email": "klaipeda@bmw.lt",
    "phone": null,
    "website": "https://www.krasta-auto.lt",
    "coords": {
      "lat": 55.68097686767578,
      "lng": 21.191144943237305
    }
  },
  {
    "id": "02899_1",
    "name": "Inchcape Auto UAB - Vilnius",
    "country": "LT",
    "city": "Vilnius",
    "address": "Ozo g. 10A, 08200 Vilnius",
    "email": "office@bmw.lt",
    "phone": "+370-64953016",
    "website": "https://www.krasta-auto.lt",
    "coords": {
      "lat": 54.71446990966797,
      "lng": 25.277847290039062
    }
  },
  {
    "id": "30503_1",
    "name": "WESS Select",
    "country": "LV",
    "city": "Riga",
    "address": "Karla Ulmana gatve 123, 2167 Riga",
    "email": "info@wess-select.lv",
    "phone": "+371-67004700",
    "website": "http://www.bmwwess.lv",
    "coords": {
      "lat": 56.92802810668945,
      "lng": 24.024232864379883
    }
  },
  {
    "id": "30393_1",
    "name": "Inchcape Motors Latvia SIA",
    "country": "LV",
    "city": "Riga",
    "address": "Dārzciema iela 64a, 1.stāvs,  1073  Riga",
    "email": "web.requests@inchcape.lv",
    "phone": "+371-67828600",
    "website": "https://bmw-inchcape.lv/",
    "coords": {
      "lat": 56.93777084350586,
      "lng": 24.18212890625
    }
  },
  {
    "id": "09243_5",
    "name": "United Motors AS, Peetri",
    "country": "EE",
    "city": "Peetri, Rae vald",
    "address": "Reti tee 4, 75312 Peetri, Rae vald",
    "email": "peetri@unitedmotors.ee",
    "phone": "+372-6630000",
    "website": "https://www.unitedmotors.ee",
    "coords": {
      "lat": 59.383201599121094,
      "lng": 24.83507537841797
    }
  },
  {
    "id": "49835_2",
    "name": "EurostAuto OÜ, Tallinn",
    "country": "EE",
    "city": "Tallinn",
    "address": "Kadaka tee 72a, Harju maakond, 12618 Tallinn",
    "email": "info@eurostauto.ee",
    "phone": "+372-67-10900",
    "website": null,
    "coords": {
      "lat": 59.4057502746582,
      "lng": 24.656797409057617
    }
  },
  {
    "id": "45396_2",
    "name": "Inchcape Motors Estonia OÜ, Tartu",
    "country": "EE",
    "city": "Soinaste  Küla",
    "address": "Välja tn 7, 61709 Soinaste  Küla",
    "email": "tartu@bmw.ee",
    "phone": "+372-730-2810",
    "website": "https://bmw.inchcape.ee",
    "coords": {
      "lat": 58.33622741699219,
      "lng": 26.711978912353516
    }
  },
  {
    "id": "09243_6",
    "name": "United Motors AS, Jõhvi SFL",
    "country": "EE",
    "city": "Jõhvi",
    "address": "Lääne 1b, 41533 Jõhvi",
    "email": "kjarve@unitedmotors.ee",
    "phone": "+372-6630400",
    "website": "https://www.unitedmotors.ee",
    "coords": {
      "lat": 59.367679595947266,
      "lng": 27.395957946777344
    }
  },
  {
    "id": "45396_1",
    "name": "Inchcape Motors Estonia OÜ,Tallinn",
    "country": "EE",
    "city": "Tallinn",
    "address": "Paldiski mnt. 108, 13522 Tallinn",
    "email": "bmw@bmw.ee",
    "phone": "+372-659-3740",
    "website": "https://bmw.inchcape.ee/",
    "coords": {
      "lat": 59.423126220703125,
      "lng": 24.643680572509766
    }
  },
  {
    "id": "45396_6",
    "name": "Inchcape Motors Estonia OÜ, Laagri",
    "country": "EE",
    "city": "Harju maakond",
    "address": "Pärnu mnt. 539, 76404 Harju maakond",
    "email": "info@inchcape.ee",
    "phone": "+372-659-3770",
    "website": "https://bmw.inchcape.ee/",
    "coords": {
      "lat": 59.340572357177734,
      "lng": 24.61764144897461
    }
  },
  {
    "id": "50941_1",
    "name": "Feltcar OÜ",
    "country": "EE",
    "city": "Pärnu",
    "address": "Ehitajate tee 18/2, 80010 Pärnu",
    "email": "kait.tamm@feltcar.ee",
    "phone": "+372-51-4433056",
    "website": null,
    "coords": {
      "lat": 58.403404235839844,
      "lng": 24.508554458618164
    }
  },
  {
    "id": "49835_1",
    "name": "EurostAuto OÜ",
    "country": "EE",
    "city": "Pärnu",
    "address": "Roheline 72, 80010 Pärnu",
    "email": "info.parnu@eurostauto.ee",
    "phone": "+372-44-76111",
    "website": "https://www.eurostauto.ee/teenindus/bmw-teenindus",
    "coords": {
      "lat": 58.406219482421875,
      "lng": 24.497364044189453
    }
  },
  {
    "id": "41552_1",
    "name": "Центр Херсон",
    "country": "UA",
    "city": "Херсон",
    "address": "Миколаївське шосе, 54., 73000 Херсон",
    "email": "salon@bmwcentre.ks.ua",
    "phone": "+380-552-416000",
    "website": "https://www.bmw.ks.ua",
    "coords": {
      "lat": 46.67117691040039,
      "lng": 32.5880241394043
    }
  },
  {
    "id": "43349_1",
    "name": "Талісман",
    "country": "UA",
    "city": "Черкаси",
    "address": "Зелінського, 1/9, 18030 Черкаси",
    "email": "bmw@talisman.net.ua",
    "phone": "+380-050-2100008",
    "website": "https://bmw.talisman.net.ua",
    "coords": {
      "lat": 49.40930938720703,
      "lng": 32.11530685424805
    }
  },
  {
    "id": "25188_1",
    "name": "Христина",
    "country": "UA",
    "city": "Львів",
    "address": "П'ясецького, 1, 79040 Львів",
    "email": "khrystyn@bmw.lviv.ua",
    "phone": "+380-32-2441907",
    "website": "https://www.bmw.lviv.ua",
    "coords": {
      "lat": 49.825504302978516,
      "lng": 23.937408447265625
    }
  },
  {
    "id": "45174_1",
    "name": "Форвард К",
    "country": "UA",
    "city": "Житомир",
    "address": "пр-т Незалежності, 170 А, 10009 Житомир",
    "email": "Customer_care@bmw.zt.ua",
    "phone": "+380-41-2433777",
    "website": "https://bmw.zt.ua/ua",
    "coords": {
      "lat": 50.27573013305664,
      "lng": 28.68191146850586
    }
  },
  {
    "id": "45570_1",
    "name": "АВТ Баварія Дніпро",
    "country": "UA",
    "city": "Дніпро",
    "address": "Панікахи, 5, 49041 Дніпро",
    "email": "bmw@bmw.dp.ua",
    "phone": "+380-95-4859595",
    "website": "https://bmw.dp.ua/ru",
    "coords": {
      "lat": 48.40339279174805,
      "lng": 35.03892135620117
    }
  },
  {
    "id": "31535_1",
    "name": "Баварія Захід",
    "country": "UA",
    "city": "Хмельницький",
    "address": "пр-т Миру, 103/1, 29015 Хмельницький",
    "email": "salon@bmw-zahid.km.ua",
    "phone": "+380-38-2785700",
    "website": "https://www.bmw-zahid.km.ua",
    "coords": {
      "lat": 49.43283462524414,
      "lng": 27.021717071533203
    }
  },
  {
    "id": "44379_1",
    "name": "Ідеал М",
    "country": "UA",
    "city": "Баранинці",
    "address": "Європейська, 1, 89425 Баранинці",
    "email": "info@bmwidealm.com",
    "phone": "+380-050-3284990",
    "website": "https://www.bmwidealm.com",
    "coords": {
      "lat": 48.57383346557617,
      "lng": 22.339826583862305
    }
  },
  {
    "id": "45571_3",
    "name": "АВТ Баварія Київ Аеропорт",
    "country": "UA",
    "city": "с. Гора",
    "address": "Бориспільська, буд.16-16/1, 08324 с. Гора",
    "email": "awt@bmw-kyiv.com.ua",
    "phone": "+380-44-3653333",
    "website": "https://bmw-kyiv.com.ua/ru",
    "coords": {
      "lat": 50.379817962646484,
      "lng": 30.844005584716797
    }
  },
  {
    "id": "47803_1",
    "name": "Альянс Преміум",
    "country": "UA",
    "city": "Івано Франківськ",
    "address": "Калуське шосе, 2 К, 76018 Івано Франківськ",
    "email": "office@bmw.if.ua",
    "phone": "+380-34-2744500",
    "website": "https://bmw.if.ua/ua",
    "coords": {
      "lat": 48.95217514038086,
      "lng": 24.6827449798584
    }
  },
  {
    "id": "25185_1",
    "name": "Емералд Моторс",
    "country": "UA",
    "city": "Одеса",
    "address": "пр-т Небесної Сотні, 2, 65101 Одеса",
    "email": "reception@bmw.odessa.ua",
    "phone": "+380-48-7405555",
    "website": "https://bmw.odessa.ua/ru",
    "coords": {
      "lat": 46.41440200805664,
      "lng": 30.71295738220215
    }
  },
  {
    "id": "43360_1",
    "name": "АФЦ Баварія",
    "country": "UA",
    "city": "Запоріжжя",
    "address": "пр-т Металургів, 34, 69006 Запоріжжя",
    "email": "afc@bmw.zp.ua",
    "phone": "+380-050-4448893",
    "website": "https://www.bmw.ua",
    "coords": {
      "lat": 47.85414123535156,
      "lng": 35.098812103271484
    }
  },
  {
    "id": "28387_1",
    "name": "Баварія Південь",
    "country": "UA",
    "city": "Миколаїв",
    "address": "Троїцька, 159/1, 54007 Миколаїв",
    "email": "finance_director@bmw-auto.net.ua",
    "phone": "+380-51-2555233",
    "website": "http://www.bmw.nikolaev.ua",
    "coords": {
      "lat": 46.97368240356445,
      "lng": 32.09562301635742
    }
  },
  {
    "id": "43047_1",
    "name": "Баварія Центр",
    "country": "UA",
    "city": "Вінниця",
    "address": "Лебединського, 19 А, 21034 Вінниця",
    "email": "info@bmw.vin.ua",
    "phone": "+380-43-2555995",
    "website": "https://www.bmw.vin.ua/ru",
    "coords": {
      "lat": 49.231414794921875,
      "lng": 28.515653610229492
    }
  },
  {
    "id": "45571_4",
    "name": "АВТ Баварія Київ",
    "country": "UA",
    "city": "Київ",
    "address": "бульвар Вацлава Гавела, буд. 4, 03124 Київ",
    "email": "awt@bmw-kyiv.com.ua",
    "phone": "+380-44-4907733",
    "website": "https://bmw-kyiv.com.ua/ru",
    "coords": {
      "lat": 50.447914123535156,
      "lng": 30.425222396850586
    }
  },
  {
    "id": "40422_1",
    "name": "Арія Моторс",
    "country": "UA",
    "city": "Львів",
    "address": "Городоцька, 174, 79000 Львів",
    "email": "sales@bmwlviv.com",
    "phone": "+380-322323500",
    "website": "https://www.bmwlviv.com",
    "coords": {
      "lat": 49.82724380493164,
      "lng": 23.910293579101562
    }
  },
  {
    "id": "25186_2",
    "name": "Бавария Моторс",
    "country": "UA",
    "city": "Харків",
    "address": "пр-т Гагаріна, 39, 61108 Харків",
    "email": "info@bmw.kharkov.ua",
    "phone": "+380-57-7276100",
    "website": "https://bmw.kharkov.ua/ru",
    "coords": {
      "lat": 50.098480224609375,
      "lng": 36.26520538330078
    }
  },
  {
    "id": "48352_1",
    "name": "Автосервіс-Альянс",
    "country": "UA",
    "city": "Полтава",
    "address": "Харківське шосе, 29, 36008 Полтава",
    "email": "info@bmw.poltava.ua",
    "phone": "+380-532-670077",
    "website": "http://www.bmw.poltava.ua/",
    "coords": {
      "lat": 49.5559196472168,
      "lng": 34.5439338684082
    }
  },
  {
    "id": "25190_1",
    "name": "Автосервіс Альянс",
    "country": "UA",
    "city": "Кременчук",
    "address": "Проїзд 40-років ДАІ, 1, 39600 Кременчук",
    "email": "alliance@bmw.pl.ua",
    "phone": "+380-053-6756081",
    "website": "http://bmw.pl.ua/ru",
    "coords": {
      "lat": 49.10966873168945,
      "lng": 33.41144943237305
    }
  },
  {
    "id": "01860_2",
    "name": "Abu Dhabi Motors LLC Khalidiya Showroom",
    "country": "AE",
    "city": "Abu Dhabi",
    "address": "32 Street, Khalidiya Corniche Road, 46468 Abu Dhabi",
    "email": "mark.lobbecke@alsaqergroup.com",
    "phone": "+971-2-6811700",
    "website": "https://www.bmw-abudhabi.com",
    "coords": {
      "lat": 24.466346740722656,
      "lng": 54.339630126953125
    }
  },
  {
    "id": "00415_4",
    "name": "AGMC LTD Showroom & Service",
    "country": "AE",
    "city": "Ras Al Khaimah",
    "address": "Al Dhait Street (Main Street), 9999 Ras Al Khaimah",
    "email": "bmw@agmc.ae",
    "phone": "+971-7-2355666",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.743896484375,
      "lng": 55.898746490478516
    }
  },
  {
    "id": "01860_3",
    "name": "Abu Dhabi Motors LLC Service, Bodyshop",
    "country": "AE",
    "city": "Abu Dhabi",
    "address": "Street 8, Zone 6, 9999 Abu Dhabi",
    "email": "bmw@alsaqergroup.com",
    "phone": "+971-2-4016333",
    "website": "https://www.bmw-abudhabi.com",
    "coords": {
      "lat": 24.368850708007812,
      "lng": 54.52259063720703
    }
  },
  {
    "id": "00415_5",
    "name": "AGMC LTD Body Shop",
    "country": "AE",
    "city": "Dubai",
    "address": "Al Barsha, 9999 Dubai",
    "email": "bmw@agmc.ae",
    "phone": "+971-4-3471175",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.121259689331055,
      "lng": 55.22939682006836
    }
  },
  {
    "id": "01860_4",
    "name": "Abu Dhabi Motors LLC",
    "country": "AE",
    "city": "Al Ain",
    "address": "Corner 12th and 14th Side Street, 26282 Al Ain",
    "email": "bmw@alsaqergroup.com",
    "phone": "+971-3-7026000",
    "website": "https://www.bmw-abudhabi.com",
    "coords": {
      "lat": 24.198610305786133,
      "lng": 55.760833740234375
    }
  },
  {
    "id": "00415_1",
    "name": "AGMC SZR Showroom",
    "country": "AE",
    "city": "Dubai",
    "address": "Sheikh Zayed Road Al Quoz 1, 00000 Dubai",
    "email": "bmw@agmc.ae",
    "phone": "+971-4-3391555",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.17436408996582,
      "lng": 55.24611282348633
    }
  },
  {
    "id": "00415_6",
    "name": "AGMC LTD Showroom & Service",
    "country": "AE",
    "city": "Fujairah",
    "address": "Highway No. E89, 9999 Fujairah",
    "email": "bmw@agmc.ae",
    "phone": "+971-9-2283333",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.128938674926758,
      "lng": 56.29304885864258
    }
  },
  {
    "id": "00415_7",
    "name": "AGMC LTD Service",
    "country": "AE",
    "city": "Dubai",
    "address": "Al Ettihad Street, 9999 Dubai",
    "email": "bmw@agmc.ae",
    "phone": "+971-4-2669520",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.26486587524414,
      "lng": 55.337154388427734
    }
  },
  {
    "id": "00415_10",
    "name": "AGMC Dubai Motor City Showroom",
    "country": "AE",
    "city": "Dubai",
    "address": "Turin Boulevard Road, Business Park, 9999 Dubai",
    "email": "customercare@agmc.ae",
    "phone": "+971-4-4070888",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.046371459960938,
      "lng": 55.23486328125
    }
  },
  {
    "id": "00415_3",
    "name": "AGMC LTD Showroom & Service",
    "country": "AE",
    "city": "Sharjah",
    "address": "Mohammad Bin Zayed, E311, 9999 Sharjah",
    "email": "bmw@agmc.ae",
    "phone": "+971-6-5182220",
    "website": "https://service.bmw-dubai.com/",
    "coords": {
      "lat": 25.33990478515625,
      "lng": 55.46970748901367
    }
  },
  {
    "id": "01860_1",
    "name": "Abu Dhabi Motors LLC",
    "country": "AE",
    "city": "Abu Dhabi",
    "address": "Airport Road, 99999 Abu Dhabi",
    "email": "bmw@alsaqergroup.com",
    "phone": "+971-2-5075800",
    "website": "https://www.bmw-abudhabi.com",
    "coords": {
      "lat": 24.417701721191406,
      "lng": 54.49445724487305
    }
  },
  {
    "id": "23757_1",
    "name": "Euromotors CJSC",
    "country": "AM",
    "city": "Arinj Community",
    "address": "1/1 Mashtots Street, 2210 Arinj Community",
    "email": "info@bmw.am",
    "phone": "+374-60-544060",
    "website": "https://www.bmw.am",
    "coords": {
      "lat": 40.233489990234375,
      "lng": 44.55936050415039
    }
  },
  {
    "id": "01338_4",
    "name": "Sergio Trepat Automóviles",
    "country": "AR",
    "city": "Acasusso",
    "address": "Av. del Libertador 14700, B1641ANP Acasusso",
    "email": "info@sergiotrepat.com",
    "phone": "54-005411-48970201",
    "website": "https://www.bmw.com.ar/sergio-trepat",
    "coords": {
      "lat": -34.47773361206055,
      "lng": -58.496482849121094
    }
  },
  {
    "id": "24876_5",
    "name": "Bremen Motors",
    "country": "AR",
    "city": "Belgrano",
    "address": "Juramento 1260, C1428DMN Belgrano",
    "email": "turnos@bremen.com.ar",
    "phone": "+54-11-47891000",
    "website": "https://www.bmw.com.ar/bremen-motors",
    "coords": {
      "lat": -34.55512237548828,
      "lng": -58.445072174072266
    }
  },
  {
    "id": "24874_1",
    "name": "A. Santos",
    "country": "AR",
    "city": "Del Viso",
    "address": "Panamericana Ramal Pilar km 40,5, B1669BUG Del Viso",
    "email": "adrian@santosbmw.com.ar",
    "phone": "+54-2320-400269",
    "website": "https://www.bmw.com.ar/adrian-santos",
    "coords": {
      "lat": -34.44361877441406,
      "lng": -58.76951599121094
    }
  },
  {
    "id": "33112_1",
    "name": "Auto Munich",
    "country": "AR",
    "city": "Córdoba",
    "address": "Sagrada Familia 332, X5003CFZ Córdoba",
    "email": "info@automunich.com.ar",
    "phone": "+54-351-4845500",
    "website": "https://www.bmw.com.ar/auto-munich",
    "coords": {
      "lat": -31.39649772644043,
      "lng": -64.2352294921875
    }
  },
  {
    "id": "31374_1",
    "name": "AutoPremier",
    "country": "AR",
    "city": "Ciudad de Buenos Aires",
    "address": "Av. Paseo Colón 1047, C1063ACM Ciudad de Buenos Aires",
    "email": "recepcion@autopremier.com.ar",
    "phone": "+54-1166648000",
    "website": "https://www.bmw.com.ar/autopremier",
    "coords": {
      "lat": -34.61986541748047,
      "lng": -58.36872482299805
    }
  },
  {
    "id": "24876_11",
    "name": "Bremen Motors",
    "country": "AR",
    "city": "Núñez",
    "address": "Av. Figueroa Alcorta 7730, C1428AAA Núñez",
    "email": "alcorta@bremen.com.ar",
    "phone": "+54-11-47890728",
    "website": "https://www.bmw.com.ar/bremen-motors",
    "coords": {
      "lat": -34.54658889770508,
      "lng": -58.45143127441406
    }
  },
  {
    "id": "01338_3",
    "name": "Sergio Trepat Automóviles",
    "country": "AR",
    "city": "Vicente López",
    "address": "Av. del Libertador 450, B1638BEQ Vicente López",
    "email": "info@sergiotrepat.com",
    "phone": "+54-11-47978800",
    "website": "https://www.bmw.com.ar/sergio-trepat",
    "coords": {
      "lat": -34.52995681762695,
      "lng": -58.46992874145508
    }
  },
  {
    "id": "01338_8",
    "name": "Sergio Trepat Automóviles",
    "country": "AR",
    "city": "Vicente López",
    "address": "Av. del Libertador 470, B1638BEQ Vicente López",
    "email": "info@sergiotrepat.com",
    "phone": "+54-11-47978800",
    "website": "https://www.bmw.com.ar/sergio-trepat",
    "coords": {
      "lat": -34.53010177612305,
      "lng": -58.46991729736328
    }
  },
  {
    "id": "32317_2",
    "name": "Genco Automóviles",
    "country": "AR",
    "city": "Mendoza",
    "address": "Rodríguez Peña 401, M5501NHJ Mendoza",
    "email": "recepcionbmw@gencosa.com.ar",
    "phone": "+54-261-4764012",
    "website": "https://www.bmw.com.ar/genco",
    "coords": {
      "lat": -32.92911148071289,
      "lng": -68.82534790039062
    }
  },
  {
    "id": "34943_1",
    "name": "Rhein Motor",
    "country": "AR",
    "city": "Bahía Blanca",
    "address": "Donado 228, B8000IYF Bahía Blanca",
    "email": "orlando.videla@rheinmotor.com.ar",
    "phone": "+54-291-4515190",
    "website": "https://www.bmw.com.ar/rhein-motor",
    "coords": {
      "lat": -38.72275924682617,
      "lng": -62.2675895690918
    }
  },
  {
    "id": "34839_4",
    "name": "Berlín Motors",
    "country": "AR",
    "city": "Tres Cerritos",
    "address": "Reyes Católicos 1501, A4408KRD Tres Cerritos",
    "email": "info@berlinmotors.com.ar",
    "phone": "+54-387-4390955",
    "website": "https://www.bmw.com.ar/berlin-salta",
    "coords": {
      "lat": -24.770641326904297,
      "lng": -65.39781951904297
    }
  },
  {
    "id": "24876_6",
    "name": "Bremen Motors",
    "country": "AR",
    "city": "Belgrano",
    "address": "Juramento1260, C1428DMN Belgrano",
    "email": "jc.belcastro@bremen.com.ar",
    "phone": "+54-11-47891000",
    "website": "https://www.bmw.com.ar",
    "coords": {
      "lat": -34.55512237548828,
      "lng": -58.445072174072266
    }
  },
  {
    "id": "34839_2",
    "name": "Berlín Motors",
    "country": "AR",
    "city": "Yerba Buena",
    "address": "Av. Aconquija 640, T4107CDT Yerba Buena",
    "email": "info@berlinmotors.com.ar",
    "phone": "+54-381-4255612",
    "website": "https://www.bmw.com.ar/berlin-tucuman",
    "coords": {
      "lat": -26.816638946533203,
      "lng": -65.27510070800781
    }
  },
  {
    "id": "24875_1",
    "name": "Bell Motors",
    "country": "AR",
    "city": "City Bell - La Plata",
    "address": "Camino Centenario 1259, B1896IDY City Bell - La Plata",
    "email": "ventas@bellmotors.com",
    "phone": "+54-221-4800505",
    "website": "https://www.bmw.com.ar/bell-motors",
    "coords": {
      "lat": -34.86225128173828,
      "lng": -58.05528259277344
    }
  },
  {
    "id": "01338_2",
    "name": "Sergio Trepat Automóviles",
    "country": "AR",
    "city": "Olivos",
    "address": "Av. del Libertador 2340, B1636DSC Olivos",
    "email": "info@sergiotrepat.com",
    "phone": "+54-11-47947500",
    "website": "https://www.bmw.com.ar/sergio-trepat",
    "coords": {
      "lat": -34.50937271118164,
      "lng": -58.478912353515625
    }
  },
  {
    "id": "24871_1",
    "name": "Natalio Automotores",
    "country": "AR",
    "city": "Rosario",
    "address": "Jujuy 2350, S2000JHD Rosario",
    "email": "giselle.strallnicoff@natalio.com.ar",
    "phone": "+54-341-4352020",
    "website": "https://www.bmw.com.ar/natalio",
    "coords": {
      "lat": -32.935115814208984,
      "lng": -60.65348434448242
    }
  },
  {
    "id": "24876_2",
    "name": "Bremen Motors",
    "country": "AR",
    "city": "Capital Federal",
    "address": "Av. del Libertador 2230, C1425AAV Capital Federal",
    "email": "libertador@bremen.com.ar",
    "phone": "+54-11-48052700",
    "website": "https://www.bmw.com.ar/bremen-motors",
    "coords": {
      "lat": -34.580726623535156,
      "lng": -58.40435028076172
    }
  },
  {
    "id": "34943_2",
    "name": "Rhein Motor",
    "country": "AR",
    "city": "Bahía Blanca",
    "address": "Saavedra 257, B8000DDE Bahía Blanca",
    "email": "orlando.videla@rheinmotor.com.ar",
    "phone": "+54-291-4526269",
    "website": "https://www.bmw.com.ar/rhein-motor",
    "coords": {
      "lat": -38.722965240478516,
      "lng": -62.26662826538086
    }
  },
  {
    "id": "44009_1",
    "name": "Ultimate Automoviles N.V.",
    "country": "AW",
    "city": "Oranjestad, Aruba",
    "address": "Sabana Blanco 35, null Oranjestad, Aruba",
    "email": null,
    "phone": "+297-5839800",
    "website": null,
    "coords": {
      "lat": 12.50711441040039,
      "lng": -70.0120620727539
    }
  },
  {
    "id": "25756_4",
    "name": "AUTO CENTAR TOMIC DOO BANJA LUKA",
    "country": "BA",
    "city": "Banja Luka",
    "address": "Trive Amelice 1b, 78000 Banja Luka",
    "email": "ljubinka.jauz@tomic.ba",
    "phone": "+387-51-322120",
    "website": "https://www.bmw.ba",
    "coords": {
      "lat": 44.7848014831543,
      "lng": 17.202945709228516
    }
  },
  {
    "id": "25756_3",
    "name": "AUTO CENTAR TOMIC DOO SARAJEVO",
    "country": "BA",
    "city": "Sarajevo",
    "address": "Trg medunarodnog prijateljstva 24, 71000 Sarajevo",
    "email": "eldin.balihodzic@tomic.ba",
    "phone": "+387-33-766905",
    "website": "https://www.bmw.ba",
    "coords": {
      "lat": 43.845611572265625,
      "lng": 18.346389770507812
    }
  },
  {
    "id": "25756_1",
    "name": "AUTO CENTAR TOMIC DOO MOSTAR",
    "country": "BA",
    "city": "Mostar",
    "address": "Bisce polje bb, 88000 Mostar",
    "email": "boris.delic@tomic.ba",
    "phone": "+387-36-351341",
    "website": "https://www.bmw.ba",
    "coords": {
      "lat": 43.30276107788086,
      "lng": 17.829675674438477
    }
  },
  {
    "id": "52022_1",
    "name": "F & B Automotive Art Inc",
    "country": "BB",
    "city": "St. Thomas",
    "address": "Welches, BB22025 St. Thomas",
    "email": "TMartin@bmwcaribbeanhub.com",
    "phone": "+1246-4261800",
    "website": null,
    "coords": {
      "lat": 13.154950141906738,
      "lng": -59.61275100708008
    }
  },
  {
    "id": "21559_1",
    "name": "Euro Motors Co. W. L.L. Showroom and Service",
    "country": "BH",
    "city": "Manama",
    "address": "Euro Motors Road 1135, Block 611, 9999 Manama",
    "email": "euromotors@euromotors.com.bh",
    "phone": "+973-17750750",
    "website": "https://www.bmw-bahrain.com",
    "coords": {
      "lat": 26.154436111450195,
      "lng": 50.6113395690918
    }
  },
  {
    "id": "47713_1",
    "name": "BMW Cotonou",
    "country": "BJ",
    "city": "Cotonou",
    "address": "Avenue Van Vollen Hoven, 01, 0 Cotonou",
    "email": "contact@lesbagnoles.com",
    "phone": "+229-21310002",
    "website": null,
    "coords": {
      "lat": 6.359823226928711,
      "lng": 2.42897629737854
    }
  },
  {
    "id": "33908_1",
    "name": "Andar Motors S.A. Santa Cruz",
    "country": "BO",
    "city": "Santa Cruz de la Sierra",
    "address": "Av. Marcelo Terceros Banzer # 358, 00000 Santa Cruz de la Sierra",
    "email": "rodrigo.capobianco@bmw-andar.bo",
    "phone": "+591-3-345-2665",
    "website": "https://www.bmw.com.bo",
    "coords": {
      "lat": -17.76142120361328,
      "lng": -63.19303512573242
    }
  },
  {
    "id": "33908_3",
    "name": "Andar Motors S.A. La Paz",
    "country": "BO",
    "city": "La Paz",
    "address": "Calle 16 Obrajes, 15000 La Paz",
    "email": "rene.aguirre@bmw-andar.bo",
    "phone": "+591-2-2150505",
    "website": "https://www.bmw.com.bo",
    "coords": {
      "lat": -16.528501510620117,
      "lng": -68.10199737548828
    }
  },
  {
    "id": "37257_1",
    "name": "Master Motors",
    "country": "BO",
    "city": "Cochabamba",
    "address": "Av. America Oeste 715, null Cochabamba",
    "email": "manfred.g@bmw-master.com",
    "phone": "+591-4--4281411",
    "website": "https://www.bmw.com.bo",
    "coords": {
      "lat": -17.372346878051758,
      "lng": -66.1700210571289
    }
  },
  {
    "id": "32130_1",
    "name": "АВТОИДЕЯ",
    "country": "BY",
    "city": "Минск",
    "address": "Юбилейная 4, 223043 Минск",
    "email": "info@autoidea.by",
    "phone": "+375-17-2320000",
    "website": "https://www.autoidea.by",
    "coords": {
      "lat": 53.97224426269531,
      "lng": 27.58966064453125
    }
  },
  {
    "id": "10307_1",
    "name": "Williamson Balfour La Dehesa",
    "country": "CL",
    "city": "Santiago de Chile",
    "address": "Avda. La Dehesa No. 265, 7690000 Santiago de Chile",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -33.36350631713867,
      "lng": -70.5146255493164
    }
  },
  {
    "id": "10307_4",
    "name": "Williamson Balfour Motors Viña del",
    "country": "CL",
    "city": "Viña del Mar",
    "address": "Avda. Libertad 841, 2520072 Viña del Mar",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -33.01394271850586,
      "lng": -71.54981994628906
    }
  },
  {
    "id": "10307_17",
    "name": "BPS La Serena Williamson Balfour Motors SpA",
    "country": "CL",
    "city": "Coquimbo",
    "address": "Av. Balmaceda 1450, Coquimbo, null Coquimbo",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -29.91398048400879,
      "lng": -71.25164031982422
    }
  },
  {
    "id": "10307_22",
    "name": "La Serena Williamson Balfour Motors SpA La Serena, Carmona",
    "country": "CL",
    "city": "La Serena",
    "address": "Av. Balmaceda 5508, 1700000 La Serena",
    "email": "wbm@inchcape.cl",
    "phone": "+56-051-2512200200",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -29.94646453857422,
      "lng": -71.26651763916016
    }
  },
  {
    "id": "10307_27",
    "name": "Body & Paint Williamson Balfour Motors SpA",
    "country": "CL",
    "city": "Santiago",
    "address": "Lo Boza 422, Parque 3, Pudahuel, 9020000 Santiago",
    "email": "benjamin.borquez@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -33.37764358520508,
      "lng": -70.7743911743164
    }
  },
  {
    "id": "10307_26",
    "name": "Punta Arenas Williamson Balfour Motors SpA Recasur",
    "country": "CL",
    "city": "Punta Arenas",
    "address": "Av. Oriente Poniente, Manzana 22, 9430199 Punta Arenas",
    "email": "rodolfogonzalez@recasur.cl",
    "phone": "+56-961585298",
    "website": null,
    "coords": {
      "lat": -53.133689880371094,
      "lng": -70.87106323242188
    }
  },
  {
    "id": "10307_21",
    "name": "Antofagasta Williamson Balfour Motors SpA Antofagasta BPS",
    "country": "CL",
    "city": "Antofagasta",
    "address": "Mall Parque Angamos, 1270236 Antofagasta",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -23.69485092163086,
      "lng": -70.41619873046875
    }
  },
  {
    "id": "10307_25",
    "name": "Williamson Balfour Motors SpA Antofagasta Servicio",
    "country": "CL",
    "city": "Antofagasta",
    "address": "Av. Pedro Aguirre Cerda 7903, null Antofagasta",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6004220330",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -23.596023559570312,
      "lng": -70.38990020751953
    }
  },
  {
    "id": "10307_7",
    "name": "Williamson Balfour Motors Bilbao",
    "country": "CL",
    "city": "Santiago de Chile",
    "address": "Avda. Francisco Bilbao 2245, 7510978 Santiago de Chile",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw-motorrad.cl",
    "coords": {
      "lat": -33.43766403198242,
      "lng": -70.60357666015625
    }
  },
  {
    "id": "10307_15",
    "name": "Williamson Balfour Motors SpA Viña del Mar",
    "country": "CL",
    "city": "Viña del Mar",
    "address": "5 Oriente 825, 2531049 Viña del Mar",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -33.01552963256836,
      "lng": -71.54322052001953
    }
  },
  {
    "id": "10307_6",
    "name": "Williamson Balfour Motors",
    "country": "CL",
    "city": "Concepción",
    "address": "Avda. Paicaví 1200, 4060429 Concepción",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw-motorrad.cl",
    "coords": {
      "lat": -36.80754470825195,
      "lng": -73.0522232055664
    }
  },
  {
    "id": "10307_19",
    "name": "Talca Williamson Balfour Motors SpA Talca BPS",
    "country": "CL",
    "city": "Maule",
    "address": "Calle 1 Nte. 2135, 348009 Maule",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -35.42646408081055,
      "lng": -71.6391372680664
    }
  },
  {
    "id": "10307_28",
    "name": "Williamson Balfour Motors SpA",
    "country": "CL",
    "city": "Santiago de Chile",
    "address": "Av. Americo Vespucio 1155, Local G2, 8590482 Santiago de Chile",
    "email": "wbm@inchcape.cl",
    "phone": "+56-6006001323",
    "website": "https://www.bmw.cl",
    "coords": {
      "lat": -33.370452880859375,
      "lng": -70.66498565673828
    }
  },
  {
    "id": "01930_11",
    "name": "Autogermana S.A. Bucaramanga",
    "country": "CO",
    "city": "Bucaramanga",
    "address": "Calle 58 No 27 -51, 680003 Bucaramanga",
    "email": "andres.chaves@autogermana.com.co",
    "phone": "+57-6076973024",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 7.108497142791748,
      "lng": -73.11343383789062
    }
  },
  {
    "id": "25808_1",
    "name": "Vessgo Ltda. Vessgo Pasadena",
    "country": "CO",
    "city": "Bogota, D.C.",
    "address": "Carrera 53  #103B - 20, 111111 Bogota, D.C.",
    "email": "joaquin@vessgo.com",
    "phone": "+57-6016167753",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.6912841796875,
      "lng": -74.06254577636719
    }
  },
  {
    "id": "25809_1",
    "name": "M-tech",
    "country": "CO",
    "city": "Bogota, D.C.",
    "address": "Carrera 19 # 103 - 22, 110111 Bogota, D.C.",
    "email": "kputh@m-techltda.com",
    "phone": "+57-6012573713",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.689009189605713,
      "lng": -74.0512924194336
    }
  },
  {
    "id": "01930_3",
    "name": "Autogermana S.A. Bogotá Servicio",
    "country": "CO",
    "city": "Bogotá D.C.",
    "address": "Cra 50 17 - 29, 111611 Bogotá D.C.",
    "email": "carlos.arias@autogermana.com.co",
    "phone": "+57-6016578080",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.630467891693115,
      "lng": -74.10498809814453
    }
  },
  {
    "id": "01930_1",
    "name": "Autogermana S.A. Bogotá",
    "country": "CO",
    "city": "Bogotá D.C.",
    "address": "Calle 127B 7-15, 110121 Bogotá D.C.",
    "email": "info@autogermana.com.co",
    "phone": "+57-6016578080",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.704010009765625,
      "lng": -74.02884674072266
    }
  },
  {
    "id": "01930_13",
    "name": "Autogermana Medellin Autogermana S.A.S.",
    "country": "CO",
    "city": "Medellin",
    "address": "Carrera 42 # 03 Sur - 81, 050022 Medellin",
    "email": "edwin.santiago@autogermana.com.co",
    "phone": "+57-6042329086",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 6.199460983276367,
      "lng": -75.57270812988281
    }
  },
  {
    "id": "01930_7",
    "name": "Autogermana S.A. Pereira",
    "country": "CO",
    "city": "Pereira",
    "address": "Av Circunvalar 13-40 Uniplex L 10, 660003 Pereira",
    "email": "andres.chaves@autogermana.com.co",
    "phone": "+57-6063400561",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.808699131011963,
      "lng": -75.69026947021484
    }
  },
  {
    "id": "01930_15",
    "name": "Autogermana S.A.S.",
    "country": "CO",
    "city": "Bogota, D.C.",
    "address": "Calle 198 # 22-81, 110141 Bogota, D.C.",
    "email": "carlos.monsalve@autogermana.com.co",
    "phone": "+57-6016578080",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.776537895202637,
      "lng": -74.04179382324219
    }
  },
  {
    "id": "25808_2",
    "name": "Vessgo Carrera 69 Vessgo Ltda. Vessgo Morato",
    "country": "CO",
    "city": "Bogota, D.C.",
    "address": "Carrera 69# 98A - 49, 111121 Bogota, D.C.",
    "email": "joaquin@vessgo.com",
    "phone": "+57-6016167753",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.691952228546143,
      "lng": -74.07527160644531
    }
  },
  {
    "id": "01930_2",
    "name": "Autogermana S.A. Medellín",
    "country": "CO",
    "city": "Medellín",
    "address": "Cra 43 A No. 19 - 109, 050021 Medellín",
    "email": "joaquin.saenz@autogermana.com.co",
    "phone": "+57-604-2329086",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 6.221449851989746,
      "lng": -75.56968688964844
    }
  },
  {
    "id": "01930_8",
    "name": "Autogermana S.A. Pereira  Servicio",
    "country": "CO",
    "city": "Pereira",
    "address": "Av 30 de Agosto Cl 94 14-73, 660003 Pereira",
    "email": "martin.gomez@autogermana.com.co",
    "phone": "+57-6063400561",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.8116350173950195,
      "lng": -75.75777435302734
    }
  },
  {
    "id": "01930_4",
    "name": "The BMW Store",
    "country": "CO",
    "city": "Bogotá D.C.",
    "address": "Carrera 9 No. 80-12 Of. 202, 110221 Bogotá D.C.",
    "email": "csaenz@thebmwstore.com.co",
    "phone": "+57-6013170060",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.663308143615723,
      "lng": -74.05169677734375
    }
  },
  {
    "id": "01930_6",
    "name": "Autogermana S.A. Bogotá Servicio",
    "country": "CO",
    "city": "Bogotá D.C.",
    "address": "Carrera 45 No 197-35, 111166 Bogotá D.C.",
    "email": "guillermo.garcia@autogermana.com.co",
    "phone": "+57-6016578080",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.77672815322876,
      "lng": -74.0443115234375
    }
  },
  {
    "id": "32424_1",
    "name": "Automunich Barranquilla",
    "country": "CO",
    "city": "Barranquilla",
    "address": "Av. Circunvalar entre Cra 46 y 43, 080020 Barranquilla",
    "email": "bqgerencia@automunich.com.co",
    "phone": "+57-6053670150",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 11.000009536743164,
      "lng": -74.8415298461914
    }
  },
  {
    "id": "32425_1",
    "name": "Auto Bonn",
    "country": "CO",
    "city": "Cali",
    "address": "Calle 18 No. 122-230, 760041 Cali",
    "email": "gburbano@gmail.com",
    "phone": "+57-6024896985",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 11.000009536743164,
      "lng": -74.8415298461914
    }
  },
  {
    "id": "01930_10",
    "name": "Autogermana S.A. Ibagué",
    "country": "CO",
    "city": "Ibague",
    "address": "Carrera 16 Sur 90 - 66, 730010 Ibague",
    "email": "German.Kairuz@autogermana.com.co",
    "phone": "+57-6082770580",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 4.420266151428223,
      "lng": -75.18189239501953
    }
  },
  {
    "id": "32425_2",
    "name": "Auto Bonn Norte",
    "country": "CO",
    "city": "Cali",
    "address": "Av. 6A Norte # 40 - 41, 760046 Cali",
    "email": "gburbano@gmail.com",
    "phone": "+57-6024896984",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 3.4794700145721436,
      "lng": -76.52599334716797
    }
  },
  {
    "id": "32425_3",
    "name": "Auto Bonn Norte",
    "country": "CO",
    "city": "Cali",
    "address": "Av. 6 Norte #40N -17, 760046 Cali",
    "email": "gburbano@gmail.com",
    "phone": "+57-6024896985",
    "website": "https://www.bmw.com.co/es/index.html",
    "coords": {
      "lat": 3.4799909591674805,
      "lng": -76.5250015258789
    }
  },
  {
    "id": "33416_1",
    "name": "Bavarian Motors CR, S.A.",
    "country": "CR",
    "city": "San José",
    "address": "La Uruca, costado sur de la Delta, 10107 San José",
    "email": "arubi@grupobmw.com",
    "phone": "+506-25475000",
    "website": "https://www.bmw.co.cr",
    "coords": {
      "lat": 9.947525978088379,
      "lng": -84.09166717529297
    }
  },
  {
    "id": "33416_5",
    "name": "Pinares Curridabat",
    "country": "CR",
    "city": "San José",
    "address": "Carretera Vieja a Tres Rios, 11801 San José",
    "email": "arubi@grupobmw.com",
    "phone": "+506/-2547-5000",
    "website": "https://www.bmw.co.cr",
    "coords": {
      "lat": 9.911346435546875,
      "lng": -84.0221176147461
    }
  },
  {
    "id": "33416_2",
    "name": "Escazu",
    "country": "CR",
    "city": "San José",
    "address": "700 metros Sur de Multiplaza, 10201 San José",
    "email": "arubi@grupobmw.com",
    "phone": "+506/-2547-5000",
    "website": "https://www.bmw.co.cr",
    "coords": {
      "lat": 9.93765640258789,
      "lng": -84.15196228027344
    }
  },
  {
    "id": "00213_4",
    "name": "Char. Pilakoutas Ltd.",
    "country": "CY",
    "city": "Paphos",
    "address": "83 Mesogis Avenue, 8820 Paphos",
    "email": "bmwpaf@pilakoutasgroup.com.cy",
    "phone": "+357-2-2586560",
    "website": "https://www.bmw.com.cy",
    "coords": {
      "lat": 34.8036994934082,
      "lng": 32.444740295410156
    }
  },
  {
    "id": "00213_1",
    "name": "Char. Pilakoutas Ltd.",
    "country": "CY",
    "city": "Nicosia",
    "address": "10 Meteoron Street, 2032 Nicosia",
    "email": "bmwsales@pilakoutasgroup.com.cy",
    "phone": "+357-2-2586100",
    "website": "https://www.bmw.com.cy",
    "coords": {
      "lat": 35.12545394897461,
      "lng": 33.364166259765625
    }
  },
  {
    "id": "00213_6",
    "name": "Char. Pilakoutas Ltd.",
    "country": "CY",
    "city": "Limassol",
    "address": "101 Paphos Street, 4152 Limassol",
    "email": "marinos@pilakoutasgroup.com.cy",
    "phone": "+357-2-2586500",
    "website": "https://www.bmw.com.cy",
    "coords": {
      "lat": 34.67585754394531,
      "lng": 33.00721740722656
    }
  },
  {
    "id": "00213_7",
    "name": "Char. Pilakoutas Ltd.",
    "country": "CY",
    "city": "Paphos",
    "address": "Industrial Area Anatolikou, 8250 Paphos",
    "email": "gazas@pilakoutasgroup.com.cy",
    "phone": "+357-2-2586570",
    "website": "https://www.bmw.com.cy",
    "coords": {
      "lat": 34.74787139892578,
      "lng": 32.4913215637207
    }
  },
  {
    "id": "36394_1",
    "name": "C. Christodoulou Lefkosia Premier C",
    "country": "CY",
    "city": "Latsia",
    "address": "1 Kilkis st., 2234 Latsia",
    "email": "chris.cclpc@cytanet.com.cy",
    "phone": "+357-2-2815100",
    "website": "https://www.bmw.com.cy",
    "coords": {
      "lat": 35.0826301574707,
      "lng": 33.38409423828125
    }
  },
  {
    "id": "49720_1",
    "name": "Koed Vejle A/S",
    "country": "DK",
    "city": "Vejle, Øst",
    "address": "Wittrupvej 1, 7120 Vejle, Øst",
    "email": "service.vejle@koed.dk",
    "phone": "+45-71-747505",
    "website": null,
    "coords": {
      "lat": 55.729339599609375,
      "lng": 9.598464012145996
    }
  },
  {
    "id": "07935_1",
    "name": "Jens Winther Automobiler APS",
    "country": "DK",
    "city": "Roskilde",
    "address": "Maglegårdsvej 5, 4000 Roskilde",
    "email": "service@jenswinther.dk",
    "phone": "+45-46-305200",
    "website": "https://www.jenswinther.dk",
    "coords": {
      "lat": 55.629302978515625,
      "lng": 12.079041481018066
    }
  },
  {
    "id": "27764_1",
    "name": "Jan Nygaard AS, Lyngby",
    "country": "DK",
    "city": "Lyngby",
    "address": "Firskovvej 31-33, 2800 Lyngby",
    "email": "info@jan-nygaard.dk",
    "phone": "+45-45-886600",
    "website": "https://www.jan-nygaard.dk",
    "coords": {
      "lat": 55.7700309753418,
      "lng": 12.5181303024292
    }
  },
  {
    "id": "30688_1",
    "name": "Sand-Jensen Automobiler A/S",
    "country": "DK",
    "city": "Silkeborg",
    "address": "Viborgvej 7-13, 8600 Silkeborg",
    "email": "info@sandjensen.dk",
    "phone": "+45-86-827200",
    "website": "https://www.sandjensen.dk",
    "coords": {
      "lat": 56.184940338134766,
      "lng": 9.54362964630127
    }
  },
  {
    "id": "52778_1",
    "name": "Koed Viborg A/S",
    "country": "DK",
    "city": "Viborg",
    "address": "Katmosevej 1, 8800 Viborg",
    "email": "service.viborg@koed.dk",
    "phone": "+45-87271700",
    "website": null,
    "coords": {
      "lat": 56.44940185546875,
      "lng": 9.382596969604492
    }
  },
  {
    "id": "49102_1",
    "name": "Hyrup & Nielsen A/S",
    "country": "DK",
    "city": "Lynge",
    "address": "Industriskellet 4, 3540 Lynge",
    "email": "info@nhauto.dk",
    "phone": "+45-70226622",
    "website": null,
    "coords": {
      "lat": 55.83103942871094,
      "lng": 12.304521560668945
    }
  },
  {
    "id": "50715_1",
    "name": "Nielsen Car Group Bilernes Hus A/S",
    "country": "DK",
    "city": "Silkeborg",
    "address": "Bredhøjvej 5, 8600 Silkeborg",
    "email": "info@bilerneshus.dk",
    "phone": "+45-72-100200",
    "website": "https://www.bilerneshus.dk",
    "coords": {
      "lat": 56.18870162963867,
      "lng": 9.555985450744629
    }
  },
  {
    "id": "53138_1",
    "name": "Bayern AutoGroup Kolding A/S",
    "country": "DK",
    "city": "Kolding",
    "address": "Trianglen 5, 6000 Kolding",
    "email": "info.kolding@bag.dk",
    "phone": "+45-70-112277",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 55.5322151184082,
      "lng": 9.464912414550781
    }
  },
  {
    "id": "53138_3",
    "name": "Bayern AutoGroup Odense A/S",
    "country": "DK",
    "city": "Odense S",
    "address": "Sivmosevænget 1, 5260 Odense S",
    "email": "info.odense@bag.dk",
    "phone": "+45-66-123333",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 55.35371398925781,
      "lng": 10.403850555419922
    }
  },
  {
    "id": "27764_5",
    "name": "Jan Nygaard København AS",
    "country": "DK",
    "city": "Kastrup",
    "address": "Englandsvej 389, 2770 Kastrup",
    "email": "indskrivningamager@jan-nygaard.dk",
    "phone": "+45-32-594611",
    "website": "https://www.jan-nygaard.dk",
    "coords": {
      "lat": 55.621986389160156,
      "lng": 12.605358123779297
    }
  },
  {
    "id": "40401_1",
    "name": "Concept Biler ApS",
    "country": "DK",
    "city": "Næstved",
    "address": "Jernbuen 4, 4700 Næstved",
    "email": "Info@conceptbiler.dk",
    "phone": "+45-55-720263",
    "website": "https://www.conceptbiler.dk",
    "coords": {
      "lat": 55.253753662109375,
      "lng": 11.80126667022705
    }
  },
  {
    "id": "54707_1",
    "name": "P/F Wenzel",
    "country": "DK",
    "city": "Torshavn",
    "address": "Gamli Velbastaðvegur 15, 0100 Torshavn",
    "email": "verkstad@wenzel.fo",
    "phone": "+298-354500",
    "website": null,
    "coords": {
      "lat": 61.99956512451172,
      "lng": -6.803130626678467
    }
  },
  {
    "id": "07983_1",
    "name": "Autoleth A/S",
    "country": "DK",
    "city": "Haderslev",
    "address": "Gammel Christiansfeldvej 51, 6100 Haderslev",
    "email": "info@utoleth.dk",
    "phone": "+45-74-532444",
    "website": "https://www.autoleth.dk",
    "coords": {
      "lat": 55.26670837402344,
      "lng": 9.49493408203125
    }
  },
  {
    "id": "07939_1",
    "name": "Jørgen Mølgaard A/S",
    "country": "DK",
    "city": "Ringsted",
    "address": "Frejasvej 12, 4100 Ringsted",
    "email": "vaerksted@jmas.dk",
    "phone": "+45-57-614488",
    "website": "https://www.jmas.dk",
    "coords": {
      "lat": 55.43053436279297,
      "lng": 11.801130294799805
    }
  },
  {
    "id": "53138_6",
    "name": "Bayern AutoGroup Holstebro A/S",
    "country": "DK",
    "city": "Holstebro",
    "address": "Jens Baggesens Vej 3-5, 7500 Holstebro",
    "email": "info.holstebro@bag.dk",
    "phone": "+45-97-423033",
    "website": "http://www.bag.dk/forhandlere/holstebro",
    "coords": {
      "lat": 56.37089157104492,
      "lng": 8.628113746643066
    }
  },
  {
    "id": "07988_2",
    "name": "Bilhuset Haldrup Randers A/S",
    "country": "DK",
    "city": "Randers",
    "address": "Århusvej 108, 8940 Randers",
    "email": "randers@bilhuset-haldrup.dk",
    "phone": "+45-86-427800",
    "website": "https://www.bilhusethaldrup.dk",
    "coords": {
      "lat": 56.438209533691406,
      "lng": 10.050674438476562
    }
  },
  {
    "id": "27764_6",
    "name": "Jan Nygaard AS, Ishøj",
    "country": "DK",
    "city": "Ishøj",
    "address": "Baldersbækvej 13, 2635 Ishøj",
    "email": "indskrivningishoej@jan-nygaard.dk",
    "phone": "+45-43-459933",
    "website": "https://www.jan-nygaard.bmw.dk",
    "coords": {
      "lat": 55.61931228637695,
      "lng": 12.323119163513184
    }
  },
  {
    "id": "53138_8",
    "name": "Bayern AutoGroup SFL Sønderborg",
    "country": "DK",
    "city": "Sønderborg",
    "address": "Nørrekobbel 1, 6400 Sønderborg",
    "email": "bmwparts@alsmotor.dk",
    "phone": "+45-87-430300",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 54.9228401184082,
      "lng": 9.784174919128418
    }
  },
  {
    "id": "53982_1",
    "name": "Procar A/S",
    "country": "DK",
    "city": "Køge",
    "address": "Industrivej 1, 4600 Køge",
    "email": "uw@procar.dk",
    "phone": "+45-70707107",
    "website": "https://www.procar-automobiler.dk/",
    "coords": {
      "lat": 55.50420379638672,
      "lng": 12.198432922363281
    }
  },
  {
    "id": "07949_1",
    "name": "Ejvind Nielsen Automobiler A/S",
    "country": "DK",
    "city": "Hobro",
    "address": "Hostrupvej 79-81, 9500 Hobro",
    "email": "info@ejvindnielsen.dk",
    "phone": "+45-98-523111",
    "website": "https://www.ejvindnielsen.dk",
    "coords": {
      "lat": 56.64834976196289,
      "lng": 9.793279647827148
    }
  },
  {
    "id": "53138_5",
    "name": "Bayern AutoGroup Esbjerg A/S",
    "country": "DK",
    "city": "Esbjerg",
    "address": "Storstrømvej 4, 6715 Esbjerg",
    "email": "info.esbjerg@bag.dk",
    "phone": "+45-76-140600",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 55.50720977783203,
      "lng": 8.47046184539795
    }
  },
  {
    "id": "07958_1",
    "name": "Arne Poulsen Automobiler A/S",
    "country": "DK",
    "city": "Herning",
    "address": "Dueoddevej 1, 7400 Herning",
    "email": "info@a-poulsen.dk",
    "phone": "+45-97-223122",
    "website": "https://www.arne-poulsen.dk",
    "coords": {
      "lat": 56.155860900878906,
      "lng": 8.976590156555176
    }
  },
  {
    "id": "27764_3",
    "name": "Jan Nygaard AS, Hillerød",
    "country": "DK",
    "city": "Hillerød",
    "address": "Lodbrogsvej 5, 3400 Hillerød",
    "email": "indskrivninghillerod@jan-nygaard.dk",
    "phone": "+45-70707667",
    "website": "https://www.jan-nygaard.dk",
    "coords": {
      "lat": 55.92869186401367,
      "lng": 12.267840385437012
    }
  },
  {
    "id": "31022_1",
    "name": "Outzen Bilcenter",
    "country": "DK",
    "city": "Ringe",
    "address": "Bygmestervej 18, 5750 Ringe",
    "email": "outzen@outzen-bil.dk",
    "phone": "+45-62-623700",
    "website": "https://www.outzen-bil.dk",
    "coords": {
      "lat": 55.23966979980469,
      "lng": 10.487175941467285
    }
  },
  {
    "id": "53138_2",
    "name": "Bayern AutoGroup Aarhus A/S",
    "country": "DK",
    "city": "Aarhus V",
    "address": "Blomstervej 4A, 8210 Aarhus V",
    "email": "info.aarhus@bag.dk",
    "phone": "+45-87-430300",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 56.183380126953125,
      "lng": 10.127946853637695
    }
  },
  {
    "id": "53138_7",
    "name": "Bayern AutoGroup SFL Horsens",
    "country": "DK",
    "city": "Horsens",
    "address": "Høegh Guldbergs Gade 36, 8700 Horsens",
    "email": "reservedele@caripo-biler.dk",
    "phone": "+45-87-430300",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 55.853580474853516,
      "lng": 9.849263191223145
    }
  },
  {
    "id": "53138_4",
    "name": "Bayern AutoGroup Aalborg A/S",
    "country": "DK",
    "city": "Aalborg",
    "address": "Jyllandsgade 26, 9000 Aalborg",
    "email": "info.aalborg@bag.dk",
    "phone": "+45-98-165555",
    "website": "http://www.bag.dk/forhandlere",
    "coords": {
      "lat": 57.042476654052734,
      "lng": 9.927020072937012
    }
  },
  {
    "id": "27764_2",
    "name": "Jan Nygaard AS, Glostrup",
    "country": "DK",
    "city": "Glostrup",
    "address": "Erhvervsvej 1, 2600 Glostrup",
    "email": "tidsbestilling@jan-nygaard.dk",
    "phone": "+45-45-886600",
    "website": "https://www.jan-nygaard.dk",
    "coords": {
      "lat": 55.69859313964844,
      "lng": 12.422575950622559
    }
  },
  {
    "id": "27764_7",
    "name": "Jan Nygaard AS, Birkerød",
    "country": "DK",
    "city": "Birkerød",
    "address": "Kongevejen 56, 3460 Birkerød",
    "email": "info@jan-nygaard.dk",
    "phone": "+45-45-886600",
    "website": "https://www.jan-nygaard.dk",
    "coords": {
      "lat": 55.84061050415039,
      "lng": 12.441807746887207
    }
  },
  {
    "id": "40559_1",
    "name": "Koed A/S",
    "country": "DK",
    "city": "Kolind",
    "address": "Nyhåbsvej 16-18, 8560 Kolind",
    "email": "Service.kolind@koed.dk",
    "phone": "+45-86-392900",
    "website": "https://www.bmw-service-koed.dk",
    "coords": {
      "lat": 56.352054595947266,
      "lng": 10.572809219360352
    }
  },
  {
    "id": "46491_1",
    "name": "Koed Aarhus Nord A/S",
    "country": "DK",
    "city": "Lystrup",
    "address": "Rokhøj 18, 8520 Lystrup",
    "email": "Service.lystrup@koed.dk",
    "phone": "+45-86-182900",
    "website": null,
    "coords": {
      "lat": 56.22916030883789,
      "lng": 10.246964454650879
    }
  },
  {
    "id": "27354_1",
    "name": "Meiniche A/S",
    "country": "DK",
    "city": "Holstebro",
    "address": "Jens Baggesens Vej 3-5, 7500 Holstebro",
    "email": "service@meiniche.dk",
    "phone": "+45-97-423033",
    "website": "https://www.meiniche.dk",
    "coords": {
      "lat": 56.37086868286133,
      "lng": 8.628680229187012
    }
  },
  {
    "id": "35785_2",
    "name": "Magna Motors S.A.",
    "country": "DO",
    "city": "Santo Domingo",
    "address": "Abraham Lincoln 504, 10148 Santo Domingo",
    "email": "atencionmagnacrm@magna.com.do",
    "phone": "+1809-544-1555",
    "website": "https://www.mini.com.do",
    "coords": {
      "lat": 18.472789764404297,
      "lng": -69.93314361572266
    }
  },
  {
    "id": "35785_3",
    "name": "Magna Motors S.A.",
    "country": "DO",
    "city": "Republica Dominicana",
    "address": "Doctores Mallen 235, Arroyo Hondo, 10510 Republica Dominicana",
    "email": "atencionmagnacrm@magna.com.do",
    "phone": "+1809-3851555",
    "website": "https://www.mini.com.do",
    "coords": {
      "lat": 18.486778259277344,
      "lng": -69.94053649902344
    }
  },
  {
    "id": "35785_1",
    "name": "MAGNA MOTORS",
    "country": "DO",
    "city": "SANTO DOMINGO",
    "address": "ABRAHAM LINCOLN #552 ESQ., 000000 SANTO DOMINGO",
    "email": "David.Rodriguez@magna.com.do",
    "phone": "+1809-544-1555",
    "website": "https://www.bmw.com.do",
    "coords": {
      "lat": 18.470226287841797,
      "lng": -69.25861358642578
    }
  },
  {
    "id": "27271_1",
    "name": "Seinäjoen Auto-Kaari Oy",
    "country": "FI",
    "city": "Hyllykallio",
    "address": "Lieskatie 2, 60510 Hyllykallio",
    "email": "huolto@autokaari.fi",
    "phone": "+358-20-7281720",
    "website": "https://www.autokaari.fi",
    "coords": {
      "lat": 62.81010055541992,
      "lng": 22.882139205932617
    }
  },
  {
    "id": "30579_2",
    "name": "Wetteri Auto Oy, Rovaniemi",
    "country": "FI",
    "city": "Rovaniemi",
    "address": "Ulakatu 12, 96300 Rovaniemi",
    "email": "info.rovaniemi@wetteri.fi",
    "phone": "+358-20-778830",
    "website": "https://www.wetteri.fi",
    "coords": {
      "lat": 66.48675537109375,
      "lng": 25.663074493408203
    }
  },
  {
    "id": "09578_1",
    "name": "Tynninharjun Autohuolto Oy",
    "country": "FI",
    "city": "Lohja",
    "address": "Maksjoentie 12, 08200 Lohja",
    "email": "posti@tynninharjunautohuolto.fi",
    "phone": "+358-19-3757900",
    "website": "https://www.tynninharjunautohuolto.fi",
    "coords": {
      "lat": 60.220970153808594,
      "lng": 24.024385452270508
    }
  },
  {
    "id": "50095_5",
    "name": "Hedin Automotive, Joensuu Bavaria Oy",
    "country": "FI",
    "city": "Joensuu",
    "address": "Voimatie 1, 80100 Joensuu",
    "email": "huoltobmw.joensuu@hedinautomotive.fi",
    "phone": "+358-106257140",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 62.61918640136719,
      "lng": 29.775094985961914
    }
  },
  {
    "id": "30579_7",
    "name": "Wetteri Auto Oy, Mikkeli",
    "country": "FI",
    "city": "Mikkeli",
    "address": "Hietakatu 5, 50130 Mikkeli",
    "email": "info.mikkeli@wetteri.fi",
    "phone": "+358-20-778810",
    "website": "https://www.wetteri.fi",
    "coords": {
      "lat": 61.67666244506836,
      "lng": 27.245758056640625
    }
  },
  {
    "id": "50095_7",
    "name": "Hedin Automotive, Helsinki Bavaria Oy",
    "country": "FI",
    "city": "Helsinki",
    "address": "Mekaanikonkatu 2, 00880 Helsinki",
    "email": "huoltobmw.helsinki@hedinautomotive.fi",
    "phone": "+358-106257130",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 60.198883056640625,
      "lng": 25.04084014892578
    }
  },
  {
    "id": "50095_9",
    "name": "Hedin Automotive, Espoo Bavaria Oy",
    "country": "FI",
    "city": "Espoo",
    "address": "Luomannotko 7, 02200 Espoo",
    "email": "huoltobmw.espoo@hedinautomotive.fi",
    "phone": "+358-106257120",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 60.17905044555664,
      "lng": 24.756900787353516
    }
  },
  {
    "id": "31705_1",
    "name": "Autokeskus Oy, Tampere",
    "country": "FI",
    "city": "Tampere",
    "address": "Hatanpään valtatie 44, 33900 Tampere",
    "email": "bmw.tampere@autokeskus.fi",
    "phone": "+358-0300-308146",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 61.481380462646484,
      "lng": 23.76333999633789
    }
  },
  {
    "id": "46524_1",
    "name": "Suomen Autohuolto Oy",
    "country": "FI",
    "city": "Oulu",
    "address": "Portinkaarre 4, 90420 Oulu",
    "email": "bmw@sah.fi",
    "phone": "+358-20-7120225",
    "website": null,
    "coords": {
      "lat": 64.95269012451172,
      "lng": 25.52140998840332
    }
  },
  {
    "id": "50095_8",
    "name": "Hedin Automotive, Airport Bavaria Oy",
    "country": "FI",
    "city": "Vantaa",
    "address": "Antaksentie 4 A, 01510 Vantaa",
    "email": "huolto.airport@hedinautomotive.fi",
    "phone": "+358-106257110",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 60.295127868652344,
      "lng": 24.94597625732422
    }
  },
  {
    "id": "50095_10",
    "name": "Hedin Automotive, SFL Kerava Bavaria Oy",
    "country": "FI",
    "city": "Kerava",
    "address": "Sarviniitynkatu 10, 04200 Kerava",
    "email": "huolto.kerava@hedinautomotive.fi",
    "phone": "+358-106257270",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 60.396751403808594,
      "lng": 25.101490020751953
    }
  },
  {
    "id": "09259_1",
    "name": "Käyttöauto Oy, Vaasa",
    "country": "FI",
    "city": "Vaasa",
    "address": "Rantamaantie 35, 65350 Vaasa",
    "email": "vaasa@kayttoauto.fi",
    "phone": "+358-6-3156300",
    "website": "https://www.kayttoauto.fi/",
    "coords": {
      "lat": 63.07920837402344,
      "lng": 21.662364959716797
    }
  },
  {
    "id": "27269_1",
    "name": "Rinta-Joupin Autoliike Oy, Pori",
    "country": "FI",
    "city": "Pori",
    "address": "Hyväntuulentie 2, 28200 Pori",
    "email": "matti.hovi@rinta-jouppi.com",
    "phone": "+358-20-7772300",
    "website": "https://www.rinta-jouppi.com",
    "coords": {
      "lat": 61.50048828125,
      "lng": 21.801179885864258
    }
  },
  {
    "id": "50095_3",
    "name": "Hedin Automotive, Jyväskylä Bavaria Oy",
    "country": "FI",
    "city": "Jyväskylä",
    "address": "Palokankaantie 20, 40320 Jyväskylä",
    "email": "huoltobmw.jyvaskyla@hedinautomotive.fi",
    "phone": "+358-106257150",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 62.2917366027832,
      "lng": 25.810840606689453
    }
  },
  {
    "id": "54520_1",
    "name": "Auto-Suni Oy",
    "country": "FI",
    "city": "Lappeenranta",
    "address": "Katsastajankatu 4, 53500 Lappeenranta",
    "email": "lappeenranta.bmw.tyonjohto@auto-suni.fi",
    "phone": "+358-10085821",
    "website": "https://www.auto-suni.fi/yhteystiedot/bmw-ja-mini-huolto-lappeenranta/",
    "coords": {
      "lat": 61.04827880859375,
      "lng": 28.200462341308594
    }
  },
  {
    "id": "31705_4",
    "name": "Autokeskus Oy Konala",
    "country": "FI",
    "city": "Helsinki",
    "address": "Ristipellontie 5, 00390 Helsinki",
    "email": "bmw.konala@autokeskus.fi",
    "phone": "+358-0300-308177",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 60.235389709472656,
      "lng": 24.856689453125
    }
  },
  {
    "id": "09259_2",
    "name": "Käyttöauto Oy, Seinäjoki",
    "country": "FI",
    "city": "Seinäjoki",
    "address": "Pohjankaari 2, 60120 Seinäjoki",
    "email": "seinajoki@kayttoauto.fi",
    "phone": "+358-6-4185111",
    "website": "https://www.kayttoauto.fi",
    "coords": {
      "lat": 62.80118942260742,
      "lng": 22.86846351623535
    }
  },
  {
    "id": "30579_3",
    "name": "Wetteri Auto Oy, Kemi",
    "country": "FI",
    "city": "Kemi",
    "address": "Valajankatu 14, 94600 Kemi",
    "email": "info@wetteri.fi",
    "phone": "+358-20-778880",
    "website": "https://www.wetteri.fi",
    "coords": {
      "lat": 65.7402572631836,
      "lng": 24.585960388183594
    }
  },
  {
    "id": "31705_3",
    "name": "Autokeskus Oy, Hämeenlinna",
    "country": "FI",
    "city": "Hämeenlinna",
    "address": "Uhrikivenkatu 11, 13130 Hämeenlinna",
    "email": "bmw.hameenlinna@autokeskus.fi",
    "phone": "+358-20-506510",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 61.000240325927734,
      "lng": 24.436080932617188
    }
  },
  {
    "id": "31705_6",
    "name": "Autokeskus Oy Airport, Vantaa",
    "country": "FI",
    "city": "Vantaa",
    "address": "Silvastintie 4, 01510 Vantaa",
    "email": "bmw.airport@autokeskus.fi",
    "phone": "+358-0300-308109",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 60.29342269897461,
      "lng": 24.9576473236084
    }
  },
  {
    "id": "31705_7",
    "name": "Autokeskus Oy, Turku",
    "country": "FI",
    "city": "Turku",
    "address": "Munkkionkuja 1, 20610 Turku",
    "email": "bmw.turku@autokeskus.fi",
    "phone": "+358-0300-308190",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 60.44105911254883,
      "lng": 22.324024200439453
    }
  },
  {
    "id": "50095_6",
    "name": "Hedin Automotive, Kuopio Bavaria Oy",
    "country": "FI",
    "city": "Kuopio",
    "address": "Kallantie 10, 70400 Kuopio",
    "email": "huoltobmw.kuopio@hedinautomotive.fi",
    "phone": "+358-106257170",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 62.92552947998047,
      "lng": 27.681556701660156
    }
  },
  {
    "id": "52502_1",
    "name": "Länsiauto Oy, Espoo",
    "country": "FI",
    "city": "Espoo",
    "address": "Marsbyntie 3, 02770 Espoo",
    "email": "toimitukset.espoo@lansiauto.fi",
    "phone": "+358-0105252300",
    "website": null,
    "coords": {
      "lat": 60.15701675415039,
      "lng": 24.692689895629883
    }
  },
  {
    "id": "09259_3",
    "name": "Käyttöauto Oy, Kokkola",
    "country": "FI",
    "city": "Kokkola",
    "address": "Mestarintie 6, 67600 Kokkola",
    "email": "kokkola@kayttoauto.fi",
    "phone": "+358-6-8239600",
    "website": "https://www.kayttoauto.fi",
    "coords": {
      "lat": 63.82466125488281,
      "lng": 23.160160064697266
    }
  },
  {
    "id": "29007_2",
    "name": "Autosalpa Oy, Porvoo",
    "country": "FI",
    "city": "Porvoo",
    "address": "Ratsumestarinkatu 1, 06100 Porvoo",
    "email": "huolto.porvoo@autosalpa.fi",
    "phone": "+358-20-7799300",
    "website": "https://www.autosalpa.fi",
    "coords": {
      "lat": 60.39226150512695,
      "lng": 25.60686492919922
    }
  },
  {
    "id": "29007_4",
    "name": "Autosalpa Oy, Kouvola",
    "country": "FI",
    "city": "Kouvola",
    "address": "Kaitilankatu 1, 45130 Kouvola",
    "email": "huolto.kouvola@autosalpa.fi",
    "phone": "+358-20-7799600",
    "website": "https://www.autosalpa.fi",
    "coords": {
      "lat": 60.86496353149414,
      "lng": 26.66306495666504
    }
  },
  {
    "id": "30579_4",
    "name": "Wetteri Auto Oy, Kajaani",
    "country": "FI",
    "city": "Kajaani",
    "address": "Sokajärventie 2, 87100 Kajaani",
    "email": "info@wetteri.fi",
    "phone": "+358-20-778840",
    "website": "https://www.wetteri.fi",
    "coords": {
      "lat": 64.22093963623047,
      "lng": 27.68770408630371
    }
  },
  {
    "id": "31705_2",
    "name": "Autokeskus Oy, Raisio",
    "country": "FI",
    "city": "Raisio",
    "address": "Haunistentie 15, 21280 Raisio",
    "email": "bmw.raisio@autokeskus.fi",
    "phone": "+358-20-506510",
    "website": "https://www.autokeskus.fi/bmw",
    "coords": {
      "lat": 60.48891830444336,
      "lng": 22.188640594482422
    }
  },
  {
    "id": "30579_1",
    "name": "Wetteri Auto Oy, Oulu",
    "country": "FI",
    "city": "Oulu",
    "address": "Äimäkuja 2, 90400 Oulu",
    "email": "info.oulu@wetteri.fi",
    "phone": "+358-20-778810",
    "website": "https://www.wetteri.fi",
    "coords": {
      "lat": 64.9848403930664,
      "lng": 25.47005271911621
    }
  },
  {
    "id": "36836_1",
    "name": "Tampereen Autocenter Oy",
    "country": "FI",
    "city": "Tampere",
    "address": "Taninkatu 12, 33400 Tampere",
    "email": "autocenter@autocenter.fi",
    "phone": "+358-20-7571116",
    "website": "https://bmw.autocenter.fi/",
    "coords": {
      "lat": 61.51845932006836,
      "lng": 23.65702247619629
    }
  },
  {
    "id": "50095_4",
    "name": "Hedin Automotive, Lahti Bavaria Oy",
    "country": "FI",
    "city": "Lahti",
    "address": "Aukeankatu 1, 15610 Lahti",
    "email": "huoltobmw.lahti@hedinautomotive.fi",
    "phone": "+358-106257180",
    "website": "https://www.hedinautomotive.fi/bavaria/",
    "coords": {
      "lat": 60.950809478759766,
      "lng": 25.649845123291016
    }
  },
  {
    "id": "52502_2",
    "name": "Länsiauto Oy, Hyvinkää",
    "country": "FI",
    "city": "Hyvinkää",
    "address": "Helletorpankatu 1, 05830 Hyvinkää",
    "email": "toimitukset.espoo@lansiauto.fi",
    "phone": "+358-0105252300",
    "website": null,
    "coords": {
      "lat": 60.61924743652344,
      "lng": 24.815874099731445
    }
  },
  {
    "id": "38800_1",
    "name": "JCS Automobiles",
    "country": "GF",
    "city": "Cayenne",
    "address": "406-454 Route de Montabo, 97327 Cayenne",
    "email": "Jean-Christophe.Vaude@jcsautomobile.com",
    "phone": "+590-419490",
    "website": null,
    "coords": {
      "lat": 4.935710906982422,
      "lng": -52.29546356201172
    }
  },
  {
    "id": "07759_3",
    "name": "Spanos S.A.",
    "country": "GR",
    "city": "Glyfada",
    "address": "99 Vouliagmenis Ave, 16561 Glyfada",
    "email": "salesglifada@bmw-spanos.gr",
    "phone": "+30-210-9604999",
    "website": "https://www.bmw-spanos.gr/",
    "coords": {
      "lat": 37.86841583251953,
      "lng": 23.76020050048828
    }
  },
  {
    "id": "09110_1",
    "name": "Servin Kalamatas Ltd.",
    "country": "GR",
    "city": "Kalamata",
    "address": "Iroon Politechniou, Akovitika, 24100 Kalamata",
    "email": "info@servinkalamatas.gr",
    "phone": "+30-27210-99606",
    "website": "http://www.bmw-service-servin-kalamatas.gr",
    "coords": {
      "lat": 37.039100646972656,
      "lng": 22.076332092285156
    }
  },
  {
    "id": "07759_4",
    "name": "Spanos S.A.",
    "country": "GR",
    "city": "Nea Kifissia",
    "address": "26 Evrota street, 14564 Nea Kifissia",
    "email": "service.kifissia@bmw-spanos.gr",
    "phone": "+30-211-1100555",
    "website": "https://www.bmw-spanos.gr/",
    "coords": {
      "lat": 38.10000228881836,
      "lng": 23.805091857910156
    }
  },
  {
    "id": "28934_2",
    "name": "Ioannidis Bros S.A.",
    "country": "GR",
    "city": "Serres",
    "address": "8th km Nat.Road Serres-Thessaloniki, 62100 Serres",
    "email": "bmw-sales@ioannidis-bros.gr",
    "phone": "+30-23210-80000",
    "website": "http://bmw-ioannidis.gr/",
    "coords": {
      "lat": 41.09389877319336,
      "lng": 23.46736717224121
    }
  },
  {
    "id": "06057_1",
    "name": "Adamidis S.A.",
    "country": "GR",
    "city": "Thessaloniki",
    "address": "4th km Nat. Road Thessalonikis-Athi, 57009 Thessaloniki",
    "email": "info@adamidis.gr",
    "phone": "+30-2310-753615",
    "website": "http://www.bmw-service-adamidis.gr",
    "coords": {
      "lat": 40.6551513671875,
      "lng": 22.872800827026367
    }
  },
  {
    "id": "07759_2",
    "name": "Spanos S.A.",
    "country": "GR",
    "city": "Nea Smyrni",
    "address": "299 Syggrou Ave., 17122 Nea Smyrni",
    "email": "info@bmw-spanos.gr",
    "phone": "+30-210-9424449",
    "website": "https://www.bmw-spanos.gr/",
    "coords": {
      "lat": 37.94355010986328,
      "lng": 23.700300216674805
    }
  },
  {
    "id": "09107_1",
    "name": "K. Katsioulis S.A.",
    "country": "GR",
    "city": "Ioannina",
    "address": "10th km of Nat. Road Ioanninon-Athi, 45500 Ioannina",
    "email": "sales@bmw-katsioulis.gr",
    "phone": "+30-26510-91064",
    "website": "https://www.bmw-katsioulis.gr/",
    "coords": {
      "lat": 39.57753372192383,
      "lng": 20.86313247680664
    }
  },
  {
    "id": "28934_3",
    "name": "Ioannidis Bros S.A.",
    "country": "GR",
    "city": "Kavala",
    "address": "Stavros Amygdaleonas, 64012 Kavala",
    "email": "bmw-sales@ioannidis-bros.gr",
    "phone": "+30-2510-600000",
    "website": "http://bmw-ioannidis.gr/",
    "coords": {
      "lat": 40.95293426513672,
      "lng": 24.367267608642578
    }
  },
  {
    "id": "44893_1",
    "name": "Velmar Autotechnica Hellas S.A.",
    "country": "GR",
    "city": "Thessaloniki",
    "address": "10 Marinou Antipa St., 57001 Thessaloniki",
    "email": "info@bmw-velmar.gr",
    "phone": "+30-2310-475871",
    "website": "https://www.bmw-velmar.gr/",
    "coords": {
      "lat": 40.56931686401367,
      "lng": 22.98295021057129
    }
  },
  {
    "id": "09104_1",
    "name": "I. Milonakis S.A.",
    "country": "GR",
    "city": "Crete",
    "address": "4th km Chanion-Kasteliou, 73100 Crete",
    "email": "service@bmw-mylonakis.gr",
    "phone": "+30-28210-23944",
    "website": "https://www.bmw-mylonakis.gr/",
    "coords": {
      "lat": 35.50754928588867,
      "lng": 23.980199813842773
    }
  },
  {
    "id": "40477_1",
    "name": "Andreas Tzouramanis Ltd.",
    "country": "GR",
    "city": "Patra",
    "address": "Nat. Road Patron-Athinon 105, 26442 Patra",
    "email": "info@bmw-tzouramanis.gr",
    "phone": "+30-2610-436825",
    "website": "http://www.bmw-tzouramanis.gr",
    "coords": {
      "lat": 38.2721061706543,
      "lng": 21.757856369018555
    }
  },
  {
    "id": "09118_1",
    "name": "Korfiatis Bros. S.A.",
    "country": "GR",
    "city": "Athens",
    "address": "68 Kifissou Ave. & 3 Vionos Str., 10442 Athens",
    "email": "info@bmw-korfiatis.gr",
    "phone": "+30-210-5153900",
    "website": "http://www.bmw-service-korfiatis.gr",
    "coords": {
      "lat": 38.00225067138672,
      "lng": 23.706783294677734
    }
  },
  {
    "id": "09109_2",
    "name": "Servin Kritis S.A.",
    "country": "GR",
    "city": "Chania",
    "address": "78 Karamanli ave., 73300 Chania",
    "email": "info.chania@bmw-servinkritis.gr",
    "phone": "+30-28210-02095",
    "website": "http://www.bmw-servinkritis.gr/",
    "coords": {
      "lat": 35.494632720947266,
      "lng": 24.042285919189453
    }
  },
  {
    "id": "09115_1",
    "name": "Servin Karditsas Ltd.",
    "country": "GR",
    "city": "Karditsa",
    "address": "5th Km Nat.Road Karditsas-Athinon, 43100 Karditsa",
    "email": "gerkod@otenet.gr",
    "phone": "+30-24410-61784",
    "website": "http://www.bmw-service-servin-karditsas.gr",
    "coords": {
      "lat": 39.370548248291016,
      "lng": 21.98444938659668
    }
  },
  {
    "id": "09109_1",
    "name": "Servin Kritis S.A.",
    "country": "GR",
    "city": "Crete",
    "address": "Ikarou Av. & Stadiou,N.Alikarnassos, 71601 Crete",
    "email": "info@bmw-servinkritis.gr",
    "phone": "+30-2810-330660",
    "website": "https://www.servin-kritis.bmw-motorrad.gr",
    "coords": {
      "lat": 35.3383674621582,
      "lng": 25.160816192626953
    }
  },
  {
    "id": "30899_3",
    "name": "Papadopoulos Giannis S.A.",
    "country": "GR",
    "city": "Larissa",
    "address": "6th km Nat. Road Larissa-Trikala, 41500 Larissa",
    "email": "info@bmw-papadopoulos.gr",
    "phone": "+30-2410-851800",
    "website": "https://www.bmw-papadopoulos.gr",
    "coords": {
      "lat": 39.63143539428711,
      "lng": 22.34485626220703
    }
  },
  {
    "id": "30899_1",
    "name": "Papadopoulos Giannis S.A.",
    "country": "GR",
    "city": "Thessaloniki",
    "address": "16th Km. A/D Thessalonikis Neon, 57001 Thessaloniki",
    "email": "aftersales.thessaloniki@bmw-papadopoulos.gr",
    "phone": "+30-2310-478100",
    "website": "https://www.bmw-papadopoulos.gr",
    "coords": {
      "lat": 40.5168342590332,
      "lng": 23.011449813842773
    }
  },
  {
    "id": "29994_12",
    "name": "Sfakianakis S.A.",
    "country": "GR",
    "city": "Peristeri",
    "address": "36 Kifisou Ave & Papakyriazi St., 12133 Peristeri",
    "email": "sales_peristeri@bmw-sfakianakis.gr",
    "phone": "+30-210-5787930",
    "website": "https://www.sfakianakis-athens.bmw-motorrad.gr",
    "coords": {
      "lat": 38.010379791259766,
      "lng": 23.716920852661133
    }
  },
  {
    "id": "29994_4",
    "name": "Sfakianakis S.A.",
    "country": "GR",
    "city": "Marousi",
    "address": "53 Kifisias Av & 2 Homatianou Str, 15123 Marousi",
    "email": "sales_marousi@bmw-sfakianakis.gr",
    "phone": "+30-210-6194500",
    "website": "https://www.bmw-sfakianakis.gr/",
    "coords": {
      "lat": 38.03703308105469,
      "lng": 23.79854965209961
    }
  },
  {
    "id": "29994_5",
    "name": "Sfakianakis S.A.",
    "country": "GR",
    "city": "Marousi",
    "address": "20 Evropis & Daskalou Kitsiou, 15124 Marousi",
    "email": "BMWService-Marousi@bmw-sfakianakis.gr",
    "phone": "+30-210-6300710",
    "website": "https://www.bmw-sfakianakis.gr/",
    "coords": {
      "lat": 38.04231643676758,
      "lng": 23.79840087890625
    }
  },
  {
    "id": "28105_1",
    "name": "Spanos Partnership",
    "country": "GR",
    "city": "Nea Smyrni",
    "address": "8 Amfitheas Ave., 17122 Nea Smyrni",
    "email": "service@bmw-spanos.gr",
    "phone": "+30-210-9424449",
    "website": "https://www.bmw-spanos.gr",
    "coords": {
      "lat": 37.943115234375,
      "lng": 23.700599670410156
    }
  },
  {
    "id": "31064_3",
    "name": "Excel Automotriz Pradera",
    "country": "GT",
    "city": "Ciudad de Guatemala",
    "address": "Blvd. Los Próceres 26-42 Zona 10, 01010 Ciudad de Guatemala",
    "email": "eofigueroa@excelautomotriz.com",
    "phone": "+502/-22778227",
    "website": "https://www.bmw.com.gt",
    "coords": {
      "lat": 14.580275535583496,
      "lng": -90.49427795410156
    }
  },
  {
    "id": "31064_5",
    "name": "BMW Zona 10 Pradera Autogaleria,  S.A.",
    "country": "GT",
    "city": "Guatemala",
    "address": "18 calle 26-71, zona 10, 00000 Guatemala",
    "email": "eofigueroa@excelautomotriz.com",
    "phone": "+502/-22772800",
    "website": null,
    "coords": {
      "lat": 14.579489707946777,
      "lng": -90.4929428100586
    }
  },
  {
    "id": "31064_4",
    "name": "BMW Condado Concepción Autogalería,  S.A.",
    "country": "GT",
    "city": "Guatemala",
    "address": "Carretera a El Salvador km. 16.5, 00000 Guatemala",
    "email": "eofigueroa@excelautomotriz.com",
    "phone": "+502-22778440",
    "website": "https://www.bmw.com.gt",
    "coords": {
      "lat": 14.547423362731934,
      "lng": -90.4537353515625
    }
  },
  {
    "id": "46473_1",
    "name": "Atkins Kroll Inc.",
    "country": "GU",
    "city": "Tamuning",
    "address": "443 South Marine Corps Drive, 96913 Tamuning",
    "email": null,
    "phone": "+1671-649-6410",
    "website": "https://www.bmw-guam.com/",
    "coords": {
      "lat": 13.48939037322998,
      "lng": 144.78746032714844
    }
  },
  {
    "id": "35199_4",
    "name": "AUTOEXCEL S.A. de C.V.",
    "country": "HN",
    "city": "San Pedro Sula",
    "address": "Avenida New Orleans, 21104 San Pedro Sula",
    "email": "cagarcia@excelautomotriz.com",
    "phone": "+504-2530-9000",
    "website": "https://www.bmw.hn",
    "coords": {
      "lat": 15.483357429504395,
      "lng": -88.03186798095703
    }
  },
  {
    "id": "35199_1",
    "name": "Excel Automotriz Tegucigalpa",
    "country": "HN",
    "city": "Tegucigalpa",
    "address": "Blvd. Florencia, Resid. La Hacienda, 11101 Tegucigalpa",
    "email": "alarin@excelautomotriz.com",
    "phone": "+504-22084275",
    "website": "https://www.bmw.hn",
    "coords": {
      "lat": 14.087258338928223,
      "lng": -87.17379760742188
    }
  },
  {
    "id": "35199_2",
    "name": "AUTOEXCEL S.A. de C.V.",
    "country": "HN",
    "city": "Tegucigalpa",
    "address": "Blv. 14 de Noviembre, 11101 Tegucigalpa",
    "email": "prfernandez@excelautomotriz.com",
    "phone": "+504-22084275",
    "website": "https://www.bmw.hn",
    "coords": {
      "lat": 14.087390899658203,
      "lng": -87.19862365722656
    }
  },
  {
    "id": "35199_3",
    "name": "Excel Automotriz San Pedro Sula",
    "country": "HN",
    "city": "San Pedro Sula",
    "address": "Boulevard del Sur, 21104 San Pedro Sula",
    "email": "latrigueros@excelautomotriz.com",
    "phone": "+504-2530-9000",
    "website": "https://www.bmw.hn",
    "coords": {
      "lat": 15.486407279968262,
      "lng": -88.03500366210938
    }
  },
  {
    "id": "36712_1",
    "name": "Apollo Motors S.A.",
    "country": "HT",
    "city": "Port-au-Prince",
    "address": "87-A Route de l'aeroport, HT6110 Port-au-Prince",
    "email": "g.dominique@apollo-motors.com",
    "phone": "+509-2813-0003",
    "website": null,
    "coords": {
      "lat": 18.568471908569336,
      "lng": -72.30774688720703
    }
  },
  {
    "id": "25859_3",
    "name": "Astra Autoprima",
    "country": "ID",
    "city": "Jakarta utara",
    "address": "Jl. Gaya Motor Selatan No.1, 14330 Jakarta utara",
    "email": "terry@bmw.astra.co.id",
    "phone": "+62-21-65835225",
    "website": "https://www.bmw.astra.co.id",
    "coords": {
      "lat": -6.139999866485596,
      "lng": 106.88475799560547
    }
  },
  {
    "id": "25859_7",
    "name": "Astra Surabaya",
    "country": "ID",
    "city": "Surabaya",
    "address": "Jl. H.R. Muhammad Kav. 2, 60189 Surabaya",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-31-7345600",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -7.286342144012451,
      "lng": 112.7019271850586
    }
  },
  {
    "id": "25861_3",
    "name": "Tunas Asset Sarana",
    "country": "ID",
    "city": "Jakarta Barat",
    "address": "Jl. Hayam Wuruk No. 51, 11169 Jakarta Barat",
    "email": "fransiscus.irman@bmw-tunas.co.id",
    "phone": "+62-21-6260775",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.158758163452148,
      "lng": 106.81912994384766
    }
  },
  {
    "id": "28697_3",
    "name": "Eurokars Group Eurokars PIK 2",
    "country": "ID",
    "city": "Tangerang",
    "address": "jl Fatmawati Kav KLB no 25-26, 15400 Tangerang",
    "email": "bmw.info@eurokars.co.id",
    "phone": "+62-21-5361616",
    "website": "https://bmw-eurokars.co.id/",
    "coords": {
      "lat": -6.057509899139404,
      "lng": 106.68338775634766
    }
  },
  {
    "id": "25859_1",
    "name": "Astra Sunter",
    "country": "ID",
    "city": "Jakarta Utara",
    "address": "Jl. Gaya Motor Selatan No. 1, 14330 Jakarta Utara",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-21-6509330",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.140427112579346,
      "lng": 106.88532257080078
    }
  },
  {
    "id": "25859_4",
    "name": "Astra Makassar",
    "country": "ID",
    "city": "Makassar",
    "address": "Jl. Andi Pangeran Pettarani no 98 A, 90222 Makassar",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-411-4669495",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -5.157875061035156,
      "lng": 119.43634796142578
    }
  },
  {
    "id": "25859_5",
    "name": "Astra  Denpasar",
    "country": "ID",
    "city": "Denpasar Timur, Bali",
    "address": "Jl.Gatot Subroto Timur No.168, 80237 Denpasar Timur, Bali",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-361-4713347",
    "website": "https://www.bmw.astra.co.id",
    "coords": {
      "lat": -8.635697364807129,
      "lng": 115.24716186523438
    }
  },
  {
    "id": "25861_2",
    "name": "Tunas Tomang",
    "country": "ID",
    "city": "Jakarta Barat",
    "address": "Jl. Tomang Raya No. 19, 11440 Jakarta Barat",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-21-5667509",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.177657127380371,
      "lng": 106.79884338378906
    }
  },
  {
    "id": "25861_4",
    "name": "Tunas Bandung",
    "country": "ID",
    "city": "Bandung",
    "address": "Jl. Soekarno Hatta No. 735A, 40116 Bandung",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-22-73280333",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.93828821182251,
      "lng": 107.66539764404297
    }
  },
  {
    "id": "50184_1",
    "name": "Karyatama Trans Niaga Pekanbaru",
    "country": "ID",
    "city": "Pekanbaru, Riau",
    "address": "JL.Soekarno Hatta, Tangkerang Barat, 28282 Pekanbaru, Riau",
    "email": "info@bmw-ktn.co.id",
    "phone": "+62-896-26987267",
    "website": "https://bmw-ktn.co.id/",
    "coords": {
      "lat": 0.4895322024822235,
      "lng": 101.41922760009766
    }
  },
  {
    "id": "25859_9",
    "name": "Astra Cilandak",
    "country": "ID",
    "city": "Jakarta Selatan",
    "address": "Jl. RA Kartini Kav. 203 Cilandak, 12430 Jakarta Selatan",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-21-7691072",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.292734146118164,
      "lng": 106.78974914550781
    }
  },
  {
    "id": "25859_12",
    "name": "Astra Mampang",
    "country": "ID",
    "city": "Mampang",
    "address": "jl Buncit Raya no 9, RT 07/05, 12740 Mampang",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-21-6509330",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.267762184143066,
      "lng": 106.83026885986328
    }
  },
  {
    "id": "28697_1",
    "name": "Eurokars Kebon Jeruk",
    "country": "ID",
    "city": "Jakarta Barat",
    "address": "Jl. Panjang No. 6, 11530 Jakarta Barat",
    "email": "bmw.info@eurokars.co.id",
    "phone": "+62-21-5361616",
    "website": "https://bmw-eurokars.co.id/",
    "coords": {
      "lat": -6.19205904006958,
      "lng": 106.76850128173828
    }
  },
  {
    "id": "52364_1",
    "name": "PT Performance Motors Indonesia",
    "country": "ID",
    "city": "Central Jakarta",
    "address": "Plaza Galeon Building Ground Floor, 10230 Central Jakarta",
    "email": "info.cs@bmw-performancemotors.co.id",
    "phone": "+62-21-29937269",
    "website": "https://www.bmw-performancemotors.co.id",
    "coords": {
      "lat": -6.1984171867370605,
      "lng": 106.82295989990234
    }
  },
  {
    "id": "40708_1",
    "name": "Artha Motor Lestari Medan",
    "country": "ID",
    "city": "Medan",
    "address": "Jl W Mongonsidi 54, Polonia, 20152 Medan",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-61-4511299",
    "website": "https://www.bmw.co.id",
    "coords": {
      "lat": 3.5712270736694336,
      "lng": 98.66481018066406
    }
  },
  {
    "id": "52364_3",
    "name": "PMI BPS PT Performance Auto Selection",
    "country": "ID",
    "city": "Indonesia",
    "address": "Jl MT Haryono Kav 29, 12820 Indonesia",
    "email": "info.cs@bmw-performancemotors.co.id",
    "phone": "+62-21-29937269",
    "website": "https://www.bmw-performancemotors.co.id",
    "coords": {
      "lat": -6.24246883392334,
      "lng": 106.8579330444336
    }
  },
  {
    "id": "53737_1",
    "name": "PT Plaza Auto Bavaria Plaza BMW Pondok Indah",
    "country": "ID",
    "city": "Jakarta",
    "address": "Jl Sultan Iskandar Muda no. 99, 12240 Jakarta",
    "email": "info@plazabmw.co.id",
    "phone": null,
    "website": "https://www.bmwplaza.co.id",
    "coords": {
      "lat": -6.249627590179443,
      "lng": 106.78141784667969
    }
  },
  {
    "id": "28697_2",
    "name": "Eurokars Prima Indonesia",
    "country": "ID",
    "city": "Jakarta Barat",
    "address": "Jl. Panjang No. 6, 11530 Jakarta Barat",
    "email": "doddy@eurokars.co.id",
    "phone": "+62-21-5358000",
    "website": "https://www.bmw.co.id",
    "coords": {
      "lat": -6.19205904006958,
      "lng": 106.76850128173828
    }
  },
  {
    "id": "40708_3",
    "name": "Artha Motor Lestari Thamrin",
    "country": "ID",
    "city": "Central Jakarta",
    "address": "Jl MH Thamrin No 8-9, 10230 Central Jakarta",
    "email": "cs@bmw-aml.co.id",
    "phone": "+62-21-29937269",
    "website": "https://bmw-aml.co.id/",
    "coords": {
      "lat": -6.198313236236572,
      "lng": 106.8228530883789
    }
  },
  {
    "id": "25861_1",
    "name": "Tunas Hayam Wuruk",
    "country": "ID",
    "city": "Jakarta Barat",
    "address": "Jl. Hayam Wuruk No. 51, 11160 Jakarta Barat",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-21-6495550",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.158758163452148,
      "lng": 106.81912994384766
    }
  },
  {
    "id": "25859_11",
    "name": "Astra Serpong",
    "country": "ID",
    "city": "Tangerang Selatan",
    "address": "Astra BIZ Center No.11A, 15331 Tangerang Selatan",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-21-30062022",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.287464618682861,
      "lng": 106.63877868652344
    }
  },
  {
    "id": "25861_8",
    "name": "Tunas Bekasi",
    "country": "ID",
    "city": "Bekasi",
    "address": "Jalan boulevard Timur Blok VA, 17143 Bekasi",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-21-6495550",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.226099967956543,
      "lng": 107.00359344482422
    }
  },
  {
    "id": "50856_1",
    "name": "Karya Prima Ultima",
    "country": "ID",
    "city": "Tangerang Selatan",
    "address": "Jalan Ciater Raya, 15310 Tangerang Selatan",
    "email": null,
    "phone": "+62-8111861861",
    "website": null,
    "coords": {
      "lat": -6.315827369689941,
      "lng": 106.70311737060547
    }
  },
  {
    "id": "25859_6",
    "name": "Astra Semarang",
    "country": "ID",
    "city": "Semarang",
    "address": "Jl. Jend. Sudirman No. 295, 50149 Semarang",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-24-7604666",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.983459949493408,
      "lng": 110.38788604736328
    }
  },
  {
    "id": "25859_8",
    "name": "Astra Pluit",
    "country": "ID",
    "city": "Jakarta Utara",
    "address": "Jl.Pluit Selatan Raya, 14450 Jakarta Utara",
    "email": "contact.us@bmw.astra.co.id",
    "phone": "+62-21-66605599",
    "website": "https://bmw.astra.co.id/",
    "coords": {
      "lat": -6.12565279006958,
      "lng": 106.7982177734375
    }
  },
  {
    "id": "25861_5",
    "name": "Tunas Tebet",
    "country": "ID",
    "city": "Jakarta Selatan",
    "address": "Jl. Dr. Soepomo No. 174, 12810 Jakarta Selatan",
    "email": "contact.id@bmw.co.id",
    "phone": "+62-21-8298451",
    "website": "https://www.bmw-tunas.co.id",
    "coords": {
      "lat": -6.230301856994629,
      "lng": 106.84651947021484
    }
  },
  {
    "id": "30756_1",
    "name": "PT. Bestindo Car Utama",
    "country": "ID",
    "city": "Tangerang",
    "address": "Jl. Jenderal Sudirman Blok B6 No. 1, 15224 Tangerang",
    "email": "bmw.bintaro@bestindocar.co.id",
    "phone": "+62-21-74868000",
    "website": "https://bmw-bestindo.co.id/",
    "coords": {
      "lat": -6.2816481590271,
      "lng": 106.72792053222656
    }
  },
  {
    "id": "52364_2",
    "name": "PT Performance Motors Ind Medan PMI Medan",
    "country": "ID",
    "city": "Medan",
    "address": "Jl W Mongonsidi 54, Polonia, 20152 Medan",
    "email": "info.cs@bmw-performancemotors.co.id",
    "phone": "+62-61-4511299",
    "website": "https://www.bmw-performancemotors.co.id",
    "coords": {
      "lat": 3.571320056915283,
      "lng": 98.66484832763672
    }
  },
  {
    "id": "53737_2",
    "name": "PT Plaza Auto Bavaria Plaza BMW Arjuna",
    "country": "ID",
    "city": "Surabaya",
    "address": "JL. Kedungdoro No. 122-128, 60251 Surabaya",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": -7.267560005187988,
      "lng": 112.72917938232422
    }
  },
  {
    "id": "02415_1",
    "name": "J Donohoe",
    "country": "IE",
    "city": "Enniscorthy",
    "address": "Quarrypark, Y21 XP59 Enniscorthy",
    "email": "sales@jdonohoebmw.com",
    "phone": "+353-53-9230304",
    "website": "https://www.donohoebmw.ie",
    "coords": {
      "lat": 52.514163970947266,
      "lng": -6.565349102020264
    }
  },
  {
    "id": "32416_1",
    "name": "Colm Quinn (Athlone)",
    "country": "IE",
    "city": "Athlone",
    "address": "Glasson Road, N37 VR68 Athlone",
    "email": "sales@colmquinnbmw.ie",
    "phone": "+353-90-6465888",
    "website": "http://www.colmquinnbmw.ie",
    "coords": {
      "lat": 53.43888854980469,
      "lng": -7.899463176727295
    }
  },
  {
    "id": "02417_1",
    "name": "N Conlan & Sons (Limerick)",
    "country": "IE",
    "city": "Limerick",
    "address": "Tipperary Road, V94 AW61 Limerick",
    "email": "info@conlansbmw.ie",
    "phone": "+353-61-422600",
    "website": "http://www.nconlanandsonsbmw.ie/contentv3/",
    "coords": {
      "lat": 52.650047302246094,
      "lng": -8.576847076416016
    }
  },
  {
    "id": "27767_1",
    "name": "Frank Keane (Naas Road)",
    "country": "IE",
    "city": "Dublin",
    "address": "John F Kennedy Drive, D12 T320 Dublin",
    "email": "info@frankkeanebmw.ie",
    "phone": "+353-1-2405666",
    "website": "http://www.frankkeanebmw.ie",
    "coords": {
      "lat": 53.326087951660156,
      "lng": -6.348143100738525
    }
  },
  {
    "id": "29830_1",
    "name": "Kearys",
    "country": "IE",
    "city": "Cork",
    "address": "Eastgate Business Park, T45 DX63 Cork",
    "email": "bmwreception@kearys.ie",
    "phone": "+353-21-5003600",
    "website": "http://www.kearysbmw.ie",
    "coords": {
      "lat": 51.905155181884766,
      "lng": -8.356428146362305
    }
  },
  {
    "id": "32416_4",
    "name": "Colm Quinn (Drogheda)",
    "country": "IE",
    "city": "Drogheda",
    "address": "M1 Retail Park, A92 H194 Drogheda",
    "email": "salesdrogheda@colmquinnbmw.ie",
    "phone": "+353-41-6874888",
    "website": "http://www.colmquinnbmw.ie",
    "coords": {
      "lat": 53.72753143310547,
      "lng": -6.388385772705078
    }
  },
  {
    "id": "02254_1",
    "name": "Joe Duffy",
    "country": "IE",
    "city": "Dublin",
    "address": "Exit 5 M50, D11 XH5N Dublin",
    "email": "info@joeduffybmw.ie",
    "phone": "+353-1-8647781",
    "website": "https://www.joeduffybmw.ie",
    "coords": {
      "lat": 53.404205322265625,
      "lng": -6.306225776672363
    }
  },
  {
    "id": "37193_1",
    "name": "Frank Keane (Blackrock)",
    "country": "IE",
    "city": "Blackrock",
    "address": "Temple Road, A94 Y8A0 Blackrock",
    "email": "blackrock@frankkeanebmw.ie",
    "phone": "+353-1-2405600",
    "website": "http://www.frankkeanebmw.ie",
    "coords": {
      "lat": 53.2989387512207,
      "lng": -6.172973155975342
    }
  },
  {
    "id": "32416_2",
    "name": "Colm Quinn (Galway)",
    "country": "IE",
    "city": "Galway City",
    "address": "Outer Tuam Road, H91 Y504 Galway City",
    "email": "salesgalway@colmquinnbmw.ie",
    "phone": "+353-90-6465888",
    "website": "http://www.colmquinnbmw.ie",
    "coords": {
      "lat": 53.29361343383789,
      "lng": -9.017950057983398
    }
  },
  {
    "id": "02417_2",
    "name": "N Conlan & Sons (Naas)",
    "country": "IE",
    "city": "Naas",
    "address": "Newhall, W91 E6EP Naas",
    "email": "info@conlanandsonsbmw.ie",
    "phone": "+353-45-409100",
    "website": "http://www.conlanandsonsbmw.ie/contentv3/",
    "coords": {
      "lat": 53.20842742919922,
      "lng": -6.74066686630249
    }
  },
  {
    "id": "09126_1",
    "name": "Bolands",
    "country": "IE",
    "city": "Waterford",
    "address": "Butlerstown Roundabout, X91 XA02 Waterford",
    "email": "info@bolandsbmw.ie",
    "phone": "+353-51-872122",
    "website": "https://www.bolandsbmw.ie",
    "coords": {
      "lat": 52.24190139770508,
      "lng": -7.166339874267578
    }
  },
  {
    "id": "02421_1",
    "name": "Morrison",
    "country": "IE",
    "city": "Cahir",
    "address": "Cork Road, E21 XD25 Cahir",
    "email": "info@morrisonbmw.ie",
    "phone": "+353-52-7441122",
    "website": "https://www.morrisonbmw.ie",
    "coords": {
      "lat": 52.37417221069336,
      "lng": -7.933786869049072
    }
  },
  {
    "id": "02257_1",
    "name": "Martin Reilly Authorised Repairer",
    "country": "IE",
    "city": "Sligo",
    "address": "Carraroe, F91 N231 Sligo",
    "email": "info@martinreillybmw.ie",
    "phone": "+353-71-9169099",
    "website": "https://www.martinreillybmw.ie",
    "coords": {
      "lat": 54.24053192138672,
      "lng": -8.476127624511719
    }
  },
  {
    "id": "29831_1",
    "name": "Aherns",
    "country": "IE",
    "city": "Castleisland",
    "address": "Tralee Road, V92 N235 Castleisland",
    "email": "info@ahernsbmw.ie",
    "phone": "+353-66-7143000",
    "website": "http://www.ahernsbmw.ie/contentv3/",
    "coords": {
      "lat": 52.23365783691406,
      "lng": -9.474065780639648
    }
  },
  {
    "id": "23520_2",
    "name": "אולם תצוגה חיפה",
    "country": "IL",
    "city": "חיפה",
    "address": "דרך בר יהודה 69, נשר, 36883 חיפה",
    "email": "service1@delekmotors.co.il",
    "phone": "+972-4-8202024",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 32.77459716796875,
      "lng": 35.04331970214844
    }
  },
  {
    "id": "25758_1",
    "name": "נ.ג בע מ",
    "country": "IL",
    "city": "נצרת עילית",
    "address": "רחוב העבודה 20, 17096 נצרת עילית",
    "email": "service.center@ng-bmw.com",
    "phone": "+972-4-6570829",
    "website": "https://www.bmw.co.il/he/",
    "coords": {
      "lat": 32.71460723876953,
      "lng": 35.33407211303711
    }
  },
  {
    "id": "23520_3",
    "name": "אולם תצוגה תל אביב",
    "country": "IL",
    "city": "תל אביב",
    "address": "המסגר 16, 67776 תל אביב",
    "email": "service1@delekmotors.co.il",
    "phone": "+972-3-6899000",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 32.05851364135742,
      "lng": 34.78514099121094
    }
  },
  {
    "id": "32814_1",
    "name": "שיא סוכנויות רכב",
    "country": "IL",
    "city": "חיפה",
    "address": "דרך בר יהודה 69, נשר, 36651 חיפה",
    "email": "yaron@bmwnorth.co.il",
    "phone": "+972-4-8202024",
    "website": null,
    "coords": {
      "lat": 32.77547836303711,
      "lng": 35.04317092895508
    }
  },
  {
    "id": "38427_1",
    "name": "מרכז שירות אזורי ירושלים",
    "country": "IL",
    "city": "ירושלים",
    "address": "הפרסה 16, 67800 ירושלים",
    "email": "service@bmw-service.co.il",
    "phone": "+972-2-5950005",
    "website": "https://teuza-service.co.il",
    "coords": {
      "lat": 31.750457763671875,
      "lng": 35.20957565307617
    }
  },
  {
    "id": "38429_1",
    "name": "דן דן בע\"מ",
    "country": "IL",
    "city": "באר שבע",
    "address": "העמל 2, 84247 באר שבע",
    "email": "katanovdan@gmail.com",
    "phone": "+972-8-6900416",
    "website": null,
    "coords": {
      "lat": 31.390594482421875,
      "lng": 34.78514862060547
    }
  },
  {
    "id": "23520_7",
    "name": "מוסך מרכזי דלק מוטורס",
    "country": "IL",
    "city": "ניר צבי",
    "address": "אזור תעשיה ניר צבי, 72905 ניר צבי",
    "email": "service1@delekmotors.co.il",
    "phone": "+972-8-9139111",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 31.959030151367188,
      "lng": 34.85728073120117
    }
  },
  {
    "id": "23520_6",
    "name": "אולם תצוגה ירושלים",
    "country": "IL",
    "city": "ירושלים",
    "address": "פייר קניג 40, 93420 ירושלים",
    "email": "service1@delekmotors.co.il",
    "phone": "+972-2-6722688",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 31.75102424621582,
      "lng": 35.21360778808594
    }
  },
  {
    "id": "53657_1",
    "name": "מרכז שרות תכלת",
    "country": "IL",
    "city": "Rishon LeZion",
    "address": "10 Ha Etsel st., 75050 Rishon LeZion",
    "email": "tiran@thelet.co.il",
    "phone": "+972-3-6238000",
    "website": null,
    "coords": {
      "lat": 31.990009307861328,
      "lng": 34.76313018798828
    }
  },
  {
    "id": "23520_11",
    "name": "Delek Motors Ltd.",
    "country": "IL",
    "city": "Ashdod",
    "address": "11 Haorgim St., 77609 Ashdod",
    "email": "k.cohen2@delekmotors.co.il",
    "phone": "+972-3-3108202",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 31.811309814453125,
      "lng": 34.660484313964844
    }
  },
  {
    "id": "40990_1",
    "name": "מרכז שירות ארצי",
    "country": "IL",
    "city": "פתח תקווה",
    "address": "יגיע כפיים 20, 49001 פתח תקווה",
    "email": "Hanoch.fransis@bmw-sh.co.il",
    "phone": "+972-3-9222307",
    "website": "https://bmws.co.il",
    "coords": {
      "lat": 32.09733963012695,
      "lng": 34.857845306396484
    }
  },
  {
    "id": "23520_1",
    "name": "Delek Motors Ltd.",
    "country": "IL",
    "city": "Nir Zvi",
    "address": "Nir Zvi P.O box 200, 72905 Nir Zvi",
    "email": null,
    "phone": "+972-8-9139998",
    "website": "https://www.bmw.co.il",
    "coords": {
      "lat": 31.958538055419922,
      "lng": 34.85686492919922
    }
  },
  {
    "id": "30714_2",
    "name": "FU Krishna Automobiles Ludhiana",
    "country": "IN",
    "city": "Ludhiana",
    "address": "Dhandhari Khurd, G T Road, 141010 Ludhiana",
    "email": "info@bmw-krishnaautomobiles.in",
    "phone": "+91-161-5250000",
    "website": "https://www.bmw-krishnaautomobiles.in",
    "coords": {
      "lat": 30.88182258605957,
      "lng": 75.89452362060547
    }
  },
  {
    "id": "30714_1",
    "name": "FU + MINI Krishna Automobiles Chandigarh",
    "country": "IN",
    "city": "Chandigarh",
    "address": "Plot 125, 160002 Chandigarh",
    "email": "info@bmw-krishnaautomobiles.in",
    "phone": "+91-172-5250000",
    "website": "http://www.bmw-krishnaautomobiles.in/home/",
    "coords": {
      "lat": 30.70391082763672,
      "lng": 76.80286407470703
    }
  },
  {
    "id": "30949_4",
    "name": "FU Infinity Cars Pvt. Ltd. Indore",
    "country": "IN",
    "city": "Indore",
    "address": "Unit # 17, Mangal Compound,, 452010 Indore",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-9713522266",
    "website": "http://www.bmw-infinitycars.in/home/",
    "coords": {
      "lat": 22.770971298217773,
      "lng": 75.82369232177734
    }
  },
  {
    "id": "31898_3",
    "name": "FU Bavaria Motors Pvt. Ltd. Goa",
    "country": "IN",
    "city": "Goa",
    "address": "Plot No. 2B Phase 1A;NH 46, 403722 Goa",
    "email": "info@bmw-bavariamotors.in",
    "phone": "+91-832-2733541",
    "website": "https://www.bmw.in",
    "coords": {
      "lat": 15.36658000946045,
      "lng": 73.92304992675781
    }
  },
  {
    "id": "31901_5",
    "name": "BPS OSL Prestige Pvt. Ltd. Budge Budge Road",
    "country": "IN",
    "city": "Kolkata",
    "address": "JL11, Mouza - Shampa Mirza Nagar, 700141 Kolkata",
    "email": "info@bmw-oslprestige.in",
    "phone": "+91-33-22517010",
    "website": "https://www.bmw-oslprestige.in",
    "coords": {
      "lat": 22.50613021850586,
      "lng": 88.2513427734375
    }
  },
  {
    "id": "34979_6",
    "name": "SA KUN Motoren Pvt. Ltd. Jubilee Hills",
    "country": "IN",
    "city": "Hyderabad",
    "address": "Plot No.1 & 2 Survey No.403/1,, 500033 Hyderabad",
    "email": "Sales.Hyderabad@bmw-kunexclusive.in",
    "phone": "+91-40-44656565",
    "website": "https://www.bmw-kunexclusive-hyderabad.in/",
    "coords": {
      "lat": 17.421802520751953,
      "lng": 78.4107894897461
    }
  },
  {
    "id": "38033_4",
    "name": "FU Speed Motors Pvt. Ltd. Agra",
    "country": "IN",
    "city": "Agra",
    "address": "607 Mauja Artoni, NH2,, 282007 Agra",
    "email": "divij.narain@bmw-speedmotorwagen.in",
    "phone": "+91-562-7703010363",
    "website": "https://www.bmw-speedmotorwagen.in",
    "coords": {
      "lat": 27.226675033569336,
      "lng": 77.8984603881836
    }
  },
  {
    "id": "44117_4",
    "name": "SA EVM Autokraft India Pvt. Ltd. Trivandrum SA",
    "country": "IN",
    "city": "Trivandrum",
    "address": "Survey No. 947, Kadakampally V., 695029 Trivandrum",
    "email": "info@bmw-evmautokraft.in",
    "phone": "+91-811-3033333",
    "website": "https://www.bmw-evmautokraft.in",
    "coords": {
      "lat": 8.501100540161133,
      "lng": 76.9134292602539
    }
  },
  {
    "id": "48455_2",
    "name": "SA Performance Cars Pvt. Ltd. Rajouri Garden",
    "country": "IN",
    "city": "New Delhi",
    "address": "C-5, Ring Road, ,block C, 110027 New Delhi",
    "email": "anand.prakash@bmw-infinitycars.in",
    "phone": "+91-49991333",
    "website": "https://www.bmw-infinitycars-delhi.in/",
    "coords": {
      "lat": 28.64470672607422,
      "lng": 77.12672424316406
    }
  },
  {
    "id": "52684_1",
    "name": "FU KUN Exclusive Cars Pvt. Ltd. Hosur Road",
    "country": "IN",
    "city": "Bengaluru",
    "address": "Survey No. 45, GKR Pentagon, 560068 Bengaluru",
    "email": "info.bengaluru@bmw-kunexclusive.in",
    "phone": "+91-80-7314853000",
    "website": "https://www.bmw-kunexclusive-bengaluru.in/",
    "coords": {
      "lat": 12.862263679504395,
      "lng": 77.65975189208984
    }
  },
  {
    "id": "30802_1",
    "name": "FU + MINI K.U.N. Motor Company Meenambakkam",
    "country": "IN",
    "city": "Chennai",
    "address": "No. 20, G S T Road, 600027 Chennai",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-42911111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 12.985806465148926,
      "lng": 80.17408752441406
    }
  },
  {
    "id": "30842_3",
    "name": "SA Navnit Motors Pvt. Ltd. Malad",
    "country": "IN",
    "city": "Mumbai",
    "address": "Ramchandra Lane junction, 400064 Mumbai",
    "email": "navnit.kachalia@bmw-navnitmotors.in",
    "phone": "+91-22-66772222",
    "website": "https://www.bmw-navnitmotors-mumbai.in/",
    "coords": {
      "lat": 19.189273834228516,
      "lng": 72.83592224121094
    }
  },
  {
    "id": "31898_6",
    "name": "FU Bavaria Motors Pvt. Ltd. Aurangabad",
    "country": "IN",
    "city": "Aurangabad",
    "address": "Plot no P/1/2,Chikhalthana, 431007 Aurangabad",
    "email": "info@bmw-bavariamotors.in",
    "phone": "+91-20-26141555",
    "website": "https://www.bmw-bavariamotors.in",
    "coords": {
      "lat": 19.873729705810547,
      "lng": 75.38825988769531
    }
  },
  {
    "id": "35964_1",
    "name": "FU Mandhan Motors Pvt. Ltd. Raipur",
    "country": "IN",
    "city": "Raipur",
    "address": "Ring Road No.1, Sarona, 492009 Raipur",
    "email": "mohit.dabrai@bmw-munichmotors.in",
    "phone": "+91-11-700888",
    "website": "https://www.bmw-munichmotors.in",
    "coords": {
      "lat": 21.241741180419922,
      "lng": 81.58164978027344
    }
  },
  {
    "id": "43469_1",
    "name": "FU Titania Products Pvt. Ltd. Ranchi",
    "country": "IN",
    "city": "Ranchi",
    "address": "NH-33, Chakla,, 835219 Ranchi",
    "email": "info@bmw-titaniumautos.in",
    "phone": "+91-9608104485",
    "website": "https://www.bmw-titaniumautos.in",
    "coords": {
      "lat": 23.351762771606445,
      "lng": 85.3243179321289
    }
  },
  {
    "id": "46690_6",
    "name": "FU Gallops Autohaus Pvt. Ltd. Nagpur",
    "country": "IN",
    "city": "Nagpur",
    "address": "C-48, Central MIDC Road, Hingna, 440028 Nagpur",
    "email": "info@bmw-GallopsAutohaus.in",
    "phone": "+91-8238084949",
    "website": "https://www.bmw-gallopsautohaus.in",
    "coords": {
      "lat": 21.12131118774414,
      "lng": 79.01286315917969
    }
  },
  {
    "id": "51467_2",
    "name": "SA Ring Road Cars Pvt. Ltd. Whitefield SE",
    "country": "IN",
    "city": "Hobli, Bangalore",
    "address": "Plot No 17/B, Khata No 243/17-b, 560036 Hobli, Bangalore",
    "email": "prashanth.jain@bmw-deutschemotoren.in",
    "phone": "+91-080-9971314315",
    "website": "https://www.bmw-deutschemotoren.in/",
    "coords": {
      "lat": 12.984416961669922,
      "lng": 77.70796966552734
    }
  },
  {
    "id": "30802_14",
    "name": "SA + BPS K.U.N. Motor Company Pvt. Ltd. Ambattur SA",
    "country": "IN",
    "city": "Ambatur",
    "address": "B 7&8, Ambattur Industrial Estate, 600058 Ambatur",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-42911111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 13.088482856750488,
      "lng": 80.17092895507812
    }
  },
  {
    "id": "46688_2",
    "name": "FU Eminent Cars Pvt. Ltd. Vadodara",
    "country": "IN",
    "city": "Vadodara",
    "address": "TP Scheme no. 20, FP No. 31, 390012 Vadodara",
    "email": "contactus@bmw-eminentcars.in",
    "phone": "+91-7760740000",
    "website": "https://www.bmw-eminentcars.in",
    "coords": {
      "lat": 22.280256271362305,
      "lng": 73.15399932861328
    }
  },
  {
    "id": "46688_1",
    "name": "FU Eminent Cars Pvt. Ltd. Surat",
    "country": "IN",
    "city": "Surat",
    "address": "TP No. 3, Rundh, FP No. 38,, 395007 Surat",
    "email": "contactus@bmw-eminentcars.in",
    "phone": "+91-7760740000",
    "website": "https://www.bmw-eminentcars.in",
    "coords": {
      "lat": 21.15184783935547,
      "lng": 72.76256561279297
    }
  },
  {
    "id": "50858_1",
    "name": "FU Varsha Cars Pvt. Ltd. Mangalore",
    "country": "IN",
    "city": "Mangalore",
    "address": "Kannur Checkpost, Mangalore, 575007 Mangalore",
    "email": "varun.dev@bmw-varshaautohaus.in",
    "phone": "+91-824-2275777",
    "website": "https://www.bmw-varshaautohaus.in/",
    "coords": {
      "lat": 12.867792129516602,
      "lng": 74.9034194946289
    }
  },
  {
    "id": "30712_5",
    "name": "MINI Standalone Bird Automotive Pvt. Ltd. Vasant Kunj",
    "country": "IN",
    "city": "New Delhi",
    "address": "Plot No. 8 & 9, Sector C 6 & 7, 110070 New Delhi",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 28.536537170410156,
      "lng": 77.14813995361328
    }
  },
  {
    "id": "54791_1",
    "name": "SA Krishna Automotive Mahaveer Gateway",
    "country": "IN",
    "city": "Hyderabad",
    "address": "Unit No.G04, Mahaveer Gateway, 500032 Hyderabad",
    "email": "info@bmw-krishnaautomobiles.in",
    "phone": "+91-9512000124",
    "website": "http://www.bmw-krishnaautomobiles.in/home/",
    "coords": {
      "lat": 17.420116424560547,
      "lng": 78.35546875
    }
  },
  {
    "id": "30802_2",
    "name": "FU K.U.N. Motor Company Pvt. Ltd. Coimbatore",
    "country": "IN",
    "city": "Coimbatore",
    "address": "Door No.1/582-2, Avinashi Road,, 641407 Coimbatore",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-422-3505111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 11.014886856079102,
      "lng": 77.04055786132812
    }
  },
  {
    "id": "30712_2",
    "name": "FU Bird Automotive Pvt. Ltd. Sector 14",
    "country": "IN",
    "city": "Gurgaon",
    "address": "4 IDC, M.G. Road,, 122001 Gurgaon",
    "email": "info@bmw-birdautomotive.in",
    "phone": "+91-124-3988557",
    "website": "https://www.bmw-birdautomotive.in",
    "coords": {
      "lat": 28.471092224121094,
      "lng": 77.05430603027344
    }
  },
  {
    "id": "34979_7",
    "name": "FU KUN Motoren Pvt. Ltd. Visakhapatnam",
    "country": "IN",
    "city": "Visakhapatnam",
    "address": "45-56-1/3, NH 5 road,, 530024 Visakhapatnam",
    "email": "Sales.Hyderabad@bmw-kunexclusive.in",
    "phone": "+91-09581012222",
    "website": "https://www.bmw-kunexclusive-hyderabad.in/",
    "coords": {
      "lat": 17.73967170715332,
      "lng": 83.29495239257812
    }
  },
  {
    "id": "44117_3",
    "name": "SE EVM Autokraft India Pvt. Ltd. Trivandrum SE",
    "country": "IN",
    "city": "Thiruvananthapuram",
    "address": "Plot No. 4C, 695021 Thiruvananthapuram",
    "email": "info@bmw-evmautokraft.in",
    "phone": "+91-7558889967",
    "website": "https://www.bmw-evmautokraft.in",
    "coords": {
      "lat": 8.50259017944336,
      "lng": 76.89754486083984
    }
  },
  {
    "id": "51467_1",
    "name": "SA Ring Road Cars Pvt. Ltd. Whitefield SA",
    "country": "IN",
    "city": "Bangalore",
    "address": "222/220A, Whitefield Road,, 560048 Bangalore",
    "email": "prashanth.jain@bmw-deutschemotoren.in",
    "phone": "+91-080-9971314315",
    "website": "https://www.bmw-deutschemotoren.in/",
    "coords": {
      "lat": 12.98816204071045,
      "lng": 77.73004913330078
    }
  },
  {
    "id": "30802_15",
    "name": "SA K.U.N. Motor Company Pvt. Ltd. OMR",
    "country": "IN",
    "city": "Chennai",
    "address": "No. 155, Old Mahabalipuram Road,, 600119 Chennai",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-42911111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 12.910576820373535,
      "lng": 80.22896575927734
    }
  },
  {
    "id": "30949_1",
    "name": "SA+BPS Infinity Cars Pvt. Ltd. Worli",
    "country": "IN",
    "city": "Mumbai",
    "address": "Dr. A. B. Road, 400018 Mumbai",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 18.988380432128906,
      "lng": 72.81454467773438
    }
  },
  {
    "id": "33371_2",
    "name": "SA Sanghi Cars India Pvt. Ltd. Udaipur Showroom",
    "country": "IN",
    "city": "Udaipur",
    "address": "E-95 Madri Industrial Area, 313003 Udaipur",
    "email": "info@bmw-sanghiclassic.in",
    "phone": "+91-9214292145",
    "website": "https://www.bmw-sanghiclassic.in",
    "coords": {
      "lat": 24.580846786499023,
      "lng": 73.74813079833984
    }
  },
  {
    "id": "38033_1",
    "name": "FU Speed Motors Pvt. Ltd. Lucknow",
    "country": "IN",
    "city": "Lucknow",
    "address": "Faizabad Road, 227105 Lucknow",
    "email": "divij.narain@bmw-speedmotorwagen.in",
    "phone": "+91-7703010363",
    "website": "https://www.bmw-speedmotorwagen.in",
    "coords": {
      "lat": 26.885061264038086,
      "lng": 81.04725646972656
    }
  },
  {
    "id": "44117_1",
    "name": "FU + MINI EVM Autokraft India Pvt. Ltd. Kochi",
    "country": "IN",
    "city": "Cochin",
    "address": "Angel Plaza 23/649 A1, NH 47, 682022 Cochin",
    "email": "info@bmw-evmautokraft.in",
    "phone": "+91-811-3033333",
    "website": "https://www.bmw-evmautokraft.in",
    "coords": {
      "lat": 10.051183700561523,
      "lng": 76.31987762451172
    }
  },
  {
    "id": "46691_4",
    "name": "FU Deutsche Cars Pvt. Ltd. Noida",
    "country": "IN",
    "city": "Noida",
    "address": "Plot No. H8, Sector 63, 201301 Noida",
    "email": null,
    "phone": "+91-120-4199000",
    "website": null,
    "coords": {
      "lat": 28.631160736083984,
      "lng": 77.38009643554688
    }
  },
  {
    "id": "51467_3",
    "name": "SA Ring Road Cars Pvt. Ltd. Jayanagar",
    "country": "IN",
    "city": "Bangalore",
    "address": "Jodh Tower, No. 40, 27th Cross,, 560011 Bangalore",
    "email": "prashanth.jain@bmw-deutschemotoren.in",
    "phone": "+91-080-9971314315",
    "website": "https://www.bmw-deutschemotoren.in/",
    "coords": {
      "lat": 12.9307861328125,
      "lng": 77.58081817626953
    }
  },
  {
    "id": "30712_7",
    "name": "SA + MINI Bird Automotive Pvt. Ltd. Golf Course Road",
    "country": "IN",
    "city": "Gurugram",
    "address": "Address 1 Baani,, 122011 Gurugram",
    "email": "info@bmw-birdautomotive.in",
    "phone": "+91-11-124402902",
    "website": "http://www.bmw-birdautomotive.in/in/birdautomotive/en/index.html",
    "coords": {
      "lat": 28.421300888061523,
      "lng": 77.10465240478516
    }
  },
  {
    "id": "30802_5",
    "name": "SA K.U.N. Motor Company Pvt. Ltd. Mount Road",
    "country": "IN",
    "city": "Chennai",
    "address": "377, Anna Salai, Teynampet, 600014 Chennai",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-28464441",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 13.059198379516602,
      "lng": 80.26504516601562
    }
  },
  {
    "id": "30949_10",
    "name": "SE Infinity Cars Pvt. Ltd. Turbhe",
    "country": "IN",
    "city": "Navi Mumbai",
    "address": "D-20/7 TTC Industrial Area,, 400000 Navi Mumbai",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 19.075773239135742,
      "lng": 73.03121185302734
    }
  },
  {
    "id": "30949_8",
    "name": "SA + BPS Infinity Cars Pvt. Ltd. Vashi",
    "country": "IN",
    "city": "Mumbai",
    "address": "Plot No.50, Sector No.1, Near Nerul, 400706 Mumbai",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 19.051780700683594,
      "lng": 73.01968383789062
    }
  },
  {
    "id": "31898_1",
    "name": "SA Bavaria Motors Pvt. Ltd. Camp Road",
    "country": "IN",
    "city": "Pune",
    "address": "CTS No. 15B Wellesly Road, 411001 Pune",
    "email": "info@bmw-bavariamotors.in",
    "phone": "+91-20-26141555",
    "website": "https://www.bmw-bavariamotors.in",
    "coords": {
      "lat": 18.51991844177246,
      "lng": 73.87398529052734
    }
  },
  {
    "id": "30802_4",
    "name": "SE K.U.N Motor Company Pvt. Ltd. Ambattur SE",
    "country": "IN",
    "city": "Chennai",
    "address": "No. 70, Southern Avenue,, 600058 Chennai",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-49261111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 13.095200538635254,
      "lng": 80.17192840576172
    }
  },
  {
    "id": "30842_2",
    "name": "SE Navnit Motors Pvt. Ltd. Andheri PaperBox",
    "country": "IN",
    "city": "Mumbai",
    "address": "14B, Paper Box Compound,, 400093 Mumbai",
    "email": "info@bmw-navnitmotors.in",
    "phone": "+91-22-66777800",
    "website": "https://www.bmw-navnitmotors-mumbai.in/",
    "coords": {
      "lat": 19.134309768676758,
      "lng": 72.87444305419922
    }
  },
  {
    "id": "30842_14",
    "name": "SE Navnit Motors Pvt. Ltd. Thane",
    "country": "IN",
    "city": "Mumbai",
    "address": "Navnit House, Old Mumbai Agra Road,, 400604 Mumbai",
    "email": "info@bmw-navnitmotors.in",
    "phone": "+91-22-26253333",
    "website": "https://www.bmw-navnitmotors-mumbai.in/",
    "coords": {
      "lat": 19.209779739379883,
      "lng": 72.97807312011719
    }
  },
  {
    "id": "34979_3",
    "name": "SE KUN Motoren Pvt. Ltd. RTC Xroads",
    "country": "IN",
    "city": "Hyderabad",
    "address": "#1-8-670, 3rd Gate,, 500020 Hyderabad",
    "email": "info.hyd@bmw-kunexclusive.in",
    "phone": "+91-40-27676946",
    "website": "https://www.bmw-kunexclusive-hyderabad.in/",
    "coords": {
      "lat": 17.40544891357422,
      "lng": 78.49956512451172
    }
  },
  {
    "id": "38033_2",
    "name": "FU Speed Motors Pvt. Ltd. Kanpur",
    "country": "IN",
    "city": "Kanpur",
    "address": "No.64, Government Industrial Estate, 208001 Kanpur",
    "email": "sabir.irfan@bmw-speedmotorwagen.in",
    "phone": "+91-7786072306",
    "website": "https://www.bmw-speedmotorwagen.in",
    "coords": {
      "lat": 26.481414794921875,
      "lng": 80.34601593017578
    }
  },
  {
    "id": "43469_3",
    "name": "FU Titania Products Pvt. Ltd. Patna",
    "country": "IN",
    "city": "Patna",
    "address": "H No 2104638, Begumpur Bypass, 800009 Patna",
    "email": "info@bmw-titaniumautos.in",
    "phone": "+91-9608104485",
    "website": "https://www.bmw-titaniumautos.in",
    "coords": {
      "lat": 25.577463150024414,
      "lng": 85.22740936279297
    }
  },
  {
    "id": "46690_1",
    "name": "FU Gallops Autohaus Pvt. Ltd. Rajkot",
    "country": "IN",
    "city": "Rajkot",
    "address": "Survey No 390 , Plot No.6111, 360004 Rajkot",
    "email": "info@bmw-GallopsAutohaus.in",
    "phone": "+91-9512002117",
    "website": "https://www.bmw-gallopsautohaus.in",
    "coords": {
      "lat": 22.254180908203125,
      "lng": 70.79988861083984
    }
  },
  {
    "id": "46690_2",
    "name": "FU + MINI Gallops Autohaus Pvt. Ltd. Ahmedabad",
    "country": "IN",
    "city": "Ahmedabad",
    "address": "Survey No. 220, SG Highway, 382210 Ahmedabad",
    "email": "info@bmw-GallopsAutohaus.in",
    "phone": "+91-9099234567",
    "website": "https://www.bmw-gallopsautohaus.in",
    "coords": {
      "lat": 22.991146087646484,
      "lng": 72.49676513671875
    }
  },
  {
    "id": "46691_6",
    "name": "SA Deutsche Cars Pvt. Ltd. Safdarjung Enclave",
    "country": "IN",
    "city": "New Delhi",
    "address": "B-5/7, Safdarjung Enclave, 110029 New Delhi",
    "email": null,
    "phone": "+91-11-43090000",
    "website": null,
    "coords": {
      "lat": 28.561054229736328,
      "lng": 77.18833923339844
    }
  },
  {
    "id": "52684_3",
    "name": "SE K.U.N. Motor Company Pvt. Ltd. Airport Road",
    "country": "IN",
    "city": "Bengaluru",
    "address": "No. 40/66, Sonnappanahalli, 562157 Bengaluru",
    "email": "info.bengaluru@bmw-kunexclusive.in",
    "phone": "+91-80-7314853000",
    "website": "https://www.bmw-kunexclusive-bengaluru.in/",
    "coords": {
      "lat": 13.172551155090332,
      "lng": 77.63069915771484
    }
  },
  {
    "id": "30712_9",
    "name": "FU Bird Automotive Pvt. Ltd. Dehradun",
    "country": "IN",
    "city": "Dehradun",
    "address": "Khasra 170 min &169 ka of Khata1, 248002 Dehradun",
    "email": "info@bmw-birdautomotive.in",
    "phone": "+91-135-6170617",
    "website": "http://www.bmw-birdautomotive.in/in/birdautomotive/en/index.html",
    "coords": {
      "lat": 30.26527976989746,
      "lng": 77.98352813720703
    }
  },
  {
    "id": "30802_6",
    "name": "FU K.U.N. Motor Company Pvt. Ltd. Madurai",
    "country": "IN",
    "city": "Madurai",
    "address": "Survey No. 82/9A2-12A, NH 7,, 625008 Madurai",
    "email": "info@bmw-kunexclusive.in",
    "phone": "+91-44-42911111",
    "website": "https://www.bmw-kunexclusive-chennai.in/",
    "coords": {
      "lat": 9.874706268310547,
      "lng": 78.02751922607422
    }
  },
  {
    "id": "30842_1",
    "name": "SA Navnit Motors Pvt. Ltd. Juhu",
    "country": "IN",
    "city": "Mumbai",
    "address": "C-Wing Waterford Buidling, 400058 Mumbai",
    "email": "info@bmw-navnitmotors.in",
    "phone": "+91-22-26253333",
    "website": "https://www.bmw-navnitmotors-mumbai.in/",
    "coords": {
      "lat": 19.11609649658203,
      "lng": 72.84073638916016
    }
  },
  {
    "id": "30949_16",
    "name": "SE Infinity Cars Pvt. Ltd. Lalbaug",
    "country": "IN",
    "city": "Mumbai",
    "address": "Plot 57&58, Dattaram Khamkar Marg, 400012 Mumbai",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 18.991901397705078,
      "lng": 72.83367156982422
    }
  },
  {
    "id": "31901_3",
    "name": "SE OSL Prestige Pvt. Ltd. East Topsia Road",
    "country": "IN",
    "city": "Kolkata",
    "address": "43 East Topsia Road,, 700105 Kolkata",
    "email": "info@bmw-oslprestige.in",
    "phone": "+91-33-9874058048",
    "website": "https://www.bmw-oslprestige.in",
    "coords": {
      "lat": 22.539196014404297,
      "lng": 88.40286254882812
    }
  },
  {
    "id": "31901_2",
    "name": "SA + MINI SE OSL Prestige Pvt. Ltd. Cuttack",
    "country": "IN",
    "city": "Cuttack",
    "address": "Bhanpur, NH 16, 753011 Cuttack",
    "email": "info@bmw-oslprestige.in",
    "phone": "+91-671-6543968",
    "website": "http://bmw-oslprestige.in/home/",
    "coords": {
      "lat": 20.460067749023438,
      "lng": 85.90169525146484
    }
  },
  {
    "id": "34979_4",
    "name": "FU KUN Motoren Pvt. Ltd. Vijayawada",
    "country": "IN",
    "city": "Vijaywada",
    "address": "Plot No. 4, Industrial Park, 522503 Vijaywada",
    "email": "info.hyd@bmw-kunexclusive.in",
    "phone": "+91-08645236565",
    "website": "https://www.bmw-kunexclusive.in",
    "coords": {
      "lat": 16.423259735107422,
      "lng": 80.56429290771484
    }
  },
  {
    "id": "46691_1",
    "name": "SA Deutsche Cars Pvt. Ltd. Mohan Cooperative",
    "country": "IN",
    "city": "New Delhi",
    "address": "H5/ B1, Mohan Cooperative, 110044 New Delhi",
    "email": null,
    "phone": "+91-11-43090000",
    "website": null,
    "coords": {
      "lat": 28.517709732055664,
      "lng": 77.29511260986328
    }
  },
  {
    "id": "46691_2",
    "name": "FU + BPS Deutsche Cars Pvt. Ltd. Faridabad",
    "country": "IN",
    "city": "Faridabad",
    "address": "Plot No. 1, Sector 27B,, 121003 Faridabad",
    "email": null,
    "phone": "+91-129-4269000",
    "website": null,
    "coords": {
      "lat": 28.445302963256836,
      "lng": 77.30745697021484
    }
  },
  {
    "id": "52684_2",
    "name": "SA KUN Exclusive Cars Pvt Ltd Lavelle Road",
    "country": "IN",
    "city": "Bengaluru",
    "address": "No 2, Ground Floor, 560001 Bengaluru",
    "email": "info.bengaluru@bmw-kunexclusive.in",
    "phone": "+91-80-7314853000",
    "website": "https://www.bmw-kunexclusive-bengaluru.in/",
    "coords": {
      "lat": 12.97254467010498,
      "lng": 77.59908294677734
    }
  },
  {
    "id": "30949_9",
    "name": "SA Infinity Cars Pvt. Ltd. Nariman Point",
    "country": "IN",
    "city": "Mumbai",
    "address": "1-B Ground Flooor, Maker Chamber VI, 400021 Mumbai",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 18.924169540405273,
      "lng": 72.82199096679688
    }
  },
  {
    "id": "31898_2",
    "name": "SE+BPS Bavaria Motors Pvt. Ltd. Hadapsar",
    "country": "IN",
    "city": "Pune",
    "address": "Plot no. 25, Near Wanowrie, 411014 Pune",
    "email": "info@bmw-bavariamotors.in",
    "phone": "+91-20-27030333",
    "website": "https://www.bmw-bavariamotors.in",
    "coords": {
      "lat": 18.507680892944336,
      "lng": 73.91931915283203
    }
  },
  {
    "id": "31901_10",
    "name": "SE+ BPS OSL Prestige Pvt. Ltd. Budge Budge Road",
    "country": "IN",
    "city": "Kolkata",
    "address": "JL No - 11, PS - Maheshtala, 700141 Kolkata",
    "email": "info@bmw-oslprestige.in",
    "phone": "+91-33-9874058048",
    "website": "https://www.bmw-oslprestige.in/",
    "coords": {
      "lat": 22.513322830200195,
      "lng": 88.27423095703125
    }
  },
  {
    "id": "31901_1",
    "name": "SA OSL Prestige Pvt. Ltd. Silver Arcade",
    "country": "IN",
    "city": "Kolkata",
    "address": "The Silver Arcade,, 700105 Kolkata",
    "email": "info@bmw-oslprestige.in",
    "phone": "+91-33-9874058048",
    "website": "https://www.bmw-oslprestige.in/",
    "coords": {
      "lat": 22.54934310913086,
      "lng": 88.40043640136719
    }
  },
  {
    "id": "34979_1",
    "name": "SA KUN Motoren Pvt. Ltd. Khairatabad",
    "country": "IN",
    "city": "Hyderabad",
    "address": "6-3-569, Opp. RTA Office, 500082 Hyderabad",
    "email": "Sales.Hyderabad@bmw-kunexclusive.in",
    "phone": "+91-40-44656565",
    "website": "https://www.bmw-kunexclusive-hyderabad.in/",
    "coords": {
      "lat": 17.416772842407227,
      "lng": 78.45703125
    }
  },
  {
    "id": "48455_1",
    "name": "SE Performance Cars Pvt. Ltd. Mayapuri",
    "country": "IN",
    "city": "New Delhi",
    "address": "B-41, Block B, 110064 New Delhi",
    "email": "anand.prakash@bmw-infinitycars.in",
    "phone": "+91-011-49991333",
    "website": "https://www.bmw-infinitycars-delhi.in/",
    "coords": {
      "lat": 28.627094268798828,
      "lng": 77.12499237060547
    }
  },
  {
    "id": "30949_17",
    "name": "SA Performance Cars Pvt. Ltd. Vishwavidyalaya",
    "country": "IN",
    "city": "New Delhi",
    "address": "Vishwavidyalaya Metro Station, 110007 New Delhi",
    "email": "info@bmw-infinitycars.in",
    "phone": "+91-22-67145100",
    "website": "https://www.bmw-infinitycars.in",
    "coords": {
      "lat": 28.694595336914062,
      "lng": 77.21521759033203
    }
  },
  {
    "id": "33371_1",
    "name": "FU Sanghi Cars India Pvt. Ltd. Jaipur",
    "country": "IN",
    "city": "Jaipur",
    "address": "Sanghi Garden, Tonk Road, 302018 Jaipur",
    "email": "info@bmw-sanghiclassic.in",
    "phone": "+91-141-2722557",
    "website": "https://www.bmw-sanghiclassic.in",
    "coords": {
      "lat": 26.85605812072754,
      "lng": 75.79472351074219
    }
  },
  {
    "id": "51467_4",
    "name": "SE+ BPS Ring Road Cars Pvt. Ltd. Mysore Road",
    "country": "IN",
    "city": "Bangalore",
    "address": "No. 22/8, E Katha No. 2503954469, 560059 Bangalore",
    "email": "prashanth.jain@bmw-deutschemotoren.in",
    "phone": "+91-080-9971314315",
    "website": "https://www.bmw-deutschemotoren.in/",
    "coords": {
      "lat": 12.922403335571289,
      "lng": 77.49449920654297
    }
  },
  {
    "id": "43469_2",
    "name": "FU Titania Products Pvt. Ltd. Guwahati",
    "country": "IN",
    "city": "Guwahati",
    "address": "NH27, Nr Maniram Dewan Trade Centre, 781034 Guwahati",
    "email": "info@bmw-titaniumautos.in",
    "phone": "+91-9608104485",
    "website": "https://www.bmw-titaniumautos.in",
    "coords": {
      "lat": 26.11454200744629,
      "lng": 91.7280502319336
    }
  },
  {
    "id": "35614_3",
    "name": "Al-Uroush AutomotiveLtd.",
    "country": "IQ",
    "city": "Sulaymaniyah",
    "address": "Kirkuk Rd, 46001 Sulaymaniyah",
    "email": "info@bmw-iraq.com",
    "phone": "+964-781-3777777",
    "website": "https://www.bmw-iraq.com",
    "coords": {
      "lat": 35.56621170043945,
      "lng": 45.37104034423828
    }
  },
  {
    "id": "35614_2",
    "name": "Al-Uroush Automotive Ltd. Baghdad FF Facility",
    "country": "IQ",
    "city": "Baghdad",
    "address": "Mahalla, No. 901, Street 27, 10001 Baghdad",
    "email": "info@bmw-iraq.com",
    "phone": "+964-781-3888888",
    "website": "https://www.bmw-iraq.com",
    "coords": {
      "lat": 33.349998474121094,
      "lng": 44.41669845581055
    }
  },
  {
    "id": "35614_1",
    "name": "Al-Uroush AutomotiveLtd. Showroom and Service",
    "country": "IQ",
    "city": "Erbil",
    "address": "100m Street, 45 M4 Warsh, 44001 Erbil",
    "email": "info@bmw-iraq.com",
    "phone": "+964-781-3777777",
    "website": "https://www.bmw-iraq.com",
    "coords": {
      "lat": 36.17987823486328,
      "lng": 44.01602554321289
    }
  },
  {
    "id": "35249_1",
    "name": "Motor Vehicle Trading Co. L.L.C. Showroom",
    "country": "JO",
    "city": "Amman",
    "address": "Mecca Street, 145, P.O. Box 739, 99999 Amman",
    "email": "bmw@ak.com.jo",
    "phone": "+96-26-5803090",
    "website": "https://www.bmw-jordan.com",
    "coords": {
      "lat": 31.97563934326172,
      "lng": 35.85966873168945
    }
  },
  {
    "id": "35249_2",
    "name": "Motor Vehicle Trading Co. L.L.C. Service Centre",
    "country": "JO",
    "city": "Amman",
    "address": "Ahmad Bani Younis Street Bldg. 8, 9999 Amman",
    "email": "bmw@ak.com.jo",
    "phone": "+962-5-5803080",
    "website": "https://www.bmw-jordan.com",
    "coords": {
      "lat": 31.94097137451172,
      "lng": 35.84700012207031
    }
  },
  {
    "id": "38576_1",
    "name": "Autocenter Estocada LLC",
    "country": "KG",
    "city": "Bishkek",
    "address": "Abdrahmanov Str 327, 720011 Bishkek",
    "email": "office@bmw-center.kg",
    "phone": "+996-312-376770",
    "website": "https://www.bmw.kg",
    "coords": {
      "lat": 42.893310546875,
      "lng": 74.61197662353516
    }
  },
  {
    "id": "02351_3",
    "name": "Ali Mohammed Thunayan Alghanim & Sons Automotive Co. W.L.L.",
    "country": "KW",
    "city": "Kuwait",
    "address": "Road 12, Airport Road (55), 21540 Kuwait",
    "email": "bmw.enquiries@aas.com.kw",
    "phone": "+965-2-1846464",
    "website": "https://www.bmw-kuwait.com",
    "coords": {
      "lat": 29.33552360534668,
      "lng": 47.94583511352539
    }
  },
  {
    "id": "02351_1",
    "name": "Ali Mohammed Thunayan Alghanim & Sons Automotive Co. W.L.L.",
    "country": "KW",
    "city": "Safat",
    "address": "Road 12, Airport Road (55), 13076 Safat",
    "email": "bmw.enquiries@aas.com.kw",
    "phone": "+965-1846464",
    "website": "https://www.bmw-kuwait.com",
    "coords": {
      "lat": 29.336380004882812,
      "lng": 47.94868850708008
    }
  },
  {
    "id": "37098_5",
    "name": "Bavaria Almaty",
    "country": "KZ",
    "city": "Almaty",
    "address": "Al-Farabi 107, 050000 Almaty",
    "email": "info-almaty@bavaria.kz",
    "phone": "+7-(727)-3331905",
    "website": "https://bavaria-almaty.kz",
    "coords": {
      "lat": 43.2005615234375,
      "lng": 76.90299224853516
    }
  },
  {
    "id": "37098_6",
    "name": "Bavaria Kuldzhinka",
    "country": "KZ",
    "city": "Almaty",
    "address": "Kuldzhinsky tract, 100/1, 050000 Almaty",
    "email": "reception.bmw@mycar.kz",
    "phone": "+7-(702)-8811111",
    "website": "https://bavaria-kuldzhinka.kz",
    "coords": {
      "lat": 43.31093215942383,
      "lng": 77.01770782470703
    }
  },
  {
    "id": "48508_2",
    "name": "Autocenter Bavaria Karaganda",
    "country": "KZ",
    "city": "Karaganda",
    "address": "Saryarka 37/2, 100004 Karaganda",
    "email": "info@bavaria-karaganda.kz",
    "phone": "+7-7212-504343",
    "website": null,
    "coords": {
      "lat": 49.79737854003906,
      "lng": 73.1546859741211
    }
  },
  {
    "id": "37098_3",
    "name": "Bavaria Atyrau",
    "country": "KZ",
    "city": "Atyrau",
    "address": "Abulkhair Khan str 67, 060000 Atyrau",
    "email": "info.atyrau@bavaria.kz",
    "phone": "+7-7122-930222",
    "website": "https://bavaria-atyrau.kz/bmw",
    "coords": {
      "lat": 47.10770797729492,
      "lng": 51.861854553222656
    }
  },
  {
    "id": "42864_1",
    "name": "Bavaria East",
    "country": "KZ",
    "city": "Oskemen",
    "address": "Satpayev ave., 62/2, 070000 Oskemen",
    "email": "info@bmw-east.kz",
    "phone": "+7-(7232)-49-20-70",
    "website": "https://bavaria-east.kz/",
    "coords": {
      "lat": 49.91108322143555,
      "lng": 82.62549591064453
    }
  },
  {
    "id": "37098_2",
    "name": "Bavaria Astana",
    "country": "KZ",
    "city": "Astana",
    "address": "Kabanbai Batyr ave., 35, 010000 Astana",
    "email": "info.astana@bavaria.kz",
    "phone": "+7-(7172)-57-61-61",
    "website": "https://bavaria-astana.kz",
    "coords": {
      "lat": 51.11988067626953,
      "lng": 71.40809631347656
    }
  },
  {
    "id": "54208_1",
    "name": "Bavaria Pavlodar",
    "country": "KZ",
    "city": "Pavlodar",
    "address": "Raketnaya 7, 140000 Pavlodar",
    "email": null,
    "phone": null,
    "website": "https://bavaria-pavlodar.kz",
    "coords": {
      "lat": 52.32381820678711,
      "lng": 76.89154815673828
    }
  },
  {
    "id": "43030_1",
    "name": "Bavaria Batys",
    "country": "KZ",
    "city": "Uralsk",
    "address": "Zhambyl str., 253, 090000 Uralsk",
    "email": "info@bavaria-uralsk.kz",
    "phone": "+7-711-7077444",
    "website": "https://bavaria-uralsk.kz",
    "coords": {
      "lat": 51.241477966308594,
      "lng": 51.44915008544922
    }
  },
  {
    "id": "45558_1",
    "name": "Bavaria Kostanay",
    "country": "KZ",
    "city": "Kostanay",
    "address": "Baimagambetova 147/3, 110000 Kostanay",
    "email": "office@kostanay.hyundai.kz",
    "phone": "+7-7142-990299",
    "website": "https://bavaria-kostanay.kz",
    "coords": {
      "lat": 53.207603454589844,
      "lng": 63.61505889892578
    }
  },
  {
    "id": "54176_1",
    "name": "Bavaria Kostanay",
    "country": "KZ",
    "city": "Kostanay",
    "address": "Abay 111, 110000 Kostanay",
    "email": null,
    "phone": "+7-747-0941969",
    "website": null,
    "coords": {
      "lat": 53.202945709228516,
      "lng": 63.62630081176758
    }
  },
  {
    "id": "53885_1",
    "name": "Bavaria Shymkent",
    "country": "KZ",
    "city": "Shymkent",
    "address": "Shymkent city Tamerlan highway 236, 160005 Shymkent",
    "email": null,
    "phone": "+7-747-3020202",
    "website": null,
    "coords": {
      "lat": 42.36115264892578,
      "lng": 69.51902770996094
    }
  },
  {
    "id": "00211_2",
    "name": "Bassoul Heneine S.A.L Service Center",
    "country": "LB",
    "city": "Beirut",
    "address": "Mar EliasStreet, 9999 Beirut",
    "email": "info@bashen.com",
    "phone": "+961-1-360779",
    "website": "https://www.bmw-lebanon.com",
    "coords": {
      "lat": 33.885948181152344,
      "lng": 35.49351501464844
    }
  },
  {
    "id": "00211_3",
    "name": "Bassoul Heneine S.A.L Showroom",
    "country": "LB",
    "city": "Beirut",
    "address": "Mina El Hosn Street, 9999 Beirut",
    "email": "info@bashen.com",
    "phone": "+961-1-360779",
    "website": "https://www.bmw-lebanon.com",
    "coords": {
      "lat": 33.90261459350586,
      "lng": 35.4924201965332
    }
  },
  {
    "id": "00211_1",
    "name": "Bassoul Heneine",
    "country": "LB",
    "city": "Beirut",
    "address": "Youssef Heneine Street, 2613-4203 Beirut",
    "email": "info@bashen.com",
    "phone": "+961-1-684684",
    "website": "https://www.bmw-lebanon.com",
    "coords": {
      "lat": 33.88356399536133,
      "lng": 35.5583381652832
    }
  },
  {
    "id": "10616_1",
    "name": "Prestige Automobile (Pvt) Ltd.",
    "country": "LK",
    "city": "Battaramulla",
    "address": "#234-238, Pannipitiya Road, 94043 Battaramulla",
    "email": "prestige@prestigeauto.lk",
    "phone": "+94/-2875661",
    "website": "https://www.bmw.lk",
    "coords": {
      "lat": 6.896154403686523,
      "lng": 79.92280578613281
    }
  },
  {
    "id": "27165_1",
    "name": "Schweig",
    "country": "LU",
    "city": "Hosingen",
    "address": "6, Haaptstrooss, 9806 Hosingen",
    "email": "info@schweig.net.bmw.lu",
    "phone": "+352-92-1376",
    "website": "http://www.schweig.bmw.lu",
    "coords": {
      "lat": 50.01390075683594,
      "lng": 6.091007232666016
    }
  },
  {
    "id": "27166_1",
    "name": "Bilia Mersch",
    "country": "LU",
    "city": "Mersch",
    "address": "21, Rue de la Gare, 7535 Mersch",
    "email": "mersch@bilia.lu",
    "phone": "+352-32-9111",
    "website": "https://bilia.bmw.lu/fr",
    "coords": {
      "lat": 49.75300598144531,
      "lng": 6.109879016876221
    }
  },
  {
    "id": "26836_1",
    "name": "Bilia Luxembourg",
    "country": "LU",
    "city": "Luxembourg",
    "address": "7, Rue Christophe Plantin, 2339 Luxembourg",
    "email": "bmw@bilia.lu",
    "phone": "+352-49-1941",
    "website": "https://www.bilia.bmw.lu",
    "coords": {
      "lat": 49.58871078491211,
      "lng": 6.120251178741455
    }
  },
  {
    "id": "27164_1",
    "name": "Muzzolini",
    "country": "LU",
    "city": "Esch-Sur-Alzette",
    "address": "6 Rue Romain Fandel, 4149 Esch-Sur-Alzette",
    "email": "info@muzzolini.net.bmw.lu",
    "phone": "+352-57-2626",
    "website": "http://www.muzzolini.bmw.lu",
    "coords": {
      "lat": 49.51321792602539,
      "lng": 5.996328830718994
    }
  },
  {
    "id": "44703_1",
    "name": "Tripoli Center Showroom",
    "country": "LY",
    "city": "Tripoli",
    "address": "Al-Rabea Al-Arabi, 779 Tripoli",
    "email": "redasbeta@gmail.com",
    "phone": "+218-21-3339935",
    "website": "https://www.bmw.ly",
    "coords": {
      "lat": 32.88570022583008,
      "lng": 13.174070358276367
    }
  },
  {
    "id": "54398_1",
    "name": "Madi Company for car import",
    "country": "LY",
    "city": "Tripoli",
    "address": "Swani Road, 00218 Tripoli",
    "email": "ashraf.hassan@madi-libya.com",
    "phone": "+218-34666611717",
    "website": null,
    "coords": {
      "lat": 32.802154541015625,
      "lng": 13.127086639404297
    }
  },
  {
    "id": "21149_2",
    "name": "Ryad Auto - Rabat",
    "country": "MA",
    "city": "Rabat",
    "address": "Avenue Mehdi Ben Barka, 10104 Rabat",
    "email": "contact@smeia.com",
    "phone": "+212-37-716200",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 33.94823455810547,
      "lng": -6.870352745056152
    }
  },
  {
    "id": "21149_3",
    "name": "Smeia Tangier",
    "country": "MA",
    "city": "Tangier",
    "address": "Lot 23-24, ZI Gzenaya, 90000 Tangier",
    "email": "contact@smeia.com",
    "phone": "+212-539-399430",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 35.715538024902344,
      "lng": -5.903700828552246
    }
  },
  {
    "id": "21149_4",
    "name": "Smeia Marrakech",
    "country": "MA",
    "city": "Marrakech",
    "address": "KM 10, Route de Fès, 40000 Marrakech",
    "email": "contact@smeia.com",
    "phone": "+212-524-327235",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 31.647920608520508,
      "lng": -7.934301376342773
    }
  },
  {
    "id": "21149_6",
    "name": "Smeia Fes",
    "country": "MA",
    "city": "Fès",
    "address": "Unité d'aménagement touristique, 30090 Fès",
    "email": "contact@smeia.com",
    "phone": "+212/-522-400700",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 34.056427001953125,
      "lng": -5.009424686431885
    }
  },
  {
    "id": "28507_1",
    "name": "Soutra - Agadir",
    "country": "MA",
    "city": "Agadir",
    "address": "313 Avenue Hassan II, 99999 Agadir",
    "email": "contact@smeia.com",
    "phone": "+212-528-847428",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 30.360689163208008,
      "lng": -9.5347900390625
    }
  },
  {
    "id": "21149_7",
    "name": "Smeia Oujda",
    "country": "MA",
    "city": "Oujda",
    "address": "Commune rurale Ahl Angad Technopole, 6000 Oujda",
    "email": "contact@smeia.com",
    "phone": "+212/-522-400700",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 34.77021408081055,
      "lng": -1.9418407678604126
    }
  },
  {
    "id": "21149_1",
    "name": "Smeia",
    "country": "MA",
    "city": "Casablanca",
    "address": "Angle Bd Moulay Slimane et, 20250 Casablanca",
    "email": "contact@smeia.com",
    "phone": "+212/-522-400700",
    "website": "https://www.bmw.ma",
    "coords": {
      "lat": 33.594261169433594,
      "lng": -7.587060451507568
    }
  },
  {
    "id": "20745_1",
    "name": "Autospace S.R.L.",
    "country": "MD",
    "city": "Chisinau",
    "address": "Str. Bucuriei nr.18a, 2004 Chisinau",
    "email": "bmw@bmw.md",
    "phone": "+373-22-223399",
    "website": null,
    "coords": {
      "lat": 47.04129409790039,
      "lng": 28.811866760253906
    }
  },
  {
    "id": "37005_1",
    "name": "VOLI MOTORS D.O.O.",
    "country": "ME",
    "city": "Podgorica",
    "address": "27 Josipa Broza Tita, 81000 Podgorica",
    "email": "office@bmw-voli.me",
    "phone": "+382-20-652880",
    "website": "https://www.bmw-voli.me",
    "coords": {
      "lat": 42.432857513427734,
      "lng": 19.27386474609375
    }
  },
  {
    "id": "53895_1",
    "name": "MBM Parfait Martinique",
    "country": "MQ",
    "city": "LE LAMENTIN",
    "address": "Centre Commercial la Galleria, 97232 LE LAMENTIN",
    "email": null,
    "phone": null,
    "website": null,
    "coords": {
      "lat": 14.619752883911133,
      "lng": -61.01054000854492
    }
  },
  {
    "id": "20090_1",
    "name": "Muscats Motors Ltd.",
    "country": "MT",
    "city": "Gzira",
    "address": "Rue D' Argens, GZR1368 Gzira",
    "email": "info@mml.mizzi.com.mt",
    "phone": "+356-23-264000",
    "website": "http://www.bmw.com.mt/en",
    "coords": {
      "lat": 35.908729553222656,
      "lng": 14.494500160217285
    }
  },
  {
    "id": "00166_1",
    "name": "Leal & Co. Ltd.",
    "country": "MU",
    "city": "Les Pailles",
    "address": "Motorway M1, 11201 Les Pailles",
    "email": "bmwsales@lealgroup.mu",
    "phone": "+230-207-2300",
    "website": "https://www.bmw.mu",
    "coords": {
      "lat": -20.19671058654785,
      "lng": 57.48308563232422
    }
  },
  {
    "id": "29479_2",
    "name": "Seong Hoe Premium Motors Sdn. Bhd. (Melaka)",
    "country": "MY",
    "city": "Melaka",
    "address": "Lot 188, Jalan Semabok,, 75450 Melaka",
    "email": "bmw@seonghoe.com.my",
    "phone": "+60-6-2882228",
    "website": "https://www.bmw-seonghoe.com.my",
    "coords": {
      "lat": 2.1962320804595947,
      "lng": 102.26943969726562
    }
  },
  {
    "id": "36835_2",
    "name": "Regas Premium Auto Sdn Bhd (Sibu)",
    "country": "MY",
    "city": "Sibu",
    "address": "35, Jalan Lanang, 96000 Sibu",
    "email": "info@regas.com.my",
    "phone": "+6084-344444",
    "website": "https://www.bmw-regas.com.my",
    "coords": {
      "lat": 2.281214952468872,
      "lng": 111.83596801757812
    }
  },
  {
    "id": "37479_1",
    "name": "Wheelcorp Premium Sdn Bhd (Setia Alam)",
    "country": "MY",
    "city": "Shah Alam",
    "address": "No 1, Jalan Setia Murni AH U13/AH, 40170 Shah Alam",
    "email": "info@wheelcorppremium.com.my",
    "phone": "+603-33583913",
    "website": "https://www.bmw-wheelcorppremium.com.my",
    "coords": {
      "lat": 3.109971046447754,
      "lng": 101.4501724243164
    }
  },
  {
    "id": "30484_2",
    "name": "Tian Siang Premium Auto Sdn. Bhd. (Butterworth)",
    "country": "MY",
    "city": "Prai",
    "address": "Lot 6235, Jalan Baru, 13700 Prai",
    "email": "bmw@tiansiang.com",
    "phone": "+04-3982600",
    "website": "https://www.bmw-tiansiang.my",
    "coords": {
      "lat": 5.373550891876221,
      "lng": 100.40766143798828
    }
  },
  {
    "id": "25329_1",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Ara Damansara)",
    "country": "MY",
    "city": "Petaling Jaya",
    "address": "Block 1, Sime Darby Motors City, 47301 Petaling Jaya",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 3.1150360107421875,
      "lng": 101.57009887695312
    }
  },
  {
    "id": "25329_10",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Kuala Lumpur)",
    "country": "MY",
    "city": "Kuala Lumpur",
    "address": "362, Jalan Tun Razak, 50400 Kuala Lumpur",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 3.1585190296173096,
      "lng": 101.72122955322266
    }
  },
  {
    "id": "36835_1",
    "name": "Regas Premium Auto Sdn Bhd (Kuching)",
    "country": "MY",
    "city": "Kuching",
    "address": "8, Jalan Tun Jugah, 93350 Kuching",
    "email": "info@regas.com.my",
    "phone": "+6082-467777",
    "website": "https://www.bmw-regas.com.my",
    "coords": {
      "lat": 1.5198179483413696,
      "lng": 110.35347747802734
    }
  },
  {
    "id": "29479_1",
    "name": "Seong Hoe Premium Motors Sdn. Bhd. (Melaka)",
    "country": "MY",
    "city": "Melaka",
    "address": "2020, Jalan Semabok, 75050 Melaka",
    "email": "bmw@seonghoe.com.my",
    "phone": "+06-2882228",
    "website": "https://www.bmw-seonghoe.com.my",
    "coords": {
      "lat": 2.195862054824829,
      "lng": 102.26856231689453
    }
  },
  {
    "id": "25329_14",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (CSL)",
    "country": "MY",
    "city": "Kuala Lumpur",
    "address": "No.8, Jalan Dua Off,, 55200 Kuala Lumpur",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 3.1237809658050537,
      "lng": 101.71183013916016
    }
  },
  {
    "id": "25329_15",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Sungai Pinang)",
    "country": "MY",
    "city": "Georgetown",
    "address": "No 3, Jalan Sungai Pinang, 10150 Georgetown",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 5.401919841766357,
      "lng": 100.32328796386719
    }
  },
  {
    "id": "33873_3",
    "name": "Quill Automobiles Sdn Bhd",
    "country": "MY",
    "city": "Petaling Jaya",
    "address": "14, Jalan 13/4, 46200 Petaling Jaya",
    "email": "info@quill-automobiles.com.my",
    "phone": "+60-3-79411990",
    "website": "https://www.bmw-quillautomobiles.com.my",
    "coords": {
      "lat": 3.115964889526367,
      "lng": 101.64193725585938
    }
  },
  {
    "id": "47038_1",
    "name": "Regas Premium Sabah Sdn Bhd (Kota Kinabalu)",
    "country": "MY",
    "city": "Kota Kinabalu",
    "address": "Lot 2, Jalan Iramanis, 88400 Kota Kinabalu",
    "email": "general.kk@regas.my",
    "phone": "+6088-383303",
    "website": "https://www.bmw-regas.com.my",
    "coords": {
      "lat": 5.970804214477539,
      "lng": 116.11121368408203
    }
  },
  {
    "id": "30484_3",
    "name": "Tian Siang Premium Auto Sdn. Bhd. (Langkawi)",
    "country": "MY",
    "city": "Langkawi",
    "address": "68, Persiaran Dayang 1, 07000 Langkawi",
    "email": "bmw@tiansiang.com",
    "phone": "+604-9668628",
    "website": "https://www.bmw-tiansiang.my",
    "coords": {
      "lat": 6.317954063415527,
      "lng": 99.8508071899414
    }
  },
  {
    "id": "39488_1",
    "name": "Millennium Welt Sdn Bhd (Seremban 2)",
    "country": "MY",
    "city": "Seremban",
    "address": "No.1, Jalan S2 A6, 70300 Seremban",
    "email": "info@millenniumwelt.com.my",
    "phone": "+606-7752288",
    "website": "https://www.bmw-millenniumwelt.com.my",
    "coords": {
      "lat": 2.704906940460205,
      "lng": 101.91072845458984
    }
  },
  {
    "id": "27240_1",
    "name": "Lee Motors Autocare Sdn Bhd (Alor Setar)",
    "country": "MY",
    "city": "Alor Setar",
    "address": "218, Jalan Gangsa, 05150 Alor Setar",
    "email": "sales@leebmw.com.my",
    "phone": "+604-7365280",
    "website": "https://www.bmw-leemotors.com.my",
    "coords": {
      "lat": 6.134639739990234,
      "lng": 100.36065673828125
    }
  },
  {
    "id": "30484_1",
    "name": "Tian Siang Premium Auto Sdn. Bhd. (Ipoh)",
    "country": "MY",
    "city": "Ipoh",
    "address": "99, Jalan Kuala Kangsar, 30010 Ipoh",
    "email": "bmw@tiansiang.com",
    "phone": "+05-5062800",
    "website": "https://www.bmw-tiansiang.my",
    "coords": {
      "lat": 4.624361991882324,
      "lng": 101.08168029785156
    }
  },
  {
    "id": "39488_2",
    "name": "Millennium Welt Sdn Bhd (Batu Pahat)",
    "country": "MY",
    "city": "Batu Pahat",
    "address": "28A & 28B, Jalan Tanjong Laboh, 83000 Batu Pahat",
    "email": "info@millenniumwelt.com.my",
    "phone": "+607-4343288",
    "website": "https://www.bmw-millenniumwelt.com.my",
    "coords": {
      "lat": 1.8453819751739502,
      "lng": 102.94053649902344
    }
  },
  {
    "id": "33873_1",
    "name": "Quill Automobiles Sdn Bhd (Petaling Jaya)",
    "country": "MY",
    "city": "Petaling Jaya",
    "address": "112, Jalan Prof. Khoo Kay Kim, 46300 Petaling Jaya",
    "email": "info@quill-automobiles.com.my",
    "phone": "+03-79556333",
    "website": "https://www.bmw-quillautomobiles.com.my",
    "coords": {
      "lat": 3.113524913787842,
      "lng": 101.63294219970703
    }
  },
  {
    "id": "53924_2",
    "name": "Performance Motors (Puchong)",
    "country": "MY",
    "city": "Puchong",
    "address": "No 3, Lebuh Puteri,, 47100 Puchong",
    "email": null,
    "phone": "1300-13-8288",
    "website": null,
    "coords": {
      "lat": 3.0133700370788574,
      "lng": 101.62139892578125
    }
  },
  {
    "id": "53236_1",
    "name": "Millennium Welt KT Sdn. Bhd.",
    "country": "MY",
    "city": "Kuala Terengganu",
    "address": "159, Jalan Sultan Mohamad, 21100 Kuala Terengganu",
    "email": null,
    "phone": "+609-6221313",
    "website": null,
    "coords": {
      "lat": 5.313461780548096,
      "lng": 103.13823699951172
    }
  },
  {
    "id": "36835_3",
    "name": "Regas Premium Auto Sdn Bhd (Miri)",
    "country": "MY",
    "city": "Miri",
    "address": "Lot 1381, Airport Road, 98000 Miri",
    "email": "info@regas.com.my",
    "phone": "+6085-437699",
    "website": "https://www.bmw-regas.com.my",
    "coords": {
      "lat": 4.357168197631836,
      "lng": 113.98418426513672
    }
  },
  {
    "id": "39488_3",
    "name": "Millennium Welt Sdn Bhd (Kuantan)",
    "country": "MY",
    "city": "Kuantan",
    "address": "Lot 32, Jalan Teluk Sisek, 25000 Kuantan",
    "email": "info@millenniumwelt.com.my",
    "phone": "+609-5161666",
    "website": "https://www.bmw-millenniumwelt.com.my",
    "coords": {
      "lat": 3.8120639324188232,
      "lng": 103.33295440673828
    }
  },
  {
    "id": "53924_1",
    "name": "Performance Motors (Damansara)",
    "country": "MY",
    "city": "Kuala Lumpur",
    "address": "2779, Jalan Damansara, 60000 Kuala Lumpur",
    "email": null,
    "phone": "1300-13-8288",
    "website": null,
    "coords": {
      "lat": 3.163012981414795,
      "lng": 101.61735534667969
    }
  },
  {
    "id": "25329_12",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Tebrau)",
    "country": "MY",
    "city": "Tebrau",
    "address": "3B, Jalan Persiaran Desa Tebrau, 81100 Tebrau",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 1.5498939752578735,
      "lng": 103.79297637939453
    }
  },
  {
    "id": "25329_8",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Balakong)",
    "country": "MY",
    "city": "Balakong",
    "address": "Lot 60566, Jalan Balakong, 43300 Balakong",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 3.027657985687256,
      "lng": 101.75312042236328
    }
  },
  {
    "id": "25329_9",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Penang)",
    "country": "MY",
    "city": "Pulau Pinang",
    "address": "15, Jalan Anson, 10400 Pulau Pinang",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 5.421064853668213,
      "lng": 100.32489776611328
    }
  },
  {
    "id": "25329_3",
    "name": "Sime Darby Auto Bavaria Sdn. Bhd. (Johor Bahru)",
    "country": "MY",
    "city": "Johor Bahru",
    "address": "Batu 4 1/2, Jalan Skudai, 81200 Johor Bahru",
    "email": "abcustomercare@autobavaria.com.my",
    "phone": "1300-13-3338",
    "website": "https://www.bmw-autobavaria.com",
    "coords": {
      "lat": 1.4858089685440063,
      "lng": 103.71595764160156
    }
  },
  {
    "id": "39488_4",
    "name": "Millennium Welt Sdn Bhd (Kuala Lumpur North)",
    "country": "MY",
    "city": "Kuala Lumpur",
    "address": "Lot 50009 Off Jalan Kuching, 51200 Kuala Lumpur",
    "email": "info@millenniumwelt.com.my",
    "phone": "+603-61222288",
    "website": "https://www.bmw-millenniumwelt.com.my",
    "coords": {
      "lat": 3.188926935195923,
      "lng": 101.67001342773438
    }
  },
  {
    "id": "30746_1",
    "name": "BMW Motorrad Pupkewitz",
    "country": "NA",
    "city": "Windhoek",
    "address": "Cnr Bismarck and David Hosea Meroro, 0926 Windhoek",
    "email": "armand.barnard@pupkewitzbmw.com",
    "phone": "+264-61-2958100",
    "website": "http://www.bmw-pupkewitz.co.za/",
    "coords": {
      "lat": -22.580595016479492,
      "lng": 17.066633224487305
    }
  },
  {
    "id": "21721_8",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Uyo",
    "address": "Nwaniba Road, 520221 Uyo",
    "email": "bmwservice@coscharisgroup.net",
    "phone": "+234-8-5291018",
    "website": "https://www.coscharisgroup.com",
    "coords": {
      "lat": 5.02400016784668,
      "lng": 8.0021390914917
    }
  },
  {
    "id": "21721_2",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Abuja",
    "address": "Plot 388 Constitution Avenue, 99999 Abuja",
    "email": "bmw@coscharisgroup.com",
    "phone": "+234/-803-3012567",
    "website": "https://www.coscharisgroup.com",
    "coords": {
      "lat": 9.051252365112305,
      "lng": 7.479170799255371
    }
  },
  {
    "id": "52339_1",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Lagos",
    "address": "KM 32 Lekki-Epe Expressway, Awoyaya, 100001 Lagos",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 6.464000225067139,
      "lng": 3.696023464202881
    }
  },
  {
    "id": "52339_11",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Enugu",
    "address": "No. 7, Kingsway Road,, null Enugu",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 5.438868999481201,
      "lng": 7.481330394744873
    }
  },
  {
    "id": "52339_9",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Lagos",
    "address": "CG-EKO, Old PWD Building, beside, null Lagos",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 6.586597919464111,
      "lng": 3.3408329486846924
    }
  },
  {
    "id": "52339_10",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "AWKA",
    "address": "Ike Etele Plaza Beside CBN, null AWKA",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 6.2254719734191895,
      "lng": 7.081974983215332
    }
  },
  {
    "id": "52339_5",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Port Harcourt",
    "address": "242, Aba Road, null Port Harcourt",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 4.815842628479004,
      "lng": 7.04990816116333
    }
  },
  {
    "id": "52339_4",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "CALABAR",
    "address": "No.3, Calabar Road, null CALABAR",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 8.963285446166992,
      "lng": 7.324519634246826
    }
  },
  {
    "id": "52339_6",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "LAGOS",
    "address": "Plot 97B, Ahmadu Bello Way, null LAGOS",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 6.4304351806640625,
      "lng": 3.4130959510803223
    }
  },
  {
    "id": "52339_8",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Kano",
    "address": "Plot 8 City Centre, null Kano",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 11.976710319519043,
      "lng": 8.54362964630127
    }
  },
  {
    "id": "52339_12",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Ibadan",
    "address": "KM 10, Iwo - Osogbo Road, null Ibadan",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 5.403309345245361,
      "lng": 7.9392571449279785
    }
  },
  {
    "id": "52339_3",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "ABUJA",
    "address": "PLOT 388 CONSTITUTION AVENUE, 900211 ABUJA",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 9.051586151123047,
      "lng": 7.479378700256348
    }
  },
  {
    "id": "21721_3",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Port Harcourt",
    "address": "Plot 242  Aba Road, 500262 Port Harcourt",
    "email": "bmw@coscharisgroup.com",
    "phone": "+234-803-5470559",
    "website": "https://www.coscharisgroup.com",
    "coords": {
      "lat": 4.8355021476745605,
      "lng": 7.019198894500732
    }
  },
  {
    "id": "52339_2",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "LAGOS",
    "address": "68A ADEOLA ODEKU, null LAGOS",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 6.4304351806640625,
      "lng": 3.4130959510803223
    }
  },
  {
    "id": "21721_7",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Kano",
    "address": "Plot 8 Guda Abdullahi Road, 700231 Kano",
    "email": "bmwservice@coscharisgroup.net",
    "phone": "+234-1-4431746",
    "website": "https://www.coscharisgroup.com",
    "coords": {
      "lat": 11.976694107055664,
      "lng": 8.543618202209473
    }
  },
  {
    "id": "52339_7",
    "name": "Coscharis Motors Ltd.",
    "country": "NG",
    "city": "Uyo",
    "address": "Nwaniba Road, Oppoite Atlantic FM,, null Uyo",
    "email": "info@coscharisgroup.net",
    "phone": "+234-802-2908265",
    "website": "https://www.coscharisgroup.net",
    "coords": {
      "lat": 5.026825428009033,
      "lng": 7.978974342346191
    }
  },
  {
    "id": "10075_1",
    "name": "Bilia Norge AS, Avd. Hønefoss",
    "country": "NO",
    "city": "Hønefoss",
    "address": "Asbjørnsensgt. 21, 3503 Hønefoss",
    "email": "firmapost.honefoss@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 60.176109313964844,
      "lng": 10.276189804077148
    }
  },
  {
    "id": "10075_8",
    "name": "Bilia Norge AS, Avd Gol",
    "country": "NO",
    "city": "Gol",
    "address": "Heradvegen 9, 3550 Gol",
    "email": "firmapost.gol@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 60.70197677612305,
      "lng": 8.988507270812988
    }
  },
  {
    "id": "51931_1",
    "name": "Sulland Auto AS, Hamar Avd. Hamar",
    "country": "NO",
    "city": "Hamar",
    "address": "Disenstrandvegen 9, 2306 Hamar",
    "email": "post.sulland.hamar@sulland.no",
    "phone": "+47-62-536650",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 60.79124069213867,
      "lng": 11.096115112304688
    }
  },
  {
    "id": "51931_15",
    "name": "Sulland Auto AS, Steinkjer Avd. Steinkjer",
    "country": "NO",
    "city": "Steinkjer",
    "address": "Moloveien 26, 7714 Steinkjer",
    "email": "post.bst@sulland.no",
    "phone": "+47-74-046510",
    "website": "https://www.sulland.no/sulland-steinkjer-bmw",
    "coords": {
      "lat": 64.007568359375,
      "lng": 11.491168022155762
    }
  },
  {
    "id": "10075_11",
    "name": "Bilia Norge AS, Avd.Kongsvinger",
    "country": "NO",
    "city": "Kongsvinger",
    "address": "Gaukåsvegen 7, 2211 Kongsvinger",
    "email": "firmapost.kongsvinger@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 60.170265197753906,
      "lng": 12.026274681091309
    }
  },
  {
    "id": "51931_2",
    "name": "Sulland Auto AS, Gjøvik Avd. Gjøvik",
    "country": "NO",
    "city": "Gjøvik",
    "address": "Autovegen 3, 2803 Gjøvik",
    "email": "post.sulland.gjovik@sulland.no",
    "phone": "+47-61-140700",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 60.782325744628906,
      "lng": 10.629317283630371
    }
  },
  {
    "id": "51931_11",
    "name": "Sulland Auto AS, Bodø Avd. Bodø",
    "country": "NO",
    "city": "Bodø",
    "address": "Olav V Gate 106, 8004 Bodø",
    "email": "post.bbo@sulland.no",
    "phone": "+47-40-130400",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 67.27497863769531,
      "lng": 14.406460762023926
    }
  },
  {
    "id": "24766_12",
    "name": "Hedin Automotive Bavaria AS Molde",
    "country": "NO",
    "city": "Molde",
    "address": "Hendenvegen 3, 6423 Molde",
    "email": "service.molde@hedinautomotive.no",
    "phone": "+47-71-201400",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 62.762298583984375,
      "lng": 7.2717790603637695
    }
  },
  {
    "id": "24766_17",
    "name": "Hedin Automotive Bavaria AS Stavanger",
    "country": "NO",
    "city": "Stavanger",
    "address": "Fabrikkveien 36, 4033 Stavanger",
    "email": "service.stavanger@hedinautomotive.no",
    "phone": "+47-51-965000",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 58.902931213378906,
      "lng": 5.698391914367676
    }
  },
  {
    "id": "24766_7",
    "name": "Hedin Automotive Bavaria AS Kristiansand",
    "country": "NO",
    "city": "Kristiansand",
    "address": "Barstølveien 32, 4636 Kristiansand",
    "email": "service.kristiansand@hedinautomotive.no",
    "phone": "+47-38-145430",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 58.17156982421875,
      "lng": 8.123430252075195
    }
  },
  {
    "id": "24766_9",
    "name": "Hedin Automotive Bavaria AS Arendal",
    "country": "NO",
    "city": "Arendal",
    "address": "Stoaveien 2, 4858 Arendal",
    "email": "service.arendal@hedinautomotive.no",
    "phone": "+47-37-006900",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 58.459129333496094,
      "lng": 8.713408470153809
    }
  },
  {
    "id": "24766_15",
    "name": "Hedin Automotive Bavaria AS Oslo",
    "country": "NO",
    "city": "Oslo",
    "address": "Breivollveien 31, 0668 Oslo",
    "email": "service.oslo@hedinautomotive.no",
    "phone": "+47-23-377220",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 59.9229850769043,
      "lng": 10.841650009155273
    }
  },
  {
    "id": "24766_13",
    "name": "Hedin Automotive Bavaria AS Kristiansund",
    "country": "NO",
    "city": "Kristiansund",
    "address": "Verkstedveien 5, 6517 Kristiansund",
    "email": "service.kristiansund@hedinautomotive.no",
    "phone": "+47-70-334560",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 63.10968017578125,
      "lng": 7.775030136108398
    }
  },
  {
    "id": "24766_21",
    "name": "Hedin Automotive Bavaria AS Haugesund",
    "country": "NO",
    "city": "Karmsund",
    "address": "Norevegen 5, 5508 Karmsund",
    "email": "service.haugesund@hedinautomotive.no",
    "phone": "+47-52-859100",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 59.38264846801758,
      "lng": 5.308990478515625
    }
  },
  {
    "id": "21316_1",
    "name": "Strandveien Auto AS",
    "country": "NO",
    "city": "Trondheim",
    "address": "Tungasletta 16, 7047 Trondheim",
    "email": "mail@strandveienauto.no",
    "phone": "+47-73-875000",
    "website": "https://strandveienauto.no",
    "coords": {
      "lat": 63.42007064819336,
      "lng": 10.462486267089844
    }
  },
  {
    "id": "10075_10",
    "name": "Bilia Norge AS, Avd. Skien",
    "country": "NO",
    "city": "Skien",
    "address": "Østre Buktenveg 8, 3736 Skien",
    "email": "personbil@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.16120147705078,
      "lng": 9.635518074035645
    }
  },
  {
    "id": "51931_4",
    "name": "Sulland Auto AS, Trondheim",
    "country": "NO",
    "city": "Tiller",
    "address": "Vestre Rosten 83, 7075 Tiller",
    "email": "post.trondheim@sulland.no",
    "phone": "+47-96-237000",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 63.36577606201172,
      "lng": 10.375776290893555
    }
  },
  {
    "id": "04779_1",
    "name": "Sulland Østfold AS, Sarpsborg Avd. Sarpsborg",
    "country": "NO",
    "city": "Sarpsborg",
    "address": "Johan Gundersens Vei 2, 1711 Sarpsborg",
    "email": "post.fsa@sulland.no",
    "phone": "+47-69-138700",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 59.28325271606445,
      "lng": 11.080720901489258
    }
  },
  {
    "id": "31758_1",
    "name": "GS Bildeler AS",
    "country": "NO",
    "city": "Bud",
    "address": "Prestgardsvegen 160, 6430 Bud",
    "email": "verksted@gsbildeler.no",
    "phone": "+47-71-266777",
    "website": "https://www.gsbildeler.no/verksted/bud",
    "coords": {
      "lat": 62.906864166259766,
      "lng": 6.916532039642334
    }
  },
  {
    "id": "51931_8",
    "name": "Sulland Auto AS, Fredrikstad Avd. Fredrikstad",
    "country": "NO",
    "city": "Fredrikstad",
    "address": "Smørbøttaveien 11, 1617 Fredrikstad",
    "email": "post.bfr@sulland.no",
    "phone": "+47-69-351640",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 59.240074157714844,
      "lng": 10.979117393493652
    }
  },
  {
    "id": "10075_2",
    "name": "Bilia Norge AS, Avd Skøyen",
    "country": "NO",
    "city": "Oslo",
    "address": "Drammensveien 213, 0281 Oslo",
    "email": "firmapost.skoyen@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.917991638183594,
      "lng": 10.6614408493042
    }
  },
  {
    "id": "10075_14",
    "name": "Bilia Norge AS, Drammen",
    "country": "NO",
    "city": "Lierstranda",
    "address": "Industrigata 2, 3414 Lierstranda",
    "email": "firmapost.drammen@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.75656509399414,
      "lng": 10.258584976196289
    }
  },
  {
    "id": "24766_1",
    "name": "Hedin Automotive Bavaria AS Gardermoen",
    "country": "NO",
    "city": "Gardermoen",
    "address": "Museumsvegen 16, 2060 Gardermoen",
    "email": "service.gardermoen@hedinautomotive.no",
    "phone": "+47-63-942480",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 60.18780517578125,
      "lng": 11.068609237670898
    }
  },
  {
    "id": "24766_3",
    "name": "Hedin Automotive Bavaria AS Lillestrøm",
    "country": "NO",
    "city": "Kjeller",
    "address": "C.J. Hansens vei 15, 2007 Kjeller",
    "email": "service.lillestrom@hedinautomotive.no",
    "phone": "+47-64-847300",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 59.963157653808594,
      "lng": 11.062688827514648
    }
  },
  {
    "id": "24766_18",
    "name": "Hedin Automotive Bavaria AS Bryne",
    "country": "NO",
    "city": "Bryne",
    "address": "Martin Vagles vei 5, 4344 Bryne",
    "email": "service.bryne@hedinautomotive.no",
    "phone": "+47-51-776650",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 58.72171401977539,
      "lng": 5.637798309326172
    }
  },
  {
    "id": "04671_4",
    "name": "Jæger Sentrum avd. Førde",
    "country": "NO",
    "city": "Førde",
    "address": "Hafstadvegen 76, 6802 Førde",
    "email": "post@biltreff.no",
    "phone": "+47-57-725660",
    "website": "http://www.bmw.biltreff.no/",
    "coords": {
      "lat": 61.448455810546875,
      "lng": 5.872406959533691
    }
  },
  {
    "id": "04618_1",
    "name": "Steinkjer Bil A/S",
    "country": "NO",
    "city": "Steinkjer",
    "address": "Fjordg. 9, 7714 Steinkjer",
    "email": "verksted@steinkjerbil.no",
    "phone": "+47-74-170850",
    "website": "https://www.steinkjerbil.no",
    "coords": {
      "lat": 64.00909423828125,
      "lng": 11.490039825439453
    }
  },
  {
    "id": "04671_3",
    "name": "Jæger Sentrum avd. Åsane",
    "country": "NO",
    "city": "Nyborg",
    "address": "Litleåsveien 53, 5132 Nyborg",
    "email": "salg@jaeger.no",
    "phone": "+47-55-606300",
    "website": "https://www.jaegersentrum.no",
    "coords": {
      "lat": 60.46718978881836,
      "lng": 5.3385701179504395
    }
  },
  {
    "id": "10075_3",
    "name": "Bilia Norge AS, Avd. Follo",
    "country": "NO",
    "city": "Ski",
    "address": "Nordbyveien 98, 1406 Ski",
    "email": "firmapost.follo@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.71822738647461,
      "lng": 10.797650337219238
    }
  },
  {
    "id": "51931_3",
    "name": "Sulland Auto AS, Lillehammer Avd. Lillehammer",
    "country": "NO",
    "city": "Lillehammer",
    "address": "Lagervegen 1, 2605 Lillehammer",
    "email": "post.sulland.lillehammer@sulland.no",
    "phone": "+47-61-248786",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 61.12945556640625,
      "lng": 10.444584846496582
    }
  },
  {
    "id": "51931_12",
    "name": "Sulland Auto AS, Tromsø Avd. Tromsø",
    "country": "NO",
    "city": "Tromsø",
    "address": "Heilovegen 12, 9015 Tromsø",
    "email": "post.btr@sulland.no",
    "phone": "+47-40-130700",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 69.67561340332031,
      "lng": 18.924091339111328
    }
  },
  {
    "id": "51931_13",
    "name": "Sulland Auto AS, Harstad Avd. Harstad",
    "country": "NO",
    "city": "Harstad",
    "address": "Gamle Stangnesvei 1, 9409 Harstad",
    "email": "post.bht@sulland.no",
    "phone": "+47-40-130600",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 68.78295135498047,
      "lng": 16.56473159790039
    }
  },
  {
    "id": "04671_1",
    "name": "Jæger Sentrum avd. Kokstad",
    "country": "NO",
    "city": "Kokstad",
    "address": "Kokstadvegen 42, 5257 Kokstad",
    "email": "nybil@jaeger.no",
    "phone": "+47-55-606300",
    "website": "https://www.jaegersentrum.no",
    "coords": {
      "lat": 60.30058288574219,
      "lng": 5.264392852783203
    }
  },
  {
    "id": "10075_9",
    "name": "Bilia Norge AS, Avd Furubakken",
    "country": "NO",
    "city": "Høvik",
    "address": "Ramstadsletta 15, 1363 Høvik",
    "email": "firmapost.hovik.bmw@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.898590087890625,
      "lng": 10.567675590515137
    }
  },
  {
    "id": "10075_12",
    "name": "Bilia Norge AS, Avd Notodden",
    "country": "NO",
    "city": "Notodden",
    "address": "Tuvenbøygen 1, 3676 Notodden",
    "email": "dag.christensen@bilia.no",
    "phone": "+47-915-08555",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.56532669067383,
      "lng": 9.225642204284668
    }
  },
  {
    "id": "29020_1",
    "name": "Bilia Norge AS, Avd. Vestfold",
    "country": "NO",
    "city": "Tønsberg",
    "address": "Semslinna 15, 3170 Tønsberg",
    "email": "firmapost.vestfold@bilia.no",
    "phone": "+47-53-024000",
    "website": "https://www.bilia.no/biler/bmw",
    "coords": {
      "lat": 59.281768798828125,
      "lng": 10.36870002746582
    }
  },
  {
    "id": "51931_9",
    "name": "Sulland Auto AS, Moss Avd. Moss",
    "country": "NO",
    "city": "Moss",
    "address": "Varnaveien 30, 1523 Moss",
    "email": "post.bmo@sulland.no",
    "phone": "+47-69-262400",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 59.417903900146484,
      "lng": 10.676169395446777
    }
  },
  {
    "id": "51931_14",
    "name": "Sulland Auto AS, Alta Avd. Alta",
    "country": "NO",
    "city": "Alta",
    "address": "Trekanten 2, 9515 Alta",
    "email": "post.bal@sulland.no",
    "phone": "+47-90-754750",
    "website": "https://www.sulland.no/merker/bmw",
    "coords": {
      "lat": 69.97452545166016,
      "lng": 23.36545181274414
    }
  },
  {
    "id": "24766_14",
    "name": "Hedin Automotive Bavaria AS Ålesund",
    "country": "NO",
    "city": "Skodje",
    "address": "Digerneset Næringspark 8, 6260 Skodje",
    "email": "service.alesund@hedinautomotive.no",
    "phone": "+47-70-178585",
    "website": "https://hedinautomotive.no/",
    "coords": {
      "lat": 62.491241455078125,
      "lng": 6.609341144561768
    }
  },
  {
    "id": "48529_1",
    "name": "Laxmi Premium Motors P Ltd",
    "country": "NP",
    "city": "Kathmandu",
    "address": "Ward no-32 Tinkune, 44600 Kathmandu",
    "email": null,
    "phone": "+977-1-4111776",
    "website": null,
    "coords": {
      "lat": 27.68589210510254,
      "lng": 85.34709930419922
    }
  },
  {
    "id": "26974_1",
    "name": "Coombes Johnston Tauranga",
    "country": "NZ",
    "city": "Tauranga",
    "address": "113 Hewletts Road, 3116 Tauranga",
    "email": "tgasales@coombesjohnstonbmw.co.nz",
    "phone": "+64-7-5755280",
    "website": "https://www.coombesjohnstonbmwtauranga.co.nz",
    "coords": {
      "lat": -37.665992736816406,
      "lng": 176.1956024169922
    }
  },
  {
    "id": "26965_1",
    "name": "Coombes Johnston BMW",
    "country": "NZ",
    "city": "Hamilton",
    "address": "497 Te Rapa Road, 3200 Hamilton",
    "email": "sales@coombesjohnstonbmw.co.nz",
    "phone": "+64-7-8468888",
    "website": "https://www.coombesjohnstonbmw.co.nz",
    "coords": {
      "lat": -37.76028823852539,
      "lng": 175.2484893798828
    }
  },
  {
    "id": "09065_4",
    "name": "East Auckland BMW",
    "country": "NZ",
    "city": "Auckland",
    "address": "8 Beale Place, 2013 Auckland",
    "email": "info@eastaucklandbmw.co.nz",
    "phone": "+64-9-2838120",
    "website": "https://www.eastaucklandbmw.com",
    "coords": {
      "lat": -36.95486831665039,
      "lng": 174.90374755859375
    }
  },
  {
    "id": "01179_4",
    "name": "Continental Cars BMW Wellington",
    "country": "NZ",
    "city": "Wellington",
    "address": "138 Hutt Road, Kaiwharawhara, 6035 Wellington",
    "email": "sales@ccbmwwellington.co.nz",
    "phone": "+64-4-4999030",
    "website": "https://www.ccbmwwellington.co.nz",
    "coords": {
      "lat": -41.2589225769043,
      "lng": 174.79148864746094
    }
  },
  {
    "id": "53563_1",
    "name": "Manawatu BMW",
    "country": "NZ",
    "city": "Palmerston North",
    "address": "550 Tremaine Avenue, 4410 Palmerston North",
    "email": "euan.means@manawatubmw.co.nz",
    "phone": "+64-6-9526940",
    "website": "https://www.manawatubmw.co.nz",
    "coords": {
      "lat": -40.34351348876953,
      "lng": 175.60252380371094
    }
  },
  {
    "id": "44614_1",
    "name": "Christchurch BMW",
    "country": "NZ",
    "city": "Christchurch",
    "address": "104 Moorhouse Avenue, 8011 Christchurch",
    "email": "sales@chchbmw.co.nz",
    "phone": "+64-3-3637240",
    "website": "https://www.christchurchbmw.co.nz",
    "coords": {
      "lat": -43.5401725769043,
      "lng": 172.62515258789062
    }
  },
  {
    "id": "01179_1",
    "name": "Continental Cars BMW",
    "country": "NZ",
    "city": "Auckland",
    "address": "45 Wairau Road, 0622 Auckland",
    "email": "hayden.cate@continentalcarsbmw.co.nz",
    "phone": "+64-9-4882000",
    "website": "https://www.ccbmwauckland.co.nz",
    "coords": {
      "lat": -36.77859878540039,
      "lng": 174.74607849121094
    }
  },
  {
    "id": "44615_1",
    "name": "Hawkes Bay BMW",
    "country": "NZ",
    "city": "Hastings",
    "address": "822-824 North Karamu Road, 4122 Hastings",
    "email": "sales@hawkesbaybmw.co.nz",
    "phone": "+64-6-8730055",
    "website": "https://www.hawkesbaybmw.co.nz",
    "coords": {
      "lat": -39.63701248168945,
      "lng": 176.85403442382812
    }
  },
  {
    "id": "09065_1",
    "name": "Auckland City BMW",
    "country": "NZ",
    "city": "Newmarket",
    "address": "7 Great South Road, 1051 Newmarket",
    "email": "info@aucklandcitybmw.com",
    "phone": "+64-9-5243300",
    "website": "https://www.aucklandcitybmw.com",
    "coords": {
      "lat": -36.87629318237305,
      "lng": 174.7779998779297
    }
  },
  {
    "id": "02582_1",
    "name": "Cooke Howlison BMW",
    "country": "NZ",
    "city": "Dunedin",
    "address": "451 Andersons Bay Road, 9001 Dunedin",
    "email": "bmwsales@cookehowlison.co.nz",
    "phone": "+64-3-4664903",
    "website": "https://www.cookehowlisonbmw.co.nz",
    "coords": {
      "lat": -45.89577865600586,
      "lng": 170.50631713867188
    }
  },
  {
    "id": "03974_1",
    "name": "BMW Costa del Este",
    "country": "PA",
    "city": "Ciudad de Panamá",
    "address": "Calle 2da y Calle 1ra transversal, null Ciudad de Panamá",
    "email": "gdeluca@fasa.com.pa",
    "phone": "+507-378-0400",
    "website": "https://www.bmw.com.pa",
    "coords": {
      "lat": 9.021936416625977,
      "lng": -79.46207427978516
    }
  },
  {
    "id": "03974_2",
    "name": "BMW David",
    "country": "PA",
    "city": "David",
    "address": "Via Interamericana, null David",
    "email": "gdeluca@fasa.com.pa",
    "phone": "+507/-788-0115",
    "website": "https://www.bmw.com.pa",
    "coords": {
      "lat": 8.433242797851562,
      "lng": -82.42030334472656
    }
  },
  {
    "id": "03974_5",
    "name": "Bavarian Motors David Chirqui",
    "country": "PA",
    "city": "Panama",
    "address": "Av. 7ta Oeste con Calle F Sur, null Panama",
    "email": "gdeluca@fasa.com.pa",
    "phone": "+507-378-0400",
    "website": "https://www.bmw.com.pa",
    "coords": {
      "lat": 8.998311996459961,
      "lng": -79.50175476074219
    }
  },
  {
    "id": "03974_3",
    "name": "BMW Plaza",
    "country": "PA",
    "city": "Ciudad de Panamá",
    "address": "Calle 50 y Via Porras, null Ciudad de Panamá",
    "email": "gdeluca@fasa.com.pa",
    "phone": "+507-378-0400",
    "website": "https://www.bmw.com.pa",
    "coords": {
      "lat": 8.993547439575195,
      "lng": -79.5013427734375
    }
  },
  {
    "id": "39402_1",
    "name": "Roberts BMW - Arequipa",
    "country": "PE",
    "city": "Arequipa",
    "address": "Cruce Av. López de Romaña y Ernesto, 04011 Arequipa",
    "email": "rheredia@gruporoberts.com",
    "phone": "+51-54-606600",
    "website": "https://www.bmw.com.pe",
    "coords": {
      "lat": -16.42091178894043,
      "lng": -71.55110168457031
    }
  },
  {
    "id": "21815_1",
    "name": "BMW Lima",
    "country": "PE",
    "city": "Lima",
    "address": "Av. El Polo 1117, 33 Lima",
    "email": "atencionalcliente.bmw@inchcape.pe",
    "phone": "+511/-6103535",
    "website": "https://www.bmw.com.pe",
    "coords": {
      "lat": -12.096305847167969,
      "lng": -76.96964263916016
    }
  },
  {
    "id": "21815_6",
    "name": "Inchcape Motors Peru S.A.",
    "country": "PE",
    "city": "Arequipa",
    "address": "Av. Alfonso Ugarte 500, 04011 Arequipa",
    "email": "atencionalcliente.bmw@inchcape.pe",
    "phone": "+511/-6103535",
    "website": "https://www.bmw.com.pe",
    "coords": {
      "lat": -16.42698097229004,
      "lng": -71.55755615234375
    }
  },
  {
    "id": "21815_4",
    "name": "Inchcape Motors Perú",
    "country": "PE",
    "city": "Lima",
    "address": "Av. Republica de Panama No 3330, 15047 Lima",
    "email": "victor.acero@inchcape.pe",
    "phone": "+511-6103535",
    "website": "https://www.bmw.com.pe",
    "coords": {
      "lat": -12.096356391906738,
      "lng": -77.02117919921875
    }
  },
  {
    "id": "42505_1",
    "name": "Premium Auto Sopadep SA",
    "country": "PF",
    "city": "Quartier de Tipaerui",
    "address": "Route de ceinture, 98716 Quartier de Tipaerui",
    "email": "contact@sopadep.pf",
    "phone": "+689-40475475",
    "website": "http://www.sopadep.pf/?page=gamme_bmw",
    "coords": {
      "lat": -17.545562744140625,
      "lng": -149.57797241210938
    }
  },
  {
    "id": "42505_4",
    "name": "Premium Auto",
    "country": "PF",
    "city": "Papeete",
    "address": "Servitude Fare Ute, 19 Voie N, 98713 Papeete",
    "email": "dir@sopadep.pf",
    "phone": "+689-4050320",
    "website": null,
    "coords": {
      "lat": -17.530296325683594,
      "lng": -149.56912231445312
    }
  },
  {
    "id": "26611_1",
    "name": "Pampanga Premier Cars, Inc. Premier Motorrad",
    "country": "PH",
    "city": "City of San Fernando, Pampanga",
    "address": "CGIC Building, 2000 City of San Fernando, Pampanga",
    "email": "customercare@premiercarsbmw.com.ph",
    "phone": "+63-9989686379",
    "website": "http://www.bmw.com.ph/en/index.html",
    "coords": {
      "lat": 15.045693397521973,
      "lng": 120.68974304199219
    }
  },
  {
    "id": "53897_1",
    "name": "Visayas Motor Works Inc.",
    "country": "PH",
    "city": "Lahug City of Cebu",
    "address": "Nivel Hills, 6000 Lahug City of Cebu",
    "email": null,
    "phone": "+63-917-1155290",
    "website": null,
    "coords": {
      "lat": 10.338102340698242,
      "lng": 123.89656829833984
    }
  },
  {
    "id": "47635_3",
    "name": "RSA Motors Alabang",
    "country": "PH",
    "city": "Metro Manila",
    "address": "8261 Dr Arcadio Santos Ave, 1700 Metro Manila",
    "email": "alabang@rsabmw.ph",
    "phone": "+63-9088118368",
    "website": "http://www.bmw.com.ph",
    "coords": {
      "lat": 14.461322784423828,
      "lng": 121.02381896972656
    }
  },
  {
    "id": "47635_2",
    "name": "RSA Motors Libis",
    "country": "PH",
    "city": "Quezon City",
    "address": "184 Eulogio Rodriguez Jr. Ave, 1110 Quezon City",
    "email": "info@rsabmw.ph",
    "phone": "+63-282487777",
    "website": "https://www.bmw.com.ph",
    "coords": {
      "lat": 14.608656883239746,
      "lng": 121.07772064208984
    }
  },
  {
    "id": "36994_1",
    "name": "Autoallee",
    "country": "PH",
    "city": "Quezon City",
    "address": "Eton Centris, North Edsa, 1110 Quezon City",
    "email": "customerservice@autoalleebmw.com.ph",
    "phone": "+63-234333191",
    "website": "http://www.bmw.com.ph/en/index.html",
    "coords": {
      "lat": 14.639693260192871,
      "lng": 121.0411148071289
    }
  },
  {
    "id": "47635_1",
    "name": "RSA Motors Greenhills",
    "country": "PH",
    "city": "Mandaluyong City",
    "address": "403 Connecticut St cor Florida and, null Mandaluyong City",
    "email": "info@rsabmw.ph",
    "phone": "+63-2-9171190998",
    "website": "http://www.bmw.com.ph",
    "coords": {
      "lat": 14.601213455200195,
      "lng": 121.05841827392578
    }
  },
  {
    "id": "26825_6",
    "name": "Dewan Motors (Pvt) Ltd. Product Support Centre",
    "country": "PK",
    "city": "Faisalabad",
    "address": "Jaranwala Road, Plot No. 4, 38000 Faisalabad",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-41-8727297",
    "website": "https://www.bmw-pakstian.com",
    "coords": {
      "lat": 31.413772583007812,
      "lng": 73.11268615722656
    }
  },
  {
    "id": "26825_5",
    "name": "Dewan Motors (Pvt) Ltd. Service Only",
    "country": "PK",
    "city": "Islamabad",
    "address": "Plot 81 D, Street No. 6, 44000 Islamabad",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-51-4100736",
    "website": "https://www.bmw-pakistan.com",
    "coords": {
      "lat": 33.66014862060547,
      "lng": 73.05528259277344
    }
  },
  {
    "id": "26825_8",
    "name": "Dewan Motors (Pvt) Ltd. Product Display Centre (Showroom)",
    "country": "PK",
    "city": "Islamabad",
    "address": "Jinnah Avenue, Sohrab Plaza, 44000 Islamabad",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-51-2871880",
    "website": "https://www.bmw-pakistan.com",
    "coords": {
      "lat": 33.72515869140625,
      "lng": 73.0863265991211
    }
  },
  {
    "id": "26825_2",
    "name": "Dewan Motors (Pvt) Ltd. Service Centre",
    "country": "PK",
    "city": "Karachi",
    "address": "Plot 30-A, Sector 23, 75250 Karachi",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-21-35053180",
    "website": "https://www.bmw-pakistan.com",
    "coords": {
      "lat": 24.83774757385254,
      "lng": 67.11897277832031
    }
  },
  {
    "id": "26825_3",
    "name": "Dewan Motors (Pvt) Ltd. Sales & Service Lahore",
    "country": "PK",
    "city": "Lahore",
    "address": "15 B, Davis Road, 54000 Lahore",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-42-6360263",
    "website": "https://www.bmw-pakistan.com",
    "coords": {
      "lat": 31.557653427124023,
      "lng": 74.3387222290039
    }
  },
  {
    "id": "26825_9",
    "name": "Dewan Motors (Pvt) Ltd. Sales Office",
    "country": "PK",
    "city": "Karachi",
    "address": "Plot No. 7, Block 7&8, 75350 Karachi",
    "email": "bmw@yousufdewan.com",
    "phone": "+92-21-34323693",
    "website": "https://www.bmw-pakistan.com",
    "coords": {
      "lat": 24.86881446838379,
      "lng": 67.08688354492188
    }
  },
  {
    "id": "02577_5",
    "name": "Hendo Guimarães",
    "country": "PT",
    "city": "Guimarães",
    "address": "Rua Capitão Salgueiro Maia, 121, 4835-604 Guimarães",
    "email": "geral@hendo.pt",
    "phone": "+351-808-100212",
    "website": "http://www.hendo.bmw.pt",
    "coords": {
      "lat": 41.43806838989258,
      "lng": -8.33436107635498
    }
  },
  {
    "id": "02552_5",
    "name": "MCoutinho Bomcar Vila Real",
    "country": "PT",
    "city": "Vila Real",
    "address": "Avenida da Europa, 4, 5000-557 Vila Real",
    "email": "mcoutinhobomcar@mcoutinho.pt",
    "phone": "+351-259-301900",
    "website": "https://bmwmcoutinhobomcar.pt/",
    "coords": {
      "lat": 41.295467376708984,
      "lng": -7.7319817543029785
    }
  },
  {
    "id": "42447_3",
    "name": "A MatosCar Castelo Branco",
    "country": "PT",
    "city": "Castelo Branco",
    "address": "Zona Industrial de Castelo Branco, 6000-459 Castelo Branco",
    "email": "bmw@amatoscar.pt",
    "phone": "+351-27-2098216",
    "website": "http://www.amatoscar.pt",
    "coords": {
      "lat": 39.812007904052734,
      "lng": -7.5230488777160645
    }
  },
  {
    "id": "02157_1",
    "name": "BMcar Braga",
    "country": "PT",
    "city": "Braga",
    "address": "Av. Barros e Soares E. N. 101,, 4715-214 Braga",
    "email": "braga@bmcar.com.pt",
    "phone": "+351-25-3240100",
    "website": "http://www.bmcar.bmw.pt",
    "coords": {
      "lat": 41.52766799926758,
      "lng": -8.41804313659668
    }
  },
  {
    "id": "02157_5",
    "name": "BMcar Guimarães",
    "country": "PT",
    "city": "Guimarães",
    "address": "Rodovia de Covas, 26, 4810-225 Guimarães",
    "email": "guimaraes@bmcar.com.pt",
    "phone": "+351-25-3401640",
    "website": "http://www.bmcar.bmw.pt",
    "coords": {
      "lat": 41.42372512817383,
      "lng": -8.301198959350586
    }
  },
  {
    "id": "02552_1",
    "name": "MCoutinho Bomcar Leiria",
    "country": "PT",
    "city": "Leiria",
    "address": "Variante da Marinha Grande, Barosa, 2400-016 Leiria",
    "email": "mcoutinhobomcar@mcoutinho.pt",
    "phone": "+351-24-4880110",
    "website": "https://bmwmcoutinhobomcar.pt",
    "coords": {
      "lat": 39.74793243408203,
      "lng": -8.865033149719238
    }
  },
  {
    "id": "02602_5",
    "name": "BMcar Aliados",
    "country": "PT",
    "city": "Porto",
    "address": "Av. dos Aliados, 195, 4000-067 Porto",
    "email": "aliados@bmcar.com.pt",
    "phone": "+351-22-6001224",
    "website": "http://www.bmcar.com.pt",
    "coords": {
      "lat": 41.148773193359375,
      "lng": -8.611451148986816
    }
  },
  {
    "id": "02568_1",
    "name": "Tomeifel",
    "country": "PT",
    "city": "Vila Real",
    "address": "Z.I. Constantim - Lotes 153 e 154, 5000-082 Vila Real",
    "email": "tomeifel@tomeifel.com",
    "phone": "+351-25-9301020",
    "website": "http://www.tomeifel.bmw.pt",
    "coords": {
      "lat": 41.27705764770508,
      "lng": -7.716125011444092
    }
  },
  {
    "id": "02566_10",
    "name": "Santogal Setúbal",
    "country": "PT",
    "city": "Setúbal",
    "address": "Rua dos 4 Caminhos, 18, 2910-475 Setúbal",
    "email": "geral.bmw.sb@santogal.pt",
    "phone": "+351-21-0430670",
    "website": "http://www.santogal.pt",
    "coords": {
      "lat": 38.533111572265625,
      "lng": -8.8760404586792
    }
  },
  {
    "id": "02566_11",
    "name": "Santogal Lisboa - Estefânia",
    "country": "PT",
    "city": "Lisboa",
    "address": "Rua D. Estefânia, 118-120 A, 1000-158 Lisboa",
    "email": "geral.bmw.ln@santogal.pt",
    "phone": "+351-21-0430660",
    "website": "http://www.santogal.pt",
    "coords": {
      "lat": 38.73455810546875,
      "lng": -9.141420364379883
    }
  },
  {
    "id": "02552_4",
    "name": "MCoutinho Bomcar Bragança",
    "country": "PT",
    "city": "Bragança",
    "address": "R. Cel. Teófilo de Morais 1, 5300-107 Bragança",
    "email": "mcoutinhomotors@mcoutinho.pt",
    "phone": "+351-273-300390",
    "website": "https://bmwmcoutinhobomcar.pt",
    "coords": {
      "lat": 41.785884857177734,
      "lng": -6.77521276473999
    }
  },
  {
    "id": "02554_1",
    "name": "Auto Bayern",
    "country": "PT",
    "city": "Lisboa",
    "address": "Rua Sao Domingos Benfica, 2C, 1500-559 Lisboa",
    "email": "geral@autobayern.pt",
    "phone": "+351-21-7710280",
    "website": "http://www.autobayern.bmw.pt",
    "coords": {
      "lat": 38.74267578125,
      "lng": -9.174051284790039
    }
  },
  {
    "id": "02602_1",
    "name": "BMcar Barcelos",
    "country": "PT",
    "city": "Barcelos",
    "address": "R. da Calçada, Lugar de Mariz Ap591, 4750-572 Barcelos",
    "email": "barcelos@bmcar.com.pt",
    "phone": "+351-25-3808790",
    "website": "http://www.bmcar.bmw.pt",
    "coords": {
      "lat": 41.52765655517578,
      "lng": -8.661759376525879
    }
  },
  {
    "id": "42447_1",
    "name": "A MatosCar Évora",
    "country": "PT",
    "city": "Évora",
    "address": "Rua da Barba Rala, 1A, 7005-345 Évora",
    "email": "bmw@amatoscar.pt",
    "phone": "+351-266-740910",
    "website": "http://www.amatoscar.pt",
    "coords": {
      "lat": 38.54994201660156,
      "lng": -7.913265228271484
    }
  },
  {
    "id": "02566_4",
    "name": "Santogal Oeiras",
    "country": "PT",
    "city": "Oeiras",
    "address": "Estrada de Paco de Arcos, 52, 2770-130 Oeiras",
    "email": "geral.bmw.pr@santogal.pt",
    "phone": "+351-21-0430180",
    "website": "http://www.santogal.bmw.pt",
    "coords": {
      "lat": 38.70734786987305,
      "lng": -9.295344352722168
    }
  },
  {
    "id": "02566_12",
    "name": "Santogal Seixal",
    "country": "PT",
    "city": "Corroios",
    "address": "Rua Dulcino Caiano Pereira, 2855-575 Corroios",
    "email": "vendas.bmw.sx@santogal.pt",
    "phone": "+351-21-8729400",
    "website": "http://www.santogal.pt",
    "coords": {
      "lat": 38.63648986816406,
      "lng": -9.1493501663208
    }
  },
  {
    "id": "02577_6",
    "name": "Hendo Paredes",
    "country": "PT",
    "city": "Paredes",
    "address": "Rua Central de Mouriz, 464, 4580-590 Paredes",
    "email": "geral@hendo.pt",
    "phone": "+351-808-100212",
    "website": "http://www.hendo.bmw.pt",
    "coords": {
      "lat": 41.19763946533203,
      "lng": -8.351052284240723
    }
  },
  {
    "id": "20522_1",
    "name": "Terauto",
    "country": "PT",
    "city": "Angra do Heroismo",
    "address": "Reguinho - São Bento, 9700-110 Angra do Heroismo",
    "email": "geral@terauto.pt",
    "phone": "+351-29-5204890",
    "website": "http://www.terauto.bmw.pt",
    "coords": {
      "lat": 38.67618179321289,
      "lng": -27.206912994384766
    }
  },
  {
    "id": "02566_1",
    "name": "Santogal Praça de Espanha",
    "country": "PT",
    "city": "Lisboa",
    "address": "Rua D. Luís de Noronha, 40, 1069-081 Lisboa",
    "email": "geral.bmw.ln@santogal.pt",
    "phone": "+351-21-0430670",
    "website": "http://www.santogal.bmw.pt",
    "coords": {
      "lat": 38.74004364013672,
      "lng": -9.157050132751465
    }
  },
  {
    "id": "02566_5",
    "name": "Santogal Santo Antão do Tojal",
    "country": "PT",
    "city": "Santo Antão do Tojal",
    "address": "EN 115, Km 80, Casal de S. Roque, 2660-161 Santo Antão do Tojal",
    "email": "geral.bmw.lr@santogal.pt",
    "phone": "+351-21-0430843",
    "website": "http://www.santogal.bmw.pt",
    "coords": {
      "lat": 38.852882385253906,
      "lng": -9.152013778686523
    }
  },
  {
    "id": "42447_2",
    "name": "A MatosCar Guarda",
    "country": "PT",
    "city": "Guarda",
    "address": "Rua Vila de Manteigas, 1, 6300-617 Guarda",
    "email": "bmw@amatoscar.pt",
    "phone": "+351-27-1036267",
    "website": "http://www.amatoscar.pt",
    "coords": {
      "lat": 40.54403305053711,
      "lng": -7.258530139923096
    }
  },
  {
    "id": "02157_3",
    "name": "BMcar Povoa Varzim",
    "country": "PT",
    "city": "Povoa de Varzim",
    "address": "Av. 25 de Abril, 2190, 4490-004 Povoa de Varzim",
    "email": "bmcar@bmcar.com.pt",
    "phone": "+351-252-290100",
    "website": "http://www.bmcar.bmw.pt",
    "coords": {
      "lat": 41.377410888671875,
      "lng": -8.746164321899414
    }
  },
  {
    "id": "02157_6",
    "name": "BMcar Famalicão",
    "country": "PT",
    "city": "Vila Nova de Famalicão",
    "address": "Rua 29 de Setembro, 91, 4760-774 Vila Nova de Famalicão",
    "email": "famalicao@bmcar.com.pt",
    "phone": "+351-252-144890",
    "website": "https://www.bmcar.pt/",
    "coords": {
      "lat": 41.3813591003418,
      "lng": -8.542790412902832
    }
  },
  {
    "id": "02182_1",
    "name": "AMG Car Seixal",
    "country": "PT",
    "city": "Amora",
    "address": "EN 10 - Santa Marta, 2845-547 Amora",
    "email": "planeamento@amgcar.pt",
    "phone": "+351-21-2549220",
    "website": "http://www.amgcar.bmw.pt",
    "coords": {
      "lat": 38.631797790527344,
      "lng": -9.138671875
    }
  },
  {
    "id": "02575_1",
    "name": "Aníbal Carvalho & Filhos",
    "country": "PT",
    "city": "Santarem",
    "address": "Av. do Matadouro Regional,Lt.21, 2005-002 Santarem",
    "email": "acf@bmw-acf.com",
    "phone": "+351-24-3351971",
    "website": "http://www.anibalcfilhos.bmw.pt",
    "coords": {
      "lat": 39.25589370727539,
      "lng": -8.713971138000488
    }
  },
  {
    "id": "52875_3",
    "name": "Caetano Aveiro",
    "country": "PT",
    "city": "Aveiro",
    "address": "Av. Europa, 462, 3800-230 Aveiro",
    "email": "aveiro@bmw.caetano.pt",
    "phone": "+351-23-4305150",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 40.66214370727539,
      "lng": -8.61275577545166
    }
  },
  {
    "id": "52875_8",
    "name": "Caetano Bento Roma",
    "country": "PT",
    "city": "Lisboa",
    "address": "Rua Coronel Bento Roma, 18 A/B, 1700-122 Lisboa",
    "email": "lisboa@bmw.caetano.pt",
    "phone": "+351-21-8428530",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 38.74833297729492,
      "lng": -9.138092041015625
    }
  },
  {
    "id": "52875_6",
    "name": "Caetano Lisboa",
    "country": "PT",
    "city": "Lisboa",
    "address": "Alameda dos Oceanos 113/115, 1990-392 Lisboa",
    "email": "lisboa@bmw.caetano.pt",
    "phone": "+351-21-8912300",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 38.78267288208008,
      "lng": -9.097861289978027
    }
  },
  {
    "id": "52875_11",
    "name": "Caetano Porto",
    "country": "PT",
    "city": "Porto",
    "address": "R. Manuel Pinto de Azevedo, 462/500, 4100-320 Porto",
    "email": "porto@bmw.caetano.pt",
    "phone": "+351-22-6192300",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 41.173946380615234,
      "lng": -8.648125648498535
    }
  },
  {
    "id": "52875_7",
    "name": "Caetano Portimão",
    "country": "PT",
    "city": "Portimão",
    "address": "Urb. Vale Arrancada, Lote 3/4, 8500-473 Portimão",
    "email": "portimao@bmw.caetano.pt",
    "phone": "+351-28-2490360",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 37.15361022949219,
      "lng": -8.55082893371582
    }
  },
  {
    "id": "52875_12",
    "name": "Caetano Matosinhos",
    "country": "PT",
    "city": "Matosinhos",
    "address": "Av.Comendador Ferreira de Matos,646, 4450-121 Matosinhos",
    "email": "matosinhos@bmw.caetano.pt",
    "phone": "+351-22-3206026",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 41.17640686035156,
      "lng": -8.683319091796875
    }
  },
  {
    "id": "02602_3",
    "name": "BMcar Porto",
    "country": "PT",
    "city": "Porto",
    "address": "Centro Emp. da Circunvalação Est., 4250-148 Porto",
    "email": "porto@bmcar.com.pt",
    "phone": "+351-22-7662300",
    "website": "http://www.bmcar.com.pt",
    "coords": {
      "lat": 41.18088912963867,
      "lng": -8.61905574798584
    }
  },
  {
    "id": "02552_3",
    "name": "MCoutinho Bomcar Coimbra",
    "country": "PT",
    "city": "Coimbra",
    "address": "Rua das Areias - Trouxemil, 3025-137 Coimbra",
    "email": "bomcar@bomcar.pt",
    "phone": "+351-23-9917170",
    "website": "https://bmwmcoutinhobomcar.pt",
    "coords": {
      "lat": 40.27556228637695,
      "lng": -8.445245742797852
    }
  },
  {
    "id": "02552_6",
    "name": "MCoutinho Bomcar Viseu",
    "country": "PT",
    "city": "Viseu",
    "address": "Zona Industrial de Coimbrões, 3501-907 Viseu",
    "email": "mcoutinhobomcar@mcoutinho.pt",
    "phone": "+351-232-480810",
    "website": "https://bmwmcoutinhobomcar.pt",
    "coords": {
      "lat": 40.628700256347656,
      "lng": -7.870370864868164
    }
  },
  {
    "id": "02569_2",
    "name": "Auto Açoreana",
    "country": "PT",
    "city": "Ponta Delgada",
    "address": "Canada João Leite - Via Rápida, 9500-708 Ponta Delgada",
    "email": "autoacoreana@autoacoreana.pt",
    "phone": "+351-29-6654400",
    "website": "http://www.autoacoreana.bmw.pt",
    "coords": {
      "lat": 37.756534576416016,
      "lng": -25.631038665771484
    }
  },
  {
    "id": "02546_1",
    "name": "Madeira Motores",
    "country": "PT",
    "city": "Funchal",
    "address": "Rua Dom Ernesto Sena de Oliveira,, 9050-092 Funchal",
    "email": "madeira.motores@madeiramotores.net",
    "phone": "+351-29-1934927",
    "website": "http://www.madeiramotores.bmw.pt",
    "coords": {
      "lat": 32.6616325378418,
      "lng": -16.9001522064209
    }
  },
  {
    "id": "02566_9",
    "name": "Santogal Carnaxide",
    "country": "PT",
    "city": "Carnaxide",
    "address": "Rua do Proletariado, 17, 2790-045 Carnaxide",
    "email": "vendas.bmw.al@santogal.pt",
    "phone": "+351-21-0430940",
    "website": "http://www.santogal.pt",
    "coords": {
      "lat": 38.723628997802734,
      "lng": -9.218339920043945
    }
  },
  {
    "id": "02569_1",
    "name": "Auto Açoreana",
    "country": "PT",
    "city": "Ponta Delgada",
    "address": "Praceta da Pranchinha, 20 S. Pedro, 9500-330 Ponta Delgada",
    "email": "vendas@autoacoreana.pt",
    "phone": "+351-29-6304900",
    "website": "http://www.autoacoreana.bmw.pt",
    "coords": {
      "lat": 37.743717193603516,
      "lng": -25.65169906616211
    }
  },
  {
    "id": "02594_1",
    "name": "Banix",
    "country": "PT",
    "city": "Torres Vedras",
    "address": "Edificio Banix, Avenida Carlos, 2560-629 Torres Vedras",
    "email": "geral@banix.pt",
    "phone": "+351-261-339040",
    "website": "http://www.banix.bmw.pt",
    "coords": {
      "lat": 39.06999206542969,
      "lng": -9.242822647094727
    }
  },
  {
    "id": "02154_1",
    "name": "A. B. Heleno Leiria",
    "country": "PT",
    "city": "Leiria",
    "address": "Edifício Auto-Industrial, E. N. 1, 2400-822 Leiria",
    "email": "geral@brasheleno.pt",
    "phone": "+351-24-4860000",
    "website": "http://www.abrazheleno.bmw.pt",
    "coords": {
      "lat": 39.73131561279297,
      "lng": -8.82649040222168
    }
  },
  {
    "id": "02157_2",
    "name": "BMcar Viana do Castelo",
    "country": "PT",
    "city": "Viana do Castelo",
    "address": "Zona Ind. de V. C. 1ª fase, Neiva, 4935-231 Viana do Castelo",
    "email": "viana@bmcar.com.pt",
    "phone": "+351-25-8320240",
    "website": "http://www.bmcar.bmw.pt",
    "coords": {
      "lat": 41.64219284057617,
      "lng": -8.770012855529785
    }
  },
  {
    "id": "52875_4",
    "name": "Caetano Cascais",
    "country": "PT",
    "city": "Alcabideche",
    "address": "Alameda das Fisgas, 40 - Alcoitão, 2645-117 Alcabideche",
    "email": "cascais@bmw.caetano.pt",
    "phone": "+351-21-4606220",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 38.73698043823242,
      "lng": -9.39041805267334
    }
  },
  {
    "id": "52875_5",
    "name": "Caetano Faro",
    "country": "PT",
    "city": "Faro",
    "address": "EN 125 - Pontes de Marchil, 8005-518 Faro",
    "email": "faro@bmw.caetano.pt",
    "phone": "+351-28-9860140",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 37.029598236083984,
      "lng": -7.947433948516846
    }
  },
  {
    "id": "52875_10",
    "name": "Caetano Maia",
    "country": "PT",
    "city": "Maia",
    "address": "Rua Eng. Frederico Ulrich, 2239, 4470-605 Maia",
    "email": "maia@bmw.caetano.pt",
    "phone": "+351-22-1103187",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 41.25904083251953,
      "lng": -8.637868881225586
    }
  },
  {
    "id": "52875_1",
    "name": "Caetano Vila Nova de Gaia",
    "country": "PT",
    "city": "Vila Nova de Gaia",
    "address": "Rua do Barreiro, 547, Madalena, 4405-730 Vila Nova de Gaia",
    "email": "gaia@bmw.caetano.pt",
    "phone": "+351-22-7161000",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 41.113807678222656,
      "lng": -8.630497932434082
    }
  },
  {
    "id": "52875_2",
    "name": "Caetano Santa Maria da Feira",
    "country": "PT",
    "city": "Espargo Santa Maria da Feira",
    "address": "Rua 1º de Maio, 229, 4520-115 Espargo Santa Maria da Feira",
    "email": "smfeira@bmw.caetano.pt",
    "phone": "+351-25-6330660",
    "website": "https://www.caetano.pt/bmw",
    "coords": {
      "lat": 40.919944763183594,
      "lng": -8.572283744812012
    }
  },
  {
    "id": "45788_1",
    "name": "Lizitália",
    "country": "PT",
    "city": "Caldas da Rainha",
    "address": "EN 8-Lavradio-Estrada da Tornada 53, 2500-315 Caldas da Rainha",
    "email": "bmw.cliente.lizitalia@lizauto.pt",
    "phone": "+351-262-837190",
    "website": null,
    "coords": {
      "lat": 39.43046188354492,
      "lng": -9.13105583190918
    }
  },
  {
    "id": "20278_1",
    "name": "Al Sadd Showroom Alfardan Automobiles Co. (Al Sadd)",
    "country": "QA",
    "city": "Doha",
    "address": "Suhaim Bin Hamad Street, 00000 Doha",
    "email": "afa@alfardan.com.qa",
    "phone": "+974-4-44208888",
    "website": "https://www.bmw-qatar.com",
    "coords": {
      "lat": 25.370573043823242,
      "lng": 51.53978729248047
    }
  },
  {
    "id": "20278_2",
    "name": "Al Lusail Boulevard Alfardan Automobiles L.L.C. Al Lusail Lusail Boulevard",
    "country": "QA",
    "city": "Lusail City",
    "address": "192, 3763 Lusail City",
    "email": "afa@alfardan.com.qa",
    "phone": "+974-4-4477577",
    "website": "https://www.bmw-qatar.com",
    "coords": {
      "lat": 25.416259765625,
      "lng": 51.492549896240234
    }
  },
  {
    "id": "20278_5",
    "name": "Alfardan Automobiles (Service C.) Service Center and Parts",
    "country": "QA",
    "city": "Doha",
    "address": "Industrial Area,St. No.1, Bldg. No, 3763 Doha",
    "email": "adminafa@qatar.net.qa",
    "phone": "+974-4-44065555",
    "website": "https://www.bmw-qatar.com",
    "coords": {
      "lat": 25.21973419189453,
      "lng": 51.434669494628906
    }
  },
  {
    "id": "20278_3",
    "name": "Westbay Showroom Alfardan Automobiles (Westbay)",
    "country": "QA",
    "city": "Doha",
    "address": "Al Funduq Street, West Bay, 3763 Doha",
    "email": "afa@alfardan.com.qa",
    "phone": "+974-44208888",
    "website": "https://www.bmw-qatar.com",
    "coords": {
      "lat": 25.320371627807617,
      "lng": 51.529266357421875
    }
  },
  {
    "id": "20278_9",
    "name": "Jery Al Samur Alfardan Automobiles Co.(L.L.C)",
    "country": "QA",
    "city": "Umm Slala",
    "address": "1200, 3763 Umm Slala",
    "email": "afa@alfardan.com.qa",
    "phone": "+974-4-4477577",
    "website": "https://www.bmw-qatar.com",
    "coords": {
      "lat": 25.417789459228516,
      "lng": 51.35285186767578
    }
  },
  {
    "id": "40024_2",
    "name": "Leal Reunion St. Pierre",
    "country": "RE",
    "city": "Saint Pierre",
    "address": "21, Rue Pointe du Bois, 97410 Saint Pierre",
    "email": "digitalmarketingreunion@leal.lealgroup.com",
    "phone": "+262-960000",
    "website": "https://www.bmw.re",
    "coords": {
      "lat": -21.320171356201172,
      "lng": 55.44599533081055
    }
  },
  {
    "id": "40024_1",
    "name": "Leal Reunion S.A.S",
    "country": "RE",
    "city": "Sainte Clotilde",
    "address": "23 route de la Rivière des pluies, 97490 Sainte Clotilde",
    "email": "digitalmarketingreunion@leal.lealgroup.com",
    "phone": "+262-960000",
    "website": "https://www.bmw.re",
    "coords": {
      "lat": -20.901840209960938,
      "lng": 55.50273132324219
    }
  },
  {
    "id": "21415_1",
    "name": "Axsel-Motors",
    "country": "RU",
    "city": "Saint Petersburg",
    "address": "Schkiperskij protok 21, 199106 Saint Petersburg",
    "email": "sales@bmw-axsel.ru",
    "phone": "+7-812-3255252",
    "website": "https://www.bmw-axsel.ru/owners/",
    "coords": {
      "lat": 59.933868408203125,
      "lng": 30.22795867919922
    }
  },
  {
    "id": "26959_3",
    "name": "Borishof",
    "country": "RU",
    "city": "Moscow",
    "address": "29 km. MKAD, 142718 Moscow",
    "email": "info@bmw-borishof.ru",
    "phone": "+7-495-7451111",
    "website": "https://www.bmw-borishof.ru/owners/",
    "coords": {
      "lat": 55.571102142333984,
      "lng": 37.672698974609375
    }
  },
  {
    "id": "29221_1",
    "name": "Aldis",
    "country": "RU",
    "city": "Togliatty",
    "address": "Sportivnaya 11, 445057 Togliatty",
    "email": "otdel.prodazh@bmw-aldis.ru",
    "phone": "+7-8482-270111",
    "website": "https://bmw-aldis.ru/owners/",
    "coords": {
      "lat": 53.50446319580078,
      "lng": 49.26393508911133
    }
  },
  {
    "id": "31574_1",
    "name": "Bars",
    "country": "RU",
    "city": "Omsk",
    "address": "Volgogradskaya 61, 644106 Omsk",
    "email": "info@bmw-bars.ru",
    "phone": "+7-3812-330777",
    "website": "https://bmw-bars.ru/owners/",
    "coords": {
      "lat": 54.988250732421875,
      "lng": 73.23585510253906
    }
  },
  {
    "id": "44864_3",
    "name": "Rolf Premium",
    "country": "RU",
    "city": "Khimki",
    "address": "Leningradskoe shosse 21, 141410 Khimki",
    "email": "info.himki@bmw-rolf.ru",
    "phone": "+7-495-7378787",
    "website": "https://bmw-rolf.ru/owners/",
    "coords": {
      "lat": 55.90639877319336,
      "lng": 37.41156768798828
    }
  },
  {
    "id": "49009_1",
    "name": "ATLAS",
    "country": "RU",
    "city": "Krasnodar",
    "address": "Dzerzhinskogo 231/B, 350005 Krasnodar",
    "email": "info@bmw-atlas.ru",
    "phone": "+7-861-201-50-00",
    "website": "https://bmw-atlas.ru/owners/",
    "coords": {
      "lat": 45.112701416015625,
      "lng": 38.983699798583984
    }
  },
  {
    "id": "49114_1",
    "name": "Avtomobili Bavarii Avtomobili Bavarii Yug",
    "country": "RU",
    "city": "Voronezhskaya oblast",
    "address": "Solnechny, Moskovskoe shosse 6/1, 394000 Voronezhskaya oblast",
    "email": "info@bmw-abvr.ru",
    "phone": "+7-473-300-30-40",
    "website": "https://bmw-abvr.ru/owners/",
    "coords": {
      "lat": 51.774654388427734,
      "lng": 39.195228576660156
    }
  },
  {
    "id": "38393_1",
    "name": "Premier Avto",
    "country": "RU",
    "city": "Vladivostok",
    "address": "ul. Makovskogo, 93, 690024 Vladivostok",
    "email": "info@bmw-premier-auto.ru",
    "phone": "+7-423-2303030",
    "website": "https://www.bmw-premier-auto.ru",
    "coords": {
      "lat": 43.22491455078125,
      "lng": 131.99461364746094
    }
  },
  {
    "id": "10665_1",
    "name": "Avtomobili Bavarii",
    "country": "RU",
    "city": "Nizhny Novgorod",
    "address": "Brinskogo 12, 603163 Nizhny Novgorod",
    "email": "info@bmw-abnn.ru",
    "phone": "+7-831-2703070",
    "website": "https://bmw-abnn.ru/owners/",
    "coords": {
      "lat": 56.3001594543457,
      "lng": 44.06313705444336
    }
  },
  {
    "id": "26551_1",
    "name": "BaltAvtoTrade-M",
    "country": "RU",
    "city": "Moscow",
    "address": "Rubljovskoje Chaussee 64, build 2, 121609 Moscow",
    "email": "info@bmw-baltauto.ru",
    "phone": "+7-495-7777733",
    "website": "https://bmw-baltauto.ru/owners/",
    "coords": {
      "lat": 55.76868438720703,
      "lng": 37.378814697265625
    }
  },
  {
    "id": "26828_1",
    "name": "Angara",
    "country": "RU",
    "city": "Irkutsk",
    "address": "Yaroslavskogo, 302, 664048 Irkutsk",
    "email": "info@bmw-angara.ru",
    "phone": "+7-3952-500202",
    "website": "https://bmw-angara.ru/owners/",
    "coords": {
      "lat": 52.34901809692383,
      "lng": 104.14240264892578
    }
  },
  {
    "id": "27741_1",
    "name": "ElitAuto",
    "country": "RU",
    "city": "Krasnoyarsk",
    "address": "Alekseeva 52, 660118 Krasnoyarsk",
    "email": "elitavto@bmw-elitavto.ru",
    "phone": "+7-3912-204204",
    "website": "https://bmw-elitavto.ru/owners/",
    "coords": {
      "lat": 56.044586181640625,
      "lng": 92.89747619628906
    }
  },
  {
    "id": "26551_2",
    "name": "BaltAvtoTrade-M",
    "country": "RU",
    "city": "Moscow",
    "address": "Varshavskoe shosse 138, 117105 Moscow",
    "email": "info-varshavka@bmw-baltauto.ru",
    "phone": "+7-495-3639696",
    "website": "https://bmw-varshavka.ru/owners/",
    "coords": {
      "lat": 55.61334228515625,
      "lng": 37.60884094238281
    }
  },
  {
    "id": "29630_1",
    "name": "TolSar",
    "country": "RU",
    "city": "Saratov",
    "address": "Shehurdina 20 A, 410010 Saratov",
    "email": "info@bmw-tolsar.ru",
    "phone": "+7-8452-693000",
    "website": "https://bmw-tolsar.ru/owners/",
    "coords": {
      "lat": 51.57412338256836,
      "lng": 45.99076843261719
    }
  },
  {
    "id": "29691_1",
    "name": "Armada",
    "country": "RU",
    "city": "Rostov-on-Don",
    "address": "Prospect Sholokhova 253, 344009 Rostov-on-Don",
    "email": "info@bmw-armada.ru",
    "phone": "+7-863-3067777",
    "website": "https://bmw-armada.ru/owners/",
    "coords": {
      "lat": 47.25238800048828,
      "lng": 39.783302307128906
    }
  },
  {
    "id": "32330_2",
    "name": "Avtodom",
    "country": "RU",
    "city": "Moscow",
    "address": "Zorge 17, 125252 Moscow",
    "email": "info@avtodom.ru",
    "phone": "+7-495-5005000",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 55.78681945800781,
      "lng": 37.508697509765625
    }
  },
  {
    "id": "32330_3",
    "name": "Avtodom",
    "country": "RU",
    "city": "Moscow",
    "address": "Vernadskogo pr. 97, k.2, 119526 Moscow",
    "email": "info@avtodom.ru",
    "phone": "+7-495-5005000",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 55.668800354003906,
      "lng": 37.494384765625
    }
  },
  {
    "id": "36961_1",
    "name": "Grand Auto",
    "country": "RU",
    "city": "Tver",
    "address": "Borovlevo, 1, 170546 Tver",
    "email": "info@bmw-grandauto.ru",
    "phone": "+7-4822-797969",
    "website": "https://bmw-grandauto.ru/owners/",
    "coords": {
      "lat": 56.79026412963867,
      "lng": 35.90981674194336
    }
  },
  {
    "id": "43474_1",
    "name": "Rus Motors",
    "country": "RU",
    "city": "Kaliningrad",
    "address": "Moskovskiy pr., 203a, 236006 Kaliningrad",
    "email": "info@bmw-rusmotors.ru",
    "phone": "+7-4012-555512",
    "website": "https://bmw-rusmotors.ru/owners/",
    "coords": {
      "lat": 54.709171295166016,
      "lng": 20.567447662353516
    }
  },
  {
    "id": "20337_1",
    "name": "Bakra",
    "country": "RU",
    "city": "Respublika Adygeya",
    "address": "Turgenevskoe shosse 23, 385140 Respublika Adygeya",
    "email": "bakra@bmw-bakra.ru",
    "phone": "+7-861-2790707",
    "website": "https://bmw-bakra.ru/owners/",
    "coords": {
      "lat": 45.02001953125,
      "lng": 38.937435150146484
    }
  },
  {
    "id": "31723_1",
    "name": "AvtoHaus",
    "country": "RU",
    "city": "Ekaterinburg",
    "address": "Sibirsky trakt 26, 620100 Ekaterinburg",
    "email": "info@bmw-avtohaus.ru",
    "phone": "+7-343-2220111",
    "website": "https://www.bmw-avtohaus.ru/owners/",
    "coords": {
      "lat": 56.819740295410156,
      "lng": 60.66304016113281
    }
  },
  {
    "id": "32647_1",
    "name": "Bavaria Avto",
    "country": "RU",
    "city": "Tula",
    "address": "Novomoskovskoe Shosse 15, 300045 Tula",
    "email": "info@bmw-bavaria-auto.ru",
    "phone": "+7-4872-363555",
    "website": "https://bmw-bavaria-auto.ru/owners/",
    "coords": {
      "lat": 54.165103912353516,
      "lng": 37.64086151123047
    }
  },
  {
    "id": "35226_2",
    "name": "Avilon",
    "country": "RU",
    "city": "Moscow",
    "address": "Kommerchsky proezd, 10, 140053 Moscow",
    "email": "info_bd@bmw-avilon.ru",
    "phone": "+7-495-7301115",
    "website": "https://www.bmw-avilon.ru/owners/",
    "coords": {
      "lat": 55.649566650390625,
      "lng": 37.8355827331543
    }
  },
  {
    "id": "48964_2",
    "name": "TransTechService",
    "country": "RU",
    "city": "Kazan",
    "address": "Agronomicheskaya str., 7, 420049 Kazan",
    "email": "kazan@bmw-tts.ru",
    "phone": "+7-843-5182535",
    "website": "https://bmw-tts.ru/owners/",
    "coords": {
      "lat": 55.77588653564453,
      "lng": 49.14545822143555
    }
  },
  {
    "id": "48964_6",
    "name": "TransTechService",
    "country": "RU",
    "city": "Ufa",
    "address": "Pr. Salavata Ulayeva 95, 450057 Ufa",
    "email": "ufa@bmw-tts.ru",
    "phone": "+7-3472-924499",
    "website": "https://bmw-tts.ru/owners/",
    "coords": {
      "lat": 54.753238677978516,
      "lng": 56.02141189575195
    }
  },
  {
    "id": "32330_8",
    "name": "Avtodom",
    "country": "RU",
    "city": "Moscow",
    "address": "pos. Moskovsky, kv. 80, bld 3, 2, 108811 Moscow",
    "email": "info@avtodom.ru",
    "phone": "+7-495-5005000",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 55.61880111694336,
      "lng": 37.393524169921875
    }
  },
  {
    "id": "43009_1",
    "name": "ElitAvto Sibir",
    "country": "RU",
    "city": "Novosibirsk",
    "address": "Bolshevistskaya str., 177/1, 630028 Novosibirsk",
    "email": "elitavto@bmw-elitavtosibir.ru",
    "phone": "+7-383-3190319",
    "website": "https://bmw-elitavto.ru/owners/",
    "coords": {
      "lat": 54.99307632446289,
      "lng": 82.97881317138672
    }
  },
  {
    "id": "32648_1",
    "name": "Izar-Avto",
    "country": "RU",
    "city": "Penza",
    "address": "Prospekt pobedy, 121, 440066 Penza",
    "email": "info@bmw-izar-avto.ru",
    "phone": "+7-8412-200020",
    "website": "https://bmw-izar-avto.ru/owners/",
    "coords": {
      "lat": 53.233375549316406,
      "lng": 44.91522979736328
    }
  },
  {
    "id": "32330_7",
    "name": "Avtodom",
    "country": "RU",
    "city": "Moscow",
    "address": "Shmitovsky proezd 24A, 123100 Moscow",
    "email": "info@bmw-avtodom.ru",
    "phone": "+7-495-5005000",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 55.756343841552734,
      "lng": 37.53950119018555
    }
  },
  {
    "id": "43473_1",
    "name": "Sibcar",
    "country": "RU",
    "city": "Surgut",
    "address": "Bystrinskaya str., 3, 628400 Surgut",
    "email": "info@bmw-sibcar.ru",
    "phone": "+7-3462-215555",
    "website": "https://bmw-sibcarbm.ru/owners/",
    "coords": {
      "lat": 61.261619567871094,
      "lng": 73.42814636230469
    }
  },
  {
    "id": "48571_1",
    "name": "Premier Auto",
    "country": "RU",
    "city": "Smolensk",
    "address": "Kutuzova str 50, 214011 Smolensk",
    "email": "info@bmw-premieravto.ru",
    "phone": "+7-481-2778888",
    "website": "https://bmw-premieravto.ru/owners/",
    "coords": {
      "lat": 54.8375244140625,
      "lng": 32.04473876953125
    }
  },
  {
    "id": "47152_1",
    "name": "AvroraAvto",
    "country": "RU",
    "city": "Belgorod",
    "address": "Studencheskaya str 1-T, 308023 Belgorod",
    "email": "info@bmw-avroraavto.ru",
    "phone": "+7-4722-376337",
    "website": "https://bmw-avroraavto.ru/owners/",
    "coords": {
      "lat": 50.61750030517578,
      "lng": 36.61122131347656
    }
  },
  {
    "id": "26959_2",
    "name": "BorisHof",
    "country": "RU",
    "city": "Moscow",
    "address": "Shosse Entusiastov, 2 km from MKAD, 143961 Moscow",
    "email": "info@bmw-borishof.ru",
    "phone": "+7-495-7451111",
    "website": "https://www.bmw-borishof.ru/owners/",
    "coords": {
      "lat": 55.78502655029297,
      "lng": 37.87934875488281
    }
  },
  {
    "id": "28824_1",
    "name": "Avtoport",
    "country": "RU",
    "city": "Khimki",
    "address": "MKAD 74-th km, 5, 141400 Khimki",
    "email": "info@bmw-avtoport.ru",
    "phone": "+7-495-7878888",
    "website": "https://bmw-avtoport.ru/owners/",
    "coords": {
      "lat": 55.87828063964844,
      "lng": 37.431358337402344
    }
  },
  {
    "id": "29221_2",
    "name": "Aldis",
    "country": "RU",
    "city": "Samara",
    "address": "Demokraticheskaja 65, 443031 Samara",
    "email": "office-s@bmw-aldis.ru",
    "phone": "+7-846-2078448",
    "website": "https://bmw-aldis.ru/owners/",
    "coords": {
      "lat": 53.28744125366211,
      "lng": 50.22627258300781
    }
  },
  {
    "id": "32330_4",
    "name": "Avtodom",
    "country": "RU",
    "city": "Saint Petersburg",
    "address": "Startovaja 10, 196210 Saint Petersburg",
    "email": "infospb@bmw-avtodom.ru",
    "phone": "+7-812-7777700",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 59.80681610107422,
      "lng": 30.31328010559082
    }
  },
  {
    "id": "41201_1",
    "name": "ITS-Avto",
    "country": "RU",
    "city": "Izhevsk",
    "address": "ul. K.Marksa, 55a, 426003 Izhevsk",
    "email": "info@bmw-its.ru",
    "phone": "+7-3412-901603",
    "website": "https://bmw-its.ru/owners/",
    "coords": {
      "lat": 56.829105377197266,
      "lng": 53.20624923706055
    }
  },
  {
    "id": "46335_1",
    "name": "Nikamotors",
    "country": "RU",
    "city": "Novorossiysk",
    "address": "Zolotaya Rybka 22, 353900 Novorossiysk",
    "email": "info@bmw-nikamotors.ru",
    "phone": "+7-8617-308550",
    "website": "https://bmw-nikamotors.ru/owners/",
    "coords": {
      "lat": 44.772090911865234,
      "lng": 37.694881439208984
    }
  },
  {
    "id": "44864_1",
    "name": "Rolf Premium",
    "country": "RU",
    "city": "Moscow",
    "address": "85 km MKAD, bld.2, 1, 141000 Moscow",
    "email": "info@bmw-rolf.ru",
    "phone": "+7-495-9807080",
    "website": "https://bmw-rolf.ru/owners/",
    "coords": {
      "lat": 55.90946960449219,
      "lng": 37.59379959106445
    }
  },
  {
    "id": "49010_1",
    "name": "ATLAS",
    "country": "RU",
    "city": "Sochi",
    "address": "Transportnaya 20, 354002 Sochi",
    "email": "sochi@bmw-atlas.ru",
    "phone": "+7-862-227-07-27",
    "website": "https://bmw-atlas.ru/owners/",
    "coords": {
      "lat": 43.60820007324219,
      "lng": 39.74728012084961
    }
  },
  {
    "id": "48964_3",
    "name": "TransTechService",
    "country": "RU",
    "city": "Naberezhnye Chelny",
    "address": "Menzelinsky trakt, 1, 423800 Naberezhnye Chelny",
    "email": "chelny@bmw-tts.ru",
    "phone": "+7-8552-999034",
    "website": "https://bmw-tts.ru/owners/",
    "coords": {
      "lat": 55.70647430419922,
      "lng": 52.392608642578125
    }
  },
  {
    "id": "10224_1",
    "name": "Evrosib Service Center",
    "country": "RU",
    "city": "Saint Petersburg",
    "address": "Obvodny channel embankment 72/1, 192007 Saint Petersburg",
    "email": "crm@bmw-eurosib.ru",
    "phone": "+7-812-7403000",
    "website": "https://bmw-eurosib.ru/owners/",
    "coords": {
      "lat": 59.91211700439453,
      "lng": 30.33235740661621
    }
  },
  {
    "id": "25444_1",
    "name": "M-Service",
    "country": "RU",
    "city": "Chelyabinsk",
    "address": "Bratiev Kashirinyh 139, 454128 Chelyabinsk",
    "email": "info@bmw-mservice.ru",
    "phone": "+7-351-2815555",
    "website": "https://bmw-mservice.ru/owners/",
    "coords": {
      "lat": 55.17109680175781,
      "lng": 61.300411224365234
    }
  },
  {
    "id": "27766_1",
    "name": "Eurosib Lahta",
    "country": "RU",
    "city": "Saint Petersburg",
    "address": "Savushkina 112, build 2, 197374 Saint Petersburg",
    "email": "info@bmw-lahta.ru",
    "phone": "+7-812-7405555",
    "website": "https://bmw-eurosib.ru/owners/",
    "coords": {
      "lat": 59.98493576049805,
      "lng": 30.227018356323242
    }
  },
  {
    "id": "32330_1",
    "name": "Avtodom",
    "country": "RU",
    "city": "Moscow",
    "address": "51 km MKAD, 143085 Moscow",
    "email": "info@avtodom.ru",
    "phone": "+7-495-5005000",
    "website": "https://www.bmw-avtodom.ru/owners/",
    "coords": {
      "lat": 55.68871307373047,
      "lng": 37.412689208984375
    }
  },
  {
    "id": "51798_1",
    "name": "ElitAvto Barnaul",
    "country": "RU",
    "city": "Barnaul",
    "address": "Baltiyskaya, 81, 656057 Barnaul",
    "email": "info@bmw-elitavtosibir.ru",
    "phone": "+7-3852-201-200",
    "website": "https://bmw-elitavto.ru/owners/",
    "coords": {
      "lat": 53.33600616455078,
      "lng": 83.66583251953125
    }
  },
  {
    "id": "31928_1",
    "name": "Axsel-Motors Sever",
    "country": "RU",
    "city": "Saint Petersburg",
    "address": "Kushelevskaya doroga, 14, 195220 Saint Petersburg",
    "email": "sales@bmw-axsel.ru",
    "phone": "+7-812-3253000",
    "website": "https://www.bmw-axsel.ru/owners/",
    "coords": {
      "lat": 59.99097442626953,
      "lng": 30.373458862304688
    }
  },
  {
    "id": "32460_1",
    "name": "Avto-Avangard",
    "country": "RU",
    "city": "Moscow",
    "address": "Novorizhskoe shosse, 143420 Moscow",
    "email": "info@bmw-avangard.ru",
    "phone": "+7-495-1546900",
    "website": "https://www.bmw-avangard.ru/owners/",
    "coords": {
      "lat": 55.79172897338867,
      "lng": 37.258522033691406
    }
  },
  {
    "id": "20449_1",
    "name": "Avtomobili Bavarii",
    "country": "RU",
    "city": "Perm",
    "address": "sh. Kosmonavtov 380, 614065 Perm",
    "email": "reception@bmw-abperm.ru",
    "phone": "+7-342-2545555",
    "website": "https://bmw-abperm.ru/owners/",
    "coords": {
      "lat": 57.994224548339844,
      "lng": 56.2054557800293
    }
  },
  {
    "id": "26959_1",
    "name": "Borishof",
    "country": "RU",
    "city": "Moscow",
    "address": "Jaroslavskoje Chaussee 36, 129337 Moscow",
    "email": "info@bmw-borishof.ru",
    "phone": "+7-495-7451111",
    "website": "https://www.bmw-borishof.ru/owners/",
    "coords": {
      "lat": 55.86274337768555,
      "lng": 37.696861267089844
    }
  },
  {
    "id": "35226_1",
    "name": "Avilon",
    "country": "RU",
    "city": "Moscow",
    "address": "Volgogradsky avenue 41 bld.1, 109316 Moscow",
    "email": "info@bmw-avilon.ru",
    "phone": "+7-495-7304445",
    "website": "https://www.bmw-avilon.ru/owners/",
    "coords": {
      "lat": 55.71560287475586,
      "lng": 37.71438217163086
    }
  },
  {
    "id": "46617_1",
    "name": "Prime Auto OOO Silver-Avto PRIME",
    "country": "RU",
    "city": "Magnitogorsk",
    "address": "Magnitnaya 162, 455020 Magnitogorsk",
    "email": "info@bmw-primeauto.ru",
    "phone": "+7-3519-547555",
    "website": "https://bmw-primeauto.ru/owners/",
    "coords": {
      "lat": 53.379920959472656,
      "lng": 59.019351959228516
    }
  },
  {
    "id": "47577_1",
    "name": "ElitAvto",
    "country": "RU",
    "city": "Kemerovo",
    "address": "Kuznetsky Prospekt 115, 650055 Kemerovo",
    "email": "kemerovo@bmw-elitavtosibir.ru",
    "phone": "+7-(3842)-480-500",
    "website": "https://bmw-elitavto.ru/owners/",
    "coords": {
      "lat": 55.332069396972656,
      "lng": 86.0616455078125
    }
  },
  {
    "id": "51157_1",
    "name": "Bars",
    "country": "RU",
    "city": "Tyumen",
    "address": "Feduninskogo 83 bld 1, 625053 Tyumen",
    "email": "info@bmw-bars.ru",
    "phone": "+7-3452-670707",
    "website": "https://bmw-bars.ru/owners/",
    "coords": {
      "lat": 57.09043884277344,
      "lng": 65.60353088378906
    }
  },
  {
    "id": "04612_9",
    "name": "Mohamed Yousuf Naghi Motors LLC Showroom and Fast Lane",
    "country": "SA",
    "city": "Madinah",
    "address": "Ring Road, 99999 Madinah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-14-848552",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 24.467588424682617,
      "lng": 39.66435623168945
    }
  },
  {
    "id": "04612_6",
    "name": "MYNM Automall New Cars Showroom | Quick Service",
    "country": "SA",
    "city": "Jeddah",
    "address": "King Abdul Aziz Road, 00704 Jeddah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 21.649429321289062,
      "lng": 39.11450958251953
    }
  },
  {
    "id": "04612_2",
    "name": "MYNM Dabbab Quick Service",
    "country": "SA",
    "city": "Riyadh",
    "address": "Dabab street, 11413 Riyadh",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 24.66456413269043,
      "lng": 46.708438873291016
    }
  },
  {
    "id": "04612_4",
    "name": "MYNM Khobar New & Used Cars Showroom | Service",
    "country": "SA",
    "city": "Al Khobar",
    "address": "King Fahad Street( Dammam  Khobar, 34234 Al Khobar",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 26.34865379333496,
      "lng": 50.19313430786133
    }
  },
  {
    "id": "04612_5",
    "name": "Mohamed Yousuf Naghi Motors LLC Showroom and Fast Lane",
    "country": "SA",
    "city": "Makkah",
    "address": "Al Lith Rd, Beside Al-Borj Gasoline, 21421 Makkah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-12-5323333",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 21.363554000854492,
      "lng": 39.7950439453125
    }
  },
  {
    "id": "04612_10",
    "name": "Mohamed Yousuf Naghi Motors LC Showroom and Service Centre",
    "country": "SA",
    "city": "Buraydah",
    "address": "King Abdulaziz Road, 99999 Buraydah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-16-3818999",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 26.378910064697266,
      "lng": 43.90553665161133
    }
  },
  {
    "id": "04612_7",
    "name": "MYNM Heraa New Cars Showroom | Service",
    "country": "SA",
    "city": "Jeddah",
    "address": "Al Marwah Street, 99999 Jeddah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 21.630207061767578,
      "lng": 39.201133728027344
    }
  },
  {
    "id": "04612_3",
    "name": "MYNM Khurais New & Used Cars Showroom | Service",
    "country": "SA",
    "city": "Riyadh",
    "address": "Khurais Road, 11413 Riyadh",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 24.75485610961914,
      "lng": 46.82798385620117
    }
  },
  {
    "id": "04612_1",
    "name": "Mohamed Yousuf Naghi Motors LLC MYNM Tahlia New Cars Showroom",
    "country": "SA",
    "city": "Jeddah",
    "address": "Al Fitehi St., 21421 Jeddah",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 21.549785614013672,
      "lng": 39.16379928588867
    }
  },
  {
    "id": "04612_8",
    "name": "MYNM Sulaimaniyah New Cars Showroom",
    "country": "SA",
    "city": "Riyadh",
    "address": "King Abdulaziz Road, 99999 Riyadh",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 24.708982467651367,
      "lng": 46.707977294921875
    }
  },
  {
    "id": "04612_12",
    "name": "MYNM North Ring Road New & Used Cars Showroom I Service",
    "country": "SA",
    "city": "Riyadh",
    "address": "North Ring Road, 11564 Riyadh",
    "email": "bmwgroup@bmw.mynaghi.com",
    "phone": "+966-800-1238000",
    "website": "https://www.bmw-saudiarabia.com",
    "coords": {
      "lat": 24.77358627319336,
      "lng": 46.675331115722656
    }
  },
  {
    "id": "03373_1",
    "name": "Nilssons Bilhall AB",
    "country": "SE",
    "city": "Vimmerby",
    "address": "Lundsgatan 5, 598 40 Vimmerby",
    "email": "Info@nilssonsbilhall.se",
    "phone": "+46-492-79790",
    "website": "https://www.nilssons.bmw.se",
    "coords": {
      "lat": 57.66990280151367,
      "lng": 15.849832534790039
    }
  },
  {
    "id": "24812_7",
    "name": "Förenade Bil AB, Kristianstad",
    "country": "SE",
    "city": "Kristianstad",
    "address": "Sävvägen 2, 291 59 Kristianstad",
    "email": "kristianstad@forenadebil.se",
    "phone": "+46-44-6203100",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/kristianstad.html",
    "coords": {
      "lat": 56.020870208740234,
      "lng": 14.12552261352539
    }
  },
  {
    "id": "35163_1",
    "name": "Hedin Automotive Bavaria AB / Kista",
    "country": "SE",
    "city": "Kista",
    "address": "Haukadalsgatan 3, 164 21 Kista",
    "email": "bmw.kista@hedinautomotive.se",
    "phone": "+46-8-7353900",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/kista.",
    "coords": {
      "lat": 59.400306701660156,
      "lng": 17.95938491821289
    }
  },
  {
    "id": "36501_5",
    "name": "Holmgrens Bil AB Karlskrona",
    "country": "SE",
    "city": "Karlskrona",
    "address": "Vedeby gata 5, 371 49 Karlskrona",
    "email": "bilsalj.karlskrona.vg@holmgrensbil.se",
    "phone": "+46-455-355700",
    "website": "https://www.bmw.se/holmgrensbilkarlskrona",
    "coords": {
      "lat": 56.20429229736328,
      "lng": 15.642900466918945
    }
  },
  {
    "id": "36501_6",
    "name": "Holmgrens Bil AB Värnamo",
    "country": "SE",
    "city": "Värnamo",
    "address": "Bredastensvägen 4, 331 44 Värnamo",
    "email": "bilsalj.varnamo.rv@holmgrensbil.se",
    "phone": "+46-370-694400",
    "website": "https://www.bmw.se/holmgrensbilvarnamo",
    "coords": {
      "lat": 57.1944580078125,
      "lng": 14.03657054901123
    }
  },
  {
    "id": "20387_1",
    "name": "Hackefors Bil AB",
    "country": "SE",
    "city": "Linköping",
    "address": "Låskolvsgatan 1, 589 41 Linköping",
    "email": "verkstad@hackefors.se",
    "phone": "+46-13-362540",
    "website": "http://www.hackefors.bmw.se/",
    "coords": {
      "lat": 58.399169921875,
      "lng": 15.689859390258789
    }
  },
  {
    "id": "35163_7",
    "name": "Hedin Automotive Bavaria AB / Gävle",
    "country": "SE",
    "city": "Gävle",
    "address": "Skolgången 1, 802 57 Gävle",
    "email": "bmw.gavle@hedinautomotive.se",
    "phone": "+46-26-4213100",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/gavle.",
    "coords": {
      "lat": 60.65798568725586,
      "lng": 17.162996292114258
    }
  },
  {
    "id": "36331_2",
    "name": "Mechanum Sverige AB / Malmö",
    "country": "SE",
    "city": "Malmö",
    "address": "Västkustvägen 17, 211 24 Malmö",
    "email": "info@mechanum.com",
    "phone": "+46-31-3400100",
    "website": "http://www.mechanum.com/",
    "coords": {
      "lat": 55.61444854736328,
      "lng": 13.02834701538086
    }
  },
  {
    "id": "36501_1",
    "name": "Holmgrens Bil AB Vimmerby",
    "country": "SE",
    "city": "Vimmerby",
    "address": "BGC-ID: FOR3211, 598 40 Vimmerby",
    "email": "bilsalj.vimmerby.bg@holmgrensbil.se",
    "phone": "+46-492-69700",
    "website": "https://www.bmw.se/holmgrensbilvimmerby",
    "coords": {
      "lat": 57.67143630981445,
      "lng": 15.851533889770508
    }
  },
  {
    "id": "36501_9",
    "name": "Holmgrens Bil AB Nyköping",
    "country": "SE",
    "city": "Nyköping",
    "address": "Kocks väg 6, 611 38 Nyköping",
    "email": "bilsalj.nykoping.kv@holmgrensbil.se",
    "phone": "+46-155-454100",
    "website": "https://www.bmw.se/holmgrensbilnykoping",
    "coords": {
      "lat": 58.7525749206543,
      "lng": 16.976272583007812
    }
  },
  {
    "id": "36501_10",
    "name": "Holmgrens Bil AB Linköping",
    "country": "SE",
    "city": "Linköping",
    "address": "Gudmundsgatan 11, 582 78 Linköping",
    "email": "salj.linkoping@holmgrensbil.se",
    "phone": "+46-13-5603500",
    "website": "https://www.bmw.se/holmgrensbillinkoping",
    "coords": {
      "lat": 58.43149185180664,
      "lng": 15.66197395324707
    }
  },
  {
    "id": "45781_1",
    "name": "Biljouren i Åkersberga AB",
    "country": "SE",
    "city": "Åkersberga",
    "address": "Sågvägen 8, 184 40 Åkersberga",
    "email": "biljouren@biljouren.se",
    "phone": "+46-8-54085000",
    "website": "https://www.biljouren.se",
    "coords": {
      "lat": 59.47992706298828,
      "lng": 18.289268493652344
    }
  },
  {
    "id": "50781_1",
    "name": "Werksta Sweden AB",
    "country": "SE",
    "city": "Handen",
    "address": "Anläggarvägen 18, 136 44 Handen",
    "email": "haninge@werksta.se",
    "phone": "+46-8-4485850",
    "website": "https://www.werksta.se",
    "coords": {
      "lat": 59.1707878112793,
      "lng": 18.155916213989258
    }
  },
  {
    "id": "03337_1",
    "name": "NIFAB",
    "country": "SE",
    "city": "Sävsjö",
    "address": "Sågaregatan 15, 576 36 Sävsjö",
    "email": "nifab.n@telia.com",
    "phone": "+46-382-12745",
    "website": "https://www.nifab-savsjo.torget.se/",
    "coords": {
      "lat": 57.40651321411133,
      "lng": 14.664093971252441
    }
  },
  {
    "id": "24239_1",
    "name": "Ivars Bilservice i Hoting AB",
    "country": "SE",
    "city": "Hoting",
    "address": "Industrivägen 2, 833 51 Hoting",
    "email": "ivars.bilservice@telia.com",
    "phone": "+46-671-10930",
    "website": "https://www.ivarsbilservice.se",
    "coords": {
      "lat": 64.10924530029297,
      "lng": 16.19709587097168
    }
  },
  {
    "id": "33822_4",
    "name": "Bilia BMU AB, Trollhättan",
    "country": "SE",
    "city": "Trollhättan",
    "address": "Kardanvägen 18, 461 38 Trollhättan",
    "email": "info.trollhattan@bilia.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/trollhattan",
    "coords": {
      "lat": 58.295040130615234,
      "lng": 12.322015762329102
    }
  },
  {
    "id": "35163_8",
    "name": "Hedin Automotive Bavaria AB / Öst.",
    "country": "SE",
    "city": "Östersund",
    "address": "Fagerbacken 65, 831 48 Östersund",
    "email": "bmw.ostersund@hedinautomotive.se",
    "phone": "+46-63-6605600",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/osters",
    "coords": {
      "lat": 63.17030334472656,
      "lng": 14.685864448547363
    }
  },
  {
    "id": "33822_7",
    "name": "Bilia BMU AB, Segeltorp",
    "country": "SE",
    "city": "Segeltorp",
    "address": "Smista Allé 31, 141 70 Segeltorp",
    "email": "Info.stockholm@biliagroup.se",
    "phone": "+46-0771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/segeltorp",
    "coords": {
      "lat": 59.284523010253906,
      "lng": 17.937976837158203
    }
  },
  {
    "id": "24812_1",
    "name": "Förenade Bil AB, Malmö",
    "country": "SE",
    "city": "Malmö",
    "address": "Djurhagegatan 15, 213 76 Malmö",
    "email": "bmw.malmo@forenadebil.se",
    "phone": "+46-40-243700",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/malmo.html",
    "coords": {
      "lat": 55.558998107910156,
      "lng": 13.0728759765625
    }
  },
  {
    "id": "33822_1",
    "name": "Bilia BMU AB, Mölndal",
    "country": "SE",
    "city": "Mölndal",
    "address": "Göteborgsvägen 92, 431 37 Mölndal",
    "email": "info.molndal@bilia.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/molndal.html",
    "coords": {
      "lat": 57.67236328125,
      "lng": 12.010810852050781
    }
  },
  {
    "id": "33822_15",
    "name": "Bilia BMU AB, Aröd SFL",
    "country": "SE",
    "city": "Hisings Backa",
    "address": "Aröds industriväg 10, 422 43 Hisings Backa",
    "email": "info@biliagroup.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/molndal.html",
    "coords": {
      "lat": 57.730796813964844,
      "lng": 11.956963539123535
    }
  },
  {
    "id": "35163_15",
    "name": "Hedin Automotive Bavaria AB / Umeå",
    "country": "SE",
    "city": "Umeå",
    "address": "Illervägen 5, 906 21 Umeå",
    "email": "umea@hedinautomotive.se",
    "phone": "+46-90-9996100",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/umea.h",
    "coords": {
      "lat": 63.85042953491211,
      "lng": 20.32012939453125
    }
  },
  {
    "id": "36501_8",
    "name": "Holmgrens Bil AB Skövde",
    "country": "SE",
    "city": "Skövde",
    "address": "Plantvägen 1, 541 63 Skövde",
    "email": "bilsalj.skovde.pv@holmgrensbil.se",
    "phone": "+46-500-103000",
    "website": "https://www.bmw.se/holmgrensbilskovde",
    "coords": {
      "lat": 58.42044448852539,
      "lng": 13.874990463256836
    }
  },
  {
    "id": "21868_1",
    "name": "Lunds Bil i Varberg AB",
    "country": "SE",
    "city": "Varberg",
    "address": "Lindbergsvägen 2, 432 32 Varberg",
    "email": "bmw.varberg@lundsbil.se",
    "phone": "+46-340-646550",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/lunds-bil.html",
    "coords": {
      "lat": 57.123783111572266,
      "lng": 12.263758659362793
    }
  },
  {
    "id": "24812_4",
    "name": "Förenade Bil AB, Lund",
    "country": "SE",
    "city": "Lund",
    "address": "Traktorvägen 7, 226 60 Lund",
    "email": "bmw.lund@forenadebil.se",
    "phone": "+46-46-311550",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/lund",
    "coords": {
      "lat": 55.71616744995117,
      "lng": 13.162053108215332
    }
  },
  {
    "id": "33822_3",
    "name": "Bilia BMU AB, Borås",
    "country": "SE",
    "city": "Borås",
    "address": "Elementgatan 8, 504 64 Borås",
    "email": "info.boras@biliagroup.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/boras",
    "coords": {
      "lat": 57.701656341552734,
      "lng": 12.828206062316895
    }
  },
  {
    "id": "33822_9",
    "name": "Bilia BMU AB, Lidingö",
    "country": "SE",
    "city": "Lidingö",
    "address": "Förrådsvägen 2, 181 41 Lidingö",
    "email": "thomas.sjoblom@bilia.se",
    "phone": "+46-771-400000",
    "website": "https://www.biliagroup.bmw.se/",
    "coords": {
      "lat": 59.35707092285156,
      "lng": 18.17236328125
    }
  },
  {
    "id": "33822_5",
    "name": "Bilia BMU AB, Uddevalla",
    "country": "SE",
    "city": "Uddevalla",
    "address": "Norgårdsvägen 10, 451 75 Uddevalla",
    "email": "info.uddevalla@bilia.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/uddevalla",
    "coords": {
      "lat": 58.349422454833984,
      "lng": 11.832627296447754
    }
  },
  {
    "id": "35163_10",
    "name": "Hedin Automotive Bavaria AB Solna",
    "country": "SE",
    "city": "Solna",
    "address": "Gårdsvägen 7C, 169 70 Solna",
    "email": "bmw.solna@hedinautomotive.se",
    "phone": "+46-8-57046100",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/solna-",
    "coords": {
      "lat": 59.36626052856445,
      "lng": 18.01207733154297
    }
  },
  {
    "id": "35163_9",
    "name": "Bavaria Sverige Bil AB/ Luleå",
    "country": "SE",
    "city": "Luleå",
    "address": "Hummergatan 8, 973 34 Luleå",
    "email": "bmw.lulea@hedinautomotive.se",
    "phone": "+46-920-432600",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/lulea.",
    "coords": {
      "lat": 65.5994644165039,
      "lng": 22.145797729492188
    }
  },
  {
    "id": "36501_12",
    "name": "Holmgrens Bil AB Vetlanda",
    "country": "SE",
    "city": "Vetlanda",
    "address": "Bilgatan 1, 574 33 Vetlanda",
    "email": "vetlanda.bilforsaljning@holmgrensbil.se",
    "phone": "+46-383-763000",
    "website": null,
    "coords": {
      "lat": 57.42387008666992,
      "lng": 15.104521751403809
    }
  },
  {
    "id": "02883_2",
    "name": "Autowåx Bil AB",
    "country": "SE",
    "city": "Karlstad",
    "address": "Säterivägen 24, 653 41 Karlstad",
    "email": "info@autowax.se",
    "phone": "+46-54-217712",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/autowax.html",
    "coords": {
      "lat": 59.39176940917969,
      "lng": 13.473104476928711
    }
  },
  {
    "id": "33822_2",
    "name": "Bilia BMU AB, Kungsbacka",
    "country": "SE",
    "city": "Kungsbacka",
    "address": "Hallabäcksvägen 2, 434 37 Kungsbacka",
    "email": "info@biliagroup.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/kungsbacka",
    "coords": {
      "lat": 57.509578704833984,
      "lng": 12.064957618713379
    }
  },
  {
    "id": "33822_14",
    "name": "Bilia BMU AB, Aröd Sales",
    "country": "SE",
    "city": "Hisings Backa",
    "address": "Aröds industriväg 10, 422 43 Hisings Backa",
    "email": "info@biliagroup.se",
    "phone": "+46-771-400000",
    "website": null,
    "coords": {
      "lat": 57.730796813964844,
      "lng": 11.956963539123535
    }
  },
  {
    "id": "33822_17",
    "name": "Bilia BMU AB, Västerås",
    "country": "SE",
    "city": "Västerås",
    "address": "Transformatorgatan 11, 721 37 Västerås",
    "email": "vasteras@mbilar.com",
    "phone": "+46-21-171180",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/m-bilar-group/vasteras",
    "coords": {
      "lat": 59.64923095703125,
      "lng": 16.570724487304688
    }
  },
  {
    "id": "33822_18",
    "name": "Bilia BMU AB, Dalarna",
    "country": "SE",
    "city": "Borlänge",
    "address": "Singelgatan 3, 784 72 Borlänge",
    "email": "dalarna@mbilar.com",
    "phone": "+46-243-315300",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/m-bilar-group/dalarna",
    "coords": {
      "lat": 60.4901237487793,
      "lng": 15.477618217468262
    }
  },
  {
    "id": "33822_20",
    "name": "Bilia BMU AB, Mora SFL",
    "country": "SE",
    "city": "Färnäs",
    "address": "Hindrikesvägen 12, 792 75 Färnäs",
    "email": "verkstad.mora@mbilar.com",
    "phone": "+46-70-4370518",
    "website": null,
    "coords": {
      "lat": 61.0086555480957,
      "lng": 14.614311218261719
    }
  },
  {
    "id": "35163_16",
    "name": "Hedin Automotive Bavaria AB / Ö-vik",
    "country": "SE",
    "city": "Örnsköldsvik",
    "address": "Sjögatan 1R, 891 60 Örnsköldsvik",
    "email": "ornskoldsvik@hedinautomotive.se",
    "phone": "+46-660-247300",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/ornsko",
    "coords": {
      "lat": 63.286399841308594,
      "lng": 18.729461669921875
    }
  },
  {
    "id": "36501_2",
    "name": "Holmgrens Bil AB Jönköping",
    "country": "SE",
    "city": "Jönköping",
    "address": "Österängsvägen 8, 554 63 Jönköping",
    "email": "bil.jonkoping.crm@holmgrensbil.se",
    "phone": "+46-36-348040",
    "website": "https://www.bmw.se/holmgrensbiljonkoping",
    "coords": {
      "lat": 57.782562255859375,
      "lng": 14.233441352844238
    }
  },
  {
    "id": "36331_4",
    "name": "Mechanum Sverige AB / Partille",
    "country": "SE",
    "city": "Partille",
    "address": "Benjamins väg 12, 433 38 Partille",
    "email": "info@mechanum.com",
    "phone": "+46-31-3400100",
    "website": "http://www.mechanum.com/",
    "coords": {
      "lat": 57.74088668823242,
      "lng": 12.13351821899414
    }
  },
  {
    "id": "43289_1",
    "name": "Werksta Enköping AB",
    "country": "SE",
    "city": "Enköping",
    "address": "Myrangatan 5, 745 37 Enköping",
    "email": "enkoping@werksta.se",
    "phone": "+46-171-105422",
    "website": "https://www.werksta.se/bilverkstader/bilverkstad-enkoping/",
    "coords": {
      "lat": 59.64801025390625,
      "lng": 17.090639114379883
    }
  },
  {
    "id": "33822_19",
    "name": "Bilia BMU AB, Örebro",
    "country": "SE",
    "city": "Örebro",
    "address": "Bettorpsgatan 22, 703 69 Örebro",
    "email": "orebro@mbilar.com",
    "phone": "+46-10-1605700",
    "website": "https://www.mbilar.com",
    "coords": {
      "lat": 59.305213928222656,
      "lng": 15.230864524841309
    }
  },
  {
    "id": "35163_4",
    "name": "Hedin Automotive Bavaria AB /Bromma",
    "country": "SE",
    "city": "Bromma",
    "address": "Ulvsundavägen 170, 168 67 Bromma",
    "email": "info@hedinautomotive.se",
    "phone": "+46-8-58893640",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/vallin",
    "coords": {
      "lat": 59.3519401550293,
      "lng": 17.957748413085938
    }
  },
  {
    "id": "35163_5",
    "name": "Bavaria Sverige Bil AB / Uppsala",
    "country": "SE",
    "city": "Uppsala",
    "address": "Fyrislundsgatan 75, 754 50 Uppsala",
    "email": "uppsala@hedinautomotive.se",
    "phone": "+46-18-4184500",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/uppsal",
    "coords": {
      "lat": 59.85325241088867,
      "lng": 17.691518783569336
    }
  },
  {
    "id": "36501_4",
    "name": "Holmgrens Bil AB Kalmar",
    "country": "SE",
    "city": "Kalmar",
    "address": "Dragonvägen 1, 392 39 Kalmar",
    "email": "bilsalj.kalmar.dv@holmgrensbil.se",
    "phone": "+46-480-442740",
    "website": "https://www.bmw.se/holmgrensbilkalmar",
    "coords": {
      "lat": 56.67444610595703,
      "lng": 16.321640014648438
    }
  },
  {
    "id": "36501_11",
    "name": "Holmgrens Bil AB Norrköping",
    "country": "SE",
    "city": "Åby",
    "address": "Cylindervägen 7, 616 34 Åby",
    "email": "bil.norrkoping.crm@holmgrensbil.se",
    "phone": "+46-11-4705800",
    "website": "https://www.bmw.se/holmgrensbilnorrkoping",
    "coords": {
      "lat": 58.645748138427734,
      "lng": 16.16685676574707
    }
  },
  {
    "id": "24385_1",
    "name": "RH Bilservice AB",
    "country": "SE",
    "city": "Södertälje",
    "address": "Lännockvägen 29, 152 42 Södertälje",
    "email": "rh.bil@rhbil.se",
    "phone": "+46-8-55030366",
    "website": "http://www.rhbil.se/",
    "coords": {
      "lat": 59.209144592285156,
      "lng": 17.656156539916992
    }
  },
  {
    "id": "28805_1",
    "name": "Bendt Bil AB",
    "country": "SE",
    "city": "Halmstad",
    "address": "Kristinehedsvägen 13, 302 44 Halmstad",
    "email": "info@bendtbil.se",
    "phone": "+46-35-104050",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bendt-bil.html",
    "coords": {
      "lat": 56.680328369140625,
      "lng": 12.886748313903809
    }
  },
  {
    "id": "33822_8",
    "name": "Bilia BMU AB, Nacka",
    "country": "SE",
    "city": "Nacka",
    "address": "Jarlabergsvägen 2, 131 48 Nacka",
    "email": "Info.stockholm@biliagroup.se",
    "phone": "+46-771-400000",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/bilia-group/nacka",
    "coords": {
      "lat": 59.313663482666016,
      "lng": 18.168107986450195
    }
  },
  {
    "id": "35163_6",
    "name": "Bavaria Sverige Bil AB / Skellefteå",
    "country": "SE",
    "city": "Skellefteå",
    "address": "Tjärnvägen 4, 931 61 Skellefteå",
    "email": "bmw.skelleftea@hedinautomotive.se",
    "phone": "+46-910-763300",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/skelle",
    "coords": {
      "lat": 64.72831726074219,
      "lng": 20.963302612304688
    }
  },
  {
    "id": "35163_11",
    "name": "Hedin Automotive Bavaria AB Sol. WS",
    "country": "SE",
    "city": "Solna",
    "address": "Gårdsvägen 7C, 169 70 Solna",
    "email": "bmw.solna@hedinautomotive.se",
    "phone": "+46-8-57046100",
    "website": null,
    "coords": {
      "lat": 59.36626052856445,
      "lng": 18.01207733154297
    }
  },
  {
    "id": "36331_7",
    "name": "Mechanum Sverige AB / Tagene SFL Ne",
    "country": "SE",
    "city": "Hisings Kärra",
    "address": "Transkärrsgatan 16, 427 37 Hisings Kärra",
    "email": "info@mechanum.com",
    "phone": "+46-31-3400100",
    "website": "http://www.mechanum.com/",
    "coords": {
      "lat": 57.78470993041992,
      "lng": 11.995189666748047
    }
  },
  {
    "id": "24812_5",
    "name": "Förenade Bil AB, Helsingborg",
    "country": "SE",
    "city": "Helsingborg",
    "address": "Garnisonsgatan 15, 254 66 Helsingborg",
    "email": "hbg@forenadebil.se",
    "phone": "+46-42-329700",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/helsingborg",
    "coords": {
      "lat": 56.074642181396484,
      "lng": 12.726799964904785
    }
  },
  {
    "id": "24812_6",
    "name": "Förenade Bil AB, Ängelholm",
    "country": "SE",
    "city": "Ängelholm",
    "address": "Klippanvägen 4, 262 71 Ängelholm",
    "email": "agh@forenadebil.se",
    "phone": "+46-431-415730",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/angelholm",
    "coords": {
      "lat": 56.25051498413086,
      "lng": 12.888583183288574
    }
  },
  {
    "id": "33822_16",
    "name": "Bilia BMU AB, Eskilstuna",
    "country": "SE",
    "city": "Eskilstuna",
    "address": "Västerleden 56, 633 47 Eskilstuna",
    "email": "eskilstuna@mbilar.com",
    "phone": "+46-16-171180",
    "website": "http://www.bmw.se/sv/avdelning/aterforsaljare/m-bilar-group/eskilstuna",
    "coords": {
      "lat": 59.38832092285156,
      "lng": 16.465835571289062
    }
  },
  {
    "id": "35163_2",
    "name": "Hedin Automotive Bavaria AB / Dand.",
    "country": "SE",
    "city": "Danderyd",
    "address": "Danderydsvägen 142, 182 36 Danderyd",
    "email": "info@hedinautomotive.se",
    "phone": "+46-8-4465850",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/dander",
    "coords": {
      "lat": 59.41064453125,
      "lng": 18.038057327270508
    }
  },
  {
    "id": "35163_3",
    "name": "Hedin Automotive Bavaria AB / Tyr.",
    "country": "SE",
    "city": "Tyresö",
    "address": "Vintervägen 4, 135 40 Tyresö",
    "email": "service.tyreso@hedinautomotive.se",
    "phone": "+46-8-58893670",
    "website": "https://dealers.bmw.se/hedin-automotive/hedin-automotive-skadecenter-t",
    "coords": {
      "lat": 59.24469757080078,
      "lng": 18.217439651489258
    }
  },
  {
    "id": "36331_1",
    "name": "Mechanum Sverige AB / Mölndal",
    "country": "SE",
    "city": "Mölndal",
    "address": "Argongatan 32, 431 53 Mölndal",
    "email": "info@mechanum.com",
    "phone": "+46-31-3400100",
    "website": "http://www.mechanum.com/",
    "coords": {
      "lat": 57.64118957519531,
      "lng": 12.008564949035645
    }
  },
  {
    "id": "36501_7",
    "name": "Holmgrens Bil AB Växjö",
    "country": "SE",
    "city": "Växjö",
    "address": "Vaktvägen 3, 352 36 Växjö",
    "email": "bilsalj.vaxjo.hv@holmgrensbil.se",
    "phone": "+46-470-700400",
    "website": "https://www.bmw.se/holmgrensbilvaxjo",
    "coords": {
      "lat": 56.87992858886719,
      "lng": 14.760676383972168
    }
  },
  {
    "id": "24812_8",
    "name": "Förenade Bil AB, Halmstad",
    "country": "SE",
    "city": "Halmstad",
    "address": "Ryttarevägen 7, 302 62 Halmstad",
    "email": "bmw.halmstad@forenadebil.se",
    "phone": "+46-035-2023500",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/forenade-bil/malmo.html",
    "coords": {
      "lat": 56.65480422973633,
      "lng": 12.901592254638672
    }
  },
  {
    "id": "35163_14",
    "name": "Hedin Automotive Bavaria AB / Sunds",
    "country": "SE",
    "city": "Sundsvall",
    "address": "Landsvägsallén 71, 852 29 Sundsvall",
    "email": "sundsvall@hedinautomotive.se",
    "phone": "+46-60-7445100",
    "website": "https://www.bmw.se/sv/avdelning/aterforsaljare/hedin-automotive/sundsv",
    "coords": {
      "lat": 62.37955093383789,
      "lng": 17.359737396240234
    }
  },
  {
    "id": "29902_1",
    "name": "Eurokars Habitat Pte. Ltd.",
    "country": "SG",
    "city": "Singapore",
    "address": "27 Leng Kee Road, 159098 Singapore",
    "email": "MINI.info@eurokars.com.sg",
    "phone": "+65-64733777",
    "website": "https://www.mini.com.sg",
    "coords": {
      "lat": 1.2906609773635864,
      "lng": 103.81153869628906
    }
  },
  {
    "id": "51569_1",
    "name": "Eurokars Auto Pte Ltd",
    "country": "SG",
    "city": "Singapore",
    "address": "11 Kung Chong Road, 159147 Singapore",
    "email": "bmw.info@eurokars.com.sg",
    "phone": "+65-62698833",
    "website": "https://www.bmweurokars.com.sg/",
    "coords": {
      "lat": 1.2903170585632324,
      "lng": 103.81361389160156
    }
  },
  {
    "id": "51569_2",
    "name": "Eurokars Auto Pte Ltd",
    "country": "SG",
    "city": "Singapore",
    "address": "29 Leng Kee Road, 159099 Singapore",
    "email": "bmw.info@eurokars.com.sg",
    "phone": "+65-62698833",
    "website": "https://www.bmweurokars.com.sg/",
    "coords": {
      "lat": 1.2907296419143677,
      "lng": 103.81129455566406
    }
  },
  {
    "id": "00780_3",
    "name": "Performance Motors Ltd.",
    "country": "SG",
    "city": "Singapore",
    "address": "280 Kampong Arang Road, 438180 Singapore",
    "email": "CallCentre.pml@simedarby.com.sg",
    "phone": "+65-62255269",
    "website": "https://pml-bmw.com.sg/",
    "coords": {
      "lat": 1.3010129928588867,
      "lng": 103.88272857666016
    }
  },
  {
    "id": "00780_1",
    "name": "Performance Motors Ltd.",
    "country": "SG",
    "city": "Singapore",
    "address": "303 Alexandra Road, 159941 Singapore",
    "email": "CallCentre.pml@simedarby.com.sg",
    "phone": "+65-62255269",
    "website": "https://pml-bmw.com.sg/",
    "coords": {
      "lat": 1.290197491645813,
      "lng": 103.80732727050781
    }
  },
  {
    "id": "00780_6",
    "name": "Performance Motors Ltd.",
    "country": "SG",
    "city": "Singapore",
    "address": "1 Ubi Road 4, 408607 Singapore",
    "email": "CallCentre.pml@simedarby.com.sg",
    "phone": "+65-62255269",
    "website": "https://pml-bmw.com.sg/",
    "coords": {
      "lat": 1.3340660333633423,
      "lng": 103.8993148803711
    }
  },
  {
    "id": "24179_13",
    "name": "Millennium Auto  (Suratthani)",
    "country": "TH",
    "city": "Suratthani",
    "address": "161 Moo  Tombon Wat Pradu1, 84000 Suratthani",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-9352000",
    "website": "https://www.millenniumauto.co.th",
    "coords": {
      "lat": 9.123361587524414,
      "lng": 99.28740692138672
    }
  },
  {
    "id": "24761_5",
    "name": "Performance Motors (Ayutthaya)",
    "country": "TH",
    "city": "Ayutthaya",
    "address": "9/99 Moo 7, Asian Road, Ban Krot, 13160 Ayutthaya",
    "email": "info@bmw-performancemotors.com",
    "phone": "+66-35-880999",
    "website": null,
    "coords": {
      "lat": 14.303791999816895,
      "lng": 100.61225128173828
    }
  },
  {
    "id": "29213_1",
    "name": "German Auto (Bangna)",
    "country": "TH",
    "city": "Bangkok",
    "address": "441 Bangna Trad, 10260 Bangkok",
    "email": "contactcenter@bmw-germanauto.com",
    "phone": "+66-2-3961199",
    "website": "https://www.facebook.com/BMWGermanAuto",
    "coords": {
      "lat": 13.669214248657227,
      "lng": 100.63145446777344
    }
  },
  {
    "id": "29213_4",
    "name": "German Auto (Pattaya)",
    "country": "TH",
    "city": "Chonburi",
    "address": "99/96 Moo 3 T. Najomtien A.Sattahip, 20250 Chonburi",
    "email": "contactcenter@bmw-germanauto.com",
    "phone": "+66-38-235600",
    "website": "https://www.facebook.com/BMWGermanAuto",
    "coords": {
      "lat": 12.795918464660645,
      "lng": 100.91707611083984
    }
  },
  {
    "id": "21675_1",
    "name": "Barcelona Motor (Vibhavadi)",
    "country": "TH",
    "city": "Bangkok",
    "address": "299 Moo 14, Vibhavadi-Rangsit Rd.,, 10900 Bangkok",
    "email": "info@bmw-barcelonamotor.com",
    "phone": "+66-2-4817777",
    "website": "https://www.bmwbarcelonamotor.com/",
    "coords": {
      "lat": 13.808616638183594,
      "lng": 100.5602798461914
    }
  },
  {
    "id": "24179_7",
    "name": "Millennium Auto (Ubon Ratchathani)",
    "country": "TH",
    "city": "Ubonratchatani",
    "address": "9 Moo 8 Tumbol Jaeramae, 34000 Ubonratchatani",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-45-206222",
    "website": "https://www.millenniumauto.co.th",
    "coords": {
      "lat": 15.211453437805176,
      "lng": 104.81385040283203
    }
  },
  {
    "id": "38761_3",
    "name": "Amorn Prestige (Rangsit)",
    "country": "TH",
    "city": "Pathumthani",
    "address": "94/5 Phahonyothin Rd.,Prachathipat, 12130 Pathumthani",
    "email": "crm.amornprestige@bmw-amornprestige.com",
    "phone": "+66-2-5311909",
    "website": "https://www.facebook.com/BMWAmornPrestige",
    "coords": {
      "lat": 13.986900329589844,
      "lng": 100.6194076538086
    }
  },
  {
    "id": "38761_1",
    "name": "Amorn Prestige (Ratchadapisek)",
    "country": "TH",
    "city": "Bangkok",
    "address": "168 Ratchadapisek Road, 10900 Bangkok",
    "email": "crm.amornprestige@bmw-amornprestige.com",
    "phone": "+66-2-5139555",
    "website": "https://www.facebook.com/BMWAmornPrestige",
    "coords": {
      "lat": 13.820210456848145,
      "lng": 100.57537078857422
    }
  },
  {
    "id": "21600_1",
    "name": "Europa Motor (Headquarters)",
    "country": "TH",
    "city": "Bangkok",
    "address": "979 Prannok- Phutthamonthon,, 10170 Bangkok",
    "email": "info@bmw-europamotor.com",
    "phone": "+66-2-4332266",
    "website": "https://www.facebook.com/EuropaMotor",
    "coords": {
      "lat": 13.753767967224121,
      "lng": 100.42269897460938
    }
  },
  {
    "id": "21600_2",
    "name": "Europa Motor (Praram 2)",
    "country": "TH",
    "city": "Bangkok",
    "address": "176/2 and 176/3 Rama 2 Rd. Samaedam, 10150 Bangkok",
    "email": "info@bmw-europamotor.com",
    "phone": "+66-2-8481111",
    "website": "https://www.facebook.com/EuropaMotor",
    "coords": {
      "lat": 13.658199310302734,
      "lng": 100.43157196044922
    }
  },
  {
    "id": "21666_1",
    "name": "Nithiboon (Phitsanulok)",
    "country": "TH",
    "city": "Pitsanulok",
    "address": "168 Moo 9, Thapho, 65000 Pitsanulok",
    "email": "Tiensaeng.Nitayamekin@bmw-nithiboon.com",
    "phone": "+66-97-9232277",
    "website": "https://www.facebook.com/BMWNithiboon",
    "coords": {
      "lat": 16.742950439453125,
      "lng": 100.18090057373047
    }
  },
  {
    "id": "23777_1",
    "name": "Nelson's Autohaus (Chonburi)",
    "country": "TH",
    "city": "Chonburi",
    "address": "61/1 Moo 1, 20000 Chonburi",
    "email": "sales@bmw-nelsonsautohaus.com",
    "phone": "+66-38-288858",
    "website": null,
    "coords": {
      "lat": 13.338541984558105,
      "lng": 100.97242736816406
    }
  },
  {
    "id": "24179_1",
    "name": "Millennium Auto (Ladprao)",
    "country": "TH",
    "city": "Bangkok",
    "address": "2222/9 Ladprao Road Soi Ladprao 112, 10310 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-9352000",
    "website": "https://www.millenniumauto.co.th",
    "coords": {
      "lat": 13.780963897705078,
      "lng": 100.6178970336914
    }
  },
  {
    "id": "24179_8",
    "name": "Millennium Auto (Phuket)",
    "country": "TH",
    "city": "Phuket",
    "address": "9/99 Moo 5 Chalermprakiat Rama 9 Ro, 83000 Phuket",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-76-201900",
    "website": "https://www.millenniumauto.co.th",
    "coords": {
      "lat": 7.920529365539551,
      "lng": 98.3698501586914
    }
  },
  {
    "id": "24179_12",
    "name": "Millennium Auto (Pattanakarn)",
    "country": "TH",
    "city": "Bangkok",
    "address": "2089 Pattanakarn, Khet Suanluang, 10250 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-9352000",
    "website": "https://www.millenniumauto.co.th/",
    "coords": {
      "lat": 13.736740112304688,
      "lng": 100.63420867919922
    }
  },
  {
    "id": "21675_9",
    "name": "Barcelona Motor (Bangkhae)",
    "country": "TH",
    "city": "Bangkhae",
    "address": "548 Phetkasem Rd., Bangkhaenue, 10160 Bangkhae",
    "email": "info@bmw-barcelonamotor.com",
    "phone": "+66-2-0805888",
    "website": "https://www.bmwbarcelonamotor.com/",
    "coords": {
      "lat": 13.710569381713867,
      "lng": 100.40191650390625
    }
  },
  {
    "id": "38761_2",
    "name": "Amorn Prestige Co., Ltd.",
    "country": "TH",
    "city": "Bangkok",
    "address": "60 Soi Chalermsuk, Ratchadapisek Rd, 10900 Bangkok",
    "email": "crm.amornprestige@bmw-amornprestige.com",
    "phone": "+66-2-513-2232",
    "website": "https://www.facebook.com/BMWAmornPrestige",
    "coords": {
      "lat": 13.824358940124512,
      "lng": 100.57295989990234
    }
  },
  {
    "id": "21600_3",
    "name": "Europa Motor (Ratchapruek)",
    "country": "TH",
    "city": "Bangkok",
    "address": "206 Prannok- Phutthamonthon, 10170 Bangkok",
    "email": "info@bmw-europamotor.com",
    "phone": "+66-2-458-2266",
    "website": "https://www.facebook.com/EuropaMotor",
    "coords": {
      "lat": 13.754476547241211,
      "lng": 100.42250061035156
    }
  },
  {
    "id": "21675_6",
    "name": "Barcelona Motor (Chiang Mai)",
    "country": "TH",
    "city": "Chiangmai",
    "address": "402 Chiangmai - Lampang Rd.,, 50000 Chiangmai",
    "email": "info@bmw-barcelonamotor.com",
    "phone": "+66-53-306472",
    "website": "https://www.bmwbarcelonamotor.com/",
    "coords": {
      "lat": 18.80548858642578,
      "lng": 99.01688385009766
    }
  },
  {
    "id": "24179_2",
    "name": "Millennium Auto (Rama 4)",
    "country": "TH",
    "city": "Bangkok",
    "address": "2929/9 Rama 4 Road, 10110 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-6633222",
    "website": null,
    "coords": {
      "lat": 13.719901084899902,
      "lng": 100.56512451171875
    }
  },
  {
    "id": "44696_1",
    "name": "Platino Motor (Nakornpathom)",
    "country": "TH",
    "city": "Nakornpathom",
    "address": "629/9 Phetkasem Rd.,, 73000 Nakornpathom",
    "email": "office@bmw-platinomotor.co.th",
    "phone": "+66-34-275324",
    "website": null,
    "coords": {
      "lat": 13.809408187866211,
      "lng": 100.06486511230469
    }
  },
  {
    "id": "21600_4",
    "name": "Europa Motor Used car",
    "country": "TH",
    "city": "Bangkok",
    "address": "893/1-2 Prannok-Phutthamonthon, 10170 Bangkok",
    "email": "info@bmw-europamotor.com",
    "phone": "+66-2-4332266",
    "website": "https://www.facebook.com/EuropaMotor",
    "coords": {
      "lat": 13.752633094787598,
      "lng": 100.43187713623047
    }
  },
  {
    "id": "24179_9",
    "name": "Millennium Auto (Hat Yai)",
    "country": "TH",
    "city": "Songkla",
    "address": "888 Suphasanrangsan Road,, 90110 Songkla",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-74-491900",
    "website": "https://www.millenniumauto.co.th",
    "coords": {
      "lat": 7.008486747741699,
      "lng": 100.4904556274414
    }
  },
  {
    "id": "24179_10",
    "name": "Millennium Auto (Icon Siam)",
    "country": "TH",
    "city": "Bangkok",
    "address": "ICONSIAM Shopping Mall 229, 3 Fl., 10600 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-9352000",
    "website": "https://www.millenniumauto.co.th/",
    "coords": {
      "lat": 13.726940155029297,
      "lng": 100.50999450683594
    }
  },
  {
    "id": "23777_2",
    "name": "Nelson's Autohaus (Rayong)",
    "country": "TH",
    "city": "Rayong",
    "address": "Tambon Phe, A.muang Rayong, 21160 Rayong",
    "email": "sales@bmw-nelsonsautohaus.com",
    "phone": "+66-38-288858",
    "website": null,
    "coords": {
      "lat": 12.641515731811523,
      "lng": 101.40607452392578
    }
  },
  {
    "id": "24761_2",
    "name": "Performance Motors (Charan)",
    "country": "TH",
    "city": "Bangkok",
    "address": "292 Charansanitwong Rd., 10700 Bangkok",
    "email": "info@bmw-performancemotors.com",
    "phone": "+66-2-8800999",
    "website": null,
    "coords": {
      "lat": 13.797494888305664,
      "lng": 100.50900268554688
    }
  },
  {
    "id": "29213_3",
    "name": "German Auto Co., Ltd.",
    "country": "TH",
    "city": "Bangkok",
    "address": "527 Moo 4 Bangchalong,Bangplee,, 10540 Bangkok",
    "email": "contactcenter@bmw-germanauto.com",
    "phone": "+66-2-3961199",
    "website": "https://www.facebook.com/BMWGermanAuto",
    "coords": {
      "lat": 13.632689476013184,
      "lng": 100.73886108398438
    }
  },
  {
    "id": "40528_1",
    "name": "Nat Bavarian Motor (Udonthani)",
    "country": "TH",
    "city": "Udonthani",
    "address": "555 Moo 8, Soi Ban Bongkham, 41000 Udonthani",
    "email": "chanvit.utenpitakkul@bmw-natbavarianmotor.com",
    "phone": "+66-42-327555",
    "website": "https://www.facebook.com/Natbavarian/",
    "coords": {
      "lat": 17.432790756225586,
      "lng": 102.78874969482422
    }
  },
  {
    "id": "20984_1",
    "name": "Sky Autohaus (Khonkaen)",
    "country": "TH",
    "city": "Khonkaen",
    "address": "294/8 Moo 7, Maliwan Rd.,, 40000 Khonkaen",
    "email": "samart.yimsiri@bmw-skyautohaus.com",
    "phone": "+66-43-333799",
    "website": "https://www.facebook.com/SkyAutohausBMWandMINI/",
    "coords": {
      "lat": 16.440570831298828,
      "lng": 102.8194808959961
    }
  },
  {
    "id": "24761_3",
    "name": "Performance Motors (Donmueang)",
    "country": "TH",
    "city": "Bangkok",
    "address": "Vibhavadee Rd., 10210 Bangkok",
    "email": "info@bmw-performancemotors.com",
    "phone": "+66-2-5610999",
    "website": null,
    "coords": {
      "lat": 13.863773345947266,
      "lng": 100.57083892822266
    }
  },
  {
    "id": "24761_1",
    "name": "Performance Motors (Ramintra)",
    "country": "TH",
    "city": "Bangkok",
    "address": "25/14-15 Moo4 Ramintra Road, 10220 Bangkok",
    "email": "info@bmw-performancemotors.com",
    "phone": "+66-2-900-5700",
    "website": null,
    "coords": {
      "lat": 13.86390495300293,
      "lng": 100.6166000366211
    }
  },
  {
    "id": "24179_5",
    "name": "Millennium Auto (Paragon)",
    "country": "TH",
    "city": "Bangkok",
    "address": "991 Siam Paragon Shopping Center, 10330 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-6109900",
    "website": "https://www.millenniumauto.co.th/",
    "coords": {
      "lat": 13.746246337890625,
      "lng": 100.53480529785156
    }
  },
  {
    "id": "21899_1",
    "name": "Cherdchai Autohaus (Korat)",
    "country": "TH",
    "city": "Nakhonratchasima",
    "address": "2198 Mitraparp Rd., A. Muang, 30000 Nakhonratchasima",
    "email": "Darunee.lomnaimaung@bmw-cherdchaiautohaus.com",
    "phone": "+66-44-213341",
    "website": "https://www.facebook.com/bmwcherdchaiautohaus/",
    "coords": {
      "lat": 14.965347290039062,
      "lng": 102.06421661376953
    }
  },
  {
    "id": "24179_6",
    "name": "Millennium Auto (Rama 3)",
    "country": "TH",
    "city": "Bangkok",
    "address": "999 Rama 3 Road, Bang Khlo, 10120 Bangkok",
    "email": "info@bmw-millenniumauto.com",
    "phone": "+66-2-6706000",
    "website": "https://www.millenniumauto.co.th/",
    "coords": {
      "lat": 13.686803817749023,
      "lng": 100.51942443847656
    }
  },
  {
    "id": "24761_4",
    "name": "Performance Motors (Ratchapruk)",
    "country": "TH",
    "city": "Nonthaburi",
    "address": "119 Moo 1  Tambol Om Kret, 11120 Nonthaburi",
    "email": "info@bmw-performancemotors.com",
    "phone": "+66-2-1950999",
    "website": null,
    "coords": {
      "lat": 13.900652885437012,
      "lng": 100.45015716552734
    }
  },
  {
    "id": "29213_2",
    "name": "German Auto (Chaengwattana)",
    "country": "TH",
    "city": "Nonthaburi",
    "address": "59 Moo 4, T. Prakkret, A. Pakkret, 11120 Nonthaburi",
    "email": "contactcenter@bmw-germanauto.com",
    "phone": "+66-2-1190999",
    "website": "https://www.facebook.com/BMWGermanAuto",
    "coords": {
      "lat": 13.906596183776855,
      "lng": 100.51915740966797
    }
  },
  {
    "id": "22788_1",
    "name": "Autohouse LLC",
    "country": "TM",
    "city": "Ashgabat",
    "address": "G. Guliyewa 4 (2127), 744015 Ashgabat",
    "email": "m.ramazanov@bmwtm.com",
    "phone": "+993-64-077770",
    "website": "https://bmwtm.com",
    "coords": {
      "lat": 37.95101547241211,
      "lng": 58.4337272644043
    }
  },
  {
    "id": "01626_6",
    "name": "Borusan Oto Adana",
    "country": "TR",
    "city": "Mersin",
    "address": "Yenice Mah. Cemal Gürsel, 33800 Mersin",
    "email": "info@borusanoto.com",
    "phone": "+90-324-6150615",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 36.9779167175293,
      "lng": 35.08085632324219
    }
  },
  {
    "id": "47627_1",
    "name": "Agacli Oto Servis Hizmetleri A.S.",
    "country": "TR",
    "city": "Ankara",
    "address": "Eskisehir Yolu, Erler Mah., 06790 Ankara",
    "email": "berkolcen@gmail.com",
    "phone": "+90-312-9093434",
    "website": "https://agaclioto.bmw.com.tr",
    "coords": {
      "lat": 39.9011116027832,
      "lng": 32.683448791503906
    }
  },
  {
    "id": "01161_1",
    "name": "Köprülü Oto",
    "country": "TR",
    "city": "Karatay-Konya",
    "address": "Fevzi Cakmak Mah. Ankara, 42050 Karatay-Konya",
    "email": "suleyman.koprulu@koprulu.com.tr",
    "phone": "+90-332-4448547",
    "website": "https://kopruluoto.bmw.com.tr",
    "coords": {
      "lat": 37.90902328491211,
      "lng": 32.51591491699219
    }
  },
  {
    "id": "01626_5",
    "name": "Borusan Oto Istinye",
    "country": "TR",
    "city": "Istanbul",
    "address": "Istinye Mahallesi Sariyer Caddesi, 34460 Istanbul",
    "email": "info@borusanoto.com",
    "phone": "+90-212-3593099",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 41.12000274658203,
      "lng": 29.047855377197266
    }
  },
  {
    "id": "01626_22",
    "name": "Borusan Oto Samandira",
    "country": "TR",
    "city": "Istanbul",
    "address": "Akpinar Mah. Bilim Cad. No:2, 34885 Istanbul",
    "email": "info@borusanoto.com",
    "phone": "+90-216-2288000",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 40.975276947021484,
      "lng": 29.229167938232422
    }
  },
  {
    "id": "42115_1",
    "name": "Dinamik Oto",
    "country": "TR",
    "city": "Trabzon",
    "address": "Sögütlü Mahallesi Adnan Kahveci, 61300 Trabzon",
    "email": "a.ozturk@dinamikoto.com.tr",
    "phone": "+90-462-3444242",
    "website": "https://dinamikoto.bmw.com.tr",
    "coords": {
      "lat": 41.017147064208984,
      "lng": 39.599647521972656
    }
  },
  {
    "id": "47574_1",
    "name": "Otomol Izmir",
    "country": "TR",
    "city": "Izmir",
    "address": "Umurbey mah.Sehitler Sok., 35230 Izmir",
    "email": "osman@otomol.com",
    "phone": "+90-232-2420909",
    "website": "https://otomol.bmw.com.tr",
    "coords": {
      "lat": 38.437599182128906,
      "lng": 27.160999298095703
    }
  },
  {
    "id": "45595_1",
    "name": "AU Otomotiv",
    "country": "TR",
    "city": "ANKARA",
    "address": "Bahcekapi Mah. Sanayi Bulvari No:10, 06797 ANKARA",
    "email": "nulus@auotomotiv.com.tr",
    "phone": "+90-312-2784222",
    "website": "https://auotomotiv.bmw.com.tr",
    "coords": {
      "lat": 39.94183349609375,
      "lng": 32.71241760253906
    }
  },
  {
    "id": "45541_1",
    "name": "Sandikci Oto",
    "country": "TR",
    "city": "SAKARYA",
    "address": "Hanliköy Mahallesi Kartopu Sokak, 54000 SAKARYA",
    "email": "harun.sandikci@sandikci.toyota.com.tr",
    "phone": "+90-264-6662700",
    "website": "https://sandikcioto.bmw.com.tr",
    "coords": {
      "lat": 40.72844314575195,
      "lng": 30.383968353271484
    }
  },
  {
    "id": "40888_3",
    "name": "Otomol Maslak",
    "country": "TR",
    "city": "Istanbul",
    "address": "Dereboyu Cad. No: 15 Ata Center, 34398 Istanbul",
    "email": "osman@otomol.com",
    "phone": "+90-212-2866667",
    "website": null,
    "coords": {
      "lat": 41.1122932434082,
      "lng": 29.021324157714844
    }
  },
  {
    "id": "40888_4",
    "name": "Otomol Cayyolu",
    "country": "TR",
    "city": "Ankara",
    "address": "Erler, Dumlupinar Blv. No: 408, 06790 Ankara",
    "email": "aydin.yasar@otomol.com",
    "phone": "+90-312-4090909",
    "website": "https://otomol.bmw.com.tr",
    "coords": {
      "lat": 39.8985710144043,
      "lng": 32.68349075317383
    }
  },
  {
    "id": "40888_5",
    "name": "Otomol Antalya",
    "country": "TR",
    "city": "Antalya",
    "address": "Altinova Sinan Mah.Serik Cad.No:139, 07170 Antalya",
    "email": "info@otomol.com",
    "phone": "+90-212-4090909",
    "website": "https://www.otomol.com/",
    "coords": {
      "lat": 36.926448822021484,
      "lng": 30.79692268371582
    }
  },
  {
    "id": "01127_1",
    "name": "Kosifler Oto Bostanci",
    "country": "TR",
    "city": "Istanbul",
    "address": "Icerenköy Mh. Askent Sokak, 34752 Istanbul",
    "email": "sinan.kosif@kosifler.com.tr",
    "phone": "+90-216-5783333",
    "website": "https://kosifleroto.bmw.com.tr",
    "coords": {
      "lat": 40.96184158325195,
      "lng": 29.112192153930664
    }
  },
  {
    "id": "01127_8",
    "name": "Kosifler Oto Trabzon",
    "country": "TR",
    "city": "Trabzon",
    "address": "Kasustu Mah. Devlet Karayolu Cad., 61290 Trabzon",
    "email": null,
    "phone": "+90-462-3335561",
    "website": "https://kosifleroto.bmw.com.tr",
    "coords": {
      "lat": 40.96480178833008,
      "lng": 39.83848571777344
    }
  },
  {
    "id": "01626_4",
    "name": "Borusan Oto Avcilar",
    "country": "TR",
    "city": "Istanbul",
    "address": "Firuzköy Bulvari No: 21, 34320 Istanbul",
    "email": "info@borusanoto.com",
    "phone": "+90-212-4120512",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 40.99248123168945,
      "lng": 28.716821670532227
    }
  },
  {
    "id": "01626_18",
    "name": "Borusan Oto Çayyolu",
    "country": "TR",
    "city": "Ankara",
    "address": "Konutkent mahallesi 3028, 06810 Ankara",
    "email": "simay.alsan@borusanoto.com",
    "phone": "+90-312-2533333",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 39.87837600708008,
      "lng": 32.6553840637207
    }
  },
  {
    "id": "25313_3",
    "name": "Özgörkey Denizli",
    "country": "TR",
    "city": "Denizli",
    "address": "Yenisehir Mahallesi 55 Sokak No:1/1, 20125 Denizli",
    "email": "beyhan.akyurt@ozgorkey.com",
    "phone": "+90-232-3881990",
    "website": "https://ozgorkey.bmw.com.tr",
    "coords": {
      "lat": 37.76066207885742,
      "lng": 29.04336929321289
    }
  },
  {
    "id": "22077_1",
    "name": "Cangar Motors Co.Ltd.",
    "country": "TR",
    "city": "Lefkosa (Zypern-Nord)",
    "address": "Sehit Mustafa Ruso Caddesi, 99010 Lefkosa (Zypern-Nord)",
    "email": "info@cangarmotors.com",
    "phone": "+90-392-227055",
    "website": "http://www.bmw.cc/ncy/en/",
    "coords": {
      "lat": 35.20173263549805,
      "lng": 33.36699676513672
    }
  },
  {
    "id": "25314_1",
    "name": "Öztorun Oto",
    "country": "TR",
    "city": "Kocaeli",
    "address": "Yenisehir Mah. Arac, 41050 Kocaeli",
    "email": "sabri@oztorun.com",
    "phone": "+90-262-4441269",
    "website": "https://oztorun.bmw.com.tr",
    "coords": {
      "lat": 40.77289581298828,
      "lng": 29.968473434448242
    }
  },
  {
    "id": "25314_3",
    "name": "Öztorun Sakarya",
    "country": "TR",
    "city": "Adapazari",
    "address": "Cadde 54 AVM,Arabacialani Mahallesi, 54050 Adapazari",
    "email": "info@oztorun.com",
    "phone": "+90-262-4441269",
    "website": "https://oztorun.bmw.com.tr",
    "coords": {
      "lat": 40.77442169189453,
      "lng": 30.364709854125977
    }
  },
  {
    "id": "42953_1",
    "name": "Otomol Atasehir",
    "country": "TR",
    "city": "Istanbul",
    "address": "Barbaros Mah. Feslegen Sok., 34758 Istanbul",
    "email": "osman@otomol.com",
    "phone": "+90-216-5752525",
    "website": null,
    "coords": {
      "lat": 40.98954772949219,
      "lng": 29.10542106628418
    }
  },
  {
    "id": "46866_1",
    "name": "Piyalepasa Otomotiv",
    "country": "TR",
    "city": "Istanbul",
    "address": "Kaptanpasa Mah., 34384 Istanbul",
    "email": "bitera@piyalepasaotomotiv.com",
    "phone": "+90-212-3111000",
    "website": "https://piyalepasa.bmw.com.tr",
    "coords": {
      "lat": 41.03925323486328,
      "lng": 28.966703414916992
    }
  },
  {
    "id": "01626_21",
    "name": "Borusan Oto Corlu",
    "country": "TR",
    "city": "Tekirdag",
    "address": "E-5 Karayolu Üzeri Istanbul Cad.No., 34522 Tekirdag",
    "email": "simay.alsan@borusanoto.com",
    "phone": "+90-282-2921500",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 41.14250183105469,
      "lng": 27.863000869750977
    }
  },
  {
    "id": "07682_1",
    "name": "Teknik Oto Bursa 1",
    "country": "TR",
    "city": "Bursa",
    "address": "Ovaakca Cesmebasi Mah., 16335 Bursa",
    "email": "resepsiyon1@teknikoto.com",
    "phone": "+90-224-2804920",
    "website": "https://teknikoto.bmw.com.tr",
    "coords": {
      "lat": 40.306880950927734,
      "lng": 29.061857223510742
    }
  },
  {
    "id": "40888_2",
    "name": "Otomol Bodrum",
    "country": "TR",
    "city": "Mugla",
    "address": "Kemikler Mah. Güllük-Güvercinlik, 48200 Mugla",
    "email": "osman@otomol.com",
    "phone": "+90-252-5110909",
    "website": "https://otomol.bmw.com.tr",
    "coords": {
      "lat": 37.215721130371094,
      "lng": 27.65825843811035
    }
  },
  {
    "id": "41446_1",
    "name": "Inciroglu Otomotiv",
    "country": "TR",
    "city": "Kayseri",
    "address": "Inciroglu Ikiz Plaza Anbar Mah., 34860 Kayseri",
    "email": "vedat@inciroglu.com.tr",
    "phone": "+90-352-3334440",
    "website": "https://inciroglu.bmw.com.tr",
    "coords": {
      "lat": 38.75544357299805,
      "lng": 35.37652587890625
    }
  },
  {
    "id": "47626_1",
    "name": "Burmot Motorlu Vasitalar Servis Ticaret San.Ltd.Sti.",
    "country": "TR",
    "city": "Bursa",
    "address": "Ücevler Mah. Nilüfer Cad.Kücük, 16285 Bursa",
    "email": "emrah.babir@burmot.com",
    "phone": "+90-224-2696464",
    "website": "https://burmot.bmw.com.tr",
    "coords": {
      "lat": 40.21451950073242,
      "lng": 28.90096664428711
    }
  },
  {
    "id": "52642_1",
    "name": "Akcinler Otomotiv",
    "country": "TR",
    "city": "Manisa",
    "address": "Evrenos Mah. Evrenos Kume Evler, 45140 Manisa",
    "email": null,
    "phone": "+90-236-2333535",
    "website": null,
    "coords": {
      "lat": 38.641571044921875,
      "lng": 27.393718719482422
    }
  },
  {
    "id": "01127_4",
    "name": "Kosifler Oto Bagdat Caddesi",
    "country": "TR",
    "city": "Istanbul",
    "address": "Bagdat Cad. No: 234, 34728 Istanbul",
    "email": "selim.kosif@kosifler.com.tr",
    "phone": "+90-216-4675314",
    "website": "https://kosifleroto.bmw.com.tr",
    "coords": {
      "lat": 40.97313690185547,
      "lng": 29.056621551513672
    }
  },
  {
    "id": "07682_3",
    "name": "Teknik Oto Eskisehir",
    "country": "TR",
    "city": "Eskisehir",
    "address": "Satilmisoglu Mah. Bursa Yolu, 26100 Eskisehir",
    "email": "gurolmumcu@teknikoto.com",
    "phone": "+90-222-4112141",
    "website": "https://teknikoto.bmw.com.tr",
    "coords": {
      "lat": 39.82400131225586,
      "lng": 30.350963592529297
    }
  },
  {
    "id": "30832_1",
    "name": "Oto Beyhan",
    "country": "TR",
    "city": "Mugla",
    "address": "Orhaniye Mah. 122 Sok. No: 1-7, 48000 Mugla",
    "email": "ayhan.cay@otobeyhan.com.tr",
    "phone": "+90-252-2144765",
    "website": "https://beyhanoto.bmw.com.tr",
    "coords": {
      "lat": 37.19900894165039,
      "lng": 28.369932174682617
    }
  },
  {
    "id": "36112_1",
    "name": "Erenler Otomotiv",
    "country": "TR",
    "city": "Antep",
    "address": "Mervesehir Mah. Sehit Ömer Halis, 27080 Antep",
    "email": "erdinc@erenleroto.com",
    "phone": "+90-342-3228383",
    "website": "https://erenler.bmw.com.tr",
    "coords": {
      "lat": 37.09200668334961,
      "lng": 37.39967346191406
    }
  },
  {
    "id": "44038_1",
    "name": "Gül-al Otomotiv",
    "country": "TR",
    "city": "Istanbul",
    "address": "Eksioglu Mahallesi, 34768 Istanbul",
    "email": "a.tasdemir@gulal.com.tr",
    "phone": "+90-216-4844848",
    "website": "https://gul-al.bmw.com.tr",
    "coords": {
      "lat": 41.02790832519531,
      "lng": 29.237478256225586
    }
  },
  {
    "id": "01132_1",
    "name": "Ege Servis",
    "country": "TR",
    "city": "Izmir",
    "address": "Ankara Cad. No:285, 35110 Izmir",
    "email": "atarhan@egeservis.com.tr",
    "phone": "+90-232-4611765",
    "website": "https://egeservis.bmw.com.tr",
    "coords": {
      "lat": 38.47040557861328,
      "lng": 27.242794036865234
    }
  },
  {
    "id": "01626_16",
    "name": "Borusan Oto Bodrum",
    "country": "TR",
    "city": "Mugla",
    "address": "Konacik Mah., 25200 Mugla",
    "email": "simay.alsan@borusanoto.com",
    "phone": "+90-252-3110444",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 37.05590057373047,
      "lng": 27.371999740600586
    }
  },
  {
    "id": "40888_1",
    "name": "Otomol-Merter",
    "country": "TR",
    "city": "Istanbul",
    "address": "Osmaniye Mah. Cirpici Yanyol Cad, 34140 Istanbul",
    "email": "osman@otomol.com",
    "phone": "+90-212-4090909",
    "website": "https://otomol.bmw.com.tr",
    "coords": {
      "lat": 41.00290298461914,
      "lng": 28.89069938659668
    }
  },
  {
    "id": "39595_1",
    "name": "Musluoglu Otomotiv",
    "country": "TR",
    "city": "Istanbul",
    "address": "Aydintepe Mh. E5, 34947 Istanbul",
    "email": "alimuslu@musluoglugrup.com",
    "phone": "+90-216-4940808",
    "website": "https://musluoglu.bmw.com.tr",
    "coords": {
      "lat": 40.85667037963867,
      "lng": 29.288265228271484
    }
  },
  {
    "id": "41865_1",
    "name": "Özgür Oto",
    "country": "TR",
    "city": "Denizli",
    "address": "Izmir Yolu Menderes, 20100 Denizli",
    "email": "ozgur@ozguroto.com.tr",
    "phone": "+90-258-3713777",
    "website": "https://ozguroto.bmw.com.tr",
    "coords": {
      "lat": 37.803524017333984,
      "lng": 29.073530197143555
    }
  },
  {
    "id": "44806_1",
    "name": "Badilli Oto",
    "country": "TR",
    "city": "SANLIURFA",
    "address": "Ogulbey Mahallesi, 63050 SANLIURFA",
    "email": "mahmut.badilli@badillioto.com",
    "phone": "+90-414-3152299",
    "website": "https://badillioto.bmw.com.tr",
    "coords": {
      "lat": 37.160400390625,
      "lng": 38.878501892089844
    }
  },
  {
    "id": "45780_1",
    "name": "Trend Oto",
    "country": "TR",
    "city": "Istanbul",
    "address": "Yukari Dudullu Mah. Necip Fazil Bul, 34775 Istanbul",
    "email": "vedat.belge@trendotoservis.com",
    "phone": "+90-216-4665050",
    "website": "https://trendoto.bmw.com.tr",
    "coords": {
      "lat": 41.00792694091797,
      "lng": 29.162141799926758
    }
  },
  {
    "id": "01127_6",
    "name": "Kosifler Oto Samsun",
    "country": "TR",
    "city": "Samsun - Türkiye",
    "address": "Cumhuriyet Mah..Atatürk Bulv.No:306, 55310 Samsun - Türkiye",
    "email": "ugur.sakiroglu@kosifler.com.tr",
    "phone": "+90-362-2664545",
    "website": "https://kosifleroto.bmw.com.tr",
    "coords": {
      "lat": 41.23198699951172,
      "lng": 36.50910949707031
    }
  },
  {
    "id": "01626_3",
    "name": "Borusan Oto Esenboga",
    "country": "TR",
    "city": "Ankara",
    "address": "Balikhisar Mahallesi, Köy Ici Küme, 06150 Ankara",
    "email": "info@borusanoto.com",
    "phone": "+90-312-8405252",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 40.08779525756836,
      "lng": 32.97454071044922
    }
  },
  {
    "id": "07682_4",
    "name": "Teknik Oto Bursa 2",
    "country": "TR",
    "city": "Bursa",
    "address": "Alaaddin Bey Mah., 16110 Bursa",
    "email": "gurolmumcu@teknikoto.com",
    "phone": "+90-224-4416866",
    "website": "https://teknikoto.bmw.com.tr",
    "coords": {
      "lat": 40.21207809448242,
      "lng": 28.927631378173828
    }
  },
  {
    "id": "43926_1",
    "name": "Er-Güleryüz Otomotiv",
    "country": "TR",
    "city": "Erzurum",
    "address": "Ömer Nasuhi Bilmen Mah. Tortum Yolu, 25050 Erzurum",
    "email": "Hasancalmasur@erguleryuzotomotiv.com.tr",
    "phone": "+90-442-2490785",
    "website": "https://er-guleryuz.bmw.com.tr/",
    "coords": {
      "lat": 39.954410552978516,
      "lng": 41.294620513916016
    }
  },
  {
    "id": "01127_2",
    "name": "Kosifler Oto Antalya",
    "country": "TR",
    "city": "Antalya",
    "address": "Altinova Sinan Mah. Serik Cad., 07170 Antalya",
    "email": "antalya.info@kosifler.com.tr",
    "phone": "+90-242-3204400",
    "website": "https://kosifleroto.bmw.com.tr",
    "coords": {
      "lat": 36.91463851928711,
      "lng": 30.77700424194336
    }
  },
  {
    "id": "01626_9",
    "name": "Borusan Oto Gaziantep",
    "country": "TR",
    "city": "Gaziantep",
    "address": "15 Temmuz Mah. Prf. Dr. Necmettin, 27590 Gaziantep",
    "email": "simay.alsan@borusanoto.com",
    "phone": "+90-342-3228383",
    "website": "https://www.borusanoto.com",
    "coords": {
      "lat": 37.092193603515625,
      "lng": 37.39997863769531
    }
  },
  {
    "id": "07682_6",
    "name": "Teknik Oto Bursa 3",
    "country": "TR",
    "city": "Bursa",
    "address": "Alaaddinbey Mah., 16120 Bursa",
    "email": "gurolmumcu@teknikoto.com",
    "phone": "+90-224-4140074",
    "website": "https://teknikoto.bmw.com.tr",
    "coords": {
      "lat": 40.21342849731445,
      "lng": 28.90963363647461
    }
  },
  {
    "id": "25313_1",
    "name": "Özgörkey",
    "country": "TR",
    "city": "Izmir",
    "address": "Üniversite Cad. No: 66, 35100 Izmir",
    "email": "batu@ozgorkey.com",
    "phone": "+90-232-3881990",
    "website": "https://ozgorkey.bmw.com.tr",
    "coords": {
      "lat": 38.45442581176758,
      "lng": 27.19875717163086
    }
  },
  {
    "id": "36405_1",
    "name": "Ücler Otomotiv",
    "country": "TR",
    "city": "Kayseri",
    "address": "Yeni Sanayi Bölgesi Seker, 38010 Kayseri",
    "email": "ersin@uclerotomotiv.com.tr",
    "phone": "+90-352-3317900",
    "website": "https://ucler.bmw.com.tr",
    "coords": {
      "lat": 38.740360260009766,
      "lng": 35.426578521728516
    }
  },
  {
    "id": "41156_1",
    "name": "Istanbul Oto",
    "country": "TR",
    "city": "Istanbul",
    "address": "Cobancesme Mah., 34196 Istanbul",
    "email": "berkay@istanbuloto.com.tr",
    "phone": "+90-212-6609960",
    "website": "https://istanbuloto.bmw.com.tr",
    "coords": {
      "lat": 41.001556396484375,
      "lng": 28.822660446166992
    }
  },
  {
    "id": "48336_2",
    "name": "LAFAST MOTORS LIMITED",
    "country": "TT",
    "city": "San Fernando",
    "address": "59-61 Lady Hailes Ave. Corner Gulf, null San Fernando",
    "email": "jp_agostini@lafastmotors.com",
    "phone": "+1-868-6124269",
    "website": null,
    "coords": {
      "lat": 10.266698837280273,
      "lng": -61.46388244628906
    }
  },
  {
    "id": "48336_1",
    "name": "LAFAST MOTORS LIMITED",
    "country": "TT",
    "city": "Port of Spain",
    "address": "37 Dundonald Street, null Port of Spain",
    "email": null,
    "phone": "+1-868-6124269",
    "website": null,
    "coords": {
      "lat": 10.660931587219238,
      "lng": -61.51377487182617
    }
  },
  {
    "id": "00934_5",
    "name": "Automotores Motor Haus S.A.",
    "country": "UY",
    "city": "Montevideo",
    "address": "Camino Carrasco 7170, 11500 Montevideo",
    "email": "luis.pascual@bmwuruguay.com",
    "phone": "+598-29243125",
    "website": "https://www.bmw.com.uy",
    "coords": {
      "lat": -34.86958694458008,
      "lng": -56.06635665893555
    }
  },
  {
    "id": "00934_1",
    "name": "Motor Haus",
    "country": "UY",
    "city": "Montevideo",
    "address": "Ramon Escobar 1330, 11800 Montevideo",
    "email": "luis.pascual@bmwuruguay.com",
    "phone": "+598-29243125",
    "website": "https://www.bmw.com.uy",
    "coords": {
      "lat": -34.8924446105957,
      "lng": -56.18887710571289
    }
  },
  {
    "id": "46554_2",
    "name": "THACO Auto Distribution Co Ltd (Long Bien)",
    "country": "VN",
    "city": "Hanoi",
    "address": "1 Ngo Gia Tu St, Long Bien District, 100000 Hanoi",
    "email": "care@thaco.com.vn",
    "phone": "+84-938908488",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 21.054597854614258,
      "lng": 105.88692474365234
    }
  },
  {
    "id": "46554_14",
    "name": "THACO Auto Distribution Co Ltd (Can Tho)",
    "country": "VN",
    "city": "Cai Rang District, Can Tho",
    "address": "Quang Trung St, Hung Phu 1 ResArea, 900000 Cai Rang District, Can Tho",
    "email": "care@thaco.com.vn",
    "phone": "+84-901806689",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.016571998596191,
      "lng": 105.78289031982422
    }
  },
  {
    "id": "46554_15",
    "name": "THACO Auto Distribution Co Ltd (Dak Lak)",
    "country": "VN",
    "city": "Buon Me Thuot City, Dak Lak",
    "address": "19,Nguyen Tat Thanh St, Tan Loi War, 630000 Buon Me Thuot City, Dak Lak",
    "email": "care@thaco.com.vn",
    "phone": "+84-901881400",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 12.686580657958984,
      "lng": 108.05371856689453
    }
  },
  {
    "id": "46554_9",
    "name": "THACO Auto Distribution Co Ltd (Nguyen Van Troi)",
    "country": "VN",
    "city": "Phu Nhuan, Ho Chi Minh",
    "address": "80, Nguyen Van Troi St, Ward 8, 700000 Phu Nhuan, Ho Chi Minh",
    "email": "care@thaco.com.vn",
    "phone": "+84-938889572",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.796512603759766,
      "lng": 106.67486572265625
    }
  },
  {
    "id": "46554_10",
    "name": "THACO Auto Distribution Co Ltd (Le Duan)",
    "country": "VN",
    "city": "Ha Noi",
    "address": "132, Le Duan St, Hai Ba Trung Dist, 100000 Ha Noi",
    "email": "care@thaco.com.vn",
    "phone": "+84-938880262",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 21.0194091796875,
      "lng": 105.84122467041016
    }
  },
  {
    "id": "46554_19",
    "name": "THACO Auto Distribution Co Ltd (Nha Trang)",
    "country": "VN",
    "city": "Nha Trang City, Khanh Hoa Province",
    "address": "Lot 1, Area 2, 23/10 St, Vinh Hiep, 650000 Nha Trang City, Khanh Hoa Province",
    "email": "care@thaco.com.vn",
    "phone": "+84-901871739",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 12.25468921661377,
      "lng": 109.16471862792969
    }
  },
  {
    "id": "46554_6",
    "name": "THACO Auto Distribution Co Ltd (Da Nang)",
    "country": "VN",
    "city": "Danang City",
    "address": "356 Dien Bien Phu St,Thanh Khe Dist, 550000 Danang City",
    "email": "care@thaco.com.vn",
    "phone": "+84-909779356",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 16.06652069091797,
      "lng": 108.1917953491211
    }
  },
  {
    "id": "46554_18",
    "name": "THACO Auto Distribution Co Ltd (Bac Ninh)",
    "country": "VN",
    "city": "Bac Ninh City, Bac Ninh Province",
    "address": "1, Le Thai To St, Vo Cuong Ward, 220000 Bac Ninh City, Bac Ninh Province",
    "email": "care@thaco.com.vn",
    "phone": "+84-933806002",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 21.16819953918457,
      "lng": 106.0470962524414
    }
  },
  {
    "id": "46554_16",
    "name": "THACO Auto Distribution Co Ltd (Bien Hoa)",
    "country": "VN",
    "city": "Dong Nai",
    "address": "18 St 2A, An Binh Ward, Bien Hoa, 810000 Dong Nai",
    "email": "care@thaco.com.vn",
    "phone": "+84-901889686",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.929008483886719,
      "lng": 106.86872100830078
    }
  },
  {
    "id": "46554_11",
    "name": "THACO Auto Distribution Co Ltd (Le Van Luong)",
    "country": "VN",
    "city": "Ha Noi",
    "address": "68, Le Van Luong St,Thanh Xuan Dist, 100000 Ha Noi",
    "email": "care@thaco.com.vn",
    "phone": "+84-938881836",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 21.002723693847656,
      "lng": 105.80079650878906
    }
  },
  {
    "id": "46554_12",
    "name": "THACO Auto Distribution Co Ltd (Hai Phong)",
    "country": "VN",
    "city": "Ngo Quyen Dist, Hai Phong",
    "address": "8 Nguyen Trai, May To Ward, 180000 Ngo Quyen Dist, Hai Phong",
    "email": "care@thaco.com.vn",
    "phone": "+84-938899848",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 20.8669490814209,
      "lng": 106.69434356689453
    }
  },
  {
    "id": "46554_5",
    "name": "THACO Auto Distribution Co Ltd (Sala)",
    "country": "VN",
    "city": "District 2, Ho Chi Minh City",
    "address": "12 Mai Chi Tho St, An Loi Dong Ward, 700000 District 2, Ho Chi Minh City",
    "email": "care@thaco.com.vn",
    "phone": "+84-907808880",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.77338981628418,
      "lng": 106.72344970703125
    }
  },
  {
    "id": "46554_17",
    "name": "THACO Auto Distribution Co Ltd (Binh Duong)",
    "country": "VN",
    "city": "Thuan An City, Binh Duong",
    "address": "56/9 Binh Duong Blvd, Binh Giao Qtr, 823900 Thuan An City, Binh Duong",
    "email": "care@thaco.com.vn",
    "phone": "+84-901889798",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.93889331817627,
      "lng": 106.71011352539062
    }
  },
  {
    "id": "46554_13",
    "name": "THACO Auto Distribution Co Ltd (Vinh)",
    "country": "VN",
    "city": "Vinh City, Nghe An",
    "address": "46 Rd, Hamlet 3, Nghi Phu Commune, 460000 Vinh City, Nghe An",
    "email": "care@thaco.com.vn",
    "phone": "+84-901828618",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 18.71953010559082,
      "lng": 105.67168426513672
    }
  },
  {
    "id": "46554_1",
    "name": "THACO Auto Distribution Co Ltd (Phu My Hung)",
    "country": "VN",
    "city": "Ho Chi Minh City",
    "address": "314 Nguyen Van Linh, Binh Thuan, D7, 700000 Ho Chi Minh City",
    "email": "care@thaco.com.vn",
    "phone": "+84-938901800",
    "website": "https://www.bmw.vn",
    "coords": {
      "lat": 10.741562843322754,
      "lng": 106.72136688232422
    }
  },
  {
    "id": "02980_1",
    "name": "BMW Kempton Park",
    "country": "ZA",
    "city": "Isando",
    "address": "Cnr Isando and Brabazon Road, 1619 Isando",
    "email": "autobahn@autobahnbmw.co.za",
    "phone": "+27-11-3926263",
    "website": "https://www.bmw.co.za/kempton_park",
    "coords": {
      "lat": -26.132389068603516,
      "lng": 28.20134162902832
    }
  },
  {
    "id": "09725_1",
    "name": "BMW Mahikeng",
    "country": "ZA",
    "city": "Mafikeng",
    "address": "Cnr Nelson Mandela and Aerodrome, 2745 Mafikeng",
    "email": "shireen.dada@dadamotorsmahikeng.co.za",
    "phone": "+27-18-3812760",
    "website": "https://www.bmw.co.za/mahikeng",
    "coords": {
      "lat": -25.84271240234375,
      "lng": 25.63836669921875
    }
  },
  {
    "id": "43760_4",
    "name": "BMW Pietermaritzburg",
    "country": "ZA",
    "city": "Pietermaritzburg",
    "address": "9 Armitage Road, 3201 Pietermaritzburg",
    "email": "concierge.pmb@supertechgroup.co.za",
    "phone": "+27-33-8978800",
    "website": "https://www.bmw.co.za/pietermaritzburg",
    "coords": {
      "lat": -29.583599090576172,
      "lng": 30.374378204345703
    }
  },
  {
    "id": "43760_6",
    "name": "BMW Shelly Beach",
    "country": "ZA",
    "city": "Shelly Beach",
    "address": "55 Main Road, 4265 Shelly Beach",
    "email": "concierge.sb@supertechgroup.co.za",
    "phone": "+27-39-3150020",
    "website": "https://www.bmw.co.za/shelly_beach",
    "coords": {
      "lat": -30.798824310302734,
      "lng": 30.398406982421875
    }
  },
  {
    "id": "44046_1",
    "name": "BMW Menlyn",
    "country": "ZA",
    "city": "Menlyn",
    "address": "Cnr Garstfontein Rd and Lois Ave, 0181 Menlyn",
    "email": "info@bmw-menlyn.co.za",
    "phone": "+27-12-4262700",
    "website": "https://www.bmw.co.za/menlyn",
    "coords": {
      "lat": -25.78891944885254,
      "lng": 28.274213790893555
    }
  },
  {
    "id": "46199_1",
    "name": "BMW Richards Bay",
    "country": "ZA",
    "city": "Richards Bay",
    "address": "2 Bauxite Bay, 3900 Richards Bay",
    "email": "kirsten.hodgson@smg.co.za",
    "phone": "+27-35-4260020",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_richards_bay.html",
    "coords": {
      "lat": -28.754287719726562,
      "lng": 32.02516174316406
    }
  },
  {
    "id": "30773_2",
    "name": "BMW East Rand (Dalpark)",
    "country": "ZA",
    "city": "Brakpan",
    "address": "30 Pendoring Avenue, 1543 Brakpan",
    "email": "info@bmweastrand.co.za",
    "phone": "+27-10-1092000",
    "website": "http://www.bmw-eastrand.co.za",
    "coords": {
      "lat": -26.2479190826416,
      "lng": 28.320316314697266
    }
  },
  {
    "id": "51003_1",
    "name": "BMW Cape Town City SMG",
    "country": "ZA",
    "city": "Cape Town",
    "address": "Cnr Heerengracht and Hertzog Blvd, 7708 Cape Town",
    "email": "bmwcapetowncity@smg.co.za",
    "phone": "+27-21-4027700",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_cape_town_city.html",
    "coords": {
      "lat": -33.919151306152344,
      "lng": 18.42793083190918
    }
  },
  {
    "id": "02487_1",
    "name": "BMW Ermelo",
    "country": "ZA",
    "city": "Ermelo",
    "address": "114 Kerk Street, 2351 Ermelo",
    "email": "info@autobmw.co.za",
    "phone": "+27-17-8112242",
    "website": "https://www.bmw.co.za/ermelo",
    "coords": {
      "lat": -26.51883316040039,
      "lng": 29.984800338745117
    }
  },
  {
    "id": "10237_4",
    "name": "BMW Vereeniging",
    "country": "ZA",
    "city": "Vereeniging",
    "address": "Cnr Johannesburg and Gen. Smuts, 1939 Vereeniging",
    "email": "vereeniging@sovereignbmw.co.za",
    "phone": "+27-16-4505500",
    "website": "https://www.bmw.co.za/vereeniging",
    "coords": {
      "lat": -26.661861419677734,
      "lng": 27.9341983795166
    }
  },
  {
    "id": "26582_1",
    "name": "BMW Bedfordview",
    "country": "ZA",
    "city": "Bruma",
    "address": "8 Kings Road, Bedfordview, 2008 Bruma",
    "email": "info@bmwbedfordview.co.za",
    "phone": "+27-11-2010000",
    "website": "https://www.bmw.co.za/bedfordview",
    "coords": {
      "lat": -26.173444747924805,
      "lng": 28.133028030395508
    }
  },
  {
    "id": "45849_1",
    "name": "BMW Ballito",
    "country": "ZA",
    "city": "Ballito",
    "address": "5 Moffat Dr, Ballito, Business Park, 4420 Ballito",
    "email": "bmwballito@smg.co.za",
    "phone": "+27-32-9465300",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_ballito.html",
    "coords": {
      "lat": -29.5216064453125,
      "lng": 31.19736099243164
    }
  },
  {
    "id": "08384_4",
    "name": "BMW Nelson Mandela Bay",
    "country": "ZA",
    "city": "Gqeberha",
    "address": "6 Ring Road, 6045 Gqeberha",
    "email": "LST-ZA-3701-BMWNMB@cfao.com",
    "phone": "+27-41-5022247",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_nelson_mandela_bay.html",
    "coords": {
      "lat": -33.949649810791016,
      "lng": 25.58241081237793
    }
  },
  {
    "id": "26582_2",
    "name": "BMW Sandton",
    "country": "ZA",
    "city": "Johannesburg",
    "address": "Corner Rivonia and South Road, 2146 Johannesburg",
    "email": "info@sandtonbmw.co.za",
    "phone": "+27-11-6766600",
    "website": "https://www.bmw.co.za/sandton",
    "coords": {
      "lat": -26.0928897857666,
      "lng": 28.056900024414062
    }
  },
  {
    "id": "31954_4",
    "name": "BMW Polokwane",
    "country": "ZA",
    "city": "Polokwane",
    "address": "Corner Clivicola and Buffalo Thorn, 0699 Polokwane",
    "email": "info@bmw-polokwane.co.za",
    "phone": "+27-15-2998500",
    "website": "https://www.bmw.co.za/polokwane",
    "coords": {
      "lat": -23.888050079345703,
      "lng": 29.49550437927246
    }
  },
  {
    "id": "09616_1",
    "name": "BMW Stellenbosch",
    "country": "ZA",
    "city": "Stellenbosch",
    "address": "Corner  R44 and Webers Valley Road, 7600 Stellenbosch",
    "email": "info@donford.co.za",
    "phone": "+27-21-8884200",
    "website": "https://www.bmw.co.za/stellenbosch",
    "coords": {
      "lat": -33.97592544555664,
      "lng": 18.84255027770996
    }
  },
  {
    "id": "10237_7",
    "name": "BMW George",
    "country": "ZA",
    "city": "George",
    "address": "1 Blueview Drive, Eden Meander, 6530 George",
    "email": "kelly.byles@bmwgeorge.co.za",
    "phone": "+27-44-8017900",
    "website": "https://www.bmw.co.za/george",
    "coords": {
      "lat": -33.98086166381836,
      "lng": 22.496719360351562
    }
  },
  {
    "id": "43760_1",
    "name": "BMW Pinetown",
    "country": "ZA",
    "city": "Pinetown",
    "address": "6 Kirk Road, New Germany, 3600 Pinetown",
    "email": "concierge.ptn@supertechgroup.co.za",
    "phone": "+27-31-7020271",
    "website": "https://www.bmw.co.za/pinetown",
    "coords": {
      "lat": -29.812793731689453,
      "lng": 30.850749969482422
    }
  },
  {
    "id": "45850_2",
    "name": "Supertech Pietermaritzburg ARC",
    "country": "ZA",
    "city": "Pietermaritzburg",
    "address": "55 Boshoff Street, 3201 Pietermaritzburg",
    "email": "Selven@supertechgroup.co.za",
    "phone": "+27-33-4920567",
    "website": "http://www.bmw-supertechpietermaritzburg.co.za",
    "coords": {
      "lat": -29.594682693481445,
      "lng": 30.379030227661133
    }
  },
  {
    "id": "02980_2",
    "name": "Autobahn ARC",
    "country": "ZA",
    "city": "Spartan",
    "address": "8 Spartan Road, 1620 Spartan",
    "email": "harry.nieuwoudt@autobahnbmw.co.za",
    "phone": "+27-11-9743224",
    "website": "http://www.autobahnbmw.co.za/",
    "coords": {
      "lat": -26.117080688476562,
      "lng": 28.201820373535156
    }
  },
  {
    "id": "54441_2",
    "name": "BMW Fountains Circle",
    "country": "ZA",
    "city": "Pretoria",
    "address": "84 Harmony Street, Muckeneuk, 0001 Pretoria",
    "email": "info@bmwcenturion.co.za",
    "phone": "+27-12-0023702",
    "website": "https://www.bmw.co.za/centurion",
    "coords": {
      "lat": -25.763479232788086,
      "lng": 28.196054458618164
    }
  },
  {
    "id": "51003_3",
    "name": "BMW Cape Town City ARC",
    "country": "ZA",
    "city": "Foreshore",
    "address": "Crn Christian Barnard and Old Marin, 8001 Foreshore",
    "email": "reception@arc-autoatlantic.co.za",
    "phone": "+27-21-4027700",
    "website": "https://www.arc-autoatlantic.co.za",
    "coords": {
      "lat": -33.921199798583984,
      "lng": 18.432750701904297
    }
  },
  {
    "id": "54993_1",
    "name": "LMG Approved Repair Centre",
    "country": "ZA",
    "city": "Pretoria",
    "address": "535 Breed Street, 0159 Pretoria",
    "email": null,
    "phone": "+27-12-0301000",
    "website": null,
    "coords": {
      "lat": -25.680679321289062,
      "lng": 28.270179748535156
    }
  },
  {
    "id": "08384_3",
    "name": "BMW Fourways",
    "country": "ZA",
    "city": "Fourways",
    "address": "Corner Witkoppen  and Cedar Road, 2055 Fourways",
    "email": "info@cedarisle.co.za",
    "phone": "+27-010-2710714",
    "website": "https://www.bmw.co.za/fourways",
    "coords": {
      "lat": -26.012935638427734,
      "lng": 27.99690818786621
    }
  },
  {
    "id": "33519_1",
    "name": "BMW Century City",
    "country": "ZA",
    "city": "Cape Town",
    "address": "1 Century Way, Century City, 7441 Cape Town",
    "email": "smgcpt@smg.co.za",
    "phone": "+27-21-5256000",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_century_city.html",
    "coords": {
      "lat": -33.8927001953125,
      "lng": 18.504409790039062
    }
  },
  {
    "id": "09616_2",
    "name": "BMW Somerset West",
    "country": "ZA",
    "city": "Somerset West",
    "address": "10 Dynagel street, 7110 Somerset West",
    "email": "info@donford.co.za",
    "phone": "+27-21-8530080",
    "website": "https://www.bmw.co.za/somerset_west",
    "coords": {
      "lat": -34.08049011230469,
      "lng": 18.81831932067871
    }
  },
  {
    "id": "10304_1",
    "name": "BMW Bryanston",
    "country": "ZA",
    "city": "Johannesburg",
    "address": "Corner Ormonde and William Nicol, 2021 Johannesburg",
    "email": "info@jsn.co.za",
    "phone": "+27-11-7009000",
    "website": "https://www.bmw.co.za/bryanston",
    "coords": {
      "lat": -26.06365394592285,
      "lng": 28.023725509643555
    }
  },
  {
    "id": "33302_1",
    "name": "BMW Mbombela",
    "country": "ZA",
    "city": "Nelspruit",
    "address": "16 Naaldekoker Crescent, 1201 Nelspruit",
    "email": "reception.eastview@eastviewbmw.co.za",
    "phone": "+27-13-7576600",
    "website": "https://www.bmw.co.za/mbombela",
    "coords": {
      "lat": -25.435686111450195,
      "lng": 30.965084075927734
    }
  },
  {
    "id": "43760_7",
    "name": "BMW East London",
    "country": "ZA",
    "city": "East London",
    "address": "Cnr Pearce Street and 4th Avenue, 5241 East London",
    "email": "concierge.el@supertechgroup.co.za",
    "phone": "+27-43-7268730",
    "website": "https://www.bmw.co.za/east_london",
    "coords": {
      "lat": -32.99363327026367,
      "lng": 27.91304588317871
    }
  },
  {
    "id": "02979_1",
    "name": "BMW Secunda",
    "country": "ZA",
    "city": "Secunda",
    "address": "Cnr Walter Sisulu and Kiewiet Str, 2302 Secunda",
    "email": "pinnacleauto@pinnacleauto.co.za",
    "phone": "+27-17-6208000",
    "website": "https://www.bmw.co.za/secunda",
    "coords": {
      "lat": -26.513002395629883,
      "lng": 29.1728572845459
    }
  },
  {
    "id": "26582_4",
    "name": "BMW East Rand (Dalpark)",
    "country": "ZA",
    "city": "Brakpan",
    "address": "30 Pendoring Avenue, 1543 Brakpan",
    "email": "info@bmweastrand.co.za",
    "phone": "+27-10-1092000",
    "website": "https://www.bmw-eastrand.co.za",
    "coords": {
      "lat": -26.2479190826416,
      "lng": 28.320316314697266
    }
  },
  {
    "id": "28520_1",
    "name": "Ronil Auto",
    "country": "ZA",
    "city": "Maputo",
    "address": "1786 Avenida De Angola, 1246 Maputo",
    "email": "craig@ronil-auto.com",
    "phone": "+258-21-321300",
    "website": "http://www.bmw-ronilauto.co.za/",
    "coords": {
      "lat": -25.965858459472656,
      "lng": 32.579410552978516
    }
  },
  {
    "id": "43057_1",
    "name": "BMW Umhlanga",
    "country": "ZA",
    "city": "Umhlanga",
    "address": "Cnr Umhlanga Rocks Dr and Ncondo Pl, 4320 Umhlanga",
    "email": "smgumhlanga@smg.co.za",
    "phone": "+27-31-5029800",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_umhlanga.html",
    "coords": {
      "lat": -29.727275848388672,
      "lng": 31.073036193847656
    }
  },
  {
    "id": "43760_5",
    "name": "BMW Newcastle",
    "country": "ZA",
    "city": "Newcastle",
    "address": "1 Albert Wessels Drive, 2940 Newcastle",
    "email": "concierge.nn@supertechgroup.co.za",
    "phone": "+27-34-3126060",
    "website": "https://www.bmw.co.za/newcastle",
    "coords": {
      "lat": -27.76610565185547,
      "lng": 29.944135665893555
    }
  },
  {
    "id": "30773_4",
    "name": "Sandton BMW Approved Repair Centre",
    "country": "ZA",
    "city": "Wynberg",
    "address": "38 Andries Street, 2090 Wynberg",
    "email": "mark.corna@sandtonbmwarc.co.za",
    "phone": "+27-11-5318900",
    "website": "http://www.arc-sandton.co.za/",
    "coords": {
      "lat": -26.1085205078125,
      "lng": 28.078489303588867
    }
  },
  {
    "id": "10237_3",
    "name": "Sovereign ARC",
    "country": "ZA",
    "city": "Bloemfontein",
    "address": "Plot 90 Estoire, 9300 Bloemfontein",
    "email": "sovereign.arc@bmwdealer.co.za",
    "phone": "+27-51-4334773",
    "website": "http://www.arc-sovereign.co.za",
    "coords": {
      "lat": -29.157669067382812,
      "lng": 26.31719970703125
    }
  },
  {
    "id": "44643_2",
    "name": "SMG Tygervalley ARC",
    "country": "ZA",
    "city": "Cape Town",
    "address": "5 Jean Simonis Street, 7500 Cape Town",
    "email": "bruce.durham@smg.co.za",
    "phone": "+27-21-9396160",
    "website": "http://www.arc-smgtygervalley.co.za/",
    "coords": {
      "lat": -33.906742095947266,
      "lng": 18.596363067626953
    }
  },
  {
    "id": "43057_2",
    "name": "SMG Umhlanga ARC",
    "country": "ZA",
    "city": "Durban",
    "address": "115 Flanders Avenue, 4300 Durban",
    "email": "naven.naidoo1@smg.co.za",
    "phone": "+27-31-5029800",
    "website": "http://www.arc-smgumhlanga.co.za/",
    "coords": {
      "lat": -29.843017578125,
      "lng": 31.03050422668457
    }
  },
  {
    "id": "21819_1",
    "name": "BMW Klerksdorp",
    "country": "ZA",
    "city": "Klerksdorp",
    "address": "60 Margaretha Prinsloo Street, 2570 Klerksdorp",
    "email": "ggh.reception@teamdaly.co.za",
    "phone": "+27-18-0111888",
    "website": "https://www.bmw.co.za/klerksdorp",
    "coords": {
      "lat": -26.86992073059082,
      "lng": 26.668209075927734
    }
  },
  {
    "id": "26582_3",
    "name": "BMW East Rand (Boksburg)",
    "country": "ZA",
    "city": "Boksburg",
    "address": "126 North Rand road, 1459 Boksburg",
    "email": "info@bmweastrand.co.za",
    "phone": "+27-11-4183300",
    "website": "https://www.bmw.co.za/east_rand",
    "coords": {
      "lat": -26.17822265625,
      "lng": 28.251230239868164
    }
  },
  {
    "id": "31954_3",
    "name": "BMW Rustenburg",
    "country": "ZA",
    "city": "Rustenburg",
    "address": "Corner 4th Ave and R24, 0299 Rustenburg",
    "email": "info@bmw-rustenburg.co.za",
    "phone": "+27-14-5372308",
    "website": "https://www.bmw.co.za/rustenburg",
    "coords": {
      "lat": -25.704177856445312,
      "lng": 27.256317138671875
    }
  },
  {
    "id": "08384_2",
    "name": "Northcliff Auto ARC",
    "country": "ZA",
    "city": "Randburg",
    "address": "1 High View Boulevard, High View, 2194 Randburg",
    "email": "patrick.jansen2@northcliffbmw.co.za",
    "phone": "+27-11-7963700",
    "website": "http://www.arc-northcliffauto.co.za",
    "coords": {
      "lat": -26.070926666259766,
      "lng": 27.97665023803711
    }
  },
  {
    "id": "21730_1",
    "name": "BMW Midrand",
    "country": "ZA",
    "city": "Midrand",
    "address": "Cnr Allandale Rd and Pretorius Rd, 1685 Midrand",
    "email": "info@abmbmw.co.za",
    "phone": "+27-11-6974700",
    "website": "https://www.bmw.co.za/midrand",
    "coords": {
      "lat": -26.01115608215332,
      "lng": 28.109102249145508
    }
  },
  {
    "id": "23228_1",
    "name": "BMW Welkom",
    "country": "ZA",
    "city": "Welkom",
    "address": "Cnr Stateway and Tempest Road, 9459 Welkom",
    "email": "loraine.parodi@parkwelkom.co.za",
    "phone": "+27-57-3532785",
    "website": "https://www.bmw.co.za/welkom",
    "coords": {
      "lat": -27.978864669799805,
      "lng": 26.732868194580078
    }
  },
  {
    "id": "43760_3",
    "name": "BMW Durban South",
    "country": "ZA",
    "city": "Rossburgh",
    "address": "8 Cliff Crescent, 4094 Rossburgh",
    "email": "concierge.dbn@supertechgroup.co.za",
    "phone": "+27-31-4651981",
    "website": "https://www.bmw.co.za/durban_south",
    "coords": {
      "lat": -29.880041122436523,
      "lng": 30.961502075195312
    }
  },
  {
    "id": "52187_1",
    "name": "BMW Driving Experience",
    "country": "ZA",
    "city": "Midrand",
    "address": "Simlak Drive, 1685 Midrand",
    "email": null,
    "phone": "+27-86-1269374",
    "website": null,
    "coords": {
      "lat": -26.018430709838867,
      "lng": 28.106760025024414
    }
  },
  {
    "id": "51003_2",
    "name": "BMW Constantia",
    "country": "ZA",
    "city": "Claremont",
    "address": "215 Main Road, 7708 Claremont",
    "email": "bmwconstantia@smg.co.za",
    "phone": "+27-21-6701100",
    "website": "https://www.bmw.co.za/bmw_constantia",
    "coords": {
      "lat": -33.98295974731445,
      "lng": 18.46600914001465
    }
  },
  {
    "id": "09620_1",
    "name": "BMW Paarlberg",
    "country": "ZA",
    "city": "Paarl",
    "address": "199 Main Street, 7646 Paarl",
    "email": "simonne.dahl@paarlbergbmw.co.za",
    "phone": "+27-21-8722076",
    "website": "https://www.bmw.co.za/paarlberg",
    "coords": {
      "lat": -33.740726470947266,
      "lng": 18.96283531188965
    }
  },
  {
    "id": "10237_5",
    "name": "BMW Kimberley",
    "country": "ZA",
    "city": "Kimberley",
    "address": "110 Long Street, 8301 Kimberley",
    "email": "dmarais@motus.co.za",
    "phone": "+27-53-8323194",
    "website": "https://www.bmw.co.za/kimberley",
    "coords": {
      "lat": -28.74408721923828,
      "lng": 24.748821258544922
    }
  },
  {
    "id": "09613_2",
    "name": "BMW Centurion",
    "country": "ZA",
    "city": "Pretoria",
    "address": "2023 Lenchen Avenue South, 0157 Pretoria",
    "email": "info@bmwcenturion.co.za",
    "phone": "+27-12-0023702",
    "website": "https://www.bmw.co.za/centurion",
    "coords": {
      "lat": -25.860960006713867,
      "lng": 28.188480377197266
    }
  },
  {
    "id": "21819_2",
    "name": "Service Fast Lane [Potchefstroom]",
    "country": "ZA",
    "city": "Potchefstroom",
    "address": "66 Walter Sisulu lane, 2520 Potchefstroom",
    "email": "ggh.reception@teamdaly.co.za",
    "phone": "+27-18-0111888",
    "website": "https://www.bmw.co.za/klerksdorp",
    "coords": {
      "lat": -26.708539962768555,
      "lng": 27.097679138183594
    }
  },
  {
    "id": "08384_1",
    "name": "BMW Northcliff",
    "country": "ZA",
    "city": "Johannesburg",
    "address": "11 Cresta Lane, Randburg, 2194 Johannesburg",
    "email": "northcliffauto@northcliffbmw.co.za",
    "phone": "+27-11-7729800",
    "website": "https://www.bmw.co.za/northcliff",
    "coords": {
      "lat": -26.12710952758789,
      "lng": 27.972530364990234
    }
  },
  {
    "id": "09613_1",
    "name": "BMW Fountains Circle",
    "country": "ZA",
    "city": "Pretoria",
    "address": "84 Harmony Street, Muckleneuk, 0002 Pretoria",
    "email": "clubfountains@bmwdealer.co.za",
    "phone": "+27-12-0022149",
    "website": "https://www.bmw.co.za/fountains_circle",
    "coords": {
      "lat": -25.763479232788086,
      "lng": 28.196054458618164
    }
  },
  {
    "id": "09660_1",
    "name": "Capital BMW",
    "country": "ZA",
    "city": "Gaborone, Botswana",
    "address": "1279 Old Lobatse Road, 2000 Gaborone, Botswana",
    "email": "khalil.arbi@capitalmotorsbw.com",
    "phone": "+267-3951913",
    "website": "http://www.bmw-capitalmotors.co.za/",
    "coords": {
      "lat": -24.674942016601562,
      "lng": 25.906404495239258
    }
  },
  {
    "id": "23389_1",
    "name": "BMW Joburg South",
    "country": "ZA",
    "city": "Johannesburg",
    "address": "Corner Oak and Middle Lane, 2196 Johannesburg",
    "email": "info@autoglenbmw.co.za",
    "phone": "+27-11-6814100",
    "website": "https://www.bmw.co.za/joburg_south",
    "coords": {
      "lat": -26.263782501220703,
      "lng": 28.058805465698242
    }
  },
  {
    "id": "27191_1",
    "name": "BMW Durban City",
    "country": "ZA",
    "city": "Durban",
    "address": "41 Somtseu Road, 4001 Durban",
    "email": "smgdurban@smg.co.za",
    "phone": "+27-31-3145300",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_durban_city.html",
    "coords": {
      "lat": -29.84532928466797,
      "lng": 31.030439376831055
    }
  },
  {
    "id": "44643_1",
    "name": "BMW Tygervalley",
    "country": "ZA",
    "city": "Cape Town",
    "address": "1 Pasita Road, 7530 Cape Town",
    "email": "smgtygervalley@smg.co.za",
    "phone": "+27-21-9188700",
    "website": "https://www.bmw.co.za/en/retailers-pages/bmw_tygervalley.html",
    "coords": {
      "lat": -33.86983871459961,
      "lng": 18.639678955078125
    }
  },
  {
    "id": "10237_1",
    "name": "BMW Bloemfontein",
    "country": "ZA",
    "city": "Bloemfontein",
    "address": "52 Zastron street, 9301 Bloemfontein",
    "email": "EDeBeer@SovereignBMW.co.za",
    "phone": "+27-51-4000000",
    "website": "https://www.bmw.co.za/bloemfontein",
    "coords": {
      "lat": -29.113059997558594,
      "lng": 26.221900939941406
    }
  },
  {
    "id": "45848_1",
    "name": "BMW West Rand",
    "country": "ZA",
    "city": "Little Falls",
    "address": "Corner Shearwater rd and Cannet, 1724 Little Falls",
    "email": "clearwater@bmwclearwater.co.za",
    "phone": "+27-11-7613500",
    "website": "https://www.bmw.co.za/west_rand",
    "coords": {
      "lat": -26.107830047607422,
      "lng": 27.883769989013672
    }
  },
  {
    "id": "31954_1",
    "name": "BMW Montana",
    "country": "ZA",
    "city": "Pretoria",
    "address": "501 Breedt Street, 0159 Pretoria",
    "email": "info@bmw-montana.co.za",
    "phone": "+27-12-5233600",
    "website": "https://www.bmw.co.za/montana",
    "coords": {
      "lat": -25.68140983581543,
      "lng": 28.277090072631836
    }
  },
  {
    "id": "54441_4",
    "name": "Club Motors Fountains ARC",
    "country": "ZA",
    "city": "Gezina",
    "address": "629 Voortrekker Road, 0083 Gezina",
    "email": "Lesego.Mdawo@bwmr.co.za",
    "phone": "+27-12-3352522",
    "website": "https://www.arc-clubmotorsfountains.co.za",
    "coords": {
      "lat": -25.71308135986328,
      "lng": 28.20117950439453
    }
  },
  {
    "id": "54441_1",
    "name": "BMW Centurion",
    "country": "ZA",
    "city": "Pretoria",
    "address": "2023 Lenchen Avenue South, 0157 Pretoria",
    "email": "info@bmwcenturion.co.za",
    "phone": "+27-12-0023702",
    "website": "https://www.bmw.co.za/centurion",
    "coords": {
      "lat": -25.860960006713867,
      "lng": 28.188480377197266
    }
  },
  {
    "id": "21730_3",
    "name": "Auto Body Specialists",
    "country": "ZA",
    "city": "Midrand",
    "address": "989 Richards Drive, 1685 Midrand",
    "email": "info@abmbmw.co.za",
    "phone": "+27-11-6974700",
    "website": "http://www.autobavariamidrand.co.za",
    "coords": {
      "lat": -26.013450622558594,
      "lng": 28.12196922302246
    }
  },
  {
    "id": "46199_2",
    "name": "SMG North Coast ARC",
    "country": "ZA",
    "city": "Richards Bay",
    "address": "2 Bauxite Bay, 3900 Richards Bay",
    "email": "jon.carpede@bmwdealer.co.za",
    "phone": "+27-35-4260020",
    "website": "http://smg.co.za/smg-north-coast-auto-repair-centre/",
    "coords": {
      "lat": -28.754287719726562,
      "lng": 32.02516174316406
    }
  },
  {
    "id": "09616_3",
    "name": "Donford ARC",
    "country": "ZA",
    "city": "Strand",
    "address": "16 Mynhardt Street, 7140 Strand",
    "email": "henre.hanekom@donford.co.za",
    "phone": "+27-21-8549235",
    "website": "http://www.donford.co.za",
    "coords": {
      "lat": -34.094871520996094,
      "lng": 18.8414249420166
    }
  },
  {
    "id": "02485_2",
    "name": "BMW Durban South ARC",
    "country": "ZA",
    "city": "Durban",
    "address": "359 South Coast Road, 4094 Durban",
    "email": "selven@supertechgroup.co.za",
    "phone": "+27-31-4651981",
    "website": "https://www.arc-supertechdurban.co.za",
    "coords": {
      "lat": -29.9066219329834,
      "lng": 30.98058319091797
    }
  },
  {
    "id": "27191_2",
    "name": "SMG Durban ARC",
    "country": "ZA",
    "city": "Briardene",
    "address": "11-12 Marseilles Crescent, 4501 Briardene",
    "email": "hennie.coetzer@smg.co.za",
    "phone": "+27-31-5601300",
    "website": "http://www.arc-smgdurban.co.za/",
    "coords": {
      "lat": -29.794902801513672,
      "lng": 31.012258529663086
    }
  },
  {
    "id": "09633_3",
    "name": "Club Motors Fountains ARC",
    "country": "ZA",
    "city": "Gezina",
    "address": "629 Voortrekker Road, 0083 Gezina",
    "email": "Lesego.Mdawo@bwmr.co.za",
    "phone": "+27-12-3352522",
    "website": "http://www.arc-clubmotorsfountains.co.za",
    "coords": {
      "lat": -25.71308135986328,
      "lng": 28.20117950439453
    }
  },
  {
    "id": "31954_5",
    "name": "Montana ARC",
    "country": "ZA",
    "city": "Pretoria",
    "address": "501 Breedt Street,, 0159 Pretoria",
    "email": "kobus.mouton@lmg.co.za",
    "phone": "+27-12-5233600",
    "website": "http://www.bmw-zambesiauto.co.za",
    "coords": {
      "lat": -25.681224822998047,
      "lng": 28.271148681640625
    }
  },
  {
    "id": "47541_1",
    "name": "East Rand Approved Repair Centre",
    "country": "ZA",
    "city": "Brakpan",
    "address": "30 Pendoring Avenue, 1543 Brakpan",
    "email": "ricardo.pires@bmweastrand.co.za",
    "phone": "+27-10-1093000",
    "website": "http://www.arc.eastrand.co.za",
    "coords": {
      "lat": -26.2479190826416,
      "lng": 28.320316314697266
    }
  },
  {
    "id": "45176_1",
    "name": "BMW eMalahleni",
    "country": "ZA",
    "city": "Witbank",
    "address": "Route N4 Business Park, Corridor Cr, 1035 Witbank",
    "email": "eastview@eastviewbmw.co.za",
    "phone": "+27-13-6584400",
    "website": "https://www.bmw.co.za/emalahleni",
    "coords": {
      "lat": -25.887802124023438,
      "lng": 29.275737762451172
    }
  },
  {
    "id": "25921_1",
    "name": "Eurobike - Ribeirão Preto",
    "country": "BR",
    "city": "Ribeirão Preto",
    "address": "Av Wladimir Meirelles Ferreira,1600, 14021-630 Ribeirão Preto",
    "email": "marketing@eurobike.com.br",
    "phone": "+55-16-39657000",
    "website": "https://www.eurobikebmw.com.br/",
    "coords": {
      "lat": -21.210426330566406,
      "lng": -47.80149841308594
    }
  },
  {
    "id": "32007_5",
    "name": "Autostar - Nações Unidas",
    "country": "BR",
    "city": "São Paulo",
    "address": "Av. das Nações Unidas, 17381, 04730-090 São Paulo",
    "email": "vendas.bmw@autostar.com.br",
    "phone": "+55-11-56453000",
    "website": "https://bmw.autostar.com.br/",
    "coords": {
      "lat": -23.641822814941406,
      "lng": -46.724124908447266
    }
  },
  {
    "id": "41338_1",
    "name": "Saga - Goiânia",
    "country": "BR",
    "city": "Goiânia",
    "address": "Av Dep Jamel Cecílio, 1338, 74085-580 Goiânia",
    "email": "coordenadorqualidadebmw@gruposaga.com.br",
    "phone": "+55-62-31421248",
    "website": "https://www.sagabmw.com.br/",
    "coords": {
      "lat": -16.69781494140625,
      "lng": -49.25181579589844
    }
  },
  {
    "id": "41062_5",
    "name": "Iesa - Novo Hamburgo",
    "country": "BR",
    "city": "Novo Hamburgo",
    "address": "R. Ignácio Treis, 495, 93334-375 Novo Hamburgo",
    "email": "centralderelacionamento@grupoiesa.com.br",
    "phone": "+55-51-30253030",
    "website": "https://www.iesabmw.com.br/",
    "coords": {
      "lat": -29.71016502380371,
      "lng": -51.14705276489258
    }
  },
  {
    "id": "41062_1",
    "name": "Iesa - Caxias do Sul",
    "country": "BR",
    "city": "Caxias do Sul",
    "address": "Av. Rubem Bento Alves, 7.977, 95012-500 Caxias do Sul",
    "email": "centralderelacionamento@grupoiesa.com.br",
    "phone": "+55-54-30395220",
    "website": "https://www.iesabmw.com.br/",
    "coords": {
      "lat": -29.171411514282227,
      "lng": -51.21165084838867
    }
  },
  {
    "id": "25336_1",
    "name": "Euroville - Belo Horizonte",
    "country": "BR",
    "city": "Belo Horizonte",
    "address": "Av. Raja Gabaglia, 3.055, 30350-563 Belo Horizonte",
    "email": "euroville@eurovillebmw.com.br",
    "phone": "+55-31-33044100",
    "website": "https://eurovillebmw.com.br/bmw",
    "coords": {
      "lat": -19.961034774780273,
      "lng": -43.95726013183594
    }
  },
  {
    "id": "25336_8",
    "name": "Euroville Pós-Vendas - BH",
    "country": "BR",
    "city": "Belo Horizonte",
    "address": "Rua Geraldo Vasconcellos, 405, 30494-100 Belo Horizonte",
    "email": "euroville@eurovillebmw.com.br",
    "phone": "+55-31-35194100",
    "website": "https://eurovillebmw.com.br/bmw",
    "coords": {
      "lat": -19.958215713500977,
      "lng": -43.96405792236328
    }
  },
  {
    "id": "25336_10",
    "name": "Euroville - Juiz de Fora",
    "country": "BR",
    "city": "Juiz de Fora",
    "address": "Av. Deusdedith Salgado, 4900, 36033-000 Juiz de Fora",
    "email": "euroville@eurovillebmw.com.br",
    "phone": "+55-31-33044101",
    "website": "https://eurovillebmw.com.br/bmw",
    "coords": {
      "lat": -21.807531356811523,
      "lng": -43.376495361328125
    }
  },
  {
    "id": "25345_2",
    "name": "Top Car - Florianópolis",
    "country": "BR",
    "city": "Florianópolis",
    "address": "Rua Visconde de Cairu, 176, 88075-050 Florianópolis",
    "email": "atendimento@bmwtopcar.com.br",
    "phone": "+55-48-3027-5111",
    "website": "https://bmwtopcar.com.br/",
    "coords": {
      "lat": -27.59511375427246,
      "lng": -48.57316589355469
    }
  },
  {
    "id": "25345_12",
    "name": "Top Car - Balneário Camboriú",
    "country": "BR",
    "city": "Balneário Camboriú",
    "address": "Avenida do Estado Dalmo Vieira, 88338-635 Balneário Camboriú",
    "email": "atendimento@bmwtopcar.com.br",
    "phone": "+55-47-3228-5500",
    "website": "https://bmwtopcar.com.br/",
    "coords": {
      "lat": -26.961109161376953,
      "lng": -48.63982009887695
    }
  },
  {
    "id": "25352_8",
    "name": "Osten - Santos",
    "country": "BR",
    "city": "Santos",
    "address": "Rua da Constituição, 520, 11015-472 Santos",
    "email": "contato@ostengroup.com.br",
    "phone": "+55-13-32293333",
    "website": "https://bmwosten.com.br/",
    "coords": {
      "lat": -23.947368621826172,
      "lng": -46.323638916015625
    }
  },
  {
    "id": "32007_4",
    "name": "Euro Import - Joinville",
    "country": "BR",
    "city": "Joinville",
    "address": "Rua Botuverá, 508, 89214-110 Joinville",
    "email": "faleconosco@euroimport.com.br",
    "phone": "+55-47-33055100",
    "website": "https://www.euroimportbmw.com.br/",
    "coords": {
      "lat": -26.323633193969727,
      "lng": -48.8681755065918
    }
  },
  {
    "id": "41869_1",
    "name": "Isar Motors - Teresina",
    "country": "BR",
    "city": "Teresina",
    "address": "Avenida João XXIII, 4181, 64053-010 Teresina",
    "email": "guilherme.melo@isarbmw.com.br",
    "phone": "+55-86-21074488",
    "website": "https://www.isarbmw.com.br/bmw",
    "coords": {
      "lat": -5.080893039703369,
      "lng": -42.76158142089844
    }
  },
  {
    "id": "53178_1",
    "name": "Haus - Palmas",
    "country": "BR",
    "city": "Palmas",
    "address": "Q ACSU SO100 Av.Joaquim T. Segurado, 77018-380 Palmas",
    "email": "Andressanery@grupognc.com.br",
    "phone": "+55-63-99311-9493",
    "website": "https://www.hausmotors.com.br/bmw/",
    "coords": {
      "lat": -10.244407653808594,
      "lng": -48.33346176147461
    }
  },
  {
    "id": "25336_4",
    "name": "Euroville - Uberlândia",
    "country": "BR",
    "city": "Uberlândia",
    "address": "Av. João Naves de Ávila, 3.370, 38408-100 Uberlândia",
    "email": "euroville@eurovillebmw.com.br",
    "phone": "+55-34-32924100",
    "website": "https://eurovillebmw.com.br/bmw",
    "coords": {
      "lat": -18.92655372619629,
      "lng": -48.25912857055664
    }
  },
  {
    "id": "25336_11",
    "name": "Euroville - Uberaba",
    "country": "BR",
    "city": "Uberaba",
    "address": "Av. Fernando Costa, 200, 38022-300 Uberaba",
    "email": "euroville@eurovillebmw.com.br",
    "phone": "+55-31-33044100",
    "website": "https://eurovillebmw.com.br/bmw",
    "coords": {
      "lat": -19.763450622558594,
      "lng": -47.94203186035156
    }
  },
  {
    "id": "25348_1",
    "name": "Eurobike - Campinas",
    "country": "BR",
    "city": "Campinas",
    "address": "Av. Julio de Mesquita, 694, 13025-060 Campinas",
    "email": "eurobike@eurobike.com.br",
    "phone": "+55-19-32558788",
    "website": "https://www.eurobikebmw.com.br/bmw-campinas-eurobike",
    "coords": {
      "lat": -22.899452209472656,
      "lng": -47.05500030517578
    }
  },
  {
    "id": "32007_11",
    "name": "Autostar - Colômbia",
    "country": "BR",
    "city": "São Paulo",
    "address": "Rua Colômbia, 810, 01438-000 São Paulo",
    "email": "vendas.bmw@autostar.com.br",
    "phone": "+55-11-33728888",
    "website": "https://bmw.autostar.com.br/",
    "coords": {
      "lat": -23.5717830657959,
      "lng": -46.67459487915039
    }
  },
  {
    "id": "32008_1",
    "name": "Euro Import - Londrina",
    "country": "BR",
    "city": "Londrina",
    "address": "Av. Tiradentes, 5.665, 86072-000 Londrina",
    "email": "faleconosco@euroimport.com.br",
    "phone": "+55-43-33799800",
    "website": "https://www.euroimportbmw.com.br/",
    "coords": {
      "lat": -23.2904052734375,
      "lng": -51.220489501953125
    }
  },
  {
    "id": "35282_1",
    "name": "Braga Motors - Manaus",
    "country": "BR",
    "city": "Manaus",
    "address": "Av. Djalma Batista, 3.500 C,, 69050-010 Manaus",
    "email": "marketing@bragamotors.com.br",
    "phone": "+55-92-33216000",
    "website": "http://www.bmw.com.br/braga-motors",
    "coords": {
      "lat": -3.085019111633301,
      "lng": -60.024253845214844
    }
  },
  {
    "id": "40484_3",
    "name": "Haus - Maceió",
    "country": "BR",
    "city": "Maceió",
    "address": "Av. Comendador Gustavo Paiva, 5132, 57038-000 Maceió",
    "email": "SaraAlmeida@grupognc.com.br",
    "phone": "+55-82-40091820",
    "website": "https://www.hausmotors.com.br/bmw/",
    "coords": {
      "lat": -9.634466171264648,
      "lng": -35.701900482177734
    }
  },
  {
    "id": "40998_2",
    "name": "Grand Brasil - Alphaville",
    "country": "BR",
    "city": "Barueri",
    "address": "Alameda Tocantins, 855, 06455-020 Barueri",
    "email": "crc@grandbrasil.com.br",
    "phone": "+55-11-38837147",
    "website": "http://www.bmw.com.br/grand-brasil",
    "coords": {
      "lat": -23.50258445739746,
      "lng": -46.85645294189453
    }
  },
  {
    "id": "41397_1",
    "name": "Raviera - Campo Grande",
    "country": "BR",
    "city": "Campo Grande",
    "address": "Rua Ceará, 100, 79040-000 Campo Grande",
    "email": "faleconosco@ravieramotors.com.br",
    "phone": "+55-67-40097000",
    "website": "https://ravieramotors.com.br/",
    "coords": {
      "lat": -20.466733932495117,
      "lng": -54.5907096862793
    }
  },
  {
    "id": "44866_1",
    "name": "PG Prime - João Pessoa",
    "country": "BR",
    "city": "Cabedelo",
    "address": "Rodovia BR 230, KM 13, 58310-000 Cabedelo",
    "email": "agendamento1@pgprime.com.br",
    "phone": "+55-83-31941800",
    "website": "https://pgprimebmw.com.br/bmw-pb",
    "coords": {
      "lat": -7.080639362335205,
      "lng": -34.84923553466797
    }
  },
  {
    "id": "49124_2",
    "name": "BM Belém",
    "country": "BR",
    "city": "Belém",
    "address": "Tv. Dom Pedro I, 353, 66050-100 Belém",
    "email": "contato@bmbelem.com.br",
    "phone": "+55-91-32055030",
    "website": "https://bmw.bmbelem.com.br/",
    "coords": {
      "lat": -1.4357640743255615,
      "lng": -48.49104690551758
    }
  },
  {
    "id": "49124_4",
    "name": "BM Vitória",
    "country": "BR",
    "city": "Vitória",
    "address": "Av. Fernando Ferrari, 250, 29060-220 Vitória",
    "email": "clientes@bmvitoria.com.br",
    "phone": "+55-27-31831830",
    "website": "https://bmw.bmvitoria.com.br/",
    "coords": {
      "lat": -20.284751892089844,
      "lng": -40.302330017089844
    }
  },
  {
    "id": "49124_5",
    "name": "BM Vitória Pós-Vendas",
    "country": "BR",
    "city": "Vitória",
    "address": "Avenida Leitão da Silva, 1873, 29045-974 Vitória",
    "email": "clientes@bmvitoria.com.br",
    "phone": "+55-27-31831830",
    "website": "https://bmw.bmvitoria.com.br/",
    "coords": {
      "lat": -20.29872703552246,
      "lng": -40.304283142089844
    }
  },
  {
    "id": "40484_1",
    "name": "Haus - Salvador",
    "country": "BR",
    "city": "Salvador",
    "address": "Av. Luís Viana, 13091, 41500-300 Salvador",
    "email": "aurivalterjr@gruponewchase.com.br",
    "phone": "+55-71-35055550",
    "website": "https://www.hausmotors.com.br/bmw/",
    "coords": {
      "lat": -12.920665740966797,
      "lng": -38.35686111450195
    }
  },
  {
    "id": "40568_3",
    "name": "Germânica - Piracicaba",
    "country": "BR",
    "city": "Piracicaba",
    "address": "Av Dr Cassio Paschoal Padovani,1300, 13420-360 Piracicaba",
    "email": "objetivos_vendas.germanicapiracicaba@germanicabmw.com.br",
    "phone": "+55-19-31244200",
    "website": "https://www.germanicabmw.com.br/",
    "coords": {
      "lat": -22.729934692382812,
      "lng": -47.61481857299805
    }
  },
  {
    "id": "40568_1",
    "name": "Germânica - Sorocaba",
    "country": "BR",
    "city": "Sorocaba",
    "address": "Av. Antonio Bardella, 1.600, 18085-852 Sorocaba",
    "email": "mdeniz@germanicabmw.com.br",
    "phone": "+55-15-33330900",
    "website": "https://www.germanicabmw.com.br/",
    "coords": {
      "lat": -23.472440719604492,
      "lng": -47.423500061035156
    }
  },
  {
    "id": "25345_11",
    "name": "Top Car - Criciúma",
    "country": "BR",
    "city": "Criciúma",
    "address": "Rua Coronel Marcos Rovaris, 281, 88801-100 Criciúma",
    "email": "atendimento@bmwtopcar.com.br",
    "phone": "+55-48-3801-3000",
    "website": "https://bmwtopcar.com.br/",
    "coords": {
      "lat": -28.678112030029297,
      "lng": -49.365726470947266
    }
  },
  {
    "id": "25352_2",
    "name": "Osten - Tatuapé",
    "country": "BR",
    "city": "São Paulo",
    "address": "Rua Itapura, 1078, 03310-000 São Paulo",
    "email": "contato@ostengroup.com.br",
    "phone": "+55-11-20953300",
    "website": "https://bmwosten.com.br/",
    "coords": {
      "lat": -23.548294067382812,
      "lng": -46.565673828125
    }
  },
  {
    "id": "25352_6",
    "name": "Osten - São José dos Campos",
    "country": "BR",
    "city": "São José dos Campos",
    "address": "Av. Dr. Eduardo Cury, 220, 12242-001 São José dos Campos",
    "email": "contato@ostengroup.com.br",
    "phone": "+55-12-39288888",
    "website": "https://bmwosten.com.br/",
    "coords": {
      "lat": -23.202049255371094,
      "lng": -45.909080505371094
    }
  },
  {
    "id": "32007_12",
    "name": "Autostar - Vila Olímpia",
    "country": "BR",
    "city": "São Paulo",
    "address": "Rua Gomes de Carvalho, 421, 04547-002 São Paulo",
    "email": "vendas.bmw@autostar.com.br",
    "phone": "+55-11-30588888",
    "website": "https://bmw.autostar.com.br/",
    "coords": {
      "lat": -23.600555419921875,
      "lng": -46.67796325683594
    }
  },
  {
    "id": "41062_4",
    "name": "Iesa - Porto Alegre",
    "country": "BR",
    "city": "Porto Alegre",
    "address": "Av.Senador Tarso Dutra, 295, 90690-140 Porto Alegre",
    "email": "centralderelacionamento@grupoiesa.com.br",
    "phone": "+55-51-30253000",
    "website": "https://www.iesabmw.com.br/",
    "coords": {
      "lat": -30.041135787963867,
      "lng": -51.1734504699707
    }
  },
  {
    "id": "25349_1",
    "name": "Agulhas Negras - SBC",
    "country": "BR",
    "city": "São Bernardo do Campo",
    "address": "Av. Dr. Rudge Ramos, 837, 09639-000 São Bernardo do Campo",
    "email": "marketing@agulhasnegras.com.br",
    "phone": "+55-11-41228222",
    "website": "https://www.bmwagulhasnegras.com.br/",
    "coords": {
      "lat": -23.649932861328125,
      "lng": -46.57768630981445
    }
  },
  {
    "id": "25921_19",
    "name": "Eurobike - Brasília",
    "country": "BR",
    "city": "Brasília",
    "address": "EPAR - Antigo Terminal 2, 71608-900 Brasília",
    "email": "marketing@eurobike.com.br",
    "phone": "+55-16-39657000",
    "website": "https://www.eurobikebmw.com.br/",
    "coords": {
      "lat": -15.869841575622559,
      "lng": -47.931297302246094
    }
  },
  {
    "id": "37061_3",
    "name": "Sael - Recife",
    "country": "BR",
    "city": "Recife",
    "address": "Av. Mal Mascarenhas de Morais 1860, 51170-000 Recife",
    "email": "contato@sael.com.br",
    "phone": "+55-81-21284567",
    "website": "https://www.sael.com.br/bmw/",
    "coords": {
      "lat": -8.100852012634277,
      "lng": -34.910404205322266
    }
  },
  {
    "id": "41062_8",
    "name": "Iesa - Passo Fundo",
    "country": "BR",
    "city": "Passo Fundo",
    "address": "Av. Brasil Oeste, 3880, 99030-284 Passo Fundo",
    "email": "centralderelacionamento@grupoiesa.com.br",
    "phone": "+55-51-30253000",
    "website": "https://www.iesabmw.com.br/",
    "coords": {
      "lat": -28.26953887939453,
      "lng": -52.440486907958984
    }
  },
  {
    "id": "25348_2",
    "name": "Eurobike Campinas Motorrad/Serviços",
    "country": "BR",
    "city": "Campinas",
    "address": "Rua Carolina Florence, 437, 13073-225 Campinas",
    "email": "mbimotors@mbimotors.com.br",
    "phone": "+55-19-32419699",
    "website": "https://www.eurobikebmw.com.br/bmw-campinas-eurobike",
    "coords": {
      "lat": -22.885208129882812,
      "lng": -47.062259674072266
    }
  },
  {
    "id": "25349_4",
    "name": "Agulhas Negras - 23 de Maio",
    "country": "BR",
    "city": "São Paulo",
    "address": "Av. 23 de Maio, 3.033, 04008-090 São Paulo",
    "email": "marketing@agulhasnegras.com.br",
    "phone": "+55-11-32542929",
    "website": "https://www.bmwagulhasnegras.com.br/",
    "coords": {
      "lat": -23.58252716064453,
      "lng": -46.65143585205078
    }
  },
  {
    "id": "25352_5",
    "name": "Osten Pós-Vendas - Barra Funda",
    "country": "BR",
    "city": "São Paulo",
    "address": "Av. Ordem e Progresso, 247, 01141-030 São Paulo",
    "email": "contato@ostengroup.com.br",
    "phone": "+55-11-36125959",
    "website": "https://bmwosten.com.br/",
    "coords": {
      "lat": -23.518165588378906,
      "lng": -46.66807174682617
    }
  },
  {
    "id": "41397_3",
    "name": "Raviera - Dourados",
    "country": "BR",
    "city": "Dourados",
    "address": "Avenida Marcelino Pires, 5110, 79840-630 Dourados",
    "email": "faleconosco@ravieramotors.com.br",
    "phone": "+55-67-30339530",
    "website": "https://ravieramotors.com.br/",
    "coords": {
      "lat": -22.224353790283203,
      "lng": -54.77830123901367
    }
  },
  {
    "id": "43371_1",
    "name": "Euro Motors - Rio Preto",
    "country": "BR",
    "city": "São José do Rio Preto",
    "address": "Av Pres Juscelino Kubitschek, 3.600, 15093-225 São José do Rio Preto",
    "email": "contato@grupoeuromotors.com.br",
    "phone": "+55-17-32017200",
    "website": "https://www.euromotors.com.br/bmw/",
    "coords": {
      "lat": -20.853641510009766,
      "lng": -49.413841247558594
    }
  },
  {
    "id": "44866_3",
    "name": "PG Prime - Natal",
    "country": "BR",
    "city": "Natal",
    "address": "Av. Dão Silveira, 3712 - Lote A, 59066-180 Natal",
    "email": "agendamento1@pgprime.com.br",
    "phone": "+55-84-3344-9744",
    "website": "https://pgprimebmw.com.br/bmw-rn",
    "coords": {
      "lat": -5.852916240692139,
      "lng": -35.21089172363281
    }
  },
  {
    "id": "50862_1",
    "name": "Euro Motors - Jundiaí",
    "country": "BR",
    "city": "Jundiaí",
    "address": "Avenida Prefeito Luis Latorre, 4501, 13209-430 Jundiaí",
    "email": "contato@grupoeuromotors.com.br",
    "phone": "+55-017-3354-1300",
    "website": "https://www.bmw.com.br/euro-motors",
    "coords": {
      "lat": -23.176530838012695,
      "lng": -46.905738830566406
    }
  },
  {
    "id": "25345_10",
    "name": "Top Car - Chapecó",
    "country": "BR",
    "city": "Chapecó",
    "address": "Av. Getúlio Dorneles Vargas, 3066-N, 89801-000 Chapecó",
    "email": "atendimento@bmwtopcar.com.br",
    "phone": "+55-49-3981-1000",
    "website": "https://bmwtopcar.com.br/",
    "coords": {
      "lat": -27.07797622680664,
      "lng": -52.62158203125
    }
  },
  {
    "id": "41442_2",
    "name": "Barigui - Ponta Grossa",
    "country": "BR",
    "city": "Ponta Grossa",
    "address": "Avenida Dom Pedro II, 270, 84053-000 Ponta Grossa",
    "email": "barigui@bmwbarigui.com.br",
    "phone": "+55-44-30273500",
    "website": "https://www.bmwbarigui.com.br/",
    "coords": {
      "lat": -25.085872650146484,
      "lng": -50.17793273925781
    }
  },
  {
    "id": "25345_1",
    "name": "Top Car - Blumenau",
    "country": "BR",
    "city": "Blumenau",
    "address": "Rua Herman Huscher, 729, 89023-000 Blumenau",
    "email": "atendimento@bmwtopcar.com.br",
    "phone": "+55-47-3036-5111",
    "website": "https://bmwtopcar.com.br/",
    "coords": {
      "lat": -26.935604095458984,
      "lng": -49.06770324707031
    }
  },
  {
    "id": "32007_2",
    "name": "Euro Import - Curitiba",
    "country": "BR",
    "city": "Curitiba",
    "address": "Rua Tobias de Macedo Junior, 217, 82010-340 Curitiba",
    "email": "faleconosco@euroimport.com.br",
    "phone": "+55-41-32139800",
    "website": "https://www.euroimportbmw.com.br/",
    "coords": {
      "lat": -25.430692672729492,
      "lng": -49.32390594482422
    }
  },
  {
    "id": "49124_3",
    "name": "BM Rio Pós-Vendas",
    "country": "BR",
    "city": "Rio de Janeiro",
    "address": "Rua Equador, 94, 20220-410 Rio de Janeiro",
    "email": "contato@bmwrio.com.br",
    "phone": "+55-21-20424442",
    "website": "https://bmwrio.com.br/home",
    "coords": {
      "lat": -22.89676856994629,
      "lng": -43.20200729370117
    }
  },
  {
    "id": "25332_1",
    "name": "Autokraft",
    "country": "BR",
    "city": "Rio de Janeiro",
    "address": "Av. das Américas, 1.690, 22640-101 Rio de Janeiro",
    "email": "vendas@grupoautokraft.com.br",
    "phone": "+55-21-31399000",
    "website": "https://www.autokraft-bmw.com.br/bmw",
    "coords": {
      "lat": -23.000452041625977,
      "lng": -43.331695556640625
    }
  },
  {
    "id": "35262_4",
    "name": "Munique Motors - Porto Velho",
    "country": "BR",
    "city": "Porto Velho",
    "address": "Av. Governador Jorge Teixeira 1.473, 76804-017 Porto Velho",
    "email": "recepcao@bmwmunique.com.br",
    "phone": "+55-69-32233603",
    "website": "https://www.bmwmuniquemotors.com.br/",
    "coords": {
      "lat": -8.756999969482422,
      "lng": -63.88652420043945
    }
  },
  {
    "id": "40998_1",
    "name": "Grand Brasil - Gastão Vidigal",
    "country": "BR",
    "city": "São Paulo",
    "address": "Av. Dr. Gastão Vidigal, 1.357, 05314-000 São Paulo",
    "email": "crc@grandbrasil.com.br",
    "phone": "+55-11-38837147",
    "website": "http://www.bmw.com.br/grand-brasil",
    "coords": {
      "lat": -23.52987289428711,
      "lng": -46.73786926269531
    }
  },
  {
    "id": "41442_1",
    "name": "Barigui - Maringá",
    "country": "BR",
    "city": "Maringá",
    "address": "Rua Rubens Sebastião Marin, 1626, 87045-020 Maringá",
    "email": "barigui@bmwbarigui.com.br",
    "phone": "+55-44-30273500",
    "website": "https://www.bmwbarigui.com.br/",
    "coords": {
      "lat": -23.42422866821289,
      "lng": -51.8995475769043
    }
  },
  {
    "id": "53178_2",
    "name": "Haus - Aracaju",
    "country": "BR",
    "city": "Aracaju",
    "address": "Av. Min. Geraldo Barreto Sobral,120, 49027-255 Aracaju",
    "email": "Andressanery@grupognc.com.br",
    "phone": "+55-79-98836-4243",
    "website": "https://www.hausmotors.com.br/bmw/",
    "coords": {
      "lat": -10.941473007202148,
      "lng": -37.059993743896484
    }
  },
  {
    "id": "25352_4",
    "name": "Osten - Sumaré",
    "country": "BR",
    "city": "São Paulo",
    "address": "Av. Sumaré, 810, 05016-110 São Paulo",
    "email": "contato@ostengroup.com.br",
    "phone": "+55-11-38685577",
    "website": "https://bmwosten.com.br/",
    "coords": {
      "lat": -23.536420822143555,
      "lng": -46.67439270019531
    }
  },
  {
    "id": "32007_15",
    "name": "Original - São Luís",
    "country": "BR",
    "city": "São Luís",
    "address": "Avenida dos Holandeses, 11, 65071-380 São Luís",
    "email": "ana.eidan@originalautos.com.br",
    "phone": "+55-98-31942525",
    "website": "https://www.originalbmw.com.br/",
    "coords": {
      "lat": -2.488759994506836,
      "lng": -44.24811935424805
    }
  },
  {
    "id": "49124_1",
    "name": "BM Rio",
    "country": "BR",
    "city": "Rio de Janeiro",
    "address": "Rua Mena Barreto 161, 22271-100 Rio de Janeiro",
    "email": "contato@bmwrio.com.br",
    "phone": "+55-21-20424442",
    "website": "https://bmwrio.com.br/home",
    "coords": {
      "lat": -22.956336975097656,
      "lng": -43.19107437133789
    }
  },
  {
    "id": "32008_2",
    "name": "Euro Import - Cascavel",
    "country": "BR",
    "city": "Cascavel",
    "address": "Av. Brasil, 2542, 85816-294 Cascavel",
    "email": "giovani.brustolin@eurobmw.com.br",
    "phone": "+55-45-32268800",
    "website": "https://www.euroimportbmw.com.br/",
    "coords": {
      "lat": -24.950485229492188,
      "lng": -53.425289154052734
    }
  },
  {
    "id": "40484_2",
    "name": "Haus - Fortaleza",
    "country": "BR",
    "city": "Fortaleza",
    "address": "Avenida Rogaciano Leite,1033 - A, 60810-001 Fortaleza",
    "email": "saramendes@hausmotors.com.br",
    "phone": "+55-85-34014900",
    "website": "https://www.hausmotors.com.br/bmw/",
    "coords": {
      "lat": -3.7672200202941895,
      "lng": -38.496620178222656
    }
  },
  {
    "id": "35262_1",
    "name": "Galaxie Motors - Cuiabá",
    "country": "BR",
    "city": "Cuiabá",
    "address": "Av. Fernando Corrêa da Costa, 1.944, 78065-000 Cuiabá",
    "email": "contato@galaxiemotors.com.br",
    "phone": "+55-65-21236090",
    "website": "https://www.bmw-galaxiemotors.com.br/",
    "coords": {
      "lat": -15.611751556396484,
      "lng": -56.076446533203125
    }
  },
  {
    "id": "36834_1",
    "name": "Naosa Country Automoviles de Baviera S.A. de C.V.",
    "country": "MX",
    "city": "Guadalajara",
    "address": "Av. de las Americas 930, 44620 Guadalajara",
    "email": "contacto@bmwnaosa.com",
    "phone": "+52-33-37771212",
    "website": "http://www.bmw.com.mx/naosa",
    "coords": {
      "lat": 20.694982528686523,
      "lng": -103.37251281738281
    }
  },
  {
    "id": "43734_1",
    "name": "Esmeralda Motors",
    "country": "MX",
    "city": "Atizapán de Zaragoza",
    "address": "Av. Jiménez 95, 52930 Atizapán de Zaragoza",
    "email": "oscar.gonzalez@surman.com",
    "phone": "+52-55-53087700",
    "website": "https://www.bmw.com.mx/esmeralda",
    "coords": {
      "lat": 19.561859130859375,
      "lng": -99.29768371582031
    }
  },
  {
    "id": "44792_1",
    "name": "Cumbres Autopolis Premium S.A de C.V",
    "country": "MX",
    "city": "Monterrey",
    "address": "Av. Paseo de los Leones 1000, 64361 Monterrey",
    "email": "adrian.bichara@grupoautopolis.com",
    "phone": "+52-81-21422100",
    "website": "https://www.bmw.com.mx/cumbres",
    "coords": {
      "lat": 25.742050170898438,
      "lng": -100.41290283203125
    }
  },
  {
    "id": "22046_4",
    "name": "Servicio Central Polanco Servicio Central Polanco SA de CV",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Schiller No. 248, 11570 Ciudad de México",
    "email": "atencionaclientes@bavariabmw.com",
    "phone": "+52-55-10853390",
    "website": "https://www.bmw.com.mx/es/distribuidores/grupo_bavaria.html",
    "coords": {
      "lat": 19.43389892578125,
      "lng": -99.18637084960938
    }
  },
  {
    "id": "22046_10",
    "name": "Grupo Bavaria Grupo Bavaria S.A. de C.V.",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Marina Nacional 151, 11320 Ciudad de México",
    "email": "atencionaclientes@bavariabmw.com",
    "phone": "+52-55-52551552",
    "website": "https://www.bmw.com.mx/es/distribuidores/grupo_bavaria.html",
    "coords": {
      "lat": 19.447208404541016,
      "lng": -99.18170166015625
    }
  },
  {
    "id": "23676_1",
    "name": "Surman Chihuahua",
    "country": "MX",
    "city": "Chihuahua",
    "address": "Periférico de la Juventud No. 7505, 31267 Chihuahua",
    "email": "hector.portillo@surman.com",
    "phone": "+52-614-4232850",
    "website": "https://www.bmw.com.mx/surman-autos",
    "coords": {
      "lat": 28.645092010498047,
      "lng": -106.12628173828125
    }
  },
  {
    "id": "33159_1",
    "name": "Auto Premium Tampico",
    "country": "MX",
    "city": "Tampico",
    "address": "Calle Paseo Lomas de Rosales 101, 89100 Tampico",
    "email": "atencion.clientes@bmwtampico.com.mx",
    "phone": "+52-833-2301500",
    "website": "http://www.bmw.com.mx/autopremium-tampico",
    "coords": {
      "lat": 22.26588249206543,
      "lng": -97.87403106689453
    }
  },
  {
    "id": "43614_1",
    "name": "Río Mayo",
    "country": "MX",
    "city": "Cuernavaca",
    "address": "Avenida Río Mayo No. 1105, 62290 Cuernavaca",
    "email": "Gerenciabdc.mmm@grupoautofin.com",
    "phone": "+52-777-3152727",
    "website": "https://www.bmw.com.mx/rio-mayo",
    "coords": {
      "lat": 18.934314727783203,
      "lng": -99.21175384521484
    }
  },
  {
    "id": "22046_1",
    "name": "Grupo Bavaria",
    "country": "MX",
    "city": "México",
    "address": "Presidente Masaryk No. 60, 11560 México",
    "email": "atencionaclientes@bavariabmw.com",
    "phone": "+52-55-52551552",
    "website": "https://www.bmw.com.mx/es/distribuidores/grupo_bavaria.html",
    "coords": {
      "lat": 19.431190490722656,
      "lng": -99.18363952636719
    }
  },
  {
    "id": "26014_1",
    "name": "Surman Hermosillo",
    "country": "MX",
    "city": "Hermosillo",
    "address": "Av. Rosales No. 84, 83000 Hermosillo",
    "email": "cmorales@momentumbmw.com.mx",
    "phone": "+52-662-2133330",
    "website": "https://www.bmw.com.mx/surman-automotriz",
    "coords": {
      "lat": 29.064748764038086,
      "lng": -110.97271728515625
    }
  },
  {
    "id": "34808_1",
    "name": "Autowelt",
    "country": "MX",
    "city": "Culiacán",
    "address": "Blvd. Pedro Infante No. 2431 pte, 82000 Culiacán",
    "email": "atencion.clientes@bmwculiacan.com.mx",
    "phone": "+52-667-8465151",
    "website": "http://www.bmw.com.mx/autowelt",
    "coords": {
      "lat": 24.800722122192383,
      "lng": -107.41471099853516
    }
  },
  {
    "id": "51117_1",
    "name": "Interlomas Continental Interlomas S.A. de C.V.",
    "country": "MX",
    "city": "Estado de Mexico",
    "address": "Blvd. Magnocentro 31, 52765 Estado de Mexico",
    "email": "roberto.olimon@bmwinterlomas.com.mx",
    "phone": "+52-5568556033",
    "website": null,
    "coords": {
      "lat": 19.402259826660156,
      "lng": -99.27163696289062
    }
  },
  {
    "id": "43485_3",
    "name": "Cever San Angel Cever San Antonio S.A. de C.V.",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Insurgentes Sur 2358, 01070 Ciudad de México",
    "email": "atencionaclientes@bmwsanantonio.com.mx",
    "phone": "+52-55-56622300",
    "website": "https://www.bmw.com.mx/cever-san-antonio",
    "coords": {
      "lat": 19.3431453704834,
      "lng": -99.18939971923828
    }
  },
  {
    "id": "44792_2",
    "name": "Autopolis Gonzalitos Autopolis Premium S.A de C.V",
    "country": "MX",
    "city": "Monterrey",
    "address": "Av. Dr. José Eleuterio González 501, 64060 Monterrey",
    "email": "bmw.gonzalitos@grupoautopolis.com",
    "phone": "+52-81-21422142",
    "website": "https://www.bmw.com.mx/cumbres",
    "coords": {
      "lat": 25.676008224487305,
      "lng": -100.35201263427734
    }
  },
  {
    "id": "44788_1",
    "name": "VECSA Oaxaca VECSA Oaxaca S.A de C.V",
    "country": "MX",
    "city": "Oaxaca",
    "address": "Av. Universidad 400, 68130 Oaxaca",
    "email": "vecsaoaxaca@bmwvecsa.com",
    "phone": "+52-951-1447955",
    "website": "http://www.bmw.com.mx/vecsa-oaxaca",
    "coords": {
      "lat": 17.03522491455078,
      "lng": -96.71260833740234
    }
  },
  {
    "id": "49817_3",
    "name": "Vanguardia Motors Vanauto W S.A de C.V.",
    "country": "MX",
    "city": "Zapopan",
    "address": "Av. Vallarta 5408, 45027 Zapopan",
    "email": "mavazquez@vanguardiamotors.com",
    "phone": "+52-3315683993",
    "website": "https://www.bmw.com.mx/es/distribuidores/vanguardia-motors.html",
    "coords": {
      "lat": 20.681058883666992,
      "lng": -103.43042755126953
    }
  },
  {
    "id": "49817_2",
    "name": "Vanguardia Motors Vanauto W S.A de C.V. Taller H&P",
    "country": "MX",
    "city": "Zapopan",
    "address": "Av. Lopez Mateos Sur 6976, 45236 Zapopan",
    "email": "mavazquez@vanguardiamotors.com",
    "phone": "+52-3315297190",
    "website": "https://www.bmw.com.mx/es/distribuidores/vanguardia-motors.html",
    "coords": {
      "lat": 20.609975814819336,
      "lng": -103.43070983886719
    }
  },
  {
    "id": "53312_1",
    "name": "Surman Juarez Surman Juarez S.A. de C.V.",
    "country": "MX",
    "city": "Cd. Juarez",
    "address": "Av. Teofilo Borunda 8715, 32528 Cd. Juarez",
    "email": null,
    "phone": "+52-871-7078800",
    "website": null,
    "coords": {
      "lat": 31.68107795715332,
      "lng": -106.40129089355469
    }
  },
  {
    "id": "43955_1",
    "name": "Farrera Merida Farrera Peninsula S.A. de C.V.",
    "country": "MX",
    "city": "Merida",
    "address": "Tablaje Catastral 16677, 97345 Merida",
    "email": "atencion.bmwmerida@farrerauto.com",
    "phone": "+52-999-9412500",
    "website": "https://www.bmw.com.mx/es/fastlane/dealer-locator.html",
    "coords": {
      "lat": 21.055130004882812,
      "lng": -89.63157653808594
    }
  },
  {
    "id": "44790_1",
    "name": "Carmen Motors Tijuana Carmen Motors BC S.A. de C.V.",
    "country": "MX",
    "city": "Tijuana",
    "address": "Blvd. Paseo de los Heroes 11110, 22010 Tijuana",
    "email": "jantunano@carmenmotors.com.mx",
    "phone": "+52-664-6333595",
    "website": "http://www.bmw.com.mx/carmen-motors-tijuana",
    "coords": {
      "lat": 32.51804733276367,
      "lng": -117.00372314453125
    }
  },
  {
    "id": "22046_5",
    "name": "Body Shop Grupo Bavaria Grupo Bavaria S.A. de C.V.",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Avenida Central 401, 01180 Ciudad de México",
    "email": "atencionaclientes@bavariabmw.com",
    "phone": "+52-55-10853420",
    "website": "https://www.bmw.com.mx/es/distribuidores/grupo_bavaria.html",
    "coords": {
      "lat": 19.385879516601562,
      "lng": -99.19822692871094
    }
  },
  {
    "id": "22195_1",
    "name": "Talismán Automotriz",
    "country": "MX",
    "city": "Morelia",
    "address": "Av. Acueducto 2900, 58240 Morelia",
    "email": "atencion@fametalisman.com",
    "phone": "+52-443-3247201",
    "website": "http://www.bmw.com.mx/talisman-automotriz",
    "coords": {
      "lat": 19.69548797607422,
      "lng": -101.15709686279297
    }
  },
  {
    "id": "22202_1",
    "name": "Euromotors del Centro Euromotors del Centro S.A. de C.V.",
    "country": "MX",
    "city": "Leon",
    "address": "Blvd. Jose Maria Morelos 1430, 37130 Leon",
    "email": "atencionaclientes@bmwleon.mx",
    "phone": "+52-477-2141100",
    "website": "https://www.bmw.com.mx/euromotors-del-centro",
    "coords": {
      "lat": 21.169782638549805,
      "lng": -101.68830108642578
    }
  },
  {
    "id": "22203_4",
    "name": "Euromotors de Queretaro II Euromotors de Queretaro SA de CV",
    "country": "MX",
    "city": "Queretaro",
    "address": "Av. 5 de Febrero 1724, 76090 Queretaro",
    "email": "gerencia@motorradqueretaro.mx",
    "phone": "+52-442-2099400",
    "website": "https://www.bmw.com.mx/euromotors-queretaro",
    "coords": {
      "lat": 20.63397979736328,
      "lng": -100.4270248413086
    }
  },
  {
    "id": "24892_1",
    "name": "Momentum Satélite",
    "country": "MX",
    "city": "Tlalnepantla",
    "address": "Blvd. Manuel Avila Camacho No. 2489, 54060 Tlalnepantla",
    "email": "karla.rosas@surman.com",
    "phone": "+52-55-91402100",
    "website": "https://www.bmw.com.mx/momentum-satelite",
    "coords": {
      "lat": 19.53324317932129,
      "lng": -99.21903228759766
    }
  },
  {
    "id": "43485_1",
    "name": "Cever San Antonio",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "NUEVA YORK NO. 327, 03810 Ciudad de México",
    "email": "atencionaclientes@bmwsanantonio.com.mx",
    "phone": "+52-55-10853360",
    "website": "https://www.bmw.com.mx/cever-san-antonio",
    "coords": {
      "lat": 19.38751792907715,
      "lng": -99.17581176757812
    }
  },
  {
    "id": "44789_1",
    "name": "VECSA Hidalgo VECSA Hidalgo S.A de C.V",
    "country": "MX",
    "city": "Pachuca",
    "address": "Distribuidor Vial la Paz 113, 42094 Pachuca",
    "email": "josemaria.hernandez@bmwvecsa.com",
    "phone": "+52-771-7172554",
    "website": "http://www.bmw.com.mx/vecsa-pachuca",
    "coords": {
      "lat": 20.089401245117188,
      "lng": -98.7450942993164
    }
  },
  {
    "id": "46754_1",
    "name": "Cever Metepec Cever Automotriz Metepec SA de CV",
    "country": "MX",
    "city": "Estado de Mexico",
    "address": "Av. Toluca-Metepec 161-B, 52166 Estado de Mexico",
    "email": "agonzalez@bmwmetepec.com.mx",
    "phone": "+52-722-7062222",
    "website": "https:///www.bmw.com.mx/es/distribuidores/cever-metepec.html",
    "coords": {
      "lat": 19.250730514526367,
      "lng": -99.61414337158203
    }
  },
  {
    "id": "49507_1",
    "name": "GTC Motors Sendero GTC Motors S.A. de C.V.",
    "country": "MX",
    "city": "San Luis Potosi",
    "address": "Carr. Mexico-Piedras Negras 3303, 78394 San Luis Potosi",
    "email": "gcomercial@gtcbmw.com",
    "phone": "+52-444-8247072",
    "website": "https://www.bmw.com.mx/gtcmotors",
    "coords": {
      "lat": 22.121978759765625,
      "lng": -100.9122314453125
    }
  },
  {
    "id": "20169_1",
    "name": "VECSA Puebla",
    "country": "MX",
    "city": "Puebla",
    "address": "Boulevard Atlixcayotl No. 5316, 72190 Puebla",
    "email": "atencion.clientes@bmwvecsa.com",
    "phone": "+52-222-3090800",
    "website": "http://www.bmw.com.mx/vecsa-puebla",
    "coords": {
      "lat": 19.02578353881836,
      "lng": -98.23603057861328
    }
  },
  {
    "id": "22197_1",
    "name": "Tecnología de Tabasco",
    "country": "MX",
    "city": "Villahermosa",
    "address": "Prol. de Av. Usumacinta 2119, 86035 Villahermosa",
    "email": "asistente194@grupocruces.com.mx",
    "phone": "+52-993-3166732",
    "website": "https://www.bmw.com.mx/tecnologia-tabasco",
    "coords": {
      "lat": 18.001726150512695,
      "lng": -92.95889282226562
    }
  },
  {
    "id": "31406_1",
    "name": "VECSA Veracruz VECSA Veracruz S.A. de C.V.",
    "country": "MX",
    "city": "Alvarado",
    "address": "Carr. Boca del Rio-Anton L. 4450, 95264 Alvarado",
    "email": "atencionaclientes@bmwvecsa.com",
    "phone": "+52-229-9236030",
    "website": "http://www.bmw.com.mx/vecsa-veracruz",
    "coords": {
      "lat": 19.06553077697754,
      "lng": -96.07975769042969
    }
  },
  {
    "id": "52847_1",
    "name": "Autopremium Reynosa Autopremium Tamaulipas S.A. de C.V.",
    "country": "MX",
    "city": "Reynosa",
    "address": "Av. Carr a Monterrey 490, 88730 Reynosa",
    "email": "atencionaclientes@bmwreynosa.mx",
    "phone": "+52-8999516600",
    "website": null,
    "coords": {
      "lat": 26.057540893554688,
      "lng": -98.36318969726562
    }
  },
  {
    "id": "22192_5",
    "name": "Farrera Tuxtla Farrera Peninsula S.A. de C.V.",
    "country": "MX",
    "city": "Tuxtla Gutierrez",
    "address": "Blvd. Ciro Farrera 690, 29050 Tuxtla Gutierrez",
    "email": "contacto@bmwchiapas.mx",
    "phone": "+52-961-6175800",
    "website": "https://www.bmw.com.mx/farrera-tuxtla",
    "coords": {
      "lat": 16.749977111816406,
      "lng": -93.15156555175781
    }
  },
  {
    "id": "43614_2",
    "name": "Acapulco",
    "country": "MX",
    "city": "Acapulco",
    "address": "Av. Costera Miguel Aleman No. 2038, 39690 Acapulco",
    "email": "Gerenciabdc.mmm@grupoautofin.com",
    "phone": "+52-744-4812207",
    "website": "https://www.bmw.com.mx/acapulco",
    "coords": {
      "lat": 16.852930068969727,
      "lng": -99.90077209472656
    }
  },
  {
    "id": "41418_1",
    "name": "Coapa Motors",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "CALZADA DEL HUESO NO. 524, 04920 Ciudad de México",
    "email": "gerente.mini@minicoapa.com.mx",
    "phone": "+52-55-55998100",
    "website": "https://www.bmw.com.mx/coapa-motors",
    "coords": {
      "lat": 19.30405044555664,
      "lng": -99.1232681274414
    }
  },
  {
    "id": "47920_1",
    "name": "Euromotors de Monterrey Euromotors de Monterrey S.A. de C.V",
    "country": "MX",
    "city": "Monterrey",
    "address": "Av. David Alfaro Siqueiros 101, 66269 Monterrey",
    "email": "motorrad@euromotorsmty.mx",
    "phone": "+52-81-22224300",
    "website": "https://www.bmw.com.mx/euromotors_monterrey",
    "coords": {
      "lat": 25.645675659179688,
      "lng": -100.32135009765625
    }
  },
  {
    "id": "50919_1",
    "name": "Cever Santa Fe Cever Automotriz Santa Fe SA de CV",
    "country": "MX",
    "city": "Ciudad de Mexico",
    "address": "Av. Juan Salvador Agraz 101, 05370 Ciudad de Mexico",
    "email": "jfigueroa@bmw-santafe.com.mx",
    "phone": "+52-5589444444",
    "website": null,
    "coords": {
      "lat": 19.358089447021484,
      "lng": -99.27690887451172
    }
  },
  {
    "id": "51117_2",
    "name": "Interlomas BPS Continental Interlomas S.A. de C.V.",
    "country": "MX",
    "city": "Estado de México",
    "address": "Av. Jesus del Monte 44, 52779 Estado de México",
    "email": null,
    "phone": "+52-5568556033",
    "website": null,
    "coords": {
      "lat": 19.401819229125977,
      "lng": -99.28488159179688
    }
  },
  {
    "id": "28407_1",
    "name": "Lerma Motors",
    "country": "MX",
    "city": "Lerma",
    "address": "Carretera México - Toluca Km. 47,5, 52031 Lerma",
    "email": "Edgar.Valenzuela@plantatoluca.com",
    "phone": "+52-722-2651400",
    "website": "https://www.bmw.com.mx/lerma-motors",
    "coords": {
      "lat": 19.28262710571289,
      "lng": -99.48252868652344
    }
  },
  {
    "id": "23675_1",
    "name": "Carmen Motors Carmen Motors S.A.de C.V.",
    "country": "MX",
    "city": "Zapopan",
    "address": "Av. Patria 1908, 45110 Zapopan",
    "email": "fcarrasco@carmenmotors.com.mx",
    "phone": "+52-333-6484747",
    "website": "https://www.bmw.com.mx/carmen-motors",
    "coords": {
      "lat": 20.70570182800293,
      "lng": -103.41283416748047
    }
  },
  {
    "id": "44788_2",
    "name": "VECSA Oaxaca Taller VECSA Oaxaca S.A de C.V",
    "country": "MX",
    "city": "Oaxaca",
    "address": "Fresnito 206 Local 4, 71233 Oaxaca",
    "email": "atencion.clientesoaxaca@bmwvecsa.com",
    "phone": "+52-951-1447955",
    "website": "http://www.bmw.com.mx/vecsa-oaxaca",
    "coords": {
      "lat": 17.036128997802734,
      "lng": -96.71358489990234
    }
  },
  {
    "id": "49507_2",
    "name": "GTC Motors La Loma GTC Motors S.A. de C.V.",
    "country": "MX",
    "city": "San Luis Potosi",
    "address": "Av Cordillera de los Alpes 750, 78216 San Luis Potosi",
    "email": "atencionaclientes@bmwslp.com",
    "phone": "+52-444-8254444",
    "website": "https://www.bmw.com.mx/gtcmotors",
    "coords": {
      "lat": 22.135175704956055,
      "lng": -101.02976989746094
    }
  },
  {
    "id": "22202_2",
    "name": "Taller Euromotors del Centro",
    "country": "MX",
    "city": "León",
    "address": "Oceano Pacifico No. 301 A, 37300 León",
    "email": "crm@bmwleon.mx",
    "phone": "+52-477-2141100",
    "website": "https://www.bmw.com.mx/euromotors-del-centro",
    "coords": {
      "lat": 21.146255493164062,
      "lng": -101.70452880859375
    }
  },
  {
    "id": "41363_1",
    "name": "Lindavista Motors",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Calzada Vallejo 1030, 02300 Ciudad de México",
    "email": "atencion.clientes@bmwlindavista.com.mx",
    "phone": "+52-55-50780860",
    "website": "http://www.bmw.com.mx/lindavista-motors",
    "coords": {
      "lat": 19.497085571289062,
      "lng": -99.15541076660156
    }
  },
  {
    "id": "44791_1",
    "name": "Soni Aguascalientes Soni Aguascalientes S.A de C.V",
    "country": "MX",
    "city": "Aguascalientes",
    "address": "Blvd. Luis Donaldo Colosio 360, 20115 Aguascalientes",
    "email": "rpc@bmwaguascalientes.mx",
    "phone": "+52-449-9960451",
    "website": "http://www.bmw.com.mx/bmw-aguascalientes",
    "coords": {
      "lat": 21.924644470214844,
      "lng": -102.30828857421875
    }
  },
  {
    "id": "50078_1",
    "name": "NAOSA Vallarta Automoviles Baviera de V. SA de CV",
    "country": "MX",
    "city": "Puerto Vallarta",
    "address": "Carr. A Tepic 5755, 48290 Puerto Vallarta",
    "email": null,
    "phone": "+52-322-1026466",
    "website": null,
    "coords": {
      "lat": 20.689245223999023,
      "lng": -105.25345611572266
    }
  },
  {
    "id": "22202_6",
    "name": "BPS Euromotors del Centro Irapuato Euromotors del Centro S.A. de C.V.",
    "country": "MX",
    "city": "Irapuato",
    "address": "Av. Villas de Irapuato 787, 36643 Irapuato",
    "email": "atencionaclientes@bmwleon.mx",
    "phone": "+52-462-6885689",
    "website": "http://www.bmw.com.mx/euromotors-del-centro",
    "coords": {
      "lat": 20.67972183227539,
      "lng": -101.37621307373047
    }
  },
  {
    "id": "22203_1",
    "name": "Euromotors de Querétaro",
    "country": "MX",
    "city": "Querétaro",
    "address": "Prol. Bernardo Quintana 8250, 76030 Querétaro",
    "email": "atencion.clientes@bmwqueretaro.mx",
    "phone": "+52-442-2142020",
    "website": "http://www.bmw.com.mx/euromotors-queretaro",
    "coords": {
      "lat": 20.568693161010742,
      "lng": -100.35832977294922
    }
  },
  {
    "id": "36834_2",
    "name": "NAOSA Country Automoviles de Baviera S.A. de C.V.",
    "country": "MX",
    "city": "Guadalajara",
    "address": "Av. de las Americas 930, 44620 Guadalajara",
    "email": null,
    "phone": "+52-(33)37771212",
    "website": "https://www.bmw.com.mx/naosa",
    "coords": {
      "lat": 20.69475746154785,
      "lng": -103.37273406982422
    }
  },
  {
    "id": "43485_2",
    "name": "Cever San Antonio Cever San Antonio S.A. de C.V.",
    "country": "MX",
    "city": "Ciudad de Mexico",
    "address": "Nueva York 289, 03810 Ciudad de Mexico",
    "email": "atencionaclientes@bmwsanantonio.com.mx",
    "phone": "+52-55-10853360",
    "website": "https://www.bmw-motorrad.com.mx/cever-sanantonio",
    "coords": {
      "lat": 19.387584686279297,
      "lng": -99.1758041381836
    }
  },
  {
    "id": "50868_1",
    "name": "HUB Antuñano Grupo Hub Motors S.A. de C.V.",
    "country": "MX",
    "city": "Puebla",
    "address": "Blvd. Esteban de Antuñano 1314, 72130 Puebla",
    "email": "citasdeservicio@bmwhub.mx",
    "phone": "+52-2223090700",
    "website": "https://www.bmw-motorrad.com.mx/hub-puebla/es/home.html",
    "coords": {
      "lat": 19.082809448242188,
      "lng": -98.23838806152344
    }
  },
  {
    "id": "43485_4",
    "name": "Cever Pedregal Cever San Antonio S.A. de C.V.",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Periferico Sur 2772, 01900 Ciudad de México",
    "email": "atencionaclientes@bmwsanantonio.com.mx",
    "phone": "+52-55-10853360",
    "website": "https://www.bmw.com.mx/cever-san-antonio",
    "coords": {
      "lat": 19.324542999267578,
      "lng": -99.21501922607422
    }
  },
  {
    "id": "22196_1",
    "name": "Surman Motors",
    "country": "MX",
    "city": "Torreón",
    "address": "Blvd. Independencia esquina, 27010 Torreón",
    "email": "linda.fernandez@surman.com",
    "phone": "+52-871-7494000",
    "website": "https://www.bmw.com.mx/surman-motors",
    "coords": {
      "lat": 25.571842193603516,
      "lng": -103.41899871826172
    }
  },
  {
    "id": "50868_2",
    "name": "HUB Serdan Grupo Hub Motors S.A. de C.V.",
    "country": "MX",
    "city": "Puebla",
    "address": "Blvd. Hermanos Serdan 788-1, 72020 Puebla",
    "email": "citasdeservicio@bmwhub.mx",
    "phone": "+52-2223090700",
    "website": "https://www.bmw.com.mx/es/distribuidores/hub-motors-puebla.html",
    "coords": {
      "lat": 19.09054946899414,
      "lng": -98.22898864746094
    }
  },
  {
    "id": "47920_3",
    "name": "Euromotors Saltillo Euromotors de Monterrey S.A. de C.V",
    "country": "MX",
    "city": "Saltillo",
    "address": "Blvd Galerias 180, 25240 Saltillo",
    "email": null,
    "phone": "+52-844-4500600",
    "website": null,
    "coords": {
      "lat": 25.456823348999023,
      "lng": -100.9838638305664
    }
  },
  {
    "id": "49817_1",
    "name": "Vanguardia Motors Vanauto W S.A de C.V.",
    "country": "MX",
    "city": "Zapopan",
    "address": "Av. Lopez Mateos Sur 5677, 45080 Zapopan",
    "email": "irobles@dirtop.com.mx",
    "phone": "+52-3315683993",
    "website": "http://www.bmw.com.mx/autokam-germania",
    "coords": {
      "lat": 20.62575912475586,
      "lng": -103.41930389404297
    }
  },
  {
    "id": "52059_1",
    "name": "Carmen Motors Los Cabos Carmen Motors BC Sur S.A de C.V.",
    "country": "MX",
    "city": "San Jose del Cabo",
    "address": "Carr. Km 24.7 Cabo San Lucas Lt 1, 23400 San Jose del Cabo",
    "email": "mauriciomtz@vehiculoseuropeos.com.mx",
    "phone": "52-664-6333595",
    "website": "https://www.bmw.com.mx/es/distribuidores/bmw-los-cabos.html",
    "coords": {
      "lat": 23.002010345458984,
      "lng": -109.73206329345703
    }
  },
  {
    "id": "54778_1",
    "name": "CLEBER Innovación Motriz S.A. de C.V.",
    "country": "MX",
    "city": "San Pedro Garza Garcia",
    "address": "Calz. del Valle Alberto Santos 320, 66220 San Pedro Garza Garcia",
    "email": "ventas.bmw@cleber.com",
    "phone": "+52-8110018800",
    "website": null,
    "coords": {
      "lat": 25.654220581054688,
      "lng": -100.36180114746094
    }
  },
  {
    "id": "22192_1",
    "name": "Farrera Peninsula Cancun Farrera Peninsula S.A. de C.V.",
    "country": "MX",
    "city": "Benito Juarez",
    "address": "Av. Tulum 334 SM 9 MZ 3 Lote 1, 77504 Benito Juarez",
    "email": "calidad.bmw@gfarrera.com.mx",
    "phone": "+52-998-2677617",
    "website": "http://www.bmw.com.mx/farrera-peninsula-cancun",
    "coords": {
      "lat": 21.131071090698242,
      "lng": -86.82911682128906
    }
  },
  {
    "id": "44790_2",
    "name": "Carmen Motors Mexicali Carmen Motors BC S.A. de C.V.",
    "country": "MX",
    "city": "Mexicali",
    "address": "Calzada Cetys 2579, 21259 Mexicali",
    "email": "jbernal@carmenmotors.com.mx",
    "phone": "+52-686-5646421",
    "website": "http://www.bmw.com.mx/carmen-motors-mexicali",
    "coords": {
      "lat": 32.65311050415039,
      "lng": -115.40254974365234
    }
  },
  {
    "id": "50919_2",
    "name": "Cever Santa Fe Servicio Cever Automotriz Santa Fe SA de CV",
    "country": "MX",
    "city": "Ciudad de México",
    "address": "Carr. México-Toluca 5341, 05100 Ciudad de México",
    "email": "Reccsaantafe@bmw-santafe.com.mx",
    "phone": "+52-5589444444",
    "website": null,
    "coords": {
      "lat": 19.364410400390625,
      "lng": -99.27967834472656
    }
  }
]